
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefc1b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefc1b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gzEFX", function(module, exports) {
module.exports = new URL("logo.0eae7cf3.svg", import.meta.url).toString();

});

parcelRegister("aSkX0", function(module, exports) {
module.exports = new URL("arrow-down-circle.70916082.svg", import.meta.url).toString();

});

parcelRegister("aDAK4", function(module, exports) {
module.exports = new URL("arrow-down-left.d8f17500.svg", import.meta.url).toString();

});

parcelRegister("1meM0", function(module, exports) {
module.exports = new URL("arrow-down-right.fdb894c4.svg", import.meta.url).toString();

});

parcelRegister("cTP1h", function(module, exports) {
module.exports = new URL("arrow-down.67bd222b.svg", import.meta.url).toString();

});

parcelRegister("at0JQ", function(module, exports) {
module.exports = new URL("arrow-left-circle.82d83f2c.svg", import.meta.url).toString();

});

parcelRegister("k9pG5", function(module, exports) {
module.exports = new URL("arrow-left.2b7bce11.svg", import.meta.url).toString();

});

parcelRegister("gvg6J", function(module, exports) {
module.exports = new URL("arrow-right.b6c3437d.svg", import.meta.url).toString();

});

parcelRegister("6bhVB", function(module, exports) {
module.exports = new URL("arrow-right-circle.a621a6b2.svg", import.meta.url).toString();

});

parcelRegister("5Ys9c", function(module, exports) {
module.exports = new URL("arrow-up-circle.3c850c3b.svg", import.meta.url).toString();

});

parcelRegister("fkduY", function(module, exports) {
module.exports = new URL("arrow-up-left.ae958530.svg", import.meta.url).toString();

});

parcelRegister("5MMfA", function(module, exports) {
module.exports = new URL("arrow-up-right.ef218568.svg", import.meta.url).toString();

});

parcelRegister("egVAF", function(module, exports) {
module.exports = new URL("arrow-up.87a69047.svg", import.meta.url).toString();

});

parcelRegister("5bEOF", function(module, exports) {
module.exports = new URL("check-circle.5331953b.svg", import.meta.url).toString();

});

parcelRegister("8uQrw", function(module, exports) {
module.exports = new URL("check.8bdb7ed6.svg", import.meta.url).toString();

});

parcelRegister("3i4HJ", function(module, exports) {
module.exports = new URL("chevron-down.52252869.svg", import.meta.url).toString();

});

parcelRegister("aI8cw", function(module, exports) {
module.exports = new URL("chevron-left.25a630df.svg", import.meta.url).toString();

});

parcelRegister("e0I9T", function(module, exports) {
module.exports = new URL("chevron-right.93d437c0.svg", import.meta.url).toString();

});

parcelRegister("27kk0", function(module, exports) {
module.exports = new URL("chevron-up.aa6afa50.svg", import.meta.url).toString();

});

parcelRegister("4fLzU", function(module, exports) {
module.exports = new URL("copy.c779f593.svg", import.meta.url).toString();

});

parcelRegister("3mjvv", function(module, exports) {
module.exports = new URL("eye-off.e08a48fa.svg", import.meta.url).toString();

});

parcelRegister("iybUV", function(module, exports) {
module.exports = new URL("eye.b787035f.svg", import.meta.url).toString();

});

parcelRegister("fPARS", function(module, exports) {
module.exports = new URL("info.0c73e176.svg", import.meta.url).toString();

});

parcelRegister("6F1KK", function(module, exports) {
module.exports = new URL("minus.2bc6816f.svg", import.meta.url).toString();

});

parcelRegister("cqUTC", function(module, exports) {
module.exports = new URL("sun.399e38be.svg", import.meta.url).toString();

});

parcelRegister("3iyV5", function(module, exports) {
module.exports = new URL("moon.bbd71798.svg", import.meta.url).toString();

});

parcelRegister("g4mKI", function(module, exports) {
module.exports = new URL("more-horizontal.cdde0f9d.svg", import.meta.url).toString();

});

parcelRegister("iq8O1", function(module, exports) {
module.exports = new URL("more-vertical.b583a7d5.svg", import.meta.url).toString();

});

parcelRegister("hXJX4", function(module, exports) {
module.exports = new URL("send.db914cab.svg", import.meta.url).toString();

});

parcelRegister("48dpK", function(module, exports) {
module.exports = new URL("smile.43d71d81.svg", import.meta.url).toString();

});

parcelRegister("dnzu1", function(module, exports) {
module.exports = new URL("search.0774f788.svg", import.meta.url).toString();

});

parcelRegister("cA0OS", function(module, exports) {
module.exports = new URL("upload.4eba1150.svg", import.meta.url).toString();

});

parcelRegister("5gLkM", function(module, exports) {
module.exports = new URL("video.cee0f850.svg", import.meta.url).toString();

});

parcelRegister("7Gv20", function(module, exports) {
module.exports = new URL("x.ff5d9f4b.svg", import.meta.url).toString();

});

parcelRegister("li2ow", function(module, exports) {
module.exports = new URL("plus.f987e3e2.svg", import.meta.url).toString();

});

parcelRegister("cVSYW", function(module, exports) {

$parcel$export(module.exports, "connect", () => connect);
$parcel$export(module.exports, "send", () => send);

var $cBUNY = parcelRequire("cBUNY");

var $aOJ2H = parcelRequire("aOJ2H");

var $73MNt = parcelRequire("73MNt");
"use strict";
const { isFunction, isArray } = $cBUNY.default || $cBUNY;
const { window } = $aOJ2H.default || $aOJ2H;
const ENV = "production";
const defautlOpts = {};
let CONNECT_ATTEPT = 0;
const CONNECT_ATTEPT_MAX_ALLOWED = 1;
const connect = (key, options = {})=>{
    const isDev = options.development || window && window.location && window.location.host.includes("local") || ENV === "test" || ENV === "development";
    const SOCKET_BACKEND_URL = isDev ? "http://localhost:13336/" : "https://socket.symbols.app/";
    const socketUrls = isArray(options.socketUrl) ? options.socketUrl : [
        options.socketUrl || SOCKET_BACKEND_URL
    ];
    const primaryUrl = socketUrls[0];
    const secondaryUrl = socketUrls[1] || "socket.symbols.app";
    const socket = (0, $73MNt.default)(primaryUrl || SOCKET_BACKEND_URL, {
    });
    socket.on("connect", ()=>{
        if (isDev) console.log(`Connected to %c${primaryUrl || SOCKET_BACKEND_URL} %c${key} %c${socket.id}`, "font-weight: bold; color: green;", "font-weight: bold;", "");
        socket.emit("initConnect", {
            key: key,
            ...options
        });
        try {
            if (isFunction(options.onConnect)) options.onConnect(socket.id, socket);
        } catch (e) {
            console.error(e);
        }
    });
    socket.on("connect_error", (err)=>{
        console.log(`event: connect_error | reason: ${err.message}`);
        try {
            if (isFunction(options.onError)) options.onError(err, socket);
            if (CONNECT_ATTEPT < CONNECT_ATTEPT_MAX_ALLOWED) {
                CONNECT_ATTEPT++;
                socket.disconnect();
                if (ENV === "test" || ENV === "development") console.log("Could not connect to %c" + primaryUrl + "%c, reconnecting to %c" + secondaryUrl, "font-weight: bold; color: red;", "", "font-weight: bold; color: green;");
                connect(key, {
                    ...options,
                    socketUrl: secondaryUrl
                });
            }
        } catch (e) {
            console.error(e);
        }
    });
    socket.on("disconnect", (reason)=>{
        console.log(`event: disconnect | reason: ${reason}`);
        try {
            if (isFunction(options.onDisconnect)) options.onDisconnect(reason, socket);
        } catch (e) {
            console.error(e);
        }
    });
    socket.onAny((event, ...args)=>{
        if (event === "connect") return;
        try {
            if (isFunction(options.onChange)) options.onChange(event, args[0], socket);
        } catch (e) {
            console.error(e);
        }
    });
    return socket;
};
function send(event = "change", changes, options) {
    this.emit(event, changes, {
        ...options,
        ...defautlOpts
    });
}
function disconnect() {
    this.disconnect();
}

});
parcelRegister("cBUNY", function(module, exports) {

var $NWrSd = parcelRequire("NWrSd");

var $jOLBF = parcelRequire("jOLBF");

var $EqHTq = parcelRequire("EqHTq");

var $8wu6n = parcelRequire("8wu6n");

var $fMhOg = parcelRequire("fMhOg");

var $hSU9O = parcelRequire("hSU9O");

var $cPMIO = parcelRequire("cPMIO");

var $cQ6eY = parcelRequire("cQ6eY");

var $5WrxC = parcelRequire("5WrxC");

var $jvD5p = parcelRequire("jvD5p");

var $57Gb5 = parcelRequire("57Gb5");

var $glQML = parcelRequire("glQML");
"use strict";
$parcel$exportWildcard(module.exports, $NWrSd);
$parcel$exportWildcard(module.exports, $jOLBF);
$parcel$exportWildcard(module.exports, $EqHTq);
$parcel$exportWildcard(module.exports, $8wu6n);
$parcel$exportWildcard(module.exports, $fMhOg);
$parcel$exportWildcard(module.exports, $hSU9O);
$parcel$exportWildcard(module.exports, $cPMIO);
$parcel$exportWildcard(module.exports, $cQ6eY);
$parcel$exportWildcard(module.exports, $5WrxC);
$parcel$exportWildcard(module.exports, $jvD5p);
$parcel$exportWildcard(module.exports, $57Gb5);
$parcel$exportWildcard(module.exports, $glQML);

});
parcelRegister("NWrSd", function(module, exports) {

$parcel$export(module.exports, "generateKey", () => $0961ea6318004278$export$3a7728e868aa3ebd);
$parcel$export(module.exports, "createSnapshotId", () => $0961ea6318004278$export$6f8fb29fbb5b5b63);
"use strict";
const $0961ea6318004278$export$3a7728e868aa3ebd = function() {
    let index = 0;
    function newId() {
        index++;
        return index;
    }
    return newId;
}();
const $0961ea6318004278$export$6f8fb29fbb5b5b63 = $0961ea6318004278$export$3a7728e868aa3ebd;

});

parcelRegister("jOLBF", function(module, exports) {

$parcel$export(module.exports, "NODE_ENV", () => $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4);
$parcel$export(module.exports, "isProduction", () => $e6d79d7b0d7b5fe1$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $e6d79d7b0d7b5fe1$export$410cbc2864fa25b5);
$parcel$export(module.exports, "isDevelopment", () => $e6d79d7b0d7b5fe1$export$df77466336fe5355);
$parcel$export(module.exports, "getNev", () => $e6d79d7b0d7b5fe1$export$d84272657cb7c466);
"use strict";
const $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4 = "production";
const $e6d79d7b0d7b5fe1$export$f15d00aa73aafac4 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === "production" || env === "prod" || env !== "development" && env !== "dev" && env !== "test";
const $e6d79d7b0d7b5fe1$export$410cbc2864fa25b5 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === "test";
const $e6d79d7b0d7b5fe1$export$df77466336fe5355 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === "development" || env === "dev";
const $e6d79d7b0d7b5fe1$export$d84272657cb7c466 = (key, env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env[key];

});

parcelRegister("EqHTq", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $079873fc3f2b5f81$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isString", () => $079873fc3f2b5f81$export$844ec244b1367d54);
$parcel$export(module.exports, "isNumber", () => $079873fc3f2b5f81$export$7e4aa119212bc614);
$parcel$export(module.exports, "isFunction", () => $079873fc3f2b5f81$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isBoolean", () => $079873fc3f2b5f81$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isNull", () => $079873fc3f2b5f81$export$630801d484da15df);
$parcel$export(module.exports, "isArray", () => $079873fc3f2b5f81$export$43bee75e5e14138e);
$parcel$export(module.exports, "isDate", () => $079873fc3f2b5f81$export$871608497c498473);
$parcel$export(module.exports, "isObjectLike", () => $079873fc3f2b5f81$export$c10d0b04eaa80a43);
$parcel$export(module.exports, "isDefined", () => $079873fc3f2b5f81$export$4e62c701997796c1);
$parcel$export(module.exports, "isUndefined", () => $079873fc3f2b5f81$export$fce6876652108ab);
$parcel$export(module.exports, "TYPES", () => $079873fc3f2b5f81$export$426db7a6155b7a80);
$parcel$export(module.exports, "is", () => $079873fc3f2b5f81$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "isNot", () => $079873fc3f2b5f81$export$612ae635ef713eeb);

var $cPMIO = parcelRequire("cPMIO");
"use strict";
const $079873fc3f2b5f81$export$a6cdc56e425d0d0a = (arg)=>{
    if (arg === null) return false;
    return typeof arg === "object" && arg.constructor === Object;
};
const $079873fc3f2b5f81$export$844ec244b1367d54 = (arg)=>typeof arg === "string";
const $079873fc3f2b5f81$export$7e4aa119212bc614 = (arg)=>typeof arg === "number";
const $079873fc3f2b5f81$export$f6e2535fb5126e54 = (arg)=>typeof arg === "function";
const $079873fc3f2b5f81$export$f9ce7b637dfbe238 = (arg)=>arg === true || arg === false;
const $079873fc3f2b5f81$export$630801d484da15df = (arg)=>arg === null;
const $079873fc3f2b5f81$export$43bee75e5e14138e = (arg)=>Array.isArray(arg);
const $079873fc3f2b5f81$export$871608497c498473 = (d)=>d instanceof Date;
const $079873fc3f2b5f81$export$c10d0b04eaa80a43 = (arg)=>{
    if (arg === null) return false;
    // if (isArray(arg)) return false
    return typeof arg === "object";
};
const $079873fc3f2b5f81$export$4e62c701997796c1 = (arg)=>{
    return $079873fc3f2b5f81$export$a6cdc56e425d0d0a(arg) || $079873fc3f2b5f81$export$c10d0b04eaa80a43(arg) || $079873fc3f2b5f81$export$844ec244b1367d54(arg) || $079873fc3f2b5f81$export$7e4aa119212bc614(arg) || $079873fc3f2b5f81$export$f6e2535fb5126e54(arg) || $079873fc3f2b5f81$export$43bee75e5e14138e(arg) || $079873fc3f2b5f81$export$c10d0b04eaa80a43(arg) || $079873fc3f2b5f81$export$f9ce7b637dfbe238(arg) || $079873fc3f2b5f81$export$871608497c498473(arg) || $079873fc3f2b5f81$export$630801d484da15df(arg);
};
const $079873fc3f2b5f81$export$fce6876652108ab = (arg)=>{
    return arg === undefined;
};
const $079873fc3f2b5f81$export$426db7a6155b7a80 = {
    boolean: $079873fc3f2b5f81$export$f9ce7b637dfbe238,
    array: $079873fc3f2b5f81$export$43bee75e5e14138e,
    object: $079873fc3f2b5f81$export$a6cdc56e425d0d0a,
    string: $079873fc3f2b5f81$export$844ec244b1367d54,
    date: $079873fc3f2b5f81$export$871608497c498473,
    number: $079873fc3f2b5f81$export$7e4aa119212bc614,
    null: $079873fc3f2b5f81$export$630801d484da15df,
    function: $079873fc3f2b5f81$export$f6e2535fb5126e54,
    objectLike: $079873fc3f2b5f81$export$c10d0b04eaa80a43,
    node: (0, $cPMIO.isNode),
    htmlElement: (0, $cPMIO.isHtmlElement),
    defined: $079873fc3f2b5f81$export$4e62c701997796c1
};
const $079873fc3f2b5f81$export$226b3eccf92c9ed9 = (arg)=>{
    return (...args)=>{
        return args.map((val)=>$079873fc3f2b5f81$export$426db7a6155b7a80[val](arg)).filter((v)=>v).length > 0;
    };
};
const $079873fc3f2b5f81$export$612ae635ef713eeb = (arg)=>{
    return (...args)=>{
        return args.map((val)=>$079873fc3f2b5f81$export$426db7a6155b7a80[val](arg)).filter((v)=>v).length === 0;
    };
};

});
parcelRegister("cPMIO", function(module, exports) {

$parcel$export(module.exports, "isNode", () => $95800a96be489797$export$8ee0fc9ee280b4ee);
$parcel$export(module.exports, "isHtmlElement", () => $95800a96be489797$export$211442cb55fb93);

var $jvD5p = parcelRequire("jvD5p");
"use strict";
const $95800a96be489797$export$8ee0fc9ee280b4ee = (obj)=>{
    return (typeof Node === "object" ? obj instanceof (0, $jvD5p.window).Node : obj && typeof obj === "object" && typeof obj.nodeType === "number" && typeof obj.nodeName === "string") || false;
};
const $95800a96be489797$export$211442cb55fb93 = (obj)=>{
    return (typeof HTMLElement === "object" ? obj instanceof (0, $jvD5p.window).HTMLElement // DOM2
     : obj && typeof obj === "object" && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === "string") || false;
};

});
parcelRegister("jvD5p", function(module, exports) {

$parcel$export(module.exports, "global", () => $e33f3b456b841cc9$export$90b4d2ff6acb88af);
$parcel$export(module.exports, "self", () => $e33f3b456b841cc9$export$82c2e460fb230c2a);
$parcel$export(module.exports, "window", () => $e33f3b456b841cc9$export$8291e5b88f90ce4);
$parcel$export(module.exports, "document", () => $e33f3b456b841cc9$export$5a7bfc01df82fcd1);
"use strict";
const $e33f3b456b841cc9$export$90b4d2ff6acb88af = globalThis;
const $e33f3b456b841cc9$export$82c2e460fb230c2a = globalThis;
const $e33f3b456b841cc9$export$8291e5b88f90ce4 = globalThis;
const $e33f3b456b841cc9$export$5a7bfc01df82fcd1 = $e33f3b456b841cc9$export$8291e5b88f90ce4.document // eslint-disable-line
;

});



parcelRegister("8wu6n", function(module, exports) {

$parcel$export(module.exports, "exec", () => $6348a97baa20d8d9$export$78e3044358792147);
$parcel$export(module.exports, "map", () => $6348a97baa20d8d9$export$871de8747c9eaa88);
$parcel$export(module.exports, "merge", () => $6348a97baa20d8d9$export$4950aa0f605343fb);
$parcel$export(module.exports, "deepMerge", () => $6348a97baa20d8d9$export$6969335ea1e4e77c);
$parcel$export(module.exports, "clone", () => $6348a97baa20d8d9$export$9cd59f9826255e47);
$parcel$export(module.exports, "deepCloneExclude", () => $6348a97baa20d8d9$export$99e9e507e655127d);
$parcel$export(module.exports, "mergeArrayExclude", () => $6348a97baa20d8d9$export$1c8d6f44648a0c27);
$parcel$export(module.exports, "deepClone", () => $6348a97baa20d8d9$export$b7d58db314e0ac27);
$parcel$export(module.exports, "deepCloneWithExtnd", () => $6348a97baa20d8d9$export$e249d5701977b61b);
$parcel$export(module.exports, "deepStringify", () => $6348a97baa20d8d9$export$7885cbf849c4488d);
$parcel$export(module.exports, "objectToString", () => $6348a97baa20d8d9$export$830c053460e5ddf6);
$parcel$export(module.exports, "detachFunctionsFromObject", () => $6348a97baa20d8d9$export$43ffbb9d42fee1c4);
$parcel$export(module.exports, "deepDestringify", () => $6348a97baa20d8d9$export$87659e1dc59ed8a3);
$parcel$export(module.exports, "stringToObject", () => $6348a97baa20d8d9$export$a6c9a3ccba61521e);
$parcel$export(module.exports, "diffObjects", () => $6348a97baa20d8d9$export$fcd7b39b3d1c2c1);
$parcel$export(module.exports, "diff", () => $6348a97baa20d8d9$export$a37e3c603d7117e5);
$parcel$export(module.exports, "diffArrays", () => $6348a97baa20d8d9$export$f1c08b3bfc8443c4);
$parcel$export(module.exports, "hasOwnProperty", () => $6348a97baa20d8d9$export$5a15a386532a5ea4);
$parcel$export(module.exports, "isEmpty", () => $6348a97baa20d8d9$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "isEmptyObject", () => $6348a97baa20d8d9$export$83b788b1a3698c03);
$parcel$export(module.exports, "makeObjectWithoutPrototype", () => $6348a97baa20d8d9$export$d6d64087a1bd2d);
$parcel$export(module.exports, "deepDiff", () => $6348a97baa20d8d9$export$f00d38dfe38936c3);
$parcel$export(module.exports, "overwrite", () => $6348a97baa20d8d9$export$d3305692eb3e9a81);
$parcel$export(module.exports, "overwriteShallow", () => $6348a97baa20d8d9$export$1c07155dfdd98f41);
$parcel$export(module.exports, "overwriteDeep", () => $6348a97baa20d8d9$export$f0b277b530b4fffd);
$parcel$export(module.exports, "mergeIfExisted", () => $6348a97baa20d8d9$export$7bde6dffa6d2dd59);
$parcel$export(module.exports, "flattenRecursive", () => $6348a97baa20d8d9$export$d53c2c5b09d0676f);
$parcel$export(module.exports, "isEqualDeep", () => $6348a97baa20d8d9$export$683c7d6569f339f4);
$parcel$export(module.exports, "deepContains", () => $6348a97baa20d8d9$export$273cb3019e2f952c);
$parcel$export(module.exports, "removeFromObject", () => $6348a97baa20d8d9$export$bdd7fc6cf95d63b);

var $jvD5p = parcelRequire("jvD5p");

var $EqHTq = parcelRequire("EqHTq");

var $hSU9O = parcelRequire("hSU9O");

var $5WrxC = parcelRequire("5WrxC");
"use strict";
const $6348a97baa20d8d9$export$78e3044358792147 = (param, element, state, context)=>{
    if ((0, $EqHTq.isFunction)(param)) return param(element, state || element.state, context || element.context);
    return param;
};
const $6348a97baa20d8d9$export$871de8747c9eaa88 = (obj, extention, element)=>{
    for(const e in extention)obj[e] = $6348a97baa20d8d9$export$78e3044358792147(extention[e], element);
};
const $6348a97baa20d8d9$export$4950aa0f605343fb = (element, obj, excludeFrom = [])=>{
    for(const e in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, e);
        if (!hasOwnProperty || excludeFrom.includes(e) || e.startsWith("__")) continue;
        const elementProp = element[e];
        const objProp = obj[e];
        if (elementProp === undefined) element[e] = objProp;
    }
    return element;
};
const $6348a97baa20d8d9$export$6969335ea1e4e77c = (element, extend, excludeFrom = [])=>{
    for(const e in extend){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(extend, e);
        if (!hasOwnProperty || excludeFrom.includes(e) || e.startsWith("__")) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if ((0, $EqHTq.isObjectLike)(elementProp) && (0, $EqHTq.isObjectLike)(extendProp)) $6348a97baa20d8d9$export$6969335ea1e4e77c(elementProp, extendProp, excludeFrom);
        else if (elementProp === undefined) element[e] = extendProp;
    }
    return element;
};
const $6348a97baa20d8d9$export$9cd59f9826255e47 = (obj, excludeFrom = [])=>{
    const o = {};
    for(const prop in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, prop);
        if (!hasOwnProperty || excludeFrom.includes(prop) || prop.startsWith("__")) continue;
        o[prop] = obj[prop];
    }
    return o;
};
const $6348a97baa20d8d9$export$99e9e507e655127d = (obj, excludeFrom = [])=>{
    if ((0, $EqHTq.isArray)(obj)) return obj.map((x)=>$6348a97baa20d8d9$export$99e9e507e655127d(x, excludeFrom));
    const o = {};
    for(const k in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, k);
        if (!hasOwnProperty || excludeFrom.includes(k) || k.startsWith("__")) continue;
        let v = obj[k];
        if (k === "extend" && (0, $EqHTq.isArray)(v)) v = $6348a97baa20d8d9$export$1c8d6f44648a0c27(v, excludeFrom);
        if ((0, $EqHTq.isArray)(v)) o[k] = v.map((x)=>$6348a97baa20d8d9$export$99e9e507e655127d(x, excludeFrom));
        else if ((0, $EqHTq.isObject)(v)) o[k] = $6348a97baa20d8d9$export$99e9e507e655127d(v, excludeFrom);
        else o[k] = v;
    }
    return o;
};
const $6348a97baa20d8d9$export$1c8d6f44648a0c27 = (arr, excl = [])=>{
    return arr.reduce((acc, curr)=>$6348a97baa20d8d9$export$6969335ea1e4e77c(acc, $6348a97baa20d8d9$export$99e9e507e655127d(curr, excl)), {});
};
const $6348a97baa20d8d9$export$b7d58db314e0ac27 = (obj, excludeFrom = [], cleanUndefined = false)=>{
    const o = (0, $EqHTq.isArray)(obj) ? [] : {};
    for(const prop in obj){
        if (prop === "__proto__") continue;
        if (excludeFrom.includes(prop) || prop.startsWith("__")) continue;
        let objProp = obj[prop];
        if (cleanUndefined && (0, $EqHTq.isUndefined)(objProp)) continue;
        if (prop === "extend" && (0, $EqHTq.isArray)(objProp)) objProp = (0, $hSU9O.mergeArray)(objProp);
        if ((0, $EqHTq.isObjectLike)(objProp)) o[prop] = $6348a97baa20d8d9$export$b7d58db314e0ac27(objProp, excludeFrom, cleanUndefined);
        else o[prop] = objProp;
    }
    return o;
};
const $6348a97baa20d8d9$export$e249d5701977b61b = (obj, excludeFrom = [], cleanUndefined = false)=>{
    const o = (0, $EqHTq.isArray)(obj) ? [] : {};
    for(const prop in obj){
        if (prop === "__proto__") continue;
        if (excludeFrom.includes(prop) || prop.startsWith("__")) continue;
        const objProp = obj[prop];
        if (cleanUndefined && (0, $EqHTq.isUndefined)(objProp)) continue;
        if ((0, $EqHTq.isObjectLike)(objProp)) o[prop] = $6348a97baa20d8d9$export$e249d5701977b61b(objProp, excludeFrom, cleanUndefined);
        else o[prop] = objProp;
    }
    return o;
};
const $6348a97baa20d8d9$export$7885cbf849c4488d = (obj, stringified = {})=>{
    for(const prop in obj){
        const objProp = obj[prop];
        if ((0, $EqHTq.isFunction)(objProp)) stringified[prop] = objProp.toString();
        else if ((0, $EqHTq.isObject)(objProp)) {
            stringified[prop] = {};
            $6348a97baa20d8d9$export$7885cbf849c4488d(objProp, stringified[prop]);
        } else if ((0, $EqHTq.isArray)(objProp)) {
            stringified[prop] = [];
            objProp.forEach((v, i)=>{
                if ((0, $EqHTq.isObject)(v)) {
                    stringified[prop][i] = {};
                    $6348a97baa20d8d9$export$7885cbf849c4488d(v, stringified[prop][i]);
                } else if ((0, $EqHTq.isFunction)(v)) stringified[prop][i] = v.toString();
                else stringified[prop][i] = v;
            });
        } else stringified[prop] = objProp;
    }
    return stringified;
};
const $6348a97baa20d8d9$export$830c053460e5ddf6 = (obj, indent = 0)=>{
    const spaces = "  ".repeat(indent);
    let str = "{\n";
    for (const [key, value] of Object.entries(obj)){
        const keyNotAllowdChars = (0, $5WrxC.stringIncludesAny)(key, [
            "&",
            "*",
            "-",
            ":",
            "%",
            "{",
            "}",
            ">",
            "<",
            "@",
            ".",
            "/",
            "!",
            " "
        ]);
        const stringedKey = keyNotAllowdChars ? `'${key}'` : key;
        str += `${spaces}  ${stringedKey}: `;
        if ((0, $EqHTq.isArray)(value)) {
            str += "[\n";
            for (const element of value){
                if ((0, $EqHTq.isObject)(element) && element !== null) str += `${spaces}    ${$6348a97baa20d8d9$export$830c053460e5ddf6(element, indent + 2)},\n`;
                else if ((0, $EqHTq.isString)(element)) str += `${spaces}    '${element}',\n`;
                else str += `${spaces}    ${element},\n`;
            }
            str += `${spaces}  ]`;
        } else if ((0, $EqHTq.isObjectLike)(value)) str += $6348a97baa20d8d9$export$830c053460e5ddf6(value, indent + 1);
        else if ((0, $EqHTq.isString)(value)) str += (0, $5WrxC.stringIncludesAny)(value, [
            "\n",
            "'"
        ]) ? `\`${value}\`` : `'${value}'`;
        else str += value;
        str += ",\n";
    }
    str += `${spaces}}`;
    return str;
};
const $6348a97baa20d8d9$export$43ffbb9d42fee1c4 = (obj, detached = {})=>{
    for(const prop in obj){
        const objProp = obj[prop];
        if ((0, $EqHTq.isFunction)(objProp)) continue;
        else if ((0, $EqHTq.isObject)(objProp)) {
            detached[prop] = {};
            $6348a97baa20d8d9$export$7885cbf849c4488d(objProp, detached[prop]);
        } else if ((0, $EqHTq.isArray)(objProp)) {
            detached[prop] = [];
            objProp.forEach((v, i)=>{
                if ((0, $EqHTq.isFunction)(v)) return;
                if ((0, $EqHTq.isObject)(v)) {
                    detached[prop][i] = {};
                    $6348a97baa20d8d9$export$43ffbb9d42fee1c4(v, detached[prop][i]);
                } else detached[prop][i] = v;
            });
        } else detached[prop] = objProp;
    }
    return detached;
};
const $6348a97baa20d8d9$export$87659e1dc59ed8a3 = (obj, destringified = {})=>{
    for(const prop in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, prop);
        if (!hasOwnProperty) continue;
        const objProp = obj[prop];
        if ((0, $EqHTq.isString)(objProp)) {
            if (objProp.includes("=>") || objProp.includes("function") || objProp.startsWith("(")) try {
                const evalProp = (0, $jvD5p.window).eval(`(${objProp})`) // use parentheses to convert string to function expression
                ;
                destringified[prop] = evalProp;
            } catch (e) {
                if (e) destringified[prop] = objProp;
            }
            else destringified[prop] = objProp;
        } else if ((0, $EqHTq.isArray)(objProp)) {
            destringified[prop] = [];
            objProp.forEach((arrProp)=>{
                if ((0, $EqHTq.isString)(arrProp)) {
                    if (arrProp.includes("=>") || arrProp.includes("function") || arrProp.startsWith("(")) try {
                        const evalProp = (0, $jvD5p.window).eval(`(${arrProp})`) // use parentheses to convert string to function expression
                        ;
                        destringified[prop].push(evalProp);
                    } catch (e) {
                        if (e) destringified[prop].push(arrProp);
                    }
                    else destringified[prop].push(arrProp);
                } else if ((0, $EqHTq.isObject)(arrProp)) destringified[prop].push($6348a97baa20d8d9$export$87659e1dc59ed8a3(arrProp));
                else destringified[prop].push(arrProp);
            });
        } else if ((0, $EqHTq.isObject)(objProp)) destringified[prop] = $6348a97baa20d8d9$export$87659e1dc59ed8a3(objProp, destringified[prop]) // recursively call deepDestringify for nested objects
        ;
        else destringified[prop] = objProp;
    }
    return destringified;
};
const $6348a97baa20d8d9$export$a6c9a3ccba61521e = (str, verbose)=>{
    try {
        return (0, $jvD5p.window).eval("(" + str + ")") // eslint-disable-line
        ;
    } catch (e) {
        if (verbose) console.warn(e);
    }
};
const $6348a97baa20d8d9$export$fcd7b39b3d1c2c1 = (original, objToDiff, cache)=>{
    for(const e in objToDiff){
        if (e === "ref") continue;
        const originalProp = original[e];
        const objToDiffProp = objToDiff[e];
        if ((0, $EqHTq.isObject)(originalProp) && (0, $EqHTq.isObject)(objToDiffProp)) {
            cache[e] = {};
            $6348a97baa20d8d9$export$a37e3c603d7117e5(originalProp, objToDiffProp, cache[e]);
        } else if (objToDiffProp !== undefined) cache[e] = objToDiffProp;
    }
    return cache;
};
const $6348a97baa20d8d9$export$f1c08b3bfc8443c4 = (original, objToDiff, cache)=>{
    if (original.length !== objToDiff.length) cache = objToDiff;
    else {
        const diffArr = [];
        for(let i = 0; i < original.length; i++){
            const diffObj = $6348a97baa20d8d9$export$a37e3c603d7117e5(original[i], objToDiff[i]);
            if (Object.keys(diffObj).length > 0) diffArr.push(diffObj);
        }
        if (diffArr.length > 0) cache = diffArr;
    }
    return cache;
};
const $6348a97baa20d8d9$export$a37e3c603d7117e5 = (original, objToDiff, cache = {})=>{
    if ((0, $EqHTq.isArray)(original) && (0, $EqHTq.isArray)(objToDiff)) {
        cache = [];
        $6348a97baa20d8d9$export$f1c08b3bfc8443c4(original, objToDiff, cache);
    } else $6348a97baa20d8d9$export$fcd7b39b3d1c2c1(original, objToDiff, cache);
    return cache;
};
const $6348a97baa20d8d9$export$5a15a386532a5ea4 = (o, ...args)=>Object.prototype.hasOwnProperty.call(o, ...args);
const $6348a97baa20d8d9$export$dd1bc94b04021eeb = (o)=>Object.keys(o).length === 0;
const $6348a97baa20d8d9$export$83b788b1a3698c03 = (o)=>(0, $EqHTq.isObject)(o) && $6348a97baa20d8d9$export$dd1bc94b04021eeb(o);
const $6348a97baa20d8d9$export$d6d64087a1bd2d = ()=>Object.create(null);
const $6348a97baa20d8d9$export$f00d38dfe38936c3 = (lhs, rhs)=>{
    if (lhs === rhs) return {};
    if (!(0, $EqHTq.isObjectLike)(lhs) || !(0, $EqHTq.isObjectLike)(rhs)) return rhs;
    const deletedValues = Object.keys(lhs).reduce((acc, key)=>{
        if (!$6348a97baa20d8d9$export$5a15a386532a5ea4(rhs, key)) acc[key] = undefined;
        return acc;
    }, $6348a97baa20d8d9$export$d6d64087a1bd2d());
    if ((0, $EqHTq.isDate)(lhs) || (0, $EqHTq.isDate)(rhs)) {
        if (lhs.valueOf() === rhs.valueOf()) return {};
        return rhs;
    }
    return Object.keys(rhs).reduce((acc, key)=>{
        if (!$6348a97baa20d8d9$export$5a15a386532a5ea4(lhs, key)) {
            acc[key] = rhs[key];
            return acc;
        }
        const difference = $6348a97baa20d8d9$export$a37e3c603d7117e5(lhs[key], rhs[key]);
        if ($6348a97baa20d8d9$export$83b788b1a3698c03(difference) && !(0, $EqHTq.isDate)(difference) && ($6348a97baa20d8d9$export$83b788b1a3698c03(lhs[key]) || !$6348a97baa20d8d9$export$83b788b1a3698c03(rhs[key]))) return acc;
        acc[key] = difference;
        return acc;
    }, deletedValues);
};
const $6348a97baa20d8d9$export$d3305692eb3e9a81 = (element, params, excludeFrom = [])=>{
    const { ref: ref } = element;
    const changes = {};
    for(const e in params){
        if (excludeFrom.includes(e) || e.startsWith("__")) continue;
        const elementProp = element[e];
        const paramsProp = params[e];
        if (paramsProp) {
            ref.__cache[e] = changes[e] = elementProp;
            ref[e] = paramsProp;
        }
    }
    return changes;
};
const $6348a97baa20d8d9$export$1c07155dfdd98f41 = (obj, params, excludeFrom = [])=>{
    for(const e in params){
        if (excludeFrom.includes(e) || e.startsWith("__")) continue;
        obj[e] = params[e];
    }
    return obj;
};
const $6348a97baa20d8d9$export$f0b277b530b4fffd = (obj, params, excludeFrom = [])=>{
    for(const e in params){
        if (e === "__proto__") continue;
        if (excludeFrom.includes(e) || e.startsWith("__")) continue;
        const objProp = obj[e];
        const paramsProp = params[e];
        if ((0, $EqHTq.isObjectLike)(objProp) && (0, $EqHTq.isObjectLike)(paramsProp)) $6348a97baa20d8d9$export$f0b277b530b4fffd(objProp, paramsProp);
        else if (paramsProp !== undefined) obj[e] = paramsProp;
    }
    return obj;
};
const $6348a97baa20d8d9$export$7bde6dffa6d2dd59 = (a, b)=>{
    if ((0, $EqHTq.isObjectLike)(a) && (0, $EqHTq.isObjectLike)(b)) return $6348a97baa20d8d9$export$6969335ea1e4e77c(a, b);
    return a || b;
};
const $6348a97baa20d8d9$export$d53c2c5b09d0676f = (param, prop, stack = [])=>{
    const objectized = (0, $hSU9O.mergeAndCloneIfArray)(param);
    stack.push(objectized);
    const extendOfExtend = objectized[prop];
    if (extendOfExtend) $6348a97baa20d8d9$export$d53c2c5b09d0676f(extendOfExtend, prop, stack);
    delete objectized[prop];
    return stack;
};
const $6348a97baa20d8d9$export$683c7d6569f339f4 = (param, element, visited = new Set())=>{
    // Check if both values are non-null objects
    if (typeof param !== "object" || typeof element !== "object" || param === null || element === null) return param === element // Compare non-object values directly
    ;
    // Check for circular references
    if (visited.has(param) || visited.has(element)) return true // Assume equality to break the circular reference
    ;
    visited.add(param);
    visited.add(element);
    const keysParam = Object.keys(param);
    const keysElement = Object.keys(element);
    // Check if both objects have the same number of properties
    if (keysParam.length !== keysElement.length) return false;
    // Check if all properties in param also exist in element
    for (const key of keysParam){
        if (!keysElement.includes(key)) return false;
        const paramProp = param[key];
        const elementProp = element[key];
        // Recursively check property values
        if (!$6348a97baa20d8d9$export$683c7d6569f339f4(paramProp, elementProp, visited)) return false;
    }
    return true;
};
const $6348a97baa20d8d9$export$273cb3019e2f952c = (obj1, obj2)=>{
    if (typeof obj1 !== typeof obj2) return false;
    if ((0, $EqHTq.isObjectLike)(obj1)) {
        if (Array.isArray(obj1) && Array.isArray(obj2)) {
            if (obj1.length !== obj2.length) return false;
            for(let i = 0; i < obj1.length; i++){
                if (!$6348a97baa20d8d9$export$273cb3019e2f952c(obj1[i], obj2[i])) return false;
            }
        } else if ((0, $EqHTq.isObjectLike)(obj1) && obj2 !== null) for(const key in obj1){
            const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj2, key);
            if (!hasOwnProperty || !$6348a97baa20d8d9$export$273cb3019e2f952c(obj1[key], obj2[key])) return false;
        }
    } else return obj2 === obj1;
    return true;
};
const $6348a97baa20d8d9$export$bdd7fc6cf95d63b = (obj, props)=>{
    if (props === undefined || props === null) return obj;
    if ((0, $EqHTq.is)(props)("string", "number")) delete obj[props];
    else if ((0, $EqHTq.isArray)(props)) props.forEach((prop)=>delete obj[prop]);
    else throw new Error("Invalid input: props must be a string or an array of strings");
    return obj;
};

});
parcelRegister("hSU9O", function(module, exports) {

$parcel$export(module.exports, "arrayContainsOtherArray", () => $d0530a7c3063b815$export$de875babef361e5d);
$parcel$export(module.exports, "removeFromArray", () => $d0530a7c3063b815$export$8af121ae7401c4);
$parcel$export(module.exports, "swapItemsInArray", () => $d0530a7c3063b815$export$7e6517ca043a4c76);
$parcel$export(module.exports, "joinArrays", () => $d0530a7c3063b815$export$fc359ae9633f7296);
$parcel$export(module.exports, "mergeArray", () => $d0530a7c3063b815$export$fd2fbaf2367ef824);
$parcel$export(module.exports, "mergeAndCloneIfArray", () => $d0530a7c3063b815$export$803a4c6bdde5cd1d);
$parcel$export(module.exports, "cutArrayBeforeValue", () => $d0530a7c3063b815$export$e1c90dd42d36d8f4);
$parcel$export(module.exports, "cutArrayAfterValue", () => $d0530a7c3063b815$export$e9b4b966d876219d);
$parcel$export(module.exports, "createNestedObject", () => $d0530a7c3063b815$export$a9706fb8026b394a);
$parcel$export(module.exports, "removeValueFromArray", () => $d0530a7c3063b815$export$7268a0a9258a5297);
$parcel$export(module.exports, "removeValueFromArrayAll", () => $d0530a7c3063b815$export$91b305d65813a3f8);

var $8wu6n = parcelRequire("8wu6n");

var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $d0530a7c3063b815$export$de875babef361e5d = (arr1, arr2)=>{
    return arr2.every((val)=>arr1.includes(val));
};
const $d0530a7c3063b815$export$8af121ae7401c4 = (arr, index)=>{
    if ((0, $EqHTq.isString)(index)) index = parseInt(index);
    if ((0, $EqHTq.isNumber)(index)) {
        if (index < 0 || index >= arr.length || isNaN(index)) throw new Error("Invalid index");
        arr.splice(index, 1);
    } else if ((0, $EqHTq.isArray)(index)) index.forEach((idx)=>$d0530a7c3063b815$export$8af121ae7401c4(arr, idx));
    else throw new Error("Invalid index");
    return arr;
};
const $d0530a7c3063b815$export$7e6517ca043a4c76 = (arr, i, j)=>{
    [arr[i], arr[j]] = [
        arr[j],
        arr[i]
    ];
};
const $d0530a7c3063b815$export$fc359ae9633f7296 = (...arrays)=>{
    return [].concat(...arrays);
};
const $d0530a7c3063b815$export$fd2fbaf2367ef824 = (arr, excludeFrom = [])=>{
    return arr.reduce((a, c)=>(0, $8wu6n.deepMerge)(a, (0, $8wu6n.deepClone)(c, excludeFrom), excludeFrom), {});
};
const $d0530a7c3063b815$export$803a4c6bdde5cd1d = (obj)=>{
    return (0, $EqHTq.isArray)(obj) ? $d0530a7c3063b815$export$fd2fbaf2367ef824(obj) : (0, $8wu6n.deepClone)(obj);
};
const $d0530a7c3063b815$export$e1c90dd42d36d8f4 = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index !== -1) return arr.slice(0, index);
    return arr;
};
const $d0530a7c3063b815$export$e9b4b966d876219d = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index !== -1) return arr.slice(index + 1);
    return arr;
};
const $d0530a7c3063b815$export$a9706fb8026b394a = (arr, lastValue)=>{
    const nestedObject = {};
    if (arr.length === 0) return lastValue;
    arr.reduce((obj, value, index)=>{
        if (!obj[value]) obj[value] = {};
        if (index === arr.length - 1 && lastValue) obj[value] = lastValue;
        return obj[value];
    }, nestedObject);
    return nestedObject;
};
const $d0530a7c3063b815$export$7268a0a9258a5297 = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index > -1) {
        const newArray = [
            ...arr
        ];
        newArray.splice(index, 1);
        return newArray;
    }
    return arr.slice();
};
const $d0530a7c3063b815$export$91b305d65813a3f8 = (arr, value)=>{
    return arr.filter((item)=>item !== value);
};

});

parcelRegister("5WrxC", function(module, exports) {

$parcel$export(module.exports, "stringIncludesAny", () => $4537bba2bd33729a$export$5e62532c096c05e0);
$parcel$export(module.exports, "trimStringFromSymbols", () => $4537bba2bd33729a$export$4cb168a4c77839cc);
$parcel$export(module.exports, "replaceLiteralsWithObjectFields", () => $4537bba2bd33729a$export$7cb52b7decbd2220);
$parcel$export(module.exports, "lowercaseFirstLetter", () => $4537bba2bd33729a$export$f08459d87829d2ee);
"use strict";
const $4537bba2bd33729a$export$5e62532c096c05e0 = (str, characters)=>{
    for (const char of characters){
        if (str.includes(char)) return true;
    }
    return false;
};
const $4537bba2bd33729a$export$4cb168a4c77839cc = (str, characters)=>{
    // Create a regular expression pattern to match the specified symbols
    const pattern = new RegExp(`[${characters.join("\\")}]`, "g");
    // Replace matched symbols with an empty string
    return str.replace(pattern, "");
};
/**
 * Replaces placeholders in a string with corresponding {{ }} values from an object.
 *
 * @param {string} str - The string containing placeholders to replace.
 * @param {object} state - The object containing the values to substitute.
 * @returns {string} The modified string with placeholders replaced by values from the object.
 */ const $4537bba2bd33729a$var$brackRegex = /\{\{\s*((?:\.\.\/)+)?([^}\s]+)\s*\}\}/g;
const $4537bba2bd33729a$export$7cb52b7decbd2220 = (str, state)=>{
    if (!str.includes("{{")) return str;
    return str.replace($4537bba2bd33729a$var$brackRegex, (_, parentPath, variable)=>{
        if (parentPath) {
            const parentLevels = parentPath.match(/\.\.\//g).length;
            let parentState = state;
            for(let i = 0; i < parentLevels; i++){
                parentState = parentState.parent;
                if (!parentState) return "" // Return an empty string if the parent level doesn't exist
                ;
            }
            const value = parentState[variable.trim()];
            return value !== undefined ? `${value}` : "";
        } else {
            const value = state[variable.trim()];
            return value !== undefined ? `${value}` : "";
        }
    });
};
const $4537bba2bd33729a$export$f08459d87829d2ee = (inputString)=>{
    return `${inputString.charAt(0).toLowerCase()}${inputString.slice(1)}`;
};

});


parcelRegister("fMhOg", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $b7c9275e9e0262d0$export$61fc7d43ac8f84b0);
$parcel$export(module.exports, "debounceOnContext", () => $b7c9275e9e0262d0$export$d3757b91c00af798);
$parcel$export(module.exports, "memoize", () => $b7c9275e9e0262d0$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "isStringFunction", () => $b7c9275e9e0262d0$export$6f017d9966fe4675);
"use strict";
function $b7c9275e9e0262d0$export$61fc7d43ac8f84b0(func, wait, immediate) {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
const $b7c9275e9e0262d0$export$d3757b91c00af798 = (element, func, timeout = 300)=>{
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            func.apply(element, args);
        }, timeout);
    };
};
const $b7c9275e9e0262d0$export$fc10aeed3a532e2a = (fn)=>{
    const cache = {};
    return (...args)=>{
        const n = args[0];
        if (n in cache) return cache[n];
        else {
            const result = fn(n);
            cache[n] = result;
            return result;
        }
    };
};
const $b7c9275e9e0262d0$export$6f017d9966fe4675 = (inputString)=>{
    // Regular expression to match both regular and arrow function declarations
    const functionRegex = /^((function\s*\([^)]*\)\s*\{[^}]*\})|(\([^)]*\)\s*=>))/;
    // Use the regex to test if the inputString matches the function pattern
    return functionRegex.test(inputString);
};

});

parcelRegister("cQ6eY", function(module, exports) {

$parcel$export(module.exports, "logIf", () => $958f2e9ae228360b$export$f3730dd3d285b7c6);
$parcel$export(module.exports, "logGroupIf", () => $958f2e9ae228360b$export$7cea94b68a0c230b);
"use strict";
const $958f2e9ae228360b$export$f3730dd3d285b7c6 = (bool, ...arg)=>{
    if (bool) arg.map((v)=>console.log(v));
};
const $958f2e9ae228360b$export$7cea94b68a0c230b = (bool, key, ...arg)=>{
    if (bool) {
        console.group(key);
        arg.map((v)=>console.log(v));
        console.groupEnd(key);
    }
};

});

parcelRegister("57Gb5", function(module, exports) {

$parcel$export(module.exports, "isMobile", () => $3bae52d896fdaae9$export$d0a8044dce8ff2fc);
$parcel$export(module.exports, "setCookie", () => $3bae52d896fdaae9$export$110700823644f4a6);
$parcel$export(module.exports, "getCookie", () => $3bae52d896fdaae9$export$4be65e66cfa2648a);

var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $3bae52d896fdaae9$export$d0a8044dce8ff2fc = (()=>typeof navigator === "undefined" ? false : /Mobi/.test(navigator.userAgent))();
const $3bae52d896fdaae9$export$110700823644f4a6 = (cname, cvalue, exdays = 365)=>{
    if ((0, $EqHTq.isUndefined)(document) || (0, $EqHTq.isUndefined)(document.cookie)) return;
    const d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
};
const $3bae52d896fdaae9$export$4be65e66cfa2648a = (cname)=>{
    if ((0, $EqHTq.isUndefined)(document) || (0, $EqHTq.isUndefined)(document.cookie)) return;
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) === " ")c = c.substring(1);
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return "";
};

});

parcelRegister("glQML", function(module, exports) {

$parcel$export(module.exports, "HTML_TAGS", () => $be778da0f6744ca3$export$4c3fa92ca590c71f);
$parcel$export(module.exports, "isValidHtmlTag", () => $be778da0f6744ca3$export$52675ca41d41c093);
"use strict";
const $be778da0f6744ca3$export$4c3fa92ca590c71f = {
    root: [
        "body",
        "html"
    ],
    head: [
        "title",
        "base",
        "meta",
        "style"
    ],
    body: [
        "string",
        "fragment",
        "a",
        "abbr",
        "acronym",
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "basefont",
        "bdi",
        "bdo",
        "big",
        "blockquote",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "search",
        "col",
        "colgroup",
        "data",
        "datalist",
        "dd",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "em",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hr",
        "i",
        "iframe",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "link",
        "main",
        "map",
        "mark",
        "meter",
        "nav",
        "noframes",
        "noscript",
        "object",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "param",
        "picture",
        "pre",
        "progress",
        "hgroup",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "script",
        "section",
        "select",
        "small",
        "source",
        "span",
        "strike",
        "strong",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "hgroup",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr",
        // SVG
        "svg",
        "path"
    ]
};
const $be778da0f6744ca3$export$52675ca41d41c093 = (arg)=>$be778da0f6744ca3$export$4c3fa92ca590c71f.body.includes(arg);

});


parcelRegister("aOJ2H", function(module, exports) {

$parcel$export(module.exports, "global", () => $7e0183656ac8db45$export$90b4d2ff6acb88af);
$parcel$export(module.exports, "self", () => $7e0183656ac8db45$export$82c2e460fb230c2a);
$parcel$export(module.exports, "window", () => $7e0183656ac8db45$export$8291e5b88f90ce4);
$parcel$export(module.exports, "document", () => $7e0183656ac8db45$export$5a7bfc01df82fcd1);
"use strict";
const $7e0183656ac8db45$export$90b4d2ff6acb88af = globalThis;
const $7e0183656ac8db45$export$82c2e460fb230c2a = globalThis;
const $7e0183656ac8db45$export$8291e5b88f90ce4 = globalThis;
const $7e0183656ac8db45$export$5a7bfc01df82fcd1 = $7e0183656ac8db45$export$8291e5b88f90ce4.document // eslint-disable-line
;

});

parcelRegister("73MNt", function(module, exports) {

$parcel$export(module.exports, "default", () => $523eaa49d3f99bf8$export$841407ceb083bd74);

var $kATNo = parcelRequire("kATNo");

var $fL4YY = parcelRequire("fL4YY");

var $lGX0c = parcelRequire("lGX0c");

var $2BjQv = parcelRequire("2BjQv");
/**
 * Managers cache.
 */ const $523eaa49d3f99bf8$var$cache = {};
function $523eaa49d3f99bf8$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $kATNo.url)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $523eaa49d3f99bf8$var$cache[id] && path in $523eaa49d3f99bf8$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $fL4YY.Manager)(source, opts);
    else {
        if (!$523eaa49d3f99bf8$var$cache[id]) $523eaa49d3f99bf8$var$cache[id] = new (0, $fL4YY.Manager)(source, opts);
        io = $523eaa49d3f99bf8$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($523eaa49d3f99bf8$export$841407ceb083bd74, {
    Manager: $fL4YY.Manager,
    Socket: $lGX0c.Socket,
    io: $523eaa49d3f99bf8$export$841407ceb083bd74,
    connect: $523eaa49d3f99bf8$export$841407ceb083bd74
});

});
parcelRegister("kATNo", function(module, exports) {

$parcel$export(module.exports, "url", () => $efe27346e00da8a8$export$128fa18b7194ef);
parcelRequire("1XKMK");
var $l7wSz = parcelRequire("l7wSz");
function $efe27346e00da8a8$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $l7wSz.parse)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}

});
parcelRegister("1XKMK", function(module, exports) {

$parcel$export(module.exports, "Socket", () => (parcelRequire("al9N3")).Socket);
$parcel$export(module.exports, "installTimerFunctions", () => (parcelRequire("5vwdc")).installTimerFunctions);
$parcel$export(module.exports, "parse", () => (parcelRequire("l7wSz")).parse);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("cFgwF")).nextTick);

var $al9N3 = parcelRequire("al9N3");

var $6opKi = parcelRequire("6opKi");

var $gEtm1 = parcelRequire("gEtm1");

var $5vwdc = parcelRequire("5vwdc");

var $l7wSz = parcelRequire("l7wSz");

var $cFgwF = parcelRequire("cFgwF");
const $16df97babd1aadf1$export$a51d6b395ff4c65a = (0, $al9N3.Socket).protocol;

});
parcelRegister("al9N3", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $787375aed2c43820$export$4798917dbf149b79);

var $gEtm1 = parcelRequire("gEtm1");

var $5vwdc = parcelRequire("5vwdc");

var $2buxl = parcelRequire("2buxl");

var $l7wSz = parcelRequire("l7wSz");

var $687to = parcelRequire("687to");

var $CnWUo = parcelRequire("CnWUo");

var $cFgwF = parcelRequire("cFgwF");
class $787375aed2c43820$export$4798917dbf149b79 extends (0, $687to.Emitter) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts = {}){
        super();
        this.binaryType = (0, $cFgwF.defaultBinaryType);
        this.writeBuffer = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            uri = (0, $l7wSz.parse)(uri);
            opts.hostname = uri.host;
            opts.secure = uri.protocol === "https" || uri.protocol === "wss";
            opts.port = uri.port;
            if (uri.query) opts.query = uri.query;
        } else if (opts.host) opts.hostname = (0, $l7wSz.parse)(opts.host).host;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = opts.transports || [
            "polling",
            "websocket",
            "webtransport"
        ];
        this.writeBuffer = [];
        this.prevBufferLen = 0;
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $2buxl.decode)(this.opts.query);
        // set on handshake
        this.id = null;
        this.upgrades = null;
        this.pingInterval = null;
        this.pingTimeout = null;
        // set on heartbeat
        this.pingTimeoutTimer = null;
        if (typeof addEventListener === "function") {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this.beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this.beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this.offlineEventListener = ()=>{
                    this.onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                addEventListener("offline", this.offlineEventListener, false);
            }
        }
        this.open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $CnWUo.protocol);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new (0, $gEtm1.transports)[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ open() {
        let transport;
        if (this.opts.rememberUpgrade && $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) transport = "websocket";
        else if (0 === this.transports.length) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        } else transport = this.transports[0];
        this.readyState = "opening";
        // Retry with the next transport if the transport is disabled (jsonp: false)
        try {
            transport = this.createTransport(transport);
        } catch (e) {
            this.transports.shift();
            this.open();
            return;
        }
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (reason)=>this.onClose("transport close", reason));
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this.upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
        // we check for `readyState` in case an `open`
        // listener already closed the socket
        if ("open" === this.readyState && this.opts.upgrade) {
            let i = 0;
            const l = this.upgrades.length;
            for(; i < l; i++)this.probe(this.upgrades[i]);
        }
    }
    /**
     * Handles a packet.
     *
     * @private
     */ onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            this.resetPingTimeout();
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this.sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this.onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this.upgrades = this.filterUpgrades(data.upgrades);
        this.pingInterval = data.pingInterval;
        this.pingTimeout = data.pingTimeout;
        this.maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this.resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ resetPingTimeout() {
        this.clearTimeoutFn(this.pingTimeoutTimer);
        this.pingTimeoutTimer = this.setTimeoutFn(()=>{
            this.onClose("ping timeout");
        }, this.pingInterval + this.pingTimeout);
        if (this.opts.autoUnref) this.pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ onDrain() {
        this.writeBuffer.splice(0, this.prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this.prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this.getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this.prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ getWritablePackets() {
        const shouldCheckPayloadSize = this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $5vwdc.byteLength)(data);
            if (i > 0 && payloadSize > this.maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    send(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this.onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ onError(err) {
        $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess = false;
        this.emitReserved("error", err);
        this.onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this.pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if (typeof removeEventListener === "function") {
                removeEventListener("beforeunload", this.beforeunloadEventListener, false);
                removeEventListener("offline", this.offlineEventListener, false);
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this.prevBufferLen = 0;
        }
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        let i = 0;
        const j = upgrades.length;
        for(; i < j; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
$787375aed2c43820$export$4798917dbf149b79.protocol = (0, $CnWUo.protocol);

});
parcelRegister("gEtm1", function(module, exports) {

$parcel$export(module.exports, "transports", () => $c1f726e793763466$export$46dec00755c1153b);

var $7pvuz = parcelRequire("7pvuz");

var $dhyBt = parcelRequire("dhyBt");

var $hJTtX = parcelRequire("hJTtX");
const $c1f726e793763466$export$46dec00755c1153b = {
    websocket: (0, $dhyBt.WS),
    webtransport: (0, $hJTtX.WT),
    polling: (0, $7pvuz.Polling)
};

});
parcelRegister("7pvuz", function(module, exports) {

$parcel$export(module.exports, "Polling", () => $56534be56e5aa809$export$265ee5eefd4c309b);

var $6opKi = parcelRequire("6opKi");

var $e3yjg = parcelRequire("e3yjg");

var $CnWUo = parcelRequire("CnWUo");

var $lB1J3 = parcelRequire("lB1J3");

var $687to = parcelRequire("687to");

var $5vwdc = parcelRequire("5vwdc");

var $3kfWP = parcelRequire("3kfWP");
function $56534be56e5aa809$var$empty() {}
const $56534be56e5aa809$var$hasXHR2 = function() {
    const xhr = new (0, $lB1J3.XHR)({
        xdomain: false
    });
    return null != xhr.responseType;
}();
class $56534be56e5aa809$export$265ee5eefd4c309b extends (0, $6opKi.Transport) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        this.polling = false;
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
        /**
         * XHR supports binary
         */ const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $56534be56e5aa809$var$hasXHR2 && !forceBase64;
        if (this.opts.withCredentials) this.cookieJar = (0, $lB1J3.createCookieJar)();
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this.poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this.polling || !this.writable) {
            let total = 0;
            if (this.polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ poll() {
        this.polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $CnWUo.decodePayload)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this.polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this.poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $CnWUo.encodePayload)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $e3yjg.yeast)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Creates a request.
     *
     * @param {String} method
     * @private
     */ request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd,
            cookieJar: this.cookieJar
        }, this.opts);
        return new $56534be56e5aa809$export$7fa6c5b6f8193917(this.uri(), opts);
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $56534be56e5aa809$export$7fa6c5b6f8193917 extends (0, $687to.Emitter) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(uri, opts){
        super();
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.method = opts.method || "GET";
        this.uri = uri;
        this.data = undefined !== opts.data ? opts.data : null;
        this.create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ create() {
        var _a;
        const opts = (0, $5vwdc.pick)(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this.opts.xd;
        const xhr = this.xhr = new (0, $lB1J3.XHR)(opts);
        try {
            xhr.open(this.method, this.uri, true);
            try {
                if (this.opts.extraHeaders) {
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this.opts.extraHeaders)if (this.opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this.opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this.method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this.opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this.opts.withCredentials;
            if (this.opts.requestTimeout) xhr.timeout = this.opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this.opts.cookieJar) === null || _a === void 0 || _a.parseCookies(xhr);
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this.onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this.onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this.data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this.onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this.index = $56534be56e5aa809$export$7fa6c5b6f8193917.requestsCount++;
            $56534be56e5aa809$export$7fa6c5b6f8193917.requests[this.index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ onError(err) {
        this.emitReserved("error", err, this.xhr);
        this.cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ cleanup(fromError) {
        if ("undefined" === typeof this.xhr || null === this.xhr) return;
        this.xhr.onreadystatechange = $56534be56e5aa809$var$empty;
        if (fromError) try {
            this.xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $56534be56e5aa809$export$7fa6c5b6f8193917.requests[this.index];
        this.xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ onLoad() {
        const data = this.xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this.cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this.cleanup();
    }
}
$56534be56e5aa809$export$7fa6c5b6f8193917.requestsCount = 0;
$56534be56e5aa809$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $56534be56e5aa809$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $3kfWP.globalThisShim) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $56534be56e5aa809$var$unloadHandler, false);
    }
}
function $56534be56e5aa809$var$unloadHandler() {
    for(let i in $56534be56e5aa809$export$7fa6c5b6f8193917.requests)if ($56534be56e5aa809$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $56534be56e5aa809$export$7fa6c5b6f8193917.requests[i].abort();
}

});
parcelRegister("6opKi", function(module, exports) {

$parcel$export(module.exports, "Transport", () => $4a78f487f5bb98d8$export$86495b081fef8e52);
parcelRequire("CnWUo");
var $ezyGD = parcelRequire("ezyGD");

var $687to = parcelRequire("687to");

var $5vwdc = parcelRequire("5vwdc");

var $2buxl = parcelRequire("2buxl");
class $4a78f487f5bb98d8$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $4a78f487f5bb98d8$export$86495b081fef8e52 extends (0, $687to.Emitter) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $4a78f487f5bb98d8$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $ezyGD.decodePacket)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $2buxl.encode)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}

});
parcelRegister("CnWUo", function(module, exports) {

$parcel$export(module.exports, "encodePayload", () => $0736208648dc8bae$export$144d64fe58dad441);
$parcel$export(module.exports, "decodePayload", () => $0736208648dc8bae$export$d10cc2e7f7566a2d);
$parcel$export(module.exports, "createPacketEncoderStream", () => $0736208648dc8bae$export$a525fb718e9c623a);
$parcel$export(module.exports, "createPacketDecoderStream", () => $0736208648dc8bae$export$552d20aac7500f47);
$parcel$export(module.exports, "protocol", () => $0736208648dc8bae$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "encodePacket", () => (parcelRequire("bRHuL")).encodePacket);
$parcel$export(module.exports, "decodePacket", () => (parcelRequire("ezyGD")).decodePacket);

var $bRHuL = parcelRequire("bRHuL");

var $ezyGD = parcelRequire("ezyGD");

var $fsDlh = parcelRequire("fsDlh");
const $0736208648dc8bae$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $0736208648dc8bae$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $bRHuL.encodePacket)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($0736208648dc8bae$var$SEPARATOR));
        });
    });
};
const $0736208648dc8bae$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($0736208648dc8bae$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $ezyGD.decodePacket)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $0736208648dc8bae$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $bRHuL.encodePacketToBinary)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $0736208648dc8bae$var$TEXT_DECODER;
function $0736208648dc8bae$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $0736208648dc8bae$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $0736208648dc8bae$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$0736208648dc8bae$var$TEXT_DECODER) $0736208648dc8bae$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* READ_HEADER */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 1) break;
                    const header = $0736208648dc8bae$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* READ_EXTENDED_LENGTH_16 */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 2) break;
                    const headerArray = $0736208648dc8bae$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* READ_PAYLOAD */ ;
                } else if (state === 2 /* READ_EXTENDED_LENGTH_64 */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 8) break;
                    const headerArray = $0736208648dc8bae$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $fsDlh.ERROR_PACKET));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* READ_PAYLOAD */ ;
                } else {
                    if ($0736208648dc8bae$var$totalLength(chunks) < expectedLength) break;
                    const data = $0736208648dc8bae$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $ezyGD.decodePacket)(isBinary ? data : $0736208648dc8bae$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $fsDlh.ERROR_PACKET));
                    break;
                }
            }
        }
    });
}
const $0736208648dc8bae$export$a51d6b395ff4c65a = 4;

});
parcelRegister("bRHuL", function(module, exports) {

$parcel$export(module.exports, "encodePacket", () => $8a3662315a48cdbd$export$57852049361a8e62);
$parcel$export(module.exports, "encodePacketToBinary", () => $8a3662315a48cdbd$export$ec0c9b9013ee0ef5);

var $fsDlh = parcelRequire("fsDlh");
const $8a3662315a48cdbd$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $8a3662315a48cdbd$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $8a3662315a48cdbd$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $8a3662315a48cdbd$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($8a3662315a48cdbd$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(data, callback);
    } else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $fsDlh.PACKET_TYPES)[type] + (data || ""));
};
const $8a3662315a48cdbd$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $8a3662315a48cdbd$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $8a3662315a48cdbd$var$TEXT_ENCODER;
function $8a3662315a48cdbd$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($8a3662315a48cdbd$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($8a3662315a48cdbd$var$toArray).then(callback);
    else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(packet.data))) return callback($8a3662315a48cdbd$var$toArray(packet.data));
    $8a3662315a48cdbd$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$8a3662315a48cdbd$var$TEXT_ENCODER) $8a3662315a48cdbd$var$TEXT_ENCODER = new TextEncoder();
        callback($8a3662315a48cdbd$var$TEXT_ENCODER.encode(encoded));
    });
}

});
parcelRegister("fsDlh", function(module, exports) {

$parcel$export(module.exports, "PACKET_TYPES", () => $b417fd17fc84e4e3$export$c169aefb7330cccb);
$parcel$export(module.exports, "PACKET_TYPES_REVERSE", () => $b417fd17fc84e4e3$export$47791e8004edd485);
$parcel$export(module.exports, "ERROR_PACKET", () => $b417fd17fc84e4e3$export$c718b5840781f8a7);
const $b417fd17fc84e4e3$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$b417fd17fc84e4e3$export$c169aefb7330cccb["open"] = "0";
$b417fd17fc84e4e3$export$c169aefb7330cccb["close"] = "1";
$b417fd17fc84e4e3$export$c169aefb7330cccb["ping"] = "2";
$b417fd17fc84e4e3$export$c169aefb7330cccb["pong"] = "3";
$b417fd17fc84e4e3$export$c169aefb7330cccb["message"] = "4";
$b417fd17fc84e4e3$export$c169aefb7330cccb["upgrade"] = "5";
$b417fd17fc84e4e3$export$c169aefb7330cccb["noop"] = "6";
const $b417fd17fc84e4e3$export$47791e8004edd485 = Object.create(null);
Object.keys($b417fd17fc84e4e3$export$c169aefb7330cccb).forEach((key)=>{
    $b417fd17fc84e4e3$export$47791e8004edd485[$b417fd17fc84e4e3$export$c169aefb7330cccb[key]] = key;
});
const $b417fd17fc84e4e3$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};

});


parcelRegister("ezyGD", function(module, exports) {

$parcel$export(module.exports, "decodePacket", () => $a9bf3da28855a34f$export$4647901878f33f31);

var $fsDlh = parcelRequire("fsDlh");

var $aVEkU = parcelRequire("aVEkU");
const $a9bf3da28855a34f$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $a9bf3da28855a34f$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $a9bf3da28855a34f$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $a9bf3da28855a34f$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $fsDlh.PACKET_TYPES_REVERSE)[type];
    if (!packetType) return 0, $fsDlh.ERROR_PACKET;
    return encodedPacket.length > 1 ? {
        type: (0, $fsDlh.PACKET_TYPES_REVERSE)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $fsDlh.PACKET_TYPES_REVERSE)[type]
    };
};
const $a9bf3da28855a34f$var$decodeBase64Packet = (data, binaryType)=>{
    if ($a9bf3da28855a34f$var$withNativeArrayBuffer) {
        const decoded = (0, $aVEkU.decode)(data);
        return $a9bf3da28855a34f$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $a9bf3da28855a34f$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};

});
parcelRegister("aVEkU", function(module, exports) {

$parcel$export(module.exports, "decode", () => $7f4e842ae29bcbc5$export$2f872c0f2117be69);
// imported from https://github.com/socketio/base64-arraybuffer
const $7f4e842ae29bcbc5$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
const $7f4e842ae29bcbc5$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(let i = 0; i < $7f4e842ae29bcbc5$var$chars.length; i++)$7f4e842ae29bcbc5$var$lookup[$7f4e842ae29bcbc5$var$chars.charCodeAt(i)] = i;
const $7f4e842ae29bcbc5$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i] >> 2];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const $7f4e842ae29bcbc5$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i)];
        encoded2 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};

});



parcelRegister("687to", function(module, exports) {

$parcel$export(module.exports, "Emitter", () => $8ff0082eecb39b62$export$4293555f241ae35a);
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $8ff0082eecb39b62$export$4293555f241ae35a(obj) {
    if (obj) return $8ff0082eecb39b62$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $8ff0082eecb39b62$var$mixin(obj) {
    for(var key in $8ff0082eecb39b62$export$4293555f241ae35a.prototype)obj[key] = $8ff0082eecb39b62$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.on = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.off = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.removeListener = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.removeAllListeners = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks["$" + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks["$" + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks["$" + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$8ff0082eecb39b62$export$4293555f241ae35a.prototype.emitReserved = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks["$" + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});

parcelRegister("5vwdc", function(module, exports) {

$parcel$export(module.exports, "pick", () => $4028d5a20a4526d1$export$357523c63a2253b9);
$parcel$export(module.exports, "installTimerFunctions", () => $4028d5a20a4526d1$export$2f67576668b97183);
$parcel$export(module.exports, "byteLength", () => $4028d5a20a4526d1$export$a48f0734ac7c2329);

var $3kfWP = parcelRequire("3kfWP");
function $4028d5a20a4526d1$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT = (0, $3kfWP.globalThisShim).setTimeout;
const $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT = (0, $3kfWP.globalThisShim).clearTimeout;
function $4028d5a20a4526d1$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT.bind((0, $3kfWP.globalThisShim));
        obj.clearTimeoutFn = $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT.bind((0, $3kfWP.globalThisShim));
    } else {
        obj.setTimeoutFn = (0, $3kfWP.globalThisShim).setTimeout.bind((0, $3kfWP.globalThisShim));
        obj.clearTimeoutFn = (0, $3kfWP.globalThisShim).clearTimeout.bind((0, $3kfWP.globalThisShim));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $4028d5a20a4526d1$var$BASE64_OVERHEAD = 1.33;
function $4028d5a20a4526d1$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $4028d5a20a4526d1$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $4028d5a20a4526d1$var$BASE64_OVERHEAD);
}
function $4028d5a20a4526d1$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}

});
parcelRegister("3kfWP", function(module, exports) {

$parcel$export(module.exports, "globalThisShim", () => $26bf9c4279db2ef0$export$394f9358f6231289);
const $26bf9c4279db2ef0$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();

});


parcelRegister("2buxl", function(module, exports) {

$parcel$export(module.exports, "encode", () => $19744bce3c183d10$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $19744bce3c183d10$export$2f872c0f2117be69);
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $19744bce3c183d10$export$c564cdbbe6da493(obj) {
    let str = "";
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += "&";
        str += encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]);
    }
    return str;
}
function $19744bce3c183d10$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split("&");
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split("=");
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}

});


parcelRegister("e3yjg", function(module, exports) {

$parcel$export(module.exports, "yeast", () => $a3bbf5b17719daf1$export$5bb64b92cb4135a);
// imported from https://github.com/unshiftio/yeast
"use strict";
const $a3bbf5b17719daf1$var$alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), $a3bbf5b17719daf1$var$length = 64, $a3bbf5b17719daf1$var$map = {};
let $a3bbf5b17719daf1$var$seed = 0, $a3bbf5b17719daf1$var$i = 0, $a3bbf5b17719daf1$var$prev;
function $a3bbf5b17719daf1$export$c564cdbbe6da493(num) {
    let encoded = "";
    do {
        encoded = $a3bbf5b17719daf1$var$alphabet[num % $a3bbf5b17719daf1$var$length] + encoded;
        num = Math.floor(num / $a3bbf5b17719daf1$var$length);
    }while (num > 0);
    return encoded;
}
function $a3bbf5b17719daf1$export$2f872c0f2117be69(str) {
    let decoded = 0;
    for($a3bbf5b17719daf1$var$i = 0; $a3bbf5b17719daf1$var$i < str.length; $a3bbf5b17719daf1$var$i++)decoded = decoded * $a3bbf5b17719daf1$var$length + $a3bbf5b17719daf1$var$map[str.charAt($a3bbf5b17719daf1$var$i)];
    return decoded;
}
function $a3bbf5b17719daf1$export$5bb64b92cb4135a() {
    const now = $a3bbf5b17719daf1$export$c564cdbbe6da493(+new Date());
    if (now !== $a3bbf5b17719daf1$var$prev) return $a3bbf5b17719daf1$var$seed = 0, $a3bbf5b17719daf1$var$prev = now;
    return now + "." + $a3bbf5b17719daf1$export$c564cdbbe6da493($a3bbf5b17719daf1$var$seed++);
}
//
// Map each character to its index.
//
for(; $a3bbf5b17719daf1$var$i < $a3bbf5b17719daf1$var$length; $a3bbf5b17719daf1$var$i++)$a3bbf5b17719daf1$var$map[$a3bbf5b17719daf1$var$alphabet[$a3bbf5b17719daf1$var$i]] = $a3bbf5b17719daf1$var$i;

});

parcelRegister("lB1J3", function(module, exports) {

$parcel$export(module.exports, "XHR", () => $fb8e645f3bad3d56$export$a2d42eb087c10497);
$parcel$export(module.exports, "createCookieJar", () => $fb8e645f3bad3d56$export$19413efcf2fac759);
// browser shim for xmlhttprequest module

var $kxvpX = parcelRequire("kxvpX");

var $3kfWP = parcelRequire("3kfWP");
function $fb8e645f3bad3d56$export$a2d42eb087c10497(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $kxvpX.hasCORS))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $3kfWP.globalThisShim)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}
function $fb8e645f3bad3d56$export$19413efcf2fac759() {}

});
parcelRegister("kxvpX", function(module, exports) {

$parcel$export(module.exports, "hasCORS", () => $ef3f42a25dd224af$export$5235bbd4a1ef06e);
// imported from https://github.com/component/has-cors
let $ef3f42a25dd224af$var$value = false;
try {
    $ef3f42a25dd224af$var$value = typeof XMLHttpRequest !== "undefined" && "withCredentials" in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $ef3f42a25dd224af$export$5235bbd4a1ef06e = $ef3f42a25dd224af$var$value;

});



parcelRegister("dhyBt", function(module, exports) {

$parcel$export(module.exports, "WS", () => $9ab7b46a38551fa4$export$911baa0677ac404c);

var $6opKi = parcelRequire("6opKi");

var $e3yjg = parcelRequire("e3yjg");

var $5vwdc = parcelRequire("5vwdc");

var $cFgwF = parcelRequire("cFgwF");
parcelRequire("CnWUo");
var $bRHuL = parcelRequire("bRHuL");

var $6ZWSX = parcelRequire("6ZWSX");
var $9ab7b46a38551fa4$require$Buffer = $6ZWSX.Buffer;
// detect ReactNative environment
const $9ab7b46a38551fa4$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $9ab7b46a38551fa4$export$911baa0677ac404c extends (0, $6opKi.Transport) {
    /**
     * WebSocket transport constructor.
     *
     * @param {Object} opts - connection options
     * @protected
     */ constructor(opts){
        super(opts);
        this.supportsBinary = !opts.forceBase64;
    }
    get name() {
        return "websocket";
    }
    doOpen() {
        if (!this.check()) // let probe timeout
        return;
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $9ab7b46a38551fa4$var$isReactNative ? {} : (0, $5vwdc.pick)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = (0, $cFgwF.usingBrowserWebSocket) && !$9ab7b46a38551fa4$var$isReactNative ? protocols ? new (0, $cFgwF.WebSocket)(uri, protocols) : new (0, $cFgwF.WebSocket)(uri) : new (0, $cFgwF.WebSocket)(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $bRHuL.encodePacket)(packet, this.supportsBinary, (data)=>{
                // always create a new object (GH-437)
                const opts = {};
                if (!(0, $cFgwF.usingBrowserWebSocket)) {
                    if (packet.options) opts.compress = packet.options.compress;
                    if (this.opts.perMessageDeflate) {
                        const len = // @ts-ignore
                        "string" === typeof data ? $9ab7b46a38551fa4$require$Buffer.byteLength(data) : data.length;
                        if (len < this.opts.perMessageDeflate.threshold) opts.compress = false;
                    }
                }
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    if (0, $cFgwF.usingBrowserWebSocket) // TypeError is thrown when passing the second argument on Safari
                    this.ws.send(data);
                    else this.ws.send(data, opts);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $cFgwF.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $e3yjg.yeast)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Feature detection for WebSocket.
     *
     * @return {Boolean} whether this transport is available.
     * @private
     */ check() {
        return !!(0, $cFgwF.WebSocket);
    }
}

});
parcelRegister("cFgwF", function(module, exports) {

$parcel$export(module.exports, "nextTick", () => $93862213c34af1ff$export$bdd553fddd433dcb);
$parcel$export(module.exports, "WebSocket", () => $93862213c34af1ff$export$3909fb301d3dc8c9);
$parcel$export(module.exports, "usingBrowserWebSocket", () => $93862213c34af1ff$export$3407ba5dfb7a683d);
$parcel$export(module.exports, "defaultBinaryType", () => $93862213c34af1ff$export$790dcbc41e2d75d5);

var $3kfWP = parcelRequire("3kfWP");
const $93862213c34af1ff$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $93862213c34af1ff$export$3909fb301d3dc8c9 = (0, $3kfWP.globalThisShim).WebSocket || (0, $3kfWP.globalThisShim).MozWebSocket;
const $93862213c34af1ff$export$3407ba5dfb7a683d = true;
const $93862213c34af1ff$export$790dcbc41e2d75d5 = "arraybuffer";

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("hJTtX", function(module, exports) {

$parcel$export(module.exports, "WT", () => $cea1ad415a07b478$export$961c930859384407);

var $6opKi = parcelRequire("6opKi");

var $cFgwF = parcelRequire("cFgwF");

var $CnWUo = parcelRequire("CnWUo");
class $cea1ad415a07b478$export$961c930859384407 extends (0, $6opKi.Transport) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        // @ts-ignore
        if (typeof WebTransport !== "function") return;
        // @ts-ignore
        this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        this.transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this.transport.ready.then(()=>{
            this.transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $CnWUo.createPacketDecoderStream)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $CnWUo.createPacketEncoderStream)();
                encoderStream.readable.pipeTo(stream.writable);
                this.writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this.writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this.writer.write(packet).then(()=>{
                if (lastPacket) (0, $cFgwF.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this.transport) === null || _a === void 0 || _a.close();
    }
}

});


parcelRegister("l7wSz", function(module, exports) {

$parcel$export(module.exports, "parse", () => $f603c1892ffe9e8b$export$98e6a39c04603d36);
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $f603c1892ffe9e8b$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $f603c1892ffe9e8b$var$parts = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
];
function $f603c1892ffe9e8b$export$98e6a39c04603d36(str) {
    if (str.length > 2000) throw "URI too long";
    const src = str, b = str.indexOf("["), e = str.indexOf("]");
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ";") + str.substring(e, str.length);
    let m = $f603c1892ffe9e8b$var$re.exec(str || ""), uri = {}, i = 14;
    while(i--)uri[$f603c1892ffe9e8b$var$parts[i]] = m[i] || "";
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ":");
        uri.authority = uri.authority.replace("[", "").replace("]", "").replace(/;/g, ":");
        uri.ipv6uri = true;
    }
    uri.pathNames = $f603c1892ffe9e8b$var$pathNames(uri, uri["path"]);
    uri.queryKey = $f603c1892ffe9e8b$var$queryKey(uri, uri["query"]);
    return uri;
}
function $f603c1892ffe9e8b$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == "/" || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == "/") names.splice(names.length - 1, 1);
    return names;
}
function $f603c1892ffe9e8b$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}

});




parcelRegister("fL4YY", function(module, exports) {

$parcel$export(module.exports, "Manager", () => $b78f1c3cb524f77d$export$d0d38e7dec7a1a61);
parcelRequire("1XKMK");
var $5vwdc = parcelRequire("5vwdc");
var $cFgwF = parcelRequire("cFgwF");
var $al9N3 = parcelRequire("al9N3");

var $lGX0c = parcelRequire("lGX0c");

var $2BjQv = parcelRequire("2BjQv");

var $vPX8d = parcelRequire("vPX8d");

var $5pEXn = parcelRequire("5pEXn");

var $687to = parcelRequire("687to");
class $b78f1c3cb524f77d$export$d0d38e7dec7a1a61 extends (0, $687to.Emitter) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $5pEXn.Backoff)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $2BjQv;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $al9N3.Socket)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $vPX8d.on)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $vPX8d.on)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $vPX8d.on)(socket, "ping", this.onping.bind(this)), (0, $vPX8d.on)(socket, "data", this.ondata.bind(this)), (0, $vPX8d.on)(socket, "error", this.onerror.bind(this)), (0, $vPX8d.on)(socket, "close", this.onclose.bind(this)), (0, $vPX8d.on)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $cFgwF.nextTick)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $lGX0c.Socket)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
        if (this.engine) this.engine.close();
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called upon engine close.
     *
     * @private
     */ onclose(reason, description) {
        this.cleanup();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}

});
parcelRegister("lGX0c", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $fcab49da21a6222a$export$4798917dbf149b79);

var $2BjQv = parcelRequire("2BjQv");

var $vPX8d = parcelRequire("vPX8d");

var $687to = parcelRequire("687to");
/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $fcab49da21a6222a$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $fcab49da21a6222a$export$4798917dbf149b79 extends (0, $687to.Emitter) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $vPX8d.on)(io, "open", this.onopen.bind(this)),
            (0, $vPX8d.on)(io, "packet", this.onpacket.bind(this)),
            (0, $vPX8d.on)(io, "error", this.onerror.bind(this)),
            (0, $vPX8d.on)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        if ($fcab49da21a6222a$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $2BjQv.PacketType).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
        const discardPacket = this.flags.volatile && (!isTransportWritable || !this.connected);
        if (discardPacket) ;
        else if (this.connected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        this.acks[id] = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, [
                null,
                ...args
            ]);
        };
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        // the timeout flag is optional
        const withErr = this.flags.timeout !== undefined || this._opts.ackTimeout !== undefined;
        return new Promise((resolve, reject)=>{
            args.push((arg1, arg2)=>{
                if (withErr) return arg1 ? reject(arg1) : resolve(arg2);
                else return resolve(arg1);
            });
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $2BjQv.PacketType).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $2BjQv.PacketType).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $2BjQv.PacketType).EVENT:
            case (0, $2BjQv.PacketType).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $2BjQv.PacketType).ACK:
            case (0, $2BjQv.PacketType).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $2BjQv.PacketType).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $2BjQv.PacketType).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $2BjQv.PacketType).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowlegement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if ("function" === typeof ack) {
            ack.apply(this, packet.data);
            delete this.acks[packet.id];
        }
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $2BjQv.PacketType).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}

});
parcelRegister("2BjQv", function(module, exports) {

$parcel$export(module.exports, "protocol", () => $1e4e6e6cc3958162$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "PacketType", () => $1e4e6e6cc3958162$export$84d4095e16c6fc19);
$parcel$export(module.exports, "Encoder", () => $1e4e6e6cc3958162$export$a50aceb0e02a00aa);
$parcel$export(module.exports, "Decoder", () => $1e4e6e6cc3958162$export$f9de6ca0bc043724);

var $687to = parcelRequire("687to");

var $8URBv = parcelRequire("8URBv");

var $eGKCF = parcelRequire("eGKCF");
/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $1e4e6e6cc3958162$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $1e4e6e6cc3958162$export$a51d6b395ff4c65a = 5;
var $1e4e6e6cc3958162$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($1e4e6e6cc3958162$export$84d4095e16c6fc19 || ($1e4e6e6cc3958162$export$84d4095e16c6fc19 = {}));
class $1e4e6e6cc3958162$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK) {
            if ((0, $eGKCF.hasBinary)(obj)) return this.encodeAsBinary({
                type: obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $8URBv.deconstructPacket)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $1e4e6e6cc3958162$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $1e4e6e6cc3958162$export$f9de6ca0bc043724 extends (0, $687to.Emitter) {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $1e4e6e6cc3958162$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $eGKCF.isBinary)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($1e4e6e6cc3958162$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($1e4e6e6cc3958162$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT:
                return $1e4e6e6cc3958162$var$isObject(payload);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $1e4e6e6cc3958162$var$isObject(payload);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $1e4e6e6cc3958162$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $1e4e6e6cc3958162$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $8URBv.reconstructPacket)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}

});
parcelRegister("8URBv", function(module, exports) {

$parcel$export(module.exports, "deconstructPacket", () => $67dd224d5a131c9e$export$ac2edb9eb7af56f6);
$parcel$export(module.exports, "reconstructPacket", () => $67dd224d5a131c9e$export$a00da3b1ec037a04);

var $eGKCF = parcelRequire("eGKCF");
function $67dd224d5a131c9e$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $67dd224d5a131c9e$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $67dd224d5a131c9e$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $eGKCF.isBinary)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $67dd224d5a131c9e$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $67dd224d5a131c9e$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $67dd224d5a131c9e$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $67dd224d5a131c9e$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $67dd224d5a131c9e$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $67dd224d5a131c9e$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $67dd224d5a131c9e$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}

});
parcelRegister("eGKCF", function(module, exports) {

$parcel$export(module.exports, "isBinary", () => $ab192732c3780e48$export$37488ff1135b1696);
$parcel$export(module.exports, "hasBinary", () => $ab192732c3780e48$export$5234c529abdb5610);
const $ab192732c3780e48$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $ab192732c3780e48$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $ab192732c3780e48$var$toString = Object.prototype.toString;
const $ab192732c3780e48$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $ab192732c3780e48$var$toString.call(Blob) === "[object BlobConstructor]";
const $ab192732c3780e48$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $ab192732c3780e48$var$toString.call(File) === "[object FileConstructor]";
function $ab192732c3780e48$export$37488ff1135b1696(obj) {
    return $ab192732c3780e48$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $ab192732c3780e48$var$isView(obj)) || $ab192732c3780e48$var$withNativeBlob && obj instanceof Blob || $ab192732c3780e48$var$withNativeFile && obj instanceof File;
}
function $ab192732c3780e48$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($ab192732c3780e48$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($ab192732c3780e48$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $ab192732c3780e48$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $ab192732c3780e48$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}

});



parcelRegister("vPX8d", function(module, exports) {

$parcel$export(module.exports, "on", () => $05fb321879039179$export$af631764ddc44097);
function $05fb321879039179$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}

});


parcelRegister("5pEXn", function(module, exports) {

$parcel$export(module.exports, "Backoff", () => $3f0f0eae169725b6$export$2d38012449449c89);
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $3f0f0eae169725b6$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};

});




parcelRegister("2Tywo", function(module, exports) {

$parcel$export(module.exports, "_config", () => _config);
$parcel$export(module.exports, "_isString", () => _isString);
$parcel$export(module.exports, "_isUndefined", () => _isUndefined);
$parcel$export(module.exports, "_numExp", () => _numExp);
$parcel$export(module.exports, "_numWithUnitExp", () => _numWithUnitExp);
$parcel$export(module.exports, "_relExp", () => _relExp);
$parcel$export(module.exports, "gsap", () => gsap);
$parcel$export(module.exports, "_missingPlugin", () => _missingPlugin);
$parcel$export(module.exports, "_plugins", () => _plugins);
$parcel$export(module.exports, "GSCache", () => GSCache);
$parcel$export(module.exports, "_getCache", () => _getCache);
$parcel$export(module.exports, "_getProperty", () => _getProperty);
$parcel$export(module.exports, "_forEachName", () => _forEachName);
$parcel$export(module.exports, "_round", () => _round);
$parcel$export(module.exports, "_parseRelative", () => _parseRelative);
$parcel$export(module.exports, "_ticker", () => _ticker);
$parcel$export(module.exports, "getUnit", () => getUnit);
$parcel$export(module.exports, "_replaceRandom", () => _replaceRandom);
$parcel$export(module.exports, "_getSetter", () => _getSetter);
$parcel$export(module.exports, "PropTween", () => PropTween);
$parcel$export(module.exports, "_colorExp", () => _colorExp);
$parcel$export(module.exports, "_colorStringFilter", () => _colorStringFilter);
$parcel$export(module.exports, "_renderComplexString", () => _renderComplexString);
$parcel$export(module.exports, "_checkPlugin", () => _checkPlugin);
$parcel$export(module.exports, "_sortPropTweensByPriority", () => _sortPropTweensByPriority);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === _roundPrecise(tTime / cycleDuration)) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && this._time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? _interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    };
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _merge2;
        var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.12.5";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

parcelRegister("iJUCQ", function(module, exports) {
module.exports = new URL("kick_1.3edd0e26.wav", import.meta.url).toString();

});

parcelRegister("lQ3FR", function(module, exports) {
module.exports = new URL("kick_2.e8189f7b.wav", import.meta.url).toString();

});

parcelRegister("bl0Lo", function(module, exports) {
module.exports = new URL("snare.be3ef740.wav", import.meta.url).toString();

});

parcelRegister("ldgBe", function(module, exports) {
module.exports = new URL("rim-shot.18d5da21.wav", import.meta.url).toString();

});

parcelRegister("gUISN", function(module, exports) {
module.exports = new URL("hat-closed.a7ea2119.wav", import.meta.url).toString();

});

parcelRegister("ICc8l", function(module, exports) {
module.exports = new URL("hat-open.4c183f4b.wav", import.meta.url).toString();

});

parcelRegister("724aH", function(module, exports) {
module.exports = new URL("tom-high_v1.8f868918.wav", import.meta.url).toString();

});

parcelRegister("dihGQ", function(module, exports) {
module.exports = new URL("tom-low.a72faf66.wav", import.meta.url).toString();

});

parcelRegister("i9qio", function(module, exports) {
module.exports = new URL("cymbal.ebe3e78f.wav", import.meta.url).toString();

});

parcelRegister("eyEFG", function(module, exports) {
module.exports = new URL("maracas.8f881e47.wav", import.meta.url).toString();

});

parcelRegister("5eTGP", function(module, exports) {
module.exports = new URL("zap.71b2f811.wav", import.meta.url).toString();

});

parcelRegister("hhjNk", function(module, exports) {
module.exports = new URL("zap_v1.e0cb4566.wav", import.meta.url).toString();

});

var $5b38727783012434$exports = {};
/*! p5.js v1.9.0 November 28, 2023 */ !function(e1) {
    $5b38727783012434$exports = e1();
}(function() {
    var s, t, r;
    return (function o(n, s, i) {
        function a(t, e1) {
            if (!s[t]) {
                if (!n[t]) {
                    var r = undefined;
                    if (!e1 && r) return r(t, !0);
                    if (l) return l(t, !0);
                    throw (e1 = new Error("Cannot find module '" + t + "'")).code = "MODULE_NOT_FOUND", e1;
                }
                r = s[t] = {
                    exports: {}
                }, n[t][0].call(r.exports, function(e1) {
                    return a(n[t][1][e1] || e1);
                }, r, r.exports, o, n, s, i);
            }
            return s[t].exports;
        }
        for(var l = undefined, e1 = 0; e1 < i.length; e1++)a(i[e1]);
        return a;
    })({
        1: [
            function(e1, t, r) {
                "use strict";
                r.byteLength = function(e1) {
                    var e1 = c(e1), t = e1[0], e1 = e1[1];
                    return 3 * (t + e1) / 4 - e1;
                }, r.toByteArray = function(e1) {
                    var t, r, o = c(e1), n = o[0], o = o[1], s = new u(function(e1, t) {
                        return 3 * (e1 + t) / 4 - t;
                    }(n, o)), i = 0, a = 0 < o ? n - 4 : n;
                    for(r = 0; r < a; r += 4)t = l[e1.charCodeAt(r)] << 18 | l[e1.charCodeAt(r + 1)] << 12 | l[e1.charCodeAt(r + 2)] << 6 | l[e1.charCodeAt(r + 3)], s[i++] = t >> 16 & 255, s[i++] = t >> 8 & 255, s[i++] = 255 & t;
                    2 === o && (t = l[e1.charCodeAt(r)] << 2 | l[e1.charCodeAt(r + 1)] >> 4, s[i++] = 255 & t);
                    1 === o && (t = l[e1.charCodeAt(r)] << 10 | l[e1.charCodeAt(r + 1)] << 4 | l[e1.charCodeAt(r + 2)] >> 2, s[i++] = t >> 8 & 255, s[i++] = 255 & t);
                    return s;
                }, r.fromByteArray = function(e1) {
                    for(var t, r = e1.length, o = r % 3, n = [], s = 0, i = r - o; s < i; s += 16383)n.push(function(e1, t, r) {
                        for(var o, n = [], s = t; s < r; s += 3)o = (e1[s] << 16 & 16711680) + (e1[s + 1] << 8 & 65280) + (255 & e1[s + 2]), n.push(function(e1) {
                            return a[e1 >> 18 & 63] + a[e1 >> 12 & 63] + a[e1 >> 6 & 63] + a[63 & e1];
                        }(o));
                        return n.join("");
                    }(e1, s, i < s + 16383 ? i : s + 16383));
                    1 == o ? (t = e1[r - 1], n.push(a[t >> 2] + a[t << 4 & 63] + "==")) : 2 == o && (t = (e1[r - 2] << 8) + e1[r - 1], n.push(a[t >> 10] + a[t >> 4 & 63] + a[t << 2 & 63] + "="));
                    return n.join("");
                };
                for(var a = [], l = [], u = "undefined" != typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", n = 0, s = o.length; n < s; ++n)a[n] = o[n], l[o.charCodeAt(n)] = n;
                function c(e1) {
                    var t = e1.length;
                    if (0 < t % 4) throw new Error("Invalid string. Length must be a multiple of 4");
                    e1 = e1.indexOf("="), t = (e1 = -1 === e1 ? t : e1) === t ? 0 : 4 - e1 % 4;
                    return [
                        e1,
                        t
                    ];
                }
                l["-".charCodeAt(0)] = 62, l["_".charCodeAt(0)] = 63;
            },
            {}
        ],
        2: [
            function(e1, t, r) {},
            {}
        ],
        3: [
            function(e1, t, r) {},
            {}
        ],
        4: [
            function(A, e1, L) {
                (function(d) {
                    "use strict";
                    var S = A("base64-js"), s = A("ieee754"), e1 = "function" == typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("nodejs.util.inspect.custom") : null, t = (L.Buffer = d, L.SlowBuffer = function(e1) {
                        +e1 != e1 && (e1 = 0);
                        return d.alloc(+e1);
                    }, L.INSPECT_MAX_BYTES = 50, 2147483647);
                    function l(e1) {
                        if (t < e1) throw new RangeError('The value "' + e1 + '" is invalid for option "size"');
                        e1 = new Uint8Array(e1);
                        return Object.setPrototypeOf(e1, d.prototype), e1;
                    }
                    function d(e1, t, r) {
                        if ("number" != typeof e1) return o(e1, t, r);
                        if ("string" == typeof t) throw new TypeError('The "string" argument must be of type string. Received type number');
                        return i(e1);
                    }
                    function o(e1, t, r) {
                        if ("string" == typeof e1) {
                            var o = e1, n = t;
                            if (d.isEncoding(n = "string" == typeof n && "" !== n ? n : "utf8")) return s = 0 | h(o, n), i = l(s), i = (o = i.write(o, n)) !== s ? i.slice(0, o) : i;
                            throw new TypeError("Unknown encoding: " + n);
                        }
                        if (ArrayBuffer.isView(e1)) return u(e1);
                        if (null != e1) {
                            if (C(e1, ArrayBuffer) || e1 && C(e1.buffer, ArrayBuffer)) {
                                var s = e1, o = t, i = r;
                                if (o < 0 || s.byteLength < o) throw new RangeError('"offset" is outside of buffer bounds');
                                if (s.byteLength < o + (i || 0)) throw new RangeError('"length" is outside of buffer bounds');
                                return s = void 0 === o && void 0 === i ? new Uint8Array(s) : void 0 === i ? new Uint8Array(s, o) : new Uint8Array(s, o, i), Object.setPrototypeOf(s, d.prototype), s;
                            }
                            if ("number" == typeof e1) throw new TypeError('The "value" argument must not be of type number. Received type number');
                            n = e1.valueOf && e1.valueOf();
                            if (null != n && n !== e1) return d.from(n, t, r);
                            var a = function(e1) {
                                var t, r;
                                if (d.isBuffer(e1)) return t = 0 | c(e1.length), 0 !== (r = l(t)).length && e1.copy(r, 0, 0, t), r;
                                if (void 0 !== e1.length) return "number" != typeof e1.length || O(e1.length) ? l(0) : u(e1);
                                if ("Buffer" === e1.type && Array.isArray(e1.data)) return u(e1.data);
                            }(e1);
                            if (a) return a;
                            if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof e1[Symbol.toPrimitive]) return d.from(e1[Symbol.toPrimitive]("string"), t, r);
                        }
                        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e1);
                    }
                    function n(e1) {
                        if ("number" != typeof e1) throw new TypeError('"size" argument must be of type number');
                        if (e1 < 0) throw new RangeError('The value "' + e1 + '" is invalid for option "size"');
                    }
                    function i(e1) {
                        return n(e1), l(e1 < 0 ? 0 : 0 | c(e1));
                    }
                    function u(e1) {
                        for(var t = e1.length < 0 ? 0 : 0 | c(e1.length), r = l(t), o = 0; o < t; o += 1)r[o] = 255 & e1[o];
                        return r;
                    }
                    function c(e1) {
                        if (t <= e1) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + t.toString(16) + " bytes");
                        return 0 | e1;
                    }
                    function h(e1, t) {
                        if (d.isBuffer(e1)) return e1.length;
                        if (ArrayBuffer.isView(e1) || C(e1, ArrayBuffer)) return e1.byteLength;
                        if ("string" != typeof e1) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e1);
                        var r = e1.length, o = 2 < arguments.length && !0 === arguments[2];
                        if (!o && 0 === r) return 0;
                        for(var n = !1;;)switch(t){
                            case "ascii":
                            case "latin1":
                            case "binary":
                                return r;
                            case "utf8":
                            case "utf-8":
                                return M(e1).length;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                return 2 * r;
                            case "hex":
                                return r >>> 1;
                            case "base64":
                                return E(e1).length;
                            default:
                                if (n) return o ? -1 : M(e1).length;
                                t = ("" + t).toLowerCase(), n = !0;
                        }
                    }
                    function r(e1, t, r) {
                        var o, n = !1;
                        if ((t = void 0 === t || t < 0 ? 0 : t) > this.length) return "";
                        if ((r = void 0 === r || r > this.length ? this.length : r) <= 0) return "";
                        if ((r >>>= 0) <= (t >>>= 0)) return "";
                        for(e1 = e1 || "utf8";;)switch(e1){
                            case "hex":
                                var s = this, i = t, a = r, l = s.length;
                                (!a || a < 0 || l < a) && (a = l);
                                for(var u = "", c = i = !i || i < 0 ? 0 : i; c < a; ++c)u += P[s[c]];
                                return u;
                            case "utf8":
                            case "utf-8":
                                return T(this, t, r);
                            case "ascii":
                                var d = this, l = t, h = r, f = "";
                                h = Math.min(d.length, h);
                                for(var p = l; p < h; ++p)f += String.fromCharCode(127 & d[p]);
                                return f;
                            case "latin1":
                            case "binary":
                                var m = this, i = t, y = r, g = "";
                                y = Math.min(m.length, y);
                                for(var v = i; v < y; ++v)g += String.fromCharCode(m[v]);
                                return g;
                            case "base64":
                                return b = this, o = r, 0 === (j = t) && o === b.length ? S.fromByteArray(b) : S.fromByteArray(b.slice(j, o));
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                for(var b = t, j = r, _ = this.slice(b, j), x = "", w = 0; w < _.length; w += 2)x += String.fromCharCode(_[w] + 256 * _[w + 1]);
                                return x;
                            default:
                                if (n) throw new TypeError("Unknown encoding: " + e1);
                                e1 = (e1 + "").toLowerCase(), n = !0;
                        }
                    }
                    function a(e1, t, r) {
                        var o = e1[t];
                        e1[t] = e1[r], e1[r] = o;
                    }
                    function f(e1, t, r, o, n) {
                        if (0 === e1.length) return -1;
                        if ("string" == typeof r ? (o = r, r = 0) : 2147483647 < r ? r = 2147483647 : r < -2147483648 && (r = -2147483648), (r = (r = O(r = +r) ? n ? 0 : e1.length - 1 : r) < 0 ? e1.length + r : r) >= e1.length) {
                            if (n) return -1;
                            r = e1.length - 1;
                        } else if (r < 0) {
                            if (!n) return -1;
                            r = 0;
                        }
                        if ("string" == typeof t && (t = d.from(t, o)), d.isBuffer(t)) return 0 === t.length ? -1 : p(e1, t, r, o, n);
                        if ("number" == typeof t) return t &= 255, "function" == typeof Uint8Array.prototype.indexOf ? (n ? Uint8Array.prototype.indexOf : Uint8Array.prototype.lastIndexOf).call(e1, t, r) : p(e1, [
                            t
                        ], r, o, n);
                        throw new TypeError("val must be string, number or Buffer");
                    }
                    function p(e1, t, r, o, n) {
                        var s = 1, i = e1.length, a = t.length;
                        if (void 0 !== o && ("ucs2" === (o = String(o).toLowerCase()) || "ucs-2" === o || "utf16le" === o || "utf-16le" === o)) {
                            if (e1.length < 2 || t.length < 2) return -1;
                            i /= s = 2, a /= 2, r /= 2;
                        }
                        function l(e1, t) {
                            return 1 === s ? e1[t] : e1.readUInt16BE(t * s);
                        }
                        if (n) for(var u = -1, c = r; c < i; c++)if (l(e1, c) === l(t, -1 === u ? 0 : c - u)) {
                            if (c - (u = -1 === u ? c : u) + 1 === a) return u * s;
                        } else -1 !== u && (c -= c - u), u = -1;
                        else for(c = r = i < r + a ? i - a : r; 0 <= c; c--){
                            for(var d = !0, h = 0; h < a; h++)if (l(e1, c + h) !== l(t, h)) {
                                d = !1;
                                break;
                            }
                            if (d) return c;
                        }
                        return -1;
                    }
                    function y(e1, t, r, o) {
                        return k(function(e1) {
                            for(var t = [], r = 0; r < e1.length; ++r)t.push(255 & e1.charCodeAt(r));
                            return t;
                        }(t), e1, r, o);
                    }
                    function g(e1, t, r, o) {
                        return k(function(e1, t) {
                            for(var r, o, n = [], s = 0; s < e1.length && !((t -= 2) < 0); ++s)o = e1.charCodeAt(s), r = o >> 8, o = o % 256, n.push(o), n.push(r);
                            return n;
                        }(t, e1.length - r), e1, r, o);
                    }
                    function T(e1, t, r) {
                        r = Math.min(e1.length, r);
                        for(var o = [], n = t; n < r;){
                            var s, i, a, l, u = e1[n], c = null, d = 239 < u ? 4 : 223 < u ? 3 : 191 < u ? 2 : 1;
                            if (n + d <= r) switch(d){
                                case 1:
                                    u < 128 && (c = u);
                                    break;
                                case 2:
                                    128 == (192 & (s = e1[n + 1])) && 127 < (l = (31 & u) << 6 | 63 & s) && (c = l);
                                    break;
                                case 3:
                                    s = e1[n + 1], i = e1[n + 2], 128 == (192 & s) && 128 == (192 & i) && 2047 < (l = (15 & u) << 12 | (63 & s) << 6 | 63 & i) && (l < 55296 || 57343 < l) && (c = l);
                                    break;
                                case 4:
                                    s = e1[n + 1], i = e1[n + 2], a = e1[n + 3], 128 == (192 & s) && 128 == (192 & i) && 128 == (192 & a) && 65535 < (l = (15 & u) << 18 | (63 & s) << 12 | (63 & i) << 6 | 63 & a) && l < 1114112 && (c = l);
                            }
                            null === c ? (c = 65533, d = 1) : 65535 < c && (c -= 65536, o.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), o.push(c), n += d;
                        }
                        var h = o, f = h.length;
                        if (f <= v) return String.fromCharCode.apply(String, h);
                        for(var p = "", m = 0; m < f;)p += String.fromCharCode.apply(String, h.slice(m, m += v));
                        return p;
                    }
                    L.kMaxLength = t, (d.TYPED_ARRAY_SUPPORT = function() {
                        try {
                            var e1 = new Uint8Array(1), t = {
                                foo: function() {
                                    return 42;
                                }
                            };
                            return Object.setPrototypeOf(t, Uint8Array.prototype), Object.setPrototypeOf(e1, t), 42 === e1.foo();
                        } catch (e1) {
                            return !1;
                        }
                    }()) || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(d.prototype, "parent", {
                        enumerable: !0,
                        get: function() {
                            if (d.isBuffer(this)) return this.buffer;
                        }
                    }), Object.defineProperty(d.prototype, "offset", {
                        enumerable: !0,
                        get: function() {
                            if (d.isBuffer(this)) return this.byteOffset;
                        }
                    }), "undefined" != typeof Symbol && null != Symbol.species && d[Symbol.species] === d && Object.defineProperty(d, Symbol.species, {
                        value: null,
                        configurable: !0,
                        enumerable: !1,
                        writable: !1
                    }), d.poolSize = 8192, d.from = o, Object.setPrototypeOf(d.prototype, Uint8Array.prototype), Object.setPrototypeOf(d, Uint8Array), d.alloc = function(e1, t, r) {
                        return t, r, n(e1), !(e1 <= 0) && void 0 !== t ? "string" == typeof r ? l(e1).fill(t, r) : l(e1).fill(t) : l(e1);
                    }, d.allocUnsafe = i, d.allocUnsafeSlow = i, d.isBuffer = function(e1) {
                        return null != e1 && !0 === e1._isBuffer && e1 !== d.prototype;
                    }, d.compare = function(e1, t) {
                        if (C(e1, Uint8Array) && (e1 = d.from(e1, e1.offset, e1.byteLength)), C(t, Uint8Array) && (t = d.from(t, t.offset, t.byteLength)), !d.isBuffer(e1) || !d.isBuffer(t)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                        if (e1 === t) return 0;
                        for(var r = e1.length, o = t.length, n = 0, s = Math.min(r, o); n < s; ++n)if (e1[n] !== t[n]) {
                            r = e1[n], o = t[n];
                            break;
                        }
                        return r < o ? -1 : o < r ? 1 : 0;
                    }, d.isEncoding = function(e1) {
                        switch(String(e1).toLowerCase()){
                            case "hex":
                            case "utf8":
                            case "utf-8":
                            case "ascii":
                            case "latin1":
                            case "binary":
                            case "base64":
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                return !0;
                            default:
                                return !1;
                        }
                    }, d.concat = function(e1, t) {
                        if (!Array.isArray(e1)) throw new TypeError('"list" argument must be an Array of Buffers');
                        if (0 === e1.length) return d.alloc(0);
                        if (void 0 === t) for(n = t = 0; n < e1.length; ++n)t += e1[n].length;
                        for(var r = d.allocUnsafe(t), o = 0, n = 0; n < e1.length; ++n){
                            var s = e1[n];
                            if (C(s, Uint8Array) && (s = d.from(s)), !d.isBuffer(s)) throw new TypeError('"list" argument must be an Array of Buffers');
                            s.copy(r, o), o += s.length;
                        }
                        return r;
                    }, d.byteLength = h, d.prototype._isBuffer = !0, d.prototype.swap16 = function() {
                        var e1 = this.length;
                        if (e1 % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                        for(var t = 0; t < e1; t += 2)a(this, t, t + 1);
                        return this;
                    }, d.prototype.swap32 = function() {
                        var e1 = this.length;
                        if (e1 % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                        for(var t = 0; t < e1; t += 4)a(this, t, t + 3), a(this, t + 1, t + 2);
                        return this;
                    }, d.prototype.swap64 = function() {
                        var e1 = this.length;
                        if (e1 % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                        for(var t = 0; t < e1; t += 8)a(this, t, t + 7), a(this, t + 1, t + 6), a(this, t + 2, t + 5), a(this, t + 3, t + 4);
                        return this;
                    }, d.prototype.toLocaleString = d.prototype.toString = function() {
                        var e1 = this.length;
                        return 0 === e1 ? "" : 0 === arguments.length ? T(this, 0, e1) : r.apply(this, arguments);
                    }, d.prototype.equals = function(e1) {
                        if (d.isBuffer(e1)) return this === e1 || 0 === d.compare(this, e1);
                        throw new TypeError("Argument must be a Buffer");
                    }, d.prototype.inspect = function() {
                        var e1 = "", t = L.INSPECT_MAX_BYTES, e1 = this.toString("hex", 0, t).replace(/(.{2})/g, "$1 ").trim();
                        return this.length > t && (e1 += " ... "), "<Buffer " + e1 + ">";
                    }, e1 && (d.prototype[e1] = d.prototype.inspect), d.prototype.compare = function(e1, t, r, o, n) {
                        if (C(e1, Uint8Array) && (e1 = d.from(e1, e1.offset, e1.byteLength)), !d.isBuffer(e1)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e1);
                        if (void 0 === r && (r = e1 ? e1.length : 0), void 0 === o && (o = 0), void 0 === n && (n = this.length), (t = void 0 === t ? 0 : t) < 0 || r > e1.length || o < 0 || n > this.length) throw new RangeError("out of range index");
                        if (n <= o && r <= t) return 0;
                        if (n <= o) return -1;
                        if (r <= t) return 1;
                        if (this === e1) return 0;
                        for(var s = (n >>>= 0) - (o >>>= 0), i = (r >>>= 0) - (t >>>= 0), a = Math.min(s, i), l = this.slice(o, n), u = e1.slice(t, r), c = 0; c < a; ++c)if (l[c] !== u[c]) {
                            s = l[c], i = u[c];
                            break;
                        }
                        return s < i ? -1 : i < s ? 1 : 0;
                    }, d.prototype.includes = function(e1, t, r) {
                        return -1 !== this.indexOf(e1, t, r);
                    }, d.prototype.indexOf = function(e1, t, r) {
                        return f(this, e1, t, r, !0);
                    }, d.prototype.lastIndexOf = function(e1, t, r) {
                        return f(this, e1, t, r, !1);
                    }, d.prototype.write = function(e1, t, r, o) {
                        if (void 0 === t) o = "utf8", r = this.length, t = 0;
                        else if (void 0 === r && "string" == typeof t) o = t, r = this.length, t = 0;
                        else {
                            if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                            t >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === o && (o = "utf8")) : (o = r, r = void 0);
                        }
                        var n = this.length - t;
                        if ((void 0 === r || n < r) && (r = n), 0 < e1.length && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                        o = o || "utf8";
                        for(var s, i, a, l = !1;;)switch(o){
                            case "hex":
                                var u = this, c = e1, d = t, h = r, f = (d = Number(d) || 0, u.length - d);
                                (!h || f < (h = Number(h))) && (h = f), (f = c.length) / 2 < h && (h = f / 2);
                                for(var p = 0; p < h; ++p){
                                    var m = parseInt(c.substr(2 * p, 2), 16);
                                    if (O(m)) return p;
                                    u[d + p] = m;
                                }
                                return p;
                            case "utf8":
                            case "utf-8":
                                return f = t, a = r, k(M(e1, (i = this).length - f), i, f, a);
                            case "ascii":
                                return y(this, e1, t, r);
                            case "latin1":
                            case "binary":
                                return y(this, e1, t, r);
                            case "base64":
                                return i = this, a = t, s = r, k(E(e1), i, a, s);
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                return g(this, e1, t, r);
                            default:
                                if (l) throw new TypeError("Unknown encoding: " + o);
                                o = ("" + o).toLowerCase(), l = !0;
                        }
                    }, d.prototype.toJSON = function() {
                        return {
                            type: "Buffer",
                            data: Array.prototype.slice.call(this._arr || this, 0)
                        };
                    };
                    var v = 4096;
                    function m(e1, t, r) {
                        if (e1 % 1 != 0 || e1 < 0) throw new RangeError("offset is not uint");
                        if (r < e1 + t) throw new RangeError("Trying to access beyond buffer length");
                    }
                    function b(e1, t, r, o, n, s) {
                        if (!d.isBuffer(e1)) throw new TypeError('"buffer" argument must be a Buffer instance');
                        if (n < t || t < s) throw new RangeError('"value" argument is out of bounds');
                        if (r + o > e1.length) throw new RangeError("Index out of range");
                    }
                    function j(e1, t, r, o) {
                        if (r + o > e1.length) throw new RangeError("Index out of range");
                        if (r < 0) throw new RangeError("Index out of range");
                    }
                    function _(e1, t, r, o, n) {
                        return t = +t, r >>>= 0, n || j(e1, 0, r, 4), s.write(e1, t, r, o, 23, 4), r + 4;
                    }
                    function x(e1, t, r, o, n) {
                        return t = +t, r >>>= 0, n || j(e1, 0, r, 8), s.write(e1, t, r, o, 52, 8), r + 8;
                    }
                    d.prototype.slice = function(e1, t) {
                        var r = this.length, r = ((e1 = ~~e1) < 0 ? (e1 += r) < 0 && (e1 = 0) : r < e1 && (e1 = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : r < t && (t = r), t < e1 && (t = e1), this.subarray(e1, t));
                        return Object.setPrototypeOf(r, d.prototype), r;
                    }, d.prototype.readUIntLE = function(e1, t, r) {
                        e1 >>>= 0, t >>>= 0, r || m(e1, t, this.length);
                        for(var o = this[e1], n = 1, s = 0; ++s < t && (n *= 256);)o += this[e1 + s] * n;
                        return o;
                    }, d.prototype.readUIntBE = function(e1, t, r) {
                        e1 >>>= 0, t >>>= 0, r || m(e1, t, this.length);
                        for(var o = this[e1 + --t], n = 1; 0 < t && (n *= 256);)o += this[e1 + --t] * n;
                        return o;
                    }, d.prototype.readUInt8 = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 1, this.length), this[e1];
                    }, d.prototype.readUInt16LE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 2, this.length), this[e1] | this[e1 + 1] << 8;
                    }, d.prototype.readUInt16BE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 2, this.length), this[e1] << 8 | this[e1 + 1];
                    }, d.prototype.readUInt32LE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 4, this.length), (this[e1] | this[e1 + 1] << 8 | this[e1 + 2] << 16) + 16777216 * this[e1 + 3];
                    }, d.prototype.readUInt32BE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 4, this.length), 16777216 * this[e1] + (this[e1 + 1] << 16 | this[e1 + 2] << 8 | this[e1 + 3]);
                    }, d.prototype.readIntLE = function(e1, t, r) {
                        e1 >>>= 0, t >>>= 0, r || m(e1, t, this.length);
                        for(var o = this[e1], n = 1, s = 0; ++s < t && (n *= 256);)o += this[e1 + s] * n;
                        return (n *= 128) <= o && (o -= Math.pow(2, 8 * t)), o;
                    }, d.prototype.readIntBE = function(e1, t, r) {
                        e1 >>>= 0, t >>>= 0, r || m(e1, t, this.length);
                        for(var o = t, n = 1, s = this[e1 + --o]; 0 < o && (n *= 256);)s += this[e1 + --o] * n;
                        return (n *= 128) <= s && (s -= Math.pow(2, 8 * t)), s;
                    }, d.prototype.readInt8 = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 1, this.length), 128 & this[e1] ? -1 * (255 - this[e1] + 1) : this[e1];
                    }, d.prototype.readInt16LE = function(e1, t) {
                        e1 >>>= 0, t || m(e1, 2, this.length);
                        t = this[e1] | this[e1 + 1] << 8;
                        return 32768 & t ? 4294901760 | t : t;
                    }, d.prototype.readInt16BE = function(e1, t) {
                        e1 >>>= 0, t || m(e1, 2, this.length);
                        t = this[e1 + 1] | this[e1] << 8;
                        return 32768 & t ? 4294901760 | t : t;
                    }, d.prototype.readInt32LE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 4, this.length), this[e1] | this[e1 + 1] << 8 | this[e1 + 2] << 16 | this[e1 + 3] << 24;
                    }, d.prototype.readInt32BE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 4, this.length), this[e1] << 24 | this[e1 + 1] << 16 | this[e1 + 2] << 8 | this[e1 + 3];
                    }, d.prototype.readFloatLE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 4, this.length), s.read(this, e1, !0, 23, 4);
                    }, d.prototype.readFloatBE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 4, this.length), s.read(this, e1, !1, 23, 4);
                    }, d.prototype.readDoubleLE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 8, this.length), s.read(this, e1, !0, 52, 8);
                    }, d.prototype.readDoubleBE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 8, this.length), s.read(this, e1, !1, 52, 8);
                    }, d.prototype.writeUIntLE = function(e1, t, r, o) {
                        e1 = +e1, t >>>= 0, r >>>= 0, o || b(this, e1, t, r, Math.pow(2, 8 * r) - 1, 0);
                        var n = 1, s = 0;
                        for(this[t] = 255 & e1; ++s < r && (n *= 256);)this[t + s] = e1 / n & 255;
                        return t + r;
                    }, d.prototype.writeUIntBE = function(e1, t, r, o) {
                        e1 = +e1, t >>>= 0, r >>>= 0, o || b(this, e1, t, r, Math.pow(2, 8 * r) - 1, 0);
                        var n = r - 1, s = 1;
                        for(this[t + n] = 255 & e1; 0 <= --n && (s *= 256);)this[t + n] = e1 / s & 255;
                        return t + r;
                    }, d.prototype.writeUInt8 = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 1, 255, 0), this[t] = 255 & e1, t + 1;
                    }, d.prototype.writeUInt16LE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 2, 65535, 0), this[t] = 255 & e1, this[t + 1] = e1 >>> 8, t + 2;
                    }, d.prototype.writeUInt16BE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 2, 65535, 0), this[t] = e1 >>> 8, this[t + 1] = 255 & e1, t + 2;
                    }, d.prototype.writeUInt32LE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 4, 4294967295, 0), this[t + 3] = e1 >>> 24, this[t + 2] = e1 >>> 16, this[t + 1] = e1 >>> 8, this[t] = 255 & e1, t + 4;
                    }, d.prototype.writeUInt32BE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 4, 4294967295, 0), this[t] = e1 >>> 24, this[t + 1] = e1 >>> 16, this[t + 2] = e1 >>> 8, this[t + 3] = 255 & e1, t + 4;
                    }, d.prototype.writeIntLE = function(e1, t, r, o) {
                        e1 = +e1, t >>>= 0, o || b(this, e1, t, r, (o = Math.pow(2, 8 * r - 1)) - 1, -o);
                        var n = 0, s = 1, i = 0;
                        for(this[t] = 255 & e1; ++n < r && (s *= 256);)e1 < 0 && 0 === i && 0 !== this[t + n - 1] && (i = 1), this[t + n] = (e1 / s >> 0) - i & 255;
                        return t + r;
                    }, d.prototype.writeIntBE = function(e1, t, r, o) {
                        e1 = +e1, t >>>= 0, o || b(this, e1, t, r, (o = Math.pow(2, 8 * r - 1)) - 1, -o);
                        var n = r - 1, s = 1, i = 0;
                        for(this[t + n] = 255 & e1; 0 <= --n && (s *= 256);)e1 < 0 && 0 === i && 0 !== this[t + n + 1] && (i = 1), this[t + n] = (e1 / s >> 0) - i & 255;
                        return t + r;
                    }, d.prototype.writeInt8 = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 1, 127, -128), this[t] = 255 & (e1 = e1 < 0 ? 255 + e1 + 1 : e1), t + 1;
                    }, d.prototype.writeInt16LE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 2, 32767, -32768), this[t] = 255 & e1, this[t + 1] = e1 >>> 8, t + 2;
                    }, d.prototype.writeInt16BE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 2, 32767, -32768), this[t] = e1 >>> 8, this[t + 1] = 255 & e1, t + 2;
                    }, d.prototype.writeInt32LE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 4, 2147483647, -2147483648), this[t] = 255 & e1, this[t + 1] = e1 >>> 8, this[t + 2] = e1 >>> 16, this[t + 3] = e1 >>> 24, t + 4;
                    }, d.prototype.writeInt32BE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 4, 2147483647, -2147483648), this[t] = (e1 = e1 < 0 ? 4294967295 + e1 + 1 : e1) >>> 24, this[t + 1] = e1 >>> 16, this[t + 2] = e1 >>> 8, this[t + 3] = 255 & e1, t + 4;
                    }, d.prototype.writeFloatLE = function(e1, t, r) {
                        return _(this, e1, t, !0, r);
                    }, d.prototype.writeFloatBE = function(e1, t, r) {
                        return _(this, e1, t, !1, r);
                    }, d.prototype.writeDoubleLE = function(e1, t, r) {
                        return x(this, e1, t, !0, r);
                    }, d.prototype.writeDoubleBE = function(e1, t, r) {
                        return x(this, e1, t, !1, r);
                    }, d.prototype.copy = function(e1, t, r, o) {
                        if (!d.isBuffer(e1)) throw new TypeError("argument should be a Buffer");
                        if (r = r || 0, o || 0 === o || (o = this.length), t >= e1.length && (t = e1.length), (o = 0 < o && o < r ? r : o) === r) return 0;
                        if (0 === e1.length || 0 === this.length) return 0;
                        if ((t = t || 0) < 0) throw new RangeError("targetStart out of bounds");
                        if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
                        if (o < 0) throw new RangeError("sourceEnd out of bounds");
                        o > this.length && (o = this.length);
                        var n = (o = e1.length - t < o - r ? e1.length - t + r : o) - r;
                        if (this === e1 && "function" == typeof Uint8Array.prototype.copyWithin) this.copyWithin(t, r, o);
                        else if (this === e1 && r < t && t < o) for(var s = n - 1; 0 <= s; --s)e1[s + t] = this[s + r];
                        else Uint8Array.prototype.set.call(e1, this.subarray(r, o), t);
                        return n;
                    }, d.prototype.fill = function(e1, t, r, o) {
                        if ("string" == typeof e1) {
                            if ("string" == typeof t ? (o = t, t = 0, r = this.length) : "string" == typeof r && (o = r, r = this.length), void 0 !== o && "string" != typeof o) throw new TypeError("encoding must be a string");
                            if ("string" == typeof o && !d.isEncoding(o)) throw new TypeError("Unknown encoding: " + o);
                            var n;
                            1 === e1.length && (n = e1.charCodeAt(0), ("utf8" === o && n < 128 || "latin1" === o) && (e1 = n));
                        } else "number" == typeof e1 ? e1 &= 255 : "boolean" == typeof e1 && (e1 = Number(e1));
                        if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
                        var s;
                        if (!(r <= t)) {
                            if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, "number" == typeof (e1 = e1 || 0)) for(s = t; s < r; ++s)this[s] = e1;
                            else {
                                var i = d.isBuffer(e1) ? e1 : d.from(e1, o), a = i.length;
                                if (0 === a) throw new TypeError('The value "' + e1 + '" is invalid for argument "value"');
                                for(s = 0; s < r - t; ++s)this[s + t] = i[s % a];
                            }
                        }
                        return this;
                    };
                    var w = /[^+/0-9A-Za-z-_]/g;
                    function M(e1, t) {
                        t = t || 1 / 0;
                        for(var r, o = e1.length, n = null, s = [], i = 0; i < o; ++i){
                            if (55295 < (r = e1.charCodeAt(i)) && r < 57344) {
                                if (!n) {
                                    if (56319 < r) {
                                        -1 < (t -= 3) && s.push(239, 191, 189);
                                        continue;
                                    }
                                    if (i + 1 === o) {
                                        -1 < (t -= 3) && s.push(239, 191, 189);
                                        continue;
                                    }
                                    n = r;
                                    continue;
                                }
                                if (r < 56320) {
                                    -1 < (t -= 3) && s.push(239, 191, 189), n = r;
                                    continue;
                                }
                                r = 65536 + (n - 55296 << 10 | r - 56320);
                            } else n && -1 < (t -= 3) && s.push(239, 191, 189);
                            if (n = null, r < 128) {
                                if (--t < 0) break;
                                s.push(r);
                            } else if (r < 2048) {
                                if ((t -= 2) < 0) break;
                                s.push(r >> 6 | 192, 63 & r | 128);
                            } else if (r < 65536) {
                                if ((t -= 3) < 0) break;
                                s.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                            } else {
                                if (!(r < 1114112)) throw new Error("Invalid code point");
                                if ((t -= 4) < 0) break;
                                s.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                            }
                        }
                        return s;
                    }
                    function E(e1) {
                        return S.toByteArray(function(e1) {
                            if ((e1 = (e1 = e1.split("=")[0]).trim().replace(w, "")).length < 2) return "";
                            for(; e1.length % 4 != 0;)e1 += "=";
                            return e1;
                        }(e1));
                    }
                    function k(e1, t, r, o) {
                        for(var n = 0; n < o && !(n + r >= t.length || n >= e1.length); ++n)t[n + r] = e1[n];
                        return n;
                    }
                    function C(e1, t) {
                        return e1 instanceof t || null != e1 && null != e1.constructor && null != e1.constructor.name && e1.constructor.name === t.name;
                    }
                    function O(e1) {
                        return e1 != e1;
                    }
                    var P = function() {
                        for(var e1 = "0123456789abcdef", t = new Array(256), r = 0; r < 16; ++r)for(var o = 16 * r, n = 0; n < 16; ++n)t[o + n] = e1[r] + e1[n];
                        return t;
                    }();
                }).call(this, A("buffer").Buffer);
            },
            {
                "base64-js": 1,
                buffer: 4,
                ieee754: 246
            }
        ],
        5: [
            function(e1, t, r) {
                t.exports = function(e1) {
                    if ("function" != typeof e1) throw TypeError(String(e1) + " is not a function");
                    return e1;
                };
            },
            {}
        ],
        6: [
            function(e1, t, r) {
                var o = e1("../internals/is-object");
                t.exports = function(e1) {
                    if (o(e1) || null === e1) return e1;
                    throw TypeError("Can't set " + String(e1) + " as a prototype");
                };
            },
            {
                "../internals/is-object": 74
            }
        ],
        7: [
            function(e1, t, r) {
                var o = e1("../internals/well-known-symbol"), n = e1("../internals/object-create"), e1 = e1("../internals/object-define-property"), s = o("unscopables"), i = Array.prototype;
                null == i[s] && e1.f(i, s, {
                    configurable: !0,
                    value: n(null)
                }), t.exports = function(e1) {
                    i[s][e1] = !0;
                };
            },
            {
                "../internals/object-create": 90,
                "../internals/object-define-property": 92,
                "../internals/well-known-symbol": 148
            }
        ],
        8: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/string-multibyte").charAt;
                t.exports = function(e1, t, r) {
                    return t + (r ? o(e1, t).length : 1);
                };
            },
            {
                "../internals/string-multibyte": 123
            }
        ],
        9: [
            function(e1, t, r) {
                t.exports = function(e1, t, r) {
                    if (e1 instanceof t) return e1;
                    throw TypeError("Incorrect " + (r ? r + " " : "") + "invocation");
                };
            },
            {}
        ],
        10: [
            function(e1, t, r) {
                var o = e1("../internals/is-object");
                t.exports = function(e1) {
                    if (o(e1)) return e1;
                    throw TypeError(String(e1) + " is not an object");
                };
            },
            {
                "../internals/is-object": 74
            }
        ],
        11: [
            function(e1, t, r) {
                t.exports = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView;
            },
            {}
        ],
        12: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return l(e1) && u(M, c(e1));
                }
                var n, s = e1("../internals/array-buffer-native"), i = e1("../internals/descriptors"), a = e1("../internals/global"), l = e1("../internals/is-object"), u = e1("../internals/has"), c = e1("../internals/classof"), d = e1("../internals/create-non-enumerable-property"), h = e1("../internals/redefine"), f = e1("../internals/object-define-property").f, p = e1("../internals/object-get-prototype-of"), m = e1("../internals/object-set-prototype-of"), y = e1("../internals/well-known-symbol"), e1 = e1("../internals/uid"), g = a.Int8Array, v = g && g.prototype, b = a.Uint8ClampedArray, b = b && b.prototype, j = g && p(g), _ = v && p(v), x = Object.prototype, w = x.isPrototypeOf, y = y("toStringTag"), S = e1("TYPED_ARRAY_TAG"), T = s && !!m && "Opera" !== c(a.opera), e1 = !1, M = {
                    Int8Array: 1,
                    Uint8Array: 1,
                    Uint8ClampedArray: 1,
                    Int16Array: 2,
                    Uint16Array: 2,
                    Int32Array: 4,
                    Uint32Array: 4,
                    Float32Array: 4,
                    Float64Array: 8
                };
                for(n in M)a[n] || (T = !1);
                if ((!T || "function" != typeof j || j === Function.prototype) && (j = function() {
                    throw TypeError("Incorrect invocation");
                }, T)) for(n in M)a[n] && m(a[n], j);
                if ((!T || !_ || _ === x) && (_ = j.prototype, T)) for(n in M)a[n] && m(a[n].prototype, _);
                if (T && p(b) !== _ && m(b, _), i && !u(_, y)) for(n in e1 = !0, f(_, y, {
                    get: function() {
                        return l(this) ? this[S] : void 0;
                    }
                }), M)a[n] && d(a[n], S, n);
                t.exports = {
                    NATIVE_ARRAY_BUFFER_VIEWS: T,
                    TYPED_ARRAY_TAG: e1 && S,
                    aTypedArray: function(e1) {
                        if (o(e1)) return e1;
                        throw TypeError("Target is not a typed array");
                    },
                    aTypedArrayConstructor: function(e1) {
                        if (m) {
                            if (w.call(j, e1)) return e1;
                        } else for(var t in M)if (u(M, n)) {
                            t = a[t];
                            if (t && (e1 === t || w.call(t, e1))) return e1;
                        }
                        throw TypeError("Target is not a typed array constructor");
                    },
                    exportTypedArrayMethod: function(e1, t, r) {
                        if (i) {
                            if (r) for(var o in M){
                                o = a[o];
                                o && u(o.prototype, e1) && delete o.prototype[e1];
                            }
                            _[e1] && !r || h(_, e1, !r && T && v[e1] || t);
                        }
                    },
                    exportTypedArrayStaticMethod: function(e1, t, r) {
                        var o, n;
                        if (i) {
                            if (m) {
                                if (r) for(o in M)(n = a[o]) && u(n, e1) && delete n[e1];
                                if (j[e1] && !r) return;
                                try {
                                    return h(j, e1, !r && T && g[e1] || t);
                                } catch (e1) {}
                            }
                            for(o in M)!(n = a[o]) || n[e1] && !r || h(n, e1, t);
                        }
                    },
                    isView: function(e1) {
                        e1 = c(e1);
                        return "DataView" === e1 || u(M, e1);
                    },
                    isTypedArray: o,
                    TypedArray: j,
                    TypedArrayPrototype: _
                };
            },
            {
                "../internals/array-buffer-native": 11,
                "../internals/classof": 29,
                "../internals/create-non-enumerable-property": 38,
                "../internals/descriptors": 43,
                "../internals/global": 59,
                "../internals/has": 60,
                "../internals/is-object": 74,
                "../internals/object-define-property": 92,
                "../internals/object-get-prototype-of": 97,
                "../internals/object-set-prototype-of": 101,
                "../internals/redefine": 108,
                "../internals/uid": 145,
                "../internals/well-known-symbol": 148
            }
        ],
        13: [
            function(e1, t, D) {
                "use strict";
                function r(e1) {
                    return [
                        255 & e1
                    ];
                }
                function o(e1) {
                    return [
                        255 & e1,
                        e1 >> 8 & 255
                    ];
                }
                function n(e1) {
                    return [
                        255 & e1,
                        e1 >> 8 & 255,
                        e1 >> 16 & 255,
                        e1 >> 24 & 255
                    ];
                }
                function s(e1) {
                    return e1[3] << 24 | e1[2] << 16 | e1[1] << 8 | e1[0];
                }
                function i(e1) {
                    return O(e1, 23, 4);
                }
                function F(e1) {
                    return O(e1, 52, 8);
                }
                function a(e1, t) {
                    H(e1[w], t, {
                        get: function() {
                            return b(this)[t];
                        }
                    });
                }
                function l(e1, t, r, o) {
                    if (r = m(r), e1 = b(e1), r + t > e1.byteLength) throw C(S);
                    var n = b(e1.buffer).bytes, r = r + e1.byteOffset, e1 = n.slice(r, r + t);
                    return o ? e1 : e1.reverse();
                }
                function u(e1, t, r, o, n, s) {
                    if (r = m(r), e1 = b(e1), r + t > e1.byteLength) throw C(S);
                    for(var i = b(e1.buffer).bytes, a = r + e1.byteOffset, l = o(+n), u = 0; u < t; u++)i[a + u] = l[s ? u : t - u - 1];
                }
                var c = e1("../internals/global"), d = e1("../internals/descriptors"), U = e1("../internals/array-buffer-native"), N = e1("../internals/create-non-enumerable-property"), h = e1("../internals/redefine-all"), f = e1("../internals/fails"), p = e1("../internals/an-instance"), B = e1("../internals/to-integer"), G = e1("../internals/to-length"), m = e1("../internals/to-index"), y = e1("../internals/ieee754"), V = e1("../internals/object-get-prototype-of"), g = e1("../internals/object-set-prototype-of"), z = e1("../internals/object-get-own-property-names").f, H = e1("../internals/object-define-property").f, W = e1("../internals/array-fill"), v = e1("../internals/set-to-string-tag"), e1 = e1("../internals/internal-state"), b = e1.get, j = e1.set, _ = "ArrayBuffer", x = "DataView", w = "prototype", S = "Wrong index", T = c[_], M = T, E = c[x], e1 = E && E[w], k = Object.prototype, C = c.RangeError, O = y.pack, P = y.unpack;
                if (U) {
                    if (!f(function() {
                        T(1);
                    }) || !f(function() {
                        new T(-1);
                    }) || f(function() {
                        return new T, new T(1.5), new T(NaN), T.name != _;
                    })) {
                        for(var A, c = (M = function(e1) {
                            return p(this, M), new T(m(e1));
                        })[w] = T[w], L = z(T), R = 0; L.length > R;)(A = L[R++]) in M || N(M, A, T[A]);
                        c.constructor = M;
                    }
                    g && V(e1) !== k && g(e1, k);
                    var y = new E(new M(2)), I = e1.setInt8;
                    y.setInt8(0, 2147483648), y.setInt8(1, 2147483649), !y.getInt8(0) && y.getInt8(1) || h(e1, {
                        setInt8: function(e1, t) {
                            I.call(this, e1, t << 24 >> 24);
                        },
                        setUint8: function(e1, t) {
                            I.call(this, e1, t << 24 >> 24);
                        }
                    }, {
                        unsafe: !0
                    });
                } else M = function(e1) {
                    p(this, M, _);
                    e1 = m(e1);
                    j(this, {
                        bytes: W.call(new Array(e1), 0),
                        byteLength: e1
                    }), d || (this.byteLength = e1);
                }, E = function(e1, t, r) {
                    p(this, E, x), p(e1, M, x);
                    var o = b(e1).byteLength, t = B(t);
                    if (t < 0 || o < t) throw C("Wrong offset");
                    if (o < t + (r = void 0 === r ? o - t : G(r))) throw C("Wrong length");
                    j(this, {
                        buffer: e1,
                        byteLength: r,
                        byteOffset: t
                    }), d || (this.buffer = e1, this.byteLength = r, this.byteOffset = t);
                }, d && (a(M, "byteLength"), a(E, "buffer"), a(E, "byteLength"), a(E, "byteOffset")), h(E[w], {
                    getInt8: function(e1) {
                        return l(this, 1, e1)[0] << 24 >> 24;
                    },
                    getUint8: function(e1) {
                        return l(this, 1, e1)[0];
                    },
                    getInt16: function(e1) {
                        e1 = l(this, 2, e1, 1 < arguments.length ? arguments[1] : void 0);
                        return (e1[1] << 8 | e1[0]) << 16 >> 16;
                    },
                    getUint16: function(e1) {
                        e1 = l(this, 2, e1, 1 < arguments.length ? arguments[1] : void 0);
                        return e1[1] << 8 | e1[0];
                    },
                    getInt32: function(e1) {
                        return s(l(this, 4, e1, 1 < arguments.length ? arguments[1] : void 0));
                    },
                    getUint32: function(e1) {
                        return s(l(this, 4, e1, 1 < arguments.length ? arguments[1] : void 0)) >>> 0;
                    },
                    getFloat32: function(e1) {
                        return P(l(this, 4, e1, 1 < arguments.length ? arguments[1] : void 0), 23);
                    },
                    getFloat64: function(e1) {
                        return P(l(this, 8, e1, 1 < arguments.length ? arguments[1] : void 0), 52);
                    },
                    setInt8: function(e1, t) {
                        u(this, 1, e1, r, t);
                    },
                    setUint8: function(e1, t) {
                        u(this, 1, e1, r, t);
                    },
                    setInt16: function(e1, t) {
                        u(this, 2, e1, o, t, 2 < arguments.length ? arguments[2] : void 0);
                    },
                    setUint16: function(e1, t) {
                        u(this, 2, e1, o, t, 2 < arguments.length ? arguments[2] : void 0);
                    },
                    setInt32: function(e1, t) {
                        u(this, 4, e1, n, t, 2 < arguments.length ? arguments[2] : void 0);
                    },
                    setUint32: function(e1, t) {
                        u(this, 4, e1, n, t, 2 < arguments.length ? arguments[2] : void 0);
                    },
                    setFloat32: function(e1, t) {
                        u(this, 4, e1, i, t, 2 < arguments.length ? arguments[2] : void 0);
                    },
                    setFloat64: function(e1, t) {
                        u(this, 8, e1, F, t, 2 < arguments.length ? arguments[2] : void 0);
                    }
                });
                v(M, _), v(E, x), t.exports = {
                    ArrayBuffer: M,
                    DataView: E
                };
            },
            {
                "../internals/an-instance": 9,
                "../internals/array-buffer-native": 11,
                "../internals/array-fill": 15,
                "../internals/create-non-enumerable-property": 38,
                "../internals/descriptors": 43,
                "../internals/fails": 51,
                "../internals/global": 59,
                "../internals/ieee754": 65,
                "../internals/internal-state": 70,
                "../internals/object-define-property": 92,
                "../internals/object-get-own-property-names": 95,
                "../internals/object-get-prototype-of": 97,
                "../internals/object-set-prototype-of": 101,
                "../internals/redefine-all": 107,
                "../internals/set-to-string-tag": 117,
                "../internals/to-index": 133,
                "../internals/to-integer": 135,
                "../internals/to-length": 136
            }
        ],
        14: [
            function(e1, t, r) {
                "use strict";
                var l = e1("../internals/to-object"), u = e1("../internals/to-absolute-index"), c = e1("../internals/to-length"), d = Math.min;
                t.exports = [].copyWithin || function(e1, t) {
                    var r = l(this), o = c(r.length), n = u(e1, o), s = u(t, o), e1 = 2 < arguments.length ? arguments[2] : void 0, i = d((void 0 === e1 ? o : u(e1, o)) - s, o - n), a = 1;
                    for(s < n && n < s + i && (a = -1, s += i - 1, n += i - 1); 0 < i--;)s in r ? r[n] = r[s] : delete r[n], n += a, s += a;
                    return r;
                };
            },
            {
                "../internals/to-absolute-index": 132,
                "../internals/to-length": 136,
                "../internals/to-object": 137
            }
        ],
        15: [
            function(e1, t, r) {
                "use strict";
                var i = e1("../internals/to-object"), a = e1("../internals/to-absolute-index"), l = e1("../internals/to-length");
                t.exports = function(e1) {
                    for(var t = i(this), r = l(t.length), o = arguments.length, n = a(1 < o ? arguments[1] : void 0, r), o = 2 < o ? arguments[2] : void 0, s = void 0 === o ? r : a(o, r); n < s;)t[n++] = e1;
                    return t;
                };
            },
            {
                "../internals/to-absolute-index": 132,
                "../internals/to-length": 136,
                "../internals/to-object": 137
            }
        ],
        16: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-iteration").forEach, n = e1("../internals/array-method-is-strict"), e1 = e1("../internals/array-method-uses-to-length"), n = n("forEach"), e1 = e1("forEach");
                t.exports = n && e1 ? [].forEach : function(e1) {
                    return o(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                };
            },
            {
                "../internals/array-iteration": 19,
                "../internals/array-method-is-strict": 22,
                "../internals/array-method-uses-to-length": 23
            }
        ],
        17: [
            function(e1, t, r) {
                "use strict";
                var f = e1("../internals/function-bind-context"), p = e1("../internals/to-object"), m = e1("../internals/call-with-safe-iteration-closing"), y = e1("../internals/is-array-iterator-method"), g = e1("../internals/to-length"), v = e1("../internals/create-property"), b = e1("../internals/get-iterator-method");
                t.exports = function(e1) {
                    var t, r, o, n, s, i, a = p(e1), e1 = "function" == typeof this ? this : Array, l = arguments.length, u = 1 < l ? arguments[1] : void 0, c = void 0 !== u, d = b(a), h = 0;
                    if (c && (u = f(u, 2 < l ? arguments[2] : void 0, 2)), null == d || e1 == Array && y(d)) for(r = new e1(t = g(a.length)); h < t; h++)i = c ? u(a[h], h) : a[h], v(r, h, i);
                    else for(s = (n = d.call(a)).next, r = new e1; !(o = s.call(n)).done; h++)i = c ? m(n, u, [
                        o.value,
                        h
                    ], !0) : o.value, v(r, h, i);
                    return r.length = h, r;
                };
            },
            {
                "../internals/call-with-safe-iteration-closing": 26,
                "../internals/create-property": 40,
                "../internals/function-bind-context": 54,
                "../internals/get-iterator-method": 57,
                "../internals/is-array-iterator-method": 71,
                "../internals/to-length": 136,
                "../internals/to-object": 137
            }
        ],
        18: [
            function(e1, t, r) {
                function o(a) {
                    return function(e1, t, r) {
                        var o, n = l(e1), s = u(n.length), i = c(r, s);
                        if (a && t != t) {
                            for(; i < s;)if ((o = n[i++]) != o) return !0;
                        } else for(; i < s; i++)if ((a || i in n) && n[i] === t) return a || i || 0;
                        return !a && -1;
                    };
                }
                var l = e1("../internals/to-indexed-object"), u = e1("../internals/to-length"), c = e1("../internals/to-absolute-index");
                t.exports = {
                    includes: o(!0),
                    indexOf: o(!1)
                };
            },
            {
                "../internals/to-absolute-index": 132,
                "../internals/to-indexed-object": 134,
                "../internals/to-length": 136
            }
        ],
        19: [
            function(e1, t, r) {
                function o(h) {
                    var f = 1 == h, p = 2 == h, m = 3 == h, y = 4 == h, g = 6 == h, v = 5 == h || g;
                    return function(e1, t, r, o) {
                        for(var n, s, i = _(e1), a = j(i), l = b(t, r, 3), u = x(a.length), c = 0, t = o || w, d = f ? t(e1, u) : p ? t(e1, 0) : void 0; c < u; c++)if ((v || c in a) && (s = l(n = a[c], c, i), h)) {
                            if (f) d[c] = s;
                            else if (s) switch(h){
                                case 3:
                                    return !0;
                                case 5:
                                    return n;
                                case 6:
                                    return c;
                                case 2:
                                    S.call(d, n);
                            }
                            else if (y) return !1;
                        }
                        return g ? -1 : m || y ? y : d;
                    };
                }
                var b = e1("../internals/function-bind-context"), j = e1("../internals/indexed-object"), _ = e1("../internals/to-object"), x = e1("../internals/to-length"), w = e1("../internals/array-species-create"), S = [].push;
                t.exports = {
                    forEach: o(0),
                    map: o(1),
                    filter: o(2),
                    some: o(3),
                    every: o(4),
                    find: o(5),
                    findIndex: o(6)
                };
            },
            {
                "../internals/array-species-create": 25,
                "../internals/function-bind-context": 54,
                "../internals/indexed-object": 66,
                "../internals/to-length": 136,
                "../internals/to-object": 137
            }
        ],
        20: [
            function(e1, t, r) {
                "use strict";
                var n = e1("../internals/to-indexed-object"), s = e1("../internals/to-integer"), i = e1("../internals/to-length"), o = e1("../internals/array-method-is-strict"), e1 = e1("../internals/array-method-uses-to-length"), a = Math.min, l = [].lastIndexOf, u = !!l && 1 / [
                    1
                ].lastIndexOf(1, -0) < 0, o = o("lastIndexOf"), e1 = e1("indexOf", {
                    ACCESSORS: !0,
                    1: 0
                });
                t.exports = u || !o || !e1 ? function(e1) {
                    if (u) return l.apply(this, arguments) || 0;
                    var t = n(this), r = i(t.length), o = r - 1;
                    for((o = 1 < arguments.length ? a(o, s(arguments[1])) : o) < 0 && (o = r + o); 0 <= o; o--)if (o in t && t[o] === e1) return o || 0;
                    return -1;
                } : l;
            },
            {
                "../internals/array-method-is-strict": 22,
                "../internals/array-method-uses-to-length": 23,
                "../internals/to-indexed-object": 134,
                "../internals/to-integer": 135,
                "../internals/to-length": 136
            }
        ],
        21: [
            function(e1, t, r) {
                var o = e1("../internals/fails"), n = e1("../internals/well-known-symbol"), s = e1("../internals/engine-v8-version"), i = n("species");
                t.exports = function(t) {
                    return 51 <= s || !o(function() {
                        var e1 = [];
                        return (e1.constructor = {})[i] = function() {
                            return {
                                foo: 1
                            };
                        }, 1 !== e1[t](Boolean).foo;
                    });
                };
            },
            {
                "../internals/engine-v8-version": 48,
                "../internals/fails": 51,
                "../internals/well-known-symbol": 148
            }
        ],
        22: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/fails");
                t.exports = function(e1, t) {
                    var r = [][e1];
                    return !!r && o(function() {
                        r.call(null, t || function() {
                            throw 1;
                        }, 1);
                    });
                };
            },
            {
                "../internals/fails": 51
            }
        ],
        23: [
            function(e1, t, r) {
                function i(e1) {
                    throw e1;
                }
                var a = e1("../internals/descriptors"), l = e1("../internals/fails"), u = e1("../internals/has"), c = Object.defineProperty, d = {};
                t.exports = function(e1, t) {
                    var r, o, n, s;
                    return u(d, e1) ? d[e1] : (r = [][e1], o = !!u(t = t || {}, "ACCESSORS") && t.ACCESSORS, n = u(t, 0) ? t[0] : i, s = u(t, 1) ? t[1] : void 0, d[e1] = !!r && !l(function() {
                        if (o && !a) return !0;
                        var e1 = {
                            length: -1
                        };
                        o ? c(e1, 1, {
                            enumerable: !0,
                            get: i
                        }) : e1[1] = 1, r.call(e1, n, s);
                    }));
                };
            },
            {
                "../internals/descriptors": 43,
                "../internals/fails": 51,
                "../internals/has": 60
            }
        ],
        24: [
            function(e1, t, r) {
                function o(u) {
                    return function(e1, t, r, o) {
                        c(t);
                        var n = d(e1), s = h(n), i = f(n.length), a = u ? i - 1 : 0, l = u ? -1 : 1;
                        if (r < 2) for(;;){
                            if (a in s) {
                                o = s[a], a += l;
                                break;
                            }
                            if (a += l, u ? a < 0 : i <= a) throw TypeError("Reduce of empty array with no initial value");
                        }
                        for(; u ? 0 <= a : a < i; a += l)a in s && (o = t(o, s[a], a, n));
                        return o;
                    };
                }
                var c = e1("../internals/a-function"), d = e1("../internals/to-object"), h = e1("../internals/indexed-object"), f = e1("../internals/to-length");
                t.exports = {
                    left: o(!1),
                    right: o(!0)
                };
            },
            {
                "../internals/a-function": 5,
                "../internals/indexed-object": 66,
                "../internals/to-length": 136,
                "../internals/to-object": 137
            }
        ],
        25: [
            function(e1, t, r) {
                var o = e1("../internals/is-object"), n = e1("../internals/is-array"), s = e1("../internals/well-known-symbol")("species");
                t.exports = function(e1, t) {
                    var r;
                    return new (void 0 === (r = n(e1) && ("function" == typeof (r = e1.constructor) && (r === Array || n(r.prototype)) || o(r) && null === (r = r[s])) ? void 0 : r) ? Array : r)(0 === t ? 0 : t);
                };
            },
            {
                "../internals/is-array": 72,
                "../internals/is-object": 74,
                "../internals/well-known-symbol": 148
            }
        ],
        26: [
            function(e1, t, r) {
                var n = e1("../internals/an-object");
                t.exports = function(t, e1, r, o) {
                    try {
                        return o ? e1(n(r)[0], r[1]) : e1(r);
                    } catch (e1) {
                        o = t.return;
                        throw void 0 !== o && n(o.call(t)), e1;
                    }
                };
            },
            {
                "../internals/an-object": 10
            }
        ],
        27: [
            function(e1, t, r) {
                var n = e1("../internals/well-known-symbol")("iterator"), s = !1;
                try {
                    var o = 0, i = {
                        next: function() {
                            return {
                                done: !!o++
                            };
                        },
                        return: function() {
                            s = !0;
                        }
                    };
                    i[n] = function() {
                        return this;
                    }, Array.from(i, function() {
                        throw 2;
                    });
                } catch (e1) {}
                t.exports = function(e1, t) {
                    if (!t && !s) return !1;
                    var r = !1;
                    try {
                        var o = {};
                        o[n] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: r = !0
                                    };
                                }
                            };
                        }, e1(o);
                    } catch (e1) {}
                    return r;
                };
            },
            {
                "../internals/well-known-symbol": 148
            }
        ],
        28: [
            function(e1, t, r) {
                var o = {}.toString;
                t.exports = function(e1) {
                    return o.call(e1).slice(8, -1);
                };
            },
            {}
        ],
        29: [
            function(e1, t, r) {
                var o = e1("../internals/to-string-tag-support"), n = e1("../internals/classof-raw"), s = e1("../internals/well-known-symbol")("toStringTag"), i = "Arguments" == n(function() {
                    return arguments;
                }());
                t.exports = o ? n : function(e1) {
                    var t;
                    return void 0 === e1 ? "Undefined" : null === e1 ? "Null" : "string" == typeof (t = function(e1, t) {
                        try {
                            return e1[t];
                        } catch (e1) {}
                    }(e1 = Object(e1), s)) ? t : i ? n(e1) : "Object" == (t = n(e1)) && "function" == typeof e1.callee ? "Arguments" : t;
                };
            },
            {
                "../internals/classof-raw": 28,
                "../internals/to-string-tag-support": 141,
                "../internals/well-known-symbol": 148
            }
        ],
        30: [
            function(e1, t, r) {
                "use strict";
                var u = e1("../internals/object-define-property").f, c = e1("../internals/object-create"), d = e1("../internals/redefine-all"), h = e1("../internals/function-bind-context"), f = e1("../internals/an-instance"), p = e1("../internals/iterate"), i = e1("../internals/define-iterator"), a = e1("../internals/set-species"), m = e1("../internals/descriptors"), y = e1("../internals/internal-metadata").fastKey, e1 = e1("../internals/internal-state"), g = e1.set, v = e1.getterFor;
                t.exports = {
                    getConstructor: function(e1, r, o, n) {
                        function s(e1, t, r) {
                            var o, n = l(e1), s = i(e1, t);
                            return s ? s.value = r : (n.last = s = {
                                index: o = y(t, !0),
                                key: t,
                                value: r,
                                previous: t = n.last,
                                next: void 0,
                                removed: !1
                            }, n.first || (n.first = s), t && (t.next = s), m ? n.size++ : e1.size++, "F" !== o && (n.index[o] = s)), e1;
                        }
                        function i(e1, t) {
                            var r, e1 = l(e1), o = y(t);
                            if ("F" !== o) return e1.index[o];
                            for(r = e1.first; r; r = r.next)if (r.key == t) return r;
                        }
                        var a = e1(function(e1, t) {
                            f(e1, a, r), g(e1, {
                                type: r,
                                index: c(null),
                                first: void 0,
                                last: void 0,
                                size: 0
                            }), m || (e1.size = 0), null != t && p(t, e1[n], e1, o);
                        }), l = v(r);
                        return d(a.prototype, {
                            clear: function() {
                                for(var e1 = l(this), t = e1.index, r = e1.first; r;)r.removed = !0, r.previous && (r.previous = r.previous.next = void 0), delete t[r.index], r = r.next;
                                e1.first = e1.last = void 0, m ? e1.size = 0 : this.size = 0;
                            },
                            delete: function(e1) {
                                var t, r, o = l(this), e1 = i(this, e1);
                                return e1 && (t = e1.next, r = e1.previous, delete o.index[e1.index], e1.removed = !0, r && (r.next = t), t && (t.previous = r), o.first == e1 && (o.first = t), o.last == e1 && (o.last = r), m ? o.size-- : this.size--), !!e1;
                            },
                            forEach: function(e1) {
                                for(var t, r = l(this), o = h(e1, 1 < arguments.length ? arguments[1] : void 0, 3); t = t ? t.next : r.first;)for(o(t.value, t.key, this); t && t.removed;)t = t.previous;
                            },
                            has: function(e1) {
                                return !!i(this, e1);
                            }
                        }), d(a.prototype, o ? {
                            get: function(e1) {
                                e1 = i(this, e1);
                                return e1 && e1.value;
                            },
                            set: function(e1, t) {
                                return s(this, 0 === e1 ? 0 : e1, t);
                            }
                        } : {
                            add: function(e1) {
                                return s(this, e1 = 0 === e1 ? 0 : e1, e1);
                            }
                        }), m && u(a.prototype, "size", {
                            get: function() {
                                return l(this).size;
                            }
                        }), a;
                    },
                    setStrong: function(e1, t, r) {
                        var o = t + " Iterator", n = v(t), s = v(o);
                        i(e1, t, function(e1, t) {
                            g(this, {
                                type: o,
                                target: e1,
                                state: n(e1),
                                kind: t,
                                last: void 0
                            });
                        }, function() {
                            for(var e1 = s(this), t = e1.kind, r = e1.last; r && r.removed;)r = r.previous;
                            return e1.target && (e1.last = r = r ? r.next : e1.state.first) ? "keys" == t ? {
                                value: r.key,
                                done: !1
                            } : "values" == t ? {
                                value: r.value,
                                done: !1
                            } : {
                                value: [
                                    r.key,
                                    r.value
                                ],
                                done: !1
                            } : {
                                value: e1.target = void 0,
                                done: !0
                            };
                        }, r ? "entries" : "values", !r, !0), a(t);
                    }
                };
            },
            {
                "../internals/an-instance": 9,
                "../internals/define-iterator": 41,
                "../internals/descriptors": 43,
                "../internals/function-bind-context": 54,
                "../internals/internal-metadata": 69,
                "../internals/internal-state": 70,
                "../internals/iterate": 77,
                "../internals/object-create": 90,
                "../internals/object-define-property": 92,
                "../internals/redefine-all": 107,
                "../internals/set-species": 116
            }
        ],
        31: [
            function(e1, t, r) {
                "use strict";
                function l(e1) {
                    return e1.frozen || (e1.frozen = new o);
                }
                function o() {
                    this.entries = [];
                }
                function n(e1, t) {
                    return i(e1.entries, function(e1) {
                        return e1[0] === t;
                    });
                }
                var u = e1("../internals/redefine-all"), c = e1("../internals/internal-metadata").getWeakData, d = e1("../internals/an-object"), h = e1("../internals/is-object"), f = e1("../internals/an-instance"), p = e1("../internals/iterate"), s = e1("../internals/array-iteration"), m = e1("../internals/has"), e1 = e1("../internals/internal-state"), y = e1.set, g = e1.getterFor, i = s.find, a = s.findIndex, v = 0;
                o.prototype = {
                    get: function(e1) {
                        e1 = n(this, e1);
                        if (e1) return e1[1];
                    },
                    has: function(e1) {
                        return !!n(this, e1);
                    },
                    set: function(e1, t) {
                        var r = n(this, e1);
                        r ? r[1] = t : this.entries.push([
                            e1,
                            t
                        ]);
                    },
                    delete: function(t) {
                        var e1 = a(this.entries, function(e1) {
                            return e1[0] === t;
                        });
                        return ~e1 && this.entries.splice(e1, 1), !!~e1;
                    }
                }, t.exports = {
                    getConstructor: function(e1, r, o, n) {
                        function s(e1, t, r) {
                            var o = a(e1), n = c(d(t), !0);
                            return !0 === n ? l(o).set(t, r) : n[o.id] = r, e1;
                        }
                        var i = e1(function(e1, t) {
                            f(e1, i, r), y(e1, {
                                type: r,
                                id: v++,
                                frozen: void 0
                            }), null != t && p(t, e1[n], e1, o);
                        }), a = g(r);
                        return u(i.prototype, {
                            delete: function(e1) {
                                var t, r = a(this);
                                return !!h(e1) && (!0 === (t = c(e1)) ? l(r).delete(e1) : t && m(t, r.id) && delete t[r.id]);
                            },
                            has: function(e1) {
                                var t, r = a(this);
                                return !!h(e1) && (!0 === (t = c(e1)) ? l(r).has(e1) : t && m(t, r.id));
                            }
                        }), u(i.prototype, o ? {
                            get: function(e1) {
                                var t, r = a(this);
                                if (h(e1)) return !0 === (t = c(e1)) ? l(r).get(e1) : t ? t[r.id] : void 0;
                            },
                            set: function(e1, t) {
                                return s(this, e1, t);
                            }
                        } : {
                            add: function(e1) {
                                return s(this, e1, !0);
                            }
                        }), i;
                    }
                };
            },
            {
                "../internals/an-instance": 9,
                "../internals/an-object": 10,
                "../internals/array-iteration": 19,
                "../internals/has": 60,
                "../internals/internal-metadata": 69,
                "../internals/internal-state": 70,
                "../internals/is-object": 74,
                "../internals/iterate": 77,
                "../internals/redefine-all": 107
            }
        ],
        32: [
            function(e1, t, r) {
                "use strict";
                var y = e1("../internals/export"), g = e1("../internals/global"), v = e1("../internals/is-forced"), b = e1("../internals/redefine"), j = e1("../internals/internal-metadata"), _ = e1("../internals/iterate"), x = e1("../internals/an-instance"), w = e1("../internals/is-object"), S = e1("../internals/fails"), T = e1("../internals/check-correctness-of-iteration"), M = e1("../internals/set-to-string-tag"), E = e1("../internals/inherit-if-required");
                t.exports = function(r, e1, t) {
                    function o(e1) {
                        var r = f[e1];
                        b(f, e1, "add" == e1 ? function(e1) {
                            return r.call(this, 0 === e1 ? 0 : e1), this;
                        } : "delete" == e1 ? function(e1) {
                            return !(c && !w(e1)) && r.call(this, 0 === e1 ? 0 : e1);
                        } : "get" == e1 ? function(e1) {
                            return c && !w(e1) ? void 0 : r.call(this, 0 === e1 ? 0 : e1);
                        } : "has" == e1 ? function(e1) {
                            return !(c && !w(e1)) && r.call(this, 0 === e1 ? 0 : e1);
                        } : function(e1, t) {
                            return r.call(this, 0 === e1 ? 0 : e1, t), this;
                        });
                    }
                    var n, s, i, a, l, u = -1 !== r.indexOf("Map"), c = -1 !== r.indexOf("Weak"), d = u ? "set" : "add", h = g[r], f = h && h.prototype, p = h, m = {};
                    return v(r, "function" != typeof h || !(c || f.forEach && !S(function() {
                        (new h).entries().next();
                    }))) ? (p = t.getConstructor(e1, r, u, d), j.REQUIRED = !0) : v(r, !0) && (s = (n = new p)[d](c ? {} : -0, 1) != n, i = S(function() {
                        n.has(1);
                    }), a = T(function(e1) {
                        new h(e1);
                    }), l = !c && S(function() {
                        for(var e1 = new h, t = 5; t--;)e1[d](t, t);
                        return !e1.has(-0);
                    }), a || (((p = e1(function(e1, t) {
                        x(e1, p, r);
                        e1 = E(new h, e1, p);
                        return null != t && _(t, e1[d], e1, u), e1;
                    })).prototype = f).constructor = p), (i || l) && (o("delete"), o("has"), u && o("get")), (l || s) && o(d), c && f.clear && delete f.clear), m[r] = p, y({
                        global: !0,
                        forced: p != h
                    }, m), M(p, r), c || t.setStrong(p, r, u), p;
                };
            },
            {
                "../internals/an-instance": 9,
                "../internals/check-correctness-of-iteration": 27,
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/global": 59,
                "../internals/inherit-if-required": 67,
                "../internals/internal-metadata": 69,
                "../internals/is-forced": 73,
                "../internals/is-object": 74,
                "../internals/iterate": 77,
                "../internals/redefine": 108,
                "../internals/set-to-string-tag": 117
            }
        ],
        33: [
            function(e1, t, r) {
                var a = e1("../internals/has"), l = e1("../internals/own-keys"), u = e1("../internals/object-get-own-property-descriptor"), c = e1("../internals/object-define-property");
                t.exports = function(e1, t) {
                    for(var r = l(t), o = c.f, n = u.f, s = 0; s < r.length; s++){
                        var i = r[s];
                        a(e1, i) || o(e1, i, n(t, i));
                    }
                };
            },
            {
                "../internals/has": 60,
                "../internals/object-define-property": 92,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/own-keys": 103
            }
        ],
        34: [
            function(e1, t, r) {
                var o = e1("../internals/well-known-symbol")("match");
                t.exports = function(t) {
                    var r = /./;
                    try {
                        "/./"[t](r);
                    } catch (e1) {
                        try {
                            return r[o] = !1, "/./"[t](r);
                        } catch (e1) {}
                    }
                    return !1;
                };
            },
            {
                "../internals/well-known-symbol": 148
            }
        ],
        35: [
            function(e1, t, r) {
                e1 = e1("../internals/fails");
                t.exports = !e1(function() {
                    function e1() {}
                    return e1.prototype.constructor = null, Object.getPrototypeOf(new e1) !== e1.prototype;
                });
            },
            {
                "../internals/fails": 51
            }
        ],
        36: [
            function(e1, t, r) {
                var s = e1("../internals/require-object-coercible"), i = /"/g;
                t.exports = function(e1, t, r, o) {
                    var e1 = String(s(e1)), n = "<" + t;
                    return "" !== r && (n += " " + r + '="' + String(o).replace(i, "&quot;") + '"'), n + ">" + e1 + "</" + t + ">";
                };
            },
            {
                "../internals/require-object-coercible": 113
            }
        ],
        37: [
            function(e1, t, r) {
                "use strict";
                function o() {
                    return this;
                }
                var n = e1("../internals/iterators-core").IteratorPrototype, s = e1("../internals/object-create"), i = e1("../internals/create-property-descriptor"), a = e1("../internals/set-to-string-tag"), l = e1("../internals/iterators");
                t.exports = function(e1, t, r) {
                    t += " Iterator";
                    return e1.prototype = s(n, {
                        next: i(1, r)
                    }), a(e1, t, !1, !0), l[t] = o, e1;
                };
            },
            {
                "../internals/create-property-descriptor": 39,
                "../internals/iterators": 79,
                "../internals/iterators-core": 78,
                "../internals/object-create": 90,
                "../internals/set-to-string-tag": 117
            }
        ],
        38: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), n = e1("../internals/object-define-property"), s = e1("../internals/create-property-descriptor");
                t.exports = o ? function(e1, t, r) {
                    return n.f(e1, t, s(1, r));
                } : function(e1, t, r) {
                    return e1[t] = r, e1;
                };
            },
            {
                "../internals/create-property-descriptor": 39,
                "../internals/descriptors": 43,
                "../internals/object-define-property": 92
            }
        ],
        39: [
            function(e1, t, r) {
                t.exports = function(e1, t) {
                    return {
                        enumerable: !(1 & e1),
                        configurable: !(2 & e1),
                        writable: !(4 & e1),
                        value: t
                    };
                };
            },
            {}
        ],
        40: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/to-primitive"), n = e1("../internals/object-define-property"), s = e1("../internals/create-property-descriptor");
                t.exports = function(e1, t, r) {
                    t = o(t);
                    t in e1 ? n.f(e1, t, s(0, r)) : e1[t] = r;
                };
            },
            {
                "../internals/create-property-descriptor": 39,
                "../internals/object-define-property": 92,
                "../internals/to-primitive": 140
            }
        ],
        41: [
            function(e1, t, r) {
                "use strict";
                function m() {
                    return this;
                }
                var y = e1("../internals/export"), g = e1("../internals/create-iterator-constructor"), v = e1("../internals/object-get-prototype-of"), b = e1("../internals/object-set-prototype-of"), j = e1("../internals/set-to-string-tag"), _ = e1("../internals/create-non-enumerable-property"), x = e1("../internals/redefine"), o = e1("../internals/well-known-symbol"), w = e1("../internals/is-pure"), S = e1("../internals/iterators"), e1 = e1("../internals/iterators-core"), T = e1.IteratorPrototype, M = e1.BUGGY_SAFARI_ITERATORS, E = o("iterator"), k = "values", C = "entries";
                t.exports = function(e1, t, r, o, n, s, i) {
                    g(r, t, o);
                    function a(e1) {
                        if (e1 === n && f) return f;
                        if (!M && e1 in d) return d[e1];
                        switch(e1){
                            case "keys":
                            case k:
                            case C:
                                return function() {
                                    return new r(this, e1);
                                };
                        }
                        return function() {
                            return new r(this);
                        };
                    }
                    var l, u, o = t + " Iterator", c = !1, d = e1.prototype, h = d[E] || d["@@iterator"] || n && d[n], f = !M && h || a(n), p = "Array" == t && d.entries || h;
                    if (p && (p = v(p.call(new e1)), T !== Object.prototype && p.next && (w || v(p) === T || (b ? b(p, T) : "function" != typeof p[E] && _(p, E, m)), j(p, o, !0, !0), w && (S[o] = m))), n == k && h && h.name !== k && (c = !0, f = function() {
                        return h.call(this);
                    }), w && !i || d[E] === f || _(d, E, f), S[t] = f, n) {
                        if (l = {
                            values: a(k),
                            keys: s ? f : a("keys"),
                            entries: a(C)
                        }, i) for(u in l)!M && !c && u in d || x(d, u, l[u]);
                        else y({
                            target: t,
                            proto: !0,
                            forced: M || c
                        }, l);
                    }
                    return l;
                };
            },
            {
                "../internals/create-iterator-constructor": 37,
                "../internals/create-non-enumerable-property": 38,
                "../internals/export": 50,
                "../internals/is-pure": 75,
                "../internals/iterators": 79,
                "../internals/iterators-core": 78,
                "../internals/object-get-prototype-of": 97,
                "../internals/object-set-prototype-of": 101,
                "../internals/redefine": 108,
                "../internals/set-to-string-tag": 117,
                "../internals/well-known-symbol": 148
            }
        ],
        42: [
            function(e1, t, r) {
                var o = e1("../internals/path"), n = e1("../internals/has"), s = e1("../internals/well-known-symbol-wrapped"), i = e1("../internals/object-define-property").f;
                t.exports = function(e1) {
                    var t = o.Symbol || (o.Symbol = {});
                    n(t, e1) || i(t, e1, {
                        value: s.f(e1)
                    });
                };
            },
            {
                "../internals/has": 60,
                "../internals/object-define-property": 92,
                "../internals/path": 104,
                "../internals/well-known-symbol-wrapped": 147
            }
        ],
        43: [
            function(e1, t, r) {
                e1 = e1("../internals/fails");
                t.exports = !e1(function() {
                    return 7 != Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1];
                });
            },
            {
                "../internals/fails": 51
            }
        ],
        44: [
            function(e1, t, r) {
                var o = e1("../internals/global"), e1 = e1("../internals/is-object"), n = o.document, s = e1(n) && e1(n.createElement);
                t.exports = function(e1) {
                    return s ? n.createElement(e1) : {};
                };
            },
            {
                "../internals/global": 59,
                "../internals/is-object": 74
            }
        ],
        45: [
            function(e1, t, r) {
                t.exports = {
                    CSSRuleList: 0,
                    CSSStyleDeclaration: 0,
                    CSSValueList: 0,
                    ClientRectList: 0,
                    DOMRectList: 0,
                    DOMStringList: 0,
                    DOMTokenList: 1,
                    DataTransferItemList: 0,
                    FileList: 0,
                    HTMLAllCollection: 0,
                    HTMLCollection: 0,
                    HTMLFormElement: 0,
                    HTMLSelectElement: 0,
                    MediaList: 0,
                    MimeTypeArray: 0,
                    NamedNodeMap: 0,
                    NodeList: 1,
                    PaintRequestList: 0,
                    Plugin: 0,
                    PluginArray: 0,
                    SVGLengthList: 0,
                    SVGNumberList: 0,
                    SVGPathSegList: 0,
                    SVGPointList: 0,
                    SVGStringList: 0,
                    SVGTransformList: 0,
                    SourceBufferList: 0,
                    StyleSheetList: 0,
                    TextTrackCueList: 0,
                    TextTrackList: 0,
                    TouchList: 0
                };
            },
            {}
        ],
        46: [
            function(e1, t, r) {
                e1 = e1("../internals/engine-user-agent");
                t.exports = /(iphone|ipod|ipad).*applewebkit/i.test(e1);
            },
            {
                "../internals/engine-user-agent": 47
            }
        ],
        47: [
            function(e1, t, r) {
                e1 = e1("../internals/get-built-in");
                t.exports = e1("navigator", "userAgent") || "";
            },
            {
                "../internals/get-built-in": 56
            }
        ],
        48: [
            function(e1, t, r) {
                var o, n, s = e1("../internals/global"), e1 = e1("../internals/engine-user-agent"), s = s.process, s = s && s.versions, s = s && s.v8;
                s ? n = (o = s.split("."))[0] + o[1] : e1 && (!(o = e1.match(/Edge\/(\d+)/)) || 74 <= o[1]) && (o = e1.match(/Chrome\/(\d+)/)) && (n = o[1]), t.exports = n && +n;
            },
            {
                "../internals/engine-user-agent": 47,
                "../internals/global": 59
            }
        ],
        49: [
            function(e1, t, r) {
                t.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            },
            {}
        ],
        50: [
            function(e1, t, r) {
                var u = e1("../internals/global"), c = e1("../internals/object-get-own-property-descriptor").f, d = e1("../internals/create-non-enumerable-property"), h = e1("../internals/redefine"), f = e1("../internals/set-global"), p = e1("../internals/copy-constructor-properties"), m = e1("../internals/is-forced");
                t.exports = function(e1, t) {
                    var r, o, n, s = e1.target, i = e1.global, a = e1.stat, l = i ? u : a ? u[s] || f(s, {}) : (u[s] || {}).prototype;
                    if (l) for(r in t){
                        if (o = t[r], n = e1.noTargetGet ? (n = c(l, r)) && n.value : l[r], !m(i ? r : s + (a ? "." : "#") + r, e1.forced) && void 0 !== n) {
                            if (typeof o == typeof n) continue;
                            p(o, n);
                        }
                        (e1.sham || n && n.sham) && d(o, "sham", !0), h(l, r, o, e1);
                    }
                };
            },
            {
                "../internals/copy-constructor-properties": 33,
                "../internals/create-non-enumerable-property": 38,
                "../internals/global": 59,
                "../internals/is-forced": 73,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/redefine": 108,
                "../internals/set-global": 115
            }
        ],
        51: [
            function(e1, t, r) {
                t.exports = function(e1) {
                    try {
                        return !!e1();
                    } catch (e1) {
                        return !0;
                    }
                };
            },
            {}
        ],
        52: [
            function(e1, t, r) {
                "use strict";
                e1("../modules/es.regexp.exec");
                var u = e1("../internals/redefine"), c = e1("../internals/fails"), d = e1("../internals/well-known-symbol"), h = e1("../internals/regexp-exec"), f = e1("../internals/create-non-enumerable-property"), p = d("species"), m = !c(function() {
                    var e1 = /./;
                    return e1.exec = function() {
                        var e1 = [];
                        return e1.groups = {
                            a: "7"
                        }, e1;
                    }, "7" !== "".replace(e1, "$<a>");
                }), y = "$0" === "a".replace(/./, "$0"), e1 = d("replace"), g = !!/./[e1] && "" === /./[e1]("a", "$0"), v = !c(function() {
                    var e1 = /(?:)/, t = e1.exec, e1 = (e1.exec = function() {
                        return t.apply(this, arguments);
                    }, "ab".split(e1));
                    return 2 !== e1.length || "a" !== e1[0] || "b" !== e1[1];
                });
                t.exports = function(r, e1, t, o) {
                    var s, n, i = d(r), a = !c(function() {
                        var e1 = {};
                        return e1[i] = function() {
                            return 7;
                        }, 7 != ""[r](e1);
                    }), l = a && !c(function() {
                        var e1 = !1, t = /a/;
                        return "split" === r && ((t = {
                            constructor: {}
                        }).constructor[p] = function() {
                            return t;
                        }, t.flags = "", t[i] = /./[i]), t.exec = function() {
                            return e1 = !0, null;
                        }, t[i](""), !e1;
                    });
                    a && l && ("replace" !== r || m && y && !g) && ("split" !== r || v) || (s = /./[i], t = (l = t(i, ""[r], function(e1, t, r, o, n) {
                        return t.exec === h ? a && !n ? {
                            done: !0,
                            value: s.call(t, r, o)
                        } : {
                            done: !0,
                            value: e1.call(r, t, o)
                        } : {
                            done: !1
                        };
                    }, {
                        REPLACE_KEEPS_$0: y,
                        REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: g
                    }))[0], n = l[1], u(String.prototype, r, t), u(RegExp.prototype, i, 2 == e1 ? function(e1, t) {
                        return n.call(e1, this, t);
                    } : function(e1) {
                        return n.call(e1, this);
                    })), o && f(RegExp.prototype[i], "sham", !0);
                };
            },
            {
                "../internals/create-non-enumerable-property": 38,
                "../internals/fails": 51,
                "../internals/redefine": 108,
                "../internals/regexp-exec": 110,
                "../internals/well-known-symbol": 148,
                "../modules/es.regexp.exec": 187
            }
        ],
        53: [
            function(e1, t, r) {
                e1 = e1("../internals/fails");
                t.exports = !e1(function() {
                    return Object.isExtensible(Object.preventExtensions({}));
                });
            },
            {
                "../internals/fails": 51
            }
        ],
        54: [
            function(e1, t, r) {
                var s = e1("../internals/a-function");
                t.exports = function(o, n, e1) {
                    if (s(o), void 0 === n) return o;
                    switch(e1){
                        case 0:
                            return function() {
                                return o.call(n);
                            };
                        case 1:
                            return function(e1) {
                                return o.call(n, e1);
                            };
                        case 2:
                            return function(e1, t) {
                                return o.call(n, e1, t);
                            };
                        case 3:
                            return function(e1, t, r) {
                                return o.call(n, e1, t, r);
                            };
                    }
                    return function() {
                        return o.apply(n, arguments);
                    };
                };
            },
            {
                "../internals/a-function": 5
            }
        ],
        55: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/a-function"), n = e1("../internals/is-object"), c = [].slice, d = {};
                t.exports = Function.bind || function(i) {
                    var a = o(this), l = c.call(arguments, 1), u = function() {
                        var e1 = l.concat(c.call(arguments));
                        if (this instanceof u) {
                            var t = a, r = e1.length, o = e1;
                            if (!(r in d)) {
                                for(var n = [], s = 0; s < r; s++)n[s] = "a[" + s + "]";
                                d[r] = Function("C,a", "return new C(" + n.join(",") + ")");
                            }
                            return d[r](t, o);
                        }
                        return a.apply(i, e1);
                    };
                    return n(a.prototype) && (u.prototype = a.prototype), u;
                };
            },
            {
                "../internals/a-function": 5,
                "../internals/is-object": 74
            }
        ],
        56: [
            function(e1, t, r) {
                function o(e1) {
                    return "function" == typeof e1 ? e1 : void 0;
                }
                var n = e1("../internals/path"), s = e1("../internals/global");
                t.exports = function(e1, t) {
                    return arguments.length < 2 ? o(n[e1]) || o(s[e1]) : n[e1] && n[e1][t] || s[e1] && s[e1][t];
                };
            },
            {
                "../internals/global": 59,
                "../internals/path": 104
            }
        ],
        57: [
            function(e1, t, r) {
                var o = e1("../internals/classof"), n = e1("../internals/iterators"), s = e1("../internals/well-known-symbol")("iterator");
                t.exports = function(e1) {
                    if (null != e1) return e1[s] || e1["@@iterator"] || n[o(e1)];
                };
            },
            {
                "../internals/classof": 29,
                "../internals/iterators": 79,
                "../internals/well-known-symbol": 148
            }
        ],
        58: [
            function(e1, t, r) {
                var o = e1("../internals/an-object"), n = e1("../internals/get-iterator-method");
                t.exports = function(e1) {
                    var t = n(e1);
                    if ("function" != typeof t) throw TypeError(String(e1) + " is not iterable");
                    return o(t.call(e1));
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/get-iterator-method": 57
            }
        ],
        59: [
            function(e1, r, t) {
                (function(e1) {
                    function t(e1) {
                        return e1 && e1.Math == Math && e1;
                    }
                    r.exports = t("object" == typeof globalThis && globalThis) || t("object" == typeof window && window) || t("object" == typeof self && self) || t("object" == typeof e1 && e1) || Function("return this")();
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        60: [
            function(e1, t, r) {
                var o = {}.hasOwnProperty;
                t.exports = function(e1, t) {
                    return o.call(e1, t);
                };
            },
            {}
        ],
        61: [
            function(e1, t, r) {
                t.exports = {};
            },
            {}
        ],
        62: [
            function(e1, t, r) {
                var o = e1("../internals/global");
                t.exports = function(e1, t) {
                    var r = o.console;
                    r && r.error && (1 === arguments.length ? r.error(e1) : r.error(e1, t));
                };
            },
            {
                "../internals/global": 59
            }
        ],
        63: [
            function(e1, t, r) {
                e1 = e1("../internals/get-built-in");
                t.exports = e1("document", "documentElement");
            },
            {
                "../internals/get-built-in": 56
            }
        ],
        64: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), n = e1("../internals/fails"), s = e1("../internals/document-create-element");
                t.exports = !o && !n(function() {
                    return 7 != Object.defineProperty(s("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a;
                });
            },
            {
                "../internals/descriptors": 43,
                "../internals/document-create-element": 44,
                "../internals/fails": 51
            }
        ],
        65: [
            function(e1, t, r) {
                var h = Math.abs, f = Math.pow, p = Math.floor, m = Math.log, y = Math.LN2;
                t.exports = {
                    pack: function(e1, t, r) {
                        var o, n, s, i = new Array(r), a = 8 * r - t - 1, r = (1 << a) - 1, l = r >> 1, u = 23 === t ? f(2, -24) - f(2, -77) : 0, c = e1 < 0 || 0 === e1 && 1 / e1 < 0 ? 1 : 0, d = 0;
                        for((e1 = h(e1)) != e1 || e1 === 1 / 0 ? (n = e1 != e1 ? 1 : 0, o = r) : (o = p(m(e1) / y), e1 * (s = f(2, -o)) < 1 && (o--, s *= 2), 2 <= (e1 += 1 <= o + l ? u / s : u * f(2, 1 - l)) * s && (o++, s /= 2), r <= o + l ? (n = 0, o = r) : 1 <= o + l ? (n = (e1 * s - 1) * f(2, t), o += l) : (n = e1 * f(2, l - 1) * f(2, t), o = 0)); 8 <= t; i[d++] = 255 & n, n /= 256, t -= 8);
                        for(o = o << t | n, a += t; 0 < a; i[d++] = 255 & o, o /= 256, a -= 8);
                        return i[--d] |= 128 * c, i;
                    },
                    unpack: function(e1, t) {
                        var r, o = e1.length, n = 8 * o - t - 1, s = (1 << n) - 1, i = s >> 1, a = n - 7, l = o - 1, n = e1[l--], u = 127 & n;
                        for(n >>= 7; 0 < a; u = 256 * u + e1[l], l--, a -= 8);
                        for(r = u & (1 << -a) - 1, u >>= -a, a += t; 0 < a; r = 256 * r + e1[l], l--, a -= 8);
                        if (0 === u) u = 1 - i;
                        else {
                            if (u === s) return r ? NaN : n ? -1 / 0 : 1 / 0;
                            r += f(2, t), u -= i;
                        }
                        return (n ? -1 : 1) * r * f(2, u - t);
                    }
                };
            },
            {}
        ],
        66: [
            function(e1, t, r) {
                var o = e1("../internals/fails"), n = e1("../internals/classof-raw"), s = "".split;
                t.exports = o(function() {
                    return !Object("z").propertyIsEnumerable(0);
                }) ? function(e1) {
                    return "String" == n(e1) ? s.call(e1, "") : Object(e1);
                } : Object;
            },
            {
                "../internals/classof-raw": 28,
                "../internals/fails": 51
            }
        ],
        67: [
            function(e1, t, r) {
                var o = e1("../internals/is-object"), n = e1("../internals/object-set-prototype-of");
                t.exports = function(e1, t, r) {
                    return n && "function" == typeof (t = t.constructor) && t !== r && o(t = t.prototype) && t !== r.prototype && n(e1, t), e1;
                };
            },
            {
                "../internals/is-object": 74,
                "../internals/object-set-prototype-of": 101
            }
        ],
        68: [
            function(e1, t, r) {
                var e1 = e1("../internals/shared-store"), o = Function.toString;
                "function" != typeof e1.inspectSource && (e1.inspectSource = function(e1) {
                    return o.call(e1);
                }), t.exports = e1.inspectSource;
            },
            {
                "../internals/shared-store": 119
            }
        ],
        69: [
            function(e1, t, r) {
                function o(e1) {
                    a(e1, c, {
                        value: {
                            objectID: "O" + ++d,
                            weakData: {}
                        }
                    });
                }
                var n = e1("../internals/hidden-keys"), s = e1("../internals/is-object"), i = e1("../internals/has"), a = e1("../internals/object-define-property").f, l = e1("../internals/uid"), u = e1("../internals/freezing"), c = l("meta"), d = 0, h = Object.isExtensible || function() {
                    return !0;
                }, f = t.exports = {
                    REQUIRED: !1,
                    fastKey: function(e1, t) {
                        if (!s(e1)) return "symbol" == typeof e1 ? e1 : ("string" == typeof e1 ? "S" : "P") + e1;
                        if (!i(e1, c)) {
                            if (!h(e1)) return "F";
                            if (!t) return "E";
                            o(e1);
                        }
                        return e1[c].objectID;
                    },
                    getWeakData: function(e1, t) {
                        if (!i(e1, c)) {
                            if (!h(e1)) return !0;
                            if (!t) return !1;
                            o(e1);
                        }
                        return e1[c].weakData;
                    },
                    onFreeze: function(e1) {
                        return u && f.REQUIRED && h(e1) && !i(e1, c) && o(e1), e1;
                    }
                };
                n[c] = !0;
            },
            {
                "../internals/freezing": 53,
                "../internals/has": 60,
                "../internals/hidden-keys": 61,
                "../internals/is-object": 74,
                "../internals/object-define-property": 92,
                "../internals/uid": 145
            }
        ],
        70: [
            function(e1, t, r) {
                var o, n, s, i, a, l, u, c, d = e1("../internals/native-weak-map"), h = e1("../internals/global"), f = e1("../internals/is-object"), p = e1("../internals/create-non-enumerable-property"), m = e1("../internals/has"), y = e1("../internals/shared-key"), e1 = e1("../internals/hidden-keys"), h = h.WeakMap;
                u = d ? (o = new h, n = o.get, s = o.has, i = o.set, a = function(e1, t) {
                    return i.call(o, e1, t), t;
                }, l = function(e1) {
                    return n.call(o, e1) || {};
                }, function(e1) {
                    return s.call(o, e1);
                }) : (e1[c = y("state")] = !0, a = function(e1, t) {
                    return p(e1, c, t), t;
                }, l = function(e1) {
                    return m(e1, c) ? e1[c] : {};
                }, function(e1) {
                    return m(e1, c);
                }), t.exports = {
                    set: a,
                    get: l,
                    has: u,
                    enforce: function(e1) {
                        return u(e1) ? l(e1) : a(e1, {});
                    },
                    getterFor: function(t) {
                        return function(e1) {
                            if (f(e1) && (e1 = l(e1)).type === t) return e1;
                            throw TypeError("Incompatible receiver, " + t + " required");
                        };
                    }
                };
            },
            {
                "../internals/create-non-enumerable-property": 38,
                "../internals/global": 59,
                "../internals/has": 60,
                "../internals/hidden-keys": 61,
                "../internals/is-object": 74,
                "../internals/native-weak-map": 85,
                "../internals/shared-key": 118
            }
        ],
        71: [
            function(e1, t, r) {
                var o = e1("../internals/well-known-symbol"), n = e1("../internals/iterators"), s = o("iterator"), i = Array.prototype;
                t.exports = function(e1) {
                    return void 0 !== e1 && (n.Array === e1 || i[s] === e1);
                };
            },
            {
                "../internals/iterators": 79,
                "../internals/well-known-symbol": 148
            }
        ],
        72: [
            function(e1, t, r) {
                var o = e1("../internals/classof-raw");
                t.exports = Array.isArray || function(e1) {
                    return "Array" == o(e1);
                };
            },
            {
                "../internals/classof-raw": 28
            }
        ],
        73: [
            function(e1, t, r) {
                function o(e1, t) {
                    return (e1 = a[i(e1)]) == u || e1 != l && ("function" == typeof t ? n(t) : !!t);
                }
                var n = e1("../internals/fails"), s = /#|\.prototype\./, i = o.normalize = function(e1) {
                    return String(e1).replace(s, ".").toLowerCase();
                }, a = o.data = {}, l = o.NATIVE = "N", u = o.POLYFILL = "P";
                t.exports = o;
            },
            {
                "../internals/fails": 51
            }
        ],
        74: [
            function(e1, t, r) {
                t.exports = function(e1) {
                    return "object" == typeof e1 ? null !== e1 : "function" == typeof e1;
                };
            },
            {}
        ],
        75: [
            function(e1, t, r) {
                t.exports = !1;
            },
            {}
        ],
        76: [
            function(e1, t, r) {
                var o = e1("../internals/is-object"), n = e1("../internals/classof-raw"), s = e1("../internals/well-known-symbol")("match");
                t.exports = function(e1) {
                    var t;
                    return o(e1) && (void 0 !== (t = e1[s]) ? !!t : "RegExp" == n(e1));
                };
            },
            {
                "../internals/classof-raw": 28,
                "../internals/is-object": 74,
                "../internals/well-known-symbol": 148
            }
        ],
        77: [
            function(e1, t, r) {
                function h(e1, t) {
                    this.stopped = e1, this.result = t;
                }
                var f = e1("../internals/an-object"), p = e1("../internals/is-array-iterator-method"), m = e1("../internals/to-length"), y = e1("../internals/function-bind-context"), g = e1("../internals/get-iterator-method"), v = e1("../internals/call-with-safe-iteration-closing");
                (t.exports = function(e1, t, r, o, n) {
                    var s, i, a, l, u, c, d = y(t, r, o ? 2 : 1);
                    if (n) s = e1;
                    else {
                        if ("function" != typeof (t = g(e1))) throw TypeError("Target is not iterable");
                        if (p(t)) {
                            for(i = 0, a = m(e1.length); i < a; i++)if ((l = o ? d(f(c = e1[i])[0], c[1]) : d(e1[i])) && l instanceof h) return l;
                            return new h(!1);
                        }
                        s = t.call(e1);
                    }
                    for(u = s.next; !(c = u.call(s)).done;)if ("object" == typeof (l = v(s, d, c.value, o)) && l && l instanceof h) return l;
                    return new h(!1);
                }).stop = function(e1) {
                    return new h(!0, e1);
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/call-with-safe-iteration-closing": 26,
                "../internals/function-bind-context": 54,
                "../internals/get-iterator-method": 57,
                "../internals/is-array-iterator-method": 71,
                "../internals/to-length": 136
            }
        ],
        78: [
            function(e1, t, r) {
                "use strict";
                var o, n, s = e1("../internals/object-get-prototype-of"), i = e1("../internals/create-non-enumerable-property"), a = e1("../internals/has"), l = e1("../internals/well-known-symbol"), e1 = e1("../internals/is-pure"), l = l("iterator"), u = !1;
                [].keys && ("next" in (n = [].keys()) ? (s = s(s(n))) !== Object.prototype && (o = s) : u = !0), null == o && (o = {}), e1 || a(o, l) || i(o, l, function() {
                    return this;
                }), t.exports = {
                    IteratorPrototype: o,
                    BUGGY_SAFARI_ITERATORS: u
                };
            },
            {
                "../internals/create-non-enumerable-property": 38,
                "../internals/has": 60,
                "../internals/is-pure": 75,
                "../internals/object-get-prototype-of": 97,
                "../internals/well-known-symbol": 148
            }
        ],
        79: [
            function(e1, t, r) {
                t.exports = {};
            },
            {}
        ],
        80: [
            function(e1, t, r) {
                t.exports = Math.sign || function(e1) {
                    return 0 == (e1 = +e1) || e1 != e1 ? e1 : e1 < 0 ? -1 : 1;
                };
            },
            {}
        ],
        81: [
            function(e1, t, r) {
                var o, n, s, i, a, l, u, c, d = e1("../internals/global"), h = e1("../internals/object-get-own-property-descriptor").f, f = e1("../internals/classof-raw"), p = e1("../internals/task").set, e1 = e1("../internals/engine-is-ios"), m = d.MutationObserver || d.WebKitMutationObserver, y = d.process, g = d.Promise, v = "process" == f(y), f = h(d, "queueMicrotask"), h = f && f.value;
                h || (o = function() {
                    var e1, t;
                    for(v && (e1 = y.domain) && e1.exit(); n;){
                        t = n.fn, n = n.next;
                        try {
                            t();
                        } catch (e1) {
                            throw n ? i() : s = void 0, e1;
                        }
                    }
                    s = void 0, e1 && e1.enter();
                }, i = v ? function() {
                    y.nextTick(o);
                } : m && !e1 ? (a = !0, l = document.createTextNode(""), new m(o).observe(l, {
                    characterData: !0
                }), function() {
                    l.data = a = !a;
                }) : g && g.resolve ? (u = g.resolve(void 0), c = u.then, function() {
                    c.call(u, o);
                }) : function() {
                    p.call(d, o);
                }), t.exports = h || function(e1) {
                    e1 = {
                        fn: e1,
                        next: void 0
                    };
                    s && (s.next = e1), n || (n = e1, i()), s = e1;
                };
            },
            {
                "../internals/classof-raw": 28,
                "../internals/engine-is-ios": 46,
                "../internals/global": 59,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/task": 130
            }
        ],
        82: [
            function(e1, t, r) {
                e1 = e1("../internals/global");
                t.exports = e1.Promise;
            },
            {
                "../internals/global": 59
            }
        ],
        83: [
            function(e1, t, r) {
                e1 = e1("../internals/fails");
                t.exports = !!Object.getOwnPropertySymbols && !e1(function() {
                    return !String(Symbol());
                });
            },
            {
                "../internals/fails": 51
            }
        ],
        84: [
            function(e1, t, r) {
                var o = e1("../internals/fails"), n = e1("../internals/well-known-symbol"), s = e1("../internals/is-pure"), i = n("iterator");
                t.exports = !o(function() {
                    var e1 = new URL("b?a=1&b=2&c=3", "http://a"), r = e1.searchParams, o = "";
                    return e1.pathname = "c%20d", r.forEach(function(e1, t) {
                        r.delete("b"), o += t + e1;
                    }), s && !e1.toJSON || !r.sort || "http://a/c%20d?a=1&c=3" !== e1.href || "3" !== r.get("c") || "a=1" !== String(new URLSearchParams("?a=1")) || !r[i] || "a" !== new URL("https://a@b").username || "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") || "xn--e1aybc" !== new URL("http://\u0442\u0435\u0441\u0442").host || "#%D0%B1" !== new URL("http://a#\u0431").hash || "a1c3" !== o || "x" !== new URL("http://x", void 0).host;
                });
            },
            {
                "../internals/fails": 51,
                "../internals/is-pure": 75,
                "../internals/well-known-symbol": 148
            }
        ],
        85: [
            function(e1, t, r) {
                var o = e1("../internals/global"), e1 = e1("../internals/inspect-source"), o = o.WeakMap;
                t.exports = "function" == typeof o && /native code/.test(e1(o));
            },
            {
                "../internals/global": 59,
                "../internals/inspect-source": 68
            }
        ],
        86: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    var r, o;
                    this.promise = new e1(function(e1, t) {
                        if (void 0 !== r || void 0 !== o) throw TypeError("Bad Promise constructor");
                        r = e1, o = t;
                    }), this.resolve = n(r), this.reject = n(o);
                }
                var n = e1("../internals/a-function");
                t.exports.f = function(e1) {
                    return new o(e1);
                };
            },
            {
                "../internals/a-function": 5
            }
        ],
        87: [
            function(e1, t, r) {
                var o = e1("../internals/is-regexp");
                t.exports = function(e1) {
                    if (o(e1)) throw TypeError("The method doesn't accept regular expressions");
                    return e1;
                };
            },
            {
                "../internals/is-regexp": 76
            }
        ],
        88: [
            function(e1, t, r) {
                var o = e1("../internals/global").isFinite;
                t.exports = Number.isFinite || function(e1) {
                    return "number" == typeof e1 && o(e1);
                };
            },
            {
                "../internals/global": 59
            }
        ],
        89: [
            function(e1, t, r) {
                "use strict";
                var h = e1("../internals/descriptors"), o = e1("../internals/fails"), f = e1("../internals/object-keys"), p = e1("../internals/object-get-own-property-symbols"), m = e1("../internals/object-property-is-enumerable"), y = e1("../internals/to-object"), g = e1("../internals/indexed-object"), n = Object.assign, s = Object.defineProperty;
                t.exports = !n || o(function() {
                    var e1, t, r, o;
                    return !(!h || 1 === n({
                        b: 1
                    }, n(s({}, "a", {
                        enumerable: !0,
                        get: function() {
                            s(this, "b", {
                                value: 3,
                                enumerable: !1
                            });
                        }
                    }), {
                        b: 2
                    })).b) || (t = {}, o = "abcdefghijklmnopqrst", (e1 = {})[r = Symbol()] = 7, o.split("").forEach(function(e1) {
                        t[e1] = e1;
                    }), 7 != n({}, e1)[r] || f(n({}, t)).join("") != o);
                }) ? function(e1, t) {
                    for(var r = y(e1), o = arguments.length, n = 1, s = p.f, i = m.f; n < o;)for(var a, l = g(arguments[n++]), u = s ? f(l).concat(s(l)) : f(l), c = u.length, d = 0; d < c;)a = u[d++], h && !i.call(l, a) || (r[a] = l[a]);
                    return r;
                } : n;
            },
            {
                "../internals/descriptors": 43,
                "../internals/fails": 51,
                "../internals/indexed-object": 66,
                "../internals/object-get-own-property-symbols": 96,
                "../internals/object-keys": 99,
                "../internals/object-property-is-enumerable": 100,
                "../internals/to-object": 137
            }
        ],
        90: [
            function(e1, t, r) {
                function o() {}
                var n, s = e1("../internals/an-object"), i = e1("../internals/object-define-properties"), a = e1("../internals/enum-bug-keys"), l = e1("../internals/hidden-keys"), u = e1("../internals/html"), c = e1("../internals/document-create-element"), e1 = e1("../internals/shared-key"), d = "prototype", h = "script", f = e1("IE_PROTO"), p = function(e1) {
                    return "<" + h + ">" + e1 + "</" + h + ">";
                }, m = function() {
                    try {
                        n = document.domain && new ActiveXObject("htmlfile");
                    } catch (e1) {}
                    m = n ? ((e1 = n).write(p("")), e1.close(), t = e1.parentWindow.Object, e1 = null, t) : (e1 = c("iframe"), t = "java" + h + ":", e1.style.display = "none", u.appendChild(e1), e1.src = String(t), (t = e1.contentWindow.document).open(), t.write(p("document.F=Object")), t.close(), t.F);
                    for(var e2, t, r = a.length; r--;)delete m[d][a[r]];
                    return m();
                };
                l[f] = !0, t.exports = Object.create || function(e1, t) {
                    var r;
                    return null !== e1 ? (o[d] = s(e1), r = new o, o[d] = null, r[f] = e1) : r = m(), void 0 === t ? r : i(r, t);
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/document-create-element": 44,
                "../internals/enum-bug-keys": 49,
                "../internals/hidden-keys": 61,
                "../internals/html": 63,
                "../internals/object-define-properties": 91,
                "../internals/shared-key": 118
            }
        ],
        91: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), i = e1("../internals/object-define-property"), a = e1("../internals/an-object"), l = e1("../internals/object-keys");
                t.exports = o ? Object.defineProperties : function(e1, t) {
                    a(e1);
                    for(var r, o = l(t), n = o.length, s = 0; s < n;)i.f(e1, r = o[s++], t[r]);
                    return e1;
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/descriptors": 43,
                "../internals/object-define-property": 92,
                "../internals/object-keys": 99
            }
        ],
        92: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), n = e1("../internals/ie8-dom-define"), s = e1("../internals/an-object"), i = e1("../internals/to-primitive"), a = Object.defineProperty;
                r.f = o ? a : function(e1, t, r) {
                    if (s(e1), t = i(t, !0), s(r), n) try {
                        return a(e1, t, r);
                    } catch (e1) {}
                    if ("get" in r || "set" in r) throw TypeError("Accessors not supported");
                    return "value" in r && (e1[t] = r.value), e1;
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/descriptors": 43,
                "../internals/ie8-dom-define": 64,
                "../internals/to-primitive": 140
            }
        ],
        93: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), n = e1("../internals/object-property-is-enumerable"), s = e1("../internals/create-property-descriptor"), i = e1("../internals/to-indexed-object"), a = e1("../internals/to-primitive"), l = e1("../internals/has"), u = e1("../internals/ie8-dom-define"), c = Object.getOwnPropertyDescriptor;
                r.f = o ? c : function(e1, t) {
                    if (e1 = i(e1), t = a(t, !0), u) try {
                        return c(e1, t);
                    } catch (e1) {}
                    if (l(e1, t)) return s(!n.f.call(e1, t), e1[t]);
                };
            },
            {
                "../internals/create-property-descriptor": 39,
                "../internals/descriptors": 43,
                "../internals/has": 60,
                "../internals/ie8-dom-define": 64,
                "../internals/object-property-is-enumerable": 100,
                "../internals/to-indexed-object": 134,
                "../internals/to-primitive": 140
            }
        ],
        94: [
            function(e1, t, r) {
                var o = e1("../internals/to-indexed-object"), n = e1("../internals/object-get-own-property-names").f, s = {}.toString, i = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                t.exports.f = function(e1) {
                    if (!i || "[object Window]" != s.call(e1)) return n(o(e1));
                    try {
                        return n(e1);
                    } catch (e1) {
                        return i.slice();
                    }
                };
            },
            {
                "../internals/object-get-own-property-names": 95,
                "../internals/to-indexed-object": 134
            }
        ],
        95: [
            function(e1, t, r) {
                var o = e1("../internals/object-keys-internal"), n = e1("../internals/enum-bug-keys").concat("length", "prototype");
                r.f = Object.getOwnPropertyNames || function(e1) {
                    return o(e1, n);
                };
            },
            {
                "../internals/enum-bug-keys": 49,
                "../internals/object-keys-internal": 98
            }
        ],
        96: [
            function(e1, t, r) {
                r.f = Object.getOwnPropertySymbols;
            },
            {}
        ],
        97: [
            function(e1, t, r) {
                var o = e1("../internals/has"), n = e1("../internals/to-object"), s = e1("../internals/shared-key"), e1 = e1("../internals/correct-prototype-getter"), i = s("IE_PROTO"), a = Object.prototype;
                t.exports = e1 ? Object.getPrototypeOf : function(e1) {
                    return e1 = n(e1), o(e1, i) ? e1[i] : "function" == typeof e1.constructor && e1 instanceof e1.constructor ? e1.constructor.prototype : e1 instanceof Object ? a : null;
                };
            },
            {
                "../internals/correct-prototype-getter": 35,
                "../internals/has": 60,
                "../internals/shared-key": 118,
                "../internals/to-object": 137
            }
        ],
        98: [
            function(e1, t, r) {
                var i = e1("../internals/has"), a = e1("../internals/to-indexed-object"), l = e1("../internals/array-includes").indexOf, u = e1("../internals/hidden-keys");
                t.exports = function(e1, t) {
                    var r, o = a(e1), n = 0, s = [];
                    for(r in o)!i(u, r) && i(o, r) && s.push(r);
                    for(; t.length > n;)!i(o, r = t[n++]) || ~l(s, r) || s.push(r);
                    return s;
                };
            },
            {
                "../internals/array-includes": 18,
                "../internals/has": 60,
                "../internals/hidden-keys": 61,
                "../internals/to-indexed-object": 134
            }
        ],
        99: [
            function(e1, t, r) {
                var o = e1("../internals/object-keys-internal"), n = e1("../internals/enum-bug-keys");
                t.exports = Object.keys || function(e1) {
                    return o(e1, n);
                };
            },
            {
                "../internals/enum-bug-keys": 49,
                "../internals/object-keys-internal": 98
            }
        ],
        100: [
            function(e1, t, r) {
                "use strict";
                var o = {}.propertyIsEnumerable, n = Object.getOwnPropertyDescriptor, s = n && !o.call({
                    1: 2
                }, 1);
                r.f = s ? function(e1) {
                    e1 = n(this, e1);
                    return !!e1 && e1.enumerable;
                } : o;
            },
            {}
        ],
        101: [
            function(e1, t, r) {
                var n = e1("../internals/an-object"), s = e1("../internals/a-possible-prototype");
                t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                    var r, o = !1, e1 = {};
                    try {
                        (r = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(e1, []), o = e1 instanceof Array;
                    } catch (e1) {}
                    return function(e1, t) {
                        return n(e1), s(t), o ? r.call(e1, t) : e1.__proto__ = t, e1;
                    };
                }() : void 0);
            },
            {
                "../internals/a-possible-prototype": 6,
                "../internals/an-object": 10
            }
        ],
        102: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/to-string-tag-support"), n = e1("../internals/classof");
                t.exports = o ? ({}).toString : function() {
                    return "[object " + n(this) + "]";
                };
            },
            {
                "../internals/classof": 29,
                "../internals/to-string-tag-support": 141
            }
        ],
        103: [
            function(e1, t, r) {
                var o = e1("../internals/get-built-in"), n = e1("../internals/object-get-own-property-names"), s = e1("../internals/object-get-own-property-symbols"), i = e1("../internals/an-object");
                t.exports = o("Reflect", "ownKeys") || function(e1) {
                    var t = n.f(i(e1)), r = s.f;
                    return r ? t.concat(r(e1)) : t;
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/get-built-in": 56,
                "../internals/object-get-own-property-names": 95,
                "../internals/object-get-own-property-symbols": 96
            }
        ],
        104: [
            function(e1, t, r) {
                e1 = e1("../internals/global");
                t.exports = e1;
            },
            {
                "../internals/global": 59
            }
        ],
        105: [
            function(e1, t, r) {
                t.exports = function(e1) {
                    try {
                        return {
                            error: !1,
                            value: e1()
                        };
                    } catch (e1) {
                        return {
                            error: !0,
                            value: e1
                        };
                    }
                };
            },
            {}
        ],
        106: [
            function(e1, t, r) {
                var o = e1("../internals/an-object"), n = e1("../internals/is-object"), s = e1("../internals/new-promise-capability");
                t.exports = function(e1, t) {
                    return o(e1), n(t) && t.constructor === e1 ? t : ((0, (e1 = s.f(e1)).resolve)(t), e1.promise);
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/is-object": 74,
                "../internals/new-promise-capability": 86
            }
        ],
        107: [
            function(e1, t, r) {
                var n = e1("../internals/redefine");
                t.exports = function(e1, t, r) {
                    for(var o in t)n(e1, o, t[o], r);
                    return e1;
                };
            },
            {
                "../internals/redefine": 108
            }
        ],
        108: [
            function(e1, t, r) {
                var i = e1("../internals/global"), a = e1("../internals/create-non-enumerable-property"), l = e1("../internals/has"), u = e1("../internals/set-global"), o = e1("../internals/inspect-source"), e1 = e1("../internals/internal-state"), n = e1.get, c = e1.enforce, d = String(String).split("String");
                (t.exports = function(e1, t, r, o) {
                    var n = !!o && !!o.unsafe, s = !!o && !!o.enumerable, o = !!o && !!o.noTargetGet;
                    "function" == typeof r && ("string" != typeof t || l(r, "name") || a(r, "name", t), c(r).source = d.join("string" == typeof t ? t : "")), e1 === i ? s ? e1[t] = r : u(t, r) : (n ? !o && e1[t] && (s = !0) : delete e1[t], s ? e1[t] = r : a(e1, t, r));
                })(Function.prototype, "toString", function() {
                    return "function" == typeof this && n(this).source || o(this);
                });
            },
            {
                "../internals/create-non-enumerable-property": 38,
                "../internals/global": 59,
                "../internals/has": 60,
                "../internals/inspect-source": 68,
                "../internals/internal-state": 70,
                "../internals/set-global": 115
            }
        ],
        109: [
            function(e1, t, r) {
                var o = e1("./classof-raw"), n = e1("./regexp-exec");
                t.exports = function(e1, t) {
                    var r = e1.exec;
                    if ("function" == typeof r) {
                        r = r.call(e1, t);
                        if ("object" != typeof r) throw TypeError("RegExp exec method returned something other than an Object or null");
                        return r;
                    }
                    if ("RegExp" !== o(e1)) throw TypeError("RegExp#exec called on incompatible receiver");
                    return n.call(e1, t);
                };
            },
            {
                "./classof-raw": 28,
                "./regexp-exec": 110
            }
        ],
        110: [
            function(e1, t, r) {
                "use strict";
                var o, n, d = e1("./regexp-flags"), e1 = e1("./regexp-sticky-helpers"), h = RegExp.prototype.exec, f = String.prototype.replace, s = h, p = (o = /a/, n = /b*/g, h.call(o, "a"), h.call(n, "a"), 0 !== o.lastIndex || 0 !== n.lastIndex), m = e1.UNSUPPORTED_Y || e1.BROKEN_CARET, y = void 0 !== /()??/.exec("")[1];
                t.exports = s = p || y || m ? function(e1) {
                    var t, r, o, n, s = this, i = m && s.sticky, a = d.call(s), l = s.source, u = 0, c = e1;
                    return i && (-1 === (a = a.replace("y", "")).indexOf("g") && (a += "g"), c = String(e1).slice(s.lastIndex), 0 < s.lastIndex && (!s.multiline || s.multiline && "\n" !== e1[s.lastIndex - 1]) && (l = "(?: " + l + ")", c = " " + c, u++), r = new RegExp("^(?:" + l + ")", a)), y && (r = new RegExp("^" + l + "$(?!\\s)", a)), p && (t = s.lastIndex), o = h.call(i ? r : s, c), i ? o ? (o.input = o.input.slice(u), o[0] = o[0].slice(u), o.index = s.lastIndex, s.lastIndex += o[0].length) : s.lastIndex = 0 : p && o && (s.lastIndex = s.global ? o.index + o[0].length : t), y && o && 1 < o.length && f.call(o[0], r, function() {
                        for(n = 1; n < arguments.length - 2; n++)void 0 === arguments[n] && (o[n] = void 0);
                    }), o;
                } : s;
            },
            {
                "./regexp-flags": 111,
                "./regexp-sticky-helpers": 112
            }
        ],
        111: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/an-object");
                t.exports = function() {
                    var e1 = o(this), t = "";
                    return e1.global && (t += "g"), e1.ignoreCase && (t += "i"), e1.multiline && (t += "m"), e1.dotAll && (t += "s"), e1.unicode && (t += "u"), e1.sticky && (t += "y"), t;
                };
            },
            {
                "../internals/an-object": 10
            }
        ],
        112: [
            function(e1, t, r) {
                "use strict";
                e1 = e1("./fails");
                function o(e1, t) {
                    return RegExp(e1, t);
                }
                r.UNSUPPORTED_Y = e1(function() {
                    var e1 = o("a", "y");
                    return e1.lastIndex = 2, null != e1.exec("abcd");
                }), r.BROKEN_CARET = e1(function() {
                    var e1 = o("^r", "gy");
                    return e1.lastIndex = 2, null != e1.exec("str");
                });
            },
            {
                "./fails": 51
            }
        ],
        113: [
            function(e1, t, r) {
                t.exports = function(e1) {
                    if (null == e1) throw TypeError("Can't call method on " + e1);
                    return e1;
                };
            },
            {}
        ],
        114: [
            function(e1, t, r) {
                t.exports = Object.is || function(e1, t) {
                    return e1 === t ? 0 !== e1 || 1 / e1 == 1 / t : e1 != e1 && t != t;
                };
            },
            {}
        ],
        115: [
            function(e1, t, r) {
                var o = e1("../internals/global"), n = e1("../internals/create-non-enumerable-property");
                t.exports = function(t, r) {
                    try {
                        n(o, t, r);
                    } catch (e1) {
                        o[t] = r;
                    }
                    return r;
                };
            },
            {
                "../internals/create-non-enumerable-property": 38,
                "../internals/global": 59
            }
        ],
        116: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/get-built-in"), n = e1("../internals/object-define-property"), s = e1("../internals/well-known-symbol"), i = e1("../internals/descriptors"), a = s("species");
                t.exports = function(e1) {
                    var e1 = o(e1), t = n.f;
                    i && e1 && !e1[a] && t(e1, a, {
                        configurable: !0,
                        get: function() {
                            return this;
                        }
                    });
                };
            },
            {
                "../internals/descriptors": 43,
                "../internals/get-built-in": 56,
                "../internals/object-define-property": 92,
                "../internals/well-known-symbol": 148
            }
        ],
        117: [
            function(e1, t, r) {
                var o = e1("../internals/object-define-property").f, n = e1("../internals/has"), s = e1("../internals/well-known-symbol")("toStringTag");
                t.exports = function(e1, t, r) {
                    e1 && !n(e1 = r ? e1 : e1.prototype, s) && o(e1, s, {
                        configurable: !0,
                        value: t
                    });
                };
            },
            {
                "../internals/has": 60,
                "../internals/object-define-property": 92,
                "../internals/well-known-symbol": 148
            }
        ],
        118: [
            function(e1, t, r) {
                var o = e1("../internals/shared"), n = e1("../internals/uid"), s = o("keys");
                t.exports = function(e1) {
                    return s[e1] || (s[e1] = n(e1));
                };
            },
            {
                "../internals/shared": 120,
                "../internals/uid": 145
            }
        ],
        119: [
            function(e1, t, r) {
                var o = e1("../internals/global"), e1 = e1("../internals/set-global"), n = "__core-js_shared__", o = o[n] || e1(n, {});
                t.exports = o;
            },
            {
                "../internals/global": 59,
                "../internals/set-global": 115
            }
        ],
        120: [
            function(e1, t, r) {
                var o = e1("../internals/is-pure"), n = e1("../internals/shared-store");
                (t.exports = function(e1, t) {
                    return n[e1] || (n[e1] = void 0 !== t ? t : {});
                })("versions", []).push({
                    version: "3.6.5",
                    mode: o ? "pure" : "global",
                    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
                });
            },
            {
                "../internals/is-pure": 75,
                "../internals/shared-store": 119
            }
        ],
        121: [
            function(e1, t, r) {
                var o = e1("../internals/an-object"), n = e1("../internals/a-function"), s = e1("../internals/well-known-symbol")("species");
                t.exports = function(e1, t) {
                    var e1 = o(e1).constructor;
                    return void 0 === e1 || null == (e1 = o(e1)[s]) ? t : n(e1);
                };
            },
            {
                "../internals/a-function": 5,
                "../internals/an-object": 10,
                "../internals/well-known-symbol": 148
            }
        ],
        122: [
            function(e1, t, r) {
                var o = e1("../internals/fails");
                t.exports = function(t) {
                    return o(function() {
                        var e1 = ""[t]('"');
                        return e1 !== e1.toLowerCase() || 3 < e1.split('"').length;
                    });
                };
            },
            {
                "../internals/fails": 51
            }
        ],
        123: [
            function(e1, t, r) {
                function o(n) {
                    return function(e1, t) {
                        var r, e1 = String(i(e1)), t = s(t), o = e1.length;
                        return t < 0 || o <= t ? n ? "" : void 0 : (r = e1.charCodeAt(t)) < 55296 || 56319 < r || t + 1 === o || (o = e1.charCodeAt(t + 1)) < 56320 || 57343 < o ? n ? e1.charAt(t) : r : n ? e1.slice(t, t + 2) : o - 56320 + (r - 55296 << 10) + 65536;
                    };
                }
                var s = e1("../internals/to-integer"), i = e1("../internals/require-object-coercible");
                t.exports = {
                    codeAt: o(!1),
                    charAt: o(!0)
                };
            },
            {
                "../internals/require-object-coercible": 113,
                "../internals/to-integer": 135
            }
        ],
        124: [
            function(e1, t, r) {
                e1 = e1("../internals/engine-user-agent");
                t.exports = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(e1);
            },
            {
                "../internals/engine-user-agent": 47
            }
        ],
        125: [
            function(e1, t, r) {
                function o(n) {
                    return function(e1, t, r) {
                        var e1 = String(a(e1)), o = e1.length, r = void 0 === r ? " " : String(r), t = s(t);
                        return t <= o || "" == r ? e1 : ((o = i.call(r, l((t = t - o) / r.length))).length > t && (o = o.slice(0, t)), n ? e1 + o : o + e1);
                    };
                }
                var s = e1("../internals/to-length"), i = e1("../internals/string-repeat"), a = e1("../internals/require-object-coercible"), l = Math.ceil;
                t.exports = {
                    start: o(!1),
                    end: o(!0)
                };
            },
            {
                "../internals/require-object-coercible": 113,
                "../internals/string-repeat": 127,
                "../internals/to-length": 136
            }
        ],
        126: [
            function(e1, t, r) {
                "use strict";
                function g(e1) {
                    return e1 + 22 + 75 * (e1 < 26);
                }
                function s(e1) {
                    var t, r = [], o = (e1 = function(e1) {
                        for(var t = [], r = 0, o = e1.length; r < o;){
                            var n, s = e1.charCodeAt(r++);
                            55296 <= s && s <= 56319 && r < o ? 56320 == (64512 & (n = e1.charCodeAt(r++))) ? t.push(((1023 & s) << 10) + (1023 & n) + 65536) : (t.push(s), r--) : t.push(s);
                        }
                        return t;
                    }(e1)).length, n = 128, s = 0, i = 72;
                    for(c = 0; c < e1.length; c++)(t = e1[c]) < 128 && r.push(M(t));
                    var a = r.length, l = a;
                    for(a && r.push("-"); l < o;){
                        for(var u = v, c = 0; c < e1.length; c++)n <= (t = e1[c]) && t < u && (u = t);
                        var d = l + 1;
                        if (u - n > T((v - s) / d)) throw RangeError(w);
                        for(s += (u - n) * d, n = u, c = 0; c < e1.length; c++){
                            if ((t = e1[c]) < n && ++s > v) throw RangeError(w);
                            if (t == n) {
                                for(var h = s, f = b;; f += b){
                                    var p = f <= i ? 1 : i + j <= f ? j : f - i;
                                    if (h < p) break;
                                    var m = h - p, y = b - p;
                                    r.push(M(g(p + m % y))), h = T(m / y);
                                }
                                r.push(M(g(h))), i = function(e1, t, r) {
                                    var o = 0;
                                    for(e1 = r ? T(e1 / x) : e1 >> 1, e1 += T(e1 / t); S * j >> 1 < e1; o += b)e1 = T(e1 / S);
                                    return T(o + (S + 1) * e1 / (e1 + _));
                                }(s, d, l == a), s = 0, ++l;
                            }
                        }
                        ++s, ++n;
                    }
                    return r.join("");
                }
                var v = 2147483647, b = 36, j = 26, _ = 38, x = 700, i = /[^\0-\u007E]/, a = /[.\u3002\uFF0E\uFF61]/g, w = "Overflow: input needs wider integers to process", S = b - 1, T = Math.floor, M = String.fromCharCode;
                t.exports = function(e1) {
                    for(var t, r = [], o = e1.toLowerCase().replace(a, ".").split("."), n = 0; n < o.length; n++)t = o[n], r.push(i.test(t) ? "xn--" + s(t) : t);
                    return r.join(".");
                };
            },
            {}
        ],
        127: [
            function(e1, t, r) {
                "use strict";
                var n = e1("../internals/to-integer"), s = e1("../internals/require-object-coercible");
                t.exports = "".repeat || function(e1) {
                    var t = String(s(this)), r = "", o = n(e1);
                    if (o < 0 || o == 1 / 0) throw RangeError("Wrong number of repetitions");
                    for(; 0 < o; (o >>>= 1) && (t += t))1 & o && (r += t);
                    return r;
                };
            },
            {
                "../internals/require-object-coercible": 113,
                "../internals/to-integer": 135
            }
        ],
        128: [
            function(e1, t, r) {
                var o = e1("../internals/fails"), n = e1("../internals/whitespaces");
                t.exports = function(e1) {
                    return o(function() {
                        return !!n[e1]() || "\u200B\x85\u180E" != "\u200B\x85\u180E"[e1]() || n[e1].name !== e1;
                    });
                };
            },
            {
                "../internals/fails": 51,
                "../internals/whitespaces": 149
            }
        ],
        129: [
            function(e1, t, r) {
                function o(t) {
                    return function(e1) {
                        e1 = String(n(e1));
                        return 1 & t && (e1 = e1.replace(s, "")), e1 = 2 & t ? e1.replace(i, "") : e1;
                    };
                }
                var n = e1("../internals/require-object-coercible"), e1 = "[" + e1("../internals/whitespaces") + "]", s = RegExp("^" + e1 + e1 + "*"), i = RegExp(e1 + e1 + "*$");
                t.exports = {
                    start: o(1),
                    end: o(2),
                    trim: o(3)
                };
            },
            {
                "../internals/require-object-coercible": 113,
                "../internals/whitespaces": 149
            }
        ],
        130: [
            function(e1, t, r) {
                function o(e1) {
                    return function() {
                        x(e1);
                    };
                }
                function n(e1) {
                    x(e1.data);
                }
                function s(e1) {
                    a.postMessage(e1 + "", f.protocol + "//" + f.host);
                }
                var i, a = e1("../internals/global"), l = e1("../internals/fails"), u = e1("../internals/classof-raw"), c = e1("../internals/function-bind-context"), d = e1("../internals/html"), h = e1("../internals/document-create-element"), e1 = e1("../internals/engine-is-ios"), f = a.location, p = a.setImmediate, m = a.clearImmediate, y = a.process, g = a.MessageChannel, v = a.Dispatch, b = 0, j = {}, _ = "onreadystatechange", x = function(e1) {
                    var t;
                    j.hasOwnProperty(e1) && (t = j[e1], delete j[e1], t());
                };
                p && m || (p = function(e1) {
                    for(var t = [], r = 1; r < arguments.length;)t.push(arguments[r++]);
                    return j[++b] = function() {
                        ("function" == typeof e1 ? e1 : Function(e1)).apply(void 0, t);
                    }, i(b), b;
                }, m = function(e1) {
                    delete j[e1];
                }, "process" == u(y) ? i = function(e1) {
                    y.nextTick(o(e1));
                } : v && v.now ? i = function(e1) {
                    v.now(o(e1));
                } : g && !e1 ? (e1 = (u = new g).port2, u.port1.onmessage = n, i = c(e1.postMessage, e1, 1)) : !a.addEventListener || "function" != typeof postMessage || a.importScripts || l(s) || "file:" === f.protocol ? i = _ in h("script") ? function(e1) {
                    d.appendChild(h("script"))[_] = function() {
                        d.removeChild(this), x(e1);
                    };
                } : function(e1) {
                    setTimeout(o(e1), 0);
                } : (i = s, a.addEventListener("message", n, !1))), t.exports = {
                    set: p,
                    clear: m
                };
            },
            {
                "../internals/classof-raw": 28,
                "../internals/document-create-element": 44,
                "../internals/engine-is-ios": 46,
                "../internals/fails": 51,
                "../internals/function-bind-context": 54,
                "../internals/global": 59,
                "../internals/html": 63
            }
        ],
        131: [
            function(e1, t, r) {
                var o = e1("../internals/classof-raw");
                t.exports = function(e1) {
                    if ("number" != typeof e1 && "Number" != o(e1)) throw TypeError("Incorrect invocation");
                    return +e1;
                };
            },
            {
                "../internals/classof-raw": 28
            }
        ],
        132: [
            function(e1, t, r) {
                var o = e1("../internals/to-integer"), n = Math.max, s = Math.min;
                t.exports = function(e1, t) {
                    e1 = o(e1);
                    return e1 < 0 ? n(e1 + t, 0) : s(e1, t);
                };
            },
            {
                "../internals/to-integer": 135
            }
        ],
        133: [
            function(e1, t, r) {
                var o = e1("../internals/to-integer"), n = e1("../internals/to-length");
                t.exports = function(e1) {
                    if (void 0 === e1) return 0;
                    var e1 = o(e1), t = n(e1);
                    if (e1 !== t) throw RangeError("Wrong length or index");
                    return t;
                };
            },
            {
                "../internals/to-integer": 135,
                "../internals/to-length": 136
            }
        ],
        134: [
            function(e1, t, r) {
                var o = e1("../internals/indexed-object"), n = e1("../internals/require-object-coercible");
                t.exports = function(e1) {
                    return o(n(e1));
                };
            },
            {
                "../internals/indexed-object": 66,
                "../internals/require-object-coercible": 113
            }
        ],
        135: [
            function(e1, t, r) {
                var o = Math.ceil, n = Math.floor;
                t.exports = function(e1) {
                    return isNaN(e1 = +e1) ? 0 : (0 < e1 ? n : o)(e1);
                };
            },
            {}
        ],
        136: [
            function(e1, t, r) {
                var o = e1("../internals/to-integer"), n = Math.min;
                t.exports = function(e1) {
                    return 0 < e1 ? n(o(e1), 9007199254740991) : 0;
                };
            },
            {
                "../internals/to-integer": 135
            }
        ],
        137: [
            function(e1, t, r) {
                var o = e1("../internals/require-object-coercible");
                t.exports = function(e1) {
                    return Object(o(e1));
                };
            },
            {
                "../internals/require-object-coercible": 113
            }
        ],
        138: [
            function(e1, t, r) {
                var o = e1("../internals/to-positive-integer");
                t.exports = function(e1, t) {
                    e1 = o(e1);
                    if (e1 % t) throw RangeError("Wrong offset");
                    return e1;
                };
            },
            {
                "../internals/to-positive-integer": 139
            }
        ],
        139: [
            function(e1, t, r) {
                var o = e1("../internals/to-integer");
                t.exports = function(e1) {
                    e1 = o(e1);
                    if (e1 < 0) throw RangeError("The argument can't be less than 0");
                    return e1;
                };
            },
            {
                "../internals/to-integer": 135
            }
        ],
        140: [
            function(e1, t, r) {
                var n = e1("../internals/is-object");
                t.exports = function(e1, t) {
                    if (!n(e1)) return e1;
                    var r, o;
                    if (t && "function" == typeof (r = e1.toString) && !n(o = r.call(e1)) || "function" == typeof (r = e1.valueOf) && !n(o = r.call(e1)) || !t && "function" == typeof (r = e1.toString) && !n(o = r.call(e1))) return o;
                    throw TypeError("Can't convert object to primitive value");
                };
            },
            {
                "../internals/is-object": 74
            }
        ],
        141: [
            function(e1, t, r) {
                var o = {};
                o[e1("../internals/well-known-symbol")("toStringTag")] = "z", t.exports = "[object z]" === String(o);
            },
            {
                "../internals/well-known-symbol": 148
            }
        ],
        142: [
            function(e1, t, D) {
                "use strict";
                function f(e1, t) {
                    for(var r = 0, o = t.length, n = new (Q(e1))(o); r < o;)n[r] = t[r++];
                    return n;
                }
                function r(e1, t) {
                    M(e1, t, {
                        get: function() {
                            return T(this)[t];
                        }
                    });
                }
                function p(e1) {
                    return e1 instanceof k || "ArrayBuffer" == (e1 = B(e1)) || "SharedArrayBuffer" == e1;
                }
                function o(e1, t) {
                    return L(e1) && "symbol" != typeof t && t in e1 && String(+t) == String(t);
                }
                function n(e1, t) {
                    return o(e1, t = d(t, !0)) ? U(2, e1[t]) : X(e1, t);
                }
                function s(e1, t, r) {
                    return !(o(e1, t = d(t, !0)) && b(r) && h(r, "value")) || h(r, "get") || h(r, "set") || r.configurable || h(r, "writable") && !r.writable || h(r, "enumerable") && !r.enumerable ? M(e1, t, r) : (e1[t] = r.value, e1);
                }
                var a = e1("../internals/export"), l = e1("../internals/global"), i = e1("../internals/descriptors"), F = e1("../internals/typed-array-constructors-require-wrappers"), u = e1("../internals/array-buffer-view-core"), c = e1("../internals/array-buffer"), m = e1("../internals/an-instance"), U = e1("../internals/create-property-descriptor"), y = e1("../internals/create-non-enumerable-property"), N = e1("../internals/to-length"), g = e1("../internals/to-index"), v = e1("../internals/to-offset"), d = e1("../internals/to-primitive"), h = e1("../internals/has"), B = e1("../internals/classof"), b = e1("../internals/is-object"), G = e1("../internals/object-create"), j = e1("../internals/object-set-prototype-of"), V = e1("../internals/object-get-own-property-names").f, _ = e1("../internals/typed-array-from"), z = e1("../internals/array-iteration").forEach, H = e1("../internals/set-species"), x = e1("../internals/object-define-property"), w = e1("../internals/object-get-own-property-descriptor"), S = e1("../internals/internal-state"), W = e1("../internals/inherit-if-required"), T = S.get, q = S.set, M = x.f, X = w.f, Y = Math.round, E = l.RangeError, k = c.ArrayBuffer, Z = c.DataView, C = u.NATIVE_ARRAY_BUFFER_VIEWS, O = u.TYPED_ARRAY_TAG, P = u.TypedArray, A = u.TypedArrayPrototype, Q = u.aTypedArrayConstructor, L = u.isTypedArray, R = "BYTES_PER_ELEMENT", I = "Wrong length";
                i ? (C || (w.f = n, x.f = s, r(A, "buffer"), r(A, "byteOffset"), r(A, "byteLength"), r(A, "length")), a({
                    target: "Object",
                    stat: !0,
                    forced: !C
                }, {
                    getOwnPropertyDescriptor: n,
                    defineProperty: s
                }), t.exports = function(e1, t, n) {
                    function u(e1, o) {
                        M(e1, o, {
                            get: function() {
                                var e1 = this, t = o;
                                return (e1 = T(e1)).view[r](t * c + e1.byteOffset, !0);
                            },
                            set: function(e1) {
                                var t = this, r = o;
                                t = T(t), n && (e1 = (e1 = Y(e1)) < 0 ? 0 : 255 < e1 ? 255 : 255 & e1), t.view[s](r * c + t.byteOffset, e1, !0);
                            },
                            enumerable: !0
                        });
                    }
                    var c = e1.match(/\d+$/)[0] / 8, d = e1 + (n ? "Clamped" : "") + "Array", r = "get" + e1, s = "set" + e1, i = l[d], h = i, e1 = h && h.prototype, o = {};
                    C ? F && (h = t(function(e1, t, r, o) {
                        return m(e1, h, d), W(b(t) ? p(t) ? void 0 !== o ? new i(t, v(r, c), o) : void 0 !== r ? new i(t, v(r, c)) : new i(t) : L(t) ? f(h, t) : _.call(h, t) : new i(g(t)), e1, h);
                    }), j && j(h, P), z(V(i), function(e1) {
                        e1 in h || y(h, e1, i[e1]);
                    }), h.prototype = e1) : (h = t(function(e1, t, r, o) {
                        m(e1, h, d);
                        var n, s, i = 0, a = 0;
                        if (b(t)) {
                            if (!p(t)) return L(t) ? f(h, t) : _.call(h, t);
                            var l = t, a = v(r, c), r = t.byteLength;
                            if (void 0 === o) {
                                if (r % c) throw E(I);
                                if ((n = r - a) < 0) throw E(I);
                            } else if (r < (n = N(o) * c) + a) throw E(I);
                            s = n / c;
                        } else s = g(t), l = new k(n = s * c);
                        for(q(e1, {
                            buffer: l,
                            byteOffset: a,
                            byteLength: n,
                            length: s,
                            view: new Z(l)
                        }); i < s;)u(e1, i++);
                    }), j && j(h, P), e1 = h.prototype = G(A)), e1.constructor !== h && y(e1, "constructor", h), O && y(e1, O, d), o[d] = h, a({
                        global: !0,
                        forced: h != i,
                        sham: !C
                    }, o), R in h || y(h, R, c), R in e1 || y(e1, R, c), H(d);
                }) : t.exports = function() {};
            },
            {
                "../internals/an-instance": 9,
                "../internals/array-buffer": 13,
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19,
                "../internals/classof": 29,
                "../internals/create-non-enumerable-property": 38,
                "../internals/create-property-descriptor": 39,
                "../internals/descriptors": 43,
                "../internals/export": 50,
                "../internals/global": 59,
                "../internals/has": 60,
                "../internals/inherit-if-required": 67,
                "../internals/internal-state": 70,
                "../internals/is-object": 74,
                "../internals/object-create": 90,
                "../internals/object-define-property": 92,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/object-get-own-property-names": 95,
                "../internals/object-set-prototype-of": 101,
                "../internals/set-species": 116,
                "../internals/to-index": 133,
                "../internals/to-length": 136,
                "../internals/to-offset": 138,
                "../internals/to-primitive": 140,
                "../internals/typed-array-constructors-require-wrappers": 143,
                "../internals/typed-array-from": 144
            }
        ],
        143: [
            function(e1, t, r) {
                var o = e1("../internals/global"), n = e1("../internals/fails"), s = e1("../internals/check-correctness-of-iteration"), e1 = e1("../internals/array-buffer-view-core").NATIVE_ARRAY_BUFFER_VIEWS, i = o.ArrayBuffer, a = o.Int8Array;
                t.exports = !e1 || !n(function() {
                    a(1);
                }) || !n(function() {
                    new a(-1);
                }) || !s(function(e1) {
                    new a, new a(null), new a(1.5), new a(e1);
                }, !0) || n(function() {
                    return 1 !== new a(new i(2), 1, void 0).length;
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/check-correctness-of-iteration": 27,
                "../internals/fails": 51,
                "../internals/global": 59
            }
        ],
        144: [
            function(e1, t, r) {
                var h = e1("../internals/to-object"), f = e1("../internals/to-length"), p = e1("../internals/get-iterator-method"), m = e1("../internals/is-array-iterator-method"), y = e1("../internals/function-bind-context"), g = e1("../internals/array-buffer-view-core").aTypedArrayConstructor;
                t.exports = function(e1) {
                    var t, r, o, n, s, i, a = h(e1), l = arguments.length, u = 1 < l ? arguments[1] : void 0, c = void 0 !== u, d = p(a);
                    if (null != d && !m(d)) for(i = (s = d.call(a)).next, a = []; !(n = i.call(s)).done;)a.push(n.value);
                    for(c && 2 < l && (u = y(u, arguments[2], 2)), r = f(a.length), o = new (g(this))(r), t = 0; t < r; t++)o[t] = c ? u(a[t], t) : a[t];
                    return o;
                };
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/function-bind-context": 54,
                "../internals/get-iterator-method": 57,
                "../internals/is-array-iterator-method": 71,
                "../internals/to-length": 136,
                "../internals/to-object": 137
            }
        ],
        145: [
            function(e1, t, r) {
                var o = 0, n = Math.random();
                t.exports = function(e1) {
                    return "Symbol(" + String(void 0 === e1 ? "" : e1) + ")_" + (++o + n).toString(36);
                };
            },
            {}
        ],
        146: [
            function(e1, t, r) {
                e1 = e1("../internals/native-symbol");
                t.exports = e1 && !Symbol.sham && "symbol" == typeof Symbol.iterator;
            },
            {
                "../internals/native-symbol": 83
            }
        ],
        147: [
            function(e1, t, r) {
                e1 = e1("../internals/well-known-symbol");
                r.f = e1;
            },
            {
                "../internals/well-known-symbol": 148
            }
        ],
        148: [
            function(e1, t, r) {
                var o = e1("../internals/global"), n = e1("../internals/shared"), s = e1("../internals/has"), i = e1("../internals/uid"), a = e1("../internals/native-symbol"), e1 = e1("../internals/use-symbol-as-uid"), l = n("wks"), u = o.Symbol, c = e1 ? u : u && u.withoutSetter || i;
                t.exports = function(e1) {
                    return s(l, e1) || (a && s(u, e1) ? l[e1] = u[e1] : l[e1] = c("Symbol." + e1)), l[e1];
                };
            },
            {
                "../internals/global": 59,
                "../internals/has": 60,
                "../internals/native-symbol": 83,
                "../internals/shared": 120,
                "../internals/uid": 145,
                "../internals/use-symbol-as-uid": 146
            }
        ],
        149: [
            function(e1, t, r) {
                t.exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
            },
            {}
        ],
        150: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/global"), s = e1("../internals/array-buffer"), e1 = e1("../internals/set-species"), i = "ArrayBuffer", s = s[i];
                o({
                    global: !0,
                    forced: n[i] !== s
                }, {
                    ArrayBuffer: s
                }), e1(i);
            },
            {
                "../internals/array-buffer": 13,
                "../internals/export": 50,
                "../internals/global": 59,
                "../internals/set-species": 116
            }
        ],
        151: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/fails"), d = e1("../internals/is-array"), h = e1("../internals/is-object"), f = e1("../internals/to-object"), p = e1("../internals/to-length"), m = e1("../internals/create-property"), y = e1("../internals/array-species-create"), s = e1("../internals/array-method-has-species-support"), i = e1("../internals/well-known-symbol"), e1 = e1("../internals/engine-v8-version"), g = i("isConcatSpreadable"), v = 9007199254740991, b = "Maximum allowed index exceeded", i = 51 <= e1 || !n(function() {
                    var e1 = [];
                    return e1[g] = !1, e1.concat()[0] !== e1;
                }), e1 = s("concat");
                o({
                    target: "Array",
                    proto: !0,
                    forced: !i || !e1
                }, {
                    concat: function(e1) {
                        for(var t, r, o, n, s, i = f(this), a = y(i, 0), l = 0, u = -1, c = arguments.length; u < c; u++)if (s = void 0, !h(n = o = -1 === u ? i : arguments[u]) || (void 0 !== (s = n[g]) ? !s : !d(n))) {
                            if (v <= l) throw TypeError(b);
                            m(a, l++, o);
                        } else {
                            if (r = p(o.length), v < l + r) throw TypeError(b);
                            for(t = 0; t < r; t++, l++)t in o && m(a, l, o[t]);
                        }
                        return a.length = l, a;
                    }
                });
            },
            {
                "../internals/array-method-has-species-support": 21,
                "../internals/array-species-create": 25,
                "../internals/create-property": 40,
                "../internals/engine-v8-version": 48,
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/is-array": 72,
                "../internals/is-object": 74,
                "../internals/to-length": 136,
                "../internals/to-object": 137,
                "../internals/well-known-symbol": 148
            }
        ],
        152: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/array-copy-within"), e1 = e1("../internals/add-to-unscopables");
                o({
                    target: "Array",
                    proto: !0
                }, {
                    copyWithin: n
                }), e1("copyWithin");
            },
            {
                "../internals/add-to-unscopables": 7,
                "../internals/array-copy-within": 14,
                "../internals/export": 50
            }
        ],
        153: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-iteration").every, s = e1("../internals/array-method-is-strict"), e1 = e1("../internals/array-method-uses-to-length"), s = s("every"), e1 = e1("every");
                o({
                    target: "Array",
                    proto: !0,
                    forced: !s || !e1
                }, {
                    every: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/array-iteration": 19,
                "../internals/array-method-is-strict": 22,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        154: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/array-fill"), e1 = e1("../internals/add-to-unscopables");
                o({
                    target: "Array",
                    proto: !0
                }, {
                    fill: n
                }), e1("fill");
            },
            {
                "../internals/add-to-unscopables": 7,
                "../internals/array-fill": 15,
                "../internals/export": 50
            }
        ],
        155: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-iteration").filter, s = e1("../internals/array-method-has-species-support"), e1 = e1("../internals/array-method-uses-to-length"), s = s("filter"), e1 = e1("filter");
                o({
                    target: "Array",
                    proto: !0,
                    forced: !s || !e1
                }, {
                    filter: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/array-iteration": 19,
                "../internals/array-method-has-species-support": 21,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        156: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-iteration").findIndex, s = e1("../internals/add-to-unscopables"), e1 = e1("../internals/array-method-uses-to-length"), i = "findIndex", a = !0, e1 = e1(i);
                i in [] && Array(1)[i](function() {
                    a = !1;
                }), o({
                    target: "Array",
                    proto: !0,
                    forced: a || !e1
                }, {
                    findIndex: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                }), s(i);
            },
            {
                "../internals/add-to-unscopables": 7,
                "../internals/array-iteration": 19,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        157: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), e1 = e1("../internals/array-for-each");
                o({
                    target: "Array",
                    proto: !0,
                    forced: [].forEach != e1
                }, {
                    forEach: e1
                });
            },
            {
                "../internals/array-for-each": 16,
                "../internals/export": 50
            }
        ],
        158: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/array-from");
                o({
                    target: "Array",
                    stat: !0,
                    forced: !e1("../internals/check-correctness-of-iteration")(function(e1) {
                        Array.from(e1);
                    })
                }, {
                    from: n
                });
            },
            {
                "../internals/array-from": 17,
                "../internals/check-correctness-of-iteration": 27,
                "../internals/export": 50
            }
        ],
        159: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-includes").includes, s = e1("../internals/add-to-unscopables");
                o({
                    target: "Array",
                    proto: !0,
                    forced: !e1("../internals/array-method-uses-to-length")("indexOf", {
                        ACCESSORS: !0,
                        1: 0
                    })
                }, {
                    includes: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                }), s("includes");
            },
            {
                "../internals/add-to-unscopables": 7,
                "../internals/array-includes": 18,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        160: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-includes").indexOf, s = e1("../internals/array-method-is-strict"), e1 = e1("../internals/array-method-uses-to-length"), i = [].indexOf, a = !!i && 1 / [
                    1
                ].indexOf(1, -0) < 0, s = s("indexOf"), e1 = e1("indexOf", {
                    ACCESSORS: !0,
                    1: 0
                });
                o({
                    target: "Array",
                    proto: !0,
                    forced: a || !s || !e1
                }, {
                    indexOf: function(e1) {
                        return a ? i.apply(this, arguments) || 0 : n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/array-includes": 18,
                "../internals/array-method-is-strict": 22,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        161: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/to-indexed-object"), n = e1("../internals/add-to-unscopables"), s = e1("../internals/iterators"), i = e1("../internals/internal-state"), e1 = e1("../internals/define-iterator"), a = "Array Iterator", l = i.set, u = i.getterFor(a);
                t.exports = e1(Array, "Array", function(e1, t) {
                    l(this, {
                        type: a,
                        target: o(e1),
                        index: 0,
                        kind: t
                    });
                }, function() {
                    var e1 = u(this), t = e1.target, r = e1.kind, o = e1.index++;
                    return !t || o >= t.length ? {
                        value: e1.target = void 0,
                        done: !0
                    } : "keys" == r ? {
                        value: o,
                        done: !1
                    } : "values" == r ? {
                        value: t[o],
                        done: !1
                    } : {
                        value: [
                            o,
                            t[o]
                        ],
                        done: !1
                    };
                }, "values"), s.Arguments = s.Array, n("keys"), n("values"), n("entries");
            },
            {
                "../internals/add-to-unscopables": 7,
                "../internals/define-iterator": 41,
                "../internals/internal-state": 70,
                "../internals/iterators": 79,
                "../internals/to-indexed-object": 134
            }
        ],
        162: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/indexed-object"), s = e1("../internals/to-indexed-object"), e1 = e1("../internals/array-method-is-strict"), i = [].join, n = n != Object, e1 = e1("join", ",");
                o({
                    target: "Array",
                    proto: !0,
                    forced: n || !e1
                }, {
                    join: function(e1) {
                        return i.call(s(this), void 0 === e1 ? "," : e1);
                    }
                });
            },
            {
                "../internals/array-method-is-strict": 22,
                "../internals/export": 50,
                "../internals/indexed-object": 66,
                "../internals/to-indexed-object": 134
            }
        ],
        163: [
            function(e1, t, r) {
                var o = e1("../internals/export"), e1 = e1("../internals/array-last-index-of");
                o({
                    target: "Array",
                    proto: !0,
                    forced: e1 !== [].lastIndexOf
                }, {
                    lastIndexOf: e1
                });
            },
            {
                "../internals/array-last-index-of": 20,
                "../internals/export": 50
            }
        ],
        164: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-iteration").map, s = e1("../internals/array-method-has-species-support"), e1 = e1("../internals/array-method-uses-to-length"), s = s("map"), e1 = e1("map");
                o({
                    target: "Array",
                    proto: !0,
                    forced: !s || !e1
                }, {
                    map: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/array-iteration": 19,
                "../internals/array-method-has-species-support": 21,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        165: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), u = e1("../internals/is-object"), c = e1("../internals/is-array"), d = e1("../internals/to-absolute-index"), h = e1("../internals/to-length"), f = e1("../internals/to-indexed-object"), p = e1("../internals/create-property"), n = e1("../internals/well-known-symbol"), s = e1("../internals/array-method-has-species-support"), e1 = e1("../internals/array-method-uses-to-length"), s = s("slice"), e1 = e1("slice", {
                    ACCESSORS: !0,
                    0: 0,
                    1: 2
                }), m = n("species"), y = [].slice, g = Math.max;
                o({
                    target: "Array",
                    proto: !0,
                    forced: !s || !e1
                }, {
                    slice: function(e1, t) {
                        var r, o, n, s = f(this), i = h(s.length), a = d(e1, i), l = d(void 0 === t ? i : t, i);
                        if (c(s) && ((r = "function" == typeof (r = s.constructor) && (r === Array || c(r.prototype)) || u(r) && null === (r = r[m]) ? void 0 : r) === Array || void 0 === r)) return y.call(s, a, l);
                        for(o = new (void 0 === r ? Array : r)(g(l - a, 0)), n = 0; a < l; a++, n++)a in s && p(o, n, s[a]);
                        return o.length = n, o;
                    }
                });
            },
            {
                "../internals/array-method-has-species-support": 21,
                "../internals/array-method-uses-to-length": 23,
                "../internals/create-property": 40,
                "../internals/export": 50,
                "../internals/is-array": 72,
                "../internals/is-object": 74,
                "../internals/to-absolute-index": 132,
                "../internals/to-indexed-object": 134,
                "../internals/to-length": 136,
                "../internals/well-known-symbol": 148
            }
        ],
        166: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-iteration").some, s = e1("../internals/array-method-is-strict"), e1 = e1("../internals/array-method-uses-to-length"), s = s("some"), e1 = e1("some");
                o({
                    target: "Array",
                    proto: !0,
                    forced: !s || !e1
                }, {
                    some: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/array-iteration": 19,
                "../internals/array-method-is-strict": 22,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        167: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), d = e1("../internals/to-absolute-index"), h = e1("../internals/to-integer"), f = e1("../internals/to-length"), p = e1("../internals/to-object"), m = e1("../internals/array-species-create"), y = e1("../internals/create-property"), n = e1("../internals/array-method-has-species-support"), e1 = e1("../internals/array-method-uses-to-length"), n = n("splice"), e1 = e1("splice", {
                    ACCESSORS: !0,
                    0: 0,
                    1: 2
                }), g = Math.max, v = Math.min;
                o({
                    target: "Array",
                    proto: !0,
                    forced: !n || !e1
                }, {
                    splice: function(e1, t) {
                        var r, o, n, s, i, a, l = p(this), u = f(l.length), c = d(e1, u), e1 = arguments.length;
                        if (0 === e1 ? r = o = 0 : o = 1 === e1 ? (r = 0, u - c) : (r = e1 - 2, v(g(h(t), 0), u - c)), 9007199254740991 < u + r - o) throw TypeError("Maximum allowed length exceeded");
                        for(n = m(l, o), s = 0; s < o; s++)(i = c + s) in l && y(n, s, l[i]);
                        if (r < (n.length = o)) {
                            for(s = c; s < u - o; s++)a = s + r, (i = s + o) in l ? l[a] = l[i] : delete l[a];
                            for(s = u; u - o + r < s; s--)delete l[s - 1];
                        } else if (o < r) for(s = u - o; c < s; s--)a = s + r - 1, (i = s + o - 1) in l ? l[a] = l[i] : delete l[a];
                        for(s = 0; s < r; s++)l[s + c] = arguments[s + 2];
                        return l.length = u - o + r, n;
                    }
                });
            },
            {
                "../internals/array-method-has-species-support": 21,
                "../internals/array-method-uses-to-length": 23,
                "../internals/array-species-create": 25,
                "../internals/create-property": 40,
                "../internals/export": 50,
                "../internals/to-absolute-index": 132,
                "../internals/to-integer": 135,
                "../internals/to-length": 136,
                "../internals/to-object": 137
            }
        ],
        168: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), e1 = e1("../internals/object-define-property").f, n = Function.prototype, s = n.toString, i = /^\s*function ([^ (]*)/;
                !o || "name" in n || e1(n, "name", {
                    configurable: !0,
                    get: function() {
                        try {
                            return s.call(this).match(i)[1];
                        } catch (e1) {
                            return "";
                        }
                    }
                });
            },
            {
                "../internals/descriptors": 43,
                "../internals/object-define-property": 92
            }
        ],
        169: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/collection"), e1 = e1("../internals/collection-strong");
                t.exports = o("Map", function(e1) {
                    return function() {
                        return e1(this, arguments.length ? arguments[0] : void 0);
                    };
                }, e1);
            },
            {
                "../internals/collection": 32,
                "../internals/collection-strong": 30
            }
        ],
        170: [
            function(e1, t, r) {
                var e1 = e1("../internals/export"), o = Math.hypot, l = Math.abs, u = Math.sqrt;
                e1({
                    target: "Math",
                    stat: !0,
                    forced: !!o && o(1 / 0, NaN) !== 1 / 0
                }, {
                    hypot: function(e1, t) {
                        for(var r, o, n = 0, s = 0, i = arguments.length, a = 0; s < i;)a < (r = l(arguments[s++])) ? (n = n * (o = a / r) * o + 1, a = r) : n += 0 < r ? (o = r / a) * o : r;
                        return a === 1 / 0 ? 1 / 0 : a * u(n);
                    }
                });
            },
            {
                "../internals/export": 50
            }
        ],
        171: [
            function(e1, t, r) {
                var e1 = e1("../internals/export"), o = Math.log, n = Math.LN2;
                e1({
                    target: "Math",
                    stat: !0
                }, {
                    log2: function(e1) {
                        return o(e1) / n;
                    }
                });
            },
            {
                "../internals/export": 50
            }
        ],
        172: [
            function(e1, t, r) {
                e1("../internals/export")({
                    target: "Math",
                    stat: !0
                }, {
                    sign: e1("../internals/math-sign")
                });
            },
            {
                "../internals/export": 50,
                "../internals/math-sign": 80
            }
        ],
        173: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    var t, r, o, n, s, i, a, l = d(e1, !1);
                    if ("string" == typeof l && 2 < l.length) {
                        if (43 === (e1 = (l = g(l)).charCodeAt(0)) || 45 === e1) {
                            if (88 === (t = l.charCodeAt(2)) || 120 === t) return NaN;
                        } else if (48 === e1) {
                            switch(l.charCodeAt(1)){
                                case 66:
                                case 98:
                                    r = 2, o = 49;
                                    break;
                                case 79:
                                case 111:
                                    r = 8, o = 55;
                                    break;
                                default:
                                    return +l;
                            }
                            for(s = (n = l.slice(2)).length, i = 0; i < s; i++)if ((a = n.charCodeAt(i)) < 48 || o < a) return NaN;
                            return parseInt(n, r);
                        }
                    }
                    return +l;
                }
                var n = e1("../internals/descriptors"), s = e1("../internals/global"), i = e1("../internals/is-forced"), a = e1("../internals/redefine"), l = e1("../internals/has"), u = e1("../internals/classof-raw"), c = e1("../internals/inherit-if-required"), d = e1("../internals/to-primitive"), h = e1("../internals/fails"), f = e1("../internals/object-create"), p = e1("../internals/object-get-own-property-names").f, m = e1("../internals/object-get-own-property-descriptor").f, y = e1("../internals/object-define-property").f, g = e1("../internals/string-trim").trim, v = "Number", b = s[v], j = b.prototype, _ = u(f(j)) == v;
                if (i(v, !b(" 0o1") || !b("0b1") || b("+0x1"))) {
                    for(var x, w = function(e1) {
                        var e1 = arguments.length < 1 ? 0 : e1, t = this;
                        return t instanceof w && (_ ? h(function() {
                            j.valueOf.call(t);
                        }) : u(t) != v) ? c(new b(o(e1)), t, w) : o(e1);
                    }, S = n ? p(b) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), T = 0; S.length > T; T++)l(b, x = S[T]) && !l(w, x) && y(w, x, m(b, x));
                    (w.prototype = j).constructor = w, a(s, v, w);
                }
            },
            {
                "../internals/classof-raw": 28,
                "../internals/descriptors": 43,
                "../internals/fails": 51,
                "../internals/global": 59,
                "../internals/has": 60,
                "../internals/inherit-if-required": 67,
                "../internals/is-forced": 73,
                "../internals/object-create": 90,
                "../internals/object-define-property": 92,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/object-get-own-property-names": 95,
                "../internals/redefine": 108,
                "../internals/string-trim": 129,
                "../internals/to-primitive": 140
            }
        ],
        174: [
            function(e1, t, r) {
                e1("../internals/export")({
                    target: "Number",
                    stat: !0
                }, {
                    isFinite: e1("../internals/number-is-finite")
                });
            },
            {
                "../internals/export": 50,
                "../internals/number-is-finite": 88
            }
        ],
        175: [
            function(e1, t, r) {
                "use strict";
                function c(e1, t, r) {
                    return 0 === t ? r : t % 2 == 1 ? c(e1, t - 1, r * e1) : c(e1 * e1, t / 2, r);
                }
                var o = e1("../internals/export"), d = e1("../internals/to-integer"), h = e1("../internals/this-number-value"), f = e1("../internals/string-repeat"), e1 = e1("../internals/fails"), n = 1..toFixed, p = Math.floor;
                o({
                    target: "Number",
                    proto: !0,
                    forced: n && ("0.000" !== 8e-5.toFixed(3) || "1" !== .9.toFixed(0) || "1.25" !== 1.255.toFixed(2) || "1000000000000000128" !== 0xde0b6b3a7640080.toFixed(0)) || !e1(function() {
                        n.call({});
                    })
                }, {
                    toFixed: function(e1) {
                        function t(e1, t) {
                            for(var r = -1, o = t; ++r < 6;)o += e1 * a[r], a[r] = o % 1e7, o = p(o / 1e7);
                        }
                        function r(e1) {
                            for(var t = 6, r = 0; 0 <= --t;)r += a[t], a[t] = p(r / e1), r = r % e1 * 1e7;
                        }
                        function o() {
                            for(var e1, t = 6, r = ""; 0 <= --t;)"" === r && 0 !== t && 0 === a[t] || (e1 = String(a[t]), r = "" === r ? e1 : r + f.call("0", 7 - e1.length) + e1);
                            return r;
                        }
                        var n, s, i = h(this), e1 = d(e1), a = [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ], l = "", u = "0";
                        if (e1 < 0 || 20 < e1) throw RangeError("Incorrect fraction digits");
                        if (i != i) return "NaN";
                        if (i <= -1000000000000000000000 || 1e21 <= i) return String(i);
                        if (i < 0 && (l = "-", i = -i), 1e-21 < i) {
                            if (i = (n = function(e1) {
                                for(var t = 0, r = e1; 4096 <= r;)t += 12, r /= 4096;
                                for(; 2 <= r;)t += 1, r /= 2;
                                return t;
                            }(i * c(2, 69, 1)) - 69) < 0 ? i * c(2, -n, 1) : i / c(2, n, 1), i *= 4503599627370496, 0 < (n = 52 - n)) {
                                for(t(0, i), s = e1; 7 <= s;)t(1e7, 0), s -= 7;
                                for(t(c(10, s, 1), 0), s = n - 1; 23 <= s;)r(8388608), s -= 23;
                                r(1 << s), t(1, 1), r(2), u = o();
                            } else t(0, i), t(1 << -n, 0), u = o() + f.call("0", e1);
                        }
                        return u = 0 < e1 ? l + ((i = u.length) <= e1 ? "0." + f.call("0", e1 - i) + u : u.slice(0, i - e1) + "." + u.slice(i - e1)) : l + u;
                    }
                });
            },
            {
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/string-repeat": 127,
                "../internals/this-number-value": 131,
                "../internals/to-integer": 135
            }
        ],
        176: [
            function(e1, t, r) {
                var o = e1("../internals/export"), e1 = e1("../internals/object-assign");
                o({
                    target: "Object",
                    stat: !0,
                    forced: Object.assign !== e1
                }, {
                    assign: e1
                });
            },
            {
                "../internals/export": 50,
                "../internals/object-assign": 89
            }
        ],
        177: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/iterate"), s = e1("../internals/create-property");
                o({
                    target: "Object",
                    stat: !0
                }, {
                    fromEntries: function(e1) {
                        var r = {};
                        return n(e1, function(e1, t) {
                            s(r, e1, t);
                        }, void 0, !0), r;
                    }
                });
            },
            {
                "../internals/create-property": 40,
                "../internals/export": 50,
                "../internals/iterate": 77
            }
        ],
        178: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/fails"), s = e1("../internals/to-indexed-object"), i = e1("../internals/object-get-own-property-descriptor").f, e1 = e1("../internals/descriptors"), n = n(function() {
                    i(1);
                });
                o({
                    target: "Object",
                    stat: !0,
                    forced: !e1 || n,
                    sham: !e1
                }, {
                    getOwnPropertyDescriptor: function(e1, t) {
                        return i(s(e1), t);
                    }
                });
            },
            {
                "../internals/descriptors": 43,
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/to-indexed-object": 134
            }
        ],
        179: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/fails"), e1 = e1("../internals/object-get-own-property-names-external").f;
                o({
                    target: "Object",
                    stat: !0,
                    forced: n(function() {
                        return !Object.getOwnPropertyNames(1);
                    })
                }, {
                    getOwnPropertyNames: e1
                });
            },
            {
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/object-get-own-property-names-external": 94
            }
        ],
        180: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/fails"), s = e1("../internals/to-object"), i = e1("../internals/object-get-prototype-of"), e1 = e1("../internals/correct-prototype-getter");
                o({
                    target: "Object",
                    stat: !0,
                    forced: n(function() {
                        i(1);
                    }),
                    sham: !e1
                }, {
                    getPrototypeOf: function(e1) {
                        return i(s(e1));
                    }
                });
            },
            {
                "../internals/correct-prototype-getter": 35,
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/object-get-prototype-of": 97,
                "../internals/to-object": 137
            }
        ],
        181: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/to-object"), s = e1("../internals/object-keys");
                o({
                    target: "Object",
                    stat: !0,
                    forced: e1("../internals/fails")(function() {
                        s(1);
                    })
                }, {
                    keys: function(e1) {
                        return s(n(e1));
                    }
                });
            },
            {
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/object-keys": 99,
                "../internals/to-object": 137
            }
        ],
        182: [
            function(e1, t, r) {
                var o = e1("../internals/to-string-tag-support"), n = e1("../internals/redefine"), e1 = e1("../internals/object-to-string");
                o || n(Object.prototype, "toString", e1, {
                    unsafe: !0
                });
            },
            {
                "../internals/object-to-string": 102,
                "../internals/redefine": 108,
                "../internals/to-string-tag-support": 141
            }
        ],
        183: [
            function(e1, D, F) {
                "use strict";
                var r, t, o, n, s = e1("../internals/export"), i = e1("../internals/is-pure"), g = e1("../internals/global"), a = e1("../internals/get-built-in"), l = e1("../internals/native-promise-constructor"), U = e1("../internals/redefine"), N = e1("../internals/redefine-all"), B = e1("../internals/set-to-string-tag"), G = e1("../internals/set-species"), V = e1("../internals/is-object"), c = e1("../internals/a-function"), z = e1("../internals/an-instance"), H = e1("../internals/classof-raw"), W = e1("../internals/inspect-source"), d = e1("../internals/iterate"), q = e1("../internals/check-correctness-of-iteration"), X = e1("../internals/species-constructor"), v = e1("../internals/task").set, u = e1("../internals/microtask"), h = e1("../internals/promise-resolve"), Y = e1("../internals/host-report-errors"), f = e1("../internals/new-promise-capability"), b = e1("../internals/perform"), p = e1("../internals/internal-state"), Z = e1("../internals/is-forced"), m = e1("../internals/well-known-symbol"), y = e1("../internals/engine-v8-version"), Q = m("species"), j = "Promise", _ = p.get, J = p.set, K = p.getterFor(j), x = l, w = g.TypeError, S = g.document, T = g.process, M = a("fetch"), E = f.f, $ = E, k = "process" == H(T), ee = !!(S && S.createEvent && g.dispatchEvent), C = "unhandledrejection", te = "rejectionhandled", O = 1, re = 2, P = 1, oe = 2, e1 = Z(j, function() {
                    var e1, t;
                    if (!(W(x) !== String(x))) {
                        if (66 === y) return !0;
                        if (!k && "function" != typeof PromiseRejectionEvent) return !0;
                    }
                    return !(!i || x.prototype.finally) || !(51 <= y && /native code/.test(x)) && (t = function(e1) {
                        e1(function() {}, function() {});
                    }, ((e1 = x.resolve(1)).constructor = {})[Q] = t, !(e1.then(function() {}) instanceof t));
                }), m = e1 || !q(function(e1) {
                    x.all(e1).catch(function() {});
                }), ne = function(e1) {
                    var t;
                    return !(!V(e1) || "function" != typeof (t = e1.then)) && t;
                }, A = function(f, p, m) {
                    var y;
                    p.notified || (p.notified = !0, y = p.reactions, u(function() {
                        for(var r, o, e1 = p.value, t = p.state == O, n = 0; y.length > n;){
                            var s, i, a, l = y[n++], u = t ? l.ok : l.fail, c = l.resolve, d = l.reject, h = l.domain;
                            try {
                                u ? (t || (p.rejection === oe && function(e1, t) {
                                    v.call(g, function() {
                                        if (k) T.emit("rejectionHandled", e1);
                                        else se(te, e1, t.value);
                                    });
                                }(f, p), p.rejection = P), !0 === u ? s = e1 : (h && h.enter(), s = u(e1), h && (h.exit(), a = !0)), s === l.promise ? d(w("Promise-chain cycle")) : (i = ne(s)) ? i.call(s, c, d) : c(s)) : d(e1);
                            } catch (e1) {
                                h && !a && h.exit(), d(e1);
                            }
                        }
                        p.reactions = [], p.notified = !1, m && !p.rejection && (r = f, o = p, v.call(g, function() {
                            var e1 = o.value, t = ie(o);
                            if (t && (t = b(function() {
                                k ? T.emit("unhandledRejection", e1, r) : se(C, r, e1);
                            }), o.rejection = k || ie(o) ? oe : P, t.error)) throw t.value;
                        }));
                    }));
                }, se = function(e1, t, r) {
                    var o;
                    ee ? ((o = S.createEvent("Event")).promise = t, o.reason = r, o.initEvent(e1, !1, !0), g.dispatchEvent(o)) : o = {
                        promise: t,
                        reason: r
                    }, (t = g["on" + e1]) ? t(o) : e1 === C && Y("Unhandled promise rejection", r);
                }, ie = function(e1) {
                    return e1.rejection !== P && !e1.parent;
                }, L = function(t, r, o, n) {
                    return function(e1) {
                        t(r, o, e1, n);
                    };
                }, R = function(e1, t, r, o) {
                    t.done || (t.done = !0, (t = o ? o : t).value = r, t.state = re, A(e1, t, !0));
                }, I = function(r, o, e1, t) {
                    if (!o.done) {
                        o.done = !0, t && (o = t);
                        try {
                            if (r === e1) throw w("Promise can't be resolved itself");
                            var n = ne(e1);
                            n ? u(function() {
                                var t = {
                                    done: !1
                                };
                                try {
                                    n.call(e1, L(I, r, t, o), L(R, r, t, o));
                                } catch (e1) {
                                    R(r, t, e1, o);
                                }
                            }) : (o.value = e1, o.state = O, A(r, o, !1));
                        } catch (e1) {
                            R(r, {
                                done: !1
                            }, e1, o);
                        }
                    }
                };
                e1 && (x = function(e1) {
                    z(this, x, j), c(e1), r.call(this);
                    var t = _(this);
                    try {
                        e1(L(I, this, t), L(R, this, t));
                    } catch (e1) {
                        R(this, t, e1);
                    }
                }, (r = function(e1) {
                    J(this, {
                        type: j,
                        done: !1,
                        notified: !1,
                        parent: !1,
                        reactions: [],
                        rejection: !1,
                        state: 0,
                        value: void 0
                    });
                }).prototype = N(x.prototype, {
                    then: function(e1, t) {
                        var r = K(this), o = E(X(this, x));
                        return o.ok = "function" != typeof e1 || e1, o.fail = "function" == typeof t && t, o.domain = k ? T.domain : void 0, r.parent = !0, r.reactions.push(o), 0 != r.state && A(this, r, !1), o.promise;
                    },
                    catch: function(e1) {
                        return this.then(void 0, e1);
                    }
                }), t = function() {
                    var e1 = new r, t = _(e1);
                    this.promise = e1, this.resolve = L(I, e1, t), this.reject = L(R, e1, t);
                }, f.f = E = function(e1) {
                    return e1 === x || e1 === o ? new t : $(e1);
                }, i || "function" != typeof l || (n = l.prototype.then, U(l.prototype, "then", function(e1, t) {
                    var r = this;
                    return new x(function(e1, t) {
                        n.call(r, e1, t);
                    }).then(e1, t);
                }, {
                    unsafe: !0
                }), "function" == typeof M && s({
                    global: !0,
                    enumerable: !0,
                    forced: !0
                }, {
                    fetch: function(e1) {
                        return h(x, M.apply(g, arguments));
                    }
                }))), s({
                    global: !0,
                    wrap: !0,
                    forced: e1
                }, {
                    Promise: x
                }), B(x, j, !1, !0), G(j), o = a(j), s({
                    target: j,
                    stat: !0,
                    forced: e1
                }, {
                    reject: function(e1) {
                        var t = E(this);
                        return t.reject.call(void 0, e1), t.promise;
                    }
                }), s({
                    target: j,
                    stat: !0,
                    forced: i || e1
                }, {
                    resolve: function(e1) {
                        return h(i && this === o ? x : this, e1);
                    }
                }), s({
                    target: j,
                    stat: !0,
                    forced: m
                }, {
                    all: function(e1) {
                        var a = this, t = E(a), l = t.resolve, u = t.reject, r = b(function() {
                            var o = c(a.resolve), n = [], s = 0, i = 1;
                            d(e1, function(e1) {
                                var t = s++, r = !1;
                                n.push(void 0), i++, o.call(a, e1).then(function(e1) {
                                    r || (r = !0, n[t] = e1, --i || l(n));
                                }, u);
                            }), --i || l(n);
                        });
                        return r.error && u(r.value), t.promise;
                    },
                    race: function(e1) {
                        var r = this, o = E(r), n = o.reject, t = b(function() {
                            var t = c(r.resolve);
                            d(e1, function(e1) {
                                t.call(r, e1).then(o.resolve, n);
                            });
                        });
                        return t.error && n(t.value), o.promise;
                    }
                });
            },
            {
                "../internals/a-function": 5,
                "../internals/an-instance": 9,
                "../internals/check-correctness-of-iteration": 27,
                "../internals/classof-raw": 28,
                "../internals/engine-v8-version": 48,
                "../internals/export": 50,
                "../internals/get-built-in": 56,
                "../internals/global": 59,
                "../internals/host-report-errors": 62,
                "../internals/inspect-source": 68,
                "../internals/internal-state": 70,
                "../internals/is-forced": 73,
                "../internals/is-object": 74,
                "../internals/is-pure": 75,
                "../internals/iterate": 77,
                "../internals/microtask": 81,
                "../internals/native-promise-constructor": 82,
                "../internals/new-promise-capability": 86,
                "../internals/perform": 105,
                "../internals/promise-resolve": 106,
                "../internals/redefine": 108,
                "../internals/redefine-all": 107,
                "../internals/set-species": 116,
                "../internals/set-to-string-tag": 117,
                "../internals/species-constructor": 121,
                "../internals/task": 130,
                "../internals/well-known-symbol": 148
            }
        ],
        184: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/get-built-in"), s = e1("../internals/a-function"), i = e1("../internals/an-object"), a = e1("../internals/is-object"), l = e1("../internals/object-create"), u = e1("../internals/function-bind"), e1 = e1("../internals/fails"), c = n("Reflect", "construct"), d = e1(function() {
                    function e1() {}
                    return !(c(function() {}, [], e1) instanceof e1);
                }), h = !e1(function() {
                    c(function() {});
                }), n = d || h;
                o({
                    target: "Reflect",
                    stat: !0,
                    forced: n,
                    sham: n
                }, {
                    construct: function(e1, t) {
                        s(e1), i(t);
                        var r = arguments.length < 3 ? e1 : s(arguments[2]);
                        if (h && !d) return c(e1, t, r);
                        if (e1 == r) {
                            switch(t.length){
                                case 0:
                                    return new e1;
                                case 1:
                                    return new e1(t[0]);
                                case 2:
                                    return new e1(t[0], t[1]);
                                case 3:
                                    return new e1(t[0], t[1], t[2]);
                                case 4:
                                    return new e1(t[0], t[1], t[2], t[3]);
                            }
                            var o = [
                                null
                            ];
                            return o.push.apply(o, t), new (u.apply(e1, o));
                        }
                        o = r.prototype, r = l(a(o) ? o : Object.prototype), o = Function.apply.call(e1, r, t);
                        return a(o) ? o : r;
                    }
                });
            },
            {
                "../internals/a-function": 5,
                "../internals/an-object": 10,
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/function-bind": 55,
                "../internals/get-built-in": 56,
                "../internals/is-object": 74,
                "../internals/object-create": 90
            }
        ],
        185: [
            function(e1, t, r) {
                var o = e1("../internals/export"), s = e1("../internals/is-object"), i = e1("../internals/an-object"), a = e1("../internals/has"), l = e1("../internals/object-get-own-property-descriptor"), u = e1("../internals/object-get-prototype-of");
                o({
                    target: "Reflect",
                    stat: !0
                }, {
                    get: function e1(t, r) {
                        var o, n = arguments.length < 3 ? t : arguments[2];
                        return i(t) === n ? t[r] : (o = l.f(t, r)) ? a(o, "value") ? o.value : void 0 === o.get ? void 0 : o.get.call(n) : s(o = u(t)) ? e1(o, r, n) : void 0;
                    }
                });
            },
            {
                "../internals/an-object": 10,
                "../internals/export": 50,
                "../internals/has": 60,
                "../internals/is-object": 74,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/object-get-prototype-of": 97
            }
        ],
        186: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), n = e1("../internals/global"), s = e1("../internals/is-forced"), i = e1("../internals/inherit-if-required"), a = e1("../internals/object-define-property").f, l = e1("../internals/object-get-own-property-names").f, u = e1("../internals/is-regexp"), c = e1("../internals/regexp-flags"), d = e1("../internals/regexp-sticky-helpers"), h = e1("../internals/redefine"), f = e1("../internals/fails"), p = e1("../internals/internal-state").set, m = e1("../internals/set-species"), y = e1("../internals/well-known-symbol")("match"), g = n.RegExp, v = g.prototype, b = /a/g, j = /a/g, _ = new g(b) !== b, x = d.UNSUPPORTED_Y;
                if (o && s("RegExp", !_ || x || f(function() {
                    return j[y] = !1, g(b) != b || g(j) == j || "/a/i" != g(b, "i");
                }))) {
                    for(var w = function(e1, t) {
                        var r, o = this instanceof w, n = u(e1), s = void 0 === t;
                        if (!o && n && e1.constructor === w && s) return e1;
                        _ ? n && !s && (e1 = e1.source) : e1 instanceof w && (s && (t = c.call(e1)), e1 = e1.source), x && (r = !!t && -1 < t.indexOf("y")) && (t = t.replace(/y/g, ""));
                        n = i(_ ? new g(e1, t) : g(e1, t), o ? this : v, w);
                        return x && r && p(n, {
                            sticky: r
                        }), n;
                    }, S = l(g), T = 0; S.length > T;)!function(t) {
                        t in w || a(w, t, {
                            configurable: !0,
                            get: function() {
                                return g[t];
                            },
                            set: function(e1) {
                                g[t] = e1;
                            }
                        });
                    }(S[T++]);
                    (v.constructor = w).prototype = v, h(n, "RegExp", w);
                }
                m("RegExp");
            },
            {
                "../internals/descriptors": 43,
                "../internals/fails": 51,
                "../internals/global": 59,
                "../internals/inherit-if-required": 67,
                "../internals/internal-state": 70,
                "../internals/is-forced": 73,
                "../internals/is-regexp": 76,
                "../internals/object-define-property": 92,
                "../internals/object-get-own-property-names": 95,
                "../internals/redefine": 108,
                "../internals/regexp-flags": 111,
                "../internals/regexp-sticky-helpers": 112,
                "../internals/set-species": 116,
                "../internals/well-known-symbol": 148
            }
        ],
        187: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), e1 = e1("../internals/regexp-exec");
                o({
                    target: "RegExp",
                    proto: !0,
                    forced: /./.exec !== e1
                }, {
                    exec: e1
                });
            },
            {
                "../internals/export": 50,
                "../internals/regexp-exec": 110
            }
        ],
        188: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/redefine"), n = e1("../internals/an-object"), s = e1("../internals/fails"), i = e1("../internals/regexp-flags"), e1 = "toString", a = RegExp.prototype, l = a[e1], s = s(function() {
                    return "/a/b" != l.call({
                        source: "a",
                        flags: "b"
                    });
                }), u = l.name != e1;
                (s || u) && o(RegExp.prototype, e1, function() {
                    var e1 = n(this), t = String(e1.source), r = e1.flags;
                    return "/" + t + "/" + String(void 0 === r && e1 instanceof RegExp && !("flags" in a) ? i.call(e1) : r);
                }, {
                    unsafe: !0
                });
            },
            {
                "../internals/an-object": 10,
                "../internals/fails": 51,
                "../internals/redefine": 108,
                "../internals/regexp-flags": 111
            }
        ],
        189: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/collection"), e1 = e1("../internals/collection-strong");
                t.exports = o("Set", function(e1) {
                    return function() {
                        return e1(this, arguments.length ? arguments[0] : void 0);
                    };
                }, e1);
            },
            {
                "../internals/collection": 32,
                "../internals/collection-strong": 30
            }
        ],
        190: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/object-get-own-property-descriptor").f, s = e1("../internals/to-length"), i = e1("../internals/not-a-regexp"), a = e1("../internals/require-object-coercible"), l = e1("../internals/correct-is-regexp-logic"), e1 = e1("../internals/is-pure"), u = "".endsWith, c = Math.min, l = l("endsWith");
                o({
                    target: "String",
                    proto: !0,
                    forced: !!(e1 || l || !(o = n(String.prototype, "endsWith")) || o.writable) && !l
                }, {
                    endsWith: function(e1) {
                        var t = String(a(this)), r = (i(e1), 1 < arguments.length ? arguments[1] : void 0), o = s(t.length), r = void 0 === r ? o : c(s(r), o), o = String(e1);
                        return u ? u.call(t, o, r) : t.slice(r - o.length, r) === o;
                    }
                });
            },
            {
                "../internals/correct-is-regexp-logic": 34,
                "../internals/export": 50,
                "../internals/is-pure": 75,
                "../internals/not-a-regexp": 87,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/require-object-coercible": 113,
                "../internals/to-length": 136
            }
        ],
        191: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/not-a-regexp"), s = e1("../internals/require-object-coercible");
                o({
                    target: "String",
                    proto: !0,
                    forced: !e1("../internals/correct-is-regexp-logic")("includes")
                }, {
                    includes: function(e1) {
                        return !!~String(s(this)).indexOf(n(e1), 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/correct-is-regexp-logic": 34,
                "../internals/export": 50,
                "../internals/not-a-regexp": 87,
                "../internals/require-object-coercible": 113
            }
        ],
        192: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/string-multibyte").charAt, n = e1("../internals/internal-state"), e1 = e1("../internals/define-iterator"), s = "String Iterator", i = n.set, a = n.getterFor(s);
                e1(String, "String", function(e1) {
                    i(this, {
                        type: s,
                        string: String(e1),
                        index: 0
                    });
                }, function() {
                    var e1 = a(this), t = e1.string, r = e1.index;
                    return r >= t.length ? {
                        value: void 0,
                        done: !0
                    } : (t = o(t, r), e1.index += t.length, {
                        value: t,
                        done: !1
                    });
                });
            },
            {
                "../internals/define-iterator": 41,
                "../internals/internal-state": 70,
                "../internals/string-multibyte": 123
            }
        ],
        193: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/fix-regexp-well-known-symbol-logic"), c = e1("../internals/an-object"), d = e1("../internals/to-length"), n = e1("../internals/require-object-coercible"), h = e1("../internals/advance-string-index"), f = e1("../internals/regexp-exec-abstract");
                o("match", 1, function(o, l, u) {
                    return [
                        function(e1) {
                            var t = n(this), r = null == e1 ? void 0 : e1[o];
                            return void 0 !== r ? r.call(e1, t) : new RegExp(e1)[o](String(t));
                        },
                        function(e1) {
                            var t = u(l, e1, this);
                            if (t.done) return t.value;
                            var r = c(e1), o = String(this);
                            if (!r.global) return f(r, o);
                            for(var n = r.unicode, s = [], i = r.lastIndex = 0; null !== (a = f(r, o));){
                                var a = String(a[0]);
                                "" === (s[i] = a) && (r.lastIndex = h(o, d(r.lastIndex), n)), i++;
                            }
                            return 0 === i ? null : s;
                        }
                    ];
                });
            },
            {
                "../internals/advance-string-index": 8,
                "../internals/an-object": 10,
                "../internals/fix-regexp-well-known-symbol-logic": 52,
                "../internals/regexp-exec-abstract": 109,
                "../internals/require-object-coercible": 113,
                "../internals/to-length": 136
            }
        ],
        194: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/string-pad").start;
                o({
                    target: "String",
                    proto: !0,
                    forced: e1("../internals/string-pad-webkit-bug")
                }, {
                    padStart: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/export": 50,
                "../internals/string-pad": 125,
                "../internals/string-pad-webkit-bug": 124
            }
        ],
        195: [
            function(e1, t, r) {
                e1("../internals/export")({
                    target: "String",
                    proto: !0
                }, {
                    repeat: e1("../internals/string-repeat")
                });
            },
            {
                "../internals/export": 50,
                "../internals/string-repeat": 127
            }
        ],
        196: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/fix-regexp-well-known-symbol-logic"), T = e1("../internals/an-object"), M = e1("../internals/to-object"), E = e1("../internals/to-length"), k = e1("../internals/to-integer"), s = e1("../internals/require-object-coercible"), C = e1("../internals/advance-string-index"), O = e1("../internals/regexp-exec-abstract"), P = Math.max, A = Math.min, L = Math.floor, R = /\$([$&'`]|\d\d?|<[^>]*>)/g, I = /\$([$&'`]|\d\d?)/g;
                o("replace", 2, function(n, j, _, e1) {
                    var x = e1.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE, w = e1.REPLACE_KEEPS_$0, S = x ? "$" : "$0";
                    return [
                        function(e1, t) {
                            var r = s(this), o = null == e1 ? void 0 : e1[n];
                            return void 0 !== o ? o.call(e1, r, t) : j.call(String(r), e1, t);
                        },
                        function(e1, t) {
                            if (!x && w || "string" == typeof t && -1 === t.indexOf(S)) {
                                var r = _(j, e1, this, t);
                                if (r.done) return r.value;
                            }
                            for(var o, n = T(e1), s = String(this), i = "function" == typeof t, a = (i || (t = String(t)), n.global), l = (a && (o = n.unicode, n.lastIndex = 0), []); null !== (f = O(n, s)) && (l.push(f), a);)"" === String(f[0]) && (n.lastIndex = C(s, E(n.lastIndex), o));
                            for(var u, c = "", d = 0, h = 0; h < l.length; h++){
                                for(var f = l[h], p = String(f[0]), m = P(A(k(f.index), s.length), 0), y = [], g = 1; g < f.length; g++)y.push(void 0 === (u = f[g]) ? u : String(u));
                                var v = f.groups, b = i ? (b = [
                                    p
                                ].concat(y, m, s), void 0 !== v && b.push(v), String(t.apply(void 0, b))) : function(s, i, a, l, u, e1) {
                                    var c = a + s.length, d = l.length, t = I;
                                    void 0 !== u && (u = M(u), t = R);
                                    return j.call(e1, t, function(e1, t) {
                                        var r;
                                        switch(t.charAt(0)){
                                            case "$":
                                                return "$";
                                            case "&":
                                                return s;
                                            case "`":
                                                return i.slice(0, a);
                                            case "'":
                                                return i.slice(c);
                                            case "<":
                                                r = u[t.slice(1, -1)];
                                                break;
                                            default:
                                                var o, n = +t;
                                                if (0 == n) return e1;
                                                if (d < n) return 0 !== (o = L(n / 10)) && o <= d ? void 0 === l[o - 1] ? t.charAt(1) : l[o - 1] + t.charAt(1) : e1;
                                                r = l[n - 1];
                                        }
                                        return void 0 === r ? "" : r;
                                    });
                                }(p, s, m, y, v, t);
                                d <= m && (c += s.slice(d, m) + b, d = m + p.length);
                            }
                            return c + s.slice(d);
                        }
                    ];
                });
            },
            {
                "../internals/advance-string-index": 8,
                "../internals/an-object": 10,
                "../internals/fix-regexp-well-known-symbol-logic": 52,
                "../internals/regexp-exec-abstract": 109,
                "../internals/require-object-coercible": 113,
                "../internals/to-integer": 135,
                "../internals/to-length": 136,
                "../internals/to-object": 137
            }
        ],
        197: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/fix-regexp-well-known-symbol-logic"), i = e1("../internals/an-object"), a = e1("../internals/require-object-coercible"), l = e1("../internals/same-value"), u = e1("../internals/regexp-exec-abstract");
                o("search", 1, function(o, n, s) {
                    return [
                        function(e1) {
                            var t = a(this), r = null == e1 ? void 0 : e1[o];
                            return void 0 !== r ? r.call(e1, t) : new RegExp(e1)[o](String(t));
                        },
                        function(e1) {
                            var t, r = s(n, e1, this);
                            return r.done ? r.value : (r = i(e1), e1 = String(this), t = r.lastIndex, l(t, 0) || (r.lastIndex = 0), e1 = u(r, e1), l(r.lastIndex, t) || (r.lastIndex = t), null === e1 ? -1 : e1.index);
                        }
                    ];
                });
            },
            {
                "../internals/an-object": 10,
                "../internals/fix-regexp-well-known-symbol-logic": 52,
                "../internals/regexp-exec-abstract": 109,
                "../internals/require-object-coercible": 113,
                "../internals/same-value": 114
            }
        ],
        198: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/fix-regexp-well-known-symbol-logic"), c = e1("../internals/is-regexp"), g = e1("../internals/an-object"), d = e1("../internals/require-object-coercible"), v = e1("../internals/species-constructor"), b = e1("../internals/advance-string-index"), j = e1("../internals/to-length"), _ = e1("../internals/regexp-exec-abstract"), h = e1("../internals/regexp-exec"), e1 = e1("../internals/fails"), f = [].push, x = Math.min, w = 4294967295, S = !e1(function() {
                    return !RegExp(w, "y");
                });
                o("split", 2, function(n, p, m) {
                    var y = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || 1 < ".".split(/()()/).length || "".split(/.?/).length ? function(e1, t) {
                        var r = String(d(this)), o = void 0 === t ? w : t >>> 0;
                        if (0 == o) return [];
                        if (void 0 === e1) return [
                            r
                        ];
                        if (!c(e1)) return p.call(r, e1, o);
                        for(var n, s, i, a = [], t = (e1.ignoreCase ? "i" : "") + (e1.multiline ? "m" : "") + (e1.unicode ? "u" : "") + (e1.sticky ? "y" : ""), l = 0, u = new RegExp(e1.source, t + "g"); (n = h.call(u, r)) && !(l < (s = u.lastIndex) && (a.push(r.slice(l, n.index)), 1 < n.length && n.index < r.length && f.apply(a, n.slice(1)), i = n[0].length, l = s, a.length >= o));)u.lastIndex === n.index && u.lastIndex++;
                        return l === r.length ? !i && u.test("") || a.push("") : a.push(r.slice(l)), a.length > o ? a.slice(0, o) : a;
                    } : "0".split(void 0, 0).length ? function(e1, t) {
                        return void 0 === e1 && 0 === t ? [] : p.call(this, e1, t);
                    } : p;
                    return [
                        function(e1, t) {
                            var r = d(this), o = null == e1 ? void 0 : e1[n];
                            return void 0 !== o ? o.call(e1, r, t) : y.call(String(r), e1, t);
                        },
                        function(e1, t) {
                            var r = m(y, e1, this, t, y !== p);
                            if (r.done) return r.value;
                            var r = g(e1), o = String(this), e1 = v(r, RegExp), n = r.unicode, s = (r.ignoreCase ? "i" : "") + (r.multiline ? "m" : "") + (r.unicode ? "u" : "") + (S ? "y" : "g"), i = new e1(S ? r : "^(?:" + r.source + ")", s), a = void 0 === t ? w : t >>> 0;
                            if (0 == a) return [];
                            if (0 === o.length) return null === _(i, o) ? [
                                o
                            ] : [];
                            for(var l = 0, u = 0, c = []; u < o.length;){
                                i.lastIndex = S ? u : 0;
                                var d, h = _(i, S ? o : o.slice(u));
                                if (null === h || (d = x(j(i.lastIndex + (S ? 0 : u)), o.length)) === l) u = b(o, u, n);
                                else {
                                    if (c.push(o.slice(l, u)), c.length === a) return c;
                                    for(var f = 1; f <= h.length - 1; f++)if (c.push(h[f]), c.length === a) return c;
                                    u = l = d;
                                }
                            }
                            return c.push(o.slice(l)), c;
                        }
                    ];
                }, !S);
            },
            {
                "../internals/advance-string-index": 8,
                "../internals/an-object": 10,
                "../internals/fails": 51,
                "../internals/fix-regexp-well-known-symbol-logic": 52,
                "../internals/is-regexp": 76,
                "../internals/regexp-exec": 110,
                "../internals/regexp-exec-abstract": 109,
                "../internals/require-object-coercible": 113,
                "../internals/species-constructor": 121,
                "../internals/to-length": 136
            }
        ],
        199: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/object-get-own-property-descriptor").f, s = e1("../internals/to-length"), i = e1("../internals/not-a-regexp"), a = e1("../internals/require-object-coercible"), l = e1("../internals/correct-is-regexp-logic"), e1 = e1("../internals/is-pure"), u = "".startsWith, c = Math.min, l = l("startsWith");
                o({
                    target: "String",
                    proto: !0,
                    forced: !!(e1 || l || !(o = n(String.prototype, "startsWith")) || o.writable) && !l
                }, {
                    startsWith: function(e1) {
                        var t = String(a(this)), r = (i(e1), s(c(1 < arguments.length ? arguments[1] : void 0, t.length))), e1 = String(e1);
                        return u ? u.call(t, e1, r) : t.slice(r, r + e1.length) === e1;
                    }
                });
            },
            {
                "../internals/correct-is-regexp-logic": 34,
                "../internals/export": 50,
                "../internals/is-pure": 75,
                "../internals/not-a-regexp": 87,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/require-object-coercible": 113,
                "../internals/to-length": 136
            }
        ],
        200: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/create-html");
                o({
                    target: "String",
                    proto: !0,
                    forced: e1("../internals/string-html-forced")("sub")
                }, {
                    sub: function() {
                        return n(this, "sub", "", "");
                    }
                });
            },
            {
                "../internals/create-html": 36,
                "../internals/export": 50,
                "../internals/string-html-forced": 122
            }
        ],
        201: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/string-trim").trim;
                o({
                    target: "String",
                    proto: !0,
                    forced: e1("../internals/string-trim-forced")("trim")
                }, {
                    trim: function() {
                        return n(this);
                    }
                });
            },
            {
                "../internals/export": 50,
                "../internals/string-trim": 129,
                "../internals/string-trim-forced": 128
            }
        ],
        202: [
            function(e1, t, r) {
                "use strict";
                var o, n, s, i, a, l = e1("../internals/export"), u = e1("../internals/descriptors"), c = e1("../internals/global"), d = e1("../internals/has"), h = e1("../internals/is-object"), f = e1("../internals/object-define-property").f, e1 = e1("../internals/copy-constructor-properties"), p = c.Symbol;
                !u || "function" != typeof p || "description" in p.prototype && void 0 === p().description || (o = {}, e1(n = function() {
                    var e1 = arguments.length < 1 || void 0 === arguments[0] ? void 0 : String(arguments[0]), t = this instanceof n ? new p(e1) : void 0 === e1 ? p() : p(e1);
                    return "" === e1 && (o[t] = !0), t;
                }, p), (c = n.prototype = p.prototype).constructor = n, s = c.toString, i = "Symbol(test)" == String(p("test")), a = /^Symbol\((.*)\)[^)]+$/, f(c, "description", {
                    configurable: !0,
                    get: function() {
                        var e1 = h(this) ? this.valueOf() : this, t = s.call(e1);
                        return d(o, e1) ? "" : "" === (e1 = i ? t.slice(7, -1) : t.replace(a, "$1")) ? void 0 : e1;
                    }
                }), l({
                    global: !0,
                    forced: !0
                }, {
                    Symbol: n
                }));
            },
            {
                "../internals/copy-constructor-properties": 33,
                "../internals/descriptors": 43,
                "../internals/export": 50,
                "../internals/global": 59,
                "../internals/has": 60,
                "../internals/is-object": 74,
                "../internals/object-define-property": 92
            }
        ],
        203: [
            function(e1, t, r) {
                e1("../internals/define-well-known-symbol")("iterator");
            },
            {
                "../internals/define-well-known-symbol": 42
            }
        ],
        204: [
            function(e1, D, F) {
                "use strict";
                function o(e1, t) {
                    var r = M[e1] = f(w[_]);
                    return ie(r, {
                        type: j,
                        tag: e1,
                        description: t
                    }), s || (r.description = t), r;
                }
                function r(t, e1) {
                    u(t);
                    var r = c(e1), e1 = q(r).concat(I(r));
                    return v(e1, function(e1) {
                        s && !R.call(r, e1) || L(t, e1, r[e1]);
                    }), t;
                }
                function t(e1, t) {
                    var r, e1 = c(e1), t = d(t, !0);
                    if (e1 !== x || !l(M, t) || l(E, t)) return !(r = le(e1, t)) || !l(M, t) || l(e1, b) && e1[b][t] || (r.enumerable = !0), r;
                }
                function U(e1) {
                    var e1 = ue(c(e1)), t = [];
                    return v(e1, function(e1) {
                        l(M, e1) || l(ee, e1) || t.push(e1);
                    }), t;
                }
                var n = e1("../internals/export"), N = e1("../internals/global"), B = e1("../internals/get-built-in"), G = e1("../internals/is-pure"), s = e1("../internals/descriptors"), i = e1("../internals/native-symbol"), V = e1("../internals/use-symbol-as-uid"), a = e1("../internals/fails"), l = e1("../internals/has"), z = e1("../internals/is-array"), H = e1("../internals/is-object"), u = e1("../internals/an-object"), W = e1("../internals/to-object"), c = e1("../internals/to-indexed-object"), d = e1("../internals/to-primitive"), h = e1("../internals/create-property-descriptor"), f = e1("../internals/object-create"), q = e1("../internals/object-keys"), X = e1("../internals/object-get-own-property-names"), Y = e1("../internals/object-get-own-property-names-external"), p = e1("../internals/object-get-own-property-symbols"), Z = e1("../internals/object-get-own-property-descriptor"), Q = e1("../internals/object-define-property"), J = e1("../internals/object-property-is-enumerable"), K = e1("../internals/create-non-enumerable-property"), m = e1("../internals/redefine"), y = e1("../internals/shared"), $ = e1("../internals/shared-key"), ee = e1("../internals/hidden-keys"), te = e1("../internals/uid"), re = e1("../internals/well-known-symbol"), oe = e1("../internals/well-known-symbol-wrapped"), ne = e1("../internals/define-well-known-symbol"), se = e1("../internals/set-to-string-tag"), g = e1("../internals/internal-state"), v = e1("../internals/array-iteration").forEach, b = $("hidden"), j = "Symbol", _ = "prototype", e1 = re("toPrimitive"), ie = g.set, ae = g.getterFor(j), x = Object[_], w = N.Symbol, S = B("JSON", "stringify"), le = Z.f, T = Q.f, ue = Y.f, ce = J.f, M = y("symbols"), E = y("op-symbols"), k = y("string-to-symbol-registry"), C = y("symbol-to-string-registry"), $ = y("wks"), g = N.QObject, O = !g || !g[_] || !g[_].findChild, P = s && a(function() {
                    return 7 != f(T({}, "a", {
                        get: function() {
                            return T(this, "a", {
                                value: 7
                            }).a;
                        }
                    })).a;
                }) ? function(e1, t, r) {
                    var o = le(x, t);
                    o && delete x[t], T(e1, t, r), o && e1 !== x && T(x, t, o);
                } : T, A = V ? function(e1) {
                    return "symbol" == typeof e1;
                } : function(e1) {
                    return Object(e1) instanceof w;
                }, L = function(e1, t, r) {
                    e1 === x && L(E, t, r), u(e1);
                    t = d(t, !0);
                    return u(r), (l(M, t) ? (r.enumerable ? (l(e1, b) && e1[b][t] && (e1[b][t] = !1), r = f(r, {
                        enumerable: h(0, !1)
                    })) : (l(e1, b) || T(e1, b, h(1, {})), e1[b][t] = !0), P) : T)(e1, t, r);
                }, R = function(e1) {
                    var e1 = d(e1, !0), t = ce.call(this, e1);
                    return !(this === x && l(M, e1) && !l(E, e1)) && (!(t || !l(this, e1) || !l(M, e1) || l(this, b) && this[b][e1]) || t);
                }, I = function(e1) {
                    var t = e1 === x, e1 = ue(t ? E : c(e1)), r = [];
                    return v(e1, function(e1) {
                        !l(M, e1) || t && !l(x, e1) || r.push(M[e1]);
                    }), r;
                };
                i || (m((w = function() {
                    if (this instanceof w) throw TypeError("Symbol is not a constructor");
                    var e1 = arguments.length && void 0 !== arguments[0] ? String(arguments[0]) : void 0, t = te(e1), r = function(e1) {
                        this === x && r.call(E, e1), l(this, b) && l(this[b], t) && (this[b][t] = !1), P(this, t, h(1, e1));
                    };
                    return s && O && P(x, t, {
                        configurable: !0,
                        set: r
                    }), o(t, e1);
                })[_], "toString", function() {
                    return ae(this).tag;
                }), m(w, "withoutSetter", function(e1) {
                    return o(te(e1), e1);
                }), J.f = R, Q.f = L, Z.f = t, X.f = Y.f = U, p.f = I, oe.f = function(e1) {
                    return o(re(e1), e1);
                }, s && (T(w[_], "description", {
                    configurable: !0,
                    get: function() {
                        return ae(this).description;
                    }
                }), G || m(x, "propertyIsEnumerable", R, {
                    unsafe: !0
                }))), n({
                    global: !0,
                    wrap: !0,
                    forced: !i,
                    sham: !i
                }, {
                    Symbol: w
                }), v(q($), function(e1) {
                    ne(e1);
                }), n({
                    target: j,
                    stat: !0,
                    forced: !i
                }, {
                    for: function(e1) {
                        var t, e1 = String(e1);
                        return l(k, e1) ? k[e1] : (t = w(e1), k[e1] = t, C[t] = e1, t);
                    },
                    keyFor: function(e1) {
                        if (!A(e1)) throw TypeError(e1 + " is not a symbol");
                        if (l(C, e1)) return C[e1];
                    },
                    useSetter: function() {
                        O = !0;
                    },
                    useSimple: function() {
                        O = !1;
                    }
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !i,
                    sham: !s
                }, {
                    create: function(e1, t) {
                        return void 0 === t ? f(e1) : r(f(e1), t);
                    },
                    defineProperty: L,
                    defineProperties: r,
                    getOwnPropertyDescriptor: t
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !i
                }, {
                    getOwnPropertyNames: U,
                    getOwnPropertySymbols: I
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: a(function() {
                        p.f(1);
                    })
                }, {
                    getOwnPropertySymbols: function(e1) {
                        return p.f(W(e1));
                    }
                }), S && n({
                    target: "JSON",
                    stat: !0,
                    forced: !i || a(function() {
                        var e1 = w();
                        return "[null]" != S([
                            e1
                        ]) || "{}" != S({
                            a: e1
                        }) || "{}" != S(Object(e1));
                    })
                }, {
                    stringify: function(e1, t, r) {
                        for(var o, n = [
                            e1
                        ], s = 1; s < arguments.length;)n.push(arguments[s++]);
                        if ((H(o = t) || void 0 !== e1) && !A(e1)) return z(t) || (t = function(e1, t) {
                            if ("function" == typeof o && (t = o.call(this, e1, t)), !A(t)) return t;
                        }), n[1] = t, S.apply(null, n);
                    }
                }), w[_][e1] || K(w[_], e1, w[_].valueOf), se(w, j), ee[b] = !0;
            },
            {
                "../internals/an-object": 10,
                "../internals/array-iteration": 19,
                "../internals/create-non-enumerable-property": 38,
                "../internals/create-property-descriptor": 39,
                "../internals/define-well-known-symbol": 42,
                "../internals/descriptors": 43,
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/get-built-in": 56,
                "../internals/global": 59,
                "../internals/has": 60,
                "../internals/hidden-keys": 61,
                "../internals/internal-state": 70,
                "../internals/is-array": 72,
                "../internals/is-object": 74,
                "../internals/is-pure": 75,
                "../internals/native-symbol": 83,
                "../internals/object-create": 90,
                "../internals/object-define-property": 92,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/object-get-own-property-names": 95,
                "../internals/object-get-own-property-names-external": 94,
                "../internals/object-get-own-property-symbols": 96,
                "../internals/object-keys": 99,
                "../internals/object-property-is-enumerable": 100,
                "../internals/redefine": 108,
                "../internals/set-to-string-tag": 117,
                "../internals/shared": 120,
                "../internals/shared-key": 118,
                "../internals/to-indexed-object": 134,
                "../internals/to-object": 137,
                "../internals/to-primitive": 140,
                "../internals/uid": 145,
                "../internals/use-symbol-as-uid": 146,
                "../internals/well-known-symbol": 148,
                "../internals/well-known-symbol-wrapped": 147
            }
        ],
        205: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-copy-within"), s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("copyWithin", function(e1, t) {
                    return n.call(s(this), e1, t, 2 < arguments.length ? arguments[2] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-copy-within": 14
            }
        ],
        206: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-iteration").every, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("every", function(e1) {
                    return n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19
            }
        ],
        207: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-fill"), s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("fill", function(e1) {
                    return n.apply(s(this), arguments);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-fill": 15
            }
        ],
        208: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), s = e1("../internals/array-iteration").filter, i = e1("../internals/species-constructor"), a = o.aTypedArray, l = o.aTypedArrayConstructor;
                (0, o.exportTypedArrayMethod)("filter", function(e1) {
                    for(var t = s(a(this), e1, 1 < arguments.length ? arguments[1] : void 0), e1 = i(this, this.constructor), r = 0, o = t.length, n = new (l(e1))(o); r < o;)n[r] = t[r++];
                    return n;
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19,
                "../internals/species-constructor": 121
            }
        ],
        209: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-iteration").findIndex, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("findIndex", function(e1) {
                    return n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19
            }
        ],
        210: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-iteration").find, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("find", function(e1) {
                    return n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19
            }
        ],
        211: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Float32", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 142
            }
        ],
        212: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Float64", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 142
            }
        ],
        213: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-iteration").forEach, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("forEach", function(e1) {
                    n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19
            }
        ],
        214: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-includes").includes, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("includes", function(e1) {
                    return n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-includes": 18
            }
        ],
        215: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-includes").indexOf, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("indexOf", function(e1) {
                    return n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-includes": 18
            }
        ],
        216: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Int16", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 142
            }
        ],
        217: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Int32", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 142
            }
        ],
        218: [
            function(e1, t, r) {
                "use strict";
                function o() {
                    return a.call(c(this));
                }
                var n = e1("../internals/global"), s = e1("../internals/array-buffer-view-core"), i = e1("../modules/es.array.iterator"), e1 = e1("../internals/well-known-symbol")("iterator"), n = n.Uint8Array, a = i.values, l = i.keys, u = i.entries, c = s.aTypedArray, i = s.exportTypedArrayMethod, s = n && n.prototype[e1], n = !!s && ("values" == s.name || null == s.name);
                i("entries", function() {
                    return u.call(c(this));
                }), i("keys", function() {
                    return l.call(c(this));
                }), i("values", o, !n), i(e1, o, !n);
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/global": 59,
                "../internals/well-known-symbol": 148,
                "../modules/es.array.iterator": 161
            }
        ],
        219: [
            function(e1, t, r) {
                "use strict";
                var e1 = e1("../internals/array-buffer-view-core"), o = e1.aTypedArray, e1 = e1.exportTypedArrayMethod, n = [].join;
                e1("join", function(e1) {
                    return n.apply(o(this), arguments);
                });
            },
            {
                "../internals/array-buffer-view-core": 12
            }
        ],
        220: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-last-index-of"), s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("lastIndexOf", function(e1) {
                    return n.apply(s(this), arguments);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-last-index-of": 20
            }
        ],
        221: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-iteration").map, s = e1("../internals/species-constructor"), i = o.aTypedArray, a = o.aTypedArrayConstructor;
                (0, o.exportTypedArrayMethod)("map", function(e1) {
                    return n(i(this), e1, 1 < arguments.length ? arguments[1] : void 0, function(e1, t) {
                        return new (a(s(e1, e1.constructor)))(t);
                    });
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19,
                "../internals/species-constructor": 121
            }
        ],
        222: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-reduce").right, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("reduceRight", function(e1) {
                    return n(s(this), e1, arguments.length, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-reduce": 24
            }
        ],
        223: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-reduce").left, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("reduce", function(e1) {
                    return n(s(this), e1, arguments.length, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-reduce": 24
            }
        ],
        224: [
            function(e1, t, r) {
                "use strict";
                var e1 = e1("../internals/array-buffer-view-core"), n = e1.aTypedArray, e1 = e1.exportTypedArrayMethod, s = Math.floor;
                e1("reverse", function() {
                    for(var e1, t = n(this).length, r = s(t / 2), o = 0; o < r;)e1 = this[o], this[o++] = this[--t], this[t] = e1;
                    return this;
                });
            },
            {
                "../internals/array-buffer-view-core": 12
            }
        ],
        225: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), i = e1("../internals/to-length"), a = e1("../internals/to-offset"), l = e1("../internals/to-object"), e1 = e1("../internals/fails"), u = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("set", function(e1) {
                    u(this);
                    var t = a(1 < arguments.length ? arguments[1] : void 0, 1), r = this.length, o = l(e1), n = i(o.length), s = 0;
                    if (r < n + t) throw RangeError("Wrong length");
                    for(; s < n;)this[t + s] = o[s++];
                }, e1(function() {
                    new Int8Array(1).set({});
                }));
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/fails": 51,
                "../internals/to-length": 136,
                "../internals/to-object": 137,
                "../internals/to-offset": 138
            }
        ],
        226: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), i = e1("../internals/species-constructor"), e1 = e1("../internals/fails"), a = o.aTypedArray, l = o.aTypedArrayConstructor, o = o.exportTypedArrayMethod, u = [].slice;
                o("slice", function(e1, t) {
                    for(var r = u.call(a(this), e1, t), e1 = i(this, this.constructor), o = 0, n = r.length, s = new (l(e1))(n); o < n;)s[o] = r[o++];
                    return s;
                }, e1(function() {
                    new Int8Array(1).slice();
                }));
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/fails": 51,
                "../internals/species-constructor": 121
            }
        ],
        227: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-iteration").some, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("some", function(e1) {
                    return n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19
            }
        ],
        228: [
            function(e1, t, r) {
                "use strict";
                var e1 = e1("../internals/array-buffer-view-core"), o = e1.aTypedArray, e1 = e1.exportTypedArrayMethod, n = [].sort;
                e1("sort", function(e1) {
                    return n.call(o(this), e1);
                });
            },
            {
                "../internals/array-buffer-view-core": 12
            }
        ],
        229: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/to-length"), s = e1("../internals/to-absolute-index"), i = e1("../internals/species-constructor"), a = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("subarray", function(e1, t) {
                    var r = a(this), o = r.length, e1 = s(e1, o);
                    return new (i(r, r.constructor))(r.buffer, r.byteOffset + e1 * r.BYTES_PER_ELEMENT, n((void 0 === t ? o : s(t, o)) - e1));
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/species-constructor": 121,
                "../internals/to-absolute-index": 132,
                "../internals/to-length": 136
            }
        ],
        230: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/global"), n = e1("../internals/array-buffer-view-core"), e1 = e1("../internals/fails"), s = o.Int8Array, i = n.aTypedArray, o = n.exportTypedArrayMethod, a = [].toLocaleString, l = [].slice, u = !!s && e1(function() {
                    a.call(new s(1));
                });
                o("toLocaleString", function() {
                    return a.apply(u ? l.call(i(this)) : i(this), arguments);
                }, e1(function() {
                    return [
                        1,
                        2
                    ].toLocaleString() != new s([
                        1,
                        2
                    ]).toLocaleString();
                }) || !e1(function() {
                    s.prototype.toLocaleString.call([
                        1,
                        2
                    ]);
                }));
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/fails": 51,
                "../internals/global": 59
            }
        ],
        231: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core").exportTypedArrayMethod, n = e1("../internals/fails"), e1 = e1("../internals/global").Uint8Array, e1 = e1 && e1.prototype || {}, s = [].toString, i = [].join, n = (n(function() {
                    s.call({});
                }) && (s = function() {
                    return i.call(this);
                }), e1.toString != s);
                o("toString", s, n);
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/fails": 51,
                "../internals/global": 59
            }
        ],
        232: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Uint16", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 142
            }
        ],
        233: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Uint32", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 142
            }
        ],
        234: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Uint8", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 142
            }
        ],
        235: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Uint8", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                }, !0);
            },
            {
                "../internals/typed-array-constructor": 142
            }
        ],
        236: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return function() {
                        return e1(this, arguments.length ? arguments[0] : void 0);
                    };
                }
                var n, s, i, a, l, u = e1("../internals/global"), c = e1("../internals/redefine-all"), d = e1("../internals/internal-metadata"), h = e1("../internals/collection"), f = e1("../internals/collection-weak"), p = e1("../internals/is-object"), m = e1("../internals/internal-state").enforce, e1 = e1("../internals/native-weak-map"), u = !u.ActiveXObject && "ActiveXObject" in u, y = Object.isExtensible, t = t.exports = h("WeakMap", o, f);
                e1 && u && (n = f.getConstructor(o, "WeakMap", !0), d.REQUIRED = !0, h = t.prototype, s = h.delete, i = h.has, a = h.get, l = h.set, c(h, {
                    delete: function(e1) {
                        var t;
                        return p(e1) && !y(e1) ? ((t = m(this)).frozen || (t.frozen = new n), s.call(this, e1) || t.frozen.delete(e1)) : s.call(this, e1);
                    },
                    has: function(e1) {
                        var t;
                        return p(e1) && !y(e1) ? ((t = m(this)).frozen || (t.frozen = new n), i.call(this, e1) || t.frozen.has(e1)) : i.call(this, e1);
                    },
                    get: function(e1) {
                        var t;
                        return !p(e1) || y(e1) || ((t = m(this)).frozen || (t.frozen = new n), i.call(this, e1)) ? a.call(this, e1) : t.frozen.get(e1);
                    },
                    set: function(e1, t) {
                        var r;
                        return !p(e1) || y(e1) || ((r = m(this)).frozen || (r.frozen = new n), i.call(this, e1)) ? l.call(this, e1, t) : r.frozen.set(e1, t), this;
                    }
                }));
            },
            {
                "../internals/collection": 32,
                "../internals/collection-weak": 31,
                "../internals/global": 59,
                "../internals/internal-metadata": 69,
                "../internals/internal-state": 70,
                "../internals/is-object": 74,
                "../internals/native-weak-map": 85,
                "../internals/redefine-all": 107
            }
        ],
        237: [
            function(e1, t, r) {
                var o, n = e1("../internals/global"), s = e1("../internals/dom-iterables"), i = e1("../internals/array-for-each"), a = e1("../internals/create-non-enumerable-property");
                for(o in s){
                    var l = n[o], l = l && l.prototype;
                    if (l && l.forEach !== i) try {
                        a(l, "forEach", i);
                    } catch (e1) {
                        l.forEach = i;
                    }
                }
            },
            {
                "../internals/array-for-each": 16,
                "../internals/create-non-enumerable-property": 38,
                "../internals/dom-iterables": 45,
                "../internals/global": 59
            }
        ],
        238: [
            function(e1, t, r) {
                var o, n = e1("../internals/global"), s = e1("../internals/dom-iterables"), i = e1("../modules/es.array.iterator"), a = e1("../internals/create-non-enumerable-property"), e1 = e1("../internals/well-known-symbol"), l = e1("iterator"), u = e1("toStringTag"), c = i.values;
                for(o in s){
                    var d = n[o], h = d && d.prototype;
                    if (h) {
                        if (h[l] !== c) try {
                            a(h, l, c);
                        } catch (e1) {
                            h[l] = c;
                        }
                        if (h[u] || a(h, u, o), s[o]) {
                            for(var f in i)if (h[f] !== i[f]) try {
                                a(h, f, i[f]);
                            } catch (e1) {
                                h[f] = i[f];
                            }
                        }
                    }
                }
            },
            {
                "../internals/create-non-enumerable-property": 38,
                "../internals/dom-iterables": 45,
                "../internals/global": 59,
                "../internals/well-known-symbol": 148,
                "../modules/es.array.iterator": 161
            }
        ],
        239: [
            function(e1, t, D) {
                "use strict";
                e1("../modules/es.array.iterator");
                function n(t) {
                    try {
                        return decodeURIComponent(t);
                    } catch (e1) {
                        return t;
                    }
                }
                function r(e1) {
                    return B[e1];
                }
                function s(e1) {
                    return encodeURIComponent(e1).replace(N, r);
                }
                function c(e1) {
                    this.entries.length = 0, R(this.entries, e1);
                }
                function u(e1, t) {
                    if (e1 < t) throw TypeError("Not enough arguments");
                }
                function d() {
                    y(this, d, k);
                    var e1, t, r, o, n, s, i, a, l = 0 < arguments.length ? arguments[0] : void 0, u = [];
                    if (O(this, {
                        type: k,
                        entries: u,
                        updateURL: function() {},
                        updateSearchParams: c
                    }), void 0 !== l) {
                        if (_(l)) {
                            if ("function" == typeof (e1 = T(l))) for(r = (t = e1.call(l)).next; !(o = r.call(t)).done;){
                                if ((s = (n = (o = S(j(o.value))).next).call(o)).done || (i = n.call(o)).done || !n.call(o).done) throw TypeError("Expected sequence with length 2");
                                u.push({
                                    key: s.value + "",
                                    value: i.value + ""
                                });
                            }
                            else for(a in l)g(l, a) && u.push({
                                key: a,
                                value: l[a] + ""
                            });
                        } else R(u, "string" == typeof l ? "?" === l.charAt(0) ? l.slice(1) : l : l + "");
                    }
                }
                var o = e1("../internals/export"), i = e1("../internals/get-built-in"), a = e1("../internals/native-url"), l = e1("../internals/redefine"), h = e1("../internals/redefine-all"), f = e1("../internals/set-to-string-tag"), p = e1("../internals/create-iterator-constructor"), m = e1("../internals/internal-state"), y = e1("../internals/an-instance"), g = e1("../internals/has"), v = e1("../internals/function-bind-context"), b = e1("../internals/classof"), j = e1("../internals/an-object"), _ = e1("../internals/is-object"), x = e1("../internals/object-create"), w = e1("../internals/create-property-descriptor"), S = e1("../internals/get-iterator"), T = e1("../internals/get-iterator-method"), e1 = e1("../internals/well-known-symbol"), M = i("fetch"), E = i("Headers"), i = e1("iterator"), k = "URLSearchParams", C = k + "Iterator", O = m.set, P = m.getterFor(k), F = m.getterFor(C), U = /\+/g, A = Array(4), L = function(e1) {
                    var t, r = e1.replace(U, " "), o = 4;
                    try {
                        return decodeURIComponent(r);
                    } catch (e1) {
                        for(; o;)r = r.replace((t = o--, A[t - 1] || (A[t - 1] = RegExp("((?:%[\\da-f]{2}){" + t + "})", "gi"))), n);
                        return r;
                    }
                }, N = /[!'()~]|%20/g, B = {
                    "!": "%21",
                    "'": "%27",
                    "(": "%28",
                    ")": "%29",
                    "~": "%7E",
                    "%20": "+"
                }, R = function(e1, t) {
                    if (t) for(var r, o = t.split("&"), n = 0; n < o.length;)(r = o[n++]).length && (r = r.split("="), e1.push({
                        key: L(r.shift()),
                        value: L(r.join("="))
                    }));
                }, I = p(function(e1, t) {
                    O(this, {
                        type: C,
                        iterator: S(P(e1).entries),
                        kind: t
                    });
                }, "Iterator", function() {
                    var e1 = F(this), t = e1.kind, e1 = e1.iterator.next(), r = e1.value;
                    return e1.done || (e1.value = "keys" === t ? r.key : "values" === t ? r.value : [
                        r.key,
                        r.value
                    ]), e1;
                }), e1 = d.prototype;
                h(e1, {
                    append: function(e1, t) {
                        u(arguments.length, 2);
                        var r = P(this);
                        r.entries.push({
                            key: e1 + "",
                            value: t + ""
                        }), r.updateURL();
                    },
                    delete: function(e1) {
                        u(arguments.length, 1);
                        for(var t = P(this), r = t.entries, o = e1 + "", n = 0; n < r.length;)r[n].key === o ? r.splice(n, 1) : n++;
                        t.updateURL();
                    },
                    get: function(e1) {
                        u(arguments.length, 1);
                        for(var t = P(this).entries, r = e1 + "", o = 0; o < t.length; o++)if (t[o].key === r) return t[o].value;
                        return null;
                    },
                    getAll: function(e1) {
                        u(arguments.length, 1);
                        for(var t = P(this).entries, r = e1 + "", o = [], n = 0; n < t.length; n++)t[n].key === r && o.push(t[n].value);
                        return o;
                    },
                    has: function(e1) {
                        u(arguments.length, 1);
                        for(var t = P(this).entries, r = e1 + "", o = 0; o < t.length;)if (t[o++].key === r) return !0;
                        return !1;
                    },
                    set: function(e1, t) {
                        u(arguments.length, 1);
                        for(var r, o = P(this), n = o.entries, s = !1, i = e1 + "", a = t + "", l = 0; l < n.length; l++)(r = n[l]).key === i && (s ? n.splice(l--, 1) : (s = !0, r.value = a));
                        s || n.push({
                            key: i,
                            value: a
                        }), o.updateURL();
                    },
                    sort: function() {
                        for(var e1, t, r = P(this), o = r.entries, n = o.slice(), s = o.length = 0; s < n.length; s++){
                            for(e1 = n[s], t = 0; t < s; t++)if (o[t].key > e1.key) {
                                o.splice(t, 0, e1);
                                break;
                            }
                            t === s && o.push(e1);
                        }
                        r.updateURL();
                    },
                    forEach: function(e1) {
                        for(var t, r = P(this).entries, o = v(e1, 1 < arguments.length ? arguments[1] : void 0, 3), n = 0; n < r.length;)o((t = r[n++]).value, t.key, this);
                    },
                    keys: function() {
                        return new I(this, "keys");
                    },
                    values: function() {
                        return new I(this, "values");
                    },
                    entries: function() {
                        return new I(this, "entries");
                    }
                }, {
                    enumerable: !0
                }), l(e1, i, e1.entries), l(e1, "toString", function() {
                    for(var e1, t = P(this).entries, r = [], o = 0; o < t.length;)e1 = t[o++], r.push(s(e1.key) + "=" + s(e1.value));
                    return r.join("&");
                }, {
                    enumerable: !0
                }), f(d, k), o({
                    global: !0,
                    forced: !a
                }, {
                    URLSearchParams: d
                }), a || "function" != typeof M || "function" != typeof E || o({
                    global: !0,
                    enumerable: !0,
                    forced: !0
                }, {
                    fetch: function(e1) {
                        var t, r, o, e1 = [
                            e1
                        ];
                        return 1 < arguments.length && (_(t = arguments[1]) && (r = t.body, b(r) === k && ((o = t.headers ? new E(t.headers) : new E).has("content-type") || o.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"), t = x(t, {
                            body: w(0, String(r)),
                            headers: w(0, o)
                        }))), e1.push(t)), M.apply(this, e1);
                    }
                }), t.exports = {
                    URLSearchParams: d,
                    getState: P
                };
            },
            {
                "../internals/an-instance": 9,
                "../internals/an-object": 10,
                "../internals/classof": 29,
                "../internals/create-iterator-constructor": 37,
                "../internals/create-property-descriptor": 39,
                "../internals/export": 50,
                "../internals/function-bind-context": 54,
                "../internals/get-built-in": 56,
                "../internals/get-iterator": 58,
                "../internals/get-iterator-method": 57,
                "../internals/has": 60,
                "../internals/internal-state": 70,
                "../internals/is-object": 74,
                "../internals/native-url": 84,
                "../internals/object-create": 90,
                "../internals/redefine": 108,
                "../internals/redefine-all": 107,
                "../internals/set-to-string-tag": 117,
                "../internals/well-known-symbol": 148,
                "../modules/es.array.iterator": 161
            }
        ],
        240: [
            function(e1, y, F) {
                "use strict";
                e1("../modules/es.string.iterator");
                function c(e1) {
                    var t, r, o, n;
                    if ("number" == typeof e1) {
                        for(t = [], r = 0; r < 4; r++)t.unshift(e1 % 256), e1 = Y(e1 / 256);
                        return t.join(".");
                    }
                    if ("object" != typeof e1) return e1;
                    for(t = "", o = le(e1), r = 0; r < 8; r++)n && 0 === e1[r] || (n = n && !1, o === r ? (t += r ? ":" : "::", n = !0) : (t += e1[r].toString(16), r < 7 && (t += ":")));
                    return "[" + t + "]";
                }
                function n(e1) {
                    return !e1.host || e1.cannotBeABaseURL || "file" == e1.scheme;
                }
                function a(e1, t, r, o) {
                    var n, s, i, a = r || me, l = 0, u = "", c = !1, d = !1, h = !1;
                    for(r || (e1.scheme = "", e1.username = "", e1.password = "", e1.host = null, e1.port = null, e1.path = [], e1.query = null, e1.fragment = null, e1.cannotBeABaseURL = !1, t = t.replace(ie, "")), t = t.replace(ae, ""), n = b(t); l <= n.length;){
                        switch(s = n[l], a){
                            case me:
                                if (!s || !K.test(s)) {
                                    if (r) return j;
                                    a = ge;
                                    continue;
                                }
                                u += s.toLowerCase(), a = ye;
                                break;
                            case ye:
                                if (s && ($.test(s) || "+" == s || "-" == s || "." == s)) u += s.toLowerCase();
                                else {
                                    if (":" != s) {
                                        if (r) return j;
                                        u = "", a = ge, l = 0;
                                        continue;
                                    }
                                    if (r && (k(e1) != v(E, u) || "file" == u && (C(e1) || null !== e1.port) || "file" == e1.scheme && !e1.host)) return;
                                    if (e1.scheme = u, r) return void (k(e1) && E[e1.scheme] == e1.port && (e1.port = null));
                                    u = "", "file" == e1.scheme ? a = Me : k(e1) && o && o.scheme == e1.scheme ? a = ve : k(e1) ? a = xe : "/" == n[l + 1] ? (a = be, l++) : (e1.cannotBeABaseURL = !0, e1.path.push(""), a = Ce);
                                }
                                break;
                            case ge:
                                if (!o || o.cannotBeABaseURL && "#" != s) return j;
                                if (o.cannotBeABaseURL && "#" == s) {
                                    e1.scheme = o.scheme, e1.path = o.path.slice(), e1.query = o.query, e1.fragment = "", e1.cannotBeABaseURL = !0, a = D;
                                    break;
                                }
                                a = "file" == o.scheme ? Me : je;
                                continue;
                            case ve:
                                if ("/" != s || "/" != n[l + 1]) {
                                    a = je;
                                    continue;
                                }
                                a = P, l++;
                                break;
                            case be:
                                if ("/" == s) {
                                    a = A;
                                    break;
                                }
                                a = R;
                                continue;
                            case je:
                                if (e1.scheme = o.scheme, s == g) e1.username = o.username, e1.password = o.password, e1.host = o.host, e1.port = o.port, e1.path = o.path.slice(), e1.query = o.query;
                                else if ("/" == s || "\\" == s && k(e1)) a = _e;
                                else if ("?" == s) e1.username = o.username, e1.password = o.password, e1.host = o.host, e1.port = o.port, e1.path = o.path.slice(), e1.query = "", a = I;
                                else {
                                    if ("#" != s) {
                                        e1.username = o.username, e1.password = o.password, e1.host = o.host, e1.port = o.port, e1.path = o.path.slice(), e1.path.pop(), a = R;
                                        continue;
                                    }
                                    e1.username = o.username, e1.password = o.password, e1.host = o.host, e1.port = o.port, e1.path = o.path.slice(), e1.query = o.query, e1.fragment = "", a = D;
                                }
                                break;
                            case _e:
                                if (!k(e1) || "/" != s && "\\" != s) {
                                    if ("/" != s) {
                                        e1.username = o.username, e1.password = o.password, e1.host = o.host, e1.port = o.port, a = R;
                                        continue;
                                    }
                                    a = A;
                                } else a = P;
                                break;
                            case xe:
                                if (a = P, "/" != s || "/" != u.charAt(l + 1)) continue;
                                l++;
                                break;
                            case P:
                                if ("/" == s || "\\" == s) break;
                                a = A;
                                continue;
                            case A:
                                if ("@" == s) {
                                    c && (u = "%40" + u);
                                    for(var c = !0, f = b(u), p = 0; p < f.length; p++){
                                        var m = f[p];
                                        ":" != m || h ? (m = M(m, T), h ? e1.password += m : e1.username += m) : h = !0;
                                    }
                                    u = "";
                                } else if (s == g || "/" == s || "?" == s || "#" == s || "\\" == s && k(e1)) {
                                    if (c && "" == u) return Q;
                                    l -= b(u).length + 1, u = "", a = we;
                                } else u += s;
                                break;
                            case we:
                            case Se:
                                if (r && "file" == e1.scheme) {
                                    a = ke;
                                    continue;
                                }
                                if (":" != s || d) {
                                    if (s == g || "/" == s || "?" == s || "#" == s || "\\" == s && k(e1)) {
                                        if (k(e1) && "" == u) return _;
                                        if (r && "" == u && (C(e1) || null !== e1.port)) return;
                                        if (i = w(e1, u)) return i;
                                        if (u = "", a = L, r) return;
                                        continue;
                                    }
                                    "[" == s ? d = !0 : "]" == s && (d = !1), u += s;
                                } else {
                                    if ("" == u) return _;
                                    if (i = w(e1, u)) return i;
                                    if (u = "", a = Te, r == Se) return;
                                }
                                break;
                            case Te:
                                if (!x.test(s)) {
                                    if (s == g || "/" == s || "?" == s || "#" == s || "\\" == s && k(e1) || r) {
                                        if ("" != u) {
                                            var y = parseInt(u, 10);
                                            if (65535 < y) return J;
                                            e1.port = k(e1) && y === E[e1.scheme] ? null : y, u = "";
                                        }
                                        if (r) return;
                                        a = L;
                                        continue;
                                    }
                                    return J;
                                }
                                u += s;
                                break;
                            case Me:
                                if (e1.scheme = "file", "/" == s || "\\" == s) a = Ee;
                                else {
                                    if (!o || "file" != o.scheme) {
                                        a = R;
                                        continue;
                                    }
                                    if (s == g) e1.host = o.host, e1.path = o.path.slice(), e1.query = o.query;
                                    else if ("?" == s) e1.host = o.host, e1.path = o.path.slice(), e1.query = "", a = I;
                                    else {
                                        if ("#" != s) {
                                            de(n.slice(l).join("")) || (e1.host = o.host, e1.path = o.path.slice(), he(e1)), a = R;
                                            continue;
                                        }
                                        e1.host = o.host, e1.path = o.path.slice(), e1.query = o.query, e1.fragment = "", a = D;
                                    }
                                }
                                break;
                            case Ee:
                                if ("/" == s || "\\" == s) {
                                    a = ke;
                                    break;
                                }
                                o && "file" == o.scheme && !de(n.slice(l).join("")) && (O(o.path[0], !0) ? e1.path.push(o.path[0]) : e1.host = o.host), a = R;
                                continue;
                            case ke:
                                if (s == g || "/" == s || "\\" == s || "?" == s || "#" == s) {
                                    if (!r && O(u)) a = R;
                                    else {
                                        if ("" == u) {
                                            if (e1.host = "", r) return;
                                        } else {
                                            if (i = w(e1, u)) return i;
                                            if ("localhost" == e1.host && (e1.host = ""), r) return;
                                            u = "";
                                        }
                                        a = L;
                                    }
                                    continue;
                                }
                                u += s;
                                break;
                            case L:
                                if (k(e1)) {
                                    if (a = R, "/" != s && "\\" != s) continue;
                                } else if (r || "?" != s) {
                                    if (r || "#" != s) {
                                        if (s != g && (a = R, "/" != s)) continue;
                                    } else e1.fragment = "", a = D;
                                } else e1.query = "", a = I;
                                break;
                            case R:
                                if (s == g || "/" == s || "\\" == s && k(e1) || !r && ("?" == s || "#" == s)) {
                                    if (pe(u) ? (he(e1), "/" == s || "\\" == s && k(e1) || e1.path.push("")) : fe(u) ? "/" == s || "\\" == s && k(e1) || e1.path.push("") : ("file" == e1.scheme && !e1.path.length && O(u) && (e1.host && (e1.host = ""), u = u.charAt(0) + ":"), e1.path.push(u)), u = "", "file" == e1.scheme && (s == g || "?" == s || "#" == s)) for(; 1 < e1.path.length && "" === e1.path[0];)e1.path.shift();
                                    "?" == s ? (e1.query = "", a = I) : "#" == s && (e1.fragment = "", a = D);
                                } else u += M(s, ce);
                                break;
                            case Ce:
                                "?" == s ? (e1.query = "", a = I) : "#" == s ? (e1.fragment = "", a = D) : s != g && (e1.path[0] += M(s, S));
                                break;
                            case I:
                                r || "#" != s ? s != g && ("'" == s && k(e1) ? e1.query += "%27" : e1.query += "#" == s ? "%23" : M(s, S)) : (e1.fragment = "", a = D);
                                break;
                            case D:
                                s != g && (e1.fragment += M(s, ue));
                        }
                        l++;
                    }
                }
                function l(e1) {
                    var t, r, o = G(this, l, "URL"), n = 1 < arguments.length ? arguments[1] : void 0, e1 = String(e1), s = X(o, {
                        type: "URL"
                    });
                    if (void 0 !== n) {
                        if (n instanceof l) t = p(n);
                        else if (r = a(t = {}, String(n))) throw TypeError(r);
                    }
                    if (r = a(s, e1, null, t)) throw TypeError(r);
                    var i = s.searchParams = new q;
                    (n = f(i)).updateSearchParams(s.query), n.updateURL = function() {
                        s.query = String(i) || null;
                    }, u || (o.href = m.call(o), o.origin = Oe.call(o), o.protocol = Pe.call(o), o.username = Ae.call(o), o.password = Le.call(o), o.host = Re.call(o), o.hostname = Ie.call(o), o.port = De.call(o), o.pathname = Fe.call(o), o.search = Ue.call(o), o.searchParams = Ne.call(o), o.hash = Be.call(o));
                }
                function t(e1, t) {
                    return {
                        get: e1,
                        set: t,
                        configurable: !0,
                        enumerable: !0
                    };
                }
                var g, r, o, U = e1("../internals/export"), u = e1("../internals/descriptors"), N = e1("../internals/native-url"), s = e1("../internals/global"), B = e1("../internals/object-define-properties"), i = e1("../internals/redefine"), G = e1("../internals/an-instance"), v = e1("../internals/has"), d = e1("../internals/object-assign"), b = e1("../internals/array-from"), V = e1("../internals/string-multibyte").codeAt, z = e1("../internals/string-punycode-to-ascii"), H = e1("../internals/set-to-string-tag"), W = e1("../modules/web.url-search-params"), e1 = e1("../internals/internal-state"), h = s.URL, q = W.URLSearchParams, f = W.getState, X = e1.set, p = e1.getterFor("URL"), Y = Math.floor, Z = Math.pow, Q = "Invalid authority", j = "Invalid scheme", _ = "Invalid host", J = "Invalid port", K = /[A-Za-z]/, $ = /[\d+-.A-Za-z]/, x = /\d/, ee = /^(0x|0X)/, te = /^[0-7]+$/, re = /^\d+$/, oe = /^[\dA-Fa-f]+$/, ne = /[\u0000\u0009\u000A\u000D #%/:?@[\\]]/, se = /[\u0000\u0009\u000A\u000D #/:?@[\\]]/, ie = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g, ae = /[\u0009\u000A\u000D]/g, w = function(e1, t) {
                    var r, o, n;
                    if ("[" == t.charAt(0)) return "]" == t.charAt(t.length - 1) && (r = function(e1) {
                        var t = [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ], r = 0, o = null, n = 0, s, i, a, l, u, c, d, h = function() {
                            return e1.charAt(n);
                        };
                        if (h() == ":") {
                            if (e1.charAt(1) != ":") return;
                            n += 2;
                            r++;
                            o = r;
                        }
                        while(h()){
                            if (r == 8) return;
                            if (h() == ":") {
                                if (o !== null) return;
                                n++;
                                r++;
                                o = r;
                                continue;
                            }
                            s = i = 0;
                            while(i < 4 && oe.test(h())){
                                s = s * 16 + parseInt(h(), 16);
                                n++;
                                i++;
                            }
                            if (h() == ".") {
                                if (i == 0) return;
                                n -= i;
                                if (r > 6) return;
                                a = 0;
                                while(h()){
                                    l = null;
                                    if (a > 0) {
                                        if (h() == "." && a < 4) n++;
                                        else return;
                                    }
                                    if (!x.test(h())) return;
                                    while(x.test(h())){
                                        u = parseInt(h(), 10);
                                        if (l === null) l = u;
                                        else if (l == 0) return;
                                        else l = l * 10 + u;
                                        if (l > 255) return;
                                        n++;
                                    }
                                    t[r] = t[r] * 256 + l;
                                    a++;
                                    if (a == 2 || a == 4) r++;
                                }
                                if (a != 4) return;
                                break;
                            } else if (h() == ":") {
                                n++;
                                if (!h()) return;
                            } else if (h()) return;
                            t[r++] = s;
                        }
                        if (o !== null) {
                            c = r - o;
                            r = 7;
                            while(r != 0 && c > 0){
                                d = t[r];
                                t[r--] = t[o + c - 1];
                                t[o + --c] = d;
                            }
                        } else if (r != 8) return;
                        return t;
                    }(t.slice(1, -1))) ? void (e1.host = r) : _;
                    if (k(e1)) return t = z(t), ne.test(t) || null === (r = function(e1) {
                        var t = e1.split("."), r, o, n, s, i, a, l;
                        if (t.length && t[t.length - 1] == "") t.pop();
                        if ((r = t.length) > 4) return e1;
                        for(o = [], n = 0; n < r; n++){
                            s = t[n];
                            if (s == "") return e1;
                            i = 10;
                            if (s.length > 1 && s.charAt(0) == "0") {
                                i = ee.test(s) ? 16 : 8;
                                s = s.slice(i == 8 ? 1 : 2);
                            }
                            if (s === "") a = 0;
                            else {
                                if (!(i == 10 ? re : i == 8 ? te : oe).test(s)) return e1;
                                a = parseInt(s, i);
                            }
                            o.push(a);
                        }
                        for(n = 0; n < r; n++){
                            a = o[n];
                            if (n == r - 1) {
                                if (a >= Z(256, 5 - r)) return null;
                            } else if (a > 255) return null;
                        }
                        for(l = o.pop(), n = 0; n < o.length; n++)l += o[n] * Z(256, 3 - n);
                        return l;
                    }(t)) ? _ : void (e1.host = r);
                    if (se.test(t)) return _;
                    for(r = "", o = b(t), n = 0; n < o.length; n++)r += M(o[n], S);
                    e1.host = r;
                }, le = function(e1) {
                    for(var t = null, r = 1, o = null, n = 0, s = 0; s < 8; s++)0 !== e1[s] ? (r < n && (t = o, r = n), o = null, n = 0) : (null === o && (o = s), ++n);
                    return r < n && (t = o, r = n), t;
                }, S = {}, ue = d({}, S, {
                    " ": 1,
                    '"': 1,
                    "<": 1,
                    ">": 1,
                    "`": 1
                }), ce = d({}, ue, {
                    "#": 1,
                    "?": 1,
                    "{": 1,
                    "}": 1
                }), T = d({}, ce, {
                    "/": 1,
                    ":": 1,
                    ";": 1,
                    "=": 1,
                    "@": 1,
                    "[": 1,
                    "\\": 1,
                    "]": 1,
                    "^": 1,
                    "|": 1
                }), M = function(e1, t) {
                    var r = V(e1, 0);
                    return 32 < r && r < 127 && !v(t, e1) ? e1 : encodeURIComponent(e1);
                }, E = {
                    ftp: 21,
                    file: null,
                    http: 80,
                    https: 443,
                    ws: 80,
                    wss: 443
                }, k = function(e1) {
                    return v(E, e1.scheme);
                }, C = function(e1) {
                    return "" != e1.username || "" != e1.password;
                }, O = function(e1, t) {
                    return 2 == e1.length && K.test(e1.charAt(0)) && (":" == (e1 = e1.charAt(1)) || !t && "|" == e1);
                }, de = function(e1) {
                    return 1 < e1.length && O(e1.slice(0, 2)) && (2 == e1.length || "/" === (e1 = e1.charAt(2)) || "\\" === e1 || "?" === e1 || "#" === e1);
                }, he = function(e1) {
                    var t = e1.path, r = t.length;
                    !r || "file" == e1.scheme && 1 == r && O(t[0], !0) || t.pop();
                }, fe = function(e1) {
                    return "." === e1 || "%2e" === e1.toLowerCase();
                }, pe = function(e1) {
                    return ".." === (e1 = e1.toLowerCase()) || "%2e." === e1 || ".%2e" === e1 || "%2e%2e" === e1;
                }, me = {}, ye = {}, ge = {}, ve = {}, be = {}, je = {}, _e = {}, xe = {}, P = {}, A = {}, we = {}, Se = {}, Te = {}, Me = {}, Ee = {}, ke = {}, L = {}, R = {}, Ce = {}, I = {}, D = {}, s = l.prototype, m = function() {
                    var e1 = p(this), t = e1.scheme, r = e1.username, o = e1.password, n = e1.host, s = e1.port, i = e1.path, a = e1.query, l = e1.fragment, u = t + ":";
                    return null !== n ? (u += "//", C(e1) && (u += r + (o ? ":" + o : "") + "@"), u += c(n), null !== s && (u += ":" + s)) : "file" == t && (u += "//"), u += e1.cannotBeABaseURL ? i[0] : i.length ? "/" + i.join("/") : "", null !== a && (u += "?" + a), null !== l && (u += "#" + l), u;
                }, Oe = function() {
                    var e1 = p(this), t = e1.scheme, r = e1.port;
                    if ("blob" == t) try {
                        return new URL(t.path[0]).origin;
                    } catch (e1) {
                        return "null";
                    }
                    return "file" != t && k(e1) ? t + "://" + c(e1.host) + (null !== r ? ":" + r : "") : "null";
                }, Pe = function() {
                    return p(this).scheme + ":";
                }, Ae = function() {
                    return p(this).username;
                }, Le = function() {
                    return p(this).password;
                }, Re = function() {
                    var e1 = p(this), t = e1.host, e1 = e1.port;
                    return null === t ? "" : null === e1 ? c(t) : c(t) + ":" + e1;
                }, Ie = function() {
                    var e1 = p(this).host;
                    return null === e1 ? "" : c(e1);
                }, De = function() {
                    var e1 = p(this).port;
                    return null === e1 ? "" : String(e1);
                }, Fe = function() {
                    var e1 = p(this), t = e1.path;
                    return e1.cannotBeABaseURL ? t[0] : t.length ? "/" + t.join("/") : "";
                }, Ue = function() {
                    var e1 = p(this).query;
                    return e1 ? "?" + e1 : "";
                }, Ne = function() {
                    return p(this).searchParams;
                }, Be = function() {
                    var e1 = p(this).fragment;
                    return e1 ? "#" + e1 : "";
                };
                u && B(s, {
                    href: t(m, function(e1) {
                        var t = p(this), e1 = String(e1), e1 = a(t, e1);
                        if (e1) throw TypeError(e1);
                        f(t.searchParams).updateSearchParams(t.query);
                    }),
                    origin: t(Oe),
                    protocol: t(Pe, function(e1) {
                        var t = p(this);
                        a(t, String(e1) + ":", me);
                    }),
                    username: t(Ae, function(e1) {
                        var t = p(this), r = b(String(e1));
                        if (!n(t)) {
                            t.username = "";
                            for(var o = 0; o < r.length; o++)t.username += M(r[o], T);
                        }
                    }),
                    password: t(Le, function(e1) {
                        var t = p(this), r = b(String(e1));
                        if (!n(t)) {
                            t.password = "";
                            for(var o = 0; o < r.length; o++)t.password += M(r[o], T);
                        }
                    }),
                    host: t(Re, function(e1) {
                        var t = p(this);
                        t.cannotBeABaseURL || a(t, String(e1), we);
                    }),
                    hostname: t(Ie, function(e1) {
                        var t = p(this);
                        t.cannotBeABaseURL || a(t, String(e1), Se);
                    }),
                    port: t(De, function(e1) {
                        var t = p(this);
                        n(t) || ("" == (e1 = String(e1)) ? t.port = null : a(t, e1, Te));
                    }),
                    pathname: t(Fe, function(e1) {
                        var t = p(this);
                        t.cannotBeABaseURL || (t.path = [], a(t, e1 + "", L));
                    }),
                    search: t(Ue, function(e1) {
                        var t = p(this);
                        "" == (e1 = String(e1)) ? t.query = null : ("?" == e1.charAt(0) && (e1 = e1.slice(1)), t.query = "", a(t, e1, I)), f(t.searchParams).updateSearchParams(t.query);
                    }),
                    searchParams: t(Ne),
                    hash: t(Be, function(e1) {
                        var t = p(this);
                        "" == (e1 = String(e1)) ? t.fragment = null : ("#" == e1.charAt(0) && (e1 = e1.slice(1)), t.fragment = "", a(t, e1, D));
                    })
                }), i(s, "toJSON", function() {
                    return m.call(this);
                }, {
                    enumerable: !0
                }), i(s, "toString", function() {
                    return m.call(this);
                }, {
                    enumerable: !0
                }), h && (r = h.createObjectURL, o = h.revokeObjectURL, r && i(l, "createObjectURL", function(e1) {
                    return r.apply(h, arguments);
                }), o && i(l, "revokeObjectURL", function(e1) {
                    return o.apply(h, arguments);
                })), H(l, "URL"), U({
                    global: !0,
                    forced: !N,
                    sham: !u
                }, {
                    URL: l
                });
            },
            {
                "../internals/an-instance": 9,
                "../internals/array-from": 17,
                "../internals/descriptors": 43,
                "../internals/export": 50,
                "../internals/global": 59,
                "../internals/has": 60,
                "../internals/internal-state": 70,
                "../internals/native-url": 84,
                "../internals/object-assign": 89,
                "../internals/object-define-properties": 91,
                "../internals/redefine": 108,
                "../internals/set-to-string-tag": 117,
                "../internals/string-multibyte": 123,
                "../internals/string-punycode-to-ascii": 126,
                "../modules/es.string.iterator": 192,
                "../modules/web.url-search-params": 239
            }
        ],
        241: [
            function(e1, t, r) {
                "use strict";
                t.exports = e1("./").polyfill();
            },
            {
                "./": 242
            }
        ],
        242: [
            function(V, r, o) {
                (function(B, G) {
                    var e1, t;
                    e1 = this, t = function() {
                        "use strict";
                        function l(e1) {
                            return "function" == typeof e1;
                        }
                        var r = Array.isArray || function(e1) {
                            return "[object Array]" === Object.prototype.toString.call(e1);
                        }, o = 0, t = void 0, n = void 0, i = function(e1, t) {
                            d[o] = e1, d[o + 1] = t, 2 === (o += 2) && (n ? n(h) : D());
                        };
                        var e1 = "undefined" != typeof window ? window : void 0, s = e1 || {}, s = s.MutationObserver || s.WebKitMutationObserver, a = "undefined" == typeof self && void 0 !== B && "[object process]" === ({}).toString.call(B), u = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;
                        function c() {
                            var e1 = setTimeout;
                            return function() {
                                return e1(h, 1);
                            };
                        }
                        var d = new Array(1e3);
                        function h() {
                            for(var e1 = 0; e1 < o; e1 += 2)(0, d[e1])(d[e1 + 1]), d[e1] = void 0, d[e1 + 1] = void 0;
                            o = 0;
                        }
                        function f() {
                            try {
                                var e1 = Function("return this")().require("vertx");
                                return void 0 !== (t = e1.runOnLoop || e1.runOnContext) ? function() {
                                    t(h);
                                } : c();
                            } catch (e1) {
                                return c();
                            }
                        }
                        var p, m, y, D = void 0;
                        function g(e1, t) {
                            var r, o = this, n = new this.constructor(j), s = (void 0 === n[b] && A(n), o._state);
                            return s ? (r = arguments[s - 1], i(function() {
                                return O(s, n, r, o._result);
                            })) : k(o, n, e1, t), n;
                        }
                        function v(e1) {
                            var t;
                            return e1 && "object" == typeof e1 && e1.constructor === this ? e1 : (T(t = new this(j), e1), t);
                        }
                        var D = a ? function() {
                            return B.nextTick(h);
                        } : s ? (m = 0, a = new s(h), y = document.createTextNode(""), a.observe(y, {
                            characterData: !0
                        }), function() {
                            y.data = m = ++m % 2;
                        }) : u ? ((p = new MessageChannel).port1.onmessage = h, function() {
                            return p.port2.postMessage(0);
                        }) : (void 0 === e1 && "function" == typeof V ? f : c)(), b = Math.random().toString(36).substring(2);
                        function j() {}
                        var _ = void 0, x = 1, w = 2;
                        function F(e1, o, n) {
                            i(function(t) {
                                var r = !1, e1 = function(e1, t, r, o) {
                                    try {
                                        e1.call(t, r, o);
                                    } catch (e1) {
                                        return e1;
                                    }
                                }(n, o, function(e1) {
                                    r || (r = !0, (o !== e1 ? T : M)(t, e1));
                                }, function(e1) {
                                    r || (r = !0, E(t, e1));
                                }, t._label);
                                !r && e1 && (r = !0, E(t, e1));
                            }, e1);
                        }
                        function S(e1, t, r) {
                            var o, n;
                            t.constructor === e1.constructor && r === g && t.constructor.resolve === v ? (o = e1, (n = t)._state === x ? M(o, n._result) : n._state === w ? E(o, n._result) : k(n, void 0, function(e1) {
                                return T(o, e1);
                            }, function(e1) {
                                return E(o, e1);
                            })) : void 0 !== r && l(r) ? F(e1, t, r) : M(e1, t);
                        }
                        function T(t, e1) {
                            if (t === e1) E(t, new TypeError("You cannot resolve a promise with itself"));
                            else if (r = typeof e1, null === e1 || "object" != r && "function" != r) M(t, e1);
                            else {
                                r = void 0;
                                try {
                                    r = e1.then;
                                } catch (e1) {
                                    return void E(t, e1);
                                }
                                S(t, e1, r);
                            }
                            var r;
                        }
                        function U(e1) {
                            e1._onerror && e1._onerror(e1._result), C(e1);
                        }
                        function M(e1, t) {
                            e1._state === _ && (e1._result = t, e1._state = x, 0 !== e1._subscribers.length && i(C, e1));
                        }
                        function E(e1, t) {
                            e1._state === _ && (e1._state = w, e1._result = t, i(U, e1));
                        }
                        function k(e1, t, r, o) {
                            var n = e1._subscribers, s = n.length;
                            e1._onerror = null, n[s] = t, n[s + x] = r, n[s + w] = o, 0 === s && e1._state && i(C, e1);
                        }
                        function C(e1) {
                            var t = e1._subscribers, r = e1._state;
                            if (0 !== t.length) {
                                for(var o, n = void 0, s = e1._result, i = 0; i < t.length; i += 3)o = t[i], n = t[i + r], o ? O(r, o, n, s) : n(s);
                                e1._subscribers.length = 0;
                            }
                        }
                        function O(e1, t, r, o) {
                            var n = l(r), s = void 0, i = void 0, a = !0;
                            if (n) {
                                try {
                                    s = r(o);
                                } catch (e1) {
                                    a = !1, i = e1;
                                }
                                if (t === s) return void E(t, new TypeError("A promises callback cannot return that same promise."));
                            } else s = o;
                            t._state === _ && (n && a ? T(t, s) : !1 === a ? E(t, i) : e1 === x ? M(t, s) : e1 === w && E(t, s));
                        }
                        var P = 0;
                        function A(e1) {
                            e1[b] = P++, e1._state = void 0, e1._result = void 0, e1._subscribers = [];
                        }
                        L.prototype._enumerate = function(e1) {
                            for(var t = 0; this._state === _ && t < e1.length; t++)this._eachEntry(e1[t], t);
                        }, L.prototype._eachEntry = function(t, e1) {
                            var r = this._instanceConstructor, o = r.resolve;
                            if (o === v) {
                                var n, s = void 0, i = void 0, a = !1;
                                try {
                                    s = t.then;
                                } catch (e1) {
                                    a = !0, i = e1;
                                }
                                s === g && t._state !== _ ? this._settledAt(t._state, e1, t._result) : "function" != typeof s ? (this._remaining--, this._result[e1] = t) : r === R ? (n = new r(j), a ? E(n, i) : S(n, t, s), this._willSettleAt(n, e1)) : this._willSettleAt(new r(function(e1) {
                                    return e1(t);
                                }), e1);
                            } else this._willSettleAt(o(t), e1);
                        }, L.prototype._settledAt = function(e1, t, r) {
                            var o = this.promise;
                            o._state === _ && (this._remaining--, e1 === w ? E(o, r) : this._result[t] = r), 0 === this._remaining && M(o, this._result);
                        }, L.prototype._willSettleAt = function(e1, t) {
                            var r = this;
                            k(e1, void 0, function(e1) {
                                return r._settledAt(x, t, e1);
                            }, function(e1) {
                                return r._settledAt(w, t, e1);
                            });
                        };
                        var N = L;
                        function L(e1, t) {
                            this._instanceConstructor = e1, this.promise = new e1(j), this.promise[b] || A(this.promise), r(t) ? (this.length = t.length, this._remaining = t.length, this._result = new Array(this.length), 0 !== this.length && (this.length = this.length || 0, this._enumerate(t), 0 !== this._remaining) || M(this.promise, this._result)) : E(this.promise, new Error("Array Methods must be provided an Array"));
                        }
                        I.prototype.catch = function(e1) {
                            return this.then(null, e1);
                        }, I.prototype.finally = function(t) {
                            var r = this.constructor;
                            return l(t) ? this.then(function(e1) {
                                return r.resolve(t()).then(function() {
                                    return e1;
                                });
                            }, function(e1) {
                                return r.resolve(t()).then(function() {
                                    throw e1;
                                });
                            }) : this.then(t, t);
                        };
                        var R = I;
                        function I(e1) {
                            if (this[b] = P++, this._result = this._state = void 0, this._subscribers = [], j !== e1) {
                                if ("function" != typeof e1) throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                                if (!(this instanceof I)) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                                var t = this;
                                try {
                                    e1(function(e1) {
                                        T(t, e1);
                                    }, function(e1) {
                                        E(t, e1);
                                    });
                                } catch (e1) {
                                    E(t, e1);
                                }
                            }
                        }
                        return R.prototype.then = g, R.all = function(e1) {
                            return new N(this, e1).promise;
                        }, R.race = function(n) {
                            var s = this;
                            return r(n) ? new s(function(e1, t) {
                                for(var r = n.length, o = 0; o < r; o++)s.resolve(n[o]).then(e1, t);
                            }) : new s(function(e1, t) {
                                return t(new TypeError("You must pass an array to race."));
                            });
                        }, R.resolve = v, R.reject = function(e1) {
                            var t = new this(j);
                            return E(t, e1), t;
                        }, R._setScheduler = function(e1) {
                            n = e1;
                        }, R._setAsap = function(e1) {
                            i = e1;
                        }, R._asap = i, R.polyfill = function() {
                            var e1 = void 0;
                            if (void 0 !== G) e1 = G;
                            else if ("undefined" != typeof self) e1 = self;
                            else try {
                                e1 = Function("return this")();
                            } catch (e1) {
                                throw new Error("polyfill failed because global object is unavailable in this environment");
                            }
                            var t = e1.Promise;
                            if (t) {
                                var r = null;
                                try {
                                    r = Object.prototype.toString.call(t.resolve());
                                } catch (e1) {}
                                if ("[object Promise]" === r && !t.cast) return;
                            }
                            e1.Promise = R;
                        }, R.Promise = R;
                    }, "object" == typeof o && void 0 !== r ? r.exports = t() : "function" == typeof s && s.amd ? s(t) : e1.ES6Promise = t();
                }).call(this, V("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 251
            }
        ],
        243: [
            function(e1, t, r) {
                var o, n;
                o = this, n = function(e1, t) {
                    "use strict";
                    var r = 5e3, o = "callback";
                    function d(t) {
                        try {
                            delete window[t];
                        } catch (e1) {
                            window[t] = void 0;
                        }
                    }
                    function h(e1) {
                        e1 = document.getElementById(e1);
                        e1 && document.getElementsByTagName("head")[0].removeChild(e1);
                    }
                    t.exports = function(s) {
                        var i = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1], a = s, l = i.timeout || r, u = i.jsonpCallback || o, c = void 0;
                        return new Promise(function(t, e1) {
                            var r = i.jsonpCallbackFunction || "jsonp_" + Date.now() + "_" + Math.ceil(1e5 * Math.random()), o = u + "_" + r, n = (window[r] = function(e1) {
                                t({
                                    ok: !0,
                                    json: function() {
                                        return Promise.resolve(e1);
                                    }
                                }), c && clearTimeout(c), h(o), d(r);
                            }, a += -1 === a.indexOf("?") ? "?" : "&", document.createElement("script"));
                            n.setAttribute("src", "" + a + u + "=" + r), i.charset && n.setAttribute("charset", i.charset), n.id = o, document.getElementsByTagName("head")[0].appendChild(n), c = setTimeout(function() {
                                e1(new Error("JSONP request to " + s + " timed out")), d(r), h(o), window[r] = function() {
                                    d(r);
                                };
                            }, l), n.onerror = function() {
                                e1(new Error("JSONP request to " + s + " failed")), d(r), h(o), c && clearTimeout(c);
                            };
                        });
                    };
                }, "function" == typeof s && s.amd ? s([
                    "exports",
                    "module"
                ], n) : void 0 !== r && void 0 !== t ? n(0, t) : (n(n = {
                    exports: {}
                }, n), o.fetchJsonp = n.exports);
            },
            {}
        ],
        244: [
            function(e1, t, r) {
                var o = function(a) {
                    "use strict";
                    var l, u, c, d, h, f, t, p, m, o, e1;
                    if (!(void 0 === a || "undefined" != typeof navigator && /MSIE [1-9]\./.test(navigator.userAgent))) return e1 = a.document, l = function() {
                        return a.URL || a.webkitURL || a;
                    }, u = e1.createElementNS("http://www.w3.org/1999/xhtml", "a"), c = "download" in u, d = /constructor/i.test(a.HTMLElement) || a.safari, h = /CriOS\/[\d]+/.test(navigator.userAgent), f = function(e1) {
                        (a.setImmediate || a.setTimeout)(function() {
                            throw e1;
                        }, 0);
                    }, t = 4e4, p = function(e1) {
                        setTimeout(function() {
                            "string" == typeof e1 ? l().revokeObjectURL(e1) : e1.remove();
                        }, t);
                    }, m = function(e1) {
                        return /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e1.type) ? new Blob([
                            String.fromCharCode(65279),
                            e1
                        ], {
                            type: e1.type
                        }) : e1;
                    }, e1 = (o = function(e1, r, t) {
                        t || (e1 = m(e1));
                        var o, n, s = this, t = "application/octet-stream" === e1.type, i = function() {
                            for(var e1 = s, t = "writestart progress write writeend".split(" "), r = void 0, o = (t = [].concat(t)).length; o--;){
                                var n = e1["on" + t[o]];
                                if ("function" == typeof n) try {
                                    n.call(e1, r || e1);
                                } catch (e1) {
                                    f(e1);
                                }
                            }
                        };
                        s.readyState = s.INIT, c ? (o = l().createObjectURL(e1), setTimeout(function() {
                            var e1, t;
                            u.href = o, u.download = r, e1 = u, t = new MouseEvent("click"), e1.dispatchEvent(t), i(), p(o), s.readyState = s.DONE;
                        })) : (h || t && d) && a.FileReader ? ((n = new FileReader).onloadend = function() {
                            var e1 = h ? n.result : n.result.replace(/^data:[^;]*;/, "data:attachment/file;");
                            a.open(e1, "_blank") || (a.location.href = e1), e1 = void 0, s.readyState = s.DONE, i();
                        }, n.readAsDataURL(e1), s.readyState = s.INIT) : (o = o || l().createObjectURL(e1), !t && a.open(o, "_blank") || (a.location.href = o), s.readyState = s.DONE, i(), p(o));
                    }).prototype, "undefined" != typeof navigator && navigator.msSaveOrOpenBlob ? function(e1, t, r) {
                        return t = t || e1.name || "download", r || (e1 = m(e1)), navigator.msSaveOrOpenBlob(e1, t);
                    } : (e1.abort = function() {}, e1.readyState = e1.INIT = 0, e1.WRITING = 1, e1.DONE = 2, e1.error = e1.onwritestart = e1.onprogress = e1.onwrite = e1.onabort = e1.onerror = e1.onwriteend = null, function(e1, t, r) {
                        return new o(e1, t || e1.name || "download", r);
                    });
                }("undefined" != typeof self && self || "undefined" != typeof window && window || this.content);
                void 0 !== t && t.exports ? t.exports.saveAs = o : null != s && null !== s.amd && s("FileSaver.js", function() {
                    return o;
                });
            },
            {}
        ],
        245: [
            function(e1, t, r) {
                var o, n = Object.defineProperty, s = (n(r, "__esModule", {
                    value: !0
                }), r), i = {
                    GIFEncoder: ()=>h,
                    applyPalette: ()=>function(e1, t, r = "rgb565") {
                            if (!e1 || !e1.buffer) throw new Error("quantize() expected RGBA Uint8Array data");
                            if (!(e1 instanceof Uint8Array || e1 instanceof Uint8ClampedArray)) throw new Error("quantize() expected RGBA Uint8Array data");
                            if (256 < t.length) throw new Error("applyPalette() only works with 256 colors or less");
                            const o = new Uint32Array(e1.buffer), n = o.length, s = "rgb444" === r ? 4096 : 65536, i = new Uint8Array(n), a = new Array(s);
                            if ("rgba4444" === r) for(let e1 = 0; e1 < n; e1++){
                                var l = o[e1], u = l >> 24 & 255, c = l >> 16 & 255, d = l >> 8 & 255, l = 255 & l, h = P(l, d, c, u), h = h in a ? a[h] : a[h] = function(t, r, o, n, s) {
                                    let i = 0, a = 1e100;
                                    for(let e1 = 0; e1 < s.length; e1++){
                                        var l, u = s[e1], c = v(u[3] - n);
                                        c > a || (l = u[0], (c += v(l - t)) > a || (l = u[1], (c += v(l - r)) > a || (l = u[2], (c += v(l - o)) > a || (a = c, i = e1))));
                                    }
                                    return i;
                                }(l, d, c, u, t);
                                i[e1] = h;
                            }
                            else {
                                const g = "rgb444" === r ? A : O;
                                for(let e1 = 0; e1 < n; e1++){
                                    var f = o[e1], p = f >> 16 & 255, m = f >> 8 & 255, f = 255 & f, y = g(f, m, p), y = y in a ? a[y] : a[y] = function(t, r, o, n) {
                                        let s = 0, i = 1e100;
                                        for(let e1 = 0; e1 < n.length; e1++){
                                            var a, l = n[e1], u = v(l[0] - t);
                                            u > i || (a = l[1], (u += v(a - r)) > i || (a = l[2], (u += v(a - o)) > i || (i = u, s = e1)));
                                        }
                                        return s;
                                    }(f, m, p, t);
                                    i[e1] = y;
                                }
                            }
                            return i;
                        },
                    default: ()=>f,
                    nearestColor: ()=>function(e1, t, r = u) {
                            return e1[l(e1, t, r)];
                        },
                    nearestColorIndex: ()=>l,
                    nearestColorIndexWithDistance: ()=>d,
                    prequantize: ()=>function(e1, { roundRGB: r = 5, roundAlpha: o = 10, oneBitAlpha: n = null } = {}) {
                            const s = new Uint32Array(e1.buffer);
                            for(let t = 0; t < s.length; t++){
                                var i = s[t];
                                let e1 = i >> 24 & 255;
                                var a, l = i >> 16 & 255, u = i >> 8 & 255, i = 255 & i;
                                e1 = c(e1, o), n && (a = "number" == typeof n ? n : 127, e1 = e1 <= a ? 0 : 255), i = c(i, r), u = c(u, r), l = c(l, r), s[t] = e1 << 24 | l << 16 | u << 8 | i << 0;
                            }
                        },
                    quantize: ()=>function(e1, t, r = {}) {
                            var { format: o = "rgb565", clearAlpha: n = !0, clearAlphaColor: s = 0, clearAlphaThreshold: i = 0, oneBitAlpha: a = !1 } = r;
                            if (!e1 || !e1.buffer) throw new Error("quantize() expected RGBA Uint8Array data");
                            if (!(e1 instanceof Uint8Array || e1 instanceof Uint8ClampedArray)) throw new Error("quantize() expected RGBA Uint8Array data");
                            e1 = new Uint32Array(e1.buffer);
                            let l = !1 !== r.useSqrt;
                            const u = "rgba4444" === o, c = function(r, e1) {
                                const t = "rgb444" === e1 ? 4096 : 65536, o = new Array(t), n = r.length;
                                if ("rgba4444" === e1) for(let t = 0; t < n; ++t){
                                    var s = r[t], i = s >> 24 & 255, a = s >> 16 & 255, l = s >> 8 & 255, s = 255 & s, u = P(s, l, a, i);
                                    let e1 = u in o ? o[u] : o[u] = D();
                                    e1.rc += s, e1.gc += l, e1.bc += a, e1.ac += i, e1.cnt++;
                                }
                                else if ("rgb444" === e1) for(let t = 0; t < n; ++t){
                                    var c = r[t], d = c >> 16 & 255, h = c >> 8 & 255, c = 255 & c, f = A(c, h, d);
                                    let e1 = f in o ? o[f] : o[f] = D();
                                    e1.rc += c, e1.gc += h, e1.bc += d, e1.cnt++;
                                }
                                else for(let t = 0; t < n; ++t){
                                    var p = r[t], m = p >> 16 & 255, y = p >> 8 & 255, p = 255 & p, g = O(p, y, m);
                                    let e1 = g in o ? o[g] : o[g] = D();
                                    e1.rc += p, e1.gc += y, e1.bc += m, e1.cnt++;
                                }
                                return o;
                            }(e1, o), d = c.length, h = d - 1, f = new Uint32Array(d + 1);
                            for(var p = 0, m = 0; m < d; ++m){
                                const C = c[m];
                                null != C && (M = 1 / C.cnt, u && (C.ac *= M), C.rc *= M, C.gc *= M, C.bc *= M, c[p++] = C);
                            }
                            R(t) / p < .022 && (l = !1);
                            for(var y, g, v, m = 0; m < p - 1; ++m)c[m].fw = m + 1, c[m + 1].bk = m, l && (c[m].cnt = Math.sqrt(c[m].cnt));
                            l && (c[m].cnt = Math.sqrt(c[m].cnt));
                            for(m = 0; m < p; ++m){
                                I(c, m, !1);
                                var b = c[m].err;
                                for(g = ++f[0]; 1 < g && (v = g >> 1, !(c[y = f[v]].err <= b)); g = v)f[g] = y;
                                f[g] = m;
                            }
                            var j, _ = p - t;
                            for(m = 0; m < _;){
                                for(;;){
                                    var x = f[1];
                                    if ((j = c[x]).tm >= j.mtm && c[j.nn].mtm <= j.tm) break;
                                    j.mtm == h ? x = f[1] = f[f[0]--] : (I(c, x, !1), j.tm = m);
                                    b = c[x].err;
                                    for(g = 1; (v = g + g) <= f[0] && (v < f[0] && c[f[v]].err > c[f[v + 1]].err && v++, !(b <= c[y = f[v]].err)); g = v)f[g] = y;
                                    f[g] = x;
                                }
                                var w = c[j.nn], S = j.cnt, T = w.cnt, M = 1 / (S + T);
                                u && (j.ac = M * (S * j.ac + T * w.ac)), j.rc = M * (S * j.rc + T * w.rc), j.gc = M * (S * j.gc + T * w.gc), j.bc = M * (S * j.bc + T * w.bc), j.cnt += w.cnt, j.mtm = ++m, c[w.bk].fw = w.fw, c[w.fw].bk = w.bk, w.mtm = h;
                            }
                            let E = [];
                            for(m = 0;;){
                                let e1 = L(Math.round(c[m].rc), 0, 255), t = L(Math.round(c[m].gc), 0, 255), r = L(Math.round(c[m].bc), 0, 255), o = 255;
                                u && (o = L(Math.round(c[m].ac), 0, 255), a && (k = "number" == typeof a ? a : 127, o = o <= k ? 0 : 255), n && o <= i && (e1 = t = r = s, o = 0));
                                var k = u ? [
                                    e1,
                                    t,
                                    r,
                                    o
                                ] : [
                                    e1,
                                    t,
                                    r
                                ];
                                if (function(t, r) {
                                    for(let e1 = 0; e1 < t.length; e1++){
                                        var o = t[e1], n = o[0] === r[0] && o[1] === r[1] && o[2] === r[2], o = !(4 <= o.length && 4 <= r.length) || o[3] === r[3];
                                        if (n && o) return !0;
                                    }
                                    return !1;
                                }(E, k) || E.push(k), 0 == (m = c[m].fw)) break;
                            }
                            return E;
                        },
                    snapColorsToPalette: ()=>function(r, o, e1 = 5) {
                            if (r.length && o.length) {
                                var n = r.map((e1)=>e1.slice(0, 3)), s = e1 * e1, i = r[0].length;
                                for(let t = 0; t < o.length; t++){
                                    let e1 = o[t];
                                    e1 = e1.length < i ? [
                                        e1[0],
                                        e1[1],
                                        e1[2],
                                        255
                                    ] : e1.length > i ? e1.slice(0, 3) : e1.slice();
                                    var a = d(n, e1.slice(0, 3), u), l = a[0], a = a[1];
                                    0 < a && a <= s && (r[l] = e1);
                                }
                            }
                        }
                };
                for(o in i)n(s, o, {
                    get: i[o],
                    enumerable: !0
                });
                var a = {
                    signature: "GIF",
                    version: "89a",
                    trailer: 59,
                    extensionIntroducer: 33,
                    applicationExtensionLabel: 255,
                    graphicControlExtensionLabel: 249,
                    imageSeparator: 44,
                    signatureSize: 3,
                    versionSize: 3,
                    globalColorTableFlagMask: 128,
                    colorResolutionMask: 112,
                    sortFlagMask: 8,
                    globalColorTableSizeMask: 7,
                    applicationIdentifierSize: 8,
                    applicationAuthCodeSize: 3,
                    disposalMethodMask: 28,
                    userInputFlagMask: 2,
                    transparentColorFlagMask: 1,
                    localColorTableFlagMask: 128,
                    interlaceFlagMask: 64,
                    idSortFlagMask: 32,
                    localColorTableSizeMask: 7
                };
                function E(e1 = 256) {
                    let n = 0, s = new Uint8Array(e1);
                    return {
                        get buffer () {
                            return s.buffer;
                        },
                        reset () {
                            n = 0;
                        },
                        bytesView () {
                            return s.subarray(0, n);
                        },
                        bytes () {
                            return s.slice(0, n);
                        },
                        writeByte (e1) {
                            i(n + 1), s[n] = e1, n++;
                        },
                        writeBytes (t, r = 0, o = t.length) {
                            i(n + o);
                            for(let e1 = 0; e1 < o; e1++)s[n++] = t[e1 + r];
                        },
                        writeBytesView (e1, t = 0, r = e1.byteLength) {
                            i(n + r), s.set(e1.subarray(t, t + r), n), n += r;
                        }
                    };
                    function i(e1) {
                        var t = s.length;
                        if (!(e1 <= t)) {
                            e1 = Math.max(e1, t * (t < 1048576 ? 2 : 1.125) >>> 0), 0 != t && (e1 = Math.max(e1, 256));
                            const r = s;
                            s = new Uint8Array(e1), 0 < n && s.set(r.subarray(0, n), 0);
                        }
                    }
                }
                var k = [
                    0,
                    1,
                    3,
                    7,
                    15,
                    31,
                    63,
                    127,
                    255,
                    511,
                    1023,
                    2047,
                    4095,
                    8191,
                    16383,
                    32767,
                    65535
                ];
                var S = function(e1, t, r, o, n = E(512), s = new Uint8Array(256), i = new Int32Array(5003), a = new Int32Array(5003)) {
                    var l = i.length, o = Math.max(2, o);
                    s.fill(0), a.fill(0), i.fill(-1);
                    let u = 0, c = 0;
                    var d = o + 1;
                    const h = d;
                    let f = !1, p = h, m = (1 << p) - 1;
                    var y = 1 << d - 1;
                    const g = 1 + y;
                    let v = 2 + y, b = 0, j = r[0], _ = 0;
                    for(let e1 = l; e1 < 65536; e1 *= 2)++_;
                    _ = 8 - _, n.writeByte(o), M(y);
                    var x = r.length;
                    for(let t = 1; t < x; t++)e: {
                        var w = r[t], S = (w << 12) + j;
                        let e1 = w << _ ^ j;
                        if (i[e1] === S) j = a[e1];
                        else {
                            for(var T = 0 === e1 ? 1 : l - e1; 0 <= i[e1];)if ((e1 -= T) < 0 && (e1 += l), i[e1] === S) {
                                j = a[e1];
                                break e;
                            }
                            M(j), j = w, v < 4096 ? (a[e1] = v++, i[e1] = S) : (i.fill(-1), v = 2 + y, f = !0, M(y));
                        }
                    }
                    return M(j), M(g), n.writeByte(0), n.bytesView();
                    function M(e1) {
                        for(u &= k[c], 0 < c ? u |= e1 << c : u = e1, c += p; 8 <= c;)s[b++] = 255 & u, 254 <= b && (n.writeByte(b), n.writeBytesView(s, 0, b), b = 0), u >>= 8, c -= 8;
                        if ((v > m || f) && (f ? (p = h, m = (1 << p) - 1, f = !1) : (++p, m = 12 === p ? 1 << p : (1 << p) - 1)), e1 == g) {
                            for(; 0 < c;)s[b++] = 255 & u, 254 <= b && (n.writeByte(b), n.writeBytesView(s, 0, b), b = 0), u >>= 8, c -= 8;
                            0 < b && (n.writeByte(b), n.writeBytesView(s, 0, b), b = 0);
                        }
                    }
                };
                function O(e1, t, r) {
                    return e1 << 8 & 63488 | t << 2 & 992 | r >> 3;
                }
                function P(e1, t, r, o) {
                    return e1 >> 4 | 240 & t | (240 & r) << 4 | (240 & o) << 8;
                }
                function A(e1, t, r) {
                    return e1 >> 4 << 8 | 240 & t | r >> 4;
                }
                function L(e1, t, r) {
                    return e1 < t ? t : r < e1 ? r : e1;
                }
                function R(e1) {
                    return e1 * e1;
                }
                function I(e1, t, r) {
                    var o = 0, n = 1e100;
                    const s = e1[t];
                    for(var i = s.cnt, a = s.ac, l = s.rc, u = s.gc, c = s.bc, d = s.fw; 0 != d; d = e1[d].fw){
                        var h, f = e1[d], p = f.cnt, p = i * p / (i + p);
                        n <= p || (h = 0, r && n <= (h += p * R(f.ac - a)) || n <= (h += p * R(f.rc - l)) || n <= (h += p * R(f.gc - u)) || n <= (h += p * R(f.bc - c)) || (n = h, o = d));
                    }
                    s.err = n, s.nn = o;
                }
                function D() {
                    return {
                        ac: 0,
                        rc: 0,
                        gc: 0,
                        bc: 0,
                        cnt: 0,
                        nn: 0,
                        fw: 0,
                        bk: 0,
                        tm: 0,
                        mtm: 0,
                        err: 0
                    };
                }
                function u(e1, t) {
                    for(var r = 0, o = 0; o < e1.length; o++){
                        var n = e1[o] - t[o];
                        r += n * n;
                    }
                    return r;
                }
                function c(e1, t) {
                    return 1 < t ? Math.round(e1 / t) * t : e1;
                }
                function v(e1) {
                    return e1 * e1;
                }
                function l(t, r, o = u) {
                    let n = 1 / 0, s = -1;
                    for(let e1 = 0; e1 < t.length; e1++){
                        var i = o(r, t[e1]);
                        i < n && (n = i, s = e1);
                    }
                    return s;
                }
                function d(t, r, o = u) {
                    let n = 1 / 0, s = -1;
                    for(let e1 = 0; e1 < t.length; e1++){
                        var i = o(r, t[e1]);
                        i < n && (n = i, s = e1);
                    }
                    return [
                        s,
                        n
                    ];
                }
                function h(e1 = {}) {
                    const { initialCapacity: t = 4096, auto: g = !0 } = e1, v = E(t);
                    const b = new Uint8Array(256), j = new Int32Array(5003), _ = new Int32Array(5003);
                    let x = !1;
                    return {
                        reset () {
                            v.reset(), x = !1;
                        },
                        finish () {
                            v.writeByte(a.trailer);
                        },
                        bytes () {
                            return v.bytes();
                        },
                        bytesView () {
                            return v.bytesView();
                        },
                        get buffer () {
                            return v.buffer;
                        },
                        get stream () {
                            return v;
                        },
                        writeHeader: w,
                        writeFrame (e1, t, r, o = {}) {
                            var { transparent: n = !1, transparentIndex: s = 0, delay: i = 0, palette: a = null, repeat: l = 0, colorDepth: u = 8, dispose: c = -1 } = o;
                            let d = !1;
                            if (g ? x || (d = !0, w(), x = !0) : d = Boolean(o.first), t = Math.max(0, Math.floor(t)), r = Math.max(0, Math.floor(r)), d) {
                                if (!a) throw new Error("First frame must include a { palette } option");
                                var [o, h, f, p, m = 8] = [
                                    v,
                                    t,
                                    r,
                                    a,
                                    u
                                ];
                                p = F(p.length) - 1, m = 128 | m - 1 << 4 | p, M(o, h), M(o, f), o.writeBytes([
                                    m,
                                    0,
                                    0
                                ]), T(v, a), 0 <= l && (p = v, h = l, p.writeByte(33), p.writeByte(255), p.writeByte(11), C(p, "NETSCAPE2.0"), p.writeByte(3), p.writeByte(1), M(p, h), p.writeByte(0));
                            }
                            var y, f = Math.round(i / 10), o = v, m = c, l = f, h = n, p = s, i = (o.writeByte(33), o.writeByte(249), o.writeByte(4), p < 0 && (p = 0, h = !1), h = h ? (y = 1, 2) : y = 0, 0 <= m && (h = 7 & m), h <<= 2, o.writeByte(0 | h | y), M(o, l), o.writeByte(p || 0), o.writeByte(0), Boolean(a) && !d);
                            c = v, n = t, s = r, y = i ? a : null, c.writeByte(44), M(c, 0), M(c, 0), M(c, n), M(c, s), y ? (n = F(y.length) - 1, c.writeByte(128 | n)) : c.writeByte(0), i && T(v, a), [l, o, s, n, c = 8, i, a, e1] = [
                                v,
                                e1,
                                t,
                                r,
                                u,
                                b,
                                j,
                                _
                            ], S(s, n, o, c, l, i, a, e1);
                        }
                    };
                    function w() {
                        C(v, "GIF89a");
                    }
                }
                function T(r, o) {
                    var e1 = 1 << F(o.length);
                    for(let t = 0; t < e1; t++){
                        let e1 = [
                            0,
                            0,
                            0
                        ];
                        t < o.length && (e1 = o[t]), r.writeByte(e1[0]), r.writeByte(e1[1]), r.writeByte(e1[2]);
                    }
                }
                function M(e1, t) {
                    e1.writeByte(255 & t), e1.writeByte(t >> 8 & 255);
                }
                function C(e1, t) {
                    for(var r = 0; r < t.length; r++)e1.writeByte(t.charCodeAt(r));
                }
                function F(e1) {
                    return Math.max(Math.ceil(Math.log2(e1)), 1);
                }
                var f = h;
            },
            {}
        ],
        246: [
            function(e1, t, r) {
                r.read = function(e1, t, r, o, n) {
                    var s, i, a = 8 * n - o - 1, l = (1 << a) - 1, u = l >> 1, c = -7, d = r ? n - 1 : 0, h = r ? -1 : 1, n = e1[t + d];
                    for(d += h, s = n & (1 << -c) - 1, n >>= -c, c += a; 0 < c; s = 256 * s + e1[t + d], d += h, c -= 8);
                    for(i = s & (1 << -c) - 1, s >>= -c, c += o; 0 < c; i = 256 * i + e1[t + d], d += h, c -= 8);
                    if (0 === s) s = 1 - u;
                    else {
                        if (s === l) return i ? NaN : 1 / 0 * (n ? -1 : 1);
                        i += Math.pow(2, o), s -= u;
                    }
                    return (n ? -1 : 1) * i * Math.pow(2, s - o);
                }, r.write = function(e1, t, r, o, n, s) {
                    var i, a, l = 8 * s - n - 1, u = (1 << l) - 1, c = u >> 1, d = 23 === n ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = o ? 0 : s - 1, f = o ? 1 : -1, s = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                    for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, i = u) : (i = Math.floor(Math.log(t) / Math.LN2), t * (o = Math.pow(2, -i)) < 1 && (i--, o *= 2), 2 <= (t += 1 <= i + c ? d / o : d * Math.pow(2, 1 - c)) * o && (i++, o /= 2), u <= i + c ? (a = 0, i = u) : 1 <= i + c ? (a = (t * o - 1) * Math.pow(2, n), i += c) : (a = t * Math.pow(2, c - 1) * Math.pow(2, n), i = 0)); 8 <= n; e1[r + h] = 255 & a, h += f, a /= 256, n -= 8);
                    for(i = i << n | a, l += n; 0 < l; e1[r + h] = 255 & i, h += f, i /= 256, l -= 8);
                    e1[r + h - f] |= 128 * s;
                };
            },
            {}
        ],
        247: [
            function(o, e1, c) {
                "use strict";
                var t;
                function y(e1, t) {
                    return e1.b === t.b && e1.a === t.a;
                }
                function g(e1, t) {
                    return e1.b < t.b || e1.b === t.b && e1.a <= t.a;
                }
                function v(e1, t, r) {
                    var o = t.b - e1.b, n = r.b - t.b;
                    return 0 < o + n ? o < n ? t.a - e1.a + o / (o + n) * (e1.a - r.a) : t.a - r.a + n / (o + n) * (r.a - e1.a) : 0;
                }
                function b(e1, t, r) {
                    var o = t.b - e1.b, n = r.b - t.b;
                    return 0 < o + n ? (t.a - r.a) * o + (t.a - e1.a) * n : 0;
                }
                function j(e1, t) {
                    return e1.a < t.a || e1.a === t.a && e1.b <= t.b;
                }
                function V(e1, t, r) {
                    var o = t.a - e1.a, n = r.a - t.a;
                    return 0 < o + n ? o < n ? t.b - e1.b + o / (o + n) * (e1.b - r.b) : t.b - r.b + n / (o + n) * (r.b - e1.b) : 0;
                }
                function z(e1, t, r) {
                    var o = t.a - e1.a, n = r.a - t.a;
                    return 0 < o + n ? (t.b - r.b) * o + (t.b - e1.b) * n : 0;
                }
                function _(e1, t, r, o) {
                    return (e1 = e1 < 0 ? 0 : e1) <= (r = r < 0 ? 0 : r) ? 0 === r ? (t + o) / 2 : t + e1 / (e1 + r) * (o - t) : o + r / (e1 + r) * (t - o);
                }
                function d(e1) {
                    var t = s(e1.b);
                    return n(t, e1.c), n(t.b, e1.c), i(t, e1.a), t;
                }
                function x(e1, t) {
                    var r = !1, o = !1;
                    e1 !== t && (t.a !== e1.a && (o = !0, M(t.a, e1.a)), t.d !== e1.d && (r = !0, a(t.d, e1.d)), T(t, e1), o || (n(t, e1.a), e1.a.c = e1), r || (i(t, e1.d), e1.d.a = e1));
                }
                function m(e1) {
                    var t = e1.b, r = !1;
                    e1.d !== e1.b.d && (r = !0, a(e1.d, e1.b.d)), e1.c === e1 ? M(e1.a, null) : (e1.b.d.a = e1.b.e, e1.a.c = e1.c, T(e1, e1.b.e), r || i(e1, e1.d)), t.c === t ? (M(t.a, null), a(t.d, null)) : (e1.d.a = t.b.e, t.a.c = t.c, T(t, t.b.e)), H(e1);
                }
                function w(e1) {
                    var t = s(e1), r = t.b;
                    return T(t, e1.e), t.a = e1.b.a, n(r, t.a), t.d = r.d = e1.d, t = t.b, T(e1.b, e1.b.b.e), T(e1.b, t), e1.b.a = t.a, t.b.a.c = t.b, t.b.d = e1.b.d, t.f = e1.f, t.b.f = e1.b.f, t;
                }
                function S(e1, t) {
                    var r = !1, o = s(e1), n = o.b;
                    return t.d !== e1.d && (r = !0, a(t.d, e1.d)), T(o, e1.e), T(n, t), o.a = e1.b.a, n.a = t.a, o.d = n.d = e1.d, e1.d.a = n, r || i(o, e1.d), o;
                }
                function s(e1) {
                    var t = new u, r = new u, o = e1.b.h;
                    return (((r.h = o).b.h = t).h = e1).b.h = r, t.b = r, ((t.c = t).e = r).b = t, (r.c = r).e = t;
                }
                function T(e1, t) {
                    var r = e1.c, o = t.c;
                    r.b.e = t, (o.b.e = e1).c = o, t.c = r;
                }
                function n(e1, t) {
                    var r = t.f, o = new D(t, r);
                    for(r.e = o, r = (t.f = o).c = e1; r.a = o, (r = r.c) !== e1;);
                }
                function i(e1, t) {
                    var r = t.d, o = new te(t, r);
                    for(r.b = o, (t.d = o).a = e1, o.c = t.c, r = e1; r.d = o, (r = r.e) !== e1;);
                }
                function H(e1) {
                    var t = e1.h;
                    e1 = e1.b.h, (t.b.h = e1).b.h = t;
                }
                function M(e1, t) {
                    for(var r = e1.c, o = r; o.a = t, (o = o.c) !== r;);
                    r = e1.f, ((o = e1.e).f = r).e = o;
                }
                function a(e1, t) {
                    for(var r = e1.a, o = r; o.d = t, (o = o.e) !== r;);
                    r = e1.d, ((o = e1.b).d = r).b = o;
                }
                function W(e1) {
                    var t = 0;
                    return Math.abs(e1[1]) > Math.abs(e1[0]) && (t = 1), t = Math.abs(e1[2]) > Math.abs(e1[t]) ? 2 : t;
                }
                function E(e1, t) {
                    e1.f += t.f, e1.b.f += t.b.f;
                }
                function h(e1, t, r) {
                    return e1 = e1.a, t = t.a, r = r.a, t.b.a === e1 ? r.b.a === e1 ? g(t.a, r.a) ? b(r.b.a, t.a, r.a) <= 0 : 0 <= b(t.b.a, r.a, t.a) : b(r.b.a, e1, r.a) <= 0 : r.b.a === e1 ? 0 <= b(t.b.a, e1, t.a) : (t = v(t.b.a, e1, t.a), (e1 = v(r.b.a, e1, r.a)) <= t);
                }
                function k(e1) {
                    e1.a.i = null;
                    var t = e1.e;
                    t.a.c = t.c, t.c.a = t.a, e1.e = null;
                }
                function C(e1, t) {
                    m(e1.a), e1.c = !1, (e1.a = t).i = e1;
                }
                function O(e1) {
                    for(var t = e1.a.a; (e1 = G(e1)).a.a === t;);
                    return e1.c && (C(e1, t = S(B(e1).a.b, e1.a.e)), e1 = G(e1)), e1;
                }
                function q(e1, t, r) {
                    var o = new N;
                    return o.a = r, o.e = p(e1.f, t.e, o), r.i = o;
                }
                function X(e1, t) {
                    switch(e1.s){
                        case 100130:
                            return 0 != (1 & t);
                        case 100131:
                            return 0 !== t;
                        case 100132:
                            return 0 < t;
                        case 100133:
                            return t < 0;
                        case 100134:
                            return 2 <= t || t <= -2;
                    }
                    return !1;
                }
                function f(e1) {
                    var t = e1.a, r = t.d;
                    r.c = e1.d, r.a = t, k(e1);
                }
                function P(e1, t, r) {
                    for(t = (e1 = t).a; e1 !== r;){
                        e1.c = !1;
                        var o = B(e1), n = o.a;
                        if (n.a !== t.a) {
                            if (!o.c) {
                                f(e1);
                                break;
                            }
                            C(o, n = S(t.c.b, n.b));
                        }
                        t.c !== n && (x(n.b.e, n), x(t, n)), f(e1), t = o.a, e1 = o;
                    }
                    return t;
                }
                function A(e1, t, r, o, n, s) {
                    for(var i = !0; q(e1, t, r.b), (r = r.c) !== o;);
                    for(null === n && (n = B(t).a.b.c); (r = (o = B(t)).a.b).a === n.a;)r.c !== n && (x(r.b.e, r), x(n.b.e, r)), o.f = t.f - r.f, o.d = X(e1, o.f), t.b = !0, !i && R(e1, t) && (E(r, n), k(t), m(n)), i = !1, t = o, n = r;
                    t.b = !0, s && J(e1, t);
                }
                function Y(e1, t, r, o, n) {
                    var s = [
                        t.g[0],
                        t.g[1],
                        t.g[2]
                    ];
                    t.d = null, t.d = e1.o && e1.o(s, r, o, e1.c) || null, null === t.d && (n ? e1.n || (l(e1, 100156), e1.n = !0) : t.d = r[0]);
                }
                function L(e1, t, r) {
                    var o = [
                        null,
                        null,
                        null,
                        null
                    ];
                    o[0] = t.a.d, o[1] = r.a.d, Y(e1, t.a, o, [
                        .5,
                        .5,
                        0,
                        0
                    ], !1), x(t, r);
                }
                function Z(e1, t, r, o, n) {
                    var s = Math.abs(t.b - e1.b) + Math.abs(t.a - e1.a), i = Math.abs(r.b - e1.b) + Math.abs(r.a - e1.a), a = n + 1;
                    o[n] = .5 * i / (s + i), o[a] = .5 * s / (s + i), e1.g[0] += o[n] * t.g[0] + o[a] * r.g[0], e1.g[1] += o[n] * t.g[1] + o[a] * r.g[1], e1.g[2] += o[n] * t.g[2] + o[a] * r.g[2];
                }
                function R(e1, t) {
                    var r = B(t), o = t.a, n = r.a;
                    if (g(o.a, n.a)) {
                        if (0 < b(n.b.a, o.a, n.a)) return;
                        if (y(o.a, n.a)) {
                            if (o.a !== n.a) {
                                var r = e1.e, s = o.a.h;
                                if (0 <= s) {
                                    var i = (r = r.b).d, a = r.e, l = r.c, u = l[s];
                                    i[u] = i[r.a], (l[i[u]] = u) <= --r.a && (u <= 1 || g(a[i[u >> 1]], a[i[u]]) ? U : ue)(r, u), a[s] = null, l[s] = r.b, r.b = s;
                                } else for(r.c[-(s + 1)] = null; 0 < r.a && null === r.c[r.d[r.a - 1]];)--r.a;
                                L(e1, n.b.e, o);
                            }
                        } else w(n.b), x(o, n.b.e), t.b = r.b = !0;
                    } else {
                        if (b(o.b.a, n.a, o.a) < 0) return;
                        G(t).b = t.b = !0, w(o.b), x(n.b.e, o);
                    }
                    return 1;
                }
                function Q(e1, t) {
                    var r = B(t), o = t.a, n = r.a, s = o.a, i = n.a, a = o.b.a, l = n.b.a, u = new D;
                    if (b(a, e1.a, s), b(l, e1.a, i), !(s === i || Math.min(s.a, a.a) > Math.max(i.a, l.a))) {
                        if (g(s, i)) {
                            if (0 < b(l, s, i)) return;
                        } else if (b(a, i, s) < 0) return;
                        var c, d, h = a, f = s, p = l, m = i;
                        if (g(h, f) || (c = h, h = f, f = c), g(p, m) || (c = p, p = m, m = c), g(h, p) || (c = h, h = p, p = c, c = f, f = m, m = c), g(p, f) ? g(f, m) ? ((c = v(h, p, f)) + (d = v(p, f, m)) < 0 && (c = -c, d = -d), u.b = _(c, p.b, d, f.b)) : ((c = b(h, p, f)) + (d = -b(h, m, f)) < 0 && (c = -c, d = -d), u.b = _(c, p.b, d, m.b)) : u.b = (p.b + f.b) / 2, j(h, f) || (c = h, h = f, f = c), j(p, m) || (c = p, p = m, m = c), j(h, p) || (c = h, h = p, p = c, c = f, f = m, m = c), j(p, f) ? j(f, m) ? ((c = V(h, p, f)) + (d = V(p, f, m)) < 0 && (c = -c, d = -d), u.a = _(c, p.a, d, f.a)) : ((c = z(h, p, f)) + (d = -z(h, m, f)) < 0 && (c = -c, d = -d), u.a = _(c, p.a, d, m.a)) : u.a = (p.a + f.a) / 2, g(u, e1.a) && (u.b = e1.a.b, u.a = e1.a.a), h = g(s, i) ? s : i, g(h, u) && (u.b = h.b, u.a = h.a), y(u, s) || y(u, i)) return R(e1, t), 0;
                        if (!y(a, e1.a) && 0 <= b(a, e1.a, u) || !y(l, e1.a) && b(l, e1.a, u) <= 0) {
                            if (l === e1.a) w(o.b), x(n.b, o), o = B(t = O(t)).a, P(e1, B(t), r), A(e1, t, o.b.e, o, o, !0);
                            else {
                                if (a !== e1.a) return 0 <= b(a, e1.a, u) && (G(t).b = t.b = !0, w(o.b), o.a.b = e1.a.b, o.a.a = e1.a.a), void (b(l, e1.a, u) <= 0 && (t.b = r.b = !0, w(n.b), n.a.b = e1.a.b, n.a.a = e1.a.a));
                                for(w(n.b), x(o.e, n.b.e), i = (s = r = t).a.b.a; (s = G(s)).a.b.a === i;);
                                s = B(t = s).a.b.c, r.a = n.b.e, A(e1, t, (n = P(e1, r, null)).c, o.b.c, s, !0);
                            }
                            return 1;
                        }
                        w(o.b), w(n.b), x(n.b.e, o), o.a.b = u.b, o.a.a = u.a, o.a.h = ne(e1.e, o.a), o = o.a, n = [
                            0,
                            0,
                            0,
                            0
                        ], u = [
                            s.d,
                            a.d,
                            i.d,
                            l.d
                        ], o.g[0] = o.g[1] = o.g[2] = 0, Z(o, s, a, n, 0), Z(o, i, l, n, 2), Y(e1, o, u, n, !0), G(t).b = t.b = r.b = !0;
                    }
                }
                function J(e1, t) {
                    for(var r = B(t);;){
                        for(; r.b;)r = B(t = r);
                        if (!t.b && (null === (t = G(r = t)) || !t.b)) break;
                        t.b = !1;
                        var o = t.a, n = r.a;
                        if (s = o.b.a !== n.b.a) e: {
                            var s, i = B(s = t), a = s.a, l = i.a, u = void 0;
                            if (g(a.b.a, l.b.a)) {
                                if (b(a.b.a, l.b.a, a.a) < 0) {
                                    s = !1;
                                    break e;
                                }
                                G(s).b = s.b = !0, u = w(a), x(l.b, u), u.d.c = s.d;
                            } else {
                                if (0 < b(l.b.a, a.b.a, l.a)) {
                                    s = !1;
                                    break e;
                                }
                                s.b = i.b = !0, u = w(l), x(a.e, l.b), u.b.d.c = s.d;
                            }
                            s = !0;
                        }
                        if (s && (r.c ? (k(r), m(n), n = (r = B(t)).a) : t.c && (k(t), m(o), o = (t = G(r)).a)), o.a !== n.a) {
                            if (o.b.a === n.b.a || t.c || r.c || o.b.a !== e1.a && n.b.a !== e1.a) R(e1, t);
                            else if (Q(e1, t)) break;
                        }
                        o.a === n.a && o.b.a === n.b.a && (E(n, o), k(t), m(o), t = G(r));
                    }
                }
                function K(e1, t) {
                    var r = new N, o = d(e1.b);
                    o.a.b = 4e150, o.a.a = t, o.b.a.b = -4000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000, o.b.a.a = t, e1.a = o.b.a, r.a = o, r.f = 0, r.d = !1, r.c = !1, r.h = !0, r.b = !1, o = p(o = e1.f, o.a, r), r.e = o;
                }
                function $(e1) {
                    this.a = new ee, this.b = e1, this.c = h;
                }
                function p(e1, t, r) {
                    for(; null !== (t = t.c).b && !e1.c(e1.b, t.b, r););
                    return e1 = new ee(r, t.a, t), t.a.c = e1, t.a = e1;
                }
                function ee(e1, t, r) {
                    this.b = e1 || null, this.a = t || this, this.c = r || this;
                }
                function r() {
                    this.d = 0, this.p = this.b = this.q = null, this.j = [
                        0,
                        0,
                        0
                    ], this.s = 100130, this.n = !1, this.o = this.a = this.e = this.f = null, this.m = !1, this.c = this.r = this.i = this.k = this.l = this.h = null;
                }
                function I(e1, t) {
                    if (e1.d !== t) for(; e1.d !== t;)if (e1.d < t) switch(e1.d){
                        case 0:
                            l(e1, 100151), e1.u(null);
                            break;
                        case 1:
                            l(e1, 100152), e1.t();
                    }
                    else switch(e1.d){
                        case 2:
                            l(e1, 100154), e1.v();
                            break;
                        case 1:
                            l(e1, 100153), e1.w();
                    }
                }
                function l(e1, t) {
                    e1.p && e1.p(t, e1.c);
                }
                function te(e1, t) {
                    this.b = e1 || this, this.d = t || this, this.a = null, this.c = !1;
                }
                function u() {
                    (this.h = this).i = this.d = this.a = this.e = this.c = this.b = null, this.f = 0;
                }
                function re() {
                    this.c = new D, this.a = new te, this.b = new u, this.d = new u, this.b.b = this.d, this.d.b = this.b;
                }
                function D(e1, t) {
                    this.e = e1 || this, this.f = t || this, this.d = this.c = null, this.g = [
                        0,
                        0,
                        0
                    ], this.h = this.a = this.b = 0;
                }
                function oe() {
                    this.c = [], this.d = null, this.a = 0, this.e = !1, this.b = new ie;
                }
                function ne(e1, t) {
                    var r, o, n;
                    return e1.e ? (2 * (o = ++(r = e1.b).a) > r.f && (r.f *= 2, r.c = ae(r.c, r.f + 1)), 0 === r.b ? n = o : (n = r.b, r.b = r.c[r.b]), r.e[n] = t, r.c[n] = o, r.d[o] = n, r.h && ue(r, o), n) : (r = e1.a++, e1.c[r] = t, -(r + 1));
                }
                function se(e1) {
                    if (0 === e1.a) return le(e1.b);
                    var t = e1.c[e1.d[e1.a - 1]];
                    if (0 !== e1.b.a && g(F(e1.b), t)) return le(e1.b);
                    for(; --e1.a, 0 < e1.a && null === e1.c[e1.d[e1.a - 1]];);
                    return t;
                }
                function ie() {
                    this.d = ae([
                        0
                    ], 33), this.e = [
                        null,
                        null
                    ], this.c = [
                        0,
                        0
                    ], this.a = 0, this.f = 32, this.b = 0, this.h = !1, this.d[1] = 1;
                }
                function ae(e1, t) {
                    for(var r = Array(t), o = 0; o < e1.length; o++)r[o] = e1[o];
                    for(; o < t; o++)r[o] = 0;
                    return r;
                }
                function F(e1) {
                    return e1.e[e1.d[1]];
                }
                function le(e1) {
                    var t = e1.d, r = e1.e, o = e1.c, n = t[1], s = r[n];
                    return 0 < e1.a && (t[1] = t[e1.a], o[t[1]] = 1, r[n] = null, o[n] = e1.b, e1.b = n, 0 < --e1.a && U(e1, 1)), s;
                }
                function U(e1, t) {
                    for(var r = e1.d, o = e1.e, n = e1.c, s = t, i = r[s];;){
                        var a = s << 1, l = (a < e1.a && g(o[r[a + 1]], o[r[a]]) && (a += 1), r[a]);
                        if (a > e1.a || g(o[i], o[l])) {
                            n[r[s] = i] = s;
                            break;
                        }
                        n[r[s] = l] = s, s = a;
                    }
                }
                function ue(e1, t) {
                    for(var r = e1.d, o = e1.e, n = e1.c, s = t, i = r[s];;){
                        var a = s >> 1, l = r[a];
                        if (0 == a || g(o[l], o[i])) {
                            n[r[s] = i] = s;
                            break;
                        }
                        n[r[s] = l] = s, s = a;
                    }
                }
                function N() {
                    this.e = this.a = null, this.f = 0, this.c = this.b = this.h = this.d = !1;
                }
                function B(e1) {
                    return e1.e.c.b;
                }
                function G(e1) {
                    return e1.e.a.b;
                }
                (t = r.prototype).x = function() {
                    I(this, 0);
                }, t.B = function(e1, t) {
                    switch(e1){
                        case 100142:
                            return;
                        case 100140:
                            switch(t){
                                case 100130:
                                case 100131:
                                case 100132:
                                case 100133:
                                case 100134:
                                    return void (this.s = t);
                            }
                            break;
                        case 100141:
                            return void (this.m = !!t);
                        default:
                            return void l(this, 100900);
                    }
                    l(this, 100901);
                }, t.y = function(e1) {
                    switch(e1){
                        case 100142:
                            return 0;
                        case 100140:
                            return this.s;
                        case 100141:
                            return this.m;
                        default:
                            l(this, 100900);
                    }
                    return !1;
                }, t.A = function(e1, t, r) {
                    this.j[0] = e1, this.j[1] = t, this.j[2] = r;
                }, t.z = function(e1, t) {
                    var r = t || null;
                    switch(e1){
                        case 100100:
                        case 100106:
                            this.h = r;
                            break;
                        case 100104:
                        case 100110:
                            this.l = r;
                            break;
                        case 100101:
                        case 100107:
                            this.k = r;
                            break;
                        case 100102:
                        case 100108:
                            this.i = r;
                            break;
                        case 100103:
                        case 100109:
                            this.p = r;
                            break;
                        case 100105:
                        case 100111:
                            this.o = r;
                            break;
                        case 100112:
                            this.r = r;
                            break;
                        default:
                            l(this, 100900);
                    }
                }, t.C = function(e1, t) {
                    var r = !1, o = [
                        0,
                        0,
                        0
                    ];
                    I(this, 2);
                    for(var n = 0; n < 3; ++n){
                        var s = e1[n];
                        s < -1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000 && (s = -1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000, r = !0), 1e150 < s && (s = 1e150, r = !0), o[n] = s;
                    }
                    r && l(this, 100155), null === (r = this.q) ? x(r = d(this.b), r.b) : (w(r), r = r.e), r.a.d = t, r.a.g[0] = o[0], r.a.g[1] = o[1], r.a.g[2] = o[2], r.f = 1, r.b.f = -1, this.q = r;
                }, t.u = function(e1) {
                    I(this, 0), this.d = 1, this.b = new re, this.c = e1;
                }, t.t = function() {
                    I(this, 1), this.d = 2, this.q = null;
                }, t.v = function() {
                    I(this, 2), this.d = 1;
                }, t.w = function() {
                    I(this, 1), this.d = 0;
                    var e1, t, r = this.j[0], o = this.j[1], n = this.j[2], s = !1, i = [
                        r,
                        o,
                        n
                    ];
                    if (0 === r && 0 === o && 0 === n) {
                        for(var o = [
                            -2000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                            -2000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                            -2000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000
                        ], a = [
                            2e150,
                            2e150,
                            2e150
                        ], n = [], l = [], r = (s = this.b.c).e; r !== s; r = r.e)for(var u = 0; u < 3; ++u){
                            var c = r.g[u];
                            c < a[u] && (a[u] = c, l[u] = r), c > o[u] && (o[u] = c, n[u] = r);
                        }
                        if (o[1] - a[1] > o[r = 0] - a[0] && (r = 1), a[r = o[2] - a[2] > o[r] - a[r] ? 2 : r] >= o[r]) i[0] = 0, i[1] = 0, i[2] = 1;
                        else {
                            for(a = l[r], n = n[r], l = [
                                o = 0,
                                0,
                                0
                            ], a = [
                                a.g[0] - n.g[0],
                                a.g[1] - n.g[1],
                                a.g[2] - n.g[2]
                            ], u = [
                                0,
                                0,
                                0
                            ], r = s.e; r !== s; r = r.e)u[0] = r.g[0] - n.g[0], u[1] = r.g[1] - n.g[1], u[2] = r.g[2] - n.g[2], l[0] = a[1] * u[2] - a[2] * u[1], l[1] = a[2] * u[0] - a[0] * u[2], l[2] = a[0] * u[1] - a[1] * u[0], o < (c = l[0] * l[0] + l[1] * l[1] + l[2] * l[2]) && (o = c, i[0] = l[0], i[1] = l[1], i[2] = l[2]);
                            o <= 0 && (i[0] = i[1] = i[2] = 0, i[W(a)] = 1);
                        }
                        s = !0;
                    }
                    for(l = W(i), r = this.b.c, o = (l + 1) % 3, n = (l + 2) % 3, l = 0 < i[l] ? 1 : -1, i = r.e; i !== r; i = i.e)i.b = i.g[o], i.a = l * i.g[n];
                    if (s) {
                        for(i = 0, r = (s = this.b.a).b; r !== s; r = r.b)if (!((o = r.a).f <= 0)) for(; i += (o.a.b - o.b.a.b) * (o.a.a + o.b.a.a), (o = o.e) !== r.a;);
                        if (i < 0) for(s = (i = this.b.c).e; s !== i; s = s.e)s.a = -s.a;
                    }
                    for(this.n = !1, i = this.b.b, r = i.h; r !== i; r = s)s = r.h, o = r.e, y(r.a, r.b.a) && r.e.e !== r && (L(this, o, r), m(r), o = (r = o).e), o.e === r && (o !== r && (o !== s && o !== s.b || (s = s.h), m(o)), r !== s && r !== s.b || (s = s.h), m(r));
                    for(this.e = i = new oe, s = this.b.c, r = s.e; r !== s; r = r.e)r.h = ne(i, r);
                    var d = i;
                    d.d = [];
                    for(var h = 0; h < d.a; h++)d.d[h] = h;
                    d.d.sort(function(r) {
                        return function(e1, t) {
                            return g(r[e1], r[t]) ? 1 : -1;
                        };
                    }(d.c)), d.e = !0;
                    for(var f = d.b, p = f.a; 1 <= p; --p)U(f, p);
                    for(f.h = !0, this.f = new $(this), K(this, -4000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000), K(this, 4e150); null !== (i = se(this.e));){
                        for(;;){
                            e: if (0 === (r = this.e).a) s = F(r.b);
                            else if (s = r.c[r.d[r.a - 1]], 0 !== r.b.a && g(r = F(r.b), s)) {
                                s = r;
                                break e;
                            }
                            if (null === s || !y(s, i)) break;
                            s = se(this.e), L(this, i.c, s.c);
                        }
                        !function e1(t, r) {
                            for(var o, n = (t.a = r).c; null === n.i;)if ((n = n.c) === r.c) {
                                var n = t, s = r;
                                (c = new N).a = s.c.b;
                                for(var i = (a = n.f).a; null !== (i = i.a).b && !a.c(a.b, c, i.b););
                                var a, l, u = B(a = i.b), c = a.a, i = u.a;
                                return void (0 === b(c.b.a, s, c.a) ? y((c = a.a).a, s) || y(c.b.a, s) || (w(c.b), a.c && (m(c.c), a.c = !1), x(s.c, c), e1(n, s)) : (l = g(i.b.a, c.b.a) ? a : u, u = void 0, a.d || l.c ? (u = l === a ? S(s.c.b, c.e) : S(i.b.c.b, s.c).b, l.c ? C(l, u) : ((a = q(c = n, a, u)).f = G(a).f + a.a.f, a.d = X(c, a.f)), e1(n, s)) : A(n, a, s.c, s.c, null, !0)));
                            }
                            a = (c = B(n = O(n.i))).a, (c = P(t, c, null)).c === a ? (c = (a = c).c, i = B(n), u = n.a, l = i.a, o = !1, u.b.a !== l.b.a && Q(t, n), y(u.a, t.a) && (x(c.b.e, u), c = B(n = O(n)).a, P(t, B(n), i), o = !0), y(l.a, t.a) && (x(a, l.b.e), a = P(t, i, null), o = !0), o ? A(t, n, a.c, c, c, !0) : (s = g(l.a, u.a) ? l.b.e : u, A(t, n, s = S(a.c.b, s), s.c, s.c, !1), s.b.i.c = !0, J(t, n))) : A(t, n, c.c, a, a, !0);
                        }(this, i);
                    }
                    for(this.a = this.f.a.a.b.a.a, i = 0; null !== (s = this.f.a.a.b);)s.h || ++i, k(s);
                    for(this.f = null, (i = this.e).b = null, i.d = null, this.e = i.c = null, i = this.b, r = i.a.b; r !== i.a; r = s)s = r.b, (r = r.a).e.e === r && (E(r.c, r), m(r));
                    if (!this.n) {
                        if (i = this.b, this.m) for(r = i.b.h; r !== i.b; r = s)s = r.h, r.b.d.c !== r.d.c ? r.f = r.d.c ? 1 : -1 : m(r);
                        else for(r = i.a.b; r !== i.a; r = s)if (s = r.b, r.c) {
                            for(r = r.a; g(r.b.a, r.a); r = r.c.b);
                            for(; g(r.a, r.b.a); r = r.e);
                            for(o = r.c.b, n = void 0; r.e !== o;)if (g(r.b.a, o.a)) {
                                for(; o.e !== r && (g((t = o.e).b.a, t.a) || b(o.a, o.b.a, o.e.b.a) <= 0);)o = (n = S(o.e, o)).b;
                                o = o.c.b;
                            } else {
                                for(; o.e !== r && (g((e1 = r.c.b).a, e1.b.a) || 0 <= b(r.b.a, r.a, r.c.b.a));)r = (n = S(r, r.c.b)).b;
                                r = r.e;
                            }
                            for(; o.e.e !== r;)n = S(o.e, o), o = n.b;
                        }
                        if (this.h || this.i || this.k || this.l) {
                            if (this.m) {
                                for(s = (i = this.b).a.b; s !== i.a; s = s.b)if (s.c) {
                                    for(this.h && this.h(2, this.c), r = s.a; this.k && this.k(r.a.d, this.c), (r = r.e) !== s.a;);
                                    this.i && this.i(this.c);
                                }
                            } else {
                                for(i = this.b, s = !!this.l, r = !1, o = -1, n = i.a.d; n !== i.a; n = n.d)if (n.c) for(r || (this.h && this.h(4, this.c), r = !0), l = n.a; s && (a = l.b.d.c ? 0 : 1, o !== a && (o = a, this.l && this.l(!!o, this.c))), this.k && this.k(l.a.d, this.c), (l = l.e) !== n.a;);
                                r && this.i && this.i(this.c);
                            }
                        }
                        if (this.r) {
                            for(i = this.b, r = i.a.b; r !== i.a; r = s)if (s = r.b, !r.c) {
                                for(n = (o = r.a).e, l = void 0; n = (l = n).e, (l.d = null) === l.b.d && (l.c === l ? M(l.a, null) : (l.a.c = l.c, T(l, l.b.e)), (a = l.b).c === a ? M(a.a, null) : (a.a.c = a.c, T(a, a.b.e)), H(l)), l !== o;);
                                o = r.d, ((r = r.b).d = o).b = r;
                            }
                            return this.r(this.b), void (this.c = this.b = null);
                        }
                    }
                    this.b = this.c = null;
                }, this.libtess = {
                    GluTesselator: r,
                    windingRule: {
                        GLU_TESS_WINDING_ODD: 100130,
                        GLU_TESS_WINDING_NONZERO: 100131,
                        GLU_TESS_WINDING_POSITIVE: 100132,
                        GLU_TESS_WINDING_NEGATIVE: 100133,
                        GLU_TESS_WINDING_ABS_GEQ_TWO: 100134
                    },
                    primitiveType: {
                        GL_LINE_LOOP: 2,
                        GL_TRIANGLES: 4,
                        GL_TRIANGLE_STRIP: 5,
                        GL_TRIANGLE_FAN: 6
                    },
                    errorType: {
                        GLU_TESS_MISSING_BEGIN_POLYGON: 100151,
                        GLU_TESS_MISSING_END_POLYGON: 100153,
                        GLU_TESS_MISSING_BEGIN_CONTOUR: 100152,
                        GLU_TESS_MISSING_END_CONTOUR: 100154,
                        GLU_TESS_COORD_TOO_LARGE: 100155,
                        GLU_TESS_NEED_COMBINE_CALLBACK: 100156
                    },
                    gluEnum: {
                        GLU_TESS_MESH: 100112,
                        GLU_TESS_TOLERANCE: 100142,
                        GLU_TESS_WINDING_RULE: 100140,
                        GLU_TESS_BOUNDARY_ONLY: 100141,
                        GLU_INVALID_ENUM: 100900,
                        GLU_INVALID_VALUE: 100901,
                        GLU_TESS_BEGIN: 100100,
                        GLU_TESS_VERTEX: 100101,
                        GLU_TESS_END: 100102,
                        GLU_TESS_ERROR: 100103,
                        GLU_TESS_EDGE_FLAG: 100104,
                        GLU_TESS_COMBINE: 100105,
                        GLU_TESS_BEGIN_DATA: 100106,
                        GLU_TESS_VERTEX_DATA: 100107,
                        GLU_TESS_END_DATA: 100108,
                        GLU_TESS_ERROR_DATA: 100109,
                        GLU_TESS_EDGE_FLAG_DATA: 100110,
                        GLU_TESS_COMBINE_DATA: 100111
                    }
                }, r.prototype.gluDeleteTess = r.prototype.x, r.prototype.gluTessProperty = r.prototype.B, r.prototype.gluGetTessProperty = r.prototype.y, r.prototype.gluTessNormal = r.prototype.A, r.prototype.gluTessCallback = r.prototype.z, r.prototype.gluTessVertex = r.prototype.C, r.prototype.gluTessBeginPolygon = r.prototype.u, r.prototype.gluTessBeginContour = r.prototype.t, r.prototype.gluTessEndContour = r.prototype.v, r.prototype.gluTessEndPolygon = r.prototype.w, void 0 !== e1 && (e1.exports = this.libtess);
            },
            {}
        ],
        248: [
            function(e1, t, r) {
                "use strict";
                function o(g, e1, t, r) {
                    var v = 0, o = void 0 === (r = void 0 === r ? {} : r).loop ? null : r.loop, b = void 0 === r.palette ? null : r.palette;
                    if (e1 <= 0 || t <= 0 || 65535 < e1 || 65535 < t) throw new Error("Width/Height invalid.");
                    function j(e1) {
                        e1 = e1.length;
                        if (e1 < 2 || 256 < e1 || e1 & e1 - 1) throw new Error("Invalid code/color length, must be power of 2 and 2 .. 256.");
                        return e1;
                    }
                    g[v++] = 71, g[v++] = 73, g[v++] = 70, g[v++] = 56, g[v++] = 57, g[v++] = 97;
                    var n = 0, s = 0;
                    if (null !== b) {
                        for(var i = j(b); i >>= 1;)++n;
                        if (i = 1 << n, --n, void 0 !== r.background) {
                            if (i <= (s = r.background)) throw new Error("Background index out of range.");
                            if (0 === s) throw new Error("Background index explicitly passed as 0.");
                        }
                    }
                    if (g[v++] = 255 & e1, g[v++] = e1 >> 8 & 255, g[v++] = 255 & t, g[v++] = t >> 8 & 255, g[v++] = (null !== b ? 128 : 0) | n, g[v++] = s, g[v++] = 0, null !== b) for(var a = 0, l = b.length; a < l; ++a){
                        var u = b[a];
                        g[v++] = u >> 16 & 255, g[v++] = u >> 8 & 255, g[v++] = 255 & u;
                    }
                    if (null !== o) {
                        if (o < 0 || 65535 < o) throw new Error("Loop count invalid.");
                        g[v++] = 33, g[v++] = 255, g[v++] = 11, g[v++] = 78, g[v++] = 69, g[v++] = 84, g[v++] = 83, g[v++] = 67, g[v++] = 65, g[v++] = 80, g[v++] = 69, g[v++] = 50, g[v++] = 46, g[v++] = 48, g[v++] = 3, g[v++] = 1, g[v++] = 255 & o, g[v++] = o >> 8 & 255, g[v++] = 0;
                    }
                    var _ = !1;
                    this.addFrame = function(e1, t, r, o, n, s) {
                        if (!0 === _ && (--v, _ = !1), s = void 0 === s ? {} : s, e1 < 0 || t < 0 || 65535 < e1 || 65535 < t) throw new Error("x/y invalid.");
                        if (r <= 0 || o <= 0 || 65535 < r || 65535 < o) throw new Error("Width/Height invalid.");
                        if (n.length < r * o) throw new Error("Not enough pixels for the frame size.");
                        var i = !0, a = s.palette;
                        if (null == a && (i = !1, a = b), null == a) throw new Error("Must supply either a local or global palette.");
                        for(var l = j(a), u = 0; l >>= 1;)++u;
                        var l = 1 << u, c = void 0 === s.delay ? 0 : s.delay, d = void 0 === s.disposal ? 0 : s.disposal;
                        if (d < 0 || 3 < d) throw new Error("Disposal out of range.");
                        var h = !1, f = 0;
                        if (void 0 !== s.transparent && null !== s.transparent && (h = !0, (f = s.transparent) < 0 || l <= f)) throw new Error("Transparent color index.");
                        if (0 === d && !h && 0 === c || (g[v++] = 33, g[v++] = 249, g[v++] = 4, g[v++] = d << 2 | (!0 === h ? 1 : 0), g[v++] = 255 & c, g[v++] = c >> 8 & 255, g[v++] = f, g[v++] = 0), g[v++] = 44, g[v++] = 255 & e1, g[v++] = e1 >> 8 & 255, g[v++] = 255 & t, g[v++] = t >> 8 & 255, g[v++] = 255 & r, g[v++] = r >> 8 & 255, g[v++] = 255 & o, g[v++] = o >> 8 & 255, g[v++] = !0 === i ? 128 | u - 1 : 0, !0 === i) for(var p = 0, m = a.length; p < m; ++p){
                            var y = a[p];
                            g[v++] = y >> 16 & 255, g[v++] = y >> 8 & 255, g[v++] = 255 & y;
                        }
                        return v = function(t, r, e1, o) {
                            t[r++] = e1;
                            var n = r++, s = 1 << e1, i = s - 1, a = 1 + s, l = 1 + a, u = e1 + 1, c = 0, d = 0;
                            function h(e1) {
                                for(; e1 <= c;)t[r++] = 255 & d, d >>= 8, c -= 8, r === n + 256 && (t[n] = 255, n = r++);
                            }
                            function f(e1) {
                                d |= e1 << c, c += u, h(8);
                            }
                            var p = o[0] & i, m = {};
                            f(s);
                            for(var y = 1, g = o.length; y < g; ++y){
                                var v = o[y] & i, b = p << 8 | v, j = m[b];
                                if (void 0 === j) {
                                    for(d |= p << c, c += u; 8 <= c;)t[r++] = 255 & d, d >>= 8, c -= 8, r === n + 256 && (t[n] = 255, n = r++);
                                    4096 === l ? (f(s), l = 1 + a, u = e1 + 1, m = {}) : (1 << u <= l && ++u, m[b] = l++), p = v;
                                } else p = j;
                            }
                            f(p), f(a), h(1), n + 1 === r ? t[n] = 0 : (t[n] = r - n - 1, t[r++] = 0);
                            return r;
                        }(g, v, u < 2 ? 2 : u, n);
                    }, this.end = function() {
                        return !1 === _ && (g[v++] = 59, _ = !0), v;
                    }, this.getOutputBuffer = function() {
                        return g;
                    }, this.setOutputBuffer = function(e1) {
                        g = e1;
                    }, this.getOutputBufferPosition = function() {
                        return v;
                    }, this.setOutputBufferPosition = function(e1) {
                        v = e1;
                    };
                }
                function M(e1, t, r, o) {
                    for(var n = e1[t++], s = 1 << n, i = 1 + s, a = 1 + i, l = n + 1, u = (1 << l) - 1, c = 0, d = 0, h = 0, f = e1[t++], p = new Int32Array(4096), m = null;;){
                        for(; c < 16 && 0 !== f;)d |= e1[t++] << c, c += 8, 1 === f ? f = e1[t++] : --f;
                        if (c < l) break;
                        var y = d & u;
                        if (d >>= l, c -= l, y == s) a = 1 + i, u = (1 << (l = n + 1)) - 1, m = null;
                        else {
                            if (y == i) break;
                            for(var g = y < a ? y : m, v = 0, b = g; s < b;)b = p[b] >> 8, ++v;
                            var j = b;
                            if (o < h + v + (g !== y ? 1 : 0)) return void console.log("Warning, gif stream longer than expected.");
                            r[h++] = j;
                            var _ = h += v;
                            for(g !== y && (r[h++] = j), b = g; v--;)b = p[b], r[--_] = 255 & b, b >>= 8;
                            null !== m && a < 4096 && (p[a++] = m << 8 | j, u + 1 <= a && l < 12 && (++l, u = u << 1 | 1)), m = y;
                        }
                    }
                    h !== o && console.log("Warning, gif stream shorter than expected.");
                }
                try {
                    r.GifWriter = o, r.GifReader = function(b) {
                        var e1 = 0;
                        if (71 !== b[e1++] || 73 !== b[e1++] || 70 !== b[e1++] || 56 !== b[e1++] || 56 != (b[e1++] + 1 & 253) || 97 !== b[e1++]) throw new Error("Invalid GIF 87a/89a header.");
                        var j = b[e1++] | b[e1++] << 8, t = b[e1++] | b[e1++] << 8, r = b[e1++], o = 1 << 1 + (7 & r), n = (b[e1++], b[e1++], null), s = null, i = (r >> 7 && (n = e1, e1 += 3 * (s = o)), !0), a = [], l = 0, u = null, c = 0, d = null;
                        for(this.width = j, this.height = t; i && e1 < b.length;)switch(b[e1++]){
                            case 33:
                                switch(b[e1++]){
                                    case 255:
                                        if (11 !== b[e1] || 78 == b[e1 + 1] && 69 == b[e1 + 2] && 84 == b[e1 + 3] && 83 == b[e1 + 4] && 67 == b[e1 + 5] && 65 == b[e1 + 6] && 80 == b[e1 + 7] && 69 == b[e1 + 8] && 50 == b[e1 + 9] && 46 == b[e1 + 10] && 48 == b[e1 + 11] && 3 == b[e1 + 12] && 1 == b[e1 + 13] && 0 == b[e1 + 16]) e1 += 14, d = b[e1++] | b[e1++] << 8, e1++;
                                        else for(e1 += 12;;){
                                            if (!(0 <= (f = b[e1++]))) throw Error("Invalid block size");
                                            if (0 === f) break;
                                            e1 += f;
                                        }
                                        break;
                                    case 249:
                                        if (4 !== b[e1++] || 0 !== b[e1 + 4]) throw new Error("Invalid graphics extension block.");
                                        var h = b[e1++], l = b[e1++] | b[e1++] << 8, u = b[e1++];
                                        0 == (1 & h) && (u = null), c = h >> 2 & 7, e1++;
                                        break;
                                    case 254:
                                        for(;;){
                                            if (!(0 <= (f = b[e1++]))) throw Error("Invalid block size");
                                            if (0 === f) break;
                                            e1 += f;
                                        }
                                        break;
                                    default:
                                        throw new Error("Unknown graphic control label: 0x" + b[e1 - 1].toString(16));
                                }
                                break;
                            case 44:
                                var f, p = b[e1++] | b[e1++] << 8, m = b[e1++] | b[e1++] << 8, y = b[e1++] | b[e1++] << 8, g = b[e1++] | b[e1++] << 8, v = b[e1++], _ = v >> 6 & 1, x = 1 << 1 + (7 & v), w = n, S = s, T = !1, v = (v >> 7 && (T = !0, w = e1, e1 += 3 * (S = x)), e1);
                                for(e1++;;){
                                    if (!(0 <= (f = b[e1++]))) throw Error("Invalid block size");
                                    if (0 === f) break;
                                    e1 += f;
                                }
                                a.push({
                                    x: p,
                                    y: m,
                                    width: y,
                                    height: g,
                                    has_local_palette: T,
                                    palette_offset: w,
                                    palette_size: S,
                                    data_offset: v,
                                    data_length: e1 - v,
                                    transparent_index: u,
                                    interlaced: !!_,
                                    delay: l,
                                    disposal: c
                                });
                                break;
                            case 59:
                                i = !1;
                                break;
                            default:
                                throw new Error("Unknown gif block: 0x" + b[e1 - 1].toString(16));
                        }
                        this.numFrames = function() {
                            return a.length;
                        }, this.loopCount = function() {
                            return d;
                        }, this.frameInfo = function(e1) {
                            if (e1 < 0 || e1 >= a.length) throw new Error("Frame index out of range.");
                            return a[e1];
                        }, this.decodeAndBlitFrameBGRA = function(e1, t) {
                            for(var e1 = this.frameInfo(e1), r = e1.width * e1.height, o = new Uint8Array(r), n = (M(b, e1.data_offset, o, r), e1.palette_offset), s = e1.transparent_index, i = (null === s && (s = 256), e1.width), a = j - i, l = i, u = 4 * (e1.y * j + e1.x), c = 4 * ((e1.y + e1.height) * j + e1.x), d = u, h = 4 * a, f = (!0 === e1.interlaced && (h += 4 * j * 7), 8), p = 0, m = o.length; p < m; ++p){
                                var y, g, v = o[p];
                                0 === l && (l = i, c <= (d += h) && (h = 4 * a + 4 * j * (f - 1), d = u + (i + a) * (f << 1), f >>= 1)), v === s ? d += 4 : (y = b[n + 3 * v], g = b[n + 3 * v + 1], v = b[n + 3 * v + 2], t[d++] = v, t[d++] = g, t[d++] = y, t[d++] = 255), --l;
                            }
                        }, this.decodeAndBlitFrameRGBA = function(e1, t) {
                            for(var e1 = this.frameInfo(e1), r = e1.width * e1.height, o = new Uint8Array(r), n = (M(b, e1.data_offset, o, r), e1.palette_offset), s = e1.transparent_index, i = (null === s && (s = 256), e1.width), a = j - i, l = i, u = 4 * (e1.y * j + e1.x), c = 4 * ((e1.y + e1.height) * j + e1.x), d = u, h = 4 * a, f = (!0 === e1.interlaced && (h += 4 * j * 7), 8), p = 0, m = o.length; p < m; ++p){
                                var y, g, v = o[p];
                                0 === l && (l = i, c <= (d += h) && (h = 4 * a + 4 * j * (f - 1), d = u + (i + a) * (f << 1), f >>= 1)), v === s ? d += 4 : (y = b[n + 3 * v], g = b[n + 3 * v + 1], v = b[n + 3 * v + 2], t[d++] = y, t[d++] = g, t[d++] = v, t[d++] = 255), --l;
                            }
                        };
                    };
                } catch (e1) {}
            },
            {}
        ],
        249: [
            function(Ar, r, o) {
                (function(Pr) {
                    var e1, t;
                    e1 = this, t = function(j) {
                        "use strict";
                        function D(e1) {
                            if (null == this) throw TypeError();
                            var t, r = String(this), o = r.length, e1 = e1 ? Number(e1) : 0;
                            if (!((e1 = e1 != e1 ? 0 : e1) < 0 || o <= e1)) return 55296 <= (t = r.charCodeAt(e1)) && t <= 56319 && e1 + 1 < o && 56320 <= (o = r.charCodeAt(e1 + 1)) && o <= 57343 ? 1024 * (t - 55296) + o - 56320 + 65536 : t;
                        }
                        String.prototype.codePointAt || ((F = function() {
                            try {
                                var e1 = {}, t = Object.defineProperty, r = t(e1, e1, e1) && t;
                            } catch (e1) {}
                            return r;
                        }()) ? F(String.prototype, "codePointAt", {
                            value: D,
                            configurable: !0,
                            writable: !0
                        }) : String.prototype.codePointAt = D);
                        var F, U = 0, N = -3;
                        function B() {
                            this.table = new Uint16Array(16), this.trans = new Uint16Array(288);
                        }
                        function G(e1, t) {
                            this.source = e1, this.sourceIndex = 0, this.tag = 0, this.bitcount = 0, this.dest = t, this.destLen = 0, this.ltree = new B, this.dtree = new B;
                        }
                        var V = new B, z = new B, H = new Uint8Array(30), W = new Uint16Array(30), q = new Uint8Array(30), X = new Uint16Array(30), Y = new Uint8Array([
                            16,
                            17,
                            18,
                            0,
                            8,
                            7,
                            9,
                            6,
                            10,
                            5,
                            11,
                            4,
                            12,
                            3,
                            13,
                            2,
                            14,
                            1,
                            15
                        ]), Z = new B, v = new Uint8Array(320);
                        function Q(e1, t, r, o) {
                            for(var n, s = 0; s < r; ++s)e1[s] = 0;
                            for(s = 0; s < 30 - r; ++s)e1[s + r] = s / r | 0;
                            for(n = o, s = 0; s < 30; ++s)t[s] = n, n += 1 << e1[s];
                        }
                        var J = new Uint16Array(16);
                        function K(e1, t, r, o) {
                            for(var n, s = 0; s < 16; ++s)e1.table[s] = 0;
                            for(s = 0; s < o; ++s)e1.table[t[r + s]]++;
                            for(s = n = e1.table[0] = 0; s < 16; ++s)J[s] = n, n += e1.table[s];
                            for(s = 0; s < o; ++s)t[r + s] && (e1.trans[J[t[r + s]]++] = s);
                        }
                        function b(e1, t, r) {
                            if (!t) return r;
                            for(; e1.bitcount < 24;)e1.tag |= e1.source[e1.sourceIndex++] << e1.bitcount, e1.bitcount += 8;
                            var o = e1.tag & 65535 >>> 16 - t;
                            return e1.tag >>>= t, e1.bitcount -= t, o + r;
                        }
                        function $(e1, t) {
                            for(; e1.bitcount < 24;)e1.tag |= e1.source[e1.sourceIndex++] << e1.bitcount, e1.bitcount += 8;
                            for(var r = 0, o = 0, n = 0, s = e1.tag; o = 2 * o + (1 & s), s >>>= 1, r += t.table[++n], 0 <= (o -= t.table[n]););
                            return e1.tag = s, e1.bitcount -= n, t.trans[r + o];
                        }
                        function ee(e1, t, r) {
                            for(;;){
                                var o = $(e1, t);
                                if (256 === o) return U;
                                if (o < 256) e1.dest[e1.destLen++] = o;
                                else for(var n, s = b(e1, H[o -= 257], W[o]), o = $(e1, r), i = n = e1.destLen - b(e1, q[o], X[o]); i < n + s; ++i)e1.dest[e1.destLen++] = e1.dest[i];
                            }
                        }
                        for(var e1 = V, te = z, t = 0; t < 7; ++t)e1.table[t] = 0;
                        for(e1.table[7] = 24, e1.table[8] = 152, e1.table[9] = 112, t = 0; t < 24; ++t)e1.trans[t] = 256 + t;
                        for(t = 0; t < 144; ++t)e1.trans[24 + t] = t;
                        for(t = 0; t < 8; ++t)e1.trans[168 + t] = 280 + t;
                        for(t = 0; t < 112; ++t)e1.trans[176 + t] = 144 + t;
                        for(t = 0; t < 5; ++t)te.table[t] = 0;
                        for(te.table[5] = 32, t = 0; t < 32; ++t)te.trans[t] = t;
                        Q(H, W, 4, 3), Q(q, X, 2, 1), H[28] = 0, W[28] = 258;
                        var re = function(e1, t) {
                            var r, o, n, s = new G(e1, t);
                            do {
                                switch(n = void 0, (o = s).bitcount-- || (o.tag = o.source[o.sourceIndex++], o.bitcount = 7), n = 1 & o.tag, o.tag >>>= 1, o = n, b(s, 2, 0)){
                                    case 0:
                                        r = function(e1) {
                                            for(var t, r; 8 < e1.bitcount;)e1.sourceIndex--, e1.bitcount -= 8;
                                            if ((t = 256 * e1.source[e1.sourceIndex + 1] + e1.source[e1.sourceIndex]) !== (65535 & ~(256 * e1.source[e1.sourceIndex + 3] + e1.source[e1.sourceIndex + 2]))) return N;
                                            for(e1.sourceIndex += 4, r = t; r; --r)e1.dest[e1.destLen++] = e1.source[e1.sourceIndex++];
                                            return e1.bitcount = 0, U;
                                        }(s);
                                        break;
                                    case 1:
                                        r = ee(s, V, z);
                                        break;
                                    case 2:
                                        y = m = p = g = i = f = h = d = c = u = l = a = void 0;
                                        for(var i, a = s, l = s.ltree, u = s.dtree, c = b(a, 5, 257), d = b(a, 5, 1), h = b(a, 4, 4), f = 0; f < 19; ++f)v[f] = 0;
                                        for(f = 0; f < h; ++f){
                                            var p = b(a, 3, 0);
                                            v[Y[f]] = p;
                                        }
                                        for(K(Z, v, 0, 19), i = 0; i < c + d;){
                                            var m = $(a, Z);
                                            switch(m){
                                                case 16:
                                                    for(var y = v[i - 1], g = b(a, 2, 3); g; --g)v[i++] = y;
                                                    break;
                                                case 17:
                                                    for(g = b(a, 3, 3); g; --g)v[i++] = 0;
                                                    break;
                                                case 18:
                                                    for(g = b(a, 7, 11); g; --g)v[i++] = 0;
                                                    break;
                                                default:
                                                    v[i++] = m;
                                            }
                                        }
                                        K(l, v, 0, c), K(u, v, c, d), r = ee(s, s.ltree, s.dtree);
                                        break;
                                    default:
                                        r = N;
                                }
                                if (r !== U) throw new Error("Data error");
                            }while (!o);
                            return s.destLen < s.dest.length ? "function" == typeof s.dest.slice ? s.dest.slice(0, s.destLen) : s.dest.subarray(0, s.destLen) : s.dest;
                        };
                        function g(e1, t, r, o, n) {
                            return Math.pow(1 - n, 3) * e1 + 3 * Math.pow(1 - n, 2) * n * t + 3 * (1 - n) * Math.pow(n, 2) * r + Math.pow(n, 3) * o;
                        }
                        function a() {
                            this.x1 = Number.NaN, this.y1 = Number.NaN, this.x2 = Number.NaN, this.y2 = Number.NaN;
                        }
                        function h() {
                            this.commands = [], this.fill = "black", this.stroke = null, this.strokeWidth = 1;
                        }
                        function oe(e1) {
                            throw new Error(e1);
                        }
                        function ne(e1, t) {
                            e1 || oe(t);
                        }
                        a.prototype.isEmpty = function() {
                            return isNaN(this.x1) || isNaN(this.y1) || isNaN(this.x2) || isNaN(this.y2);
                        }, a.prototype.addPoint = function(e1, t) {
                            "number" == typeof e1 && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = e1, this.x2 = e1), e1 < this.x1 && (this.x1 = e1), e1 > this.x2 && (this.x2 = e1)), "number" == typeof t && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = t, this.y2 = t), t < this.y1 && (this.y1 = t), t > this.y2 && (this.y2 = t));
                        }, a.prototype.addX = function(e1) {
                            this.addPoint(e1, null);
                        }, a.prototype.addY = function(e1) {
                            this.addPoint(null, e1);
                        }, a.prototype.addBezier = function(e1, t, r, o, n, s, i, a) {
                            var l = [
                                e1,
                                t
                            ], u = [
                                r,
                                o
                            ], c = [
                                n,
                                s
                            ], d = [
                                i,
                                a
                            ];
                            this.addPoint(e1, t), this.addPoint(i, a);
                            for(var h = 0; h <= 1; h++){
                                var f, p = 6 * l[h] - 12 * u[h] + 6 * c[h], m = -3 * l[h] + 9 * u[h] - 9 * c[h] + 3 * d[h], y = 3 * u[h] - 3 * l[h];
                                0 == m ? 0 == p || 0 < (f = -y / p) && f < 1 && (0 === h && this.addX(g(l[h], u[h], c[h], d[h], f)), 1 === h && this.addY(g(l[h], u[h], c[h], d[h], f))) : (f = Math.pow(p, 2) - 4 * y * m) < 0 || (0 < (y = (-p + Math.sqrt(f)) / (2 * m)) && y < 1 && (0 === h && this.addX(g(l[h], u[h], c[h], d[h], y)), 1 === h && this.addY(g(l[h], u[h], c[h], d[h], y))), 0 < (y = (-p - Math.sqrt(f)) / (2 * m)) && y < 1 && (0 === h && this.addX(g(l[h], u[h], c[h], d[h], y)), 1 === h && this.addY(g(l[h], u[h], c[h], d[h], y))));
                            }
                        }, a.prototype.addQuad = function(e1, t, r, o, n, s) {
                            r = e1 + 2 / 3 * (r - e1), o = t + 2 / 3 * (o - t);
                            this.addBezier(e1, t, r, o, r + 1 / 3 * (n - e1), o + 1 / 3 * (s - t), n, s);
                        }, h.prototype.moveTo = function(e1, t) {
                            this.commands.push({
                                type: "M",
                                x: e1,
                                y: t
                            });
                        }, h.prototype.lineTo = function(e1, t) {
                            this.commands.push({
                                type: "L",
                                x: e1,
                                y: t
                            });
                        }, h.prototype.curveTo = h.prototype.bezierCurveTo = function(e1, t, r, o, n, s) {
                            this.commands.push({
                                type: "C",
                                x1: e1,
                                y1: t,
                                x2: r,
                                y2: o,
                                x: n,
                                y: s
                            });
                        }, h.prototype.quadTo = h.prototype.quadraticCurveTo = function(e1, t, r, o) {
                            this.commands.push({
                                type: "Q",
                                x1: e1,
                                y1: t,
                                x: r,
                                y: o
                            });
                        }, h.prototype.close = h.prototype.closePath = function() {
                            this.commands.push({
                                type: "Z"
                            });
                        }, h.prototype.extend = function(e1) {
                            var t;
                            if (e1.commands) e1 = e1.commands;
                            else if (e1 instanceof a) return t = e1, this.moveTo(t.x1, t.y1), this.lineTo(t.x2, t.y1), this.lineTo(t.x2, t.y2), this.lineTo(t.x1, t.y2), void this.close();
                            Array.prototype.push.apply(this.commands, e1);
                        }, h.prototype.getBoundingBox = function() {
                            for(var e1 = new a, t = 0, r = 0, o = 0, n = 0, s = 0; s < this.commands.length; s++){
                                var i = this.commands[s];
                                switch(i.type){
                                    case "M":
                                        e1.addPoint(i.x, i.y), t = o = i.x, r = n = i.y;
                                        break;
                                    case "L":
                                        e1.addPoint(i.x, i.y), o = i.x, n = i.y;
                                        break;
                                    case "Q":
                                        e1.addQuad(o, n, i.x1, i.y1, i.x, i.y), o = i.x, n = i.y;
                                        break;
                                    case "C":
                                        e1.addBezier(o, n, i.x1, i.y1, i.x2, i.y2, i.x, i.y), o = i.x, n = i.y;
                                        break;
                                    case "Z":
                                        o = t, n = r;
                                        break;
                                    default:
                                        throw new Error("Unexpected path command " + i.type);
                                }
                            }
                            return e1.isEmpty() && e1.addPoint(0, 0), e1;
                        }, h.prototype.draw = function(e1) {
                            e1.beginPath();
                            for(var t = 0; t < this.commands.length; t += 1){
                                var r = this.commands[t];
                                "M" === r.type ? e1.moveTo(r.x, r.y) : "L" === r.type ? e1.lineTo(r.x, r.y) : "C" === r.type ? e1.bezierCurveTo(r.x1, r.y1, r.x2, r.y2, r.x, r.y) : "Q" === r.type ? e1.quadraticCurveTo(r.x1, r.y1, r.x, r.y) : "Z" === r.type && e1.closePath();
                            }
                            this.fill && (e1.fillStyle = this.fill, e1.fill()), this.stroke && (e1.strokeStyle = this.stroke, e1.lineWidth = this.strokeWidth, e1.stroke());
                        }, h.prototype.toPathData = function(n) {
                            function e1() {
                                for(var e1 = arguments, t = "", r = 0; r < arguments.length; r += 1){
                                    var o = e1[r];
                                    0 <= o && 0 < r && (t += " "), t += (o, Math.round(o) === o ? "" + Math.round(o) : o.toFixed(n));
                                }
                                return t;
                            }
                            n = void 0 !== n ? n : 2;
                            for(var t = "", r = 0; r < this.commands.length; r += 1){
                                var o = this.commands[r];
                                "M" === o.type ? t += "M" + e1(o.x, o.y) : "L" === o.type ? t += "L" + e1(o.x, o.y) : "C" === o.type ? t += "C" + e1(o.x1, o.y1, o.x2, o.y2, o.x, o.y) : "Q" === o.type ? t += "Q" + e1(o.x1, o.y1, o.x, o.y) : "Z" === o.type && (t += "Z");
                            }
                            return t;
                        }, h.prototype.toSVG = function(e1) {
                            var t = (t = '<path d="') + this.toPathData(e1) + '"';
                            return this.fill && "black" !== this.fill && (null === this.fill ? t += ' fill="none"' : t += ' fill="' + this.fill + '"'), this.stroke && (t += ' stroke="' + this.stroke + '" stroke-width="' + this.strokeWidth + '"'), t += "/>";
                        }, h.prototype.toDOMElement = function(e1) {
                            var e1 = this.toPathData(e1), t = document.createElementNS("http://www.w3.org/2000/svg", "path");
                            return t.setAttribute("d", e1), t;
                        };
                        var L = {
                            fail: oe,
                            argument: ne,
                            assert: ne
                        }, m = {}, w = {}, l = {};
                        function r(e1) {
                            return function() {
                                return e1;
                            };
                        }
                        w.BYTE = function(e1) {
                            return L.argument(0 <= e1 && e1 <= 255, "Byte value should be between 0 and 255."), [
                                e1
                            ];
                        }, l.BYTE = r(1), w.CHAR = function(e1) {
                            return [
                                e1.charCodeAt(0)
                            ];
                        }, l.CHAR = r(1), w.CHARARRAY = function(e1) {
                            for(var t = [], r = 0; r < e1.length; r += 1)t[r] = e1.charCodeAt(r);
                            return t;
                        }, l.CHARARRAY = function(e1) {
                            return e1.length;
                        }, w.USHORT = function(e1) {
                            return [
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.USHORT = r(2), w.SHORT = function(e1) {
                            return [
                                (e1 = 32768 <= e1 ? -(65536 - e1) : e1) >> 8 & 255,
                                255 & e1
                            ];
                        }, l.SHORT = r(2), w.UINT24 = function(e1) {
                            return [
                                e1 >> 16 & 255,
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.UINT24 = r(3), w.ULONG = function(e1) {
                            return [
                                e1 >> 24 & 255,
                                e1 >> 16 & 255,
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.ULONG = r(4), w.LONG = function(e1) {
                            return [
                                (e1 = 2147483648 <= e1 ? -(4294967296 - e1) : e1) >> 24 & 255,
                                e1 >> 16 & 255,
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.LONG = r(4), w.FIXED = w.ULONG, l.FIXED = l.ULONG, w.FWORD = w.SHORT, l.FWORD = l.SHORT, w.UFWORD = w.USHORT, l.UFWORD = l.USHORT, w.LONGDATETIME = function(e1) {
                            return [
                                0,
                                0,
                                0,
                                0,
                                e1 >> 24 & 255,
                                e1 >> 16 & 255,
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.LONGDATETIME = r(8), w.TAG = function(e1) {
                            return L.argument(4 === e1.length, "Tag should be exactly 4 ASCII characters."), [
                                e1.charCodeAt(0),
                                e1.charCodeAt(1),
                                e1.charCodeAt(2),
                                e1.charCodeAt(3)
                            ];
                        }, l.TAG = r(4), w.Card8 = w.BYTE, l.Card8 = l.BYTE, w.Card16 = w.USHORT, l.Card16 = l.USHORT, w.OffSize = w.BYTE, l.OffSize = l.BYTE, w.SID = w.USHORT, l.SID = l.USHORT, w.NUMBER = function(e1) {
                            return -107 <= e1 && e1 <= 107 ? [
                                e1 + 139
                            ] : 108 <= e1 && e1 <= 1131 ? [
                                247 + ((e1 -= 108) >> 8),
                                255 & e1
                            ] : -1131 <= e1 && e1 <= -108 ? [
                                251 + ((e1 = -e1 - 108) >> 8),
                                255 & e1
                            ] : -32768 <= e1 && e1 <= 32767 ? w.NUMBER16(e1) : w.NUMBER32(e1);
                        }, l.NUMBER = function(e1) {
                            return w.NUMBER(e1).length;
                        }, w.NUMBER16 = function(e1) {
                            return [
                                28,
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.NUMBER16 = r(3), w.NUMBER32 = function(e1) {
                            return [
                                29,
                                e1 >> 24 & 255,
                                e1 >> 16 & 255,
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.NUMBER32 = r(5), w.REAL = function(e1) {
                            for(var t = e1.toString(), r = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(t), o = (r && (r = parseFloat("1e" + ((r[2] ? +r[2] : 0) + r[1].length)), t = (Math.round(e1 * r) / r).toString()), ""), n = 0, s = t.length; n < s; n += 1){
                                var i = t[n];
                                o += "e" === i ? "-" === t[++n] ? "c" : "b" : "." === i ? "a" : "-" === i ? "e" : i;
                            }
                            for(var a = [
                                30
                            ], l = 0, u = (o += 1 & o.length ? "f" : "ff").length; l < u; l += 2)a.push(parseInt(o.substr(l, 2), 16));
                            return a;
                        }, l.REAL = function(e1) {
                            return w.REAL(e1).length;
                        }, w.NAME = w.CHARARRAY, l.NAME = l.CHARARRAY, w.STRING = w.CHARARRAY, l.STRING = l.CHARARRAY, m.UTF8 = function(e1, t, r) {
                            for(var o = [], n = r, s = 0; s < n; s++, t += 1)o[s] = e1.getUint8(t);
                            return String.fromCharCode.apply(null, o);
                        }, m.UTF16 = function(e1, t, r) {
                            for(var o = [], n = r / 2, s = 0; s < n; s++, t += 2)o[s] = e1.getUint16(t);
                            return String.fromCharCode.apply(null, o);
                        }, w.UTF16 = function(e1) {
                            for(var t = [], r = 0; r < e1.length; r += 1){
                                var o = e1.charCodeAt(r);
                                t[t.length] = o >> 8 & 255, t[t.length] = 255 & o;
                            }
                            return t;
                        }, l.UTF16 = function(e1) {
                            return 2 * e1.length;
                        };
                        var se, ie = {
                            "x-mac-croatian": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\u0160\u2122\xb4\xa8\u2260\u017D\xd8\u221E\xb1\u2264\u2265\u2206\xb5\u2202\u2211\u220F\u0161\u222B\xaa\xba\u03A9\u017E\xf8\xbf\xa1\xac\u221A\u0192\u2248\u0106\xab\u010C\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u0110\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\uF8FF\xa9\u2044\u20AC\u2039\u203A\xc6\xbb\u2013\xb7\u201A\u201E\u2030\xc2\u0107\xc1\u010D\xc8\xcd\xce\xcf\xcc\xd3\xd4\u0111\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u03C0\xcb\u02DA\xb8\xca\xe6\u02C7",
                            "x-mac-cyrillic": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\u0490\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u0491\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E",
                            "x-mac-gaelic": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u1E02\xb1\u2264\u2265\u1E03\u010A\u010B\u1E0A\u1E0B\u1E1E\u1E1F\u0120\u0121\u1E40\xe6\xf8\u1E41\u1E56\u1E57\u027C\u0192\u017F\u1E60\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\u1E61\u1E9B\xff\u0178\u1E6A\u20AC\u2039\u203A\u0176\u0177\u1E6B\xb7\u1EF2\u1EF3\u204A\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\u2663\xd2\xda\xdb\xd9\u0131\xdd\xfd\u0174\u0175\u1E84\u1E85\u1E80\u1E81\u1E82\u1E83",
                            "x-mac-greek": "\xc4\xb9\xb2\xc9\xb3\xd6\xdc\u0385\xe0\xe2\xe4\u0384\xa8\xe7\xe9\xe8\xea\xeb\xa3\u2122\xee\xef\u2022\xbd\u2030\xf4\xf6\xa6\u20AC\xf9\xfb\xfc\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xdf\xae\xa9\u03A3\u03AA\xa7\u2260\xb0\xb7\u0391\xb1\u2264\u2265\xa5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xac\u039F\u03A1\u2248\u03A4\xab\xbb\u2026\xa0\u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xf7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\xad",
                            "x-mac-icelandic": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\u20AC\xd0\xf0\xde\xfe\xfd\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7",
                            "x-mac-inuit": "\u1403\u1404\u1405\u1406\u140A\u140B\u1431\u1432\u1433\u1434\u1438\u1439\u1449\u144E\u144F\u1450\u1451\u1455\u1456\u1466\u146D\u146E\u146F\u1470\u1472\u1473\u1483\u148B\u148C\u148D\u148E\u1490\u1491\xb0\u14A1\u14A5\u14A6\u2022\xb6\u14A7\xae\xa9\u2122\u14A8\u14AA\u14AB\u14BB\u14C2\u14C3\u14C4\u14C5\u14C7\u14C8\u14D0\u14EF\u14F0\u14F1\u14F2\u14F4\u14F5\u1505\u14D5\u14D6\u14D7\u14D8\u14DA\u14DB\u14EA\u1528\u1529\u152A\u152B\u152D\u2026\xa0\u152E\u153E\u1555\u1556\u1557\u2013\u2014\u201C\u201D\u2018\u2019\u1558\u1559\u155A\u155D\u1546\u1547\u1548\u1549\u154B\u154C\u1550\u157F\u1580\u1581\u1582\u1583\u1584\u1585\u158F\u1590\u1591\u1592\u1593\u1594\u1595\u1671\u1672\u1673\u1674\u1675\u1676\u1596\u15A0\u15A1\u15A2\u15A3\u15A4\u15A5\u15A6\u157C\u0141\u0142",
                            "x-mac-ce": "\xc4\u0100\u0101\xc9\u0104\xd6\xdc\xe1\u0105\u010C\xe4\u010D\u0106\u0107\xe9\u0179\u017A\u010E\xed\u010F\u0112\u0113\u0116\xf3\u0117\xf4\xf6\xf5\xfa\u011A\u011B\xfc\u2020\xb0\u0118\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\u0119\xa8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xac\u221A\u0144\u0147\u2206\xab\xbb\u2026\xa0\u0148\u0150\xd5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xc1\u0164\u0165\xcd\u017D\u017E\u016A\xd3\xd4\u016B\u016E\xda\u016F\u0170\u0171\u0172\u0173\xdd\xfd\u0137\u017B\u0141\u017C\u0122\u02C7",
                            macintosh: "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\u20AC\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7",
                            "x-mac-romanian": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\u0102\u0218\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\u0103\u0219\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\u20AC\u2039\u203A\u021A\u021B\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7",
                            "x-mac-turkish": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\uF8A0\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
                        }, ae = (m.MACSTRING = function(e1, t, r, o) {
                            var n = ie[o];
                            if (void 0 !== n) {
                                for(var s = "", i = 0; i < r; i++){
                                    var a = e1.getUint8(t + i);
                                    s += a <= 127 ? String.fromCharCode(a) : n[127 & a];
                                }
                                return s;
                            }
                        }, "function" == typeof WeakMap && new WeakMap);
                        function le(e1) {
                            return -128 <= e1 && e1 <= 127;
                        }
                        w.MACSTRING = function(e1, t) {
                            var r = function(e1) {
                                if (!se) for(var t in se = {}, ie)se[t] = new String(t);
                                var r = se[e1];
                                if (void 0 !== r) {
                                    if (ae) {
                                        var o = ae.get(r);
                                        if (void 0 !== o) return o;
                                    }
                                    var n = ie[e1];
                                    if (void 0 !== n) {
                                        for(var s = {}, i = 0; i < n.length; i++)s[n.charCodeAt(i)] = i + 128;
                                        return ae && ae.set(r, s), s;
                                    }
                                }
                            }(t);
                            if (void 0 !== r) {
                                for(var o = [], n = 0; n < e1.length; n++){
                                    var s = e1.charCodeAt(n);
                                    if (128 <= s && void 0 === (s = r[s])) return;
                                    o[n] = s;
                                }
                                return o;
                            }
                        }, l.MACSTRING = function(e1, t) {
                            e1 = w.MACSTRING(e1, t);
                            return void 0 !== e1 ? e1.length : 0;
                        }, w.VARDELTAS = function(e1) {
                            for(var t = 0, r = []; t < e1.length;)var o = e1[t], t = (0 === o ? function(e1, t, r) {
                                for(var o = 0, n = e1.length; t < n && o < 64 && 0 === e1[t];)++t, ++o;
                                return r.push(128 | o - 1), t;
                            } : -128 <= o && o <= 127 ? function(e1, t, r) {
                                for(var o = 0, n = e1.length, s = t; s < n && o < 64;){
                                    var i = e1[s];
                                    if (!le(i)) break;
                                    if (0 === i && s + 1 < n && 0 === e1[s + 1]) break;
                                    ++s, ++o;
                                }
                                r.push(o - 1);
                                for(var a = t; a < s; ++a)r.push(e1[a] + 256 & 255);
                                return s;
                            } : function(e1, t, r) {
                                for(var o = 0, n = e1.length, s = t; s < n && o < 64;){
                                    var i = e1[s];
                                    if (0 === i) break;
                                    if (le(i) && s + 1 < n && le(e1[s + 1])) break;
                                    ++s, ++o;
                                }
                                r.push(64 | o - 1);
                                for(var a = t; a < s; ++a){
                                    var l = e1[a];
                                    r.push(l + 65536 >> 8 & 255, l + 256 & 255);
                                }
                                return s;
                            })(e1, t, r);
                            return r;
                        }, w.INDEX = function(e1) {
                            for(var t = 1, r = [
                                t
                            ], o = [], n = 0; n < e1.length; n += 1){
                                var s = w.OBJECT(e1[n]);
                                Array.prototype.push.apply(o, s), t += s.length, r.push(t);
                            }
                            if (0 === o.length) return [
                                0,
                                0
                            ];
                            for(var i = [], a = 1 + Math.floor(Math.log(t) / Math.log(2)) / 8 | 0, l = [
                                void 0,
                                w.BYTE,
                                w.USHORT,
                                w.UINT24,
                                w.ULONG
                            ][a], u = 0; u < r.length; u += 1){
                                var c = l(r[u]);
                                Array.prototype.push.apply(i, c);
                            }
                            return Array.prototype.concat(w.Card16(e1.length), w.OffSize(a), i, o);
                        }, l.INDEX = function(e1) {
                            return w.INDEX(e1).length;
                        }, w.DICT = function(e1) {
                            for(var t = [], r = Object.keys(e1), o = r.length, n = 0; n < o; n += 1){
                                var s = parseInt(r[n], 0), i = e1[s];
                                t = (t = t.concat(w.OPERAND(i.value, i.type))).concat(w.OPERATOR(s));
                            }
                            return t;
                        }, l.DICT = function(e1) {
                            return w.DICT(e1).length;
                        }, w.OPERATOR = function(e1) {
                            return e1 < 1200 ? [
                                e1
                            ] : [
                                12,
                                e1 - 1200
                            ];
                        }, w.OPERAND = function(e1, t) {
                            var r = [];
                            if (Array.isArray(t)) for(var o = 0; o < t.length; o += 1)L.argument(e1.length === t.length, "Not enough arguments given for type" + t), r = r.concat(w.OPERAND(e1[o], t[o]));
                            else if ("SID" === t) r = r.concat(w.NUMBER(e1));
                            else if ("offset" === t) r = r.concat(w.NUMBER32(e1));
                            else if ("number" === t) r = r.concat(w.NUMBER(e1));
                            else {
                                if ("real" !== t) throw new Error("Unknown operand type " + t);
                                r = r.concat(w.REAL(e1));
                            }
                            return r;
                        }, w.OP = w.BYTE, l.OP = l.BYTE;
                        var ue = "function" == typeof WeakMap && new WeakMap;
                        function n(e1, t, r) {
                            for(var o = 0; o < t.length; o += 1){
                                var n = t[o];
                                this[n.name] = n.value;
                            }
                            if (this.tableName = e1, this.fields = t, r) for(var s = Object.keys(r), i = 0; i < s.length; i += 1){
                                var a = s[i], l = r[a];
                                void 0 !== this[a] && (this[a] = l);
                            }
                        }
                        function ce(e1, t, r) {
                            void 0 === r && (r = t.length);
                            var o = new Array(t.length + 1);
                            o[0] = {
                                name: e1 + "Count",
                                type: "USHORT",
                                value: r
                            };
                            for(var n = 0; n < t.length; n++)o[n + 1] = {
                                name: e1 + n,
                                type: "USHORT",
                                value: t[n]
                            };
                            return o;
                        }
                        function de(e1, t, r) {
                            var o = t.length, n = new Array(o + 1);
                            n[0] = {
                                name: e1 + "Count",
                                type: "USHORT",
                                value: o
                            };
                            for(var s = 0; s < o; s++)n[s + 1] = {
                                name: e1 + s,
                                type: "TABLE",
                                value: r(t[s], s)
                            };
                            return n;
                        }
                        function he(e1, t, r) {
                            var o = t.length, n = [];
                            n[0] = {
                                name: e1 + "Count",
                                type: "USHORT",
                                value: o
                            };
                            for(var s = 0; s < o; s++)n = n.concat(r(t[s], s));
                            return n;
                        }
                        function fe(e1) {
                            1 === e1.format ? n.call(this, "coverageTable", [
                                {
                                    name: "coverageFormat",
                                    type: "USHORT",
                                    value: 1
                                }
                            ].concat(ce("glyph", e1.glyphs))) : L.assert(!1, "Can't create coverage table format 2 yet.");
                        }
                        function pe(e1) {
                            n.call(this, "scriptListTable", he("scriptRecord", e1, function(e1, t) {
                                var r = e1.script, o = r.defaultLangSys;
                                return L.assert(!!o, "Unable to write GSUB: script " + e1.tag + " has no default language system."), [
                                    {
                                        name: "scriptTag" + t,
                                        type: "TAG",
                                        value: e1.tag
                                    },
                                    {
                                        name: "script" + t,
                                        type: "TABLE",
                                        value: new n("scriptTable", [
                                            {
                                                name: "defaultLangSys",
                                                type: "TABLE",
                                                value: new n("defaultLangSys", [
                                                    {
                                                        name: "lookupOrder",
                                                        type: "USHORT",
                                                        value: 0
                                                    },
                                                    {
                                                        name: "reqFeatureIndex",
                                                        type: "USHORT",
                                                        value: o.reqFeatureIndex
                                                    }
                                                ].concat(ce("featureIndex", o.featureIndexes)))
                                            }
                                        ].concat(he("langSys", r.langSysRecords, function(e1, t) {
                                            var r = e1.langSys;
                                            return [
                                                {
                                                    name: "langSysTag" + t,
                                                    type: "TAG",
                                                    value: e1.tag
                                                },
                                                {
                                                    name: "langSys" + t,
                                                    type: "TABLE",
                                                    value: new n("langSys", [
                                                        {
                                                            name: "lookupOrder",
                                                            type: "USHORT",
                                                            value: 0
                                                        },
                                                        {
                                                            name: "reqFeatureIndex",
                                                            type: "USHORT",
                                                            value: r.reqFeatureIndex
                                                        }
                                                    ].concat(ce("featureIndex", r.featureIndexes)))
                                                }
                                            ];
                                        })))
                                    }
                                ];
                            }));
                        }
                        function me(e1) {
                            n.call(this, "featureListTable", he("featureRecord", e1, function(e1, t) {
                                var r = e1.feature;
                                return [
                                    {
                                        name: "featureTag" + t,
                                        type: "TAG",
                                        value: e1.tag
                                    },
                                    {
                                        name: "feature" + t,
                                        type: "TABLE",
                                        value: new n("featureTable", [
                                            {
                                                name: "featureParams",
                                                type: "USHORT",
                                                value: r.featureParams
                                            }
                                        ].concat(ce("lookupListIndex", r.lookupListIndexes)))
                                    }
                                ];
                            }));
                        }
                        function ye(e1, r) {
                            n.call(this, "lookupListTable", de("lookup", e1, function(e1) {
                                var t = r[e1.lookupType];
                                return L.assert(!!t, "Unable to write GSUB lookup type " + e1.lookupType + " tables."), new n("lookupTable", [
                                    {
                                        name: "lookupType",
                                        type: "USHORT",
                                        value: e1.lookupType
                                    },
                                    {
                                        name: "lookupFlag",
                                        type: "USHORT",
                                        value: e1.lookupFlag
                                    }
                                ].concat(de("subtable", e1.subtables, t)));
                            }));
                        }
                        w.CHARSTRING = function(e1) {
                            if (ue) {
                                var t = ue.get(e1);
                                if (void 0 !== t) return t;
                            }
                            for(var r = [], o = e1.length, n = 0; n < o; n += 1)var s = e1[n], r = r.concat(w[s.type](s.value));
                            return ue && ue.set(e1, r), r;
                        }, l.CHARSTRING = function(e1) {
                            return w.CHARSTRING(e1).length;
                        }, w.OBJECT = function(e1) {
                            var t = w[e1.type];
                            return L.argument(void 0 !== t, "No encoding function for type " + e1.type), t(e1.value);
                        }, l.OBJECT = function(e1) {
                            var t = l[e1.type];
                            return L.argument(void 0 !== t, "No sizeOf function for type " + e1.type), t(e1.value);
                        }, w.TABLE = function(e1) {
                            for(var t = [], r = e1.fields.length, o = [], n = [], s = 0; s < r; s += 1){
                                var i = e1.fields[s], a = w[i.type], l = (L.argument(void 0 !== a, "No encoding function for field type " + i.type + " (" + i.name + ")"), e1[i.name]), a = a(l = void 0 === l ? i.value : l);
                                "TABLE" === i.type ? (n.push(t.length), t = t.concat([
                                    0,
                                    0
                                ]), o.push(a)) : t = t.concat(a);
                            }
                            for(var u = 0; u < o.length; u += 1){
                                var c = n[u], d = t.length;
                                L.argument(d < 65536, "Table " + e1.tableName + " too big."), t[c] = d >> 8, t[c + 1] = 255 & d, t = t.concat(o[u]);
                            }
                            return t;
                        }, l.TABLE = function(e1) {
                            for(var t = 0, r = e1.fields.length, o = 0; o < r; o += 1){
                                var n = e1.fields[o], s = l[n.type], i = (L.argument(void 0 !== s, "No sizeOf function for field type " + n.type + " (" + n.name + ")"), e1[n.name]);
                                t += s(i = void 0 === i ? n.value : i), "TABLE" === n.type && (t += 2);
                            }
                            return t;
                        }, w.RECORD = w.TABLE, l.RECORD = l.TABLE, w.LITERAL = function(e1) {
                            return e1;
                        }, l.LITERAL = function(e1) {
                            return e1.length;
                        }, n.prototype.encode = function() {
                            return w.TABLE(this);
                        }, n.prototype.sizeOf = function() {
                            return l.TABLE(this);
                        };
                        var S = {
                            Table: n,
                            Record: n,
                            Coverage: (fe.prototype = Object.create(n.prototype)).constructor = fe,
                            ScriptList: (pe.prototype = Object.create(n.prototype)).constructor = pe,
                            FeatureList: (me.prototype = Object.create(n.prototype)).constructor = me,
                            LookupList: (ye.prototype = Object.create(n.prototype)).constructor = ye,
                            ushortList: ce,
                            tableList: de,
                            recordList: he
                        };
                        function ge(e1, t) {
                            return e1.getUint8(t);
                        }
                        function ve(e1, t) {
                            return e1.getUint16(t, !1);
                        }
                        function be(e1, t) {
                            return e1.getUint32(t, !1);
                        }
                        function je(e1, t) {
                            return e1.getInt16(t, !1) + e1.getUint16(t + 2, !1) / 65535;
                        }
                        var _e = {
                            byte: 1,
                            uShort: 2,
                            short: 2,
                            uLong: 4,
                            fixed: 4,
                            longDateTime: 8,
                            tag: 4
                        };
                        function u(e1, t) {
                            this.data = e1, this.offset = t, this.relativeOffset = 0;
                        }
                        u.prototype.parseByte = function() {
                            var e1 = this.data.getUint8(this.offset + this.relativeOffset);
                            return this.relativeOffset += 1, e1;
                        }, u.prototype.parseChar = function() {
                            var e1 = this.data.getInt8(this.offset + this.relativeOffset);
                            return this.relativeOffset += 1, e1;
                        }, u.prototype.parseCard8 = u.prototype.parseByte, u.prototype.parseCard16 = u.prototype.parseUShort = function() {
                            var e1 = this.data.getUint16(this.offset + this.relativeOffset);
                            return this.relativeOffset += 2, e1;
                        }, u.prototype.parseSID = u.prototype.parseUShort, u.prototype.parseOffset16 = u.prototype.parseUShort, u.prototype.parseShort = function() {
                            var e1 = this.data.getInt16(this.offset + this.relativeOffset);
                            return this.relativeOffset += 2, e1;
                        }, u.prototype.parseF2Dot14 = function() {
                            var e1 = this.data.getInt16(this.offset + this.relativeOffset) / 16384;
                            return this.relativeOffset += 2, e1;
                        }, u.prototype.parseOffset32 = u.prototype.parseULong = function() {
                            var e1 = be(this.data, this.offset + this.relativeOffset);
                            return this.relativeOffset += 4, e1;
                        }, u.prototype.parseFixed = function() {
                            var e1 = je(this.data, this.offset + this.relativeOffset);
                            return this.relativeOffset += 4, e1;
                        }, u.prototype.parseString = function(e1) {
                            var t = this.data, r = this.offset + this.relativeOffset, o = "";
                            this.relativeOffset += e1;
                            for(var n = 0; n < e1; n++)o += String.fromCharCode(t.getUint8(r + n));
                            return o;
                        }, u.prototype.parseTag = function() {
                            return this.parseString(4);
                        }, u.prototype.parseLongDateTime = function() {
                            var e1 = be(this.data, this.offset + this.relativeOffset + 4);
                            return e1 -= 2082844800, this.relativeOffset += 8, e1;
                        }, u.prototype.parseVersion = function(e1) {
                            var t = ve(this.data, this.offset + this.relativeOffset), r = ve(this.data, this.offset + this.relativeOffset + 2);
                            return this.relativeOffset += 4, t + r / (e1 = void 0 === e1 ? 4096 : e1) / 10;
                        }, u.prototype.skip = function(e1, t) {
                            this.relativeOffset += _e[e1] * (t = void 0 === t ? 1 : t);
                        }, u.prototype.parseULongList = function(e1) {
                            void 0 === e1 && (e1 = this.parseULong());
                            for(var t = new Array(e1), r = this.data, o = this.offset + this.relativeOffset, n = 0; n < e1; n++)t[n] = r.getUint32(o), o += 4;
                            return this.relativeOffset += 4 * e1, t;
                        }, u.prototype.parseOffset16List = u.prototype.parseUShortList = function(e1) {
                            void 0 === e1 && (e1 = this.parseUShort());
                            for(var t = new Array(e1), r = this.data, o = this.offset + this.relativeOffset, n = 0; n < e1; n++)t[n] = r.getUint16(o), o += 2;
                            return this.relativeOffset += 2 * e1, t;
                        }, u.prototype.parseShortList = function(e1) {
                            for(var t = new Array(e1), r = this.data, o = this.offset + this.relativeOffset, n = 0; n < e1; n++)t[n] = r.getInt16(o), o += 2;
                            return this.relativeOffset += 2 * e1, t;
                        }, u.prototype.parseByteList = function(e1) {
                            for(var t = new Array(e1), r = this.data, o = this.offset + this.relativeOffset, n = 0; n < e1; n++)t[n] = r.getUint8(o++);
                            return this.relativeOffset += e1, t;
                        }, u.prototype.parseList = function(e1, t) {
                            t || (t = e1, e1 = this.parseUShort());
                            for(var r = new Array(e1), o = 0; o < e1; o++)r[o] = t.call(this);
                            return r;
                        }, u.prototype.parseList32 = function(e1, t) {
                            t || (t = e1, e1 = this.parseULong());
                            for(var r = new Array(e1), o = 0; o < e1; o++)r[o] = t.call(this);
                            return r;
                        }, u.prototype.parseRecordList = function(e1, t) {
                            t || (t = e1, e1 = this.parseUShort());
                            for(var r = new Array(e1), o = Object.keys(t), n = 0; n < e1; n++){
                                for(var s = {}, i = 0; i < o.length; i++){
                                    var a = o[i], l = t[a];
                                    s[a] = l.call(this);
                                }
                                r[n] = s;
                            }
                            return r;
                        }, u.prototype.parseRecordList32 = function(e1, t) {
                            t || (t = e1, e1 = this.parseULong());
                            for(var r = new Array(e1), o = Object.keys(t), n = 0; n < e1; n++){
                                for(var s = {}, i = 0; i < o.length; i++){
                                    var a = o[i], l = t[a];
                                    s[a] = l.call(this);
                                }
                                r[n] = s;
                            }
                            return r;
                        }, u.prototype.parseStruct = function(e1) {
                            if ("function" == typeof e1) return e1.call(this);
                            for(var t = Object.keys(e1), r = {}, o = 0; o < t.length; o++){
                                var n = t[o], s = e1[n];
                                r[n] = s.call(this);
                            }
                            return r;
                        }, u.prototype.parseValueRecord = function(e1) {
                            var t;
                            if (0 !== (e1 = void 0 === e1 ? this.parseUShort() : e1)) return t = {}, 1 & e1 && (t.xPlacement = this.parseShort()), 2 & e1 && (t.yPlacement = this.parseShort()), 4 & e1 && (t.xAdvance = this.parseShort()), 8 & e1 && (t.yAdvance = this.parseShort()), 16 & e1 && (t.xPlaDevice = void 0, this.parseShort()), 32 & e1 && (t.yPlaDevice = void 0, this.parseShort()), 64 & e1 && (t.xAdvDevice = void 0, this.parseShort()), 128 & e1 && (t.yAdvDevice = void 0, this.parseShort()), t;
                        }, u.prototype.parseValueRecordList = function() {
                            for(var e1 = this.parseUShort(), t = this.parseUShort(), r = new Array(t), o = 0; o < t; o++)r[o] = this.parseValueRecord(e1);
                            return r;
                        }, u.prototype.parsePointer = function(e1) {
                            var t = this.parseOffset16();
                            if (0 < t) return new u(this.data, this.offset + t).parseStruct(e1);
                        }, u.prototype.parsePointer32 = function(e1) {
                            var t = this.parseOffset32();
                            if (0 < t) return new u(this.data, this.offset + t).parseStruct(e1);
                        }, u.prototype.parseListOfLists = function(e1) {
                            for(var t = this.parseOffset16List(), r = t.length, o = this.relativeOffset, n = new Array(r), s = 0; s < r; s++){
                                var i = t[s];
                                if (0 === i) n[s] = void 0;
                                else if (this.relativeOffset = i, e1) {
                                    for(var a = this.parseOffset16List(), l = new Array(a.length), u = 0; u < a.length; u++)this.relativeOffset = i + a[u], l[u] = e1.call(this);
                                    n[s] = l;
                                } else n[s] = this.parseUShortList();
                            }
                            return this.relativeOffset = o, n;
                        }, u.prototype.parseCoverage = function() {
                            var e1 = this.offset + this.relativeOffset, t = this.parseUShort(), r = this.parseUShort();
                            if (1 === t) return {
                                format: 1,
                                glyphs: this.parseUShortList(r)
                            };
                            if (2 !== t) throw new Error("0x" + e1.toString(16) + ": Coverage format must be 1 or 2.");
                            for(var o = new Array(r), n = 0; n < r; n++)o[n] = {
                                start: this.parseUShort(),
                                end: this.parseUShort(),
                                index: this.parseUShort()
                            };
                            return {
                                format: 2,
                                ranges: o
                            };
                        }, u.prototype.parseClassDef = function() {
                            var e1 = this.offset + this.relativeOffset, t = this.parseUShort();
                            if (1 === t) return {
                                format: 1,
                                startGlyph: this.parseUShort(),
                                classes: this.parseUShortList()
                            };
                            if (2 === t) return {
                                format: 2,
                                ranges: this.parseRecordList({
                                    start: u.uShort,
                                    end: u.uShort,
                                    classId: u.uShort
                                })
                            };
                            throw new Error("0x" + e1.toString(16) + ": ClassDef format must be 1 or 2.");
                        }, u.list = function(e1, t) {
                            return function() {
                                return this.parseList(e1, t);
                            };
                        }, u.list32 = function(e1, t) {
                            return function() {
                                return this.parseList32(e1, t);
                            };
                        }, u.recordList = function(e1, t) {
                            return function() {
                                return this.parseRecordList(e1, t);
                            };
                        }, u.recordList32 = function(e1, t) {
                            return function() {
                                return this.parseRecordList32(e1, t);
                            };
                        }, u.pointer = function(e1) {
                            return function() {
                                return this.parsePointer(e1);
                            };
                        }, u.pointer32 = function(e1) {
                            return function() {
                                return this.parsePointer32(e1);
                            };
                        }, u.tag = u.prototype.parseTag, u.byte = u.prototype.parseByte, u.uShort = u.offset16 = u.prototype.parseUShort, u.uShortList = u.prototype.parseUShortList, u.uLong = u.offset32 = u.prototype.parseULong, u.uLongList = u.prototype.parseULongList, u.struct = u.prototype.parseStruct, u.coverage = u.prototype.parseCoverage, u.classDef = u.prototype.parseClassDef;
                        var xe = {
                            reserved: u.uShort,
                            reqFeatureIndex: u.uShort,
                            featureIndexes: u.uShortList
                        }, R = (u.prototype.parseScriptList = function() {
                            return this.parsePointer(u.recordList({
                                tag: u.tag,
                                script: u.pointer({
                                    defaultLangSys: u.pointer(xe),
                                    langSysRecords: u.recordList({
                                        tag: u.tag,
                                        langSys: u.pointer(xe)
                                    })
                                })
                            })) || [];
                        }, u.prototype.parseFeatureList = function() {
                            return this.parsePointer(u.recordList({
                                tag: u.tag,
                                feature: u.pointer({
                                    featureParams: u.offset16,
                                    lookupListIndexes: u.uShortList
                                })
                            })) || [];
                        }, u.prototype.parseLookupList = function(o) {
                            return this.parsePointer(u.list(u.pointer(function() {
                                var e1 = this.parseUShort(), t = (L.argument(1 <= e1 && e1 <= 9, "GPOS/GSUB lookup type " + e1 + " unknown."), this.parseUShort()), r = 16 & t;
                                return {
                                    lookupType: e1,
                                    lookupFlag: t,
                                    subtables: this.parseList(u.pointer(o[e1])),
                                    markFilteringSet: r ? this.parseUShort() : void 0
                                };
                            }))) || [];
                        }, u.prototype.parseFeatureVariationsList = function() {
                            return this.parsePointer32(function() {
                                var e1 = this.parseUShort(), t = this.parseUShort();
                                return L.argument(1 === e1 && t < 1, "GPOS/GSUB feature variations table unknown."), this.parseRecordList32({
                                    conditionSetOffset: u.offset32,
                                    featureTableSubstitutionOffset: u.offset32
                                });
                            }) || [];
                        }, {
                            getByte: ge,
                            getCard8: ge,
                            getUShort: ve,
                            getCard16: ve,
                            getShort: function(e1, t) {
                                return e1.getInt16(t, !1);
                            },
                            getULong: be,
                            getFixed: je,
                            getTag: function(e1, t) {
                                for(var r = "", o = t; o < t + 4; o += 1)r += String.fromCharCode(e1.getInt8(o));
                                return r;
                            },
                            getOffset: function(e1, t, r) {
                                for(var o = 0, n = 0; n < r; n += 1)o = (o <<= 8) + e1.getUint8(t + n);
                                return o;
                            },
                            getBytes: function(e1, t, r) {
                                for(var o = [], n = t; n < r; n += 1)o.push(e1.getUint8(n));
                                return o;
                            },
                            bytesToString: function(e1) {
                                for(var t = "", r = 0; r < e1.length; r += 1)t += String.fromCharCode(e1[r]);
                                return t;
                            },
                            Parser: u
                        });
                        var we = {
                            parse: function(e1, t) {
                                for(var r = {}, o = (r.version = R.getUShort(e1, t), L.argument(0 === r.version, "cmap table version should be 0."), r.numTables = R.getUShort(e1, t + 2), -1), n = r.numTables - 1; 0 <= n; --n){
                                    var s = R.getUShort(e1, t + 4 + 8 * n), i = R.getUShort(e1, t + 4 + 8 * n + 2);
                                    if (3 === s && (0 === i || 1 === i || 10 === i) || 0 === s && (0 === i || 1 === i || 2 === i || 3 === i || 4 === i)) {
                                        o = R.getULong(e1, t + 4 + 8 * n + 4);
                                        break;
                                    }
                                }
                                if (-1 === o) throw new Error("No valid cmap sub-tables found.");
                                var a = new R.Parser(e1, t + o);
                                if (r.format = a.parseUShort(), 12 === r.format) {
                                    var l, u = r, c = a;
                                    c.parseUShort(), u.length = c.parseULong(), u.language = c.parseULong(), u.groupCount = l = c.parseULong(), u.glyphIndexMap = {};
                                    for(var d = 0; d < l; d += 1)for(var h = c.parseULong(), f = c.parseULong(), p = c.parseULong(), m = h; m <= f; m += 1)u.glyphIndexMap[m] = p, p++;
                                } else {
                                    if (4 !== r.format) throw new Error("Only format 4 and 12 cmap tables are supported (found format " + r.format + ").");
                                    var y = r, g = e1, v = t, b = o;
                                    y.length = a.parseUShort(), y.language = a.parseUShort(), y.segCount = j = a.parseUShort() >> 1, a.skip("uShort", 3), y.glyphIndexMap = {};
                                    for(var j, _ = new R.Parser(g, v + b + 14), x = new R.Parser(g, v + b + 16 + 2 * j), w = new R.Parser(g, v + b + 16 + 4 * j), S = new R.Parser(g, v + b + 16 + 6 * j), T = v + b + 16 + 8 * j, M = 0; M < j - 1; M += 1)for(var E = void 0, k = _.parseUShort(), C = x.parseUShort(), O = w.parseShort(), P = S.parseUShort(), A = C; A <= k; A += 1)0 !== P ? (T = (T = S.offset + S.relativeOffset - 2) + P + 2 * (A - C), 0 !== (E = R.getUShort(g, T)) && (E = E + O & 65535)) : E = A + O & 65535, y.glyphIndexMap[A] = E;
                                }
                                return r;
                            },
                            make: function(e1) {
                                for(var t = !0, r = e1.length - 1; 0 < r; --r)if (65535 < e1.get(r).unicode) {
                                    console.log("Adding CMAP format 12 (needed!)"), t = !1;
                                    break;
                                }
                                var o, n, s = [
                                    {
                                        name: "version",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "numTables",
                                        type: "USHORT",
                                        value: t ? 1 : 2
                                    },
                                    {
                                        name: "platformID",
                                        type: "USHORT",
                                        value: 3
                                    },
                                    {
                                        name: "encodingID",
                                        type: "USHORT",
                                        value: 1
                                    },
                                    {
                                        name: "offset",
                                        type: "ULONG",
                                        value: t ? 12 : 20
                                    }
                                ], i = (s = (s = t ? s : s.concat([
                                    {
                                        name: "cmap12PlatformID",
                                        type: "USHORT",
                                        value: 3
                                    },
                                    {
                                        name: "cmap12EncodingID",
                                        type: "USHORT",
                                        value: 10
                                    },
                                    {
                                        name: "cmap12Offset",
                                        type: "ULONG",
                                        value: 0
                                    }
                                ])).concat([
                                    {
                                        name: "format",
                                        type: "USHORT",
                                        value: 4
                                    },
                                    {
                                        name: "cmap4Length",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "language",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "segCountX2",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "searchRange",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "entrySelector",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "rangeShift",
                                        type: "USHORT",
                                        value: 0
                                    }
                                ]), new S.Table("cmap", s));
                                for(i.segments = [], r = 0; r < e1.length; r += 1){
                                    for(var a = e1.get(r), l = 0; l < a.unicodes.length; l += 1)o = a.unicodes[l], n = r, i.segments.push({
                                        end: o,
                                        start: o,
                                        delta: -(o - n),
                                        offset: 0,
                                        glyphIndex: n
                                    });
                                    i.segments = i.segments.sort(function(e1, t) {
                                        return e1.start - t.start;
                                    });
                                }
                                i.segments.push({
                                    end: 65535,
                                    start: 65535,
                                    delta: 1,
                                    offset: 0
                                });
                                var u = i.segments.length, c = 0, d = [], h = [], f = [], p = [], m = [], y = [];
                                for(r = 0; r < u; r += 1){
                                    var g = i.segments[r];
                                    g.end <= 65535 && g.start <= 65535 ? (d = d.concat({
                                        name: "end_" + r,
                                        type: "USHORT",
                                        value: g.end
                                    }), h = h.concat({
                                        name: "start_" + r,
                                        type: "USHORT",
                                        value: g.start
                                    }), f = f.concat({
                                        name: "idDelta_" + r,
                                        type: "SHORT",
                                        value: g.delta
                                    }), p = p.concat({
                                        name: "idRangeOffset_" + r,
                                        type: "USHORT",
                                        value: g.offset
                                    }), void 0 !== g.glyphId && (m = m.concat({
                                        name: "glyph_" + r,
                                        type: "USHORT",
                                        value: g.glyphId
                                    }))) : c += 1, t || void 0 === g.glyphIndex || (y = (y = (y = y.concat({
                                        name: "cmap12Start_" + r,
                                        type: "ULONG",
                                        value: g.start
                                    })).concat({
                                        name: "cmap12End_" + r,
                                        type: "ULONG",
                                        value: g.end
                                    })).concat({
                                        name: "cmap12Glyph_" + r,
                                        type: "ULONG",
                                        value: g.glyphIndex
                                    }));
                                }
                                return i.segCountX2 = 2 * (u - c), i.searchRange = 2 * Math.pow(2, Math.floor(Math.log(u - c) / Math.log(2))), i.entrySelector = Math.log(i.searchRange / 2) / Math.log(2), i.rangeShift = i.segCountX2 - i.searchRange, i.fields = i.fields.concat(d), i.fields.push({
                                    name: "reservedPad",
                                    type: "USHORT",
                                    value: 0
                                }), i.fields = i.fields.concat(h), i.fields = i.fields.concat(f), i.fields = i.fields.concat(p), i.fields = i.fields.concat(m), i.cmap4Length = 14 + 2 * d.length + 2 + 2 * h.length + 2 * f.length + 2 * p.length + 2 * m.length, t || (s = 16 + 4 * y.length, i.cmap12Offset = 20 + i.cmap4Length, i.fields = i.fields.concat([
                                    {
                                        name: "cmap12Format",
                                        type: "USHORT",
                                        value: 12
                                    },
                                    {
                                        name: "cmap12Reserved",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "cmap12Length",
                                        type: "ULONG",
                                        value: s
                                    },
                                    {
                                        name: "cmap12Language",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "cmap12nGroups",
                                        type: "ULONG",
                                        value: y.length / 3
                                    }
                                ]), i.fields = i.fields.concat(y)), i;
                            }
                        }, Se = [
                            ".notdef",
                            "space",
                            "exclam",
                            "quotedbl",
                            "numbersign",
                            "dollar",
                            "percent",
                            "ampersand",
                            "quoteright",
                            "parenleft",
                            "parenright",
                            "asterisk",
                            "plus",
                            "comma",
                            "hyphen",
                            "period",
                            "slash",
                            "zero",
                            "one",
                            "two",
                            "three",
                            "four",
                            "five",
                            "six",
                            "seven",
                            "eight",
                            "nine",
                            "colon",
                            "semicolon",
                            "less",
                            "equal",
                            "greater",
                            "question",
                            "at",
                            "A",
                            "B",
                            "C",
                            "D",
                            "E",
                            "F",
                            "G",
                            "H",
                            "I",
                            "J",
                            "K",
                            "L",
                            "M",
                            "N",
                            "O",
                            "P",
                            "Q",
                            "R",
                            "S",
                            "T",
                            "U",
                            "V",
                            "W",
                            "X",
                            "Y",
                            "Z",
                            "bracketleft",
                            "backslash",
                            "bracketright",
                            "asciicircum",
                            "underscore",
                            "quoteleft",
                            "a",
                            "b",
                            "c",
                            "d",
                            "e",
                            "f",
                            "g",
                            "h",
                            "i",
                            "j",
                            "k",
                            "l",
                            "m",
                            "n",
                            "o",
                            "p",
                            "q",
                            "r",
                            "s",
                            "t",
                            "u",
                            "v",
                            "w",
                            "x",
                            "y",
                            "z",
                            "braceleft",
                            "bar",
                            "braceright",
                            "asciitilde",
                            "exclamdown",
                            "cent",
                            "sterling",
                            "fraction",
                            "yen",
                            "florin",
                            "section",
                            "currency",
                            "quotesingle",
                            "quotedblleft",
                            "guillemotleft",
                            "guilsinglleft",
                            "guilsinglright",
                            "fi",
                            "fl",
                            "endash",
                            "dagger",
                            "daggerdbl",
                            "periodcentered",
                            "paragraph",
                            "bullet",
                            "quotesinglbase",
                            "quotedblbase",
                            "quotedblright",
                            "guillemotright",
                            "ellipsis",
                            "perthousand",
                            "questiondown",
                            "grave",
                            "acute",
                            "circumflex",
                            "tilde",
                            "macron",
                            "breve",
                            "dotaccent",
                            "dieresis",
                            "ring",
                            "cedilla",
                            "hungarumlaut",
                            "ogonek",
                            "caron",
                            "emdash",
                            "AE",
                            "ordfeminine",
                            "Lslash",
                            "Oslash",
                            "OE",
                            "ordmasculine",
                            "ae",
                            "dotlessi",
                            "lslash",
                            "oslash",
                            "oe",
                            "germandbls",
                            "onesuperior",
                            "logicalnot",
                            "mu",
                            "trademark",
                            "Eth",
                            "onehalf",
                            "plusminus",
                            "Thorn",
                            "onequarter",
                            "divide",
                            "brokenbar",
                            "degree",
                            "thorn",
                            "threequarters",
                            "twosuperior",
                            "registered",
                            "minus",
                            "eth",
                            "multiply",
                            "threesuperior",
                            "copyright",
                            "Aacute",
                            "Acircumflex",
                            "Adieresis",
                            "Agrave",
                            "Aring",
                            "Atilde",
                            "Ccedilla",
                            "Eacute",
                            "Ecircumflex",
                            "Edieresis",
                            "Egrave",
                            "Iacute",
                            "Icircumflex",
                            "Idieresis",
                            "Igrave",
                            "Ntilde",
                            "Oacute",
                            "Ocircumflex",
                            "Odieresis",
                            "Ograve",
                            "Otilde",
                            "Scaron",
                            "Uacute",
                            "Ucircumflex",
                            "Udieresis",
                            "Ugrave",
                            "Yacute",
                            "Ydieresis",
                            "Zcaron",
                            "aacute",
                            "acircumflex",
                            "adieresis",
                            "agrave",
                            "aring",
                            "atilde",
                            "ccedilla",
                            "eacute",
                            "ecircumflex",
                            "edieresis",
                            "egrave",
                            "iacute",
                            "icircumflex",
                            "idieresis",
                            "igrave",
                            "ntilde",
                            "oacute",
                            "ocircumflex",
                            "odieresis",
                            "ograve",
                            "otilde",
                            "scaron",
                            "uacute",
                            "ucircumflex",
                            "udieresis",
                            "ugrave",
                            "yacute",
                            "ydieresis",
                            "zcaron",
                            "exclamsmall",
                            "Hungarumlautsmall",
                            "dollaroldstyle",
                            "dollarsuperior",
                            "ampersandsmall",
                            "Acutesmall",
                            "parenleftsuperior",
                            "parenrightsuperior",
                            "266 ff",
                            "onedotenleader",
                            "zerooldstyle",
                            "oneoldstyle",
                            "twooldstyle",
                            "threeoldstyle",
                            "fouroldstyle",
                            "fiveoldstyle",
                            "sixoldstyle",
                            "sevenoldstyle",
                            "eightoldstyle",
                            "nineoldstyle",
                            "commasuperior",
                            "threequartersemdash",
                            "periodsuperior",
                            "questionsmall",
                            "asuperior",
                            "bsuperior",
                            "centsuperior",
                            "dsuperior",
                            "esuperior",
                            "isuperior",
                            "lsuperior",
                            "msuperior",
                            "nsuperior",
                            "osuperior",
                            "rsuperior",
                            "ssuperior",
                            "tsuperior",
                            "ff",
                            "ffi",
                            "ffl",
                            "parenleftinferior",
                            "parenrightinferior",
                            "Circumflexsmall",
                            "hyphensuperior",
                            "Gravesmall",
                            "Asmall",
                            "Bsmall",
                            "Csmall",
                            "Dsmall",
                            "Esmall",
                            "Fsmall",
                            "Gsmall",
                            "Hsmall",
                            "Ismall",
                            "Jsmall",
                            "Ksmall",
                            "Lsmall",
                            "Msmall",
                            "Nsmall",
                            "Osmall",
                            "Psmall",
                            "Qsmall",
                            "Rsmall",
                            "Ssmall",
                            "Tsmall",
                            "Usmall",
                            "Vsmall",
                            "Wsmall",
                            "Xsmall",
                            "Ysmall",
                            "Zsmall",
                            "colonmonetary",
                            "onefitted",
                            "rupiah",
                            "Tildesmall",
                            "exclamdownsmall",
                            "centoldstyle",
                            "Lslashsmall",
                            "Scaronsmall",
                            "Zcaronsmall",
                            "Dieresissmall",
                            "Brevesmall",
                            "Caronsmall",
                            "Dotaccentsmall",
                            "Macronsmall",
                            "figuredash",
                            "hypheninferior",
                            "Ogoneksmall",
                            "Ringsmall",
                            "Cedillasmall",
                            "questiondownsmall",
                            "oneeighth",
                            "threeeighths",
                            "fiveeighths",
                            "seveneighths",
                            "onethird",
                            "twothirds",
                            "zerosuperior",
                            "foursuperior",
                            "fivesuperior",
                            "sixsuperior",
                            "sevensuperior",
                            "eightsuperior",
                            "ninesuperior",
                            "zeroinferior",
                            "oneinferior",
                            "twoinferior",
                            "threeinferior",
                            "fourinferior",
                            "fiveinferior",
                            "sixinferior",
                            "seveninferior",
                            "eightinferior",
                            "nineinferior",
                            "centinferior",
                            "dollarinferior",
                            "periodinferior",
                            "commainferior",
                            "Agravesmall",
                            "Aacutesmall",
                            "Acircumflexsmall",
                            "Atildesmall",
                            "Adieresissmall",
                            "Aringsmall",
                            "AEsmall",
                            "Ccedillasmall",
                            "Egravesmall",
                            "Eacutesmall",
                            "Ecircumflexsmall",
                            "Edieresissmall",
                            "Igravesmall",
                            "Iacutesmall",
                            "Icircumflexsmall",
                            "Idieresissmall",
                            "Ethsmall",
                            "Ntildesmall",
                            "Ogravesmall",
                            "Oacutesmall",
                            "Ocircumflexsmall",
                            "Otildesmall",
                            "Odieresissmall",
                            "OEsmall",
                            "Oslashsmall",
                            "Ugravesmall",
                            "Uacutesmall",
                            "Ucircumflexsmall",
                            "Udieresissmall",
                            "Yacutesmall",
                            "Thornsmall",
                            "Ydieresissmall",
                            "001.000",
                            "001.001",
                            "001.002",
                            "001.003",
                            "Black",
                            "Bold",
                            "Book",
                            "Light",
                            "Medium",
                            "Regular",
                            "Roman",
                            "Semibold"
                        ], Te = [
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "space",
                            "exclam",
                            "quotedbl",
                            "numbersign",
                            "dollar",
                            "percent",
                            "ampersand",
                            "quoteright",
                            "parenleft",
                            "parenright",
                            "asterisk",
                            "plus",
                            "comma",
                            "hyphen",
                            "period",
                            "slash",
                            "zero",
                            "one",
                            "two",
                            "three",
                            "four",
                            "five",
                            "six",
                            "seven",
                            "eight",
                            "nine",
                            "colon",
                            "semicolon",
                            "less",
                            "equal",
                            "greater",
                            "question",
                            "at",
                            "A",
                            "B",
                            "C",
                            "D",
                            "E",
                            "F",
                            "G",
                            "H",
                            "I",
                            "J",
                            "K",
                            "L",
                            "M",
                            "N",
                            "O",
                            "P",
                            "Q",
                            "R",
                            "S",
                            "T",
                            "U",
                            "V",
                            "W",
                            "X",
                            "Y",
                            "Z",
                            "bracketleft",
                            "backslash",
                            "bracketright",
                            "asciicircum",
                            "underscore",
                            "quoteleft",
                            "a",
                            "b",
                            "c",
                            "d",
                            "e",
                            "f",
                            "g",
                            "h",
                            "i",
                            "j",
                            "k",
                            "l",
                            "m",
                            "n",
                            "o",
                            "p",
                            "q",
                            "r",
                            "s",
                            "t",
                            "u",
                            "v",
                            "w",
                            "x",
                            "y",
                            "z",
                            "braceleft",
                            "bar",
                            "braceright",
                            "asciitilde",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "exclamdown",
                            "cent",
                            "sterling",
                            "fraction",
                            "yen",
                            "florin",
                            "section",
                            "currency",
                            "quotesingle",
                            "quotedblleft",
                            "guillemotleft",
                            "guilsinglleft",
                            "guilsinglright",
                            "fi",
                            "fl",
                            "",
                            "endash",
                            "dagger",
                            "daggerdbl",
                            "periodcentered",
                            "",
                            "paragraph",
                            "bullet",
                            "quotesinglbase",
                            "quotedblbase",
                            "quotedblright",
                            "guillemotright",
                            "ellipsis",
                            "perthousand",
                            "",
                            "questiondown",
                            "",
                            "grave",
                            "acute",
                            "circumflex",
                            "tilde",
                            "macron",
                            "breve",
                            "dotaccent",
                            "dieresis",
                            "",
                            "ring",
                            "cedilla",
                            "",
                            "hungarumlaut",
                            "ogonek",
                            "caron",
                            "emdash",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "AE",
                            "",
                            "ordfeminine",
                            "",
                            "",
                            "",
                            "",
                            "Lslash",
                            "Oslash",
                            "OE",
                            "ordmasculine",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "ae",
                            "",
                            "",
                            "",
                            "dotlessi",
                            "",
                            "",
                            "lslash",
                            "oslash",
                            "oe",
                            "germandbls"
                        ], Me = [
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "space",
                            "exclamsmall",
                            "Hungarumlautsmall",
                            "",
                            "dollaroldstyle",
                            "dollarsuperior",
                            "ampersandsmall",
                            "Acutesmall",
                            "parenleftsuperior",
                            "parenrightsuperior",
                            "twodotenleader",
                            "onedotenleader",
                            "comma",
                            "hyphen",
                            "period",
                            "fraction",
                            "zerooldstyle",
                            "oneoldstyle",
                            "twooldstyle",
                            "threeoldstyle",
                            "fouroldstyle",
                            "fiveoldstyle",
                            "sixoldstyle",
                            "sevenoldstyle",
                            "eightoldstyle",
                            "nineoldstyle",
                            "colon",
                            "semicolon",
                            "commasuperior",
                            "threequartersemdash",
                            "periodsuperior",
                            "questionsmall",
                            "",
                            "asuperior",
                            "bsuperior",
                            "centsuperior",
                            "dsuperior",
                            "esuperior",
                            "",
                            "",
                            "isuperior",
                            "",
                            "",
                            "lsuperior",
                            "msuperior",
                            "nsuperior",
                            "osuperior",
                            "",
                            "",
                            "rsuperior",
                            "ssuperior",
                            "tsuperior",
                            "",
                            "ff",
                            "fi",
                            "fl",
                            "ffi",
                            "ffl",
                            "parenleftinferior",
                            "",
                            "parenrightinferior",
                            "Circumflexsmall",
                            "hyphensuperior",
                            "Gravesmall",
                            "Asmall",
                            "Bsmall",
                            "Csmall",
                            "Dsmall",
                            "Esmall",
                            "Fsmall",
                            "Gsmall",
                            "Hsmall",
                            "Ismall",
                            "Jsmall",
                            "Ksmall",
                            "Lsmall",
                            "Msmall",
                            "Nsmall",
                            "Osmall",
                            "Psmall",
                            "Qsmall",
                            "Rsmall",
                            "Ssmall",
                            "Tsmall",
                            "Usmall",
                            "Vsmall",
                            "Wsmall",
                            "Xsmall",
                            "Ysmall",
                            "Zsmall",
                            "colonmonetary",
                            "onefitted",
                            "rupiah",
                            "Tildesmall",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "exclamdownsmall",
                            "centoldstyle",
                            "Lslashsmall",
                            "",
                            "",
                            "Scaronsmall",
                            "Zcaronsmall",
                            "Dieresissmall",
                            "Brevesmall",
                            "Caronsmall",
                            "",
                            "Dotaccentsmall",
                            "",
                            "",
                            "Macronsmall",
                            "",
                            "",
                            "figuredash",
                            "hypheninferior",
                            "",
                            "",
                            "Ogoneksmall",
                            "Ringsmall",
                            "Cedillasmall",
                            "",
                            "",
                            "",
                            "onequarter",
                            "onehalf",
                            "threequarters",
                            "questiondownsmall",
                            "oneeighth",
                            "threeeighths",
                            "fiveeighths",
                            "seveneighths",
                            "onethird",
                            "twothirds",
                            "",
                            "",
                            "zerosuperior",
                            "onesuperior",
                            "twosuperior",
                            "threesuperior",
                            "foursuperior",
                            "fivesuperior",
                            "sixsuperior",
                            "sevensuperior",
                            "eightsuperior",
                            "ninesuperior",
                            "zeroinferior",
                            "oneinferior",
                            "twoinferior",
                            "threeinferior",
                            "fourinferior",
                            "fiveinferior",
                            "sixinferior",
                            "seveninferior",
                            "eightinferior",
                            "nineinferior",
                            "centinferior",
                            "dollarinferior",
                            "periodinferior",
                            "commainferior",
                            "Agravesmall",
                            "Aacutesmall",
                            "Acircumflexsmall",
                            "Atildesmall",
                            "Adieresissmall",
                            "Aringsmall",
                            "AEsmall",
                            "Ccedillasmall",
                            "Egravesmall",
                            "Eacutesmall",
                            "Ecircumflexsmall",
                            "Edieresissmall",
                            "Igravesmall",
                            "Iacutesmall",
                            "Icircumflexsmall",
                            "Idieresissmall",
                            "Ethsmall",
                            "Ntildesmall",
                            "Ogravesmall",
                            "Oacutesmall",
                            "Ocircumflexsmall",
                            "Otildesmall",
                            "Odieresissmall",
                            "OEsmall",
                            "Oslashsmall",
                            "Ugravesmall",
                            "Uacutesmall",
                            "Ucircumflexsmall",
                            "Udieresissmall",
                            "Yacutesmall",
                            "Thornsmall",
                            "Ydieresissmall"
                        ], c = [
                            ".notdef",
                            ".null",
                            "nonmarkingreturn",
                            "space",
                            "exclam",
                            "quotedbl",
                            "numbersign",
                            "dollar",
                            "percent",
                            "ampersand",
                            "quotesingle",
                            "parenleft",
                            "parenright",
                            "asterisk",
                            "plus",
                            "comma",
                            "hyphen",
                            "period",
                            "slash",
                            "zero",
                            "one",
                            "two",
                            "three",
                            "four",
                            "five",
                            "six",
                            "seven",
                            "eight",
                            "nine",
                            "colon",
                            "semicolon",
                            "less",
                            "equal",
                            "greater",
                            "question",
                            "at",
                            "A",
                            "B",
                            "C",
                            "D",
                            "E",
                            "F",
                            "G",
                            "H",
                            "I",
                            "J",
                            "K",
                            "L",
                            "M",
                            "N",
                            "O",
                            "P",
                            "Q",
                            "R",
                            "S",
                            "T",
                            "U",
                            "V",
                            "W",
                            "X",
                            "Y",
                            "Z",
                            "bracketleft",
                            "backslash",
                            "bracketright",
                            "asciicircum",
                            "underscore",
                            "grave",
                            "a",
                            "b",
                            "c",
                            "d",
                            "e",
                            "f",
                            "g",
                            "h",
                            "i",
                            "j",
                            "k",
                            "l",
                            "m",
                            "n",
                            "o",
                            "p",
                            "q",
                            "r",
                            "s",
                            "t",
                            "u",
                            "v",
                            "w",
                            "x",
                            "y",
                            "z",
                            "braceleft",
                            "bar",
                            "braceright",
                            "asciitilde",
                            "Adieresis",
                            "Aring",
                            "Ccedilla",
                            "Eacute",
                            "Ntilde",
                            "Odieresis",
                            "Udieresis",
                            "aacute",
                            "agrave",
                            "acircumflex",
                            "adieresis",
                            "atilde",
                            "aring",
                            "ccedilla",
                            "eacute",
                            "egrave",
                            "ecircumflex",
                            "edieresis",
                            "iacute",
                            "igrave",
                            "icircumflex",
                            "idieresis",
                            "ntilde",
                            "oacute",
                            "ograve",
                            "ocircumflex",
                            "odieresis",
                            "otilde",
                            "uacute",
                            "ugrave",
                            "ucircumflex",
                            "udieresis",
                            "dagger",
                            "degree",
                            "cent",
                            "sterling",
                            "section",
                            "bullet",
                            "paragraph",
                            "germandbls",
                            "registered",
                            "copyright",
                            "trademark",
                            "acute",
                            "dieresis",
                            "notequal",
                            "AE",
                            "Oslash",
                            "infinity",
                            "plusminus",
                            "lessequal",
                            "greaterequal",
                            "yen",
                            "mu",
                            "partialdiff",
                            "summation",
                            "product",
                            "pi",
                            "integral",
                            "ordfeminine",
                            "ordmasculine",
                            "Omega",
                            "ae",
                            "oslash",
                            "questiondown",
                            "exclamdown",
                            "logicalnot",
                            "radical",
                            "florin",
                            "approxequal",
                            "Delta",
                            "guillemotleft",
                            "guillemotright",
                            "ellipsis",
                            "nonbreakingspace",
                            "Agrave",
                            "Atilde",
                            "Otilde",
                            "OE",
                            "oe",
                            "endash",
                            "emdash",
                            "quotedblleft",
                            "quotedblright",
                            "quoteleft",
                            "quoteright",
                            "divide",
                            "lozenge",
                            "ydieresis",
                            "Ydieresis",
                            "fraction",
                            "currency",
                            "guilsinglleft",
                            "guilsinglright",
                            "fi",
                            "fl",
                            "daggerdbl",
                            "periodcentered",
                            "quotesinglbase",
                            "quotedblbase",
                            "perthousand",
                            "Acircumflex",
                            "Ecircumflex",
                            "Aacute",
                            "Edieresis",
                            "Egrave",
                            "Iacute",
                            "Icircumflex",
                            "Idieresis",
                            "Igrave",
                            "Oacute",
                            "Ocircumflex",
                            "apple",
                            "Ograve",
                            "Uacute",
                            "Ucircumflex",
                            "Ugrave",
                            "dotlessi",
                            "circumflex",
                            "tilde",
                            "macron",
                            "breve",
                            "dotaccent",
                            "ring",
                            "cedilla",
                            "hungarumlaut",
                            "ogonek",
                            "caron",
                            "Lslash",
                            "lslash",
                            "Scaron",
                            "scaron",
                            "Zcaron",
                            "zcaron",
                            "brokenbar",
                            "Eth",
                            "eth",
                            "Yacute",
                            "yacute",
                            "Thorn",
                            "thorn",
                            "minus",
                            "multiply",
                            "onesuperior",
                            "twosuperior",
                            "threesuperior",
                            "onehalf",
                            "onequarter",
                            "threequarters",
                            "franc",
                            "Gbreve",
                            "gbreve",
                            "Idotaccent",
                            "Scedilla",
                            "scedilla",
                            "Cacute",
                            "cacute",
                            "Ccaron",
                            "ccaron",
                            "dcroat"
                        ];
                        function Ee(e1) {
                            this.font = e1;
                        }
                        function ke(e1) {
                            this.cmap = e1;
                        }
                        function Ce(e1, t) {
                            this.encoding = e1, this.charset = t;
                        }
                        function Oe(e1) {
                            switch(e1.version){
                                case 1:
                                    this.names = c.slice();
                                    break;
                                case 2:
                                    this.names = new Array(e1.numberOfGlyphs);
                                    for(var t = 0; t < e1.numberOfGlyphs; t++)e1.glyphNameIndex[t] < c.length ? this.names[t] = c[e1.glyphNameIndex[t]] : this.names[t] = e1.names[e1.glyphNameIndex[t] - c.length];
                                    break;
                                case 2.5:
                                    this.names = new Array(e1.numberOfGlyphs);
                                    for(var r = 0; r < e1.numberOfGlyphs; r++)this.names[r] = c[r + e1.glyphNameIndex[r]];
                                    break;
                                default:
                                    this.names = [];
                            }
                        }
                        Ee.prototype.charToGlyphIndex = function(e1) {
                            var t = e1.codePointAt(0), r = this.font.glyphs;
                            if (r) {
                                for(var o = 0; o < r.length; o += 1)for(var n = r.get(o), s = 0; s < n.unicodes.length; s += 1)if (n.unicodes[s] === t) return o;
                            }
                            return null;
                        }, ke.prototype.charToGlyphIndex = function(e1) {
                            return this.cmap.glyphIndexMap[e1.codePointAt(0)] || 0;
                        }, Ce.prototype.charToGlyphIndex = function(e1) {
                            e1 = e1.codePointAt(0), e1 = this.encoding[e1];
                            return this.charset.indexOf(e1);
                        }, Oe.prototype.nameToGlyphIndex = function(e1) {
                            return this.names.indexOf(e1);
                        }, Oe.prototype.glyphIndexToName = function(e1) {
                            return this.names[e1];
                        };
                        var d = {
                            line: function(e1, t, r, o, n) {
                                e1.beginPath(), e1.moveTo(t, r), e1.lineTo(o, n), e1.stroke();
                            }
                        };
                        function f(e1) {
                            this.bindConstructorValues(e1);
                        }
                        function Pe(t, e1, r) {
                            Object.defineProperty(t, e1, {
                                get: function() {
                                    return t.path, t[r];
                                },
                                set: function(e1) {
                                    t[r] = e1;
                                },
                                enumerable: !0,
                                configurable: !0
                            });
                        }
                        function Ae(e1, t) {
                            if (this.font = e1, this.glyphs = {}, Array.isArray(t)) for(var r = 0; r < t.length; r++)this.glyphs[r] = t[r];
                            this.length = t && t.length || 0;
                        }
                        f.prototype.bindConstructorValues = function(e1) {
                            var t;
                            this.index = e1.index || 0, this.name = e1.name || null, this.unicode = e1.unicode || void 0, this.unicodes = e1.unicodes || void 0 !== e1.unicode ? [
                                e1.unicode
                            ] : [], e1.xMin && (this.xMin = e1.xMin), e1.yMin && (this.yMin = e1.yMin), e1.xMax && (this.xMax = e1.xMax), e1.yMax && (this.yMax = e1.yMax), e1.advanceWidth && (this.advanceWidth = e1.advanceWidth), Object.defineProperty(this, "path", (e1 = e1.path, t = e1 || new h, {
                                configurable: !0,
                                get: function() {
                                    return t = "function" == typeof t ? t() : t;
                                },
                                set: function(e1) {
                                    t = e1;
                                }
                            }));
                        }, f.prototype.addUnicode = function(e1) {
                            0 === this.unicodes.length && (this.unicode = e1), this.unicodes.push(e1);
                        }, f.prototype.getBoundingBox = function() {
                            return this.path.getBoundingBox();
                        }, f.prototype.getPath = function(e1, t, r, o, n) {
                            e1 = void 0 !== e1 ? e1 : 0, t = void 0 !== t ? t : 0, r = void 0 !== r ? r : 72;
                            for(var s, i, a = (o = o || {}).xScale, l = o.yScale, u = ((s = o.hinting && n && n.hinting ? this.path && n.hinting.exec(this, r) : s) ? (i = n.hinting.getCommands(s), e1 = Math.round(e1), t = Math.round(t), a = l = 1) : (i = this.path.commands, o = 1 / this.path.unitsPerEm * r, void 0 === a && (a = o), void 0 === l && (l = o)), new h), c = 0; c < i.length; c += 1){
                                var d = i[c];
                                "M" === d.type ? u.moveTo(e1 + d.x * a, t + -d.y * l) : "L" === d.type ? u.lineTo(e1 + d.x * a, t + -d.y * l) : "Q" === d.type ? u.quadraticCurveTo(e1 + d.x1 * a, t + -d.y1 * l, e1 + d.x * a, t + -d.y * l) : "C" === d.type ? u.curveTo(e1 + d.x1 * a, t + -d.y1 * l, e1 + d.x2 * a, t + -d.y2 * l, e1 + d.x * a, t + -d.y * l) : "Z" === d.type && u.closePath();
                            }
                            return u;
                        }, f.prototype.getContours = function() {
                            if (void 0 === this.points) return [];
                            for(var e1 = [], t = [], r = 0; r < this.points.length; r += 1){
                                var o = this.points[r];
                                t.push(o), o.lastPointOfContour && (e1.push(t), t = []);
                            }
                            return L.argument(0 === t.length, "There are still points left in the current contour."), e1;
                        }, f.prototype.getMetrics = function() {
                            for(var e1 = this.path.commands, t = [], r = [], o = 0; o < e1.length; o += 1){
                                var n = e1[o];
                                "Z" !== n.type && (t.push(n.x), r.push(n.y)), "Q" !== n.type && "C" !== n.type || (t.push(n.x1), r.push(n.y1)), "C" === n.type && (t.push(n.x2), r.push(n.y2));
                            }
                            var s = {
                                xMin: Math.min.apply(null, t),
                                yMin: Math.min.apply(null, r),
                                xMax: Math.max.apply(null, t),
                                yMax: Math.max.apply(null, r),
                                leftSideBearing: this.leftSideBearing
                            };
                            return isFinite(s.xMin) || (s.xMin = 0), isFinite(s.xMax) || (s.xMax = this.advanceWidth), isFinite(s.yMin) || (s.yMin = 0), isFinite(s.yMax) || (s.yMax = 0), s.rightSideBearing = this.advanceWidth - s.leftSideBearing - (s.xMax - s.xMin), s;
                        }, f.prototype.draw = function(e1, t, r, o, n) {
                            this.getPath(t, r, o, n).draw(e1);
                        }, f.prototype.drawPoints = function(i, e1, t, r) {
                            function o(e1, t, r, o) {
                                var n = 2 * Math.PI;
                                i.beginPath();
                                for(var s = 0; s < e1.length; s += 1)i.moveTo(t + e1[s].x * o, r + e1[s].y * o), i.arc(t + e1[s].x * o, r + e1[s].y * o, 2, 0, n, !1);
                                i.closePath(), i.fill();
                            }
                            e1 = void 0 !== e1 ? e1 : 0, t = void 0 !== t ? t : 0;
                            for(var r = 1 / this.path.unitsPerEm * (r = void 0 !== r ? r : 24), n = [], s = [], a = this.path, l = 0; l < a.commands.length; l += 1){
                                var u = a.commands[l];
                                void 0 !== u.x && n.push({
                                    x: u.x,
                                    y: -u.y
                                }), void 0 !== u.x1 && s.push({
                                    x: u.x1,
                                    y: -u.y1
                                }), void 0 !== u.x2 && s.push({
                                    x: u.x2,
                                    y: -u.y2
                                });
                            }
                            i.fillStyle = "blue", o(n, e1, t, r), i.fillStyle = "red", o(s, e1, t, r);
                        }, f.prototype.drawMetrics = function(e1, t, r, o) {
                            t = void 0 !== t ? t : 0, r = void 0 !== r ? r : 0, o = 1 / this.path.unitsPerEm * (o = void 0 !== o ? o : 24), e1.lineWidth = 1, e1.strokeStyle = "black", d.line(e1, t, -10000, t, 1e4), d.line(e1, -10000, r, 1e4, r);
                            var n = this.xMin || 0, s = this.yMin || 0, i = this.xMax || 0, a = this.yMax || 0, l = this.advanceWidth || 0;
                            e1.strokeStyle = "blue", d.line(e1, t + n * o, -10000, t + n * o, 1e4), d.line(e1, t + i * o, -10000, t + i * o, 1e4), d.line(e1, -10000, r + -s * o, 1e4, r + -s * o), d.line(e1, -10000, r + -a * o, 1e4, r + -a * o), e1.strokeStyle = "green", d.line(e1, t + l * o, -10000, t + l * o, 1e4);
                        }, Ae.prototype.get = function(e1) {
                            return "function" == typeof this.glyphs[e1] && (this.glyphs[e1] = this.glyphs[e1]()), this.glyphs[e1];
                        }, Ae.prototype.push = function(e1, t) {
                            this.glyphs[e1] = t, this.length++;
                        };
                        var p = {
                            GlyphSet: Ae,
                            glyphLoader: function(e1, t) {
                                return new f({
                                    index: t,
                                    font: e1
                                });
                            },
                            ttfGlyphLoader: function(r, e1, o, n, s, i) {
                                return function() {
                                    var t = new f({
                                        index: e1,
                                        font: r
                                    });
                                    return t.path = function() {
                                        o(t, n, s);
                                        var e1 = i(r.glyphs, t);
                                        return e1.unitsPerEm = r.unitsPerEm, e1;
                                    }, Pe(t, "xMin", "_xMin"), Pe(t, "xMax", "_xMax"), Pe(t, "yMin", "_yMin"), Pe(t, "yMax", "_yMax"), t;
                                };
                            },
                            cffGlyphLoader: function(r, e1, o, n) {
                                return function() {
                                    var t = new f({
                                        index: e1,
                                        font: r
                                    });
                                    return t.path = function() {
                                        var e1 = o(r, t, n);
                                        return e1.unitsPerEm = r.unitsPerEm, e1;
                                    }, t;
                                };
                            }
                        };
                        function Le(e1) {
                            e1 = e1.length < 1240 ? 107 : e1.length < 33900 ? 1131 : 32768;
                            return e1;
                        }
                        function y(e1, t, r) {
                            var o, n = [], s = [], i = R.getCard16(e1, t);
                            if (0 !== i) {
                                for(var a = R.getByte(e1, t + 2), l = t + (i + 1) * a + 2, u = t + 3, c = 0; c < i + 1; c += 1)n.push(R.getOffset(e1, u, a)), u += a;
                                o = l + n[i];
                            } else o = t + 2;
                            for(var d = 0; d < n.length - 1; d += 1){
                                var h = R.getBytes(e1, l + n[d], l + n[d + 1]);
                                r && (h = r(h)), s.push(h);
                            }
                            return {
                                objects: s,
                                startOffset: t,
                                endOffset: o
                            };
                        }
                        function Re(e1, t) {
                            if (28 === t) return e1.parseByte() << 8 | e1.parseByte();
                            if (29 === t) return e1.parseByte() << 24 | e1.parseByte() << 16 | e1.parseByte() << 8 | e1.parseByte();
                            if (30 === t) {
                                for(var r = e1, o = "", n = [
                                    "0",
                                    "1",
                                    "2",
                                    "3",
                                    "4",
                                    "5",
                                    "6",
                                    "7",
                                    "8",
                                    "9",
                                    ".",
                                    "E",
                                    "E-",
                                    null,
                                    "-"
                                ];;){
                                    var s = r.parseByte(), i = s >> 4, s = 15 & s;
                                    if (15 == i) break;
                                    if (o += n[i], 15 == s) break;
                                    o += n[s];
                                }
                                return parseFloat(o);
                            }
                            if (32 <= t && t <= 246) return t - 139;
                            if (247 <= t && t <= 250) return 256 * (t - 247) + e1.parseByte() + 108;
                            if (251 <= t && t <= 254) return 256 * -(t - 251) - e1.parseByte() - 108;
                            throw new Error("Invalid b0 " + t);
                        }
                        function Ie(e1, t, r) {
                            var o = new R.Parser(e1, t = void 0 !== t ? t : 0), n = [], s = [];
                            for(r = void 0 !== r ? r : e1.length; o.relativeOffset < r;){
                                var i = o.parseByte();
                                i <= 21 ? (12 === i && (i = 1200 + o.parseByte()), n.push([
                                    i,
                                    s
                                ]), s = []) : s.push(Re(o, i));
                            }
                            for(var a = n, l = {}, u = 0; u < a.length; u += 1){
                                var c = a[u][0], d = a[u][1], h = void 0, h = 1 === d.length ? d[0] : d;
                                if (l.hasOwnProperty(c) && !isNaN(l[c])) throw new Error("Object " + l + " already has key " + c);
                                l[c] = h;
                            }
                            return l;
                        }
                        function De(e1, t) {
                            return t = t <= 390 ? Se[t] : e1[t - 391];
                        }
                        function Fe(e1, t, r) {
                            for(var o, n = {}, s = 0; s < t.length; s += 1){
                                var i = t[s];
                                if (Array.isArray(i.type)) {
                                    var a = [];
                                    a.length = i.type.length;
                                    for(var l = 0; l < i.type.length; l++)void 0 === (o = void 0 !== e1[i.op] ? e1[i.op][l] : void 0) && (o = void 0 !== i.value && void 0 !== i.value[l] ? i.value[l] : null), "SID" === i.type[l] && (o = De(r, o)), a[l] = o;
                                    n[i.name] = a;
                                } else void 0 === (o = e1[i.op]) && (o = void 0 !== i.value ? i.value : null), "SID" === i.type && (o = De(r, o)), n[i.name] = o;
                            }
                            return n;
                        }
                        var Ue = [
                            {
                                name: "version",
                                op: 0,
                                type: "SID"
                            },
                            {
                                name: "notice",
                                op: 1,
                                type: "SID"
                            },
                            {
                                name: "copyright",
                                op: 1200,
                                type: "SID"
                            },
                            {
                                name: "fullName",
                                op: 2,
                                type: "SID"
                            },
                            {
                                name: "familyName",
                                op: 3,
                                type: "SID"
                            },
                            {
                                name: "weight",
                                op: 4,
                                type: "SID"
                            },
                            {
                                name: "isFixedPitch",
                                op: 1201,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "italicAngle",
                                op: 1202,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "underlinePosition",
                                op: 1203,
                                type: "number",
                                value: -100
                            },
                            {
                                name: "underlineThickness",
                                op: 1204,
                                type: "number",
                                value: 50
                            },
                            {
                                name: "paintType",
                                op: 1205,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "charstringType",
                                op: 1206,
                                type: "number",
                                value: 2
                            },
                            {
                                name: "fontMatrix",
                                op: 1207,
                                type: [
                                    "real",
                                    "real",
                                    "real",
                                    "real",
                                    "real",
                                    "real"
                                ],
                                value: [
                                    .001,
                                    0,
                                    0,
                                    .001,
                                    0,
                                    0
                                ]
                            },
                            {
                                name: "uniqueId",
                                op: 13,
                                type: "number"
                            },
                            {
                                name: "fontBBox",
                                op: 5,
                                type: [
                                    "number",
                                    "number",
                                    "number",
                                    "number"
                                ],
                                value: [
                                    0,
                                    0,
                                    0,
                                    0
                                ]
                            },
                            {
                                name: "strokeWidth",
                                op: 1208,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "xuid",
                                op: 14,
                                type: [],
                                value: null
                            },
                            {
                                name: "charset",
                                op: 15,
                                type: "offset",
                                value: 0
                            },
                            {
                                name: "encoding",
                                op: 16,
                                type: "offset",
                                value: 0
                            },
                            {
                                name: "charStrings",
                                op: 17,
                                type: "offset",
                                value: 0
                            },
                            {
                                name: "private",
                                op: 18,
                                type: [
                                    "number",
                                    "offset"
                                ],
                                value: [
                                    0,
                                    0
                                ]
                            },
                            {
                                name: "ros",
                                op: 1230,
                                type: [
                                    "SID",
                                    "SID",
                                    "number"
                                ]
                            },
                            {
                                name: "cidFontVersion",
                                op: 1231,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "cidFontRevision",
                                op: 1232,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "cidFontType",
                                op: 1233,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "cidCount",
                                op: 1234,
                                type: "number",
                                value: 8720
                            },
                            {
                                name: "uidBase",
                                op: 1235,
                                type: "number"
                            },
                            {
                                name: "fdArray",
                                op: 1236,
                                type: "offset"
                            },
                            {
                                name: "fdSelect",
                                op: 1237,
                                type: "offset"
                            },
                            {
                                name: "fontName",
                                op: 1238,
                                type: "SID"
                            }
                        ], Ne = [
                            {
                                name: "subrs",
                                op: 19,
                                type: "offset",
                                value: 0
                            },
                            {
                                name: "defaultWidthX",
                                op: 20,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "nominalWidthX",
                                op: 21,
                                type: "number",
                                value: 0
                            }
                        ];
                        function Be(e1, t, r, o) {
                            return Fe(Ie(e1, t, r), Ne, o);
                        }
                        function Ge(e1, t, r, o) {
                            for(var n = [], s = 0; s < r.length; s += 1){
                                var i = new DataView(new Uint8Array(r[s]).buffer), i = (a = o, Fe(Ie(i, 0, i.byteLength), Ue, a)), a = (i._subrs = [], i._subrsBias = 0, i.private[0]), l = i.private[1];
                                0 !== a && 0 !== l && (a = Be(e1, l + t, a, o), i._defaultWidthX = a.defaultWidthX, i._nominalWidthX = a.nominalWidthX, 0 !== a.subrs && (l = y(e1, l + a.subrs + t), i._subrs = l.objects, i._subrsBias = Le(i._subrs)), i._privateDict = a), n.push(i);
                            }
                            return n;
                        }
                        function Ve(y, g, e1) {
                            var v, b, j, _, t, x, w, r, S, T = new h, M = [], E = 0, k = !1, C = !1, O = 0, P = 0, A = (S = (y.isCIDFont ? (t = y.tables.cff.topDict._fdSelect[g.index], t = y.tables.cff.topDict._fdArray[t], x = t._subrs, w = t._subrsBias, r = t._defaultWidthX, t) : (x = y.tables.cff.topDict._subrs, w = y.tables.cff.topDict._subrsBias, r = y.tables.cff.topDict._defaultWidthX, y.tables.cff.topDict))._nominalWidthX, r);
                            function L(e1, t) {
                                C && T.closePath(), T.moveTo(e1, t), C = !0;
                            }
                            function R() {
                                M.length % 2 == 0 || k || (A = M.shift() + S), E += M.length >> 1, M.length = 0, k = !0;
                            }
                            return function e1(t) {
                                for(var r, o, n, s, i, a, l, u, c, d, h, f, p = 0; p < t.length;){
                                    var m = t[p];
                                    switch(p += 1, m){
                                        case 1:
                                        case 3:
                                            R();
                                            break;
                                        case 4:
                                            1 < M.length && !k && (A = M.shift() + S, k = !0), P += M.pop(), L(O, P);
                                            break;
                                        case 5:
                                            for(; 0 < M.length;)O += M.shift(), P += M.shift(), T.lineTo(O, P);
                                            break;
                                        case 6:
                                            for(; 0 < M.length && (O += M.shift(), T.lineTo(O, P), 0 !== M.length);)P += M.shift(), T.lineTo(O, P);
                                            break;
                                        case 7:
                                            for(; 0 < M.length && (P += M.shift(), T.lineTo(O, P), 0 !== M.length);)O += M.shift(), T.lineTo(O, P);
                                            break;
                                        case 8:
                                            for(; 0 < M.length;)v = O + M.shift(), b = P + M.shift(), j = v + M.shift(), _ = b + M.shift(), O = j + M.shift(), P = _ + M.shift(), T.curveTo(v, b, j, _, O, P);
                                            break;
                                        case 10:
                                            i = M.pop() + w, (a = x[i]) && e1(a);
                                            break;
                                        case 11:
                                            return;
                                        case 12:
                                            switch(m = t[p], p += 1, m){
                                                case 35:
                                                    v = O + M.shift(), b = P + M.shift(), j = v + M.shift(), _ = b + M.shift(), l = j + M.shift(), u = _ + M.shift(), c = l + M.shift(), d = u + M.shift(), h = c + M.shift(), f = d + M.shift(), O = h + M.shift(), P = f + M.shift(), M.shift(), T.curveTo(v, b, j, _, l, u), T.curveTo(c, d, h, f, O, P);
                                                    break;
                                                case 34:
                                                    v = O + M.shift(), b = P, j = v + M.shift(), _ = b + M.shift(), l = j + M.shift(), u = _, c = l + M.shift(), d = _, h = c + M.shift(), f = P, O = h + M.shift(), T.curveTo(v, b, j, _, l, u), T.curveTo(c, d, h, f, O, P);
                                                    break;
                                                case 36:
                                                    v = O + M.shift(), b = P + M.shift(), j = v + M.shift(), _ = b + M.shift(), l = j + M.shift(), u = _, c = l + M.shift(), d = _, h = c + M.shift(), f = d + M.shift(), O = h + M.shift(), T.curveTo(v, b, j, _, l, u), T.curveTo(c, d, h, f, O, P);
                                                    break;
                                                case 37:
                                                    v = O + M.shift(), b = P + M.shift(), j = v + M.shift(), _ = b + M.shift(), l = j + M.shift(), u = _ + M.shift(), c = l + M.shift(), d = u + M.shift(), h = c + M.shift(), f = d + M.shift(), Math.abs(h - O) > Math.abs(f - P) ? O = h + M.shift() : P = f + M.shift(), T.curveTo(v, b, j, _, l, u), T.curveTo(c, d, h, f, O, P);
                                                    break;
                                                default:
                                                    console.log("Glyph " + g.index + ": unknown operator 1200" + m), M.length = 0;
                                            }
                                            break;
                                        case 14:
                                            0 < M.length && !k && (A = M.shift() + S, k = !0), C && (T.closePath(), C = !1);
                                            break;
                                        case 18:
                                            R();
                                            break;
                                        case 19:
                                        case 20:
                                            R(), p += E + 7 >> 3;
                                            break;
                                        case 21:
                                            2 < M.length && !k && (A = M.shift() + S, k = !0), P += M.pop(), L(O += M.pop(), P);
                                            break;
                                        case 22:
                                            1 < M.length && !k && (A = M.shift() + S, k = !0), L(O += M.pop(), P);
                                            break;
                                        case 23:
                                            R();
                                            break;
                                        case 24:
                                            for(; 2 < M.length;)v = O + M.shift(), b = P + M.shift(), j = v + M.shift(), _ = b + M.shift(), O = j + M.shift(), P = _ + M.shift(), T.curveTo(v, b, j, _, O, P);
                                            O += M.shift(), P += M.shift(), T.lineTo(O, P);
                                            break;
                                        case 25:
                                            for(; 6 < M.length;)O += M.shift(), P += M.shift(), T.lineTo(O, P);
                                            v = O + M.shift(), b = P + M.shift(), j = v + M.shift(), _ = b + M.shift(), O = j + M.shift(), P = _ + M.shift(), T.curveTo(v, b, j, _, O, P);
                                            break;
                                        case 26:
                                            for(M.length % 2 && (O += M.shift()); 0 < M.length;)v = O, b = P + M.shift(), j = v + M.shift(), _ = b + M.shift(), O = j, P = _ + M.shift(), T.curveTo(v, b, j, _, O, P);
                                            break;
                                        case 27:
                                            for(M.length % 2 && (P += M.shift()); 0 < M.length;)v = O + M.shift(), b = P, j = v + M.shift(), _ = b + M.shift(), O = j + M.shift(), P = _, T.curveTo(v, b, j, _, O, P);
                                            break;
                                        case 28:
                                            r = t[p], o = t[p + 1], M.push((r << 24 | o << 16) >> 16), p += 2;
                                            break;
                                        case 29:
                                            i = M.pop() + y.gsubrsBias, (a = y.gsubrs[i]) && e1(a);
                                            break;
                                        case 30:
                                            for(; 0 < M.length && (v = O, b = P + M.shift(), j = v + M.shift(), _ = b + M.shift(), O = j + M.shift(), P = _ + (1 === M.length ? M.shift() : 0), T.curveTo(v, b, j, _, O, P), 0 !== M.length);)v = O + M.shift(), b = P, j = v + M.shift(), _ = b + M.shift(), P = _ + M.shift(), O = j + (1 === M.length ? M.shift() : 0), T.curveTo(v, b, j, _, O, P);
                                            break;
                                        case 31:
                                            for(; 0 < M.length && (v = O + M.shift(), b = P, j = v + M.shift(), _ = b + M.shift(), P = _ + M.shift(), O = j + (1 === M.length ? M.shift() : 0), T.curveTo(v, b, j, _, O, P), 0 !== M.length);)v = O, b = P + M.shift(), j = v + M.shift(), _ = b + M.shift(), O = j + M.shift(), P = _ + (1 === M.length ? M.shift() : 0), T.curveTo(v, b, j, _, O, P);
                                            break;
                                        default:
                                            m < 32 ? console.log("Glyph " + g.index + ": unknown operator " + m) : m < 247 ? M.push(m - 139) : m < 251 ? (r = t[p], p += 1, M.push(256 * (m - 247) + r + 108)) : m < 255 ? (r = t[p], p += 1, M.push(256 * -(m - 251) - r - 108)) : (r = t[p], o = t[p + 1], n = t[p + 2], s = t[p + 3], p += 4, M.push((r << 24 | o << 16 | n << 8 | s) / 65536));
                                    }
                                }
                            }(e1), g.advanceWidth = A, T;
                        }
                        function ze(e1, t) {
                            var r, o = Se.indexOf(e1);
                            return 0 <= o && (r = o), 0 <= (o = t.indexOf(e1)) ? r = o + Se.length : (r = Se.length + t.length, t.push(e1)), r;
                        }
                        function He(e1, t, r) {
                            for(var o = {}, n = 0; n < e1.length; n += 1){
                                var s = e1[n], i = t[s.name];
                                void 0 === i || function e1(t, r) {
                                    if (t === r) return 1;
                                    if (Array.isArray(t) && Array.isArray(r) && t.length === r.length) {
                                        for(var o = 0; o < t.length; o += 1)if (!e1(t[o], r[o])) return;
                                        return 1;
                                    }
                                }(i, s.value) || ("SID" === s.type && (i = ze(i, r)), o[s.op] = {
                                    name: s.name,
                                    type: s.type,
                                    value: i
                                });
                            }
                            return o;
                        }
                        function We(e1, t) {
                            var r = new S.Record("Top DICT", [
                                {
                                    name: "dict",
                                    type: "DICT",
                                    value: {}
                                }
                            ]);
                            return r.dict = He(Ue, e1, t), r;
                        }
                        function qe(e1) {
                            var t = new S.Record("Top DICT INDEX", [
                                {
                                    name: "topDicts",
                                    type: "INDEX",
                                    value: []
                                }
                            ]);
                            return t.topDicts = [
                                {
                                    name: "topDict_0",
                                    type: "TABLE",
                                    value: e1
                                }
                            ], t;
                        }
                        function Xe(e1) {
                            for(var t = new S.Record("CharStrings INDEX", [
                                {
                                    name: "charStrings",
                                    type: "INDEX",
                                    value: []
                                }
                            ]), r = 0; r < e1.length; r += 1){
                                var o = e1.get(r), n = function(e1) {
                                    for(var t = [], r = e1.path, o = (t.push({
                                        name: "width",
                                        type: "NUMBER",
                                        value: e1.advanceWidth
                                    }), 0), n = 0, s = 0; s < r.commands.length; s += 1){
                                        var i, a, l, u, c = void 0, d = void 0, h = r.commands[s];
                                        "M" === (h = "Q" === h.type ? {
                                            type: "C",
                                            x: h.x,
                                            y: h.y,
                                            x1: 1 / 3 * o + 2 / 3 * h.x1,
                                            y1: 1 / 3 * n + 2 / 3 * h.y1,
                                            x2: 1 / 3 * h.x + 2 / 3 * h.x1,
                                            y2: 1 / 3 * h.y + 2 / 3 * h.y1
                                        } : h).type ? (c = Math.round(h.x - o), d = Math.round(h.y - n), t.push({
                                            name: "dx",
                                            type: "NUMBER",
                                            value: c
                                        }), t.push({
                                            name: "dy",
                                            type: "NUMBER",
                                            value: d
                                        }), t.push({
                                            name: "rmoveto",
                                            type: "OP",
                                            value: 21
                                        }), o = Math.round(h.x), n = Math.round(h.y)) : "L" === h.type ? (c = Math.round(h.x - o), d = Math.round(h.y - n), t.push({
                                            name: "dx",
                                            type: "NUMBER",
                                            value: c
                                        }), t.push({
                                            name: "dy",
                                            type: "NUMBER",
                                            value: d
                                        }), t.push({
                                            name: "rlineto",
                                            type: "OP",
                                            value: 5
                                        }), o = Math.round(h.x), n = Math.round(h.y)) : "C" === h.type && (i = Math.round(h.x1 - o), a = Math.round(h.y1 - n), l = Math.round(h.x2 - h.x1), u = Math.round(h.y2 - h.y1), c = Math.round(h.x - h.x2), d = Math.round(h.y - h.y2), t.push({
                                            name: "dx1",
                                            type: "NUMBER",
                                            value: i
                                        }), t.push({
                                            name: "dy1",
                                            type: "NUMBER",
                                            value: a
                                        }), t.push({
                                            name: "dx2",
                                            type: "NUMBER",
                                            value: l
                                        }), t.push({
                                            name: "dy2",
                                            type: "NUMBER",
                                            value: u
                                        }), t.push({
                                            name: "dx",
                                            type: "NUMBER",
                                            value: c
                                        }), t.push({
                                            name: "dy",
                                            type: "NUMBER",
                                            value: d
                                        }), t.push({
                                            name: "rrcurveto",
                                            type: "OP",
                                            value: 8
                                        }), o = Math.round(h.x), n = Math.round(h.y));
                                    }
                                    return t.push({
                                        name: "endchar",
                                        type: "OP",
                                        value: 14
                                    }), t;
                                }(o);
                                t.charStrings.push({
                                    name: o.name,
                                    type: "CHARSTRING",
                                    value: n
                                });
                            }
                            return t;
                        }
                        var Ye = {
                            parse: function(e1, t, r) {
                                r.tables.cff = {}, o = e1, n = t, (s = {}).formatMajor = R.getCard8(o, n), s.formatMinor = R.getCard8(o, n + 1), s.size = R.getCard8(o, n + 2), s.offsetSize = R.getCard8(o, n + 3), s.startOffset = n, s.endOffset = n + 4;
                                var o = y(e1, s.endOffset, R.bytesToString), n = y(e1, o.endOffset), s = y(e1, n.endOffset, R.bytesToString), o = y(e1, s.endOffset);
                                if (r.gsubrs = o.objects, r.gsubrsBias = Le(r.gsubrs), 1 !== (o = Ge(e1, t, n.objects, s.objects)).length) throw new Error("CFF table has too many fonts in 'FontSet' - count of fonts NameIndex.length = " + o.length);
                                if (n = o[0], (r.tables.cff.topDict = n)._privateDict && (r.defaultWidthX = n._privateDict.defaultWidthX, r.nominalWidthX = n._privateDict.nominalWidthX), void 0 !== n.ros[0] && void 0 !== n.ros[1] && (r.isCIDFont = !0), r.isCIDFont) {
                                    var o = n.fdArray, i = n.fdSelect;
                                    if (0 === o || 0 === i) throw new Error("Font is marked as a CID font, but FDArray and/or FDSelect information is missing");
                                    o = Ge(e1, t, y(e1, o += t).objects, s.objects);
                                    n._fdArray = o, n._fdSelect = function(e1, t, r, o) {
                                        var n, s = [], i = new R.Parser(e1, t);
                                        if (0 === (e1 = i.parseCard8())) for(var a = 0; a < r; a++){
                                            if (o <= (n = i.parseCard8())) throw new Error("CFF table CID Font FDSelect has bad FD index value " + n + " (FD count " + o + ")");
                                            s.push(n);
                                        }
                                        else {
                                            if (3 !== e1) throw new Error("CFF Table CID Font FDSelect table has unsupported format " + e1);
                                            var l, u = i.parseCard16(), c = i.parseCard16();
                                            if (0 !== c) throw new Error("CFF Table CID Font FDSelect format 3 range has bad initial GID " + c);
                                            for(var d = 0; d < u; d++){
                                                if (n = i.parseCard8(), l = i.parseCard16(), o <= n) throw new Error("CFF table CID Font FDSelect has bad FD index value " + n + " (FD count " + o + ")");
                                                if (r < l) throw new Error("CFF Table CID Font FDSelect format 3 range has bad GID " + l);
                                                for(; c < l; c++)s.push(n);
                                                c = l;
                                            }
                                            if (l !== r) throw new Error("CFF Table CID Font FDSelect format 3 range has bad final GID " + l);
                                        }
                                        return s;
                                    }(e1, i += t, r.numGlyphs, o.length);
                                }
                                var i = t + n.private[1], o = Be(e1, i, n.private[0], s.objects), a = (r.defaultWidthX = o.defaultWidthX, r.nominalWidthX = o.nominalWidthX, 0 !== o.subrs ? (i = y(e1, i + o.subrs), r.subrs = i.objects, r.subrsBias = Le(r.subrs)) : (r.subrs = [], r.subrsBias = 0), y(e1, t + n.charStrings)), o = (r.nGlyphs = a.objects.length, function(e1, t, r, o) {
                                    var n = new R.Parser(e1, t), s = (--r, [
                                        ".notdef"
                                    ]);
                                    if (0 === (e1 = n.parseCard8())) for(var i = 0; i < r; i += 1)a = n.parseSID(), s.push(De(o, a));
                                    else if (1 === e1) for(; s.length <= r;)for(var a = n.parseSID(), l = n.parseCard8(), u = 0; u <= l; u += 1)s.push(De(o, a)), a += 1;
                                    else {
                                        if (2 !== e1) throw new Error("Unknown charset format " + e1);
                                        for(; s.length <= r;){
                                            a = n.parseSID(), l = n.parseCard16();
                                            for(var c = 0; c <= l; c += 1)s.push(De(o, a)), a += 1;
                                        }
                                    }
                                    return s;
                                }(e1, t + n.charset, r.nGlyphs, s.objects));
                                0 === n.encoding ? r.cffEncoding = new Ce(Te, o) : 1 === n.encoding ? r.cffEncoding = new Ce(Me, o) : r.cffEncoding = function(e1, t, r) {
                                    var o = {}, n = new R.Parser(e1, t);
                                    if (0 === (e1 = n.parseCard8())) for(var s = n.parseCard8(), i = 0; i < s; i += 1)o[l = n.parseCard8()] = i;
                                    else {
                                        if (1 !== e1) throw new Error("Unknown encoding format " + e1);
                                        for(var a = n.parseCard8(), l = 1, u = 0; u < a; u += 1)for(var c = n.parseCard8(), d = n.parseCard8(), h = c; h <= c + d; h += 1)o[h] = l, l += 1;
                                    }
                                    return new Ce(o, r);
                                }(e1, t + n.encoding, o), r.encoding = r.encoding || r.cffEncoding, r.glyphs = new p.GlyphSet(r);
                                for(var l = 0; l < r.nGlyphs; l += 1){
                                    var u = a.objects[l];
                                    r.glyphs.push(l, p.cffGlyphLoader(r, l, Ve, u));
                                }
                            },
                            make: function(e1, t) {
                                for(var r, o = new S.Table("CFF ", [
                                    {
                                        name: "header",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "nameIndex",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "topDictIndex",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "stringIndex",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "globalSubrIndex",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "charsets",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "charStringsIndex",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "privateDict",
                                        type: "RECORD"
                                    }
                                ]), n = 1 / t.unitsPerEm, n = {
                                    version: t.version,
                                    fullName: t.fullName,
                                    familyName: t.familyName,
                                    weight: t.weightName,
                                    fontBBox: t.fontBBox || [
                                        0,
                                        0,
                                        0,
                                        0
                                    ],
                                    fontMatrix: [
                                        n,
                                        0,
                                        0,
                                        n,
                                        0,
                                        0
                                    ],
                                    charset: 999,
                                    encoding: 0,
                                    charStrings: 999,
                                    private: [
                                        0,
                                        999
                                    ]
                                }, s = [], i = 1; i < e1.length; i += 1)r = e1.get(i), s.push(r.name);
                                var a, l, u = [], t = (o.header = new S.Record("Header", [
                                    {
                                        name: "major",
                                        type: "Card8",
                                        value: 1
                                    },
                                    {
                                        name: "minor",
                                        type: "Card8",
                                        value: 0
                                    },
                                    {
                                        name: "hdrSize",
                                        type: "Card8",
                                        value: 4
                                    },
                                    {
                                        name: "major",
                                        type: "Card8",
                                        value: 1
                                    }
                                ]), o.nameIndex = function(e1) {
                                    var t = new S.Record("Name INDEX", [
                                        {
                                            name: "names",
                                            type: "INDEX",
                                            value: []
                                        }
                                    ]);
                                    t.names = [];
                                    for(var r = 0; r < e1.length; r += 1)t.names.push({
                                        name: "name_" + r,
                                        type: "NAME",
                                        value: e1[r]
                                    });
                                    return t;
                                }([
                                    t.postScriptName
                                ]), We(n, u)), c = (o.topDictIndex = qe(t), o.globalSubrIndex = new S.Record("Global Subr INDEX", [
                                    {
                                        name: "subrs",
                                        type: "INDEX",
                                        value: []
                                    }
                                ]), o.charsets = function(e1, t) {
                                    for(var r = new S.Record("Charsets", [
                                        {
                                            name: "format",
                                            type: "Card8",
                                            value: 0
                                        }
                                    ]), o = 0; o < e1.length; o += 1){
                                        var n = ze(e1[o], t);
                                        r.fields.push({
                                            name: "glyph_" + o,
                                            type: "SID",
                                            value: n
                                        });
                                    }
                                    return r;
                                }(s, u), o.charStringsIndex = Xe(e1), o.privateDict = (c = {}, a = u, (l = new S.Record("Private DICT", [
                                    {
                                        name: "dict",
                                        type: "DICT",
                                        value: {}
                                    }
                                ])).dict = He(Ne, c, a), l), o.stringIndex = function(e1) {
                                    var t = new S.Record("String INDEX", [
                                        {
                                            name: "strings",
                                            type: "INDEX",
                                            value: []
                                        }
                                    ]);
                                    t.strings = [];
                                    for(var r = 0; r < e1.length; r += 1)t.strings.push({
                                        name: "string_" + r,
                                        type: "STRING",
                                        value: e1[r]
                                    });
                                    return t;
                                }(u), o.header.sizeOf() + o.nameIndex.sizeOf() + o.topDictIndex.sizeOf() + o.stringIndex.sizeOf() + o.globalSubrIndex.sizeOf());
                                return n.charset = c, n.encoding = 0, n.charStrings = n.charset + o.charsets.sizeOf(), n.private[1] = n.charStrings + o.charStringsIndex.sizeOf(), t = We(n, u), o.topDictIndex = qe(t), o;
                            }
                        };
                        var Ze = {
                            parse: function(e1, t) {
                                var r = {}, e1 = new R.Parser(e1, t);
                                return r.version = e1.parseVersion(), r.fontRevision = Math.round(1e3 * e1.parseFixed()) / 1e3, r.checkSumAdjustment = e1.parseULong(), r.magicNumber = e1.parseULong(), L.argument(1594834165 === r.magicNumber, "Font header has wrong magic number."), r.flags = e1.parseUShort(), r.unitsPerEm = e1.parseUShort(), r.created = e1.parseLongDateTime(), r.modified = e1.parseLongDateTime(), r.xMin = e1.parseShort(), r.yMin = e1.parseShort(), r.xMax = e1.parseShort(), r.yMax = e1.parseShort(), r.macStyle = e1.parseUShort(), r.lowestRecPPEM = e1.parseUShort(), r.fontDirectionHint = e1.parseShort(), r.indexToLocFormat = e1.parseShort(), r.glyphDataFormat = e1.parseShort(), r;
                            },
                            make: function(e1) {
                                var t = Math.round((new Date).getTime() / 1e3) + 2082844800, r = t;
                                return e1.createdTimestamp && (r = e1.createdTimestamp + 2082844800), new S.Table("head", [
                                    {
                                        name: "version",
                                        type: "FIXED",
                                        value: 65536
                                    },
                                    {
                                        name: "fontRevision",
                                        type: "FIXED",
                                        value: 65536
                                    },
                                    {
                                        name: "checkSumAdjustment",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "magicNumber",
                                        type: "ULONG",
                                        value: 1594834165
                                    },
                                    {
                                        name: "flags",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "unitsPerEm",
                                        type: "USHORT",
                                        value: 1e3
                                    },
                                    {
                                        name: "created",
                                        type: "LONGDATETIME",
                                        value: r
                                    },
                                    {
                                        name: "modified",
                                        type: "LONGDATETIME",
                                        value: t
                                    },
                                    {
                                        name: "xMin",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "yMin",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "xMax",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "yMax",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "macStyle",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "lowestRecPPEM",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "fontDirectionHint",
                                        type: "SHORT",
                                        value: 2
                                    },
                                    {
                                        name: "indexToLocFormat",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "glyphDataFormat",
                                        type: "SHORT",
                                        value: 0
                                    }
                                ], e1);
                            }
                        };
                        var Qe = {
                            parse: function(e1, t) {
                                var r = {}, e1 = new R.Parser(e1, t);
                                return r.version = e1.parseVersion(), r.ascender = e1.parseShort(), r.descender = e1.parseShort(), r.lineGap = e1.parseShort(), r.advanceWidthMax = e1.parseUShort(), r.minLeftSideBearing = e1.parseShort(), r.minRightSideBearing = e1.parseShort(), r.xMaxExtent = e1.parseShort(), r.caretSlopeRise = e1.parseShort(), r.caretSlopeRun = e1.parseShort(), r.caretOffset = e1.parseShort(), e1.relativeOffset += 8, r.metricDataFormat = e1.parseShort(), r.numberOfHMetrics = e1.parseUShort(), r;
                            },
                            make: function(e1) {
                                return new S.Table("hhea", [
                                    {
                                        name: "version",
                                        type: "FIXED",
                                        value: 65536
                                    },
                                    {
                                        name: "ascender",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "descender",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "lineGap",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "advanceWidthMax",
                                        type: "UFWORD",
                                        value: 0
                                    },
                                    {
                                        name: "minLeftSideBearing",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "minRightSideBearing",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "xMaxExtent",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "caretSlopeRise",
                                        type: "SHORT",
                                        value: 1
                                    },
                                    {
                                        name: "caretSlopeRun",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "caretOffset",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "reserved1",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "reserved2",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "reserved3",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "reserved4",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "metricDataFormat",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "numberOfHMetrics",
                                        type: "USHORT",
                                        value: 0
                                    }
                                ], e1);
                            }
                        };
                        var Je = {
                            parse: function(e1, t, r, o, n) {
                                for(var s, i, a = new R.Parser(e1, t), l = 0; l < o; l += 1){
                                    l < r && (s = a.parseUShort(), i = a.parseShort());
                                    var u = n.get(l);
                                    u.advanceWidth = s, u.leftSideBearing = i;
                                }
                            },
                            make: function(e1) {
                                for(var t = new S.Table("hmtx", []), r = 0; r < e1.length; r += 1){
                                    var o = e1.get(r), n = o.advanceWidth || 0, o = o.leftSideBearing || 0;
                                    t.fields.push({
                                        name: "advanceWidth_" + r,
                                        type: "USHORT",
                                        value: n
                                    }), t.fields.push({
                                        name: "leftSideBearing_" + r,
                                        type: "SHORT",
                                        value: o
                                    });
                                }
                                return t;
                            }
                        };
                        var Ke = {
                            make: function(e1) {
                                for(var t = new S.Table("ltag", [
                                    {
                                        name: "version",
                                        type: "ULONG",
                                        value: 1
                                    },
                                    {
                                        name: "flags",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "numTags",
                                        type: "ULONG",
                                        value: e1.length
                                    }
                                ]), r = "", o = 12 + 4 * e1.length, n = 0; n < e1.length; ++n){
                                    var s = r.indexOf(e1[n]);
                                    s < 0 && (s = r.length, r += e1[n]), t.fields.push({
                                        name: "offset " + n,
                                        type: "USHORT",
                                        value: o + s
                                    }), t.fields.push({
                                        name: "length " + n,
                                        type: "USHORT",
                                        value: e1[n].length
                                    });
                                }
                                return t.fields.push({
                                    name: "stringPool",
                                    type: "CHARARRAY",
                                    value: r
                                }), t;
                            },
                            parse: function(e1, t) {
                                for(var r = new R.Parser(e1, t), o = r.parseULong(), n = (L.argument(1 === o, "Unsupported ltag table version."), r.skip("uLong", 1), r.parseULong()), s = [], i = 0; i < n; i++){
                                    for(var a = "", l = t + r.parseUShort(), u = r.parseUShort(), c = l; c < l + u; ++c)a += String.fromCharCode(e1.getInt8(c));
                                    s.push(a);
                                }
                                return s;
                            }
                        };
                        var $e = {
                            parse: function(e1, t) {
                                var r = {}, e1 = new R.Parser(e1, t);
                                return r.version = e1.parseVersion(), r.numGlyphs = e1.parseUShort(), 1 === r.version && (r.maxPoints = e1.parseUShort(), r.maxContours = e1.parseUShort(), r.maxCompositePoints = e1.parseUShort(), r.maxCompositeContours = e1.parseUShort(), r.maxZones = e1.parseUShort(), r.maxTwilightPoints = e1.parseUShort(), r.maxStorage = e1.parseUShort(), r.maxFunctionDefs = e1.parseUShort(), r.maxInstructionDefs = e1.parseUShort(), r.maxStackElements = e1.parseUShort(), r.maxSizeOfInstructions = e1.parseUShort(), r.maxComponentElements = e1.parseUShort(), r.maxComponentDepth = e1.parseUShort()), r;
                            },
                            make: function(e1) {
                                return new S.Table("maxp", [
                                    {
                                        name: "version",
                                        type: "FIXED",
                                        value: 20480
                                    },
                                    {
                                        name: "numGlyphs",
                                        type: "USHORT",
                                        value: e1
                                    }
                                ]);
                            }
                        }, et = [
                            "copyright",
                            "fontFamily",
                            "fontSubfamily",
                            "uniqueID",
                            "fullName",
                            "version",
                            "postScriptName",
                            "trademark",
                            "manufacturer",
                            "designer",
                            "description",
                            "manufacturerURL",
                            "designerURL",
                            "license",
                            "licenseURL",
                            "reserved",
                            "preferredFamily",
                            "preferredSubfamily",
                            "compatibleFullName",
                            "sampleText",
                            "postScriptFindFontName",
                            "wwsFamily",
                            "wwsSubfamily"
                        ], tt = {
                            0: "en",
                            1: "fr",
                            2: "de",
                            3: "it",
                            4: "nl",
                            5: "sv",
                            6: "es",
                            7: "da",
                            8: "pt",
                            9: "no",
                            10: "he",
                            11: "ja",
                            12: "ar",
                            13: "fi",
                            14: "el",
                            15: "is",
                            16: "mt",
                            17: "tr",
                            18: "hr",
                            19: "zh-Hant",
                            20: "ur",
                            21: "hi",
                            22: "th",
                            23: "ko",
                            24: "lt",
                            25: "pl",
                            26: "hu",
                            27: "es",
                            28: "lv",
                            29: "se",
                            30: "fo",
                            31: "fa",
                            32: "ru",
                            33: "zh",
                            34: "nl-BE",
                            35: "ga",
                            36: "sq",
                            37: "ro",
                            38: "cz",
                            39: "sk",
                            40: "si",
                            41: "yi",
                            42: "sr",
                            43: "mk",
                            44: "bg",
                            45: "uk",
                            46: "be",
                            47: "uz",
                            48: "kk",
                            49: "az-Cyrl",
                            50: "az-Arab",
                            51: "hy",
                            52: "ka",
                            53: "mo",
                            54: "ky",
                            55: "tg",
                            56: "tk",
                            57: "mn-CN",
                            58: "mn",
                            59: "ps",
                            60: "ks",
                            61: "ku",
                            62: "sd",
                            63: "bo",
                            64: "ne",
                            65: "sa",
                            66: "mr",
                            67: "bn",
                            68: "as",
                            69: "gu",
                            70: "pa",
                            71: "or",
                            72: "ml",
                            73: "kn",
                            74: "ta",
                            75: "te",
                            76: "si",
                            77: "my",
                            78: "km",
                            79: "lo",
                            80: "vi",
                            81: "id",
                            82: "tl",
                            83: "ms",
                            84: "ms-Arab",
                            85: "am",
                            86: "ti",
                            87: "om",
                            88: "so",
                            89: "sw",
                            90: "rw",
                            91: "rn",
                            92: "ny",
                            93: "mg",
                            94: "eo",
                            128: "cy",
                            129: "eu",
                            130: "ca",
                            131: "la",
                            132: "qu",
                            133: "gn",
                            134: "ay",
                            135: "tt",
                            136: "ug",
                            137: "dz",
                            138: "jv",
                            139: "su",
                            140: "gl",
                            141: "af",
                            142: "br",
                            143: "iu",
                            144: "gd",
                            145: "gv",
                            146: "ga",
                            147: "to",
                            148: "el-polyton",
                            149: "kl",
                            150: "az",
                            151: "nn"
                        }, rt = {
                            0: 0,
                            1: 0,
                            2: 0,
                            3: 0,
                            4: 0,
                            5: 0,
                            6: 0,
                            7: 0,
                            8: 0,
                            9: 0,
                            10: 5,
                            11: 1,
                            12: 4,
                            13: 0,
                            14: 6,
                            15: 0,
                            16: 0,
                            17: 0,
                            18: 0,
                            19: 2,
                            20: 4,
                            21: 9,
                            22: 21,
                            23: 3,
                            24: 29,
                            25: 29,
                            26: 29,
                            27: 29,
                            28: 29,
                            29: 0,
                            30: 0,
                            31: 4,
                            32: 7,
                            33: 25,
                            34: 0,
                            35: 0,
                            36: 0,
                            37: 0,
                            38: 29,
                            39: 29,
                            40: 0,
                            41: 5,
                            42: 7,
                            43: 7,
                            44: 7,
                            45: 7,
                            46: 7,
                            47: 7,
                            48: 7,
                            49: 7,
                            50: 4,
                            51: 24,
                            52: 23,
                            53: 7,
                            54: 7,
                            55: 7,
                            56: 7,
                            57: 27,
                            58: 7,
                            59: 4,
                            60: 4,
                            61: 4,
                            62: 4,
                            63: 26,
                            64: 9,
                            65: 9,
                            66: 9,
                            67: 13,
                            68: 13,
                            69: 11,
                            70: 10,
                            71: 12,
                            72: 17,
                            73: 16,
                            74: 14,
                            75: 15,
                            76: 18,
                            77: 19,
                            78: 20,
                            79: 22,
                            80: 30,
                            81: 0,
                            82: 0,
                            83: 0,
                            84: 4,
                            85: 28,
                            86: 28,
                            87: 28,
                            88: 0,
                            89: 0,
                            90: 0,
                            91: 0,
                            92: 0,
                            93: 0,
                            94: 0,
                            128: 0,
                            129: 0,
                            130: 0,
                            131: 0,
                            132: 0,
                            133: 0,
                            134: 0,
                            135: 7,
                            136: 4,
                            137: 26,
                            138: 0,
                            139: 0,
                            140: 0,
                            141: 0,
                            142: 0,
                            143: 28,
                            144: 0,
                            145: 0,
                            146: 0,
                            147: 0,
                            148: 6,
                            149: 0,
                            150: 0,
                            151: 0
                        }, ot = {
                            1078: "af",
                            1052: "sq",
                            1156: "gsw",
                            1118: "am",
                            5121: "ar-DZ",
                            15361: "ar-BH",
                            3073: "ar",
                            2049: "ar-IQ",
                            11265: "ar-JO",
                            13313: "ar-KW",
                            12289: "ar-LB",
                            4097: "ar-LY",
                            6145: "ary",
                            8193: "ar-OM",
                            16385: "ar-QA",
                            1025: "ar-SA",
                            10241: "ar-SY",
                            7169: "aeb",
                            14337: "ar-AE",
                            9217: "ar-YE",
                            1067: "hy",
                            1101: "as",
                            2092: "az-Cyrl",
                            1068: "az",
                            1133: "ba",
                            1069: "eu",
                            1059: "be",
                            2117: "bn",
                            1093: "bn-IN",
                            8218: "bs-Cyrl",
                            5146: "bs",
                            1150: "br",
                            1026: "bg",
                            1027: "ca",
                            3076: "zh-HK",
                            5124: "zh-MO",
                            2052: "zh",
                            4100: "zh-SG",
                            1028: "zh-TW",
                            1155: "co",
                            1050: "hr",
                            4122: "hr-BA",
                            1029: "cs",
                            1030: "da",
                            1164: "prs",
                            1125: "dv",
                            2067: "nl-BE",
                            1043: "nl",
                            3081: "en-AU",
                            10249: "en-BZ",
                            4105: "en-CA",
                            9225: "en-029",
                            16393: "en-IN",
                            6153: "en-IE",
                            8201: "en-JM",
                            17417: "en-MY",
                            5129: "en-NZ",
                            13321: "en-PH",
                            18441: "en-SG",
                            7177: "en-ZA",
                            11273: "en-TT",
                            2057: "en-GB",
                            1033: "en",
                            12297: "en-ZW",
                            1061: "et",
                            1080: "fo",
                            1124: "fil",
                            1035: "fi",
                            2060: "fr-BE",
                            3084: "fr-CA",
                            1036: "fr",
                            5132: "fr-LU",
                            6156: "fr-MC",
                            4108: "fr-CH",
                            1122: "fy",
                            1110: "gl",
                            1079: "ka",
                            3079: "de-AT",
                            1031: "de",
                            5127: "de-LI",
                            4103: "de-LU",
                            2055: "de-CH",
                            1032: "el",
                            1135: "kl",
                            1095: "gu",
                            1128: "ha",
                            1037: "he",
                            1081: "hi",
                            1038: "hu",
                            1039: "is",
                            1136: "ig",
                            1057: "id",
                            1117: "iu",
                            2141: "iu-Latn",
                            2108: "ga",
                            1076: "xh",
                            1077: "zu",
                            1040: "it",
                            2064: "it-CH",
                            1041: "ja",
                            1099: "kn",
                            1087: "kk",
                            1107: "km",
                            1158: "quc",
                            1159: "rw",
                            1089: "sw",
                            1111: "kok",
                            1042: "ko",
                            1088: "ky",
                            1108: "lo",
                            1062: "lv",
                            1063: "lt",
                            2094: "dsb",
                            1134: "lb",
                            1071: "mk",
                            2110: "ms-BN",
                            1086: "ms",
                            1100: "ml",
                            1082: "mt",
                            1153: "mi",
                            1146: "arn",
                            1102: "mr",
                            1148: "moh",
                            1104: "mn",
                            2128: "mn-CN",
                            1121: "ne",
                            1044: "nb",
                            2068: "nn",
                            1154: "oc",
                            1096: "or",
                            1123: "ps",
                            1045: "pl",
                            1046: "pt",
                            2070: "pt-PT",
                            1094: "pa",
                            1131: "qu-BO",
                            2155: "qu-EC",
                            3179: "qu",
                            1048: "ro",
                            1047: "rm",
                            1049: "ru",
                            9275: "smn",
                            4155: "smj-NO",
                            5179: "smj",
                            3131: "se-FI",
                            1083: "se",
                            2107: "se-SE",
                            8251: "sms",
                            6203: "sma-NO",
                            7227: "sms",
                            1103: "sa",
                            7194: "sr-Cyrl-BA",
                            3098: "sr",
                            6170: "sr-Latn-BA",
                            2074: "sr-Latn",
                            1132: "nso",
                            1074: "tn",
                            1115: "si",
                            1051: "sk",
                            1060: "sl",
                            11274: "es-AR",
                            16394: "es-BO",
                            13322: "es-CL",
                            9226: "es-CO",
                            5130: "es-CR",
                            7178: "es-DO",
                            12298: "es-EC",
                            17418: "es-SV",
                            4106: "es-GT",
                            18442: "es-HN",
                            2058: "es-MX",
                            19466: "es-NI",
                            6154: "es-PA",
                            15370: "es-PY",
                            10250: "es-PE",
                            20490: "es-PR",
                            3082: "es",
                            1034: "es",
                            21514: "es-US",
                            14346: "es-UY",
                            8202: "es-VE",
                            2077: "sv-FI",
                            1053: "sv",
                            1114: "syr",
                            1064: "tg",
                            2143: "tzm",
                            1097: "ta",
                            1092: "tt",
                            1098: "te",
                            1054: "th",
                            1105: "bo",
                            1055: "tr",
                            1090: "tk",
                            1152: "ug",
                            1058: "uk",
                            1070: "hsb",
                            1056: "ur",
                            2115: "uz-Cyrl",
                            1091: "uz",
                            1066: "vi",
                            1106: "cy",
                            1160: "wo",
                            1157: "sah",
                            1144: "ii",
                            1130: "yo"
                        };
                        var nt = "utf-16", st = {
                            0: "macintosh",
                            1: "x-mac-japanese",
                            2: "x-mac-chinesetrad",
                            3: "x-mac-korean",
                            6: "x-mac-greek",
                            7: "x-mac-cyrillic",
                            9: "x-mac-devanagai",
                            10: "x-mac-gurmukhi",
                            11: "x-mac-gujarati",
                            12: "x-mac-oriya",
                            13: "x-mac-bengali",
                            14: "x-mac-tamil",
                            15: "x-mac-telugu",
                            16: "x-mac-kannada",
                            17: "x-mac-malayalam",
                            18: "x-mac-sinhalese",
                            19: "x-mac-burmese",
                            20: "x-mac-khmer",
                            21: "x-mac-thai",
                            22: "x-mac-lao",
                            23: "x-mac-georgian",
                            24: "x-mac-armenian",
                            25: "x-mac-chinesesimp",
                            26: "x-mac-tibetan",
                            27: "x-mac-mongolian",
                            28: "x-mac-ethiopic",
                            29: "x-mac-ce",
                            30: "x-mac-vietnamese",
                            31: "x-mac-extarabic"
                        }, it = {
                            15: "x-mac-icelandic",
                            17: "x-mac-turkish",
                            18: "x-mac-croatian",
                            24: "x-mac-ce",
                            25: "x-mac-ce",
                            26: "x-mac-ce",
                            27: "x-mac-ce",
                            28: "x-mac-ce",
                            30: "x-mac-icelandic",
                            37: "x-mac-romanian",
                            38: "x-mac-ce",
                            39: "x-mac-ce",
                            40: "x-mac-ce",
                            143: "x-mac-inuit",
                            146: "x-mac-gaelic"
                        };
                        function at(e1, t, r) {
                            switch(e1){
                                case 0:
                                    return nt;
                                case 1:
                                    return it[r] || st[t];
                                case 3:
                                    if (1 === t || 10 === t) return nt;
                            }
                        }
                        function lt(e1) {
                            var t, r = {};
                            for(t in e1)r[e1[t]] = parseInt(t);
                            return r;
                        }
                        function ut(e1, t, r, o, n, s) {
                            return new S.Record("NameRecord", [
                                {
                                    name: "platformID",
                                    type: "USHORT",
                                    value: e1
                                },
                                {
                                    name: "encodingID",
                                    type: "USHORT",
                                    value: t
                                },
                                {
                                    name: "languageID",
                                    type: "USHORT",
                                    value: r
                                },
                                {
                                    name: "nameID",
                                    type: "USHORT",
                                    value: o
                                },
                                {
                                    name: "length",
                                    type: "USHORT",
                                    value: n
                                },
                                {
                                    name: "offset",
                                    type: "USHORT",
                                    value: s
                                }
                            ]);
                        }
                        function ct(e1, t) {
                            if ((r = function(e1, t) {
                                var r = e1.length, o = t.length - r + 1;
                                e: for(var n = 0; n < o; n++)for(; n < o; n++){
                                    for(var s = 0; s < r; s++)if (t[n + s] !== e1[s]) continue e;
                                    return n;
                                }
                                return -1;
                            }(e1, t)) < 0) for(var r = t.length, o = 0, n = e1.length; o < n; ++o)t.push(e1[o]);
                            return r;
                        }
                        var dt = {
                            parse: function(e1, t, r) {
                                for(var o = {}, n = new R.Parser(e1, t), t = n.parseUShort(), s = n.parseUShort(), i = n.offset + n.parseUShort(), a = 0; a < s; a++){
                                    var l = n.parseUShort(), u = n.parseUShort(), c = n.parseUShort(), d = n.parseUShort(), d = et[d] || d, h = n.parseUShort(), f = n.parseUShort(), p = function(e1, t, r) {
                                        switch(e1){
                                            case 0:
                                                if (65535 === t) return "und";
                                                if (r) return r[t];
                                                break;
                                            case 1:
                                                return tt[t];
                                            case 3:
                                                return ot[t];
                                        }
                                    }(l, c, r), l = at(l, u, c);
                                    void 0 !== l && void 0 !== p && (u = void 0, (u = l === nt ? m.UTF16(e1, i + f, h) : m.MACSTRING(e1, i + f, h, l)) && ((c = void 0 === (c = o[d]) ? o[d] = {} : c)[p] = u));
                                }
                                return 1 === t && n.parseUShort(), o;
                            },
                            make: function(e1, t) {
                                var r, o = [], n = {}, s = lt(et);
                                for(r in e1){
                                    var i = s[r];
                                    if (void 0 === i && (i = r), h = parseInt(i), isNaN(h)) throw new Error('Name table entry "' + r + '" does not exist, see nameTableNames for complete list.');
                                    n[h] = e1[r], o.push(h);
                                }
                                for(var a = lt(tt), l = lt(ot), u = [], c = [], d = 0; d < o.length; d++){
                                    var h, f, p = n[h = o[d]];
                                    for(f in p){
                                        var m = p[f], y = 1, g = a[f], v = rt[g], b = at(y, v, g), b = w.MACSTRING(m, b), j = (void 0 === b && (y = 0, (g = t.indexOf(f)) < 0 && (g = t.length, t.push(f)), v = 4, b = w.UTF16(m)), ct(b, c)), y = (u.push(ut(y, v, g, h, b.length, j)), l[f]);
                                        void 0 !== y && (g = ct(v = w.UTF16(m), c), u.push(ut(3, 1, y, h, v.length, g)));
                                    }
                                }
                                u.sort(function(e1, t) {
                                    return e1.platformID - t.platformID || e1.encodingID - t.encodingID || e1.languageID - t.languageID || e1.nameID - t.nameID;
                                });
                                for(var _ = new S.Table("name", [
                                    {
                                        name: "format",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "count",
                                        type: "USHORT",
                                        value: u.length
                                    },
                                    {
                                        name: "stringOffset",
                                        type: "USHORT",
                                        value: 6 + 12 * u.length
                                    }
                                ]), x = 0; x < u.length; x++)_.fields.push({
                                    name: "record_" + x,
                                    type: "RECORD",
                                    value: u[x]
                                });
                                return _.fields.push({
                                    name: "strings",
                                    type: "LITERAL",
                                    value: c
                                }), _;
                            }
                        }, ht = [
                            {
                                begin: 0,
                                end: 127
                            },
                            {
                                begin: 128,
                                end: 255
                            },
                            {
                                begin: 256,
                                end: 383
                            },
                            {
                                begin: 384,
                                end: 591
                            },
                            {
                                begin: 592,
                                end: 687
                            },
                            {
                                begin: 688,
                                end: 767
                            },
                            {
                                begin: 768,
                                end: 879
                            },
                            {
                                begin: 880,
                                end: 1023
                            },
                            {
                                begin: 11392,
                                end: 11519
                            },
                            {
                                begin: 1024,
                                end: 1279
                            },
                            {
                                begin: 1328,
                                end: 1423
                            },
                            {
                                begin: 1424,
                                end: 1535
                            },
                            {
                                begin: 42240,
                                end: 42559
                            },
                            {
                                begin: 1536,
                                end: 1791
                            },
                            {
                                begin: 1984,
                                end: 2047
                            },
                            {
                                begin: 2304,
                                end: 2431
                            },
                            {
                                begin: 2432,
                                end: 2559
                            },
                            {
                                begin: 2560,
                                end: 2687
                            },
                            {
                                begin: 2688,
                                end: 2815
                            },
                            {
                                begin: 2816,
                                end: 2943
                            },
                            {
                                begin: 2944,
                                end: 3071
                            },
                            {
                                begin: 3072,
                                end: 3199
                            },
                            {
                                begin: 3200,
                                end: 3327
                            },
                            {
                                begin: 3328,
                                end: 3455
                            },
                            {
                                begin: 3584,
                                end: 3711
                            },
                            {
                                begin: 3712,
                                end: 3839
                            },
                            {
                                begin: 4256,
                                end: 4351
                            },
                            {
                                begin: 6912,
                                end: 7039
                            },
                            {
                                begin: 4352,
                                end: 4607
                            },
                            {
                                begin: 7680,
                                end: 7935
                            },
                            {
                                begin: 7936,
                                end: 8191
                            },
                            {
                                begin: 8192,
                                end: 8303
                            },
                            {
                                begin: 8304,
                                end: 8351
                            },
                            {
                                begin: 8352,
                                end: 8399
                            },
                            {
                                begin: 8400,
                                end: 8447
                            },
                            {
                                begin: 8448,
                                end: 8527
                            },
                            {
                                begin: 8528,
                                end: 8591
                            },
                            {
                                begin: 8592,
                                end: 8703
                            },
                            {
                                begin: 8704,
                                end: 8959
                            },
                            {
                                begin: 8960,
                                end: 9215
                            },
                            {
                                begin: 9216,
                                end: 9279
                            },
                            {
                                begin: 9280,
                                end: 9311
                            },
                            {
                                begin: 9312,
                                end: 9471
                            },
                            {
                                begin: 9472,
                                end: 9599
                            },
                            {
                                begin: 9600,
                                end: 9631
                            },
                            {
                                begin: 9632,
                                end: 9727
                            },
                            {
                                begin: 9728,
                                end: 9983
                            },
                            {
                                begin: 9984,
                                end: 10175
                            },
                            {
                                begin: 12288,
                                end: 12351
                            },
                            {
                                begin: 12352,
                                end: 12447
                            },
                            {
                                begin: 12448,
                                end: 12543
                            },
                            {
                                begin: 12544,
                                end: 12591
                            },
                            {
                                begin: 12592,
                                end: 12687
                            },
                            {
                                begin: 43072,
                                end: 43135
                            },
                            {
                                begin: 12800,
                                end: 13055
                            },
                            {
                                begin: 13056,
                                end: 13311
                            },
                            {
                                begin: 44032,
                                end: 55215
                            },
                            {
                                begin: 55296,
                                end: 57343
                            },
                            {
                                begin: 67840,
                                end: 67871
                            },
                            {
                                begin: 19968,
                                end: 40959
                            },
                            {
                                begin: 57344,
                                end: 63743
                            },
                            {
                                begin: 12736,
                                end: 12783
                            },
                            {
                                begin: 64256,
                                end: 64335
                            },
                            {
                                begin: 64336,
                                end: 65023
                            },
                            {
                                begin: 65056,
                                end: 65071
                            },
                            {
                                begin: 65040,
                                end: 65055
                            },
                            {
                                begin: 65104,
                                end: 65135
                            },
                            {
                                begin: 65136,
                                end: 65279
                            },
                            {
                                begin: 65280,
                                end: 65519
                            },
                            {
                                begin: 65520,
                                end: 65535
                            },
                            {
                                begin: 3840,
                                end: 4095
                            },
                            {
                                begin: 1792,
                                end: 1871
                            },
                            {
                                begin: 1920,
                                end: 1983
                            },
                            {
                                begin: 3456,
                                end: 3583
                            },
                            {
                                begin: 4096,
                                end: 4255
                            },
                            {
                                begin: 4608,
                                end: 4991
                            },
                            {
                                begin: 5024,
                                end: 5119
                            },
                            {
                                begin: 5120,
                                end: 5759
                            },
                            {
                                begin: 5760,
                                end: 5791
                            },
                            {
                                begin: 5792,
                                end: 5887
                            },
                            {
                                begin: 6016,
                                end: 6143
                            },
                            {
                                begin: 6144,
                                end: 6319
                            },
                            {
                                begin: 10240,
                                end: 10495
                            },
                            {
                                begin: 40960,
                                end: 42127
                            },
                            {
                                begin: 5888,
                                end: 5919
                            },
                            {
                                begin: 66304,
                                end: 66351
                            },
                            {
                                begin: 66352,
                                end: 66383
                            },
                            {
                                begin: 66560,
                                end: 66639
                            },
                            {
                                begin: 118784,
                                end: 119039
                            },
                            {
                                begin: 119808,
                                end: 120831
                            },
                            {
                                begin: 1044480,
                                end: 1048573
                            },
                            {
                                begin: 65024,
                                end: 65039
                            },
                            {
                                begin: 917504,
                                end: 917631
                            },
                            {
                                begin: 6400,
                                end: 6479
                            },
                            {
                                begin: 6480,
                                end: 6527
                            },
                            {
                                begin: 6528,
                                end: 6623
                            },
                            {
                                begin: 6656,
                                end: 6687
                            },
                            {
                                begin: 11264,
                                end: 11359
                            },
                            {
                                begin: 11568,
                                end: 11647
                            },
                            {
                                begin: 19904,
                                end: 19967
                            },
                            {
                                begin: 43008,
                                end: 43055
                            },
                            {
                                begin: 65536,
                                end: 65663
                            },
                            {
                                begin: 65856,
                                end: 65935
                            },
                            {
                                begin: 66432,
                                end: 66463
                            },
                            {
                                begin: 66464,
                                end: 66527
                            },
                            {
                                begin: 66640,
                                end: 66687
                            },
                            {
                                begin: 66688,
                                end: 66735
                            },
                            {
                                begin: 67584,
                                end: 67647
                            },
                            {
                                begin: 68096,
                                end: 68191
                            },
                            {
                                begin: 119552,
                                end: 119647
                            },
                            {
                                begin: 73728,
                                end: 74751
                            },
                            {
                                begin: 119648,
                                end: 119679
                            },
                            {
                                begin: 7040,
                                end: 7103
                            },
                            {
                                begin: 7168,
                                end: 7247
                            },
                            {
                                begin: 7248,
                                end: 7295
                            },
                            {
                                begin: 43136,
                                end: 43231
                            },
                            {
                                begin: 43264,
                                end: 43311
                            },
                            {
                                begin: 43312,
                                end: 43359
                            },
                            {
                                begin: 43520,
                                end: 43615
                            },
                            {
                                begin: 65936,
                                end: 65999
                            },
                            {
                                begin: 66e3,
                                end: 66047
                            },
                            {
                                begin: 66208,
                                end: 66271
                            },
                            {
                                begin: 127024,
                                end: 127135
                            }
                        ];
                        var ft = {
                            parse: function(e1, t) {
                                var r = {}, o = new R.Parser(e1, t);
                                r.version = o.parseUShort(), r.xAvgCharWidth = o.parseShort(), r.usWeightClass = o.parseUShort(), r.usWidthClass = o.parseUShort(), r.fsType = o.parseUShort(), r.ySubscriptXSize = o.parseShort(), r.ySubscriptYSize = o.parseShort(), r.ySubscriptXOffset = o.parseShort(), r.ySubscriptYOffset = o.parseShort(), r.ySuperscriptXSize = o.parseShort(), r.ySuperscriptYSize = o.parseShort(), r.ySuperscriptXOffset = o.parseShort(), r.ySuperscriptYOffset = o.parseShort(), r.yStrikeoutSize = o.parseShort(), r.yStrikeoutPosition = o.parseShort(), r.sFamilyClass = o.parseShort(), r.panose = [];
                                for(var n = 0; n < 10; n++)r.panose[n] = o.parseByte();
                                return r.ulUnicodeRange1 = o.parseULong(), r.ulUnicodeRange2 = o.parseULong(), r.ulUnicodeRange3 = o.parseULong(), r.ulUnicodeRange4 = o.parseULong(), r.achVendID = String.fromCharCode(o.parseByte(), o.parseByte(), o.parseByte(), o.parseByte()), r.fsSelection = o.parseUShort(), r.usFirstCharIndex = o.parseUShort(), r.usLastCharIndex = o.parseUShort(), r.sTypoAscender = o.parseShort(), r.sTypoDescender = o.parseShort(), r.sTypoLineGap = o.parseShort(), r.usWinAscent = o.parseUShort(), r.usWinDescent = o.parseUShort(), 1 <= r.version && (r.ulCodePageRange1 = o.parseULong(), r.ulCodePageRange2 = o.parseULong()), 2 <= r.version && (r.sxHeight = o.parseShort(), r.sCapHeight = o.parseShort(), r.usDefaultChar = o.parseUShort(), r.usBreakChar = o.parseUShort(), r.usMaxContent = o.parseUShort()), r;
                            },
                            make: function(e1) {
                                return new S.Table("OS/2", [
                                    {
                                        name: "version",
                                        type: "USHORT",
                                        value: 3
                                    },
                                    {
                                        name: "xAvgCharWidth",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usWeightClass",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usWidthClass",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "fsType",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "ySubscriptXSize",
                                        type: "SHORT",
                                        value: 650
                                    },
                                    {
                                        name: "ySubscriptYSize",
                                        type: "SHORT",
                                        value: 699
                                    },
                                    {
                                        name: "ySubscriptXOffset",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "ySubscriptYOffset",
                                        type: "SHORT",
                                        value: 140
                                    },
                                    {
                                        name: "ySuperscriptXSize",
                                        type: "SHORT",
                                        value: 650
                                    },
                                    {
                                        name: "ySuperscriptYSize",
                                        type: "SHORT",
                                        value: 699
                                    },
                                    {
                                        name: "ySuperscriptXOffset",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "ySuperscriptYOffset",
                                        type: "SHORT",
                                        value: 479
                                    },
                                    {
                                        name: "yStrikeoutSize",
                                        type: "SHORT",
                                        value: 49
                                    },
                                    {
                                        name: "yStrikeoutPosition",
                                        type: "SHORT",
                                        value: 258
                                    },
                                    {
                                        name: "sFamilyClass",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "bFamilyType",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bSerifStyle",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bWeight",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bProportion",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bContrast",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bStrokeVariation",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bArmStyle",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bLetterform",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bMidline",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bXHeight",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "ulUnicodeRange1",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "ulUnicodeRange2",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "ulUnicodeRange3",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "ulUnicodeRange4",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "achVendID",
                                        type: "CHARARRAY",
                                        value: "XXXX"
                                    },
                                    {
                                        name: "fsSelection",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usFirstCharIndex",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usLastCharIndex",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "sTypoAscender",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "sTypoDescender",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "sTypoLineGap",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usWinAscent",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usWinDescent",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "ulCodePageRange1",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "ulCodePageRange2",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "sxHeight",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "sCapHeight",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usDefaultChar",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usBreakChar",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usMaxContext",
                                        type: "USHORT",
                                        value: 0
                                    }
                                ], e1);
                            },
                            unicodeRanges: ht,
                            getUnicodeRange: function(e1) {
                                for(var t = 0; t < ht.length; t += 1){
                                    var r = ht[t];
                                    if (e1 >= r.begin && e1 < r.end) return t;
                                }
                                return -1;
                            }
                        };
                        var pt = {
                            parse: function(e1, t) {
                                var r = {}, o = new R.Parser(e1, t);
                                switch(r.version = o.parseVersion(), r.italicAngle = o.parseFixed(), r.underlinePosition = o.parseShort(), r.underlineThickness = o.parseShort(), r.isFixedPitch = o.parseULong(), r.minMemType42 = o.parseULong(), r.maxMemType42 = o.parseULong(), r.minMemType1 = o.parseULong(), r.maxMemType1 = o.parseULong(), r.version){
                                    case 1:
                                        r.names = c.slice();
                                        break;
                                    case 2:
                                        r.numberOfGlyphs = o.parseUShort(), r.glyphNameIndex = new Array(r.numberOfGlyphs);
                                        for(var n = 0; n < r.numberOfGlyphs; n++)r.glyphNameIndex[n] = o.parseUShort();
                                        r.names = [];
                                        for(var s, i = 0; i < r.numberOfGlyphs; i++)r.glyphNameIndex[i] >= c.length && (s = o.parseChar(), r.names.push(o.parseString(s)));
                                        break;
                                    case 2.5:
                                        r.numberOfGlyphs = o.parseUShort(), r.offset = new Array(r.numberOfGlyphs);
                                        for(var a = 0; a < r.numberOfGlyphs; a++)r.offset[a] = o.parseChar();
                                }
                                return r;
                            },
                            make: function() {
                                return new S.Table("post", [
                                    {
                                        name: "version",
                                        type: "FIXED",
                                        value: 196608
                                    },
                                    {
                                        name: "italicAngle",
                                        type: "FIXED",
                                        value: 0
                                    },
                                    {
                                        name: "underlinePosition",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "underlineThickness",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "isFixedPitch",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "minMemType42",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "maxMemType42",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "minMemType1",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "maxMemType1",
                                        type: "ULONG",
                                        value: 0
                                    }
                                ]);
                            }
                        }, o = new Array(9), s = (o[1] = function() {
                            var e1 = this.offset + this.relativeOffset, t = this.parseUShort();
                            return 1 === t ? {
                                substFormat: 1,
                                coverage: this.parsePointer(u.coverage),
                                deltaGlyphId: this.parseUShort()
                            } : 2 === t ? {
                                substFormat: 2,
                                coverage: this.parsePointer(u.coverage),
                                substitute: this.parseOffset16List()
                            } : void L.assert(!1, "0x" + e1.toString(16) + ": lookup type 1 format must be 1 or 2.");
                        }, o[2] = function() {
                            var e1 = this.parseUShort();
                            return L.argument(1 === e1, "GSUB Multiple Substitution Subtable identifier-format must be 1"), {
                                substFormat: e1,
                                coverage: this.parsePointer(u.coverage),
                                sequences: this.parseListOfLists()
                            };
                        }, o[3] = function() {
                            var e1 = this.parseUShort();
                            return L.argument(1 === e1, "GSUB Alternate Substitution Subtable identifier-format must be 1"), {
                                substFormat: e1,
                                coverage: this.parsePointer(u.coverage),
                                alternateSets: this.parseListOfLists()
                            };
                        }, o[4] = function() {
                            var e1 = this.parseUShort();
                            return L.argument(1 === e1, "GSUB ligature table identifier-format must be 1"), {
                                substFormat: e1,
                                coverage: this.parsePointer(u.coverage),
                                ligatureSets: this.parseListOfLists(function() {
                                    return {
                                        ligGlyph: this.parseUShort(),
                                        components: this.parseUShortList(this.parseUShort() - 1)
                                    };
                                })
                            };
                        }, {
                            sequenceIndex: u.uShort,
                            lookupListIndex: u.uShort
                        });
                        o[5] = function() {
                            var e1, t, r = this.offset + this.relativeOffset, o = this.parseUShort();
                            return 1 === o ? {
                                substFormat: o,
                                coverage: this.parsePointer(u.coverage),
                                ruleSets: this.parseListOfLists(function() {
                                    var e1 = this.parseUShort(), t = this.parseUShort();
                                    return {
                                        input: this.parseUShortList(e1 - 1),
                                        lookupRecords: this.parseRecordList(t, s)
                                    };
                                })
                            } : 2 === o ? {
                                substFormat: o,
                                coverage: this.parsePointer(u.coverage),
                                classDef: this.parsePointer(u.classDef),
                                classSets: this.parseListOfLists(function() {
                                    var e1 = this.parseUShort(), t = this.parseUShort();
                                    return {
                                        classes: this.parseUShortList(e1 - 1),
                                        lookupRecords: this.parseRecordList(t, s)
                                    };
                                })
                            } : 3 === o ? (e1 = this.parseUShort(), t = this.parseUShort(), {
                                substFormat: o,
                                coverages: this.parseList(e1, u.pointer(u.coverage)),
                                lookupRecords: this.parseRecordList(t, s)
                            }) : void L.assert(!1, "0x" + r.toString(16) + ": lookup type 5 format must be 1, 2 or 3.");
                        }, o[6] = function() {
                            var e1 = this.offset + this.relativeOffset, t = this.parseUShort();
                            return 1 === t ? {
                                substFormat: 1,
                                coverage: this.parsePointer(u.coverage),
                                chainRuleSets: this.parseListOfLists(function() {
                                    return {
                                        backtrack: this.parseUShortList(),
                                        input: this.parseUShortList(this.parseShort() - 1),
                                        lookahead: this.parseUShortList(),
                                        lookupRecords: this.parseRecordList(s)
                                    };
                                })
                            } : 2 === t ? {
                                substFormat: 2,
                                coverage: this.parsePointer(u.coverage),
                                backtrackClassDef: this.parsePointer(u.classDef),
                                inputClassDef: this.parsePointer(u.classDef),
                                lookaheadClassDef: this.parsePointer(u.classDef),
                                chainClassSet: this.parseListOfLists(function() {
                                    return {
                                        backtrack: this.parseUShortList(),
                                        input: this.parseUShortList(this.parseShort() - 1),
                                        lookahead: this.parseUShortList(),
                                        lookupRecords: this.parseRecordList(s)
                                    };
                                })
                            } : 3 === t ? {
                                substFormat: 3,
                                backtrackCoverage: this.parseList(u.pointer(u.coverage)),
                                inputCoverage: this.parseList(u.pointer(u.coverage)),
                                lookaheadCoverage: this.parseList(u.pointer(u.coverage)),
                                lookupRecords: this.parseRecordList(s)
                            } : void L.assert(!1, "0x" + e1.toString(16) + ": lookup type 6 format must be 1, 2 or 3.");
                        }, o[7] = function() {
                            var e1 = this.parseUShort(), e1 = (L.argument(1 === e1, "GSUB Extension Substitution subtable identifier-format must be 1"), this.parseUShort()), t = new u(this.data, this.offset + this.parseULong());
                            return {
                                substFormat: 1,
                                lookupType: e1,
                                extension: o[e1].call(t)
                            };
                        }, o[8] = function() {
                            var e1 = this.parseUShort();
                            return L.argument(1 === e1, "GSUB Reverse Chaining Contextual Single Substitution Subtable identifier-format must be 1"), {
                                substFormat: e1,
                                coverage: this.parsePointer(u.coverage),
                                backtrackCoverage: this.parseList(u.pointer(u.coverage)),
                                lookaheadCoverage: this.parseList(u.pointer(u.coverage)),
                                substitutes: this.parseUShortList()
                            };
                        };
                        var mt = new Array(9);
                        mt[1] = function(e1) {
                            return 1 === e1.substFormat ? new S.Table("substitutionTable", [
                                {
                                    name: "substFormat",
                                    type: "USHORT",
                                    value: 1
                                },
                                {
                                    name: "coverage",
                                    type: "TABLE",
                                    value: new S.Coverage(e1.coverage)
                                },
                                {
                                    name: "deltaGlyphID",
                                    type: "USHORT",
                                    value: e1.deltaGlyphId
                                }
                            ]) : new S.Table("substitutionTable", [
                                {
                                    name: "substFormat",
                                    type: "USHORT",
                                    value: 2
                                },
                                {
                                    name: "coverage",
                                    type: "TABLE",
                                    value: new S.Coverage(e1.coverage)
                                }
                            ].concat(S.ushortList("substitute", e1.substitute)));
                        }, mt[3] = function(e1) {
                            return L.assert(1 === e1.substFormat, "Lookup type 3 substFormat must be 1."), new S.Table("substitutionTable", [
                                {
                                    name: "substFormat",
                                    type: "USHORT",
                                    value: 1
                                },
                                {
                                    name: "coverage",
                                    type: "TABLE",
                                    value: new S.Coverage(e1.coverage)
                                }
                            ].concat(S.tableList("altSet", e1.alternateSets, function(e1) {
                                return new S.Table("alternateSetTable", S.ushortList("alternate", e1));
                            })));
                        }, mt[4] = function(e1) {
                            return L.assert(1 === e1.substFormat, "Lookup type 4 substFormat must be 1."), new S.Table("substitutionTable", [
                                {
                                    name: "substFormat",
                                    type: "USHORT",
                                    value: 1
                                },
                                {
                                    name: "coverage",
                                    type: "TABLE",
                                    value: new S.Coverage(e1.coverage)
                                }
                            ].concat(S.tableList("ligSet", e1.ligatureSets, function(e1) {
                                return new S.Table("ligatureSetTable", S.tableList("ligature", e1, function(e1) {
                                    return new S.Table("ligatureTable", [
                                        {
                                            name: "ligGlyph",
                                            type: "USHORT",
                                            value: e1.ligGlyph
                                        }
                                    ].concat(S.ushortList("component", e1.components, e1.components.length + 1)));
                                }));
                            })));
                        };
                        var yt = {
                            parse: function(e1, t) {
                                return t = (e1 = new u(e1, t = t || 0)).parseVersion(1), L.argument(1 === t || 1.1 === t, "Unsupported GSUB table version."), 1 === t ? {
                                    version: t,
                                    scripts: e1.parseScriptList(),
                                    features: e1.parseFeatureList(),
                                    lookups: e1.parseLookupList(o)
                                } : {
                                    version: t,
                                    scripts: e1.parseScriptList(),
                                    features: e1.parseFeatureList(),
                                    lookups: e1.parseLookupList(o),
                                    variations: e1.parseFeatureVariationsList()
                                };
                            },
                            make: function(e1) {
                                return new S.Table("GSUB", [
                                    {
                                        name: "version",
                                        type: "ULONG",
                                        value: 65536
                                    },
                                    {
                                        name: "scripts",
                                        type: "TABLE",
                                        value: new S.ScriptList(e1.scripts)
                                    },
                                    {
                                        name: "features",
                                        type: "TABLE",
                                        value: new S.FeatureList(e1.features)
                                    },
                                    {
                                        name: "lookups",
                                        type: "TABLE",
                                        value: new S.LookupList(e1.lookups, mt)
                                    }
                                ]);
                            }
                        };
                        var gt = {
                            parse: function(e1, t) {
                                for(var r = new R.Parser(e1, t), o = r.parseULong(), n = (L.argument(1 === o, "Unsupported META table version."), r.parseULong(), r.parseULong(), r.parseULong()), s = {}, i = 0; i < n; i++){
                                    var a = r.parseTag(), l = r.parseULong(), u = r.parseULong(), l = m.UTF8(e1, t + l, u);
                                    s[a] = l;
                                }
                                return s;
                            },
                            make: function(e1) {
                                var t, r = Object.keys(e1).length, o = "", n = 16 + 12 * r, s = new S.Table("meta", [
                                    {
                                        name: "version",
                                        type: "ULONG",
                                        value: 1
                                    },
                                    {
                                        name: "flags",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "offset",
                                        type: "ULONG",
                                        value: n
                                    },
                                    {
                                        name: "numTags",
                                        type: "ULONG",
                                        value: r
                                    }
                                ]);
                                for(t in e1){
                                    var i = o.length;
                                    o += e1[t], s.fields.push({
                                        name: "tag " + t,
                                        type: "TAG",
                                        value: t
                                    }), s.fields.push({
                                        name: "offset " + t,
                                        type: "ULONG",
                                        value: n + i
                                    }), s.fields.push({
                                        name: "length " + t,
                                        type: "ULONG",
                                        value: e1[t].length
                                    });
                                }
                                return s.fields.push({
                                    name: "stringPool",
                                    type: "CHARARRAY",
                                    value: o
                                }), s;
                            }
                        };
                        function vt(e1) {
                            return Math.log(e1) / Math.log(2) | 0;
                        }
                        function bt(e1) {
                            for(; e1.length % 4 != 0;)e1.push(0);
                            for(var t = 0, r = 0; r < e1.length; r += 4)t += (e1[r] << 24) + (e1[r + 1] << 16) + (e1[r + 2] << 8) + e1[r + 3];
                            return t %= Math.pow(2, 32);
                        }
                        function jt(e1, t, r, o) {
                            return new S.Record("Table Record", [
                                {
                                    name: "tag",
                                    type: "TAG",
                                    value: void 0 !== e1 ? e1 : ""
                                },
                                {
                                    name: "checkSum",
                                    type: "ULONG",
                                    value: void 0 !== t ? t : 0
                                },
                                {
                                    name: "offset",
                                    type: "ULONG",
                                    value: void 0 !== r ? r : 0
                                },
                                {
                                    name: "length",
                                    type: "ULONG",
                                    value: void 0 !== o ? o : 0
                                }
                            ]);
                        }
                        function _t(e1) {
                            for(var t = new S.Table("sfnt", [
                                {
                                    name: "version",
                                    type: "TAG",
                                    value: "OTTO"
                                },
                                {
                                    name: "numTables",
                                    type: "USHORT",
                                    value: 0
                                },
                                {
                                    name: "searchRange",
                                    type: "USHORT",
                                    value: 0
                                },
                                {
                                    name: "entrySelector",
                                    type: "USHORT",
                                    value: 0
                                },
                                {
                                    name: "rangeShift",
                                    type: "USHORT",
                                    value: 0
                                }
                            ]), r = (t.tables = e1, t.numTables = e1.length, Math.pow(2, vt(t.numTables))), o = (t.searchRange = 16 * r, t.entrySelector = vt(r), t.rangeShift = 16 * t.numTables - t.searchRange, []), n = [], s = t.sizeOf() + jt().sizeOf() * t.numTables; s % 4 != 0;)s += 1, n.push({
                                name: "padding",
                                type: "BYTE",
                                value: 0
                            });
                            for(var i = 0; i < e1.length; i += 1){
                                var a = e1[i], l = (L.argument(4 === a.tableName.length, "Table name" + a.tableName + " is invalid."), a.sizeOf()), u = jt(a.tableName, bt(a.encode()), s, l);
                                for(o.push({
                                    name: u.tag + " Table Record",
                                    type: "RECORD",
                                    value: u
                                }), n.push({
                                    name: a.tableName + " table",
                                    type: "RECORD",
                                    value: a
                                }), s += l, L.argument(!isNaN(s), "Something went wrong calculating the offset."); s % 4 != 0;)s += 1, n.push({
                                    name: "padding",
                                    type: "BYTE",
                                    value: 0
                                });
                            }
                            return o.sort(function(e1, t) {
                                return e1.value.tag > t.value.tag ? 1 : -1;
                            }), t.fields = t.fields.concat(o), t.fields = t.fields.concat(n), t;
                        }
                        function xt(e1, t, r) {
                            for(var o = 0; o < t.length; o += 1){
                                var n = e1.charToGlyphIndex(t[o]);
                                if (0 < n) return e1.glyphs.get(n).getMetrics();
                            }
                            return r;
                        }
                        var wt = {
                            make: _t,
                            fontToTable: function(e1) {
                                for(var t, r = [], o = [], n = [], s = [], i = [], a = [], l = [], u = 0, c = 0, d = 0, h = 0, f = 0, p = 0; p < e1.glyphs.length; p += 1){
                                    var m = e1.glyphs.get(p), y = 0 | m.unicode;
                                    if (isNaN(m.advanceWidth)) throw new Error("Glyph " + m.name + " (" + p + "): advanceWidth is not a number.");
                                    (y < t || void 0 === t) && 0 < y && (t = y), u < y && (u = y);
                                    var y = ft.getUnicodeRange(y);
                                    if (y < 32) c |= 1 << y;
                                    else if (y < 64) d |= 1 << y - 32;
                                    else if (y < 96) h |= 1 << y - 64;
                                    else {
                                        if (!(y < 123)) throw new Error("Unicode ranges bits > 123 are reserved for internal usage");
                                        f |= 1 << y - 96;
                                    }
                                    ".notdef" !== m.name && (y = m.getMetrics(), r.push(y.xMin), o.push(y.yMin), n.push(y.xMax), s.push(y.yMax), a.push(y.leftSideBearing), l.push(y.rightSideBearing), i.push(m.advanceWidth));
                                }
                                var g, v = {
                                    xMin: Math.min.apply(null, r),
                                    yMin: Math.min.apply(null, o),
                                    xMax: Math.max.apply(null, n),
                                    yMax: Math.max.apply(null, s),
                                    advanceWidthMax: Math.max.apply(null, i),
                                    advanceWidthAvg: function(e1) {
                                        for(var t = 0, r = 0; r < e1.length; r += 1)t += e1[r];
                                        return t / e1.length;
                                    }(i),
                                    minLeftSideBearing: Math.min.apply(null, a),
                                    maxLeftSideBearing: Math.max.apply(null, a),
                                    minRightSideBearing: Math.min.apply(null, l)
                                }, b = (v.ascender = e1.ascender, v.descender = e1.descender, Ze.make({
                                    flags: 3,
                                    unitsPerEm: e1.unitsPerEm,
                                    xMin: v.xMin,
                                    yMin: v.yMin,
                                    xMax: v.xMax,
                                    yMax: v.yMax,
                                    lowestRecPPEM: 3,
                                    createdTimestamp: e1.createdTimestamp
                                })), j = Qe.make({
                                    ascender: v.ascender,
                                    descender: v.descender,
                                    advanceWidthMax: v.advanceWidthMax,
                                    minLeftSideBearing: v.minLeftSideBearing,
                                    minRightSideBearing: v.minRightSideBearing,
                                    xMaxExtent: v.maxLeftSideBearing + (v.xMax - v.xMin),
                                    numberOfHMetrics: e1.glyphs.length
                                }), _ = $e.make(e1.glyphs.length), x = ft.make({
                                    xAvgCharWidth: Math.round(v.advanceWidthAvg),
                                    usWeightClass: e1.tables.os2.usWeightClass,
                                    usWidthClass: e1.tables.os2.usWidthClass,
                                    usFirstCharIndex: t,
                                    usLastCharIndex: u,
                                    ulUnicodeRange1: c,
                                    ulUnicodeRange2: d,
                                    ulUnicodeRange3: h,
                                    ulUnicodeRange4: f,
                                    fsSelection: e1.tables.os2.fsSelection,
                                    sTypoAscender: v.ascender,
                                    sTypoDescender: v.descender,
                                    sTypoLineGap: 0,
                                    usWinAscent: v.yMax,
                                    usWinDescent: Math.abs(v.yMin),
                                    ulCodePageRange1: 1,
                                    sxHeight: xt(e1, "xyvw", {
                                        yMax: Math.round(v.ascender / 2)
                                    }).yMax,
                                    sCapHeight: xt(e1, "HIKLEFJMNTZBDPRAGOQSUVWXY", v).yMax,
                                    usDefaultChar: e1.hasChar(" ") ? 32 : 0,
                                    usBreakChar: e1.hasChar(" ") ? 32 : 0
                                }), w = Je.make(e1.glyphs), S = we.make(e1.glyphs), T = e1.getEnglishName("fontFamily"), M = e1.getEnglishName("fontSubfamily"), E = T + " " + M, k = (k = e1.getEnglishName("postScriptName")) || T.replace(/\s/g, "") + "-" + M, C = {};
                                for(g in e1.names)C[g] = e1.names[g];
                                C.uniqueID || (C.uniqueID = {
                                    en: e1.getEnglishName("manufacturer") + ":" + E
                                }), C.postScriptName || (C.postScriptName = {
                                    en: k
                                }), C.preferredFamily || (C.preferredFamily = e1.names.fontFamily), C.preferredSubfamily || (C.preferredSubfamily = e1.names.fontSubfamily);
                                var O = [], P = dt.make(C, O), O = 0 < O.length ? Ke.make(O) : void 0, A = pt.make(), E = Ye.make(e1.glyphs, {
                                    version: e1.getEnglishName("version"),
                                    fullName: E,
                                    familyName: T,
                                    weightName: M,
                                    postScriptName: k,
                                    unitsPerEm: e1.unitsPerEm,
                                    fontBBox: [
                                        0,
                                        v.yMin,
                                        v.ascender,
                                        v.advanceWidthMax
                                    ]
                                }), T = e1.metas && 0 < Object.keys(e1.metas).length ? gt.make(e1.metas) : void 0, M = [
                                    b,
                                    j,
                                    _,
                                    x,
                                    P,
                                    S,
                                    A,
                                    E,
                                    w
                                ];
                                O && M.push(O), e1.tables.gsub && M.push(yt.make(e1.tables.gsub)), T && M.push(T);
                                for(var D = bt((k = _t(M)).encode()), L = k.fields, R = !1, I = 0; I < L.length; I += 1)if ("head table" === L[I].name) {
                                    L[I].value.checkSumAdjustment = 2981146554 - D, R = !0;
                                    break;
                                }
                                if (R) return k;
                                throw new Error("Could not find head table with checkSum to adjust.");
                            },
                            computeCheckSum: bt
                        };
                        function St(e1, t) {
                            for(var r = 0, o = e1.length - 1; r <= o;){
                                var n = r + o >>> 1, s = e1[n].tag;
                                if (s === t) return n;
                                s < t ? r = 1 + n : o = n - 1;
                            }
                            return -r - 1;
                        }
                        function Tt(e1, t) {
                            for(var r = 0, o = e1.length - 1; r <= o;){
                                var n = r + o >>> 1, s = e1[n];
                                if (s === t) return n;
                                s < t ? r = 1 + n : o = n - 1;
                            }
                            return -r - 1;
                        }
                        function Mt(e1, t) {
                            for(var r = 0, o = e1.length - 1; r <= o;){
                                var n, s = r + o >>> 1, i = (n = e1[s]).start;
                                if (i === t) return n;
                                i < t ? r = 1 + s : o = s - 1;
                            }
                            if (0 < r) return t > (n = e1[r - 1]).end ? 0 : n;
                        }
                        function Et(e1, t) {
                            this.font = e1, this.tableName = t;
                        }
                        function kt(e1) {
                            Et.call(this, e1, "gpos");
                        }
                        function i(e1) {
                            Et.call(this, e1, "gsub");
                        }
                        function Ct(e1, t, r) {
                            for(var o = e1.subtables, n = 0; n < o.length; n++){
                                var s = o[n];
                                if (s.substFormat === t) return s;
                            }
                            if (r) return o.push(r), r;
                        }
                        function Ot(e1) {
                            for(var t = new ArrayBuffer(e1.length), r = new Uint8Array(t), o = 0; o < e1.length; ++o)r[o] = e1[o];
                            return t;
                        }
                        function _(e1, t) {
                            if (!e1) throw t;
                        }
                        function Pt(e1, t, r, o, n) {
                            var s = 0 < (t & o) ? (s = e1.parseByte(), r + (s = 0 == (t & n) ? -s : s)) : 0 < (t & n) ? r : r + e1.parseShort();
                            return s;
                        }
                        function At(e1, t, r) {
                            var o, n = new R.Parser(t, r);
                            if (e1.numberOfContours = n.parseShort(), e1._xMin = n.parseShort(), e1._yMin = n.parseShort(), e1._xMax = n.parseShort(), e1._yMax = n.parseShort(), 0 < e1.numberOfContours) {
                                for(var s = e1.endPointIndices = [], i = 0; i < e1.numberOfContours; i += 1)s.push(n.parseUShort());
                                e1.instructionLength = n.parseUShort(), e1.instructions = [];
                                for(var a = 0; a < e1.instructionLength; a += 1)e1.instructions.push(n.parseByte());
                                for(var l = s[s.length - 1] + 1, u = [], c = 0; c < l; c += 1)if (o = n.parseByte(), u.push(o), 0 < (8 & o)) for(var d = n.parseByte(), h = 0; h < d; h += 1)u.push(o), c += 1;
                                if (L.argument(u.length === l, "Bad flags."), 0 < s.length) {
                                    var f, p = [];
                                    if (0 < l) {
                                        for(var m = 0; m < l; m += 1)o = u[m], (f = {}).onCurve = !!(1 & o), f.lastPointOfContour = 0 <= s.indexOf(m), p.push(f);
                                        for(var y = 0, g = 0; g < l; g += 1)o = u[g], (f = p[g]).x = Pt(n, o, y, 2, 16), y = f.x;
                                        for(var v = 0, b = 0; b < l; b += 1)o = u[b], (f = p[b]).y = Pt(n, o, v, 4, 32), v = f.y;
                                    }
                                    e1.points = p;
                                } else e1.points = [];
                            } else if (0 === e1.numberOfContours) e1.points = [];
                            else {
                                e1.isComposite = !0, e1.points = [], e1.components = [];
                                for(var j = !0; j;){
                                    u = n.parseUShort();
                                    var _ = {
                                        glyphIndex: n.parseUShort(),
                                        xScale: 1,
                                        scale01: 0,
                                        scale10: 0,
                                        yScale: 1,
                                        dx: 0,
                                        dy: 0
                                    };
                                    0 < (1 & u) ? 0 < (2 & u) ? (_.dx = n.parseShort(), _.dy = n.parseShort()) : _.matchedPoints = [
                                        n.parseUShort(),
                                        n.parseUShort()
                                    ] : 0 < (2 & u) ? (_.dx = n.parseChar(), _.dy = n.parseChar()) : _.matchedPoints = [
                                        n.parseByte(),
                                        n.parseByte()
                                    ], 0 < (8 & u) ? _.xScale = _.yScale = n.parseF2Dot14() : 0 < (64 & u) ? (_.xScale = n.parseF2Dot14(), _.yScale = n.parseF2Dot14()) : 0 < (128 & u) && (_.xScale = n.parseF2Dot14(), _.scale01 = n.parseF2Dot14(), _.scale10 = n.parseF2Dot14(), _.yScale = n.parseF2Dot14()), e1.components.push(_), j = !!(32 & u);
                                }
                                if (256 & u) {
                                    e1.instructionLength = n.parseUShort(), e1.instructions = [];
                                    for(var x = 0; x < e1.instructionLength; x += 1)e1.instructions.push(n.parseByte());
                                }
                            }
                        }
                        function Lt(e1, t) {
                            for(var r = [], o = 0; o < e1.length; o += 1){
                                var n = e1[o], n = {
                                    x: t.xScale * n.x + t.scale01 * n.y + t.dx,
                                    y: t.scale10 * n.x + t.yScale * n.y + t.dy,
                                    onCurve: n.onCurve,
                                    lastPointOfContour: n.lastPointOfContour
                                };
                                r.push(n);
                            }
                            return r;
                        }
                        function Rt(e1) {
                            var t = new h;
                            if (e1) for(var r = function(e1) {
                                for(var t = [], r = [], o = 0; o < e1.length; o += 1){
                                    var n = e1[o];
                                    r.push(n), n.lastPointOfContour && (t.push(r), r = []);
                                }
                                return L.argument(0 === r.length, "There are still points left in the current contour."), t;
                            }(e1), o = 0; o < r.length; ++o){
                                var n, s = r[o], i = s[s.length - 1], a = s[0];
                                i.onCurve ? t.moveTo(i.x, i.y) : a.onCurve ? t.moveTo(a.x, a.y) : (n = {
                                    x: .5 * (i.x + a.x),
                                    y: .5 * (i.y + a.y)
                                }, t.moveTo(n.x, n.y));
                                for(var l = 0; l < s.length; ++l){
                                    var u, c = i, i = a, a = s[(l + 1) % s.length];
                                    i.onCurve ? t.lineTo(i.x, i.y) : (u = a, c.onCurve || (i.x, c.x, i.y, c.y), a.onCurve || (u = {
                                        x: .5 * (i.x + a.x),
                                        y: .5 * (i.y + a.y)
                                    }), t.quadraticCurveTo(i.x, i.y, u.x, u.y));
                                }
                                t.closePath();
                            }
                            return t;
                        }
                        function It(e1, t) {
                            if (t.isComposite) for(var r = 0; r < t.components.length; r += 1){
                                var o = t.components[r], n = e1.get(o.glyphIndex);
                                if (n.getPath(), n.points) {
                                    var s = void 0;
                                    if (void 0 === o.matchedPoints) s = Lt(n.points, o);
                                    else {
                                        if (o.matchedPoints[0] > t.points.length - 1 || o.matchedPoints[1] > n.points.length - 1) throw Error("Matched points out of range in " + t.name);
                                        var i = t.points[o.matchedPoints[0]], a = n.points[o.matchedPoints[1]], o = {
                                            xScale: o.xScale,
                                            scale01: o.scale01,
                                            scale10: o.scale10,
                                            yScale: o.yScale,
                                            dx: 0,
                                            dy: 0
                                        }, a = Lt([
                                            a
                                        ], o)[0];
                                        o.dx = i.x - a.x, o.dy = i.y - a.y, s = Lt(n.points, o);
                                    }
                                    t.points = t.points.concat(s);
                                }
                            }
                            return Rt(t.points);
                        }
                        (kt.prototype = Et.prototype = {
                            searchTag: St,
                            binSearch: Tt,
                            getTable: function(e1) {
                                var t = this.font.tables[this.tableName];
                                return t = !t && e1 ? this.font.tables[this.tableName] = this.createDefaultTable() : t;
                            },
                            getScriptNames: function() {
                                var e1 = this.getTable();
                                return e1 ? e1.scripts.map(function(e1) {
                                    return e1.tag;
                                }) : [];
                            },
                            getDefaultScriptName: function() {
                                var e1 = this.getTable();
                                if (e1) {
                                    for(var t = !1, r = 0; r < e1.scripts.length; r++){
                                        var o = e1.scripts[r].tag;
                                        if ("DFLT" === o) return o;
                                        "latn" === o && (t = !0);
                                    }
                                    return t ? "latn" : void 0;
                                }
                            },
                            getScriptTable: function(e1, t) {
                                var r, o = this.getTable(t);
                                if (o) return r = o.scripts, 0 <= (o = St(o.scripts, e1 = e1 || "DFLT")) ? r[o].script : t ? (r.splice(-1 - o, 0, t = {
                                    tag: e1,
                                    script: {
                                        defaultLangSys: {
                                            reserved: 0,
                                            reqFeatureIndex: 65535,
                                            featureIndexes: []
                                        },
                                        langSysRecords: []
                                    }
                                }), t.script) : void 0;
                            },
                            getLangSysTable: function(e1, t, r) {
                                var o, e1 = this.getScriptTable(e1, r);
                                if (e1) return t && "dflt" !== t && "DFLT" !== t ? 0 <= (o = St(e1.langSysRecords, t)) ? e1.langSysRecords[o].langSys : r ? (e1.langSysRecords.splice(-1 - o, 0, r = {
                                    tag: t,
                                    langSys: {
                                        reserved: 0,
                                        reqFeatureIndex: 65535,
                                        featureIndexes: []
                                    }
                                }), r.langSys) : void 0 : e1.defaultLangSys;
                            },
                            getFeatureTable: function(e1, t, r, o) {
                                e1 = this.getLangSysTable(e1, t, o);
                                if (e1) {
                                    for(var n, s = e1.featureIndexes, i = this.font.tables[this.tableName].features, a = 0; a < s.length; a++)if ((n = i[s[a]]).tag === r) return n.feature;
                                    if (o) return t = i.length, L.assert(0 === t || r >= i[t - 1].tag, "Features must be added in alphabetical order."), i.push(n = {
                                        tag: r,
                                        feature: {
                                            params: 0,
                                            lookupListIndexes: []
                                        }
                                    }), s.push(t), n.feature;
                                }
                            },
                            getLookupTables: function(e1, t, r, o, n) {
                                var e1 = this.getFeatureTable(e1, t, r, n), s = [];
                                if (e1) {
                                    for(var i, a = e1.lookupListIndexes, l = this.font.tables[this.tableName].lookups, u = 0; u < a.length; u++)(i = l[a[u]]).lookupType === o && s.push(i);
                                    if (0 === s.length && n) return t = l.length, l.push(i = {
                                        lookupType: o,
                                        lookupFlag: 0,
                                        subtables: [],
                                        markFilteringSet: void 0
                                    }), a.push(t), [
                                        i
                                    ];
                                }
                                return s;
                            },
                            getGlyphClass: function(e1, t) {
                                switch(e1.format){
                                    case 1:
                                        return e1.startGlyph <= t && t < e1.startGlyph + e1.classes.length ? e1.classes[t - e1.startGlyph] : 0;
                                    case 2:
                                        var r = Mt(e1.ranges, t);
                                        return r ? r.classId : 0;
                                }
                            },
                            getCoverageIndex: function(e1, t) {
                                switch(e1.format){
                                    case 1:
                                        var r = Tt(e1.glyphs, t);
                                        return 0 <= r ? r : -1;
                                    case 2:
                                        r = Mt(e1.ranges, t);
                                        return r ? r.index + t - r.start : -1;
                                }
                            },
                            expandCoverage: function(e1) {
                                if (1 === e1.format) return e1.glyphs;
                                for(var t = [], r = e1.ranges, o = 0; o < r.length; o++)for(var n = r[o], s = n.start, i = n.end, a = s; a <= i; a++)t.push(a);
                                return t;
                            }
                        }).init = function() {
                            var e1 = this.getDefaultScriptName();
                            this.defaultKerningTables = this.getKerningTables(e1);
                        }, kt.prototype.getKerningValue = function(e1, t, r) {
                            for(var o = 0; o < e1.length; o++)for(var n = e1[o].subtables, s = 0; s < n.length; s++){
                                var i = n[s], a = this.getCoverageIndex(i.coverage, t);
                                if (!(a < 0)) switch(i.posFormat){
                                    case 1:
                                        for(var l = i.pairSets[a], u = 0; u < l.length; u++){
                                            var c = l[u];
                                            if (c.secondGlyph === r) return c.value1 && c.value1.xAdvance || 0;
                                        }
                                        break;
                                    case 2:
                                        var d = this.getGlyphClass(i.classDef1, t), h = this.getGlyphClass(i.classDef2, r), d = i.classRecords[d][h];
                                        return d.value1 && d.value1.xAdvance || 0;
                                }
                            }
                            return 0;
                        }, kt.prototype.getKerningTables = function(e1, t) {
                            if (this.font.tables.gpos) return this.getLookupTables(e1, t, "kern", 2);
                        }, (i.prototype = Et.prototype).createDefaultTable = function() {
                            return {
                                version: 1,
                                scripts: [
                                    {
                                        tag: "DFLT",
                                        script: {
                                            defaultLangSys: {
                                                reserved: 0,
                                                reqFeatureIndex: 65535,
                                                featureIndexes: []
                                            },
                                            langSysRecords: []
                                        }
                                    }
                                ],
                                features: [],
                                lookups: []
                            };
                        }, i.prototype.getSingle = function(e1, t, r) {
                            for(var o = [], n = this.getLookupTables(t, r, e1, 1), s = 0; s < n.length; s++)for(var i = n[s].subtables, a = 0; a < i.length; a++){
                                var l = i[a], u = this.expandCoverage(l.coverage), c = void 0;
                                if (1 === l.substFormat) for(var d = l.deltaGlyphId, c = 0; c < u.length; c++){
                                    var h = u[c];
                                    o.push({
                                        sub: h,
                                        by: h + d
                                    });
                                }
                                else {
                                    var f = l.substitute;
                                    for(c = 0; c < u.length; c++)o.push({
                                        sub: u[c],
                                        by: f[c]
                                    });
                                }
                            }
                            return o;
                        }, i.prototype.getAlternates = function(e1, t, r) {
                            for(var o = [], n = this.getLookupTables(t, r, e1, 3), s = 0; s < n.length; s++)for(var i = n[s].subtables, a = 0; a < i.length; a++)for(var l = i[a], u = this.expandCoverage(l.coverage), c = l.alternateSets, d = 0; d < u.length; d++)o.push({
                                sub: u[d],
                                by: c[d]
                            });
                            return o;
                        }, i.prototype.getLigatures = function(e1, t, r) {
                            for(var o = [], n = this.getLookupTables(t, r, e1, 4), s = 0; s < n.length; s++)for(var i = n[s].subtables, a = 0; a < i.length; a++)for(var l = i[a], u = this.expandCoverage(l.coverage), c = l.ligatureSets, d = 0; d < u.length; d++)for(var h = u[d], f = c[d], p = 0; p < f.length; p++){
                                var m = f[p];
                                o.push({
                                    sub: [
                                        h
                                    ].concat(m.components),
                                    by: m.ligGlyph
                                });
                            }
                            return o;
                        }, i.prototype.addSingle = function(e1, t, r, o) {
                            r = Ct(this.getLookupTables(r, o, e1, 1, !0)[0], 2, {
                                substFormat: 2,
                                coverage: {
                                    format: 1,
                                    glyphs: []
                                },
                                substitute: []
                            }), L.assert(1 === r.coverage.format, "Ligature: unable to modify coverage table format " + r.coverage.format), o = t.sub, e1 = this.binSearch(r.coverage.glyphs, o);
                            e1 < 0 && (r.coverage.glyphs.splice(e1 = -1 - e1, 0, o), r.substitute.splice(e1, 0, 0)), r.substitute[e1] = t.by;
                        }, i.prototype.addAlternate = function(e1, t, r, o) {
                            r = Ct(this.getLookupTables(r, o, e1, 3, !0)[0], 1, {
                                substFormat: 1,
                                coverage: {
                                    format: 1,
                                    glyphs: []
                                },
                                alternateSets: []
                            }), L.assert(1 === r.coverage.format, "Ligature: unable to modify coverage table format " + r.coverage.format), o = t.sub, e1 = this.binSearch(r.coverage.glyphs, o);
                            e1 < 0 && (r.coverage.glyphs.splice(e1 = -1 - e1, 0, o), r.alternateSets.splice(e1, 0, 0)), r.alternateSets[e1] = t.by;
                        }, i.prototype.addLigature = function(e1, t, r, o) {
                            var r = this.getLookupTables(r, o, e1, 4, !0)[0], o = r.subtables[0], e1 = (o || (r.subtables[0] = o = {
                                substFormat: 1,
                                coverage: {
                                    format: 1,
                                    glyphs: []
                                },
                                ligatureSets: []
                            }), L.assert(1 === o.coverage.format, "Ligature: unable to modify coverage table format " + o.coverage.format), t.sub[0]), n = t.sub.slice(1), r = {
                                ligGlyph: t.by,
                                components: n
                            }, t = this.binSearch(o.coverage.glyphs, e1);
                            if (0 <= t) {
                                for(var s = o.ligatureSets[t], i = 0; i < s.length; i++)if (function(e1, t) {
                                    var r = e1.length;
                                    if (r === t.length) {
                                        for(var o = 0; o < r; o++)if (e1[o] !== t[o]) return;
                                        return 1;
                                    }
                                }(s[i].components, n)) return;
                                s.push(r);
                            } else o.coverage.glyphs.splice(t = -1 - t, 0, e1), o.ligatureSets.splice(t, 0, [
                                r
                            ]);
                        }, i.prototype.getFeature = function(e1, t, r) {
                            if (/ss\d\d/.test(e1)) return this.getSingle(e1, t, r);
                            switch(e1){
                                case "aalt":
                                case "salt":
                                    return this.getSingle(e1, t, r).concat(this.getAlternates(e1, t, r));
                                case "dlig":
                                case "liga":
                                case "rlig":
                                    return this.getLigatures(e1, t, r);
                            }
                        }, i.prototype.add = function(e1, t, r, o) {
                            if (/ss\d\d/.test(e1)) return this.addSingle(e1, t, r, o);
                            switch(e1){
                                case "aalt":
                                case "salt":
                                    return "number" == typeof t.by ? this.addSingle(e1, t, r, o) : this.addAlternate(e1, t, r, o);
                                case "dlig":
                                case "liga":
                                case "rlig":
                                    return this.addLigature(e1, t, r, o);
                            }
                        };
                        var Dt = {
                            getPath: Rt,
                            parse: function(e1, t, r, o) {
                                for(var n = new p.GlyphSet(o), s = 0; s < r.length - 1; s += 1){
                                    var i = r[s];
                                    i !== r[s + 1] ? n.push(s, p.ttfGlyphLoader(o, s, At, e1, t + i, It)) : n.push(s, p.glyphLoader(o, s));
                                }
                                return n;
                            }
                        };
                        function Ft(e1) {
                            this.font = e1, this.getCommands = function(e1) {
                                return Dt.getPath(e1).commands;
                            }, this._fpgmState = this._prepState = void 0, this._errorState = 0;
                        }
                        function Ut(e1) {
                            return e1;
                        }
                        function Nt(e1) {
                            return Math.sign(e1) * Math.round(Math.abs(e1));
                        }
                        function Bt(e1) {
                            return Math.sign(e1) * Math.round(Math.abs(2 * e1)) / 2;
                        }
                        function Gt(e1) {
                            return Math.sign(e1) * (Math.round(Math.abs(e1) + .5) - .5);
                        }
                        function Vt(e1) {
                            return Math.sign(e1) * Math.ceil(Math.abs(e1));
                        }
                        function zt(e1) {
                            return Math.sign(e1) * Math.floor(Math.abs(e1));
                        }
                        function Ht(e1) {
                            var t = this.srPeriod, r = this.srPhase, o = 1;
                            return e1 < 0 && (e1 = -e1, o = -1), e1 += this.srThreshold - r, e1 = Math.trunc(e1 / t) * t, (e1 += r) < 0 ? r * o : e1 * o;
                        }
                        var x = {
                            x: 1,
                            y: 0,
                            axis: "x",
                            distance: function(e1, t, r, o) {
                                return (r ? e1.xo : e1.x) - (o ? t.xo : t.x);
                            },
                            interpolate: function(e1, t, r, o) {
                                var n, s, i, a, l, u, c;
                                if (!o || o === this) return n = e1.xo - t.xo, s = e1.xo - r.xo, l = t.x - t.xo, u = r.x - r.xo, 0 === (c = (i = Math.abs(n)) + (a = Math.abs(s))) ? void (e1.x = e1.xo + (l + u) / 2) : void (e1.x = e1.xo + (l * a + u * i) / c);
                                n = o.distance(e1, t, !0, !0), s = o.distance(e1, r, !0, !0), l = o.distance(t, t, !1, !0), u = o.distance(r, r, !1, !0), 0 === (c = (i = Math.abs(n)) + (a = Math.abs(s))) ? x.setRelative(e1, e1, (l + u) / 2, o, !0) : x.setRelative(e1, e1, (l * a + u * i) / c, o, !0);
                            },
                            normalSlope: Number.NEGATIVE_INFINITY,
                            setRelative: function(e1, t, r, o, n) {
                                var s, i;
                                o && o !== this ? (s = n ? t.xo : t.x, i = n ? t.yo : t.y, s += r * o.x, i += r * o.y, e1.x = s + (e1.y - i) / o.normalSlope) : e1.x = (n ? t.xo : t.x) + r;
                            },
                            slope: 0,
                            touch: function(e1) {
                                e1.xTouched = !0;
                            },
                            touched: function(e1) {
                                return e1.xTouched;
                            },
                            untouch: function(e1) {
                                e1.xTouched = !1;
                            }
                        }, T = {
                            x: 0,
                            y: 1,
                            axis: "y",
                            distance: function(e1, t, r, o) {
                                return (r ? e1.yo : e1.y) - (o ? t.yo : t.y);
                            },
                            interpolate: function(e1, t, r, o) {
                                var n, s, i, a, l, u, c;
                                if (!o || o === this) return n = e1.yo - t.yo, s = e1.yo - r.yo, l = t.y - t.yo, u = r.y - r.yo, 0 === (c = (i = Math.abs(n)) + (a = Math.abs(s))) ? void (e1.y = e1.yo + (l + u) / 2) : void (e1.y = e1.yo + (l * a + u * i) / c);
                                n = o.distance(e1, t, !0, !0), s = o.distance(e1, r, !0, !0), l = o.distance(t, t, !1, !0), u = o.distance(r, r, !1, !0), 0 === (c = (i = Math.abs(n)) + (a = Math.abs(s))) ? T.setRelative(e1, e1, (l + u) / 2, o, !0) : T.setRelative(e1, e1, (l * a + u * i) / c, o, !0);
                            },
                            normalSlope: 0,
                            setRelative: function(e1, t, r, o, n) {
                                var s, i;
                                o && o !== this ? (s = n ? t.xo : t.x, i = n ? t.yo : t.y, s += r * o.x, i += r * o.y, e1.y = i + o.normalSlope * (e1.x - s)) : e1.y = (n ? t.yo : t.y) + r;
                            },
                            slope: Number.POSITIVE_INFINITY,
                            touch: function(e1) {
                                e1.yTouched = !0;
                            },
                            touched: function(e1) {
                                return e1.yTouched;
                            },
                            untouch: function(e1) {
                                e1.yTouched = !1;
                            }
                        };
                        function Wt(e1, t) {
                            this.x = e1, this.y = t, this.axis = void 0, this.slope = t / e1, this.normalSlope = -e1 / t, Object.freeze(this);
                        }
                        function qt(e1, t) {
                            var r = Math.sqrt(e1 * e1 + t * t);
                            return t /= r, 1 === (e1 /= r) && 0 === t ? x : 0 === e1 && 1 === t ? T : new Wt(e1, t);
                        }
                        function M(e1, t, r, o) {
                            this.x = this.xo = Math.round(64 * e1) / 64, this.y = this.yo = Math.round(64 * t) / 64, this.lastPointOfContour = r, this.onCurve = o, this.prevPointOnContour = void 0, this.nextPointOnContour = void 0, this.xTouched = !1, this.yTouched = !1, Object.preventExtensions(this);
                        }
                        Object.freeze(x), Object.freeze(T), Wt.prototype.distance = function(e1, t, r, o) {
                            return this.x * x.distance(e1, t, r, o) + this.y * T.distance(e1, t, r, o);
                        }, Wt.prototype.interpolate = function(e1, t, r, o) {
                            var n = o.distance(e1, t, !0, !0), s = o.distance(e1, r, !0, !0), t = o.distance(t, t, !1, !0), r = o.distance(r, r, !1, !0), n = Math.abs(n), s = Math.abs(s), i = n + s;
                            0 === i ? this.setRelative(e1, e1, (t + r) / 2, o, !0) : this.setRelative(e1, e1, (t * s + r * n) / i, o, !0);
                        }, Wt.prototype.setRelative = function(e1, t, r, o, n) {
                            var s = n ? t.xo : t.x, n = n ? t.yo : t.y, t = s + r * (o = o || this).x, s = n + r * o.y, n = o.normalSlope, r = this.slope, o = e1.x, i = e1.y;
                            e1.x = (r * o - n * t + s - i) / (r - n), e1.y = r * (e1.x - o) + i;
                        }, Wt.prototype.touch = function(e1) {
                            e1.xTouched = !0, e1.yTouched = !0;
                        }, M.prototype.nextTouched = function(e1) {
                            for(var t = this.nextPointOnContour; !e1.touched(t) && t !== this;)t = t.nextPointOnContour;
                            return t;
                        }, M.prototype.prevTouched = function(e1) {
                            for(var t = this.prevPointOnContour; !e1.touched(t) && t !== this;)t = t.prevPointOnContour;
                            return t;
                        };
                        var Xt = Object.freeze(new M(0, 0)), Yt = {
                            cvCutIn: 17 / 16,
                            deltaBase: 9,
                            deltaShift: .125,
                            loop: 1,
                            minDis: 1,
                            autoFlip: !0
                        };
                        function E(e1, t) {
                            switch(this.env = e1, this.stack = [], this.prog = t, e1){
                                case "glyf":
                                    this.zp0 = this.zp1 = this.zp2 = 1, this.rp0 = this.rp1 = this.rp2 = 0;
                                case "prep":
                                    this.fv = this.pv = this.dpv = x, this.round = Nt;
                            }
                        }
                        function Zt(e1) {
                            for(var t = e1.tZone = new Array(e1.gZone.length), r = 0; r < t.length; r++)t[r] = new M(0, 0);
                        }
                        function Qt(e1, t) {
                            var r, o = e1.prog, n = e1.ip, s = 1;
                            do {
                                if (88 === (r = o[++n])) s++;
                                else if (89 === r) s--;
                                else if (64 === r) n += o[n + 1] + 1;
                                else if (65 === r) n += 2 * o[n + 1] + 1;
                                else if (176 <= r && r <= 183) n += r - 176 + 1;
                                else if (184 <= r && r <= 191) n += 2 * (r - 184 + 1);
                                else if (t && 1 === s && 27 === r) break;
                            }while (0 < s);
                            e1.ip = n;
                        }
                        function Jt(e1, t) {
                            j.DEBUG && console.log(t.step, "SVTCA[" + e1.axis + "]"), t.fv = t.pv = t.dpv = e1;
                        }
                        function Kt(e1, t) {
                            j.DEBUG && console.log(t.step, "SPVTCA[" + e1.axis + "]"), t.pv = t.dpv = e1;
                        }
                        function $t(e1, t) {
                            j.DEBUG && console.log(t.step, "SFVTCA[" + e1.axis + "]"), t.fv = e1;
                        }
                        function er(e1, t) {
                            var r, o = t.stack, n = o.pop(), o = o.pop(), s = t.z2[n], i = t.z1[o];
                            j.DEBUG && console.log("SPVTL[" + e1 + "]", n, o), n = e1 ? (r = s.y - i.y, i.x - s.x) : (r = i.x - s.x, i.y - s.y), t.pv = t.dpv = qt(r, n);
                        }
                        function tr(e1, t) {
                            var r, o = t.stack, n = o.pop(), o = o.pop(), s = t.z2[n], i = t.z1[o];
                            j.DEBUG && console.log("SFVTL[" + e1 + "]", n, o), n = e1 ? (r = s.y - i.y, i.x - s.x) : (r = i.x - s.x, i.y - s.y), t.fv = qt(r, n);
                        }
                        function rr(e1) {
                            j.DEBUG && console.log(e1.step, "POP[]"), e1.stack.pop();
                        }
                        function or(e1, t) {
                            var r = t.stack.pop(), o = t.z0[r], n = t.fv, s = t.pv, i = (j.DEBUG && console.log(t.step, "MDAP[" + e1 + "]", r), s.distance(o, Xt));
                            e1 && (i = t.round(i)), n.setRelative(o, Xt, i, s), n.touch(o), t.rp0 = t.rp1 = r;
                        }
                        function nr(e1, t) {
                            var r, o, n, s = t.z2, i = s.length - 2;
                            j.DEBUG && console.log(t.step, "IUP[" + e1.axis + "]");
                            for(var a = 0; a < i; a++)r = s[a], e1.touched(r) || (o = r.prevTouched(e1)) !== r && (o === (n = r.nextTouched(e1)) && e1.setRelative(r, r, e1.distance(o, o, !1, !0), e1, !0), e1.interpolate(r, o, n, e1));
                        }
                        function sr(e1, t) {
                            for(var r = t.stack, o = e1 ? t.rp1 : t.rp2, n = (e1 ? t.z0 : t.z1)[o], s = t.fv, i = t.pv, a = t.loop, l = t.z2; a--;){
                                var u = r.pop(), c = l[u], d = i.distance(n, n, !1, !0);
                                s.setRelative(c, c, d, i), s.touch(c), j.DEBUG && console.log(t.step, (1 < t.loop ? "loop " + (t.loop - a) + ": " : "") + "SHP[" + (e1 ? "rp1" : "rp2") + "]", u);
                            }
                            t.loop = 1;
                        }
                        function ir(e1, t) {
                            for(var r = t.stack, o = e1 ? t.rp1 : t.rp2, n = (e1 ? t.z0 : t.z1)[o], s = t.fv, i = t.pv, o = r.pop(), a = t.z2[t.contours[o]], l = a, u = (j.DEBUG && console.log(t.step, "SHC[" + e1 + "]", o), i.distance(n, n, !1, !0)); l !== n && s.setRelative(l, l, u, i), (l = l.nextPointOnContour) !== a;);
                        }
                        function ar(e1, t) {
                            var r, o, n = t.stack, s = e1 ? t.rp1 : t.rp2, s = (e1 ? t.z0 : t.z1)[s], i = t.fv, a = t.pv, n = n.pop();
                            switch(j.DEBUG && console.log(t.step, "SHZ[" + e1 + "]", n), n){
                                case 0:
                                    r = t.tZone;
                                    break;
                                case 1:
                                    r = t.gZone;
                                    break;
                                default:
                                    throw new Error("Invalid zone");
                            }
                            for(var l = a.distance(s, s, !1, !0), u = r.length - 2, c = 0; c < u; c++)o = r[c], i.setRelative(o, o, l, a);
                        }
                        function lr(e1, t) {
                            var r = t.stack, o = r.pop() / 64, r = r.pop(), n = t.z1[r], s = t.z0[t.rp0], i = t.fv, a = t.pv;
                            i.setRelative(n, s, o, a), i.touch(n), j.DEBUG && console.log(t.step, "MSIRP[" + e1 + "]", o, r), t.rp1 = t.rp0, t.rp2 = r, e1 && (t.rp0 = r);
                        }
                        function ur(e1, t) {
                            var r = t.stack, o = r.pop(), r = r.pop(), n = t.z0[r], s = t.fv, i = t.pv, a = t.cvt[o], o = (j.DEBUG && console.log(t.step, "MIAP[" + e1 + "]", o, "(", a, ")", r), i.distance(n, Xt));
                            e1 && (Math.abs(o - a) < t.cvCutIn && (o = a), o = t.round(o)), s.setRelative(n, Xt, o, i), 0 === t.zp0 && (n.xo = n.x, n.yo = n.y), s.touch(n), t.rp0 = t.rp1 = r;
                        }
                        function cr(e1, t) {
                            var r = t.stack, o = r.pop(), n = t.z2[o];
                            j.DEBUG && console.log(t.step, "GC[" + e1 + "]", o), r.push(64 * t.dpv.distance(n, Xt, e1, !1));
                        }
                        function dr(e1, t) {
                            var r = t.stack, o = r.pop(), r = r.pop(), n = t.z1[o], s = t.z0[r], s = t.dpv.distance(s, n, e1, e1);
                            j.DEBUG && console.log(t.step, "MD[" + e1 + "]", o, r, "->", s), t.stack.push(Math.round(64 * s));
                        }
                        function hr(e1, t) {
                            var r = t.stack, o = r.pop(), n = t.fv, s = t.pv, i = t.ppem, a = t.deltaBase + 16 * (e1 - 1), l = t.deltaShift, u = t.z0;
                            j.DEBUG && console.log(t.step, "DELTAP[" + e1 + "]", o, r);
                            for(var c = 0; c < o; c++){
                                var d = r.pop(), h = r.pop();
                                a + ((240 & h) >> 4) === i && (0 <= (h = (15 & h) - 8) && h++, j.DEBUG && console.log(t.step, "DELTAPFIX", d, "by", h * l), d = u[d], n.setRelative(d, d, h * l, s));
                            }
                        }
                        function fr(e1, t) {
                            var r = t.stack, o = r.pop();
                            j.DEBUG && console.log(t.step, "ROUND[]"), r.push(64 * t.round(o / 64));
                        }
                        function pr(e1, t) {
                            var r = t.stack, o = r.pop(), n = t.ppem, s = t.deltaBase + 16 * (e1 - 1), i = t.deltaShift;
                            j.DEBUG && console.log(t.step, "DELTAC[" + e1 + "]", o, r);
                            for(var a = 0; a < o; a++){
                                var l = r.pop(), u = r.pop();
                                s + ((240 & u) >> 4) === n && (0 <= (u = (15 & u) - 8) && u++, u = u * i, j.DEBUG && console.log(t.step, "DELTACFIX", l, "by", u), t.cvt[l] += u);
                            }
                        }
                        function mr(e1, t) {
                            var r, o = t.stack, n = o.pop(), o = o.pop(), s = t.z2[n], i = t.z1[o];
                            j.DEBUG && console.log(t.step, "SDPVTL[" + e1 + "]", n, o), n = e1 ? (r = s.y - i.y, i.x - s.x) : (r = i.x - s.x, i.y - s.y), t.dpv = qt(r, n);
                        }
                        function k(e1, t) {
                            var r = t.stack, o = t.prog, n = t.ip;
                            j.DEBUG && console.log(t.step, "PUSHB[" + e1 + "]");
                            for(var s = 0; s < e1; s++)r.push(o[++n]);
                            t.ip = n;
                        }
                        function C(e1, t) {
                            var r = t.ip, o = t.prog, n = t.stack;
                            j.DEBUG && console.log(t.ip, "PUSHW[" + e1 + "]");
                            for(var s = 0; s < e1; s++){
                                var i = o[++r] << 8 | o[++r];
                                32768 & i && (i = -(1 + (65535 ^ i))), n.push(i);
                            }
                            t.ip = r;
                        }
                        function O(e1, t, r, o, n, s) {
                            var i, a, l = s.stack, u = e1 && l.pop(), l = l.pop(), c = s.rp0, c = s.z0[c], d = s.z1[l], h = s.minDis, f = s.fv, p = s.dpv, m = i = p.distance(d, c, !0, !0), y = 0 <= m ? 1 : -1;
                            m = Math.abs(m), e1 && (a = s.cvt[u], o && Math.abs(m - a) < s.cvCutIn && (m = a)), r && m < h && (m = h), o && (m = s.round(m)), f.setRelative(d, c, y * m, p), f.touch(d), j.DEBUG && console.log(s.step, (e1 ? "MIRP[" : "MDRP[") + (t ? "M" : "m") + (r ? ">" : "_") + (o ? "R" : "_") + (0 === n ? "Gr" : 1 === n ? "Bl" : 2 === n ? "Wh" : "") + "]", e1 ? u + "(" + s.cvt[u] + "," + a + ")" : "", l, "(d =", i, "->", y * m, ")"), s.rp1 = s.rp0, s.rp2 = l, t && (s.rp0 = l);
                        }
                        Ft.prototype.exec = function(e1, t) {
                            if ("number" != typeof t) throw new Error("Point size is not a number!");
                            if (!(2 < this._errorState)) {
                                var r = this.font, o = this._prepState;
                                if (!o || o.ppem !== t) {
                                    var n = this._fpgmState;
                                    if (!n) {
                                        E.prototype = Yt, (n = this._fpgmState = new E("fpgm", r.tables.fpgm)).funcs = [], n.font = r, j.DEBUG && (console.log("---EXEC FPGM---"), n.step = -1);
                                        try {
                                            vr(n);
                                        } catch (e1) {
                                            return console.log("Hinting error in FPGM:" + e1), void (this._errorState = 3);
                                        }
                                    }
                                    E.prototype = n, (o = this._prepState = new E("prep", r.tables.prep)).ppem = t;
                                    var s = r.tables.cvt;
                                    if (s) for(var i = o.cvt = new Array(s.length), a = t / r.unitsPerEm, l = 0; l < s.length; l++)i[l] = s[l] * a;
                                    else o.cvt = [];
                                    j.DEBUG && (console.log("---EXEC PREP---"), o.step = -1);
                                    try {
                                        vr(o);
                                    } catch (e1) {
                                        this._errorState < 2 && console.log("Hinting error in PREP:" + e1), this._errorState = 2;
                                    }
                                }
                                if (!(1 < this._errorState)) try {
                                    return yr(e1, o);
                                } catch (e1) {
                                    this._errorState < 1 && (console.log("Hinting error:" + e1), console.log("Note: further hinting errors are silenced")), this._errorState = 1;
                                }
                            }
                        };
                        var yr = function(e1, t) {
                            var r = t.ppem / t.font.unitsPerEm, o = r, n = e1.components;
                            if (E.prototype = t, n) {
                                for(var s = t.font, i = [], a = [], l = 0; l < n.length; l++){
                                    var u = n[l], c = s.glyphs.get(u.glyphIndex), d = new E("glyf", c.instructions);
                                    j.DEBUG && (console.log("---EXEC COMP " + l + "---"), d.step = -1), gr(c, d, r, o);
                                    for(var h = Math.round(u.dx * r), f = Math.round(u.dy * o), p = d.gZone, m = d.contours, y = 0; y < p.length; y++){
                                        var g = p[y];
                                        g.xTouched = g.yTouched = !1, g.xo = g.x = g.x + h, g.yo = g.y = g.y + f;
                                    }
                                    var v = i.length;
                                    i.push.apply(i, p);
                                    for(var b = 0; b < m.length; b++)a.push(m[b] + v);
                                }
                                e1.instructions && !d.inhibitGridFit && ((d = new E("glyf", e1.instructions)).gZone = d.z0 = d.z1 = d.z2 = i, d.contours = a, i.push(new M(0, 0), new M(Math.round(e1.advanceWidth * r), 0)), j.DEBUG && (console.log("---EXEC COMPOSITE---"), d.step = -1), vr(d), i.length -= 2);
                            } else d = new E("glyf", e1.instructions), j.DEBUG && (console.log("---EXEC GLYPH---"), d.step = -1), gr(e1, d, r, o), i = d.gZone;
                            return i;
                        }, gr = function(e1, t, r, o) {
                            for(var n, s, i, a = e1.points || [], l = a.length, u = t.gZone = t.z0 = t.z1 = t.z2 = [], c = t.contours = [], d = 0; d < l; d++)n = a[d], u[d] = new M(n.x * r, n.y * o, n.lastPointOfContour, n.onCurve);
                            for(var h = 0; h < l; h++)n = u[h], s || (s = n, c.push(h)), n.lastPointOfContour ? ((n.nextPointOnContour = s).prevPointOnContour = n, s = void 0) : (i = u[h + 1], (n.nextPointOnContour = i).prevPointOnContour = n);
                            if (!t.inhibitGridFit) {
                                if (j.DEBUG) {
                                    console.log("PROCESSING GLYPH", t.stack);
                                    for(var f = 0; f < l; f++)console.log(f, u[f].x, u[f].y);
                                }
                                if (u.push(new M(0, 0), new M(Math.round(e1.advanceWidth * r), 0)), vr(t), u.length -= 2, j.DEBUG) {
                                    console.log("FINISHED GLYPH", t.stack);
                                    for(var p = 0; p < l; p++)console.log(p, u[p].x, u[p].y);
                                }
                            }
                        }, vr = function(e1) {
                            var t = e1.prog;
                            if (t) {
                                var r, o = t.length;
                                for(e1.ip = 0; e1.ip < o; e1.ip++){
                                    if (j.DEBUG && e1.step++, !(r = br[t[e1.ip]])) throw new Error("unknown instruction: 0x" + Number(t[e1.ip]).toString(16));
                                    r(e1);
                                }
                            }
                        }, br = [
                            Jt.bind(void 0, T),
                            Jt.bind(void 0, x),
                            Kt.bind(void 0, T),
                            Kt.bind(void 0, x),
                            $t.bind(void 0, T),
                            $t.bind(void 0, x),
                            er.bind(void 0, 0),
                            er.bind(void 0, 1),
                            tr.bind(void 0, 0),
                            tr.bind(void 0, 1),
                            function(e1) {
                                var t = (r = e1.stack).pop(), r = r.pop();
                                j.DEBUG && console.log(e1.step, "SPVFS[]", t, r), e1.pv = e1.dpv = qt(r, t);
                            },
                            function(e1) {
                                var t = (r = e1.stack).pop(), r = r.pop();
                                j.DEBUG && console.log(e1.step, "SPVFS[]", t, r), e1.fv = qt(r, t);
                            },
                            function(e1) {
                                var t = e1.stack, r = e1.pv;
                                j.DEBUG && console.log(e1.step, "GPV[]"), t.push(16384 * r.x), t.push(16384 * r.y);
                            },
                            function(e1) {
                                var t = e1.stack, r = e1.fv;
                                j.DEBUG && console.log(e1.step, "GFV[]"), t.push(16384 * r.x), t.push(16384 * r.y);
                            },
                            function(e1) {
                                e1.fv = e1.pv, j.DEBUG && console.log(e1.step, "SFVTPV[]");
                            },
                            function(e1) {
                                var t = (s = e1.stack).pop(), r = s.pop(), o = s.pop(), n = s.pop(), s = s.pop(), i = e1.z0, a = e1.z1, l = i[t], i = i[r], u = a[o], a = a[n], e1 = e1.z2[s], t = (j.DEBUG && console.log("ISECT[], ", t, r, o, n, s), l.x), r = l.y, o = i.x, n = i.y, s = u.x, l = u.y, i = a.x, u = a.y, a = (t - o) * (l - u) - (r - n) * (s - i), c = t * n - r * o, d = s * u - l * i;
                                e1.x = (c * (s - i) - d * (t - o)) / a, e1.y = (c * (l - u) - d * (r - n)) / a;
                            },
                            function(e1) {
                                e1.rp0 = e1.stack.pop(), j.DEBUG && console.log(e1.step, "SRP0[]", e1.rp0);
                            },
                            function(e1) {
                                e1.rp1 = e1.stack.pop(), j.DEBUG && console.log(e1.step, "SRP1[]", e1.rp1);
                            },
                            function(e1) {
                                e1.rp2 = e1.stack.pop(), j.DEBUG && console.log(e1.step, "SRP2[]", e1.rp2);
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                switch(j.DEBUG && console.log(e1.step, "SZP0[]", t), e1.zp0 = t){
                                    case 0:
                                        e1.tZone || Zt(e1), e1.z0 = e1.tZone;
                                        break;
                                    case 1:
                                        e1.z0 = e1.gZone;
                                        break;
                                    default:
                                        throw new Error("Invalid zone pointer");
                                }
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                switch(j.DEBUG && console.log(e1.step, "SZP1[]", t), e1.zp1 = t){
                                    case 0:
                                        e1.tZone || Zt(e1), e1.z1 = e1.tZone;
                                        break;
                                    case 1:
                                        e1.z1 = e1.gZone;
                                        break;
                                    default:
                                        throw new Error("Invalid zone pointer");
                                }
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                switch(j.DEBUG && console.log(e1.step, "SZP2[]", t), e1.zp2 = t){
                                    case 0:
                                        e1.tZone || Zt(e1), e1.z2 = e1.tZone;
                                        break;
                                    case 1:
                                        e1.z2 = e1.gZone;
                                        break;
                                    default:
                                        throw new Error("Invalid zone pointer");
                                }
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                switch(j.DEBUG && console.log(e1.step, "SZPS[]", t), e1.zp0 = e1.zp1 = e1.zp2 = t){
                                    case 0:
                                        e1.tZone || Zt(e1), e1.z0 = e1.z1 = e1.z2 = e1.tZone;
                                        break;
                                    case 1:
                                        e1.z0 = e1.z1 = e1.z2 = e1.gZone;
                                        break;
                                    default:
                                        throw new Error("Invalid zone pointer");
                                }
                            },
                            function(e1) {
                                e1.loop = e1.stack.pop(), j.DEBUG && console.log(e1.step, "SLOOP[]", e1.loop);
                            },
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "RTG[]"), e1.round = Nt;
                            },
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "RTHG[]"), e1.round = Gt;
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                j.DEBUG && console.log(e1.step, "SMD[]", t), e1.minDis = t / 64;
                            },
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "ELSE[]"), Qt(e1, !1);
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                j.DEBUG && console.log(e1.step, "JMPR[]", t), e1.ip += t - 1;
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                j.DEBUG && console.log(e1.step, "SCVTCI[]", t), e1.cvCutIn = t / 64;
                            },
                            void 0,
                            void 0,
                            function(e1) {
                                var t = e1.stack;
                                j.DEBUG && console.log(e1.step, "DUP[]"), t.push(t[t.length - 1]);
                            },
                            rr,
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "CLEAR[]"), e1.stack.length = 0;
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "SWAP[]"), t.push(r), t.push(o);
                            },
                            function(e1) {
                                var t = e1.stack;
                                j.DEBUG && console.log(e1.step, "DEPTH[]"), t.push(t.length);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "CINDEX[]", r), t.push(t[t.length - r]);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "MINDEX[]", r), t.push(t.splice(t.length - r, 1)[0]);
                            },
                            void 0,
                            void 0,
                            void 0,
                            function(e1) {
                                var t = (o = e1.stack).pop(), r = o.pop(), o = (j.DEBUG && console.log(e1.step, "LOOPCALL[]", t, r), e1.ip), n = e1.prog;
                                e1.prog = e1.funcs[t];
                                for(var s = 0; s < r; s++)vr(e1), j.DEBUG && console.log(++e1.step, s + 1 < r ? "next loopcall" : "done loopcall", s);
                                e1.ip = o, e1.prog = n;
                            },
                            function(e1) {
                                var t = e1.stack.pop(), r = (j.DEBUG && console.log(e1.step, "CALL[]", t), e1.ip), o = e1.prog;
                                e1.prog = e1.funcs[t], vr(e1), e1.ip = r, e1.prog = o, j.DEBUG && console.log(++e1.step, "returning from", t);
                            },
                            function(e1) {
                                if ("fpgm" !== e1.env) throw new Error("FDEF not allowed here");
                                var t = e1.stack, r = e1.prog, o = e1.ip, t = t.pop(), n = o;
                                for(j.DEBUG && console.log(e1.step, "FDEF[]", t); 45 !== r[++o];);
                                e1.ip = o, e1.funcs[t] = r.slice(n + 1, o);
                            },
                            void 0,
                            or.bind(void 0, 0),
                            or.bind(void 0, 1),
                            nr.bind(void 0, T),
                            nr.bind(void 0, x),
                            sr.bind(void 0, 0),
                            sr.bind(void 0, 1),
                            ir.bind(void 0, 0),
                            ir.bind(void 0, 1),
                            ar.bind(void 0, 0),
                            ar.bind(void 0, 1),
                            function(e1) {
                                for(var t = e1.stack, r = e1.loop, o = e1.fv, n = t.pop() / 64, s = e1.z2; r--;){
                                    var i = t.pop(), a = s[i];
                                    j.DEBUG && console.log(e1.step, (1 < e1.loop ? "loop " + (e1.loop - r) + ": " : "") + "SHPIX[]", i, n), o.setRelative(a, a, n), o.touch(a);
                                }
                                e1.loop = 1;
                            },
                            function(e1) {
                                for(var t = e1.stack, r = e1.rp1, o = e1.rp2, n = e1.loop, s = e1.z0[r], i = e1.z1[o], a = e1.fv, l = e1.dpv, u = e1.z2; n--;){
                                    var c = t.pop(), d = u[c];
                                    j.DEBUG && console.log(e1.step, (1 < e1.loop ? "loop " + (e1.loop - n) + ": " : "") + "IP[]", c, r, "<->", o), a.interpolate(d, s, i, l), a.touch(d);
                                }
                                e1.loop = 1;
                            },
                            lr.bind(void 0, 0),
                            lr.bind(void 0, 1),
                            function(e1) {
                                for(var t = e1.stack, r = e1.rp0, o = e1.z0[r], n = e1.loop, s = e1.fv, i = e1.pv, a = e1.z1; n--;){
                                    var l = t.pop(), u = a[l];
                                    j.DEBUG && console.log(e1.step, (1 < e1.loop ? "loop " + (e1.loop - n) + ": " : "") + "ALIGNRP[]", l), s.setRelative(u, o, 0, i), s.touch(u);
                                }
                                e1.loop = 1;
                            },
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "RTDG[]"), e1.round = Bt;
                            },
                            ur.bind(void 0, 0),
                            ur.bind(void 0, 1),
                            function(e1) {
                                var t = e1.prog, r = e1.ip, o = e1.stack, n = t[++r];
                                j.DEBUG && console.log(e1.step, "NPUSHB[]", n);
                                for(var s = 0; s < n; s++)o.push(t[++r]);
                                e1.ip = r;
                            },
                            function(e1) {
                                var t = e1.ip, r = e1.prog, o = e1.stack, n = r[++t];
                                j.DEBUG && console.log(e1.step, "NPUSHW[]", n);
                                for(var s = 0; s < n; s++){
                                    var i = r[++t] << 8 | r[++t];
                                    32768 & i && (i = -(1 + (65535 ^ i))), o.push(i);
                                }
                                e1.ip = t;
                            },
                            function(e1) {
                                var t = e1.stack, r = (r = e1.store) || (e1.store = []), o = t.pop(), t = t.pop();
                                j.DEBUG && console.log(e1.step, "WS", o, t), r[t] = o;
                            },
                            function(e1) {
                                var t = e1.stack, r = e1.store, o = t.pop(), e1 = (j.DEBUG && console.log(e1.step, "RS", o), r && r[o] || 0);
                                t.push(e1);
                            },
                            function(e1) {
                                var t = (r = e1.stack).pop(), r = r.pop();
                                j.DEBUG && console.log(e1.step, "WCVTP", t, r), e1.cvt[r] = t / 64;
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "RCVT", r), t.push(64 * e1.cvt[r]);
                            },
                            cr.bind(void 0, 0),
                            cr.bind(void 0, 1),
                            void 0,
                            dr.bind(void 0, 0),
                            dr.bind(void 0, 1),
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "MPPEM[]"), e1.stack.push(e1.ppem);
                            },
                            void 0,
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "FLIPON[]"), e1.autoFlip = !0;
                            },
                            void 0,
                            void 0,
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "LT[]", r, o), t.push(o < r ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "LTEQ[]", r, o), t.push(o <= r ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "GT[]", r, o), t.push(r < o ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "GTEQ[]", r, o), t.push(r <= o ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "EQ[]", r, o), t.push(r === o ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "NEQ[]", r, o), t.push(r !== o ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "ODD[]", r), t.push(Math.trunc(r) % 2 ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "EVEN[]", r), t.push(Math.trunc(r) % 2 ? 0 : 1);
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                j.DEBUG && console.log(e1.step, "IF[]", t), t || (Qt(e1, !0), j.DEBUG && console.log(e1.step, "EIF[]"));
                            },
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "EIF[]");
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "AND[]", r, o), t.push(r && o ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "OR[]", r, o), t.push(r || o ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "NOT[]", r), t.push(r ? 0 : 1);
                            },
                            hr.bind(void 0, 1),
                            function(e1) {
                                var t = e1.stack.pop();
                                j.DEBUG && console.log(e1.step, "SDB[]", t), e1.deltaBase = t;
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                j.DEBUG && console.log(e1.step, "SDS[]", t), e1.deltaShift = Math.pow(.5, t);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "ADD[]", r, o), t.push(o + r);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "SUB[]", r, o), t.push(o - r);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "DIV[]", r, o), t.push(64 * o / r);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "MUL[]", r, o), t.push(o * r / 64);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "ABS[]", r), t.push(Math.abs(r));
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "NEG[]", r), t.push(-r);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "FLOOR[]", r), t.push(64 * Math.floor(r / 64));
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "CEILING[]", r), t.push(64 * Math.ceil(r / 64));
                            },
                            fr.bind(void 0, 0),
                            fr.bind(void 0, 1),
                            fr.bind(void 0, 2),
                            fr.bind(void 0, 3),
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            function(e1) {
                                var t = (r = e1.stack).pop(), r = r.pop();
                                j.DEBUG && console.log(e1.step, "WCVTF[]", t, r), e1.cvt[r] = t * e1.ppem / e1.font.unitsPerEm;
                            },
                            hr.bind(void 0, 2),
                            hr.bind(void 0, 3),
                            pr.bind(void 0, 1),
                            pr.bind(void 0, 2),
                            pr.bind(void 0, 3),
                            function(e1) {
                                var t, r = e1.stack.pop();
                                switch(j.DEBUG && console.log(e1.step, "SROUND[]", r), e1.round = Ht, 192 & r){
                                    case 0:
                                        t = .5;
                                        break;
                                    case 64:
                                        t = 1;
                                        break;
                                    case 128:
                                        t = 2;
                                        break;
                                    default:
                                        throw new Error("invalid SROUND value");
                                }
                                switch(e1.srPeriod = t, 48 & r){
                                    case 0:
                                        e1.srPhase = 0;
                                        break;
                                    case 16:
                                        e1.srPhase = .25 * t;
                                        break;
                                    case 32:
                                        e1.srPhase = .5 * t;
                                        break;
                                    case 48:
                                        e1.srPhase = .75 * t;
                                        break;
                                    default:
                                        throw new Error("invalid SROUND value");
                                }
                                e1.srThreshold = 0 === (r &= 15) ? 0 : (r / 8 - .5) * t;
                            },
                            function(e1) {
                                var t, r = e1.stack.pop();
                                switch(j.DEBUG && console.log(e1.step, "S45ROUND[]", r), e1.round = Ht, 192 & r){
                                    case 0:
                                        t = Math.sqrt(2) / 2;
                                        break;
                                    case 64:
                                        t = Math.sqrt(2);
                                        break;
                                    case 128:
                                        t = 2 * Math.sqrt(2);
                                        break;
                                    default:
                                        throw new Error("invalid S45ROUND value");
                                }
                                switch(e1.srPeriod = t, 48 & r){
                                    case 0:
                                        e1.srPhase = 0;
                                        break;
                                    case 16:
                                        e1.srPhase = .25 * t;
                                        break;
                                    case 32:
                                        e1.srPhase = .5 * t;
                                        break;
                                    case 48:
                                        e1.srPhase = .75 * t;
                                        break;
                                    default:
                                        throw new Error("invalid S45ROUND value");
                                }
                                e1.srThreshold = 0 === (r &= 15) ? 0 : (r / 8 - .5) * t;
                            },
                            void 0,
                            void 0,
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "ROFF[]"), e1.round = Ut;
                            },
                            void 0,
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "RUTG[]"), e1.round = Vt;
                            },
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "RDTG[]"), e1.round = zt;
                            },
                            rr,
                            rr,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            function(e1) {
                                var t = e1.stack.pop();
                                j.DEBUG && console.log(e1.step, "SCANCTRL[]", t);
                            },
                            mr.bind(void 0, 0),
                            mr.bind(void 0, 1),
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = 0;
                                j.DEBUG && console.log(e1.step, "GETINFO[]", r), 1 & r && (o = 35), 32 & r && (o |= 4096), t.push(o);
                            },
                            void 0,
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop(), n = t.pop();
                                j.DEBUG && console.log(e1.step, "ROLL[]"), t.push(o), t.push(r), t.push(n);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "MAX[]", r, o), t.push(Math.max(o, r));
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "MIN[]", r, o), t.push(Math.min(o, r));
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                j.DEBUG && console.log(e1.step, "SCANTYPE[]", t);
                            },
                            function(e1) {
                                var t = e1.stack.pop(), r = e1.stack.pop();
                                switch(j.DEBUG && console.log(e1.step, "INSTCTRL[]", t, r), t){
                                    case 1:
                                        return void (e1.inhibitGridFit = !!r);
                                    case 2:
                                        return void (e1.ignoreCvt = !!r);
                                    default:
                                        throw new Error("invalid INSTCTRL[] selector");
                                }
                            },
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            k.bind(void 0, 1),
                            k.bind(void 0, 2),
                            k.bind(void 0, 3),
                            k.bind(void 0, 4),
                            k.bind(void 0, 5),
                            k.bind(void 0, 6),
                            k.bind(void 0, 7),
                            k.bind(void 0, 8),
                            C.bind(void 0, 1),
                            C.bind(void 0, 2),
                            C.bind(void 0, 3),
                            C.bind(void 0, 4),
                            C.bind(void 0, 5),
                            C.bind(void 0, 6),
                            C.bind(void 0, 7),
                            C.bind(void 0, 8),
                            O.bind(void 0, 0, 0, 0, 0, 0),
                            O.bind(void 0, 0, 0, 0, 0, 1),
                            O.bind(void 0, 0, 0, 0, 0, 2),
                            O.bind(void 0, 0, 0, 0, 0, 3),
                            O.bind(void 0, 0, 0, 0, 1, 0),
                            O.bind(void 0, 0, 0, 0, 1, 1),
                            O.bind(void 0, 0, 0, 0, 1, 2),
                            O.bind(void 0, 0, 0, 0, 1, 3),
                            O.bind(void 0, 0, 0, 1, 0, 0),
                            O.bind(void 0, 0, 0, 1, 0, 1),
                            O.bind(void 0, 0, 0, 1, 0, 2),
                            O.bind(void 0, 0, 0, 1, 0, 3),
                            O.bind(void 0, 0, 0, 1, 1, 0),
                            O.bind(void 0, 0, 0, 1, 1, 1),
                            O.bind(void 0, 0, 0, 1, 1, 2),
                            O.bind(void 0, 0, 0, 1, 1, 3),
                            O.bind(void 0, 0, 1, 0, 0, 0),
                            O.bind(void 0, 0, 1, 0, 0, 1),
                            O.bind(void 0, 0, 1, 0, 0, 2),
                            O.bind(void 0, 0, 1, 0, 0, 3),
                            O.bind(void 0, 0, 1, 0, 1, 0),
                            O.bind(void 0, 0, 1, 0, 1, 1),
                            O.bind(void 0, 0, 1, 0, 1, 2),
                            O.bind(void 0, 0, 1, 0, 1, 3),
                            O.bind(void 0, 0, 1, 1, 0, 0),
                            O.bind(void 0, 0, 1, 1, 0, 1),
                            O.bind(void 0, 0, 1, 1, 0, 2),
                            O.bind(void 0, 0, 1, 1, 0, 3),
                            O.bind(void 0, 0, 1, 1, 1, 0),
                            O.bind(void 0, 0, 1, 1, 1, 1),
                            O.bind(void 0, 0, 1, 1, 1, 2),
                            O.bind(void 0, 0, 1, 1, 1, 3),
                            O.bind(void 0, 1, 0, 0, 0, 0),
                            O.bind(void 0, 1, 0, 0, 0, 1),
                            O.bind(void 0, 1, 0, 0, 0, 2),
                            O.bind(void 0, 1, 0, 0, 0, 3),
                            O.bind(void 0, 1, 0, 0, 1, 0),
                            O.bind(void 0, 1, 0, 0, 1, 1),
                            O.bind(void 0, 1, 0, 0, 1, 2),
                            O.bind(void 0, 1, 0, 0, 1, 3),
                            O.bind(void 0, 1, 0, 1, 0, 0),
                            O.bind(void 0, 1, 0, 1, 0, 1),
                            O.bind(void 0, 1, 0, 1, 0, 2),
                            O.bind(void 0, 1, 0, 1, 0, 3),
                            O.bind(void 0, 1, 0, 1, 1, 0),
                            O.bind(void 0, 1, 0, 1, 1, 1),
                            O.bind(void 0, 1, 0, 1, 1, 2),
                            O.bind(void 0, 1, 0, 1, 1, 3),
                            O.bind(void 0, 1, 1, 0, 0, 0),
                            O.bind(void 0, 1, 1, 0, 0, 1),
                            O.bind(void 0, 1, 1, 0, 0, 2),
                            O.bind(void 0, 1, 1, 0, 0, 3),
                            O.bind(void 0, 1, 1, 0, 1, 0),
                            O.bind(void 0, 1, 1, 0, 1, 1),
                            O.bind(void 0, 1, 1, 0, 1, 2),
                            O.bind(void 0, 1, 1, 0, 1, 3),
                            O.bind(void 0, 1, 1, 1, 0, 0),
                            O.bind(void 0, 1, 1, 1, 0, 1),
                            O.bind(void 0, 1, 1, 1, 0, 2),
                            O.bind(void 0, 1, 1, 1, 0, 3),
                            O.bind(void 0, 1, 1, 1, 1, 0),
                            O.bind(void 0, 1, 1, 1, 1, 1),
                            O.bind(void 0, 1, 1, 1, 1, 2),
                            O.bind(void 0, 1, 1, 1, 1, 3)
                        ], jr = Array.from || function(e1) {
                            return e1.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]?|[^\uD800-\uDFFF]|./g) || [];
                        };
                        function P(e1) {
                            (e1 = e1 || {}).empty || (_(e1.familyName, "When creating a new Font object, familyName is required."), _(e1.styleName, "When creating a new Font object, styleName is required."), _(e1.unitsPerEm, "When creating a new Font object, unitsPerEm is required."), _(e1.ascender, "When creating a new Font object, ascender is required."), _(e1.descender, "When creating a new Font object, descender is required."), _(e1.descender < 0, "Descender should be negative (e.g. -512)."), this.names = {
                                fontFamily: {
                                    en: e1.familyName || " "
                                },
                                fontSubfamily: {
                                    en: e1.styleName || " "
                                },
                                fullName: {
                                    en: e1.fullName || e1.familyName + " " + e1.styleName
                                },
                                postScriptName: {
                                    en: e1.postScriptName || (e1.familyName + e1.styleName).replace(/\s/g, "")
                                },
                                designer: {
                                    en: e1.designer || " "
                                },
                                designerURL: {
                                    en: e1.designerURL || " "
                                },
                                manufacturer: {
                                    en: e1.manufacturer || " "
                                },
                                manufacturerURL: {
                                    en: e1.manufacturerURL || " "
                                },
                                license: {
                                    en: e1.license || " "
                                },
                                licenseURL: {
                                    en: e1.licenseURL || " "
                                },
                                version: {
                                    en: e1.version || "Version 0.1"
                                },
                                description: {
                                    en: e1.description || " "
                                },
                                copyright: {
                                    en: e1.copyright || " "
                                },
                                trademark: {
                                    en: e1.trademark || " "
                                }
                            }, this.unitsPerEm = e1.unitsPerEm || 1e3, this.ascender = e1.ascender, this.descender = e1.descender, this.createdTimestamp = e1.createdTimestamp, this.tables = {
                                os2: {
                                    usWeightClass: e1.weightClass || this.usWeightClasses.MEDIUM,
                                    usWidthClass: e1.widthClass || this.usWidthClasses.MEDIUM,
                                    fsSelection: e1.fsSelection || this.fsSelectionValues.REGULAR
                                }
                            }), this.supported = !0, this.glyphs = new p.GlyphSet(this, e1.glyphs || []), this.encoding = new Ee(this), this.position = new kt(this), this.substitution = new i(this), this.tables = this.tables || {}, Object.defineProperty(this, "hinting", {
                                get: function() {
                                    return this._hinting || ("truetype" === this.outlinesFormat ? this._hinting = new Ft(this) : void 0);
                                }
                            });
                        }
                        function _r(e1, t) {
                            var r, o = JSON.stringify(e1), n = 256;
                            for(r in t){
                                var s = parseInt(r);
                                if (s && !(s < 256)) {
                                    if (JSON.stringify(t[r]) === o) return s;
                                    n <= s && (n = s + 1);
                                }
                            }
                            return t[n] = e1, n;
                        }
                        P.prototype.hasChar = function(e1) {
                            return null !== this.encoding.charToGlyphIndex(e1);
                        }, P.prototype.charToGlyphIndex = function(e1) {
                            return this.encoding.charToGlyphIndex(e1);
                        }, P.prototype.charToGlyph = function(e1) {
                            e1 = this.charToGlyphIndex(e1);
                            return this.glyphs.get(e1) || this.glyphs.get(0);
                        }, P.prototype.stringToGlyphs = function(e1, t) {
                            t = t || this.defaultRenderOptions;
                            for(var r = jr(e1), o = [], n = 0; n < r.length; n += 1){
                                var s = r[n];
                                o.push(this.charToGlyphIndex(s));
                            }
                            var i = o.length;
                            if (t.features) {
                                var e1 = t.script || this.substitution.getDefaultScriptName(), a = [];
                                t.features.liga && (a = a.concat(this.substitution.getFeature("liga", e1, t.language))), t.features.rlig && (a = a.concat(this.substitution.getFeature("rlig", e1, t.language)));
                                for(var l = 0; l < i; l += 1)for(var u = 0; u < a.length; u++){
                                    for(var c = a[u], d = c.sub, h = d.length, f = 0; f < h && d[f] === o[l + f];)f++;
                                    f === h && (o.splice(l, h, c.by), i = i - h + 1);
                                }
                            }
                            for(var p = new Array(i), m = this.glyphs.get(0), y = 0; y < i; y += 1)p[y] = this.glyphs.get(o[y]) || m;
                            return p;
                        }, P.prototype.nameToGlyphIndex = function(e1) {
                            return this.glyphNames.nameToGlyphIndex(e1);
                        }, P.prototype.nameToGlyph = function(e1) {
                            e1 = this.nameToGlyphIndex(e1);
                            return this.glyphs.get(e1) || this.glyphs.get(0);
                        }, P.prototype.glyphIndexToName = function(e1) {
                            return this.glyphNames.glyphIndexToName ? this.glyphNames.glyphIndexToName(e1) : "";
                        }, P.prototype.getKerningValue = function(e1, t) {
                            e1 = e1.index || e1, t = t.index || t;
                            var r = this.position.defaultKerningTables;
                            return r ? this.position.getKerningValue(r, e1, t) : this.kerningPairs[e1 + "," + t] || 0;
                        }, P.prototype.defaultRenderOptions = {
                            kerning: !0,
                            features: {
                                liga: !0,
                                rlig: !0
                            }
                        }, P.prototype.forEachGlyph = function(e1, t, r, o, n, s) {
                            t = void 0 !== t ? t : 0, r = void 0 !== r ? r : 0, n = n || this.defaultRenderOptions;
                            var i, a = 1 / this.unitsPerEm * (o = void 0 !== o ? o : 72), l = this.stringToGlyphs(e1, n);
                            n.kerning && (e1 = n.script || this.position.getDefaultScriptName(), i = this.position.getKerningTables(e1, n.language));
                            for(var u = 0; u < l.length; u += 1){
                                var c = l[u];
                                s.call(this, c, t, r, o, n), c.advanceWidth && (t += c.advanceWidth * a), n.kerning && u < l.length - 1 && (t += (i ? this.position.getKerningValue(i, c.index, l[u + 1].index) : this.getKerningValue(c, l[u + 1])) * a), n.letterSpacing ? t += n.letterSpacing * o : n.tracking && (t += n.tracking / 1e3 * o);
                            }
                            return t;
                        }, P.prototype.getPath = function(e1, t, r, o, n) {
                            var s = new h;
                            return this.forEachGlyph(e1, t, r, o, n, function(e1, t, r, o) {
                                e1 = e1.getPath(t, r, o, n, this);
                                s.extend(e1);
                            }), s;
                        }, P.prototype.getPaths = function(e1, t, r, o, n) {
                            var s = [];
                            return this.forEachGlyph(e1, t, r, o, n, function(e1, t, r, o) {
                                e1 = e1.getPath(t, r, o, n, this);
                                s.push(e1);
                            }), s;
                        }, P.prototype.getAdvanceWidth = function(e1, t, r) {
                            return this.forEachGlyph(e1, 0, 0, t, r, function() {});
                        }, P.prototype.draw = function(e1, t, r, o, n, s) {
                            this.getPath(t, r, o, n, s).draw(e1);
                        }, P.prototype.drawPoints = function(n, e1, t, r, o, s) {
                            this.forEachGlyph(e1, t, r, o, s, function(e1, t, r, o) {
                                e1.drawPoints(n, t, r, o);
                            });
                        }, P.prototype.drawMetrics = function(n, e1, t, r, o, s) {
                            this.forEachGlyph(e1, t, r, o, s, function(e1, t, r, o) {
                                e1.drawMetrics(n, t, r, o);
                            });
                        }, P.prototype.getEnglishName = function(e1) {
                            e1 = this.names[e1];
                            if (e1) return e1.en;
                        }, P.prototype.validate = function() {
                            var t = this;
                            function e1(e1) {
                                e1 = t.getEnglishName(e1);
                                e1 && e1.trim().length;
                            }
                            e1("fontFamily"), e1("weightName"), e1("manufacturer"), e1("copyright"), e1("version"), this.unitsPerEm;
                        }, P.prototype.toTables = function() {
                            return wt.fontToTable(this);
                        }, P.prototype.toBuffer = function() {
                            return console.warn("Font.toBuffer is deprecated. Use Font.toArrayBuffer instead."), this.toArrayBuffer();
                        }, P.prototype.toArrayBuffer = function() {
                            for(var e1 = this.toTables().encode(), t = new ArrayBuffer(e1.length), r = new Uint8Array(t), o = 0; o < e1.length; o++)r[o] = e1[o];
                            return t;
                        }, P.prototype.download = function(t) {
                            var e1 = this.getEnglishName("fontFamily"), r = this.getEnglishName("fontSubfamily"), o = (t = t || e1.replace(/\s/g, "") + "-" + r + ".otf", this.toArrayBuffer());
                            "undefined" != typeof window ? (window.requestFileSystem = window.requestFileSystem || window.webkitRequestFileSystem, window.requestFileSystem(window.TEMPORARY, o.byteLength, function(e1) {
                                e1.root.getFile(t, {
                                    create: !0
                                }, function(r) {
                                    r.createWriter(function(e1) {
                                        var t = new DataView(o), t = new Blob([
                                            t
                                        ], {
                                            type: "font/opentype"
                                        });
                                        e1.write(t), e1.addEventListener("writeend", function() {
                                            location.href = r.toURL();
                                        }, !1);
                                    });
                                });
                            }, function(e1) {
                                throw new Error(e1.name + ": " + e1.message);
                            })) : (e1 = Ar("fs"), r = function(e1) {
                                for(var t = new Pr(e1.byteLength), r = new Uint8Array(e1), o = 0; o < t.length; ++o)t[o] = r[o];
                                return t;
                            }(o), e1.writeFileSync(t, r));
                        }, P.prototype.fsSelectionValues = {
                            ITALIC: 1,
                            UNDERSCORE: 2,
                            NEGATIVE: 4,
                            OUTLINED: 8,
                            STRIKEOUT: 16,
                            BOLD: 32,
                            REGULAR: 64,
                            USER_TYPO_METRICS: 128,
                            WWS: 256,
                            OBLIQUE: 512
                        }, P.prototype.usWidthClasses = {
                            ULTRA_CONDENSED: 1,
                            EXTRA_CONDENSED: 2,
                            CONDENSED: 3,
                            SEMI_CONDENSED: 4,
                            MEDIUM: 5,
                            SEMI_EXPANDED: 6,
                            EXPANDED: 7,
                            EXTRA_EXPANDED: 8,
                            ULTRA_EXPANDED: 9
                        }, P.prototype.usWeightClasses = {
                            THIN: 100,
                            EXTRA_LIGHT: 200,
                            LIGHT: 300,
                            NORMAL: 400,
                            MEDIUM: 500,
                            SEMI_BOLD: 600,
                            BOLD: 700,
                            EXTRA_BOLD: 800,
                            BLACK: 900
                        };
                        var xr = {
                            make: function(e1, t) {
                                var r = new S.Table("fvar", [
                                    {
                                        name: "version",
                                        type: "ULONG",
                                        value: 65536
                                    },
                                    {
                                        name: "offsetToData",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "countSizePairs",
                                        type: "USHORT",
                                        value: 2
                                    },
                                    {
                                        name: "axisCount",
                                        type: "USHORT",
                                        value: e1.axes.length
                                    },
                                    {
                                        name: "axisSize",
                                        type: "USHORT",
                                        value: 20
                                    },
                                    {
                                        name: "instanceCount",
                                        type: "USHORT",
                                        value: e1.instances.length
                                    },
                                    {
                                        name: "instanceSize",
                                        type: "USHORT",
                                        value: 4 + 4 * e1.axes.length
                                    }
                                ]);
                                r.offsetToData = r.sizeOf();
                                for(var o, n, s, i = 0; i < e1.axes.length; i++)r.fields = r.fields.concat((o = i, n = e1.axes[i], s = t, s = _r(n.name, t), [
                                    {
                                        name: "tag_" + o,
                                        type: "TAG",
                                        value: n.tag
                                    },
                                    {
                                        name: "minValue_" + o,
                                        type: "FIXED",
                                        value: n.minValue << 16
                                    },
                                    {
                                        name: "defaultValue_" + o,
                                        type: "FIXED",
                                        value: n.defaultValue << 16
                                    },
                                    {
                                        name: "maxValue_" + o,
                                        type: "FIXED",
                                        value: n.maxValue << 16
                                    },
                                    {
                                        name: "flags_" + o,
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "nameID_" + o,
                                        type: "USHORT",
                                        value: s
                                    }
                                ]));
                                for(var a = 0; a < e1.instances.length; a++)r.fields = r.fields.concat(function(e1, t, r, o) {
                                    for(var n = [
                                        {
                                            name: "nameID_" + e1,
                                            type: "USHORT",
                                            value: _r(t.name, o)
                                        },
                                        {
                                            name: "flags_" + e1,
                                            type: "USHORT",
                                            value: 0
                                        }
                                    ], s = 0; s < r.length; ++s){
                                        var i = r[s].tag;
                                        n.push({
                                            name: "axis_" + e1 + " " + i,
                                            type: "FIXED",
                                            value: t.coordinates[i] << 16
                                        });
                                    }
                                    return n;
                                }(a, e1.instances[a], e1.axes, t));
                                return r;
                            },
                            parse: function(e1, t, r) {
                                for(var o, n, s, i, a = new R.Parser(e1, t), l = a.parseULong(), u = (L.argument(65536 === l, "Unsupported fvar table version."), a.parseOffset16()), c = (a.skip("uShort", 1), a.parseUShort()), d = a.parseUShort(), h = a.parseUShort(), f = a.parseUShort(), p = [], m = 0; m < c; m++)p.push((o = e1, n = t + u + m * d, s = r, i = {}, o = new R.Parser(o, n), i.tag = o.parseTag(), i.minValue = o.parseFixed(), i.defaultValue = o.parseFixed(), i.maxValue = o.parseFixed(), o.skip("uShort", 1), i.name = s[o.parseUShort()] || {}, i));
                                for(var y = [], g = t + u + c * d, v = 0; v < h; v++)y.push(function(e1, t, r, o) {
                                    var n = {}, s = new R.Parser(e1, t);
                                    n.name = o[s.parseUShort()] || {}, s.skip("uShort", 1), n.coordinates = {};
                                    for(var i = 0; i < r.length; ++i)n.coordinates[r[i].tag] = s.parseFixed();
                                    return n;
                                }(e1, g + v * f, p, r));
                                return {
                                    axes: p,
                                    instances: y
                                };
                            }
                        }, A = new Array(10);
                        A[1] = function() {
                            var e1 = this.offset + this.relativeOffset, t = this.parseUShort();
                            return 1 === t ? {
                                posFormat: 1,
                                coverage: this.parsePointer(u.coverage),
                                value: this.parseValueRecord()
                            } : 2 === t ? {
                                posFormat: 2,
                                coverage: this.parsePointer(u.coverage),
                                values: this.parseValueRecordList()
                            } : void L.assert(!1, "0x" + e1.toString(16) + ": GPOS lookup type 1 format must be 1 or 2.");
                        }, A[2] = function() {
                            var e1, t, r, o, n = this.offset + this.relativeOffset, s = this.parseUShort(), n = (L.assert(1 === s || 2 === s, "0x" + n.toString(16) + ": GPOS lookup type 2 format must be 1 or 2."), this.parsePointer(u.coverage)), i = this.parseUShort(), a = this.parseUShort();
                            return 1 === s ? {
                                posFormat: s,
                                coverage: n,
                                valueFormat1: i,
                                valueFormat2: a,
                                pairSets: this.parseList(u.pointer(u.list(function() {
                                    return {
                                        secondGlyph: this.parseUShort(),
                                        value1: this.parseValueRecord(i),
                                        value2: this.parseValueRecord(a)
                                    };
                                })))
                            } : 2 === s ? (e1 = this.parsePointer(u.classDef), t = this.parsePointer(u.classDef), r = this.parseUShort(), o = this.parseUShort(), {
                                posFormat: s,
                                coverage: n,
                                valueFormat1: i,
                                valueFormat2: a,
                                classDef1: e1,
                                classDef2: t,
                                class1Count: r,
                                class2Count: o,
                                classRecords: this.parseList(r, u.list(o, function() {
                                    return {
                                        value1: this.parseValueRecord(i),
                                        value2: this.parseValueRecord(a)
                                    };
                                }))
                            }) : void 0;
                        }, A[3] = function() {
                            return {
                                error: "GPOS Lookup 3 not supported"
                            };
                        }, A[4] = function() {
                            return {
                                error: "GPOS Lookup 4 not supported"
                            };
                        }, A[5] = function() {
                            return {
                                error: "GPOS Lookup 5 not supported"
                            };
                        }, A[6] = function() {
                            return {
                                error: "GPOS Lookup 6 not supported"
                            };
                        }, A[7] = function() {
                            return {
                                error: "GPOS Lookup 7 not supported"
                            };
                        }, A[8] = function() {
                            return {
                                error: "GPOS Lookup 8 not supported"
                            };
                        }, A[9] = function() {
                            return {
                                error: "GPOS Lookup 9 not supported"
                            };
                        };
                        var wr = new Array(10);
                        var Sr = {
                            parse: function(e1, t) {
                                return t = (e1 = new u(e1, t = t || 0)).parseVersion(1), L.argument(1 === t || 1.1 === t, "Unsupported GPOS table version " + t), 1 === t ? {
                                    version: t,
                                    scripts: e1.parseScriptList(),
                                    features: e1.parseFeatureList(),
                                    lookups: e1.parseLookupList(A)
                                } : {
                                    version: t,
                                    scripts: e1.parseScriptList(),
                                    features: e1.parseFeatureList(),
                                    lookups: e1.parseLookupList(A),
                                    variations: e1.parseFeatureVariationsList()
                                };
                            },
                            make: function(e1) {
                                return new S.Table("GPOS", [
                                    {
                                        name: "version",
                                        type: "ULONG",
                                        value: 65536
                                    },
                                    {
                                        name: "scripts",
                                        type: "TABLE",
                                        value: new S.ScriptList(e1.scripts)
                                    },
                                    {
                                        name: "features",
                                        type: "TABLE",
                                        value: new S.FeatureList(e1.features)
                                    },
                                    {
                                        name: "lookups",
                                        type: "TABLE",
                                        value: new S.LookupList(e1.lookups, wr)
                                    }
                                ]);
                            }
                        };
                        var Tr = {
                            parse: function(e1, t) {
                                if (e1 = new R.Parser(e1, t), 0 === (t = e1.parseUShort())) {
                                    var r = e1, o = {}, n = (r.skip("uShort"), r.parseUShort()), s = (L.argument(0 === n, "Unsupported kern sub-table version."), r.skip("uShort", 2), r.parseUShort());
                                    r.skip("uShort", 3);
                                    for(var i = 0; i < s; i += 1){
                                        var a = r.parseUShort(), l = r.parseUShort(), u = r.parseShort();
                                        o[a + "," + l] = u;
                                    }
                                    return o;
                                }
                                if (1 !== t) throw new Error("Unsupported kern table version (" + t + ").");
                                var c = e1, d = {}, n = (c.skip("uShort"), 1 < c.parseULong() && console.warn("Only the first kern subtable is supported."), c.skip("uLong"), 255 & c.parseUShort());
                                if (c.skip("uShort"), 0 == n) {
                                    var h = c.parseUShort();
                                    c.skip("uShort", 3);
                                    for(var f = 0; f < h; f += 1){
                                        var p = c.parseUShort(), m = c.parseUShort(), y = c.parseShort();
                                        d[p + "," + m] = y;
                                    }
                                }
                                return d;
                            }
                        };
                        var Mr = {
                            parse: function(e1, t, r, o) {
                                for(var n = new R.Parser(e1, t), s = o ? n.parseUShort : n.parseULong, i = [], a = 0; a < r + 1; a += 1){
                                    var l = s.call(n);
                                    o && (l *= 2), i.push(l);
                                }
                                return i;
                            }
                        };
                        function Er(e1, r) {
                            Ar("fs").readFile(e1, function(e1, t) {
                                if (e1) return r(e1.message);
                                r(null, Ot(t));
                            });
                        }
                        function kr(e1, t) {
                            var r = new XMLHttpRequest;
                            r.open("get", e1, !0), r.responseType = "arraybuffer", r.onload = function() {
                                return r.response ? t(null, r.response) : t("Font could not be loaded: " + r.statusText);
                            }, r.onerror = function() {
                                t("Font could not be loaded");
                            }, r.send();
                        }
                        function Cr(e1, t) {
                            for(var r = [], o = 12, n = 0; n < t; n += 1){
                                var s = R.getTag(e1, o), i = R.getULong(e1, o + 4), a = R.getULong(e1, o + 8), l = R.getULong(e1, o + 12);
                                r.push({
                                    tag: s,
                                    checksum: i,
                                    offset: a,
                                    length: l,
                                    compression: !1
                                }), o += 16;
                            }
                            return r;
                        }
                        function I(e1, t) {
                            if ("WOFF" !== t.compression) return {
                                data: e1,
                                offset: t.offset
                            };
                            var e1 = new Uint8Array(e1.buffer, t.offset + 2, t.compressedLength - 2), r = new Uint8Array(t.length);
                            if (re(e1, r), r.byteLength !== t.length) throw new Error("Decompression error: " + t.tag + " decompressed length doesn't match recorded length");
                            return {
                                data: new DataView(r.buffer, 0),
                                offset: 0
                            };
                        }
                        function Or(e1) {
                            var t, r, o, n, s, i, a, l, u, c, d, h, f, p, m = new P({
                                empty: !0
                            }), y = new DataView(e1, 0), g = [], e1 = R.getTag(y, 0);
                            if (e1 === String.fromCharCode(0, 1, 0, 0) || "true" === e1 || "typ1" === e1) m.outlinesFormat = "truetype", g = Cr(y, o = R.getUShort(y, 4));
                            else if ("OTTO" === e1) m.outlinesFormat = "cff", g = Cr(y, o = R.getUShort(y, 4));
                            else {
                                if ("wOFF" !== e1) throw new Error("Unsupported OpenType signature " + e1);
                                var v = R.getTag(y, 4);
                                if (v === String.fromCharCode(0, 1, 0, 0)) m.outlinesFormat = "truetype";
                                else {
                                    if ("OTTO" !== v) throw new Error("Unsupported OpenType flavor " + e1);
                                    m.outlinesFormat = "cff";
                                }
                                g = function(e1, t) {
                                    for(var r = [], o = 44, n = 0; n < t; n += 1){
                                        var s = R.getTag(e1, o), i = R.getULong(e1, o + 4), a = R.getULong(e1, o + 8), l = R.getULong(e1, o + 12), u = void 0, u = a < l && "WOFF";
                                        r.push({
                                            tag: s,
                                            offset: i,
                                            compression: u,
                                            compressedLength: a,
                                            length: l
                                        }), o += 20;
                                    }
                                    return r;
                                }(y, o = R.getUShort(y, 12));
                            }
                            for(var b = 0; b < o; b += 1){
                                var j = g[b], _ = void 0;
                                switch(j.tag){
                                    case "cmap":
                                        _ = I(y, j), m.tables.cmap = we.parse(_.data, _.offset), m.encoding = new ke(m.tables.cmap);
                                        break;
                                    case "cvt ":
                                        _ = I(y, j), p = new R.Parser(_.data, _.offset), m.tables.cvt = p.parseShortList(j.length / 2);
                                        break;
                                    case "fvar":
                                        s = j;
                                        break;
                                    case "fpgm":
                                        _ = I(y, j), p = new R.Parser(_.data, _.offset), m.tables.fpgm = p.parseByteList(j.length);
                                        break;
                                    case "head":
                                        _ = I(y, j), m.tables.head = Ze.parse(_.data, _.offset), m.unitsPerEm = m.tables.head.unitsPerEm, t = m.tables.head.indexToLocFormat;
                                        break;
                                    case "hhea":
                                        _ = I(y, j), m.tables.hhea = Qe.parse(_.data, _.offset), m.ascender = m.tables.hhea.ascender, m.descender = m.tables.hhea.descender, m.numberOfHMetrics = m.tables.hhea.numberOfHMetrics;
                                        break;
                                    case "hmtx":
                                        u = j;
                                        break;
                                    case "ltag":
                                        _ = I(y, j), r = Ke.parse(_.data, _.offset);
                                        break;
                                    case "maxp":
                                        _ = I(y, j), m.tables.maxp = $e.parse(_.data, _.offset), m.numGlyphs = m.tables.maxp.numGlyphs;
                                        break;
                                    case "name":
                                        h = j;
                                        break;
                                    case "OS/2":
                                        _ = I(y, j), m.tables.os2 = ft.parse(_.data, _.offset);
                                        break;
                                    case "post":
                                        _ = I(y, j), m.tables.post = pt.parse(_.data, _.offset), m.glyphNames = new Oe(m.tables.post);
                                        break;
                                    case "prep":
                                        _ = I(y, j), p = new R.Parser(_.data, _.offset), m.tables.prep = p.parseByteList(j.length);
                                        break;
                                    case "glyf":
                                        i = j;
                                        break;
                                    case "loca":
                                        d = j;
                                        break;
                                    case "CFF ":
                                        n = j;
                                        break;
                                    case "kern":
                                        c = j;
                                        break;
                                    case "GPOS":
                                        a = j;
                                        break;
                                    case "GSUB":
                                        l = j;
                                        break;
                                    case "meta":
                                        f = j;
                                }
                            }
                            v = I(y, h);
                            if (m.tables.name = dt.parse(v.data, v.offset, r), m.names = m.tables.name, i && d) {
                                e1 = 0 === t, v = I(y, d), v = Mr.parse(v.data, v.offset, m.numGlyphs, e1), e1 = I(y, i);
                                m.glyphs = Dt.parse(e1.data, e1.offset, v, m);
                            } else {
                                if (!n) throw new Error("Font doesn't contain TrueType or CFF outlines.");
                                e1 = I(y, n);
                                Ye.parse(e1.data, e1.offset, m);
                            }
                            for(var v = I(y, u), x = (Je.parse(v.data, v.offset, m.numberOfHMetrics, m.numGlyphs, m.glyphs), m), w = x.tables.cmap.glyphIndexMap, S = Object.keys(w), T = 0; T < S.length; T += 1){
                                var M, E = S[T], k = w[E];
                                (M = x.glyphs.get(k)).addUnicode(parseInt(E));
                            }
                            for(var C = 0; C < x.glyphs.length; C += 1)M = x.glyphs.get(C), x.cffEncoding ? x.isCIDFont ? M.name = "gid" + C : M.name = x.cffEncoding.charset[C] : x.glyphNames.names && (M.name = x.glyphNames.glyphIndexToName(C));
                            return c ? (e1 = I(y, c), m.kerningPairs = Tr.parse(e1.data, e1.offset)) : m.kerningPairs = {}, a && (v = I(y, a), m.tables.gpos = Sr.parse(v.data, v.offset), m.position.init()), l && (e1 = I(y, l), m.tables.gsub = yt.parse(e1.data, e1.offset)), s && (v = I(y, s), m.tables.fvar = xr.parse(v.data, v.offset, m.names)), f && (e1 = I(y, f), m.tables.meta = gt.parse(e1.data, e1.offset), m.metas = m.tables.meta), m;
                        }
                        j.Font = P, j.Glyph = f, j.Path = h, j.BoundingBox = a, j._parse = R, j.parse = Or, j.load = function(e1, o) {
                            ("undefined" == typeof window ? Er : kr)(e1, function(e1, t) {
                                if (e1) return o(e1);
                                var r;
                                try {
                                    r = Or(t);
                                } catch (e1) {
                                    return o(e1, null);
                                }
                                return o(null, r);
                            });
                        }, j.loadSync = function(e1) {
                            return Or(Ot(Ar("fs").readFileSync(e1)));
                        }, Object.defineProperty(j, "__esModule", {
                            value: !0
                        });
                    }, "object" == typeof o && void 0 !== r ? t(o) : "function" == typeof s && s.amd ? s([
                        "exports"
                    ], t) : t(e1.opentype = {});
                }).call(this, Ar("buffer").Buffer);
            },
            {
                buffer: 4,
                fs: 2
            }
        ],
        250: [
            function(e1, t, u) {
                (function(n) {
                    function s(e1, t) {
                        for(var r = 0, o = e1.length - 1; 0 <= o; o--){
                            var n = e1[o];
                            "." === n ? e1.splice(o, 1) : ".." === n ? (e1.splice(o, 1), r++) : r && (e1.splice(o, 1), r--);
                        }
                        if (t) for(; r--;)e1.unshift("..");
                        return e1;
                    }
                    function i(e1, t) {
                        if (e1.filter) return e1.filter(t);
                        for(var r = [], o = 0; o < e1.length; o++)t(e1[o], o, e1) && r.push(e1[o]);
                        return r;
                    }
                    u.resolve = function() {
                        for(var e1 = "", t = !1, r = arguments.length - 1; -1 <= r && !t; r--){
                            var o = 0 <= r ? arguments[r] : n.cwd();
                            if ("string" != typeof o) throw new TypeError("Arguments to path.resolve must be strings");
                            o && (e1 = o + "/" + e1, t = "/" === o.charAt(0));
                        }
                        return (t ? "/" : "") + (e1 = s(i(e1.split("/"), function(e1) {
                            return !!e1;
                        }), !t).join("/")) || ".";
                    }, u.normalize = function(e1) {
                        var t = u.isAbsolute(e1), r = "/" === o(e1, -1);
                        return (e1 = (e1 = s(i(e1.split("/"), function(e1) {
                            return !!e1;
                        }), !t).join("/")) || t ? e1 : ".") && r && (e1 += "/"), (t ? "/" : "") + e1;
                    }, u.isAbsolute = function(e1) {
                        return "/" === e1.charAt(0);
                    }, u.join = function() {
                        var e1 = Array.prototype.slice.call(arguments, 0);
                        return u.normalize(i(e1, function(e1, t) {
                            if ("string" != typeof e1) throw new TypeError("Arguments to path.join must be strings");
                            return e1;
                        }).join("/"));
                    }, u.relative = function(e1, t) {
                        function r(e1) {
                            for(var t = 0; t < e1.length && "" === e1[t]; t++);
                            for(var r = e1.length - 1; 0 <= r && "" === e1[r]; r--);
                            return r < t ? [] : e1.slice(t, r - t + 1);
                        }
                        e1 = u.resolve(e1).substr(1), t = u.resolve(t).substr(1);
                        for(var o = r(e1.split("/")), n = r(t.split("/")), s = Math.min(o.length, n.length), i = s, a = 0; a < s; a++)if (o[a] !== n[a]) {
                            i = a;
                            break;
                        }
                        for(var l = [], a = i; a < o.length; a++)l.push("..");
                        return (l = l.concat(n.slice(i))).join("/");
                    }, u.sep = "/", u.delimiter = ":", u.dirname = function(e1) {
                        if ("string" != typeof e1 && (e1 += ""), 0 === e1.length) return ".";
                        for(var t = 47 === e1.charCodeAt(0), r = -1, o = !0, n = e1.length - 1; 1 <= n; --n)if (47 === e1.charCodeAt(n)) {
                            if (!o) {
                                r = n;
                                break;
                            }
                        } else o = !1;
                        return -1 === r ? t ? "/" : "." : t && 1 === r ? "/" : e1.slice(0, r);
                    }, u.basename = function(e1, t) {
                        e1 = function(e1) {
                            "string" != typeof e1 && (e1 += "");
                            for(var t = 0, r = -1, o = !0, n = e1.length - 1; 0 <= n; --n)if (47 === e1.charCodeAt(n)) {
                                if (!o) {
                                    t = n + 1;
                                    break;
                                }
                            } else -1 === r && (o = !1, r = n + 1);
                            return -1 === r ? "" : e1.slice(t, r);
                        }(e1);
                        return e1 = t && e1.substr(-1 * t.length) === t ? e1.substr(0, e1.length - t.length) : e1;
                    }, u.extname = function(e1) {
                        "string" != typeof e1 && (e1 += "");
                        for(var t = -1, r = 0, o = -1, n = !0, s = 0, i = e1.length - 1; 0 <= i; --i){
                            var a = e1.charCodeAt(i);
                            if (47 === a) {
                                if (n) continue;
                                r = i + 1;
                                break;
                            }
                            -1 === o && (n = !1, o = i + 1), 46 === a ? -1 === t ? t = i : 1 !== s && (s = 1) : -1 !== t && (s = -1);
                        }
                        return -1 === t || -1 === o || 0 === s || 1 === s && t === o - 1 && t === r + 1 ? "" : e1.slice(t, o);
                    };
                    var o = "b" === "ab".substr(-1) ? function(e1, t, r) {
                        return e1.substr(t, r);
                    } : function(e1, t, r) {
                        return t < 0 && (t = e1.length + t), e1.substr(t, r);
                    };
                }).call(this, e1("_process"));
            },
            {
                _process: 251
            }
        ],
        251: [
            function(e1, t, r) {
                var o, n, t = t.exports = {};
                function s() {
                    throw new Error("setTimeout has not been defined");
                }
                function i() {
                    throw new Error("clearTimeout has not been defined");
                }
                try {
                    o = "function" == typeof setTimeout ? setTimeout : s;
                } catch (e1) {
                    o = s;
                }
                try {
                    n = "function" == typeof clearTimeout ? clearTimeout : i;
                } catch (e1) {
                    n = i;
                }
                function a(t) {
                    if (o === setTimeout) return setTimeout(t, 0);
                    if ((o === s || !o) && setTimeout) return (o = setTimeout)(t, 0);
                    try {
                        return o(t, 0);
                    } catch (e1) {
                        try {
                            return o.call(null, t, 0);
                        } catch (e1) {
                            return o.call(this, t, 0);
                        }
                    }
                }
                var l, u = [], c = !1, d = -1;
                function h() {
                    c && l && (c = !1, l.length ? u = l.concat(u) : d = -1, u.length && f());
                }
                function f() {
                    if (!c) {
                        for(var e1 = a(h), t = (c = !0, u.length); t;){
                            for(l = u, u = []; ++d < t;)l && l[d].run();
                            d = -1, t = u.length;
                        }
                        l = null, c = !1, !function(t) {
                            if (n === clearTimeout) return clearTimeout(t);
                            if ((n === i || !n) && clearTimeout) return (n = clearTimeout)(t);
                            try {
                                n(t);
                            } catch (e1) {
                                try {
                                    return n.call(null, t);
                                } catch (e1) {
                                    return n.call(this, t);
                                }
                            }
                        }(e1);
                    }
                }
                function p(e1, t) {
                    this.fun = e1, this.array = t;
                }
                function m() {}
                t.nextTick = function(e1) {
                    var t = new Array(arguments.length - 1);
                    if (1 < arguments.length) for(var r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
                    u.push(new p(e1, t)), 1 !== u.length || c || a(f);
                }, p.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, t.title = "browser", t.browser = !0, t.env = {}, t.argv = [], t.version = "", t.versions = {}, t.on = m, t.addListener = m, t.once = m, t.off = m, t.removeListener = m, t.removeAllListeners = m, t.emit = m, t.prependListener = m, t.prependOnceListener = m, t.listeners = function(e1) {
                    return [];
                }, t.binding = function(e1) {
                    throw new Error("process.binding is not supported");
                }, t.cwd = function() {
                    return "/";
                }, t.chdir = function(e1) {
                    throw new Error("process.chdir is not supported");
                }, t.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        252: [
            function(e1, t, r) {
                t = function(s) {
                    "use strict";
                    var l, e1 = Object.prototype, u = e1.hasOwnProperty, t = "function" == typeof Symbol ? Symbol : {}, o = t.iterator || "@@iterator", r = t.asyncIterator || "@@asyncIterator", n = t.toStringTag || "@@toStringTag";
                    function i(e1, t, r, o) {
                        var n, s, i, a, t = t && t.prototype instanceof y ? t : y, t = Object.create(t.prototype), o = new S(o || []);
                        return t._invoke = (n = e1, s = r, i = o, a = d, function(e1, t) {
                            if (a === f) throw new Error("Generator is already running");
                            if (a === p) {
                                if ("throw" === e1) throw t;
                                return M();
                            }
                            for(i.method = e1, i.arg = t;;){
                                var r = i.delegate;
                                if (r) {
                                    r = function e1(t, r) {
                                        var o = t.iterator[r.method];
                                        if (o === l) {
                                            if (r.delegate = null, "throw" === r.method) {
                                                if (t.iterator.return && (r.method = "return", r.arg = l, e1(t, r), "throw" === r.method)) return m;
                                                r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
                                            }
                                            return m;
                                        }
                                        o = c(o, t.iterator, r.arg);
                                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, m;
                                        o = o.arg;
                                        if (!o) return r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, m;
                                        if (!o.done) return o;
                                        r[t.resultName] = o.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = l);
                                        r.delegate = null;
                                        return m;
                                    }(r, i);
                                    if (r) {
                                        if (r === m) continue;
                                        return r;
                                    }
                                }
                                if ("next" === i.method) i.sent = i._sent = i.arg;
                                else if ("throw" === i.method) {
                                    if (a === d) throw a = p, i.arg;
                                    i.dispatchException(i.arg);
                                } else "return" === i.method && i.abrupt("return", i.arg);
                                a = f;
                                r = c(n, s, i);
                                if ("normal" === r.type) {
                                    if (a = i.done ? p : h, r.arg !== m) return {
                                        value: r.arg,
                                        done: i.done
                                    };
                                } else "throw" === r.type && (a = p, i.method = "throw", i.arg = r.arg);
                            }
                        }), t;
                    }
                    function c(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    s.wrap = i;
                    var d = "suspendedStart", h = "suspendedYield", f = "executing", p = "completed", m = {};
                    function y() {}
                    function a() {}
                    function g() {}
                    var t = {}, v = (t[o] = function() {
                        return this;
                    }, Object.getPrototypeOf), v = v && v(v(T([]))), b = (v && v !== e1 && u.call(v, o) && (t = v), g.prototype = y.prototype = Object.create(t));
                    function j(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            e1[t] = function(e1) {
                                return this._invoke(t, e1);
                            };
                        });
                    }
                    function _(i) {
                        var t;
                        this._invoke = function(r, o) {
                            function e1() {
                                return new Promise(function(e1, t) {
                                    !function t(e1, r, o, n) {
                                        var s, e1 = c(i[e1], i, r);
                                        if ("throw" !== e1.type) return (r = (s = e1.arg).value) && "object" == typeof r && u.call(r, "__await") ? Promise.resolve(r.__await).then(function(e1) {
                                            t("next", e1, o, n);
                                        }, function(e1) {
                                            t("throw", e1, o, n);
                                        }) : Promise.resolve(r).then(function(e1) {
                                            s.value = e1, o(s);
                                        }, function(e1) {
                                            return t("throw", e1, o, n);
                                        });
                                        n(e1.arg);
                                    }(r, o, e1, t);
                                });
                            }
                            return t = t ? t.then(e1, e1) : e1();
                        };
                    }
                    function x(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function w(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function S(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(x, this), this.reset(!0);
                    }
                    function T(t) {
                        if (t) {
                            var r, e1 = t[o];
                            if (e1) return e1.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) return r = -1, (e1 = function e1() {
                                for(; ++r < t.length;)if (u.call(t, r)) return e1.value = t[r], e1.done = !1, e1;
                                return e1.value = l, e1.done = !0, e1;
                            }).next = e1;
                        }
                        return {
                            next: M
                        };
                    }
                    function M() {
                        return {
                            value: l,
                            done: !0
                        };
                    }
                    return (a.prototype = b.constructor = g).constructor = a, g[n] = a.displayName = "GeneratorFunction", s.isGeneratorFunction = function(e1) {
                        e1 = "function" == typeof e1 && e1.constructor;
                        return !!e1 && (e1 === a || "GeneratorFunction" === (e1.displayName || e1.name));
                    }, s.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, g) : (e1.__proto__ = g, n in e1 || (e1[n] = "GeneratorFunction")), e1.prototype = Object.create(b), e1;
                    }, s.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, j(_.prototype), _.prototype[r] = function() {
                        return this;
                    }, s.AsyncIterator = _, s.async = function(e1, t, r, o) {
                        var n = new _(i(e1, t, r, o));
                        return s.isGeneratorFunction(t) ? n : n.next().then(function(e1) {
                            return e1.done ? e1.value : n.next();
                        });
                    }, j(b), b[n] = "Generator", b[o] = function() {
                        return this;
                    }, b.toString = function() {
                        return "[object Generator]";
                    }, s.keys = function(r) {
                        var e1, o = [];
                        for(e1 in r)o.push(e1);
                        return o.reverse(), function e1() {
                            for(; o.length;){
                                var t = o.pop();
                                if (t in r) return e1.value = t, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, s.values = T, S.prototype = {
                        constructor: S,
                        reset: function(e1) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = l, this.done = !1, this.delegate = null, this.method = "next", this.arg = l, this.tryEntries.forEach(w), !e1) for(var t in this)"t" === t.charAt(0) && u.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = l);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(r) {
                            if (this.done) throw r;
                            var o = this;
                            function e1(e1, t) {
                                return s.type = "throw", s.arg = r, o.next = e1, t && (o.method = "next", o.arg = l), !!t;
                            }
                            for(var t = this.tryEntries.length - 1; 0 <= t; --t){
                                var n = this.tryEntries[t], s = n.completion;
                                if ("root" === n.tryLoc) return e1("end");
                                if (n.tryLoc <= this.prev) {
                                    var i = u.call(n, "catchLoc"), a = u.call(n, "finallyLoc");
                                    if (i && a) {
                                        if (this.prev < n.catchLoc) return e1(n.catchLoc, !0);
                                        if (this.prev < n.finallyLoc) return e1(n.finallyLoc);
                                    } else if (i) {
                                        if (this.prev < n.catchLoc) return e1(n.catchLoc, !0);
                                    } else {
                                        if (!a) throw new Error("try statement without catch or finally");
                                        if (this.prev < n.finallyLoc) return e1(n.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; 0 <= r; --r){
                                var o = this.tryEntries[r];
                                if (o.tryLoc <= this.prev && u.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                                    var n = o;
                                    break;
                                }
                            }
                            var s = (n = n && ("break" === e1 || "continue" === e1) && n.tryLoc <= t && t <= n.finallyLoc ? null : n) ? n.completion : {};
                            return s.type = e1, s.arg = t, n ? (this.method = "next", this.next = n.finallyLoc, m) : this.complete(s);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), m;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; 0 <= t; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), w(r), m;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; 0 <= t; --t){
                                var r, o, n = this.tryEntries[t];
                                if (n.tryLoc === e1) return "throw" === (r = n.completion).type && (o = r.arg, w(n)), o;
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(e1, t, r) {
                            return this.delegate = {
                                iterator: T(e1),
                                resultName: t,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = l), m;
                        }
                    }, s;
                }("object" == typeof t ? t.exports : {});
                try {
                    regeneratorRuntime = t;
                } catch (e1) {
                    Function("r", "regeneratorRuntime = r")(t);
                }
            },
            {}
        ],
        253: [
            function(e1, t, r) {
                !function(e1) {
                    "use strict";
                    var t, r, i, o, n, s, a, l, u, c;
                    function d(e1) {
                        if ("string" != typeof e1 && (e1 = String(e1)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(e1)) throw new TypeError("Invalid character in header field name");
                        return e1.toLowerCase();
                    }
                    function h(e1) {
                        return e1 = "string" != typeof e1 ? String(e1) : e1;
                    }
                    function f(t) {
                        var e1 = {
                            next: function() {
                                var e1 = t.shift();
                                return {
                                    done: void 0 === e1,
                                    value: e1
                                };
                            }
                        };
                        return r && (e1[Symbol.iterator] = function() {
                            return e1;
                        }), e1;
                    }
                    function p(t) {
                        this.map = {}, t instanceof p ? t.forEach(function(e1, t) {
                            this.append(t, e1);
                        }, this) : Array.isArray(t) ? t.forEach(function(e1) {
                            this.append(e1[0], e1[1]);
                        }, this) : t && Object.getOwnPropertyNames(t).forEach(function(e1) {
                            this.append(e1, t[e1]);
                        }, this);
                    }
                    function m(e1) {
                        if (e1.bodyUsed) return Promise.reject(new TypeError("Already read"));
                        e1.bodyUsed = !0;
                    }
                    function y(r) {
                        return new Promise(function(e1, t) {
                            r.onload = function() {
                                e1(r.result);
                            }, r.onerror = function() {
                                t(r.error);
                            };
                        });
                    }
                    function g(e1) {
                        var t = new FileReader, r = y(t);
                        return t.readAsArrayBuffer(e1), r;
                    }
                    function v(e1) {
                        var t;
                        return e1.slice ? e1.slice(0) : ((t = new Uint8Array(e1.byteLength)).set(new Uint8Array(e1)), t.buffer);
                    }
                    function b() {
                        return this.bodyUsed = !1, this._initBody = function(e1) {
                            if (this._bodyInit = e1) {
                                if ("string" == typeof e1) this._bodyText = e1;
                                else if (i && Blob.prototype.isPrototypeOf(e1)) this._bodyBlob = e1;
                                else if (o && FormData.prototype.isPrototypeOf(e1)) this._bodyFormData = e1;
                                else if (t && URLSearchParams.prototype.isPrototypeOf(e1)) this._bodyText = e1.toString();
                                else if (n && i && a(e1)) this._bodyArrayBuffer = v(e1.buffer), this._bodyInit = new Blob([
                                    this._bodyArrayBuffer
                                ]);
                                else {
                                    if (!n || !ArrayBuffer.prototype.isPrototypeOf(e1) && !l(e1)) throw new Error("unsupported BodyInit type");
                                    this._bodyArrayBuffer = v(e1);
                                }
                            } else this._bodyText = "";
                            this.headers.get("content-type") || ("string" == typeof e1 ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : t && URLSearchParams.prototype.isPrototypeOf(e1) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                        }, i && (this.blob = function() {
                            var e1 = m(this);
                            if (e1) return e1;
                            if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                            if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                                this._bodyArrayBuffer
                            ]));
                            if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                            return Promise.resolve(new Blob([
                                this._bodyText
                            ]));
                        }, this.arrayBuffer = function() {
                            return this._bodyArrayBuffer ? m(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(g);
                        }), this.text = function() {
                            var e1, t, r = m(this);
                            if (r) return r;
                            if (this._bodyBlob) return r = this._bodyBlob, e1 = new FileReader, t = y(e1), e1.readAsText(r), t;
                            if (this._bodyArrayBuffer) return Promise.resolve(function(e1) {
                                for(var t = new Uint8Array(e1), r = new Array(t.length), o = 0; o < t.length; o++)r[o] = String.fromCharCode(t[o]);
                                return r.join("");
                            }(this._bodyArrayBuffer));
                            if (this._bodyFormData) throw new Error("could not read FormData body as text");
                            return Promise.resolve(this._bodyText);
                        }, o && (this.formData = function() {
                            return this.text().then(_);
                        }), this.json = function() {
                            return this.text().then(JSON.parse);
                        }, this;
                    }
                    function j(e1, t) {
                        var r, o = (t = t || {}).body;
                        if (e1 instanceof j) {
                            if (e1.bodyUsed) throw new TypeError("Already read");
                            this.url = e1.url, this.credentials = e1.credentials, t.headers || (this.headers = new p(e1.headers)), this.method = e1.method, this.mode = e1.mode, o || null == e1._bodyInit || (o = e1._bodyInit, e1.bodyUsed = !0);
                        } else this.url = String(e1);
                        if (this.credentials = t.credentials || this.credentials || "omit", !t.headers && this.headers || (this.headers = new p(t.headers)), this.method = (e1 = t.method || this.method || "GET", r = e1.toUpperCase(), -1 < u.indexOf(r) ? r : e1), this.mode = t.mode || this.mode || null, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");
                        this._initBody(o);
                    }
                    function _(e1) {
                        var r = new FormData;
                        return e1.trim().split("&").forEach(function(e1) {
                            var t;
                            e1 && (t = (e1 = e1.split("=")).shift().replace(/\+/g, " "), e1 = e1.join("=").replace(/\+/g, " "), r.append(decodeURIComponent(t), decodeURIComponent(e1)));
                        }), r;
                    }
                    function x(e1, t) {
                        t = t || {}, this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = 200 <= this.status && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new p(t.headers), this.url = t.url || "", this._initBody(e1);
                    }
                    e1.fetch || (t = "URLSearchParams" in e1, r = "Symbol" in e1 && "iterator" in Symbol, i = "FileReader" in e1 && "Blob" in e1 && function() {
                        try {
                            return new Blob, !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), o = "FormData" in e1, (n = "ArrayBuffer" in e1) && (s = [
                        "[object Int8Array]",
                        "[object Uint8Array]",
                        "[object Uint8ClampedArray]",
                        "[object Int16Array]",
                        "[object Uint16Array]",
                        "[object Int32Array]",
                        "[object Uint32Array]",
                        "[object Float32Array]",
                        "[object Float64Array]"
                    ], a = function(e1) {
                        return e1 && DataView.prototype.isPrototypeOf(e1);
                    }, l = ArrayBuffer.isView || function(e1) {
                        return e1 && -1 < s.indexOf(Object.prototype.toString.call(e1));
                    }), p.prototype.append = function(e1, t) {
                        e1 = d(e1), t = h(t);
                        var r = this.map[e1];
                        this.map[e1] = r ? r + "," + t : t;
                    }, p.prototype.delete = function(e1) {
                        delete this.map[d(e1)];
                    }, p.prototype.get = function(e1) {
                        return e1 = d(e1), this.has(e1) ? this.map[e1] : null;
                    }, p.prototype.has = function(e1) {
                        return this.map.hasOwnProperty(d(e1));
                    }, p.prototype.set = function(e1, t) {
                        this.map[d(e1)] = h(t);
                    }, p.prototype.forEach = function(e1, t) {
                        for(var r in this.map)this.map.hasOwnProperty(r) && e1.call(t, this.map[r], r, this);
                    }, p.prototype.keys = function() {
                        var r = [];
                        return this.forEach(function(e1, t) {
                            r.push(t);
                        }), f(r);
                    }, p.prototype.values = function() {
                        var t = [];
                        return this.forEach(function(e1) {
                            t.push(e1);
                        }), f(t);
                    }, p.prototype.entries = function() {
                        var r = [];
                        return this.forEach(function(e1, t) {
                            r.push([
                                t,
                                e1
                            ]);
                        }), f(r);
                    }, r && (p.prototype[Symbol.iterator] = p.prototype.entries), u = [
                        "DELETE",
                        "GET",
                        "HEAD",
                        "OPTIONS",
                        "POST",
                        "PUT"
                    ], j.prototype.clone = function() {
                        return new j(this, {
                            body: this._bodyInit
                        });
                    }, b.call(j.prototype), b.call(x.prototype), x.prototype.clone = function() {
                        return new x(this._bodyInit, {
                            status: this.status,
                            statusText: this.statusText,
                            headers: new p(this.headers),
                            url: this.url
                        });
                    }, x.error = function() {
                        var e1 = new x(null, {
                            status: 0,
                            statusText: ""
                        });
                        return e1.type = "error", e1;
                    }, c = [
                        301,
                        302,
                        303,
                        307,
                        308
                    ], x.redirect = function(e1, t) {
                        if (-1 === c.indexOf(t)) throw new RangeError("Invalid status code");
                        return new x(null, {
                            status: t,
                            headers: {
                                location: e1
                            }
                        });
                    }, e1.Headers = p, e1.Request = j, e1.Response = x, e1.fetch = function(r, s) {
                        return new Promise(function(o, e1) {
                            var t = new j(r, s), n = new XMLHttpRequest;
                            n.onload = function() {
                                var r, e1 = {
                                    status: n.status,
                                    statusText: n.statusText,
                                    headers: (e1 = n.getAllResponseHeaders() || "", r = new p, e1.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function(e1) {
                                        var e1 = e1.split(":"), t = e1.shift().trim();
                                        t && (e1 = e1.join(":").trim(), r.append(t, e1));
                                    }), r)
                                }, t = (e1.url = "responseURL" in n ? n.responseURL : e1.headers.get("X-Request-URL"), "response" in n ? n.response : n.responseText);
                                o(new x(t, e1));
                            }, n.onerror = function() {
                                e1(new TypeError("Network request failed"));
                            }, n.ontimeout = function() {
                                e1(new TypeError("Network request failed"));
                            }, n.open(t.method, t.url, !0), "include" === t.credentials ? n.withCredentials = !0 : "omit" === t.credentials && (n.withCredentials = !1), "responseType" in n && i && (n.responseType = "blob"), t.headers.forEach(function(e1, t) {
                                n.setRequestHeader(t, e1);
                            }), n.send(void 0 === t._bodyInit ? null : t._bodyInit);
                        });
                    }, e1.fetch.polyfill = !0);
                }("undefined" != typeof self ? self : this);
            },
            {}
        ],
        254: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.split"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l, o = n(e1("../core/main")), u = n(e1("../color/color_conversion"));
                function n(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                var c = [
                    {
                        h: 0,
                        s: 0,
                        b: .8275,
                        name: "gray"
                    },
                    {
                        h: 0,
                        s: 0,
                        b: .8627,
                        name: "gray"
                    },
                    {
                        h: 0,
                        s: 0,
                        b: .7529,
                        name: "gray"
                    },
                    {
                        h: .0167,
                        s: .1176,
                        b: 1,
                        name: "light pink"
                    }
                ], d = [
                    {
                        h: 0,
                        s: 0,
                        b: 0,
                        name: "black"
                    },
                    {
                        h: 0,
                        s: 0,
                        b: .5,
                        name: "gray"
                    },
                    {
                        h: 0,
                        s: 0,
                        b: 1,
                        name: "white"
                    },
                    {
                        h: 0,
                        s: .5,
                        b: .5,
                        name: "dark maroon"
                    },
                    {
                        h: 0,
                        s: .5,
                        b: 1,
                        name: "salmon pink"
                    },
                    {
                        h: 0,
                        s: 1,
                        b: 0,
                        name: "black"
                    },
                    {
                        h: 0,
                        s: 1,
                        b: .5,
                        name: "dark red"
                    },
                    {
                        h: 0,
                        s: 1,
                        b: 1,
                        name: "red"
                    },
                    {
                        h: 5,
                        s: 0,
                        b: 1,
                        name: "very light peach"
                    },
                    {
                        h: 5,
                        s: .5,
                        b: .5,
                        name: "brown"
                    },
                    {
                        h: 5,
                        s: .5,
                        b: 1,
                        name: "peach"
                    },
                    {
                        h: 5,
                        s: 1,
                        b: .5,
                        name: "brick red"
                    },
                    {
                        h: 5,
                        s: 1,
                        b: 1,
                        name: "crimson"
                    },
                    {
                        h: 10,
                        s: 0,
                        b: 1,
                        name: "light peach"
                    },
                    {
                        h: 10,
                        s: .5,
                        b: .5,
                        name: "brown"
                    },
                    {
                        h: 10,
                        s: .5,
                        b: 1,
                        name: "light orange"
                    },
                    {
                        h: 10,
                        s: 1,
                        b: .5,
                        name: "brown"
                    },
                    {
                        h: 10,
                        s: 1,
                        b: 1,
                        name: "orange"
                    },
                    {
                        h: 15,
                        s: 0,
                        b: 1,
                        name: "very light yellow"
                    },
                    {
                        h: 15,
                        s: .5,
                        b: .5,
                        name: "olive green"
                    },
                    {
                        h: 15,
                        s: .5,
                        b: 1,
                        name: "light yellow"
                    },
                    {
                        h: 15,
                        s: 1,
                        b: 0,
                        name: "dark olive green"
                    },
                    {
                        h: 15,
                        s: 1,
                        b: .5,
                        name: "olive green"
                    },
                    {
                        h: 15,
                        s: 1,
                        b: 1,
                        name: "yellow"
                    },
                    {
                        h: 20,
                        s: 0,
                        b: 1,
                        name: "very light yellow"
                    },
                    {
                        h: 20,
                        s: .5,
                        b: .5,
                        name: "olive green"
                    },
                    {
                        h: 20,
                        s: .5,
                        b: 1,
                        name: "light yellow green"
                    },
                    {
                        h: 20,
                        s: 1,
                        b: 0,
                        name: "dark olive green"
                    },
                    {
                        h: 20,
                        s: 1,
                        b: .5,
                        name: "dark yellow green"
                    },
                    {
                        h: 20,
                        s: 1,
                        b: 1,
                        name: "yellow green"
                    },
                    {
                        h: 25,
                        s: .5,
                        b: .5,
                        name: "dark yellow green"
                    },
                    {
                        h: 25,
                        s: .5,
                        b: 1,
                        name: "light green"
                    },
                    {
                        h: 25,
                        s: 1,
                        b: .5,
                        name: "dark green"
                    },
                    {
                        h: 25,
                        s: 1,
                        b: 1,
                        name: "green"
                    },
                    {
                        h: 30,
                        s: .5,
                        b: 1,
                        name: "light green"
                    },
                    {
                        h: 30,
                        s: 1,
                        b: .5,
                        name: "dark green"
                    },
                    {
                        h: 30,
                        s: 1,
                        b: 1,
                        name: "green"
                    },
                    {
                        h: 35,
                        s: 0,
                        b: .5,
                        name: "light green"
                    },
                    {
                        h: 35,
                        s: 0,
                        b: 1,
                        name: "very light green"
                    },
                    {
                        h: 35,
                        s: .5,
                        b: .5,
                        name: "dark green"
                    },
                    {
                        h: 35,
                        s: .5,
                        b: 1,
                        name: "light green"
                    },
                    {
                        h: 35,
                        s: 1,
                        b: 0,
                        name: "very dark green"
                    },
                    {
                        h: 35,
                        s: 1,
                        b: .5,
                        name: "dark green"
                    },
                    {
                        h: 35,
                        s: 1,
                        b: 1,
                        name: "green"
                    },
                    {
                        h: 40,
                        s: 0,
                        b: 1,
                        name: "very light green"
                    },
                    {
                        h: 40,
                        s: .5,
                        b: .5,
                        name: "dark green"
                    },
                    {
                        h: 40,
                        s: .5,
                        b: 1,
                        name: "light green"
                    },
                    {
                        h: 40,
                        s: 1,
                        b: .5,
                        name: "dark green"
                    },
                    {
                        h: 40,
                        s: 1,
                        b: 1,
                        name: "green"
                    },
                    {
                        h: 45,
                        s: .5,
                        b: 1,
                        name: "light turquoise"
                    },
                    {
                        h: 45,
                        s: 1,
                        b: .5,
                        name: "dark turquoise"
                    },
                    {
                        h: 45,
                        s: 1,
                        b: 1,
                        name: "turquoise"
                    },
                    {
                        h: 50,
                        s: 0,
                        b: 1,
                        name: "light sky blue"
                    },
                    {
                        h: 50,
                        s: .5,
                        b: .5,
                        name: "dark cyan"
                    },
                    {
                        h: 50,
                        s: .5,
                        b: 1,
                        name: "light cyan"
                    },
                    {
                        h: 50,
                        s: 1,
                        b: .5,
                        name: "dark cyan"
                    },
                    {
                        h: 50,
                        s: 1,
                        b: 1,
                        name: "cyan"
                    },
                    {
                        h: 55,
                        s: 0,
                        b: 1,
                        name: "light sky blue"
                    },
                    {
                        h: 55,
                        s: .5,
                        b: 1,
                        name: "light sky blue"
                    },
                    {
                        h: 55,
                        s: 1,
                        b: .5,
                        name: "dark blue"
                    },
                    {
                        h: 55,
                        s: 1,
                        b: 1,
                        name: "sky blue"
                    },
                    {
                        h: 60,
                        s: 0,
                        b: .5,
                        name: "gray"
                    },
                    {
                        h: 60,
                        s: 0,
                        b: 1,
                        name: "very light blue"
                    },
                    {
                        h: 60,
                        s: .5,
                        b: .5,
                        name: "blue"
                    },
                    {
                        h: 60,
                        s: .5,
                        b: 1,
                        name: "light blue"
                    },
                    {
                        h: 60,
                        s: 1,
                        b: .5,
                        name: "navy blue"
                    },
                    {
                        h: 60,
                        s: 1,
                        b: 1,
                        name: "blue"
                    },
                    {
                        h: 65,
                        s: 0,
                        b: 1,
                        name: "lavender"
                    },
                    {
                        h: 65,
                        s: .5,
                        b: .5,
                        name: "navy blue"
                    },
                    {
                        h: 65,
                        s: .5,
                        b: 1,
                        name: "light purple"
                    },
                    {
                        h: 65,
                        s: 1,
                        b: .5,
                        name: "dark navy blue"
                    },
                    {
                        h: 65,
                        s: 1,
                        b: 1,
                        name: "blue"
                    },
                    {
                        h: 70,
                        s: 0,
                        b: 1,
                        name: "lavender"
                    },
                    {
                        h: 70,
                        s: .5,
                        b: .5,
                        name: "navy blue"
                    },
                    {
                        h: 70,
                        s: .5,
                        b: 1,
                        name: "lavender blue"
                    },
                    {
                        h: 70,
                        s: 1,
                        b: .5,
                        name: "dark navy blue"
                    },
                    {
                        h: 70,
                        s: 1,
                        b: 1,
                        name: "blue"
                    },
                    {
                        h: 75,
                        s: .5,
                        b: 1,
                        name: "lavender"
                    },
                    {
                        h: 75,
                        s: 1,
                        b: .5,
                        name: "dark purple"
                    },
                    {
                        h: 75,
                        s: 1,
                        b: 1,
                        name: "purple"
                    },
                    {
                        h: 80,
                        s: .5,
                        b: 1,
                        name: "pinkish purple"
                    },
                    {
                        h: 80,
                        s: 1,
                        b: .5,
                        name: "dark purple"
                    },
                    {
                        h: 80,
                        s: 1,
                        b: 1,
                        name: "purple"
                    },
                    {
                        h: 85,
                        s: 0,
                        b: 1,
                        name: "light pink"
                    },
                    {
                        h: 85,
                        s: .5,
                        b: .5,
                        name: "purple"
                    },
                    {
                        h: 85,
                        s: .5,
                        b: 1,
                        name: "light fuchsia"
                    },
                    {
                        h: 85,
                        s: 1,
                        b: .5,
                        name: "dark fuchsia"
                    },
                    {
                        h: 85,
                        s: 1,
                        b: 1,
                        name: "fuchsia"
                    },
                    {
                        h: 90,
                        s: .5,
                        b: .5,
                        name: "dark fuchsia"
                    },
                    {
                        h: 90,
                        s: .5,
                        b: 1,
                        name: "hot pink"
                    },
                    {
                        h: 90,
                        s: 1,
                        b: .5,
                        name: "dark fuchsia"
                    },
                    {
                        h: 90,
                        s: 1,
                        b: 1,
                        name: "fuchsia"
                    },
                    {
                        h: 95,
                        s: 0,
                        b: 1,
                        name: "pink"
                    },
                    {
                        h: 95,
                        s: .5,
                        b: 1,
                        name: "light pink"
                    },
                    {
                        h: 95,
                        s: 1,
                        b: .5,
                        name: "dark magenta"
                    },
                    {
                        h: 95,
                        s: 1,
                        b: 1,
                        name: "magenta"
                    }
                ];
                o.default.prototype._rgbColorName = function(e1) {
                    var t, r, e1 = u.default._rgbaToHSBA(e1), o = [
                        (l = e1)[0],
                        e1[1],
                        e1[2]
                    ];
                    0 !== o[0] && (o[0] = Math.round(100 * o[0]), (e1 = o[0].toString().split(""))[r = e1.length - 1] = parseInt(e1[r]), e1[r] < 2.5 ? e1[r] = 0 : 2.5 <= e1[r] && e1[r] < 7.5 && (e1[r] = 5), 2 === e1.length ? (e1[0] = parseInt(e1[0]), 7.5 <= e1[r] && (e1[r] = 0, e1[0] = e1[0] + 1), o[0] = 10 * e1[0] + e1[1]) : 7.5 <= e1[r] ? o[0] = 10 : o[0] = e1[r]), o[2] = o[2] / 255;
                    for(var n = o.length - 1; 1 <= n; n--)o[n] <= .25 ? o[n] = 0 : .25 < o[n] && o[n] < .75 ? o[n] = .5 : o[n] = 1;
                    if (0 === o[0] && 0 === o[1] && 1 === o[2]) {
                        for(var s = 2; 0 <= s; s--)l[s] = Math.round(1e4 * l[s]) / 1e4;
                        for(var i = 0; i < c.length; i++){
                            if (c[i].h === l[0] && c[i].s === l[1] && c[i].b === l[2]) {
                                t = c[i].name;
                                break;
                            }
                            t = "white";
                        }
                    } else for(var a = 0; a < d.length; a++)if (d[a].h === o[0] && d[a].s === o[1] && d[a].b === o[2]) {
                        t = d[a].name;
                        break;
                    }
                    return t;
                };
                e1 = o.default;
                r.default = e1;
            },
            {
                "../color/color_conversion": 260,
                "../core/main": 275,
                "core-js/modules/es.function.name": 168,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.split": 198
            }
        ],
        255: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.ends-with"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.ends-with"), e1("core-js/modules/es.string.replace"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                var i = "_Description", a = "_fallbackDesc", l = "_fallbackTable", u = "_Label", c = "_labelDesc", d = "_labelTable";
                function h(e1) {
                    if ("label" === e1 || "fallback" === e1) throw new Error("description should not be LABEL or FALLBACK");
                    return e1.endsWith(".") || e1.endsWith(";") || e1.endsWith(",") || e1.endsWith("?") || e1.endsWith("!") || (e1 += "."), e1;
                }
                s.default.prototype.describe = function(e1, t) {
                    var r;
                    s.default._validateParameters("describe", arguments), "string" == typeof e1 && (r = this.canvas.id, e1 = h(e1), this.dummyDOM || (this.dummyDOM = document.getElementById(r).parentNode), this.descriptions || (this.descriptions = {}), this.descriptions.fallback ? this.descriptions.fallback.innerHTML !== e1 && (this.descriptions.fallback.innerHTML = e1) : this._describeHTML("fallback", e1), t === this.LABEL && (this.descriptions.label ? this.descriptions.label.innerHTML !== e1 && (this.descriptions.label.innerHTML = e1) : this._describeHTML("label", e1)));
                }, s.default.prototype.describeElement = function(e1, t, r) {
                    var o, n;
                    s.default._validateParameters("describeElement", arguments), "string" == typeof t && "string" == typeof e1 && (o = this.canvas.id, t = h(t), n = function(e1) {
                        if ("label" === e1 || "fallback" === e1) throw new Error("element name should not be LABEL or FALLBACK");
                        e1.endsWith(".") || e1.endsWith(";") || e1.endsWith(",") ? e1 = e1.replace(/.$/, ":") : e1.endsWith(":") || (e1 += ":");
                        return e1;
                    }(e1), e1 = e1.replace(/[^a-zA-Z0-9]/g, ""), n = '<th scope="row">'.concat(n, "</th><td>").concat(t, "</td>"), this.dummyDOM || (this.dummyDOM = document.getElementById(o).parentNode), this.descriptions ? this.descriptions.fallbackElements || (this.descriptions.fallbackElements = {}) : this.descriptions = {
                        fallbackElements: {}
                    }, this.descriptions.fallbackElements[e1] ? this.descriptions.fallbackElements[e1].innerHTML !== n && (this.descriptions.fallbackElements[e1].innerHTML = n) : this._describeElementHTML("fallback", e1, n), r === this.LABEL && (this.descriptions.labelElements || (this.descriptions.labelElements = {}), this.descriptions.labelElements[e1] ? this.descriptions.labelElements[e1].innerHTML !== n && (this.descriptions.labelElements[e1].innerHTML = n) : this._describeElementHTML("label", e1, n)));
                }, s.default.prototype._describeHTML = function(e1, t) {
                    var r, o = this.canvas.id;
                    "fallback" === e1 ? (this.dummyDOM.querySelector("#".concat(o + i)) ? this.dummyDOM.querySelector("#" + o + l).insertAdjacentHTML("beforebegin", '<p id="'.concat(o + a, '"></p>')) : (r = '<div id="'.concat(o).concat(i, '" role="region" aria-label="Canvas Description"><p id="').concat(o).concat(a, '"></p></div>'), this.dummyDOM.querySelector("#".concat(o, "accessibleOutput")) ? this.dummyDOM.querySelector("#".concat(o, "accessibleOutput")).insertAdjacentHTML("beforebegin", r) : this.dummyDOM.querySelector("#".concat(o)).innerHTML = r), this.descriptions.fallback = this.dummyDOM.querySelector("#".concat(o).concat(a)), this.descriptions.fallback.innerHTML = t) : "label" === e1 && (this.dummyDOM.querySelector("#".concat(o + u)) ? this.dummyDOM.querySelector("#".concat(o + d)) && this.dummyDOM.querySelector("#".concat(o + d)).insertAdjacentHTML("beforebegin", '<p id="'.concat(o).concat(c, '"></p>')) : (r = '<div id="'.concat(o).concat(u, '" class="p5Label"><p id="').concat(o).concat(c, '"></p></div>'), this.dummyDOM.querySelector("#".concat(o, "accessibleOutputLabel")) ? this.dummyDOM.querySelector("#".concat(o, "accessibleOutputLabel")).insertAdjacentHTML("beforebegin", r) : this.dummyDOM.querySelector("#" + o).insertAdjacentHTML("afterend", r)), this.descriptions.label = this.dummyDOM.querySelector("#" + o + c), this.descriptions.label.innerHTML = t);
                }, s.default.prototype._describeElementHTML = function(e1, t, r) {
                    var o, n = this.canvas.id;
                    "fallback" === e1 ? (this.dummyDOM.querySelector("#".concat(n + i)) ? this.dummyDOM.querySelector("#" + n + l) || this.dummyDOM.querySelector("#" + n + a).insertAdjacentHTML("afterend", '<table id="'.concat(n).concat(l, '"><caption>Canvas elements and their descriptions</caption></table>')) : (o = '<div id="'.concat(n).concat(i, '" role="region" aria-label="Canvas Description"><table id="').concat(n).concat(l, '"><caption>Canvas elements and their descriptions</caption></table></div>'), this.dummyDOM.querySelector("#".concat(n, "accessibleOutput")) ? this.dummyDOM.querySelector("#".concat(n, "accessibleOutput")).insertAdjacentHTML("beforebegin", o) : this.dummyDOM.querySelector("#" + n).innerHTML = o), (o = document.createElement("tr")).id = n + "_fte_" + t, this.dummyDOM.querySelector("#" + n + l).appendChild(o), this.descriptions.fallbackElements[t] = this.dummyDOM.querySelector("#".concat(n).concat("_fte_").concat(t)), this.descriptions.fallbackElements[t].innerHTML = r) : "label" === e1 && (this.dummyDOM.querySelector("#".concat(n + u)) ? this.dummyDOM.querySelector("#".concat(n + d)) || this.dummyDOM.querySelector("#" + n + c).insertAdjacentHTML("afterend", '<table id="'.concat(n + d, '"></table>')) : (o = '<div id="'.concat(n).concat(u, '" class="p5Label"><table id="').concat(n).concat(d, '"></table></div>'), this.dummyDOM.querySelector("#".concat(n, "accessibleOutputLabel")) ? this.dummyDOM.querySelector("#".concat(n, "accessibleOutputLabel")).insertAdjacentHTML("beforebegin", o) : this.dummyDOM.querySelector("#" + n).insertAdjacentHTML("afterend", o)), (e1 = document.createElement("tr")).id = n + "_lte_" + t, this.dummyDOM.querySelector("#" + n + d).appendChild(e1), this.descriptions.labelElements[t] = this.dummyDOM.querySelector("#".concat(n).concat("_lte_").concat(t)), this.descriptions.labelElements[t].innerHTML = r);
                };
                e1 = s.default;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.string.ends-with": 190,
                "core-js/modules/es.string.replace": 196
            }
        ],
        256: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.string.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype._updateGridOutput = function(e1) {
                    var t, r, o, n;
                    this.dummyDOM.querySelector("#".concat(e1, "_summary")) && (t = this._accessibleOutputs[e1], o = function(e1, t, r, o) {
                        t = "".concat(t, " canvas, ").concat(r, " by ").concat(o, " pixels, contains ").concat(e1[0]);
                        t = (1 === e1[0] ? "".concat(t, " shape: ") : "".concat(t, " shapes: ")).concat(e1[1]);
                        return t;
                    }((r = function(e1, t) {
                        var r, o = "", n = "", s = 0;
                        for(r in t){
                            var i, a = 0;
                            for(i in t[r]){
                                var l = '<li id="'.concat(e1, "shape").concat(s, '">').concat(t[r][i].color, " ").concat(r, ",");
                                "line" === r ? l += " location = ".concat(t[r][i].pos, ", length = ").concat(t[r][i].length, " pixels") : (l += " location = ".concat(t[r][i].pos), "point" !== r && (l += ", area = ".concat(t[r][i].area, " %")), l += "</li>"), o += l, a++, s++;
                            }
                            n = 1 < a ? "".concat(n, " ").concat(a, " ").concat(r, "s") : "".concat(n, " ").concat(a, " ").concat(r);
                        }
                        return {
                            numShapes: [
                                s,
                                n
                            ],
                            details: o
                        };
                    }(e1, this.ingredients.shapes)).numShapes, this.ingredients.colors.background, this.width, this.height), n = function(e1, t) {
                        var r, o, n = 0, s = "", i = Array.from(Array(10), function() {
                            return Array(10);
                        });
                        for(r in t)for(var a in t[r]){
                            var l = void 0;
                            l = "line" !== r ? '<a href="#'.concat(e1, "shape").concat(n, '">').concat(t[r][a].color, " ").concat(r, "</a>") : '<a href="#'.concat(e1, "shape").concat(n, '">').concat(t[r][a].color, " ").concat(r, " midpoint</a>"), i[t[r][a].loc.locY][t[r][a].loc.locX] ? i[t[r][a].loc.locY][t[r][a].loc.locX] = i[t[r][a].loc.locY][t[r][a].loc.locX] + "  " + l : i[t[r][a].loc.locY][t[r][a].loc.locX] = l, n++;
                        }
                        for(o in i){
                            var u, c = "<tr>";
                            for(u in i[o])c += "<td>", void 0 !== i[o][u] && (c += i[o][u]), c += "</td>";
                            s = s + c + "</tr>";
                        }
                        return s;
                    }(e1, this.ingredients.shapes), o !== t.summary.innerHTML && (t.summary.innerHTML = o), n !== t.map.innerHTML && (t.map.innerHTML = n), r.details !== t.shapeDetails.innerHTML && (t.shapeDetails.innerHTML = r.details), this._accessibleOutputs[e1] = t);
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.from": 158,
                "core-js/modules/es.array.map": 164,
                "core-js/modules/es.string.iterator": 192
            }
        ],
        257: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.number.to-fixed"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var o = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function l(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                function u(e1, t, r) {
                    t = Math.floor(e1[0] / t * 10), e1 = Math.floor(e1[1] / r * 10);
                    return 10 === t && (t -= 1), 10 === e1 && (e1 -= 1), {
                        locX: t,
                        locY: e1
                    };
                }
                o.default.prototype.textOutput = function(e1) {
                    o.default._validateParameters("textOutput", arguments), this._accessibleOutputs.text || (this._accessibleOutputs.text = !0, this._createOutput("textOutput", "Fallback"), e1 === this.LABEL && (this._accessibleOutputs.textLabel = !0, this._createOutput("textOutput", "Label")));
                }, o.default.prototype.gridOutput = function(e1) {
                    o.default._validateParameters("gridOutput", arguments), this._accessibleOutputs.grid || (this._accessibleOutputs.grid = !0, this._createOutput("gridOutput", "Fallback"), e1 === this.LABEL && (this._accessibleOutputs.gridLabel = !0, this._createOutput("gridOutput", "Label")));
                }, o.default.prototype._addAccsOutput = function() {
                    return this._accessibleOutputs || (this._accessibleOutputs = {
                        text: !1,
                        grid: !1,
                        textLabel: !1,
                        gridLabel: !1
                    }), this._accessibleOutputs.grid || this._accessibleOutputs.text;
                }, o.default.prototype._createOutput = function(e1, t) {
                    var r, o, n, s = this.canvas.id, i = (this.ingredients || (this.ingredients = {
                        shapes: {},
                        colors: {
                            background: "white",
                            fill: "white",
                            stroke: "black"
                        },
                        pShapes: ""
                    }), this.dummyDOM || (this.dummyDOM = document.getElementById(s).parentNode), "");
                    "Fallback" === t ? (r = s + e1, this.dummyDOM.querySelector("#".concat(o = s + "accessibleOutput")) || (this.dummyDOM.querySelector("#".concat(s, "_Description")) ? this.dummyDOM.querySelector("#".concat(s, "_Description")).insertAdjacentHTML("afterend", '<div id="'.concat(o, '" role="region" aria-label="Canvas Outputs"></div>')) : this.dummyDOM.querySelector("#".concat(s)).innerHTML = '<div id="'.concat(o, '" role="region" aria-label="Canvas Outputs"></div>'))) : "Label" === t && (r = s + e1 + (i = t), this.dummyDOM.querySelector("#".concat(o = s + "accessibleOutput" + t)) || (this.dummyDOM.querySelector("#".concat(s, "_Label")) ? this.dummyDOM.querySelector("#".concat(s, "_Label")) : this.dummyDOM.querySelector("#".concat(s))).insertAdjacentHTML("afterend", '<div id="'.concat(o, '"></div>'))), this._accessibleOutputs[r] = {}, "textOutput" === e1 ? (i = "#".concat(s, "gridOutput").concat(i), n = '<div id="'.concat(r, '">Text Output<div id="').concat(r, 'Summary" aria-label="text output summary"><p id="').concat(r, '_summary"></p><ul id="').concat(r, '_list"></ul></div><table id="').concat(r, '_shapeDetails" summary="text output shape details"></table></div>'), this.dummyDOM.querySelector(i) ? this.dummyDOM.querySelector(i).insertAdjacentHTML("beforebegin", n) : this.dummyDOM.querySelector("#".concat(o)).innerHTML = n, this._accessibleOutputs[r].list = this.dummyDOM.querySelector("#".concat(r, "_list"))) : "gridOutput" === e1 && (i = "#".concat(s, "textOutput").concat(i), n = '<div id="'.concat(r, '">Grid Output<p id="').concat(r, '_summary" aria-label="grid output summary"><table id="').concat(r, '_map" summary="grid output content"></table><ul id="').concat(r, '_shapeDetails" aria-label="grid output shape details"></ul></div>'), this.dummyDOM.querySelector(i) ? this.dummyDOM.querySelector(i).insertAdjacentHTML("afterend", n) : this.dummyDOM.querySelector("#".concat(o)).innerHTML = n, this._accessibleOutputs[r].map = this.dummyDOM.querySelector("#".concat(r, "_map"))), this._accessibleOutputs[r].shapeDetails = this.dummyDOM.querySelector("#".concat(r, "_shapeDetails")), this._accessibleOutputs[r].summary = this.dummyDOM.querySelector("#".concat(r, "_summary"));
                }, o.default.prototype._updateAccsOutput = function() {
                    var e1 = this.canvas.id;
                    JSON.stringify(this.ingredients.shapes) !== this.ingredients.pShapes && (this.ingredients.pShapes = JSON.stringify(this.ingredients.shapes), this._accessibleOutputs.text && this._updateTextOutput(e1 + "textOutput"), this._accessibleOutputs.grid && this._updateGridOutput(e1 + "gridOutput"), this._accessibleOutputs.textLabel && this._updateTextOutput(e1 + "textOutputLabel"), this._accessibleOutputs.gridLabel && this._updateGridOutput(e1 + "gridOutputLabel"));
                }, o.default.prototype._accsBackground = function(e1) {
                    this.ingredients.pShapes = JSON.stringify(this.ingredients.shapes), this.ingredients.shapes = {}, this.ingredients.colors.backgroundRGBA !== e1 && (this.ingredients.colors.backgroundRGBA = e1, this.ingredients.colors.background = this._rgbColorName(e1));
                }, o.default.prototype._accsCanvasColors = function(e1, t) {
                    "fill" === e1 ? this.ingredients.colors.fillRGBA !== t && (this.ingredients.colors.fillRGBA = t, this.ingredients.colors.fill = this._rgbColorName(t)) : "stroke" === e1 && this.ingredients.colors.strokeRGBA !== t && (this.ingredients.colors.strokeRGBA = t, this.ingredients.colors.stroke = this._rgbColorName(t));
                }, o.default.prototype._accsOutput = function(e1, t) {
                    "ellipse" === e1 && t[2] === t[3] ? e1 = "circle" : "rectangle" === e1 && t[2] === t[3] && (e1 = "square");
                    var r, o, n = {}, s = !0, i = function(e1, t) {
                        var r;
                        e1 = "rectangle" === e1 || "ellipse" === e1 || "arc" === e1 || "circle" === e1 || "square" === e1 ? (r = Math.round(t[0] + t[2] / 2), Math.round(t[1] + t[3] / 2)) : "triangle" === e1 ? (r = (t[0] + t[2] + t[4]) / 3, (t[1] + t[3] + t[5]) / 3) : "quadrilateral" === e1 ? (r = (t[0] + t[2] + t[4] + t[6]) / 4, (t[1] + t[3] + t[5] + t[7]) / 4) : "line" === e1 ? (r = (t[0] + t[2]) / 2, (t[1] + t[3]) / 2) : (r = t[0], t[1]);
                        return [
                            r,
                            e1
                        ];
                    }(e1, t);
                    if ("line" === e1 ? (n.color = this.ingredients.colors.stroke, n.length = Math.round(this.dist(t[0], t[1], t[2], t[3])), r = this._getPos(t[0], [
                        1
                    ]), o = this._getPos(t[2], [
                        3
                    ]), n.loc = u(i, this.width, this.height), n.pos = r === o ? "at ".concat(r) : "from ".concat(r, " to ").concat(o)) : ("point" === e1 ? n.color = this.ingredients.colors.stroke : (n.color = this.ingredients.colors.fill, n.area = this._getArea(e1, t)), n.pos = this._getPos.apply(this, l(i)), n.loc = u(i, this.width, this.height)), this.ingredients.shapes[e1]) {
                        if (this.ingredients.shapes[e1] !== [
                            n
                        ]) {
                            for(var a in this.ingredients.shapes[e1])JSON.stringify(this.ingredients.shapes[e1][a]) === JSON.stringify(n) && (s = !1);
                            !0 === s && this.ingredients.shapes[e1].push(n);
                        }
                    } else this.ingredients.shapes[e1] = [
                        n
                    ];
                }, o.default.prototype._getPos = function(e1, t) {
                    var e1 = new DOMPointReadOnly(e1, t), t = this._renderer.isP3D ? new DOMMatrix(this._renderer.uMVMatrix.mat4) : this.drawingContext.getTransform(), e1 = e1.matrixTransform(t), t = e1.x, e1 = e1.y, r = this.width, o = this.height;
                    return t < .4 * r ? e1 < .4 * o ? "top left" : .6 * o < e1 ? "bottom left" : "mid left" : .6 * r < t ? e1 < .4 * o ? "top right" : .6 * o < e1 ? "bottom right" : "mid right" : e1 < .4 * o ? "top middle" : .6 * o < e1 ? "bottom middle" : "middle";
                }, o.default.prototype._getArea = function(e1, t) {
                    var r, o, n = 0, s = ("arc" === e1 ? (n = (r = ((t[5] - t[4]) % (2 * Math.PI) + 2 * Math.PI) % (2 * Math.PI)) * t[2] * t[3] / 8, "open" !== t[6] && "chord" !== t[6] || (o = t[0], u = t[1], s = t[0] + t[2] / 2 * Math.cos(t[4]).toFixed(2), c = t[1] + t[3] / 2 * Math.sin(t[4]).toFixed(2), a = t[0] + t[2] / 2 * Math.cos(t[5]).toFixed(2), i = t[1] + t[3] / 2 * Math.sin(t[5]).toFixed(2), o = Math.abs(o * (c - i) + s * (i - u) + a * (u - c)) / 2, r > Math.PI ? n += o : n -= o)) : "ellipse" === e1 || "circle" === e1 ? n = 3.14 * t[2] / 2 * t[3] / 2 : "line" === e1 || "point" === e1 ? n = 0 : "quadrilateral" === e1 ? n = Math.abs((t[6] + t[0]) * (t[7] - t[1]) + (t[0] + t[2]) * (t[1] - t[3]) + (t[2] + t[4]) * (t[3] - t[5]) + (t[4] + t[6]) * (t[5] - t[7])) / 2 : "rectangle" === e1 || "square" === e1 ? n = t[2] * t[3] : "triangle" === e1 && (n = Math.abs(t[0] * (t[3] - t[5]) + t[2] * (t[5] - t[1]) + t[4] * (t[1] - t[3])) / 2), this.width * this._pixelDensity), i = this.height * this._pixelDensity, a = [
                        new DOMPoint(0, 0),
                        new DOMPoint(s, 0),
                        new DOMPoint(s, i),
                        new DOMPoint(0, i)
                    ], l = (this._renderer.isP3D ? new DOMMatrix(this._renderer.uMVMatrix.mat4) : this.drawingContext.getTransform()).inverse(), u = a.map(function(e1) {
                        return e1.matrixTransform(l);
                    }), c = Math.abs((u[3].x + u[0].x) * (u[3].y - u[0].y) + (u[0].x + u[1].x) * (u[0].y - u[1].y) + (u[1].x + u[2].x) * (u[1].y - u[2].y) + (u[2].x + u[3].x) * (u[2].y - u[3].y)) / 2;
                    return Math.round(100 * n / c);
                };
                e1 = o.default;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.fill": 154,
                "core-js/modules/es.array.from": 158,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.map": 164,
                "core-js/modules/es.number.to-fixed": 175,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        258: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.concat"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype._updateTextOutput = function(e1) {
                    var t, r, o, n;
                    this.dummyDOM.querySelector("#".concat(e1, "_summary")) && (t = this._accessibleOutputs[e1], o = function(e1, t, r, o) {
                        r = "Your output is a, ".concat(r, " by ").concat(o, " pixels, ").concat(t, " canvas containing the following");
                        r = 1 === e1 ? "".concat(r, " shape:") : "".concat(r, " ").concat(e1, " shapes:");
                        return r;
                    }((r = function(e1, t) {
                        var r, o = "", n = 0;
                        for(r in t)for(var s in t[r]){
                            var i = '<li><a href="#'.concat(e1, "shape").concat(n, '">').concat(t[r][s].color, " ").concat(r, "</a>");
                            "line" === r ? i += ", ".concat(t[r][s].pos, ", ").concat(t[r][s].length, " pixels long.</li>") : (i += ", at ".concat(t[r][s].pos), "point" !== r && (i += ", covering ".concat(t[r][s].area, "% of the canvas")), i += ".</li>"), o += i, n++;
                        }
                        return {
                            numShapes: n,
                            listShapes: o
                        };
                    }(e1, this.ingredients.shapes)).numShapes, this.ingredients.colors.background, this.width, this.height), n = function(e1, t) {
                        var r, o = "", n = 0;
                        for(r in t)for(var s in t[r]){
                            var i = '<tr id="'.concat(e1, "shape").concat(n, '"><th>').concat(t[r][s].color, " ").concat(r, "</th>");
                            "line" === r ? i += "<td>location = ".concat(t[r][s].pos, "</td><td>length = ").concat(t[r][s].length, " pixels</td></tr>") : (i += "<td>location = ".concat(t[r][s].pos, "</td>"), "point" !== r && (i += "<td> area = ".concat(t[r][s].area, "%</td>")), i += "</tr>"), o += i, n++;
                        }
                        return o;
                    }(e1, this.ingredients.shapes), o !== t.summary.innerHTML && (t.summary.innerHTML = o), r.listShapes !== t.list.innerHTML && (t.list.innerHTML = r.listShapes), n !== t.shapeDetails.innerHTML && (t.shapeDetails.innerHTML = n), this._accessibleOutputs[e1] = t);
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.concat": 151
            }
        ],
        259: [
            function(e1, t, r) {
                "use strict";
                var o = (o = e1("./core/main")) && o.__esModule ? o : {
                    default: o
                };
                e1("./core/constants"), e1("./core/environment"), e1("./core/friendly_errors/stacktrace"), e1("./core/friendly_errors/validate_params"), e1("./core/friendly_errors/file_errors"), e1("./core/friendly_errors/fes_core"), e1("./core/friendly_errors/sketch_reader"), e1("./core/helpers"), e1("./core/legacy"), e1("./core/preload"), e1("./core/p5.Element"), e1("./core/p5.Graphics"), e1("./core/p5.Renderer"), e1("./core/p5.Renderer2D"), e1("./core/rendering"), e1("./core/shim"), e1("./core/structure"), e1("./core/transform"), e1("./core/shape/2d_primitives"), e1("./core/shape/attributes"), e1("./core/shape/curves"), e1("./core/shape/vertex"), e1("./accessibility/outputs"), e1("./accessibility/textOutput"), e1("./accessibility/gridOutput"), e1("./accessibility/color_namer"), e1("./color/color_conversion"), e1("./color/creating_reading"), e1("./color/p5.Color"), e1("./color/setting"), e1("./data/p5.TypedDict"), e1("./data/local_storage.js"), e1("./dom/dom"), e1("./accessibility/describe"), e1("./events/acceleration"), e1("./events/keyboard"), e1("./events/mouse"), e1("./events/touch"), e1("./image/filters"), e1("./image/image"), e1("./image/loading_displaying"), e1("./image/p5.Image"), e1("./image/pixels"), e1("./io/files"), e1("./io/p5.Table"), e1("./io/p5.TableRow"), e1("./io/p5.XML"), e1("./math/calculation"), e1("./math/math"), e1("./math/noise"), e1("./math/p5.Vector"), e1("./math/random"), e1("./math/trigonometry"), e1("./typography/attributes"), e1("./typography/loading_displaying"), e1("./typography/p5.Font"), e1("./utilities/array_functions"), e1("./utilities/conversion"), e1("./utilities/string_functions"), e1("./utilities/time_date"), e1("./webgl/3d_primitives"), e1("./webgl/interaction"), e1("./webgl/light"), e1("./webgl/loading"), e1("./webgl/material"), e1("./webgl/p5.Camera"), e1("./webgl/p5.DataArray"), e1("./webgl/p5.Geometry"), e1("./webgl/p5.Matrix"), e1("./webgl/p5.RendererGL.Immediate"), e1("./webgl/p5.RendererGL"), e1("./webgl/p5.RendererGL.Retained"), e1("./webgl/p5.Framebuffer"), e1("./webgl/p5.Shader"), e1("./webgl/p5.RenderBuffer"), e1("./webgl/p5.Texture"), e1("./webgl/text"), e1("./core/init"), t.exports = o.default;
            },
            {
                "./accessibility/color_namer": 254,
                "./accessibility/describe": 255,
                "./accessibility/gridOutput": 256,
                "./accessibility/outputs": 257,
                "./accessibility/textOutput": 258,
                "./color/color_conversion": 260,
                "./color/creating_reading": 261,
                "./color/p5.Color": 262,
                "./color/setting": 263,
                "./core/constants": 264,
                "./core/environment": 265,
                "./core/friendly_errors/fes_core": 266,
                "./core/friendly_errors/file_errors": 267,
                "./core/friendly_errors/sketch_reader": 268,
                "./core/friendly_errors/stacktrace": 269,
                "./core/friendly_errors/validate_params": 270,
                "./core/helpers": 271,
                "./core/init": 272,
                "./core/legacy": 274,
                "./core/main": 275,
                "./core/p5.Element": 276,
                "./core/p5.Graphics": 277,
                "./core/p5.Renderer": 278,
                "./core/p5.Renderer2D": 279,
                "./core/preload": 280,
                "./core/rendering": 281,
                "./core/shape/2d_primitives": 282,
                "./core/shape/attributes": 283,
                "./core/shape/curves": 284,
                "./core/shape/vertex": 285,
                "./core/shim": 286,
                "./core/structure": 287,
                "./core/transform": 288,
                "./data/local_storage.js": 289,
                "./data/p5.TypedDict": 290,
                "./dom/dom": 291,
                "./events/acceleration": 292,
                "./events/keyboard": 293,
                "./events/mouse": 294,
                "./events/touch": 295,
                "./image/filters": 296,
                "./image/image": 297,
                "./image/loading_displaying": 298,
                "./image/p5.Image": 299,
                "./image/pixels": 300,
                "./io/files": 301,
                "./io/p5.Table": 302,
                "./io/p5.TableRow": 303,
                "./io/p5.XML": 304,
                "./math/calculation": 305,
                "./math/math": 306,
                "./math/noise": 307,
                "./math/p5.Vector": 308,
                "./math/random": 309,
                "./math/trigonometry": 310,
                "./typography/attributes": 311,
                "./typography/loading_displaying": 312,
                "./typography/p5.Font": 313,
                "./utilities/array_functions": 314,
                "./utilities/conversion": 315,
                "./utilities/string_functions": 316,
                "./utilities/time_date": 317,
                "./webgl/3d_primitives": 318,
                "./webgl/interaction": 320,
                "./webgl/light": 321,
                "./webgl/loading": 322,
                "./webgl/material": 323,
                "./webgl/p5.Camera": 324,
                "./webgl/p5.DataArray": 325,
                "./webgl/p5.Framebuffer": 326,
                "./webgl/p5.Geometry": 327,
                "./webgl/p5.Matrix": 328,
                "./webgl/p5.RenderBuffer": 329,
                "./webgl/p5.RendererGL": 332,
                "./webgl/p5.RendererGL.Immediate": 330,
                "./webgl/p5.RendererGL.Retained": 331,
                "./webgl/p5.Shader": 333,
                "./webgl/p5.Texture": 334,
                "./webgl/text": 335
            }
        ],
        260: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.ColorConversion = {
                    _hsbaToHSLA: function(e1) {
                        var t = e1[0], r = e1[1], o = e1[2], n = (2 - r) * o / 2;
                        return 0 != n && (1 == n ? r = 0 : n < .5 ? r /= 2 - r : r = r * o / (2 - 2 * n)), [
                            t,
                            r,
                            n,
                            e1[3]
                        ];
                    },
                    _hsbaToRGBA: function(e1) {
                        var t, r, o, n, s, i = 6 * e1[0], a = e1[1], l = e1[2];
                        return 0 === a ? [
                            l,
                            l,
                            l,
                            e1[3]
                        ] : (r = l * (1 - a), o = l * (1 - a * (i - (t = Math.floor(i)))), a = l * (1 - a * (1 + t - i)), i = 1 === t ? (n = o, s = l, r) : 2 === t ? (n = r, s = l, a) : 3 === t ? (n = r, s = o, l) : 4 === t ? (n = a, s = r, l) : 5 === t ? (n = l, s = r, o) : (n = l, s = a, r), [
                            n,
                            s,
                            i,
                            e1[3]
                        ]);
                    },
                    _hslaToHSBA: function(e1) {
                        var t = e1[0], r = e1[1], o = e1[2], n = o < .5 ? (1 + r) * o : o + r - o * r;
                        return [
                            t,
                            r = 2 * (n - o) / n,
                            n,
                            e1[3]
                        ];
                    },
                    _hslaToRGBA: function(e1) {
                        var t, r = 6 * e1[0], o = e1[1], n = e1[2];
                        return 0 === o ? [
                            n,
                            n,
                            n,
                            e1[3]
                        ] : [
                            (t = function(e1, t, r) {
                                return e1 < 0 ? e1 += 6 : 6 <= e1 && (e1 -= 6), e1 < 1 ? t + (r - t) * e1 : e1 < 3 ? r : e1 < 4 ? t + (r - t) * (4 - e1) : t;
                            })(2 + r, o = 2 * n - (n = n < .5 ? (1 + o) * n : n + o - n * o), n),
                            t(r, o, n),
                            t(r - 2, o, n),
                            e1[3]
                        ];
                    },
                    _rgbaToHSBA: function(e1) {
                        var t, r, o = e1[0], n = e1[1], s = e1[2], i = Math.max(o, n, s), a = i - Math.min(o, n, s);
                        return 0 == a ? r = t = 0 : (r = a / i, o === i ? t = (n - s) / a : n === i ? t = 2 + (s - o) / a : s === i && (t = 4 + (o - n) / a), t < 0 ? t += 6 : 6 <= t && (t -= 6)), [
                            t / 6,
                            r,
                            i,
                            e1[3]
                        ];
                    },
                    _rgbaToHSLA: function(e1) {
                        var t, r, o = e1[0], n = e1[1], s = e1[2], i = Math.max(o, n, s), a = Math.min(o, n, s), l = i + a, a = i - a;
                        return 0 == a ? r = t = 0 : (r = l < 1 ? a / l : a / (2 - l), o === i ? t = (n - s) / a : n === i ? t = 2 + (s - o) / a : s === i && (t = 4 + (o - n) / a), t < 0 ? t += 6 : 6 <= t && (t -= 6)), [
                            t / 6,
                            r,
                            l / 2,
                            e1[3]
                        ];
                    }
                };
                e1 = e1.default.ColorConversion;
                r.default = e1;
            },
            {
                "../core/main": 275
            }
        ],
        261: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.map"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, u = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                e1("./p5.Color"), e1("../core/friendly_errors/validate_params"), e1("../core/friendly_errors/file_errors"), e1("../core/friendly_errors/fes_core"), l.default.prototype.alpha = function(e1) {
                    return l.default._validateParameters("alpha", arguments), this.color(e1)._getAlpha();
                }, l.default.prototype.blue = function(e1) {
                    return l.default._validateParameters("blue", arguments), this.color(e1)._getBlue();
                }, l.default.prototype.brightness = function(e1) {
                    return l.default._validateParameters("brightness", arguments), this.color(e1)._getBrightness();
                }, l.default.prototype.color = function() {
                    var e1;
                    return l.default._validateParameters("color", arguments), arguments[0] instanceof l.default.Color ? arguments[0] : (e1 = arguments[0] instanceof Array ? arguments[0] : arguments, new l.default.Color(this, e1));
                }, l.default.prototype.green = function(e1) {
                    return l.default._validateParameters("green", arguments), this.color(e1)._getGreen();
                }, l.default.prototype.hue = function(e1) {
                    return l.default._validateParameters("hue", arguments), this.color(e1)._getHue();
                }, l.default.prototype.lerpColor = function(e1, t, r) {
                    l.default._validateParameters("lerpColor", arguments);
                    var o, n, s, i = this._colorMode, a = this._colorMaxes;
                    if (i === u.RGB) n = e1.levels.map(function(e1) {
                        return e1 / 255;
                    }), s = t.levels.map(function(e1) {
                        return e1 / 255;
                    });
                    else if (i === u.HSB) e1._getBrightness(), t._getBrightness(), n = e1.hsba, s = t.hsba;
                    else {
                        if (i !== u.HSL) throw new Error("".concat(i, "cannot be used for interpolation."));
                        e1._getLightness(), t._getLightness(), n = e1.hsla, s = t.hsla;
                    }
                    return r = Math.max(Math.min(r, 1), 0), void 0 === this.lerp && (this.lerp = function(e1, t, r) {
                        return r * (t - e1) + e1;
                    }), e1 = this.lerp(n[0], s[0], r), t = this.lerp(n[1], s[1], r), o = this.lerp(n[2], s[2], r), n = this.lerp(n[3], s[3], r), e1 *= a[i][0], t *= a[i][1], o *= a[i][2], n *= a[i][3], this.color(e1, t, o, n);
                }, l.default.prototype.lightness = function(e1) {
                    return l.default._validateParameters("lightness", arguments), this.color(e1)._getLightness();
                }, l.default.prototype.red = function(e1) {
                    return l.default._validateParameters("red", arguments), this.color(e1)._getRed();
                }, l.default.prototype.saturation = function(e1) {
                    return l.default._validateParameters("saturation", arguments), this.color(e1)._getSaturation();
                };
                var n = l.default;
                r.default = n;
            },
            {
                "../core/constants": 264,
                "../core/friendly_errors/fes_core": 266,
                "../core/friendly_errors/file_errors": 267,
                "../core/friendly_errors/validate_params": 270,
                "../core/main": 275,
                "./p5.Color": 262,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.map": 164,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        262: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.trim"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e1("../core/main")), d = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants")), h = s(e1("./color_conversion"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function s(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function l(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                var f = {
                    aliceblue: "#f0f8ff",
                    antiquewhite: "#faebd7",
                    aqua: "#00ffff",
                    aquamarine: "#7fffd4",
                    azure: "#f0ffff",
                    beige: "#f5f5dc",
                    bisque: "#ffe4c4",
                    black: "#000000",
                    blanchedalmond: "#ffebcd",
                    blue: "#0000ff",
                    blueviolet: "#8a2be2",
                    brown: "#a52a2a",
                    burlywood: "#deb887",
                    cadetblue: "#5f9ea0",
                    chartreuse: "#7fff00",
                    chocolate: "#d2691e",
                    coral: "#ff7f50",
                    cornflowerblue: "#6495ed",
                    cornsilk: "#fff8dc",
                    crimson: "#dc143c",
                    cyan: "#00ffff",
                    darkblue: "#00008b",
                    darkcyan: "#008b8b",
                    darkgoldenrod: "#b8860b",
                    darkgray: "#a9a9a9",
                    darkgreen: "#006400",
                    darkgrey: "#a9a9a9",
                    darkkhaki: "#bdb76b",
                    darkmagenta: "#8b008b",
                    darkolivegreen: "#556b2f",
                    darkorange: "#ff8c00",
                    darkorchid: "#9932cc",
                    darkred: "#8b0000",
                    darksalmon: "#e9967a",
                    darkseagreen: "#8fbc8f",
                    darkslateblue: "#483d8b",
                    darkslategray: "#2f4f4f",
                    darkslategrey: "#2f4f4f",
                    darkturquoise: "#00ced1",
                    darkviolet: "#9400d3",
                    deeppink: "#ff1493",
                    deepskyblue: "#00bfff",
                    dimgray: "#696969",
                    dimgrey: "#696969",
                    dodgerblue: "#1e90ff",
                    firebrick: "#b22222",
                    floralwhite: "#fffaf0",
                    forestgreen: "#228b22",
                    fuchsia: "#ff00ff",
                    gainsboro: "#dcdcdc",
                    ghostwhite: "#f8f8ff",
                    gold: "#ffd700",
                    goldenrod: "#daa520",
                    gray: "#808080",
                    green: "#008000",
                    greenyellow: "#adff2f",
                    grey: "#808080",
                    honeydew: "#f0fff0",
                    hotpink: "#ff69b4",
                    indianred: "#cd5c5c",
                    indigo: "#4b0082",
                    ivory: "#fffff0",
                    khaki: "#f0e68c",
                    lavender: "#e6e6fa",
                    lavenderblush: "#fff0f5",
                    lawngreen: "#7cfc00",
                    lemonchiffon: "#fffacd",
                    lightblue: "#add8e6",
                    lightcoral: "#f08080",
                    lightcyan: "#e0ffff",
                    lightgoldenrodyellow: "#fafad2",
                    lightgray: "#d3d3d3",
                    lightgreen: "#90ee90",
                    lightgrey: "#d3d3d3",
                    lightpink: "#ffb6c1",
                    lightsalmon: "#ffa07a",
                    lightseagreen: "#20b2aa",
                    lightskyblue: "#87cefa",
                    lightslategray: "#778899",
                    lightslategrey: "#778899",
                    lightsteelblue: "#b0c4de",
                    lightyellow: "#ffffe0",
                    lime: "#00ff00",
                    limegreen: "#32cd32",
                    linen: "#faf0e6",
                    magenta: "#ff00ff",
                    maroon: "#800000",
                    mediumaquamarine: "#66cdaa",
                    mediumblue: "#0000cd",
                    mediumorchid: "#ba55d3",
                    mediumpurple: "#9370db",
                    mediumseagreen: "#3cb371",
                    mediumslateblue: "#7b68ee",
                    mediumspringgreen: "#00fa9a",
                    mediumturquoise: "#48d1cc",
                    mediumvioletred: "#c71585",
                    midnightblue: "#191970",
                    mintcream: "#f5fffa",
                    mistyrose: "#ffe4e1",
                    moccasin: "#ffe4b5",
                    navajowhite: "#ffdead",
                    navy: "#000080",
                    oldlace: "#fdf5e6",
                    olive: "#808000",
                    olivedrab: "#6b8e23",
                    orange: "#ffa500",
                    orangered: "#ff4500",
                    orchid: "#da70d6",
                    palegoldenrod: "#eee8aa",
                    palegreen: "#98fb98",
                    paleturquoise: "#afeeee",
                    palevioletred: "#db7093",
                    papayawhip: "#ffefd5",
                    peachpuff: "#ffdab9",
                    peru: "#cd853f",
                    pink: "#ffc0cb",
                    plum: "#dda0dd",
                    powderblue: "#b0e0e6",
                    purple: "#800080",
                    rebeccapurple: "#663399",
                    red: "#ff0000",
                    rosybrown: "#bc8f8f",
                    royalblue: "#4169e1",
                    saddlebrown: "#8b4513",
                    salmon: "#fa8072",
                    sandybrown: "#f4a460",
                    seagreen: "#2e8b57",
                    seashell: "#fff5ee",
                    sienna: "#a0522d",
                    silver: "#c0c0c0",
                    skyblue: "#87ceeb",
                    slateblue: "#6a5acd",
                    slategray: "#708090",
                    slategrey: "#708090",
                    snow: "#fffafa",
                    springgreen: "#00ff7f",
                    steelblue: "#4682b4",
                    tan: "#d2b48c",
                    teal: "#008080",
                    thistle: "#d8bfd8",
                    tomato: "#ff6347",
                    turquoise: "#40e0d0",
                    violet: "#ee82ee",
                    wheat: "#f5deb3",
                    white: "#ffffff",
                    whitesmoke: "#f5f5f5",
                    yellow: "#ffff00",
                    yellowgreen: "#9acd32"
                }, e1 = /\s*/, u = /(\d{1,3})/, c = /((?:\d+(?:\.\d+)?)|(?:\.\d+))/, p = new RegExp("".concat(c.source, "%")), m = {
                    HEX3: /^#([a-f0-9])([a-f0-9])([a-f0-9])$/i,
                    HEX4: /^#([a-f0-9])([a-f0-9])([a-f0-9])([a-f0-9])$/i,
                    HEX6: /^#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})$/i,
                    HEX8: /^#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})$/i,
                    RGB: new RegExp([
                        "^rgb\\(",
                        u.source,
                        ",",
                        u.source,
                        ",",
                        u.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    RGB_PERCENT: new RegExp([
                        "^rgb\\(",
                        p.source,
                        ",",
                        p.source,
                        ",",
                        p.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    RGBA: new RegExp([
                        "^rgba\\(",
                        u.source,
                        ",",
                        u.source,
                        ",",
                        u.source,
                        ",",
                        c.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    RGBA_PERCENT: new RegExp([
                        "^rgba\\(",
                        p.source,
                        ",",
                        p.source,
                        ",",
                        p.source,
                        ",",
                        c.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    HSL: new RegExp([
                        "^hsl\\(",
                        u.source,
                        ",",
                        p.source,
                        ",",
                        p.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    HSLA: new RegExp([
                        "^hsla\\(",
                        u.source,
                        ",",
                        p.source,
                        ",",
                        p.source,
                        ",",
                        c.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    HSB: new RegExp([
                        "^hsb\\(",
                        u.source,
                        ",",
                        p.source,
                        ",",
                        p.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    HSBA: new RegExp([
                        "^hsba\\(",
                        u.source,
                        ",",
                        p.source,
                        ",",
                        p.source,
                        ",",
                        c.source,
                        "\\)$"
                    ].join(e1.source), "i")
                }, u = (n.default.Color = function() {
                    function c(e1, t) {
                        if (!(this instanceof c)) throw new TypeError("Cannot call a class as a function");
                        if (this._storeModeAndMaxes(e1._colorMode, e1._colorMaxes), ![
                            d.RGB,
                            d.HSL,
                            d.HSB
                        ].includes(this.mode)) throw new Error("".concat(this.mode, " is an invalid colorMode."));
                        this._array = c._parseInputs.apply(this, t), this._calculateLevels();
                    }
                    var e1, t, r;
                    return e1 = c, r = [
                        {
                            key: "_parseInputs",
                            value: function(e1, t, r, o) {
                                var n, s = arguments.length, i = this.mode, a = this.maxes[i], l = [];
                                if (3 <= s) {
                                    for(l[0] = e1 / a[0], l[1] = t / a[1], l[2] = r / a[2], l[3] = "number" == typeof o ? o / a[3] : 1, n = l.length - 1; 0 <= n; --n){
                                        var u = l[n];
                                        u < 0 ? l[n] = 0 : 1 < u && (l[n] = 1);
                                    }
                                    return i === d.HSL ? h.default._hslaToRGBA(l) : i === d.HSB ? h.default._hsbaToRGBA(l) : l;
                                }
                                if (1 === s && "string" == typeof e1) {
                                    r = e1.trim().toLowerCase();
                                    if (f[r]) return c._parseInputs.call(this, f[r]);
                                    if (m.HEX3.test(r)) return (l = m.HEX3.exec(r).slice(1).map(function(e1) {
                                        return parseInt(e1 + e1, 16) / 255;
                                    }))[3] = 1, l;
                                    if (m.HEX6.test(r)) return (l = m.HEX6.exec(r).slice(1).map(function(e1) {
                                        return parseInt(e1, 16) / 255;
                                    }))[3] = 1, l;
                                    if (m.HEX4.test(r)) return l = m.HEX4.exec(r).slice(1).map(function(e1) {
                                        return parseInt(e1 + e1, 16) / 255;
                                    });
                                    if (m.HEX8.test(r)) return l = m.HEX8.exec(r).slice(1).map(function(e1) {
                                        return parseInt(e1, 16) / 255;
                                    });
                                    if (m.RGB.test(r)) return (l = m.RGB.exec(r).slice(1).map(function(e1) {
                                        return e1 / 255;
                                    }))[3] = 1, l;
                                    if (m.RGB_PERCENT.test(r)) return (l = m.RGB_PERCENT.exec(r).slice(1).map(function(e1) {
                                        return parseFloat(e1) / 100;
                                    }))[3] = 1, l;
                                    if (m.RGBA.test(r)) return l = m.RGBA.exec(r).slice(1).map(function(e1, t) {
                                        return 3 === t ? parseFloat(e1) : e1 / 255;
                                    });
                                    if (m.RGBA_PERCENT.test(r)) return l = m.RGBA_PERCENT.exec(r).slice(1).map(function(e1, t) {
                                        return 3 === t ? parseFloat(e1) : parseFloat(e1) / 100;
                                    });
                                    if (m.HSL.test(r) ? (l = m.HSL.exec(r).slice(1).map(function(e1, t) {
                                        return 0 === t ? parseInt(e1, 10) / 360 : parseInt(e1, 10) / 100;
                                    }))[3] = 1 : m.HSLA.test(r) && (l = m.HSLA.exec(r).slice(1).map(function(e1, t) {
                                        return 0 === t ? parseInt(e1, 10) / 360 : 3 === t ? parseFloat(e1) : parseInt(e1, 10) / 100;
                                    })), (l = l.map(function(e1) {
                                        return Math.max(Math.min(e1, 1), 0);
                                    })).length) return h.default._hslaToRGBA(l);
                                    if (m.HSB.test(r) ? (l = m.HSB.exec(r).slice(1).map(function(e1, t) {
                                        return 0 === t ? parseInt(e1, 10) / 360 : parseInt(e1, 10) / 100;
                                    }))[3] = 1 : m.HSBA.test(r) && (l = m.HSBA.exec(r).slice(1).map(function(e1, t) {
                                        return 0 === t ? parseInt(e1, 10) / 360 : 3 === t ? parseFloat(e1) : parseInt(e1, 10) / 100;
                                    })), l.length) {
                                        for(n = l.length - 1; 0 <= n; --n)l[n] = Math.max(Math.min(l[n], 1), 0);
                                        return h.default._hsbaToRGBA(l);
                                    }
                                    l = [
                                        1,
                                        1,
                                        1,
                                        1
                                    ];
                                } else {
                                    if (1 !== s && 2 !== s || "number" != typeof e1) throw new Error("".concat(arguments, "is not a valid color representation."));
                                    l[0] = e1 / a[2], l[1] = e1 / a[2], l[2] = e1 / a[2], l[3] = "number" == typeof t ? t / a[3] : 1, l = l.map(function(e1) {
                                        return Math.max(Math.min(e1, 1), 0);
                                    });
                                }
                                return l;
                            }
                        }
                    ], t = [
                        {
                            key: "toString",
                            value: function(e1) {
                                var t = this.levels, r = this._array, o = r[3];
                                switch(e1){
                                    case "#rrggbb":
                                        return "#".concat(t[0] < 16 ? "0".concat(t[0].toString(16)) : t[0].toString(16), t[1] < 16 ? "0".concat(t[1].toString(16)) : t[1].toString(16), t[2] < 16 ? "0".concat(t[2].toString(16)) : t[2].toString(16));
                                    case "#rrggbbaa":
                                        return "#".concat(t[0] < 16 ? "0".concat(t[0].toString(16)) : t[0].toString(16), t[1] < 16 ? "0".concat(t[1].toString(16)) : t[1].toString(16), t[2] < 16 ? "0".concat(t[2].toString(16)) : t[2].toString(16), t[3] < 16 ? "0".concat(t[3].toString(16)) : t[3].toString(16));
                                    case "#rgb":
                                        return "#".concat(Math.round(15 * r[0]).toString(16), Math.round(15 * r[1]).toString(16), Math.round(15 * r[2]).toString(16));
                                    case "#rgba":
                                        return "#".concat(Math.round(15 * r[0]).toString(16), Math.round(15 * r[1]).toString(16), Math.round(15 * r[2]).toString(16), Math.round(15 * r[3]).toString(16));
                                    case "rgb":
                                        return "rgb(".concat(t[0], ", ", t[1], ", ", t[2], ")");
                                    case "rgb%":
                                        return "rgb(".concat((100 * r[0]).toPrecision(3), "%, ", (100 * r[1]).toPrecision(3), "%, ", (100 * r[2]).toPrecision(3), "%)");
                                    case "rgba%":
                                        return "rgba(".concat((100 * r[0]).toPrecision(3), "%, ", (100 * r[1]).toPrecision(3), "%, ", (100 * r[2]).toPrecision(3), "%, ", (100 * r[3]).toPrecision(3), "%)");
                                    case "hsb":
                                    case "hsv":
                                        return this.hsba || (this.hsba = h.default._rgbaToHSBA(this._array)), "hsb(".concat(this.hsba[0] * this.maxes[d.HSB][0], ", ", this.hsba[1] * this.maxes[d.HSB][1], ", ", this.hsba[2] * this.maxes[d.HSB][2], ")");
                                    case "hsb%":
                                    case "hsv%":
                                        return this.hsba || (this.hsba = h.default._rgbaToHSBA(this._array)), "hsb(".concat((100 * this.hsba[0]).toPrecision(3), "%, ", (100 * this.hsba[1]).toPrecision(3), "%, ", (100 * this.hsba[2]).toPrecision(3), "%)");
                                    case "hsba":
                                    case "hsva":
                                        return this.hsba || (this.hsba = h.default._rgbaToHSBA(this._array)), "hsba(".concat(this.hsba[0] * this.maxes[d.HSB][0], ", ", this.hsba[1] * this.maxes[d.HSB][1], ", ", this.hsba[2] * this.maxes[d.HSB][2], ", ", o, ")");
                                    case "hsba%":
                                    case "hsva%":
                                        return this.hsba || (this.hsba = h.default._rgbaToHSBA(this._array)), "hsba(".concat((100 * this.hsba[0]).toPrecision(3), "%, ", (100 * this.hsba[1]).toPrecision(3), "%, ", (100 * this.hsba[2]).toPrecision(3), "%, ", (100 * o).toPrecision(3), "%)");
                                    case "hsl":
                                        return this.hsla || (this.hsla = h.default._rgbaToHSLA(this._array)), "hsl(".concat(this.hsla[0] * this.maxes[d.HSL][0], ", ", this.hsla[1] * this.maxes[d.HSL][1], ", ", this.hsla[2] * this.maxes[d.HSL][2], ")");
                                    case "hsl%":
                                        return this.hsla || (this.hsla = h.default._rgbaToHSLA(this._array)), "hsl(".concat((100 * this.hsla[0]).toPrecision(3), "%, ", (100 * this.hsla[1]).toPrecision(3), "%, ", (100 * this.hsla[2]).toPrecision(3), "%)");
                                    case "hsla":
                                        return this.hsla || (this.hsla = h.default._rgbaToHSLA(this._array)), "hsla(".concat(this.hsla[0] * this.maxes[d.HSL][0], ", ", this.hsla[1] * this.maxes[d.HSL][1], ", ", this.hsla[2] * this.maxes[d.HSL][2], ", ", o, ")");
                                    case "hsla%":
                                        return this.hsla || (this.hsla = h.default._rgbaToHSLA(this._array)), "hsl(".concat((100 * this.hsla[0]).toPrecision(3), "%, ", (100 * this.hsla[1]).toPrecision(3), "%, ", (100 * this.hsla[2]).toPrecision(3), "%, ", (100 * o).toPrecision(3), "%)");
                                    default:
                                        return "rgba(".concat(t[0], ",", t[1], ",", t[2], ",", o, ")");
                                }
                            }
                        },
                        {
                            key: "setRed",
                            value: function(e1) {
                                this._array[0] = e1 / this.maxes[d.RGB][0], this._calculateLevels();
                            }
                        },
                        {
                            key: "setGreen",
                            value: function(e1) {
                                this._array[1] = e1 / this.maxes[d.RGB][1], this._calculateLevels();
                            }
                        },
                        {
                            key: "setBlue",
                            value: function(e1) {
                                this._array[2] = e1 / this.maxes[d.RGB][2], this._calculateLevels();
                            }
                        },
                        {
                            key: "setAlpha",
                            value: function(e1) {
                                this._array[3] = e1 / this.maxes[this.mode][3], this._calculateLevels();
                            }
                        },
                        {
                            key: "_calculateLevels",
                            value: function() {
                                for(var e1 = this._array, t = this.levels = new Array(e1.length), r = e1.length - 1; 0 <= r; --r)t[r] = Math.round(255 * e1[r]);
                                this.hsla = null, this.hsba = null;
                            }
                        },
                        {
                            key: "_getAlpha",
                            value: function() {
                                return this._array[3] * this.maxes[this.mode][3];
                            }
                        },
                        {
                            key: "_storeModeAndMaxes",
                            value: function(e1, t) {
                                this.mode = e1, this.maxes = t;
                            }
                        },
                        {
                            key: "_getMode",
                            value: function() {
                                return this.mode;
                            }
                        },
                        {
                            key: "_getMaxes",
                            value: function() {
                                return this.maxes;
                            }
                        },
                        {
                            key: "_getBlue",
                            value: function() {
                                return this._array[2] * this.maxes[d.RGB][2];
                            }
                        },
                        {
                            key: "_getBrightness",
                            value: function() {
                                return this.hsba || (this.hsba = h.default._rgbaToHSBA(this._array)), this.hsba[2] * this.maxes[d.HSB][2];
                            }
                        },
                        {
                            key: "_getGreen",
                            value: function() {
                                return this._array[1] * this.maxes[d.RGB][1];
                            }
                        },
                        {
                            key: "_getHue",
                            value: function() {
                                return this.mode === d.HSB ? (this.hsba || (this.hsba = h.default._rgbaToHSBA(this._array)), this.hsba[0] * this.maxes[d.HSB][0]) : (this.hsla || (this.hsla = h.default._rgbaToHSLA(this._array)), this.hsla[0] * this.maxes[d.HSL][0]);
                            }
                        },
                        {
                            key: "_getLightness",
                            value: function() {
                                return this.hsla || (this.hsla = h.default._rgbaToHSLA(this._array)), this.hsla[2] * this.maxes[d.HSL][2];
                            }
                        },
                        {
                            key: "_getRed",
                            value: function() {
                                return this._array[0] * this.maxes[d.RGB][0];
                            }
                        },
                        {
                            key: "_getSaturation",
                            value: function() {
                                return this.mode === d.HSB ? (this.hsba || (this.hsba = h.default._rgbaToHSBA(this._array)), this.hsba[1] * this.maxes[d.HSB][1]) : (this.hsla || (this.hsla = h.default._rgbaToHSLA(this._array)), this.hsla[1] * this.maxes[d.HSL][1]);
                            }
                        }
                    ], l(e1.prototype, t), r && l(e1, r), c;
                }(), n.default.Color);
                r.default = u;
            },
            {
                "../core/constants": 264,
                "../core/main": 275,
                "./color_conversion": 260,
                "core-js/modules/es.array.includes": 159,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.join": 162,
                "core-js/modules/es.array.map": 164,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.constructor": 186,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.includes": 191,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.string.trim": 201,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        263: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.fill"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, a = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = l();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function l() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, l = function() {
                        return e1;
                    }, e1);
                }
                e1("./p5.Color"), s.default.prototype.beginClip = function() {
                    this._renderer.beginClip(0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {});
                }, s.default.prototype.endClip = function() {
                    this._renderer.endClip();
                }, s.default.prototype.clip = function(e1, t) {
                    this._renderer.beginClip(t), e1(), this._renderer.endClip(t);
                }, s.default.prototype.background = function() {
                    var e1;
                    return (e1 = this._renderer).background.apply(e1, arguments), this;
                }, s.default.prototype.clear = function() {
                    return this._renderer.clear((arguments.length <= 0 ? void 0 : arguments[0]) || 0, (arguments.length <= 1 ? void 0 : arguments[1]) || 0, (arguments.length <= 2 ? void 0 : arguments[2]) || 0, (arguments.length <= 3 ? void 0 : arguments[3]) || 0), this;
                }, s.default.prototype.colorMode = function(e1, t, r, o, n) {
                    return s.default._validateParameters("colorMode", arguments), e1 !== a.RGB && e1 !== a.HSB && e1 !== a.HSL || (this._colorMode = e1, e1 = this._colorMaxes[e1], 2 === arguments.length ? (e1[0] = t, e1[1] = t, e1[2] = t, e1[3] = t) : 4 === arguments.length ? (e1[0] = t, e1[1] = r, e1[2] = o) : 5 === arguments.length && (e1[0] = t, e1[1] = r, e1[2] = o, e1[3] = n)), this;
                }, s.default.prototype.fill = function() {
                    var e1;
                    return this._renderer._setProperty("_fillSet", !0), this._renderer._setProperty("_doFill", !0), (e1 = this._renderer).fill.apply(e1, arguments), this;
                }, s.default.prototype.noFill = function() {
                    return this._renderer._setProperty("_doFill", !1), this;
                }, s.default.prototype.noStroke = function() {
                    return this._renderer._setProperty("_doStroke", !1), this;
                }, s.default.prototype.stroke = function() {
                    var e1;
                    return this._renderer._setProperty("_strokeSet", !0), this._renderer._setProperty("_doStroke", !0), (e1 = this._renderer).stroke.apply(e1, arguments), this;
                }, s.default.prototype.erase = function() {
                    return this._renderer.erase(0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 255, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 255), this;
                }, s.default.prototype.noErase = function() {
                    return this._renderer.noErase(), this;
                };
                var n = s.default;
                r.default = n;
            },
            {
                "../core/constants": 264,
                "../core/main": 275,
                "./p5.Color": 262,
                "core-js/modules/es.array.fill": 154,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        264: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.QUADRATIC = r.LINEAR = r._CTX_MIDDLE = r._DEFAULT_LEADMULT = r._DEFAULT_TEXT_FILL = r.WORD = r.CHAR = r.BOLDITALIC = r.BOLD = r.ITALIC = r.NORMAL = r.BLUR = r.ERODE = r.DILATE = r.POSTERIZE = r.INVERT = r.OPAQUE = r.GRAY = r.THRESHOLD = r.BURN = r.DODGE = r.SOFT_LIGHT = r.HARD_LIGHT = r.OVERLAY = r.REPLACE = r.SCREEN = r.MULTIPLY = r.EXCLUSION = r.SUBTRACT = r.DIFFERENCE = r.LIGHTEST = r.DARKEST = r.ADD = r.REMOVE = r.BLEND = r.UP_ARROW = r.TAB = r.SHIFT = r.RIGHT_ARROW = r.RETURN = r.OPTION = r.LEFT_ARROW = r.ESCAPE = r.ENTER = r.DOWN_ARROW = r.DELETE = r.CONTROL = r.BACKSPACE = r.ALT = r.AUTO = r.HSL = r.HSB = r.RGB = r.MITER = r.BEVEL = r.ROUND = r.SQUARE = r.PROJECT = r.PIE = r.CHORD = r.OPEN = r.CLOSE = r.TESS = r.QUAD_STRIP = r.QUADS = r.TRIANGLE_STRIP = r.TRIANGLE_FAN = r.TRIANGLES = r.LINE_LOOP = r.LINE_STRIP = r.LINES = r.POINTS = r.BASELINE = r.BOTTOM = r.TOP = r.CENTER = r.LEFT = r.RIGHT = r.RADIUS = r.CORNERS = r.CORNER = r.RAD_TO_DEG = r.DEG_TO_RAD = r.RADIANS = r.DEGREES = r.TWO_PI = r.TAU = r.QUARTER_PI = r.PI = r.HALF_PI = r.WAIT = r.TEXT = r.MOVE = r.HAND = r.CROSS = r.ARROW = r.WEBGL2 = r.WEBGL = r.P2D = r.VERSION = void 0, r.RGBA = r.HALF_FLOAT = r.FLOAT = r.UNSIGNED_INT = r.UNSIGNED_BYTE = r.COVER = r.CONTAIN = r.FALLBACK = r.LABEL = r.AXES = r.GRID = r._DEFAULT_FILL = r._DEFAULT_STROKE = r.PORTRAIT = r.LANDSCAPE = r.SMOOTH = r.FLAT = r.MIRROR = r.CLAMP = r.REPEAT = r.NEAREST = r.IMAGE = r.IMMEDIATE = r.TEXTURE = r.FILL = r.STROKE = r.CURVE = r.BEZIER = void 0;
                var o = Math.PI, n = (r.VERSION = "1.9.0", r.P2D = "p2d", r.WEBGL = "webgl", r.WEBGL2 = "webgl2", r.ARROW = "default", r.CROSS = "crosshair", r.HAND = "pointer", r.MOVE = "move", r.TEXT = "text", r.WAIT = "wait", o / 2), n = (r.HALF_PI = n, o), n = (r.PI = n, o / 4), n = (r.QUARTER_PI = n, 2 * o), n = (r.TAU = n, 2 * o), n = (r.TWO_PI = n, r.DEGREES = "degrees", r.RADIANS = "radians", o / 180), n = (r.DEG_TO_RAD = n, 180 / o);
                r.RAD_TO_DEG = n, r.CORNER = "corner", r.CORNERS = "corners", r.RADIUS = "radius", r.RIGHT = "right", r.LEFT = "left", r.CENTER = "center", r.TOP = "top", r.BOTTOM = "bottom", r.BASELINE = "alphabetic", r.POINTS = 0, r.LINES = 1, r.LINE_STRIP = 3, r.LINE_LOOP = 2, r.TRIANGLES = 4, r.TRIANGLE_FAN = 6, r.TRIANGLE_STRIP = 5, r.QUADS = "quads", r.QUAD_STRIP = "quad_strip", r.TESS = "tess", r.CLOSE = "close", r.OPEN = "open", r.CHORD = "chord", r.PIE = "pie", r.PROJECT = "square", r.SQUARE = "butt", r.ROUND = "round", r.BEVEL = "bevel", r.MITER = "miter", r.RGB = "rgb", r.HSB = "hsb", r.HSL = "hsl", r.AUTO = "auto", r.ALT = 18, r.BACKSPACE = 8, r.CONTROL = 17, r.DELETE = 46, r.DOWN_ARROW = 40, r.ENTER = 13, r.ESCAPE = 27, r.LEFT_ARROW = 37, r.OPTION = 18, r.RETURN = 13, r.RIGHT_ARROW = 39, r.SHIFT = 16, r.TAB = 9, r.UP_ARROW = 38, r.BLEND = "source-over", r.REMOVE = "destination-out", r.ADD = "lighter", r.DARKEST = "darken", r.LIGHTEST = "lighten", r.DIFFERENCE = "difference", r.SUBTRACT = "subtract", r.EXCLUSION = "exclusion", r.MULTIPLY = "multiply", r.SCREEN = "screen", r.REPLACE = "copy", r.OVERLAY = "overlay", r.HARD_LIGHT = "hard-light", r.SOFT_LIGHT = "soft-light", r.DODGE = "color-dodge", r.BURN = "color-burn", r.THRESHOLD = "threshold", r.GRAY = "gray", r.OPAQUE = "opaque", r.INVERT = "invert", r.POSTERIZE = "posterize", r.DILATE = "dilate", r.ERODE = "erode", r.BLUR = "blur", r.NORMAL = "normal", r.ITALIC = "italic", r.BOLD = "bold", r.BOLDITALIC = "bold italic", r.CHAR = "CHAR", r.WORD = "WORD", r._DEFAULT_TEXT_FILL = "#000000", r._DEFAULT_LEADMULT = 1.25, r._CTX_MIDDLE = "middle", r.LINEAR = "linear", r.QUADRATIC = "quadratic", r.BEZIER = "bezier", r.CURVE = "curve", r.STROKE = "stroke", r.FILL = "fill", r.TEXTURE = "texture", r.IMMEDIATE = "immediate", r.IMAGE = "image", r.NEAREST = "nearest", r.REPEAT = "repeat", r.CLAMP = "clamp", r.MIRROR = "mirror", r.FLAT = "flat", r.SMOOTH = "smooth", r.LANDSCAPE = "landscape", r.PORTRAIT = "portrait", r._DEFAULT_STROKE = "#000000", r._DEFAULT_FILL = "#FFFFFF", r.GRID = "grid", r.AXES = "axes", r.LABEL = "label", r.FALLBACK = "fallback", r.CONTAIN = "contain", r.COVER = "cover", r.UNSIGNED_BYTE = "unsigned-byte", r.UNSIGNED_INT = "unsigned-int", r.FLOAT = "float", r.HALF_FLOAT = "half-float";
                r.RGBA = "rgba";
            },
            {}
        ],
        265: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.search"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.search"), e1("core-js/modules/es.string.split"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (s = e1("./main")) && s.__esModule ? s : {
                    default: s
                }, s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("./constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                var l = [
                    s.ARROW,
                    s.CROSS,
                    s.HAND,
                    s.MOVE,
                    s.TEXT,
                    s.WAIT
                ], u = (n.default.prototype._frameRate = 0, n.default.prototype._lastFrameTime = window.performance.now(), n.default.prototype._targetFrameRate = 60, window.print), c = !1;
                function d() {
                    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth || 0;
                }
                function h() {
                    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight || 0;
                }
                n.default.prototype.print = function() {
                    var e1;
                    arguments.length ? (e1 = console).log.apply(e1, arguments) : c || (u(), window.confirm("You just tried to print the webpage. Do you want to prevent this from running again?") && (c = !0));
                }, n.default.prototype.frameCount = 0, n.default.prototype.deltaTime = 0, n.default.prototype.focused = document.hasFocus(), n.default.prototype.cursor = function(e1, t, r) {
                    var o, n = "auto", s = this._curElement.elt;
                    l.includes(e1) ? n = e1 : "string" == typeof e1 && (o = "", t && r && "number" == typeof t && "number" == typeof r && (o = "".concat(t, " ").concat(r)), n = "http://" === e1.substring(0, 7) || "https://" === e1.substring(0, 8) || /\.(cur|jpg|jpeg|gif|png|CUR|JPG|JPEG|GIF|PNG)$/.test(e1) ? "url(".concat(e1, ") ").concat(o, ", auto") : e1), s.style.cursor = n;
                }, n.default.prototype.frameRate = function(e1) {
                    return n.default._validateParameters("frameRate", arguments), "number" != typeof e1 || e1 < 0 ? this._frameRate : (this._setProperty("_targetFrameRate", e1), 0 === e1 && this._setProperty("_frameRate", e1), this);
                }, n.default.prototype.getFrameRate = function() {
                    return this.frameRate();
                }, n.default.prototype.setFrameRate = function(e1) {
                    return this.frameRate(e1);
                }, n.default.prototype.getTargetFrameRate = function() {
                    return this._targetFrameRate;
                }, n.default.prototype.noCursor = function() {
                    this._curElement.elt.style.cursor = "none";
                }, n.default.prototype.webglVersion = s.P2D, n.default.prototype.displayWidth = screen.width, n.default.prototype.displayHeight = screen.height, n.default.prototype.windowWidth = d(), n.default.prototype.windowHeight = h(), n.default.prototype._onresize = function(e1) {
                    this._setProperty("windowWidth", d()), this._setProperty("windowHeight", h());
                    var t = this._isGlobal ? window : this;
                    "function" != typeof t.windowResized || void 0 === (t = t.windowResized(e1)) || t || e1.preventDefault();
                }, n.default.prototype.width = 0, n.default.prototype.height = 0, n.default.prototype.fullscreen = function(e1) {
                    if (n.default._validateParameters("fullscreen", arguments), void 0 === e1) return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
                    if (e1) {
                        e1 = document.documentElement;
                        if (!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled)) throw new Error("Fullscreen not enabled in this browser.");
                        e1.requestFullscreen ? e1.requestFullscreen() : e1.mozRequestFullScreen ? e1.mozRequestFullScreen() : e1.webkitRequestFullscreen ? e1.webkitRequestFullscreen() : e1.msRequestFullscreen && e1.msRequestFullscreen();
                    } else document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.msExitFullscreen && document.msExitFullscreen();
                }, n.default.prototype.pixelDensity = function(e1) {
                    var t;
                    return n.default._validateParameters("pixelDensity", arguments), "number" == typeof e1 ? (e1 !== this._pixelDensity && (this._pixelDensity = e1), (t = this).resizeCanvas(this.width, this.height, !0)) : t = this._pixelDensity, t;
                }, n.default.prototype.displayDensity = function() {
                    return window.devicePixelRatio;
                }, n.default.prototype.getURL = function() {
                    return location.href;
                }, n.default.prototype.getURLPath = function() {
                    return location.pathname.split("/").filter(function(e1) {
                        return "" !== e1;
                    });
                }, n.default.prototype.getURLParams = function() {
                    for(var e1, t = /[?&]([^&=]+)(?:[&=])([^&=]+)/gim, r = {}; null != (e1 = t.exec(location.search));)e1.index === t.lastIndex && t.lastIndex++, r[e1[1]] = e1[2];
                    return r;
                };
                e1 = n.default;
                r.default = e1;
            },
            {
                "./constants": 264,
                "./main": 275,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.filter": 155,
                "core-js/modules/es.array.includes": 159,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.string.includes": 191,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.string.search": 197,
                "core-js/modules/es.string.split": 198,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        266: [
            function(r, e1, t) {
                "use strict";
                r("core-js/modules/es.symbol"), r("core-js/modules/es.symbol.description"), r("core-js/modules/es.symbol.iterator"), r("core-js/modules/es.array.concat"), r("core-js/modules/es.array.filter"), r("core-js/modules/es.array.for-each"), r("core-js/modules/es.array.includes"), r("core-js/modules/es.array.iterator"), r("core-js/modules/es.array.join"), r("core-js/modules/es.array.map"), r("core-js/modules/es.array.slice"), r("core-js/modules/es.array.some"), r("core-js/modules/es.function.name"), r("core-js/modules/es.object.assign"), r("core-js/modules/es.object.get-own-property-names"), r("core-js/modules/es.object.keys"), r("core-js/modules/es.object.to-string"), r("core-js/modules/es.regexp.constructor"), r("core-js/modules/es.regexp.exec"), r("core-js/modules/es.regexp.to-string"), r("core-js/modules/es.string.iterator"), r("core-js/modules/es.string.match"), r("core-js/modules/es.string.replace"), r("core-js/modules/es.string.split"), r("core-js/modules/es.string.starts-with"), r("core-js/modules/web.dom-collections.for-each"), r("core-js/modules/web.dom-collections.iterator"), r("core-js/modules/es.symbol"), r("core-js/modules/es.symbol.description"), r("core-js/modules/es.symbol.iterator"), r("core-js/modules/es.array.concat"), r("core-js/modules/es.array.filter"), r("core-js/modules/es.array.for-each"), r("core-js/modules/es.array.includes"), r("core-js/modules/es.array.iterator"), r("core-js/modules/es.array.join"), r("core-js/modules/es.array.map"), r("core-js/modules/es.array.slice"), r("core-js/modules/es.array.some"), r("core-js/modules/es.function.name"), r("core-js/modules/es.object.assign"), r("core-js/modules/es.object.get-own-property-names"), r("core-js/modules/es.object.keys"), r("core-js/modules/es.object.to-string"), r("core-js/modules/es.regexp.constructor"), r("core-js/modules/es.regexp.exec"), r("core-js/modules/es.regexp.to-string"), r("core-js/modules/es.string.iterator"), r("core-js/modules/es.string.match"), r("core-js/modules/es.string.replace"), r("core-js/modules/es.string.split"), r("core-js/modules/es.string.starts-with"), r("core-js/modules/web.dom-collections.for-each"), r("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var o = (l = r("../main")) && l.__esModule ? l : {
                    default: l
                };
                r("../internationalization");
                function n(r, o) {
                    o = o || console.log.bind(console), s || i(), s.some(function(e1) {
                        var t;
                        if (r.message && null !== r.message.match("\\W?".concat(e1.name, "\\W"))) return t = "function" === e1.type ? "".concat(e1.name, "()") : e1.name, o("Did you just try to use p5.js's ".concat(t, " ").concat(e1.type, "? If so, you may want to move it into your sketch's setup() function.\n\nFor more details, see: ").concat(a)), !0;
                    });
                }
                var s = null, i = null, a = (o.default._friendlyError = o.default._checkForUserDefinedFunctions = o.default._fesErrorMonitor = function() {}, s = null, "https://github.com/processing/p5.js/wiki/p5.js-overview#why-cant-i-assign-variables-using-p5-functions-and-variables-before-setup"), i = function() {
                    function e1(r) {
                        return Object.getOwnPropertyNames(r).filter(function(e1) {
                            return "_" !== e1[0] && !(e1 in t) && (t[e1] = !0);
                        }).map(function(e1) {
                            var t = "function" == typeof r[e1] ? "function" : e1 === e1.toUpperCase() ? "constant" : "variable";
                            return {
                                name: e1,
                                type: t
                            };
                        });
                    }
                    var t = {};
                    (s = [].concat(e1(o.default.prototype), e1(r("../constants")))).sort(function(e1, t) {
                        return t.name.length - e1.name.length;
                    });
                }, l = (o.default.prototype._helpForMisusedAtTopLevelCode = n, "complete" !== document.readyState && (window.addEventListener("error", n, !1), window.addEventListener("load", function() {
                    window.removeEventListener("error", n, !1);
                })), o.default);
                t.default = l;
            },
            {
                "../constants": 264,
                "../internationalization": 273,
                "../main": 275,
                "./browser_errors": void 0,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.filter": 155,
                "core-js/modules/es.array.for-each": 157,
                "core-js/modules/es.array.includes": 159,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.join": 162,
                "core-js/modules/es.array.map": 164,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.array.some": 166,
                "core-js/modules/es.function.name": 168,
                "core-js/modules/es.object.assign": 176,
                "core-js/modules/es.object.get-own-property-names": 179,
                "core-js/modules/es.object.keys": 181,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.constructor": 186,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.string.match": 193,
                "core-js/modules/es.string.replace": 196,
                "core-js/modules/es.string.split": 198,
                "core-js/modules/es.string.starts-with": 199,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/web.dom-collections.for-each": 237,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        267: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var o = (o = e1("../main")) && o.__esModule ? o : {
                    default: o
                };
                e1("../internationalization");
                o.default._friendlyFileLoadError = function() {};
                e1 = o.default;
                r.default = e1;
            },
            {
                "../internationalization": 273,
                "../main": 275
            }
        ],
        268: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/web.dom-collections.for-each"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = O(e1("../main")), s = e1("../internationalization"), a = C(e1("../constants")), l, u, c, d, h, f, p, m, y, g, v, b, j, _, x, w, S, T, M, E, I;
                function k() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, k = function() {
                        return e1;
                    }, e1);
                }
                function C(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = k();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o, n = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1)Object.prototype.hasOwnProperty.call(e1, r) && ((o = s ? Object.getOwnPropertyDescriptor(e1, r) : null) && (o.get || o.set) ? Object.defineProperty(n, r, o) : n[r] = e1[r]);
                    return n.default = e1, t && t.set(e1, n), n;
                }
                function O(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function D(e1) {
                    return L(e1) || A(e1) || P();
                }
                function P() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance");
                }
                function A(e1) {
                    if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                }
                function L(e1) {
                    if (Array.isArray(e1)) {
                        for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                        return r;
                    }
                }
                n.default._fesCodeReader = function() {};
                var R = n.default;
                r.default = R;
            },
            {
                "../constants": 264,
                "../internationalization": 273,
                "../main": 275,
                "core-js/modules/es.array.filter": 155,
                "core-js/modules/es.array.for-each": 157,
                "core-js/modules/es.array.from": 158,
                "core-js/modules/es.array.includes": 159,
                "core-js/modules/es.array.index-of": 160,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.join": 162,
                "core-js/modules/es.array.map": 164,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.keys": 181,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.constructor": 186,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.includes": 191,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.string.match": 193,
                "core-js/modules/es.string.split": 198,
                "core-js/modules/es.string.trim": 201,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.for-each": 237,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        269: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function o() {
                    var t = /(^|@)\S+:\d+/, r = /^\s*at .*(\S+:\d+|\(native\))/m, o = /^(eval@)?(\[native code])?$/;
                    return {
                        parse: function(e1) {
                            return void 0 !== e1.stacktrace || void 0 !== e1["opera#sourceloc"] ? this.parseOpera(e1) : e1.stack && e1.stack.match(r) ? this.parseV8OrIE(e1) : e1.stack ? this.parseFFOrSafari(e1) : void 0;
                        },
                        extractLocation: function(e1) {
                            return -1 === e1.indexOf(":") ? [
                                e1
                            ] : [
                                (e1 = /(.+?)(?::(\d+))?(?::(\d+))?$/.exec(e1.replace(/[()]/g, "")))[1],
                                e1[2] || void 0,
                                e1[3] || void 0
                            ];
                        },
                        parseV8OrIE: function(e1) {
                            return e1.stack.split("\n").filter(function(e1) {
                                return !!e1.match(r);
                            }, this).map(function(e1) {
                                var t = (e1 = -1 < e1.indexOf("(eval ") ? e1.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, "") : e1).replace(/^\s+/, "").replace(/\(eval code/g, "("), r = t.match(/ (\((.+):(\d+):(\d+)\)$)/), t = (t = r ? t.replace(r[0], "") : t).split(/\s+/).slice(1), r = this.extractLocation(r ? r[1] : t.pop());
                                return {
                                    functionName: t.join(" ") || void 0,
                                    fileName: -1 < [
                                        "eval",
                                        "<anonymous>"
                                    ].indexOf(r[0]) ? void 0 : r[0],
                                    lineNumber: r[1],
                                    columnNumber: r[2],
                                    source: e1
                                };
                            }, this);
                        },
                        parseFFOrSafari: function(e1) {
                            return e1.stack.split("\n").filter(function(e1) {
                                return !e1.match(o);
                            }, this).map(function(e1) {
                                var t, r;
                                return -1 === (e1 = -1 < e1.indexOf(" > eval") ? e1.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1") : e1).indexOf("@") && -1 === e1.indexOf(":") ? {
                                    functionName: e1
                                } : {
                                    functionName: (r = e1.match(t = /((.*".+"[^@]*)?[^@]*)(?:@)/)) && r[1] ? r[1] : void 0,
                                    fileName: (r = this.extractLocation(e1.replace(t, "")))[0],
                                    lineNumber: r[1],
                                    columnNumber: r[2],
                                    source: e1
                                };
                            }, this);
                        },
                        parseOpera: function(e1) {
                            return !e1.stacktrace || -1 < e1.message.indexOf("\n") && e1.message.split("\n").length > e1.stacktrace.split("\n").length ? this.parseOpera9(e1) : e1.stack ? this.parseOpera11(e1) : this.parseOpera10(e1);
                        },
                        parseOpera9: function(e1) {
                            for(var t = /Line (\d+).*script (?:in )?(\S+)/i, r = e1.message.split("\n"), o = [], n = 2, s = r.length; n < s; n += 2){
                                var i = t.exec(r[n]);
                                i && o.push({
                                    fileName: i[2],
                                    lineNumber: i[1],
                                    source: r[n]
                                });
                            }
                            return o;
                        },
                        parseOpera10: function(e1) {
                            for(var t = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, r = e1.stacktrace.split("\n"), o = [], n = 0, s = r.length; n < s; n += 2){
                                var i = t.exec(r[n]);
                                i && o.push({
                                    functionName: i[3] || void 0,
                                    fileName: i[2],
                                    lineNumber: i[1],
                                    source: r[n]
                                });
                            }
                            return o;
                        },
                        parseOpera11: function(e1) {
                            return e1.stack.split("\n").filter(function(e1) {
                                return !!e1.match(t) && !e1.match(/^Error created at/);
                            }, this).map(function(e1) {
                                var t, r = e1.split("@"), o = this.extractLocation(r.pop()), r = r.shift() || "";
                                return {
                                    functionName: r.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0,
                                    args: void 0 === (t = r.match(/\(([^)]*)\)/) ? r.replace(/^[^(]+\(([^)]*)\)$/, "$1") : t) || "[arguments not available]" === t ? void 0 : t.split(","),
                                    fileName: o[0],
                                    lineNumber: o[1],
                                    columnNumber: o[2],
                                    source: e1
                                };
                            }, this);
                        }
                    };
                }
                e1.default._getErrorStackParser = function() {
                    return new o;
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../main": 275,
                "core-js/modules/es.array.filter": 155,
                "core-js/modules/es.array.index-of": 160,
                "core-js/modules/es.array.join": 162,
                "core-js/modules/es.array.map": 164,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.string.match": 193,
                "core-js/modules/es.string.replace": 196,
                "core-js/modules/es.string.split": 198
            }
        ],
        270: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.map"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (n = e1("../main")) && n.__esModule ? n : {
                    default: n
                };
                (function(e1) {
                    if (e1 && e1.__esModule) return;
                    if (null === e1 || "object" !== a(e1) && "function" != typeof e1) return;
                    var t = i();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                })(e1("../constants")), e1("../internationalization");
                function i() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, i = function() {
                        return e1;
                    }, e1);
                }
                function a(e1) {
                    return (a = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                n.default._validateParameters = n.default._clearValidateParamsCache = function() {};
                e1 = n.default;
                r.default = e1;
            },
            {
                "../../../docs/parameterData.json": void 0,
                "../constants": 264,
                "../internationalization": 273,
                "../main": 275,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.for-each": 157,
                "core-js/modules/es.array.includes": 159,
                "core-js/modules/es.array.index-of": 160,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.join": 162,
                "core-js/modules/es.array.last-index-of": 163,
                "core-js/modules/es.array.map": 164,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.function.name": 168,
                "core-js/modules/es.map": 169,
                "core-js/modules/es.number.constructor": 173,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.get-prototype-of": 180,
                "core-js/modules/es.object.keys": 181,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.reflect.construct": 184,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.set": 189,
                "core-js/modules/es.string.includes": 191,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.string.split": 198,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.for-each": 237,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        271: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("./constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                r.default = {
                    modeAdjust: function(e1, t, r, o, n) {
                        return n === s.CORNER ? {
                            x: e1,
                            y: t,
                            w: r,
                            h: o
                        } : n === s.CORNERS ? {
                            x: e1,
                            y: t,
                            w: r - e1,
                            h: o - t
                        } : n === s.RADIUS ? {
                            x: e1 - r,
                            y: t - o,
                            w: 2 * r,
                            h: 2 * o
                        } : n === s.CENTER ? {
                            x: e1 - .5 * r,
                            y: t - .5 * o,
                            w: r,
                            h: o
                        } : void 0;
                    }
                };
            },
            {
                "./constants": 264,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        272: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator");
                var o = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                };
                e1("./internationalization");
                var n = Promise.resolve();
                Promise.all([
                    new Promise(function(e1, t) {
                        "complete" === document.readyState ? e1() : window.addEventListener("load", e1, !1);
                    }),
                    n
                ]).then(function() {
                    void 0 !== window._setupDone ? console.warn("p5.js seems to have been imported multiple times. Please remove the duplicate import") : window.mocha || (window.setup && "function" == typeof window.setup || window.draw && "function" == typeof window.draw) && !o.default.instance && new o.default;
                });
            },
            {
                "../core/main": 275,
                "./internationalization": 273,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.promise": 183,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        273: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.setTranslatorLanguage = r.currentTranslatorLanguage = r.availableTranslatorLanguages = r.initialize = r.translator = void 0;
                var n, s, o = a(e1("i18next")), i = a(e1("i18next-browser-languagedetector"));
                function a(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function l(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                var u = function() {
                    function r(e1, t) {
                        if (!(this instanceof r)) throw new TypeError("Cannot call a class as a function");
                        this.init(e1, t);
                    }
                    var e1, t, o;
                    return e1 = r, t = [
                        {
                            key: "fetchWithTimeout",
                            value: function(e1, t) {
                                var r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 2e3;
                                return Promise.race([
                                    fetch(e1, t),
                                    new Promise(function(e1, t) {
                                        return setTimeout(function() {
                                            return t(new Error("timeout"));
                                        }, r);
                                    })
                                ]);
                            }
                        },
                        {
                            key: "init",
                            value: function(e1) {
                                var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
                                this.services = e1, this.options = t;
                            }
                        },
                        {
                            key: "read",
                            value: function(e1, t, r) {
                                var o = this.options.loadPath;
                                e1 === this.options.fallback ? r(null, n[e1][t]) : s.includes(e1) ? (o = this.services.interpolator.interpolate(o, {
                                    lng: e1,
                                    ns: t
                                }), this.loadUrl(o, r)) : r("Not found", !1);
                            }
                        },
                        {
                            key: "loadUrl",
                            value: function(t, r) {
                                this.fetchWithTimeout(t).then(function(e1) {
                                    if (e1.ok) return e1.json();
                                    throw new Error("failed loading ".concat(t));
                                }, function() {
                                    throw new Error("failed loading ".concat(t));
                                }).then(function(e1) {
                                    return r(null, e1);
                                }).catch(r);
                            }
                        }
                    ], l(e1.prototype, t), o && l(e1, o), r;
                }();
                u.type = "backend", r.translator = function(e1, t) {
                    console.debug("p5.js translator called before translations were loaded"), o.default.t(e1, t);
                }, r.initialize = function() {
                    return o.default.use(i.default).use(u).init({
                        fallbackLng: "en",
                        nestingPrefix: "$tr(",
                        nestingSuffix: ")",
                        defaultNS: "translation",
                        returnEmptyString: !1,
                        interpolation: {
                            escapeValue: !1
                        },
                        detection: {
                            checkWhitelist: !1,
                            order: [
                                "querystring",
                                "navigator",
                                "htmlTag",
                                "path",
                                "subdomain"
                            ],
                            caches: []
                        },
                        backend: {
                            fallback: "en",
                            loadPath: "https://cdn.jsdelivr.net/npm/p5/translations/{{lng}}/{{ns}}.json"
                        },
                        partialBundledLanguages: !0,
                        resources: n
                    }).then(function(e1) {
                        r.translator = e1;
                    }, function(e1) {
                        return console.debug("Translations failed to load (".concat(e1, ")"));
                    });
                }, r.availableTranslatorLanguages = function() {
                    return o.default.languages;
                }, r.currentTranslatorLanguage = function(e1) {
                    return o.default.language;
                };
                r.setTranslatorLanguage = function(e1) {
                    return o.default.changeLanguage(e1 || void 0, function(e1) {
                        return console.debug("Translations failed to load (".concat(e1, ")"));
                    });
                };
            },
            {
                "../../translations": void 0,
                "../../translations/dev": void 0,
                "core-js/modules/es.array.includes": 159,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.join": 162,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.object.keys": 181,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.promise": 183,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.string.includes": 191,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.string.split": 198,
                "core-js/modules/web.dom-collections.iterator": 238,
                i18next: 3,
                "i18next-browser-languagedetector": 3
            }
        ],
        274: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("./main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype.pushStyle = function() {
                    throw new Error("pushStyle() not used, see push()");
                }, e1.default.prototype.popStyle = function() {
                    throw new Error("popStyle() not used, see pop()");
                }, e1.default.prototype.popMatrix = function() {
                    throw new Error("popMatrix() not used, see pop()");
                }, e1.default.prototype.pushMatrix = function() {
                    throw new Error("pushMatrix() not used, see push()");
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "./main": 275
            }
        ],
        275: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-own-property-names"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.object.get-own-property-names"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0, e1("./shim");
                var n = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("./constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                var l, u = function() {
                    function g(e1, t) {
                        var d = this;
                        if (!(this instanceof g)) throw new TypeError("Cannot call a class as a function");
                        this._setupDone = !1, this._preloadDone = !1, this._pixelDensity = Math.ceil(window.devicePixelRatio) || 1, this._userNode = t, this._curElement = null, this._elements = [], this._glAttributes = null, this._requestAnimId = 0, this._preloadCount = 0, this._isGlobal = !1, this._loop = !0, this._startListener = null, this._initializeInstanceVariables(), this._defaultCanvasSize = {
                            width: 100,
                            height: 100
                        }, this._events = {
                            mousemove: null,
                            mousedown: null,
                            mouseup: null,
                            dragend: null,
                            dragover: null,
                            click: null,
                            dblclick: null,
                            mouseover: null,
                            mouseout: null,
                            keydown: null,
                            keyup: null,
                            keypress: null,
                            touchstart: null,
                            touchmove: null,
                            touchend: null,
                            resize: null,
                            blur: null
                        }, this._millisStart = -1, this._recording = !1, this._lcg_random_state = null, this._gaussian_previous = !1, this._events.wheel = null, this._loadingScreenId = "p5_loading", this._registeredMethods = {};
                        var t = Object.getOwnPropertyNames(g.prototype._registeredMethods), r = !0, o = !1, n = void 0;
                        try {
                            for(var s, i = t[Symbol.iterator](); !(r = (s = i.next()).done); r = !0){
                                var a = s.value;
                                this._registeredMethods[a] = g.prototype._registeredMethods[a].slice();
                            }
                        } catch (e1) {
                            o = !0, n = e1;
                        } finally{
                            try {
                                r || null == i.return || i.return();
                            } finally{
                                if (o) throw n;
                            }
                        }
                        window.DeviceOrientationEvent && (this._events.deviceorientation = null), window.DeviceMotionEvent && !window._isNodeWebkit && (this._events.devicemotion = null), g.prototype.callRegisteredHooksFor = function(t) {
                            var e1 = this || g.prototype, r = this._isGlobal ? window : this;
                            if (e1._registeredMethods.hasOwnProperty(t)) {
                                var e1 = e1._registeredMethods[t], o = !0, t = !1, n = void 0;
                                try {
                                    for(var s, i = e1[Symbol.iterator](); !(o = (s = i.next()).done); o = !0){
                                        var a = s.value;
                                        "function" == typeof a && a.call(r);
                                    }
                                } catch (e1) {
                                    t = !0, n = e1;
                                } finally{
                                    try {
                                        o || null == i.return || i.return();
                                    } finally{
                                        if (t) throw n;
                                    }
                                }
                            }
                        }, this._start = function() {
                            d._userNode && "string" == typeof d._userNode && (d._userNode = document.getElementById(d._userNode));
                            var e1 = d._isGlobal ? window : d;
                            if (e1.preload) {
                                d.callRegisteredHooksFor("beforePreload");
                                var t, r = document.getElementById(d._loadingScreenId), o = (r || ((r = document.createElement("div")).innerHTML = "Loading...", r.style.position = "absolute", r.id = d._loadingScreenId, (d._userNode || document.body).appendChild(r)), d._preloadMethods);
                                for(t in o){
                                    o[t] = o[t] || g;
                                    var n = o[t];
                                    n !== g.prototype && n !== g || (d._isGlobal && (window[t] = d._wrapPreload(d, t)), n = d), d._registeredPreloadMethods[t] = n[t], n[t] = d._wrapPreload(n, t);
                                }
                                e1.preload(), d._runIfPreloadsAreDone();
                            } else d._setup(), d._recording || d._draw();
                        }, this._runIfPreloadsAreDone = function() {
                            var e1, t = this._isGlobal ? window : this;
                            0 === t._preloadCount && ((e1 = document.getElementById(t._loadingScreenId)) && e1.parentNode.removeChild(e1), this.callRegisteredHooksFor("afterPreload"), this._setupDone || (this._lastTargetFrameTime = window.performance.now(), this._lastRealFrameTime = window.performance.now(), t._setup(), this._recording || t._draw()));
                        }, this._decrementPreload = function() {
                            var e1 = this._isGlobal ? window : this;
                            e1._preloadDone || "function" != typeof e1.preload || (e1._setProperty("_preloadCount", e1._preloadCount - 1), e1._runIfPreloadsAreDone());
                        }, this._wrapPreload = function(o, n) {
                            var s = this;
                            return function() {
                                s._incrementPreload();
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                return s._registeredPreloadMethods[n].apply(o, t);
                            };
                        }, this._incrementPreload = function() {
                            var e1 = this._isGlobal ? window : this;
                            e1._preloadDone || e1._setProperty("_preloadCount", e1._preloadCount + 1);
                        }, this._setup = function() {
                            d.callRegisteredHooksFor("beforeSetup"), d.createCanvas(d._defaultCanvasSize.width, d._defaultCanvasSize.height, "p2d");
                            var e1 = d._isGlobal ? window : d;
                            if ("function" == typeof e1.preload) for(var t in d._preloadMethods)e1[t] = d._preloadMethods[t][t], e1[t] && d && (e1[t] = e1[t].bind(d));
                            d._millisStart = window.performance.now(), e1._preloadDone = !0, "function" == typeof e1.setup && e1.setup();
                            var r = document.getElementsByTagName("canvas"), o = !0, n = !1, s = void 0;
                            try {
                                for(var i, a = r[Symbol.iterator](); !(o = (i = a.next()).done); o = !0){
                                    var l = i.value;
                                    "true" === l.dataset.hidden && (l.style.visibility = "", delete l.dataset.hidden);
                                }
                            } catch (e1) {
                                n = !0, s = e1;
                            } finally{
                                try {
                                    o || null == a.return || a.return();
                                } finally{
                                    if (n) throw s;
                                }
                            }
                            d._lastTargetFrameTime = window.performance.now(), d._lastRealFrameTime = window.performance.now(), d._setupDone = !0, (d._accessibleOutputs.grid || d._accessibleOutputs.text) && d._updateAccsOutput(), d.callRegisteredHooksFor("afterSetup");
                        }, this._draw = function() {
                            var e1 = window.performance.now(), t = e1 - d._lastTargetFrameTime, r = 1e3 / d._targetFrameRate;
                            (!d._loop || r - 5 <= t) && (d.deltaTime = e1 - d._lastRealFrameTime, d._setProperty("deltaTime", d.deltaTime), d._frameRate = 1e3 / d.deltaTime, d.redraw(), d._lastTargetFrameTime = Math.max(d._lastTargetFrameTime + r, e1), d._lastRealFrameTime = e1, void 0 !== d._updateMouseCoords && (d._updateMouseCoords(), d._setProperty("movedX", 0), d._setProperty("movedY", 0))), d._loop && (d._requestAnimId = window.requestAnimationFrame(d._draw));
                        }, this._setProperty = function(e1, t) {
                            d[e1] = t, d._isGlobal && (window[e1] = t);
                        }, this.remove = function() {
                            d._startListener && window.removeEventListener("load", d._startListener, !1);
                            var t = document.getElementById(d._loadingScreenId);
                            if (t && (t.parentNode.removeChild(t), d._incrementPreload()), d._curElement) {
                                for(var e1 in d._loop = !1, d._requestAnimId && window.cancelAnimationFrame(d._requestAnimId), d._events)window.removeEventListener(e1, d._events[e1]);
                                var r = !0, t = !1, o = void 0;
                                try {
                                    for(var n, s = d._elements[Symbol.iterator](); !(r = (n = s.next()).done); r = !0){
                                        var i, a = n.value;
                                        for(i in a.elt && a.elt.parentNode && a.elt.parentNode.removeChild(a.elt), a._events)a.elt.removeEventListener(i, a._events[i]);
                                    }
                                } catch (e1) {
                                    t = !0, o = e1;
                                } finally{
                                    try {
                                        r || null == s.return || s.return();
                                    } finally{
                                        if (t) throw o;
                                    }
                                }
                                var l = d;
                                d._registeredMethods.remove.forEach(function(e1) {
                                    void 0 !== e1 && e1.call(l);
                                });
                            }
                            if (d._isGlobal) {
                                for(var u in g.prototype)try {
                                    delete window[u];
                                } catch (e1) {
                                    window[u] = void 0;
                                }
                                for(var c in d)if (d.hasOwnProperty(c)) try {
                                    delete window[c];
                                } catch (e1) {
                                    window[c] = void 0;
                                }
                                g.instance = null;
                            }
                        }, this._registeredMethods.init.forEach(function(e1) {
                            void 0 !== e1 && e1.call(this);
                        }, this), this._setupPromisePreloads();
                        var l, u, c = this._createFriendlyGlobalFunctionBinder();
                        if (e1) e1(this), g._checkForUserDefinedFunctions(this);
                        else {
                            for(var h in this._isGlobal = !0, g.instance = this, g.prototype)"function" == typeof g.prototype[h] ? (l = h.substring(2), this._events.hasOwnProperty(l) || (Math.hasOwnProperty(h) && Math[h] === g.prototype[h] ? c(h, g.prototype[h]) : c(h, g.prototype[h].bind(this)))) : c(h, g.prototype[h]);
                            for(var f in this)this.hasOwnProperty(f) && c(f, this[f]);
                        }
                        for(u in this._events){
                            var p = this["_on".concat(u)];
                            p && (p = p.bind(this), window.addEventListener(u, p, {
                                passive: !1
                            }), this._events[u] = p);
                        }
                        function m() {
                            d._setProperty("focused", !0);
                        }
                        function y() {
                            d._setProperty("focused", !1);
                        }
                        window.addEventListener("focus", m), window.addEventListener("blur", y), this.registerMethod("remove", function() {
                            window.removeEventListener("focus", m), window.removeEventListener("blur", y);
                        }), "complete" === document.readyState ? this._start() : (this._startListener = this._start.bind(this), window.addEventListener("load", this._startListener, !1));
                    }
                    var e1, t, r;
                    return e1 = g, t = [
                        {
                            key: "_initializeInstanceVariables",
                            value: function() {
                                this._accessibleOutputs = {
                                    text: !1,
                                    grid: !1,
                                    textLabel: !1,
                                    gridLabel: !1
                                }, this._styles = [], this._bezierDetail = 20, this._curveDetail = 20, this._colorMode = n.RGB, this._colorMaxes = {
                                    rgb: [
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    hsb: [
                                        360,
                                        100,
                                        100,
                                        1
                                    ],
                                    hsl: [
                                        360,
                                        100,
                                        100,
                                        1
                                    ]
                                }, this._downKeys = {};
                            }
                        },
                        {
                            key: "registerPreloadMethod",
                            value: function(e1, t) {
                                g.prototype._preloadMethods.hasOwnProperty(e1) || (g.prototype._preloadMethods[e1] = t);
                            }
                        },
                        {
                            key: "registerMethod",
                            value: function(e1, t) {
                                var r = this || g.prototype;
                                r._registeredMethods.hasOwnProperty(e1) || (r._registeredMethods[e1] = []), r._registeredMethods[e1].push(t);
                            }
                        },
                        {
                            key: "unregisterMethod",
                            value: function(e1, t) {
                                var r = this || g.prototype;
                                if (r._registeredMethods.hasOwnProperty(e1)) {
                                    for(var o = r._registeredMethods[e1], n = [], s = 0; s < o.length; s++)o[s] === t && n.push(s);
                                    for(var i = n.length - 1; 0 <= i; i--)o.splice(n[i], 1);
                                }
                            }
                        },
                        {
                            key: "_createFriendlyGlobalFunctionBinder",
                            value: function() {
                                var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}, r = e1.globalObject || window;
                                e1.log || console.log.bind(console);
                                return function(e1, t) {
                                    g.disableFriendlyErrors, r[e1] = t;
                                };
                            }
                        }
                    ], s(e1.prototype, t), r && s(e1, r), g;
                }();
                for(l in u.instance = null, u.disableFriendlyErrors = !1, n)u.prototype[l] = n[l];
                u.VERSION = n.VERSION, u.prototype._preloadMethods = {
                    loadJSON: u.prototype,
                    loadImage: u.prototype,
                    loadStrings: u.prototype,
                    loadXML: u.prototype,
                    loadBytes: u.prototype,
                    loadTable: u.prototype,
                    loadFont: u.prototype,
                    loadModel: u.prototype,
                    loadShader: u.prototype
                }, u.prototype._registeredMethods = {
                    init: [],
                    pre: [],
                    post: [],
                    remove: []
                }, u.prototype._registeredPreloadMethods = {}, r.default = u;
            },
            {
                "./constants": 264,
                "./shim": 286,
                "core-js/modules/es.array.for-each": 157,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.array.splice": 167,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.get-own-property-names": 179,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.for-each": 237,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        276: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (e1 = e1("./main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                n.default.Element = function() {
                    function r(e1, t) {
                        if (!(this instanceof r)) throw new TypeError("Cannot call a class as a function");
                        this.elt = e1, this._pInst = this._pixelsState = t, this._events = {}, this.width = this.elt.offsetWidth, this.height = this.elt.offsetHeight;
                    }
                    var e1, t, o;
                    return e1 = r, o = [
                        {
                            key: "_adjustListener",
                            value: function(e1, t, r) {
                                return !1 === t ? n.default.Element._detachListener(e1, r) : n.default.Element._attachListener(e1, t, r), this;
                            }
                        },
                        {
                            key: "_attachListener",
                            value: function(e1, t, r) {
                                r._events[e1] && n.default.Element._detachListener(e1, r);
                                t = t.bind(r);
                                r.elt.addEventListener(e1, t, !1), r._events[e1] = t;
                            }
                        },
                        {
                            key: "_detachListener",
                            value: function(e1, t) {
                                var r = t._events[e1];
                                t.elt.removeEventListener(e1, r, !1), t._events[e1] = null;
                            }
                        }
                    ], t = [
                        {
                            key: "parent",
                            value: function(e1) {
                                return void 0 === e1 ? this.elt.parentNode : ("string" == typeof e1 ? ("#" === e1[0] && (e1 = e1.substring(1)), e1 = document.getElementById(e1)) : e1 instanceof n.default.Element && (e1 = e1.elt), e1.appendChild(this.elt), this);
                            }
                        },
                        {
                            key: "id",
                            value: function(e1) {
                                return void 0 === e1 ? this.elt.id : (this.elt.id = e1, this.width = this.elt.offsetWidth, this.height = this.elt.offsetHeight, this);
                            }
                        },
                        {
                            key: "class",
                            value: function(e1) {
                                return void 0 === e1 ? this.elt.className : (this.elt.className = e1, this);
                            }
                        },
                        {
                            key: "mousePressed",
                            value: function(t) {
                                return n.default.Element._adjustListener("mousedown", function(e1) {
                                    return this._pInst._setProperty("mouseIsPressed", !0), this._pInst._setMouseButton(e1), t.call(this, e1);
                                }, this), this;
                            }
                        },
                        {
                            key: "doubleClicked",
                            value: function(e1) {
                                return n.default.Element._adjustListener("dblclick", e1, this), this;
                            }
                        },
                        {
                            key: "mouseWheel",
                            value: function(e1) {
                                return n.default.Element._adjustListener("wheel", e1, this), this;
                            }
                        },
                        {
                            key: "mouseReleased",
                            value: function(e1) {
                                return n.default.Element._adjustListener("mouseup", e1, this), this;
                            }
                        },
                        {
                            key: "mouseClicked",
                            value: function(e1) {
                                return n.default.Element._adjustListener("click", e1, this), this;
                            }
                        },
                        {
                            key: "mouseMoved",
                            value: function(e1) {
                                return n.default.Element._adjustListener("mousemove", e1, this), this;
                            }
                        },
                        {
                            key: "mouseOver",
                            value: function(e1) {
                                return n.default.Element._adjustListener("mouseover", e1, this), this;
                            }
                        },
                        {
                            key: "mouseOut",
                            value: function(e1) {
                                return n.default.Element._adjustListener("mouseout", e1, this), this;
                            }
                        },
                        {
                            key: "touchStarted",
                            value: function(e1) {
                                return n.default.Element._adjustListener("touchstart", e1, this), this;
                            }
                        },
                        {
                            key: "touchMoved",
                            value: function(e1) {
                                return n.default.Element._adjustListener("touchmove", e1, this), this;
                            }
                        },
                        {
                            key: "touchEnded",
                            value: function(e1) {
                                return n.default.Element._adjustListener("touchend", e1, this), this;
                            }
                        },
                        {
                            key: "dragOver",
                            value: function(e1) {
                                return n.default.Element._adjustListener("dragover", e1, this), this;
                            }
                        },
                        {
                            key: "dragLeave",
                            value: function(e1) {
                                return n.default.Element._adjustListener("dragleave", e1, this), this;
                            }
                        },
                        {
                            key: "_setProperty",
                            value: function(e1, t) {
                                this[e1] = t;
                            }
                        }
                    ], s(e1.prototype, t), o && s(e1, o), r;
                }();
                e1 = n.default.Element;
                r.default = e1;
            },
            {
                "./main": 275
            }
        ],
        277: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.object.get-prototype-of"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var c = (u = e1("./main")) && u.__esModule ? u : {
                    default: u
                }, d = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("./constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function s(e1, t) {
                    return (s = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function h(r) {
                    return function() {
                        var e1, t = l(r);
                        return f(this, function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = l(this).constructor, Reflect.construct(t, arguments, e1)) : t.apply(this, arguments));
                    };
                }
                function f(e1, t) {
                    return !t || "object" !== i(t) && "function" != typeof t ? p(e1) : t;
                }
                function p(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                function l(e1) {
                    return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                c.default.Graphics = function(e1) {
                    var t = u;
                    if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e1 && e1.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e1 && s(t, e1);
                    var r, l = h(u);
                    function u(e1, t, r, o, n) {
                        var s;
                        if (!(this instanceof u)) throw new TypeError("Cannot call a class as a function");
                        a = n || document.createElement("canvas"), (s = l.call(this, a, o)).canvas = a;
                        var i, a = r || d.P2D, r = o._userNode || document.body;
                        for(i in n || r.appendChild(s.canvas), c.default.prototype)s[i] || ("function" == typeof c.default.prototype[i] ? s[i] = c.default.prototype[i].bind(p(s)) : s[i] = c.default.prototype[i]);
                        return c.default.prototype._initializeInstanceVariables.apply(p(s)), s.width = e1, s.height = t, s._pixelDensity = o._pixelDensity, a === d.WEBGL ? s._renderer = new c.default.RendererGL(s.canvas, p(s), !1) : s._renderer = new c.default.Renderer2D(s.canvas, p(s), !1), o._elements.push(p(s)), Object.defineProperty(p(s), "deltaTime", {
                            get: function() {
                                return this._pInst.deltaTime;
                            }
                        }), s._renderer.resize(e1, t), s._renderer._applyDefaults(), f(s, p(s));
                    }
                    return t = u, e1 = [
                        {
                            key: "reset",
                            value: function() {
                                this._renderer.resetMatrix(), this._renderer.isP3D && this._renderer._update();
                            }
                        },
                        {
                            key: "remove",
                            value: function() {
                                this.elt.parentNode && this.elt.parentNode.removeChild(this.elt);
                                var e1, t = this._pInst._elements.indexOf(this);
                                for(e1 in -1 !== t && this._pInst._elements.splice(t, 1), this._events)this.elt.removeEventListener(e1, this._events[e1]);
                            }
                        },
                        {
                            key: "createFramebuffer",
                            value: function(e1) {
                                return new c.default.Framebuffer(this, e1);
                            }
                        }
                    ], n(t.prototype, e1), r && n(t, r), u;
                }(c.default.Element);
                var u = c.default.Graphics;
                r.default = u;
            },
            {
                "./constants": 264,
                "./main": 275,
                "core-js/modules/es.array.index-of": 160,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.splice": 167,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.get-prototype-of": 180,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.reflect.construct": 184,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        278: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var a = (s = e1("./main")) && s.__esModule ? s : {
                    default: s
                }, P = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== l(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = i();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function i() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, i = function() {
                        return e1;
                    }, e1);
                }
                function l(e1) {
                    return (l = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                function u(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function c(e1, t) {
                    return (c = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function d(o) {
                    return function() {
                        var e1, t, r = n(o);
                        return e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = n(this).constructor, Reflect.construct(r, arguments, e1)) : r.apply(this, arguments), r = this, !(t = e1) || "object" !== l(t) && "function" != typeof t ? h(r) : t;
                    };
                }
                function h(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                function n(e1) {
                    return (n = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                var s = function(e1) {
                    var t = s;
                    if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e1 && e1.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e1 && c(t, e1);
                    var r, n = d(s);
                    function s(e1, t, r) {
                        var o;
                        if (this instanceof s) return (o = n.call(this, e1, t)).canvas = e1, o._pixelsState = t, r ? (o._isMainCanvas = !0, o._pInst._setProperty("_curElement", h(o)), o._pInst._setProperty("canvas", o.canvas), o._pInst._setProperty("width", o.width), o._pInst._setProperty("height", o.height)) : (o.canvas.style.display = "none", o._styles = []), o._clipping = !1, o._clipInvert = !1, o._textSize = 12, o._textLeading = 15, o._textFont = "sans-serif", o._textStyle = P.NORMAL, o._textAscent = null, o._textDescent = null, o._textAlign = P.LEFT, o._textBaseline = P.BASELINE, o._textWrap = P.WORD, o._rectMode = P.CORNER, o._ellipseMode = P.CENTER, o._curveTightness = 0, o._imageMode = P.CORNER, o._tint = null, o._doStroke = !0, o._doFill = !0, o._strokeSet = !1, o._fillSet = !1, o._leadingSet = !1, o._pushPopDepth = 0, o;
                        throw new TypeError("Cannot call a class as a function");
                    }
                    return t = s, e1 = [
                        {
                            key: "push",
                            value: function() {
                                return this._pushPopDepth++, {
                                    properties: {
                                        _doStroke: this._doStroke,
                                        _strokeSet: this._strokeSet,
                                        _doFill: this._doFill,
                                        _fillSet: this._fillSet,
                                        _tint: this._tint,
                                        _imageMode: this._imageMode,
                                        _rectMode: this._rectMode,
                                        _ellipseMode: this._ellipseMode,
                                        _textFont: this._textFont,
                                        _textLeading: this._textLeading,
                                        _leadingSet: this._leadingSet,
                                        _textSize: this._textSize,
                                        _textAlign: this._textAlign,
                                        _textBaseline: this._textBaseline,
                                        _textStyle: this._textStyle,
                                        _textWrap: this._textWrap
                                    }
                                };
                            }
                        },
                        {
                            key: "pop",
                            value: function(e1) {
                                this._pushPopDepth--, e1.properties && Object.assign(this, e1.properties);
                            }
                        },
                        {
                            key: "beginClip",
                            value: function() {
                                var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
                                if (this._clipping) throw new Error("It looks like you're trying to clip while already in the middle of clipping. Did you forget to endClip()?");
                                this._clipping = !0, this._clipInvert = e1.invert;
                            }
                        },
                        {
                            key: "endClip",
                            value: function() {
                                if (!this._clipping) throw new Error("It looks like you've called endClip() without beginClip(). Did you forget to call beginClip() first?");
                                this._clipping = !1;
                            }
                        },
                        {
                            key: "resize",
                            value: function(e1, t) {
                                this.width = e1, this.height = t, this.elt.width = e1 * this._pInst._pixelDensity, this.elt.height = t * this._pInst._pixelDensity, this.elt.style.width = "".concat(e1, "px"), this.elt.style.height = "".concat(t, "px"), this._isMainCanvas && (this._pInst._setProperty("width", this.width), this._pInst._setProperty("height", this.height));
                            }
                        },
                        {
                            key: "get",
                            value: function(e1, t, r, o) {
                                var n = this._pixelsState, s = n._pixelDensity, i = this.canvas;
                                if (void 0 === e1 && void 0 === t) e1 = t = 0, r = n.width, o = n.height;
                                else if (e1 *= s, t *= s, void 0 === r && void 0 === o) return e1 < 0 || t < 0 || e1 >= i.width || t >= i.height ? [
                                    0,
                                    0,
                                    0,
                                    0
                                ] : this._getPixel(e1, t);
                                n = new a.default.Image(r * s, o * s);
                                return n.pixelDensity(s), n.canvas.getContext("2d").drawImage(i, e1, t, r * s, o * s, 0, 0, r * s, o * s), n;
                            }
                        },
                        {
                            key: "textLeading",
                            value: function(e1) {
                                return "number" == typeof e1 ? (this._setProperty("_leadingSet", !0), this._setProperty("_textLeading", e1), this._pInst) : this._textLeading;
                            }
                        },
                        {
                            key: "textStyle",
                            value: function(e1) {
                                return e1 ? (e1 !== P.NORMAL && e1 !== P.ITALIC && e1 !== P.BOLD && e1 !== P.BOLDITALIC || this._setProperty("_textStyle", e1), this._applyTextProperties()) : this._textStyle;
                            }
                        },
                        {
                            key: "textAscent",
                            value: function() {
                                return null === this._textAscent && this._updateTextMetrics(), this._textAscent;
                            }
                        },
                        {
                            key: "textDescent",
                            value: function() {
                                return null === this._textDescent && this._updateTextMetrics(), this._textDescent;
                            }
                        },
                        {
                            key: "textAlign",
                            value: function(e1, t) {
                                return void 0 !== e1 ? (this._setProperty("_textAlign", e1), void 0 !== t && this._setProperty("_textBaseline", t), this._applyTextProperties()) : {
                                    horizontal: this._textAlign,
                                    vertical: this._textBaseline
                                };
                            }
                        },
                        {
                            key: "textWrap",
                            value: function(e1) {
                                return this._setProperty("_textWrap", e1), this._textWrap;
                            }
                        },
                        {
                            key: "text",
                            value: function(e1, t, r, o, n) {
                                var s, i, a, l, u = this._pInst, c = this._textWrap, d = Number.MAX_VALUE, h = r;
                                if ((this._doFill || this._doStroke) && void 0 !== e1) {
                                    if (s = (e1 = (e1 = "string" != typeof e1 ? e1.toString() : e1).replace(/(\t)/g, "  ")).split("\n"), void 0 !== o) {
                                        switch(this._rectMode === P.CENTER && (t -= o / 2), this._textAlign){
                                            case P.CENTER:
                                                t += o / 2;
                                                break;
                                            case P.RIGHT:
                                                t += o;
                                        }
                                        if (void 0 !== n) {
                                            this._rectMode === P.CENTER && (r -= n / 2, h -= n / 2);
                                            var e1 = r, f = u.textAscent();
                                            switch(this._textBaseline){
                                                case P.BOTTOM:
                                                    l = r + n, r = Math.max(l, r), h += f;
                                                    break;
                                                case P.CENTER:
                                                    l = r + n / 2, r = Math.max(l, r), h += f / 2;
                                            }
                                            d = r + n - f, this._textBaseline === P.CENTER && (d = e1 + n - f / 2);
                                        } else this._textBaseline !== P.BOTTOM && this._textBaseline !== P.CENTER || (h = r - (e1 = u.textSize() * this._textLeading) / 2, d = r + e1 / 2);
                                        if (c === P.WORD) {
                                            for(var p = [], m = 0; m < s.length; m++){
                                                for(var y = "", g = s[m].split(" "), v = 0; v < g.length; v++)i = "".concat(y + g[v]) + " ", y = o < (a = this.textWidth(i)) && 0 < y.length ? (p.push(y), "".concat(g[v]) + " ") : i;
                                                p.push(y);
                                            }
                                            var b = 0;
                                            this._textBaseline === P.CENTER ? b = (p.length - 1) * u.textLeading() / 2 : this._textBaseline === P.BOTTOM && (b = (p.length - 1) * u.textLeading());
                                            for(var j = 0; j < s.length; j++){
                                                y = "", g = s[j].split(" ");
                                                for(var _ = 0; _ < g.length; _++)i = "".concat(y + g[_]) + " ", o < (a = this.textWidth(i)) && 0 < y.length ? (this._renderText(u, y.trim(), t, r - b, d, h), y = "".concat(g[_]) + " ", r += u.textLeading()) : y = i;
                                                this._renderText(u, y.trim(), t, r - b, d, h), r += u.textLeading();
                                            }
                                        } else {
                                            for(var x = [], w = 0; w < s.length; w++)for(var S = s[w].split(y = ""), T = 0; T < S.length; T++)i = "".concat(y + S[T]), (a = this.textWidth(i)) <= o ? y += S[T] : o < a && 0 < y.length && (x.push(y), y = "".concat(S[T]));
                                            x.push(y);
                                            var M = 0;
                                            this._textBaseline === P.CENTER ? M = (x.length - 1) * u.textLeading() / 2 : this._textBaseline === P.BOTTOM && (M = (x.length - 1) * u.textLeading());
                                            for(var E = 0; E < s.length; E++){
                                                S = s[E].split(y = "");
                                                for(var k = 0; k < S.length; k++)i = "".concat(y + S[k]), (a = this.textWidth(i)) <= o ? y += S[k] : o < a && 0 < y.length && (this._renderText(u, y.trim(), t, r - M, d, h), r += u.textLeading(), y = "".concat(S[k]));
                                            }
                                            this._renderText(u, y.trim(), t, r - M, d, h), r += u.textLeading();
                                        }
                                    } else {
                                        var C = 0;
                                        this._textBaseline === P.CENTER ? C = (s.length - 1) * u.textLeading() / 2 : this._textBaseline === P.BOTTOM && (C = (s.length - 1) * u.textLeading());
                                        for(var O = 0; O < s.length; O++)this._renderText(u, s[O], t, r - C, d, h - C), r += u.textLeading();
                                    }
                                    return u;
                                }
                            }
                        },
                        {
                            key: "_applyDefaults",
                            value: function() {
                                return this;
                            }
                        },
                        {
                            key: "_isOpenType",
                            value: function() {
                                var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : this._textFont;
                                return "object" === l(e1) && e1.font && e1.font.supported;
                            }
                        },
                        {
                            key: "_updateTextMetrics",
                            value: function() {
                                var e1, t, r, o, n, s;
                                return this._isOpenType() ? (this._setProperty("_textAscent", this._textFont._textAscent()), this._setProperty("_textDescent", this._textFont._textDescent())) : ((e1 = document.createElement("span")).style.fontFamily = this._textFont, e1.style.fontSize = "".concat(this._textSize, "px"), e1.innerHTML = "ABCjgq|", (s = document.createElement("div")).style.display = "inline-block", s.style.width = "1px", s.style.height = "0px", o = ((t = document.createElement("div")).appendChild(e1), t.appendChild(s), t.style.height = "0px", t.style.overflow = "hidden", document.body.appendChild(t), s.style.verticalAlign = "baseline", f(s)), n = f(e1), r = o[1] - n[1], o = (s.style.verticalAlign = "bottom", f(s)), n = f(e1), s = o[1] - n[1] - r, document.body.removeChild(t), this._setProperty("_textAscent", r), this._setProperty("_textDescent", s)), this;
                            }
                        }
                    ], u(t.prototype, e1), r && u(t, r), s;
                }(a.default.Element);
                function f(e1) {
                    var t = 0, r = 0;
                    if (e1.offsetParent) for(; t += e1.offsetLeft, r += e1.offsetTop, e1 = e1.offsetParent;);
                    else t += e1.offsetLeft, r += e1.offsetTop;
                    return [
                        t,
                        r
                    ];
                }
                s.prototype.textSize = function(e1) {
                    return "number" == typeof e1 ? (this._setProperty("_textSize", e1), this._leadingSet || this._setProperty("_textLeading", e1 * P._DEFAULT_LEADMULT), this._applyTextProperties()) : this._textSize;
                }, a.default.Renderer = s;
                e1 = a.default.Renderer;
                r.default = e1;
            },
            {
                "../core/constants": 264,
                "./main": 275,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.number.constructor": 173,
                "core-js/modules/es.object.assign": 176,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.get-prototype-of": 180,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.reflect.construct": 184,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.string.replace": 196,
                "core-js/modules/es.string.split": 198,
                "core-js/modules/es.string.trim": 201,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        279: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.reflect.get"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var d = (n = e1("./main")) && n.__esModule ? n : {
                    default: n
                }, p = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("./constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function l(e1, t, r) {
                    return (l = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e1, t, r) {
                        var e1 = function(e1, t) {
                            for(; !Object.prototype.hasOwnProperty.call(e1, t) && null !== (e1 = h(e1)););
                            return e1;
                        }(e1, t);
                        if (e1) return (e1 = Object.getOwnPropertyDescriptor(e1, t)).get ? e1.get.call(r) : e1.value;
                    })(e1, t, r || e1);
                }
                function u(e1, t) {
                    return (u = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function c(r) {
                    return function() {
                        var e1, t = h(r), t = (e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = h(this).constructor, Reflect.construct(t, arguments, e1)) : t.apply(this, arguments), this);
                        if (!e1 || "object" !== i(e1) && "function" != typeof e1) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }
                        return e1;
                    };
                }
                function h(e1) {
                    return (h = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                e1("./p5.Renderer");
                var f = "rgba(0,0,0,0)", n = function(e1) {
                    var t = n;
                    if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e1 && e1.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e1 && u(t, e1);
                    var r, o = c(n);
                    function n(e1, t, r) {
                        if (this instanceof n) return (e1 = o.call(this, e1, t, r)).drawingContext = e1.canvas.getContext("2d"), e1._pInst._setProperty("drawingContext", e1.drawingContext), e1;
                        throw new TypeError("Cannot call a class as a function");
                    }
                    return t = n, e1 = [
                        {
                            key: "getFilterGraphicsLayer",
                            value: function() {
                                var e1;
                                return this.filterGraphicsLayer || (e1 = (this._pInst instanceof d.default.Graphics ? this._pInst : this)._pInst, this.filterGraphicsLayer = new d.default.Graphics(this.width, this.height, p.WEBGL, e1)), this.filterGraphicsLayer.width === this.width && this.filterGraphicsLayer.height === this.height || this.filterGraphicsLayer.resizeCanvas(this.width, this.height), this.filterGraphicsLayer.pixelDensity() !== this._pInst.pixelDensity() && this.filterGraphicsLayer.pixelDensity(this._pInst.pixelDensity()), this.filterGraphicsLayer;
                            }
                        },
                        {
                            key: "_applyDefaults",
                            value: function() {
                                this._cachedFillStyle = this._cachedStrokeStyle = void 0, this._cachedBlendMode = p.BLEND, this._setFill(p._DEFAULT_FILL), this._setStroke(p._DEFAULT_STROKE), this.drawingContext.lineCap = p.ROUND, this.drawingContext.font = "normal 12px sans-serif";
                            }
                        },
                        {
                            key: "resize",
                            value: function(e1, t) {
                                l(h(n.prototype), "resize", this).call(this, e1, t), this.drawingContext.scale(this._pInst._pixelDensity, this._pInst._pixelDensity);
                            }
                        },
                        {
                            key: "background",
                            value: function() {
                                var e1, t;
                                this.drawingContext.save(), this.resetMatrix(), (arguments.length <= 0 ? void 0 : arguments[0]) instanceof d.default.Image ? 0 <= (arguments.length <= 1 ? void 0 : arguments[1]) ? (e1 = arguments.length <= 0 ? void 0 : arguments[0], this.drawingContext.globalAlpha = (arguments.length <= 1 ? void 0 : arguments[1]) / 255, this._pInst.image(e1, 0, 0, this.width, this.height)) : this._pInst.image(arguments.length <= 0 ? void 0 : arguments[0], 0, 0, this.width, this.height) : (e1 = this._getFill(), t = (t = this._pInst).color.apply(t, arguments), this._pInst._addAccsOutput() && this._pInst._accsBackground(t.levels), t = t.toString(), this._setFill(t), this._isErasing && this.blendMode(this._cachedBlendMode), this.drawingContext.fillRect(0, 0, this.width, this.height), this._setFill(e1), this._isErasing && this._pInst.erase()), this.drawingContext.restore();
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.drawingContext.save(), this.resetMatrix(), this.drawingContext.clearRect(0, 0, this.width, this.height), this.drawingContext.restore();
                            }
                        },
                        {
                            key: "fill",
                            value: function() {
                                var e1 = (e1 = this._pInst).color.apply(e1, arguments);
                                this._setFill(e1.toString()), this._pInst._addAccsOutput() && this._pInst._accsCanvasColors("fill", e1.levels);
                            }
                        },
                        {
                            key: "stroke",
                            value: function() {
                                var e1 = (e1 = this._pInst).color.apply(e1, arguments);
                                this._setStroke(e1.toString()), this._pInst._addAccsOutput() && this._pInst._accsCanvasColors("stroke", e1.levels);
                            }
                        },
                        {
                            key: "erase",
                            value: function(e1, t) {
                                this._isErasing || (this._cachedFillStyle = this.drawingContext.fillStyle, e1 = this._pInst.color(255, e1).toString(), this.drawingContext.fillStyle = e1, this._cachedStrokeStyle = this.drawingContext.strokeStyle, e1 = this._pInst.color(255, t).toString(), this.drawingContext.strokeStyle = e1, t = this._cachedBlendMode, this.blendMode(p.REMOVE), this._cachedBlendMode = t, this._isErasing = !0);
                            }
                        },
                        {
                            key: "noErase",
                            value: function() {
                                this._isErasing && (this.drawingContext.fillStyle = this._cachedFillStyle, this.drawingContext.strokeStyle = this._cachedStrokeStyle, this.blendMode(this._cachedBlendMode), this._isErasing = !1);
                            }
                        },
                        {
                            key: "beginClip",
                            value: function() {
                                var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}, e1 = (l(h(n.prototype), "beginClip", this).call(this, e1), this._cachedFillStyle = this.drawingContext.fillStyle, this._pInst.color(255, 0).toString()), e1 = (this.drawingContext.fillStyle = e1, this._cachedStrokeStyle = this.drawingContext.strokeStyle, this._pInst.color(255, 0).toString()), e1 = (this.drawingContext.strokeStyle = e1, this._cachedBlendMode);
                                this.blendMode(p.BLEND), this._cachedBlendMode = e1, this.drawingContext.beginPath(), this._clipInvert && (this.drawingContext.moveTo(-2 * this.width, -2 * this.height), this.drawingContext.lineTo(-2 * this.width, 2 * this.height), this.drawingContext.lineTo(2 * this.width, 2 * this.height), this.drawingContext.lineTo(2 * this.width, -2 * this.height), this.drawingContext.closePath());
                            }
                        },
                        {
                            key: "endClip",
                            value: function() {
                                this._doFillStrokeClose(), this.drawingContext.clip(), l(h(n.prototype), "endClip", this).call(this), this.drawingContext.fillStyle = this._cachedFillStyle, this.drawingContext.strokeStyle = this._cachedStrokeStyle, this.blendMode(this._cachedBlendMode);
                            }
                        },
                        {
                            key: "image",
                            value: function(e1, t, r, o, n, s, i, a, l) {
                                e1.gifProperties && e1._animateGif(this._pInst);
                                try {
                                    d.default.MediaElement && e1 instanceof d.default.MediaElement && e1._ensureCanvas();
                                    var u = (u = this._tint && e1.canvas ? this._getTintedImageCanvas(e1) : u) || e1.canvas || e1.elt, c = 1;
                                    e1.width && 0 < e1.width && (c = u.width / e1.width), this._isErasing && this.blendMode(this._cachedBlendMode), this.drawingContext.drawImage(u, c * t, c * r, c * o, c * n, s, i, a, l), this._isErasing && this._pInst.erase();
                                } catch (e1) {
                                    if ("NS_ERROR_NOT_AVAILABLE" !== e1.name) throw e1;
                                }
                            }
                        },
                        {
                            key: "_getTintedImageCanvas",
                            value: function(e1) {
                                if (!e1.canvas) return e1;
                                e1.tintCanvas || (e1.tintCanvas = document.createElement("canvas")), e1.tintCanvas.width !== e1.canvas.width && (e1.tintCanvas.width = e1.canvas.width), e1.tintCanvas.height !== e1.canvas.height && (e1.tintCanvas.height = e1.canvas.height);
                                var t = e1.tintCanvas.getContext("2d");
                                return t.save(), t.clearRect(0, 0, e1.canvas.width, e1.canvas.height), (this._tint[0] < 255 || this._tint[1] < 255 || this._tint[2] < 255) && (t.drawImage(e1.canvas, 0, 0), t.globalCompositeOperation = "luminosity", t.drawImage(e1.canvas, 0, 0), t.globalCompositeOperation = "color", t.drawImage(e1.canvas, 0, 0), t.globalCompositeOperation = "multiply", t.fillStyle = "rgb(".concat(this._tint.slice(0, 3).join(", "), ")"), t.fillRect(0, 0, e1.canvas.width, e1.canvas.height), t.globalCompositeOperation = "destination-in"), t.globalAlpha = this._tint[3] / 255, t.drawImage(e1.canvas, 0, 0), t.restore(), e1.tintCanvas;
                            }
                        },
                        {
                            key: "blendMode",
                            value: function(e1) {
                                if (e1 === p.SUBTRACT) console.warn("blendMode(SUBTRACT) only works in WEBGL mode.");
                                else {
                                    if (e1 !== p.BLEND && e1 !== p.REMOVE && e1 !== p.DARKEST && e1 !== p.LIGHTEST && e1 !== p.DIFFERENCE && e1 !== p.MULTIPLY && e1 !== p.EXCLUSION && e1 !== p.SCREEN && e1 !== p.REPLACE && e1 !== p.OVERLAY && e1 !== p.HARD_LIGHT && e1 !== p.SOFT_LIGHT && e1 !== p.DODGE && e1 !== p.BURN && e1 !== p.ADD) throw new Error("Mode ".concat(e1, " not recognized."));
                                    this._cachedBlendMode = e1, this.drawingContext.globalCompositeOperation = e1;
                                }
                            }
                        },
                        {
                            key: "blend",
                            value: function() {
                                for(var e1 = this.drawingContext.globalCompositeOperation, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                                var n = r[r.length - 1], s = Array.prototype.slice.call(r, 0, r.length - 1);
                                this.drawingContext.globalCompositeOperation = n, d.default.prototype.copy.apply(this, s), this.drawingContext.globalCompositeOperation = e1;
                            }
                        },
                        {
                            key: "_getPixel",
                            value: function(e1, t) {
                                e1 = this.drawingContext.getImageData(e1, t, 1, 1).data;
                                return [
                                    e1[0],
                                    e1[1],
                                    e1[2],
                                    e1[3]
                                ];
                            }
                        },
                        {
                            key: "loadPixels",
                            value: function() {
                                var e1 = this._pixelsState, t = e1._pixelDensity, r = this.width * t, t = this.height * t, r = this.drawingContext.getImageData(0, 0, r, t);
                                e1._setProperty("imageData", r), e1._setProperty("pixels", r.data);
                            }
                        },
                        {
                            key: "set",
                            value: function(e1, t, r) {
                                e1 = Math.floor(e1), t = Math.floor(t);
                                var o = this._pixelsState;
                                if (r instanceof d.default.Image) this.drawingContext.save(), this.drawingContext.setTransform(1, 0, 0, 1, 0, 0), this.drawingContext.scale(o._pixelDensity, o._pixelDensity), this.drawingContext.clearRect(e1, t, r.width, r.height), this.drawingContext.drawImage(r.canvas, e1, t), this.drawingContext.restore();
                                else {
                                    var n = 0, s = 0, i = 0, a = 0, l = 4 * (t * o._pixelDensity * (this.width * o._pixelDensity) + e1 * o._pixelDensity);
                                    if (o.imageData || o.loadPixels.call(o), "number" == typeof r) l < o.pixels.length && (i = s = n = r, a = 255);
                                    else if (r instanceof Array) {
                                        if (r.length < 4) throw new Error("pixel array must be of the form [R, G, B, A]");
                                        l < o.pixels.length && (n = r[0], s = r[1], i = r[2], a = r[3]);
                                    } else r instanceof d.default.Color && l < o.pixels.length && (n = r.levels[0], s = r.levels[1], i = r.levels[2], a = r.levels[3]);
                                    for(var u = 0; u < o._pixelDensity; u++)for(var c = 0; c < o._pixelDensity; c++)l = 4 * ((t * o._pixelDensity + c) * this.width * o._pixelDensity + (e1 * o._pixelDensity + u)), o.pixels[l] = n, o.pixels[l + 1] = s, o.pixels[l + 2] = i, o.pixels[l + 3] = a;
                                }
                            }
                        },
                        {
                            key: "updatePixels",
                            value: function(e1, t, r, o) {
                                var n = this._pixelsState, s = n._pixelDensity;
                                void 0 === e1 && void 0 === t && void 0 === r && void 0 === o && (t = e1 = 0, r = this.width, o = this.height), e1 *= s, t *= s, r *= s, o *= s, this.gifProperties && (this.gifProperties.frames[this.gifProperties.displayIndex].image = n.imageData), this.drawingContext.putImageData(n.imageData, e1, t, 0, 0, r, o);
                            }
                        },
                        {
                            key: "_acuteArcToBezier",
                            value: function(e1, t) {
                                var r = t / 2, o = Math.cos(r), n = Math.sin(r), s = 1 / Math.tan(r), r = e1 + r, i = Math.cos(r), r = Math.sin(r), a = (4 - o) / 3, n = n + (o - a) * s;
                                return {
                                    ax: Math.cos(e1).toFixed(7),
                                    ay: Math.sin(e1).toFixed(7),
                                    bx: (a * i + n * r).toFixed(7),
                                    by: (a * r - n * i).toFixed(7),
                                    cx: (a * i - n * r).toFixed(7),
                                    cy: (a * r + n * i).toFixed(7),
                                    dx: Math.cos(e1 + t).toFixed(7),
                                    dy: Math.sin(e1 + t).toFixed(7)
                                };
                            }
                        },
                        {
                            key: "arc",
                            value: function(r, o, e1, t, n, s, i) {
                                var a, l = this.drawingContext, u = e1 / 2, c = t / 2, d = [];
                                for(r += u, o += c; 1e-5 <= s - n;)a = Math.min(s - n, p.HALF_PI), d.push(this._acuteArcToBezier(n, a)), n += a;
                                return this._doFill && (this._clipping || l.beginPath(), d.forEach(function(e1, t) {
                                    0 === t && l.moveTo(r + e1.ax * u, o + e1.ay * c), l.bezierCurveTo(r + e1.bx * u, o + e1.by * c, r + e1.cx * u, o + e1.cy * c, r + e1.dx * u, o + e1.dy * c);
                                }), i !== p.PIE && null != i || l.lineTo(r, o), l.closePath(), this._clipping || l.fill()), this._doStroke && (this._clipping || l.beginPath(), d.forEach(function(e1, t) {
                                    0 === t && l.moveTo(r + e1.ax * u, o + e1.ay * c), l.bezierCurveTo(r + e1.bx * u, o + e1.by * c, r + e1.cx * u, o + e1.cy * c, r + e1.dx * u, o + e1.dy * c);
                                }), i === p.PIE ? (l.lineTo(r, o), l.closePath()) : i === p.CHORD && l.closePath(), this._clipping || l.stroke()), this;
                            }
                        },
                        {
                            key: "ellipse",
                            value: function(e1) {
                                var t = this.drawingContext, r = this._doFill, o = this._doStroke, n = parseFloat(e1[0]), s = parseFloat(e1[1]), i = parseFloat(e1[2]), e1 = parseFloat(e1[3]);
                                if (r && !o) {
                                    if (this._getFill() === f) return this;
                                } else if (!r && o && this._getStroke() === f) return this;
                                var a = i / 2 * .5522847498, l = e1 / 2 * .5522847498, u = n + i, c = s + e1, i = n + i / 2, e1 = s + e1 / 2;
                                this._clipping || t.beginPath(), t.moveTo(n, e1), t.bezierCurveTo(n, e1 - l, i - a, s, i, s), t.bezierCurveTo(i + a, s, u, e1 - l, u, e1), t.bezierCurveTo(u, e1 + l, i + a, c, i, c), t.bezierCurveTo(i - a, c, n, e1 + l, n, e1), !this._clipping && r && t.fill(), !this._clipping && o && t.stroke();
                            }
                        },
                        {
                            key: "line",
                            value: function(e1, t, r, o) {
                                var n = this.drawingContext;
                                return this._doStroke && this._getStroke() !== f && (this._clipping || n.beginPath(), n.moveTo(e1, t), n.lineTo(r, o), n.stroke()), this;
                            }
                        },
                        {
                            key: "point",
                            value: function(e1, t) {
                                var r, o, n = this.drawingContext;
                                return !this._doStroke || this._getStroke() === f ? this : (r = this._getStroke(), o = this._getFill(), this._clipping || this._setFill(r), this._clipping || n.beginPath(), n.arc(e1, t, n.lineWidth / 2, 0, p.TWO_PI, !1), void (this._clipping || (n.fill(), this._setFill(o))));
                            }
                        },
                        {
                            key: "quad",
                            value: function(e1, t, r, o, n, s, i, a) {
                                var l = this.drawingContext, u = this._doFill, c = this._doStroke;
                                if (u && !c) {
                                    if (this._getFill() === f) return this;
                                } else if (!u && c && this._getStroke() === f) return this;
                                return this._clipping || l.beginPath(), l.moveTo(e1, t), l.lineTo(r, o), l.lineTo(n, s), l.lineTo(i, a), l.closePath(), !this._clipping && u && l.fill(), !this._clipping && c && l.stroke(), this;
                            }
                        },
                        {
                            key: "rect",
                            value: function(e1) {
                                var t, r, o = e1[0], n = e1[1], s = e1[2], i = e1[3], a = e1[4], l = e1[5], u = e1[6], e1 = e1[7], c = this.drawingContext, d = this._doFill, h = this._doStroke;
                                if (d && !h) {
                                    if (this._getFill() === f) return this;
                                } else if (!d && h && this._getStroke() === f) return this;
                                return this._clipping || c.beginPath(), void 0 === a ? c.rect(o, n, s, i) : (void 0 === l && (l = a), void 0 === u && (u = l), void 0 === e1 && (e1 = u), h = (d = Math.abs(s)) / 2, r = (t = Math.abs(i)) / 2, t < 2 * (a = d < 2 * a ? h : a) && (a = r), t < 2 * (l = d < 2 * l ? h : l) && (l = r), t < 2 * (u = d < 2 * u ? h : u) && (u = r), t < 2 * (e1 = d < 2 * e1 ? h : e1) && (e1 = r), this._clipping || c.beginPath(), c.moveTo(o + a, n), c.arcTo(o + s, n, o + s, n + i, l), c.arcTo(o + s, n + i, o, n + i, u), c.arcTo(o, n + i, o, n, e1), c.arcTo(o, n, o + s, n, a), c.closePath()), !this._clipping && this._doFill && c.fill(), !this._clipping && this._doStroke && c.stroke(), this;
                            }
                        },
                        {
                            key: "triangle",
                            value: function(e1) {
                                var t = this.drawingContext, r = this._doFill, o = this._doStroke, n = e1[0], s = e1[1], i = e1[2], a = e1[3], l = e1[4], e1 = e1[5];
                                if (r && !o) {
                                    if (this._getFill() === f) return this;
                                } else if (!r && o && this._getStroke() === f) return this;
                                this._clipping || t.beginPath(), t.moveTo(n, s), t.lineTo(i, a), t.lineTo(l, e1), t.closePath(), !this._clipping && r && t.fill(), !this._clipping && o && t.stroke();
                            }
                        },
                        {
                            key: "endShape",
                            value: function(e1, t, r, o, n, s, i) {
                                if (0 !== t.length && (this._doStroke || this._doFill)) {
                                    var a, l, u, c = e1 === p.CLOSE, d = (c && !s && t.push(t[0]), t.length);
                                    if (r && null === i) {
                                        if (3 < d) {
                                            var h = [], f = 1 - this._curveTightness;
                                            for(this._clipping || this.drawingContext.beginPath(), this.drawingContext.moveTo(t[1][0], t[1][1]), l = 1; l + 2 < d; l++)a = t[l], h[0] = [
                                                a[0],
                                                a[1]
                                            ], h[1] = [
                                                a[0] + (f * t[l + 1][0] - f * t[l - 1][0]) / 6,
                                                a[1] + (f * t[l + 1][1] - f * t[l - 1][1]) / 6
                                            ], h[2] = [
                                                t[l + 1][0] + (f * t[l][0] - f * t[l + 2][0]) / 6,
                                                t[l + 1][1] + (f * t[l][1] - f * t[l + 2][1]) / 6
                                            ], h[3] = [
                                                t[l + 1][0],
                                                t[l + 1][1]
                                            ], this.drawingContext.bezierCurveTo(h[1][0], h[1][1], h[2][0], h[2][1], h[3][0], h[3][1]);
                                            c && this.drawingContext.lineTo(t[l + 1][0], t[l + 1][1]), this._doFillStrokeClose(c);
                                        }
                                    } else if (o && null === i) {
                                        for(this._clipping || this.drawingContext.beginPath(), l = 0; l < d; l++)t[l].isVert ? t[l].moveTo ? this.drawingContext.moveTo(t[l][0], t[l][1]) : this.drawingContext.lineTo(t[l][0], t[l][1]) : this.drawingContext.bezierCurveTo(t[l][0], t[l][1], t[l][2], t[l][3], t[l][4], t[l][5]);
                                        this._doFillStrokeClose(c);
                                    } else if (n && null === i) {
                                        for(this._clipping || this.drawingContext.beginPath(), l = 0; l < d; l++)t[l].isVert ? t[l].moveTo ? this.drawingContext.moveTo(t[l][0], t[l][1]) : this.drawingContext.lineTo(t[l][0], t[l][1]) : this.drawingContext.quadraticCurveTo(t[l][0], t[l][1], t[l][2], t[l][3]);
                                        this._doFillStrokeClose(c);
                                    } else if (i === p.POINTS) for(l = 0; l < d; l++)a = t[l], this._doStroke && this._pInst.stroke(a[6]), this._pInst.point(a[0], a[1]);
                                    else if (i === p.LINES) for(l = 0; l + 1 < d; l += 2)a = t[l], this._doStroke && this._pInst.stroke(t[l + 1][6]), this._pInst.line(a[0], a[1], t[l + 1][0], t[l + 1][1]);
                                    else if (i === p.TRIANGLES) for(l = 0; l + 2 < d; l += 3)a = t[l], this._clipping || this.drawingContext.beginPath(), this.drawingContext.moveTo(a[0], a[1]), this.drawingContext.lineTo(t[l + 1][0], t[l + 1][1]), this.drawingContext.lineTo(t[l + 2][0], t[l + 2][1]), this.drawingContext.closePath(), !this._clipping && this._doFill && (this._pInst.fill(t[l + 2][5]), this.drawingContext.fill()), !this._clipping && this._doStroke && (this._pInst.stroke(t[l + 2][6]), this.drawingContext.stroke());
                                    else if (i === p.TRIANGLE_STRIP) for(l = 0; l + 1 < d; l++)a = t[l], this._clipping || this.drawingContext.beginPath(), this.drawingContext.moveTo(t[l + 1][0], t[l + 1][1]), this.drawingContext.lineTo(a[0], a[1]), !this._clipping && this._doStroke && this._pInst.stroke(t[l + 1][6]), !this._clipping && this._doFill && this._pInst.fill(t[l + 1][5]), l + 2 < d && (this.drawingContext.lineTo(t[l + 2][0], t[l + 2][1]), !this._clipping && this._doStroke && this._pInst.stroke(t[l + 2][6]), !this._clipping && this._doFill && this._pInst.fill(t[l + 2][5])), this._doFillStrokeClose(c);
                                    else if (i === p.TRIANGLE_FAN) {
                                        if (2 < d) {
                                            for(this._clipping || this.drawingContext.beginPath(), l = 2; l < d; l++)a = t[l], this.drawingContext.moveTo(t[0][0], t[0][1]), this.drawingContext.lineTo(t[l - 1][0], t[l - 1][1]), this.drawingContext.lineTo(a[0], a[1]), this.drawingContext.lineTo(t[0][0], t[0][1]), l < d - 1 && (this._doFill && a[5] !== t[l + 1][5] || this._doStroke && a[6] !== t[l + 1][6]) && (!this._clipping && this._doFill && (this._pInst.fill(a[5]), this.drawingContext.fill(), this._pInst.fill(t[l + 1][5])), !this._clipping && this._doStroke && (this._pInst.stroke(a[6]), this.drawingContext.stroke(), this._pInst.stroke(t[l + 1][6])), this.drawingContext.closePath(), this._clipping || this.drawingContext.beginPath());
                                            this._doFillStrokeClose(c);
                                        }
                                    } else if (i === p.QUADS) for(l = 0; l + 3 < d; l += 4){
                                        for(a = t[l], this._clipping || this.drawingContext.beginPath(), this.drawingContext.moveTo(a[0], a[1]), u = 1; u < 4; u++)this.drawingContext.lineTo(t[l + u][0], t[l + u][1]);
                                        this.drawingContext.lineTo(a[0], a[1]), !this._clipping && this._doFill && this._pInst.fill(t[l + 3][5]), !this._clipping && this._doStroke && this._pInst.stroke(t[l + 3][6]), this._doFillStrokeClose(c);
                                    }
                                    else if (i === p.QUAD_STRIP) {
                                        if (3 < d) for(l = 0; l + 1 < d; l += 2)a = t[l], this._clipping || this.drawingContext.beginPath(), l + 3 < d ? (this.drawingContext.moveTo(t[l + 2][0], t[l + 2][1]), this.drawingContext.lineTo(a[0], a[1]), this.drawingContext.lineTo(t[l + 1][0], t[l + 1][1]), this.drawingContext.lineTo(t[l + 3][0], t[l + 3][1]), !this._clipping && this._doFill && this._pInst.fill(t[l + 3][5]), !this._clipping && this._doStroke && this._pInst.stroke(t[l + 3][6])) : (this.drawingContext.moveTo(a[0], a[1]), this.drawingContext.lineTo(t[l + 1][0], t[l + 1][1])), this._doFillStrokeClose(c);
                                    } else {
                                        for(this._clipping || this.drawingContext.beginPath(), this.drawingContext.moveTo(t[0][0], t[0][1]), l = 1; l < d; l++)(a = t[l]).isVert && (a.moveTo ? (c && this.drawingContext.closePath(), this.drawingContext.moveTo(a[0], a[1])) : this.drawingContext.lineTo(a[0], a[1]));
                                        this._doFillStrokeClose(c);
                                    }
                                    s = n = o = r = !1, c && t.pop();
                                }
                                return this;
                            }
                        },
                        {
                            key: "strokeCap",
                            value: function(e1) {
                                return e1 !== p.ROUND && e1 !== p.SQUARE && e1 !== p.PROJECT || (this.drawingContext.lineCap = e1), this;
                            }
                        },
                        {
                            key: "strokeJoin",
                            value: function(e1) {
                                return e1 !== p.ROUND && e1 !== p.BEVEL && e1 !== p.MITER || (this.drawingContext.lineJoin = e1), this;
                            }
                        },
                        {
                            key: "strokeWeight",
                            value: function(e1) {
                                return this.drawingContext.lineWidth = void 0 === e1 || 0 === e1 ? 1e-4 : e1, this;
                            }
                        },
                        {
                            key: "_getFill",
                            value: function() {
                                return this._cachedFillStyle || (this._cachedFillStyle = this.drawingContext.fillStyle), this._cachedFillStyle;
                            }
                        },
                        {
                            key: "_setFill",
                            value: function(e1) {
                                e1 !== this._cachedFillStyle && (this.drawingContext.fillStyle = e1, this._cachedFillStyle = e1);
                            }
                        },
                        {
                            key: "_getStroke",
                            value: function() {
                                return this._cachedStrokeStyle || (this._cachedStrokeStyle = this.drawingContext.strokeStyle), this._cachedStrokeStyle;
                            }
                        },
                        {
                            key: "_setStroke",
                            value: function(e1) {
                                e1 !== this._cachedStrokeStyle && (this.drawingContext.strokeStyle = e1, this._cachedStrokeStyle = e1);
                            }
                        },
                        {
                            key: "bezier",
                            value: function(e1, t, r, o, n, s, i, a) {
                                return this._pInst.beginShape(), this._pInst.vertex(e1, t), this._pInst.bezierVertex(r, o, n, s, i, a), this._pInst.endShape(), this;
                            }
                        },
                        {
                            key: "curve",
                            value: function(e1, t, r, o, n, s, i, a) {
                                return this._pInst.beginShape(), this._pInst.curveVertex(e1, t), this._pInst.curveVertex(r, o), this._pInst.curveVertex(n, s), this._pInst.curveVertex(i, a), this._pInst.endShape(), this;
                            }
                        },
                        {
                            key: "_doFillStrokeClose",
                            value: function(e1) {
                                e1 && this.drawingContext.closePath(), !this._clipping && this._doFill && this.drawingContext.fill(), !this._clipping && this._doStroke && this.drawingContext.stroke();
                            }
                        },
                        {
                            key: "applyMatrix",
                            value: function(e1, t, r, o, n, s) {
                                this.drawingContext.transform(e1, t, r, o, n, s);
                            }
                        },
                        {
                            key: "resetMatrix",
                            value: function() {
                                return this.drawingContext.setTransform(1, 0, 0, 1, 0, 0), this.drawingContext.scale(this._pInst._pixelDensity, this._pInst._pixelDensity), this;
                            }
                        },
                        {
                            key: "rotate",
                            value: function(e1) {
                                this.drawingContext.rotate(e1);
                            }
                        },
                        {
                            key: "scale",
                            value: function(e1, t) {
                                return this.drawingContext.scale(e1, t), this;
                            }
                        },
                        {
                            key: "translate",
                            value: function(e1, t) {
                                return e1 instanceof d.default.Vector && (t = e1.y, e1 = e1.x), this.drawingContext.translate(e1, t), this;
                            }
                        },
                        {
                            key: "_renderText",
                            value: function(e1, t, r, o, n, s) {
                                if (!(o < s || n <= o)) return e1.push(), this._isOpenType() ? this._textFont._renderPath(t, r, o, {
                                    renderer: this
                                }) : (this._doStroke && this._strokeSet && this.drawingContext.strokeText(t, r, o), !this._clipping && this._doFill && (this._fillSet || this._setFill(p._DEFAULT_TEXT_FILL), this.drawingContext.fillText(t, r, o))), e1.pop(), e1;
                            }
                        },
                        {
                            key: "textWidth",
                            value: function(e1) {
                                return this._isOpenType() ? this._textFont._textWidth(e1, this._textSize) : this.drawingContext.measureText(e1).width;
                            }
                        },
                        {
                            key: "_applyTextProperties",
                            value: function() {
                                var e1, t = this._pInst;
                                return this._setProperty("_textAscent", null), this._setProperty("_textDescent", null), e1 = this._textFont, this._isOpenType() && (e1 = this._textFont.font.familyName, this._setProperty("_textStyle", this._textFont.font.styleName)), this.drawingContext.font = "".concat(this._textStyle || "normal", " ").concat(this._textSize || 12, "px ").concat(e1 || "sans-serif"), this.drawingContext.textAlign = this._textAlign, this._textBaseline === p.CENTER ? this.drawingContext.textBaseline = p._CTX_MIDDLE : this.drawingContext.textBaseline = this._textBaseline, t;
                            }
                        },
                        {
                            key: "push",
                            value: function() {
                                return this.drawingContext.save(), l(h(n.prototype), "push", this).call(this);
                            }
                        },
                        {
                            key: "pop",
                            value: function(e1) {
                                this.drawingContext.restore(), this._cachedFillStyle = this.drawingContext.fillStyle, this._cachedStrokeStyle = this.drawingContext.strokeStyle, l(h(n.prototype), "pop", this).call(this, e1);
                            }
                        }
                    ], s(t.prototype, e1), r && s(t, r), n;
                }(d.default.Renderer), e1 = (n.prototype.text = function(e1, t, r, o, n) {
                    void 0 !== o && this.drawingContext.textBaseline === p.BASELINE && (s = !0, this.drawingContext.textBaseline = p.TOP);
                    var s, o = d.default.Renderer.prototype.text.apply(this, arguments);
                    return s && (this.drawingContext.textBaseline = p.BASELINE), o;
                }, d.default.Renderer2D = n, d.default.Renderer2D);
                r.default = e1;
            },
            {
                "./constants": 264,
                "./main": 275,
                "./p5.Renderer": 278,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.fill": 154,
                "core-js/modules/es.array.for-each": 157,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.join": 162,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.function.name": 168,
                "core-js/modules/es.number.to-fixed": 175,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.get-prototype-of": 180,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.reflect.construct": 184,
                "core-js/modules/es.reflect.get": 185,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        280: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator");
                var h = (e1 = e1("./main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                h.default.prototype._promisePreloads = [];
                function o() {
                    return {};
                }
                var f = (h.default.prototype.registerPromisePreload = function(e1) {
                    h.default.prototype._promisePreloads.push(e1);
                }, false);
                h.default.prototype._setupPromisePreloads = function() {
                    var e1 = !0, t = !1, r = void 0;
                    try {
                        for(var o, n = this._promisePreloads[Symbol.iterator](); !(e1 = (o = n.next()).done); e1 = !0){
                            var s = o.value, i = this, a = s.method, l = s.addCallbacks, u = s.legacyPreloadSetup, c = s.target || this, d = c[a].bind(c);
                            if (c === h.default.prototype) {
                                if (f) continue;
                                i = null, d = c[a];
                            }
                            c[a] = this._wrapPromisePreload(i, d, l), u && (c[u.method] = this._legacyPreloadGenerator(i, u, c[a]));
                        }
                    } catch (e1) {
                        t = !0, r = e1;
                    } finally{
                        try {
                            e1 || null == n.return || n.return();
                        } finally{
                            if (t) throw r;
                        }
                    }
                    f = !0;
                }, h.default.prototype._wrapPromisePreload = function(e1, l, u) {
                    var t = function() {
                        for(var e1 = this, t = (this._incrementPreload(), null), r = null, o = arguments.length, n = new Array(o), s = 0; s < o; s++)n[s] = arguments[s];
                        if (u) for(var i = n.length - 1; 0 <= i && !r && "function" == typeof n[i]; i--)r = t, t = n.pop();
                        var a = Promise.resolve(l.apply(this, n));
                        return t && a.then(t), r && a.catch(r), a.then(function() {
                            return e1._decrementPreload();
                        }), a;
                    };
                    return t = e1 ? t.bind(e1) : t;
                };
                h.default.prototype._legacyPreloadGenerator = function(e1, t, s) {
                    var i = t.createBaseObject || o, t = function() {
                        var t = this;
                        this._incrementPreload();
                        for(var e1 = arguments.length, r = new Array(e1), o = 0; o < e1; o++)r[o] = arguments[o];
                        var n = i.apply(this, r);
                        return s.apply(this, r).then(function(e1) {
                            Object.assign(n, e1), t._decrementPreload();
                        }), n;
                    };
                    return t = e1 ? t.bind(e1) : t;
                };
            },
            {
                "./main": 275,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.assign": 176,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.promise": 183,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        281: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l = (n = e1("./main")) && n.__esModule ? n : {
                    default: n
                }, u = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== a(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = i();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("./constants"));
                function i() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, i = function() {
                        return e1;
                    }, e1);
                }
                function a(e1) {
                    return (a = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("./p5.Graphics"), e1("./p5.Renderer2D"), e1("../webgl/p5.RendererGL");
                var c = "defaultCanvas0", n = (l.default.prototype.createCanvas = function(e1, t, r, o) {
                    var n, s, i;
                    if (l.default._validateParameters("createCanvas", arguments), arguments[2] instanceof HTMLCanvasElement ? (r = u.P2D, o = arguments[2]) : n = r || u.P2D, o) (i = document.getElementById(c)) && i.parentNode.removeChild(i), i = o, this._defaultGraphicsCreated = !1;
                    else {
                        if (n === u.WEBGL) (i = document.getElementById(c)) && (i.parentNode.removeChild(i), s = this._renderer, this._elements = this._elements.filter(function(e1) {
                            return e1 !== s;
                        })), (i = document.createElement("canvas")).id = c, i.classList.add("p5Canvas");
                        else if (this._defaultGraphicsCreated) i = this.canvas;
                        else {
                            i = o || document.createElement("canvas");
                            for(var a = 0; document.getElementById("defaultCanvas".concat(a));)a++;
                            c = "defaultCanvas".concat(a), i.id = c, i.classList.add("p5Canvas");
                        }
                        this._setupDone || (i.dataset.hidden = !0, i.style.visibility = "hidden"), (this._userNode || (0 === document.getElementsByTagName("main").length && (r = document.createElement("main"), document.body.appendChild(r)), document.getElementsByTagName("main")[0])).appendChild(i);
                    }
                    return n === u.WEBGL ? (this._setProperty("_renderer", new l.default.RendererGL(i, this, !0)), this._elements.push(this._renderer)) : this._defaultGraphicsCreated || (this._setProperty("_renderer", new l.default.Renderer2D(i, this, !0)), this._defaultGraphicsCreated = !0, this._elements.push(this._renderer)), this._renderer.resize(e1, t), this._renderer._applyDefaults(), this._renderer;
                }, l.default.prototype.resizeCanvas = function(e1, t, r) {
                    if (l.default._validateParameters("resizeCanvas", arguments), this._renderer) {
                        var o, n, s = {};
                        for(o in this.drawingContext){
                            var i = this.drawingContext[o];
                            "object" !== a(i) && "function" != typeof i && (s[o] = i);
                        }
                        for(n in this.width = e1, this.height = t, this._renderer.resize(e1, t), s)try {
                            this.drawingContext[n] = s[n];
                        } catch (e1) {}
                        r || this.redraw();
                    }
                    this._addAccsOutput() && this._updateAccsOutput();
                }, l.default.prototype.noCanvas = function() {
                    this.canvas && this.canvas.parentNode.removeChild(this.canvas);
                }, l.default.prototype.createGraphics = function(e1, t) {
                    for(var r = arguments.length, o = new Array(2 < r ? r - 2 : 0), n = 2; n < r; n++)o[n - 2] = arguments[n];
                    return o[0] instanceof HTMLCanvasElement && (o[1] = o[0], o[0] = u.P2D), l.default._validateParameters("createGraphics", arguments), new l.default.Graphics(e1, t, o[0], this, o[1]);
                }, l.default.prototype.createFramebuffer = function(e1) {
                    return new l.default.Framebuffer(this, e1);
                }, l.default.prototype.blendMode = function(e1) {
                    l.default._validateParameters("blendMode", arguments), e1 === u.NORMAL && (console.warn("NORMAL has been deprecated for use in blendMode. defaulting to BLEND instead."), e1 = u.BLEND), this._renderer.blendMode(e1);
                }, l.default);
                r.default = n;
            },
            {
                "../webgl/p5.RendererGL": 332,
                "./constants": 264,
                "./main": 275,
                "./p5.Graphics": 277,
                "./p5.Renderer2D": 279,
                "core-js/modules/es.array.filter": 155,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        282: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.slice"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l = n(e1("../main")), a = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = c();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../constants")), u = n(e1("../helpers"));
                function c() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, c = function() {
                        return e1;
                    }, e1);
                }
                function n(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function s(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                e1("../friendly_errors/fes_core"), e1("../friendly_errors/file_errors"), e1("../friendly_errors/validate_params"), l.default.prototype._normalizeArcAngles = function(e1, t, r, o, n) {
                    var s;
                    return e1 -= a.TWO_PI * Math.floor(e1 / a.TWO_PI), t -= a.TWO_PI * Math.floor(t / a.TWO_PI), s = Math.min(Math.abs(e1 - t), a.TWO_PI - Math.abs(e1 - t)), n && (e1 = e1 <= a.HALF_PI ? Math.atan(r / o * Math.tan(e1)) : e1 > a.HALF_PI && e1 <= 3 * a.HALF_PI ? Math.atan(r / o * Math.tan(e1)) + a.PI : Math.atan(r / o * Math.tan(e1)) + a.TWO_PI, t = t <= a.HALF_PI ? Math.atan(r / o * Math.tan(t)) : t > a.HALF_PI && t <= 3 * a.HALF_PI ? Math.atan(r / o * Math.tan(t)) + a.PI : Math.atan(r / o * Math.tan(t)) + a.TWO_PI), t < e1 && (t += a.TWO_PI), {
                        start: e1,
                        stop: t,
                        correspondToSamePoint: s < 1e-5
                    };
                }, l.default.prototype.arc = function(e1, t, r, o, n, s, i, a) {
                    return l.default._validateParameters("arc", arguments), (this._renderer._doStroke || this._renderer._doFill) && n !== s && (n = this._toRadians(n), s = this._toRadians(s), r = Math.abs(r), o = Math.abs(o), e1 = u.default.modeAdjust(e1, t, r, o, this._renderer._ellipseMode), (t = this._normalizeArcAngles(n, s, e1.w, e1.h, !0)).correspondToSamePoint ? this._renderer.ellipse([
                        e1.x,
                        e1.y,
                        e1.w,
                        e1.h,
                        a
                    ]) : (this._renderer.arc(e1.x, e1.y, e1.w, e1.h, t.start, t.stop, i, a), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("arc", [
                        e1.x,
                        e1.y,
                        e1.w,
                        e1.h,
                        t.start,
                        t.stop,
                        i
                    ]))), this;
                }, l.default.prototype.ellipse = function(e1, t, r, o, n) {
                    return l.default._validateParameters("ellipse", arguments), this._renderEllipse.apply(this, arguments);
                }, l.default.prototype.circle = function() {
                    l.default._validateParameters("circle", arguments);
                    var e1 = Array.prototype.slice.call(arguments, 0, 2);
                    return e1.push(arguments[2]), e1.push(arguments[2]), this._renderEllipse.apply(this, s(e1));
                }, l.default.prototype._renderEllipse = function(e1, t, r, o, n) {
                    return (this._renderer._doStroke || this._renderer._doFill) && (r < 0 && (r = Math.abs(r)), void 0 === o ? o = r : o < 0 && (o = Math.abs(o)), e1 = u.default.modeAdjust(e1, t, r, o, this._renderer._ellipseMode), this._renderer.ellipse([
                        e1.x,
                        e1.y,
                        e1.w,
                        e1.h,
                        n
                    ]), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("ellipse", [
                        e1.x,
                        e1.y,
                        e1.w,
                        e1.h
                    ])), this;
                }, l.default.prototype.line = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return l.default._validateParameters("line", r), this._renderer._doStroke && (e1 = this._renderer).line.apply(e1, r), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("line", r), this;
                }, l.default.prototype.point = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return l.default._validateParameters("point", r), this._renderer._doStroke && (1 === r.length && r[0] instanceof l.default.Vector ? this._renderer.point.call(this._renderer, r[0].x, r[0].y, r[0].z) : ((e1 = this._renderer).point.apply(e1, r), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("point", r))), this;
                }, l.default.prototype.quad = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return l.default._validateParameters("quad", r), (this._renderer._doStroke || this._renderer._doFill) && (this._renderer.isP3D && r.length < 12 ? this._renderer.quad.call(this._renderer, r[0], r[1], 0, r[2], r[3], 0, r[4], r[5], 0, r[6], r[7], 0, r[8], r[9]) : ((e1 = this._renderer).quad.apply(e1, r), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("quadrilateral", r))), this;
                }, l.default.prototype.rect = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return l.default._validateParameters("rect", t), this._renderRect.apply(this, t);
                }, l.default.prototype.square = function(e1, t, r, o, n, s, i) {
                    return l.default._validateParameters("square", arguments), this._renderRect.call(this, e1, t, r, r, o, n, s, i);
                }, l.default.prototype._renderRect = function() {
                    if (this._renderer._doStroke || this._renderer._doFill) {
                        3 === arguments.length && (arguments[3] = arguments[2]);
                        for(var e1 = u.default.modeAdjust(arguments[0], arguments[1], arguments[2], arguments[3], this._renderer._rectMode), t = [
                            e1.x,
                            e1.y,
                            e1.w,
                            e1.h
                        ], r = 4; r < arguments.length; r++)t[r] = arguments[r];
                        this._renderer.rect(t), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("rectangle", [
                            e1.x,
                            e1.y,
                            e1.w,
                            e1.h
                        ]);
                    }
                    return this;
                }, l.default.prototype.triangle = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return l.default._validateParameters("triangle", t), (this._renderer._doStroke || this._renderer._doFill) && this._renderer.triangle(t), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("triangle", t), this;
                };
                e1 = l.default;
                r.default = e1;
            },
            {
                "../constants": 264,
                "../friendly_errors/fes_core": 266,
                "../friendly_errors/file_errors": 267,
                "../friendly_errors/validate_params": 270,
                "../helpers": 271,
                "../main": 275,
                "core-js/modules/es.array.from": 158,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        283: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (l = e1("../main")) && l.__esModule ? l : {
                    default: l
                }, s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                n.default.prototype.ellipseMode = function(e1) {
                    return n.default._validateParameters("ellipseMode", arguments), e1 !== s.CORNER && e1 !== s.CORNERS && e1 !== s.RADIUS && e1 !== s.CENTER || (this._renderer._ellipseMode = e1), this;
                }, n.default.prototype.noSmooth = function() {
                    return this._renderer.isP3D ? this.setAttributes("antialias", !1) : "imageSmoothingEnabled" in this.drawingContext && (this.drawingContext.imageSmoothingEnabled = !1), this;
                }, n.default.prototype.rectMode = function(e1) {
                    return n.default._validateParameters("rectMode", arguments), e1 !== s.CORNER && e1 !== s.CORNERS && e1 !== s.RADIUS && e1 !== s.CENTER || (this._renderer._rectMode = e1), this;
                }, n.default.prototype.smooth = function() {
                    return this.setAttributes("antialias", !0), this._renderer.isP3D || "imageSmoothingEnabled" in this.drawingContext && (this.drawingContext.imageSmoothingEnabled = !0), this;
                }, n.default.prototype.strokeCap = function(e1) {
                    return n.default._validateParameters("strokeCap", arguments), e1 !== s.ROUND && e1 !== s.SQUARE && e1 !== s.PROJECT || this._renderer.strokeCap(e1), this;
                }, n.default.prototype.strokeJoin = function(e1) {
                    return n.default._validateParameters("strokeJoin", arguments), e1 !== s.ROUND && e1 !== s.BEVEL && e1 !== s.MITER || this._renderer.strokeJoin(e1), this;
                }, n.default.prototype.strokeWeight = function(e1) {
                    return n.default._validateParameters("strokeWeight", arguments), this._renderer.strokeWeight(e1), this;
                };
                var l = n.default;
                r.default = l;
            },
            {
                "../constants": 264,
                "../main": 275,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        284: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l = (o = e1("../main")) && o.__esModule ? o : {
                    default: o
                };
                e1("../friendly_errors/fes_core"), e1("../friendly_errors/file_errors"), e1("../friendly_errors/validate_params"), l.default.prototype.bezier = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return l.default._validateParameters("bezier", r), (this._renderer._doStroke || this._renderer._doFill) && (e1 = this._renderer).bezier.apply(e1, r), this;
                }, l.default.prototype.bezierDetail = function(e1) {
                    return l.default._validateParameters("bezierDetail", arguments), this._bezierDetail = e1, this;
                }, l.default.prototype.bezierPoint = function(e1, t, r, o, n) {
                    l.default._validateParameters("bezierPoint", arguments);
                    var s = 1 - n;
                    return Math.pow(s, 3) * e1 + 3 * Math.pow(s, 2) * n * t + 3 * s * Math.pow(n, 2) * r + Math.pow(n, 3) * o;
                }, l.default.prototype.bezierTangent = function(e1, t, r, o, n) {
                    l.default._validateParameters("bezierTangent", arguments);
                    var s = 1 - n;
                    return 3 * o * Math.pow(n, 2) - 3 * r * Math.pow(n, 2) + 6 * r * s * n - 6 * t * s * n + 3 * t * Math.pow(s, 2) - 3 * e1 * Math.pow(s, 2);
                }, l.default.prototype.curve = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return l.default._validateParameters("curve", r), this._renderer._doStroke && (e1 = this._renderer).curve.apply(e1, r), this;
                }, l.default.prototype.curveDetail = function(e1) {
                    return l.default._validateParameters("curveDetail", arguments), this._curveDetail = e1 < 3 ? 3 : e1, this;
                }, l.default.prototype.curveTightness = function(e1) {
                    return l.default._validateParameters("curveTightness", arguments), this._renderer._curveTightness = e1, this;
                }, l.default.prototype.curvePoint = function(e1, t, r, o, n) {
                    l.default._validateParameters("curvePoint", arguments);
                    var s = this._renderer._curveTightness, i = n * n * n, a = n * n;
                    return e1 * ((s - 1) / 2 * i + (1 - s) * a + (s - 1) / 2 * n) + t * ((s + 3) / 2 * i + (-5 - s) / 2 * a + 1) + r * ((-3 - s) / 2 * i + (s + 2) * a + (1 - s) / 2 * n) + o * ((1 - s) / 2 * i + (s - 1) / 2 * a);
                }, l.default.prototype.curveTangent = function(e1, t, r, o, n) {
                    l.default._validateParameters("curveTangent", arguments);
                    var s = this._renderer._curveTightness, i = n * n * 3, n = 2 * n;
                    return e1 * ((s - 1) / 2 * i + (1 - s) * n + (s - 1) / 2) + t * ((s + 3) / 2 * i + (-5 - s) / 2 * n) + r * ((-3 - s) / 2 * i + (s + 2) * n + (1 - s) / 2) + o * ((1 - s) / 2 * i + (s - 1) / 2 * n);
                };
                var o = l.default;
                r.default = o;
            },
            {
                "../friendly_errors/fes_core": 266,
                "../friendly_errors/file_errors": 267,
                "../friendly_errors/validate_params": 270,
                "../main": 275
            }
        ],
        285: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.slice"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var a = (y = e1("../main")) && y.__esModule ? y : {
                    default: y
                }, l = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = u();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../constants"));
                function u() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, u = function() {
                        return e1;
                    }, e1);
                }
                var n = null, c = [], d = [], h = !1, s = !1, f = !1, p = !1, m = !0, y = (a.default.prototype.beginContour = function() {
                    return this._renderer.isP3D ? this._renderer.beginContour() : (d = [], p = !0), this;
                }, a.default.prototype.beginShape = function(e1) {
                    var t;
                    return a.default._validateParameters("beginShape", arguments), this._renderer.isP3D ? (t = this._renderer).beginShape.apply(t, arguments) : (n = e1 === l.POINTS || e1 === l.LINES || e1 === l.TRIANGLES || e1 === l.TRIANGLE_FAN || e1 === l.TRIANGLE_STRIP || e1 === l.QUADS || e1 === l.QUAD_STRIP ? e1 : null, c = [], d = []), this;
                }, a.default.prototype.bezierVertex = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    if (a.default._validateParameters("bezierVertex", r), this._renderer.isP3D) (e1 = this._renderer).bezierVertex.apply(e1, r);
                    else if (0 === c.length) a.default._friendlyError("vertex() must be used once before calling bezierVertex()", "bezierVertex");
                    else {
                        h = !0;
                        for(var n = [], s = 0; s < r.length; s++)n[s] = r[s];
                        n.isVert = !1, (p ? d : c).push(n);
                    }
                    return this;
                }, a.default.prototype.curveVertex = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return a.default._validateParameters("curveVertex", r), this._renderer.isP3D ? (e1 = this._renderer).curveVertex.apply(e1, r) : (s = !0, this.vertex(r[0], r[1])), this;
                }, a.default.prototype.endContour = function() {
                    if (!this._renderer.isP3D) {
                        var e1 = d[0].slice();
                        e1.isVert = d[0].isVert, e1.moveTo = !1, d.push(e1), m && (c.push(c[0]), m = !1);
                        for(var t = 0; t < d.length; t++)c.push(d[t]);
                    }
                    return this;
                }, a.default.prototype.endShape = function(e1) {
                    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 1;
                    if (a.default._validateParameters("endShape", arguments), t < 1 && (console.log("\uD83C\uDF38 p5.js says: You can not have less than one instance"), t = 1), this._renderer.isP3D) this._renderer.endShape(e1, s, h, f, p, n, t);
                    else {
                        if (1 !== t && console.log("\uD83C\uDF38 p5.js says: Instancing is only supported in WebGL2 mode"), 0 === c.length) return this;
                        if (!this._renderer._doStroke && !this._renderer._doFill) return this;
                        t = e1 === l.CLOSE;
                        t && !p && c.push(c[0]), this._renderer.endShape(e1, c, s, h, f, p, n), m = (p = f = h = s = !1, true), t && c.pop();
                    }
                    return this;
                }, a.default.prototype.quadraticVertex = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    if (a.default._validateParameters("quadraticVertex", r), this._renderer.isP3D) (e1 = this._renderer).quadraticVertex.apply(e1, r);
                    else {
                        if (this._contourInited) return (e1 = {}).x = r[0], e1.y = r[1], e1.x3 = r[2], e1.y3 = r[3], e1.type = l.QUADRATIC, this._contourVertices.push(e1), this;
                        if (0 < c.length) {
                            f = !0;
                            for(var n = [], s = 0; s < r.length; s++)n[s] = r[s];
                            n.isVert = !1, (p ? d : c).push(n);
                        } else a.default._friendlyError("vertex() must be used once before calling quadraticVertex()", "quadraticVertex");
                    }
                    return this;
                }, a.default.prototype.vertex = function(e1, t, r, o, n) {
                    var s;
                    return this._renderer.isP3D ? (s = this._renderer).vertex.apply(s, arguments) : ((s = []).isVert = !0, s[0] = e1, s[1] = t, s[2] = 0, s[3] = 0, s[4] = 0, s[5] = this._renderer._getFill(), s[6] = this._renderer._getStroke(), r && (s.moveTo = r), (p ? (0 === d.length && (s.moveTo = !0), d) : c).push(s)), this;
                }, a.default.prototype.normal = function(e1, t, r) {
                    var o;
                    return this._assert3d("normal"), a.default._validateParameters("normal", arguments), (o = this._renderer).normal.apply(o, arguments), this;
                }, a.default);
                r.default = y;
            },
            {
                "../constants": 264,
                "../main": 275,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        286: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function a(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                function n(e1) {
                    return (n = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                var l, u, c;
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.uint8-clamped-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.uint8-clamped-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), window.requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(e1, t) {
                    window.setTimeout(e1, 1e3 / 60);
                }, "undefined" == typeof Uint8ClampedArray || Uint8ClampedArray.prototype.slice || Object.defineProperty(Uint8ClampedArray.prototype, "slice", {
                    value: Array.prototype.slice,
                    writable: !0,
                    configurable: !0,
                    enumerable: !1
                }), Object.assign || (l = Object.keys, e1 = Object.defineProperty, u = "function" == typeof Symbol && "symbol" === n(Symbol()), c = Object.prototype.propertyIsEnumerable, e1(Object, "assign", {
                    value: function(e1, t) {
                        if (null == e1) throw new TypeError("target must be an object");
                        for(var r, o = Object(e1), n = 1; n < arguments.length; ++n){
                            var s = Object(arguments[n]), i = l(s);
                            for(u && Object.getOwnPropertySymbols && i.push.apply(i, a(Object.getOwnPropertySymbols(s).filter(function(t) {
                                return function(e1) {
                                    return c.call(t, e1);
                                };
                            }(s)))), r = 0; r < i.length; ++r)o[i[r]] = s[i[r]];
                        }
                        return o;
                    },
                    configurable: !0,
                    enumerable: !1,
                    writable: !0
                }));
            },
            {
                "core-js/modules/es.array.filter": 155,
                "core-js/modules/es.array.from": 158,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.object.assign": 176,
                "core-js/modules/es.object.keys": 181,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.typed-array.copy-within": 205,
                "core-js/modules/es.typed-array.every": 206,
                "core-js/modules/es.typed-array.fill": 207,
                "core-js/modules/es.typed-array.filter": 208,
                "core-js/modules/es.typed-array.find": 210,
                "core-js/modules/es.typed-array.find-index": 209,
                "core-js/modules/es.typed-array.for-each": 213,
                "core-js/modules/es.typed-array.includes": 214,
                "core-js/modules/es.typed-array.index-of": 215,
                "core-js/modules/es.typed-array.iterator": 218,
                "core-js/modules/es.typed-array.join": 219,
                "core-js/modules/es.typed-array.last-index-of": 220,
                "core-js/modules/es.typed-array.map": 221,
                "core-js/modules/es.typed-array.reduce": 223,
                "core-js/modules/es.typed-array.reduce-right": 222,
                "core-js/modules/es.typed-array.reverse": 224,
                "core-js/modules/es.typed-array.set": 225,
                "core-js/modules/es.typed-array.slice": 226,
                "core-js/modules/es.typed-array.some": 227,
                "core-js/modules/es.typed-array.sort": 228,
                "core-js/modules/es.typed-array.subarray": 229,
                "core-js/modules/es.typed-array.to-locale-string": 230,
                "core-js/modules/es.typed-array.to-string": 231,
                "core-js/modules/es.typed-array.uint8-clamped-array": 235,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        287: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.assign"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("./main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype.noLoop = function() {
                    this._loop = !1;
                }, e1.default.prototype.loop = function() {
                    this._loop || (this._loop = !0, this._setupDone && this._draw());
                }, e1.default.prototype.isLooping = function() {
                    return this._loop;
                }, e1.default.prototype.push = function() {
                    this._styles.push({
                        props: {
                            _colorMode: this._colorMode
                        },
                        renderer: this._renderer.push()
                    });
                }, e1.default.prototype.pop = function() {
                    var e1 = this._styles.pop();
                    e1 ? (this._renderer.pop(e1.renderer), Object.assign(this, e1.props)) : console.warn("pop() was called without matching push()");
                }, e1.default.prototype.redraw = function(e1) {
                    if (!this._inUserDraw && this._setupDone) {
                        var t = parseInt(e1), r = ((isNaN(t) || t < 1) && (t = 1), this._isGlobal ? window : this);
                        if ("function" == typeof r.draw) {
                            void 0 === r.setup && r.scale(r._pixelDensity, r._pixelDensity);
                            for(var o = 0; o < t; o++){
                                r.resetMatrix(), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._updateAccsOutput(), r._renderer.isP3D && r._renderer._update(), r._setProperty("frameCount", r.frameCount + 1), this.callRegisteredHooksFor("pre"), this._inUserDraw = !0;
                                try {
                                    r.draw();
                                } finally{
                                    this._inUserDraw = !1;
                                }
                                this.callRegisteredHooksFor("post");
                            }
                        }
                    }
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "./main": 275,
                "core-js/modules/es.object.assign": 176
            }
        ],
        288: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (e1 = e1("./main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function o(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                n.default.prototype.applyMatrix = function() {
                    var e1 = (arguments.length <= 0 ? void 0 : arguments[0]) instanceof Object.getPrototypeOf(Uint8Array);
                    return Array.isArray(arguments.length <= 0 ? void 0 : arguments[0]) || e1 ? (e1 = this._renderer).applyMatrix.apply(e1, o(arguments.length <= 0 ? void 0 : arguments[0])) : (e1 = this._renderer).applyMatrix.apply(e1, arguments), this;
                }, n.default.prototype.resetMatrix = function() {
                    return this._renderer.resetMatrix(), this;
                }, n.default.prototype.rotate = function(e1, t) {
                    return n.default._validateParameters("rotate", arguments), this._renderer.rotate(this._toRadians(e1), t), this;
                }, n.default.prototype.rotateX = function(e1) {
                    return this._assert3d("rotateX"), n.default._validateParameters("rotateX", arguments), this._renderer.rotateX(this._toRadians(e1)), this;
                }, n.default.prototype.rotateY = function(e1) {
                    return this._assert3d("rotateY"), n.default._validateParameters("rotateY", arguments), this._renderer.rotateY(this._toRadians(e1)), this;
                }, n.default.prototype.rotateZ = function(e1) {
                    return this._assert3d("rotateZ"), n.default._validateParameters("rotateZ", arguments), this._renderer.rotateZ(this._toRadians(e1)), this;
                }, n.default.prototype.scale = function(e1, t, r) {
                    var o;
                    return n.default._validateParameters("scale", arguments), e1 instanceof n.default.Vector ? (e1 = (o = e1).x, t = o.y, r = o.z) : e1 instanceof Array && (e1 = (o = e1)[0], t = o[1], r = o[2] || 1), isNaN(t) ? t = r = e1 : isNaN(r) && (r = 1), this._renderer.scale.call(this._renderer, e1, t, r), this;
                }, n.default.prototype.shearX = function(e1) {
                    n.default._validateParameters("shearX", arguments);
                    e1 = this._toRadians(e1);
                    return this._renderer.applyMatrix(1, 0, Math.tan(e1), 1, 0, 0), this;
                }, n.default.prototype.shearY = function(e1) {
                    n.default._validateParameters("shearY", arguments);
                    e1 = this._toRadians(e1);
                    return this._renderer.applyMatrix(1, Math.tan(e1), 0, 1, 0, 0), this;
                }, n.default.prototype.translate = function(e1, t, r) {
                    return n.default._validateParameters("translate", arguments), this._renderer.isP3D ? this._renderer.translate(e1, t, r) : this._renderer.translate(e1, t), this;
                };
                e1 = n.default;
                r.default = e1;
            },
            {
                "./main": 275,
                "core-js/modules/es.array.from": 158,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.get-prototype-of": 180,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.typed-array.copy-within": 205,
                "core-js/modules/es.typed-array.every": 206,
                "core-js/modules/es.typed-array.fill": 207,
                "core-js/modules/es.typed-array.filter": 208,
                "core-js/modules/es.typed-array.find": 210,
                "core-js/modules/es.typed-array.find-index": 209,
                "core-js/modules/es.typed-array.for-each": 213,
                "core-js/modules/es.typed-array.includes": 214,
                "core-js/modules/es.typed-array.index-of": 215,
                "core-js/modules/es.typed-array.iterator": 218,
                "core-js/modules/es.typed-array.join": 219,
                "core-js/modules/es.typed-array.last-index-of": 220,
                "core-js/modules/es.typed-array.map": 221,
                "core-js/modules/es.typed-array.reduce": 223,
                "core-js/modules/es.typed-array.reduce-right": 222,
                "core-js/modules/es.typed-array.reverse": 224,
                "core-js/modules/es.typed-array.set": 225,
                "core-js/modules/es.typed-array.slice": 226,
                "core-js/modules/es.typed-array.some": 227,
                "core-js/modules/es.typed-array.sort": 228,
                "core-js/modules/es.typed-array.subarray": 229,
                "core-js/modules/es.typed-array.to-locale-string": 230,
                "core-js/modules/es.typed-array.to-string": 231,
                "core-js/modules/es.typed-array.uint8-array": 234,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        289: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.ends-with"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.ends-with"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator");
                var n = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function s(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                n.default.prototype.storeItem = function(e1, t) {
                    "string" != typeof e1 && console.log("The argument that you passed to storeItem() - ".concat(e1, " is not a string.")), e1.endsWith("p5TypeID") && console.log("The argument that you passed to storeItem() - ".concat(e1, " must not end with 'p5TypeID'.")), void 0 === t && console.log("You cannot store undefined variables using storeItem().");
                    var r = i(t);
                    switch(r){
                        case "number":
                        case "boolean":
                            t = t.toString();
                            break;
                        case "object":
                            t instanceof n.default.Color ? r = "p5.Color" : t instanceof n.default.Vector && (r = "p5.Vector", t = [
                                t.x,
                                t.y,
                                t.z
                            ]), t = JSON.stringify(t);
                    }
                    localStorage.setItem(e1, t);
                    e1 = "".concat(e1, "p5TypeID");
                    localStorage.setItem(e1, r);
                }, n.default.prototype.getItem = function(e1) {
                    var t = localStorage.getItem(e1), r = localStorage.getItem("".concat(e1, "p5TypeID"));
                    if (void 0 === r) console.log("Unable to determine type of item stored under ".concat(e1, "in local storage. Did you save the item with something other than setItem()?"));
                    else if (null !== t) switch(r){
                        case "number":
                            t = parseFloat(t);
                            break;
                        case "boolean":
                            t = "true" === t;
                            break;
                        case "object":
                            t = JSON.parse(t);
                            break;
                        case "p5.Color":
                            t = JSON.parse(t), t = this.color.apply(this, s(t.levels));
                            break;
                        case "p5.Vector":
                            t = JSON.parse(t), t = this.createVector.apply(this, s(t));
                    }
                    return t;
                }, n.default.prototype.clearStorage = function() {
                    localStorage.clear();
                }, n.default.prototype.removeItem = function(e1) {
                    "string" != typeof e1 && console.log("The argument that you passed to removeItem() - ".concat(e1, " is not a string.")), localStorage.removeItem(e1), localStorage.removeItem("".concat(e1, "p5TypeID"));
                };
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.from": 158,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.ends-with": 190,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        290: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function n(e1) {
                    return (n = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.object.keys"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function i(e1, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e1.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e1,
                            writable: !0,
                            configurable: !0
                        }
                    }), t && a(e1, t);
                }
                function a(e1, t) {
                    return (a = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function l(r) {
                    return function() {
                        var e1, t = u(r), t = (e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = u(this).constructor, Reflect.construct(t, arguments, e1)) : t.apply(this, arguments), this);
                        if (!e1 || "object" !== n(e1) && "function" != typeof e1) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }
                        return e1;
                    };
                }
                function u(e1) {
                    return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                function c(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function d(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function h(e1, t, r) {
                    t && d(e1.prototype, t), r && d(e1, r);
                }
                s.default.prototype.createStringDict = function(e1, t) {
                    return s.default._validateParameters("createStringDict", arguments), new s.default.StringDict(e1, t);
                }, s.default.prototype.createNumberDict = function(e1, t) {
                    return s.default._validateParameters("createNumberDict", arguments), new s.default.NumberDict(e1, t);
                }, s.default.TypedDict = function() {
                    function r(e1, t) {
                        return c(this, r), e1 instanceof Object ? this.data = e1 : (this.data = {}, this.data[e1] = t), this;
                    }
                    return h(r, [
                        {
                            key: "size",
                            value: function() {
                                return Object.keys(this.data).length;
                            }
                        },
                        {
                            key: "hasKey",
                            value: function(e1) {
                                return this.data.hasOwnProperty(e1);
                            }
                        },
                        {
                            key: "get",
                            value: function(e1) {
                                if (this.data.hasOwnProperty(e1)) return this.data[e1];
                                console.log("".concat(e1, " does not exist in this Dictionary"));
                            }
                        },
                        {
                            key: "set",
                            value: function(e1, t) {
                                this._validate(t) ? this.data[e1] = t : console.log("Those values dont work for this dictionary type.");
                            }
                        },
                        {
                            key: "_addObj",
                            value: function(e1) {
                                for(var t in e1)this.set(t, e1[t]);
                            }
                        },
                        {
                            key: "create",
                            value: function(e1, t) {
                                e1 instanceof Object && void 0 === t ? this._addObj(e1) : void 0 !== e1 ? this.set(e1, t) : console.log("In order to create a new Dictionary entry you must pass an object or a key, value pair");
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.data = {};
                            }
                        },
                        {
                            key: "remove",
                            value: function(e1) {
                                if (!this.data.hasOwnProperty(e1)) throw new Error("".concat(e1, " does not exist in this Dictionary"));
                                delete this.data[e1];
                            }
                        },
                        {
                            key: "print",
                            value: function() {
                                for(var e1 in this.data)console.log("key:".concat(e1, " value:").concat(this.data[e1]));
                            }
                        },
                        {
                            key: "saveTable",
                            value: function(e1) {
                                var t, r = "";
                                for(t in this.data)r += "".concat(t, ",").concat(this.data[t], "\n");
                                var o = new Blob([
                                    r
                                ], {
                                    type: "text/csv"
                                });
                                s.default.prototype.downloadFile(o, e1 || "mycsv", "csv");
                            }
                        },
                        {
                            key: "saveJSON",
                            value: function(e1, t) {
                                s.default.prototype.saveJSON(this.data, e1, t);
                            }
                        },
                        {
                            key: "_validate",
                            value: function(e1) {
                                return !0;
                            }
                        }
                    ]), r;
                }(), s.default.StringDict = function() {
                    i(n, s.default.TypedDict);
                    var o = l(n);
                    function n() {
                        c(this, n);
                        for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                        return o.call.apply(o, [
                            this
                        ].concat(t));
                    }
                    return h(n, [
                        {
                            key: "_validate",
                            value: function(e1) {
                                return "string" == typeof e1;
                            }
                        }
                    ]), n;
                }(), s.default.NumberDict = function() {
                    i(n, s.default.TypedDict);
                    var o = l(n);
                    function n() {
                        c(this, n);
                        for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                        return o.call.apply(o, [
                            this
                        ].concat(t));
                    }
                    return h(n, [
                        {
                            key: "_validate",
                            value: function(e1) {
                                return "number" == typeof e1;
                            }
                        },
                        {
                            key: "add",
                            value: function(e1, t) {
                                this.data.hasOwnProperty(e1) ? this.data[e1] += t : console.log("The key - ".concat(e1, " does not exist in this dictionary."));
                            }
                        },
                        {
                            key: "sub",
                            value: function(e1, t) {
                                this.add(e1, -t);
                            }
                        },
                        {
                            key: "mult",
                            value: function(e1, t) {
                                this.data.hasOwnProperty(e1) ? this.data[e1] *= t : console.log("The key - ".concat(e1, " does not exist in this dictionary."));
                            }
                        },
                        {
                            key: "div",
                            value: function(e1, t) {
                                this.data.hasOwnProperty(e1) ? this.data[e1] /= t : console.log("The key - ".concat(e1, " does not exist in this dictionary."));
                            }
                        },
                        {
                            key: "_valueTest",
                            value: function(e1) {
                                if (0 === Object.keys(this.data).length) throw new Error("Unable to search for a minimum or maximum value on an empty NumberDict");
                                if (1 === Object.keys(this.data).length) return this.data[Object.keys(this.data)[0]];
                                var t, r = this.data[Object.keys(this.data)[0]];
                                for(t in this.data)this.data[t] * e1 < r * e1 && (r = this.data[t]);
                                return r;
                            }
                        },
                        {
                            key: "minValue",
                            value: function() {
                                return this._valueTest(1);
                            }
                        },
                        {
                            key: "maxValue",
                            value: function() {
                                return this._valueTest(-1);
                            }
                        },
                        {
                            key: "_keyTest",
                            value: function(e1) {
                                if (0 === Object.keys(this.data).length) throw new Error("Unable to use minValue on an empty NumberDict");
                                if (1 === Object.keys(this.data).length) return Object.keys(this.data)[0];
                                for(var t = Object.keys(this.data)[0], r = 1; r < Object.keys(this.data).length; r++)Object.keys(this.data)[r] * e1 < t * e1 && (t = Object.keys(this.data)[r]);
                                return t;
                            }
                        },
                        {
                            key: "minKey",
                            value: function() {
                                return this._keyTest(1);
                            }
                        },
                        {
                            key: "maxKey",
                            value: function() {
                                return this._keyTest(-1);
                            }
                        }
                    ]), n;
                }();
                e1 = s.default.TypedDict;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.get-prototype-of": 180,
                "core-js/modules/es.object.keys": 181,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.reflect.construct": 184,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        291: [
            function(t, r, o) {
                "use strict";
                function n(e1) {
                    return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                t("core-js/modules/es.symbol"), t("core-js/modules/es.symbol.description"), t("core-js/modules/es.symbol.iterator"), t("core-js/modules/es.array.every"), t("core-js/modules/es.array.filter"), t("core-js/modules/es.array.for-each"), t("core-js/modules/es.array.from"), t("core-js/modules/es.array.index-of"), t("core-js/modules/es.array.iterator"), t("core-js/modules/es.array.map"), t("core-js/modules/es.array.slice"), t("core-js/modules/es.array.splice"), t("core-js/modules/es.function.name"), t("core-js/modules/es.object.get-prototype-of"), t("core-js/modules/es.object.to-string"), t("core-js/modules/es.promise"), t("core-js/modules/es.reflect.construct"), t("core-js/modules/es.regexp.exec"), t("core-js/modules/es.regexp.to-string"), t("core-js/modules/es.string.iterator"), t("core-js/modules/es.string.replace"), t("core-js/modules/es.string.split"), t("core-js/modules/es.string.trim"), t("core-js/modules/web.dom-collections.for-each"), t("core-js/modules/web.dom-collections.iterator"), t("core-js/modules/web.url"), t("core-js/modules/es.symbol"), t("core-js/modules/es.symbol.description"), t("core-js/modules/es.symbol.iterator"), t("core-js/modules/es.array.every"), t("core-js/modules/es.array.filter"), t("core-js/modules/es.array.for-each"), t("core-js/modules/es.array.from"), t("core-js/modules/es.array.index-of"), t("core-js/modules/es.array.iterator"), t("core-js/modules/es.array.map"), t("core-js/modules/es.array.slice"), t("core-js/modules/es.array.splice"), t("core-js/modules/es.function.name"), t("core-js/modules/es.object.to-string"), t("core-js/modules/es.promise"), t("core-js/modules/es.regexp.exec"), t("core-js/modules/es.regexp.to-string"), t("core-js/modules/es.string.iterator"), t("core-js/modules/es.string.replace"), t("core-js/modules/es.string.split"), t("core-js/modules/es.string.trim"), t("core-js/modules/web.dom-collections.for-each"), t("core-js/modules/web.dom-collections.iterator"), t("core-js/modules/web.url"), Object.defineProperty(o, "__esModule", {
                    value: !0
                }), o.default = void 0;
                var f = (t = t("../core/main")) && t.__esModule ? t : {
                    default: t
                };
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function a(e1, t, r) {
                    t && s(e1.prototype, t), r && s(e1, r);
                }
                function l(e1, t) {
                    return (l = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function u(o) {
                    return function() {
                        var e1, t, r = i(o);
                        return e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = i(this).constructor, Reflect.construct(r, arguments, e1)) : r.apply(this, arguments), r = this, !(t = e1) || "object" !== h(t) && "function" != typeof t ? c(r) : t;
                    };
                }
                function c(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                function i(e1) {
                    return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                function d(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function h(e1) {
                    return (h = "function" == typeof Symbol && "symbol" === n(Symbol.iterator) ? function(e1) {
                        return n(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : n(e1);
                    })(e1);
                }
                function p(e1, t, r) {
                    (t._userNode || document.body).appendChild(e1);
                    r = new (r ? f.default.MediaElement : f.default.Element)(e1, t);
                    return t._elements.push(r), r;
                }
                function m(e1, t, r, o) {
                    var n = document.createElement(t), s = ("string" == typeof (r = r || "") && (r = [
                        r
                    ]), !0), t = !1, i = void 0;
                    try {
                        for(var a, l = r[Symbol.iterator](); !(s = (a = l.next()).done); s = !0){
                            var u = a.value, c = document.createElement("source");
                            c.setAttribute("src", u), n.appendChild(c);
                        }
                    } catch (e1) {
                        t = !0, i = e1;
                    } finally{
                        try {
                            s || null == l.return || l.return();
                        } finally{
                            if (t) throw i;
                        }
                    }
                    "function" == typeof o && n.addEventListener("canplaythrough", function e1() {
                        o(), n.removeEventListener("canplaythrough", e1);
                    });
                    var d = p(n, e1, !0);
                    return d.loadedmetadata = !1, n.addEventListener("loadedmetadata", function() {
                        d.width = n.videoWidth, d.height = n.videoHeight, 0 === d.elt.width && (d.elt.width = n.videoWidth), 0 === d.elt.height && (d.elt.height = n.videoHeight), d.presetPlaybackRate && (d.elt.playbackRate = d.presetPlaybackRate, delete d.presetPlaybackRate), d.loadedmetadata = !0;
                    }), d;
                }
                f.default.prototype.select = function(e1, t) {
                    f.default._validateParameters("select", arguments);
                    t = this._getContainer(t).querySelector(e1);
                    return t ? this._wrapElement(t) : null;
                }, f.default.prototype.selectAll = function(e1, t) {
                    f.default._validateParameters("selectAll", arguments);
                    var r = [], o = this._getContainer(t).querySelectorAll(e1);
                    if (o) for(var n = 0; n < o.length; n++){
                        var s = this._wrapElement(o[n]);
                        r.push(s);
                    }
                    return r;
                }, f.default.prototype._getContainer = function(e1) {
                    var t = document;
                    return "string" == typeof e1 ? t = document.querySelector(e1) || document : e1 instanceof f.default.Element ? t = e1.elt : e1 instanceof HTMLElement && (t = e1), t;
                }, f.default.prototype._wrapElement = function(e1) {
                    var t, r = Array.prototype.slice.call(e1.children);
                    return "INPUT" === e1.tagName && "checkbox" === e1.type ? ((t = new f.default.Element(e1, this)).checked = function() {
                        return 0 === arguments.length ? this.elt.checked : (this.elt.checked = !(arguments.length <= 0 || !arguments[0]), this);
                    }, t) : "VIDEO" === e1.tagName || "AUDIO" === e1.tagName ? new f.default.MediaElement(e1, this) : "SELECT" === e1.tagName ? this.createSelect(new f.default.Element(e1, this)) : 0 < r.length && r.every(function(e1) {
                        return "INPUT" === e1.tagName || "LABEL" === e1.tagName;
                    }) ? this.createRadio(new f.default.Element(e1, this)) : new f.default.Element(e1, this);
                }, f.default.prototype.removeElements = function(e1) {
                    f.default._validateParameters("removeElements", arguments);
                    this._elements.filter(function(e1) {
                        return !(e1.elt instanceof HTMLCanvasElement);
                    }).map(function(e1) {
                        return e1.remove();
                    });
                }, f.default.Element.prototype.changed = function(e1) {
                    return f.default.Element._adjustListener("change", e1, this), this;
                }, f.default.Element.prototype.input = function(e1) {
                    return f.default.Element._adjustListener("input", e1, this), this;
                }, f.default.prototype.createDiv = function() {
                    var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "", t = document.createElement("div");
                    return t.innerHTML = e1, p(t, this);
                }, f.default.prototype.createP = function() {
                    var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "", t = document.createElement("p");
                    return t.innerHTML = e1, p(t, this);
                }, f.default.prototype.createSpan = function() {
                    var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "", t = document.createElement("span");
                    return t.innerHTML = e1, p(t, this);
                }, f.default.prototype.createImg = function() {
                    f.default._validateParameters("createImg", arguments);
                    var t, r = document.createElement("img"), o = arguments;
                    return 1 < o.length && "string" == typeof o[1] && (r.alt = o[1]), 2 < o.length && "string" == typeof o[2] && (r.crossOrigin = o[2]), r.src = o[0], t = p(r, this), r.addEventListener("load", function() {
                        t.width = r.offsetWidth || r.width, t.height = r.offsetHeight || r.height;
                        var e1 = o[o.length - 1];
                        "function" == typeof e1 && e1(t);
                    }), t;
                }, f.default.prototype.createA = function(e1, t, r) {
                    f.default._validateParameters("createA", arguments);
                    var o = document.createElement("a");
                    return o.href = e1, o.innerHTML = t, r && (o.target = r), p(o, this);
                }, f.default.prototype.createSlider = function(e1, t, r, o) {
                    f.default._validateParameters("createSlider", arguments);
                    var n = document.createElement("input");
                    return n.type = "range", n.min = e1, n.max = t, 0 === o ? n.step = 1e-18 : o && (n.step = o), "number" == typeof r && (n.value = r), p(n, this);
                }, f.default.prototype.createButton = function(e1, t) {
                    f.default._validateParameters("createButton", arguments);
                    var r = document.createElement("button");
                    return r.innerHTML = e1, t && (r.value = t), p(r, this);
                }, f.default.prototype.createCheckbox = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    f.default._validateParameters("createCheckbox", t);
                    var o = document.createElement("div"), n = document.createElement("input"), s = (n.type = "checkbox", document.createElement("label")), i = (s.appendChild(n), o.appendChild(s), p(o, this));
                    return i.checked = function() {
                        var e1 = i.elt.firstElementChild.getElementsByTagName("input")[0];
                        if (e1) {
                            if (0 === arguments.length) return e1.checked;
                            e1.checked = !(arguments.length <= 0 || !arguments[0]);
                        }
                        return i;
                    }, this.value = function(e1) {
                        return i.value = e1, this;
                    }, t[0] && (i.value(t[0]), (o = document.createElement("span")).innerHTML = t[0], s.appendChild(o)), t[1] && (n.checked = !0), i;
                }, f.default.prototype.createSelect = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    f.default._validateParameters("createSelect", r);
                    var n, s = r[0];
                    return s instanceof f.default.Element && s.elt instanceof HTMLSelectElement ? this.elt = (e1 = s).elt : s instanceof HTMLSelectElement ? (e1 = p(s, this), this.elt = s) : (n = document.createElement("select"), s && "boolean" == typeof s && n.setAttribute("multiple", "true"), e1 = p(n, this), this.elt = n), e1.option = function(e1, t) {
                        var r;
                        if (void 0 !== e1) {
                            for(var o, n = 0; n < this.elt.length; n += 1)if (this.elt[n].textContent === e1) {
                                r = n;
                                break;
                            }
                            void 0 !== r ? !1 === t ? this.elt.remove(r) : this.elt[r].value = t : ((o = document.createElement("option")).textContent = e1, o.value = void 0 === t ? e1 : t, this.elt.appendChild(o), this._pInst._elements.push(o));
                        }
                    }, e1.selected = function(e1) {
                        if (void 0 !== e1) {
                            for(var t = 0; t < this.elt.length; t += 1)this.elt[t].value.toString() === e1.toString() && (this.elt.selectedIndex = t);
                            return this;
                        }
                        if (this.elt.getAttribute("multiple")) {
                            var r = [], o = !0, n = !1, s = void 0;
                            try {
                                for(var i, a = this.elt.selectedOptions[Symbol.iterator](); !(o = (i = a.next()).done); o = !0){
                                    var l = i.value;
                                    r.push(l.value);
                                }
                            } catch (e1) {
                                n = !0, s = e1;
                            } finally{
                                try {
                                    o || null == a.return || a.return();
                                } finally{
                                    if (n) throw s;
                                }
                            }
                            return r;
                        }
                        return this.elt.value;
                    }, e1.disable = function(e1) {
                        if ("string" == typeof e1) for(var t = 0; t < this.elt.length; t++)this.elt[t].value.toString() === e1 && (this.elt[t].disabled = !0, this.elt[t].selected = !1);
                        else this.elt.disabled = !0;
                        return this;
                    }, e1.enable = function(e1) {
                        if ("string" == typeof e1) for(var t = 0; t < this.elt.length; t++)this.elt[t].value.toString() === e1 && (this.elt[t].disabled = !1, this.elt[t].selected = !1);
                        else {
                            this.elt.disabled = !1;
                            for(var r = 0; r < this.elt.length; r++)this.elt[r].disabled = !1, this.elt[r].selected = !1;
                        }
                        return this;
                    }, e1;
                }, f.default.prototype.createRadio = function() {
                    function t(e1) {
                        return e1 instanceof HTMLInputElement && "radio" === e1.type;
                    }
                    function d(e1) {
                        return e1 instanceof HTMLLabelElement;
                    }
                    var h, e1, r, o = arguments.length <= 0 ? void 0 : arguments[0];
                    o instanceof f.default.Element && (o.elt instanceof HTMLDivElement || o.elt instanceof HTMLSpanElement) ? (h = o, this.elt = o.elt) : o instanceof HTMLDivElement || o instanceof HTMLSpanElement ? (h = p(o, this), e1 = this.elt = o, "string" == typeof (arguments.length <= 1 ? void 0 : arguments[1]) && (r = arguments.length <= 1 ? void 0 : arguments[1])) : ("string" == typeof o && (r = o), e1 = document.createElement("div"), h = p(e1, this), this.elt = e1), h._name = r || "radioOption";
                    return h._getOptionsArray = function() {
                        return Array.from(this.elt.children).filter(function(e1) {
                            return t(e1) || d(e1) && t(e1.firstElementChild);
                        }).map(function(e1) {
                            return t(e1) ? e1 : e1.firstElementChild;
                        });
                    }, h.option = function(e1, t) {
                        var r, o, n, s = !0, i = !1, a = void 0;
                        try {
                            for(var l, u = h._getOptionsArray()[Symbol.iterator](); !(s = (l = u.next()).done); s = !0){
                                var c = l.value;
                                if (c.value === e1) {
                                    r = c;
                                    break;
                                }
                            }
                        } catch (e1) {
                            i = !0, a = e1;
                        } finally{
                            try {
                                s || null == u.return || u.return();
                            } finally{
                                if (i) throw a;
                            }
                        }
                        return void 0 === r && ((r = document.createElement("input")).setAttribute("type", "radio"), r.setAttribute("value", e1)), r.setAttribute("name", h._name), d(r.parentElement) ? o = r.parentElement : (o = document.createElement("label")).insertAdjacentElement("afterbegin", r), o.lastElementChild instanceof HTMLSpanElement ? n = o.lastElementChild : (n = document.createElement("span"), r.insertAdjacentElement("afterend", n)), n.innerHTML = void 0 === t ? e1 : t, this.elt.appendChild(o), r;
                    }, h.remove = function(e1) {
                        var t = !0, r = !1, o = void 0;
                        try {
                            for(var n, s = h._getOptionsArray()[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                var i = n.value;
                                if (i.value === e1) return void (d(i.parentElement) ? i.parentElement : i).remove();
                            }
                        } catch (e1) {
                            r = !0, o = e1;
                        } finally{
                            try {
                                t || null == s.return || s.return();
                            } finally{
                                if (r) throw o;
                            }
                        }
                    }, h.value = function() {
                        var e1 = "", t = !0, r = !1, o = void 0;
                        try {
                            for(var n, s = h._getOptionsArray()[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                var i = n.value;
                                if (i.checked) {
                                    e1 = i.value;
                                    break;
                                }
                            }
                        } catch (e1) {
                            r = !0, o = e1;
                        } finally{
                            try {
                                t || null == s.return || s.return();
                            } finally{
                                if (r) throw o;
                            }
                        }
                        return e1;
                    }, h.selected = function(e1) {
                        var t = null;
                        if (void 0 === e1) {
                            var r = !0, o = !1, n = void 0;
                            try {
                                for(var s, i = h._getOptionsArray()[Symbol.iterator](); !(r = (s = i.next()).done); r = !0){
                                    var a = s.value;
                                    if (a.checked) {
                                        t = a;
                                        break;
                                    }
                                }
                            } catch (e1) {
                                o = !0, n = e1;
                            } finally{
                                try {
                                    r || null == i.return || i.return();
                                } finally{
                                    if (o) throw n;
                                }
                            }
                        } else {
                            h._getOptionsArray().forEach(function(e1) {
                                e1.checked = !1, e1.removeAttribute("checked");
                            });
                            var l = !0, o = !1, n = void 0;
                            try {
                                for(var u, c = h._getOptionsArray()[Symbol.iterator](); !(l = (u = c.next()).done); l = !0){
                                    var d = u.value;
                                    d.value === e1 && (d.setAttribute("checked", !0), d.checked = !0, t = d);
                                }
                            } catch (e1) {
                                o = !0, n = e1;
                            } finally{
                                try {
                                    l || null == c.return || c.return();
                                } finally{
                                    if (o) throw n;
                                }
                            }
                        }
                        return t;
                    }, h.disable = function() {
                        var e1 = !(0 < arguments.length && void 0 !== arguments[0]) || arguments[0], t = !0, r = !1, o = void 0;
                        try {
                            for(var n, s = h._getOptionsArray()[Symbol.iterator](); !(t = (n = s.next()).done); t = !0)n.value.setAttribute("disabled", e1);
                        } catch (e1) {
                            r = !0, o = e1;
                        } finally{
                            try {
                                t || null == s.return || s.return();
                            } finally{
                                if (r) throw o;
                            }
                        }
                    }, h;
                }, f.default.prototype.createColorPicker = function(e1) {
                    f.default._validateParameters("createColorPicker", arguments);
                    var t = document.createElement("input");
                    return t.type = "color", e1 ? e1 instanceof f.default.Color ? t.value = e1.toString("#rrggbb") : (f.default.prototype._colorMode = "rgb", f.default.prototype._colorMaxes = {
                        rgb: [
                            255,
                            255,
                            255,
                            255
                        ],
                        hsb: [
                            360,
                            100,
                            100,
                            1
                        ],
                        hsl: [
                            360,
                            100,
                            100,
                            1
                        ]
                    }, t.value = f.default.prototype.color(e1).toString("#rrggbb")) : t.value = "#000000", (t = p(t, this)).color = function() {
                        return e1 && (e1.mode && (f.default.prototype._colorMode = e1.mode), e1.maxes && (f.default.prototype._colorMaxes = e1.maxes)), f.default.prototype.color(this.elt.value);
                    }, t;
                }, f.default.prototype.createInput = function() {
                    var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "", t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "text", r = (f.default._validateParameters("createInput", arguments), document.createElement("input"));
                    return r.setAttribute("value", e1), r.setAttribute("type", t), p(r, this);
                }, f.default.prototype.createFileInput = function(a) {
                    var e1, t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1];
                    f.default._validateParameters("createFileInput", arguments);
                    if (window.File && window.FileReader && window.FileList && window.Blob) return (e1 = document.createElement("input")).setAttribute("type", "file"), t && e1.setAttribute("multiple", !0), e1.addEventListener("change", function(e1) {
                        var t = !0, r = !1, o = void 0;
                        try {
                            for(var n, s = e1.target.files[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                var i = n.value;
                                f.default.File._load(i, a);
                            }
                        } catch (e1) {
                            r = !0, o = e1;
                        } finally{
                            try {
                                t || null == s.return || s.return();
                            } finally{
                                if (r) throw o;
                            }
                        }
                    }, !1), p(e1, this);
                    console.log("The File APIs are not fully supported in this browser. Cannot create element.");
                }, f.default.prototype.createVideo = function(e1, t) {
                    return f.default._validateParameters("createVideo", arguments), m(this, "video", e1, t);
                }, f.default.prototype.createAudio = function(e1, t) {
                    return f.default._validateParameters("createAudio", arguments), m(this, "audio", e1, t);
                }, f.default.prototype.VIDEO = "video", f.default.prototype.AUDIO = "audio", void 0 === navigator.mediaDevices && (navigator.mediaDevices = {}), void 0 === navigator.mediaDevices.getUserMedia && (navigator.mediaDevices.getUserMedia = function(r) {
                    var o = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
                    return o ? new Promise(function(e1, t) {
                        o.call(navigator, r, e1, t);
                    }) : Promise.reject(new Error("getUserMedia is not implemented in this browser"));
                }), f.default.prototype.createCapture = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    if (f.default._validateParameters("createCapture", t), !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) throw new DOMException("getUserMedia not supported in this browser");
                    for(var o, n = !0, s = !0, i = 0, a = t; i < a.length; i++){
                        var l = a[i];
                        l === f.default.prototype.VIDEO ? s = !1 : l === f.default.prototype.AUDIO ? n = !1 : "object" === h(l) ? u = l : "function" == typeof l && (o = l);
                    }
                    var u = u || {
                        video: n,
                        audio: s
                    }, c = document.createElement("video"), d = (c.setAttribute("playsinline", ""), navigator.mediaDevices.getUserMedia(u).then(function(t) {
                        try {
                            "srcObject" in c ? c.srcObject = t : c.src = window.URL.createObjectURL(t);
                        } catch (e1) {
                            c.src = t;
                        }
                    }, console.log), p(c, this, !0));
                    return d.loadedmetadata = !1, c.addEventListener("loadedmetadata", function() {
                        c.play(), c.width ? (d.width = c.width, d.height = c.height) : (d.width = d.elt.width = c.videoWidth, d.height = d.elt.height = c.videoHeight), d.loadedmetadata = !0, o && o(c.srcObject);
                    }), d;
                }, f.default.prototype.createElement = function(e1, t) {
                    f.default._validateParameters("createElement", arguments);
                    e1 = document.createElement(e1);
                    return void 0 !== t && (e1.innerHTML = t), p(e1, this);
                }, f.default.Element.prototype.addClass = function(e1) {
                    return this.elt.className ? this.hasClass(e1) || (this.elt.className = this.elt.className + " " + e1) : this.elt.className = e1, this;
                }, f.default.Element.prototype.removeClass = function(e1) {
                    return this.elt.classList.remove(e1), this;
                }, f.default.Element.prototype.hasClass = function(e1) {
                    return this.elt.classList.contains(e1);
                }, f.default.Element.prototype.toggleClass = function(e1) {
                    return this.elt.classList.contains(e1) ? this.elt.classList.remove(e1) : this.elt.classList.add(e1), this;
                }, f.default.Element.prototype.child = function(e1) {
                    return void 0 === e1 ? this.elt.childNodes : ("string" == typeof e1 ? ("#" === e1[0] && (e1 = e1.substring(1)), e1 = document.getElementById(e1)) : e1 instanceof f.default.Element && (e1 = e1.elt), e1 instanceof HTMLElement && this.elt.appendChild(e1), this);
                }, f.default.Element.prototype.center = function(e1) {
                    var t = this.elt.style.display, r = "none" === this.elt.style.display, o = "none" === this.parent().style.display, n = {
                        x: this.elt.offsetLeft,
                        y: this.elt.offsetTop
                    }, s = (r && this.show(), o && this.parent().show(), this.elt.style.display = "block", this.position(0, 0), Math.abs(this.parent().offsetWidth - this.elt.offsetWidth)), i = Math.abs(this.parent().offsetHeight - this.elt.offsetHeight);
                    return "both" === e1 || void 0 === e1 ? this.position(s / 2 + this.parent().offsetLeft, i / 2 + this.parent().offsetTop) : "horizontal" === e1 ? this.position(s / 2 + this.parent().offsetLeft, n.y) : "vertical" === e1 && this.position(n.x, i / 2 + this.parent().offsetTop), this.style("display", t), r && this.hide(), o && this.parent().hide(), this;
                }, f.default.Element.prototype.html = function() {
                    return 0 === arguments.length ? this.elt.innerHTML : (arguments.length <= 1 || !arguments[1] ? this.elt.innerHTML = arguments.length <= 0 ? void 0 : arguments[0] : this.elt.insertAdjacentHTML("beforeend", arguments.length <= 0 ? void 0 : arguments[0]), this);
                }, f.default.Element.prototype.position = function() {
                    return 0 === arguments.length ? {
                        x: this.elt.offsetLeft,
                        y: this.elt.offsetTop
                    } : (this.elt.style.position = "static" !== (arguments.length <= 2 ? void 0 : arguments[2]) && "fixed" !== (arguments.length <= 2 ? void 0 : arguments[2]) && "relative" !== (arguments.length <= 2 ? void 0 : arguments[2]) && "sticky" !== (arguments.length <= 2 ? void 0 : arguments[2]) && "initial" !== (arguments.length <= 2 ? void 0 : arguments[2]) && "inherit" !== (arguments.length <= 2 ? void 0 : arguments[2]) ? "absolute" : arguments.length <= 2 ? void 0 : arguments[2], this.elt.style.left = (arguments.length <= 0 ? void 0 : arguments[0]) + "px", this.elt.style.top = (arguments.length <= 1 ? void 0 : arguments[1]) + "px", this.x = arguments.length <= 0 ? void 0 : arguments[0], this.y = arguments.length <= 1 ? void 0 : arguments[1], this);
                }, f.default.Element.prototype._translate = function() {
                    this.elt.style.position = "absolute";
                    var e1 = "";
                    return this.elt.style.transform && (e1 = (e1 = this.elt.style.transform.replace(/translate3d\(.*\)/g, "")).replace(/translate[X-Z]?\(.*\)/g, "")), 2 === arguments.length ? this.elt.style.transform = "translate(" + (arguments.length <= 0 ? void 0 : arguments[0]) + "px, " + (arguments.length <= 1 ? void 0 : arguments[1]) + "px)" : 2 < arguments.length && (this.elt.style.transform = "translate3d(" + (arguments.length <= 0 ? void 0 : arguments[0]) + "px," + (arguments.length <= 1 ? void 0 : arguments[1]) + "px," + (arguments.length <= 2 ? void 0 : arguments[2]) + "px)", this.elt.parentElement.style.perspective = 3 === arguments.length ? "1000px" : (arguments.length <= 3 ? void 0 : arguments[3]) + "px"), this.elt.style.transform += e1, this;
                }, f.default.Element.prototype._rotate = function() {
                    var e1 = "";
                    return this.elt.style.transform && (e1 = (e1 = this.elt.style.transform.replace(/rotate3d\(.*\)/g, "")).replace(/rotate[X-Z]?\(.*\)/g, "")), 1 === arguments.length ? this.elt.style.transform = "rotate(" + (arguments.length <= 0 ? void 0 : arguments[0]) + "deg)" : 2 === arguments.length ? this.elt.style.transform = "rotate(" + (arguments.length <= 0 ? void 0 : arguments[0]) + "deg, " + (arguments.length <= 1 ? void 0 : arguments[1]) + "deg)" : 3 === arguments.length && (this.elt.style.transform = "rotateX(" + (arguments.length <= 0 ? void 0 : arguments[0]) + "deg)", this.elt.style.transform += "rotateY(" + (arguments.length <= 1 ? void 0 : arguments[1]) + "deg)", this.elt.style.transform += "rotateZ(" + (arguments.length <= 2 ? void 0 : arguments[2]) + "deg)"), this.elt.style.transform += e1, this;
                }, f.default.Element.prototype.style = function(e1, t) {
                    if (void 0 === (t = t instanceof f.default.Color ? "rgba(" + t.levels[0] + "," + t.levels[1] + "," + t.levels[2] + "," + t.levels[3] / 255 + ")" : t)) {
                        if (-1 === e1.indexOf(":")) return window.getComputedStyle(this.elt).getPropertyValue(e1);
                        for(var r = e1.split(";"), o = 0; o < r.length; o++){
                            var n = r[o].split(":");
                            n[0] && n[1] && (this.elt.style[n[0].trim()] = n[1].trim());
                        }
                    } else this.elt.style[e1] = t, "width" !== e1 && "height" !== e1 && "left" !== e1 && "top" !== e1 || (t = window.getComputedStyle(this.elt).getPropertyValue(e1).replace(/[^\d.]/g, ""), this[e1] = Math.round(parseFloat(t, 10)));
                    return this;
                }, f.default.Element.prototype.attribute = function(e1, t) {
                    if (null == this.elt.firstChild || "checkbox" !== this.elt.firstChild.type && "radio" !== this.elt.firstChild.type) return void 0 === t ? this.elt.getAttribute(e1) : (this.elt.setAttribute(e1, t), this);
                    if (void 0 === t) return this.elt.firstChild.getAttribute(e1);
                    for(var r = 0; r < this.elt.childNodes.length; r++)this.elt.childNodes[r].setAttribute(e1, t);
                }, f.default.Element.prototype.removeAttribute = function(e1) {
                    if (null != this.elt.firstChild && ("checkbox" === this.elt.firstChild.type || "radio" === this.elt.firstChild.type)) for(var t = 0; t < this.elt.childNodes.length; t++)this.elt.childNodes[t].removeAttribute(e1);
                    return this.elt.removeAttribute(e1), this;
                }, f.default.Element.prototype.value = function() {
                    return 0 < arguments.length ? (this.elt.value = arguments.length <= 0 ? void 0 : arguments[0], this) : "range" === this.elt.type ? parseFloat(this.elt.value) : this.elt.value;
                }, f.default.Element.prototype.show = function() {
                    return this.elt.style.display = "block", this;
                }, f.default.Element.prototype.hide = function() {
                    return this.elt.style.display = "none", this;
                }, f.default.Element.prototype.size = function(e1, t) {
                    if (0 === arguments.length) return {
                        width: this.elt.offsetWidth,
                        height: this.elt.offsetHeight
                    };
                    var r = e1, o = t, n = f.default.prototype.AUTO;
                    if (r !== n || o !== n) {
                        if (r === n ? r = t * this.width / this.height : o === n && (o = e1 * this.height / this.width), this.elt instanceof HTMLCanvasElement) {
                            var s, i = {}, a = this.elt.getContext("2d");
                            for(s in a)i[s] = a[s];
                            for(s in this.elt.setAttribute("width", r * this._pInst._pixelDensity), this.elt.setAttribute("height", o * this._pInst._pixelDensity), this.elt.style.width = r + "px", this.elt.style.height = o + "px", this._pInst.scale(this._pInst._pixelDensity, this._pInst._pixelDensity), i)this.elt.getContext("2d")[s] = i[s];
                        } else this.elt.style.width = r + "px", this.elt.style.height = o + "px", this.elt.width = r, this.elt.height = o;
                        this.width = this.elt.offsetWidth, this.height = this.elt.offsetHeight, this._pInst && this._pInst._curElement && this._pInst._curElement.elt === this.elt && (this._pInst._setProperty("width", this.elt.offsetWidth), this._pInst._setProperty("height", this.elt.offsetHeight));
                    }
                    return this;
                }, f.default.Element.prototype.remove = function() {
                    this instanceof f.default.MediaElement && (this.stop(), null !== (t = this.elt.srcObject) && t.getTracks().forEach(function(e1) {
                        e1.stop();
                    }));
                    var e1, t = this._pInst._elements.indexOf(this);
                    for(e1 in -1 !== t && this._pInst._elements.splice(t, 1), this._events)this.elt.removeEventListener(e1, this._events[e1]);
                    this.elt && this.elt.parentNode && this.elt.parentNode.removeChild(this.elt);
                }, f.default.Element.prototype.drop = function(a, l) {
                    var e1;
                    return window.File && window.FileReader && window.FileList && window.Blob ? (this._dragDisabled || (this._dragDisabled = !0, this.elt.addEventListener("dragover", e1 = function(e1) {
                        e1.preventDefault();
                    }), this.elt.addEventListener("dragleave", e1)), f.default.Element._attachListener("drop", function(e1) {
                        e1.preventDefault(), "function" == typeof l && l.call(this, e1);
                        var e1 = e1.dataTransfer.files, t = !0, r = !1, o = void 0;
                        try {
                            for(var n, s = e1[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                var i = n.value;
                                f.default.File._load(i, a);
                            }
                        } catch (e1) {
                            r = !0, o = e1;
                        } finally{
                            try {
                                t || null == s.return || s.return();
                            } finally{
                                if (r) throw o;
                            }
                        }
                    }, this)) : console.log("The File APIs are not fully supported in this browser."), this;
                }, f.default.Element.prototype.draggable = function(r) {
                    var e1, o = "ontouchstart" in window, n = 0, s = 0, i = 0, a = 0, l = o ? "touchend" : "mouseup", u = o ? "touchmove" : "mousemove";
                    function c(e1) {
                        var t;
                        e1 = e1 || window.event, a = o ? (t = e1.changedTouches, n = i - parseInt(t[0].clientX), s = a - parseInt(t[0].clientY), i = parseInt(t[0].clientX), parseInt(t[0].clientY)) : (n = i - parseInt(e1.clientX), s = a - parseInt(e1.clientY), i = parseInt(e1.clientX), parseInt(e1.clientY)), r.style.left = r.offsetLeft - n + "px", r.style.top = r.offsetTop - s + "px";
                    }
                    function d() {
                        document.removeEventListener(l, d, !1), document.removeEventListener(u, c, !1);
                    }
                    return void 0 === r ? e1 = r = this.elt : r !== this.elt && r.elt !== this.elt && (r = r.elt, e1 = this.elt), e1.addEventListener(o ? "touchstart" : "mousedown", function(e1) {
                        var t;
                        e1 = e1 || window.event, a = o ? (t = e1.changedTouches, i = parseInt(t[0].clientX), parseInt(t[0].clientY)) : (i = parseInt(e1.clientX), parseInt(e1.clientY));
                        return document.addEventListener(l, d, !1), document.addEventListener(u, c, !1), !1;
                    }, !1), e1.style.cursor = "move", this;
                };
                function y(e1, t, r, o) {
                    d(this, y), this.callback = e1, this.time = t, this.id = r, this.val = o;
                }
                t = function(t) {
                    var r = i;
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    r.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: r,
                            writable: !0,
                            configurable: !0
                        }
                    }), t && l(r, t);
                    var s = u(i);
                    function i(o, e1) {
                        d(this, i);
                        var n = c(e1 = s.call(this, o, e1));
                        return e1.elt.crossOrigin = "anonymous", e1._prevTime = 0, e1._cueIDCounter = 0, e1._cues = [], e1.pixels = [], e1._pixelsState = c(e1), e1._pixelDensity = 1, e1._modified = !1, e1._frameOnCanvas = -1, Object.defineProperty(n, "src", {
                            get: function() {
                                var e1 = n.elt.children[0].src, t = n.elt.src === window.location.href ? "" : n.elt.src;
                                return e1 === window.location.href ? t : e1;
                            },
                            set: function(e1) {
                                for(var t = 0; t < n.elt.children.length; t++)n.elt.removeChild(n.elt.children[t]);
                                var r = document.createElement("source");
                                r.src = e1, o.appendChild(r), n.elt.src = e1, n.modified = !0;
                            }
                        }), n._onended = function() {}, n.elt.onended = function() {
                            n._onended(n);
                        }, e1;
                    }
                    return a(i, [
                        {
                            key: "play",
                            value: function() {
                                var e1;
                                return this.elt.currentTime === this.elt.duration && (this.elt.currentTime = 0), 1 < this.elt.readyState || this.elt.load(), (e1 = this.elt.play()) && e1.catch && e1.catch(function(e1) {
                                    "NotAllowedError" === e1.name ? console.error(e1) : console.error("Media play method encountered an unexpected error", e1);
                                }), this;
                            }
                        },
                        {
                            key: "stop",
                            value: function() {
                                return this.elt.pause(), this.elt.currentTime = 0, this;
                            }
                        },
                        {
                            key: "pause",
                            value: function() {
                                return this.elt.pause(), this;
                            }
                        },
                        {
                            key: "loop",
                            value: function() {
                                return this.elt.setAttribute("loop", !0), this.play(), this;
                            }
                        },
                        {
                            key: "noLoop",
                            value: function() {
                                return this.elt.removeAttribute("loop"), this;
                            }
                        },
                        {
                            key: "_setupAutoplayFailDetection",
                            value: function() {
                                var t = setTimeout(function() {
                                    console.error(e);
                                }, 500);
                                this.elt.addEventListener("play", function() {
                                    return clearTimeout(t);
                                }, {
                                    passive: !0,
                                    once: !0
                                });
                            }
                        },
                        {
                            key: "autoplay",
                            value: function(e1) {
                                var t = this, r = this.elt.getAttribute("autoplay");
                                return this.elt.setAttribute("autoplay", e1), e1 && !r && (e1 = function() {
                                    return t._setupAutoplayFailDetection();
                                }, 4 === this.elt.readyState ? e1() : this.elt.addEventListener("canplay", e1, {
                                    passive: !0,
                                    once: !0
                                })), this;
                            }
                        },
                        {
                            key: "volume",
                            value: function(e1) {
                                if (void 0 === e1) return this.elt.volume;
                                this.elt.volume = e1;
                            }
                        },
                        {
                            key: "speed",
                            value: function(e1) {
                                if (void 0 === e1) return this.presetPlaybackRate || this.elt.playbackRate;
                                this.loadedmetadata ? this.elt.playbackRate = e1 : this.presetPlaybackRate = e1;
                            }
                        },
                        {
                            key: "time",
                            value: function(e1) {
                                return void 0 === e1 ? this.elt.currentTime : (this.elt.currentTime = e1, this);
                            }
                        },
                        {
                            key: "duration",
                            value: function() {
                                return this.elt.duration;
                            }
                        },
                        {
                            key: "_ensureCanvas",
                            value: function() {
                                this.canvas || (this.canvas = document.createElement("canvas"), this.drawingContext = this.canvas.getContext("2d"), this.setModified(!0));
                                var e1 = this._frameOnCanvas !== this._pInst.frameCount;
                                this.loadedmetadata && e1 && (this.canvas.width !== this.elt.width && (this.canvas.width = this.elt.width, this.canvas.height = this.elt.height, this.width = this.canvas.width, this.height = this.canvas.height), this.drawingContext.clearRect(0, 0, this.canvas.width, this.canvas.height), this.drawingContext.drawImage(this.elt, 0, 0, this.canvas.width, this.canvas.height), this.setModified(!0), this._frameOnCanvas = this._pInst.frameCount);
                            }
                        },
                        {
                            key: "loadPixels",
                            value: function() {
                                this._ensureCanvas();
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                return f.default.Renderer2D.prototype.loadPixels.apply(this, t);
                            }
                        },
                        {
                            key: "updatePixels",
                            value: function(e1, t, r, o) {
                                return this.loadedmetadata && (this._ensureCanvas(), f.default.Renderer2D.prototype.updatePixels.call(this, e1, t, r, o)), this.setModified(!0), this;
                            }
                        },
                        {
                            key: "get",
                            value: function() {
                                this._ensureCanvas();
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                return f.default.Renderer2D.prototype.get.apply(this, t);
                            }
                        },
                        {
                            key: "_getPixel",
                            value: function() {
                                this.loadPixels();
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                return f.default.Renderer2D.prototype._getPixel.apply(this, t);
                            }
                        },
                        {
                            key: "set",
                            value: function(e1, t, r) {
                                this.loadedmetadata && (this._ensureCanvas(), f.default.Renderer2D.prototype.set.call(this, e1, t, r), this.setModified(!0));
                            }
                        },
                        {
                            key: "copy",
                            value: function() {
                                this._ensureCanvas();
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                f.default.prototype.copy.apply(this, t);
                            }
                        },
                        {
                            key: "mask",
                            value: function() {
                                this.loadPixels(), this.setModified(!0);
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                f.default.Image.prototype.mask.apply(this, t);
                            }
                        },
                        {
                            key: "isModified",
                            value: function() {
                                return this._modified;
                            }
                        },
                        {
                            key: "setModified",
                            value: function(e1) {
                                this._modified = e1;
                            }
                        },
                        {
                            key: "onended",
                            value: function(e1) {
                                return this._onended = e1, this;
                            }
                        },
                        {
                            key: "connect",
                            value: function(e1) {
                                var t, r;
                                if ("function" == typeof f.default.prototype.getAudioContext) t = f.default.prototype.getAudioContext(), r = f.default.soundOut.input;
                                else try {
                                    r = (t = e1.context).destination;
                                } catch (e1) {
                                    throw "connect() is meant to be used with Web Audio API or p5.sound.js";
                                }
                                this.audioSourceNode || (this.audioSourceNode = t.createMediaElementSource(this.elt), this.audioSourceNode.connect(r)), e1 ? e1.input ? this.audioSourceNode.connect(e1.input) : this.audioSourceNode.connect(e1) : this.audioSourceNode.connect(r);
                            }
                        },
                        {
                            key: "disconnect",
                            value: function() {
                                if (!this.audioSourceNode) throw "nothing to disconnect";
                                this.audioSourceNode.disconnect();
                            }
                        },
                        {
                            key: "showControls",
                            value: function() {
                                this.elt.style["text-align"] = "inherit", this.elt.controls = !0;
                            }
                        },
                        {
                            key: "hideControls",
                            value: function() {
                                this.elt.controls = !1;
                            }
                        },
                        {
                            key: "addCue",
                            value: function(e1, t, r) {
                                var o = this._cueIDCounter++, t = new y(t, e1, o, r);
                                return this._cues.push(t), this.elt.ontimeupdate || (this.elt.ontimeupdate = this._onTimeUpdate.bind(this)), o;
                            }
                        },
                        {
                            key: "removeCue",
                            value: function(e1) {
                                for(var t = 0; t < this._cues.length; t++)this._cues[t].id === e1 && (console.log(e1), this._cues.splice(t, 1));
                                0 === this._cues.length && (this.elt.ontimeupdate = null);
                            }
                        },
                        {
                            key: "clearCues",
                            value: function() {
                                this._cues = [], this.elt.ontimeupdate = null;
                            }
                        },
                        {
                            key: "_onTimeUpdate",
                            value: function() {
                                for(var e1 = this.time(), t = 0; t < this._cues.length; t++){
                                    var r = this._cues[t].time, o = this._cues[t].val;
                                    this._prevTime < r && r <= e1 && this._cues[t].callback(o);
                                }
                                this._prevTime = e1;
                            }
                        }
                    ]), i;
                }(f.default.Element), f.default.MediaElement = t, t = function() {
                    function r(e1, t) {
                        d(this, r), this.file = e1, this._pInst = t;
                        t = e1.type.split("/");
                        this.type = t[0], this.subtype = t[1], this.name = e1.name, this.size = e1.size, this.data = void 0;
                    }
                    return a(r, null, [
                        {
                            key: "_createLoader",
                            value: function(o, n) {
                                var e1 = new FileReader;
                                return e1.onload = function(e1) {
                                    var t, r = new f.default.File(o);
                                    "application/json" === r.file.type ? r.data = JSON.parse(e1.target.result) : "text/xml" === r.file.type ? (t = (new DOMParser).parseFromString(e1.target.result, "text/xml"), r.data = new f.default.XML(t.documentElement)) : r.data = e1.target.result, n(r);
                                }, e1;
                            }
                        },
                        {
                            key: "_load",
                            value: function(e1, t) {
                                var r;
                                /^text\//.test(e1.type) || "application/json" === e1.type ? f.default.File._createLoader(e1, t).readAsText(e1) : /^(video|audio)\//.test(e1.type) ? ((r = new f.default.File(e1)).data = URL.createObjectURL(e1), t(r)) : f.default.File._createLoader(e1, t).readAsDataURL(e1);
                            }
                        }
                    ]), r;
                }(), f.default.File = t, t = f.default;
                o.default = t;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.every": 153,
                "core-js/modules/es.array.filter": 155,
                "core-js/modules/es.array.for-each": 157,
                "core-js/modules/es.array.from": 158,
                "core-js/modules/es.array.index-of": 160,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.map": 164,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.array.splice": 167,
                "core-js/modules/es.function.name": 168,
                "core-js/modules/es.object.get-prototype-of": 180,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.promise": 183,
                "core-js/modules/es.reflect.construct": 184,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.string.replace": 196,
                "core-js/modules/es.string.split": 198,
                "core-js/modules/es.string.trim": 201,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/web.dom-collections.for-each": 237,
                "core-js/modules/web.dom-collections.iterator": 238,
                "core-js/modules/web.url": 240
            }
        ],
        292: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (y = e1("../core/main")) && y.__esModule ? y : {
                    default: y
                }, s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                n.default.prototype.deviceOrientation = 1 < window.innerWidth / window.innerHeight ? "landscape" : "portrait", n.default.prototype.accelerationX = 0, n.default.prototype.accelerationY = 0, n.default.prototype.accelerationZ = 0, n.default.prototype.pAccelerationX = 0, n.default.prototype.pAccelerationY = 0, n.default.prototype.pAccelerationZ = 0, n.default.prototype._updatePAccelerations = function() {
                    this._setProperty("pAccelerationX", this.accelerationX), this._setProperty("pAccelerationY", this.accelerationY), this._setProperty("pAccelerationZ", this.accelerationZ);
                }, n.default.prototype.rotationX = 0, n.default.prototype.rotationY = 0, n.default.prototype.rotationZ = 0, n.default.prototype.pRotationX = 0, n.default.prototype.pRotationY = 0;
                var l = n.default.prototype.pRotationZ = 0, u = 0, c = 0, d = "clockwise", h = "clockwise", f = "clockwise", p = (n.default.prototype.pRotateDirectionX = void 0, n.default.prototype.pRotateDirectionY = void 0, n.default.prototype.pRotateDirectionZ = void 0, n.default.prototype._updatePRotations = function() {
                    this._setProperty("pRotationX", this.rotationX), this._setProperty("pRotationY", this.rotationY), this._setProperty("pRotationZ", this.rotationZ);
                }, n.default.prototype.turnAxis = void 0, .5), m = 30, y = (n.default.prototype.setMoveThreshold = function(e1) {
                    n.default._validateParameters("setMoveThreshold", arguments), p = e1;
                }, n.default.prototype.setShakeThreshold = function(e1) {
                    n.default._validateParameters("setShakeThreshold", arguments), m = e1;
                }, n.default.prototype._ondeviceorientation = function(e1) {
                    this._updatePRotations(), this._angleMode === s.radians && (e1.beta = e1.beta * (_PI / 180), e1.gamma = e1.gamma * (_PI / 180), e1.alpha = e1.alpha * (_PI / 180)), this._setProperty("rotationX", e1.beta), this._setProperty("rotationY", e1.gamma), this._setProperty("rotationZ", e1.alpha), this._handleMotion();
                }, n.default.prototype._ondevicemotion = function(e1) {
                    this._updatePAccelerations(), this._setProperty("accelerationX", 2 * e1.acceleration.x), this._setProperty("accelerationY", 2 * e1.acceleration.y), this._setProperty("accelerationZ", 2 * e1.acceleration.z), this._handleMotion();
                }, n.default.prototype._handleMotion = function() {
                    90 === window.orientation || -90 === window.orientation ? this._setProperty("deviceOrientation", "landscape") : 0 === window.orientation ? this._setProperty("deviceOrientation", "portrait") : void 0 === window.orientation && this._setProperty("deviceOrientation", "undefined");
                    var e1, t, r, o, n, s = this._isGlobal ? window : this;
                    "function" == typeof s.deviceMoved && (Math.abs(this.accelerationX - this.pAccelerationX) > p || Math.abs(this.accelerationY - this.pAccelerationY) > p || Math.abs(this.accelerationZ - this.pAccelerationZ) > p) && s.deviceMoved(), "function" == typeof s.deviceTurned && (t = this.rotationX + 180, e1 = this.pRotationX + 180, r = l + 180, 0 < t - e1 && t - e1 < 270 || t - e1 < -270 ? d = "clockwise" : (t - e1 < 0 || 270 < t - e1) && (d = "counter-clockwise"), d !== this.pRotateDirectionX && (r = t), 90 < Math.abs(t - r) && Math.abs(t - r) < 270 && (r = t, this._setProperty("turnAxis", "X"), s.deviceTurned()), this.pRotateDirectionX = d, l = r - 180, e1 = this.rotationY + 180, t = this.pRotationY + 180, r = u + 180, 0 < e1 - t && e1 - t < 270 || e1 - t < -270 ? h = "clockwise" : (e1 - t < 0 || 270 < e1 - this.pRotationY) && (h = "counter-clockwise"), h !== this.pRotateDirectionY && (r = e1), 90 < Math.abs(e1 - r) && Math.abs(e1 - r) < 270 && (r = e1, this._setProperty("turnAxis", "Y"), s.deviceTurned()), this.pRotateDirectionY = h, u = r - 180, 0 < this.rotationZ - this.pRotationZ && this.rotationZ - this.pRotationZ < 270 || this.rotationZ - this.pRotationZ < -270 ? f = "clockwise" : (this.rotationZ - this.pRotationZ < 0 || 270 < this.rotationZ - this.pRotationZ) && (f = "counter-clockwise"), f !== this.pRotateDirectionZ && (c = this.rotationZ), 90 < Math.abs(this.rotationZ - c) && Math.abs(this.rotationZ - c) < 270 && (c = this.rotationZ, this._setProperty("turnAxis", "Z"), s.deviceTurned()), this.pRotateDirectionZ = f, this._setProperty("turnAxis", void 0)), "function" == typeof s.deviceShaken && (null !== this.pAccelerationX && (o = Math.abs(this.accelerationX - this.pAccelerationX), n = Math.abs(this.accelerationY - this.pAccelerationY)), m < o + n && s.deviceShaken());
                }, n.default);
                r.default = y;
            },
            {
                "../core/constants": 264,
                "../core/main": 275,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        293: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var o = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                o.default.prototype.isKeyPressed = !1, o.default.prototype.keyIsPressed = !1, o.default.prototype.key = "", o.default.prototype.keyCode = 0, o.default.prototype._onkeydown = function(e1) {
                    var t;
                    this._downKeys[e1.which] || (this._setProperty("isKeyPressed", !0), this._setProperty("keyIsPressed", !0), this._setProperty("keyCode", e1.which), this._downKeys[e1.which] = !0, this._setProperty("key", e1.key || String.fromCharCode(e1.which) || e1.which), "function" != typeof (t = this._isGlobal ? window : this).keyPressed || e1.charCode || !1 === t.keyPressed(e1) && e1.preventDefault());
                }, o.default.prototype._onkeyup = function(e1) {
                    this._downKeys[e1.which] = !1, this._areDownKeys() || (this._setProperty("isKeyPressed", !1), this._setProperty("keyIsPressed", !1)), this._setProperty("_lastKeyCodeTyped", null), this._setProperty("key", e1.key || String.fromCharCode(e1.which) || e1.which), this._setProperty("keyCode", e1.which);
                    var t = this._isGlobal ? window : this;
                    "function" == typeof t.keyReleased && !1 === t.keyReleased(e1) && e1.preventDefault();
                }, o.default.prototype._onkeypress = function(e1) {
                    var t;
                    e1.which !== this._lastKeyCodeTyped && (this._setProperty("_lastKeyCodeTyped", e1.which), this._setProperty("key", e1.key || String.fromCharCode(e1.which) || e1.which), "function" == typeof (t = this._isGlobal ? window : this).keyTyped && !1 === t.keyTyped(e1) && e1.preventDefault());
                }, o.default.prototype._onblur = function(e1) {
                    this._downKeys = {};
                }, o.default.prototype.keyIsDown = function(e1) {
                    return o.default._validateParameters("keyIsDown", arguments), this._downKeys[e1] || !1;
                }, o.default.prototype._areDownKeys = function() {
                    for(var e1 in this._downKeys)if (this._downKeys.hasOwnProperty(e1) && !0 === this._downKeys[e1]) return !0;
                    return !1;
                };
                e1 = o.default;
                r.default = e1;
            },
            {
                "../core/main": 275
            }
        ],
        294: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.string.includes"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                n.default.prototype.movedX = 0, n.default.prototype.movedY = 0, n.default.prototype._hasMouseInteracted = !1, n.default.prototype.mouseX = 0, n.default.prototype.mouseY = 0, n.default.prototype.pmouseX = 0, n.default.prototype.pmouseY = 0, n.default.prototype.winMouseX = 0, n.default.prototype.winMouseY = 0, n.default.prototype.pwinMouseX = 0, n.default.prototype.pwinMouseY = 0, n.default.prototype.mouseButton = 0, n.default.prototype.mouseIsPressed = !1, n.default.prototype._updateNextMouseCoords = function(e1) {
                    var t, r, o, n, s;
                    null !== this._curElement && (!e1.touches || 0 < e1.touches.length) && (t = this._curElement.elt, r = this.width, o = this.height, (n = e1) && !n.clientX && (n.touches ? n = n.touches[0] : n.changedTouches && (n = n.changedTouches[0])), s = t.getBoundingClientRect(), r = t.scrollWidth / r || 1, t = t.scrollHeight / o || 1, o = {
                        x: (n.clientX - s.left) / r,
                        y: (n.clientY - s.top) / t,
                        winX: n.clientX,
                        winY: n.clientY,
                        id: n.identifier
                    }, this._setProperty("movedX", e1.movementX), this._setProperty("movedY", e1.movementY), this._setProperty("mouseX", o.x), this._setProperty("mouseY", o.y), this._setProperty("winMouseX", o.winX), this._setProperty("winMouseY", o.winY)), this._hasMouseInteracted || (this._updateMouseCoords(), this._setProperty("_hasMouseInteracted", !0));
                }, n.default.prototype._updateMouseCoords = function() {
                    this._setProperty("pmouseX", this.mouseX), this._setProperty("pmouseY", this.mouseY), this._setProperty("pwinMouseX", this.winMouseX), this._setProperty("pwinMouseY", this.winMouseY), this._setProperty("_pmouseWheelDeltaY", this._mouseWheelDeltaY);
                }, n.default.prototype._setMouseButton = function(e1) {
                    1 === e1.button ? this._setProperty("mouseButton", s.CENTER) : 2 === e1.button ? this._setProperty("mouseButton", s.RIGHT) : this._setProperty("mouseButton", s.LEFT);
                }, n.default.prototype._onmousemove = function(e1) {
                    var t = this._isGlobal ? window : this;
                    this._updateNextMouseCoords(e1), this.mouseIsPressed ? "function" == typeof t.mouseDragged ? !1 === t.mouseDragged(e1) && e1.preventDefault() : "function" == typeof t.touchMoved && !1 === t.touchMoved(e1) && e1.preventDefault() : "function" == typeof t.mouseMoved && !1 === t.mouseMoved(e1) && e1.preventDefault();
                }, n.default.prototype._onmousedown = function(e1) {
                    var t = this._isGlobal ? window : this;
                    this._setProperty("mouseIsPressed", !0), this._setMouseButton(e1), this._updateNextMouseCoords(e1), "function" == typeof t.mousePressed ? !1 === t.mousePressed(e1) && e1.preventDefault() : navigator.userAgent.toLowerCase().includes("safari") && "function" == typeof t.touchStarted && !1 === t.touchStarted(e1) && e1.preventDefault();
                }, n.default.prototype._onmouseup = function(e1) {
                    var t = this._isGlobal ? window : this;
                    this._setProperty("mouseIsPressed", !1), "function" == typeof t.mouseReleased ? !1 === t.mouseReleased(e1) && e1.preventDefault() : "function" == typeof t.touchEnded && !1 === t.touchEnded(e1) && e1.preventDefault();
                }, n.default.prototype._ondragend = n.default.prototype._onmouseup, n.default.prototype._ondragover = n.default.prototype._onmousemove, n.default.prototype._onclick = function(e1) {
                    var t = this._isGlobal ? window : this;
                    "function" == typeof t.mouseClicked && !1 === t.mouseClicked(e1) && e1.preventDefault();
                }, n.default.prototype._ondblclick = function(e1) {
                    var t = this._isGlobal ? window : this;
                    "function" == typeof t.doubleClicked && !1 === t.doubleClicked(e1) && e1.preventDefault();
                }, n.default.prototype._mouseWheelDeltaY = 0, n.default.prototype._pmouseWheelDeltaY = 0, n.default.prototype._onwheel = function(e1) {
                    var t = this._isGlobal ? window : this;
                    this._setProperty("_mouseWheelDeltaY", e1.deltaY), "function" == typeof t.mouseWheel && (e1.delta = e1.deltaY, !1 === t.mouseWheel(e1) && e1.preventDefault());
                }, n.default.prototype.requestPointerLock = function() {
                    var e1 = this._curElement.elt;
                    return e1.requestPointerLock = e1.requestPointerLock || e1.mozRequestPointerLock, e1.requestPointerLock ? (e1.requestPointerLock(), !0) : (console.log("requestPointerLock is not implemented in this browser"), !1);
                }, n.default.prototype.exitPointerLock = function() {
                    document.exitPointerLock();
                };
                e1 = n.default;
                r.default = e1;
            },
            {
                "../core/constants": 264,
                "../core/main": 275,
                "core-js/modules/es.array.includes": 159,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.string.includes": 191,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        295: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.string.includes"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype.touches = [], e1.default.prototype._updateTouchCoords = function(e1) {
                    if (null !== this._curElement) {
                        for(var t = [], r = 0; r < e1.touches.length; r++)t[r] = function(e1, t, r, o) {
                            var n = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, s = e1.getBoundingClientRect(), t = e1.scrollWidth / t || 1, e1 = e1.scrollHeight / r || 1, r = o.touches[n] || o.changedTouches[n];
                            return {
                                x: (r.clientX - s.left) / t,
                                y: (r.clientY - s.top) / e1,
                                winX: r.clientX,
                                winY: r.clientY,
                                id: r.identifier
                            };
                        }(this._curElement.elt, this.width, this.height, e1, r);
                        this._setProperty("touches", t);
                    }
                }, e1.default.prototype._ontouchstart = function(e1) {
                    var t = this._isGlobal ? window : this;
                    this._setProperty("mouseIsPressed", !0), this._updateTouchCoords(e1), this._updateNextMouseCoords(e1), this._updateMouseCoords(), "function" == typeof t.touchStarted ? !1 === t.touchStarted(e1) && e1.preventDefault() : navigator.userAgent.toLowerCase().includes("safari") && "function" == typeof t.mousePressed && !1 === t.mousePressed(e1) && e1.preventDefault();
                }, e1.default.prototype._ontouchmove = function(e1) {
                    var t = this._isGlobal ? window : this;
                    this._updateTouchCoords(e1), this._updateNextMouseCoords(e1), "function" == typeof t.touchMoved ? !1 === t.touchMoved(e1) && e1.preventDefault() : "function" == typeof t.mouseDragged && !1 === t.mouseDragged(e1) && e1.preventDefault();
                }, e1.default.prototype._ontouchend = function(e1) {
                    this._setProperty("mouseIsPressed", !1), this._updateTouchCoords(e1), this._updateNextMouseCoords(e1);
                    var t = this._isGlobal ? window : this;
                    "function" == typeof t.touchEnded ? !1 === t.touchEnded(e1) && e1.preventDefault() : "function" == typeof t.mouseReleased && !1 === t.mouseReleased(e1) && e1.preventDefault();
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.includes": 159,
                "core-js/modules/es.string.includes": 191
            }
        ],
        296: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.int32-array"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.int32-array"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var U, N, B, G, V = {
                    _toPixels: function(e1) {
                        var t, r;
                        return e1 instanceof ImageData ? e1.data : e1.getContext("2d") ? e1.getContext("2d").getImageData(0, 0, e1.width, e1.height).data : e1.getContext("webgl") ? (r = (t = e1.getContext("webgl")).drawingBufferWidth * t.drawingBufferHeight * 4, r = new Uint8Array(r), t.readPixels(0, 0, e1.width, e1.height, t.RGBA, t.UNSIGNED_BYTE, r), r) : void 0;
                    },
                    _getARGB: function(e1, t) {
                        t *= 4;
                        return e1[3 + t] << 24 & 4278190080 | e1[t] << 16 & 16711680 | e1[1 + t] << 8 & 65280 | 255 & e1[2 + t];
                    },
                    _setPixels: function(e1, t) {
                        for(var r, o = 0, n = e1.length; o < n; o++)e1[0 + (r = 4 * o)] = (16711680 & t[o]) >>> 16, e1[1 + r] = (65280 & t[o]) >>> 8, e1[2 + r] = 255 & t[o], e1[3 + r] = (4278190080 & t[o]) >>> 24;
                    },
                    _toImageData: function(e1) {
                        return e1 instanceof ImageData ? e1 : e1.getContext("2d").getImageData(0, 0, e1.width, e1.height);
                    },
                    _createImageData: function(e1, t) {
                        return V._tmpCanvas = document.createElement("canvas"), V._tmpCtx = V._tmpCanvas.getContext("2d"), this._tmpCtx.createImageData(e1, t);
                    },
                    apply: function(e1, t, r) {
                        var o = e1.getContext("2d"), n = o.getImageData(0, 0, e1.width, e1.height), t = t(n, r);
                        t instanceof ImageData ? o.putImageData(t, 0, 0, 0, 0, e1.width, e1.height) : o.putImageData(n, 0, 0, 0, 0, e1.width, e1.height);
                    },
                    threshold: function(e1, t) {
                        for(var r = V._toPixels(e1), o = (void 0 === t && (t = .5), Math.floor(255 * t)), n = 0; n < r.length; n += 4){
                            var s = void 0, s = o <= .2126 * r[n] + .7152 * r[n + 1] + .0722 * r[n + 2] ? 255 : 0;
                            r[n] = r[n + 1] = r[n + 2] = s;
                        }
                    },
                    gray: function(e1) {
                        for(var t = V._toPixels(e1), r = 0; r < t.length; r += 4){
                            var o = t[r], n = t[r + 1], s = t[r + 2];
                            t[r] = t[r + 1] = t[r + 2] = .2126 * o + .7152 * n + .0722 * s;
                        }
                    },
                    opaque: function(e1) {
                        for(var t = V._toPixels(e1), r = 0; r < t.length; r += 4)t[r + 3] = 255;
                        return t;
                    },
                    invert: function(e1) {
                        for(var t = V._toPixels(e1), r = 0; r < t.length; r += 4)t[r] = 255 - t[r], t[r + 1] = 255 - t[r + 1], t[r + 2] = 255 - t[r + 2];
                    },
                    posterize: function(e1, t) {
                        var r = V._toPixels(e1);
                        if ((t = void 0 === t ? 4 : t) < 2 || 255 < t) throw new Error("Level must be greater than 2 and less than 255 for posterize");
                        for(var o = t - 1, n = 0; n < r.length; n += 4){
                            var s = r[n], i = r[n + 1], a = r[n + 2];
                            r[n] = 255 * (s * t >> 8) / o, r[n + 1] = 255 * (i * t >> 8) / o, r[n + 2] = 255 * (a * t >> 8) / o;
                        }
                    },
                    dilate: function(e1) {
                        for(var t, r, o, n, s, i, a, l, u, c = V._toPixels(e1), d = 0, h = c.length ? c.length / 4 : 0, f = new Int32Array(h); d < h;)for(r = (t = d) + e1.width; d < r;)n = o = V._getARGB(c, d), (u = d - 1) < t && (u = d), r <= (l = d + 1) && (l = d), (s = d - e1.width) < 0 && (s = 0), h <= (i = d + e1.width) && (i = d), s = V._getARGB(c, s), u = V._getARGB(c, u), i = V._getARGB(c, i), (n = 77 * (n >> 16 & 255) + 151 * (n >> 8 & 255) + 28 * (255 & n)) < (a = 77 * (u >> 16 & 255) + 151 * (u >> 8 & 255) + 28 * (255 & u)) && (o = u, n = a), n < (a = 77 * ((u = V._getARGB(c, l)) >> 16 & 255) + 151 * (u >> 8 & 255) + 28 * (255 & u)) && (o = u, n = a), n < (l = 77 * (s >> 16 & 255) + 151 * (s >> 8 & 255) + 28 * (255 & s)) && (o = s, n = l), n < (u = 77 * (i >> 16 & 255) + 151 * (i >> 8 & 255) + 28 * (255 & i)) && (o = i, n = u), f[d++] = o;
                        V._setPixels(c, f);
                    },
                    erode: function(e1) {
                        for(var t, r, o, n, s, i, a, l, u, c = V._toPixels(e1), d = 0, h = c.length ? c.length / 4 : 0, f = new Int32Array(h); d < h;)for(r = (t = d) + e1.width; d < r;)n = o = V._getARGB(c, d), (u = d - 1) < t && (u = d), r <= (l = d + 1) && (l = d), (s = d - e1.width) < 0 && (s = 0), h <= (i = d + e1.width) && (i = d), s = V._getARGB(c, s), u = V._getARGB(c, u), i = V._getARGB(c, i), (a = 77 * (u >> 16 & 255) + 151 * (u >> 8 & 255) + 28 * (255 & u)) < (n = 77 * (n >> 16 & 255) + 151 * (n >> 8 & 255) + 28 * (255 & n)) && (o = u, n = a), (a = 77 * ((u = V._getARGB(c, l)) >> 16 & 255) + 151 * (u >> 8 & 255) + 28 * (255 & u)) < n && (o = u, n = a), (l = 77 * (s >> 16 & 255) + 151 * (s >> 8 & 255) + 28 * (255 & s)) < n && (o = s, n = l), (u = 77 * (i >> 16 & 255) + 151 * (i >> 8 & 255) + 28 * (255 & i)) < n && (o = i, n = u), f[d++] = o;
                        V._setPixels(c, f);
                    },
                    blur: function(e1, D) {
                        for(var t, r, o, n, s, i, a, l, u, c, d = V._toPixels(e1), h = e1.width, f = e1.height, p = h * f, m = new Int32Array(p), y = 0; y < p; y++)m[y] = V._getARGB(d, y);
                        var g, v, b, j, _, x, w, S, T = new Int32Array(p), M = new Int32Array(p), E = new Int32Array(p), F = new Int32Array(p), k = 0, C = 3.5 * D | 0;
                        if (U !== (C = C < 1 ? 1 : C < 248 ? C : 248)) {
                            N = 1 + (U = C) << 1, B = new Int32Array(N), G = new Array(N);
                            for(var O = 0; O < N; O++)G[O] = new Int32Array(256);
                            for(var P = 1, A = C - 1; P < C; P++){
                                B[C + P] = B[A] = x = A * A, w = G[C + P], S = G[A--];
                                for(var L = 0; L < 256; L++)w[L] = S[L] = x * L;
                            }
                            _ = B[C] = C * C, w = G[C];
                            for(var R = 0; R < 256; R++)w[R] = _ * R;
                        }
                        for(v = 0; v < f; v++){
                            for(g = 0; g < h; g++){
                                if (n = o = r = s = t = 0, (i = g - U) < 0) c = -i, i = 0;
                                else {
                                    if (h <= i) break;
                                    c = 0;
                                }
                                for(b = c; b < N && !(h <= i); b++){
                                    var I = m[i + k];
                                    j = G[b], s += j[(-16777216 & I) >>> 24], r += j[(16711680 & I) >> 16], o += j[(65280 & I) >> 8], n += j[255 & I], t += B[b], i++;
                                }
                                T[a = k + g] = s / t, M[a] = r / t, E[a] = o / t, F[a] = n / t;
                            }
                            k += h;
                        }
                        for(u = (l = -U) * h, v = k = 0; v < f; v++){
                            for(g = 0; g < h; g++){
                                if (n = o = r = s = t = 0, l < 0) c = a = -l, i = g;
                                else {
                                    if (f <= l) break;
                                    c = 0, a = l, i = g + u;
                                }
                                for(b = c; b < N && !(f <= a); b++)j = G[b], s += j[T[i]], r += j[M[i]], o += j[E[i]], n += j[F[i]], t += B[b], a++, i += h;
                                m[g + k] = s / t << 24 | r / t << 16 | o / t << 8 | n / t;
                            }
                            k += h, u += h, l++;
                        }
                        V._setPixels(d, m);
                    }
                };
                r.default = V;
            },
            {
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.typed-array.copy-within": 205,
                "core-js/modules/es.typed-array.every": 206,
                "core-js/modules/es.typed-array.fill": 207,
                "core-js/modules/es.typed-array.filter": 208,
                "core-js/modules/es.typed-array.find": 210,
                "core-js/modules/es.typed-array.find-index": 209,
                "core-js/modules/es.typed-array.for-each": 213,
                "core-js/modules/es.typed-array.includes": 214,
                "core-js/modules/es.typed-array.index-of": 215,
                "core-js/modules/es.typed-array.int32-array": 217,
                "core-js/modules/es.typed-array.iterator": 218,
                "core-js/modules/es.typed-array.join": 219,
                "core-js/modules/es.typed-array.last-index-of": 220,
                "core-js/modules/es.typed-array.map": 221,
                "core-js/modules/es.typed-array.reduce": 223,
                "core-js/modules/es.typed-array.reduce-right": 222,
                "core-js/modules/es.typed-array.reverse": 224,
                "core-js/modules/es.typed-array.set": 225,
                "core-js/modules/es.typed-array.slice": 226,
                "core-js/modules/es.typed-array.some": 227,
                "core-js/modules/es.typed-array.sort": 228,
                "core-js/modules/es.typed-array.subarray": 229,
                "core-js/modules/es.typed-array.to-locale-string": 230,
                "core-js/modules/es.typed-array.to-string": 231,
                "core-js/modules/es.typed-array.uint8-array": 234
            }
        ],
        297: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var C = o(e1("../core/main")), O = o(e1("omggif"));
                function o(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function P(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                C.default.prototype.createImage = function(e1, t) {
                    return C.default._validateParameters("createImage", arguments), new C.default.Image(e1, t);
                }, C.default.prototype.saveCanvas = function() {
                    C.default._validateParameters("saveCanvas", arguments);
                    var e1, t, r, o, n, s, i = [].slice.call(arguments);
                    switch(arguments[0] instanceof HTMLCanvasElement ? (e1 = arguments[0], i.shift()) : arguments[0] instanceof C.default.Element ? (e1 = arguments[0].elt, i.shift()) : arguments[0] instanceof C.default.Framebuffer ? ((n = this.createGraphics((o = arguments[0]).width, o.height)).pixelDensity(pixelDensity()), o.loadPixels(), n.loadPixels(), n.pixels.set(o.pixels), n.updatePixels(), e1 = n.elt, i.shift()) : e1 = this._curElement && this._curElement.elt, 1 <= i.length && (t = i[0]), r = (r = 2 <= i.length ? i[1] : r) || C.default.prototype._checkFileExtension(t, r)[1] || "png"){
                        default:
                            s = "image/png";
                            break;
                        case "jpeg":
                        case "jpg":
                            s = "image/jpeg";
                    }
                    e1.toBlob(function(e1) {
                        C.default.prototype.downloadFile(e1, t, r), n && n.remove();
                    }, s);
                }, C.default.prototype.encodeAndDownloadGif = function(d, e1) {
                    for(var h = d.gifProperties, t = h.loopLimit, r = (1 === t ? t = null : null === t && (t = 0), new Uint8Array(d.width * d.height * h.numFrames)), f = [], o = {}, n = 0; n < h.numFrames; n++){
                        for(var s = new Set, i = h.frames[n].image.data, a = i.length, l = new Uint32Array(d.width * d.height), u = 0, c = 0; u < a; u += 4, c++){
                            var p = i[u + 0] << 16 | i[u + 1] << 8 | i[u + 2] << 0;
                            s.add(p), l[c] = p;
                        }
                        var m = P(s).sort().toString();
                        void 0 === o[m] ? o[m] = {
                            freq: 1,
                            frames: [
                                n
                            ]
                        } : (o[m].freq += 1, o[m].frames.push(n)), f.push(l);
                    }
                    for(var y = [], g = Object.keys(o).sort(function(e1, t) {
                        return o[t].freq - o[e1].freq;
                    }), v = g[0].split(",").map(function(e1) {
                        return parseInt(e1);
                    }), y = y.concat(o[v].frames), b = new Set(v), j = 1; j < g.length; j++){
                        var _ = g[j].split(",").map(function(e1) {
                            return parseInt(e1);
                        }).filter(function(e1) {
                            return !b.has(e1);
                        });
                        if (v.length + _.length <= 256) {
                            for(var x = 0; x < _.length; x++)v.push(_[x]), b.add(_[x]);
                            y = y.concat(o[g[j]].frames);
                        }
                    }
                    y = new Set(y);
                    for(var w = {}, S = 0; S < v.length; S++)w[v[S]] || (w[v[S]] = S);
                    for(var T = 1; T < v.length;)T <<= 1;
                    v.length = T;
                    for(var t = {
                        loop: t,
                        palette: new Uint32Array(v)
                    }, M = new O.default.GifWriter(r, d.width, d.height, t), E = {}, k = 0; k < h.numFrames; k++)!function(r) {
                        var o = !y.has(r), n = o ? [] : v, s = new Uint8Array(d.width * d.height), i = {}, a = new Set, e1 = (f[r].forEach(function(e1, t) {
                            o ? (void 0 === i[e1] && (i[e1] = n.length, n.push(e1)), s[t] = i[e1]) : s[t] = w[e1], 0 < r && f[r - 1][t] !== e1 && a.add(e1);
                        }), {}), t = n.filter(function(e1) {
                            return !a.has(e1);
                        });
                        if (0 < t.length) {
                            var t = t[0], l = (o ? i : w)[t];
                            if (0 < r) {
                                for(var u = 0; u < f[r].length; u++)f[r - 1][u] === f[r][u] && (s[u] = l);
                                e1.transparent = l, E.frameOpts.disposal = 1;
                            }
                        }
                        if (e1.delay = h.frames[r].delay / 10, o) {
                            for(var c = 1; c < n.length;)c <<= 1;
                            n.length = c, e1.palette = new Uint32Array(n);
                        }
                        0 < r && M.addFrame(0, 0, d.width, d.height, E.pixelPaletteIndex, E.frameOpts), E = {
                            pixelPaletteIndex: s,
                            frameOpts: e1
                        };
                    }(k);
                    E.frameOpts.disposal = 1, M.addFrame(0, 0, d.width, d.height, E.pixelPaletteIndex, E.frameOpts);
                    t = new Blob([
                        r.slice(0, M.end())
                    ], {
                        type: "image/gif"
                    });
                    C.default.prototype.downloadFile(t, e1, "gif");
                }, C.default.prototype.saveFrames = function(e1, t, r, o, n) {
                    C.default._validateParameters("saveFrames", arguments);
                    r = C.default.prototype.constrain(r = r || 3, 0, 15);
                    r *= 1e3;
                    var o = C.default.prototype.constrain(o || 15, 0, 22), s = 0, i = C.default.prototype._makeFrame, a = this._curElement.elt, l = [], u = setInterval(function() {
                        l.push(i(e1 + s, t, a)), s++;
                    }, 1e3 / o);
                    setTimeout(function() {
                        if (clearInterval(u), n) n(l);
                        else for(var e1 = 0, t = l; e1 < t.length; e1++){
                            var r = t[e1];
                            C.default.prototype.downloadFile(r.imageData, r.filename, r.ext);
                        }
                        l = [];
                    }, .01 + r);
                }, C.default.prototype._makeFrame = function(e1, t, r) {
                    var o, r = this ? this._curElement.elt : r;
                    if (t) switch(t.toLowerCase()){
                        case "png":
                            o = "image/png";
                            break;
                        case "jpeg":
                        case "jpg":
                            o = "image/jpeg";
                            break;
                        default:
                            o = "image/png";
                    }
                    else t = "png", o = "image/png";
                    var r = (r = r.toDataURL(o)).replace(o, "image/octet-stream"), n = {};
                    return n.imageData = r, n.filename = e1, n.ext = t, n;
                };
                e1 = C.default;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.filter": 155,
                "core-js/modules/es.array.for-each": 157,
                "core-js/modules/es.array.from": 158,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.map": 164,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.object.keys": 181,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.set": 189,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.string.replace": 196,
                "core-js/modules/es.string.split": 198,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.typed-array.copy-within": 205,
                "core-js/modules/es.typed-array.every": 206,
                "core-js/modules/es.typed-array.fill": 207,
                "core-js/modules/es.typed-array.filter": 208,
                "core-js/modules/es.typed-array.find": 210,
                "core-js/modules/es.typed-array.find-index": 209,
                "core-js/modules/es.typed-array.for-each": 213,
                "core-js/modules/es.typed-array.includes": 214,
                "core-js/modules/es.typed-array.index-of": 215,
                "core-js/modules/es.typed-array.iterator": 218,
                "core-js/modules/es.typed-array.join": 219,
                "core-js/modules/es.typed-array.last-index-of": 220,
                "core-js/modules/es.typed-array.map": 221,
                "core-js/modules/es.typed-array.reduce": 223,
                "core-js/modules/es.typed-array.reduce-right": 222,
                "core-js/modules/es.typed-array.reverse": 224,
                "core-js/modules/es.typed-array.set": 225,
                "core-js/modules/es.typed-array.slice": 226,
                "core-js/modules/es.typed-array.some": 227,
                "core-js/modules/es.typed-array.sort": 228,
                "core-js/modules/es.typed-array.subarray": 229,
                "core-js/modules/es.typed-array.to-locale-string": 230,
                "core-js/modules/es.typed-array.to-string": 231,
                "core-js/modules/es.typed-array.uint32-array": 233,
                "core-js/modules/es.typed-array.uint8-array": 234,
                "core-js/modules/web.dom-collections.for-each": 237,
                "core-js/modules/web.dom-collections.iterator": 238,
                omggif: 248
            }
        ],
        298: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.copy-within"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint8-clamped-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.copy-within"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint8-clamped-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0, e1("regenerator-runtime/runtime");
                var O = n(e1("../core/main")), m = n(e1("../core/helpers")), j = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants")), g = n(e1("omggif")), P = e1("gifenc");
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function n(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function l(e1, t, r, o, n, s, i) {
                    try {
                        var a = e1[s](i), l = a.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    a.done ? t(l) : Promise.resolve(l).then(o, n);
                }
                function y(e1, t, r, o, n, s, i, a, l, u, c) {
                    var d, h, f, p, m, y, g, v, b;
                    return e1 === j.COVER && (d = t, f = r, g = s, v = i, y = a, b = l, h = u, p = c, m = Math.max(g / h, v / p), g /= m, v /= m, m = y, y = b, d === j.CENTER ? m += (h - g) / 2 : d === j.RIGHT && (m += h - g), f === j.CENTER ? y += (p - v) / 2 : f === j.BOTTOM && (y += p - v), a = (b = {
                        x: m,
                        y: y,
                        w: g,
                        h: v
                    }).x, l = b.y, u = b.w, c = b.h), e1 === j.CONTAIN && (d = t, h = r, f = o, p = n, m = s, y = i, g = u, v = c, b = Math.max(g / m, v / y), g /= b, v /= b, b = f, f = p, d === j.CENTER ? b += (m - g) / 2 : d === j.RIGHT && (b += m - g), h === j.CENTER ? f += (y - v) / 2 : h === j.BOTTOM && (f += y - v), o = (e1 = {
                        x: b,
                        y: f,
                        w: g,
                        h: v
                    }).x, n = e1.y, s = e1.w, i = e1.h), {
                        sx: a,
                        sy: l,
                        sw: u,
                        sh: c,
                        dx: o,
                        dy: n,
                        dw: s,
                        dh: i
                    };
                }
                function v(e1, t) {
                    return 0 < e1 && e1 < t ? e1 : t;
                }
                e1("../core/friendly_errors/validate_params"), e1("../core/friendly_errors/file_errors"), e1("../core/friendly_errors/fes_core"), O.default.prototype.loadImage = function(o, f, p) {
                    O.default._validateParameters("loadImage", arguments);
                    var m = new O.default.Image(1, 1, this), y = this, e1 = new Request(o, {
                        method: "GET",
                        mode: "cors"
                    });
                    return fetch(o, e1).then(function(e1) {
                        var t, r = e1.headers.get("content-type");
                        null === r && console.warn("The image you loaded does not have a Content-Type header. If you are using the online editor consider reuploading the asset."), r && r.includes("image/gif") ? e1.arrayBuffer().then(function(e1) {
                            if (e1) {
                                for(var e1 = new Uint8Array(e1), r = m, t = f, o = p, n = (function(e1) {
                                    y._decrementPreload();
                                }).bind(y), s = new g.default.GifReader(e1), i = (r.width = r.canvas.width = s.width, r.height = r.canvas.height = s.height, []), a = s.numFrames(), l = new Uint8ClampedArray(r.width * r.height * 4), u = 0; u < a; u++){
                                    var c = s.frameInfo(u), d = r.drawingContext.getImageData(0, 0, r.width, r.height), h = (l = d.data.slice(), !function(e1, t) {
                                        try {
                                            t.decodeAndBlitFrameRGBA(e1, l);
                                        } catch (e1) {
                                            O.default._friendlyFileLoadError(8, r.src), "function" == typeof o ? o(e1) : console.error(e1);
                                        }
                                    }(u, s), new ImageData(l, r.width, r.height)), h = (r.drawingContext.putImageData(h, 0, 0), c.delay);
                                    0 === h && (h = 10), i.push({
                                        image: r.drawingContext.getImageData(0, 0, r.width, r.height),
                                        delay: 10 * h
                                    }), 2 === c.disposal ? r.drawingContext.clearRect(c.x, c.y, c.width, c.height) : 3 === c.disposal && r.drawingContext.putImageData(d, 0, 0, c.x, c.y, c.width, c.height);
                                }
                                null === (e1 = s.loopCount()) ? e1 = 1 : 0 === e1 && (e1 = null), r.drawingContext.putImageData(i[0].image, 0, 0), 1 < i.length && (r.gifProperties = {
                                    displayIndex: 0,
                                    loopLimit: e1,
                                    loopCount: 0,
                                    frames: i,
                                    numFrames: a,
                                    playing: !0,
                                    timeDisplayed: 0,
                                    lastChangeTime: 0
                                }), "function" == typeof t && t(r), n();
                            }
                        }, function(e1) {
                            "function" == typeof p ? (p(e1), y._decrementPreload()) : console.error(e1);
                        }) : ((t = new Image).onload = function() {
                            m.width = m.canvas.width = t.width, m.height = m.canvas.height = t.height, m.drawingContext.drawImage(t, 0, 0), m.modified = !0, "function" == typeof f && f(m), y._decrementPreload();
                        }, t.onerror = function(e1) {
                            O.default._friendlyFileLoadError(0, t.src), "function" == typeof p ? (p(e1), y._decrementPreload()) : console.error(e1);
                        }, 0 !== o.indexOf("data:image/") && (t.crossOrigin = "Anonymous"), t.src = o), m.modified = !0;
                    }).catch(function(e1) {
                        O.default._friendlyFileLoadError(0, o), "function" == typeof p ? (p(e1), y._decrementPreload()) : console.error(e1);
                    }), m;
                }, O.default.prototype.saveGif = function() {
                    a = regeneratorRuntime.mark(function e1(t, r) {
                        var o, n, s, i, a, l, u, c, d, h, f, p, m, y, g, v, b, j, _, x, w, S, T, M, E, k, C = arguments;
                        return regeneratorRuntime.wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = 2 < C.length && void 0 !== C[2] ? C[2] : {
                                        delay: 0,
                                        units: "seconds",
                                        silent: !1,
                                        notificationDuration: 0,
                                        notificationID: "progressBar"
                                    }, "string" != typeof t) throw TypeError("fileName parameter must be a string");
                                    e1.next = 3;
                                    break;
                                case 3:
                                    if ("number" != typeof r) throw TypeError("Duration parameter must be a number");
                                    e1.next = 5;
                                    break;
                                case 5:
                                    if (n = o && o.delay || 0, s = o && o.units || "seconds", i = o && o.silent || !1, a = o && o.notificationDuration || 0, l = o && o.notificationID || "progressBar", "number" != typeof n) throw TypeError("Delay parameter must be a number");
                                    e1.next = 12;
                                    break;
                                case 12:
                                    if ("seconds" !== s && "frames" !== s) throw TypeError('Units parameter must be either "frames" or "seconds"');
                                    e1.next = 14;
                                    break;
                                case 14:
                                    if ("boolean" != typeof i) throw TypeError("Silent parameter must be a boolean");
                                    e1.next = 16;
                                    break;
                                case 16:
                                    if ("number" != typeof a) throw TypeError("Notification duration parameter must be a number");
                                    e1.next = 18;
                                    break;
                                case 18:
                                    if ("string" != typeof l) throw TypeError("Notification ID parameter must be a string");
                                    e1.next = 20;
                                    break;
                                case 20:
                                    return this._recording = !0, h = this._targetFrameRate, u = (u = 1 / (h = h !== 1 / 0 && void 0 !== h && 0 !== h ? h : 60) * 1e3) < 20 ? 20 : u, d = (c = "seconds" === s ? r * h : r) + (h = "seconds" === s ? n * h : n), h, this.frameCount = h, f = this._pixelDensity, this.pixelDensity(1), p = [], null !== document.getElementById(l) && document.getElementById(l).remove(), i || ((m = this.createP("")).id(l), m.style("font-size", "16px"), m.style("font-family", "Montserrat"), m.style("background-color", "#ffffffa0"), m.style("padding", "8px"), m.style("border-radius", "10px"), m.position(0, 0)), this._renderer instanceof O.default.RendererGL && (g = this.drawingContext, y = new Uint8Array(g.drawingBufferWidth * g.drawingBufferHeight * 4)), this.noLoop(), e1.next = 39, Promise.resolve();
                                case 39:
                                    if (h < d) return this.redraw(), M = void 0, M = this._renderer instanceof O.default.RendererGL ? (y = new Uint8Array(g.drawingBufferWidth * g.drawingBufferHeight * 4), g.readPixels(0, 0, g.drawingBufferWidth, g.drawingBufferHeight, g.RGBA, g.UNSIGNED_BYTE, y), function(e1) {
                                        for(var t = parseInt(height / 2), r = 4 * width, o = new Uint8Array(4 * width), n = 0; n < t; ++n){
                                            var s = n * r, i = (height - n - 1) * r;
                                            o.set(e1.subarray(s, s + r)), e1.copyWithin(s, i, i + r), e1.set(o, i);
                                        }
                                        return e1;
                                    }(y)) : this.drawingContext.getImageData(0, 0, this.width, this.height).data, p.push(M), h++, i || m.html("Saved frame <b>" + p.length.toString() + "</b> out of " + c.toString()), e1.next = 48, new Promise(function(e1) {
                                        return setTimeout(e1, 0);
                                    });
                                    e1.next = 50;
                                    break;
                                case 48:
                                    e1.next = 39;
                                    break;
                                case 50:
                                    i || m.html("Frames processed, generating color palette..."), this.loop(), this.pixelDensity(f), v = (0, P.GIFEncoder)(), b = function(e1) {
                                        for(var t = new Uint8Array(e1.length * e1[0].length), r = 0; r < e1.length; r++)t.set(e1[r], r * e1[0].length);
                                        var o = (0, P.quantize)(t, 256, {
                                            format: "rgba4444",
                                            oneBitAlpha: !0
                                        });
                                        256 === o.length ? o[o.length - 1] = [
                                            255 * Math.random(),
                                            255 * Math.random(),
                                            255 * Math.random(),
                                            0
                                        ] : o.push([
                                            255 * Math.random(),
                                            255 * Math.random(),
                                            255 * Math.random(),
                                            0
                                        ]);
                                        return o;
                                    }(p), j = {}, _ = function(e1) {
                                        for(var t = e1.length / 4, r = new Uint8Array(t), o = 0; o < t; o++){
                                            var n = e1[4 * o] << 24 | e1[4 * o + 1] << 16 | e1[4 * o + 2] << 8 | e1[4 * o + 3];
                                            void 0 === j[n] && (j[n] = (0, P.nearestColorIndex)(b, e1.slice(4 * o, 4 * (o + 1)))), r[o] = j[n];
                                        }
                                        return r;
                                    }, x = b.length - 1, w = [], S = 0;
                                case 60:
                                    if (!(S < p.length)) {
                                        e1.next = 71;
                                        break;
                                    }
                                    if (T = _(p[S]), M = T.slice(), 0 === S) v.writeFrame(T, this.width, this.height, {
                                        palette: b,
                                        delay: u,
                                        dispose: 1
                                    });
                                    else {
                                        for(E = 0; E < T.length; E++)T[E] === w[E] && (T[E] = x);
                                        v.writeFrame(T, this.width, this.height, {
                                            delay: u,
                                            transparent: !0,
                                            transparentIndex: x,
                                            dispose: 1
                                        });
                                    }
                                    return w = M, i || m.html("Rendered frame <b>" + S.toString() + "</b> out of " + c.toString()), e1.next = 68, new Promise(function(e1) {
                                        return setTimeout(e1, 0);
                                    });
                                case 68:
                                    S++, e1.next = 60;
                                    break;
                                case 71:
                                    v.finish(), k = v.bytesView(), k = new Blob([
                                        k
                                    ], {
                                        type: "image/gif"
                                    }), p = [], this._recording = !1, this.loop(), i || (m.html("Done. Downloading your gif!\uD83C\uDF38"), 0 < a && setTimeout(function() {
                                        return m.remove();
                                    }, 1e3 * a)), O.default.prototype.downloadFile(k, t, "gif");
                                case 80:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, this);
                    });
                    var a, r = function() {
                        var e1 = this, i = arguments;
                        return new Promise(function(t, r) {
                            var o = a.apply(e1, i);
                            function n(e1) {
                                l(o, t, r, n, s, "next", e1);
                            }
                            function s(e1) {
                                l(o, t, r, n, s, "throw", e1);
                            }
                            n(void 0);
                        });
                    };
                    return function(e1, t) {
                        return r.apply(this, arguments);
                    };
                }(), O.default.prototype.image = function(e1, t, r, o, n, s, i, a, l, u, c, d) {
                    O.default._validateParameters("image", arguments);
                    var h = e1.width, f = e1.height, p = (d = d || j.CENTER, c = c || j.CENTER, e1.elt && (h = void 0 !== h ? h : e1.elt.width, f = void 0 !== f ? f : e1.elt.height), e1.elt && e1.elt.videoWidth && !e1.canvas && (h = void 0 !== h ? h : e1.elt.videoWidth, f = void 0 !== f ? f : e1.elt.videoHeight), o || h), n = n || f, s = s || 0, i = i || 0, a = v(void 0 !== a ? a : h, h), h = v(void 0 !== l ? l : f, f), l = 1;
                    e1.elt && !e1.canvas && e1.elt.style.width && (l = e1.elt.videoWidth && !o ? e1.elt.videoWidth : e1.elt.width, l /= parseInt(e1.elt.style.width, 10)), s *= l, i *= l, h *= l, a *= l;
                    f = y(u, c, d, (f = m.default.modeAdjust(t, r, p, n, this._renderer._imageMode)).x, f.y, f.w, f.h, s, i, a, h);
                    this._renderer.image(e1, f.sx, f.sy, f.sw, f.sh, f.dx, f.dy, f.dw, f.dh);
                }, O.default.prototype.tint = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    O.default._validateParameters("tint", t);
                    var o = this.color.apply(this, t);
                    this._renderer._tint = o.levels;
                }, O.default.prototype.noTint = function() {
                    this._renderer._tint = null;
                }, O.default.prototype._getTintedImageCanvas = O.default.Renderer2D.prototype._getTintedImageCanvas, O.default.prototype.imageMode = function(e1) {
                    O.default._validateParameters("imageMode", arguments), e1 !== j.CORNER && e1 !== j.CORNERS && e1 !== j.CENTER || (this._renderer._imageMode = e1);
                };
                e1 = O.default;
                r.default = e1;
            },
            {
                "../core/constants": 264,
                "../core/friendly_errors/fes_core": 266,
                "../core/friendly_errors/file_errors": 267,
                "../core/friendly_errors/validate_params": 270,
                "../core/helpers": 271,
                "../core/main": 275,
                "core-js/modules/es.array.copy-within": 152,
                "core-js/modules/es.array.includes": 159,
                "core-js/modules/es.array.index-of": 160,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.promise": 183,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.includes": 191,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.typed-array.copy-within": 205,
                "core-js/modules/es.typed-array.every": 206,
                "core-js/modules/es.typed-array.fill": 207,
                "core-js/modules/es.typed-array.filter": 208,
                "core-js/modules/es.typed-array.find": 210,
                "core-js/modules/es.typed-array.find-index": 209,
                "core-js/modules/es.typed-array.for-each": 213,
                "core-js/modules/es.typed-array.includes": 214,
                "core-js/modules/es.typed-array.index-of": 215,
                "core-js/modules/es.typed-array.iterator": 218,
                "core-js/modules/es.typed-array.join": 219,
                "core-js/modules/es.typed-array.last-index-of": 220,
                "core-js/modules/es.typed-array.map": 221,
                "core-js/modules/es.typed-array.reduce": 223,
                "core-js/modules/es.typed-array.reduce-right": 222,
                "core-js/modules/es.typed-array.reverse": 224,
                "core-js/modules/es.typed-array.set": 225,
                "core-js/modules/es.typed-array.slice": 226,
                "core-js/modules/es.typed-array.some": 227,
                "core-js/modules/es.typed-array.sort": 228,
                "core-js/modules/es.typed-array.subarray": 229,
                "core-js/modules/es.typed-array.to-locale-string": 230,
                "core-js/modules/es.typed-array.to-string": 231,
                "core-js/modules/es.typed-array.uint8-array": 234,
                "core-js/modules/es.typed-array.uint8-clamped-array": 235,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238,
                gifenc: 245,
                omggif: 248,
                "regenerator-runtime/runtime": 252
            }
        ],
        299: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = o(e1("../core/main")), n = o(e1("./filters"));
                function o(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function i(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                s.default.Image = function() {
                    function r(e1, t) {
                        if (!(this instanceof r)) throw new TypeError("Cannot call a class as a function");
                        this.width = e1, this.height = t, this.canvas = document.createElement("canvas"), this.canvas.width = this.width, this.canvas.height = this.height, this.drawingContext = this.canvas.getContext("2d"), (this._pixelsState = this)._pixelDensity = 1, this.gifProperties = null, this._modified = !1, this.pixels = [];
                    }
                    var e1, t, o;
                    return e1 = r, t = [
                        {
                            key: "pixelDensity",
                            value: function(e1) {
                                return void 0 !== e1 ? (e1 <= 0 && (s.default._friendlyParamError({
                                    type: "INVALID_VALUE",
                                    format: {
                                        types: [
                                            "Number"
                                        ]
                                    },
                                    position: 1
                                }, "pixelDensity"), e1 = 1), this._pixelDensity = e1, this.width /= e1, this.height /= e1, this) : this._pixelDensity;
                            }
                        },
                        {
                            key: "_animateGif",
                            value: function(e1) {
                                var t, r = this.gifProperties, e1 = e1._lastRealFrameTime;
                                0 === r.lastChangeTime && (r.lastChangeTime = e1), r.playing && (r.timeDisplayed = e1 - r.lastChangeTime, t = r.frames[r.displayIndex].delay, r.timeDisplayed >= t && (t = Math.floor(r.timeDisplayed / t), r.timeDisplayed = 0, r.lastChangeTime = e1, r.displayIndex += t, r.loopCount = Math.floor(r.displayIndex / r.numFrames), null !== r.loopLimit && r.loopCount >= r.loopLimit ? r.playing = !1 : (e1 = r.displayIndex % r.numFrames, this.drawingContext.putImageData(r.frames[e1].image, 0, 0), r.displayIndex = e1, this.setModified(!0))));
                            }
                        },
                        {
                            key: "_setProperty",
                            value: function(e1, t) {
                                this[e1] = t, this.setModified(!0);
                            }
                        },
                        {
                            key: "loadPixels",
                            value: function() {
                                s.default.Renderer2D.prototype.loadPixels.call(this), this.setModified(!0);
                            }
                        },
                        {
                            key: "updatePixels",
                            value: function(e1, t, r, o) {
                                s.default.Renderer2D.prototype.updatePixels.call(this, e1, t, r, o), this.setModified(!0);
                            }
                        },
                        {
                            key: "get",
                            value: function(e1, t, r, o) {
                                return s.default._validateParameters("p5.Image.get", arguments), s.default.Renderer2D.prototype.get.apply(this, arguments);
                            }
                        },
                        {
                            key: "_getPixel",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                return s.default.Renderer2D.prototype._getPixel.apply(this, t);
                            }
                        },
                        {
                            key: "set",
                            value: function(e1, t, r) {
                                s.default.Renderer2D.prototype.set.call(this, e1, t, r), this.setModified(!0);
                            }
                        },
                        {
                            key: "resize",
                            value: function(e1, t) {
                                0 === e1 && 0 === t ? (e1 = this.canvas.width, t = this.canvas.height) : 0 === e1 ? e1 = this.canvas.width * t / this.canvas.height : 0 === t && (t = this.canvas.height * e1 / this.canvas.width), e1 = Math.floor(e1), t = Math.floor(t);
                                var r = document.createElement("canvas");
                                if (r.width = e1, r.height = t, this.gifProperties) for(var o = this.gifProperties, n = 0; n < o.numFrames; n++){
                                    for(var s = this.drawingContext.createImageData(e1, t), i = (d = d = c = u = l = void 0, o.frames[n].image), a = s, l = 0, u = 0; u < a.height; u++)for(var c = 0; c < a.width; c++){
                                        var d = Math.floor(c * i.width / a.width), d = 4 * (Math.floor(u * i.height / a.height) * i.width + d);
                                        a.data[l++] = i.data[d++], a.data[l++] = i.data[d++], a.data[l++] = i.data[d++], a.data[l++] = i.data[+d];
                                    }
                                    o.frames[n].image = s;
                                }
                                r.getContext("2d").drawImage(this.canvas, 0, 0, this.canvas.width, this.canvas.height, 0, 0, r.width, r.height), this.canvas.width = this.width = e1, this.canvas.height = this.height = t, this.drawingContext.drawImage(r, 0, 0, e1, t, 0, 0, e1, t), 0 < this.pixels.length && this.loadPixels(), this.setModified(!0);
                            }
                        },
                        {
                            key: "copy",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                s.default.prototype.copy.apply(this, t);
                            }
                        },
                        {
                            key: "mask",
                            value: function(e1) {
                                var t = this.drawingContext.globalCompositeOperation, r = 1, o = [
                                    e1 = void 0 === e1 ? this : e1,
                                    0,
                                    0,
                                    (r = e1 instanceof s.default.Renderer ? e1._pInst._pixelDensity : r) * e1.width,
                                    r * e1.height,
                                    0,
                                    0,
                                    this.width,
                                    this.height
                                ];
                                if (this.drawingContext.globalCompositeOperation = "destination-in", this.gifProperties) {
                                    for(var n = 0; n < this.gifProperties.frames.length; n++)this.drawingContext.putImageData(this.gifProperties.frames[n].image, 0, 0), this.copy.apply(this, o), this.gifProperties.frames[n].image = this.drawingContext.getImageData(0, 0, this.width, this.height);
                                    this.drawingContext.putImageData(this.gifProperties.frames[this.gifProperties.displayIndex].image, 0, 0);
                                } else this.copy.apply(this, o);
                                this.drawingContext.globalCompositeOperation = t, this.setModified(!0);
                            }
                        },
                        {
                            key: "filter",
                            value: function(e1, t) {
                                n.default.apply(this.canvas, n.default[e1], t), this.setModified(!0);
                            }
                        },
                        {
                            key: "blend",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                s.default._validateParameters("p5.Image.blend", arguments), s.default.prototype.blend.apply(this, t), this.setModified(!0);
                            }
                        },
                        {
                            key: "setModified",
                            value: function(e1) {
                                this._modified = e1;
                            }
                        },
                        {
                            key: "isModified",
                            value: function() {
                                return this._modified;
                            }
                        },
                        {
                            key: "save",
                            value: function(e1, t) {
                                this.gifProperties ? s.default.prototype.encodeAndDownloadGif(this, e1) : s.default.prototype.saveCanvas(this.canvas, e1, t);
                            }
                        },
                        {
                            key: "reset",
                            value: function() {
                                var e1;
                                this.gifProperties && ((e1 = this.gifProperties).playing = !0, e1.timeSinceStart = 0, e1.timeDisplayed = 0, e1.lastChangeTime = 0, e1.loopCount = 0, e1.displayIndex = 0, this.drawingContext.putImageData(e1.frames[0].image, 0, 0));
                            }
                        },
                        {
                            key: "getCurrentFrame",
                            value: function() {
                                var e1;
                                if (this.gifProperties) return (e1 = this.gifProperties).displayIndex % e1.numFrames;
                            }
                        },
                        {
                            key: "setFrame",
                            value: function(e1) {
                                var t;
                                this.gifProperties && (e1 < (t = this.gifProperties).numFrames && 0 <= e1 ? (t.timeDisplayed = 0, t.lastChangeTime = 0, t.displayIndex = e1, this.drawingContext.putImageData(t.frames[e1].image, 0, 0)) : console.log("Cannot set GIF to a frame number that is higher than total number of frames or below zero."));
                            }
                        },
                        {
                            key: "numFrames",
                            value: function() {
                                if (this.gifProperties) return this.gifProperties.numFrames;
                            }
                        },
                        {
                            key: "play",
                            value: function() {
                                this.gifProperties && (this.gifProperties.playing = !0);
                            }
                        },
                        {
                            key: "pause",
                            value: function() {
                                this.gifProperties && (this.gifProperties.playing = !1);
                            }
                        },
                        {
                            key: "delay",
                            value: function(e1, t) {
                                if (this.gifProperties) {
                                    var r = this.gifProperties;
                                    if (t < r.numFrames && 0 <= t) r.frames[t].delay = e1;
                                    else {
                                        var o = !0, t = !1, n = void 0;
                                        try {
                                            for(var s, i = r.frames[Symbol.iterator](); !(o = (s = i.next()).done); o = !0)s.value.delay = e1;
                                        } catch (e1) {
                                            t = !0, n = e1;
                                        } finally{
                                            try {
                                                o || null == i.return || i.return();
                                            } finally{
                                                if (t) throw n;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    ], i(e1.prototype, t), o && i(e1, o), r;
                }();
                e1 = s.default.Image;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "./filters": 296,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        300: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.filter"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var f = o(e1("../core/main")), a = o(e1("./filters"));
                function o(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                e1("../color/p5.Color"), f.default.prototype.pixels = [], f.default.prototype.blend = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    f.default._validateParameters("blend", r), this._renderer ? (e1 = this._renderer).blend.apply(e1, r) : f.default.Renderer2D.prototype.blend.apply(this, r);
                }, f.default.prototype.copy = function() {
                    for(var e1, t, r, o, n, s, i, a, l, u = arguments.length, c = new Array(u), d = 0; d < u; d++)c[d] = arguments[d];
                    if (f.default._validateParameters("copy", c), 9 === c.length) e1 = c[0], t = c[1], r = c[2], o = c[3], n = c[4], s = c[5], i = c[6], a = c[7], l = c[8];
                    else {
                        if (8 !== c.length) throw new Error("Signature not supported");
                        e1 = this, t = c[0], r = c[1], o = c[2], n = c[3], s = c[4], i = c[5], a = c[6], l = c[7];
                    }
                    f.default.prototype._copyHelper(this, e1, t, r, o, n, s, i, a, l);
                }, f.default.prototype._copyHelper = function(e1, t, r, o, n, s, i, a, l, u) {
                    var c = t.canvas.width / t.width, d = 0, h = 0;
                    t._renderer && t._renderer.isP3D && (d = t.width / 2, h = t.height / 2), e1._renderer && e1._renderer.isP3D ? f.default.RendererGL.prototype.image.call(e1._renderer, t, r + d, o + h, n, s, i, a, l, u) : e1.drawingContext.drawImage(t.canvas, c * (r + d), c * (o + h), c * n, c * s, i, a, l, u);
                }, f.default.prototype.getFilterGraphicsLayer = function() {
                    return this._renderer.getFilterGraphicsLayer();
                }, f.default.prototype.filter = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    f.default._validateParameters("filter", arguments);
                    var o = (function() {
                        var e1, t = {
                            shader: void 0,
                            operation: void 0,
                            value: void 0,
                            useWebGL: !0
                        };
                        return (arguments.length <= 0 ? void 0 : arguments[0]) instanceof f.default.Shader ? t.shader = arguments.length <= 0 ? void 0 : arguments[0] : (t.operation = arguments.length <= 0 ? void 0 : arguments[0], 1 < arguments.length && "number" == typeof (arguments.length <= 1 ? void 0 : arguments[1]) && (t.value = arguments.length <= 1 ? void 0 : arguments[1]), !1 === ((e1 = arguments.length - 1) < 0 || arguments.length <= e1 ? void 0 : arguments[e1]) && (t.useWebGL = !1)), t;
                    }).apply(void 0, t), n = o.shader, s = o.operation, i = o.value, o = o.useWebGL;
                    this._renderer.isP3D && n ? f.default.RendererGL.prototype.filter.call(this._renderer, n) : o || this._renderer.isP3D ? (!o && this._renderer.isP3D && console.warn("filter() with useWebGL=false is not supported in WEBGL"), this._renderer.isP3D ? f.default.RendererGL.prototype.filter.call(this._renderer, s, i) : ((n = this.getFilterGraphicsLayer()).copy(this._renderer, 0, 0, this.width, this.height, -this.width / 2, -this.height / 2, this.width, this.height), this._renderer.clear(), this._renderer.resetMatrix(), n.filter.apply(n, t), this._renderer._pInst.image(n, 0, 0), n.clear())) : void 0 !== this.canvas ? a.default.apply(this.canvas, a.default[s], i) : a.default.apply(this.elt, a.default[s], i);
                }, f.default.prototype.get = function(e1, t, r, o) {
                    var n;
                    return f.default._validateParameters("get", arguments), (n = this._renderer).get.apply(n, arguments);
                }, f.default.prototype.loadPixels = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    f.default._validateParameters("loadPixels", t), this._renderer.loadPixels();
                }, f.default.prototype.set = function(e1, t, r) {
                    this._renderer.set(e1, t, r);
                }, f.default.prototype.updatePixels = function(e1, t, r, o) {
                    f.default._validateParameters("updatePixels", arguments), 0 !== this.pixels.length && this._renderer.updatePixels(e1, t, r, o);
                };
                e1 = f.default;
                r.default = e1;
            },
            {
                "../color/p5.Color": 262,
                "../core/main": 275,
                "./filters": 296,
                "core-js/modules/es.array.filter": 155
            }
        ],
        301: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.from-entries"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/web.url"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.from-entries"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/web.url"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var v = s(e1("../core/main")), m = (e1("whatwg-fetch"), e1("es6-promise/auto"), s(e1("fetch-jsonp"))), n = s(e1("file-saver"));
                function s(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function y(e1) {
                    return (y = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                function g(e1) {
                    return e1.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
                }
                function i(e1, t) {
                    t && !0 !== t && "true" !== t || (t = "");
                    var r = "";
                    return (e1 = e1 || "untitled", e1.includes(".")) && (r = e1.split(".").pop()), t && r !== t && (r = t, e1 = "".concat(e1, ".").concat(r)), [
                        e1,
                        r
                    ];
                }
                e1("../core/friendly_errors/validate_params"), e1("../core/friendly_errors/file_errors"), e1("../core/friendly_errors/fes_core"), v.default.prototype.loadJSON = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    v.default._validateParameters("loadJSON", t);
                    for(var o, n, s, i = t[0], a = {}, l = "json", u = 1; u < t.length; u++){
                        var c = t[u];
                        "string" == typeof c ? "jsonp" !== c && "json" !== c || (l = c) : "function" == typeof c ? o ? n = c : o = c : "object" === y(c) && (c.hasOwnProperty("jsonpCallback") || c.hasOwnProperty("jsonpCallbackFunction")) && (l = "jsonp", s = c);
                    }
                    var d = this;
                    return this.httpDo(i, "GET", s, l, function(e1) {
                        for(var t in e1)a[t] = e1[t];
                        void 0 !== o && o(e1), d._decrementPreload();
                    }, function(e1) {
                        if (v.default._friendlyFileLoadError(5, i), !n) throw e1;
                        n(e1);
                    }), a;
                }, v.default.prototype.loadStrings = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    v.default._validateParameters("loadStrings", t);
                    for(var n, o, s = [], i = 1; i < t.length; i++){
                        var a = t[i];
                        "function" == typeof a && (void 0 === n ? n = a : void 0 === o && (o = a));
                    }
                    var l = this;
                    return v.default.prototype.httpDo.call(this, t[0], "GET", "text", function(e1) {
                        for(var t = e1.replace(/\r\n/g, "\r").replace(/\n/g, "\r").split(/\r/), r = 0, o = t.length; r < o; r += 32768)Array.prototype.push.apply(s, t.slice(r, Math.min(r + 32768, o)));
                        void 0 !== n && n(s), l._decrementPreload();
                    }, function(e1) {
                        if (v.default._friendlyFileLoadError(3, e1), !o) throw e1;
                        o(e1);
                    }), s;
                }, v.default.prototype.loadTable = function(t) {
                    var f, r, p, e1 = [], m = !1, o = t.substring(t.lastIndexOf(".") + 1, t.length);
                    "csv" === o ? p = "," : "ssv" === o ? p = ";" : "tsv" === o && (p = "	");
                    for(var n = 1; n < arguments.length; n++)"function" == typeof arguments[n] ? void 0 === f ? f = arguments[n] : void 0 === r && (r = arguments[n]) : "string" == typeof arguments[n] && (e1.push(arguments[n]), "header" === arguments[n] && (m = !0), "csv" === arguments[n] ? p = "," : "ssv" === arguments[n] ? p = ";" : "tsv" === arguments[n] && (p = "	"));
                    var y = new v.default.Table, g = this;
                    return this.httpDo(t, "GET", "table", function(e1) {
                        for(var t, r, o = {}, n = 0, s = [], i = 0, a = null, l = function() {
                            o.currentState = n, o.token = "";
                        }, u = function() {
                            a.push(o.token), l();
                        }, c = function() {
                            o.currentState = 4, s.push(a), a = null;
                        };;){
                            if (null == (t = e1[i++])) {
                                if (o.escaped) throw new Error("Unclosed quote in file.");
                                if (a) {
                                    u(), c();
                                    break;
                                }
                            }
                            if (null === a && (o.escaped = !1, a = [], l()), o.currentState === n) {
                                if ('"' === t) {
                                    o.escaped = !0, o.currentState = 1;
                                    continue;
                                }
                                o.currentState = 1;
                            }
                            if (1 === o.currentState && o.escaped) {
                                if ('"' === t) '"' === e1[i] ? (o.token += '"', i++) : (o.escaped = !1, o.currentState = 2);
                                else {
                                    if ("\r" === t) continue;
                                    o.token += t;
                                }
                            } else "\r" === t ? ("\n" === e1[i] && i++, u(), c()) : "\n" === t ? (u(), c()) : t === p ? u() : 1 === o.currentState && (o.token += t);
                        }
                        if (m) y.columns = s.shift();
                        else for(var d = 0; d < s[0].length; d++)y.columns[d] = "null";
                        for(var h = 0; h < s.length; h++)(1 !== s[h].length || "undefined" !== s[h][0] && "" !== s[h][0]) && ((r = new v.default.TableRow).arr = s[h], r.obj = function(r, e1) {
                            if (void 0 === (e1 = e1 || [])) for(var t = 0; t < r.length; t++)e1[t.toString()] = t;
                            return Object.fromEntries(e1.map(function(e1, t) {
                                return [
                                    e1,
                                    r[t]
                                ];
                            }));
                        }(s[h], y.columns), y.addRow(r));
                        "function" == typeof f && f(y), g._decrementPreload();
                    }, function(e1) {
                        v.default._friendlyFileLoadError(2, t), r ? r(e1) : console.error(e1);
                    }), y;
                }, v.default.prototype.loadXML = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    for(var o, n, s = new v.default.XML, i = 1; i < t.length; i++){
                        var a = t[i];
                        "function" == typeof a && (void 0 === o ? o = a : void 0 === n && (n = a));
                    }
                    var l = this;
                    return this.httpDo(t[0], "GET", "xml", function(e1) {
                        for(var t in e1)s[t] = e1[t];
                        void 0 !== o && o(s), l._decrementPreload();
                    }, function(e1) {
                        if (v.default._friendlyFileLoadError(1, e1), !n) throw e1;
                        n(e1);
                    }), s;
                }, v.default.prototype.loadBytes = function(t, r, o) {
                    var n = {}, s = this;
                    return this.httpDo(t, "GET", "arrayBuffer", function(e1) {
                        n.bytes = new Uint8Array(e1), "function" == typeof r && r(n), s._decrementPreload();
                    }, function(e1) {
                        if (v.default._friendlyFileLoadError(6, t), !o) throw e1;
                        o(e1);
                    }), n;
                }, v.default.prototype.httpGet = function() {
                    v.default._validateParameters("httpGet", arguments);
                    var e1 = Array.prototype.slice.call(arguments);
                    return e1.splice(1, 0, "GET"), v.default.prototype.httpDo.apply(this, e1);
                }, v.default.prototype.httpPost = function() {
                    v.default._validateParameters("httpPost", arguments);
                    var e1 = Array.prototype.slice.call(arguments);
                    return e1.splice(1, 0, "POST"), v.default.prototype.httpDo.apply(this, e1);
                }, v.default.prototype.httpDo = function() {
                    for(var r, e1, t, o = {}, n = 0, s = "text/plain", i = arguments.length - 1; 0 < i && "function" == typeof (i < 0 || arguments.length <= i ? void 0 : arguments[i]); i--)n++;
                    var a = arguments.length - n, l = arguments.length <= 0 ? void 0 : arguments[0];
                    if (2 == a && "string" == typeof l && "object" === y(arguments.length <= 1 ? void 0 : arguments[1])) p = new Request(l, arguments.length <= 1 ? void 0 : arguments[1]), e1 = arguments.length <= 2 ? void 0 : arguments[2], t = arguments.length <= 3 ? void 0 : arguments[3];
                    else {
                        for(var u, c = "GET", d = 1; d < arguments.length; d++){
                            var h = d < 0 || arguments.length <= d ? void 0 : arguments[d];
                            if ("string" == typeof h) "GET" === h || "POST" === h || "PUT" === h || "DELETE" === h ? c = h : "json" === h || "jsonp" === h || "binary" === h || "arrayBuffer" === h || "xml" === h || "text" === h || "table" === h ? r = h : u = h;
                            else if ("number" == typeof h) u = h.toString();
                            else if ("object" === y(h)) {
                                if (h.hasOwnProperty("jsonpCallback") || h.hasOwnProperty("jsonpCallbackFunction")) for(var f in h)o[f] = h[f];
                                else s = h instanceof v.default.XML ? (u = h.serialize(), "application/xml") : (u = JSON.stringify(h), "application/json");
                            } else "function" == typeof h && (e1 ? t = h : e1 = h);
                        }
                        var a = "GET" === c ? new Headers : new Headers({
                            "Content-Type": s
                        }), p = new Request(l, {
                            method: c,
                            mode: "cors",
                            body: u,
                            headers: a
                        });
                    }
                    return (a = (a = "jsonp" === (r = r || (l.includes("json") ? "json" : l.includes("xml") ? "xml" : "text")) ? (0, m.default)(l, o) : fetch(p)).then(function(e1) {
                        if (!e1.ok) throw (t = new Error(e1.body)).status = e1.status, t.ok = !1, t;
                        var t = 0;
                        switch((t = "jsonp" !== r ? e1.headers.get("content-length") : t) && 64e6 < t && v.default._friendlyFileLoadError(7, l), r){
                            case "json":
                            case "jsonp":
                                return e1.json();
                            case "binary":
                                return e1.blob();
                            case "arrayBuffer":
                                return e1.arrayBuffer();
                            case "xml":
                                return e1.text().then(function(e1) {
                                    e1 = (new DOMParser).parseFromString(e1, "text/xml");
                                    return new v.default.XML(e1.documentElement);
                                });
                            default:
                                return e1.text();
                        }
                    })).then(e1 || function() {}), a.catch(t || console.error), a;
                }, window.URL = window.URL || window.webkitURL, v.default.prototype._pWriters = [], v.default.prototype.createWriter = function(e1, t) {
                    var r, o;
                    for(o in v.default.prototype._pWriters)if (v.default.prototype._pWriters[o].name === e1) return r = new v.default.PrintWriter(e1 + this.millis(), t), v.default.prototype._pWriters.push(r), r;
                    return r = new v.default.PrintWriter(e1, t), v.default.prototype._pWriters.push(r), r;
                }, v.default.PrintWriter = function(r, o) {
                    var n = this;
                    this.name = r, this.content = "", this.write = function(e1) {
                        this.content += e1;
                    }, this.print = function(e1) {
                        this.content += "".concat(e1, "\n");
                    }, this.clear = function() {
                        this.content = "";
                    }, this.close = function() {
                        var e1, t = [];
                        for(e1 in t.push(this.content), v.default.prototype.writeFile(t, r, o), v.default.prototype._pWriters)v.default.prototype._pWriters[e1].name === this.name && v.default.prototype._pWriters.splice(e1, 1);
                        n.clear(), n = {};
                    };
                }, v.default.prototype.save = function(e1, t, r) {
                    var o = arguments, n = (this._curElement || this).elt;
                    if (0 === o.length) v.default.prototype.saveCanvas(n);
                    else if (o[0] instanceof v.default.Renderer || o[0] instanceof v.default.Graphics) v.default.prototype.saveCanvas(o[0].elt, o[1], o[2]);
                    else if (1 === o.length && "string" == typeof o[0]) v.default.prototype.saveCanvas(n, o[0]);
                    else switch(i(o[1], o[2])[1]){
                        case "json":
                            return void v.default.prototype.saveJSON(o[0], o[1], o[2]);
                        case "txt":
                            return void v.default.prototype.saveStrings(o[0], o[1], o[2]);
                        default:
                            o[0] instanceof Array ? v.default.prototype.saveStrings(o[0], o[1], o[2]) : o[0] instanceof v.default.Table ? v.default.prototype.saveTable(o[0], o[1], o[2]) : o[0] instanceof v.default.Image ? v.default.prototype.saveCanvas(o[0].canvas, o[1]) : o[0] instanceof v.default.SoundFile && v.default.prototype.saveSound(o[0], o[1], o[2], o[3]);
                    }
                }, v.default.prototype.saveJSON = function(e1, t, r) {
                    v.default._validateParameters("saveJSON", arguments), r = r ? JSON.stringify(e1) : JSON.stringify(e1, void 0, 2), this.saveStrings(r.split("\n"), t, "json");
                }, v.default.prototype.saveJSONObject = v.default.prototype.saveJSON, v.default.prototype.saveJSONArray = v.default.prototype.saveJSON, v.default.prototype.saveStrings = function(e1, t, r, o) {
                    v.default._validateParameters("saveStrings", arguments);
                    for(var n = this.createWriter(t, r || "txt"), s = 0; s < e1.length; s++)o ? n.write(e1[s] + "\r\n") : n.write(e1[s] + "\n");
                    n.close(), n.clear();
                }, v.default.prototype.saveTable = function(e1, t, r) {
                    v.default._validateParameters("saveTable", arguments), o = void 0 === r ? t.substring(t.lastIndexOf(".") + 1, t.length) : r;
                    var o, n = this.createWriter(t, o), s = e1.columns, i = "tsv" === o ? "	" : ",";
                    if ("html" !== o) {
                        if ("0" !== s[0]) {
                            for(var a = 0; a < s.length; a++)a < s.length - 1 ? n.write(s[a] + i) : n.write(s[a]);
                            n.write("\n");
                        }
                        for(var l = 0; l < e1.rows.length; l++){
                            for(var u = void 0, u = 0; u < e1.rows[l].arr.length; u++)u < e1.rows[l].arr.length - 1 ? "csv" === o && String(e1.rows[l].arr[u]).includes(",") ? n.write('"' + e1.rows[l].arr[u] + '"' + i) : n.write(e1.rows[l].arr[u] + i) : "csv" === o && String(e1.rows[l].arr[u]).includes(",") ? n.write('"' + e1.rows[l].arr[u] + '"') : n.write(e1.rows[l].arr[u]);
                            n.write("\n");
                        }
                    } else {
                        n.print("<html>"), n.print("<head>");
                        if (n.print('  <meta http-equiv="content-type" content="text/html;charset=utf-8" />'), n.print("</head>"), n.print("<body>"), n.print("  <table>"), "0" !== s[0]) {
                            n.print("    <tr>");
                            for(var c = 0; c < s.length; c++){
                                var d = g(s[c]);
                                n.print("      <td>".concat(d)), n.print("      </td>");
                            }
                            n.print("    </tr>");
                        }
                        for(var h = 0; h < e1.rows.length; h++){
                            n.print("    <tr>");
                            for(var f = 0; f < e1.columns.length; f++){
                                var p = g(e1.rows[h].getString(f));
                                n.print("      <td>".concat(p)), n.print("      </td>");
                            }
                            n.print("    </tr>");
                        }
                        n.print("  </table>"), n.print("</body>"), n.print("</html>");
                    }
                    n.close(), n.clear();
                }, v.default.prototype.writeFile = function(e1, t, r) {
                    var o = "application/octet-stream", e1 = (v.default.prototype._isSafari() && (o = "text/plain"), new Blob(e1, {
                        type: o
                    }));
                    v.default.prototype.downloadFile(e1, t, r);
                }, v.default.prototype.downloadFile = function(e1, t, r) {
                    var o, t = i(t, r), r = t[0];
                    e1 instanceof Blob ? n.default.saveAs(e1, r) : ((o = document.createElement("a")).href = e1, o.download = r, o.onclick = function(e1) {
                        document.body.removeChild(e1.target), e1.stopPropagation();
                    }, o.style.display = "none", document.body.appendChild(o), v.default.prototype._isSafari() && (e1 = (e1 = 'Hello, Safari user! To download this file...\n1. Go to File --> Save As.\n2. Choose "Page Source" as the Format.\n') + '3. Name it with this extension: ."'.concat(t[1], '"'), alert(e1)), o.click());
                }, v.default.prototype._checkFileExtension = i, v.default.prototype._isSafari = function() {
                    return 0 < Object.prototype.toString.call(window.HTMLElement).indexOf("Constructor");
                };
                e1 = v.default;
                r.default = e1;
            },
            {
                "../core/friendly_errors/fes_core": 266,
                "../core/friendly_errors/file_errors": 267,
                "../core/friendly_errors/validate_params": 270,
                "../core/main": 275,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.includes": 159,
                "core-js/modules/es.array.index-of": 160,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.last-index-of": 163,
                "core-js/modules/es.array.map": 164,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.array.splice": 167,
                "core-js/modules/es.function.name": 168,
                "core-js/modules/es.object.from-entries": 177,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.promise": 183,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.includes": 191,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.string.replace": 196,
                "core-js/modules/es.string.split": 198,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.typed-array.copy-within": 205,
                "core-js/modules/es.typed-array.every": 206,
                "core-js/modules/es.typed-array.fill": 207,
                "core-js/modules/es.typed-array.filter": 208,
                "core-js/modules/es.typed-array.find": 210,
                "core-js/modules/es.typed-array.find-index": 209,
                "core-js/modules/es.typed-array.for-each": 213,
                "core-js/modules/es.typed-array.includes": 214,
                "core-js/modules/es.typed-array.index-of": 215,
                "core-js/modules/es.typed-array.iterator": 218,
                "core-js/modules/es.typed-array.join": 219,
                "core-js/modules/es.typed-array.last-index-of": 220,
                "core-js/modules/es.typed-array.map": 221,
                "core-js/modules/es.typed-array.reduce": 223,
                "core-js/modules/es.typed-array.reduce-right": 222,
                "core-js/modules/es.typed-array.reverse": 224,
                "core-js/modules/es.typed-array.set": 225,
                "core-js/modules/es.typed-array.slice": 226,
                "core-js/modules/es.typed-array.some": 227,
                "core-js/modules/es.typed-array.sort": 228,
                "core-js/modules/es.typed-array.subarray": 229,
                "core-js/modules/es.typed-array.to-locale-string": 230,
                "core-js/modules/es.typed-array.to-string": 231,
                "core-js/modules/es.typed-array.uint8-array": 234,
                "core-js/modules/web.dom-collections.iterator": 238,
                "core-js/modules/web.url": 240,
                "es6-promise/auto": 241,
                "fetch-jsonp": 243,
                "file-saver": 244,
                "whatwg-fetch": 253
            }
        ],
        302: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.replace"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                n.default.Table = function() {
                    function t(e1) {
                        if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function");
                        this.columns = [], this.rows = [];
                    }
                    var e1, r, o;
                    return e1 = t, r = [
                        {
                            key: "addRow",
                            value: function(e1) {
                                e1 = e1 || new n.default.TableRow;
                                if (void 0 === e1.arr || void 0 === e1.obj) throw new Error("invalid TableRow: ".concat(e1));
                                return (e1.table = this).rows.push(e1), e1;
                            }
                        },
                        {
                            key: "removeRow",
                            value: function(e1) {
                                this.rows[e1].table = null;
                                e1 = this.rows.splice(e1 + 1, this.rows.length);
                                this.rows.pop(), this.rows = this.rows.concat(e1);
                            }
                        },
                        {
                            key: "getRow",
                            value: function(e1) {
                                return this.rows[e1];
                            }
                        },
                        {
                            key: "getRows",
                            value: function() {
                                return this.rows;
                            }
                        },
                        {
                            key: "findRow",
                            value: function(e1, t) {
                                if ("string" == typeof t) {
                                    for(var r = 0; r < this.rows.length; r++)if (this.rows[r].obj[t] === e1) return this.rows[r];
                                } else for(var o = 0; o < this.rows.length; o++)if (this.rows[o].arr[t] === e1) return this.rows[o];
                                return null;
                            }
                        },
                        {
                            key: "findRows",
                            value: function(e1, t) {
                                var r = [];
                                if ("string" == typeof t) for(var o = 0; o < this.rows.length; o++)this.rows[o].obj[t] === e1 && r.push(this.rows[o]);
                                else for(var n = 0; n < this.rows.length; n++)this.rows[n].arr[t] === e1 && r.push(this.rows[n]);
                                return r;
                            }
                        },
                        {
                            key: "matchRow",
                            value: function(e1, t) {
                                if ("number" == typeof t) {
                                    for(var r = 0; r < this.rows.length; r++)if (this.rows[r].arr[t].match(e1)) return this.rows[r];
                                } else for(var o = 0; o < this.rows.length; o++)if (this.rows[o].obj[t].match(e1)) return this.rows[o];
                                return null;
                            }
                        },
                        {
                            key: "matchRows",
                            value: function(e1, t) {
                                var r = [];
                                if ("number" == typeof t) for(var o = 0; o < this.rows.length; o++)this.rows[o].arr[t].match(e1) && r.push(this.rows[o]);
                                else for(var n = 0; n < this.rows.length; n++)this.rows[n].obj[t].match(e1) && r.push(this.rows[n]);
                                return r;
                            }
                        },
                        {
                            key: "getColumn",
                            value: function(e1) {
                                var t = [];
                                if ("string" == typeof e1) for(var r = 0; r < this.rows.length; r++)t.push(this.rows[r].obj[e1]);
                                else for(var o = 0; o < this.rows.length; o++)t.push(this.rows[o].arr[e1]);
                                return t;
                            }
                        },
                        {
                            key: "clearRows",
                            value: function() {
                                delete this.rows, this.rows = [];
                            }
                        },
                        {
                            key: "addColumn",
                            value: function(e1) {
                                this.columns.push(e1 || null);
                            }
                        },
                        {
                            key: "getColumnCount",
                            value: function() {
                                return this.columns.length;
                            }
                        },
                        {
                            key: "getRowCount",
                            value: function() {
                                return this.rows.length;
                            }
                        },
                        {
                            key: "removeTokens",
                            value: function(e1, t) {
                                for(var r = [], o = 0; o < e1.length; o++)r.push(e1.charAt(o).replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"));
                                var n = new RegExp(r.join("|"), "g");
                                if (void 0 === t) for(var s = 0; s < this.columns.length; s++)for(var i = 0; i < this.rows.length; i++){
                                    var a = (a = this.rows[i].arr[s]).replace(n, "");
                                    this.rows[i].arr[s] = a, this.rows[i].obj[this.columns[s]] = a;
                                }
                                else if ("string" == typeof t) for(var l = 0; l < this.rows.length; l++){
                                    var u = (u = this.rows[l].obj[t]).replace(n, ""), c = (this.rows[l].obj[t] = u, this.columns.indexOf(t));
                                    this.rows[l].arr[c] = u;
                                }
                                else for(var d = 0; d < this.rows.length; d++){
                                    var h = (h = this.rows[d].arr[t]).replace(n, "");
                                    this.rows[d].arr[t] = h, this.rows[d].obj[this.columns[t]] = h;
                                }
                            }
                        },
                        {
                            key: "trim",
                            value: function(e1) {
                                var t = new RegExp(" ", "g");
                                if (void 0 === e1) for(var r = 0; r < this.columns.length; r++)for(var o = 0; o < this.rows.length; o++){
                                    var n = (n = this.rows[o].arr[r]).replace(t, "");
                                    this.rows[o].arr[r] = n, this.rows[o].obj[this.columns[r]] = n;
                                }
                                else if ("string" == typeof e1) for(var s = 0; s < this.rows.length; s++){
                                    var i = (i = this.rows[s].obj[e1]).replace(t, ""), a = (this.rows[s].obj[e1] = i, this.columns.indexOf(e1));
                                    this.rows[s].arr[a] = i;
                                }
                                else for(var l = 0; l < this.rows.length; l++){
                                    var u = (u = this.rows[l].arr[e1]).replace(t, "");
                                    this.rows[l].arr[e1] = u, this.rows[l].obj[this.columns[e1]] = u;
                                }
                            }
                        },
                        {
                            key: "removeColumn",
                            value: function(e1) {
                                "string" == typeof e1 ? r = this.columns.indexOf(t = e1) : t = this.columns[r = e1];
                                var t, r, e1 = this.columns.splice(r + 1, this.columns.length);
                                this.columns.pop(), this.columns = this.columns.concat(e1);
                                for(var o = 0; o < this.rows.length; o++){
                                    var n = this.rows[o].arr, s = n.splice(r + 1, n.length);
                                    n.pop(), this.rows[o].arr = n.concat(s), delete this.rows[o].obj[t];
                                }
                            }
                        },
                        {
                            key: "set",
                            value: function(e1, t, r) {
                                this.rows[e1].set(t, r);
                            }
                        },
                        {
                            key: "setNum",
                            value: function(e1, t, r) {
                                this.rows[e1].setNum(t, r);
                            }
                        },
                        {
                            key: "setString",
                            value: function(e1, t, r) {
                                this.rows[e1].setString(t, r);
                            }
                        },
                        {
                            key: "get",
                            value: function(e1, t) {
                                return this.rows[e1].get(t);
                            }
                        },
                        {
                            key: "getNum",
                            value: function(e1, t) {
                                return this.rows[e1].getNum(t);
                            }
                        },
                        {
                            key: "getString",
                            value: function(e1, t) {
                                return this.rows[e1].getString(t);
                            }
                        },
                        {
                            key: "getObject",
                            value: function(e1) {
                                for(var t, r = {}, o = 0; o < this.rows.length; o++)if (t = this.rows[o].obj, "string" == typeof e1) {
                                    if (!(0 <= this.columns.indexOf(e1))) throw new Error('This table has no column named "'.concat(e1, '"'));
                                    r[t[e1]] = t;
                                } else r[o] = this.rows[o].obj;
                                return r;
                            }
                        },
                        {
                            key: "getArray",
                            value: function() {
                                for(var e1 = [], t = 0; t < this.rows.length; t++)e1.push(this.rows[t].arr);
                                return e1;
                            }
                        }
                    ], s(e1.prototype, r), o && s(e1, o), t;
                }();
                e1 = n.default;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.index-of": 160,
                "core-js/modules/es.array.join": 162,
                "core-js/modules/es.array.splice": 167,
                "core-js/modules/es.regexp.constructor": 186,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.match": 193,
                "core-js/modules/es.string.replace": 196
            }
        ],
        303: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.from-entries"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.from-entries"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                e1.default.TableRow = function() {
                    function o(e1, t) {
                        if (!(this instanceof o)) throw new TypeError("Cannot call a class as a function");
                        var r = [];
                        e1 && (r = e1.split(t = t || ",")), this.arr = r, this.obj = Object.fromEntries(r.entries()), this.table = null;
                    }
                    var e1, t, r;
                    return e1 = o, t = [
                        {
                            key: "set",
                            value: function(e1, t) {
                                if ("string" == typeof e1) {
                                    var r = this.table.columns.indexOf(e1);
                                    if (!(0 <= r)) throw new Error('This table has no column named "'.concat(e1, '"'));
                                    this.obj[e1] = t, this.arr[r] = t;
                                } else {
                                    if (!(e1 < this.table.columns.length)) throw new Error("Column #".concat(e1, " is out of the range of this table"));
                                    this.arr[e1] = t;
                                    r = this.table.columns[e1];
                                    this.obj[r] = t;
                                }
                            }
                        },
                        {
                            key: "setNum",
                            value: function(e1, t) {
                                t = parseFloat(t);
                                this.set(e1, t);
                            }
                        },
                        {
                            key: "setString",
                            value: function(e1, t) {
                                t = t.toString();
                                this.set(e1, t);
                            }
                        },
                        {
                            key: "get",
                            value: function(e1) {
                                return ("string" == typeof e1 ? this.obj : this.arr)[e1];
                            }
                        },
                        {
                            key: "getNum",
                            value: function(e1) {
                                var t = "string" == typeof e1 ? parseFloat(this.obj[e1]) : parseFloat(this.arr[e1]);
                                if ("NaN" === t.toString()) throw "Error: ".concat(this.obj[e1], " is NaN (Not a Number)");
                                return t;
                            }
                        },
                        {
                            key: "getString",
                            value: function(e1) {
                                return ("string" == typeof e1 ? this.obj : this.arr)[e1].toString();
                            }
                        }
                    ], n(e1.prototype, t), r && n(e1, r), o;
                }();
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.index-of": 160,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.from-entries": 177,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.split": 198,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        304: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var a = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function s(e1) {
                    for(var t = [], r = 0; r < e1.length; r++)t.push(new a.default.XML(e1[r]));
                    return t;
                }
                a.default.XML = function() {
                    function t(e1) {
                        if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function");
                        e1 ? this.DOM = e1 : (e1 = document.implementation.createDocument(null, "doc"), this.DOM = e1.createElement("root"));
                    }
                    var e1, r, o;
                    return e1 = t, r = [
                        {
                            key: "getParent",
                            value: function() {
                                return new a.default.XML(this.DOM.parentElement);
                            }
                        },
                        {
                            key: "getName",
                            value: function() {
                                return this.DOM.tagName;
                            }
                        },
                        {
                            key: "setName",
                            value: function(e1) {
                                var t = this.DOM.innerHTML, r = this.DOM.attributes, o = document.implementation.createDocument(null, "default").createElement(e1);
                                o.innerHTML = t;
                                for(var n = 0; n < r.length; n++)o.setAttribute(r[n].nodeName, r.nodeValue);
                                this.DOM = o;
                            }
                        },
                        {
                            key: "hasChildren",
                            value: function() {
                                return 0 < this.DOM.children.length;
                            }
                        },
                        {
                            key: "listChildren",
                            value: function() {
                                for(var e1 = [], t = 0; t < this.DOM.childNodes.length; t++)e1.push(this.DOM.childNodes[t].nodeName);
                                return e1;
                            }
                        },
                        {
                            key: "getChildren",
                            value: function(e1) {
                                return s(e1 ? this.DOM.getElementsByTagName(e1) : this.DOM.children);
                            }
                        },
                        {
                            key: "getChild",
                            value: function(e1) {
                                if ("string" != typeof e1) return new a.default.XML(this.DOM.children[e1]);
                                var t = !0, r = !1, o = void 0;
                                try {
                                    for(var n, s = this.DOM.children[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                        var i = n.value;
                                        if (i.tagName === e1) return new a.default.XML(i);
                                    }
                                } catch (e1) {
                                    r = !0, o = e1;
                                } finally{
                                    try {
                                        t || null == s.return || s.return();
                                    } finally{
                                        if (r) throw o;
                                    }
                                }
                            }
                        },
                        {
                            key: "addChild",
                            value: function(e1) {
                                e1 instanceof a.default.XML && this.DOM.appendChild(e1.DOM);
                            }
                        },
                        {
                            key: "removeChild",
                            value: function(e1) {
                                var t = -1;
                                if ("string" == typeof e1) {
                                    for(var r = 0; r < this.DOM.children.length; r++)if (this.DOM.children[r].tagName === e1) {
                                        t = r;
                                        break;
                                    }
                                } else t = e1;
                                -1 !== t && this.DOM.removeChild(this.DOM.children[t]);
                            }
                        },
                        {
                            key: "getAttributeCount",
                            value: function() {
                                return this.DOM.attributes.length;
                            }
                        },
                        {
                            key: "listAttributes",
                            value: function() {
                                var e1 = [], t = !0, r = !1, o = void 0;
                                try {
                                    for(var n, s = this.DOM.attributes[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                        var i = n.value;
                                        e1.push(i.nodeName);
                                    }
                                } catch (e1) {
                                    r = !0, o = e1;
                                } finally{
                                    try {
                                        t || null == s.return || s.return();
                                    } finally{
                                        if (r) throw o;
                                    }
                                }
                                return e1;
                            }
                        },
                        {
                            key: "hasAttribute",
                            value: function(e1) {
                                var t = {}, r = !0, o = !1, n = void 0;
                                try {
                                    for(var s, i = this.DOM.attributes[Symbol.iterator](); !(r = (s = i.next()).done); r = !0){
                                        var a = s.value;
                                        t[a.nodeName] = a.nodeValue;
                                    }
                                } catch (e1) {
                                    o = !0, n = e1;
                                } finally{
                                    try {
                                        r || null == i.return || i.return();
                                    } finally{
                                        if (o) throw n;
                                    }
                                }
                                return !!t[e1];
                            }
                        },
                        {
                            key: "getNum",
                            value: function(e1, t) {
                                var r = {}, o = !0, n = !1, s = void 0;
                                try {
                                    for(var i, a = this.DOM.attributes[Symbol.iterator](); !(o = (i = a.next()).done); o = !0){
                                        var l = i.value;
                                        r[l.nodeName] = l.nodeValue;
                                    }
                                } catch (e1) {
                                    n = !0, s = e1;
                                } finally{
                                    try {
                                        o || null == a.return || a.return();
                                    } finally{
                                        if (n) throw s;
                                    }
                                }
                                return Number(r[e1]) || t || 0;
                            }
                        },
                        {
                            key: "getString",
                            value: function(e1, t) {
                                var r = {}, o = !0, n = !1, s = void 0;
                                try {
                                    for(var i, a = this.DOM.attributes[Symbol.iterator](); !(o = (i = a.next()).done); o = !0){
                                        var l = i.value;
                                        r[l.nodeName] = l.nodeValue;
                                    }
                                } catch (e1) {
                                    n = !0, s = e1;
                                } finally{
                                    try {
                                        o || null == a.return || a.return();
                                    } finally{
                                        if (n) throw s;
                                    }
                                }
                                return r[e1] ? String(r[e1]) : t || null;
                            }
                        },
                        {
                            key: "setAttribute",
                            value: function(e1, t) {
                                this.DOM.setAttribute(e1, t);
                            }
                        },
                        {
                            key: "getContent",
                            value: function(e1) {
                                var t = this.DOM.textContent;
                                return (t = t.replace(/\s\s+/g, ",")) || e1 || null;
                            }
                        },
                        {
                            key: "setContent",
                            value: function(e1) {
                                this.DOM.children.length || (this.DOM.textContent = e1);
                            }
                        },
                        {
                            key: "serialize",
                            value: function() {
                                return (new XMLSerializer).serializeToString(this.DOM);
                            }
                        }
                    ], n(e1.prototype, r), o && n(e1, o), t;
                }();
                e1 = a.default;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.number.constructor": 173,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.string.replace": 196,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        305: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var i = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                i.default.prototype.abs = Math.abs, i.default.prototype.ceil = Math.ceil, i.default.prototype.constrain = function(e1, t, r) {
                    return i.default._validateParameters("constrain", arguments), Math.max(Math.min(e1, r), t);
                }, i.default.prototype.dist = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return i.default._validateParameters("dist", t), 4 === t.length ? Math.hypot(t[2] - t[0], t[3] - t[1]) : 6 === t.length ? Math.hypot(t[3] - t[0], t[4] - t[1], t[5] - t[2]) : void 0;
                }, i.default.prototype.exp = Math.exp, i.default.prototype.floor = Math.floor, i.default.prototype.lerp = function(e1, t, r) {
                    return i.default._validateParameters("lerp", arguments), r * (t - e1) + e1;
                }, i.default.prototype.log = Math.log, i.default.prototype.mag = function(e1, t) {
                    return i.default._validateParameters("mag", arguments), Math.hypot(e1, t);
                }, i.default.prototype.map = function(e1, t, r, o, n, s) {
                    i.default._validateParameters("map", arguments);
                    e1 = (e1 - t) / (r - t) * (n - o) + o;
                    return s ? o < n ? this.constrain(e1, o, n) : this.constrain(e1, n, o) : e1;
                }, i.default.prototype.max = function() {
                    for(var e1 = function(e1) {
                        var t = -1 / 0, r = !0, o = !1, n = void 0;
                        try {
                            for(var s, i = e1[Symbol.iterator](); !(r = (s = i.next()).done); r = !0)var a = s.value, t = t < a ? a : t;
                        } catch (e1) {
                            o = !0, n = e1;
                        } finally{
                            try {
                                r || null == i.return || i.return();
                            } finally{
                                if (o) throw n;
                            }
                        }
                        return t;
                    }, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return r[0] instanceof Array ? e1(r[0]) : e1(r);
                }, i.default.prototype.min = function() {
                    for(var e1 = function(e1) {
                        var t = 1 / 0, r = !0, o = !1, n = void 0;
                        try {
                            for(var s, i = e1[Symbol.iterator](); !(r = (s = i.next()).done); r = !0)var a = s.value, t = a < t ? a : t;
                        } catch (e1) {
                            o = !0, n = e1;
                        } finally{
                            try {
                                r || null == i.return || i.return();
                            } finally{
                                if (o) throw n;
                            }
                        }
                        return t;
                    }, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return r[0] instanceof Array ? e1(r[0]) : e1(r);
                }, i.default.prototype.norm = function(e1, t, r) {
                    return i.default._validateParameters("norm", arguments), this.map(e1, t, r, 0, 1);
                }, i.default.prototype.pow = Math.pow, i.default.prototype.round = function(e1, t) {
                    return t ? (t = Math.pow(10, t), Math.round(e1 * t) / t) : Math.round(e1);
                }, i.default.prototype.sq = function(e1) {
                    return e1 * e1;
                }, i.default.prototype.sqrt = Math.sqrt, i.default.prototype.fract = function(e1) {
                    i.default._validateParameters("fract", arguments);
                    var t, r = 0, e1 = Number(e1);
                    return isNaN(e1) || Math.abs(e1) === 1 / 0 ? e1 : (e1 < 0 && (e1 = -e1, r = 1), String(e1).includes(".") && !String(e1).includes("e") ? (t = String(e1), t = Number("0" + t.slice(t.indexOf("."))), Math.abs(r - t)) : e1 < 1 ? Math.abs(r - e1) : 0);
                };
                e1 = i.default;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.includes": 159,
                "core-js/modules/es.array.index-of": 160,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.map": 164,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.math.hypot": 170,
                "core-js/modules/es.number.constructor": 173,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.string.includes": 191,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        306: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.slice"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var o = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t, r) {
                    return (n = function() {
                        if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                            if ("function" == typeof Proxy) return 1;
                            try {
                                return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                            } catch (e1) {}
                        }
                    }() ? Reflect.construct : function(e1, t, r) {
                        var o = [
                            null
                        ];
                        o.push.apply(o, t);
                        t = new (Function.bind.apply(e1, o));
                        return r && s(t, r.prototype), t;
                    }).apply(null, arguments);
                }
                function s(e1, t) {
                    return (s = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                o.default.prototype.createVector = function(e1, t, r) {
                    return this instanceof o.default ? n(o.default.Vector, [
                        this._fromRadians.bind(this),
                        this._toRadians.bind(this)
                    ].concat(Array.prototype.slice.call(arguments))) : new o.default.Vector(e1, t, r);
                };
                e1 = o.default;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.reflect.construct": 184,
                "core-js/modules/es.regexp.to-string": 188
            }
        ],
        307: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function b(e1) {
                    return .5 * (1 - Math.cos(e1 * Math.PI));
                }
                var j, _ = 4095, x = 4, w = .5, e1 = (e1.default.prototype.noise = function(e1) {
                    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0, r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 0;
                    if (null == j) {
                        j = new Array(4096);
                        for(var o = 0; o < 4096; o++)j[o] = Math.random();
                    }
                    e1 < 0 && (e1 = -e1), t < 0 && (t = -t), r < 0 && (r = -r);
                    for(var n, s, i = Math.floor(e1), a = Math.floor(t), l = Math.floor(r), u = e1 - i, c = t - a, d = r - l, h = 0, f = .5, p = 0; p < x; p++){
                        var m = i + (a << 4) + (l << 8), y = b(u), g = b(c), v = j[m & _];
                        v += y * (j[m + 1 & _] - v), n = j[m + 16 & _], v += g * ((n += y * (j[m + 16 + 1 & _] - n)) - v), n = j[(m += 256) & _], n += y * (j[m + 1 & _] - n), s = j[m + 16 & _], n += g * ((s += y * (j[m + 16 + 1 & _] - s)) - n), h += (v += b(d) * (n - v)) * f, f *= w, i <<= 1, a <<= 1, l <<= 1, 1 <= (u *= 2) && (i++, u--), 1 <= (c *= 2) && (a++, c--), 1 <= (d *= 2) && (l++, d--);
                    }
                    return h;
                }, e1.default.prototype.noiseDetail = function(e1, t) {
                    0 < e1 && (x = e1), 0 < t && (w = t);
                }, e1.default.prototype.noiseSeed = function(e1) {
                    o = 4294967296;
                    var t, r, o, n = {
                        setSeed: function(e1) {
                            r = t = (null == e1 ? Math.random() * o : e1) >>> 0;
                        },
                        getSeed: function() {
                            return t;
                        },
                        rand: function() {
                            return (r = (1664525 * r + 1013904223) % o) / o;
                        }
                    };
                    n.setSeed(e1), j = new Array(4096);
                    for(var s = 0; s < 4096; s++)j[s] = n.rand();
                }, e1.default);
                r.default = e1;
            },
            {
                "../core/main": 275
            }
        ],
        308: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.every"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.math.sign"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.number.is-finite"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.sub"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.every"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.math.sign"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.number.is-finite"), e1("core-js/modules/es.string.sub"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var a = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = l();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function l() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, l = function() {
                        return e1;
                    }, e1);
                }
                function u(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function c(e1, t) {
                    return 0 !== e1 && (this.x = this.x % e1), 0 !== t && (this.y = this.y % t), this;
                }
                function d(e1, t, r) {
                    return 0 !== e1 && (this.x = this.x % e1), 0 !== t && (this.y = this.y % t), 0 !== r && (this.z = this.z % r), this;
                }
                a.default.Vector = function() {
                    function n() {
                        var e1 = this, t = n;
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                        var r, o, e1 = "function" == typeof (arguments.length <= 0 ? void 0 : arguments[0]) ? (this.isPInst = !0, this._fromRadians = arguments.length <= 0 ? void 0 : arguments[0], this._toRadians = arguments.length <= 1 ? void 0 : arguments[1], r = (arguments.length <= 2 ? void 0 : arguments[2]) || 0, o = (arguments.length <= 3 ? void 0 : arguments[3]) || 0, (arguments.length <= 4 ? void 0 : arguments[4]) || 0) : (r = (arguments.length <= 0 ? void 0 : arguments[0]) || 0, o = (arguments.length <= 1 ? void 0 : arguments[1]) || 0, (arguments.length <= 2 ? void 0 : arguments[2]) || 0);
                        this.x = r, this.y = o, this.z = e1;
                    }
                    var e1, t, r;
                    return e1 = n, r = [
                        {
                            key: "fromAngle",
                            value: function(e1, t) {
                                return new a.default.Vector((t = void 0 === t ? 1 : t) * Math.cos(e1), t * Math.sin(e1), 0);
                            }
                        },
                        {
                            key: "fromAngles",
                            value: function(e1, t, r) {
                                void 0 === r && (r = 1);
                                var o = Math.cos(t), t = Math.sin(t), n = Math.cos(e1), e1 = Math.sin(e1);
                                return new a.default.Vector(r * e1 * t, -r * n, r * e1 * o);
                            }
                        },
                        {
                            key: "random2D",
                            value: function() {
                                return this.fromAngle(Math.random() * s.TWO_PI);
                            }
                        },
                        {
                            key: "random3D",
                            value: function() {
                                var e1 = Math.random() * s.TWO_PI, t = 2 * Math.random() - 1, r = Math.sqrt(1 - t * t), o = r * Math.cos(e1), r = r * Math.sin(e1);
                                return new a.default.Vector(o, r, t);
                            }
                        },
                        {
                            key: "copy",
                            value: function(e1) {
                                return e1.copy(e1);
                            }
                        },
                        {
                            key: "add",
                            value: function(e1, t, r) {
                                return r ? r.set(e1) : (r = e1.copy(), 3 === arguments.length && a.default._friendlyError("The target parameter is undefined, it should be of type p5.Vector", "p5.Vector.add")), r.add(t), r;
                            }
                        },
                        {
                            key: "rem",
                            value: function(e1, t) {
                                if (e1 instanceof a.default.Vector && t instanceof a.default.Vector) return (e1 = e1.copy()).rem(t), e1;
                            }
                        },
                        {
                            key: "sub",
                            value: function(e1, t, r) {
                                return r ? r.set(e1) : (r = e1.copy(), 3 === arguments.length && a.default._friendlyError("The target parameter is undefined, it should be of type p5.Vector", "p5.Vector.sub")), r.sub(t), r;
                            }
                        },
                        {
                            key: "mult",
                            value: function(e1, t, r) {
                                return r ? r.set(e1) : (r = e1.copy(), 3 === arguments.length && a.default._friendlyError("The target parameter is undefined, it should be of type p5.Vector", "p5.Vector.mult")), r.mult(t), r;
                            }
                        },
                        {
                            key: "rotate",
                            value: function(e1, t, r) {
                                return 2 === arguments.length ? r = e1.copy() : (r instanceof a.default.Vector || a.default._friendlyError("The target parameter should be of type p5.Vector", "p5.Vector.rotate"), r.set(e1)), r.rotate(t), r;
                            }
                        },
                        {
                            key: "div",
                            value: function(e1, t, r) {
                                return r ? r.set(e1) : (r = e1.copy(), 3 === arguments.length && a.default._friendlyError("The target parameter is undefined, it should be of type p5.Vector", "p5.Vector.div")), r.div(t), r;
                            }
                        },
                        {
                            key: "dot",
                            value: function(e1, t) {
                                return e1.dot(t);
                            }
                        },
                        {
                            key: "cross",
                            value: function(e1, t) {
                                return e1.cross(t);
                            }
                        },
                        {
                            key: "dist",
                            value: function(e1, t) {
                                return e1.dist(t);
                            }
                        },
                        {
                            key: "lerp",
                            value: function(e1, t, r, o) {
                                return o ? o.set(e1) : (o = e1.copy(), 4 === arguments.length && a.default._friendlyError("The target parameter is undefined, it should be of type p5.Vector", "p5.Vector.lerp")), o.lerp(t, r), o;
                            }
                        },
                        {
                            key: "slerp",
                            value: function(e1, t, r, o) {
                                return o ? o.set(e1) : (o = e1.copy(), 4 === arguments.length && a.default._friendlyError("The target parameter is undefined, it should be of type p5.Vector", "p5.Vector.slerp")), o.slerp(t, r), o;
                            }
                        },
                        {
                            key: "mag",
                            value: function(e1) {
                                return e1.mag();
                            }
                        },
                        {
                            key: "magSq",
                            value: function(e1) {
                                return e1.magSq();
                            }
                        },
                        {
                            key: "normalize",
                            value: function(e1, t) {
                                return arguments.length < 2 ? t = e1.copy() : (t instanceof a.default.Vector || a.default._friendlyError("The target parameter should be of type p5.Vector", "p5.Vector.normalize"), t.set(e1)), t.normalize();
                            }
                        },
                        {
                            key: "limit",
                            value: function(e1, t, r) {
                                return arguments.length < 3 ? r = e1.copy() : (r instanceof a.default.Vector || a.default._friendlyError("The target parameter should be of type p5.Vector", "p5.Vector.limit"), r.set(e1)), r.limit(t);
                            }
                        },
                        {
                            key: "setMag",
                            value: function(e1, t, r) {
                                return arguments.length < 3 ? r = e1.copy() : (r instanceof a.default.Vector || a.default._friendlyError("The target parameter should be of type p5.Vector", "p5.Vector.setMag"), r.set(e1)), r.setMag(t);
                            }
                        },
                        {
                            key: "heading",
                            value: function(e1) {
                                return e1.heading();
                            }
                        },
                        {
                            key: "angleBetween",
                            value: function(e1, t) {
                                return e1.angleBetween(t);
                            }
                        },
                        {
                            key: "reflect",
                            value: function(e1, t, r) {
                                return arguments.length < 3 ? r = e1.copy() : (r instanceof a.default.Vector || a.default._friendlyError("The target parameter should be of type p5.Vector", "p5.Vector.reflect"), r.set(e1)), r.reflect(t);
                            }
                        },
                        {
                            key: "array",
                            value: function(e1) {
                                return e1.array();
                            }
                        },
                        {
                            key: "equals",
                            value: function(e1, t) {
                                var r;
                                return e1 instanceof a.default.Vector ? r = e1 : e1 instanceof Array ? r = (new a.default.Vector).set(e1) : a.default._friendlyError("The v1 parameter should be of type Array or p5.Vector", "p5.Vector.equals"), r.equals(t);
                            }
                        }
                    ], t = [
                        {
                            key: "toString",
                            value: function() {
                                return "p5.Vector Object : [".concat(this.x, ", ").concat(this.y, ", ").concat(this.z, "]");
                            }
                        },
                        {
                            key: "set",
                            value: function(e1, t, r) {
                                return e1 instanceof a.default.Vector ? (this.x = e1.x || 0, this.y = e1.y || 0, this.z = e1.z || 0) : Array.isArray(e1) ? (this.x = e1[0] || 0, this.y = e1[1] || 0, this.z = e1[2] || 0) : (this.x = e1 || 0, this.y = t || 0, this.z = r || 0), this;
                            }
                        },
                        {
                            key: "copy",
                            value: function() {
                                return this.isPInst ? new a.default.Vector(this._fromRadians, this._toRadians, this.x, this.y, this.z) : new a.default.Vector(this.x, this.y, this.z);
                            }
                        },
                        {
                            key: "add",
                            value: function(e1, t, r) {
                                return e1 instanceof a.default.Vector ? (this.x += e1.x || 0, this.y += e1.y || 0, this.z += e1.z || 0) : Array.isArray(e1) ? (this.x += e1[0] || 0, this.y += e1[1] || 0, this.z += e1[2] || 0) : (this.x += e1 || 0, this.y += t || 0, this.z += r || 0), this;
                            }
                        },
                        {
                            key: "rem",
                            value: function(e1, t, r) {
                                var o;
                                if (e1 instanceof a.default.Vector) {
                                    if ([
                                        e1.x,
                                        e1.y,
                                        e1.z
                                    ].every(Number.isFinite)) return n = parseFloat(e1.x), s = parseFloat(e1.y), o = parseFloat(e1.z), d.call(this, n, s, o);
                                } else if (Array.isArray(e1)) {
                                    if (e1.every(function(e1) {
                                        return Number.isFinite(e1);
                                    })) return 2 === e1.length ? c.call(this, e1[0], e1[1]) : 3 === e1.length ? d.call(this, e1[0], e1[1], e1[2]) : void 0;
                                } else if (1 === arguments.length) {
                                    if (Number.isFinite(e1) && 0 !== e1) return this.x = this.x % e1, this.y = this.y % e1, this.z = this.z % e1, this;
                                } else if (2 === arguments.length) {
                                    var n = Array.prototype.slice.call(arguments);
                                    if (n.every(function(e1) {
                                        return Number.isFinite(e1);
                                    }) && 2 === n.length) return c.call(this, n[0], n[1]);
                                } else if (3 === arguments.length) {
                                    var s = Array.prototype.slice.call(arguments);
                                    if (s.every(function(e1) {
                                        return Number.isFinite(e1);
                                    }) && 3 === s.length) return d.call(this, s[0], s[1], s[2]);
                                }
                            }
                        },
                        {
                            key: "sub",
                            value: function(e1, t, r) {
                                return e1 instanceof a.default.Vector ? (this.x -= e1.x || 0, this.y -= e1.y || 0, this.z -= e1.z || 0) : Array.isArray(e1) ? (this.x -= e1[0] || 0, this.y -= e1[1] || 0, this.z -= e1[2] || 0) : (this.x -= e1 || 0, this.y -= t || 0, this.z -= r || 0), this;
                            }
                        },
                        {
                            key: "mult",
                            value: function(e1, t, r) {
                                var o;
                                return e1 instanceof a.default.Vector ? Number.isFinite(e1.x) && Number.isFinite(e1.y) && Number.isFinite(e1.z) && "number" == typeof e1.x && "number" == typeof e1.y && "number" == typeof e1.z ? (this.x *= e1.x, this.y *= e1.y, this.z *= e1.z) : console.warn("p5.Vector.prototype.mult:", "x contains components that are either undefined or not finite numbers") : Array.isArray(e1) ? e1.every(function(e1) {
                                    return Number.isFinite(e1);
                                }) && e1.every(function(e1) {
                                    return "number" == typeof e1;
                                }) ? 1 === e1.length ? (this.x *= e1[0], this.y *= e1[0], this.z *= e1[0]) : 2 === e1.length ? (this.x *= e1[0], this.y *= e1[1]) : 3 === e1.length && (this.x *= e1[0], this.y *= e1[1], this.z *= e1[2]) : console.warn("p5.Vector.prototype.mult:", "x contains elements that are either undefined or not finite numbers") : (o = Array.prototype.slice.call(arguments)).every(function(e1) {
                                    return Number.isFinite(e1);
                                }) && o.every(function(e1) {
                                    return "number" == typeof e1;
                                }) ? (1 === arguments.length && (this.x *= e1, this.y *= e1, this.z *= e1), 2 === arguments.length && (this.x *= e1, this.y *= t), 3 === arguments.length && (this.x *= e1, this.y *= t, this.z *= r)) : console.warn("p5.Vector.prototype.mult:", "x, y, or z arguments are either undefined or not a finite number"), this;
                            }
                        },
                        {
                            key: "div",
                            value: function(e1, t, r) {
                                if (e1 instanceof a.default.Vector) {
                                    if (Number.isFinite(e1.x) && Number.isFinite(e1.y) && Number.isFinite(e1.z) && "number" == typeof e1.x && "number" == typeof e1.y && "number" == typeof e1.z) {
                                        var o = 0 === e1.z && 0 === this.z;
                                        if (0 === e1.x || 0 === e1.y || !o && 0 === e1.z) return console.warn("p5.Vector.prototype.div:", "divide by 0"), this;
                                        this.x /= e1.x, this.y /= e1.y, o || (this.z /= e1.z);
                                    } else console.warn("p5.Vector.prototype.div:", "x contains components that are either undefined or not finite numbers");
                                } else if (Array.isArray(e1)) {
                                    if (e1.every(function(e1) {
                                        return Number.isFinite(e1);
                                    }) && e1.every(function(e1) {
                                        return "number" == typeof e1;
                                    })) {
                                        if (e1.some(function(e1) {
                                            return 0 === e1;
                                        })) return console.warn("p5.Vector.prototype.div:", "divide by 0"), this;
                                        1 === e1.length ? (this.x /= e1[0], this.y /= e1[0], this.z /= e1[0]) : 2 === e1.length ? (this.x /= e1[0], this.y /= e1[1]) : 3 === e1.length && (this.x /= e1[0], this.y /= e1[1], this.z /= e1[2]);
                                    } else console.warn("p5.Vector.prototype.div:", "x contains components that are either undefined or not finite numbers");
                                } else {
                                    o = Array.prototype.slice.call(arguments);
                                    if (o.every(function(e1) {
                                        return Number.isFinite(e1);
                                    }) && o.every(function(e1) {
                                        return "number" == typeof e1;
                                    })) {
                                        if (o.some(function(e1) {
                                            return 0 === e1;
                                        })) return console.warn("p5.Vector.prototype.div:", "divide by 0"), this;
                                        1 === arguments.length && (this.x /= e1, this.y /= e1, this.z /= e1), 2 === arguments.length && (this.x /= e1, this.y /= t), 3 === arguments.length && (this.x /= e1, this.y /= t, this.z /= r);
                                    } else console.warn("p5.Vector.prototype.div:", "x, y, or z arguments are either undefined or not a finite number");
                                }
                                return this;
                            }
                        },
                        {
                            key: "mag",
                            value: function() {
                                return Math.sqrt(this.magSq());
                            }
                        },
                        {
                            key: "magSq",
                            value: function() {
                                var e1 = this.x, t = this.y, r = this.z;
                                return e1 * e1 + t * t + r * r;
                            }
                        },
                        {
                            key: "dot",
                            value: function(e1, t, r) {
                                return e1 instanceof a.default.Vector ? this.dot(e1.x, e1.y, e1.z) : this.x * (e1 || 0) + this.y * (t || 0) + this.z * (r || 0);
                            }
                        },
                        {
                            key: "cross",
                            value: function(e1) {
                                var t = this.y * e1.z - this.z * e1.y, r = this.z * e1.x - this.x * e1.z, e1 = this.x * e1.y - this.y * e1.x;
                                return this.isPInst ? new a.default.Vector(this._fromRadians, this._toRadians, t, r, e1) : new a.default.Vector(t, r, e1);
                            }
                        },
                        {
                            key: "dist",
                            value: function(e1) {
                                return e1.copy().sub(this).mag();
                            }
                        },
                        {
                            key: "normalize",
                            value: function() {
                                var e1 = this.mag();
                                return 0 !== e1 && this.mult(1 / e1), this;
                            }
                        },
                        {
                            key: "limit",
                            value: function(e1) {
                                var t = this.magSq();
                                return e1 * e1 < t && this.div(Math.sqrt(t)).mult(e1), this;
                            }
                        },
                        {
                            key: "setMag",
                            value: function(e1) {
                                return this.normalize().mult(e1);
                            }
                        },
                        {
                            key: "heading",
                            value: function() {
                                var e1 = Math.atan2(this.y, this.x);
                                return this.isPInst ? this._fromRadians(e1) : e1;
                            }
                        },
                        {
                            key: "setHeading",
                            value: function(e1) {
                                this.isPInst && (e1 = this._toRadians(e1));
                                var t = this.mag();
                                return this.x = t * Math.cos(e1), this.y = t * Math.sin(e1), this;
                            }
                        },
                        {
                            key: "rotate",
                            value: function(e1) {
                                var e1 = this.heading() + e1, t = (this.isPInst && (e1 = this._toRadians(e1)), this.mag());
                                return this.x = Math.cos(e1) * t, this.y = Math.sin(e1) * t, this;
                            }
                        },
                        {
                            key: "angleBetween",
                            value: function(e1) {
                                var t;
                                return 0 == this.magSq() * e1.magSq() ? NaN : (t = this.cross(e1), e1 = Math.atan2(t.mag(), this.dot(e1)) * Math.sign(t.z || 1), this.isPInst ? this._fromRadians(e1) : e1);
                            }
                        },
                        {
                            key: "lerp",
                            value: function(e1, t, r, o) {
                                return e1 instanceof a.default.Vector ? this.lerp(e1.x, e1.y, e1.z, t) : (this.x += (e1 - this.x) * o || 0, this.y += (t - this.y) * o || 0, this.z += (r - this.z) * o || 0, this);
                            }
                        },
                        {
                            key: "slerp",
                            value: function(e1, t) {
                                if (0 !== t) {
                                    if (1 === t) return this.set(e1);
                                    var r = this.mag(), o = e1.mag();
                                    if (0 == r * o) this.mult(1 - t).add(e1.x * t, e1.y * t, e1.z * t);
                                    else {
                                        var n = this.cross(e1), s = n.mag(), i = Math.atan2(s, this.dot(e1));
                                        if (0 < s) n.x /= s, n.y /= s, n.z /= s;
                                        else {
                                            if (i < .5 * Math.PI) return this.mult(1 - t).add(e1.x * t, e1.y * t, e1.z * t), this;
                                            0 === this.z && 0 === e1.z ? n.set(0, 0, 1) : 0 !== this.x ? n.set(this.y, -this.x, 0).normalize() : n.set(1, 0, 0);
                                        }
                                        s = n.cross(this), e1 = 1 - t + t * o / r, n = e1 * Math.cos(t * i), o = e1 * Math.sin(t * i);
                                        this.x = this.x * n + s.x * o, this.y = this.y * n + s.y * o, this.z = this.z * n + s.z * o;
                                    }
                                }
                                return this;
                            }
                        },
                        {
                            key: "reflect",
                            value: function(e1) {
                                return e1.normalize(), this.sub(e1.mult(2 * this.dot(e1)));
                            }
                        },
                        {
                            key: "array",
                            value: function() {
                                return [
                                    this.x || 0,
                                    this.y || 0,
                                    this.z || 0
                                ];
                            }
                        },
                        {
                            key: "equals",
                            value: function(e1, t, r) {
                                var o, n, e1 = e1 instanceof a.default.Vector ? (o = e1.x || 0, n = e1.y || 0, e1.z || 0) : Array.isArray(e1) ? (o = e1[0] || 0, n = e1[1] || 0, e1[2] || 0) : (o = e1 || 0, n = t || 0, r || 0);
                                return this.x === o && this.y === n && this.z === e1;
                            }
                        }
                    ], u(e1.prototype, t), r && u(e1, r), n;
                }();
                var n = a.default.Vector;
                r.default = n;
            },
            {
                "../core/constants": 264,
                "../core/main": 275,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.every": 153,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.array.some": 166,
                "core-js/modules/es.math.sign": 172,
                "core-js/modules/es.number.constructor": 173,
                "core-js/modules/es.number.is-finite": 174,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.string.sub": 200,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        309: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                var s = "_lcg_random_state", o = 4294967296, i = 0, e1 = (n.default.prototype._lcg = function(e1) {
                    return this[e1] = (1664525 * this[e1] + 1013904223) % o, this[e1] / o;
                }, n.default.prototype._lcgSetSeed = function(e1, t) {
                    this[e1] = (null == t ? Math.random() * o : t) >>> 0;
                }, n.default.prototype.randomSeed = function(e1) {
                    this._lcgSetSeed(s, e1), this._gaussian_previous = !1;
                }, n.default.prototype.random = function(e1, t) {
                    var r, o;
                    return n.default._validateParameters("random", arguments), r = null != this[s] ? this._lcg(s) : Math.random(), void 0 === e1 ? r : void 0 === t ? e1 instanceof Array ? e1[Math.floor(r * e1.length)] : r * e1 : (t < e1 && (o = e1, e1 = t, t = o), r * (t - e1) + e1);
                }, n.default.prototype.randomGaussian = function(e1) {
                    var t, r, o, n, s = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 1;
                    if (this._gaussian_previous) t = i, this._gaussian_previous = !1;
                    else {
                        for(; 1 <= (n = (r = this.random(2) - 1) * r + (o = this.random(2) - 1) * o););
                        t = r * (n = Math.sqrt(-2 * Math.log(n) / n)), i = o * n, this._gaussian_previous = !0;
                    }
                    return t * s + (e1 || 0);
                }, n.default);
                r.default = e1;
            },
            {
                "../core/main": 275
            }
        ],
        310: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (l = e1("../core/main")) && l.__esModule ? l : {
                    default: l
                }, s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                n.default.prototype._angleMode = s.RADIANS, n.default.prototype.acos = function(e1) {
                    return this._fromRadians(Math.acos(e1));
                }, n.default.prototype.asin = function(e1) {
                    return this._fromRadians(Math.asin(e1));
                }, n.default.prototype.atan = function(e1) {
                    return this._fromRadians(Math.atan(e1));
                }, n.default.prototype.atan2 = function(e1, t) {
                    return this._fromRadians(Math.atan2(e1, t));
                }, n.default.prototype.cos = function(e1) {
                    return Math.cos(this._toRadians(e1));
                }, n.default.prototype.sin = function(e1) {
                    return Math.sin(this._toRadians(e1));
                }, n.default.prototype.tan = function(e1) {
                    return Math.tan(this._toRadians(e1));
                }, n.default.prototype.degrees = function(e1) {
                    return e1 * s.RAD_TO_DEG;
                }, n.default.prototype.radians = function(e1) {
                    return e1 * s.DEG_TO_RAD;
                }, n.default.prototype.angleMode = function(e1) {
                    if (n.default._validateParameters("angleMode", arguments), void 0 === e1) return this._angleMode;
                    e1 !== s.DEGREES && e1 !== s.RADIANS || (this._angleMode = e1);
                }, n.default.prototype._toRadians = function(e1) {
                    return this._angleMode === s.DEGREES ? e1 * s.DEG_TO_RAD : e1;
                }, n.default.prototype._toDegrees = function(e1) {
                    return this._angleMode === s.RADIANS ? e1 * s.RAD_TO_DEG : e1;
                }, n.default.prototype._fromRadians = function(e1) {
                    return this._angleMode === s.DEGREES ? e1 * s.RAD_TO_DEG : e1;
                };
                var l = n.default;
                r.default = l;
            },
            {
                "../core/constants": 264,
                "../core/main": 275,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        311: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var i = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                i.default.prototype.textAlign = function(e1, t) {
                    var r;
                    return i.default._validateParameters("textAlign", arguments), (r = this._renderer).textAlign.apply(r, arguments);
                }, i.default.prototype.textLeading = function(e1) {
                    var t;
                    return i.default._validateParameters("textLeading", arguments), (t = this._renderer).textLeading.apply(t, arguments);
                }, i.default.prototype.textSize = function(e1) {
                    var t;
                    return i.default._validateParameters("textSize", arguments), (t = this._renderer).textSize.apply(t, arguments);
                }, i.default.prototype.textStyle = function(e1) {
                    var t;
                    return i.default._validateParameters("textStyle", arguments), (t = this._renderer).textStyle.apply(t, arguments);
                }, i.default.prototype.textWidth = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    if (t[0] += "", i.default._validateParameters("textWidth", t), 0 === t[0].length) return 0;
                    for(var o = t[0].replace(/\t/g, "  ").split(/\r?\n|\r|\n/g), n = [], s = 0; s < o.length; s++)n.push(this._renderer.textWidth(o[s]));
                    return Math.max.apply(Math, n);
                }, i.default.prototype.textAscent = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return i.default._validateParameters("textAscent", t), this._renderer.textAscent();
                }, i.default.prototype.textDescent = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return i.default._validateParameters("textDescent", t), this._renderer.textDescent();
                }, i.default.prototype._updateTextMetrics = function() {
                    return this._renderer._updateTextMetrics();
                }, i.default.prototype.textWrap = function(e1) {
                    if ("WORD" !== e1 && "CHAR" !== e1) throw "Error: textWrap accepts only WORD or CHAR";
                    return this._renderer.textWrap(e1);
                };
                e1 = i.default;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.string.replace": 196,
                "core-js/modules/es.string.split": 198
            }
        ],
        312: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.split"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l = (c = e1("../core/main")) && c.__esModule ? c : {
                    default: c
                }, n = s(e1("../core/constants")), u = s(e1("opentype.js"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function s(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o, n = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1)Object.prototype.hasOwnProperty.call(e1, r) && ((o = s ? Object.getOwnPropertyDescriptor(e1, r) : null) && (o.get || o.set) ? Object.defineProperty(n, r, o) : n[r] = e1[r]);
                    return n.default = e1, t && t.set(e1, n), n;
                }
                e1("../core/friendly_errors/validate_params"), e1("../core/friendly_errors/file_errors"), e1("../core/friendly_errors/fes_core"), l.default.prototype.loadFont = function(o, n, s) {
                    l.default._validateParameters("loadFont", arguments);
                    var i = new l.default.Font(this), a = this;
                    return u.load(o, function(e1, t) {
                        if (e1) return l.default._friendlyFileLoadError(4, o), void 0 !== s ? s(e1) : void console.error(e1, o);
                        i.font = t, void 0 !== n && n(i), a._decrementPreload();
                        var e1 = o.split("\\").pop().split("/").pop(), t = e1.lastIndexOf("."), r = t < 1 ? null : e1.slice(t + 1);
                        [
                            "ttf",
                            "otf",
                            "woff",
                            "woff2"
                        ].includes(r) && (r = e1.slice(0, -1 !== t ? t : 0), (e1 = document.createElement("style")).appendChild(document.createTextNode("\n@font-face {\nfont-family: ".concat(r, ";\nsrc: url(").concat(o, ");\n}\n"))), document.head.appendChild(e1));
                    }), i;
                }, l.default.prototype.text = function(e1, t, r, o, n) {
                    var s;
                    return l.default._validateParameters("text", arguments), this._renderer._doFill || this._renderer._doStroke ? (s = this._renderer).text.apply(s, arguments) : this;
                }, l.default.prototype.textFont = function(e1, t) {
                    if (l.default._validateParameters("textFont", arguments), arguments.length) {
                        if (e1) return this._renderer._setProperty("_textFont", e1), t && (this._renderer._setProperty("_textSize", t), this._renderer._leadingSet || this._renderer._setProperty("_textLeading", t * n._DEFAULT_LEADMULT)), this._renderer._applyTextProperties();
                        throw new Error("null font passed to textFont");
                    }
                    return this._renderer._textFont;
                };
                var c = l.default;
                r.default = c;
            },
            {
                "../core/constants": 264,
                "../core/friendly_errors/fes_core": 266,
                "../core/friendly_errors/file_errors": 267,
                "../core/friendly_errors/validate_params": 270,
                "../core/main": 275,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.includes": 159,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.last-index-of": 163,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.string.split": 198,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238,
                "opentype.js": 249
            }
        ],
        313: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, v = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== j(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = i();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function i() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, i = function() {
                        return e1;
                    }, e1);
                }
                function j(e1) {
                    return (j = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function _(e1, t) {
                    var r = e1.length;
                    return e1[t < 0 ? t % r + r : t % r];
                }
                function x(e1, t, r, o) {
                    var n, s, i;
                    return o ? (void 0 === x.tmpPoint1 && (x.tmpPoint1 = [], x.tmpPoint2 = []), s = x.tmpPoint1, i = x.tmpPoint2, s.x = t.x - e1.x, s.y = t.y - e1.y, i.x = r.x - t.x, i.y = r.y - t.y, n = s.x * i.x + s.y * i.y, s = Math.sqrt(s.x * s.x + s.y * s.y), i = Math.sqrt(i.x * i.x + i.y * i.y), Math.acos(n / (s * i)) < o) : 0 == (t[0] - e1[0]) * (r[1] - e1[1]) - (r[0] - e1[0]) * (t[1] - e1[1]);
                }
                function d(e1, t, r, o, n, s, i, a, l) {
                    var u = 1 - l, c = Math.pow(u, 3), d = Math.pow(u, 2), h = l * l, f = h * l, p = c * e1 + 3 * d * l * r + 3 * u * l * l * n + f * i, c = c * t + 3 * d * l * o + 3 * u * l * l * s + f * a, d = e1 + 2 * l * (r - e1) + h * (n - 2 * r + e1), f = t + 2 * l * (o - t) + h * (s - 2 * o + t), m = r + 2 * l * (n - r) + h * (i - 2 * n + r), h = o + 2 * l * (s - o) + h * (a - 2 * s + o), e1 = u * e1 + l * r, r = u * t + l * o, t = u * n + l * i, o = u * s + l * a, n = 90 - 180 * Math.atan2(d - m, f - h) / Math.PI;
                    return (m < d || f < h) && (n += 180), {
                        x: p,
                        y: c,
                        m: {
                            x: d,
                            y: f
                        },
                        n: {
                            x: m,
                            y: h
                        },
                        start: {
                            x: e1,
                            y: r
                        },
                        end: {
                            x: t,
                            y: o
                        },
                        alpha: n
                    };
                }
                function h(e1, t, r, o, n, s, i, a, l) {
                    return null == l ? f(e1, t, r, o, n, s, i, a) : d(e1, t, r, o, n, s, i, a, function(e1, t, r, o, n, s, i, a, l) {
                        if (!(l < 0 || f(e1, t, r, o, n, s, i, a) < l)) {
                            var u, c = .5, d = 1 - c;
                            for(u = f(e1, t, r, o, n, s, i, a, d); .01 < Math.abs(u - l);)u = f(e1, t, r, o, n, s, i, a, d += (u < l ? 1 : -1) * (c /= 2));
                            return d;
                        }
                    }(e1, t, r, o, n, s, i, a, l));
                }
                function w(e1, t, r) {
                    for(var o, n, s, i, a, l = 0, u = 0, c = (e1 = function(e1, t) {
                        function r(e1, t, r) {
                            var o, n;
                            if (!e1) return [
                                "C",
                                t.x,
                                t.y,
                                t.x,
                                t.y,
                                t.x,
                                t.y
                            ];
                            switch((e1[0] in {
                                T: 1,
                                Q: 1
                            }) || (t.qx = t.qy = null), e1[0]){
                                case "M":
                                    t.X = e1[1], t.Y = e1[2];
                                    break;
                                case "A":
                                    e1 = [
                                        "C"
                                    ].concat(M.apply(0, [
                                        t.x,
                                        t.y
                                    ].concat(e1.slice(1))));
                                    break;
                                case "S":
                                    n = "C" === r || "S" === r ? (o = 2 * t.x - t.bx, 2 * t.y - t.by) : (o = t.x, t.y), e1 = [
                                        "C",
                                        o,
                                        n
                                    ].concat(e1.slice(1));
                                    break;
                                case "T":
                                    "Q" === r || "T" === r ? (t.qx = 2 * t.x - t.qx, t.qy = 2 * t.y - t.qy) : (t.qx = t.x, t.qy = t.y), e1 = [
                                        "C"
                                    ].concat(E(t.x, t.y, t.qx, t.qy, e1[1], e1[2]));
                                    break;
                                case "Q":
                                    t.qx = e1[1], t.qy = e1[2], e1 = [
                                        "C"
                                    ].concat(E(t.x, t.y, e1[1], e1[2], e1[3], e1[4]));
                                    break;
                                case "L":
                                    e1 = [
                                        "C"
                                    ].concat(T(t.x, t.y, e1[1], e1[2]));
                                    break;
                                case "H":
                                    e1 = [
                                        "C"
                                    ].concat(T(t.x, t.y, e1[1], t.y));
                                    break;
                                case "V":
                                    e1 = [
                                        "C"
                                    ].concat(T(t.x, t.y, t.x, e1[1]));
                                    break;
                                case "Z":
                                    e1 = [
                                        "C"
                                    ].concat(T(t.x, t.y, t.X, t.Y));
                            }
                            return e1;
                        }
                        function o(e1, t) {
                            if (7 < e1[t].length) {
                                e1[t].shift();
                                for(var r = e1[t]; r.length;)c[t] = "A", a && (d[t] = "A"), e1.splice(t++, 0, [
                                    "C"
                                ].concat(r.splice(0, 6)));
                                e1.splice(t, 1), s = Math.max(i.length, a && a.length || 0);
                            }
                        }
                        function n(e1, t, r, o, n) {
                            e1 && t && "M" === e1[n][0] && "M" !== t[n][0] && (t.splice(n, 0, [
                                "M",
                                o.x,
                                o.y
                            ]), r.bx = 0, r.by = 0, r.x = e1[n][1], r.y = e1[n][2], s = Math.max(i.length, a && a.length || 0));
                        }
                        var s, i = b(e1), a = t && b(t), l = {
                            x: 0,
                            y: 0,
                            bx: 0,
                            by: 0,
                            X: 0,
                            Y: 0,
                            qx: null,
                            qy: null
                        }, u = {
                            x: 0,
                            y: 0,
                            bx: 0,
                            by: 0,
                            X: 0,
                            Y: 0,
                            qx: null,
                            qy: null
                        }, c = [], d = [], h = "", f = "";
                        s = Math.max(i.length, a && a.length || 0);
                        for(var p = 0; p < s; p++){
                            "C" !== (h = i[p] ? i[p][0] : h) && (c[p] = h, p && (f = c[p - 1])), i[p] = r(i[p], l, f), "A" !== c[p] && "C" === h && (c[p] = "C"), o(i, p), a && ("C" !== (h = a[p] ? a[p][0] : h) && (d[p] = h, p && (f = d[p - 1])), a[p] = r(a[p], u, f), "A" !== d[p] && "C" === h && (d[p] = "C"), o(a, p)), n(i, a, l, u, p), n(a, i, u, l, p);
                            var m = i[p], y = a && a[p], g = m.length, v = a && y.length;
                            l.x = m[g - 2], l.y = m[g - 1], l.bx = parseFloat(m[g - 4]) || l.x, l.by = parseFloat(m[g - 3]) || l.y, u.bx = a && (parseFloat(y[v - 4]) || u.x), u.by = a && (parseFloat(y[v - 3]) || u.y), u.x = a && y[v - 2], u.y = a && y[v - 1];
                        }
                        return a ? [
                            i,
                            a
                        ] : i;
                    }(e1)).length; u < c; u++){
                        if ("M" === (s = e1[u])[0]) o = +s[1], n = +s[2];
                        else {
                            if (t < l + (i = h(o, n, s[1], s[2], s[3], s[4], s[5], s[6])) && !r) return {
                                x: (a = h(o, n, s[1], s[2], s[3], s[4], s[5], s[6], t - l)).x,
                                y: a.y,
                                alpha: a.alpha
                            };
                            l += i, o = +s[5], n = +s[6];
                        }
                        s.shift();
                    }
                    return a = (a = r ? l : d(o, n, s[0], s[1], s[2], s[3], s[4], s[5], 1)).alpha ? {
                        x: a.x,
                        y: a.y,
                        alpha: a.alpha
                    } : a;
                }
                function b(e1) {
                    var t = [], r = 0, o = 0, n = 0, s = 0, i = 0;
                    if (e1) {
                        "M" === e1[0][0] && (n = r = +e1[0][1], s = o = +e1[0][2], i++, t[0] = [
                            "M",
                            r,
                            o
                        ]);
                        for(var a, l, u = 3 === e1.length && "M" === e1[0][0] && "R" === e1[1][0].toUpperCase() && "Z" === e1[2][0].toUpperCase(), c = i, d = e1.length; c < d; c++){
                            if (t.push(a = []), (l = e1[c])[0] !== String.prototype.toUpperCase.call(l[0])) switch(a[0] = String.prototype.toUpperCase.call(l[0]), a[0]){
                                case "A":
                                    a[1] = l[1], a[2] = l[2], a[3] = l[3], a[4] = l[4], a[5] = l[5], a[6] = +(l[6] + r), a[7] = +(l[7] + o);
                                    break;
                                case "V":
                                    a[1] = +l[1] + o;
                                    break;
                                case "H":
                                    a[1] = +l[1] + r;
                                    break;
                                case "R":
                                    for(var h, f = 2, p = (h = [
                                        r,
                                        o
                                    ].concat(l.slice(1))).length; f < p; f++)h[f] = +h[f] + r, h[++f] = +h[f] + o;
                                    t.pop(), t = t.concat(S(h, u));
                                    break;
                                case "M":
                                    n = +l[1] + r, s = +l[2] + o;
                                    break;
                                default:
                                    for(var m = 1, y = l.length; m < y; m++)a[m] = +l[m] + (m % 2 ? r : o);
                            }
                            else if ("R" === l[0]) h = [
                                r,
                                o
                            ].concat(l.slice(1)), t.pop(), t = t.concat(S(h, u)), a = [
                                "R"
                            ].concat(l.slice(-2));
                            else for(var g = 0, v = l.length; g < v; g++)a[g] = l[g];
                            switch(a[0]){
                                case "Z":
                                    r = n, o = s;
                                    break;
                                case "H":
                                    r = a[1];
                                    break;
                                case "V":
                                    o = a[1];
                                    break;
                                case "M":
                                    n = a[a.length - 2], s = a[a.length - 1];
                                    break;
                                default:
                                    r = a[a.length - 2], o = a[a.length - 1];
                            }
                        }
                    }
                    return t;
                }
                function M(e1, t, r, o, n, s, i, a, l, u) {
                    function c(e1, t, r) {
                        return {
                            x: e1 * Math.cos(r) - t * Math.sin(r),
                            y: e1 * Math.sin(r) + t * Math.cos(r)
                        };
                    }
                    var d, h = Math.PI, f = 120 * h / 180, p = h / 180 * (+n || 0), m = [], y = (u ? (x = u[0], d = u[1], j = u[2], _ = u[3]) : (e1 = (v = c(e1, t, -p)).x, t = v.y, 1 < (y = (g = (e1 - (a = (v = c(a, l, -p)).x)) / 2) * g / (r * r) + (v = (t - (l = v.y)) / 2) * v / (o * o)) && (r *= y = Math.sqrt(y), o *= y), y = r * r, b = o * o, j = (s = (s === i ? -1 : 1) * Math.sqrt(Math.abs((y * b - y * v * v - b * g * g) / (y * v * v + b * g * g)))) * r * v / o + (e1 + a) / 2, _ = s * -o * g / r + (t + l) / 2, x = Math.asin(((t - _) / o).toFixed(9)), d = Math.asin(((l - _) / o).toFixed(9)), (x = e1 < j ? h - x : x) < 0 && (x = 2 * h + x), (d = a < j ? h - d : d) < 0 && (d = 2 * h + d), i && d < x && (x -= 2 * h), !i && x < d && (d -= 2 * h)), d - x), g = (Math.abs(y) > f && (b = d, v = a, s = l, d = x + f * (i && x < d ? 1 : -1), m = M(a = j + r * Math.cos(d), l = _ + o * Math.sin(d), r, o, n, 0, i, v, s, [
                        d,
                        b,
                        j,
                        _
                    ])), y = d - x, Math.cos(x)), h = Math.sin(x), f = Math.cos(d), n = Math.sin(d), i = Math.tan(y / 4), v = 4 / 3 * r * i, s = 4 / 3 * o * i, b = [
                        e1,
                        t
                    ], j = [
                        e1 + v * h,
                        t - s * g
                    ], _ = [
                        a + v * n,
                        l - s * f
                    ], x = [
                        a,
                        l
                    ];
                    if (j[0] = 2 * b[0] - j[0], j[1] = 2 * b[1] - j[1], u) return [
                        j,
                        _,
                        x
                    ].concat(m);
                    for(var w = [], S = 0, T = (m = [
                        j,
                        _,
                        x
                    ].concat(m).join().split(",")).length; S < T; S++)w[S] = S % 2 ? c(m[S - 1], m[S], p).y : c(m[S], m[S + 1], p).x;
                    return w;
                }
                function S(e1, t) {
                    for(var r = [], o = 0, n = e1.length; o < n - 2 * !t; o += 2){
                        var s = [
                            {
                                x: +e1[o - 2],
                                y: +e1[o - 1]
                            },
                            {
                                x: +e1[o],
                                y: +e1[o + 1]
                            },
                            {
                                x: +e1[o + 2],
                                y: +e1[o + 3]
                            },
                            {
                                x: +e1[o + 4],
                                y: +e1[o + 5]
                            }
                        ];
                        t ? o ? n - 4 === o ? s[3] = {
                            x: +e1[0],
                            y: +e1[1]
                        } : n - 2 === o && (s[2] = {
                            x: +e1[0],
                            y: +e1[1]
                        }, s[3] = {
                            x: +e1[2],
                            y: +e1[3]
                        }) : s[0] = {
                            x: +e1[n - 2],
                            y: +e1[n - 1]
                        } : n - 4 === o ? s[3] = s[2] : o || (s[0] = {
                            x: +e1[o],
                            y: +e1[o + 1]
                        }), r.push([
                            "C",
                            (-s[0].x + 6 * s[1].x + s[2].x) / 6,
                            (-s[0].y + 6 * s[1].y + s[2].y) / 6,
                            (s[1].x + 6 * s[2].x - s[3].x) / 6,
                            (s[1].y + 6 * s[2].y - s[3].y) / 6,
                            s[2].x,
                            s[2].y
                        ]);
                    }
                    return r;
                }
                function T(e1, t, r, o) {
                    return [
                        e1,
                        t,
                        r,
                        o,
                        r,
                        o
                    ];
                }
                function E(e1, t, r, o, n, s) {
                    return [
                        1 / 3 * e1 + 2 / 3 * r,
                        1 / 3 * t + 2 / 3 * o,
                        1 / 3 * n + 2 / 3 * r,
                        1 / 3 * s + 2 / 3 * o,
                        n,
                        s
                    ];
                }
                function f(e1, t, r, o, n, s, i, a, l) {
                    for(var u = (l = 1 < (l = null == l ? 1 : l) ? 1 : l < 0 ? 0 : l) / 2, c = [
                        -0.1252,
                        .1252,
                        -0.3678,
                        .3678,
                        -0.5873,
                        .5873,
                        -0.7699,
                        .7699,
                        -0.9041,
                        .9041,
                        -0.9816,
                        .9816
                    ], d = 0, h = [
                        .2491,
                        .2491,
                        .2335,
                        .2335,
                        .2032,
                        .2032,
                        .1601,
                        .1601,
                        .1069,
                        .1069,
                        .0472,
                        .0472
                    ], f = 0; f < 12; f++){
                        var p = u * c[f] + u, m = y(p, e1, r, n, i), p = y(p, t, o, s, a);
                        d += h[f] * Math.sqrt(m * m + p * p);
                    }
                    return u * d;
                }
                function y(e1, t, r, o, n) {
                    return e1 * (e1 * (-3 * t + 9 * r - 9 * o + 3 * n) + 6 * t - 12 * r + 6 * o) - 3 * t + 3 * r;
                }
                n.default.Font = function() {
                    function t(e1) {
                        if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function");
                        this.parent = e1, this.cache = {}, this.font = void 0;
                    }
                    var e1, r, o;
                    return e1 = t, r = [
                        {
                            key: "textBounds",
                            value: function(e1) {
                                var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0, r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 0, o = 3 < arguments.length ? arguments[3] : void 0, n = 4 < arguments.length ? arguments[4] : void 0, s = n && n.renderer && n.renderer._pInst || this.parent, i = s._renderer.drawingContext, o = (i.textAlign || v.LEFT, i.textBaseline || v.BASELINE, o || s._renderer._textSize);
                                if (!g) {
                                    for(var a = [], l = [], u = [], c = (u[0] = [], []), d = this._scale(o), h = s._renderer.textLeading(), f = 0, p = (this.font.forEachGlyph(e1, t, r, o, n, function(e1, t, r, o) {
                                        var n = e1.getMetrics();
                                        0 === e1.index || 10 === e1.index ? u[f += 1] = [] : (u[f].push(t + n.xMin * d), u[f].push(t + n.xMax * d), c.push(r + f * h + -n.yMin * d), c.push(r + f * h + -n.yMax * d));
                                    }), 0 < u[f].length && (a[f] = Math.min.apply(null, u[f]), l[f] = Math.max.apply(null, u[f])), 0), m = 0; m <= f; m++){
                                        a[m] = Math.min.apply(null, u[m]), l[m] = Math.max.apply(null, u[m]);
                                        var y = l[m] - a[m];
                                        p < y && (p = y);
                                    }
                                    var i = Math.min.apply(null, a), g = {
                                        x: i,
                                        y: r = Math.min.apply(null, c),
                                        h: Math.max.apply(null, c) - r,
                                        w: p,
                                        advance: i - t
                                    }, o = this._handleAlignment(s._renderer, e1, g.x, g.y, g.w + g.advance);
                                    g.x = o.x, g.y = o.y;
                                }
                                return g;
                            }
                        },
                        {
                            key: "textToPoints",
                            value: function(e1, t, r, o, n) {
                                var s = t, i = [], a = e1.split(/\r?\n|\r|\n/g);
                                o = o || this.parent._renderer._textSize;
                                for(var l, u, c, d = 0; d < a.length; d++){
                                    var h = 0;
                                    t = s;
                                    for(var f = (f = a[d]).replace("	", "  "), p = this._getGlyphs(f), m = 0; m < p.length; m++){
                                        if (u = f, !((c = p)[l = m].name && "space" === c[l].name || u.length === c.length && " " === u[l])) for(var y = function(e1) {
                                            for(var t, r = [], o = 0; o < e1.length; o++)"M" === e1[o].type && (t && r.push(t), t = []), t.push(function(e1) {
                                                var t = [
                                                    e1.type
                                                ];
                                                "M" === e1.type || "L" === e1.type ? t.push(e1.x, e1.y) : "C" === e1.type ? t.push(e1.x1, e1.y1, e1.x2, e1.y2, e1.x, e1.y) : "Q" === e1.type && t.push(e1.x1, e1.y1, e1.x, e1.y);
                                                return t;
                                            }(e1[o]));
                                            return r.push(t), r;
                                        }(p[m].getPath(t, r, o).commands), g = 0; g < y.length; g++)for(var v = function(e1, t) {
                                            for(var t = function(e1, t) {
                                                if ("object" !== j(e1)) e1 = t;
                                                else for(var r in t)void 0 === e1[r] && (e1[r] = t[r]);
                                                return e1;
                                            }(t, {
                                                sampleFactor: .1,
                                                simplifyThreshold: 0
                                            }), r = w(e1, 0, 1), o = r / (r * t.sampleFactor), n = [], s = 0; s < r; s += o)n.push(w(e1, s));
                                            t.simplifyThreshold && !function(e1) {
                                                for(var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0, r = 0, o = e1.length - 1; 3 < e1.length && 0 <= o; --o)x(_(e1, o - 1), _(e1, o), _(e1, o + 1), t) && (e1.splice(o % e1.length, 1), r++);
                                            }(n, t.simplifyThreshold);
                                            return n;
                                        }(y[g], n), b = 0; b < v.length; b++)v[b].x += h, i.push(v[b]);
                                        h += p[m].advanceWidth * this._scale(o);
                                    }
                                    r += this.parent._renderer._textLeading;
                                }
                                return i;
                            }
                        },
                        {
                            key: "_getGlyphs",
                            value: function(e1) {
                                return this.font.stringToGlyphs(e1);
                            }
                        },
                        {
                            key: "_getPath",
                            value: function(e1, t, r, o) {
                                var n = (o && o.renderer && o.renderer._pInst || this.parent)._renderer, t = this._handleAlignment(n, e1, t, r);
                                return this.font.getPath(e1, t.x, t.y, n._textSize, o);
                            }
                        },
                        {
                            key: "_getPathData",
                            value: function(e1, t, r, o) {
                                var n = 3;
                                return "string" == typeof e1 && 2 < arguments.length ? e1 = this._getPath(e1, t, r, o) : "object" === j(t) && (o = t), o && "number" == typeof o.decimals && (n = o.decimals), e1.toPathData(n);
                            }
                        },
                        {
                            key: "_getSVG",
                            value: function(e1, t, r, o) {
                                var n = 3;
                                return "string" == typeof e1 && 2 < arguments.length ? e1 = this._getPath(e1, t, r, o) : "object" === j(t) && (o = t), o && ("number" == typeof o.decimals && (n = o.decimals), "number" == typeof o.strokeWidth && (e1.strokeWidth = o.strokeWidth), void 0 !== o.fill && (e1.fill = o.fill), void 0 !== o.stroke && (e1.stroke = o.stroke)), e1.toSVG(n);
                            }
                        },
                        {
                            key: "_renderPath",
                            value: function(e1, t, r, o) {
                                var n = o && o.renderer || this.parent._renderer, s = n.drawingContext, e1 = ("object" === j(e1) && e1.commands ? e1 : this._getPath(e1, t, r, o)).commands, i = (s.beginPath(), !0), t = !1, r = void 0;
                                try {
                                    for(var a, l = e1[Symbol.iterator](); !(i = (a = l.next()).done); i = !0){
                                        var u = a.value;
                                        "M" === u.type ? s.moveTo(u.x, u.y) : "L" === u.type ? s.lineTo(u.x, u.y) : "C" === u.type ? s.bezierCurveTo(u.x1, u.y1, u.x2, u.y2, u.x, u.y) : "Q" === u.type ? s.quadraticCurveTo(u.x1, u.y1, u.x, u.y) : "Z" === u.type && s.closePath();
                                    }
                                } catch (e1) {
                                    t = !0, r = e1;
                                } finally{
                                    try {
                                        i || null == l.return || l.return();
                                    } finally{
                                        if (t) throw r;
                                    }
                                }
                                return n._doStroke && n._strokeSet && !n._clipping && s.stroke(), n._doFill && !n._clipping && (n._fillSet || n._setFill(v._DEFAULT_TEXT_FILL), s.fill()), this;
                            }
                        },
                        {
                            key: "_textWidth",
                            value: function(e1, t) {
                                return this.font.getAdvanceWidth(e1, t);
                            }
                        },
                        {
                            key: "_textAscent",
                            value: function(e1) {
                                return this.font.ascender * this._scale(e1);
                            }
                        },
                        {
                            key: "_textDescent",
                            value: function(e1) {
                                return -this.font.descender * this._scale(e1);
                            }
                        },
                        {
                            key: "_scale",
                            value: function(e1) {
                                return 1 / this.font.unitsPerEm * (e1 || this.parent._renderer._textSize);
                            }
                        },
                        {
                            key: "_handleAlignment",
                            value: function(e1, t, r, o, n) {
                                var s = e1._textSize;
                                switch(void 0 === n && (n = this._textWidth(t, s)), e1._textAlign){
                                    case v.CENTER:
                                        r -= n / 2;
                                        break;
                                    case v.RIGHT:
                                        r -= n;
                                }
                                switch(e1._textBaseline){
                                    case v.TOP:
                                        o += this._textAscent(s);
                                        break;
                                    case v.CENTER:
                                        o += this._textAscent(s) / 2;
                                        break;
                                    case v.BOTTOM:
                                        o -= this._textDescent(s);
                                }
                                return {
                                    x: r,
                                    y: o
                                };
                            }
                        }
                    ], s(e1.prototype, r), o && s(e1, o), t;
                }();
                e1 = n.default;
                r.default = e1;
            },
            {
                "../core/constants": 264,
                "../core/main": 275,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.fill": 154,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.join": 162,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.array.splice": 167,
                "core-js/modules/es.function.name": 168,
                "core-js/modules/es.number.to-fixed": 175,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.string.replace": 196,
                "core-js/modules/es.string.split": 198,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        314: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.array-buffer.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.array-buffer.constructor"), e1("core-js/modules/es.object.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype.append = function(e1, t) {
                    return e1.push(t), e1;
                }, e1.default.prototype.arrayCopy = function(e1, t, r, o, n) {
                    var s, i;
                    e1 = void 0 !== n ? (i = Math.min(n, e1.length), s = o, e1.slice(t, i + t)) : (i = void 0 !== r ? (i = r, Math.min(i, e1.length)) : e1.length, r = t, e1.slice(s = 0, i)), Array.prototype.splice.apply(r, [
                        s,
                        i
                    ].concat(e1));
                }, e1.default.prototype.concat = function(e1, t) {
                    return e1.concat(t);
                }, e1.default.prototype.reverse = function(e1) {
                    return e1.reverse();
                }, e1.default.prototype.shorten = function(e1) {
                    return e1.pop(), e1;
                }, e1.default.prototype.shuffle = function(e1, t) {
                    for(var r, o, n = ArrayBuffer && ArrayBuffer.isView && ArrayBuffer.isView(e1), s = (e1 = t || n ? e1 : e1.slice()).length; 1 < s;)r = this.random(0, 1) * s | 0, o = e1[--s], e1[s] = e1[r], e1[r] = o;
                    return e1;
                }, e1.default.prototype.sort = function(e1, t) {
                    var r = t ? e1.slice(0, Math.min(t, e1.length)) : e1, t = t ? e1.slice(Math.min(t, e1.length)) : [];
                    return (r = "string" == typeof r[0] ? r.sort() : r.sort(function(e1, t) {
                        return e1 - t;
                    })).concat(t);
                }, e1.default.prototype.splice = function(e1, t, r) {
                    return Array.prototype.splice.apply(e1, [
                        r,
                        0
                    ].concat(t)), e1;
                }, e1.default.prototype.subset = function(e1, t, r) {
                    return void 0 !== r ? e1.slice(t, t + r) : e1.slice(t, e1.length);
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array-buffer.constructor": 150,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.array.splice": 167,
                "core-js/modules/es.object.to-string": 182
            }
        ],
        315: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.map"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.repeat"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.repeat"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var o = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                o.default.prototype.float = function(e1) {
                    return e1 instanceof Array ? e1.map(parseFloat) : parseFloat(e1);
                }, o.default.prototype.int = function(e1) {
                    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 10;
                    return e1 === 1 / 0 || "Infinity" === e1 ? 1 / 0 : e1 === -1 / 0 || "-Infinity" === e1 ? -1 / 0 : "string" == typeof e1 ? parseInt(e1, t) : "number" == typeof e1 ? 0 | e1 : "boolean" == typeof e1 ? e1 ? 1 : 0 : e1 instanceof Array ? e1.map(function(e1) {
                        return o.default.prototype.int(e1, t);
                    }) : void 0;
                }, o.default.prototype.str = function(e1) {
                    return e1 instanceof Array ? e1.map(o.default.prototype.str) : String(e1);
                }, o.default.prototype.boolean = function(e1) {
                    return "number" == typeof e1 ? 0 !== e1 : "string" == typeof e1 ? "true" === e1.toLowerCase() : "boolean" == typeof e1 ? e1 : e1 instanceof Array ? e1.map(o.default.prototype.boolean) : void 0;
                }, o.default.prototype.byte = function(e1) {
                    e1 = o.default.prototype.int(e1, 10);
                    return "number" == typeof e1 ? (e1 + 128) % 256 - 128 : e1 instanceof Array ? e1.map(o.default.prototype.byte) : void 0;
                }, o.default.prototype.char = function(e1) {
                    return "number" != typeof e1 || isNaN(e1) ? e1 instanceof Array ? e1.map(o.default.prototype.char) : "string" == typeof e1 ? o.default.prototype.char(parseInt(e1, 10)) : void 0 : String.fromCharCode(e1);
                }, o.default.prototype.unchar = function(e1) {
                    return "string" == typeof e1 && 1 === e1.length ? e1.charCodeAt(0) : e1 instanceof Array ? e1.map(o.default.prototype.unchar) : void 0;
                }, o.default.prototype.hex = function(e1, t) {
                    if (t = null == t ? 8 : t, e1 instanceof Array) return e1.map(function(e1) {
                        return o.default.prototype.hex(e1, t);
                    });
                    if (e1 === 1 / 0 || e1 === -1 / 0) return (e1 === 1 / 0 ? "F" : "0").repeat(t);
                    if ("number" == typeof e1) {
                        e1 < 0 && (e1 = 4294967295 + e1 + 1);
                        for(var r = Number(e1).toString(16).toUpperCase(); r.length < t;)r = "0".concat(r);
                        return r = r.length >= t ? r.substring(r.length - t, r.length) : r;
                    }
                }, o.default.prototype.unhex = function(e1) {
                    return e1 instanceof Array ? e1.map(o.default.prototype.unhex) : parseInt("0x".concat(e1), 16);
                };
                e1 = o.default;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.map": 164,
                "core-js/modules/es.number.constructor": 173,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.repeat": 195
            }
        ],
        316: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.pad-start"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.pad-start"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = (u = e1("../core/main")) && u.__esModule ? u : {
                    default: u
                };
                function i(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) {
                            var r = [], o = !0, n = !1, s = void 0;
                            try {
                                for(var i, a = e1[Symbol.iterator](); !(o = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); o = !0);
                            } catch (e1) {
                                n = !0, s = e1;
                            } finally{
                                try {
                                    o || null == a.return || a.return();
                                } finally{
                                    if (n) throw s;
                                }
                            }
                            return r;
                        }
                    }(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    }();
                }
                function o(e1, t, r) {
                    var o = i(e1.toString().split("."), 2), n = o[0], o = o[1];
                    return void 0 === r ? (n = n.padStart(t, "0"), o ? n + "." + o : n) : (n = (e1 = i(e1.toFixed(r).toString().split("."), 2))[0], o = e1[1], n = n.padStart(t, "0"), void 0 === o ? n : n + "." + o);
                }
                function n(e1, t) {
                    var r = (e1 = e1.toString()).indexOf("."), o = -1 !== r ? e1.substring(r) : "", e1 = (e1 = -1 !== r ? e1.substring(0, r) : e1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    if (0 === t) o = "";
                    else if (void 0 !== t) {
                        if (t > o.length) for(var n = t - (o += -1 === r ? "." : "").length + 1, s = 0; s < n; s++)o += "0";
                        else o = o.substring(0, t + 1);
                    }
                    return e1 + o;
                }
                function a(e1) {
                    return 0 < parseFloat(e1) ? "+".concat(e1.toString()) : e1.toString();
                }
                function l(e1) {
                    return 0 <= parseFloat(e1) ? " ".concat(e1.toString()) : e1.toString();
                }
                e1("../core/friendly_errors/validate_params"), e1("../core/friendly_errors/file_errors"), e1("../core/friendly_errors/fes_core"), s.default.prototype.join = function(e1, t) {
                    return s.default._validateParameters("join", arguments), e1.join(t);
                }, s.default.prototype.match = function(e1, t) {
                    return s.default._validateParameters("match", arguments), e1.match(t);
                }, s.default.prototype.matchAll = function(e1, t) {
                    s.default._validateParameters("matchAll", arguments);
                    for(var r = new RegExp(t, "g"), o = r.exec(e1), n = []; null !== o;)n.push(o), o = r.exec(e1);
                    return n;
                }, s.default.prototype.nf = function(e1, t, r) {
                    return s.default._validateParameters("nf", arguments), e1 instanceof Array ? e1.map(function(e1) {
                        return o(e1, t, r);
                    }) : "[object Arguments]" === Object.prototype.toString.call(e1) ? 3 === e1.length ? this.nf(e1[0], e1[1], e1[2]) : 2 === e1.length ? this.nf(e1[0], e1[1]) : this.nf(e1[0]) : o(e1, t, r);
                }, s.default.prototype.nfc = function(e1, t) {
                    return s.default._validateParameters("nfc", arguments), e1 instanceof Array ? e1.map(function(e1) {
                        return n(e1, t);
                    }) : n(e1, t);
                }, s.default.prototype.nfp = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    s.default._validateParameters("nfp", t);
                    var o = s.default.prototype.nf.apply(this, t);
                    return o instanceof Array ? o.map(a) : a(o);
                }, s.default.prototype.nfs = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    s.default._validateParameters("nfs", t);
                    var o = s.default.prototype.nf.apply(this, t);
                    return o instanceof Array ? o.map(l) : l(o);
                }, s.default.prototype.split = function(e1, t) {
                    return s.default._validateParameters("split", arguments), e1.split(t);
                }, s.default.prototype.splitTokens = function(e1, t) {
                    var r, o;
                    return s.default._validateParameters("splitTokens", arguments), o = void 0 !== t ? (o = /\]/g.exec(t), (r = /\[/g.exec(t)) && o ? (t = t.slice(0, o.index) + t.slice(o.index + 1), r = /\[/g.exec(t), t = t.slice(0, r.index) + t.slice(r.index + 1), new RegExp("[\\[".concat(t, "\\]]"), "g")) : o ? (t = t.slice(0, o.index) + t.slice(o.index + 1), new RegExp("[".concat(t, "\\]]"), "g")) : r ? (t = t.slice(0, r.index) + t.slice(r.index + 1), new RegExp("[".concat(t, "\\[]"), "g")) : new RegExp("[".concat(t, "]"), "g")) : /\s/g, e1.split(o).filter(function(e1) {
                        return e1;
                    });
                }, s.default.prototype.trim = function(e1) {
                    return s.default._validateParameters("trim", arguments), e1 instanceof Array ? e1.map(this.trim) : e1.trim();
                };
                var u = s.default;
                r.default = u;
            },
            {
                "../core/friendly_errors/fes_core": 266,
                "../core/friendly_errors/file_errors": 267,
                "../core/friendly_errors/validate_params": 270,
                "../core/main": 275,
                "core-js/modules/es.array.filter": 155,
                "core-js/modules/es.array.index-of": 160,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.join": 162,
                "core-js/modules/es.array.map": 164,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.number.to-fixed": 175,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.constructor": 186,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.string.match": 193,
                "core-js/modules/es.string.pad-start": 194,
                "core-js/modules/es.string.replace": 196,
                "core-js/modules/es.string.split": 198,
                "core-js/modules/es.string.trim": 201,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        317: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype.day = function() {
                    return (new Date).getDate();
                }, e1.default.prototype.hour = function() {
                    return (new Date).getHours();
                }, e1.default.prototype.minute = function() {
                    return (new Date).getMinutes();
                }, e1.default.prototype.millis = function() {
                    return -1 === this._millisStart ? 0 : window.performance.now() - this._millisStart;
                }, e1.default.prototype.month = function() {
                    return (new Date).getMonth() + 1;
                }, e1.default.prototype.second = function() {
                    return (new Date).getSeconds();
                }, e1.default.prototype.year = function() {
                    return (new Date).getFullYear();
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../core/main": 275
            }
        ],
        318: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.math.sign"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.math.sign"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var S = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, _ = (e1("./p5.Geometry"), function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants")));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                S.default.prototype.beginGeometry = function() {
                    return this._renderer.beginGeometry();
                }, S.default.prototype.endGeometry = function() {
                    return this._renderer.endGeometry();
                }, S.default.prototype.buildGeometry = function(e1) {
                    return this._renderer.buildGeometry(e1);
                }, S.default.prototype.freeGeometry = function(e1) {
                    this._renderer._freeBuffers(e1.gid);
                }, S.default.prototype.plane = function(e1, t, r, o) {
                    this._assert3d("plane"), S.default._validateParameters("plane", arguments), void 0 === e1 && (e1 = 50), void 0 === t && (t = e1), void 0 === o && (o = 1);
                    var n, s = "plane|".concat(r = void 0 === r ? 1 : r, "|").concat(o);
                    return this._renderer.geometryInHash(s) || ((n = new S.default.Geometry(r, o, function() {
                        for(var e1, t, r = 0; r <= this.detailY; r++)for(var o = r / this.detailY, n = 0; n <= this.detailX; n++)e1 = n / this.detailX, t = new S.default.Vector(e1 - .5, o - .5, 0), this.vertices.push(t), this.uvs.push(e1, o);
                    })).computeFaces().computeNormals(), r <= 1 && o <= 1 ? n._makeTriangleEdges()._edgesToVertices() : this._renderer._doStroke && console.log("Cannot draw stroke on plane objects with more than 1 detailX or 1 detailY"), this._renderer.createBuffers(s, n)), this._renderer.drawBuffersScaled(s, e1, t, 1), this;
                }, S.default.prototype.box = function(e1, t, r, o, n) {
                    this._assert3d("box"), S.default._validateParameters("box", arguments), void 0 === e1 && (e1 = 50), void 0 === t && (t = e1), void 0 === r && (r = t);
                    var s, i = this._renderer.attributes && this._renderer.attributes.perPixelLighting, i = (void 0 === n && (n = i ? 1 : 4), "box|".concat(o = void 0 === o ? i ? 1 : 4 : o, "|").concat(n));
                    return this._renderer.geometryInHash(i) || ((s = new S.default.Geometry(o, n, function() {
                        var n = this;
                        this.edges = [
                            [
                                0,
                                1
                            ],
                            [
                                1,
                                3
                            ],
                            [
                                3,
                                2
                            ],
                            [
                                6,
                                7
                            ],
                            [
                                8,
                                9
                            ],
                            [
                                9,
                                11
                            ],
                            [
                                14,
                                15
                            ],
                            [
                                16,
                                17
                            ],
                            [
                                17,
                                19
                            ],
                            [
                                18,
                                19
                            ],
                            [
                                20,
                                21
                            ],
                            [
                                22,
                                23
                            ]
                        ], [
                            [
                                0,
                                4,
                                2,
                                6
                            ],
                            [
                                1,
                                3,
                                5,
                                7
                            ],
                            [
                                0,
                                1,
                                4,
                                5
                            ],
                            [
                                2,
                                6,
                                3,
                                7
                            ],
                            [
                                0,
                                2,
                                1,
                                3
                            ],
                            [
                                4,
                                5,
                                6,
                                7
                            ]
                        ].forEach(function(e1, t) {
                            for(var t = 4 * t, r = 0; r < 4; r++){
                                var o = e1[r], o = new S.default.Vector((2 * (1 & o) - 1) / 2, ((2 & o) - 1) / 2, ((4 & o) / 2 - 1) / 2);
                                n.vertices.push(o), n.uvs.push(1 & r, (2 & r) / 2);
                            }
                            n.faces.push([
                                t,
                                1 + t,
                                2 + t
                            ]), n.faces.push([
                                2 + t,
                                1 + t,
                                3 + t
                            ]);
                        });
                    })).computeNormals(), o <= 4 && n <= 4 ? s._edgesToVertices() : this._renderer._doStroke && console.log("Cannot draw stroke on box objects with more than 4 detailX or 4 detailY"), this._renderer.createBuffers(i, s)), this._renderer.drawBuffersScaled(i, e1, t, r), this;
                }, S.default.prototype.sphere = function(e1, t, r) {
                    return this._assert3d("sphere"), S.default._validateParameters("sphere", arguments), this.ellipsoid(e1 = void 0 === e1 ? 50 : e1, e1, e1, t = void 0 === t ? 24 : t, r = void 0 === r ? 16 : r), this;
                };
                function l(e1, t, r, o, n, s, i) {
                    e1 = e1 <= 0 ? 1 : e1, t = t < 0 ? 0 : t, r = r <= 0 ? e1 : r, o = o < 3 ? 3 : o;
                    for(var a, l, u = (s = void 0 === s || s) ? -2 : 0, c = (n = n < 1 ? 1 : n) + ((i = void 0 === i ? 0 !== t : i) ? 2 : 0), d = Math.atan2(e1 - t, r), h = Math.sin(d), f = Math.cos(d), p = u; p <= c; ++p){
                        var m = p / n, y = r * m, g = void 0, g = p < 0 ? (m = y = 0, e1) : n < p ? (y = r, m = 1, t) : e1 + (t - e1) * m;
                        for(-2 !== p && p !== n + 2 || (g = 0), y -= r / 2, a = 0; a < o; ++a){
                            var v = a / (o - 1), b = 2 * Math.PI * v, j = Math.sin(b), b = Math.cos(b), _ = (this.vertices.push(new S.default.Vector(j * g, y, b * g)), void 0), _ = p < 0 ? new S.default.Vector(0, -1, 0) : n < p && t ? new S.default.Vector(0, 1, 0) : new S.default.Vector(j * f, h, b * f);
                            this.vertexNormals.push(_), this.uvs.push(v, m);
                        }
                    }
                    var x = 0;
                    if (s) {
                        for(l = 0; l < o; ++l)this.faces.push([
                            x + l,
                            x + o + (l + 1) % o,
                            x + o + l
                        ]);
                        x += 2 * o;
                    }
                    for(p = 0; p < n; ++p){
                        for(a = 0; a < o; ++a){
                            var w = (a + 1) % o;
                            this.faces.push([
                                x + a,
                                x + w,
                                x + o + w
                            ]), this.faces.push([
                                x + a,
                                x + o + w,
                                x + o + a
                            ]);
                        }
                        x += o;
                    }
                    if (i) for(x += o, a = 0; a < o; ++a)this.faces.push([
                        x + a,
                        x + (a + 1) % o,
                        x + o
                    ]);
                }
                S.default.prototype.cylinder = function(e1, t, r, o, n, s) {
                    this._assert3d("cylinder"), S.default._validateParameters("cylinder", arguments), void 0 === e1 && (e1 = 50), void 0 === t && (t = e1), void 0 === o && (o = 1), void 0 === s && (s = !0), void 0 === n && (n = !0);
                    var i, a = "cylinder|".concat(r = void 0 === r ? 24 : r, "|").concat(o, "|").concat(n, "|").concat(s);
                    return this._renderer.geometryInHash(a) || (i = new S.default.Geometry(r, o), l.call(i, 1, 1, 1, r, o, n, s), r <= 24 && o <= 16 ? i._makeTriangleEdges()._edgesToVertices() : this._renderer._doStroke && console.log("Cannot draw stroke on cylinder objects with more than 24 detailX or 16 detailY"), this._renderer.createBuffers(a, i)), this._renderer.drawBuffersScaled(a, e1, t, e1), this;
                }, S.default.prototype.cone = function(e1, t, r, o, n) {
                    this._assert3d("cone"), S.default._validateParameters("cone", arguments), void 0 === e1 && (e1 = 50), void 0 === t && (t = e1), void 0 === o && (o = 1), void 0 === n && (n = !0);
                    var s, i = "cone|".concat(r = void 0 === r ? 24 : r, "|").concat(o, "|").concat(n);
                    return this._renderer.geometryInHash(i) || (s = new S.default.Geometry(r, o), l.call(s, 1, 0, 1, r, o, n, !1), r <= 24 && o <= 16 ? s._makeTriangleEdges()._edgesToVertices() : this._renderer._doStroke && console.log("Cannot draw stroke on cone objects with more than 24 detailX or 16 detailY"), this._renderer.createBuffers(i, s)), this._renderer.drawBuffersScaled(i, e1, t, e1), this;
                }, S.default.prototype.ellipsoid = function(e1, t, r, o, n) {
                    this._assert3d("ellipsoid"), S.default._validateParameters("ellipsoid", arguments), void 0 === e1 && (e1 = 50), void 0 === t && (t = e1), void 0 === r && (r = e1), void 0 === n && (n = 16);
                    var s, i = "ellipsoid|".concat(o = void 0 === o ? 24 : o, "|").concat(n);
                    return this._renderer.geometryInHash(i) || ((s = new S.default.Geometry(o, n, function() {
                        for(var e1 = 0; e1 <= this.detailY; e1++)for(var t = e1 / this.detailY, r = Math.PI * t - Math.PI / 2, o = Math.cos(r), n = Math.sin(r), s = 0; s <= this.detailX; s++){
                            var i = s / this.detailX, a = 2 * Math.PI * i, l = Math.cos(a), a = Math.sin(a), a = new S.default.Vector(o * a, n, o * l);
                            this.vertices.push(a), this.vertexNormals.push(a), this.uvs.push(i, t);
                        }
                    })).computeFaces(), o <= 24 && n <= 24 ? s._makeTriangleEdges()._edgesToVertices() : this._renderer._doStroke && console.log("Cannot draw stroke on ellipsoids with more than 24 detailX or 24 detailY"), this._renderer.createBuffers(i, s)), this._renderer.drawBuffersScaled(i, e1, t, r), this;
                }, S.default.prototype.torus = function(e1, t, r, o) {
                    if (this._assert3d("torus"), S.default._validateParameters("torus", arguments), void 0 === e1) e1 = 50;
                    else if (!e1) return;
                    if (void 0 === t) t = 10;
                    else if (!t) return;
                    void 0 === r && (r = 24), void 0 === o && (o = 16);
                    var n, d = (t / e1).toPrecision(4), t = "torus|".concat(d, "|").concat(r, "|").concat(o);
                    return this._renderer.geometryInHash(t) || ((n = new S.default.Geometry(r, o, function() {
                        for(var e1 = 0; e1 <= this.detailY; e1++)for(var t = e1 / this.detailY, r = 2 * Math.PI * t, o = Math.cos(r), n = Math.sin(r), s = 1 + d * o, i = 0; i <= this.detailX; i++){
                            var a = i / this.detailX, l = 2 * Math.PI * a, u = Math.cos(l), l = Math.sin(l), c = new S.default.Vector(s * u, s * l, d * n), u = new S.default.Vector(o * u, o * l, n);
                            this.vertices.push(c), this.vertexNormals.push(u), this.uvs.push(a, t);
                        }
                    })).computeFaces(), r <= 24 && o <= 16 ? n._makeTriangleEdges()._edgesToVertices() : this._renderer._doStroke && console.log("Cannot draw strokes on torus object with more than 24 detailX or 16 detailY"), this._renderer.createBuffers(t, n)), this._renderer.drawBuffersScaled(t, e1, e1, e1), this;
                }, S.default.RendererGL.prototype.point = function(e1, t, r) {
                    var o = [];
                    return o.push(new S.default.Vector(e1, t, r = void 0 === r ? 0 : r)), this._drawPoints(o, this.immediateMode.buffers.point), this;
                }, S.default.RendererGL.prototype.triangle = function(e1) {
                    var t = e1[0], r = e1[1], o = e1[2], n = e1[3], s = e1[4], e1 = e1[5], i = (this.geometryInHash("tri") || ((i = new S.default.Geometry(1, 1, function() {
                        var e1 = [];
                        e1.push(new S.default.Vector(0, 0, 0)), e1.push(new S.default.Vector(1, 0, 0)), e1.push(new S.default.Vector(0, 1, 0)), this.edges = [
                            [
                                0,
                                1
                            ],
                            [
                                1,
                                2
                            ],
                            [
                                2,
                                0
                            ]
                        ], this.vertices = e1, this.faces = [
                            [
                                0,
                                1,
                                2
                            ]
                        ], this.uvs = [
                            0,
                            0,
                            1,
                            0,
                            1,
                            1
                        ];
                    }))._edgesToVertices(), i.computeNormals(), this.createBuffers("tri", i)), this.uMVMatrix.copy());
                    try {
                        var a = Math.sign(t * n - o * r + o * e1 - s * n + s * r - t * e1), l = new S.default.Matrix([
                            o - t,
                            n - r,
                            0,
                            0,
                            s - t,
                            e1 - r,
                            0,
                            0,
                            0,
                            0,
                            a,
                            0,
                            t,
                            r,
                            0,
                            1
                        ]).mult(this.uMVMatrix);
                        this.uMVMatrix = l, this.drawBuffers("tri");
                    } finally{
                        this.uMVMatrix = i;
                    }
                    return this;
                }, S.default.RendererGL.prototype.ellipse = function(e1) {
                    this.arc(e1[0], e1[1], e1[2], e1[3], 0, _.TWO_PI, _.OPEN, e1[4]);
                }, S.default.RendererGL.prototype.arc = function(e1) {
                    var t, r = arguments[1], o = arguments[2], n = arguments[3], s = arguments[4], i = arguments[5], a = arguments[6], l = arguments[7] || 25, u = (Math.abs(i - s) >= _.TWO_PI ? "".concat(c = "ellipse", "|") : "".concat(c = "arc", "|").concat(s, "|").concat(i, "|").concat(a, "|")).concat(l, "|"), c = (this.geometryInHash(u) || ((t = new S.default.Geometry(l, 1, function() {
                        if (s.toFixed(10) !== i.toFixed(10)) {
                            a !== _.PIE && void 0 !== a || (this.vertices.push(new S.default.Vector(.5, .5, 0)), this.uvs.push([
                                .5,
                                .5
                            ]));
                            for(var e1 = 0; e1 <= l; e1++){
                                var t = (i - s) * (e1 / l) + s, r = .5 + Math.cos(t) / 2, t = .5 + Math.sin(t) / 2;
                                this.vertices.push(new S.default.Vector(r, t, 0)), this.uvs.push([
                                    r,
                                    t
                                ]), e1 < l - 1 && (this.faces.push([
                                    0,
                                    e1 + 1,
                                    e1 + 2
                                ]), this.edges.push([
                                    e1 + 1,
                                    e1 + 2
                                ]));
                            }
                            switch(a){
                                case _.PIE:
                                    this.faces.push([
                                        0,
                                        this.vertices.length - 2,
                                        this.vertices.length - 1
                                    ]), this.edges.push([
                                        0,
                                        1
                                    ]), this.edges.push([
                                        this.vertices.length - 2,
                                        this.vertices.length - 1
                                    ]), this.edges.push([
                                        0,
                                        this.vertices.length - 1
                                    ]);
                                    break;
                                case _.CHORD:
                                    this.edges.push([
                                        0,
                                        1
                                    ]), this.edges.push([
                                        0,
                                        this.vertices.length - 1
                                    ]);
                                    break;
                                case _.OPEN:
                                    this.edges.push([
                                        0,
                                        1
                                    ]);
                                    break;
                                default:
                                    this.faces.push([
                                        0,
                                        this.vertices.length - 2,
                                        this.vertices.length - 1
                                    ]), this.edges.push([
                                        this.vertices.length - 2,
                                        this.vertices.length - 1
                                    ]);
                            }
                        }
                    })).computeNormals(), l <= 50 ? t._edgesToVertices(t) : this._doStroke && console.log("Cannot apply a stroke to an ".concat(c, " with more than 50 detail")), this.createBuffers(u, t)), this.uMVMatrix.copy());
                    try {
                        this.uMVMatrix.translate([
                            e1,
                            r,
                            0
                        ]), this.uMVMatrix.scale(o, n, 1), this.drawBuffers(u);
                    } finally{
                        this.uMVMatrix = c;
                    }
                    return this;
                }, S.default.RendererGL.prototype.rect = function(e1) {
                    var t = e1[0], r = e1[1], o = e1[2], n = e1[3];
                    if (void 0 === e1[4]) {
                        var s = this._pInst._glAttributes.perPixelLighting, i = e1[4] || (s ? 1 : 24), a = e1[5] || (s ? 1 : 16), s = "rect|".concat(i, "|").concat(a), l = (this.geometryInHash(s) || ((l = new S.default.Geometry(i, a, function() {
                            for(var e1 = 0; e1 <= this.detailY; e1++)for(var t = e1 / this.detailY, r = 0; r <= this.detailX; r++){
                                var o = r / this.detailX, n = new S.default.Vector(o, t, 0);
                                this.vertices.push(n), this.uvs.push(o, t);
                            }
                            0 < i && 0 < a && (this.edges = [
                                [
                                    0,
                                    i
                                ],
                                [
                                    i,
                                    (i + 1) * (a + 1) - 1
                                ],
                                [
                                    (i + 1) * (a + 1) - 1,
                                    (i + 1) * a
                                ],
                                [
                                    (i + 1) * a,
                                    0
                                ]
                            ]);
                        })).computeFaces().computeNormals()._edgesToVertices(), this.createBuffers(s, l)), this.uMVMatrix.copy());
                        try {
                            this.uMVMatrix.translate([
                                t,
                                r,
                                0
                            ]), this.uMVMatrix.scale(o, n, 1), this.drawBuffers(s);
                        } finally{
                            this.uMVMatrix = l;
                        }
                    } else {
                        var s = e1[4], l = void 0 === e1[5] ? s : e1[5], u = void 0 === e1[6] ? l : e1[6], e1 = void 0 === e1[7] ? u : e1[7], c = o, d = n, h = ((c += t) < t && (h = t, t = c, c = h), (d += r) < r && (h = r, r = d, d = h), Math.min((c - t) / 2, (d - r) / 2)), f = (h < s && (s = h), h < l && (l = h), h < u && (u = h), h < e1 && (e1 = h), t), p = r, h = c, t = d, m = (this.beginShape(), 0 !== l ? (this.vertex(h - l, p), this.quadraticVertex(h, p, h, p + l)) : this.vertex(h, p), 0 !== u ? (this.vertex(h, t - u), this.quadraticVertex(h, t, h - u, t)) : this.vertex(h, t), 0 !== e1 ? (this.vertex(f + e1, t), this.quadraticVertex(f, t, f, t - e1)) : this.vertex(f, t), 0 !== s ? (this.vertex(f, p + s), this.quadraticVertex(f, p, f + s, p)) : this.vertex(f, p), this.immediateMode.geometry.uvs.length = 0, true), r = !1, c = void 0;
                        try {
                            for(var y, g = this.immediateMode.geometry.vertices[Symbol.iterator](); !(m = (y = g.next()).done); m = !0){
                                var v = y.value, b = (v.x - f) / o, j = (v.y - p) / n;
                                this.immediateMode.geometry.uvs.push(b, j);
                            }
                        } catch (e1) {
                            r = !0, c = e1;
                        } finally{
                            try {
                                m || null == g.return || g.return();
                            } finally{
                                if (r) throw c;
                            }
                        }
                        this.endShape(_.CLOSE);
                    }
                    return this;
                }, S.default.RendererGL.prototype.quad = function(i, a, l, u, c, d, h, f, p, m, y, g, e1, t) {
                    void 0 === e1 && (e1 = 2), void 0 === t && (t = 2);
                    var r = "quad|".concat(i, "|").concat(a, "|").concat(l, "|").concat(u, "|").concat(c, "|").concat(d, "|").concat(h, "|").concat(f, "|").concat(p, "|").concat(m, "|").concat(y, "|").concat(g, "|").concat(e1, "|").concat(t);
                    if (!this.geometryInHash(r)) {
                        var o = new S.default.Geometry(e1, t, function() {
                            for(var e1 = 1 / (this.detailX - 1), t = 1 / (this.detailY - 1), r = 0; r < this.detailY; r++)for(var o = 0; o < this.detailX; o++){
                                var n = o * e1, s = r * t;
                                this.vertices.push(new S.default.Vector((1 - n) * ((1 - s) * i + s * m) + n * ((1 - s) * u + s * h), (1 - n) * ((1 - s) * a + s * y) + n * ((1 - s) * c + s * f), (1 - n) * ((1 - s) * l + s * g) + n * ((1 - s) * d + s * p))), this.uvs.push([
                                    n,
                                    s
                                ]);
                            }
                        });
                        o.faces = [];
                        for(var n = 0; n < t - 1; n++)for(var s = 0; s < e1 - 1; s++){
                            var v = s + n * e1, b = s + 1 + (n + 1) * e1, j = s + (n + 1) * e1;
                            o.faces.push([
                                v,
                                s + 1 + n * e1,
                                b
                            ]), o.faces.push([
                                v,
                                b,
                                j
                            ]);
                        }
                        o.computeNormals();
                        for(var _ = [
                            o.edges.length = 0,
                            2,
                            3,
                            1
                        ], x = 0; x < _.length; x++)o.edges.push([
                            _[x],
                            _[(x + 1) % _.length]
                        ]);
                        o._edgesToVertices(), this.createBuffers(r, o);
                    }
                    return this.drawBuffers(r), this;
                }, S.default.RendererGL.prototype.bezier = function(e1, t, r, o, n, s, i, a, l, u, c, d) {
                    8 === arguments.length && (c = a, u = i, a = s, i = n, n = o, o = r, r = s = l = d = 0);
                    var h = this._pInst._bezierDetail || 20;
                    this.beginShape();
                    for(var f = 0; f <= h; f++){
                        var p = Math.pow(1 - f / h, 3), m = f / h * 3 * Math.pow(1 - f / h, 2), y = 3 * Math.pow(f / h, 2) * (1 - f / h), g = Math.pow(f / h, 3);
                        this.vertex(e1 * p + o * m + i * y + u * g, t * p + n * m + a * y + c * g, r * p + s * m + l * y + d * g);
                    }
                    return this.endShape(), this;
                }, S.default.RendererGL.prototype.curve = function(e1, t, r, o, n, s, i, a, l, u, c, d) {
                    8 === arguments.length && (u = i, c = a, i = n, a = o, n = o = r, r = s = l = d = 0);
                    var h = this._pInst._curveDetail;
                    this.beginShape();
                    for(var f = 0; f <= h; f++){
                        var p = .5 * Math.pow(f / h, 3), m = .5 * Math.pow(f / h, 2), y = f / h * .5;
                        this.vertex(p * (3 * o - e1 - 3 * i + u) + m * (2 * e1 - 5 * o + 4 * i - u) + y * (-e1 + i) + 2 * o * .5, p * (3 * n - t - 3 * a + c) + m * (2 * t - 5 * n + 4 * a - c) + y * (-t + a) + 2 * n * .5, p * (3 * s - r - 3 * l + d) + m * (2 * r - 5 * s + 4 * l - d) + y * (-r + l) + 2 * s * .5);
                    }
                    return this.endShape(), this;
                }, S.default.RendererGL.prototype.line = function() {
                    return 6 === arguments.length ? (this.beginShape(_.LINES), this.vertex(arguments.length <= 0 ? void 0 : arguments[0], arguments.length <= 1 ? void 0 : arguments[1], arguments.length <= 2 ? void 0 : arguments[2]), this.vertex(arguments.length <= 3 ? void 0 : arguments[3], arguments.length <= 4 ? void 0 : arguments[4], arguments.length <= 5 ? void 0 : arguments[5]), this.endShape()) : 4 === arguments.length && (this.beginShape(_.LINES), this.vertex(arguments.length <= 0 ? void 0 : arguments[0], arguments.length <= 1 ? void 0 : arguments[1], 0), this.vertex(arguments.length <= 2 ? void 0 : arguments[2], arguments.length <= 3 ? void 0 : arguments[3], 0), this.endShape()), this;
                }, S.default.RendererGL.prototype.bezierVertex = function() {
                    if (0 === this.immediateMode._bezierVertex.length) throw Error("vertex() must be used once before calling bezierVertex()");
                    var e1, t, r, o, n, s, i = [], a = [], l = arguments.length;
                    if (0 === this._lookUpTableBezier.length || this._lutBezierDetail !== this._pInst._curveDetail) {
                        this._lookUpTableBezier = [], this._lutBezierDetail = this._pInst._curveDetail;
                        for(var u = 1 / this._lutBezierDetail, c = 0, d = 1, h = 0; c < 1;){
                            if (s = parseFloat(c.toFixed(6)), this._lookUpTableBezier[h] = this._bezierCoefficients(s), d.toFixed(6) === u.toFixed(6)) {
                                s = parseFloat(d.toFixed(6)) + parseFloat(c.toFixed(6)), ++h, this._lookUpTableBezier[h] = this._bezierCoefficients(s);
                                break;
                            }
                            c += u, d -= u, ++h;
                        }
                    }
                    for(var f = this._lookUpTableBezier.length, p = [], m = 0; m < 4; m++)p.push([]);
                    p[0] = this.immediateMode.geometry.vertexColors.slice(-4), p[3] = this.curFillColor.slice();
                    var y = [];
                    for(m = 0; m < 4; m++)y.push([]);
                    if (y[0] = this.immediateMode.geometry.vertexStrokeColors.slice(-4), y[3] = this.curStrokeColor.slice(), 6 === l) {
                        this.isBezier = !0;
                        var i = [
                            this.immediateMode._bezierVertex[0],
                            arguments.length <= 0 ? void 0 : arguments[0],
                            arguments.length <= 2 ? void 0 : arguments[2],
                            arguments.length <= 4 ? void 0 : arguments[4]
                        ], a = [
                            this.immediateMode._bezierVertex[1],
                            arguments.length <= 1 ? void 0 : arguments[1],
                            arguments.length <= 3 ? void 0 : arguments[3],
                            arguments.length <= 5 ? void 0 : arguments[5]
                        ], g = Math.hypot(i[0] - i[1], a[0] - a[1]), v = Math.hypot(i[1] - i[2], a[1] - a[2]), b = Math.hypot(i[2] - i[3], a[2] - a[3]), v = g + v + b;
                        for(g /= v, b /= v, n = 0; n < 4; n++)p[1].push(p[0][n] * (1 - g) + p[3][n] * g), p[2].push(p[0][n] * b + p[3][n] * (1 - b)), y[1].push(y[0][n] * (1 - g) + y[3][n] * g), y[2].push(y[0][n] * b + y[3][n] * (1 - b));
                        for(o = 0; o < f; o++){
                            for(this.curFillColor = [
                                0,
                                0,
                                0,
                                0
                            ], this.curStrokeColor = [
                                0,
                                0,
                                0,
                                0
                            ], m = e1 = t = 0; m < 4; m++){
                                for(n = 0; n < 4; n++)this.curFillColor[n] += this._lookUpTableBezier[o][m] * p[m][n], this.curStrokeColor[n] += this._lookUpTableBezier[o][m] * y[m][n];
                                e1 += i[m] * this._lookUpTableBezier[o][m], t += a[m] * this._lookUpTableBezier[o][m];
                            }
                            this.vertex(e1, t);
                        }
                        this.curFillColor = p[3], this.curStrokeColor = y[3], this.immediateMode._bezierVertex[0] = arguments.length <= 4 ? void 0 : arguments[4], this.immediateMode._bezierVertex[1] = arguments.length <= 5 ? void 0 : arguments[5];
                    } else if (9 === l) {
                        this.isBezier = !0, i = [
                            this.immediateMode._bezierVertex[0],
                            arguments.length <= 0 ? void 0 : arguments[0],
                            arguments.length <= 3 ? void 0 : arguments[3],
                            arguments.length <= 6 ? void 0 : arguments[6]
                        ], a = [
                            this.immediateMode._bezierVertex[1],
                            arguments.length <= 1 ? void 0 : arguments[1],
                            arguments.length <= 4 ? void 0 : arguments[4],
                            arguments.length <= 7 ? void 0 : arguments[7]
                        ];
                        var j = [
                            this.immediateMode._bezierVertex[2],
                            arguments.length <= 2 ? void 0 : arguments[2],
                            arguments.length <= 5 ? void 0 : arguments[5],
                            arguments.length <= 8 ? void 0 : arguments[8]
                        ], _ = Math.hypot(i[0] - i[1], a[0] - a[1], j[0] - j[1]), v = Math.hypot(i[1] - i[2], a[1] - a[2], j[1] - j[2]), x = Math.hypot(i[2] - i[3], a[2] - a[3], j[2] - j[3]), l = _ + v + x;
                        for(_ /= l, x /= l, n = 0; n < 4; n++)p[1].push(p[0][n] * (1 - _) + p[3][n] * _), p[2].push(p[0][n] * x + p[3][n] * (1 - x)), y[1].push(y[0][n] * (1 - _) + y[3][n] * _), y[2].push(y[0][n] * x + y[3][n] * (1 - x));
                        for(o = 0; o < f; o++){
                            for(this.curFillColor = [
                                0,
                                0,
                                0,
                                0
                            ], this.curStrokeColor = [
                                0,
                                0,
                                0,
                                0
                            ], m = e1 = t = r = 0; m < 4; m++){
                                for(n = 0; n < 4; n++)this.curFillColor[n] += this._lookUpTableBezier[o][m] * p[m][n], this.curStrokeColor[n] += this._lookUpTableBezier[o][m] * y[m][n];
                                e1 += i[m] * this._lookUpTableBezier[o][m], t += a[m] * this._lookUpTableBezier[o][m], r += j[m] * this._lookUpTableBezier[o][m];
                            }
                            this.vertex(e1, t, r);
                        }
                        this.curFillColor = p[3], this.curStrokeColor = y[3], this.immediateMode._bezierVertex[0] = arguments.length <= 6 ? void 0 : arguments[6], this.immediateMode._bezierVertex[1] = arguments.length <= 7 ? void 0 : arguments[7], this.immediateMode._bezierVertex[2] = arguments.length <= 8 ? void 0 : arguments[8];
                    }
                }, S.default.RendererGL.prototype.quadraticVertex = function() {
                    if (0 === this.immediateMode._quadraticVertex.length) throw Error("vertex() must be used once before calling quadraticVertex()");
                    var e1, t, r, o, n, s, i = [], a = [], l = arguments.length;
                    if (0 === this._lookUpTableQuadratic.length || this._lutQuadraticDetail !== this._pInst._curveDetail) {
                        this._lookUpTableQuadratic = [], this._lutQuadraticDetail = this._pInst._curveDetail;
                        for(var u = 1 / this._lutQuadraticDetail, c = 0, d = 1, h = 0; c < 1;){
                            if (s = parseFloat(c.toFixed(6)), this._lookUpTableQuadratic[h] = this._quadraticCoefficients(s), d.toFixed(6) === u.toFixed(6)) {
                                s = parseFloat(d.toFixed(6)) + parseFloat(c.toFixed(6)), ++h, this._lookUpTableQuadratic[h] = this._quadraticCoefficients(s);
                                break;
                            }
                            c += u, d -= u, ++h;
                        }
                    }
                    for(var f = this._lookUpTableQuadratic.length, p = [], m = 0; m < 3; m++)p.push([]);
                    p[0] = this.immediateMode.geometry.vertexColors.slice(-4), p[2] = this.curFillColor.slice();
                    var y = [];
                    for(m = 0; m < 3; m++)y.push([]);
                    if (y[0] = this.immediateMode.geometry.vertexStrokeColors.slice(-4), y[2] = this.curStrokeColor.slice(), 4 === l) {
                        this.isQuadratic = !0;
                        var i = [
                            this.immediateMode._quadraticVertex[0],
                            arguments.length <= 0 ? void 0 : arguments[0],
                            arguments.length <= 2 ? void 0 : arguments[2]
                        ], a = [
                            this.immediateMode._quadraticVertex[1],
                            arguments.length <= 1 ? void 0 : arguments[1],
                            arguments.length <= 3 ? void 0 : arguments[3]
                        ], g = Math.hypot(i[0] - i[1], a[0] - a[1]);
                        for(g /= g + Math.hypot(i[1] - i[2], a[1] - a[2]), n = 0; n < 4; n++)p[1].push(p[0][n] * (1 - g) + p[2][n] * g), y[1].push(y[0][n] * (1 - g) + y[2][n] * g);
                        for(o = 0; o < f; o++){
                            for(this.curFillColor = [
                                0,
                                0,
                                0,
                                0
                            ], this.curStrokeColor = [
                                0,
                                0,
                                0,
                                0
                            ], m = e1 = t = 0; m < 3; m++){
                                for(n = 0; n < 4; n++)this.curFillColor[n] += this._lookUpTableQuadratic[o][m] * p[m][n], this.curStrokeColor[n] += this._lookUpTableQuadratic[o][m] * y[m][n];
                                e1 += i[m] * this._lookUpTableQuadratic[o][m], t += a[m] * this._lookUpTableQuadratic[o][m];
                            }
                            this.vertex(e1, t);
                        }
                        this.curFillColor = p[2], this.curStrokeColor = y[2], this.immediateMode._quadraticVertex[0] = arguments.length <= 2 ? void 0 : arguments[2], this.immediateMode._quadraticVertex[1] = arguments.length <= 3 ? void 0 : arguments[3];
                    } else if (6 === l) {
                        this.isQuadratic = !0, i = [
                            this.immediateMode._quadraticVertex[0],
                            arguments.length <= 0 ? void 0 : arguments[0],
                            arguments.length <= 3 ? void 0 : arguments[3]
                        ], a = [
                            this.immediateMode._quadraticVertex[1],
                            arguments.length <= 1 ? void 0 : arguments[1],
                            arguments.length <= 4 ? void 0 : arguments[4]
                        ];
                        var v = [
                            this.immediateMode._quadraticVertex[2],
                            arguments.length <= 2 ? void 0 : arguments[2],
                            arguments.length <= 5 ? void 0 : arguments[5]
                        ], b = Math.hypot(i[0] - i[1], a[0] - a[1], v[0] - v[1]);
                        for(b /= b + Math.hypot(i[1] - i[2], a[1] - a[2], v[1] - v[2]), n = 0; n < 4; n++)p[1].push(p[0][n] * (1 - b) + p[2][n] * b), y[1].push(y[0][n] * (1 - b) + y[2][n] * b);
                        for(o = 0; o < f; o++){
                            for(this.curFillColor = [
                                0,
                                0,
                                0,
                                0
                            ], this.curStrokeColor = [
                                0,
                                0,
                                0,
                                0
                            ], m = e1 = t = r = 0; m < 3; m++){
                                for(n = 0; n < 4; n++)this.curFillColor[n] += this._lookUpTableQuadratic[o][m] * p[m][n], this.curStrokeColor[n] += this._lookUpTableQuadratic[o][m] * y[m][n];
                                e1 += i[m] * this._lookUpTableQuadratic[o][m], t += a[m] * this._lookUpTableQuadratic[o][m], r += v[m] * this._lookUpTableQuadratic[o][m];
                            }
                            this.vertex(e1, t, r);
                        }
                        this.curFillColor = p[2], this.curStrokeColor = y[2], this.immediateMode._quadraticVertex[0] = arguments.length <= 3 ? void 0 : arguments[3], this.immediateMode._quadraticVertex[1] = arguments.length <= 4 ? void 0 : arguments[4], this.immediateMode._quadraticVertex[2] = arguments.length <= 5 ? void 0 : arguments[5];
                    }
                }, S.default.RendererGL.prototype.curveVertex = function() {
                    var e1, t, r, o, n, s, i = [], a = [], l = arguments.length;
                    if (0 === this._lookUpTableBezier.length || this._lutBezierDetail !== this._pInst._curveDetail) {
                        this._lookUpTableBezier = [], this._lutBezierDetail = this._pInst._curveDetail;
                        for(var u = 1 / this._lutBezierDetail, c = 0, d = 1, h = 0; c < 1;){
                            if (s = parseFloat(c.toFixed(6)), this._lookUpTableBezier[h] = this._bezierCoefficients(s), d.toFixed(6) === u.toFixed(6)) {
                                s = parseFloat(d.toFixed(6)) + parseFloat(c.toFixed(6)), ++h, this._lookUpTableBezier[h] = this._bezierCoefficients(s);
                                break;
                            }
                            c += u, d -= u, ++h;
                        }
                    }
                    var f = this._lookUpTableBezier.length;
                    if (2 === l) {
                        if (this.immediateMode._curveVertex.push(arguments.length <= 0 ? void 0 : arguments[0]), this.immediateMode._curveVertex.push(arguments.length <= 1 ? void 0 : arguments[1]), 8 === this.immediateMode._curveVertex.length) {
                            for(this.isCurve = !0, i = this._bezierToCatmull([
                                this.immediateMode._curveVertex[0],
                                this.immediateMode._curveVertex[2],
                                this.immediateMode._curveVertex[4],
                                this.immediateMode._curveVertex[6]
                            ]), a = this._bezierToCatmull([
                                this.immediateMode._curveVertex[1],
                                this.immediateMode._curveVertex[3],
                                this.immediateMode._curveVertex[5],
                                this.immediateMode._curveVertex[7]
                            ]), n = 0; n < f; n++)t = i[0] * this._lookUpTableBezier[n][0] + i[1] * this._lookUpTableBezier[n][1] + i[2] * this._lookUpTableBezier[n][2] + i[3] * this._lookUpTableBezier[n][3], r = a[0] * this._lookUpTableBezier[n][0] + a[1] * this._lookUpTableBezier[n][1] + a[2] * this._lookUpTableBezier[n][2] + a[3] * this._lookUpTableBezier[n][3], this.vertex(t, r);
                            for(n = 0; n < l; n++)this.immediateMode._curveVertex.shift();
                        }
                    } else if (3 === l && (this.immediateMode._curveVertex.push(arguments.length <= 0 ? void 0 : arguments[0]), this.immediateMode._curveVertex.push(arguments.length <= 1 ? void 0 : arguments[1]), this.immediateMode._curveVertex.push(arguments.length <= 2 ? void 0 : arguments[2]), 12 === this.immediateMode._curveVertex.length)) {
                        for(this.isCurve = !0, i = this._bezierToCatmull([
                            this.immediateMode._curveVertex[0],
                            this.immediateMode._curveVertex[3],
                            this.immediateMode._curveVertex[6],
                            this.immediateMode._curveVertex[9]
                        ]), a = this._bezierToCatmull([
                            this.immediateMode._curveVertex[1],
                            this.immediateMode._curveVertex[4],
                            this.immediateMode._curveVertex[7],
                            this.immediateMode._curveVertex[10]
                        ]), e1 = this._bezierToCatmull([
                            this.immediateMode._curveVertex[2],
                            this.immediateMode._curveVertex[5],
                            this.immediateMode._curveVertex[8],
                            this.immediateMode._curveVertex[11]
                        ]), n = 0; n < f; n++)t = i[0] * this._lookUpTableBezier[n][0] + i[1] * this._lookUpTableBezier[n][1] + i[2] * this._lookUpTableBezier[n][2] + i[3] * this._lookUpTableBezier[n][3], r = a[0] * this._lookUpTableBezier[n][0] + a[1] * this._lookUpTableBezier[n][1] + a[2] * this._lookUpTableBezier[n][2] + a[3] * this._lookUpTableBezier[n][3], o = e1[0] * this._lookUpTableBezier[n][0] + e1[1] * this._lookUpTableBezier[n][1] + e1[2] * this._lookUpTableBezier[n][2] + e1[3] * this._lookUpTableBezier[n][3], this.vertex(t, r, o);
                        for(n = 0; n < l; n++)this.immediateMode._curveVertex.shift();
                    }
                }, S.default.RendererGL.prototype.image = function(e1, t, r, o, n, s, i, a, l) {
                    this._isErasing && this.blendMode(this._cachedBlendMode), this._pInst.push(), this._pInst.noLights(), this._pInst.noStroke(), this._pInst.texture(e1), this._pInst.textureMode(_.NORMAL);
                    var u = 0, c = (t <= e1.width && (u = t / e1.width), 1), t = (t + o <= e1.width && (c = (t + o) / e1.width), 0), o = (r <= e1.height && (t = r / e1.height), 1);
                    r + n <= e1.height && (o = (r + n) / e1.height), this.beginShape(), this.vertex(s, i, 0, u, t), this.vertex(s + a, i, 0, c, t), this.vertex(s + a, i + l, 0, c, o), this.vertex(s, i + l, 0, u, o), this.endShape(_.CLOSE), this._pInst.pop(), this._isErasing && this.blendMode(_.REMOVE);
                };
                var n = S.default;
                r.default = n;
            },
            {
                "../core/constants": 264,
                "../core/main": 275,
                "./p5.Geometry": 327,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.for-each": 157,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.math.hypot": 170,
                "core-js/modules/es.math.sign": 172,
                "core-js/modules/es.number.to-fixed": 175,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        319: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.every"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.every"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.object.assign"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (c = e1("../core/main")) && c.__esModule ? c : {
                    default: c
                }, a = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = l();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function l() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, l = function() {
                        return e1;
                    }, e1);
                }
                function s(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                function u(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                var c = function() {
                    function t(e1) {
                        if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function");
                        (this.renderer = e1)._pInst.push(), this.identityMatrix = new n.default.Matrix, e1.uMVMatrix = new n.default.Matrix, this.geometry = new n.default.Geometry, this.geometry.gid = "_p5_GeometryBuilder_".concat(t.nextGeometryId), t.nextGeometryId++, this.hasTransform = !1;
                    }
                    var e1, r, o;
                    return e1 = t, r = [
                        {
                            key: "transformVertices",
                            value: function(e1) {
                                var t = this;
                                return this.hasTransform ? e1.map(function(e1) {
                                    return t.renderer.uMVMatrix.multiplyPoint(e1);
                                }) : e1;
                            }
                        },
                        {
                            key: "transformNormals",
                            value: function(e1) {
                                var t = this;
                                return this.hasTransform ? e1.map(function(e1) {
                                    return t.renderer.uNMatrix.multiplyVec3(e1);
                                }) : e1;
                            }
                        },
                        {
                            key: "addGeometry",
                            value: function(e1) {
                                for(var t, r = this, o = (this.hasTransform = !this.renderer.uMVMatrix.mat4.every(function(e1, t) {
                                    return e1 === r.identityMatrix.mat4[t];
                                }), this.hasTransform && this.renderer.uNMatrix.inverseTranspose(this.renderer.uMVMatrix), this.geometry.vertices.length), n = ((t = this.geometry.vertices).push.apply(t, s(this.transformVertices(e1.vertices))), (t = this.geometry.vertexNormals).push.apply(t, s(this.transformNormals(e1.vertexNormals))), (t = this.geometry.uvs).push.apply(t, s(e1.uvs)), this.renderer._doFill && (t = this.geometry.faces).push.apply(t, s(e1.faces.map(function(e1) {
                                    return e1.map(function(e1) {
                                        return e1 + o;
                                    });
                                }))), this.renderer._doStroke && (t = this.geometry.edges).push.apply(t, s(e1.edges.map(function(e1) {
                                    return e1.map(function(e1) {
                                        return e1 + o;
                                    });
                                }))), s(e1.vertexColors)); n.length < 4 * e1.vertices.length;)n.push.apply(n, s(this.renderer.curFillColor));
                                (t = this.geometry.vertexColors).push.apply(t, s(n));
                            }
                        },
                        {
                            key: "addImmediate",
                            value: function() {
                                var e1 = this.renderer.immediateMode.geometry, t = this.renderer.immediateMode.shapeMode, r = [];
                                if (this.renderer._doFill) {
                                    if (t === a.TRIANGLE_STRIP || t === a.QUAD_STRIP) for(var o = 2; o < e1.vertices.length; o++)o % 2 == 0 ? r.push([
                                        o,
                                        o - 1,
                                        o - 2
                                    ]) : r.push([
                                        o,
                                        o - 2,
                                        o - 1
                                    ]);
                                    else if (t === a.TRIANGLE_FAN) for(var n = 2; n < e1.vertices.length; n++)r.push([
                                        0,
                                        n - 1,
                                        n
                                    ]);
                                    else for(var s = 0; s < e1.vertices.length; s += 3)r.push([
                                        s,
                                        s + 1,
                                        s + 2
                                    ]);
                                }
                                this.addGeometry(Object.assign({}, e1, {
                                    faces: r
                                }));
                            }
                        },
                        {
                            key: "addRetained",
                            value: function(e1) {
                                this.addGeometry(e1.model);
                            }
                        },
                        {
                            key: "finish",
                            value: function() {
                                return this.renderer._pInst.pop(), this.geometry;
                            }
                        }
                    ], u(e1.prototype, r), o && u(e1, o), t;
                }();
                c.nextGeometryId = 0, r.default = c;
            },
            {
                "../core/constants": 264,
                "../core/main": 275,
                "core-js/modules/es.array.every": 153,
                "core-js/modules/es.array.from": 158,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.map": 164,
                "core-js/modules/es.object.assign": 176,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        320: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.math.sign"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.math.sign"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var g = (s = e1("../core/main")) && s.__esModule ? s : {
                    default: s
                }, n = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== v(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = i();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function i() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, i = function() {
                        return e1;
                    }, e1);
                }
                function v(e1) {
                    return (v = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                g.default.prototype.orbitControl = function(e1, t, r, o) {
                    var n = this, s = (this._assert3d("orbitControl"), g.default._validateParameters("orbitControl", arguments), this._renderer._curCamera);
                    void 0 === e1 && (e1 = 1), void 0 === t && (t = e1), void 0 === r && (r = 1), "object" !== v(o) && (o = {}), !0 !== this.contextMenuDisabled && (this.canvas.oncontextmenu = function() {
                        return !1;
                    }, this._setProperty("contextMenuDisabled", !0)), !0 !== this.wheelDefaultDisabled && (this.canvas.onwheel = function() {
                        return !1;
                    }, this._setProperty("wheelDefaultDisabled", !0));
                    var i = o.disableTouchActions;
                    !0 === this.touchActionsDisabled || void 0 !== i && !i || (this.canvas.style["touch-action"] = "none", this._setProperty("touchActionsDisabled", !0));
                    var a, l, u, i = o.freeRotation, o = void 0 !== i && i, c = [], i = (this.touches.forEach(function(t) {
                        n._renderer.prevTouches.forEach(function(e1) {
                            t.id === e1.id && (e1 = {
                                x: t.x,
                                y: t.y,
                                px: e1.x,
                                py: e1.y
                            }, c.push(e1));
                        });
                    }), this._renderer.prevTouches = this.touches, 0), d = 0, h = 0, f = 0, p = 0, m = this.height < this.width ? this.height : this.width, y = !1;
                    return 0 < c.length ? (y = 0 < c[0].x && c[0].x < this.width && 0 < c[0].y && c[0].y < this.height, 1 === c.length ? (d = -e1 * ((a = c[0]).x - a.px) / m, h = t * (a.y - a.py) / m) : (a = c[0], l = c[1], i = -(Math.hypot(a.x - l.x, a.y - l.y) - Math.hypot(a.px - l.px, a.py - l.py)) * r * 4e-4, f = .5 * (a.x + l.x) - .5 * (a.px + l.px), p = .5 * (a.y + l.y) - .5 * (a.py + l.py)), 0 < this.touches.length ? y && (this._renderer.executeRotateAndMove = !0, this._renderer.executeZoom = !0) : (this._renderer.executeRotateAndMove = !1, this._renderer.executeZoom = !1)) : (y = 0 < this.mouseX && this.mouseX < this.width && 0 < this.mouseY && this.mouseY < this.height, 0 !== this._mouseWheelDeltaY ? (i = Math.sign(this._mouseWheelDeltaY) * r, i *= .01, this._mouseWheelDeltaY = 0, y && (this._renderer.executeZoom = !0)) : this._renderer.zoomFlag = !1, this.mouseIsPressed ? (this.mouseButton === this.LEFT ? (d = -e1 * this.movedX / m, h = t * this.movedY / m) : this.mouseButton === this.RIGHT && (f = this.movedX, p = this.movedY * s.yScale), y && (this._renderer.executeRotateAndMove = !0)) : this._renderer.executeRotateAndMove = !1), 0 !== i && this._renderer.executeZoom && (this._renderer.zoomVelocity += i), .001 < Math.abs(this._renderer.zoomVelocity) ? (o ? s._orbitFree(0, 0, this._renderer.zoomVelocity) : s._orbit(0, 0, this._renderer.zoomVelocity), 0 !== s.projMatrix.mat4[15] && (s.projMatrix.mat4[0] *= Math.pow(10, -this._renderer.zoomVelocity), s.projMatrix.mat4[5] *= Math.pow(10, -this._renderer.zoomVelocity), this._renderer.uPMatrix.mat4[0] = s.projMatrix.mat4[0], this._renderer.uPMatrix.mat4[5] = s.projMatrix.mat4[5]), this._renderer.zoomVelocity *= .85) : this._renderer.zoomVelocity = 0, 0 === d && 0 === h || !this._renderer.executeRotateAndMove || this._renderer.rotateVelocity.add(.6 * d, .6 * h), 1e-6 < this._renderer.rotateVelocity.magSq() ? (o ? s._orbitFree(-this._renderer.rotateVelocity.x, this._renderer.rotateVelocity.y, 0) : s._orbit(this._renderer.rotateVelocity.x, this._renderer.rotateVelocity.y, 0), this._renderer.rotateVelocity.mult(.85)) : this._renderer.rotateVelocity.set(0, 0), 0 === f && 0 === p || !this._renderer.executeRotateAndMove || (a = 2 * f / this.width, l = 2 * -p / this.height, this._renderer.moveVelocity.add(.15 * a, .15 * l)), 1e-6 < this._renderer.moveVelocity.magSq() ? (r = s._getLocalAxes(), e1 = s.eyeX - s.centerX, t = s.eyeY - s.centerY, m = s.eyeZ - s.centerZ, y = Math.sqrt(e1 * e1 + t * t + m * m), i = new g.default.Vector(s.centerX, s.centerY, s.centerZ), i = s.cameraMatrix.multiplyPoint(i), (i = this._renderer.uPMatrix.multiplyAndNormalizePoint(i)).x -= this._renderer.moveVelocity.x, i.y -= this._renderer.moveVelocity.y, h = 0 === (d = this._renderer.uPMatrix.mat4)[15] ? (u = (d[8] + i.x) / d[0] * y, (d[9] + i.y) / d[5] * y) : (u = (i.x - d[12]) / d[0], (i.y - d[13]) / d[5]), s.setPosition(s.eyeX + u * r.x[0] + h * r.y[0], s.eyeY + u * r.x[1] + h * r.y[1], s.eyeZ + u * r.x[2] + h * r.y[2]), this._renderer.moveVelocity.mult(.85)) : this._renderer.moveVelocity.set(0, 0), this;
                }, g.default.prototype.debugMode = function() {
                    this._assert3d("debugMode");
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    g.default._validateParameters("debugMode", t);
                    for(var o = this._registeredMethods.post.length - 1; 0 <= o; o--)this._registeredMethods.post[o].toString() !== this._grid().toString() && this._registeredMethods.post[o].toString() !== this._axesIcon().toString() || this._registeredMethods.post.splice(o, 1);
                    t[0] === n.GRID ? this.registerMethod("post", this._grid.call(this, t[1], t[2], t[3], t[4], t[5])) : t[0] === n.AXES ? this.registerMethod("post", this._axesIcon.call(this, t[1], t[2], t[3], t[4])) : (this.registerMethod("post", this._grid.call(this, t[0], t[1], t[2], t[3], t[4])), this.registerMethod("post", this._axesIcon.call(this, t[5], t[6], t[7], t[8])));
                }, g.default.prototype.noDebugMode = function() {
                    this._assert3d("noDebugMode");
                    for(var e1 = this._registeredMethods.post.length - 1; 0 <= e1; e1--)this._registeredMethods.post[e1].toString() !== this._grid().toString() && this._registeredMethods.post[e1].toString() !== this._axesIcon().toString() || this._registeredMethods.post.splice(e1, 1);
                }, g.default.prototype._grid = function(e1, r, o, n, s) {
                    void 0 === e1 && (e1 = this.width / 2), void 0 === r && (r = Math.round(e1 / 30) < 4 ? 4 : Math.round(e1 / 30)), void 0 === o && (o = 0), void 0 === n && (n = 0), void 0 === s && (s = 0);
                    var i = e1 / r, a = e1 / 2;
                    return function() {
                        this.push(), this.stroke(255 * this._renderer.curStrokeColor[0], 255 * this._renderer.curStrokeColor[1], 255 * this._renderer.curStrokeColor[2]), this._renderer.uMVMatrix.set(this._renderer._curCamera.cameraMatrix.mat4[0], this._renderer._curCamera.cameraMatrix.mat4[1], this._renderer._curCamera.cameraMatrix.mat4[2], this._renderer._curCamera.cameraMatrix.mat4[3], this._renderer._curCamera.cameraMatrix.mat4[4], this._renderer._curCamera.cameraMatrix.mat4[5], this._renderer._curCamera.cameraMatrix.mat4[6], this._renderer._curCamera.cameraMatrix.mat4[7], this._renderer._curCamera.cameraMatrix.mat4[8], this._renderer._curCamera.cameraMatrix.mat4[9], this._renderer._curCamera.cameraMatrix.mat4[10], this._renderer._curCamera.cameraMatrix.mat4[11], this._renderer._curCamera.cameraMatrix.mat4[12], this._renderer._curCamera.cameraMatrix.mat4[13], this._renderer._curCamera.cameraMatrix.mat4[14], this._renderer._curCamera.cameraMatrix.mat4[15]);
                        for(var e1 = 0; e1 <= r; e1++)this.beginShape(this.LINES), this.vertex(-a + o, n, e1 * i - a + s), this.vertex(a + o, n, e1 * i - a + s), this.endShape();
                        for(var t = 0; t <= r; t++)this.beginShape(this.LINES), this.vertex(t * i - a + o, n, -a + s), this.vertex(t * i - a + o, n, a + s), this.endShape();
                        this.pop();
                    };
                }, g.default.prototype._axesIcon = function(e1, t, r, o) {
                    return void 0 === e1 && (e1 = 40 < this.width / 20 ? this.width / 20 : 40), void 0 === t && (t = -this.width / 4), void 0 === r && (r = t), void 0 === o && (o = t), function() {
                        this.push(), this._renderer.uMVMatrix.set(this._renderer._curCamera.cameraMatrix.mat4[0], this._renderer._curCamera.cameraMatrix.mat4[1], this._renderer._curCamera.cameraMatrix.mat4[2], this._renderer._curCamera.cameraMatrix.mat4[3], this._renderer._curCamera.cameraMatrix.mat4[4], this._renderer._curCamera.cameraMatrix.mat4[5], this._renderer._curCamera.cameraMatrix.mat4[6], this._renderer._curCamera.cameraMatrix.mat4[7], this._renderer._curCamera.cameraMatrix.mat4[8], this._renderer._curCamera.cameraMatrix.mat4[9], this._renderer._curCamera.cameraMatrix.mat4[10], this._renderer._curCamera.cameraMatrix.mat4[11], this._renderer._curCamera.cameraMatrix.mat4[12], this._renderer._curCamera.cameraMatrix.mat4[13], this._renderer._curCamera.cameraMatrix.mat4[14], this._renderer._curCamera.cameraMatrix.mat4[15]), this.strokeWeight(2), this.stroke(255, 0, 0), this.beginShape(this.LINES), this.vertex(t, r, o), this.vertex(t + e1, r, o), this.endShape(), this.stroke(0, 255, 0), this.beginShape(this.LINES), this.vertex(t, r, o), this.vertex(t, r + e1, o), this.endShape(), this.stroke(0, 0, 255), this.beginShape(this.LINES), this.vertex(t, r, o), this.vertex(t, r, o + e1), this.endShape(), this.pop();
                    };
                };
                var s = g.default;
                r.default = s;
            },
            {
                "../core/constants": 264,
                "../core/main": 275,
                "core-js/modules/es.array.for-each": 157,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.splice": 167,
                "core-js/modules/es.math.hypot": 170,
                "core-js/modules/es.math.sign": 172,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.for-each": 237,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        321: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var m = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                m.default.prototype.ambientLight = function(e1, t, r, o) {
                    this._assert3d("ambientLight"), m.default._validateParameters("ambientLight", arguments);
                    var n = this.color.apply(this, arguments);
                    return this._renderer.ambientLightColors.push(n._array[0], n._array[1], n._array[2]), this._renderer._enableLighting = !0, this;
                }, m.default.prototype.specularColor = function(e1, t, r) {
                    this._assert3d("specularColor"), m.default._validateParameters("specularColor", arguments);
                    var o = this.color.apply(this, arguments);
                    return this._renderer.specularColors = [
                        o._array[0],
                        o._array[1],
                        o._array[2]
                    ], this;
                }, m.default.prototype.directionalLight = function(e1, t, r, o, n, s) {
                    this._assert3d("directionalLight"), m.default._validateParameters("directionalLight", arguments), e1 = e1 instanceof m.default.Color ? e1 : this.color(e1, t, r);
                    var i, a, t = arguments[arguments.length - 1], r = "number" == typeof t ? (i = arguments[arguments.length - 3], a = arguments[arguments.length - 2], arguments[arguments.length - 1]) : (i = t.x, a = t.y, t.z), t = Math.sqrt(i * i + a * a + r * r);
                    return this._renderer.directionalLightDirections.push(i / t, a / t, r / t), this._renderer.directionalLightDiffuseColors.push(e1._array[0], e1._array[1], e1._array[2]), Array.prototype.push.apply(this._renderer.directionalLightSpecularColors, this._renderer.specularColors), this._renderer._enableLighting = !0, this;
                }, m.default.prototype.pointLight = function(e1, t, r, o, n, s) {
                    this._assert3d("pointLight"), m.default._validateParameters("pointLight", arguments), e1 = e1 instanceof m.default.Color ? e1 : this.color(e1, t, r);
                    var i, a, t = arguments[arguments.length - 1], r = "number" == typeof t ? (i = arguments[arguments.length - 3], a = arguments[arguments.length - 2], arguments[arguments.length - 1]) : (i = t.x, a = t.y, t.z);
                    return this._renderer.pointLightPositions.push(i, a, r), this._renderer.pointLightDiffuseColors.push(e1._array[0], e1._array[1], e1._array[2]), Array.prototype.push.apply(this._renderer.pointLightSpecularColors, this._renderer.specularColors), this._renderer._enableLighting = !0, this;
                }, m.default.prototype.imageLight = function(e1) {
                    this._renderer.activeImageLight = e1, this._renderer._enableLighting = !0;
                }, m.default.prototype.lights = function() {
                    this._assert3d("lights");
                    var e1 = this.color("rgb(128,128,128)");
                    return this.ambientLight(e1), this.directionalLight(e1, 0, 0, -1), this;
                }, m.default.prototype.lightFalloff = function(e1, t, r) {
                    return this._assert3d("lightFalloff"), m.default._validateParameters("lightFalloff", arguments), e1 < 0 && (e1 = 0, console.warn("Value of constant argument in lightFalloff() should be never be negative. Set to 0.")), t < 0 && (t = 0, console.warn("Value of linear argument in lightFalloff() should be never be negative. Set to 0.")), r < 0 && (r = 0, console.warn("Value of quadratic argument in lightFalloff() should be never be negative. Set to 0.")), 0 === e1 && 0 === t && 0 === r && (e1 = 1, console.warn("Either one of the three arguments in lightFalloff() should be greater than zero. Set constant argument to 1.")), this._renderer.constantAttenuation = e1, this._renderer.linearAttenuation = t, this._renderer.quadraticAttenuation = r, this;
                }, m.default.prototype.spotLight = function(e1, t, r, o, n, s, i, a, l, u, c) {
                    this._assert3d("spotLight"), m.default._validateParameters("spotLight", arguments);
                    var d, h, f, p = arguments.length;
                    switch(p){
                        case 11:
                        case 10:
                            d = this.color(e1, t, r), h = new m.default.Vector(o, n, s), f = new m.default.Vector(i, a, l);
                            break;
                        case 9:
                            e1 instanceof m.default.Color ? (d = e1, h = new m.default.Vector(t, r, o), f = new m.default.Vector(n, s, i), u = a, c = l) : o instanceof m.default.Vector ? (d = this.color(e1, t, r), h = o, f = new m.default.Vector(n, s, i), u = a, c = l) : i instanceof m.default.Vector ? (d = this.color(e1, t, r), h = new m.default.Vector(o, n, s), f = i, u = a, c = l) : (d = this.color(e1, t, r), h = new m.default.Vector(o, n, s), f = new m.default.Vector(i, a, l));
                            break;
                        case 8:
                            u = (f = e1 instanceof m.default.Color ? (d = e1, h = new m.default.Vector(t, r, o), new m.default.Vector(n, s, i)) : o instanceof m.default.Vector ? (d = this.color(e1, t, r), h = o, new m.default.Vector(n, s, i)) : (d = this.color(e1, t, r), h = new m.default.Vector(o, n, s), i), a);
                            break;
                        case 7:
                            e1 instanceof m.default.Color && t instanceof m.default.Vector ? (d = e1, h = t, f = new m.default.Vector(r, o, n), u = s, c = i) : e1 instanceof m.default.Color && n instanceof m.default.Vector ? (d = e1, h = new m.default.Vector(t, r, o), f = n, u = s, c = i) : o instanceof m.default.Vector && n instanceof m.default.Vector ? (d = this.color(e1, t, r), h = o, f = n, u = s, c = i) : f = e1 instanceof m.default.Color ? (d = e1, h = new m.default.Vector(t, r, o), new m.default.Vector(n, s, i)) : o instanceof m.default.Vector ? (d = this.color(e1, t, r), h = o, new m.default.Vector(n, s, i)) : (d = this.color(e1, t, r), h = new m.default.Vector(o, n, s), i);
                            break;
                        case 6:
                            o instanceof m.default.Vector && n instanceof m.default.Vector ? (d = this.color(e1, t, r), h = o, f = n, u = s) : e1 instanceof m.default.Color && n instanceof m.default.Vector ? (d = e1, h = new m.default.Vector(t, r, o), f = n, u = s) : e1 instanceof m.default.Color && t instanceof m.default.Vector && (d = e1, h = t, f = new m.default.Vector(r, o, n), u = s);
                            break;
                        case 5:
                            e1 instanceof m.default.Color && t instanceof m.default.Vector && r instanceof m.default.Vector ? (d = e1, h = t, f = r, u = o, c = n) : o instanceof m.default.Vector && n instanceof m.default.Vector ? (d = this.color(e1, t, r), h = o, f = n) : e1 instanceof m.default.Color && n instanceof m.default.Vector ? (d = e1, h = new m.default.Vector(t, r, o), f = n) : e1 instanceof m.default.Color && t instanceof m.default.Vector && (d = e1, h = t, f = new m.default.Vector(r, o, n));
                            break;
                        case 4:
                            d = e1, h = t, f = r, u = o;
                            break;
                        case 3:
                            d = e1, h = t, f = r;
                            break;
                        default:
                            return console.warn("Sorry, input for spotlight() is not in prescribed format. Too ".concat(p < 3 ? "few" : "many", " arguments were provided")), this;
                    }
                    return this._renderer.spotLightDiffuseColors.push(d._array[0], d._array[1], d._array[2]), Array.prototype.push.apply(this._renderer.spotLightSpecularColors, this._renderer.specularColors), this._renderer.spotLightPositions.push(h.x, h.y, h.z), f.normalize(), this._renderer.spotLightDirections.push(f.x, f.y, f.z), void 0 === u && (u = Math.PI / 3), void 0 !== c && c < 1 ? (c = 1, console.warn("Value of concentration needs to be greater than 1. Setting it to 1")) : void 0 === c && (c = 100), u = this._renderer._pInst._toRadians(u), this._renderer.spotLightAngle.push(Math.cos(u)), this._renderer.spotLightConc.push(c), this._renderer._enableLighting = !0, this;
                }, m.default.prototype.noLights = function() {
                    this._assert3d("noLights");
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return m.default._validateParameters("noLights", t), this._renderer._enableLighting = !1, this._renderer.ambientLightColors.length = 0, this._renderer.specularColors = [
                        1,
                        1,
                        1
                    ], this._renderer.directionalLightDirections.length = 0, this._renderer.directionalLightDiffuseColors.length = 0, this._renderer.directionalLightSpecularColors.length = 0, this._renderer.pointLightPositions.length = 0, this._renderer.pointLightDiffuseColors.length = 0, this._renderer.pointLightSpecularColors.length = 0, this._renderer.spotLightPositions.length = 0, this._renderer.spotLightDirections.length = 0, this._renderer.spotLightDiffuseColors.length = 0, this._renderer.spotLightSpecularColors.length = 0, this._renderer.spotLightAngle.length = 0, this._renderer.spotLightConc.length = 0, this._renderer.constantAttenuation = 1, this._renderer.linearAttenuation = 0, this._renderer.quadraticAttenuation = 0, this._renderer._useShininess = 1, this;
                };
                e1 = m.default;
                r.default = e1;
            },
            {
                "../core/main": 275
            }
        ],
        322: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var x = (o = e1("../core/main")) && o.__esModule ? o : {
                    default: o
                };
                e1("./p5.Geometry"), x.default.prototype.loadModel = function(e1) {
                    x.default._validateParameters("loadModel", arguments);
                    var y, g, t, r = e1.slice(-4), v = ("boolean" == typeof arguments[1] ? (y = arguments[1], g = arguments[2], t = arguments[3], void 0 !== arguments[4] && (r = arguments[4])) : (y = !1, g = arguments[1], t = arguments[2], void 0 !== arguments[3] && (r = arguments[3])), new x.default.Geometry), b = (v.gid = "".concat(e1, "|").concat(y), this);
                    return r.match(/\.stl$/i) ? this.httpDo(e1, "GET", "arrayBuffer", function(e1) {
                        !function(e1, t) {
                            if (function(e1) {
                                for(var t = new DataView(e1), r = [
                                    115,
                                    111,
                                    108,
                                    105,
                                    100
                                ], o = 0; o < 5; o++)if (function(e1, t, r) {
                                    for(var o = 0, n = e1.length; o < n; o++)if (e1[o] !== t.getUint8(r + o, !1)) return;
                                    return 1;
                                }(r, t, o)) return;
                                return 1;
                            }(t)) !function(e1, t) {
                                for(var r, o, n, s, i, a, l, u = new DataView(t), c = u.getUint32(80, !0), d = !1, h = 0; h < 70; h++)1129270351 === u.getUint32(h, !1) && 82 === u.getUint8(h + 4) && 61 === u.getUint8(h + 5) && (d = !0, s = [], i = u.getUint8(h + 6) / 255, a = u.getUint8(h + 7) / 255, l = u.getUint8(h + 8) / 255);
                                for(var f = 0; f < c; f++){
                                    for(var p, m = 84 + 50 * f, y = u.getFloat32(m, !0), g = u.getFloat32(4 + m, !0), v = u.getFloat32(8 + m, !0), b = (d && (p = u.getUint16(48 + m, !0), n = 0 == (32768 & p) ? (r = (31 & p) / 31, o = (p >> 5 & 31) / 31, (p >> 10 & 31) / 31) : (r = i, o = a, l)), new x.default.Vector(y, g, v)), j = 1; j <= 3; j++){
                                        var _ = m + 12 * j, _ = new x.default.Vector(u.getFloat32(_, !0), u.getFloat32(4 + _, !0), u.getFloat32(8 + _, !0));
                                        e1.vertices.push(_), e1.vertexNormals.push(b), d && s.push(r, o, n);
                                    }
                                    e1.faces.push([
                                        3 * f,
                                        3 * f + 1,
                                        3 * f + 2
                                    ]), e1.uvs.push([
                                        0,
                                        0
                                    ], [
                                        0,
                                        0
                                    ], [
                                        0,
                                        0
                                    ]);
                                }
                            }(e1, t);
                            else {
                                t = new DataView(t);
                                if (!("TextDecoder" in window)) return console.warn("Sorry, ASCII STL loading only works in browsers that support TextDecoder (https://caniuse.com/#feat=textencoder)");
                                t = new TextDecoder("utf-8").decode(t).split("\n");
                                !function(e1, t) {
                                    for(var r, o, n = "", s = [], i = 0; i < t.length; ++i){
                                        for(var a = t[i].trim(), l = a.split(" "), u = 0; u < l.length; ++u)"" === l[u] && l.splice(u, 1);
                                        if (0 !== l.length) switch(n){
                                            case "":
                                                if ("solid" !== l[0]) return console.error(a), console.error('Invalid state "'.concat(l[0], '", should be "solid"'));
                                                n = "solid";
                                                break;
                                            case "solid":
                                                if ("facet" !== l[0] || "normal" !== l[1]) return console.error(a), console.error('Invalid state "'.concat(l[0], '", should be "facet normal"'));
                                                r = new x.default.Vector(parseFloat(l[2]), parseFloat(l[3]), parseFloat(l[4])), e1.vertexNormals.push(r, r, r), n = "facet normal";
                                                break;
                                            case "facet normal":
                                                if ("outer" !== l[0] || "loop" !== l[1]) return console.error(a), console.error('Invalid state "'.concat(l[0], '", should be "outer loop"'));
                                                n = "vertex";
                                                break;
                                            case "vertex":
                                                if ("vertex" === l[0]) o = new x.default.Vector(parseFloat(l[1]), parseFloat(l[2]), parseFloat(l[3])), e1.vertices.push(o), e1.uvs.push([
                                                    0,
                                                    0
                                                ]), s.push(e1.vertices.indexOf(o));
                                                else {
                                                    if ("endloop" !== l[0]) return console.error(a), console.error('Invalid state "'.concat(l[0], '", should be "vertex" or "endloop"'));
                                                    e1.faces.push(s), s = [], n = "endloop";
                                                }
                                                break;
                                            case "endloop":
                                                if ("endfacet" !== l[0]) return console.error(a), console.error('Invalid state "'.concat(l[0], '", should be "endfacet"'));
                                                n = "endfacet";
                                                break;
                                            case "endfacet":
                                                if ("endsolid" !== l[0]) {
                                                    if ("facet" !== l[0] || "normal" !== l[1]) return console.error(a), console.error('Invalid state "'.concat(l[0], '", should be "endsolid" or "facet normal"'));
                                                    r = new x.default.Vector(parseFloat(l[2]), parseFloat(l[3]), parseFloat(l[4])), e1.vertexNormals.push(r, r, r), n = "facet normal";
                                                }
                                                break;
                                            default:
                                                console.error('Invalid state "'.concat(n, '"'));
                                        }
                                    }
                                }(e1, t);
                            }
                        }(v, e1), y && v.normalize(), b._decrementPreload(), "function" == typeof g && g(v);
                    }, t) : r.match(/\.obj$/i) ? this.loadStrings(e1, function(e1) {
                        for(var t = v, r = e1, o = {
                            v: [],
                            vt: [],
                            vn: []
                        }, n = {}, s = 0; s < r.length; ++s){
                            var i = r[s].trim().split(/\b\s+/);
                            if (0 < i.length) {
                                if ("v" === i[0] || "vn" === i[0]) {
                                    var a = new x.default.Vector(parseFloat(i[1]), parseFloat(i[2]), parseFloat(i[3]));
                                    o[i[0]].push(a);
                                } else if ("vt" === i[0]) {
                                    a = [
                                        parseFloat(i[1]),
                                        1 - parseFloat(i[2])
                                    ];
                                    o[i[0]].push(a);
                                } else if ("f" === i[0]) for(var l = 3; l < i.length; ++l){
                                    for(var u = [], c = [
                                        1,
                                        l - 1,
                                        l
                                    ], d = 0; d < c.length; ++d){
                                        var h = i[c[d]], f = 0;
                                        if (void 0 !== n[h]) f = n[h];
                                        else {
                                            for(var p = h.split("/"), m = 0; m < p.length; m++)p[m] = parseInt(p[m]) - 1;
                                            f = n[h] = t.vertices.length, t.vertices.push(o.v[p[0]].copy()), o.vt[p[1]] ? t.uvs.push(o.vt[p[1]].slice()) : t.uvs.push([
                                                0,
                                                0
                                            ]), o.vn[p[2]] && t.vertexNormals.push(o.vn[p[2]].copy());
                                        }
                                        u.push(f);
                                    }
                                    u[0] !== u[1] && u[0] !== u[2] && u[1] !== u[2] && t.faces.push(u);
                                }
                            }
                        }
                        0 === t.vertexNormals.length && t.computeNormals(), y && v.normalize(), b._decrementPreload(), "function" == typeof g && g(v);
                    }, t) : (x.default._friendlyFileLoadError(3, e1), t ? t() : x.default._friendlyError("Sorry, the file type is invalid. Only OBJ and STL files are supported.")), v;
                }, x.default.prototype.model = function(e1) {
                    this._assert3d("model"), x.default._validateParameters("model", arguments), 0 < e1.vertices.length && (this._renderer.geometryInHash(e1.gid) || (0 === e1.edges.length && e1._makeTriangleEdges(), e1._edgesToVertices(), this._renderer.createBuffers(e1.gid, e1)), this._renderer.drawBuffers(e1.gid));
                };
                var o = x.default;
                r.default = o;
            },
            {
                "../core/main": 275,
                "./p5.Geometry": 327,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.index-of": 160,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.array.splice": 167,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.string.match": 193,
                "core-js/modules/es.string.split": 198,
                "core-js/modules/es.string.trim": 201
            }
        ],
        323: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var u = (s = e1("../core/main")) && s.__esModule ? s : {
                    default: s
                }, n = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                e1("./p5.Texture"), u.default.prototype.loadShader = function(e1, t, r, o) {
                    u.default._validateParameters("loadShader", arguments), o = o || console.error;
                    function n() {
                        i._decrementPreload(), r && r(s);
                    }
                    var s = new u.default.Shader, i = this, a = !1, l = !1;
                    return this.loadStrings(e1, function(e1) {
                        s._vertSrc = e1.join("\n"), l = !0, a && n();
                    }, o), this.loadStrings(t, function(e1) {
                        s._fragSrc = e1.join("\n"), a = !0, l && n();
                    }, o), s;
                }, u.default.prototype.createShader = function(e1, t) {
                    return u.default._validateParameters("createShader", arguments), new u.default.Shader(this._renderer, e1, t);
                }, u.default.prototype.createFilterShader = function(e1) {
                    u.default._validateParameters("createFilterShader", arguments);
                    var t = e1.includes("#version 300 es") ? "#version 300 es\n    uniform mat4 uModelViewMatrix;\n    uniform mat4 uProjectionMatrix;\n\n    in vec3 aPosition;\n    in vec2 aTexCoord;\n    out vec2 vTexCoord;\n\n    void main() {\n      // transferring texcoords for the frag shader\n      vTexCoord = aTexCoord;\n\n      // copy position with a fourth coordinate for projection (1.0 is normal)\n      vec4 positionVec4 = vec4(aPosition, 1.0);\n\n      // project to 3D space\n      gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n    }\n  " : "\n    uniform mat4 uModelViewMatrix;\n    uniform mat4 uProjectionMatrix;\n\n    attribute vec3 aPosition;\n    // texcoords only come from p5 to vertex shader\n    // so pass texcoords on to the fragment shader in a varying variable\n    attribute vec2 aTexCoord;\n    varying vec2 vTexCoord;\n\n    void main() {\n      // transferring texcoords for the frag shader\n      vTexCoord = aTexCoord;\n\n      // copy position with a fourth coordinate for projection (1.0 is normal)\n      vec4 positionVec4 = vec4(aPosition, 1.0);\n\n      // project to 3D space\n      gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n    }\n  ", t = new u.default.Shader(this._renderer, t, e1);
                    return this._renderer.GL ? t.ensureCompiledOnContext(this) : t.ensureCompiledOnContext(this._renderer.getFilterGraphicsLayer()), t;
                }, u.default.prototype.shader = function(e1) {
                    return this._assert3d("shader"), u.default._validateParameters("shader", arguments), e1.ensureCompiledOnContext(this), e1.isStrokeShader() ? this._renderer.userStrokeShader = e1 : (this._renderer.userFillShader = e1, this._renderer._useNormalMaterial = !1), this;
                }, u.default.prototype.resetShader = function() {
                    return this._renderer.userFillShader = this._renderer.userStrokeShader = null, this;
                }, u.default.prototype.texture = function(e1) {
                    return this._assert3d("texture"), u.default._validateParameters("texture", arguments), e1.gifProperties && e1._animateGif(this), this._renderer.drawMode = n.TEXTURE, this._renderer._useNormalMaterial = !1, this._renderer._tex = e1, this._renderer._setProperty("_doFill", !0), this;
                }, u.default.prototype.textureMode = function(e1) {
                    e1 !== n.IMAGE && e1 !== n.NORMAL ? console.warn("You tried to set ".concat(e1, " textureMode only supports IMAGE & NORMAL ")) : this._renderer.textureMode = e1;
                }, u.default.prototype.textureWrap = function(e1) {
                    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : e1, r = (this._renderer.textureWrapX = e1, this._renderer.textureWrapY = t, !0), o = !1, n = void 0;
                    try {
                        for(var s, i = this._renderer.textures.values()[Symbol.iterator](); !(r = (s = i.next()).done); r = !0)s.value.setWrapMode(e1, t);
                    } catch (e1) {
                        o = !0, n = e1;
                    } finally{
                        try {
                            r || null == i.return || i.return();
                        } finally{
                            if (o) throw n;
                        }
                    }
                }, u.default.prototype.normalMaterial = function() {
                    this._assert3d("normalMaterial");
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return u.default._validateParameters("normalMaterial", t), this._renderer.drawMode = n.FILL, this._renderer._useSpecularMaterial = !1, this._renderer._useEmissiveMaterial = !1, this._renderer._useNormalMaterial = !0, this._renderer.curFillColor = [
                        1,
                        1,
                        1,
                        1
                    ], this._renderer._setProperty("_doFill", !0), this.noStroke(), this;
                }, u.default.prototype.ambientMaterial = function(e1, t, r) {
                    this._assert3d("ambientMaterial"), u.default._validateParameters("ambientMaterial", arguments);
                    var o = u.default.prototype.color.apply(this, arguments);
                    return this._renderer._hasSetAmbient = !0, this._renderer.curAmbientColor = o._array, this._renderer._useNormalMaterial = !1, this._renderer._enableLighting = !0, this._renderer._setProperty("_doFill", !0), this;
                }, u.default.prototype.emissiveMaterial = function(e1, t, r, o) {
                    this._assert3d("emissiveMaterial"), u.default._validateParameters("emissiveMaterial", arguments);
                    var n = u.default.prototype.color.apply(this, arguments);
                    return this._renderer.curEmissiveColor = n._array, this._renderer._useEmissiveMaterial = !0, this._renderer._useNormalMaterial = !1, this._renderer._enableLighting = !0, this;
                }, u.default.prototype.specularMaterial = function(e1, t, r, o) {
                    this._assert3d("specularMaterial"), u.default._validateParameters("specularMaterial", arguments);
                    var n = u.default.prototype.color.apply(this, arguments);
                    return this._renderer.curSpecularColor = n._array, this._renderer._useSpecularMaterial = !0, this._renderer._useNormalMaterial = !1, this._renderer._enableLighting = !0, this;
                }, u.default.prototype.shininess = function(e1) {
                    return this._assert3d("shininess"), u.default._validateParameters("shininess", arguments), this._renderer._useShininess = e1 = e1 < 1 ? 1 : e1, this;
                }, u.default.RendererGL.prototype._applyColorBlend = function(e1) {
                    var t = this.GL, r = this.drawMode === n.TEXTURE, r = this.userFillShader || this.userStrokeShader || this.userPointShader || r || this.curBlendMode !== n.BLEND || e1[e1.length - 1] < 1 || this._isErasing;
                    return r !== this._isBlending && (r || this.curBlendMode !== n.BLEND && this.curBlendMode !== n.ADD ? t.enable(t.BLEND) : t.disable(t.BLEND), t.depthMask(!0), this._isBlending = r), this._applyBlendMode(), e1;
                }, u.default.RendererGL.prototype._applyBlendMode = function() {
                    if (this._cachedBlendMode !== this.curBlendMode) {
                        var e1 = this.GL;
                        switch(this.curBlendMode){
                            case n.BLEND:
                                e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.ONE, e1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case n.ADD:
                                e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.ONE, e1.ONE);
                                break;
                            case n.REMOVE:
                                e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.ZERO, e1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case n.MULTIPLY:
                                e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.DST_COLOR, e1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case n.SCREEN:
                                e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.ONE, e1.ONE_MINUS_SRC_COLOR);
                                break;
                            case n.EXCLUSION:
                                e1.blendEquationSeparate(e1.FUNC_ADD, e1.FUNC_ADD), e1.blendFuncSeparate(e1.ONE_MINUS_DST_COLOR, e1.ONE_MINUS_SRC_COLOR, e1.ONE, e1.ONE);
                                break;
                            case n.REPLACE:
                                e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.ONE, e1.ZERO);
                                break;
                            case n.SUBTRACT:
                                e1.blendEquationSeparate(e1.FUNC_REVERSE_SUBTRACT, e1.FUNC_ADD), e1.blendFuncSeparate(e1.ONE, e1.ONE, e1.ONE, e1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case n.DARKEST:
                                this.blendExt ? (e1.blendEquationSeparate(this.blendExt.MIN || this.blendExt.MIN_EXT, e1.FUNC_ADD), e1.blendFuncSeparate(e1.ONE, e1.ONE, e1.ONE, e1.ONE)) : console.warn("blendMode(DARKEST) does not work in your browser in WEBGL mode.");
                                break;
                            case n.LIGHTEST:
                                this.blendExt ? (e1.blendEquationSeparate(this.blendExt.MAX || this.blendExt.MAX_EXT, e1.FUNC_ADD), e1.blendFuncSeparate(e1.ONE, e1.ONE, e1.ONE, e1.ONE)) : console.warn("blendMode(LIGHTEST) does not work in your browser in WEBGL mode.");
                                break;
                            default:
                                console.error("Oops! Somehow RendererGL set curBlendMode to an unsupported mode.");
                        }
                        this._isErasing || (this._cachedBlendMode = this.curBlendMode);
                    }
                };
                var s = u.default;
                r.default = s;
            },
            {
                "../core/constants": 264,
                "../core/main": 275,
                "./p5.Texture": 334,
                "core-js/modules/es.array.includes": 159,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.join": 162,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.string.includes": 191,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        324: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.string.sub"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.string.sub"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var _ = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                _.default.prototype.camera = function() {
                    var e1;
                    this._assert3d("camera");
                    for(var t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return _.default._validateParameters("camera", r), (e1 = this._renderer._curCamera).camera.apply(e1, r), this;
                }, _.default.prototype.perspective = function() {
                    var e1;
                    this._assert3d("perspective");
                    for(var t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return _.default._validateParameters("perspective", r), (e1 = this._renderer._curCamera).perspective.apply(e1, r), this;
                }, _.default.prototype.ortho = function() {
                    var e1;
                    this._assert3d("ortho");
                    for(var t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return _.default._validateParameters("ortho", r), (e1 = this._renderer._curCamera).ortho.apply(e1, r), this;
                }, _.default.prototype.frustum = function() {
                    var e1;
                    this._assert3d("frustum");
                    for(var t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return _.default._validateParameters("frustum", r), (e1 = this._renderer._curCamera).frustum.apply(e1, r), this;
                }, _.default.prototype.createCamera = function() {
                    this._assert3d("createCamera");
                    var e1 = new _.default.Camera(this._renderer);
                    return e1._computeCameraDefaultSettings(), e1._setDefaultCamera(), this._renderer._curCamera = e1;
                }, _.default.Camera = function() {
                    function t(e1) {
                        if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function");
                        this._renderer = e1, this.cameraType = "default", this.cameraMatrix = new _.default.Matrix, this.projMatrix = new _.default.Matrix, this.yScale = 1;
                    }
                    var e1, r, o;
                    return e1 = t, r = [
                        {
                            key: "perspective",
                            value: function(e1, t, r, o) {
                                this.cameraType = 0 < arguments.length ? "custom" : "default", void 0 === e1 ? (e1 = this.defaultCameraFOV, this.cameraFOV = e1) : this.cameraFOV = this._renderer._pInst._toRadians(e1), void 0 === t && (t = this.defaultAspectRatio), void 0 === r && (r = this.defaultCameraNear), void 0 === o && (o = this.defaultCameraFar), r <= 1e-4 && (r = .01, console.log("Avoid perspective near plane values close to or below 0. Setting value to 0.01.")), o < r && console.log("Perspective far plane value is less than near plane value. Nothing will be shown."), this.aspectRatio = t, this.cameraNear = r, this.cameraFar = o, this.projMatrix = _.default.Matrix.identity();
                                var e1 = 1 / Math.tan(this.cameraFOV / 2), n = 1 / (this.cameraNear - this.cameraFar);
                                this.projMatrix.set(e1 / t, 0, 0, 0, 0, -e1 * this.yScale, 0, 0, 0, 0, (o + r) * n, -1, 0, 0, 2 * o * r * n, 0), this._isActive() && this._renderer.uPMatrix.set(this.projMatrix.mat4[0], this.projMatrix.mat4[1], this.projMatrix.mat4[2], this.projMatrix.mat4[3], this.projMatrix.mat4[4], this.projMatrix.mat4[5], this.projMatrix.mat4[6], this.projMatrix.mat4[7], this.projMatrix.mat4[8], this.projMatrix.mat4[9], this.projMatrix.mat4[10], this.projMatrix.mat4[11], this.projMatrix.mat4[12], this.projMatrix.mat4[13], this.projMatrix.mat4[14], this.projMatrix.mat4[15]);
                            }
                        },
                        {
                            key: "ortho",
                            value: function(e1, t, r, o, n, s) {
                                void 0 === e1 && (e1 = -this._renderer.width / 2), void 0 === t && (t = +this._renderer.width / 2), void 0 === r && (r = -this._renderer.height / 2), void 0 === o && (o = +this._renderer.height / 2), void 0 === n && (n = 0), void 0 === s && (s = Math.max(this._renderer.width, this._renderer.height)), this.cameraNear = n;
                                var i = t - e1, a = o - r, l = (this.cameraFar = s) - n, u = 2 / i, c = 2 / a * this.yScale, d = -2 / l, t = -(t + e1) / i, e1 = -(o + r) / a, i = -(s + n) / l;
                                this.projMatrix = _.default.Matrix.identity(), this.projMatrix.set(u, 0, 0, 0, 0, -c, 0, 0, 0, 0, d, 0, t, e1, i, 1), this._isActive() && this._renderer.uPMatrix.set(this.projMatrix.mat4[0], this.projMatrix.mat4[1], this.projMatrix.mat4[2], this.projMatrix.mat4[3], this.projMatrix.mat4[4], this.projMatrix.mat4[5], this.projMatrix.mat4[6], this.projMatrix.mat4[7], this.projMatrix.mat4[8], this.projMatrix.mat4[9], this.projMatrix.mat4[10], this.projMatrix.mat4[11], this.projMatrix.mat4[12], this.projMatrix.mat4[13], this.projMatrix.mat4[14], this.projMatrix.mat4[15]), this.cameraType = "custom";
                            }
                        },
                        {
                            key: "frustum",
                            value: function(e1, t, r, o, n, s) {
                                void 0 === e1 && (e1 = .05 * -this._renderer.width), void 0 === t && (t = .05 * +this._renderer.width), void 0 === r && (r = .05 * +this._renderer.height), void 0 === o && (o = .05 * -this._renderer.height), void 0 === n && (n = this.defaultCameraNear), void 0 === s && (s = this.defaultCameraFar), this.cameraNear = n;
                                var i = t - e1, a = o - r, l = (this.cameraFar = s) - n, u = 2 * n / i, c = 2 * n / a * this.yScale, d = -2 * s * n / l, t = (t + e1) / i, e1 = (o + r) / a, i = -(s + n) / l;
                                this.projMatrix = _.default.Matrix.identity(), this.projMatrix.set(u, 0, 0, 0, 0, -c, 0, 0, t, e1, i, -1, 0, 0, d, 0), this._isActive() && this._renderer.uPMatrix.set(this.projMatrix.mat4[0], this.projMatrix.mat4[1], this.projMatrix.mat4[2], this.projMatrix.mat4[3], this.projMatrix.mat4[4], this.projMatrix.mat4[5], this.projMatrix.mat4[6], this.projMatrix.mat4[7], this.projMatrix.mat4[8], this.projMatrix.mat4[9], this.projMatrix.mat4[10], this.projMatrix.mat4[11], this.projMatrix.mat4[12], this.projMatrix.mat4[13], this.projMatrix.mat4[14], this.projMatrix.mat4[15]), this.cameraType = "custom";
                            }
                        },
                        {
                            key: "_rotateView",
                            value: function(e1, t, r, o) {
                                var n = this.centerX, s = this.centerY, i = this.centerZ, a = (n -= this.eyeX, s -= this.eyeY, i -= this.eyeZ, _.default.Matrix.identity(this._renderer._pInst)), e1 = (a.rotate(this._renderer._pInst._toRadians(e1), t, r, o), [
                                    n * a.mat4[0] + s * a.mat4[4] + i * a.mat4[8],
                                    n * a.mat4[1] + s * a.mat4[5] + i * a.mat4[9],
                                    n * a.mat4[2] + s * a.mat4[6] + i * a.mat4[10]
                                ]);
                                e1[0] += this.eyeX, e1[1] += this.eyeY, e1[2] += this.eyeZ, this.camera(this.eyeX, this.eyeY, this.eyeZ, e1[0], e1[1], e1[2], this.upX, this.upY, this.upZ);
                            }
                        },
                        {
                            key: "pan",
                            value: function(e1) {
                                var t = this._getLocalAxes();
                                this._rotateView(e1, t.y[0], t.y[1], t.y[2]);
                            }
                        },
                        {
                            key: "tilt",
                            value: function(e1) {
                                var t = this._getLocalAxes();
                                this._rotateView(e1, t.x[0], t.x[1], t.x[2]);
                            }
                        },
                        {
                            key: "lookAt",
                            value: function(e1, t, r) {
                                this.camera(this.eyeX, this.eyeY, this.eyeZ, e1, t, r, this.upX, this.upY, this.upZ);
                            }
                        },
                        {
                            key: "camera",
                            value: function(e1, t, r, o, n, s, i, a, l) {
                                void 0 === e1 && (e1 = this.defaultEyeX, t = this.defaultEyeY, r = this.defaultEyeZ, o = e1, n = t, a = 1, l = i = s = 0), this.eyeX = e1, this.eyeY = t, this.eyeZ = r, void 0 !== o && (this.centerX = o, this.centerY = n, this.centerZ = s), void 0 !== i && (this.upX = i, this.upY = a, this.upZ = l);
                                o = this._getLocalAxes(), this.cameraMatrix.set(o.x[0], o.y[0], o.z[0], 0, o.x[1], o.y[1], o.z[1], 0, o.x[2], o.y[2], o.z[2], 0, 0, 0, 0, 1), n = -e1;
                                return this.cameraMatrix.translate([
                                    n,
                                    -t,
                                    -r
                                ]), this._isActive() && this._renderer.uMVMatrix.set(this.cameraMatrix.mat4[0], this.cameraMatrix.mat4[1], this.cameraMatrix.mat4[2], this.cameraMatrix.mat4[3], this.cameraMatrix.mat4[4], this.cameraMatrix.mat4[5], this.cameraMatrix.mat4[6], this.cameraMatrix.mat4[7], this.cameraMatrix.mat4[8], this.cameraMatrix.mat4[9], this.cameraMatrix.mat4[10], this.cameraMatrix.mat4[11], this.cameraMatrix.mat4[12], this.cameraMatrix.mat4[13], this.cameraMatrix.mat4[14], this.cameraMatrix.mat4[15]), this;
                            }
                        },
                        {
                            key: "move",
                            value: function(e1, t, r) {
                                var o = this._getLocalAxes(), e1 = [
                                    o.x[0] * e1,
                                    o.x[1] * e1,
                                    o.x[2] * e1
                                ], t = [
                                    o.y[0] * t,
                                    o.y[1] * t,
                                    o.y[2] * t
                                ], o = [
                                    o.z[0] * r,
                                    o.z[1] * r,
                                    o.z[2] * r
                                ];
                                this.camera(this.eyeX + e1[0] + t[0] + o[0], this.eyeY + e1[1] + t[1] + o[1], this.eyeZ + e1[2] + t[2] + o[2], this.centerX + e1[0] + t[0] + o[0], this.centerY + e1[1] + t[1] + o[1], this.centerZ + e1[2] + t[2] + o[2], this.upX, this.upY, this.upZ);
                            }
                        },
                        {
                            key: "setPosition",
                            value: function(e1, t, r) {
                                var o = e1 - this.eyeX, n = t - this.eyeY, s = r - this.eyeZ;
                                this.camera(e1, t, r, this.centerX + o, this.centerY + n, this.centerZ + s, this.upX, this.upY, this.upZ);
                            }
                        },
                        {
                            key: "set",
                            value: function(e1) {
                                for(var t = 0, r = [
                                    "eyeX",
                                    "eyeY",
                                    "eyeZ",
                                    "centerX",
                                    "centerY",
                                    "centerZ",
                                    "upX",
                                    "upY",
                                    "upZ",
                                    "cameraFOV",
                                    "aspectRatio",
                                    "cameraNear",
                                    "cameraFar",
                                    "cameraType",
                                    "yScale"
                                ]; t < r.length; t++){
                                    var o = r[t];
                                    this[o] = e1[o];
                                }
                                this.cameraMatrix = e1.cameraMatrix.copy(), this.projMatrix = e1.projMatrix.copy(), this._isActive() && (this._renderer.uMVMatrix.mat4 = this.cameraMatrix.mat4.slice(), this._renderer.uPMatrix.mat4 = this.projMatrix.mat4.slice());
                            }
                        },
                        {
                            key: "slerp",
                            value: function(e1, t, r) {
                                var o, n, s, i, a, l, u, c, d, h, f, p, m, y, g, v, b, j;
                                0 === r ? this.set(e1) : 1 === r ? this.set(t) : (0 !== this.projMatrix.mat4[15] && (this.projMatrix.mat4[0] = e1.projMatrix.mat4[0] * Math.pow(t.projMatrix.mat4[0] / e1.projMatrix.mat4[0], r), this.projMatrix.mat4[5] = e1.projMatrix.mat4[5] * Math.pow(t.projMatrix.mat4[5] / e1.projMatrix.mat4[5], r), this._isActive() && (this._renderer.uPMatrix.mat4 = this.projMatrix.mat4.slice())), i = new _.default.Vector(e1.eyeX, e1.eyeY, e1.eyeZ), a = new _.default.Vector(t.eyeX, t.eyeY, t.eyeZ), v = new _.default.Vector(e1.centerX, e1.centerY, e1.centerZ), j = new _.default.Vector(t.centerX, t.centerY, t.centerZ), s = _.default.Vector.dist(i, v), o = _.default.Vector.dist(a, j), o = s * Math.pow(o / s, r), s = _.default.Vector.sub(i, a), n = 1, 1e-6 < (b = (y = i.copy().sub(a).sub(v).add(j)).magSq()) && (n = _.default.Vector.dot(s, y) / b, n = Math.max(0, Math.min(n, 1))), s = _.default.Vector.lerp(_.default.Vector.lerp(i, v, n), _.default.Vector.lerp(a, j, n), r), y = e1.cameraMatrix.createSubMatrix3x3(), b = t.cameraMatrix.createSubMatrix3x3(), i = y.row(2), v = b.row(2), a = y.row(1), j = b.row(1), e1 = new _.default.Vector, t = new _.default.Vector, l = new _.default.Vector, u = new _.default.Vector, 1 - (c = .5 * ((y = (b = b.mult3x3(y.copy().transpose3x3())).diagonal())[0] + y[1] + y[2] - 1)) < 1e-7 ? (e1.set(_.default.Vector.lerp(i, v, r)).normalize(), l.set(e1).mult(n * o).add(s), u.set(e1).mult((n - 1) * o).add(s), t.set(_.default.Vector.lerp(a, j, r)).normalize()) : (v = 1 / (1 - c), j = Math.max(y[0], y[1], y[2]), p = b.mat3[1] + b.mat3[3], m = b.mat3[2] + b.mat3[6], g = b.mat3[5] + b.mat3[7], j = j === y[0] ? (h = .5 * p * (v /= d = Math.sqrt((y[0] - c) * v)), f = .5 * m * v, .5 * (b.mat3[7] - b.mat3[5]) / d) : j === y[1] ? (f = .5 * g * (v /= h = Math.sqrt((y[1] - c) * v)), d = .5 * p * v, .5 * (b.mat3[2] - b.mat3[6]) / h) : (d = .5 * m * (v /= f = Math.sqrt((y[2] - c) * v)), h = .5 * g * v, .5 * (b.mat3[3] - b.mat3[1]) / f), p = r * Math.atan2(j, c), m = Math.cos(p), y = Math.sin(p), (j = new _.default.Matrix("mat3", [
                                    m + (g = 1 - m) * d * d,
                                    g * (v = d * h) + y * f,
                                    g * (b = f * d) - y * h,
                                    g * v - y * f,
                                    m + g * h * h,
                                    g * (r = h * f) + y * d,
                                    g * b + y * h,
                                    g * r - y * d,
                                    m + g * f * f
                                ])).multiplyVec3(i, e1), l.set(e1).mult(n * o).add(s), u.set(e1).mult((n - 1) * o).add(s), j.multiplyVec3(a, t)), this.camera(l.x, l.y, l.z, u.x, u.y, u.z, t.x, t.y, t.z));
                            }
                        },
                        {
                            key: "_computeCameraDefaultSettings",
                            value: function() {
                                this.defaultAspectRatio = this._renderer.width / this._renderer.height, this.defaultEyeX = 0, this.defaultEyeY = 0, this.defaultEyeZ = 800, this.defaultCameraFOV = 2 * Math.atan(this._renderer.height / 2 / this.defaultEyeZ), this.defaultCenterX = 0, this.defaultCenterY = 0, this.defaultCenterZ = 0, this.defaultCameraNear = .1 * this.defaultEyeZ, this.defaultCameraFar = 10 * this.defaultEyeZ;
                            }
                        },
                        {
                            key: "_setDefaultCamera",
                            value: function() {
                                this.cameraFOV = this.defaultCameraFOV, this.aspectRatio = this.defaultAspectRatio, this.eyeX = this.defaultEyeX, this.eyeY = this.defaultEyeY, this.eyeZ = this.defaultEyeZ, this.centerX = this.defaultCenterX, this.centerY = this.defaultCenterY, this.centerZ = this.defaultCenterZ, this.upX = 0, this.upY = 1, this.upZ = 0, this.cameraNear = this.defaultCameraNear, this.cameraFar = this.defaultCameraFar, this.perspective(), this.camera(), this.cameraType = "default";
                            }
                        },
                        {
                            key: "_resize",
                            value: function() {
                                "default" === this.cameraType && (this._computeCameraDefaultSettings(), this.cameraFOV = this.defaultCameraFOV, this.aspectRatio = this.defaultAspectRatio, this.perspective());
                            }
                        },
                        {
                            key: "copy",
                            value: function() {
                                var e1 = new _.default.Camera(this._renderer);
                                return e1.cameraFOV = this.cameraFOV, e1.aspectRatio = this.aspectRatio, e1.eyeX = this.eyeX, e1.eyeY = this.eyeY, e1.eyeZ = this.eyeZ, e1.centerX = this.centerX, e1.centerY = this.centerY, e1.centerZ = this.centerZ, e1.upX = this.upX, e1.upY = this.upY, e1.upZ = this.upZ, e1.cameraNear = this.cameraNear, e1.cameraFar = this.cameraFar, e1.cameraType = this.cameraType, e1.cameraMatrix = this.cameraMatrix.copy(), e1.projMatrix = this.projMatrix.copy(), e1.yScale = this.yScale, e1;
                            }
                        },
                        {
                            key: "_getLocalAxes",
                            value: function() {
                                var e1 = this.eyeX - this.centerX, t = this.eyeY - this.centerY, r = this.eyeZ - this.centerZ, o = Math.sqrt(e1 * e1 + t * t + r * r), o = (0 !== o && (e1 /= o, t /= o, r /= o), this.upX), n = (a = this.upY) * r - (l = this.upZ) * t, s = -o * r + l * e1, i = o * t - a * e1, o = t * i - r * s, a = -e1 * i + r * n, l = e1 * s - t * n, u = Math.sqrt(n * n + s * s + i * i), u = (0 !== u && (n /= u, s /= u, i /= u), Math.sqrt(o * o + a * a + l * l));
                                return 0 !== u && (o /= u, a /= u, l /= u), {
                                    x: [
                                        n,
                                        s,
                                        i
                                    ],
                                    y: [
                                        o,
                                        a,
                                        l
                                    ],
                                    z: [
                                        e1,
                                        t,
                                        r
                                    ]
                                };
                            }
                        },
                        {
                            key: "_orbit",
                            value: function(e1, t, r) {
                                var o = this.eyeX - this.centerX, n = this.eyeY - this.centerY, s = this.eyeZ - this.centerZ, i = Math.hypot(o, n, s), o = new _.default.Vector(o, n, s).normalize(), n = new _.default.Vector(this.upX, this.upY, this.upZ).normalize(), s = new _.default.Vector.cross(n, o).normalize(), a = new _.default.Vector.cross(s, n), r = ((i = (i *= Math.pow(10, r)) < this.cameraNear ? this.cameraNear : i) > this.cameraFar && (i = this.cameraFar), Math.acos(Math.max(-1, Math.min(1, _.default.Vector.dot(o, n)))) + t), t = e1;
                                (r <= 0 || r >= Math.PI) && (this.upX *= -1, this.upY *= -1, this.upZ *= -1), n.mult(Math.cos(r)), a.mult(Math.cos(t) * Math.sin(r)), s.mult(Math.sin(t) * Math.sin(r)), o.set(n).add(a).add(s), this.eyeX = i * o.x + this.centerX, this.eyeY = i * o.y + this.centerY, this.eyeZ = i * o.z + this.centerZ, this.camera(this.eyeX, this.eyeY, this.eyeZ, this.centerX, this.centerY, this.centerZ, this.upX, this.upY, this.upZ);
                            }
                        },
                        {
                            key: "_orbitFree",
                            value: function(e1, t, r) {
                                var o = this.eyeX - this.centerX, n = this.eyeY - this.centerY, s = this.eyeZ - this.centerZ, i = Math.hypot(o, n, s), o = new _.default.Vector(o, n, s).normalize(), n = new _.default.Vector(this.upX, this.upY, this.upZ), s = new _.default.Vector.cross(n, o).normalize(), a = new _.default.Vector.cross(o, s), l = Math.atan2(t, e1), l = (a.mult(Math.sin(l)), s.mult(Math.cos(l)).add(a), Math.sqrt(e1 * e1 + t * t)), a = new _.default.Vector.cross(o, s), e1 = ((i = (i *= Math.pow(10, r)) < this.cameraNear ? this.cameraNear : i) > this.cameraFar && (i = this.cameraFar), Math.cos(l)), t = Math.sin(l), r = n.dot(o), l = n.dot(s), u = r * e1 + l * t, r = -r * t + l * e1, l = n.dot(a);
                                n.x = u * o.x + r * s.x + l * a.x, n.y = u * o.y + r * s.y + l * a.y, n.z = u * o.z + r * s.z + l * a.z, s.mult(-t), o.mult(e1).add(s).mult(i), this.camera(o.x + this.centerX, o.y + this.centerY, o.z + this.centerZ, this.centerX, this.centerY, this.centerZ, n.x, n.y, n.z);
                            }
                        },
                        {
                            key: "_isActive",
                            value: function() {
                                return this === this._renderer._curCamera;
                            }
                        }
                    ], n(e1.prototype, r), o && n(e1, o), t;
                }(), _.default.prototype.setCamera = function(e1) {
                    this._renderer._curCamera = e1, this._renderer.uPMatrix.set(e1.projMatrix.mat4[0], e1.projMatrix.mat4[1], e1.projMatrix.mat4[2], e1.projMatrix.mat4[3], e1.projMatrix.mat4[4], e1.projMatrix.mat4[5], e1.projMatrix.mat4[6], e1.projMatrix.mat4[7], e1.projMatrix.mat4[8], e1.projMatrix.mat4[9], e1.projMatrix.mat4[10], e1.projMatrix.mat4[11], e1.projMatrix.mat4[12], e1.projMatrix.mat4[13], e1.projMatrix.mat4[14], e1.projMatrix.mat4[15]);
                };
                e1 = _.default.Camera;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.math.hypot": 170,
                "core-js/modules/es.string.sub": 200
            }
        ],
        325: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.log2"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.log2"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                e1.default.DataArray = function() {
                    function o() {
                        var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 128, t = this, r = o;
                        if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
                        this.length = 0, this.data = new Float32Array(e1), this.initialLength = e1;
                    }
                    var e1, t, r;
                    return e1 = o, t = [
                        {
                            key: "dataArray",
                            value: function() {
                                return this.subArray(0, this.length);
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.length = 0;
                            }
                        },
                        {
                            key: "rescale",
                            value: function() {
                                var e1;
                                this.length < this.data.length / 2 && (e1 = 1 << Math.ceil(Math.log2(this.length)), (e1 = new Float32Array(e1)).set(this.data.subarray(0, this.length), 0), this.data = e1);
                            }
                        },
                        {
                            key: "reset",
                            value: function() {
                                this.clear(), this.data = new Float32Array(this.initialLength);
                            }
                        },
                        {
                            key: "push",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                this.ensureLength(this.length + t.length), this.data.set(t, this.length), this.length += t.length;
                            }
                        },
                        {
                            key: "slice",
                            value: function(e1, t) {
                                return this.data.slice(e1, Math.min(t, this.length));
                            }
                        },
                        {
                            key: "subArray",
                            value: function(e1, t) {
                                return this.data.subarray(e1, Math.min(t, this.length));
                            }
                        },
                        {
                            key: "ensureLength",
                            value: function(e1) {
                                for(; this.data.length < e1;){
                                    var t = new Float32Array(2 * this.data.length);
                                    t.set(this.data, 0), this.data = t;
                                }
                            }
                        }
                    ], n(e1.prototype, t), r && n(e1, r), o;
                }();
                e1 = e1.default.DataArray;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.math.log2": 171,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.typed-array.copy-within": 205,
                "core-js/modules/es.typed-array.every": 206,
                "core-js/modules/es.typed-array.fill": 207,
                "core-js/modules/es.typed-array.filter": 208,
                "core-js/modules/es.typed-array.find": 210,
                "core-js/modules/es.typed-array.find-index": 209,
                "core-js/modules/es.typed-array.float32-array": 211,
                "core-js/modules/es.typed-array.for-each": 213,
                "core-js/modules/es.typed-array.includes": 214,
                "core-js/modules/es.typed-array.index-of": 215,
                "core-js/modules/es.typed-array.iterator": 218,
                "core-js/modules/es.typed-array.join": 219,
                "core-js/modules/es.typed-array.last-index-of": 220,
                "core-js/modules/es.typed-array.map": 221,
                "core-js/modules/es.typed-array.reduce": 223,
                "core-js/modules/es.typed-array.reduce-right": 222,
                "core-js/modules/es.typed-array.reverse": 224,
                "core-js/modules/es.typed-array.set": 225,
                "core-js/modules/es.typed-array.slice": 226,
                "core-js/modules/es.typed-array.some": 227,
                "core-js/modules/es.typed-array.sort": 228,
                "core-js/modules/es.typed-array.subarray": 229,
                "core-js/modules/es.typed-array.to-locale-string": 230,
                "core-js/modules/es.typed-array.to-string": 231
            }
        ],
        326: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.reflect.get"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint8-clamped-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint8-clamped-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var f = (_ = e1("../core/main")) && _.__esModule ? _ : {
                    default: _
                }, a = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = l();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants")), n = e1("./p5.Texture"), p = e1("./p5.RendererGL");
                function l() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, l = function() {
                        return e1;
                    }, e1);
                }
                function u(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) {
                            var r = [], o = !0, n = !1, s = void 0;
                            try {
                                for(var i, a = e1[Symbol.iterator](); !(o = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); o = !0);
                            } catch (e1) {
                                n = !0, s = e1;
                            } finally{
                                try {
                                    o || null == a.return || a.return();
                                } finally{
                                    if (n) throw s;
                                }
                            }
                            return r;
                        }
                    }(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    }();
                }
                function s(e1, t, r) {
                    return t in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function c(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function d(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function h(e1, t, r) {
                    t && d(e1.prototype, t), r && d(e1, r);
                }
                function m(e1, t, r) {
                    return (m = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e1, t, r) {
                        var e1 = function(e1, t) {
                            for(; !Object.prototype.hasOwnProperty.call(e1, t) && null !== (e1 = v(e1)););
                            return e1;
                        }(e1, t);
                        if (e1) return (e1 = Object.getOwnPropertyDescriptor(e1, t)).get ? e1.get.call(r) : e1.value;
                    })(e1, t, r || e1);
                }
                function y(e1, t) {
                    return (y = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function g(r) {
                    return function() {
                        var e1, t = v(r), t = (e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = v(this).constructor, Reflect.construct(t, arguments, e1)) : t.apply(this, arguments), this);
                        if (!e1 || "object" !== i(e1) && "function" != typeof e1) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }
                        return e1;
                    };
                }
                function v(e1) {
                    return (v = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                var b = function(e1) {
                    var t = o;
                    if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e1 && e1.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e1 && y(t, e1);
                    var r = g(o);
                    function o(e1) {
                        var t;
                        return c(this, o), (t = r.call(this, e1.target._renderer)).fbo = e1, t.yScale = -1, t;
                    }
                    return h(o, [
                        {
                            key: "_computeCameraDefaultSettings",
                            value: function() {
                                m(v(o.prototype), "_computeCameraDefaultSettings", this).call(this), this.defaultAspectRatio = this.fbo.width / this.fbo.height, this.defaultCameraFOV = 2 * Math.atan(this.fbo.height / 2 / this.defaultEyeZ);
                            }
                        }
                    ]), o;
                }(f.default.Camera), j = (f.default.FramebufferCamera = b, function() {
                    function r(e1, t) {
                        c(this, r), this.framebuffer = e1, this.property = t;
                    }
                    return h(r, [
                        {
                            key: "rawTexture",
                            value: function() {
                                return this.framebuffer[this.property];
                            }
                        },
                        {
                            key: "width",
                            get: function() {
                                return this.framebuffer.width * this.framebuffer.density;
                            }
                        },
                        {
                            key: "height",
                            get: function() {
                                return this.framebuffer.height * this.framebuffer.density;
                            }
                        }
                    ]), r;
                }()), _ = (f.default.FramebufferTexture = j, function() {
                    function o(e1) {
                        var t = this, r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, e1 = (c(this, o), this.target = e1, this.target._renderer.framebuffers.add(this), this._isClipApplied = !1, this.pixels = [], this.format = r.format || a.UNSIGNED_BYTE, this.channels = r.channels || (e1._renderer._pInst._glAttributes.alpha ? a.RGBA : a.RGB), this.useDepth = void 0 === r.depth || r.depth, this.depthFormat = r.depthFormat || a.FLOAT, this.textureFiltering = r.textureFiltering || a.LINEAR, void 0 === r.antialias ? this.antialiasSamples = e1._renderer._pInst._glAttributes.antialias ? 2 : 0 : "number" == typeof r.antialias ? this.antialiasSamples = r.antialias : this.antialiasSamples = r.antialias ? 2 : 0, this.antialias = 0 < this.antialiasSamples, this.antialias && e1.webglVersion !== a.WEBGL2 && (console.warn("Antialiasing is unsupported in a WebGL 1 context"), this.antialias = !1), r.width && r.height ? (this.width = r.width, this.height = r.height, this.autoSized = !1) : (void 0 === r.width != (void 0 === r.height) && console.warn("Please supply both width and height for a framebuffer to give it a size. Only one was given, so the framebuffer will match the size of its canvas."), this.width = e1.width, this.height = e1.height, this.autoSized = !0), this.density = r.density || e1.pixelDensity(), e1._renderer.GL);
                        if (this.gl = e1, this._checkIfFormatsAvailable(), r.stencil && !this.useDepth && console.warn("A stencil buffer can only be used if also using depth. Since the framebuffer has no depth buffer, the stencil buffer will be ignored."), this.useStencil = this.useDepth && (void 0 === r.stencil || r.stencil), this.framebuffer = e1.createFramebuffer(), !this.framebuffer) throw new Error("Unable to create a framebuffer");
                        if (this.antialias && (this.aaFramebuffer = e1.createFramebuffer(), !this.aaFramebuffer)) throw new Error("Unable to create a framebuffer for antialiasing");
                        this._recreateTextures();
                        r = this.target._renderer._curCamera;
                        this.defaultCamera = this.createCamera(), this.target._renderer._curCamera = r, this.draw(function() {
                            return t.target.clear();
                        });
                    }
                    return h(o, [
                        {
                            key: "resize",
                            value: function(e1, t) {
                                this.autoSized = !1, this.width = e1, this.height = t, this._handleResize();
                            }
                        },
                        {
                            key: "pixelDensity",
                            value: function(e1) {
                                if (!e1) return this.density;
                                this.autoSized = !1, this.density = e1, this._handleResize();
                            }
                        },
                        {
                            key: "autoSized",
                            value: function(e1) {
                                if (void 0 === e1) return this.autoSized;
                                this.autoSized = e1, this._handleResize();
                            }
                        },
                        {
                            key: "_checkIfFormatsAvailable",
                            value: function() {
                                var e1 = this.gl, e1 = (this.useDepth && this.target.webglVersion === a.WEBGL && !e1.getExtension("WEBGL_depth_texture") && (console.warn("Unable to create depth textures in this environment. Falling back to a framebuffer without depth."), this.useDepth = !1), this.useDepth && this.target.webglVersion === a.WEBGL && this.depthFormat === a.FLOAT && (console.warn("FLOAT depth format is unavailable in WebGL 1. Defaulting to UNSIGNED_INT."), this.depthFormat = a.UNSIGNED_INT), [
                                    a.UNSIGNED_BYTE,
                                    a.FLOAT,
                                    a.HALF_FLOAT
                                ].includes(this.format) || (console.warn("Unknown Framebuffer format. Please use UNSIGNED_BYTE, FLOAT, or HALF_FLOAT. Defaulting to UNSIGNED_BYTE."), this.format = a.UNSIGNED_BYTE), this.useDepth && ![
                                    a.UNSIGNED_INT,
                                    a.FLOAT
                                ].includes(this.depthFormat) && (console.warn("Unknown Framebuffer depth format. Please use UNSIGNED_INT or FLOAT. Defaulting to FLOAT."), this.depthFormat = a.FLOAT), (0, n.checkWebGLCapabilities)(this.target._renderer));
                                e1.float || this.format !== a.FLOAT || (console.warn("This environment does not support FLOAT textures. Falling back to UNSIGNED_BYTE."), this.format = a.UNSIGNED_BYTE), this.useDepth && !e1.float && this.depthFormat === a.FLOAT && (console.warn("This environment does not support FLOAT depth textures. Falling back to UNSIGNED_INT."), this.depthFormat = a.UNSIGNED_INT), e1.halfFloat || this.format !== a.HALF_FLOAT || (console.warn("This environment does not support HALF_FLOAT textures. Falling back to UNSIGNED_BYTE."), this.format = a.UNSIGNED_BYTE), this.channels === a.RGB && [
                                    a.FLOAT,
                                    a.HALF_FLOAT
                                ].includes(this.format) && (console.warn("FLOAT and HALF_FLOAT formats do not work cross-platform with only RGB channels. Falling back to RGBA."), this.channels = a.RGBA);
                            }
                        },
                        {
                            key: "_recreateTextures",
                            value: function() {
                                var e1 = this.gl, t = (this._updateSize(), e1.getParameter(e1.TEXTURE_BINDING_2D)), r = e1.getParameter(e1.FRAMEBUFFER_BINDING), o = e1.createTexture();
                                if (!o) throw new Error("Unable to create color texture");
                                e1.bindTexture(e1.TEXTURE_2D, o);
                                var n = this._glColorFormat();
                                if (e1.texImage2D(e1.TEXTURE_2D, 0, n.internalFormat, this.width * this.density, this.height * this.density, 0, n.format, n.type, null), this.colorTexture = o, e1.bindFramebuffer(e1.FRAMEBUFFER, this.framebuffer), e1.framebufferTexture2D(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.TEXTURE_2D, o, 0), this.useDepth) {
                                    var o = e1.createTexture();
                                    if (!o) throw new Error("Unable to create depth texture");
                                    var s = this._glDepthFormat();
                                    e1.bindTexture(e1.TEXTURE_2D, o), e1.texImage2D(e1.TEXTURE_2D, 0, s.internalFormat, this.width * this.density, this.height * this.density, 0, s.format, s.type, null), e1.framebufferTexture2D(e1.FRAMEBUFFER, this.useStencil ? e1.DEPTH_STENCIL_ATTACHMENT : e1.DEPTH_ATTACHMENT, e1.TEXTURE_2D, o, 0), this.depthTexture = o;
                                }
                                this.antialias && (this.colorRenderbuffer = e1.createRenderbuffer(), e1.bindRenderbuffer(e1.RENDERBUFFER, this.colorRenderbuffer), e1.renderbufferStorageMultisample(e1.RENDERBUFFER, Math.max(0, Math.min(this.antialiasSamples, e1.getParameter(e1.MAX_SAMPLES))), n.internalFormat, this.width * this.density, this.height * this.density), this.useDepth && (s = this._glDepthFormat(), this.depthRenderbuffer = e1.createRenderbuffer(), e1.bindRenderbuffer(e1.RENDERBUFFER, this.depthRenderbuffer), e1.renderbufferStorageMultisample(e1.RENDERBUFFER, Math.max(0, Math.min(this.antialiasSamples, e1.getParameter(e1.MAX_SAMPLES))), s.internalFormat, this.width * this.density, this.height * this.density)), e1.bindFramebuffer(e1.FRAMEBUFFER, this.aaFramebuffer), e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.RENDERBUFFER, this.colorRenderbuffer), this.useDepth && e1.framebufferRenderbuffer(e1.FRAMEBUFFER, this.useStencil ? e1.DEPTH_STENCIL_ATTACHMENT : e1.DEPTH_ATTACHMENT, e1.RENDERBUFFER, this.depthRenderbuffer)), this.useDepth && (this.depth = new j(this, "depthTexture"), o = e1.NEAREST, this.depthP5Texture = new f.default.Texture(this.target._renderer, this.depth, {
                                    minFilter: o,
                                    magFilter: o
                                }), this.target._renderer.textures.set(this.depth, this.depthP5Texture)), this.color = new j(this, "colorTexture");
                                n = this.textureFiltering === a.LINEAR ? e1.LINEAR : e1.NEAREST;
                                this.colorP5Texture = new f.default.Texture(this.target._renderer, this.color, {
                                    minFilter: n,
                                    magFilter: n
                                }), this.target._renderer.textures.set(this.color, this.colorP5Texture), e1.bindTexture(e1.TEXTURE_2D, t), e1.bindFramebuffer(e1.FRAMEBUFFER, r);
                            }
                        },
                        {
                            key: "_glColorFormat",
                            value: function() {
                                var e1, t, r = this.gl, o = this.format === a.FLOAT ? r.FLOAT : this.format === a.HALF_FLOAT ? this.target.webglVersion === a.WEBGL2 ? r.HALF_FLOAT : r.getExtension("OES_texture_half_float").HALF_FLOAT_OES : r.UNSIGNED_BYTE, n = this.channels === a.RGBA ? r.RGBA : r.RGB;
                                return {
                                    internalFormat: this.target.webglVersion === a.WEBGL2 ? (s(t = {}, r.FLOAT, s({}, r.RGBA, r.RGBA32F)), s(t, r.HALF_FLOAT, s({}, r.RGBA, r.RGBA16F)), s(t, r.UNSIGNED_BYTE, (s(e1 = {}, r.RGBA, r.RGBA8), s(e1, r.RGB, r.RGB8), e1)), t[o][n]) : this.format === a.HALF_FLOAT ? r.RGBA : n,
                                    format: n,
                                    type: o
                                };
                            }
                        },
                        {
                            key: "_glDepthFormat",
                            value: function() {
                                var e1 = this.gl, t = this.useStencil ? this.depthFormat === a.FLOAT ? e1.FLOAT_32_UNSIGNED_INT_24_8_REV : this.target.webglVersion === a.WEBGL2 ? e1.UNSIGNED_INT_24_8 : e1.getExtension("WEBGL_depth_texture").UNSIGNED_INT_24_8_WEBGL : this.depthFormat === a.FLOAT ? e1.FLOAT : e1.UNSIGNED_INT, r = this.useStencil ? e1.DEPTH_STENCIL : e1.DEPTH_COMPONENT, e1 = this.useStencil ? this.depthFormat === a.FLOAT ? e1.DEPTH32F_STENCIL8 : this.target.webglVersion === a.WEBGL2 ? e1.DEPTH24_STENCIL8 : e1.DEPTH_STENCIL : this.target.webglVersion === a.WEBGL2 ? this.depthFormat === a.FLOAT ? e1.DEPTH_COMPONENT32F : e1.DEPTH_COMPONENT24 : e1.DEPTH_COMPONENT;
                                return {
                                    internalFormat: e1,
                                    format: r,
                                    type: t
                                };
                            }
                        },
                        {
                            key: "_updateSize",
                            value: function() {
                                this.autoSized && (this.width = this.target.width, this.height = this.target.height, this.density = this.target.pixelDensity());
                            }
                        },
                        {
                            key: "_canvasSizeChanged",
                            value: function() {
                                this.autoSized && this._handleResize();
                            }
                        },
                        {
                            key: "_handleResize",
                            value: function() {
                                var e1 = this.color, t = this.depth, r = this.colorRenderbuffer, o = this.depthRenderbuffer, e1 = (this._deleteTexture(e1), t && this._deleteTexture(t), this.gl);
                                r && e1.deleteRenderbuffer(r), o && e1.deleteRenderbuffer(o), this._recreateTextures(), this.defaultCamera._resize();
                            }
                        },
                        {
                            key: "createCamera",
                            value: function() {
                                var e1 = new b(this);
                                return e1._computeCameraDefaultSettings(), e1._setDefaultCamera(), this.target._renderer._curCamera = e1;
                            }
                        },
                        {
                            key: "_deleteTexture",
                            value: function(e1) {
                                this.gl.deleteTexture(e1.rawTexture()), this.target._renderer.textures.delete(e1);
                            }
                        },
                        {
                            key: "remove",
                            value: function() {
                                var e1 = this.gl;
                                this._deleteTexture(this.color), this.depth && this._deleteTexture(this.depth), e1.deleteFramebuffer(this.framebuffer), this.aaFramebuffer && e1.deleteFramebuffer(this.aaFramebuffer), this.depthRenderbuffer && e1.deleteRenderbuffer(this.depthRenderbuffer), this.colorRenderbuffer && e1.deleteRenderbuffer(this.colorRenderbuffer), this.target._renderer.framebuffers.delete(this);
                            }
                        },
                        {
                            key: "begin",
                            value: function() {
                                this.prevFramebuffer = this.target._renderer.activeFramebuffer(), this.prevFramebuffer && this.prevFramebuffer._beforeEnd(), this.target._renderer.activeFramebuffers.push(this), this._beforeBegin(), this.target.push(), this.target.setCamera(this.defaultCamera), this.target._renderer.uMVMatrix.set(this.target._renderer._curCamera.cameraMatrix.mat4[0], this.target._renderer._curCamera.cameraMatrix.mat4[1], this.target._renderer._curCamera.cameraMatrix.mat4[2], this.target._renderer._curCamera.cameraMatrix.mat4[3], this.target._renderer._curCamera.cameraMatrix.mat4[4], this.target._renderer._curCamera.cameraMatrix.mat4[5], this.target._renderer._curCamera.cameraMatrix.mat4[6], this.target._renderer._curCamera.cameraMatrix.mat4[7], this.target._renderer._curCamera.cameraMatrix.mat4[8], this.target._renderer._curCamera.cameraMatrix.mat4[9], this.target._renderer._curCamera.cameraMatrix.mat4[10], this.target._renderer._curCamera.cameraMatrix.mat4[11], this.target._renderer._curCamera.cameraMatrix.mat4[12], this.target._renderer._curCamera.cameraMatrix.mat4[13], this.target._renderer._curCamera.cameraMatrix.mat4[14], this.target._renderer._curCamera.cameraMatrix.mat4[15]);
                            }
                        },
                        {
                            key: "_framebufferToBind",
                            value: function() {
                                return this.antialias ? this.aaFramebuffer : this.framebuffer;
                            }
                        },
                        {
                            key: "_beforeBegin",
                            value: function() {
                                var e1 = this.gl;
                                e1.bindFramebuffer(e1.FRAMEBUFFER, this._framebufferToBind()), this.target._renderer.viewport(this.width * this.density, this.height * this.density);
                            }
                        },
                        {
                            key: "_beforeEnd",
                            value: function() {
                                if (this.antialias) {
                                    var e1 = this.gl, t = (e1.bindFramebuffer(e1.READ_FRAMEBUFFER, this.aaFramebuffer), e1.bindFramebuffer(e1.DRAW_FRAMEBUFFER, this.framebuffer), [
                                        [
                                            e1.COLOR_BUFFER_BIT,
                                            this.colorP5Texture.glMagFilter
                                        ]
                                    ]);
                                    this.useDepth && t.push([
                                        e1.DEPTH_BUFFER_BIT,
                                        this.depthP5Texture.glMagFilter
                                    ]);
                                    for(var r = 0, o = t; r < o.length; r++){
                                        var n = u(o[r], 2), s = n[0], n = n[1];
                                        e1.blitFramebuffer(0, 0, this.width * this.density, this.height * this.density, 0, 0, this.width * this.density, this.height * this.density, s, n);
                                    }
                                }
                            }
                        },
                        {
                            key: "end",
                            value: function() {
                                var e1 = this.gl;
                                if (this.target.pop(), this.target._renderer.activeFramebuffers.pop() !== this) throw new Error("It looks like you've called end() while another Framebuffer is active.");
                                this._beforeEnd(), this.prevFramebuffer ? this.prevFramebuffer._beforeBegin() : (e1.bindFramebuffer(e1.FRAMEBUFFER, null), this.target._renderer.viewport(this.target._renderer._origViewport.width, this.target._renderer._origViewport.height)), this.target._renderer._applyStencilTestIfClipping();
                            }
                        },
                        {
                            key: "draw",
                            value: function(e1) {
                                this.begin(), e1(), this.end();
                            }
                        },
                        {
                            key: "loadPixels",
                            value: function() {
                                var e1 = this.gl, t = this.target._renderer.activeFramebuffer(), r = (e1.bindFramebuffer(e1.FRAMEBUFFER, this.framebuffer), this._glColorFormat());
                                this.pixels = (0, p.readPixelsWebGL)(this.pixels, e1, this.framebuffer, 0, 0, this.width * this.density, this.height * this.density, r.format, r.type), t ? e1.bindFramebuffer(e1.FRAMEBUFFER, t._framebufferToBind()) : e1.bindFramebuffer(e1.FRAMEBUFFER, null);
                            }
                        },
                        {
                            key: "get",
                            value: function(e1, t, r, o) {
                                f.default._validateParameters("p5.Framebuffer.get", arguments);
                                var n = this._glColorFormat();
                                if (void 0 === e1 && void 0 === t) t = e1 = 0, r = this.width, o = this.height;
                                else if (void 0 === r && void 0 === o) return (e1 < 0 || t < 0 || e1 >= this.width || t >= this.height) && (console.warn("The x and y values passed to p5.Framebuffer.get are outside of its range and will be clamped."), e1 = this.target.constrain(e1, 0, this.width - 1), t = this.target.constrain(t, 0, this.height - 1)), (0, p.readPixelWebGL)(this.gl, this.framebuffer, e1 * this.density, t * this.density, n.format, n.type);
                                e1 = this.target.constrain(e1, 0, this.width - 1), t = this.target.constrain(t, 0, this.height - 1), r = this.target.constrain(r, 1, this.width - e1), o = this.target.constrain(o, 1, this.height - t);
                                for(var s = (0, p.readPixelsWebGL)(void 0, this.gl, this.framebuffer, e1 * this.density, t * this.density, r * this.density, o * this.density, n.format, n.type), i = new Uint8ClampedArray(r * o * this.density * this.density * 4), a = (i.fill(255), n.type === this.gl.RGB ? 3 : 4), l = 0; l < o * this.density; l++)for(var u = 0; u < r * this.density; u++)for(var c = 0; c < 4; c++){
                                    var d, h = 4 * (l * r * this.density + u) + c;
                                    c < a && (d = 4 == a ? h : (l * r * this.density + u) * a + c, i[h] = s[d]);
                                }
                                e1 = new f.default.Image(r * this.density, o * this.density);
                                return e1.imageData = e1.canvas.getContext("2d").createImageData(e1.width, e1.height), e1.imageData.data.set(i), e1.pixels = e1.imageData.data, e1.updatePixels(), 1 !== this.density && e1.resize(r, o), e1;
                            }
                        },
                        {
                            key: "updatePixels",
                            value: function() {
                                var e1 = this.gl, t = (this.colorP5Texture.bindTexture(), this._glColorFormat()), r = t.format === e1.RGBA ? 4 : 3, r = this.width * this.height * this.density * this.density * r, o = t.type === e1.UNSIGNED_BYTE ? Uint8Array : Float32Array;
                                if (!(this.pixels instanceof o) || this.pixels.length !== r) throw new Error("The pixels array has not been set correctly. Please call loadPixels() before updatePixels().");
                                e1.texImage2D(e1.TEXTURE_2D, 0, t.internalFormat, this.width * this.density, this.height * this.density, 0, t.format, t.type, this.pixels), this.colorP5Texture.unbindTexture();
                                o = this.target._renderer.activeFramebuffer();
                                this.antialias ? (this.begin(), this.target.push(), this.target.imageMode(this.target.CENTER), this.target.resetMatrix(), this.target.noStroke(), this.target.clear(), this.target.image(this, 0, 0), this.target.pop(), this.useDepth && (e1.clearDepth(1), e1.clear(e1.DEPTH_BUFFER_BIT)), this.end()) : (e1.bindFramebuffer(e1.FRAMEBUFFER, this.framebuffer), this.useDepth && (e1.clearDepth(1), e1.clear(e1.DEPTH_BUFFER_BIT)), o ? e1.bindFramebuffer(e1.FRAMEBUFFER, o._framebufferToBind()) : e1.bindFramebuffer(e1.FRAMEBUFFER, null));
                            }
                        }
                    ]), o;
                }()), e1 = f.default.Framebuffer = _;
                r.default = e1;
            },
            {
                "../core/constants": 264,
                "../core/main": 275,
                "./p5.RendererGL": 332,
                "./p5.Texture": 334,
                "core-js/modules/es.array.fill": 154,
                "core-js/modules/es.array.includes": 159,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.get-prototype-of": 180,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.reflect.construct": 184,
                "core-js/modules/es.reflect.get": 185,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.includes": 191,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.typed-array.copy-within": 205,
                "core-js/modules/es.typed-array.every": 206,
                "core-js/modules/es.typed-array.fill": 207,
                "core-js/modules/es.typed-array.filter": 208,
                "core-js/modules/es.typed-array.find": 210,
                "core-js/modules/es.typed-array.find-index": 209,
                "core-js/modules/es.typed-array.float32-array": 211,
                "core-js/modules/es.typed-array.for-each": 213,
                "core-js/modules/es.typed-array.includes": 214,
                "core-js/modules/es.typed-array.index-of": 215,
                "core-js/modules/es.typed-array.iterator": 218,
                "core-js/modules/es.typed-array.join": 219,
                "core-js/modules/es.typed-array.last-index-of": 220,
                "core-js/modules/es.typed-array.map": 221,
                "core-js/modules/es.typed-array.reduce": 223,
                "core-js/modules/es.typed-array.reduce-right": 222,
                "core-js/modules/es.typed-array.reverse": 224,
                "core-js/modules/es.typed-array.set": 225,
                "core-js/modules/es.typed-array.slice": 226,
                "core-js/modules/es.typed-array.some": 227,
                "core-js/modules/es.typed-array.sort": 228,
                "core-js/modules/es.typed-array.subarray": 229,
                "core-js/modules/es.typed-array.to-locale-string": 230,
                "core-js/modules/es.typed-array.to-string": 231,
                "core-js/modules/es.typed-array.uint8-array": 234,
                "core-js/modules/es.typed-array.uint8-clamped-array": 235,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        327: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.map"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.sub"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.map"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.sub"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var m = (s = e1("../core/main")) && s.__esModule ? s : {
                    default: s
                }, y = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function c(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                m.default.Geometry = function() {
                    function o(e1, t, r) {
                        if (this instanceof o) return this.vertices = [], this.lineVertices = new m.default.DataArray, this.lineTangentsIn = new m.default.DataArray, this.lineTangentsOut = new m.default.DataArray, this.lineSides = new m.default.DataArray, this.vertexNormals = [], this.faces = [], this.uvs = [], this.edges = [], this.vertexColors = [], this.vertexStrokeColors = [], this.lineVertexColors = new m.default.DataArray, this.detailX = void 0 !== e1 ? e1 : 1, this.detailY = void 0 !== t ? t : 1, this.dirtyFlags = {}, r instanceof Function && r.call(this), this;
                        throw new TypeError("Cannot call a class as a function");
                    }
                    var e1, t, r;
                    return e1 = o, t = [
                        {
                            key: "reset",
                            value: function() {
                                this.lineVertices.clear(), this.lineTangentsIn.clear(), this.lineTangentsOut.clear(), this.lineSides.clear(), this.vertices.length = 0, this.edges.length = 0, this.vertexColors.length = 0, this.vertexStrokeColors.length = 0, this.lineVertexColors.clear(), this.vertexNormals.length = 0, this.uvs.length = 0, this.dirtyFlags = {};
                            }
                        },
                        {
                            key: "clearColors",
                            value: function() {
                                return this.vertexColors = [], this;
                            }
                        },
                        {
                            key: "computeFaces",
                            value: function() {
                                this.faces.length = 0;
                                for(var e1, t, r, o = this.detailX + 1, n = 0; n < this.detailY; n++)for(var s = 0; s < this.detailX; s++)t = (n + 1) * o + s + 1, this.faces.push([
                                    n * o + s,
                                    e1 = n * o + s + 1,
                                    r = (n + 1) * o + s
                                ]), this.faces.push([
                                    r,
                                    e1,
                                    t
                                ]);
                                return this;
                            }
                        },
                        {
                            key: "_getFaceNormal",
                            value: function(e1) {
                                var e1 = this.faces[e1], t = this.vertices[e1[0]], r = this.vertices[e1[1]], e1 = this.vertices[e1[2]], r = m.default.Vector.sub(r, t), e1 = m.default.Vector.sub(e1, t), t = m.default.Vector.cross(r, e1), o = m.default.Vector.mag(t), r = o / (m.default.Vector.mag(r) * m.default.Vector.mag(e1));
                                return 0 === r || isNaN(r) ? (console.warn("p5.Geometry.prototype._getFaceNormal:", "face has colinear sides or a repeated vertex"), t) : (1 < r && (r = 1), t.mult(Math.asin(r) / o));
                            }
                        },
                        {
                            key: "computeNormals",
                            value: function() {
                                var e1, s = this, t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : y.FLAT, r = (1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}).roundToPrecision, i = this.vertexNormals, o = this.vertices, n = this.faces;
                                if (t === y.SMOOTH) {
                                    for(var a = {}, l = [], u = Math.pow(10, void 0 === r ? 3 : r), c = function(e1) {
                                        return Math.round(e1 * u) / u;
                                    }, d = function(e1) {
                                        return "".concat(c(e1.x), ",").concat(c(e1.y), ",").concat(c(e1.z));
                                    }, h = 0; h < o.length; h++){
                                        var f = o[h], p = d(f);
                                        void 0 === a[p] && (a[p] = l.length, l.push(f));
                                    }
                                    n.forEach(function(e1) {
                                        for(var t = 0; t < 3; ++t){
                                            var r = e1[t], r = o[r], r = d(r);
                                            e1[t] = a[r];
                                        }
                                    }), this.edges.forEach(function(e1) {
                                        for(var t = 0; t < 2; ++t){
                                            var r = e1[t], r = o[r], r = d(r);
                                            e1[t] = a[r];
                                        }
                                    }), this.vertices = o = l;
                                }
                                for(e1 = i.length = 0; e1 < o.length; ++e1)i.push(new m.default.Vector);
                                for(n.forEach(function(e1, t) {
                                    for(var r = s._getFaceNormal(t), o = 0; o < 3; ++o){
                                        var n = e1[o];
                                        i[n].add(r);
                                    }
                                }), e1 = 0; e1 < o.length; ++e1)i[e1].normalize();
                                return this;
                            }
                        },
                        {
                            key: "averageNormals",
                            value: function() {
                                for(var e1 = 0; e1 <= this.detailY; e1++){
                                    var t = this.detailX + 1, r = m.default.Vector.add(this.vertexNormals[e1 * t], this.vertexNormals[e1 * t + this.detailX]), r = m.default.Vector.div(r, 2);
                                    this.vertexNormals[e1 * t] = r, this.vertexNormals[e1 * t + this.detailX] = r;
                                }
                                return this;
                            }
                        },
                        {
                            key: "averagePoleNormals",
                            value: function() {
                                for(var e1 = new m.default.Vector(0, 0, 0), t = 0; t < this.detailX; t++)e1.add(this.vertexNormals[t]);
                                for(var e1 = m.default.Vector.div(e1, this.detailX), r = 0; r < this.detailX; r++)this.vertexNormals[r] = e1;
                                e1 = new m.default.Vector(0, 0, 0);
                                for(var o = this.vertices.length - 1; o > this.vertices.length - 1 - this.detailX; o--)e1.add(this.vertexNormals[o]);
                                e1 = m.default.Vector.div(e1, this.detailX);
                                for(var n = this.vertices.length - 1; n > this.vertices.length - 1 - this.detailX; n--)this.vertexNormals[n] = e1;
                                return this;
                            }
                        },
                        {
                            key: "_makeTriangleEdges",
                            value: function() {
                                for(var e1 = this.edges.length = 0; e1 < this.faces.length; e1++)this.edges.push([
                                    this.faces[e1][0],
                                    this.faces[e1][1]
                                ]), this.edges.push([
                                    this.faces[e1][1],
                                    this.faces[e1][2]
                                ]), this.edges.push([
                                    this.faces[e1][2],
                                    this.faces[e1][0]
                                ]);
                                return this;
                            }
                        },
                        {
                            key: "_edgesToVertices",
                            value: function() {
                                this.lineVertices.clear(), this.lineTangentsIn.clear(), this.lineTangentsOut.clear(), this.lineSides.clear();
                                for(var e1, t = new Map, r = new Set, o = 0; o < this.edges.length; o++){
                                    var n, s = this.edges[o - 1], i = this.edges[o], a = this.vertices[i[0]], l = this.vertices[i[1]], u = 0 < this.vertexStrokeColors.length ? this.vertexStrokeColors.slice(4 * i[0], 4 * (i[0] + 1)) : [
                                        0,
                                        0,
                                        0,
                                        0
                                    ], c = 0 < this.vertexStrokeColors.length ? this.vertexStrokeColors.slice(4 * i[1], 4 * (i[1] + 1)) : [
                                        0,
                                        0,
                                        0,
                                        0
                                    ], d = l.copy().sub(a).normalize(), h = 0 < d.magSq();
                                    h && this._addSegment(a, l, u, c, d), 0 < o && s[1] === i[0] ? r.has(i[0]) || (r.add(i[0]), t.delete(i[0]), e1 && h && d.dot(e1) < 1 - 1e-8 && this._addJoin(a, e1, d, u)) : (h && !r.has(i[0]) && ((n = t.get(i[0])) ? (this._addJoin(a, n.dir, d, u), t.delete(i[0]), r.add(i[0])) : t.set(i[0], {
                                        point: a,
                                        dir: d.copy().mult(-1),
                                        color: u
                                    })), e1 && !r.has(s[1]) && ((n = t.get(s[1])) ? (this._addJoin(this.vertices[s[1]], e1, n.dir.copy().mult(-1), u), t.delete(s[1]), r.add(s[1])) : t.set(s[1], {
                                        point: this.vertices[s[1]],
                                        dir: e1,
                                        color: u
                                    }), e1 = void 0)), o !== this.edges.length - 1 || r.has(i[1]) || ((a = t.get(i[1])) ? (this._addJoin(l, d, a.dir.copy().mult(-1), c), t.delete(i[1]), r.add(i[1])) : t.set(i[1], {
                                        point: l,
                                        dir: d,
                                        color: c
                                    })), h && (e1 = d);
                                }
                                var f = !0, p = !1, m = void 0;
                                try {
                                    for(var y, g = t.values()[Symbol.iterator](); !(f = (y = g.next()).done); f = !0){
                                        var v = y.value, b = v.point, j = v.dir, _ = v.color;
                                        this._addCap(b, j, _);
                                    }
                                } catch (e1) {
                                    p = !0, m = e1;
                                } finally{
                                    try {
                                        f || null == g.return || g.return();
                                    } finally{
                                        if (p) throw m;
                                    }
                                }
                                return this;
                            }
                        },
                        {
                            key: "_addSegment",
                            value: function(e1, t, r, o, n) {
                                var e1 = e1.array(), t = t.array(), s = n.array();
                                this.lineSides.push(1, 1, -1, 1, -1, -1);
                                for(var i = 0, a = [
                                    this.lineTangentsIn,
                                    this.lineTangentsOut
                                ]; i < a.length; i++)for(var l = a[i], u = 0; u < 6; u++)l.push.apply(l, c(s));
                                return (n = this.lineVertices).push.apply(n, c(e1).concat(c(t), c(e1), c(t), c(t), c(e1))), (n = this.lineVertexColors).push.apply(n, c(r).concat(c(o), c(r), c(o), c(o), c(r))), this;
                            }
                        },
                        {
                            key: "_addCap",
                            value: function(e1, t, r) {
                                for(var o, n = e1.array(), s = t.array(), i = [
                                    0,
                                    0,
                                    0
                                ], a = 0; a < 6; a++)(o = this.lineVertices).push.apply(o, c(n)), (o = this.lineTangentsIn).push.apply(o, c(s)), (o = this.lineTangentsOut).push.apply(o, i), (o = this.lineVertexColors).push.apply(o, c(r));
                                return this.lineSides.push(-1, 2, -2, 1, 2, -1), this;
                            }
                        },
                        {
                            key: "_addJoin",
                            value: function(e1, t, r, o) {
                                for(var n, s = e1.array(), i = t.array(), a = r.array(), l = 0; l < 12; l++)(n = this.lineVertices).push.apply(n, c(s)), (n = this.lineTangentsIn).push.apply(n, c(i)), (n = this.lineTangentsOut).push.apply(n, c(a)), (n = this.lineVertexColors).push.apply(n, c(o));
                                return this.lineSides.push(-1, -3, -2, -1, 0, -3), this.lineSides.push(3, 1, 2, 3, 0, 1), this;
                            }
                        },
                        {
                            key: "normalize",
                            value: function() {
                                if (0 < this.vertices.length) {
                                    for(var e1 = this.vertices[0].copy(), t = this.vertices[0].copy(), r = 0; r < this.vertices.length; r++)e1.x = Math.max(e1.x, this.vertices[r].x), t.x = Math.min(t.x, this.vertices[r].x), e1.y = Math.max(e1.y, this.vertices[r].y), t.y = Math.min(t.y, this.vertices[r].y), e1.z = Math.max(e1.z, this.vertices[r].z), t.z = Math.min(t.z, this.vertices[r].z);
                                    for(var o = m.default.Vector.lerp(e1, t, .5), n = m.default.Vector.sub(e1, t), s = 200 / Math.max(Math.max(n.x, n.y), n.z), i = 0; i < this.vertices.length; i++)this.vertices[i].sub(o), this.vertices[i].mult(s);
                                }
                                return this;
                            }
                        }
                    ], n(e1.prototype, t), r && n(e1, r), o;
                }();
                var s = m.default.Geometry;
                r.default = s;
            },
            {
                "../core/constants": 264,
                "../core/main": 275,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.for-each": 157,
                "core-js/modules/es.array.from": 158,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.map": 169,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.set": 189,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.string.sub": 200,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.for-each": 237,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        328: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var C = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                var s = Array, O = function(e1) {
                    return Array.isArray(e1);
                }, e1 = ("undefined" != typeof Float32Array && (s = Float32Array, O = function(e1) {
                    return Array.isArray(e1) || e1 instanceof Float32Array;
                }), C.default.Matrix = function() {
                    function r() {
                        var e1 = this, t = r;
                        if (e1 instanceof t) return arguments.length && ((e1 = arguments.length - 1) < 0 || arguments.length <= e1 ? void 0 : arguments[e1]) instanceof C.default && (this.p5 = (t = arguments.length - 1) < 0 || arguments.length <= t ? void 0 : arguments[t]), "mat3" === (arguments.length <= 0 ? void 0 : arguments[0]) ? this.mat3 = Array.isArray(arguments.length <= 1 ? void 0 : arguments[1]) ? arguments.length <= 1 ? void 0 : arguments[1] : new s([
                            1,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            1
                        ]) : this.mat4 = Array.isArray(arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 0 ? void 0 : arguments[0] : new s([
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ]), this;
                        throw new TypeError("Cannot call a class as a function");
                    }
                    var e1, t, o;
                    return e1 = r, o = [
                        {
                            key: "identity",
                            value: function(e1) {
                                return new C.default.Matrix(e1);
                            }
                        }
                    ], t = [
                        {
                            key: "set",
                            value: function(e1) {
                                return e1 instanceof C.default.Matrix ? this.mat4 = e1.mat4 : O(e1) ? this.mat4 = e1 : 16 === arguments.length && (this.mat4[0] = e1, this.mat4[1] = arguments[1], this.mat4[2] = arguments[2], this.mat4[3] = arguments[3], this.mat4[4] = arguments[4], this.mat4[5] = arguments[5], this.mat4[6] = arguments[6], this.mat4[7] = arguments[7], this.mat4[8] = arguments[8], this.mat4[9] = arguments[9], this.mat4[10] = arguments[10], this.mat4[11] = arguments[11], this.mat4[12] = arguments[12], this.mat4[13] = arguments[13], this.mat4[14] = arguments[14], this.mat4[15] = arguments[15]), this;
                            }
                        },
                        {
                            key: "get",
                            value: function() {
                                return new C.default.Matrix(this.mat4, this.p5);
                            }
                        },
                        {
                            key: "copy",
                            value: function() {
                                var e1;
                                return void 0 !== this.mat3 ? ((e1 = new C.default.Matrix("mat3", this.p5)).mat3[0] = this.mat3[0], e1.mat3[1] = this.mat3[1], e1.mat3[2] = this.mat3[2], e1.mat3[3] = this.mat3[3], e1.mat3[4] = this.mat3[4], e1.mat3[5] = this.mat3[5], e1.mat3[6] = this.mat3[6], e1.mat3[7] = this.mat3[7], e1.mat3[8] = this.mat3[8]) : ((e1 = new C.default.Matrix(this.p5)).mat4[0] = this.mat4[0], e1.mat4[1] = this.mat4[1], e1.mat4[2] = this.mat4[2], e1.mat4[3] = this.mat4[3], e1.mat4[4] = this.mat4[4], e1.mat4[5] = this.mat4[5], e1.mat4[6] = this.mat4[6], e1.mat4[7] = this.mat4[7], e1.mat4[8] = this.mat4[8], e1.mat4[9] = this.mat4[9], e1.mat4[10] = this.mat4[10], e1.mat4[11] = this.mat4[11], e1.mat4[12] = this.mat4[12], e1.mat4[13] = this.mat4[13], e1.mat4[14] = this.mat4[14], e1.mat4[15] = this.mat4[15]), e1;
                            }
                        },
                        {
                            key: "transpose",
                            value: function(e1) {
                                var t, r, o, n, s, i;
                                return e1 instanceof C.default.Matrix ? (t = e1.mat4[1], r = e1.mat4[2], o = e1.mat4[3], n = e1.mat4[6], s = e1.mat4[7], i = e1.mat4[11], this.mat4[0] = e1.mat4[0], this.mat4[1] = e1.mat4[4], this.mat4[2] = e1.mat4[8], this.mat4[3] = e1.mat4[12], this.mat4[4] = t, this.mat4[5] = e1.mat4[5], this.mat4[6] = e1.mat4[9], this.mat4[7] = e1.mat4[13], this.mat4[8] = r, this.mat4[9] = n, this.mat4[10] = e1.mat4[10], this.mat4[11] = e1.mat4[14], this.mat4[12] = o, this.mat4[13] = s, this.mat4[14] = i, this.mat4[15] = e1.mat4[15]) : O(e1) && (t = e1[1], r = e1[2], o = e1[3], n = e1[6], s = e1[7], i = e1[11], this.mat4[0] = e1[0], this.mat4[1] = e1[4], this.mat4[2] = e1[8], this.mat4[3] = e1[12], this.mat4[4] = t, this.mat4[5] = e1[5], this.mat4[6] = e1[9], this.mat4[7] = e1[13], this.mat4[8] = r, this.mat4[9] = n, this.mat4[10] = e1[10], this.mat4[11] = e1[14], this.mat4[12] = o, this.mat4[13] = s, this.mat4[14] = i, this.mat4[15] = e1[15]), this;
                            }
                        },
                        {
                            key: "invert",
                            value: function(e1) {
                                e1 instanceof C.default.Matrix ? (t = e1.mat4[0], r = e1.mat4[1], o = e1.mat4[2], n = e1.mat4[3], s = e1.mat4[4], i = e1.mat4[5], a = e1.mat4[6], l = e1.mat4[7], u = e1.mat4[8], c = e1.mat4[9], d = e1.mat4[10], h = e1.mat4[11], f = e1.mat4[12], p = e1.mat4[13], m = e1.mat4[14], y = e1.mat4[15]) : O(e1) && (t = e1[0], r = e1[1], o = e1[2], n = e1[3], s = e1[4], i = e1[5], a = e1[6], l = e1[7], u = e1[8], c = e1[9], d = e1[10], h = e1[11], f = e1[12], p = e1[13], m = e1[14], y = e1[15]);
                                var t, r, o, n, s, i, a, l, u, c, d, h, f, p, m, y, e1 = t * i - r * s, g = t * a - o * s, v = t * l - n * s, b = r * a - o * i, j = r * l - n * i, _ = o * l - n * a, x = u * p - c * f, w = u * m - d * f, S = u * y - h * f, T = c * m - d * p, M = c * y - h * p, E = d * y - h * m, k = e1 * E - g * M + v * T + b * S - j * w + _ * x;
                                return k ? (this.mat4[0] = (i * E - a * M + l * T) * (k = 1 / k), this.mat4[1] = (o * M - r * E - n * T) * k, this.mat4[2] = (p * _ - m * j + y * b) * k, this.mat4[3] = (d * j - c * _ - h * b) * k, this.mat4[4] = (a * S - s * E - l * w) * k, this.mat4[5] = (t * E - o * S + n * w) * k, this.mat4[6] = (m * v - f * _ - y * g) * k, this.mat4[7] = (u * _ - d * v + h * g) * k, this.mat4[8] = (s * M - i * S + l * x) * k, this.mat4[9] = (r * S - t * M - n * x) * k, this.mat4[10] = (f * j - p * v + y * e1) * k, this.mat4[11] = (c * v - u * j - h * e1) * k, this.mat4[12] = (i * w - s * T - a * x) * k, this.mat4[13] = (t * T - r * w + o * x) * k, this.mat4[14] = (p * g - f * b - m * e1) * k, this.mat4[15] = (u * b - c * g + d * e1) * k, this) : null;
                            }
                        },
                        {
                            key: "invert3x3",
                            value: function() {
                                var e1 = this.mat3[0], t = this.mat3[1], r = this.mat3[2], o = this.mat3[3], n = this.mat3[4], s = this.mat3[5], i = this.mat3[6], a = this.mat3[7], l = this.mat3[8], u = l * n - s * a, c = -l * o + s * i, d = a * o - n * i, h = e1 * u + t * c + r * d;
                                return h ? (this.mat3[0] = u * (h = 1 / h), this.mat3[1] = (-l * t + r * a) * h, this.mat3[2] = (s * t - r * n) * h, this.mat3[3] = c * h, this.mat3[4] = (l * e1 - r * i) * h, this.mat3[5] = (-s * e1 + r * o) * h, this.mat3[6] = d * h, this.mat3[7] = (-a * e1 + t * i) * h, this.mat3[8] = (n * e1 - t * o) * h, this) : null;
                            }
                        },
                        {
                            key: "transpose3x3",
                            value: function(e1) {
                                var t = (e1 = void 0 === e1 ? this.mat3 : e1)[1], r = e1[2], o = e1[5];
                                return this.mat3[0] = e1[0], this.mat3[1] = e1[3], this.mat3[2] = e1[6], this.mat3[3] = t, this.mat3[4] = e1[4], this.mat3[5] = e1[7], this.mat3[6] = r, this.mat3[7] = o, this.mat3[8] = e1[8], this;
                            }
                        },
                        {
                            key: "inverseTranspose",
                            value: function(e1) {
                                e1 = e1.mat4, void 0 === this.mat3 ? C.default._friendlyError("sorry, this function only works with mat3") : (this.mat3[0] = e1[0], this.mat3[1] = e1[1], this.mat3[2] = e1[2], this.mat3[3] = e1[4], this.mat3[4] = e1[5], this.mat3[5] = e1[6], this.mat3[6] = e1[8], this.mat3[7] = e1[9], this.mat3[8] = e1[10]), e1 = this.invert3x3();
                                if (e1) e1.transpose3x3(this.mat3);
                                else for(var t = 0; t < 9; t++)this.mat3[t] = 0;
                                return this;
                            }
                        },
                        {
                            key: "determinant",
                            value: function() {
                                var e1 = this.mat4[0] * this.mat4[5] - this.mat4[1] * this.mat4[4], t = this.mat4[0] * this.mat4[6] - this.mat4[2] * this.mat4[4], r = this.mat4[0] * this.mat4[7] - this.mat4[3] * this.mat4[4], o = this.mat4[1] * this.mat4[6] - this.mat4[2] * this.mat4[5], n = this.mat4[1] * this.mat4[7] - this.mat4[3] * this.mat4[5], s = this.mat4[2] * this.mat4[7] - this.mat4[3] * this.mat4[6], i = this.mat4[8] * this.mat4[13] - this.mat4[9] * this.mat4[12], a = this.mat4[8] * this.mat4[14] - this.mat4[10] * this.mat4[12], l = this.mat4[8] * this.mat4[15] - this.mat4[11] * this.mat4[12], u = this.mat4[9] * this.mat4[14] - this.mat4[10] * this.mat4[13], c = this.mat4[9] * this.mat4[15] - this.mat4[11] * this.mat4[13];
                                return e1 * (this.mat4[10] * this.mat4[15] - this.mat4[11] * this.mat4[14]) - t * c + r * u + o * l - n * a + s * i;
                            }
                        },
                        {
                            key: "mult",
                            value: function(e1) {
                                var t;
                                if (e1 === this || e1 === this.mat4) t = this.copy().mat4;
                                else if (e1 instanceof C.default.Matrix) t = e1.mat4;
                                else if (O(e1)) t = e1;
                                else {
                                    if (16 !== arguments.length) return;
                                    t = arguments;
                                }
                                var e1 = this.mat4[0], r = this.mat4[1], o = this.mat4[2], n = this.mat4[3];
                                return this.mat4[0] = e1 * t[0] + r * t[4] + o * t[8] + n * t[12], this.mat4[1] = e1 * t[1] + r * t[5] + o * t[9] + n * t[13], this.mat4[2] = e1 * t[2] + r * t[6] + o * t[10] + n * t[14], this.mat4[3] = e1 * t[3] + r * t[7] + o * t[11] + n * t[15], e1 = this.mat4[4], r = this.mat4[5], o = this.mat4[6], n = this.mat4[7], this.mat4[4] = e1 * t[0] + r * t[4] + o * t[8] + n * t[12], this.mat4[5] = e1 * t[1] + r * t[5] + o * t[9] + n * t[13], this.mat4[6] = e1 * t[2] + r * t[6] + o * t[10] + n * t[14], this.mat4[7] = e1 * t[3] + r * t[7] + o * t[11] + n * t[15], e1 = this.mat4[8], r = this.mat4[9], o = this.mat4[10], n = this.mat4[11], this.mat4[8] = e1 * t[0] + r * t[4] + o * t[8] + n * t[12], this.mat4[9] = e1 * t[1] + r * t[5] + o * t[9] + n * t[13], this.mat4[10] = e1 * t[2] + r * t[6] + o * t[10] + n * t[14], this.mat4[11] = e1 * t[3] + r * t[7] + o * t[11] + n * t[15], e1 = this.mat4[12], r = this.mat4[13], o = this.mat4[14], n = this.mat4[15], this.mat4[12] = e1 * t[0] + r * t[4] + o * t[8] + n * t[12], this.mat4[13] = e1 * t[1] + r * t[5] + o * t[9] + n * t[13], this.mat4[14] = e1 * t[2] + r * t[6] + o * t[10] + n * t[14], this.mat4[15] = e1 * t[3] + r * t[7] + o * t[11] + n * t[15], this;
                            }
                        },
                        {
                            key: "apply",
                            value: function(e1) {
                                var t;
                                if (e1 === this || e1 === this.mat4) t = this.copy().mat4;
                                else if (e1 instanceof C.default.Matrix) t = e1.mat4;
                                else if (O(e1)) t = e1;
                                else {
                                    if (16 !== arguments.length) return;
                                    t = arguments;
                                }
                                var e1 = this.mat4, r = e1[0], o = e1[4], n = e1[8], s = e1[12], r = (e1[0] = t[0] * r + t[1] * o + t[2] * n + t[3] * s, e1[4] = t[4] * r + t[5] * o + t[6] * n + t[7] * s, e1[8] = t[8] * r + t[9] * o + t[10] * n + t[11] * s, e1[12] = t[12] * r + t[13] * o + t[14] * n + t[15] * s, e1[1]), o = e1[5], n = e1[9], s = e1[13], r = (e1[1] = t[0] * r + t[1] * o + t[2] * n + t[3] * s, e1[5] = t[4] * r + t[5] * o + t[6] * n + t[7] * s, e1[9] = t[8] * r + t[9] * o + t[10] * n + t[11] * s, e1[13] = t[12] * r + t[13] * o + t[14] * n + t[15] * s, e1[2]), o = e1[6], n = e1[10], s = e1[14], r = (e1[2] = t[0] * r + t[1] * o + t[2] * n + t[3] * s, e1[6] = t[4] * r + t[5] * o + t[6] * n + t[7] * s, e1[10] = t[8] * r + t[9] * o + t[10] * n + t[11] * s, e1[14] = t[12] * r + t[13] * o + t[14] * n + t[15] * s, e1[3]), o = e1[7], n = e1[11], s = e1[15];
                                return e1[3] = t[0] * r + t[1] * o + t[2] * n + t[3] * s, e1[7] = t[4] * r + t[5] * o + t[6] * n + t[7] * s, e1[11] = t[8] * r + t[9] * o + t[10] * n + t[11] * s, e1[15] = t[12] * r + t[13] * o + t[14] * n + t[15] * s, this;
                            }
                        },
                        {
                            key: "scale",
                            value: function(e1, t, r) {
                                return e1 instanceof C.default.Vector ? (t = e1.y, r = e1.z, e1 = e1.x) : e1 instanceof Array && (t = e1[1], r = e1[2], e1 = e1[0]), this.mat4[0] *= e1, this.mat4[1] *= e1, this.mat4[2] *= e1, this.mat4[3] *= e1, this.mat4[4] *= t, this.mat4[5] *= t, this.mat4[6] *= t, this.mat4[7] *= t, this.mat4[8] *= r, this.mat4[9] *= r, this.mat4[10] *= r, this.mat4[11] *= r, this;
                            }
                        },
                        {
                            key: "rotate",
                            value: function(e1, t, r, o) {
                                t instanceof C.default.Vector ? (r = t.y, o = t.z, t = t.x) : t instanceof Array && (r = t[1], o = t[2], t = t[0]);
                                var n = Math.sqrt(t * t + r * r + o * o), n = (t *= 1 / n, r *= 1 / n, o *= 1 / n, this.mat4[0]), s = this.mat4[1], i = this.mat4[2], a = this.mat4[3], l = this.mat4[4], u = this.mat4[5], c = this.mat4[6], d = this.mat4[7], h = this.mat4[8], f = this.mat4[9], p = this.mat4[10], m = this.mat4[11], y = Math.sin(e1), e1 = Math.cos(e1), g = 1 - e1, v = t * t * g + e1, b = r * t * g + o * y, j = o * t * g - r * y, _ = t * r * g - o * y, x = r * r * g + e1, w = o * r * g + t * y, S = t * o * g + r * y, r = r * o * g - t * y, t = o * o * g + e1;
                                return this.mat4[0] = n * v + l * b + h * j, this.mat4[1] = s * v + u * b + f * j, this.mat4[2] = i * v + c * b + p * j, this.mat4[3] = a * v + d * b + m * j, this.mat4[4] = n * _ + l * x + h * w, this.mat4[5] = s * _ + u * x + f * w, this.mat4[6] = i * _ + c * x + p * w, this.mat4[7] = a * _ + d * x + m * w, this.mat4[8] = n * S + l * r + h * t, this.mat4[9] = s * S + u * r + f * t, this.mat4[10] = i * S + c * r + p * t, this.mat4[11] = a * S + d * r + m * t, this;
                            }
                        },
                        {
                            key: "translate",
                            value: function(e1) {
                                var t = e1[0], r = e1[1], e1 = e1[2] || 0;
                                this.mat4[12] += this.mat4[0] * t + this.mat4[4] * r + this.mat4[8] * e1, this.mat4[13] += this.mat4[1] * t + this.mat4[5] * r + this.mat4[9] * e1, this.mat4[14] += this.mat4[2] * t + this.mat4[6] * r + this.mat4[10] * e1, this.mat4[15] += this.mat4[3] * t + this.mat4[7] * r + this.mat4[11] * e1;
                            }
                        },
                        {
                            key: "rotateX",
                            value: function(e1) {
                                this.rotate(e1, 1, 0, 0);
                            }
                        },
                        {
                            key: "rotateY",
                            value: function(e1) {
                                this.rotate(e1, 0, 1, 0);
                            }
                        },
                        {
                            key: "rotateZ",
                            value: function(e1) {
                                this.rotate(e1, 0, 0, 1);
                            }
                        },
                        {
                            key: "perspective",
                            value: function(e1, t, r, o) {
                                var e1 = 1 / Math.tan(e1 / 2), n = 1 / (r - o);
                                return this.mat4[0] = e1 / t, this.mat4[1] = 0, this.mat4[2] = 0, this.mat4[3] = 0, this.mat4[4] = 0, this.mat4[5] = e1, this.mat4[6] = 0, this.mat4[7] = 0, this.mat4[8] = 0, this.mat4[9] = 0, this.mat4[10] = (o + r) * n, this.mat4[11] = -1, this.mat4[12] = 0, this.mat4[13] = 0, this.mat4[14] = 2 * o * r * n, this.mat4[15] = 0, this;
                            }
                        },
                        {
                            key: "ortho",
                            value: function(e1, t, r, o, n, s) {
                                var i = 1 / (e1 - t), a = 1 / (r - o), l = 1 / (n - s);
                                return this.mat4[0] = -2 * i, this.mat4[1] = 0, this.mat4[2] = 0, this.mat4[3] = 0, this.mat4[4] = 0, this.mat4[5] = -2 * a, this.mat4[6] = 0, this.mat4[7] = 0, this.mat4[8] = 0, this.mat4[9] = 0, this.mat4[10] = 2 * l, this.mat4[11] = 0, this.mat4[12] = (e1 + t) * i, this.mat4[13] = (o + r) * a, this.mat4[14] = (s + n) * l, this.mat4[15] = 1, this;
                            }
                        },
                        {
                            key: "multiplyVec4",
                            value: function(e1, t, r, o) {
                                var n = new Array(4), s = this.mat4;
                                return n[0] = s[0] * e1 + s[4] * t + s[8] * r + s[12] * o, n[1] = s[1] * e1 + s[5] * t + s[9] * r + s[13] * o, n[2] = s[2] * e1 + s[6] * t + s[10] * r + s[14] * o, n[3] = s[3] * e1 + s[7] * t + s[11] * r + s[15] * o, n;
                            }
                        },
                        {
                            key: "multiplyPoint",
                            value: function(e1) {
                                var t = e1.x, r = e1.y, e1 = e1.z, t = this.multiplyVec4(t, r, e1, 1);
                                return new C.default.Vector(t[0], t[1], t[2]);
                            }
                        },
                        {
                            key: "multiplyAndNormalizePoint",
                            value: function(e1) {
                                var t = e1.x, r = e1.y, e1 = e1.z, t = this.multiplyVec4(t, r, e1, 1);
                                return t[0] /= t[3], t[1] /= t[3], t[2] /= t[3], new C.default.Vector(t[0], t[1], t[2]);
                            }
                        },
                        {
                            key: "multiplyDirection",
                            value: function(e1) {
                                var t = e1.x, r = e1.y, e1 = e1.z, t = this.multiplyVec4(t, r, e1, 0);
                                return new C.default.Vector(t[0], t[1], t[2]);
                            }
                        },
                        {
                            key: "mult3x3",
                            value: function(e1) {
                                var t;
                                if (e1 === this || e1 === this.mat3) t = this.copy().mat3;
                                else if (e1 instanceof C.default.Matrix) t = e1.mat3;
                                else if (O(e1)) t = e1;
                                else {
                                    if (9 !== arguments.length) return;
                                    t = arguments;
                                }
                                var e1 = this.mat3[0], r = this.mat3[1], o = this.mat3[2];
                                return this.mat3[0] = e1 * t[0] + r * t[3] + o * t[6], this.mat3[1] = e1 * t[1] + r * t[4] + o * t[7], this.mat3[2] = e1 * t[2] + r * t[5] + o * t[8], e1 = this.mat3[3], r = this.mat3[4], o = this.mat3[5], this.mat3[3] = e1 * t[0] + r * t[3] + o * t[6], this.mat3[4] = e1 * t[1] + r * t[4] + o * t[7], this.mat3[5] = e1 * t[2] + r * t[5] + o * t[8], e1 = this.mat3[6], r = this.mat3[7], o = this.mat3[8], this.mat3[6] = e1 * t[0] + r * t[3] + o * t[6], this.mat3[7] = e1 * t[1] + r * t[4] + o * t[7], this.mat3[8] = e1 * t[2] + r * t[5] + o * t[8], this;
                            }
                        },
                        {
                            key: "column",
                            value: function(e1) {
                                return new C.default.Vector(this.mat3[3 * e1], this.mat3[3 * e1 + 1], this.mat3[3 * e1 + 2]);
                            }
                        },
                        {
                            key: "row",
                            value: function(e1) {
                                return new C.default.Vector(this.mat3[e1], this.mat3[e1 + 3], this.mat3[e1 + 6]);
                            }
                        },
                        {
                            key: "diagonal",
                            value: function() {
                                return void 0 !== this.mat3 ? [
                                    this.mat3[0],
                                    this.mat3[4],
                                    this.mat3[8]
                                ] : [
                                    this.mat4[0],
                                    this.mat4[5],
                                    this.mat4[10],
                                    this.mat4[15]
                                ];
                            }
                        },
                        {
                            key: "multiplyVec3",
                            value: function(e1, t) {
                                return (t = void 0 === t ? e1.copy() : t).x = this.row(0).dot(e1), t.y = this.row(1).dot(e1), t.z = this.row(2).dot(e1), t;
                            }
                        },
                        {
                            key: "createSubMatrix3x3",
                            value: function() {
                                var e1 = new C.default.Matrix("mat3");
                                return e1.mat3[0] = this.mat4[0], e1.mat3[1] = this.mat4[1], e1.mat3[2] = this.mat4[2], e1.mat3[3] = this.mat4[4], e1.mat3[4] = this.mat4[5], e1.mat3[5] = this.mat4[6], e1.mat3[6] = this.mat4[8], e1.mat3[7] = this.mat4[9], e1.mat3[8] = this.mat4[10], e1;
                            }
                        }
                    ], n(e1.prototype, t), o && n(e1, o), r;
                }(), C.default.Matrix);
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.typed-array.copy-within": 205,
                "core-js/modules/es.typed-array.every": 206,
                "core-js/modules/es.typed-array.fill": 207,
                "core-js/modules/es.typed-array.filter": 208,
                "core-js/modules/es.typed-array.find": 210,
                "core-js/modules/es.typed-array.find-index": 209,
                "core-js/modules/es.typed-array.float32-array": 211,
                "core-js/modules/es.typed-array.for-each": 213,
                "core-js/modules/es.typed-array.includes": 214,
                "core-js/modules/es.typed-array.index-of": 215,
                "core-js/modules/es.typed-array.iterator": 218,
                "core-js/modules/es.typed-array.join": 219,
                "core-js/modules/es.typed-array.last-index-of": 220,
                "core-js/modules/es.typed-array.map": 221,
                "core-js/modules/es.typed-array.reduce": 223,
                "core-js/modules/es.typed-array.reduce-right": 222,
                "core-js/modules/es.typed-array.reverse": 224,
                "core-js/modules/es.typed-array.set": 225,
                "core-js/modules/es.typed-array.slice": 226,
                "core-js/modules/es.typed-array.some": 227,
                "core-js/modules/es.typed-array.sort": 228,
                "core-js/modules/es.typed-array.subarray": 229,
                "core-js/modules/es.typed-array.to-locale-string": 230,
                "core-js/modules/es.typed-array.to-string": 231
            }
        ],
        329: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.map"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function o(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                e1.default.RenderBuffer = function() {
                    function i(e1, t, r, o, n, s) {
                        if (!(this instanceof i)) throw new TypeError("Cannot call a class as a function");
                        this.size = e1, this.src = t, this.dst = r, this.attr = o, this._renderer = n, this.map = s;
                    }
                    var e1, t, r;
                    return e1 = i, t = [
                        {
                            key: "_prepareBuffer",
                            value: function(e1, t) {
                                var r, o, n, s = t.attributes, i = this._renderer.GL, a = e1.model || e1, s = s[this.attr];
                                s && (r = e1[this.dst], 0 < (o = a[this.src]).length ? ((n = !r) && (e1[this.dst] = r = i.createBuffer()), i.bindBuffer(i.ARRAY_BUFFER, r), !n && !1 === a.dirtyFlags[this.src] || (n = (e1 = this.map) ? e1(o) : o, this._renderer._bindBuffer(r, i.ARRAY_BUFFER, n), a.dirtyFlags[this.src] = !1), t.enableAttrib(s, this.size)) : -1 !== (e1 = s.location) && this._renderer.registerEnabled.has(e1) && (i.disableVertexAttribArray(e1), this._renderer.registerEnabled.delete(e1)));
                            }
                        }
                    ], o(e1.prototype, t), r && o(e1, r), i;
                }();
                e1 = e1.default.RenderBuffer;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.map": 164
            }
        ],
        330: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.find-index"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.map"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.find-index"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.map"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, h = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function f(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                e1("./p5.RenderBuffer"), l.default.RendererGL.prototype.beginShape = function(e1) {
                    return this.immediateMode.shapeMode = void 0 !== e1 ? e1 : h.TESS, this.immediateMode.geometry.reset(), this.immediateMode.contourIndices = [], this;
                };
                var u = {
                    vertices: 1,
                    vertexNormals: 1,
                    vertexColors: 4,
                    vertexStrokeColors: 4,
                    uvs: 2
                }, n = (l.default.RendererGL.prototype.beginContour = function() {
                    if (this.immediateMode.shapeMode !== h.TESS) throw new Error("WebGL mode can only use contours with beginShape(TESS).");
                    this.immediateMode.contourIndices.push(this.immediateMode.geometry.vertices.length);
                }, l.default.RendererGL.prototype.vertex = function(e1, t) {
                    if (this.immediateMode.shapeMode === h.QUADS && this.immediateMode.geometry.vertices.length % 6 == 3) for(var r in u){
                        var o = u[r], r = this.immediateMode.geometry[r];
                        r.push.apply(r, f(r.slice(r.length - 3 * o, r.length - 2 * o)).concat(f(r.slice(r.length - o, r.length))));
                    }
                    var n, s, i = n = s = 0, a = (3 === arguments.length ? i = arguments[2] : 4 === arguments.length ? (n = arguments[2], s = arguments[3]) : 5 === arguments.length && (i = arguments[2], n = arguments[3], s = arguments[4]), new l.default.Vector(e1, t, i)), a = (this.immediateMode.geometry.vertices.push(a), this.immediateMode.geometry.vertexNormals.push(this._currentNormal), this.curFillColor || [
                        .5,
                        .5,
                        .5,
                        1
                    ]), a = (this.immediateMode.geometry.vertexColors.push(a[0], a[1], a[2], a[3]), this.curStrokeColor || [
                        .5,
                        .5,
                        .5,
                        1
                    ]);
                    return this.immediateMode.geometry.vertexStrokeColors.push(a[0], a[1], a[2], a[3]), this.textureMode !== h.IMAGE || this.isProcessingVertices || (null !== this._tex ? 0 < this._tex.width && 0 < this._tex.height && (n /= this._tex.width, s /= this._tex.height) : void 0 === this.userFillShader && void 0 === this.userStrokeShader && void 0 === this.userPointShader && null === this._tex && 4 <= arguments.length && console.warn("You must first call texture() before using vertex() with image based u and v coordinates")), this.immediateMode.geometry.uvs.push(n, s), this.immediateMode._bezierVertex[0] = e1, this.immediateMode._bezierVertex[1] = t, this.immediateMode._bezierVertex[2] = i, this.immediateMode._quadraticVertex[0] = e1, this.immediateMode._quadraticVertex[1] = t, this.immediateMode._quadraticVertex[2] = i, this;
                }, l.default.RendererGL.prototype.normal = function(e1, t, r) {
                    return e1 instanceof l.default.Vector ? this._currentNormal = e1 : this._currentNormal = new l.default.Vector(e1, t, r), this;
                }, l.default.RendererGL.prototype.endShape = function(e1, t, r, o, n, s) {
                    var i = 6 < arguments.length && void 0 !== arguments[6] ? arguments[6] : 1;
                    return this.immediateMode.shapeMode === h.POINTS ? this._drawPoints(this.immediateMode.geometry.vertices, this.immediateMode.buffers.point) : (3 === this.immediateMode.geometry.vertices.length && this.immediateMode.shapeMode === h.TESS && (this.immediateMode.shapeMode, h.TRIANGLES), this.isProcessingVertices = !0, this._processVertices.apply(this, arguments), this.isProcessingVertices = !1, this.immediateMode.shapeMode !== h.LINE_STRIP && this.immediateMode.shapeMode !== h.LINES || (this.immediateMode.shapeMode = h.TRIANGLE_FAN), this.immediateMode.shapeMode === h.QUADS ? this.immediateMode.shapeMode = h.TRIANGLES : this.immediateMode.shapeMode === h.QUAD_STRIP && (this.immediateMode.shapeMode = h.TRIANGLE_STRIP), this._doFill && !this.geometryBuilder && 3 <= this.immediateMode.geometry.vertices.length && this._drawImmediateFill(i), this._doStroke && !this.geometryBuilder && 1 <= this.immediateMode.geometry.lineVertices.length && this._drawImmediateStroke(), this.geometryBuilder && this.geometryBuilder.addImmediate(), this.isBezier = !1, this.isQuadratic = !1, this.isCurve = !1, this.immediateMode._bezierVertex.length = 0, this.immediateMode._quadraticVertex.length = 0, this.immediateMode._curveVertex.length = 0), this;
                }, l.default.RendererGL.prototype._processVertices = function(e1) {
                    var t;
                    0 !== this.immediateMode.geometry.vertices.length && (t = this._doStroke, e1 = e1 === h.CLOSE, t && (this.immediateMode.geometry.edges = this._calculateEdges(this.immediateMode.shapeMode, this.immediateMode.geometry.vertices, e1), this.geometryBuilder || this.immediateMode.geometry._edgesToVertices()), t = this.immediateMode.shapeMode === h.TESS, e1 = 0 < this.immediateMode.contourIndices.length, this._doFill && (this.isBezier || this.isQuadratic || this.isCurve || t || e1) && this.immediateMode.shapeMode !== h.LINES && this._tesselateShape());
                }, l.default.RendererGL.prototype._calculateEdges = function(e1, t, r) {
                    var o = [], n = 0, s = this.immediateMode.contourIndices.slice(), i = 0;
                    switch(e1){
                        case h.TRIANGLE_STRIP:
                            for(n = 0; n < t.length - 2; n++)o.push([
                                n,
                                n + 1
                            ]), o.push([
                                n,
                                n + 2
                            ]);
                            o.push([
                                n,
                                n + 1
                            ]);
                            break;
                        case h.TRIANGLE_FAN:
                            for(n = 1; n < t.length - 1; n++)o.push([
                                0,
                                n
                            ]), o.push([
                                n,
                                n + 1
                            ]);
                            o.push([
                                0,
                                t.length - 1
                            ]);
                            break;
                        case h.TRIANGLES:
                            for(n = 0; n < t.length - 2; n += 3)o.push([
                                n,
                                n + 1
                            ]), o.push([
                                n + 1,
                                n + 2
                            ]), o.push([
                                n + 2,
                                n
                            ]);
                            break;
                        case h.LINES:
                            for(n = 0; n < t.length - 1; n += 2)o.push([
                                n,
                                n + 1
                            ]);
                            break;
                        case h.QUADS:
                            for(n = 0; n < t.length - 5; n += 6)o.push([
                                n,
                                n + 1
                            ]), o.push([
                                n + 1,
                                n + 2
                            ]), o.push([
                                n + 3,
                                n + 5
                            ]), o.push([
                                n + 4,
                                n + 5
                            ]);
                            break;
                        case h.QUAD_STRIP:
                            for(n = 0; n < t.length - 2; n += 2)o.push([
                                n,
                                n + 1
                            ]), o.push([
                                n,
                                n + 2
                            ]), o.push([
                                n + 1,
                                n + 3
                            ]);
                            o.push([
                                n,
                                n + 1
                            ]);
                            break;
                        default:
                            for(n = 0; n < t.length; n++)n + 1 < t.length && n + 1 !== s[0] ? o.push([
                                n,
                                n + 1
                            ]) : ((r || i) && o.push([
                                n,
                                i
                            ]), 0 < s.length && (i = s.shift()));
                    }
                    return e1 !== h.TESS && r && o.push([
                        t.length - 1,
                        0
                    ]), o;
                }, l.default.RendererGL.prototype._tesselateShape = function() {
                    for(var u = this, e1 = (this.immediateMode.shapeMode = h.TRIANGLES, [
                        []
                    ]), t = 0; t < this.immediateMode.geometry.vertices.length; t++)0 < this.immediateMode.contourIndices.length && this.immediateMode.contourIndices[0] === t && (this.immediateMode.contourIndices.shift(), e1.push([])), e1[e1.length - 1].push(this.immediateMode.geometry.vertices[t].x, this.immediateMode.geometry.vertices[t].y, this.immediateMode.geometry.vertices[t].z, this.immediateMode.geometry.uvs[2 * t], this.immediateMode.geometry.uvs[2 * t + 1], this.immediateMode.geometry.vertexColors[4 * t], this.immediateMode.geometry.vertexColors[4 * t + 1], this.immediateMode.geometry.vertexColors[4 * t + 2], this.immediateMode.geometry.vertexColors[4 * t + 3], this.immediateMode.geometry.vertexNormals[t].x, this.immediateMode.geometry.vertexNormals[t].y, this.immediateMode.geometry.vertexNormals[t].z);
                    for(var c, r = this._triangulate(e1), d = this.immediateMode.geometry.vertices, o = (this.immediateMode.geometry.vertices = [], this.immediateMode.geometry.vertexNormals = [], this.immediateMode.geometry.uvs = [], []), n = 0, s = r.length; n < s; n += l.default.RendererGL.prototype.tessyVertexSize)o.push.apply(o, f(r.slice(n + 5, n + 9))), this.normal.apply(this, f(r.slice(n + 9, n + 12))), this.vertex.apply(this, f(r.slice(n, n + 5)));
                    this.geometryBuilder && (c = new Map, this.immediateMode.geometry.edges = this.immediateMode.geometry.edges.map(function(e1) {
                        return e1.map(function(e1) {
                            if (!c.has(e1)) {
                                var t = d[e1], r = u.immediateMode.geometry.vertices.findIndex(function(e1) {
                                    return t.x === e1.x && t.y === e1.y && t.z === e1.z;
                                });
                                if (-1 === r) {
                                    for(var o = 1 / 0, n = 0, s = 0; s < u.immediateMode.geometry.vertices.length; s++){
                                        var i = u.immediateMode.geometry.vertices[s], a = t.x - i.x, l = t.y - i.y, i = t.z - i.z, a = a * a + l * l + i * i;
                                        a < o && (o = a, n = s);
                                    }
                                    r = n;
                                }
                                c.set(e1, r);
                            }
                            return c.get(e1);
                        });
                    })), this.immediateMode.geometry.vertexColors = o;
                }, l.default.RendererGL.prototype._drawImmediateFill = function() {
                    var e1, t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 1, r = this.GL, o = (this._useVertexColor = 0 < this.immediateMode.geometry.vertexColors.length, e1 = this._getImmediateFillShader(), this._setFillUniforms(e1), !0), n = !1, s = void 0;
                    try {
                        for(var i, a = this.immediateMode.buffers.fill[Symbol.iterator](); !(o = (i = a.next()).done); o = !0)i.value._prepareBuffer(this.immediateMode.geometry, e1);
                    } catch (e1) {
                        n = !0, s = e1;
                    } finally{
                        try {
                            o || null == a.return || a.return();
                        } finally{
                            if (n) throw s;
                        }
                    }
                    if (e1.disableRemainingAttributes(), this._applyColorBlend(this.curFillColor), 1 === t) r.drawArrays(this.immediateMode.shapeMode, 0, this.immediateMode.geometry.vertices.length);
                    else try {
                        r.drawArraysInstanced(this.immediateMode.shapeMode, 0, this.immediateMode.geometry.vertices.length, t);
                    } catch (e1) {
                        console.log("\uD83C\uDF38 p5.js says: Instancing is only supported in WebGL2 mode");
                    }
                    e1.unbindShader();
                }, l.default.RendererGL.prototype._drawImmediateStroke = function() {
                    var e1 = this.GL, t = (this._useLineColor = 0 < this.immediateMode.geometry.vertexStrokeColors.length, this._getImmediateStrokeShader()), r = (this._setStrokeUniforms(t), !0), o = !1, n = void 0;
                    try {
                        for(var s, i = this.immediateMode.buffers.stroke[Symbol.iterator](); !(r = (s = i.next()).done); r = !0)s.value._prepareBuffer(this.immediateMode.geometry, t);
                    } catch (e1) {
                        o = !0, n = e1;
                    } finally{
                        try {
                            r || null == i.return || i.return();
                        } finally{
                            if (o) throw n;
                        }
                    }
                    t.disableRemainingAttributes(), this._applyColorBlend(this.curStrokeColor), e1.drawArrays(e1.TRIANGLES, 0, this.immediateMode.geometry.lineVertices.length / 3), t.unbindShader();
                }, l.default.RendererGL);
                r.default = n;
            },
            {
                "../core/constants": 264,
                "../core/main": 275,
                "./p5.RenderBuffer": 329,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.fill": 154,
                "core-js/modules/es.array.find-index": 156,
                "core-js/modules/es.array.from": 158,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.map": 164,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.map": 169,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        331: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.uint16-array"), e1("core-js/modules/es.typed-array.uint32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.uint16-array"), e1("core-js/modules/es.typed-array.uint32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var a = (s = e1("../core/main")) && s.__esModule ? s : {
                    default: s
                }, n = (e1("./p5.RendererGL"), e1("./p5.RenderBuffer"), function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = l();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants")));
                function l() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, l = function() {
                        return e1;
                    }, e1);
                }
                a.default.RendererGL.prototype.freeGeometry = function(e1) {
                    e1.gid ? this._freeBuffers(e1.gid) : console.warn("The model you passed to freeGeometry does not have an id!");
                }, a.default.RendererGL.prototype._initBufferDefaults = function(e1) {
                    var t;
                    return this._freeBuffers(e1), 1e3 < Object.keys(this.retainedMode.geometry).length && (t = Object.keys(this.retainedMode.geometry)[0], this._freeBuffers(t)), this.retainedMode.geometry[e1] = {};
                }, a.default.RendererGL.prototype._freeBuffers = function(e1) {
                    var a, l = this.retainedMode.geometry[e1];
                    function t(e1) {
                        var t = !0, r = !1, o = void 0;
                        try {
                            for(var n, s = e1[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                var i = n.value;
                                l[i.dst] && (a.deleteBuffer(l[i.dst]), l[i.dst] = null);
                            }
                        } catch (e1) {
                            r = !0, o = e1;
                        } finally{
                            try {
                                t || null == s.return || s.return();
                            } finally{
                                if (r) throw o;
                            }
                        }
                    }
                    l && (delete this.retainedMode.geometry[e1], a = this.GL, l.indexBuffer && a.deleteBuffer(l.indexBuffer), t(this.retainedMode.buffers.stroke), t(this.retainedMode.buffers.fill));
                }, a.default.RendererGL.prototype.createBuffers = function(e1, t) {
                    var r, o, n, s = this.GL, e1 = this._initBufferDefaults(e1), i = (e1.model = t, e1.indexBuffer);
                    return t.faces.length ? (i = i || (e1.indexBuffer = s.createBuffer()), n = (o = (r = a.default.RendererGL.prototype._flatten(t.faces)).some(function(e1) {
                        return 65535 < e1;
                    })) ? Uint32Array : Uint16Array, this._bindBuffer(i, s.ELEMENT_ARRAY_BUFFER, r, n), e1.indexBufferType = o ? s.UNSIGNED_INT : s.UNSIGNED_SHORT, e1.vertexCount = 3 * t.faces.length) : (i && (s.deleteBuffer(i), e1.indexBuffer = null), e1.vertexCount = t.vertices ? t.vertices.length : 0), e1.lineVertexCount = t.lineVertices ? t.lineVertices.length / 3 : 0, e1;
                }, a.default.RendererGL.prototype.drawBuffers = function(e1) {
                    var t = this.GL, r = this.retainedMode.geometry[e1];
                    if (!this.geometryBuilder && this._doFill && 0 < this.retainedMode.geometry[e1].vertexCount) {
                        this._useVertexColor = 0 < r.model.vertexColors.length;
                        var o = this._getRetainedFillShader(), n = (this._setFillUniforms(o), !0), s = !1, i = void 0;
                        try {
                            for(var a, l = this.retainedMode.buffers.fill[Symbol.iterator](); !(n = (a = l.next()).done); n = !0)a.value._prepareBuffer(r, o);
                        } catch (e1) {
                            s = !0, i = e1;
                        } finally{
                            try {
                                n || null == l.return || l.return();
                            } finally{
                                if (s) throw i;
                            }
                        }
                        o.disableRemainingAttributes(), r.indexBuffer && this._bindBuffer(r.indexBuffer, t.ELEMENT_ARRAY_BUFFER), this._applyColorBlend(this.curFillColor), this._drawElements(t.TRIANGLES, e1), o.unbindShader();
                    }
                    if (!this.geometryBuilder && this._doStroke && 0 < r.lineVertexCount) {
                        this._useLineColor = 0 < r.model.vertexStrokeColors.length;
                        var u = this._getRetainedStrokeShader(), c = (this._setStrokeUniforms(u), !0), s = !1, i = void 0;
                        try {
                            for(var d, h = this.retainedMode.buffers.stroke[Symbol.iterator](); !(c = (d = h.next()).done); c = !0)d.value._prepareBuffer(r, u);
                        } catch (e1) {
                            s = !0, i = e1;
                        } finally{
                            try {
                                c || null == h.return || h.return();
                            } finally{
                                if (s) throw i;
                            }
                        }
                        u.disableRemainingAttributes(), this._applyColorBlend(this.curStrokeColor), this._drawArrays(t.TRIANGLES, e1), u.unbindShader();
                    }
                    return this.geometryBuilder && this.geometryBuilder.addRetained(r), this;
                }, a.default.RendererGL.prototype.drawBuffersScaled = function(e1, t, r, o) {
                    var n = this.uMVMatrix.copy();
                    try {
                        this.uMVMatrix.scale(t, r, o), this.drawBuffers(e1);
                    } finally{
                        this.uMVMatrix = n;
                    }
                }, a.default.RendererGL.prototype._drawArrays = function(e1, t) {
                    return this.GL.drawArrays(e1, 0, this.retainedMode.geometry[t].lineVertexCount), this;
                }, a.default.RendererGL.prototype._drawElements = function(e1, t) {
                    var t = this.retainedMode.geometry[t], r = this.GL;
                    if (t.indexBuffer) {
                        if (this._pInst.webglVersion !== n.WEBGL2 && t.indexBufferType === r.UNSIGNED_INT && !r.getExtension("OES_element_index_uint")) throw new Error("Unable to render a 3d model with > 65535 triangles. Your web browser does not support the WebGL Extension OES_element_index_uint.");
                        r.drawElements(r.TRIANGLES, t.vertexCount, t.indexBufferType, 0);
                    } else r.drawArrays(e1 || r.TRIANGLES, 0, t.vertexCount);
                }, a.default.RendererGL.prototype._drawPoints = function(e1, t) {
                    var r = this.GL, o = this._getImmediatePointShader();
                    this._setPointUniforms(o), this._bindBuffer(t, r.ARRAY_BUFFER, this._vToNArray(e1), Float32Array, r.STATIC_DRAW), o.enableAttrib(o.attributes.aPosition, 3), this._applyColorBlend(this.curStrokeColor), r.drawArrays(r.Points, 0, e1.length), o.unbindShader();
                };
                var s = a.default.RendererGL;
                r.default = s;
            },
            {
                "../core/constants": 264,
                "../core/main": 275,
                "./p5.RenderBuffer": 329,
                "./p5.RendererGL": 332,
                "core-js/modules/es.array.fill": 154,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.some": 166,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.keys": 181,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.typed-array.copy-within": 205,
                "core-js/modules/es.typed-array.every": 206,
                "core-js/modules/es.typed-array.fill": 207,
                "core-js/modules/es.typed-array.filter": 208,
                "core-js/modules/es.typed-array.find": 210,
                "core-js/modules/es.typed-array.find-index": 209,
                "core-js/modules/es.typed-array.float32-array": 211,
                "core-js/modules/es.typed-array.for-each": 213,
                "core-js/modules/es.typed-array.includes": 214,
                "core-js/modules/es.typed-array.index-of": 215,
                "core-js/modules/es.typed-array.iterator": 218,
                "core-js/modules/es.typed-array.join": 219,
                "core-js/modules/es.typed-array.last-index-of": 220,
                "core-js/modules/es.typed-array.map": 221,
                "core-js/modules/es.typed-array.reduce": 223,
                "core-js/modules/es.typed-array.reduce-right": 222,
                "core-js/modules/es.typed-array.reverse": 224,
                "core-js/modules/es.typed-array.set": 225,
                "core-js/modules/es.typed-array.slice": 226,
                "core-js/modules/es.typed-array.some": 227,
                "core-js/modules/es.typed-array.sort": 228,
                "core-js/modules/es.typed-array.subarray": 229,
                "core-js/modules/es.typed-array.to-locale-string": 230,
                "core-js/modules/es.typed-array.to-string": 231,
                "core-js/modules/es.typed-array.uint16-array": 232,
                "core-js/modules/es.typed-array.uint32-array": 233,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        332: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.copy-within"), e1("core-js/modules/es.array.every"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.map"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.reflect.get"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.float64-array"), e1("core-js/modules/es.typed-array.int16-array"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint16-array"), e1("core-js/modules/es.typed-array.uint32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.copy-within"), e1("core-js/modules/es.array.every"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.map"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.float64-array"), e1("core-js/modules/es.typed-array.int16-array"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint16-array"), e1("core-js/modules/es.typed-array.uint32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.readPixelsWebGL = k, r.readPixelWebGL = C, r.default = void 0;
                var g = n(e1("../core/main")), l = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = d();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants")), a = n(e1("./GeometryBuilder")), u = n(e1("libtess")), c = (e1("./p5.Shader"), e1("./p5.Camera"), e1("../core/p5.Renderer"), e1("./p5.Matrix"), e1("./p5.Framebuffer"), e1("path"), e1("./p5.Texture"));
                function d() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, d = function() {
                        return e1;
                    }, e1);
                }
                function n(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function h(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                function f(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function p(e1, t, r) {
                    return (p = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e1, t, r) {
                        var e1 = function(e1, t) {
                            for(; !Object.prototype.hasOwnProperty.call(e1, t) && null !== (e1 = b(e1)););
                            return e1;
                        }(e1, t);
                        if (e1) return (e1 = Object.getOwnPropertyDescriptor(e1, t)).get ? e1.get.call(r) : e1.value;
                    })(e1, t, r || e1);
                }
                function m(e1, t) {
                    return (m = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function y(o) {
                    return function() {
                        var e1, t, r = b(o);
                        return e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = b(this).constructor, Reflect.construct(r, arguments, e1)) : r.apply(this, arguments), r = this, !(t = e1) || "object" !== i(t) && "function" != typeof t ? v(r) : t;
                    };
                }
                function v(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                function b(e1) {
                    return (b = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                function j(e1, t, r) {
                    t in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r;
                }
                function s(e1, t) {
                    T += "#define STROKE_CAP_".concat(e1, " ").concat(t, "\n"), w[l[e1]] = t;
                }
                function _(e1, t) {
                    T += "#define STROKE_JOIN_".concat(e1, " ").concat(t, "\n"), S[l[e1]] = t;
                }
                var x, w = {}, S = {}, T = "", e1 = (s("ROUND", 0), s("PROJECT", 1), s("SQUARE", 2), _("ROUND", 0), _("MITER", 1), _("BEVEL", 2), '#define PI 3.141592\n\nprecision highp float;\nprecision highp int;\n\nuniform mat4 uViewMatrix;\n\nuniform bool uUseLighting;\n\nuniform int uAmbientLightCount;\nuniform vec3 uAmbientColor[5];\n\nuniform int uDirectionalLightCount;\nuniform vec3 uLightingDirection[5];\nuniform vec3 uDirectionalDiffuseColors[5];\nuniform vec3 uDirectionalSpecularColors[5];\n\nuniform int uPointLightCount;\nuniform vec3 uPointLightLocation[5];\nuniform vec3 uPointLightDiffuseColors[5];	\nuniform vec3 uPointLightSpecularColors[5];\n\nuniform int uSpotLightCount;\nuniform float uSpotLightAngle[5];\nuniform float uSpotLightConc[5];\nuniform vec3 uSpotLightDiffuseColors[5];\nuniform vec3 uSpotLightSpecularColors[5];\nuniform vec3 uSpotLightLocation[5];\nuniform vec3 uSpotLightDirection[5];\n\nuniform bool uSpecular;\nuniform float uShininess;\n\nuniform float uConstantAttenuation;\nuniform float uLinearAttenuation;\nuniform float uQuadraticAttenuation;\n\n// setting from  _setImageLightUniforms()\n// boolean to initiate the calculateImageDiffuse and calculateImageSpecular\nuniform bool uUseImageLight;\n// texture for use in calculateImageDiffuse\nuniform sampler2D environmentMapDiffused;\n// texture for use in calculateImageSpecular\nuniform sampler2D environmentMapSpecular;\n// roughness for use in calculateImageSpecular\nuniform float levelOfDetail;\n\nconst float specularFactor = 2.0;\nconst float diffuseFactor = 0.73;\n\nstruct LightResult {\n  float specular;\n  float diffuse;\n};\n\nfloat _phongSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float shininess) {\n\n  vec3 R = reflect(lightDirection, surfaceNormal);\n  return pow(max(0.0, dot(R, viewDirection)), shininess);\n}\n\nfloat _lambertDiffuse(vec3 lightDirection, vec3 surfaceNormal) {\n  return max(0.0, dot(-lightDirection, surfaceNormal));\n}\n\nLightResult _light(vec3 viewDirection, vec3 normal, vec3 lightVector) {\n\n  vec3 lightDir = normalize(lightVector);\n\n  //compute our diffuse & specular terms\n  LightResult lr;\n  if (uSpecular)\n    lr.specular = _phongSpecular(lightDir, viewDirection, normal, uShininess);\n  lr.diffuse = _lambertDiffuse(lightDir, normal);\n  return lr;\n}\n\n// converts the range of "value" from [min1 to max1] to [min2 to max2]\nfloat map(float value, float min1, float max1, float min2, float max2) {\n  return min2 + (value - min1) * (max2 - min2) / (max1 - min1);\n}\n\nvec2 mapTextureToNormal( vec3 v ){\n  // x = r sin(phi) cos(theta)   \n  // y = r cos(phi)  \n  // z = r sin(phi) sin(theta)\n  float phi = acos( v.y );\n  // if phi is 0, then there are no x, z components\n  float theta = 0.0;\n  // else \n  theta = acos(v.x / sin(phi));\n  float sinTheta = v.z / sin(phi);\n  if (sinTheta < 0.0) {\n    // Turn it into -theta, but in the 0-2PI range\n    theta = 2.0 * PI - theta;\n  }\n  theta = theta / (2.0 * 3.14159);\n  phi = phi / 3.14159 ;\n  \n  vec2 angles = vec2( fract(theta + 0.25), 1.0 - phi );\n  return angles;\n}\n\n\nvec3 calculateImageDiffuse( vec3 vNormal, vec3 vViewPosition ){\n  // make 2 seperate builds \n  vec3 worldCameraPosition =  vec3(0.0, 0.0, 0.0);  // hardcoded world camera position\n  vec3 worldNormal = normalize(vNormal);\n  vec2 newTexCoor = mapTextureToNormal( worldNormal );\n  vec4 texture = TEXTURE( environmentMapDiffused, newTexCoor );\n  // this is to make the darker sections more dark\n  // png and jpg usually flatten the brightness so it is to reverse that\n  return smoothstep(vec3(0.0), vec3(0.8), texture.xyz);\n}\n\nvec3 calculateImageSpecular( vec3 vNormal, vec3 vViewPosition ){\n  vec3 worldCameraPosition =  vec3(0.0, 0.0, 0.0);\n  vec3 worldNormal = normalize(vNormal);\n  vec3 lightDirection = normalize( vViewPosition - worldCameraPosition );\n  vec3 R = reflect(lightDirection, worldNormal);\n  vec2 newTexCoor = mapTextureToNormal( R );\n#ifdef WEBGL2\n  vec4 outColor = textureLod(environmentMapSpecular, newTexCoor, levelOfDetail);\n#else\n  vec4 outColor = TEXTURE(environmentMapSpecular, newTexCoor);\n#endif\n  // this is to make the darker sections more dark\n  // png and jpg usually flatten the brightness so it is to reverse that\n  return pow(outColor.xyz, vec3(10.0));\n}\n\nvoid totalLight(\n  vec3 modelPosition,\n  vec3 normal,\n  out vec3 totalDiffuse,\n  out vec3 totalSpecular\n) {\n\n  totalSpecular = vec3(0.0);\n\n  if (!uUseLighting) {\n    totalDiffuse = vec3(1.0);\n    return;\n  }\n\n  totalDiffuse = vec3(0.0);\n\n  vec3 viewDirection = normalize(-modelPosition);\n\n  for (int j = 0; j < 5; j++) {\n    if (j < uDirectionalLightCount) {\n      vec3 lightVector = (uViewMatrix * vec4(uLightingDirection[j], 0.0)).xyz;\n      vec3 lightColor = uDirectionalDiffuseColors[j];\n      vec3 specularColor = uDirectionalSpecularColors[j];\n      LightResult result = _light(viewDirection, normal, lightVector);\n      totalDiffuse += result.diffuse * lightColor;\n      totalSpecular += result.specular * lightColor * specularColor;\n    }\n\n    if (j < uPointLightCount) {\n      vec3 lightPosition = (uViewMatrix * vec4(uPointLightLocation[j], 1.0)).xyz;\n      vec3 lightVector = modelPosition - lightPosition;\n    \n      //calculate attenuation\n      float lightDistance = length(lightVector);\n      float lightFalloff = 1.0 / (uConstantAttenuation + lightDistance * uLinearAttenuation + (lightDistance * lightDistance) * uQuadraticAttenuation);\n      vec3 lightColor = lightFalloff * uPointLightDiffuseColors[j];\n      vec3 specularColor = lightFalloff * uPointLightSpecularColors[j];\n\n      LightResult result = _light(viewDirection, normal, lightVector);\n      totalDiffuse += result.diffuse * lightColor;\n      totalSpecular += result.specular * lightColor * specularColor;\n    }\n\n    if(j < uSpotLightCount) {\n      vec3 lightPosition = (uViewMatrix * vec4(uSpotLightLocation[j], 1.0)).xyz;\n      vec3 lightVector = modelPosition - lightPosition;\n    \n      float lightDistance = length(lightVector);\n      float lightFalloff = 1.0 / (uConstantAttenuation + lightDistance * uLinearAttenuation + (lightDistance * lightDistance) * uQuadraticAttenuation);\n\n      vec3 lightDirection = (uViewMatrix * vec4(uSpotLightDirection[j], 0.0)).xyz;\n      float spotDot = dot(normalize(lightVector), normalize(lightDirection));\n      float spotFalloff;\n      if(spotDot < uSpotLightAngle[j]) {\n        spotFalloff = 0.0;\n      }\n      else {\n        spotFalloff = pow(spotDot, uSpotLightConc[j]);\n      }\n      lightFalloff *= spotFalloff;\n\n      vec3 lightColor = uSpotLightDiffuseColors[j];\n      vec3 specularColor = uSpotLightSpecularColors[j];\n     \n      LightResult result = _light(viewDirection, normal, lightVector);\n      \n      totalDiffuse += result.diffuse * lightColor * lightFalloff;\n      totalSpecular += result.specular * lightColor * specularColor * lightFalloff;\n    }\n  }\n\n  if( uUseImageLight ){\n    totalDiffuse += calculateImageDiffuse(normal, modelPosition);\n    totalSpecular += calculateImageSpecular(normal, modelPosition);\n  }\n\n  totalDiffuse *= diffuseFactor;\n  totalSpecular *= specularFactor;\n}\n'), M = {
                    immediateVert: "IN vec3 aPosition;\nIN vec4 aVertexColor;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform float uResolution;\nuniform float uPointSize;\n\nOUT vec4 vColor;\nvoid main(void) {\n  vec4 positionVec4 = vec4(aPosition, 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vColor = aVertexColor;\n  gl_PointSize = uPointSize;\n}\n",
                    vertexColorVert: "IN vec3 aPosition;\nIN vec4 aVertexColor;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\n\nOUT vec4 vColor;\n\nvoid main(void) {\n  vec4 positionVec4 = vec4(aPosition, 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vColor = aVertexColor;\n}\n",
                    vertexColorFrag: "IN vec4 vColor;\nvoid main(void) {\n  OUT_COLOR = vec4(vColor.rgb, 1.) * vColor.a;\n}\n",
                    normalVert: "IN vec3 aPosition;\nIN vec3 aNormal;\nIN vec2 aTexCoord;\nIN vec4 aVertexColor;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform mat3 uNormalMatrix;\n\nuniform vec4 uMaterialColor;\nuniform bool uUseVertexColor;\n\nOUT vec3 vVertexNormal;\nOUT highp vec2 vVertTexCoord;\nOUT vec4 vColor;\n\nvoid main(void) {\n  vec4 positionVec4 = vec4(aPosition, 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vVertexNormal = normalize(vec3( uNormalMatrix * aNormal ));\n  vVertTexCoord = aTexCoord;\n  vColor = (uUseVertexColor ? aVertexColor : uMaterialColor);\n}\n",
                    normalFrag: "IN vec3 vVertexNormal;\nvoid main(void) {\n  OUT_COLOR = vec4(vVertexNormal, 1.0);\n}\n",
                    basicFrag: "IN vec4 vColor;\nvoid main(void) {\n  OUT_COLOR = vec4(vColor.rgb, 1.) * vColor.a;\n}\n",
                    lightVert: e1 + "// include lighting.glgl\n\nIN vec3 aPosition;\nIN vec3 aNormal;\nIN vec2 aTexCoord;\nIN vec4 aVertexColor;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform mat3 uNormalMatrix;\n\nuniform bool uUseVertexColor;\nuniform vec4 uMaterialColor;\n\nOUT highp vec2 vVertTexCoord;\nOUT vec3 vDiffuseColor;\nOUT vec3 vSpecularColor;\nOUT vec4 vColor;\n\nvoid main(void) {\n\n  vec4 viewModelPosition = uModelViewMatrix * vec4(aPosition, 1.0);\n  gl_Position = uProjectionMatrix * viewModelPosition;\n\n  vec3 vertexNormal = normalize(uNormalMatrix * aNormal);\n  vVertTexCoord = aTexCoord;\n\n  totalLight(viewModelPosition.xyz, vertexNormal, vDiffuseColor, vSpecularColor);\n\n  for (int i = 0; i < 8; i++) {\n    if (i < uAmbientLightCount) {\n      vDiffuseColor += uAmbientColor[i];\n    }\n  }\n  \n  vColor = (uUseVertexColor ? aVertexColor : uMaterialColor);\n}\n",
                    lightTextureFrag: "uniform vec4 uTint;\nuniform sampler2D uSampler;\nuniform bool isTexture;\nuniform bool uEmissive;\n\nIN highp vec2 vVertTexCoord;\nIN vec3 vDiffuseColor;\nIN vec3 vSpecularColor;\nIN vec4 vColor;\n\nvoid main(void) {\n  if(uEmissive && !isTexture) {\n    OUT_COLOR = vColor;\n  }\n  else {\n    vec4 baseColor = isTexture\n      // Textures come in with premultiplied alpha. To apply tint and still have\n      // premultiplied alpha output, we need to multiply the RGB channels by the\n      // tint RGB, and all channels by the tint alpha.\n      ? TEXTURE(uSampler, vVertTexCoord) * vec4(uTint.rgb/255., 1.) * (uTint.a/255.)\n      // Colors come in with unmultiplied alpha, so we need to multiply the RGB\n      // channels by alpha to convert it to premultiplied alpha.\n      : vec4(vColor.rgb * vColor.a, vColor.a);\n    OUT_COLOR = vec4(baseColor.rgb * vDiffuseColor + vSpecularColor, baseColor.a);\n  }\n}\n",
                    phongVert: "precision highp int;\n\nIN vec3 aPosition;\nIN vec3 aNormal;\nIN vec2 aTexCoord;\nIN vec4 aVertexColor;\n\nuniform vec3 uAmbientColor[5];\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform mat3 uNormalMatrix;\nuniform int uAmbientLightCount;\n\nuniform bool uUseVertexColor;\nuniform vec4 uMaterialColor;\n\nOUT vec3 vNormal;\nOUT vec2 vTexCoord;\nOUT vec3 vViewPosition;\nOUT vec3 vAmbientColor;\nOUT vec4 vColor;\n\nvoid main(void) {\n\n  vec4 viewModelPosition = uModelViewMatrix * vec4(aPosition, 1.0);\n\n  // Pass varyings to fragment shader\n  vViewPosition = viewModelPosition.xyz;\n  gl_Position = uProjectionMatrix * viewModelPosition;  \n\n  vNormal = uNormalMatrix * aNormal;\n  vTexCoord = aTexCoord;\n\n  // TODO: this should be a uniform\n  vAmbientColor = vec3(0.0);\n  for (int i = 0; i < 5; i++) {\n    if (i < uAmbientLightCount) {\n      vAmbientColor += uAmbientColor[i];\n    }\n  }\n  \n  vColor = (uUseVertexColor ? aVertexColor : uMaterialColor);\n}\n",
                    phongFrag: e1 + "// include lighting.glsl\nprecision highp int;\n\nuniform bool uHasSetAmbient;\nuniform vec4 uSpecularMatColor;\nuniform vec4 uAmbientMatColor;\nuniform vec4 uEmissiveMatColor;\n\nuniform vec4 uTint;\nuniform sampler2D uSampler;\nuniform bool isTexture;\n\nIN vec3 vNormal;\nIN vec2 vTexCoord;\nIN vec3 vViewPosition;\nIN vec3 vAmbientColor;\nIN vec4 vColor;\n\nvoid main(void) {\n\n  vec3 diffuse;\n  vec3 specular;\n  totalLight(vViewPosition, normalize(vNormal), diffuse, specular);\n\n  // Calculating final color as result of all lights (plus emissive term).\n\n  vec4 baseColor = isTexture\n    // Textures come in with premultiplied alpha. To apply tint and still have\n    // premultiplied alpha output, we need to multiply the RGB channels by the\n    // tint RGB, and all channels by the tint alpha.\n    ? TEXTURE(uSampler, vTexCoord) * vec4(uTint.rgb/255., 1.) * (uTint.a/255.)\n    // Colors come in with unmultiplied alpha, so we need to multiply the RGB\n    // channels by alpha to convert it to premultiplied alpha.\n    : vec4(vColor.rgb * vColor.a, vColor.a);\n  OUT_COLOR = vec4(diffuse * baseColor.rgb + \n                    vAmbientColor * (\n                      uHasSetAmbient ? uAmbientMatColor.rgb : baseColor.rgb\n                    ) + \n                    specular * uSpecularMatColor.rgb + \n                    uEmissiveMatColor.rgb, baseColor.a);\n}\n",
                    fontVert: "IN vec3 aPosition;\nIN vec2 aTexCoord;\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\n\nuniform vec4 uGlyphRect;\nuniform float uGlyphOffset;\n\nOUT vec2 vTexCoord;\nOUT float w;\n\nvoid main() {\n  vec4 positionVec4 = vec4(aPosition, 1.0);\n\n  // scale by the size of the glyph's rectangle\n  positionVec4.xy *= uGlyphRect.zw - uGlyphRect.xy;\n\n  // Expand glyph bounding boxes by 1px on each side to give a bit of room\n  // for antialiasing\n  vec3 newOrigin = (uModelViewMatrix * vec4(0., 0., 0., 1.)).xyz;\n  vec3 newDX = (uModelViewMatrix * vec4(1., 0., 0., 1.)).xyz;\n  vec3 newDY = (uModelViewMatrix * vec4(0., 1., 0., 1.)).xyz;\n  vec2 pixelScale = vec2(\n    1. / length(newOrigin - newDX),\n    1. / length(newOrigin - newDY)\n  );\n  vec2 offset = pixelScale * normalize(aTexCoord - vec2(0.5, 0.5)) * vec2(1., -1.);\n  vec2 textureOffset = offset * (1. / vec2(\n    uGlyphRect.z - uGlyphRect.x,\n    uGlyphRect.w - uGlyphRect.y\n  ));\n\n  // move to the corner of the glyph\n  positionVec4.xy += uGlyphRect.xy;\n\n  // move to the letter's line offset\n  positionVec4.x += uGlyphOffset;\n\n  positionVec4.xy += offset;\n  \n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vTexCoord = aTexCoord + textureOffset;\n  w = gl_Position.w;\n}\n",
                    fontFrag: "#ifndef WEBGL2\n#extension GL_OES_standard_derivatives : enable\n#endif\n\n#if 0\n  // simulate integer math using floats\n	#define int float\n	#define ivec2 vec2\n	#define INT(x) float(x)\n\n	int ifloor(float v) { return floor(v); }\n	ivec2 ifloor(vec2 v) { return floor(v); }\n\n#else\n  // use native integer math\n	precision highp int;\n	#define INT(x) x\n\n	int ifloor(float v) { return int(v); }\n	int ifloor(int v) { return v; }\n	ivec2 ifloor(vec2 v) { return ivec2(v); }\n\n#endif\n\nuniform sampler2D uSamplerStrokes;\nuniform sampler2D uSamplerRowStrokes;\nuniform sampler2D uSamplerRows;\nuniform sampler2D uSamplerColStrokes;\nuniform sampler2D uSamplerCols;\n\nuniform ivec2 uStrokeImageSize;\nuniform ivec2 uCellsImageSize;\nuniform ivec2 uGridImageSize;\n\nuniform ivec2 uGridOffset;\nuniform ivec2 uGridSize;\nuniform vec4 uMaterialColor;\n\nIN vec2 vTexCoord;\n\n// some helper functions\nint ROUND(float v) { return ifloor(v + 0.5); }\nivec2 ROUND(vec2 v) { return ifloor(v + 0.5); }\nfloat saturate(float v) { return clamp(v, 0.0, 1.0); }\nvec2 saturate(vec2 v) { return clamp(v, 0.0, 1.0); }\n\nint mul(float v1, int v2) {\n  return ifloor(v1 * float(v2));\n}\n\nivec2 mul(vec2 v1, ivec2 v2) {\n  return ifloor(v1 * vec2(v2) + 0.5);\n}\n\n// unpack a 16-bit integer from a float vec2\nint getInt16(vec2 v) {\n  ivec2 iv = ROUND(v * 255.0);\n  return iv.x * INT(128) + iv.y;\n}\n\nvec2 pixelScale;\nvec2 coverage = vec2(0.0);\nvec2 weight = vec2(0.5);\nconst float minDistance = 1.0/8192.0;\nconst float hardness = 1.05; // amount of antialias\n\n// the maximum number of curves in a glyph\nconst int N = INT(250);\n\n// retrieves an indexed pixel from a sampler\nvec4 getTexel(sampler2D sampler, int pos, ivec2 size) {\n  int width = size.x;\n  int y = ifloor(pos / width);\n  int x = pos - y * width;  // pos % width\n\n  return TEXTURE(sampler, (vec2(x, y) + 0.5) / vec2(size));\n}\n\nvoid calulateCrossings(vec2 p0, vec2 p1, vec2 p2, out vec2 C1, out vec2 C2) {\n\n  // get the coefficients of the quadratic in t\n  vec2 a = p0 - p1 * 2.0 + p2;\n  vec2 b = p0 - p1;\n  vec2 c = p0 - vTexCoord;\n\n  // found out which values of 't' it crosses the axes\n  vec2 surd = sqrt(max(vec2(0.0), b * b - a * c));\n  vec2 t1 = ((b - surd) / a).yx;\n  vec2 t2 = ((b + surd) / a).yx;\n\n  // approximate straight lines to avoid rounding errors\n  if (abs(a.y) < 0.001)\n    t1.x = t2.x = c.y / (2.0 * b.y);\n\n  if (abs(a.x) < 0.001)\n    t1.y = t2.y = c.x / (2.0 * b.x);\n\n  // plug into quadratic formula to find the corrdinates of the crossings\n  C1 = ((a * t1 - b * 2.0) * t1 + c) * pixelScale;\n  C2 = ((a * t2 - b * 2.0) * t2 + c) * pixelScale;\n}\n\nvoid coverageX(vec2 p0, vec2 p1, vec2 p2) {\n\n  vec2 C1, C2;\n  calulateCrossings(p0, p1, p2, C1, C2);\n\n  // determine on which side of the x-axis the points lie\n  bool y0 = p0.y > vTexCoord.y;\n  bool y1 = p1.y > vTexCoord.y;\n  bool y2 = p2.y > vTexCoord.y;\n\n  // could web be under the curve (after t1)?\n  if (y1 ? !y2 : y0) {\n    // add the coverage for t1\n    coverage.x += saturate(C1.x + 0.5);\n    // calculate the anti-aliasing for t1\n    weight.x = min(weight.x, abs(C1.x));\n  }\n\n  // are we outside the curve (after t2)?\n  if (y1 ? !y0 : y2) {\n    // subtract the coverage for t2\n    coverage.x -= saturate(C2.x + 0.5);\n    // calculate the anti-aliasing for t2\n    weight.x = min(weight.x, abs(C2.x));\n  }\n}\n\n// this is essentially the same as coverageX, but with the axes swapped\nvoid coverageY(vec2 p0, vec2 p1, vec2 p2) {\n\n  vec2 C1, C2;\n  calulateCrossings(p0, p1, p2, C1, C2);\n\n  bool x0 = p0.x > vTexCoord.x;\n  bool x1 = p1.x > vTexCoord.x;\n  bool x2 = p2.x > vTexCoord.x;\n\n  if (x1 ? !x2 : x0) {\n    coverage.y -= saturate(C1.y + 0.5);\n    weight.y = min(weight.y, abs(C1.y));\n  }\n\n  if (x1 ? !x0 : x2) {\n    coverage.y += saturate(C2.y + 0.5);\n    weight.y = min(weight.y, abs(C2.y));\n  }\n}\n\nvoid main() {\n\n  // calculate the pixel scale based on screen-coordinates\n  pixelScale = hardness / fwidth(vTexCoord);\n\n  // which grid cell is this pixel in?\n  ivec2 gridCoord = ifloor(vTexCoord * vec2(uGridSize));\n\n  // intersect curves in this row\n  {\n    // the index into the row info bitmap\n    int rowIndex = gridCoord.y + uGridOffset.y;\n    // fetch the info texel\n    vec4 rowInfo = getTexel(uSamplerRows, rowIndex, uGridImageSize);\n    // unpack the rowInfo\n    int rowStrokeIndex = getInt16(rowInfo.xy);\n    int rowStrokeCount = getInt16(rowInfo.zw);\n\n    for (int iRowStroke = INT(0); iRowStroke < N; iRowStroke++) {\n      if (iRowStroke >= rowStrokeCount)\n        break;\n\n      // each stroke is made up of 3 points: the start and control point\n      // and the start of the next curve.\n      // fetch the indices of this pair of strokes:\n      vec4 strokeIndices = getTexel(uSamplerRowStrokes, rowStrokeIndex++, uCellsImageSize);\n\n      // unpack the stroke index\n      int strokePos = getInt16(strokeIndices.xy);\n\n      // fetch the two strokes\n      vec4 stroke0 = getTexel(uSamplerStrokes, strokePos + INT(0), uStrokeImageSize);\n      vec4 stroke1 = getTexel(uSamplerStrokes, strokePos + INT(1), uStrokeImageSize);\n\n      // calculate the coverage\n      coverageX(stroke0.xy, stroke0.zw, stroke1.xy);\n    }\n  }\n\n  // intersect curves in this column\n  {\n    int colIndex = gridCoord.x + uGridOffset.x;\n    vec4 colInfo = getTexel(uSamplerCols, colIndex, uGridImageSize);\n    int colStrokeIndex = getInt16(colInfo.xy);\n    int colStrokeCount = getInt16(colInfo.zw);\n    \n    for (int iColStroke = INT(0); iColStroke < N; iColStroke++) {\n      if (iColStroke >= colStrokeCount)\n        break;\n\n      vec4 strokeIndices = getTexel(uSamplerColStrokes, colStrokeIndex++, uCellsImageSize);\n\n      int strokePos = getInt16(strokeIndices.xy);\n      vec4 stroke0 = getTexel(uSamplerStrokes, strokePos + INT(0), uStrokeImageSize);\n      vec4 stroke1 = getTexel(uSamplerStrokes, strokePos + INT(1), uStrokeImageSize);\n      coverageY(stroke0.xy, stroke0.zw, stroke1.xy);\n    }\n  }\n\n  weight = saturate(1.0 - weight * 2.0);\n  float distance = max(weight.x + weight.y, minDistance); // manhattan approx.\n  float antialias = abs(dot(coverage, weight) / distance);\n  float cover = min(abs(coverage.x), abs(coverage.y));\n  OUT_COLOR = vec4(uMaterialColor.rgb, 1.) * uMaterialColor.a;\n  OUT_COLOR *= saturate(max(antialias, cover));\n}\n",
                    lineVert: T + "/*\n  Part of the Processing project - http://processing.org\n  Copyright (c) 2012-15 The Processing Foundation\n  Copyright (c) 2004-12 Ben Fry and Casey Reas\n  Copyright (c) 2001-04 Massachusetts Institute of Technology\n  This library is free software; you can redistribute it and/or\n  modify it under the terms of the GNU Lesser General Public\n  License as published by the Free Software Foundation, version 2.1.\n  This library is distributed in the hope that it will be useful,\n  but WITHOUT ANY WARRANTY; without even the implied warranty of\n  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU\n  Lesser General Public License for more details.\n  You should have received a copy of the GNU Lesser General\n  Public License along with this library; if not, write to the\n  Free Software Foundation, Inc., 59 Temple Place, Suite 330,\n  Boston, MA  02111-1307  USA\n*/\n\n#define PROCESSING_LINE_SHADER\n\nprecision mediump int;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform float uStrokeWeight;\n\nuniform bool uUseLineColor;\nuniform vec4 uMaterialColor;\n\nuniform vec4 uViewport;\nuniform int uPerspective;\nuniform int uStrokeJoin;\n\nIN vec4 aPosition;\nIN vec3 aTangentIn;\nIN vec3 aTangentOut;\nIN float aSide;\nIN vec4 aVertexColor;\n\nOUT vec4 vColor;\nOUT vec2 vTangent;\nOUT vec2 vCenter;\nOUT vec2 vPosition;\nOUT float vMaxDist;\nOUT float vCap;\nOUT float vJoin;\n\nvec2 lineIntersection(vec2 aPoint, vec2 aDir, vec2 bPoint, vec2 bDir) {\n  // Rotate and translate so a starts at the origin and goes out to the right\n  bPoint -= aPoint;\n  vec2 rotatedBFrom = vec2(\n    bPoint.x*aDir.x + bPoint.y*aDir.y,\n    bPoint.y*aDir.x - bPoint.x*aDir.y\n  );\n  vec2 bTo = bPoint + bDir;\n  vec2 rotatedBTo = vec2(\n    bTo.x*aDir.x + bTo.y*aDir.y,\n    bTo.y*aDir.x - bTo.x*aDir.y\n  );\n  float intersectionDistance =\n    rotatedBTo.x + (rotatedBFrom.x - rotatedBTo.x) * rotatedBTo.y /\n    (rotatedBTo.y - rotatedBFrom.y);\n  return aPoint + aDir * intersectionDistance;\n}\n\nvoid main() {\n  // Caps have one of either the in or out tangent set to 0\n  vCap = (aTangentIn == vec3(0.)) != (aTangentOut == (vec3(0.)))\n    ? 1. : 0.;\n\n  // Joins have two unique, defined tangents\n  vJoin = (\n    aTangentIn != vec3(0.) &&\n    aTangentOut != vec3(0.) &&\n    aTangentIn != aTangentOut\n  ) ? 1. : 0.;\n\n  vec4 posp = uModelViewMatrix * aPosition;\n  vec4 posqIn = uModelViewMatrix * (aPosition + vec4(aTangentIn, 0));\n  vec4 posqOut = uModelViewMatrix * (aPosition + vec4(aTangentOut, 0));\n\n  float facingCamera = pow(\n    // The word space tangent's z value is 0 if it's facing the camera\n    abs(normalize(posqIn-posp).z),\n\n    // Using pow() here to ramp `facingCamera` up from 0 to 1 really quickly\n    // so most lines get scaled and don't get clipped\n    0.25\n  );\n\n  // using a scale <1 moves the lines towards the camera\n  // in order to prevent popping effects due to half of\n  // the line disappearing behind the geometry faces.\n  float scale = mix(1., 0.995, facingCamera);\n\n  // Moving vertices slightly toward the camera\n  // to avoid depth-fighting with the fill triangles.\n  // Discussed here:\n  // http://www.opengl.org/discussion_boards/ubbthreads.php?ubb=showflat&Number=252848  \n  posp.xyz = posp.xyz * scale;\n  posqIn.xyz = posqIn.xyz * scale;\n  posqOut.xyz = posqOut.xyz * scale;\n\n  vec4 p = uProjectionMatrix * posp;\n  vec4 qIn = uProjectionMatrix * posqIn;\n  vec4 qOut = uProjectionMatrix * posqOut;\n  vCenter = p.xy;\n\n  // formula to convert from clip space (range -1..1) to screen space (range 0..[width or height])\n  // screen_p = (p.xy/p.w + <1,1>) * 0.5 * uViewport.zw\n\n  // prevent division by W by transforming the tangent formula (div by 0 causes\n  // the line to disappear, see https://github.com/processing/processing/issues/5183)\n  // t = screen_q - screen_p\n  //\n  // tangent is normalized and we don't care which aDirection it points to (+-)\n  // t = +- normalize( screen_q - screen_p )\n  // t = +- normalize( (q.xy/q.w+<1,1>)*0.5*uViewport.zw - (p.xy/p.w+<1,1>)*0.5*uViewport.zw )\n  //\n  // extract common factor, <1,1> - <1,1> cancels out\n  // t = +- normalize( (q.xy/q.w - p.xy/p.w) * 0.5 * uViewport.zw )\n  //\n  // convert to common divisor\n  // t = +- normalize( ((q.xy*p.w - p.xy*q.w) / (p.w*q.w)) * 0.5 * uViewport.zw )\n  //\n  // remove the common scalar divisor/factor, not needed due to normalize and +-\n  // (keep uViewport - can't remove because it has different components for x and y\n  //  and corrects for aspect ratio, see https://github.com/processing/processing/issues/5181)\n  // t = +- normalize( (q.xy*p.w - p.xy*q.w) * uViewport.zw )\n\n  vec2 tangentIn = normalize((qIn.xy*p.w - p.xy*qIn.w) * uViewport.zw);\n  vec2 tangentOut = normalize((qOut.xy*p.w - p.xy*qOut.w) * uViewport.zw);\n\n  vec2 curPerspScale;\n  if(uPerspective == 1) {\n    // Perspective ---\n    // convert from world to clip by multiplying with projection scaling factor\n    // to get the right thickness (see https://github.com/processing/processing/issues/5182)\n\n    // The y value of the projection matrix may be flipped if rendering to a Framebuffer.\n    // Multiplying again by its sign here negates the flip to get just the scale.\n    curPerspScale = (uProjectionMatrix * vec4(1, sign(uProjectionMatrix[1][1]), 0, 0)).xy;\n  } else {\n    // No Perspective ---\n    // multiply by W (to cancel out division by W later in the pipeline) and\n    // convert from screen to clip (derived from clip to screen above)\n    curPerspScale = p.w / (0.5 * uViewport.zw);\n  }\n\n  vec2 offset;\n  if (vJoin == 1.) {\n    vTangent = normalize(tangentIn + tangentOut);\n    vec2 normalIn = vec2(-tangentIn.y, tangentIn.x);\n    vec2 normalOut = vec2(-tangentOut.y, tangentOut.x);\n    float side = sign(aSide);\n    float sideEnum = abs(aSide);\n\n    // We generate vertices for joins on either side of the centerline, but\n    // the \"elbow\" side is the only one needing a join. By not setting the\n    // offset for the other side, all its vertices will end up in the same\n    // spot and not render, effectively discarding it.\n    if (sign(dot(tangentOut, vec2(-tangentIn.y, tangentIn.x))) != side) {\n      // Side enums:\n      //   1: the side going into the join\n      //   2: the middle of the join\n      //   3: the side going out of the join\n      if (sideEnum == 2.) {\n        // Calculate the position + tangent on either side of the join, and\n        // find where the lines intersect to find the elbow of the join\n        vec2 c = (posp.xy/posp.w + vec2(1.,1.)) * 0.5 * uViewport.zw;\n        vec2 intersection = lineIntersection(\n          c + (side * normalIn * uStrokeWeight / 2.),\n          tangentIn,\n          c + (side * normalOut * uStrokeWeight / 2.),\n          tangentOut\n        );\n        offset = (intersection - c);\n\n        // When lines are thick and the angle of the join approaches 180, the\n        // elbow might be really far from the center. We'll apply a limit to\n        // the magnitude to avoid lines going across the whole screen when this\n        // happens.\n        float mag = length(offset);\n        float maxMag = 3. * uStrokeWeight;\n        if (mag > maxMag) {\n          offset *= maxMag / mag;\n        }\n      } else if (sideEnum == 1.) {\n        offset = side * normalIn * uStrokeWeight / 2.;\n      } else if (sideEnum == 3.) {\n        offset = side * normalOut * uStrokeWeight / 2.;\n      }\n    }\n    if (uStrokeJoin == STROKE_JOIN_BEVEL) {\n      vec2 avgNormal = vec2(-vTangent.y, vTangent.x);\n      vMaxDist = abs(dot(avgNormal, normalIn * uStrokeWeight / 2.));\n    } else {\n      vMaxDist = uStrokeWeight / 2.;\n    }\n  } else {\n    vec2 tangent = aTangentIn == vec3(0.) ? tangentOut : tangentIn;\n    vTangent = tangent;\n    vec2 normal = vec2(-tangent.y, tangent.x);\n\n    float normalOffset = sign(aSide);\n    // Caps will have side values of -2 or 2 on the edge of the cap that\n    // extends out from the line\n    float tangentOffset = abs(aSide) - 1.;\n    offset = (normal * normalOffset + tangent * tangentOffset) *\n      uStrokeWeight * 0.5;\n    vMaxDist = uStrokeWeight / 2.;\n  }\n  vPosition = vCenter + offset;\n\n  gl_Position.xy = p.xy + offset.xy * curPerspScale;\n  gl_Position.zw = p.zw;\n  \n  vColor = (uUseLineColor ? aVertexColor : uMaterialColor);\n}\n",
                    lineFrag: T + "precision mediump int;\n\nuniform vec4 uMaterialColor;\nuniform int uStrokeCap;\nuniform int uStrokeJoin;\nuniform float uStrokeWeight;\n\nIN vec4 vColor;\nIN vec2 vTangent;\nIN vec2 vCenter;\nIN vec2 vPosition;\nIN float vMaxDist;\nIN float vCap;\nIN float vJoin;\n\nfloat distSquared(vec2 a, vec2 b) {\n  vec2 aToB = b - a;\n  return dot(aToB, aToB);\n}\n\nvoid main() {\n  if (vCap > 0.) {\n    if (\n      uStrokeCap == STROKE_CAP_ROUND &&\n      distSquared(vPosition, vCenter) > uStrokeWeight * uStrokeWeight * 0.25\n    ) {\n      discard;\n    } else if (\n      uStrokeCap == STROKE_CAP_SQUARE &&\n      dot(vPosition - vCenter, vTangent) > 0.\n    ) {\n      discard;\n    }\n    // Use full area for PROJECT\n  } else if (vJoin > 0.) {\n    if (\n      uStrokeJoin == STROKE_JOIN_ROUND &&\n      distSquared(vPosition, vCenter) > uStrokeWeight * uStrokeWeight * 0.25\n    ) {\n      discard;\n    } else if (uStrokeJoin == STROKE_JOIN_BEVEL) {\n      vec2 normal = vec2(-vTangent.y, vTangent.x);\n      if (abs(dot(vPosition - vCenter, normal)) > vMaxDist) {\n        discard;\n      }\n    }\n    // Use full area for MITER\n  }\n  OUT_COLOR = vec4(vColor.rgb, 1.) * vColor.a;\n}\n",
                    pointVert: "IN vec3 aPosition;\nuniform float uPointSize;\nOUT float vStrokeWeight;\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nvoid main() {\n	vec4 positionVec4 =  vec4(aPosition, 1.0);\n	gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n	gl_PointSize = uPointSize;\n	vStrokeWeight = uPointSize;\n}\n",
                    pointFrag: "precision mediump int;\nuniform vec4 uMaterialColor;\nIN float vStrokeWeight;\n\nvoid main(){\n  float mask = 0.0;\n\n  // make a circular mask using the gl_PointCoord (goes from 0 - 1 on a point)\n  // might be able to get a nicer edge on big strokeweights with smoothstep but slightly less performant\n\n  mask = step(0.98, length(gl_PointCoord * 2.0 - 1.0));\n\n  // if strokeWeight is 1 or less lets just draw a square\n  // this prevents weird artifacting from carving circles when our points are really small\n  // if strokeWeight is larger than 1, we just use it as is\n\n  mask = mix(0.0, mask, clamp(floor(vStrokeWeight - 0.5),0.0,1.0));\n\n  // throw away the borders of the mask\n  // otherwise we get weird alpha blending issues\n\n  if(mask > 0.98){\n    discard;\n  }\n\n  OUT_COLOR = vec4(uMaterialColor.rgb, 1.) * uMaterialColor.a;\n}\n",
                    imageLightVert: "precision highp float;\nattribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\n\nvarying vec3 localPos;\nvarying vec3 vWorldNormal;\nvarying vec3 vWorldPosition;\nvarying vec2 vTexCoord;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform mat3 uNormalMatrix;\n\nvoid main() {\n  // Multiply the position by the matrix.\n  vec4 viewModelPosition = uModelViewMatrix * vec4(aPosition, 1.0);\n  gl_Position = uProjectionMatrix * viewModelPosition;  \n  \n  // orient the normals and pass to the fragment shader\n  vWorldNormal = uNormalMatrix * aNormal;\n  \n  // send the view position to the fragment shader\n  vWorldPosition = (uModelViewMatrix * vec4(aPosition, 1.0)).xyz;\n  \n  localPos = vWorldPosition;\n  vTexCoord = aTexCoord;\n}\n\n\n/*\nin the vertex shader we'll compute the world position and world oriented normal of the vertices and pass those to the fragment shader as varyings.\n*/\n",
                    imageLightDiffusedFrag: "precision highp float;\nvarying vec3 localPos;\n\n// the HDR cubemap converted (can be from an equirectangular environment map.)\nuniform sampler2D environmentMap;\nvarying vec2 vTexCoord;\n\nconst float PI = 3.14159265359;\n\nvec2 nTOE( vec3 v ){\n  // x = r sin(phi) cos(theta)   \n  // y = r cos(phi)  \n  // z = r sin(phi) sin(theta)\n  float phi = acos( v.y );\n  // if phi is 0, then there are no x, z components\n  float theta = 0.0;\n  // else \n  theta = acos(v.x / sin(phi));\n  float sinTheta = v.z / sin(phi);\n  if (sinTheta < 0.0) {\n    // Turn it into -theta, but in the 0-2PI range\n    theta = 2.0 * PI - theta;\n  }\n  theta = theta / (2.0 * 3.14159);\n  phi = phi / 3.14159 ;\n  \n  vec2 angles = vec2( phi, theta );\n  return angles;\n}\n\nvoid main()\n{   	 \n	// the sample direction equals the hemisphere's orientation\n  float phi = vTexCoord.x * 2.0 * PI;\n  float theta = vTexCoord.y * PI;\n  float x = sin(theta) * cos(phi);\n  float y = sin(theta) * sin(phi);\n  float z = cos(theta);\n  vec3 normal = vec3( x, y, z);\n\n	// Discretely sampling the hemisphere given the integral's\n  // spherical coordinates translates to the following fragment code:\n	vec3 irradiance = vec3(0.0);  \n	vec3 up	= vec3(0.0, 1.0, 0.0);\n	vec3 right = normalize(cross(up, normal));\n	up = normalize(cross(normal, right));\n\n	//  We specify a fixed sampleDelta delta value to traverse\n  // the hemisphere; decreasing or increasing the sample delta\n  // will increase or decrease the accuracy respectively.\n	const float sampleDelta = 0.025;\n	float nrSamples = 0.0;\n  \n	for(float phi = 0.0; phi < 2.0 * PI; phi += sampleDelta)\n	{\n    for(float theta = 0.0; theta < ( 0.5 ) * PI; theta += sampleDelta)\n    {\n      // spherical to cartesian (in tangent space) // tangent space to world // add each sample result to irradiance\n      float x = sin(theta) * cos(phi);\n      float y = sin(theta) * sin(phi);\n      float z = cos(theta);\n      vec3 tangentSample = vec3( x, y, z);\n      \n      vec3 sampleVec = tangentSample.x * right + tangentSample.y * up + tangentSample.z * normal;\n        irradiance += (texture2D(environmentMap, nTOE(sampleVec)).xyz) * cos(theta) * sin(theta);\n      nrSamples++;\n    }\n	}\n	// divide by the total number of samples taken, giving us the average sampled irradiance.\n	irradiance = PI * irradiance * (1.0 / float(nrSamples )) ;\n  \n \n	gl_FragColor = vec4(irradiance, 1.0);\n}",
                    imageLightSpecularFrag: "precision highp float;\r\nvarying vec3 localPos;\r\nvarying vec2 vTexCoord;\r\n\r\n// our texture\r\nuniform sampler2D environmentMap;\r\nuniform float roughness;\r\n\r\nconst float PI = 3.14159265359;\r\n\r\nfloat VanDerCorput(int bits);\r\nvec2 HammersleyNoBitOps(int i, int N);\r\nvec3 ImportanceSampleGGX(vec2 Xi, vec3 N, float roughness);\r\n\r\n\r\nvec2 nTOE( vec3 v ){\r\n  // x = r sin(phi) cos(theta)   \r\n  // y = r cos(phi)  \r\n  // z = r sin(phi) sin(theta)\r\n  float phi = acos( v.y );\r\n  // if phi is 0, then there are no x, z components\r\n  float theta = 0.0;\r\n  // else \r\n  theta = acos(v.x / sin(phi));\r\n  float sinTheta = v.z / sin(phi);\r\n  if (sinTheta < 0.0) {\r\n    // Turn it into -theta, but in the 0-2PI range\r\n    theta = 2.0 * PI - theta;\r\n  }\r\n  theta = theta / (2.0 * 3.14159);\r\n  phi = phi / 3.14159 ;\r\n  \r\n  vec2 angles = vec2( phi, theta );\r\n  return angles;\r\n}\r\n\r\n\r\nvoid main(){\r\n  const int SAMPLE_COUNT = 1024; // 4096\r\n  float totalWeight = 0.0;\r\n  vec3 prefilteredColor = vec3(0.0);\r\n  float phi = vTexCoord.x * 2.0 * PI;\r\n  float theta = vTexCoord.y * PI;\r\n  float x = sin(theta) * cos(phi);\r\n  float y = sin(theta) * sin(phi);\r\n  float z = cos(theta);\r\n  vec3 N = vec3(x,y,z);\r\n  vec3 V = N;\r\n  for (int i = 0; i < SAMPLE_COUNT; ++i)\r\n  {\r\n    vec2 Xi = HammersleyNoBitOps(i, SAMPLE_COUNT);\r\n    vec3 H = ImportanceSampleGGX(Xi, N, roughness);\r\n    vec3 L = normalize(2.0 * dot(V, H) * H - V);\r\n\r\n    float NdotL = max(dot(N, L), 0.0);\r\n    if (NdotL > 0.0)\r\n    {\r\n      prefilteredColor += texture2D(environmentMap, nTOE(L)).xyz * NdotL;\r\n      totalWeight += NdotL;\r\n    }\r\n  }\r\n  prefilteredColor = prefilteredColor / totalWeight;\r\n\r\n  gl_FragColor = vec4(prefilteredColor, 1.0);\r\n}\r\n\r\nvec3 ImportanceSampleGGX(vec2 Xi, vec3 N, float roughness){\r\n  float a = roughness * roughness;\r\n\r\n  float phi = 2.0 * PI * Xi.x;\r\n  float cosTheta = sqrt((1.0 - Xi.y) / (1.0 + (a * a - 1.0) * Xi.y));\r\n  float sinTheta = sqrt(1.0 - cosTheta * cosTheta);\r\n  // from spherical coordinates to cartesian coordinates\r\n  vec3 H;\r\n  H.x = cos(phi) * sinTheta;\r\n  H.y = sin(phi) * sinTheta;\r\n  H.z = cosTheta;\r\n\r\n  // from tangent-space vector to world-space sample vector\r\n  vec3 up = abs(N.z) < 0.999 ? vec3(0.0, 0.0, 1.0) : vec3(1.0, 0.0, 0.0);\r\n  vec3 tangent = normalize(cross(up, N));\r\n  vec3 bitangent = cross(N, tangent);\r\n\r\n  vec3 sampleVec = tangent * H.x + bitangent * H.y + N * H.z;\r\n  return normalize(sampleVec);\r\n}\r\n\r\n\r\nfloat VanDerCorput(int n, int base)\r\n{\r\n  float invBase = 1.0 / float(base);\r\n  float denom = 1.0;\r\n  float result = 0.0;\r\n\r\n  for (int i = 0; i < 32; ++i)\r\n  {\r\n	if (n > 0)\r\n	{\r\n  	denom = mod(float(n), 2.0);\r\n  	result += denom * invBase;\r\n  	invBase = invBase / 2.0;\r\n  	n = int(float(n) / 2.0);\r\n	}\r\n  }\r\n\r\n  return result;\r\n}\r\n\r\nvec2 HammersleyNoBitOps(int i, int N)\r\n{\r\n  return vec2(float(i) / float(N), VanDerCorput(i, 2));\r\n}\r\n"
                };
                for(x in M)M[x] = "#ifdef WEBGL2\n\n#define IN in\n#define OUT out\n\n#ifdef FRAGMENT_SHADER\nout vec4 outColor;\n#define OUT_COLOR outColor\n#endif\n#define TEXTURE texture\n\n#else\n\n#ifdef FRAGMENT_SHADER\n#define IN varying\n#else\n#define IN attribute\n#endif\n#define OUT varying\n#define TEXTURE texture2D\n\n#ifdef FRAGMENT_SHADER\n#define OUT_COLOR gl_FragColor\n#endif\n\n#endif\n" + M[x];
                j(e1 = {}, l.GRAY, "precision highp float;\n\nvarying vec2 vTexCoord;\n\nuniform sampler2D tex0;\n\nfloat luma(vec3 color) {\n  // weighted grayscale with luminance values\n  return dot(color, vec3(0.2126, 0.7152, 0.0722));\n}\n\nvoid main() {\n  vec4 tex = texture2D(tex0, vTexCoord);\n  float gray = luma(tex.rgb);\n  gl_FragColor = vec4(gray, gray, gray, tex.a);\n}\n"), j(e1, l.ERODE, "// Reduces the bright areas in an image\n\nprecision highp float;\n\nvarying vec2 vTexCoord;\n\nuniform sampler2D tex0;\nuniform vec2 texelSize;\n\nfloat luma(vec3 color) {\n  // weighted grayscale with luminance values\n  // weights 77, 151, 28 taken from src/image/filters.js\n  return dot(color, vec3(0.300781, 0.589844, 0.109375));\n}\n\nvoid main() {\n  vec4 color = texture2D(tex0, vTexCoord);\n  float lum = luma(color.rgb);\n\n  // set current color as the darkest neighbor color\n\n  vec4 neighbors[4];\n  neighbors[0] = texture2D(tex0, vTexCoord + vec2( texelSize.x, 0.0));\n  neighbors[1] = texture2D(tex0, vTexCoord + vec2(-texelSize.x, 0.0));\n  neighbors[2] = texture2D(tex0, vTexCoord + vec2(0.0,  texelSize.y));\n  neighbors[3] = texture2D(tex0, vTexCoord + vec2(0.0, -texelSize.y));\n\n  for (int i = 0; i < 4; i++) {\n    vec4 neighborColor = neighbors[i];\n    float neighborLum = luma(neighborColor.rgb);\n\n    if (neighborLum < lum) {\n      color = neighborColor;\n      lum = neighborLum;\n    }\n  }\n\n  gl_FragColor = color;\n}\n"), j(e1, l.DILATE, "// Increase the bright areas in an image\n\nprecision highp float;\n\nvarying vec2 vTexCoord;\n\nuniform sampler2D tex0;\nuniform vec2 texelSize;\n\nfloat luma(vec3 color) {\n  // weighted grayscale with luminance values\n  // weights 77, 151, 28 taken from src/image/filters.js\n  return dot(color, vec3(0.300781, 0.589844, 0.109375));\n}\n\nvoid main() {\n  vec4 color = texture2D(tex0, vTexCoord);\n  float lum = luma(color.rgb);\n\n  // set current color as the brightest neighbor color\n\n  vec4 neighbors[4];\n  neighbors[0] = texture2D(tex0, vTexCoord + vec2( texelSize.x, 0.0));\n  neighbors[1] = texture2D(tex0, vTexCoord + vec2(-texelSize.x, 0.0));\n  neighbors[2] = texture2D(tex0, vTexCoord + vec2(0.0,  texelSize.y));\n  neighbors[3] = texture2D(tex0, vTexCoord + vec2(0.0, -texelSize.y));\n\n  for (int i = 0; i < 4; i++) {\n    vec4 neighborColor = neighbors[i];\n    float neighborLum = luma(neighborColor.rgb);\n\n    if (neighborLum > lum) {\n      color = neighborColor;\n      lum = neighborLum;\n    }\n  }\n\n  gl_FragColor = color;\n}\n"), j(e1, l.BLUR, "precision highp float;\n\n// Two-pass blur filter, unweighted kernel.\n// See also a similar blur at Adam Ferriss' repo of shader examples:\n// https://github.com/aferriss/p5jsShaderExamples/blob/gh-pages/4_image-effects/4-9_single-pass-blur/effect.frag\n\n\nuniform sampler2D tex0;\nvarying vec2 vTexCoord;\nuniform vec2 direction;\nuniform vec2 canvasSize;\nuniform float radius;\n\nfloat random(vec2 p) {\n  vec3 p3  = fract(vec3(p.xyx) * .1031);\n  p3 += dot(p3, p3.yzx + 33.33);\n  return fract((p3.x + p3.y) * p3.z);\n}\n\n// This isn't a real Gaussian weight, it's a quadratic weight. It's what the\n// CPU mode's blur uses though, so we also use it here to match.\nfloat quadWeight(float x, float e) {\n  return pow(e-abs(x), 2.);\n}\n\nvoid main(){\n  vec2 uv = vTexCoord;\n\n  // A reasonable maximum number of samples\n  const float maxSamples = 64.0;\n\n  float numSamples = floor(7. * radius);\n  if (fract(numSamples / 2.) == 0.) {\n    numSamples++;\n  }\n  vec4 avg = vec4(0.0);\n  float total = 0.0;\n\n  // Calculate the spacing to avoid skewing if numSamples > maxSamples\n  float spacing = 1.0;\n  if (numSamples > maxSamples) {\n    spacing = numSamples / maxSamples;\n    numSamples = maxSamples;\n  }\n\n  float randomOffset = (spacing - 1.0) * mix(-0.5, 0.5, random(gl_FragCoord.xy));\n  for (float i = 0.0; i < maxSamples; i++) {\n    if (i >= numSamples) break;\n\n    float sample = i * spacing - (numSamples - 1.0) * 0.5 * spacing + randomOffset;\n    vec2 sampleCoord = uv + vec2(sample, sample) / canvasSize * direction;\n    float weight = quadWeight(sample, (numSamples - 1.0) * 0.5 * spacing);\n\n    avg += weight * texture2D(tex0, sampleCoord);\n    total += weight;\n  }\n\n  avg /= total;\n  gl_FragColor = avg;\n}\n"), j(e1, l.POSTERIZE, "// Limit color space for a stylized cartoon / poster effect\n\nprecision highp float;\n\nvarying vec2 vTexCoord;\n\nuniform sampler2D tex0;\nuniform float filterParameter;\n\nvec3 quantize(vec3 color, float n) {\n  // restrict values to N options/bins\n  // and floor each channel to nearest value\n  //\n  // eg. when N = 5, values = 0.0, 0.25, 0.50, 0.75, 1.0\n  // then quantize (0.1, 0.7, 0.9) -> (0.0, 0.5, 1.0)\n\n  color = color * n;\n  color = floor(color);\n  color = color / (n - 1.0);\n  return color;\n}\n\nvoid main() {\n  vec4 color = texture2D(tex0, vTexCoord);\n\n  vec3 restrictedColor = quantize(color.rgb / color.a, filterParameter);\n\n  gl_FragColor = vec4(restrictedColor.rgb * color.a, color.a);\n}\n"), j(e1, l.OPAQUE, "// Set alpha channel to entirely opaque\n\nprecision highp float;\n\nvarying vec2 vTexCoord;\n\nuniform sampler2D tex0;\n\nvoid main() {\n  vec4 color = texture2D(tex0, vTexCoord);\n  gl_FragColor = vec4(color.rgb / color.a, 1.0);\n}\n"), j(e1, l.INVERT, "// Set each pixel to inverse value\n// Note that original INVERT does not change the opacity, so this follows suit\n\nprecision highp float;\n\nvarying vec2 vTexCoord;\n\nuniform sampler2D tex0;\n\nvoid main() {\nvec4 color = texture2D(tex0, vTexCoord);\nvec3 origColor = color.rgb / color.a;\nvec3 invertedColor = vec3(1.0) - origColor;\ngl_FragColor = vec4(invertedColor * color.a, color.a);\n}\n"), j(e1, l.THRESHOLD, "// Convert pixels to either white or black, \n// depending on if their luma is above or below filterParameter\n\nprecision highp float;\n\nvarying vec2 vTexCoord;\n\nuniform sampler2D tex0;\nuniform float filterParameter;\n\nfloat luma(vec3 color) {\n  // weighted grayscale with luminance values\n  return dot(color, vec3(0.2126, 0.7152, 0.0722));\n}\n\nvoid main() {\n  vec4 color = texture2D(tex0, vTexCoord);\n  float gray = luma(color.rgb / color.a);\n  // floor() used to match src/image/filters.js\n  float threshold = floor(filterParameter * 255.0) / 255.0;\n  float blackOrWhite = step(threshold, gray);\n  gl_FragColor = vec4(vec3(blackOrWhite) * color.a, color.a);\n}\n");
                var E = e1;
                function k(e1, t, r, o, n, s, i, a, l, u) {
                    var c = t.getParameter(t.FRAMEBUFFER_BINDING), r = (t.bindFramebuffer(t.FRAMEBUFFER, r), a === t.RGBA ? 4 : 3), d = s * i * r, h = l === t.UNSIGNED_BYTE ? Uint8Array : Float32Array;
                    if (e1 instanceof h && e1.length === d || (e1 = new h(d)), t.readPixels(o, u ? u - n - i : n, s, i, a, l, e1), t.bindFramebuffer(t.FRAMEBUFFER, c), u) for(var f = Math.floor(i / 2), p = new h(s * r), m = 0; m < f; m++){
                        var y = m * s * 4, g = (i - m - 1) * s * 4;
                        p.set(e1.subarray(y, y + 4 * s)), e1.copyWithin(y, g, g + 4 * s), e1.set(p, g);
                    }
                    return e1;
                }
                function C(e1, t, r, o, n, s, i) {
                    var a = e1.getParameter(e1.FRAMEBUFFER_BINDING), t = (e1.bindFramebuffer(e1.FRAMEBUFFER, t), n === e1.RGBA ? 4 : 3), t = new (s === e1.UNSIGNED_BYTE ? Uint8Array : Float32Array)(t);
                    return e1.readPixels(r, i ? i - o - 1 : o, 1, 1, n, s, t), e1.bindFramebuffer(e1.FRAMEBUFFER, a), Array.from(t);
                }
                g.default.prototype.setAttributes = function(e1, t) {
                    if (void 0 === this._glAttributes) console.log("You are trying to use setAttributes on a p5.Graphics object that does not use a WEBGL renderer.");
                    else {
                        var r = !0;
                        if (void 0 !== t ? (null === this._glAttributes && (this._glAttributes = {}), this._glAttributes[e1] !== t && (this._glAttributes[e1] = t, r = !1)) : e1 instanceof Object && this._glAttributes !== e1 && (this._glAttributes = e1, r = !1), this._renderer.isP3D && !r) {
                            if (!this._setupDone) {
                                for(var o in this._renderer.retainedMode.geometry)if (this._renderer.retainedMode.geometry.hasOwnProperty(o)) return void g.default._friendlyError("Sorry, Could not set the attributes, you need to call setAttributes() before calling the other drawing methods in setup()");
                            }
                            this.push(), this._renderer._resetContext(), this.pop(), this._renderer._curCamera && (this._renderer._curCamera._renderer = this._renderer);
                        }
                    }
                }, g.default.RendererGL = function(e1) {
                    var t = s;
                    if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e1 && e1.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e1 && m(t, e1);
                    var r, n = y(s);
                    function s(e1, t, r, o) {
                        if (this instanceof s) return (e1 = n.call(this, e1, t, r))._setAttributeDefaults(t), e1._initContext(), e1.isP3D = !0, e1.geometryBuilder = void 0, e1.GL = e1.drawingContext, e1._pInst._setProperty("drawingContext", e1.drawingContext), e1._isErasing = !1, e1._clipDepths = [], e1._isClipApplied = !1, e1._stencilTestOn = !1, e1._enableLighting = !1, e1.ambientLightColors = [], e1.specularColors = [
                            1,
                            1,
                            1
                        ], e1.directionalLightDirections = [], e1.directionalLightDiffuseColors = [], e1.directionalLightSpecularColors = [], e1.pointLightPositions = [], e1.pointLightDiffuseColors = [], e1.pointLightSpecularColors = [], e1.spotLightPositions = [], e1.spotLightDirections = [], e1.spotLightDiffuseColors = [], e1.spotLightSpecularColors = [], e1.spotLightAngle = [], e1.spotLightConc = [], e1.activeImageLight = null, e1.diffusedTextures = new Map, e1.specularTextures = new Map, e1.drawMode = l.FILL, e1.curFillColor = e1._cachedFillStyle = [
                            1,
                            1,
                            1,
                            1
                        ], e1.curAmbientColor = e1._cachedFillStyle = [
                            1,
                            1,
                            1,
                            1
                        ], e1.curSpecularColor = e1._cachedFillStyle = [
                            0,
                            0,
                            0,
                            0
                        ], e1.curEmissiveColor = e1._cachedFillStyle = [
                            0,
                            0,
                            0,
                            0
                        ], e1.curStrokeColor = e1._cachedStrokeStyle = [
                            0,
                            0,
                            0,
                            1
                        ], e1.curBlendMode = l.BLEND, e1._cachedBlendMode = void 0, e1.webglVersion === l.WEBGL2 ? e1.blendExt = e1.GL : e1.blendExt = e1.GL.getExtension("EXT_blend_minmax"), e1._isBlending = !1, e1._hasSetAmbient = !1, e1._useSpecularMaterial = !1, e1._useEmissiveMaterial = !1, e1._useNormalMaterial = !1, e1._useShininess = 1, e1._useLineColor = !1, e1._useVertexColor = !1, e1.registerEnabled = new Set, e1._tint = [
                            255,
                            255,
                            255,
                            255
                        ], e1.constantAttenuation = 1, e1.linearAttenuation = 0, e1.quadraticAttenuation = 0, e1.uMVMatrix = new g.default.Matrix, e1.uPMatrix = new g.default.Matrix, e1.uNMatrix = new g.default.Matrix("mat3"), e1._currentNormal = new g.default.Vector(0, 0, 1), e1._curCamera = new g.default.Camera(v(e1)), e1._curCamera._computeCameraDefaultSettings(), e1._curCamera._setDefaultCamera(), e1.filterCamera = new g.default.Camera(v(e1)), e1.filterCamera._computeCameraDefaultSettings(), e1.filterCamera._setDefaultCamera(), e1.prevTouches = [], e1.zoomVelocity = 0, e1.rotateVelocity = new g.default.Vector(0, 0), e1.moveVelocity = new g.default.Vector(0, 0), e1.executeZoom = !1, e1.executeRotateAndMove = !1, e1._defaultLightShader = void 0, e1._defaultImmediateModeShader = void 0, e1._defaultNormalShader = void 0, e1._defaultColorShader = void 0, e1._defaultPointShader = void 0, e1.userFillShader = void 0, e1.userStrokeShader = void 0, e1.userPointShader = void 0, e1.retainedMode = {
                            geometry: {},
                            buffers: {
                                stroke: [
                                    new g.default.RenderBuffer(4, "lineVertexColors", "lineColorBuffer", "aVertexColor", v(e1)),
                                    new g.default.RenderBuffer(3, "lineVertices", "lineVerticesBuffer", "aPosition", v(e1)),
                                    new g.default.RenderBuffer(3, "lineTangentsIn", "lineTangentsInBuffer", "aTangentIn", v(e1)),
                                    new g.default.RenderBuffer(3, "lineTangentsOut", "lineTangentsOutBuffer", "aTangentOut", v(e1)),
                                    new g.default.RenderBuffer(1, "lineSides", "lineSidesBuffer", "aSide", v(e1))
                                ],
                                fill: [
                                    new g.default.RenderBuffer(3, "vertices", "vertexBuffer", "aPosition", v(e1), e1._vToNArray),
                                    new g.default.RenderBuffer(3, "vertexNormals", "normalBuffer", "aNormal", v(e1), e1._vToNArray),
                                    new g.default.RenderBuffer(4, "vertexColors", "colorBuffer", "aVertexColor", v(e1)),
                                    new g.default.RenderBuffer(3, "vertexAmbients", "ambientBuffer", "aAmbientColor", v(e1)),
                                    new g.default.RenderBuffer(2, "uvs", "uvBuffer", "aTexCoord", v(e1), e1._flatten)
                                ],
                                text: [
                                    new g.default.RenderBuffer(3, "vertices", "vertexBuffer", "aPosition", v(e1), e1._vToNArray),
                                    new g.default.RenderBuffer(2, "uvs", "uvBuffer", "aTexCoord", v(e1), e1._flatten)
                                ]
                            }
                        }, e1.immediateMode = {
                            geometry: new g.default.Geometry,
                            shapeMode: l.TRIANGLE_FAN,
                            contourIndices: [],
                            _bezierVertex: [],
                            _quadraticVertex: [],
                            _curveVertex: [],
                            buffers: {
                                fill: [
                                    new g.default.RenderBuffer(3, "vertices", "vertexBuffer", "aPosition", v(e1), e1._vToNArray),
                                    new g.default.RenderBuffer(3, "vertexNormals", "normalBuffer", "aNormal", v(e1), e1._vToNArray),
                                    new g.default.RenderBuffer(4, "vertexColors", "colorBuffer", "aVertexColor", v(e1)),
                                    new g.default.RenderBuffer(3, "vertexAmbients", "ambientBuffer", "aAmbientColor", v(e1)),
                                    new g.default.RenderBuffer(2, "uvs", "uvBuffer", "aTexCoord", v(e1), e1._flatten)
                                ],
                                stroke: [
                                    new g.default.RenderBuffer(4, "lineVertexColors", "lineColorBuffer", "aVertexColor", v(e1)),
                                    new g.default.RenderBuffer(3, "lineVertices", "lineVerticesBuffer", "aPosition", v(e1)),
                                    new g.default.RenderBuffer(3, "lineTangentsIn", "lineTangentsInBuffer", "aTangentIn", v(e1)),
                                    new g.default.RenderBuffer(3, "lineTangentsOut", "lineTangentsOutBuffer", "aTangentOut", v(e1)),
                                    new g.default.RenderBuffer(1, "lineSides", "lineSidesBuffer", "aSide", v(e1))
                                ],
                                point: e1.GL.createBuffer()
                            }
                        }, e1.pointSize = 5, e1.curStrokeWeight = 1, e1.curStrokeCap = l.ROUND, e1.curStrokeJoin = l.ROUND, e1.textures = new Map, e1.framebuffers = new Set, e1.activeFramebuffers = [], e1.filterShader = void 0, e1.filterLayer = void 0, e1.filterLayerTemp = void 0, e1.defaultFilterShaders = {}, e1.textureMode = l.IMAGE, e1.textureWrapX = l.CLAMP, e1.textureWrapY = l.CLAMP, e1._tex = null, e1._curveTightness = 6, e1._lookUpTableBezier = [], e1._lookUpTableQuadratic = [], e1._lutBezierDetail = 0, e1._lutQuadraticDetail = 0, e1.isProcessingVertices = !1, e1._tessy = e1._initTessy(), e1.fontInfos = {}, e1._curShader = void 0, e1;
                        throw new TypeError("Cannot call a class as a function");
                    }
                    return t = s, e1 = [
                        {
                            key: "beginGeometry",
                            value: function() {
                                if (this.geometryBuilder) throw new Error("It looks like `beginGeometry()` is being called while another p5.Geometry is already being build.");
                                this.geometryBuilder = new a.default(this);
                            }
                        },
                        {
                            key: "endGeometry",
                            value: function() {
                                var e1;
                                if (this.geometryBuilder) return e1 = this.geometryBuilder.finish(), this.geometryBuilder = void 0, e1;
                                throw new Error("Make sure you call beginGeometry() before endGeometry()!");
                            }
                        },
                        {
                            key: "buildGeometry",
                            value: function(e1) {
                                return this.beginGeometry(), e1(), this.endGeometry();
                            }
                        },
                        {
                            key: "_setAttributeDefaults",
                            value: function(e1) {
                                var t = {
                                    alpha: !0,
                                    depth: !0,
                                    stencil: !0,
                                    antialias: navigator.userAgent.toLowerCase().includes("safari"),
                                    premultipliedAlpha: !0,
                                    preserveDrawingBuffer: !0,
                                    perPixelLighting: !0,
                                    version: 2
                                };
                                null === e1._glAttributes ? e1._glAttributes = t : e1._glAttributes = Object.assign(t, e1._glAttributes);
                            }
                        },
                        {
                            key: "_initContext",
                            value: function() {
                                if (1 !== this._pInst._glAttributes.version && (this.drawingContext = this.canvas.getContext("webgl2", this._pInst._glAttributes)), this.webglVersion = this.drawingContext ? l.WEBGL2 : l.WEBGL, this._pInst._setProperty("webglVersion", this.webglVersion), this.drawingContext || (this.drawingContext = this.canvas.getContext("webgl", this._pInst._glAttributes) || this.canvas.getContext("experimental-webgl", this._pInst._glAttributes)), null === this.drawingContext) throw new Error("Error creating webgl context");
                                var e1 = this.drawingContext;
                                e1.enable(e1.DEPTH_TEST), e1.depthFunc(e1.LEQUAL), e1.viewport(0, 0, e1.drawingBufferWidth, e1.drawingBufferHeight), e1.pixelStorei(e1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0), this._viewport = this.drawingContext.getParameter(this.drawingContext.VIEWPORT);
                            }
                        },
                        {
                            key: "_resetContext",
                            value: function(e1, t) {
                                var r, o = this.width, n = this.height, s = this.canvas.id, i = this._pInst instanceof g.default.Graphics, s = (i ? ((r = this._pInst).canvas.parentNode.removeChild(r.canvas), r.canvas = document.createElement("canvas"), (r._pInst._userNode || document.body).appendChild(r.canvas), g.default.Element.call(r, r.canvas, r._pInst), r.width = o, r.height = n) : ((r = this.canvas) && r.parentNode.removeChild(r), (r = document.createElement("canvas")).id = s, (this._pInst._userNode || document.body).appendChild(r), this._pInst.canvas = r, this.canvas = r), new g.default.RendererGL(this._pInst.canvas, this._pInst, !i));
                                this._pInst._setProperty("_renderer", s), s.resize(o, n), s._applyDefaults(), i || this._pInst._elements.push(s), "function" == typeof t && setTimeout(function() {
                                    t.apply(window._renderer, e1);
                                }, 0);
                            }
                        },
                        {
                            key: "_update",
                            value: function() {
                                this.uMVMatrix.set(this._curCamera.cameraMatrix.mat4[0], this._curCamera.cameraMatrix.mat4[1], this._curCamera.cameraMatrix.mat4[2], this._curCamera.cameraMatrix.mat4[3], this._curCamera.cameraMatrix.mat4[4], this._curCamera.cameraMatrix.mat4[5], this._curCamera.cameraMatrix.mat4[6], this._curCamera.cameraMatrix.mat4[7], this._curCamera.cameraMatrix.mat4[8], this._curCamera.cameraMatrix.mat4[9], this._curCamera.cameraMatrix.mat4[10], this._curCamera.cameraMatrix.mat4[11], this._curCamera.cameraMatrix.mat4[12], this._curCamera.cameraMatrix.mat4[13], this._curCamera.cameraMatrix.mat4[14], this._curCamera.cameraMatrix.mat4[15]), this.ambientLightColors.length = 0, this.specularColors = [
                                    1,
                                    1,
                                    1
                                ], this.directionalLightDirections.length = 0, this.directionalLightDiffuseColors.length = 0, this.directionalLightSpecularColors.length = 0, this.pointLightPositions.length = 0, this.pointLightDiffuseColors.length = 0, this.pointLightSpecularColors.length = 0, this.spotLightPositions.length = 0, this.spotLightDirections.length = 0, this.spotLightDiffuseColors.length = 0, this.spotLightSpecularColors.length = 0, this.spotLightAngle.length = 0, this.spotLightConc.length = 0, this._enableLighting = !1, this._tint = [
                                    255,
                                    255,
                                    255,
                                    255
                                ], this.GL.clearStencil(0), this.GL.clear(this.GL.DEPTH_BUFFER_BIT | this.GL.STENCIL_BUFFER_BIT), this.GL.disable(this.GL.STENCIL_TEST);
                            }
                        },
                        {
                            key: "background",
                            value: function() {
                                var e1 = (e1 = this._pInst).color.apply(e1, arguments), t = e1.levels[0] / 255, r = e1.levels[1] / 255, o = e1.levels[2] / 255, e1 = e1.levels[3] / 255;
                                this.clear(t, r, o, e1);
                            }
                        },
                        {
                            key: "fill",
                            value: function(e1, t, r, o) {
                                var n = g.default.prototype.color.apply(this._pInst, arguments);
                                this.curFillColor = n._array, this.drawMode = l.FILL, this._useNormalMaterial = !1, this._tex = null;
                            }
                        },
                        {
                            key: "stroke",
                            value: function(e1, t, r, o) {
                                var n = g.default.prototype.color.apply(this._pInst, arguments);
                                this.curStrokeColor = n._array;
                            }
                        },
                        {
                            key: "strokeCap",
                            value: function(e1) {
                                this.curStrokeCap = e1;
                            }
                        },
                        {
                            key: "strokeJoin",
                            value: function(e1) {
                                this.curStrokeJoin = e1;
                            }
                        },
                        {
                            key: "getFilterLayer",
                            value: function() {
                                return this.filterLayer || (this.filterLayer = this._pInst.createFramebuffer()), this.filterLayer;
                            }
                        },
                        {
                            key: "getFilterLayerTemp",
                            value: function() {
                                return this.filterLayerTemp || (this.filterLayerTemp = this._pInst.createFramebuffer()), this.filterLayerTemp;
                            }
                        },
                        {
                            key: "matchSize",
                            value: function(e1, t) {
                                e1.width === t.width && e1.height === t.height || e1.resize(t.width, t.height), e1.pixelDensity() !== t.pixelDensity() && e1.pixelDensity(t.pixelDensity());
                            }
                        },
                        {
                            key: "filter",
                            value: function() {
                                var e1, t, r = this, o = this.getFilterLayer(), n = void 0, s = void 0, i = ("string" == typeof (arguments.length <= 0 ? void 0 : arguments[0]) ? (s = arguments.length <= 0 ? void 0 : arguments[0], j(e1 = {}, l.BLUR, 3), j(e1, l.POSTERIZE, 4), j(e1, l.THRESHOLD, .5), n = s in e1 && void 0 === (arguments.length <= 1 ? void 0 : arguments[1]) ? e1[s] : arguments.length <= 1 ? void 0 : arguments[1], s in this.defaultFilterShaders || (this.defaultFilterShaders[s] = new g.default.Shader(o._renderer, "uniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\n\nattribute vec3 aPosition;\n// texcoords only come from p5 to vertex shader\n// so pass texcoords on to the fragment shader in a varying variable\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\n\nvoid main() {\n  // transferring texcoords for the frag shader\n  vTexCoord = aTexCoord;\n\n  // copy position with a fourth coordinate for projection (1.0 is normal)\n  vec4 positionVec4 = vec4(aPosition, 1.0);\n\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n}\n", E[s])), this.filterShader = this.defaultFilterShaders[s]) : this.filterShader = arguments.length <= 0 ? void 0 : arguments[0], this.activeFramebuffer() || this), a = (this.matchSize(o, i), i !== this && (this.filterCamera = this.getFilterLayer().createCamera()), o.draw(function() {
                                    return r._pInst.clear();
                                }), [
                                    1 / (i.width * i.pixelDensity()),
                                    1 / (i.height * i.pixelDensity())
                                ]);
                                s === l.BLUR ? (t = this.getFilterLayerTemp(), this.matchSize(t, i), this._pInst.push(), this._pInst.noStroke(), this._pInst.shader(this.filterShader), this.filterShader.setUniform("texelSize", a), this.filterShader.setUniform("canvasSize", [
                                    i.width,
                                    i.height
                                ]), this.filterShader.setUniform("radius", Math.max(1, n)), t.draw(function() {
                                    r.filterShader.setUniform("direction", [
                                        1,
                                        0
                                    ]), r.filterShader.setUniform("tex0", i), r._pInst.clear(), r._pInst.shader(r.filterShader), r._pInst.rect(-i.width / 2, -i.height / 2, i.width, i.height);
                                }), o.draw(function() {
                                    r.filterShader.setUniform("direction", [
                                        0,
                                        1
                                    ]), r.filterShader.setUniform("tex0", t), r._pInst.clear(), r._pInst.shader(r.filterShader), r._pInst.rect(-i.width / 2, -i.height / 2, i.width, i.height);
                                }), this._pInst.pop()) : o.draw(function() {
                                    r._pInst.noStroke(), r._pInst.shader(r.filterShader), r.filterShader.setUniform("tex0", i), r.filterShader.setUniform("texelSize", a), r.filterShader.setUniform("canvasSize", [
                                        i.width,
                                        i.height
                                    ]), r.filterShader.setUniform("filterParameter", n), r._pInst.rect(-i.width / 2, -i.height / 2, i.width, i.height);
                                }), this._pInst.push(), this._pInst.noStroke(), this.clear(), this._pInst.push(), this._pInst.imageMode(l.CORNER), this._pInst.blendMode(l.BLEND), this.filterCamera._resize(), this._pInst.setCamera(this.filterCamera), this._pInst.resetMatrix(), this._pInst.image(o, -this.width / 2, -this.height / 2, this.width, this.height), this._pInst.pop(), this._pInst.pop();
                            }
                        },
                        {
                            key: "pixelDensity",
                            value: function(e1) {
                                return e1 ? this._pInst.pixelDensity(e1) : this._pInst.pixelDensity();
                            }
                        },
                        {
                            key: "blendMode",
                            value: function(e1) {
                                e1 === l.DARKEST || e1 === l.LIGHTEST || e1 === l.ADD || e1 === l.BLEND || e1 === l.SUBTRACT || e1 === l.SCREEN || e1 === l.EXCLUSION || e1 === l.REPLACE || e1 === l.MULTIPLY || e1 === l.REMOVE ? this.curBlendMode = e1 : e1 !== l.BURN && e1 !== l.OVERLAY && e1 !== l.HARD_LIGHT && e1 !== l.SOFT_LIGHT && e1 !== l.DODGE || console.warn("BURN, OVERLAY, HARD_LIGHT, SOFT_LIGHT, and DODGE only work for blendMode in 2D mode.");
                            }
                        },
                        {
                            key: "erase",
                            value: function(e1, t) {
                                this._isErasing || (this._cachedBlendMode = this.curBlendMode, this._isErasing = !0, this.blendMode(l.REMOVE), this._cachedFillStyle = this.curFillColor.slice(), this.curFillColor = [
                                    1,
                                    1,
                                    1,
                                    e1 / 255
                                ], this._cachedStrokeStyle = this.curStrokeColor.slice(), this.curStrokeColor = [
                                    1,
                                    1,
                                    1,
                                    t / 255
                                ]);
                            }
                        },
                        {
                            key: "noErase",
                            value: function() {
                                var e1;
                                this._isErasing && (this.curFillColor = this._cachedFillStyle.slice(), this.curStrokeColor = this._cachedStrokeStyle.slice(), e1 = this.curBlendMode, this.blendMode(this._cachedBlendMode), this._cachedBlendMode = e1, this._isErasing = !1, this._applyBlendMode());
                            }
                        },
                        {
                            key: "drawTarget",
                            value: function() {
                                return this.activeFramebuffers[this.activeFramebuffers.length - 1] || this;
                            }
                        },
                        {
                            key: "beginClip",
                            value: function() {
                                var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}, e1 = (p(b(s.prototype), "beginClip", this).call(this, e1), this.drawTarget()._isClipApplied = !0, this.GL);
                                e1.clearStencil(0), e1.clear(e1.STENCIL_BUFFER_BIT), e1.enable(e1.STENCIL_TEST), this._stencilTestOn = !0, e1.stencilFunc(e1.ALWAYS, 1, 255), e1.stencilOp(e1.KEEP, e1.KEEP, e1.REPLACE), e1.disable(e1.DEPTH_TEST), this._pInst.push(), this._pInst.resetShader(), this._doFill && this._pInst.fill(0, 0), this._doStroke && this._pInst.stroke(0, 0);
                            }
                        },
                        {
                            key: "endClip",
                            value: function() {
                                this._pInst.pop();
                                var e1 = this.GL;
                                e1.stencilOp(e1.KEEP, e1.KEEP, e1.KEEP), e1.stencilFunc(this._clipInvert ? e1.EQUAL : e1.NOTEQUAL, 0, 255), e1.enable(e1.DEPTH_TEST), this._clipDepths.push(this._pushPopDepth), p(b(s.prototype), "endClip", this).call(this);
                            }
                        },
                        {
                            key: "_clearClip",
                            value: function() {
                                this.GL.clearStencil(1), this.GL.clear(this.GL.STENCIL_BUFFER_BIT), 0 < this._clipDepths.length && this._clipDepths.pop(), this.drawTarget()._isClipApplied = !1;
                            }
                        },
                        {
                            key: "strokeWeight",
                            value: function(e1) {
                                this.curStrokeWeight !== e1 && (this.pointSize = e1, this.curStrokeWeight = e1);
                            }
                        },
                        {
                            key: "_getPixel",
                            value: function(e1, t) {
                                var r = this.GL;
                                return C(r, null, e1, t, r.RGBA, r.UNSIGNED_BYTE, this._pInst.height * this._pInst.pixelDensity());
                            }
                        },
                        {
                            key: "loadPixels",
                            value: function() {
                                var e1, t, r = this._pixelsState;
                                !0 !== this._pInst._glAttributes.preserveDrawingBuffer ? console.log("loadPixels only works in WebGL when preserveDrawingBuffer is true.") : (e1 = this._pInst._pixelDensity, t = this.GL, r._setProperty("pixels", k(r.pixels, t, null, 0, 0, this.width * e1, this.height * e1, t.RGBA, t.UNSIGNED_BYTE, this.height * e1)));
                            }
                        },
                        {
                            key: "updatePixels",
                            value: function() {
                                var e1 = this._getTempFramebuffer();
                                e1.pixels = this._pixelsState.pixels, e1.updatePixels(), this._pInst.push(), this._pInst.resetMatrix(), this._pInst.clear(), this._pInst.imageMode(l.CENTER), this._pInst.image(e1, 0, 0), this._pInst.pop(), this.GL.clearDepth(1), this.GL.clear(this.GL.DEPTH_BUFFER_BIT);
                            }
                        },
                        {
                            key: "_getTempFramebuffer",
                            value: function() {
                                return this._tempFramebuffer || (this._tempFramebuffer = this._pInst.createFramebuffer({
                                    format: l.UNSIGNED_BYTE,
                                    useDepth: this._pInst._glAttributes.depth,
                                    depthFormat: l.UNSIGNED_INT,
                                    antialias: this._pInst._glAttributes.antialias
                                })), this._tempFramebuffer;
                            }
                        },
                        {
                            key: "geometryInHash",
                            value: function(e1) {
                                return void 0 !== this.retainedMode.geometry[e1];
                            }
                        },
                        {
                            key: "viewport",
                            value: function(e1, t) {
                                this._viewport = [
                                    0,
                                    0,
                                    e1,
                                    t
                                ], this.GL.viewport(0, 0, e1, t);
                            }
                        },
                        {
                            key: "resize",
                            value: function(t, r) {
                                g.default.Renderer.prototype.resize.call(this, t, r), this._origViewport = {
                                    width: this.GL.drawingBufferWidth,
                                    height: this.GL.drawingBufferHeight
                                }, this.viewport(this._origViewport.width, this._origViewport.height), this._curCamera._resize();
                                var t = this._pixelsState, e1 = (void 0 !== t.pixels && t._setProperty("pixels", new Uint8Array(this.GL.drawingBufferWidth * this.GL.drawingBufferHeight * 4)), !0), r = !1, t = void 0;
                                try {
                                    for(var o, n = this.framebuffers[Symbol.iterator](); !(e1 = (o = n.next()).done); e1 = !0)o.value._canvasSizeChanged();
                                } catch (e1) {
                                    r = !0, t = e1;
                                } finally{
                                    try {
                                        e1 || null == n.return || n.return();
                                    } finally{
                                        if (r) throw t;
                                    }
                                }
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                var e1 = (arguments.length <= 0 ? void 0 : arguments[0]) || 0, t = (arguments.length <= 1 ? void 0 : arguments[1]) || 0, r = (arguments.length <= 2 ? void 0 : arguments[2]) || 0, o = (arguments.length <= 3 ? void 0 : arguments[3]) || 0, n = this.activeFramebuffer();
                                n && n.format === l.UNSIGNED_BYTE && !n.antialias && 0 === o && (o = 1e-10), this.GL.clearColor(e1 * o, t * o, r * o, o), this.GL.clearDepth(1), this.GL.clear(this.GL.COLOR_BUFFER_BIT | this.GL.DEPTH_BUFFER_BIT);
                            }
                        },
                        {
                            key: "applyMatrix",
                            value: function(e1, t, r, o, n, s) {
                                16 === arguments.length ? g.default.Matrix.prototype.apply.apply(this.uMVMatrix, arguments) : this.uMVMatrix.apply([
                                    e1,
                                    t,
                                    0,
                                    0,
                                    r,
                                    o,
                                    0,
                                    0,
                                    0,
                                    0,
                                    1,
                                    0,
                                    n,
                                    s,
                                    0,
                                    1
                                ]);
                            }
                        },
                        {
                            key: "translate",
                            value: function(e1, t, r) {
                                return e1 instanceof g.default.Vector && (r = e1.z, t = e1.y, e1 = e1.x), this.uMVMatrix.translate([
                                    e1,
                                    t,
                                    r
                                ]), this;
                            }
                        },
                        {
                            key: "scale",
                            value: function(e1, t, r) {
                                return this.uMVMatrix.scale(e1, t, r), this;
                            }
                        },
                        {
                            key: "rotate",
                            value: function(e1, t) {
                                return void 0 === t ? this.rotateZ(e1) : (g.default.Matrix.prototype.rotate.apply(this.uMVMatrix, arguments), this);
                            }
                        },
                        {
                            key: "rotateX",
                            value: function(e1) {
                                return this.rotate(e1, 1, 0, 0), this;
                            }
                        },
                        {
                            key: "rotateY",
                            value: function(e1) {
                                return this.rotate(e1, 0, 1, 0), this;
                            }
                        },
                        {
                            key: "rotateZ",
                            value: function(e1) {
                                return this.rotate(e1, 0, 0, 1), this;
                            }
                        },
                        {
                            key: "push",
                            value: function() {
                                var e1 = g.default.Renderer.prototype.push.apply(this), t = e1.properties;
                                return t.uMVMatrix = this.uMVMatrix.copy(), t.uPMatrix = this.uPMatrix.copy(), t._curCamera = this._curCamera, this._curCamera = this._curCamera.copy(), t.ambientLightColors = this.ambientLightColors.slice(), t.specularColors = this.specularColors.slice(), t.directionalLightDirections = this.directionalLightDirections.slice(), t.directionalLightDiffuseColors = this.directionalLightDiffuseColors.slice(), t.directionalLightSpecularColors = this.directionalLightSpecularColors.slice(), t.pointLightPositions = this.pointLightPositions.slice(), t.pointLightDiffuseColors = this.pointLightDiffuseColors.slice(), t.pointLightSpecularColors = this.pointLightSpecularColors.slice(), t.spotLightPositions = this.spotLightPositions.slice(), t.spotLightDirections = this.spotLightDirections.slice(), t.spotLightDiffuseColors = this.spotLightDiffuseColors.slice(), t.spotLightSpecularColors = this.spotLightSpecularColors.slice(), t.spotLightAngle = this.spotLightAngle.slice(), t.spotLightConc = this.spotLightConc.slice(), t.userFillShader = this.userFillShader, t.userStrokeShader = this.userStrokeShader, t.userPointShader = this.userPointShader, t.pointSize = this.pointSize, t.curStrokeWeight = this.curStrokeWeight, t.curStrokeColor = this.curStrokeColor, t.curFillColor = this.curFillColor, t.curAmbientColor = this.curAmbientColor, t.curSpecularColor = this.curSpecularColor, t.curEmissiveColor = this.curEmissiveColor, t._hasSetAmbient = this._hasSetAmbient, t._useSpecularMaterial = this._useSpecularMaterial, t._useEmissiveMaterial = this._useEmissiveMaterial, t._useShininess = this._useShininess, t.constantAttenuation = this.constantAttenuation, t.linearAttenuation = this.linearAttenuation, t.quadraticAttenuation = this.quadraticAttenuation, t._enableLighting = this._enableLighting, t._useNormalMaterial = this._useNormalMaterial, t._tex = this._tex, t.drawMode = this.drawMode, t._currentNormal = this._currentNormal, t.curBlendMode = this.curBlendMode, t.activeImageLight = this.activeImageLight, e1;
                            }
                        },
                        {
                            key: "pop",
                            value: function() {
                                var e1;
                                0 < this._clipDepths.length && this._pushPopDepth === this._clipDepths[this._clipDepths.length - 1] && this._clearClip();
                                for(var t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                                (e1 = p(b(s.prototype), "pop", this)).call.apply(e1, [
                                    this
                                ].concat(r)), this._applyStencilTestIfClipping();
                            }
                        },
                        {
                            key: "_applyStencilTestIfClipping",
                            value: function() {
                                var e1 = this.drawTarget();
                                e1._isClipApplied !== this._stencilTestOn && (e1._isClipApplied ? (this.GL.enable(this.GL.STENCIL_TEST), this._stencilTestOn = !0) : (this.GL.disable(this.GL.STENCIL_TEST), this._stencilTestOn = !1));
                            }
                        },
                        {
                            key: "resetMatrix",
                            value: function() {
                                return this.uMVMatrix.set(this._curCamera.cameraMatrix.mat4[0], this._curCamera.cameraMatrix.mat4[1], this._curCamera.cameraMatrix.mat4[2], this._curCamera.cameraMatrix.mat4[3], this._curCamera.cameraMatrix.mat4[4], this._curCamera.cameraMatrix.mat4[5], this._curCamera.cameraMatrix.mat4[6], this._curCamera.cameraMatrix.mat4[7], this._curCamera.cameraMatrix.mat4[8], this._curCamera.cameraMatrix.mat4[9], this._curCamera.cameraMatrix.mat4[10], this._curCamera.cameraMatrix.mat4[11], this._curCamera.cameraMatrix.mat4[12], this._curCamera.cameraMatrix.mat4[13], this._curCamera.cameraMatrix.mat4[14], this._curCamera.cameraMatrix.mat4[15]), this;
                            }
                        },
                        {
                            key: "_getImmediateStrokeShader",
                            value: function() {
                                var e1 = this.userStrokeShader;
                                return e1 && e1.isStrokeShader() ? e1 : this._getLineShader();
                            }
                        },
                        {
                            key: "_getRetainedStrokeShader",
                            value: function() {
                                return this._getImmediateStrokeShader();
                            }
                        },
                        {
                            key: "_getImmediateFillShader",
                            value: function() {
                                var e1 = this.userFillShader;
                                if (this._useNormalMaterial && (!e1 || !e1.isNormalShader())) return this._getNormalShader();
                                if (this._enableLighting) {
                                    if (!e1 || !e1.isLightShader()) return this._getLightShader();
                                } else if (this._tex) {
                                    if (!e1 || !e1.isTextureShader()) return this._getLightShader();
                                } else if (!e1) return this._getImmediateModeShader();
                                return e1;
                            }
                        },
                        {
                            key: "_getRetainedFillShader",
                            value: function() {
                                if (this._useNormalMaterial) return this._getNormalShader();
                                var e1 = this.userFillShader;
                                if (this._enableLighting) {
                                    if (!e1 || !e1.isLightShader()) return this._getLightShader();
                                } else if (this._tex) {
                                    if (!e1 || !e1.isTextureShader()) return this._getLightShader();
                                } else if (!e1) return this._getColorShader();
                                return e1;
                            }
                        },
                        {
                            key: "_getImmediatePointShader",
                            value: function() {
                                var e1 = this.userPointShader;
                                return e1 && e1.isPointShader() ? e1 : this._getPointShader();
                            }
                        },
                        {
                            key: "_getRetainedLineShader",
                            value: function() {
                                return this._getImmediateLineShader();
                            }
                        },
                        {
                            key: "_getLightShader",
                            value: function() {
                                return this._defaultLightShader || (this._pInst._glAttributes.perPixelLighting ? this._defaultLightShader = new g.default.Shader(this, this._webGL2CompatibilityPrefix("vert", "highp") + M.phongVert, this._webGL2CompatibilityPrefix("frag", "highp") + M.phongFrag) : this._defaultLightShader = new g.default.Shader(this, this._webGL2CompatibilityPrefix("vert", "highp") + M.lightVert, this._webGL2CompatibilityPrefix("frag", "highp") + M.lightTextureFrag)), this._defaultLightShader;
                            }
                        },
                        {
                            key: "_getImmediateModeShader",
                            value: function() {
                                return this._defaultImmediateModeShader || (this._defaultImmediateModeShader = new g.default.Shader(this, this._webGL2CompatibilityPrefix("vert", "mediump") + M.immediateVert, this._webGL2CompatibilityPrefix("frag", "mediump") + M.vertexColorFrag)), this._defaultImmediateModeShader;
                            }
                        },
                        {
                            key: "_getNormalShader",
                            value: function() {
                                return this._defaultNormalShader || (this._defaultNormalShader = new g.default.Shader(this, this._webGL2CompatibilityPrefix("vert", "mediump") + M.normalVert, this._webGL2CompatibilityPrefix("frag", "mediump") + M.normalFrag)), this._defaultNormalShader;
                            }
                        },
                        {
                            key: "_getColorShader",
                            value: function() {
                                return this._defaultColorShader || (this._defaultColorShader = new g.default.Shader(this, this._webGL2CompatibilityPrefix("vert", "mediump") + M.normalVert, this._webGL2CompatibilityPrefix("frag", "mediump") + M.basicFrag)), this._defaultColorShader;
                            }
                        },
                        {
                            key: "_getPointShader",
                            value: function() {
                                return this._defaultPointShader || (this._defaultPointShader = new g.default.Shader(this, this._webGL2CompatibilityPrefix("vert", "mediump") + M.pointVert, this._webGL2CompatibilityPrefix("frag", "mediump") + M.pointFrag)), this._defaultPointShader;
                            }
                        },
                        {
                            key: "_getLineShader",
                            value: function() {
                                return this._defaultLineShader || (this._defaultLineShader = new g.default.Shader(this, this._webGL2CompatibilityPrefix("vert", "mediump") + M.lineVert, this._webGL2CompatibilityPrefix("frag", "mediump") + M.lineFrag)), this._defaultLineShader;
                            }
                        },
                        {
                            key: "_getFontShader",
                            value: function() {
                                return this._defaultFontShader || (this.webglVersion === l.WEBGL && this.GL.getExtension("OES_standard_derivatives"), this._defaultFontShader = new g.default.Shader(this, this._webGL2CompatibilityPrefix("vert", "mediump") + M.fontVert, this._webGL2CompatibilityPrefix("frag", "mediump") + M.fontFrag)), this._defaultFontShader;
                            }
                        },
                        {
                            key: "_webGL2CompatibilityPrefix",
                            value: function(e1, t) {
                                var r = "";
                                return this.webglVersion === l.WEBGL2 && (r += "#version 300 es\n#define WEBGL2\n"), "vert" === e1 ? r += "#define VERTEX_SHADER\n" : "frag" === e1 && (r += "#define FRAGMENT_SHADER\n"), t && (r += "precision ".concat(t, " float;\n")), r;
                            }
                        },
                        {
                            key: "_getEmptyTexture",
                            value: function() {
                                var e1;
                                return this._emptyTexture || ((e1 = new g.default.Image(1, 1)).set(0, 0, 255), this._emptyTexture = new g.default.Texture(this, e1)), this._emptyTexture;
                            }
                        },
                        {
                            key: "getTexture",
                            value: function(e1) {
                                e1 instanceof g.default.Framebuffer && (e1 = e1.color);
                                var t = this.textures.get(e1);
                                return t || (t = new g.default.Texture(this, e1), this.textures.set(e1, t), t);
                            }
                        },
                        {
                            key: "getDiffusedTexture",
                            value: function(e1) {
                                var t, r;
                                return null != this.diffusedTextures.get(e1) ? this.diffusedTextures.get(e1) : (t = Math.floor(e1.height / e1.width * 200), r = (t = this._pInst.createGraphics(200, t, l.WEBGL)).createShader(M.imageLightVert, M.imageLightDiffusedFrag), t.shader(r), r.setUniform("environmentMap", e1), t.noStroke(), t.rectMode(t.CENTER), t.rect(0, 0, t.width, t.height), this.diffusedTextures.set(e1, t), t);
                            }
                        },
                        {
                            key: "getSpecularTexture",
                            value: function(e1) {
                                if (null != this.specularTextures.get(e1)) return this.specularTextures.get(e1);
                                var t, r = [], o = this._pInst.createGraphics(512, 512, l.WEBGL), n = Math.log(512) / Math.log(2);
                                o.pixelDensity(1);
                                for(var s = 512; 1 <= s; s /= 2){
                                    o.resizeCanvas(s, s);
                                    var i = 1 - Math.log(s) / Math.log(2) / n, a = o.createShader(M.imageLightVert, M.imageLightSpecularFrag);
                                    o.shader(a), o.clear(), a.setUniform("environmentMap", e1), a.setUniform("roughness", i), o.noStroke(), o.plane(s, s), r.push(o.get().drawingContext.getImageData(0, 0, s, s));
                                }
                                return o.remove(), t = new c.MipmapTexture(this, r, {}), this.specularTextures.set(e1, t), t;
                            }
                        },
                        {
                            key: "activeFramebuffer",
                            value: function() {
                                return this.activeFramebuffers[this.activeFramebuffers.length - 1] || null;
                            }
                        },
                        {
                            key: "createFramebuffer",
                            value: function(e1) {
                                return new g.default.Framebuffer(this, e1);
                            }
                        },
                        {
                            key: "_setStrokeUniforms",
                            value: function(e1) {
                                e1.bindShader(), e1.setUniform("uUseLineColor", this._useLineColor), e1.setUniform("uMaterialColor", this.curStrokeColor), e1.setUniform("uStrokeWeight", this.curStrokeWeight), e1.setUniform("uStrokeCap", w[this.curStrokeCap]), e1.setUniform("uStrokeJoin", S[this.curStrokeJoin]);
                            }
                        },
                        {
                            key: "_setFillUniforms",
                            value: function(e1) {
                                e1.bindShader(), e1.setUniform("uUseVertexColor", this._useVertexColor), e1.setUniform("uMaterialColor", this.curFillColor), e1.setUniform("isTexture", !!this._tex), this._tex && e1.setUniform("uSampler", this._tex), e1.setUniform("uTint", this._tint), e1.setUniform("uHasSetAmbient", this._hasSetAmbient), e1.setUniform("uAmbientMatColor", this.curAmbientColor), e1.setUniform("uSpecularMatColor", this.curSpecularColor), e1.setUniform("uEmissiveMatColor", this.curEmissiveColor), e1.setUniform("uSpecular", this._useSpecularMaterial), e1.setUniform("uEmissive", this._useEmissiveMaterial), e1.setUniform("uShininess", this._useShininess), this._setImageLightUniforms(e1), e1.setUniform("uUseLighting", this._enableLighting);
                                var t = this.pointLightDiffuseColors.length / 3, t = (e1.setUniform("uPointLightCount", t), e1.setUniform("uPointLightLocation", this.pointLightPositions), e1.setUniform("uPointLightDiffuseColors", this.pointLightDiffuseColors), e1.setUniform("uPointLightSpecularColors", this.pointLightSpecularColors), this.directionalLightDiffuseColors.length / 3), t = (e1.setUniform("uDirectionalLightCount", t), e1.setUniform("uLightingDirection", this.directionalLightDirections), e1.setUniform("uDirectionalDiffuseColors", this.directionalLightDiffuseColors), e1.setUniform("uDirectionalSpecularColors", this.directionalLightSpecularColors), this.ambientLightColors.length / 3), t = (e1.setUniform("uAmbientLightCount", t), e1.setUniform("uAmbientColor", this.ambientLightColors), this.spotLightDiffuseColors.length / 3);
                                e1.setUniform("uSpotLightCount", t), e1.setUniform("uSpotLightAngle", this.spotLightAngle), e1.setUniform("uSpotLightConc", this.spotLightConc), e1.setUniform("uSpotLightDiffuseColors", this.spotLightDiffuseColors), e1.setUniform("uSpotLightSpecularColors", this.spotLightSpecularColors), e1.setUniform("uSpotLightLocation", this.spotLightPositions), e1.setUniform("uSpotLightDirection", this.spotLightDirections), e1.setUniform("uConstantAttenuation", this.constantAttenuation), e1.setUniform("uLinearAttenuation", this.linearAttenuation), e1.setUniform("uQuadraticAttenuation", this.quadraticAttenuation), e1.bindTextures();
                            }
                        },
                        {
                            key: "_setImageLightUniforms",
                            value: function(e1) {
                                var t, r;
                                e1.setUniform("uUseImageLight", null != this.activeImageLight), this.activeImageLight && (t = this.getDiffusedTexture(this.activeImageLight), e1.setUniform("environmentMapDiffused", t), t = this.getSpecularTexture(this.activeImageLight), r = 20 / this._useShininess, e1.setUniform("levelOfDetail", 8 * r), e1.setUniform("environmentMapSpecular", t));
                            }
                        },
                        {
                            key: "_setPointUniforms",
                            value: function(e1) {
                                e1.bindShader(), e1.setUniform("uMaterialColor", this.curStrokeColor), e1.setUniform("uPointSize", this.pointSize * this._pInst._pixelDensity);
                            }
                        },
                        {
                            key: "_bindBuffer",
                            value: function(e1, t, r, o, n) {
                                t = t || this.GL.ARRAY_BUFFER, this.GL.bindBuffer(t, e1), void 0 !== r && ((e1 = r) instanceof g.default.DataArray ? e1 = r.dataArray() : e1 instanceof (o || Float32Array) || (e1 = new (o || Float32Array)(e1)), this.GL.bufferData(t, e1, n || this.GL.STATIC_DRAW));
                            }
                        },
                        {
                            key: "_arraysEqual",
                            value: function(e1, r) {
                                return e1.length === r.length && e1.every(function(e1, t) {
                                    return e1 === r[t];
                                });
                            }
                        },
                        {
                            key: "_isTypedArray",
                            value: function(t) {
                                return [
                                    Float32Array,
                                    Float64Array,
                                    Int16Array,
                                    Uint16Array,
                                    Uint32Array
                                ].some(function(e1) {
                                    return t instanceof e1;
                                });
                            }
                        },
                        {
                            key: "_flatten",
                            value: function(e1) {
                                if (0 === e1.length) return [];
                                var t;
                                if (2e4 < e1.length) {
                                    for(var r = [], o = e1.slice(), n = o.pop(); Array.isArray(n) ? o.push.apply(o, h(n)) : r.push(n), o.length && void 0 !== (n = o.pop()););
                                    return r.reverse(), r;
                                }
                                return (t = []).concat.apply(t, h(e1));
                            }
                        },
                        {
                            key: "_vToNArray",
                            value: function(e1) {
                                var t = [], r = !0, o = !1, n = void 0;
                                try {
                                    for(var s, i = e1[Symbol.iterator](); !(r = (s = i.next()).done); r = !0){
                                        var a = s.value;
                                        t.push(a.x, a.y, a.z);
                                    }
                                } catch (e1) {
                                    o = !0, n = e1;
                                } finally{
                                    try {
                                        r || null == i.return || i.return();
                                    } finally{
                                        if (o) throw n;
                                    }
                                }
                                return t;
                            }
                        },
                        {
                            key: "_bezierCoefficients",
                            value: function(e1) {
                                var t = e1 * e1, r = 1 - e1, o = r * r;
                                return [
                                    o * r,
                                    3 * o * e1,
                                    3 * r * t,
                                    t * e1
                                ];
                            }
                        },
                        {
                            key: "_quadraticCoefficients",
                            value: function(e1) {
                                var t = 1 - e1;
                                return [
                                    t * t,
                                    2 * t * e1,
                                    e1 * e1
                                ];
                            }
                        },
                        {
                            key: "_bezierToCatmull",
                            value: function(e1) {
                                return [
                                    e1[1],
                                    e1[1] + (e1[2] - e1[0]) / this._curveTightness,
                                    e1[2] - (e1[3] - e1[1]) / this._curveTightness,
                                    e1[2]
                                ];
                            }
                        },
                        {
                            key: "_initTessy",
                            value: function() {
                                var e1 = new u.default.GluTesselator;
                                return e1.gluTessCallback(u.default.gluEnum.GLU_TESS_VERTEX_DATA, function(e1, t) {
                                    for(var r = 0; r < e1.length; r++)t.push(e1[r]);
                                }), e1.gluTessCallback(u.default.gluEnum.GLU_TESS_BEGIN, function(e1) {
                                    e1 !== u.default.primitiveType.GL_TRIANGLES && console.log("expected TRIANGLES but got type: ".concat(e1));
                                }), e1.gluTessCallback(u.default.gluEnum.GLU_TESS_ERROR, function(e1) {
                                    console.log("error callback"), console.log("error number: ".concat(e1));
                                }), e1.gluTessCallback(u.default.gluEnum.GLU_TESS_COMBINE, function(e1, t, r) {
                                    for(var o = new Array(g.default.RendererGL.prototype.tessyVertexSize).fill(0), n = 0; n < r.length; n++)for(var s = 0; s < o.length; s++)0 !== r[n] && t[n] && (o[s] += t[n][s] * r[n]);
                                    return o;
                                }), e1.gluTessCallback(u.default.gluEnum.GLU_TESS_EDGE_FLAG, function(e1) {}), e1.gluTessProperty(u.default.gluEnum.GLU_TESS_WINDING_RULE, u.default.windingRule.GLU_TESS_WINDING_NONZERO), e1;
                            }
                        },
                        {
                            key: "_triangulate",
                            value: function(e1) {
                                var t = e1[0] ? e1[0][2] : void 0, r = !0, o = !0, n = !1, s = void 0;
                                try {
                                    for(var i, a = e1[Symbol.iterator](); !(o = (i = a.next()).done); o = !0)for(var l = i.value, u = 0; u < l.length; u += g.default.RendererGL.prototype.tessyVertexSize)if (l[u + 2] !== t) {
                                        r = !1;
                                        break;
                                    }
                                } catch (e1) {
                                    n = !0, s = e1;
                                } finally{
                                    try {
                                        o || null == a.return || a.return();
                                    } finally{
                                        if (n) throw s;
                                    }
                                }
                                r ? this._tessy.gluTessNormal(0, 0, 1) : this._tessy.gluTessNormal(0, 0, 0);
                                var n = [], c = (this._tessy.gluTessBeginPolygon(n), !0), s = !1, d = void 0;
                                try {
                                    for(var h, f = e1[Symbol.iterator](); !(c = (h = f.next()).done); c = !0){
                                        var p = h.value;
                                        this._tessy.gluTessBeginContour();
                                        for(var m = 0; m < p.length; m += g.default.RendererGL.prototype.tessyVertexSize){
                                            var y = p.slice(m, m + g.default.RendererGL.prototype.tessyVertexSize);
                                            this._tessy.gluTessVertex(y, y);
                                        }
                                        this._tessy.gluTessEndContour();
                                    }
                                } catch (e1) {
                                    s = !0, d = e1;
                                } finally{
                                    try {
                                        c || null == f.return || f.return();
                                    } finally{
                                        if (s) throw d;
                                    }
                                }
                                return this._tessy.gluTessEndPolygon(), n;
                            }
                        }
                    ], f(t.prototype, e1), r && f(t, r), s;
                }(g.default.Renderer), g.default.prototype._assert3d = function(e1) {
                    if (!this._renderer.isP3D) throw new Error("".concat(e1, "() is only supported in WEBGL mode. If you'd like to use 3D graphics and WebGL, see  https://p5js.org/examples/form-3d-primitives.html for more information."));
                }, g.default.RendererGL.prototype.tessyVertexSize = 12;
                e1 = g.default.RendererGL;
                r.default = e1;
            },
            {
                "../core/constants": 264,
                "../core/main": 275,
                "../core/p5.Renderer": 278,
                "./GeometryBuilder": 319,
                "./p5.Camera": 324,
                "./p5.Framebuffer": 326,
                "./p5.Matrix": 328,
                "./p5.Shader": 333,
                "./p5.Texture": 334,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.copy-within": 152,
                "core-js/modules/es.array.every": 153,
                "core-js/modules/es.array.fill": 154,
                "core-js/modules/es.array.from": 158,
                "core-js/modules/es.array.includes": 159,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.array.some": 166,
                "core-js/modules/es.map": 169,
                "core-js/modules/es.object.assign": 176,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.get-prototype-of": 180,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.reflect.construct": 184,
                "core-js/modules/es.reflect.get": 185,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.set": 189,
                "core-js/modules/es.string.includes": 191,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.typed-array.copy-within": 205,
                "core-js/modules/es.typed-array.every": 206,
                "core-js/modules/es.typed-array.fill": 207,
                "core-js/modules/es.typed-array.filter": 208,
                "core-js/modules/es.typed-array.find": 210,
                "core-js/modules/es.typed-array.find-index": 209,
                "core-js/modules/es.typed-array.float32-array": 211,
                "core-js/modules/es.typed-array.float64-array": 212,
                "core-js/modules/es.typed-array.for-each": 213,
                "core-js/modules/es.typed-array.includes": 214,
                "core-js/modules/es.typed-array.index-of": 215,
                "core-js/modules/es.typed-array.int16-array": 216,
                "core-js/modules/es.typed-array.iterator": 218,
                "core-js/modules/es.typed-array.join": 219,
                "core-js/modules/es.typed-array.last-index-of": 220,
                "core-js/modules/es.typed-array.map": 221,
                "core-js/modules/es.typed-array.reduce": 223,
                "core-js/modules/es.typed-array.reduce-right": 222,
                "core-js/modules/es.typed-array.reverse": 224,
                "core-js/modules/es.typed-array.set": 225,
                "core-js/modules/es.typed-array.slice": 226,
                "core-js/modules/es.typed-array.some": 227,
                "core-js/modules/es.typed-array.sort": 228,
                "core-js/modules/es.typed-array.subarray": 229,
                "core-js/modules/es.typed-array.to-locale-string": 230,
                "core-js/modules/es.typed-array.to-string": 231,
                "core-js/modules/es.typed-array.uint16-array": 232,
                "core-js/modules/es.typed-array.uint32-array": 233,
                "core-js/modules/es.typed-array.uint8-array": 234,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238,
                libtess: 247,
                path: 250
            }
        ],
        333: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                s.default.Shader = function() {
                    function o(e1, t, r) {
                        if (!(this instanceof o)) throw new TypeError("Cannot call a class as a function");
                        this._renderer = e1, this._vertSrc = t, this._fragSrc = r, this._vertShader = -1, this._fragShader = -1, this._glProgram = 0, this._loadedAttributes = !1, this.attributes = {}, this._loadedUniforms = !1, this.uniforms = {}, this._bound = !1, this.samplers = [];
                    }
                    var e1, t, r;
                    return e1 = o, t = [
                        {
                            key: "init",
                            value: function() {
                                if (0 === this._glProgram) {
                                    var e1 = this._renderer.GL;
                                    if (this._vertShader = e1.createShader(e1.VERTEX_SHADER), e1.shaderSource(this._vertShader, this._vertSrc), e1.compileShader(this._vertShader), !e1.getShaderParameter(this._vertShader, e1.COMPILE_STATUS)) return s.default._friendlyError("Yikes! An error occurred compiling the vertex shader:".concat(e1.getShaderInfoLog(this._vertShader))), null;
                                    if (this._fragShader = e1.createShader(e1.FRAGMENT_SHADER), e1.shaderSource(this._fragShader, this._fragSrc), e1.compileShader(this._fragShader), !e1.getShaderParameter(this._fragShader, e1.COMPILE_STATUS)) return s.default._friendlyError("Darn! An error occurred compiling the fragment shader:".concat(e1.getShaderInfoLog(this._fragShader))), null;
                                    this._glProgram = e1.createProgram(), e1.attachShader(this._glProgram, this._vertShader), e1.attachShader(this._glProgram, this._fragShader), e1.linkProgram(this._glProgram), e1.getProgramParameter(this._glProgram, e1.LINK_STATUS) || s.default._friendlyError("Snap! Error linking shader program: ".concat(e1.getProgramInfoLog(this._glProgram))), this._loadAttributes(), this._loadUniforms();
                                }
                                return this;
                            }
                        },
                        {
                            key: "copyToContext",
                            value: function(e1) {
                                var t = new s.default.Shader(e1._renderer, this._vertSrc, this._fragSrc);
                                return t.ensureCompiledOnContext(e1), t;
                            }
                        },
                        {
                            key: "ensureCompiledOnContext",
                            value: function(e1) {
                                if (0 !== this._glProgram && this._renderer !== e1._renderer) throw new Error("The shader being run is attached to a different context. Do you need to copy it to this context first with .copyToContext()?");
                                0 === this._glProgram && (this._renderer = e1._renderer, this.init());
                            }
                        },
                        {
                            key: "_loadAttributes",
                            value: function() {
                                if (!this._loadedAttributes) {
                                    this.attributes = {};
                                    for(var e1 = this._renderer.GL, t = e1.getProgramParameter(this._glProgram, e1.ACTIVE_ATTRIBUTES), r = 0; r < t; ++r){
                                        var o = e1.getActiveAttrib(this._glProgram, r), n = o.name, s = e1.getAttribLocation(this._glProgram, n), i = {};
                                        i.name = n, i.location = s, i.index = r, i.type = o.type, i.size = o.size, this.attributes[n] = i;
                                    }
                                    this._loadedAttributes = !0;
                                }
                            }
                        },
                        {
                            key: "_loadUniforms",
                            value: function() {
                                if (!this._loadedUniforms) {
                                    for(var e1 = this._renderer.GL, t = e1.getProgramParameter(this._glProgram, e1.ACTIVE_UNIFORMS), r = 0, o = 0; o < t; ++o){
                                        var n = e1.getActiveUniform(this._glProgram, o), s = {}, i = (s.location = e1.getUniformLocation(this._glProgram, n.name), s.size = n.size, n.name);
                                        1 < n.size && (i = i.substring(0, i.indexOf("[0]"))), s.name = i, s.type = n.type, s._cachedData = void 0, s.type === e1.SAMPLER_2D && (s.samplerIndex = r, r++, this.samplers.push(s)), s.isArray = 1 < n.size || s.type === e1.FLOAT_MAT3 || s.type === e1.FLOAT_MAT4 || s.type === e1.FLOAT_VEC2 || s.type === e1.FLOAT_VEC3 || s.type === e1.FLOAT_VEC4 || s.type === e1.INT_VEC2 || s.type === e1.INT_VEC4 || s.type === e1.INT_VEC3, this.uniforms[i] = s;
                                    }
                                    this._loadedUniforms = !0;
                                }
                            }
                        },
                        {
                            key: "compile",
                            value: function() {}
                        },
                        {
                            key: "bindShader",
                            value: function() {
                                this.init(), this._bound || (this.useProgram(), this._bound = !0, this._setMatrixUniforms(), this.setUniform("uViewport", this._renderer._viewport));
                            }
                        },
                        {
                            key: "unbindShader",
                            value: function() {
                                return this._bound && (this.unbindTextures(), this._bound = !1), this;
                            }
                        },
                        {
                            key: "bindTextures",
                            value: function() {
                                var e1 = this._renderer.GL, t = !0, r = !1, o = void 0;
                                try {
                                    for(var n, s = this.samplers[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                        var i = n.value, a = i.texture;
                                        void 0 === a && (a = this._renderer._getEmptyTexture()), e1.activeTexture(e1.TEXTURE0 + i.samplerIndex), a.bindTexture(), a.update(), e1.uniform1i(i.location, i.samplerIndex);
                                    }
                                } catch (e1) {
                                    r = !0, o = e1;
                                } finally{
                                    try {
                                        t || null == s.return || s.return();
                                    } finally{
                                        if (r) throw o;
                                    }
                                }
                            }
                        },
                        {
                            key: "updateTextures",
                            value: function() {
                                var e1 = !0, t = !1, r = void 0;
                                try {
                                    for(var o, n = this.samplers[Symbol.iterator](); !(e1 = (o = n.next()).done); e1 = !0){
                                        var s = o.value.texture;
                                        s && s.update();
                                    }
                                } catch (e1) {
                                    t = !0, r = e1;
                                } finally{
                                    try {
                                        e1 || null == n.return || n.return();
                                    } finally{
                                        if (t) throw r;
                                    }
                                }
                            }
                        },
                        {
                            key: "unbindTextures",
                            value: function() {
                                var e1 = !0, t = !1, r = void 0;
                                try {
                                    for(var o, n = this.samplers[Symbol.iterator](); !(e1 = (o = n.next()).done); e1 = !0){
                                        var s = o.value;
                                        this.setUniform(s.name, this._renderer._getEmptyTexture());
                                    }
                                } catch (e1) {
                                    t = !0, r = e1;
                                } finally{
                                    try {
                                        e1 || null == n.return || n.return();
                                    } finally{
                                        if (t) throw r;
                                    }
                                }
                            }
                        },
                        {
                            key: "_setMatrixUniforms",
                            value: function() {
                                var e1 = this._renderer._curCamera.cameraMatrix, t = this._renderer.uPMatrix, r = this._renderer.uMVMatrix, o = r.copy();
                                o.mult(t), this.isStrokeShader() && ("default" === this._renderer._curCamera.cameraType ? this.setUniform("uPerspective", 1) : this.setUniform("uPerspective", 0)), this.setUniform("uViewMatrix", e1.mat4), this.setUniform("uProjectionMatrix", t.mat4), this.setUniform("uModelViewMatrix", r.mat4), this.setUniform("uModelViewProjectionMatrix", o.mat4), this.uniforms.uNormalMatrix && (this._renderer.uNMatrix.inverseTranspose(this._renderer.uMVMatrix), this.setUniform("uNormalMatrix", this._renderer.uNMatrix.mat3));
                            }
                        },
                        {
                            key: "useProgram",
                            value: function() {
                                var e1 = this._renderer.GL;
                                return this._renderer._curShader !== this && (e1.useProgram(this._glProgram), this._renderer._curShader = this), this;
                            }
                        },
                        {
                            key: "setUniform",
                            value: function(e1, t) {
                                var r = this.uniforms[e1];
                                if (r) {
                                    var o = this._renderer.GL;
                                    if (r.isArray) {
                                        if (r._cachedData && this._renderer._arraysEqual(r._cachedData, t)) return;
                                        r._cachedData = t.slice(0);
                                    } else {
                                        if (r._cachedData && r._cachedData === t) return;
                                        Array.isArray(t) ? r._cachedData = t.slice(0) : r._cachedData = t;
                                    }
                                    var n = r.location;
                                    switch(this.useProgram(), r.type){
                                        case o.BOOL:
                                            !0 === t ? o.uniform1i(n, 1) : o.uniform1i(n, 0);
                                            break;
                                        case o.INT:
                                            1 < r.size ? t.length && o.uniform1iv(n, t) : o.uniform1i(n, t);
                                            break;
                                        case o.FLOAT:
                                            1 < r.size ? t.length && o.uniform1fv(n, t) : o.uniform1f(n, t);
                                            break;
                                        case o.FLOAT_MAT3:
                                            o.uniformMatrix3fv(n, !1, t);
                                            break;
                                        case o.FLOAT_MAT4:
                                            o.uniformMatrix4fv(n, !1, t);
                                            break;
                                        case o.FLOAT_VEC2:
                                            1 < r.size ? t.length && o.uniform2fv(n, t) : o.uniform2f(n, t[0], t[1]);
                                            break;
                                        case o.FLOAT_VEC3:
                                            1 < r.size ? t.length && o.uniform3fv(n, t) : o.uniform3f(n, t[0], t[1], t[2]);
                                            break;
                                        case o.FLOAT_VEC4:
                                            1 < r.size ? t.length && o.uniform4fv(n, t) : o.uniform4f(n, t[0], t[1], t[2], t[3]);
                                            break;
                                        case o.INT_VEC2:
                                            1 < r.size ? t.length && o.uniform2iv(n, t) : o.uniform2i(n, t[0], t[1]);
                                            break;
                                        case o.INT_VEC3:
                                            1 < r.size ? t.length && o.uniform3iv(n, t) : o.uniform3i(n, t[0], t[1], t[2]);
                                            break;
                                        case o.INT_VEC4:
                                            1 < r.size ? t.length && o.uniform4iv(n, t) : o.uniform4i(n, t[0], t[1], t[2], t[3]);
                                            break;
                                        case o.SAMPLER_2D:
                                            o.activeTexture(o.TEXTURE0 + r.samplerIndex), r.texture = t instanceof s.default.Texture ? t : this._renderer.getTexture(t), o.uniform1i(n, r.samplerIndex), r.texture.src.gifProperties && r.texture.src._animateGif(this._renderer._pInst);
                                    }
                                    return this;
                                }
                            }
                        },
                        {
                            key: "isLightShader",
                            value: function() {
                                return void 0 !== this.attributes.aNormal || void 0 !== this.uniforms.uUseLighting || void 0 !== this.uniforms.uAmbientLightCount || void 0 !== this.uniforms.uDirectionalLightCount || void 0 !== this.uniforms.uPointLightCount || void 0 !== this.uniforms.uAmbientColor || void 0 !== this.uniforms.uDirectionalDiffuseColors || void 0 !== this.uniforms.uDirectionalSpecularColors || void 0 !== this.uniforms.uPointLightLocation || void 0 !== this.uniforms.uPointLightDiffuseColors || void 0 !== this.uniforms.uPointLightSpecularColors || void 0 !== this.uniforms.uLightingDirection || void 0 !== this.uniforms.uSpecular;
                            }
                        },
                        {
                            key: "isNormalShader",
                            value: function() {
                                return void 0 !== this.attributes.aNormal;
                            }
                        },
                        {
                            key: "isTextureShader",
                            value: function() {
                                return 0 < this.samplers.length;
                            }
                        },
                        {
                            key: "isColorShader",
                            value: function() {
                                return void 0 !== this.attributes.aVertexColor || void 0 !== this.uniforms.uMaterialColor;
                            }
                        },
                        {
                            key: "isTexLightShader",
                            value: function() {
                                return this.isLightShader() && this.isTextureShader();
                            }
                        },
                        {
                            key: "isStrokeShader",
                            value: function() {
                                return void 0 !== this.uniforms.uStrokeWeight;
                            }
                        },
                        {
                            key: "enableAttrib",
                            value: function(e1, t, r, o, n, s) {
                                var i;
                                return e1 && -1 !== (e1 = e1.location) && (i = this._renderer.GL, this._renderer.registerEnabled.has(e1) || (i.enableVertexAttribArray(e1), this._renderer.registerEnabled.add(e1)), this._renderer.GL.vertexAttribPointer(e1, t, r || i.FLOAT, o || !1, n || 0, s || 0)), this;
                            }
                        },
                        {
                            key: "disableRemainingAttributes",
                            value: function() {
                                var r = this, e1 = !0, t = !1, o = void 0;
                                try {
                                    for(var n, s = this._renderer.registerEnabled.values()[Symbol.iterator](); !(e1 = (n = s.next()).done); e1 = !0)!function() {
                                        var t = n.value;
                                        Object.keys(r.attributes).some(function(e1) {
                                            return r.attributes[e1].location === t;
                                        }) || (r._renderer.GL.disableVertexAttribArray(t), r._renderer.registerEnabled.delete(t));
                                    }();
                                } catch (e1) {
                                    t = !0, o = e1;
                                } finally{
                                    try {
                                        e1 || null == s.return || s.return();
                                    } finally{
                                        if (t) throw o;
                                    }
                                }
                            }
                        }
                    ], n(e1.prototype, t), r && n(e1, r), o;
                }();
                e1 = s.default.Shader;
                r.default = e1;
            },
            {
                "../core/main": 275,
                "core-js/modules/es.array.index-of": 160,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.array.slice": 165,
                "core-js/modules/es.array.some": 166,
                "core-js/modules/es.function.name": 168,
                "core-js/modules/es.object.keys": 181,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        334: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.checkWebGLCapabilities = m, r.default = r.MipmapTexture = void 0;
                var s = (p = e1("../core/main")) && p.__esModule ? p : {
                    default: p
                }, a = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = l();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function l() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, l = function() {
                        return e1;
                    }, e1);
                }
                function u(e1, t) {
                    return (u = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function c(r) {
                    return function() {
                        var e1, t = n(r), t = (e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = n(this).constructor, Reflect.construct(t, arguments, e1)) : t.apply(this, arguments), this);
                        if (!e1 || "object" !== i(e1) && "function" != typeof e1) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }
                        return e1;
                    };
                }
                function n(e1) {
                    return (n = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                function d(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function h(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function f(e1, t, r) {
                    t && h(e1.prototype, t), r && h(e1, r);
                }
                s.default.Texture = function() {
                    function n(e1, t, r) {
                        d(this, n), this._renderer = e1;
                        var o = this._renderer.GL, r = (r = r || {}, this.src = t, this.glTex = void 0, this.glTarget = o.TEXTURE_2D, this.glFormat = r.format || o.RGBA, this.mipmaps = !1, this.glMinFilter = r.minFilter || o.LINEAR, this.glMagFilter = r.magFilter || o.LINEAR, this.glWrapS = r.wrapS || o.CLAMP_TO_EDGE, this.glWrapT = r.wrapT || o.CLAMP_TO_EDGE, this.glDataType = r.dataType || o.UNSIGNED_BYTE, m(e1)), e1 = (this.glFormat !== o.HALF_FLOAT || r.halfFloat || (console.log("This device does not support dataType HALF_FLOAT. Falling back to FLOAT."), this.glDataType = o.FLOAT), this.glFormat !== o.HALF_FLOAT || this.glMinFilter !== o.LINEAR && this.glMagFilter !== o.LINEAR || r.halfFloatLinear || (console.log("This device does not support linear filtering for dataType FLOAT. Falling back to NEAREST."), this.glMinFilter === o.LINEAR && (this.glMinFilter = o.NEAREST), this.glMagFilter === o.LINEAR && (this.glMagFilter = o.NEAREST)), this.glFormat !== o.FLOAT || r.float || (console.log("This device does not support dataType FLOAT. Falling back to UNSIGNED_BYTE."), this.glDataType = o.UNSIGNED_BYTE), this.glFormat !== o.FLOAT || this.glMinFilter !== o.LINEAR && this.glMagFilter !== o.LINEAR || r.floatLinear || (console.log("This device does not support linear filtering for dataType FLOAT. Falling back to NEAREST."), this.glMinFilter === o.LINEAR && (this.glMinFilter = o.NEAREST), this.glMagFilter === o.LINEAR && (this.glMagFilter = o.NEAREST)), this.isSrcMediaElement = void 0 !== s.default.MediaElement && t instanceof s.default.MediaElement, this._videoPrevUpdateTime = 0, this.isSrcHTMLElement = void 0 !== s.default.Element && t instanceof s.default.Element && !(t instanceof s.default.Graphics) && !(t instanceof s.default.Renderer), this.isSrcP5Image = t instanceof s.default.Image, this.isSrcP5Graphics = t instanceof s.default.Graphics, this.isSrcP5Renderer = t instanceof s.default.Renderer, this.isImageData = "undefined" != typeof ImageData && t instanceof ImageData, this.isFramebufferTexture = t instanceof s.default.FramebufferTexture, this._getTextureDataFromSource());
                        return this.width = e1.width, this.height = e1.height, this.init(e1), this;
                    }
                    return f(n, [
                        {
                            key: "_getTextureDataFromSource",
                            value: function() {
                                var e1;
                                return this.isFramebufferTexture ? e1 = this.src.rawTexture() : this.isSrcP5Image ? e1 = this.src.canvas : this.isSrcMediaElement || this.isSrcP5Graphics || this.isSrcP5Renderer || this.isSrcHTMLElement ? e1 = this.src.elt : this.isImageData && (e1 = this.src), e1;
                            }
                        },
                        {
                            key: "init",
                            value: function(e1) {
                                var t, r = this._renderer.GL;
                                this.isFramebufferTexture || (this.glTex = r.createTexture()), this.glWrapS = this._renderer.textureWrapX, this.glWrapT = this._renderer.textureWrapY, this.setWrapMode(this.glWrapS, this.glWrapT), this.bindTexture(), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, this.glMagFilter), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, this.glMinFilter), this.isFramebufferTexture || (0 === this.width || 0 === this.height || this.isSrcMediaElement && !this.src.loadedmetadata ? (t = new Uint8Array([
                                    1,
                                    1,
                                    1,
                                    1
                                ]), r.texImage2D(this.glTarget, 0, r.RGBA, 1, 1, 0, this.glFormat, this.glDataType, t)) : r.texImage2D(this.glTarget, 0, this.glFormat, this.glFormat, this.glDataType, e1));
                            }
                        },
                        {
                            key: "update",
                            value: function() {
                                var e1, t, r, o = this.src;
                                return 0 !== o.width && 0 !== o.height && !this.isFramebufferTexture && (e1 = this._getTextureDataFromSource(), t = !1, r = this._renderer.GL, e1.width !== this.width || e1.height !== this.height ? (t = !0, this.width = e1.width || o.width, this.height = e1.height || o.height, this.isSrcP5Image ? o.setModified(!1) : (this.isSrcMediaElement || this.isSrcHTMLElement) && o.setModified(!0)) : this.isSrcP5Image ? o.isModified() && o.setModified((t = !0, false)) : this.isSrcMediaElement ? o.isModified() ? o.setModified((t = !0, false)) : o.loadedmetadata && this._videoPrevUpdateTime !== o.time() && (this._videoPrevUpdateTime = o.time(), t = !0) : this.isImageData ? o._dirty && (t = (o._dirty = !1, true)) : t = !0, t && (this.bindTexture(), r.texImage2D(this.glTarget, 0, this.glFormat, this.glFormat, this.glDataType, e1)), t);
                            }
                        },
                        {
                            key: "bindTexture",
                            value: function() {
                                return this._renderer.GL.bindTexture(this.glTarget, this.getTexture()), this;
                            }
                        },
                        {
                            key: "unbindTexture",
                            value: function() {
                                this._renderer.GL.bindTexture(this.glTarget, null);
                            }
                        },
                        {
                            key: "getTexture",
                            value: function() {
                                return this.isFramebufferTexture ? this.src.rawTexture() : this.glTex;
                            }
                        },
                        {
                            key: "setInterpolation",
                            value: function(e1, t) {
                                var r = this._renderer.GL;
                                this.glMinFilter = this.glFilter(e1), this.glMagFilter = this.glFilter(t), this.bindTexture(), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, this.glMinFilter), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, this.glMagFilter), this.unbindTexture();
                            }
                        },
                        {
                            key: "glFilter",
                            value: function(e1) {
                                var t = this._renderer.GL;
                                return e1 === a.NEAREST ? t.NEAREST : t.LINEAR;
                            }
                        },
                        {
                            key: "setWrapMode",
                            value: function(e1, t) {
                                function r(e1) {
                                    return 0 == (e1 & e1 - 1);
                                }
                                var o = this._renderer.GL, n = this._getTextureDataFromSource(), n = n.naturalWidth && n.naturalHeight ? (s = n.naturalWidth, n.naturalHeight) : (s = this.width, this.height), s = r(s), n = r(n);
                                e1 === a.REPEAT ? this._renderer.webglVersion === a.WEBGL2 || s && n ? this.glWrapS = o.REPEAT : (console.warn("You tried to set the wrap mode to REPEAT but the texture size is not a power of two. Setting to CLAMP instead"), this.glWrapS = o.CLAMP_TO_EDGE) : e1 === a.MIRROR ? this._renderer.webglVersion === a.WEBGL2 || s && n ? this.glWrapS = o.MIRRORED_REPEAT : (console.warn("You tried to set the wrap mode to MIRROR but the texture size is not a power of two. Setting to CLAMP instead"), this.glWrapS = o.CLAMP_TO_EDGE) : this.glWrapS = o.CLAMP_TO_EDGE, t === a.REPEAT ? this._renderer.webglVersion === a.WEBGL2 || s && n ? this.glWrapT = o.REPEAT : (console.warn("You tried to set the wrap mode to REPEAT but the texture size is not a power of two. Setting to CLAMP instead"), this.glWrapT = o.CLAMP_TO_EDGE) : t === a.MIRROR ? this._renderer.webglVersion === a.WEBGL2 || s && n ? this.glWrapT = o.MIRRORED_REPEAT : (console.warn("You tried to set the wrap mode to MIRROR but the texture size is not a power of two. Setting to CLAMP instead"), this.glWrapT = o.CLAMP_TO_EDGE) : this.glWrapT = o.CLAMP_TO_EDGE, this.bindTexture(), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, this.glWrapS), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, this.glWrapT), this.unbindTexture();
                            }
                        }
                    ]), n;
                }();
                var p = function(e1) {
                    var t = n;
                    if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e1 && e1.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e1 && u(t, e1);
                    var o = c(n);
                    function n(e1, t, r) {
                        d(this, n);
                        t = (e1 = o.call(this, e1, t, r))._renderer.GL;
                        return e1.glMinFilter === t.LINEAR && (e1.glMinFilter = t.LINEAR_MIPMAP_LINEAR), e1;
                    }
                    return f(n, [
                        {
                            key: "glFilter",
                            value: function(e1) {
                                return this._renderer.GL.LINEAR_MIPMAP_LINEAR;
                            }
                        },
                        {
                            key: "_getTextureDataFromSource",
                            value: function() {
                                return this.src;
                            }
                        },
                        {
                            key: "init",
                            value: function(e1) {
                                var t = this._renderer.GL;
                                this.glTex = t.createTexture(), this.bindTexture();
                                for(var r = 0; r < e1.length; r++)t.texImage2D(this.glTarget, r, this.glFormat, this.glFormat, this.glDataType, e1[r]);
                                this.glMinFilter = t.LINEAR_MIPMAP_LINEAR, t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, this.glMagFilter), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, this.glMinFilter), this.unbindTexture();
                            }
                        },
                        {
                            key: "update",
                            value: function() {}
                        }
                    ]), n;
                }(s.default.Texture);
                function m(e1) {
                    var t = e1.GL, e1 = e1.webglVersion, r = e1 === a.WEBGL2 ? t.getExtension("EXT_color_buffer_float") && t.getExtension("EXT_float_blend") : t.getExtension("OES_texture_float"), o = r && t.getExtension("OES_texture_float_linear"), e1 = e1 === a.WEBGL2 ? t.getExtension("EXT_color_buffer_float") : t.getExtension("OES_texture_half_float");
                    return {
                        float: r,
                        floatLinear: o,
                        halfFloat: e1,
                        halfFloatLinear: e1 && t.getExtension("OES_texture_half_float_linear")
                    };
                }
                r.MipmapTexture = p;
                e1 = s.default.Texture;
                r.default = e1;
            },
            {
                "../core/constants": 264,
                "../core/main": 275,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.get-prototype-of": 180,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.reflect.construct": 184,
                "core-js/modules/es.regexp.to-string": 188,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.typed-array.copy-within": 205,
                "core-js/modules/es.typed-array.every": 206,
                "core-js/modules/es.typed-array.fill": 207,
                "core-js/modules/es.typed-array.filter": 208,
                "core-js/modules/es.typed-array.find": 210,
                "core-js/modules/es.typed-array.find-index": 209,
                "core-js/modules/es.typed-array.for-each": 213,
                "core-js/modules/es.typed-array.includes": 214,
                "core-js/modules/es.typed-array.index-of": 215,
                "core-js/modules/es.typed-array.iterator": 218,
                "core-js/modules/es.typed-array.join": 219,
                "core-js/modules/es.typed-array.last-index-of": 220,
                "core-js/modules/es.typed-array.map": 221,
                "core-js/modules/es.typed-array.reduce": 223,
                "core-js/modules/es.typed-array.reduce-right": 222,
                "core-js/modules/es.typed-array.reverse": 224,
                "core-js/modules/es.typed-array.set": 225,
                "core-js/modules/es.typed-array.slice": 226,
                "core-js/modules/es.typed-array.some": 227,
                "core-js/modules/es.typed-array.sort": 228,
                "core-js/modules/es.typed-array.subarray": 229,
                "core-js/modules/es.typed-array.to-locale-string": 230,
                "core-js/modules/es.typed-array.to-string": 231,
                "core-js/modules/es.typed-array.uint8-array": 234,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ],
        335: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.sub"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.sub"), e1("core-js/modules/web.dom-collections.iterator");
                var n, B = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, M = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function G(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function V(e1, t, r) {
                    t && s(e1.prototype, t), r && s(e1, r);
                }
                e1("./p5.Shader"), e1("./p5.RendererGL.Retained"), B.default.RendererGL.prototype._applyTextProperties = function() {}, B.default.RendererGL.prototype.textWidth = function(e1) {
                    return this._isOpenType() ? this._textFont._textWidth(e1, this._textSize) : 0;
                };
                var l = function() {
                    function r(e1, t) {
                        G(this, r), this.width = e1, this.height = t, this.infos = [];
                    }
                    return V(r, [
                        {
                            key: "findImage",
                            value: function(e1) {
                                var t, r, o = this.width * this.height;
                                if (o < e1) throw new Error("font is too complex to render in 3D");
                                for(var n = this.infos.length - 1; 0 <= n; --n){
                                    var s = this.infos[n];
                                    if (s.index + e1 < o) {
                                        r = (t = s).imageData;
                                        break;
                                    }
                                }
                                if (!t) {
                                    try {
                                        r = new ImageData(this.width, this.height);
                                    } catch (e1) {
                                        var i = document.getElementsByTagName("canvas")[0], a = !i, l = (i || ((i = document.createElement("canvas")).style.display = "none", document.body.appendChild(i)), i.getContext("2d"));
                                        l && (r = l.createImageData(this.width, this.height)), a && document.body.removeChild(i);
                                    }
                                    this.infos.push(t = {
                                        index: 0,
                                        imageData: r
                                    });
                                }
                                l = t.index;
                                return t.index += e1, r._dirty = !0, {
                                    imageData: r,
                                    index: l
                                };
                            }
                        }
                    ]), r;
                }();
                function z(e1, t, r, o, n) {
                    var s = e1.imageData.data, e1 = 4 * e1.index++;
                    s[e1++] = t, s[e1++] = r, s[e1++] = o, s[+e1] = n;
                }
                var H = Math.sqrt(3), E = function() {
                    function t(e1) {
                        G(this, t), this.font = e1, this.strokeImageInfos = new l(64, 64), this.colDimImageInfos = new l(64, 64), this.rowDimImageInfos = new l(64, 64), this.colCellImageInfos = new l(64, 64), this.rowCellImageInfos = new l(64, 64), this.glyphInfos = {};
                    }
                    return V(t, [
                        {
                            key: "getGlyphInfo",
                            value: function(e1) {
                                var t = this.glyphInfos[e1.index];
                                if (!t) {
                                    var r = e1.getBoundingBox(), o = r.x1, n = r.y1, s = r.x2 - o, i = r.y2 - n, a = e1.path.commands;
                                    if (0 == s || 0 == i || !a.length) return this.glyphInfos[e1.index] = {};
                                    for(var u = [], c = [], d = [], l = 8; 0 <= l; --l)d.push([]);
                                    for(l = 8; 0 <= l; --l)c.push([]);
                                    var h, f, p, m, D = function() {
                                        function n(e1, t, r, o) {
                                            G(this, n), this.p0 = e1, this.c0 = t, this.c1 = r, this.p1 = o;
                                        }
                                        return V(n, [
                                            {
                                                key: "toQuadratic",
                                                value: function() {
                                                    return {
                                                        x: this.p0.x,
                                                        y: this.p0.y,
                                                        x1: this.p1.x,
                                                        y1: this.p1.y,
                                                        cx: (3 * (this.c0.x + this.c1.x) - (this.p0.x + this.p1.x)) / 4,
                                                        cy: (3 * (this.c0.y + this.c1.y) - (this.p0.y + this.p1.y)) / 4
                                                    };
                                                }
                                            },
                                            {
                                                key: "quadError",
                                                value: function() {
                                                    return B.default.Vector.sub(B.default.Vector.sub(this.p1, this.p0), B.default.Vector.mult(B.default.Vector.sub(this.c1, this.c0), 3)).mag() / 2;
                                                }
                                            },
                                            {
                                                key: "split",
                                                value: function(e1) {
                                                    var t = B.default.Vector.lerp(this.p0, this.c0, e1), r = B.default.Vector.lerp(this.c0, this.c1, e1), o = B.default.Vector.lerp(t, r, e1), r = (this.c1 = B.default.Vector.lerp(this.c1, this.p1, e1), this.c0 = B.default.Vector.lerp(r, this.c1, e1), B.default.Vector.lerp(o, this.c0, e1)), e1 = new n(this.p0, t, o, r);
                                                    return this.p0 = r, e1;
                                                }
                                            },
                                            {
                                                key: "splitInflections",
                                                value: function() {
                                                    var e1 = B.default.Vector.sub(this.c0, this.p0), t = B.default.Vector.sub(B.default.Vector.sub(this.c1, this.c0), e1), r = B.default.Vector.sub(B.default.Vector.sub(B.default.Vector.sub(this.p1, this.c1), e1), B.default.Vector.mult(t, 2)), o = [], n = t.x * r.y - t.y * r.x;
                                                    return 0 !== n && 0 <= (e1 = (r = e1.x * r.y - e1.y * r.x) * r - 4 * n * (e1.x * t.y - e1.y * t.x)) && (n < 0 && (n = -n, r = -r), e1 = (-r + (t = Math.sqrt(e1))) / (2 * n), 0 < (r = (-r - t) / (2 * n)) && r < 1 && (o.push(this.split(r)), e1 = 1 - (1 - e1) / (1 - r)), 0 < e1 && e1 < 1 && o.push(this.split(e1))), o.push(this), o;
                                                }
                                            }
                                        ]), n;
                                    }(), y = !0, g = !1, v = void 0;
                                    try {
                                        for(var b, j = a[Symbol.iterator](); !(y = (b = j.next()).done); y = !0){
                                            var _ = b.value, x = (_.x - o) / s, w = (_.y - n) / i;
                                            if (!U(h, f, x, w)) {
                                                switch(_.type){
                                                    case "M":
                                                        p = x, m = w;
                                                        break;
                                                    case "L":
                                                        I(h, f, x, w);
                                                        break;
                                                    case "Q":
                                                        var S = (_.x1 - o) / s, T = (_.y1 - n) / i;
                                                        L([
                                                            h,
                                                            x,
                                                            S
                                                        ], [
                                                            f,
                                                            w,
                                                            T
                                                        ], {
                                                            x: h,
                                                            y: f,
                                                            cx: S,
                                                            cy: T
                                                        });
                                                        break;
                                                    case "Z":
                                                        U(h, f, p, m) ? u.push({
                                                            x: h,
                                                            y: f
                                                        }) : (I(h, f, p, m), u.push({
                                                            x: p,
                                                            y: m
                                                        }));
                                                        break;
                                                    case "C":
                                                        for(var M = function(e1, t, r, o, n, s, i, a) {
                                                            var e1 = new D(new B.default.Vector(e1, t), new B.default.Vector(r, o), new B.default.Vector(n, s), new B.default.Vector(i, a)).splitInflections(), l = [], u = 30 / H, c = !0, t = !1, r = void 0;
                                                            try {
                                                                for(var d, h = e1[Symbol.iterator](); !(c = (d = h.next()).done); c = !0){
                                                                    for(var f = d.value, p = [], m = void 0; !(.125 <= (m = u / f.quadError()));){
                                                                        var y = Math.pow(m, 1 / 3), g = f.split(y), v = f.split(1 - y / (1 - y));
                                                                        l.push(g), p.push(f), f = v;
                                                                    }
                                                                    m < 1 && l.push(f.split(.5)), l.push(f), Array.prototype.push.apply(l, p.reverse());
                                                                }
                                                            } catch (e1) {
                                                                t = !0, r = e1;
                                                            } finally{
                                                                try {
                                                                    c || null == h.return || h.return();
                                                                } finally{
                                                                    if (t) throw r;
                                                                }
                                                            }
                                                            return l;
                                                        }(h, f, (_.x1 - o) / s, (_.y1 - n) / i, (_.x2 - o) / s, (_.y2 - n) / i, x, w), E = 0; E < M.length; E++){
                                                            var k = M[E].toQuadratic();
                                                            L([
                                                                k.x,
                                                                k.x1,
                                                                k.cx
                                                            ], [
                                                                k.y,
                                                                k.y1,
                                                                k.cy
                                                            ], k);
                                                        }
                                                        break;
                                                    default:
                                                        throw new Error("unknown command type: ".concat(_.type));
                                                }
                                                h = x, f = w;
                                            }
                                        }
                                    } catch (e1) {
                                        g = !0, v = e1;
                                    } finally{
                                        try {
                                            y || null == j.return || j.return();
                                        } finally{
                                            if (g) throw v;
                                        }
                                    }
                                    for(var C = u.length, O = this.strokeImageInfos.findImage(C), F = O.index, P = 0; P < C; ++P){
                                        var A = u[P];
                                        z(O, R(A.x), R(A.y), R(A.cx), R(A.cy));
                                    }
                                    (t = this.glyphInfos[e1.index] = {
                                        glyph: e1,
                                        uGlyphRect: [
                                            r.x1,
                                            -r.y1,
                                            r.x2,
                                            -r.y2
                                        ],
                                        strokeImageInfo: O,
                                        strokes: u,
                                        colInfo: N(d, this.colDimImageInfos, this.colCellImageInfos),
                                        rowInfo: N(c, this.rowDimImageInfos, this.rowCellImageInfos)
                                    }).uGridOffset = [
                                        t.colInfo.dimOffset,
                                        t.rowInfo.dimOffset
                                    ];
                                }
                                return t;
                                function L(e1, t, r) {
                                    var o = u.length;
                                    function n(e1, t, r) {
                                        for(var o = e1.length; 0 < o--;){
                                            var n = e1[o];
                                            n < t && (t = n), r < n && (r = n);
                                        }
                                        return {
                                            min: t,
                                            max: r
                                        };
                                    }
                                    u.push(r);
                                    for(var r = n(e1, 1, 0), e1 = Math.max(Math.floor(9 * r.min - .5), 0), s = Math.min(Math.ceil(9 * r.max + .5), 9), i = e1; i < s; ++i)d[i].push(o);
                                    for(var r = n(t, 1, 0), e1 = Math.max(Math.floor(9 * r.min - .5), 0), a = Math.min(Math.ceil(9 * r.max + .5), 9), l = e1; l < a; ++l)c[l].push(o);
                                }
                                function R(e1) {
                                    var t, r;
                                    return (e1 = (r = 255) * e1) < (t = 0) ? t : r < e1 ? r : e1;
                                }
                                function I(e1, t, r, o) {
                                    L([
                                        e1,
                                        r
                                    ], [
                                        t,
                                        o
                                    ], {
                                        x: e1,
                                        y: t,
                                        cx: (e1 + r) / 2,
                                        cy: (t + o) / 2
                                    });
                                }
                                function U(e1, t, r, o) {
                                    return Math.abs(r - e1) < 1e-5 && Math.abs(o - t) < 1e-5;
                                }
                                function N(e1, t, r) {
                                    for(var o = e1.length, n = t.findImage(o), t = n.index, s = 0, i = 0; i < o; ++i)s += e1[i].length;
                                    for(var a = r.findImage(s), l = 0; l < o; ++l){
                                        var u = e1[l], c = u.length, d = a.index;
                                        z(n, d >> 7, 127 & d, c >> 7, 127 & c);
                                        for(var h = 0; h < c; ++h){
                                            var f = u[h] + F;
                                            z(a, f >> 7, 127 & f, 0, 0);
                                        }
                                    }
                                    return {
                                        cellImageInfo: a,
                                        dimOffset: t,
                                        dimImageInfo: n
                                    };
                                }
                            }
                        }
                    ]), t;
                }();
                B.default.RendererGL.prototype._renderText = function(e1, t, r, o, n) {
                    if (this._textFont && "string" != typeof this._textFont) {
                        if (!(n <= o) && this._doFill) {
                            if (this._isOpenType()) {
                                e1.push();
                                var n = this._doStroke, s = this.drawMode, i = (this._doStroke = !1, this.drawMode = M.TEXTURE, this._textFont.font), a = (a = this._textFont._fontInfo) || (this._textFont._fontInfo = new E(i)), r = this._textFont._handleAlignment(this, t, r, o), o = this._textSize / i.unitsPerEm, l = (this.translate(r.x, r.y, 0), this.scale(o, o, 1), this.GL), r = !this._defaultFontShader, u = this._getFontShader(), c = (u.init(), u.bindShader(), r && (u.setUniform("uGridImageSize", [
                                    64,
                                    64
                                ]), u.setUniform("uCellsImageSize", [
                                    64,
                                    64
                                ]), u.setUniform("uStrokeImageSize", [
                                    64,
                                    64
                                ]), u.setUniform("uGridSize", [
                                    9,
                                    9
                                ])), this._applyColorBlend(this.curFillColor), this.retainedMode.geometry.glyph), d = (c || ((o = this._textGeom = new B.default.Geometry(1, 1, function() {
                                    for(var e1 = 0; e1 <= 1; e1++)for(var t = 0; t <= 1; t++)this.vertices.push(new B.default.Vector(t, e1, 0)), this.uvs.push(t, e1);
                                })).computeFaces().computeNormals(), c = this.createBuffers("glyph", o)), !0), r = !1, o = void 0;
                                try {
                                    for(var h, f = this.retainedMode.buffers.text[Symbol.iterator](); !(d = (h = f.next()).done); d = !0)h.value._prepareBuffer(c, u);
                                } catch (e1) {
                                    r = !0, o = e1;
                                } finally{
                                    try {
                                        d || null == f.return || f.return();
                                    } finally{
                                        if (r) throw o;
                                    }
                                }
                                this._bindBuffer(c.indexBuffer, l.ELEMENT_ARRAY_BUFFER), u.setUniform("uMaterialColor", this.curFillColor), l.pixelStorei(l.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1);
                                try {
                                    var p = 0, m = null, y = i.stringToGlyphs(t), g = !0, v = !1, b = void 0;
                                    try {
                                        for(var j, _ = y[Symbol.iterator](); !(g = (j = _.next()).done); g = !0){
                                            var x, w, S = j.value, T = (m && (p += i.getKerningValue(m, S)), a.getGlyphInfo(S));
                                            T.uGlyphRect && (x = T.rowInfo, w = T.colInfo, u.setUniform("uSamplerStrokes", T.strokeImageInfo.imageData), u.setUniform("uSamplerRowStrokes", x.cellImageInfo.imageData), u.setUniform("uSamplerRows", x.dimImageInfo.imageData), u.setUniform("uSamplerColStrokes", w.cellImageInfo.imageData), u.setUniform("uSamplerCols", w.dimImageInfo.imageData), u.setUniform("uGridOffset", T.uGridOffset), u.setUniform("uGlyphRect", T.uGlyphRect), u.setUniform("uGlyphOffset", p), u.bindTextures(), l.drawElements(l.TRIANGLES, 6, this.GL.UNSIGNED_SHORT, 0)), p += S.advanceWidth, m = S;
                                        }
                                    } catch (e1) {
                                        v = !0, b = e1;
                                    } finally{
                                        try {
                                            g || null == _.return || _.return();
                                        } finally{
                                            if (v) throw b;
                                        }
                                    }
                                } finally{
                                    u.unbindShader(), this._doStroke = n, this.drawMode = s, l.pixelStorei(l.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0), e1.pop();
                                }
                            } else console.log("WEBGL: only Opentype (.otf) and Truetype (.ttf) fonts are supported");
                            return e1;
                        }
                    } else console.log("WEBGL: you must load and set a font before drawing text. See `loadFont` and `textFont` for more details.");
                };
            },
            {
                "../core/constants": 264,
                "../core/main": 275,
                "./p5.RendererGL.Retained": 331,
                "./p5.Shader": 333,
                "core-js/modules/es.array.iterator": 161,
                "core-js/modules/es.object.get-own-property-descriptor": 178,
                "core-js/modules/es.object.to-string": 182,
                "core-js/modules/es.regexp.exec": 187,
                "core-js/modules/es.string.iterator": 192,
                "core-js/modules/es.string.split": 198,
                "core-js/modules/es.string.sub": 200,
                "core-js/modules/es.symbol": 204,
                "core-js/modules/es.symbol.description": 202,
                "core-js/modules/es.symbol.iterator": 203,
                "core-js/modules/es.weak-map": 236,
                "core-js/modules/web.dom-collections.iterator": 238
            }
        ]
    }, {}, [
        259
    ])(259);
});


/** [p5.sound]  Version: 1.0.1 - 2021-05-25 */ /**
 *  <p>p5.sound extends p5 with <a href="http://caniuse.com/audio-api"
 *  target="_blank">Web Audio</a> functionality including audio input,
 *  playback, analysis and synthesis.
 *  </p>
 *  <ul>
 *  <li><a href="#/p5.SoundFile"><b>p5.SoundFile</b></a>: Load and play sound files.</li>
 *  <li><a href="#/p5.Amplitude"><b>p5.Amplitude</b></a>: Get the current volume of a sound.</li>
 *  <li><a href="#/p5.AudioIn"><b>p5.AudioIn</b></a>: Get sound from an input source, typically
 *    a computer microphone.</li>
 *  <li><a href="#/p5.FFT"><b>p5.FFT</b></a>: Analyze the frequency of sound. Returns
 *    results from the frequency spectrum or time domain (waveform).</li>
 *  <li><a href="#/p5.Oscillator"><b>p5.Oscillator</b></a>: Generate Sine,
 *    Triangle, Square and Sawtooth waveforms. Base class of
 *    <li><a href="#/p5.Noise">p5.Noise</a> and <a href="#/p5.Pulse">p5.Pulse</a>.
 *    </li>
 *  <li>
 *    <a href="#/p5.MonoSynth">p5.MonoSynth</a> and <a href="#/p5.PolySynth">p5.PolySynth</a>: Play musical notes
 *  </li>
 *  <li><a href="#/p5.Envelope"><b>p5.Envelope</b></a>: An Envelope is a series
 *    of fades over time. Often used to control an object's
 *    output gain level as an "ADSR Envelope" (Attack, Decay,
 *    Sustain, Release). Can also modulate other parameters.</li>
 *  <li><a href="#/p5.Delay"><b>p5.Delay</b></a>: A delay effect with
 *    parameters for feedback, delayTime, and lowpass filter.</li>
 *  <li><a href="#/p5.Filter"><b>p5.Filter</b></a>: Filter the frequency range of a
 *    sound.
 *  </li>
 *  <li><a href="#/p5.Reverb"><b>p5.Reverb</b></a>: Add reverb to a sound by specifying
 *    duration and decay. </li>
 *  <b><li><a href="#/p5.Convolver">p5.Convolver</a>:</b> Extends
 *  <a href="#/p5.Reverb">p5.Reverb</a> to simulate the sound of real
 *    physical spaces through convolution.</li>
 *  <b><li><a href="#/p5.SoundRecorder">p5.SoundRecorder</a></b>: Record sound for playback
 *    / save the .wav file.
 *  <b><li><a href="#/p5.SoundLoop">p5.SoundLoop</a>, <a href="#/p5.Phrase">p5.Phrase</a></b>, <b><a href="#/p5.Part">p5.Part</a></b> and
 *  <b><a href="#/p5.Score">p5.Score</a></b>: Compose musical sequences.
 *  </li>
 *  <li><a href="#/p5/userStartAudio">userStartAudio</a>: Enable audio in a
 *  browser- and user-friendly way.</a>
 *  <p>p5.sound is on <a href="https://github.com/processing/p5.js-sound/">GitHub</a>.
 *  Download the latest version
 *  <a href="https://github.com/processing/p5.js-sound/blob/master/lib/p5.sound.js">here</a>.</p>
 *
 *  @module p5.sound
 *  @submodule p5.sound
 *  @for p5.sound
 *  @main
 */ /**
 *  p5.sound 
 *  https://p5js.org/reference/#/libraries/p5.sound
 *
 *  From the Processing Foundation and contributors
 *  https://github.com/processing/p5.js-sound/graphs/contributors
 *
 *  MIT License (MIT)
 *  https://github.com/processing/p5.js-sound/blob/master/LICENSE
 *
 *  Some of the many audio libraries & resources that inspire p5.sound:
 *   - TONE.js (c) Yotam Mann. Licensed under The MIT License (MIT). https://github.com/TONEnoTONE/Tone.js
 *   - buzz.js (c) Jay Salvat. Licensed under The MIT License (MIT). http://buzz.jaysalvat.com/
 *   - Boris Smus Web Audio API book, 2013. Licensed under the Apache License http://www.apache.org/licenses/LICENSE-2.0
 *   - wavesurfer.js https://github.com/katspaugh/wavesurfer.js
 *   - Web Audio Components by Jordan Santell https://github.com/web-audio-components
 *   - Wilm Thoben's Sound library for Processing https://github.com/processing/processing/tree/master/java/libraries/sound
 *
 *   Web Audio API: http://w3.org/TR/webaudio/
 */ 
(function(modules) {
    var installedModules = {};
    function __webpack_require__(moduleId) {
        if (installedModules[moduleId]) return installedModules[moduleId].exports;
        var module = installedModules[moduleId] = {
            i: moduleId,
            l: false,
            exports: {}
        };
        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        module.l = true;
        return module.exports;
    }
    __webpack_require__.m = modules;
    __webpack_require__.c = installedModules;
    __webpack_require__.d = function(exports, name1, getter) {
        if (!__webpack_require__.o(exports, name1)) Object.defineProperty(exports, name1, {
            enumerable: true,
            get: getter
        });
    };
    __webpack_require__.r = function(exports) {
        if (typeof Symbol !== "undefined" && Symbol.toStringTag) Object.defineProperty(exports, Symbol.toStringTag, {
            value: "Module"
        });
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
    };
    __webpack_require__.t = function(value, mode) {
        if (mode & 1) value = __webpack_require__(value);
        if (mode & 8) return value;
        if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
        var ns = Object.create(null);
        __webpack_require__.r(ns);
        Object.defineProperty(ns, "default", {
            enumerable: true,
            value: value
        });
        if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
            return value[key];
        }).bind(null, key));
        return ns;
    };
    __webpack_require__.n = function(module) {
        var getter = module && module.__esModule ? function getDefault() {
            return module["default"];
        } : function getModuleExports() {
            return module;
        };
        __webpack_require__.d(getter, "a", getter);
        return getter;
    };
    __webpack_require__.o = function(object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    __webpack_require__.p = "";
    return __webpack_require__(__webpack_require__.s = 40);
})([
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
            "use strict";
            function a(t, e) {
                this.isUndef(t) || 1 === t ? this.input = this.context.createGain() : 1 < t && (this.input = new Array(t)), this.isUndef(e) || 1 === e ? this.output = this.context.createGain() : 1 < e && (this.output = new Array(t));
            }
            var e;
            return a.prototype.set = function(t, e, n) {
                if (this.isObject(t)) n = e;
                else if (this.isString(t)) {
                    var o = {};
                    o[t] = e, t = o;
                }
                t: for(var i in t){
                    e = t[i];
                    var r = this;
                    if (-1 !== i.indexOf(".")) {
                        for(var s = i.split("."), u = 0; u < s.length - 1; u++)if ((r = r[s[u]]) instanceof a) {
                            s.splice(0, u + 1);
                            var p = s.join(".");
                            r.set(p, e);
                            continue t;
                        }
                        i = s[s.length - 1];
                    }
                    var c = r[i];
                    this.isUndef(c) || (a.Signal && c instanceof a.Signal || a.Param && c instanceof a.Param ? c.value !== e && (this.isUndef(n) ? c.value = e : c.rampTo(e, n)) : c instanceof AudioParam ? c.value !== e && (c.value = e) : c instanceof a ? c.set(e) : c !== e && (r[i] = e));
                }
                return this;
            }, a.prototype.get = function(t) {
                this.isUndef(t) ? t = this._collectDefaults(this.constructor) : this.isString(t) && (t = [
                    t
                ]);
                for(var e = {}, n = 0; n < t.length; n++){
                    var o = t[n], i = this, r = e;
                    if (-1 !== o.indexOf(".")) {
                        for(var s = o.split("."), u = 0; u < s.length - 1; u++){
                            var p = s[u];
                            r[p] = r[p] || {}, r = r[p], i = i[p];
                        }
                        o = s[s.length - 1];
                    }
                    var c = i[o];
                    this.isObject(t[o]) ? r[o] = c.get() : a.Signal && c instanceof a.Signal ? r[o] = c.value : a.Param && c instanceof a.Param ? r[o] = c.value : c instanceof AudioParam ? r[o] = c.value : c instanceof a ? r[o] = c.get() : this.isFunction(c) || this.isUndef(c) || (r[o] = c);
                }
                return e;
            }, a.prototype._collectDefaults = function(t) {
                var e = [];
                if (this.isUndef(t.defaults) || (e = Object.keys(t.defaults)), !this.isUndef(t._super)) for(var n = this._collectDefaults(t._super), o = 0; o < n.length; o++)-1 === e.indexOf(n[o]) && e.push(n[o]);
                return e;
            }, a.prototype.toString = function() {
                for(var t in a){
                    var e = t[0].match(/^[A-Z]$/), n = a[t] === this.constructor;
                    if (this.isFunction(a[t]) && e && n) return t;
                }
                return "Tone";
            }, Object.defineProperty(a.prototype, "numberOfInputs", {
                get: function() {
                    return this.input ? this.isArray(this.input) ? this.input.length : 1 : 0;
                }
            }), Object.defineProperty(a.prototype, "numberOfOutputs", {
                get: function() {
                    return this.output ? this.isArray(this.output) ? this.output.length : 1 : 0;
                }
            }), a.prototype.dispose = function() {
                return this.isUndef(this.input) || (this.input instanceof AudioNode && this.input.disconnect(), this.input = null), this.isUndef(this.output) || (this.output instanceof AudioNode && this.output.disconnect(), this.output = null), this;
            }, a.prototype.connect = function(t, e, n) {
                return Array.isArray(this.output) ? (e = this.defaultArg(e, 0), this.output[e].connect(t, 0, n)) : this.output.connect(t, e, n), this;
            }, a.prototype.disconnect = function(t, e, n) {
                this.isArray(this.output) ? this.isNumber(t) ? this.output[t].disconnect() : (e = this.defaultArg(e, 0), this.output[e].disconnect(t, 0, n)) : this.output.disconnect.apply(this.output, arguments);
            }, a.prototype.connectSeries = function() {
                if (1 < arguments.length) for(var t = arguments[0], e = 1; e < arguments.length; e++){
                    var n = arguments[e];
                    t.connect(n), t = n;
                }
                return this;
            }, a.prototype.chain = function() {
                if (0 < arguments.length) for(var t = this, e = 0; e < arguments.length; e++){
                    var n = arguments[e];
                    t.connect(n), t = n;
                }
                return this;
            }, a.prototype.fan = function() {
                if (0 < arguments.length) for(var t = 0; t < arguments.length; t++)this.connect(arguments[t]);
                return this;
            }, AudioNode.prototype.chain = a.prototype.chain, AudioNode.prototype.fan = a.prototype.fan, a.prototype.defaultArg = function(t, e) {
                if (this.isObject(t) && this.isObject(e)) {
                    var n = {};
                    for(var o in t)n[o] = this.defaultArg(e[o], t[o]);
                    for(var i in e)n[i] = this.defaultArg(t[i], e[i]);
                    return n;
                }
                return this.isUndef(t) ? e : t;
            }, a.prototype.optionsObject = function(t, e, n) {
                var o = {};
                if (1 === t.length && this.isObject(t[0])) o = t[0];
                else for(var i = 0; i < e.length; i++)o[e[i]] = t[i];
                return this.isUndef(n) ? o : this.defaultArg(o, n);
            }, a.prototype.isUndef = function(t) {
                return void 0 === t;
            }, a.prototype.isFunction = function(t) {
                return "function" == typeof t;
            }, a.prototype.isNumber = function(t) {
                return "number" == typeof t;
            }, a.prototype.isObject = function(t) {
                return "[object Object]" === Object.prototype.toString.call(t) && t.constructor === Object;
            }, a.prototype.isBoolean = function(t) {
                return "boolean" == typeof t;
            }, a.prototype.isArray = function(t) {
                return Array.isArray(t);
            }, a.prototype.isString = function(t) {
                return "string" == typeof t;
            }, a.noOp = function() {}, a.prototype._readOnly = function(t) {
                if (Array.isArray(t)) for(var e = 0; e < t.length; e++)this._readOnly(t[e]);
                else Object.defineProperty(this, t, {
                    writable: !1,
                    enumerable: !0
                });
            }, a.prototype._writable = function(t) {
                if (Array.isArray(t)) for(var e = 0; e < t.length; e++)this._writable(t[e]);
                else Object.defineProperty(this, t, {
                    writable: !0
                });
            }, a.State = {
                Started: "started",
                Stopped: "stopped",
                Paused: "paused"
            }, a.prototype.equalPowerScale = function(t) {
                var e = .5 * Math.PI;
                return Math.sin(t * e);
            }, a.prototype.dbToGain = function(t) {
                return Math.pow(2, t / 6);
            }, a.prototype.gainToDb = function(t) {
                return Math.log(t) / Math.LN10 * 20;
            }, a.prototype.intervalToFrequencyRatio = function(t) {
                return Math.pow(2, t / 12);
            }, a.prototype.now = function() {
                return a.context.now();
            }, a.now = function() {
                return a.context.now();
            }, a.extend = function(t, e) {
                function n() {}
                a.prototype.isUndef(e) && (e = a), n.prototype = e.prototype, t.prototype = new n, (t.prototype.constructor = t)._super = e;
            }, Object.defineProperty(a, "context", {
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = a.Context && t instanceof a.Context ? t : new a.Context(t), a.Context && a.Context.emit("init", e);
                }
            }), Object.defineProperty(a.prototype, "context", {
                get: function() {
                    return a.context;
                }
            }), a.setContext = function(t) {
                a.context = t;
            }, Object.defineProperty(a.prototype, "blockTime", {
                get: function() {
                    return 128 / this.context.sampleRate;
                }
            }), Object.defineProperty(a.prototype, "sampleTime", {
                get: function() {
                    return 1 / this.context.sampleRate;
                }
            }), Object.defineProperty(a, "supported", {
                get: function() {
                    var t = window.hasOwnProperty("AudioContext") || window.hasOwnProperty("webkitAudioContext"), e = window.hasOwnProperty("Promise"), n = window.hasOwnProperty("Worker");
                    return t && e && n;
                }
            }), a.version = "r10", window.TONE_SILENCE_VERSION_LOGGING || console.log("%c * Tone.js " + a.version + " * ", "background: #000; color: #fff"), a;
        }).call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(2),
            __webpack_require__(10)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(i) {
            "use strict";
            return i.Multiply = function(t) {
                this.createInsOuts(2, 0), this._mult = this.input[0] = this.output = new i.Gain, this._param = this.input[1] = this.output.gain, this._param.value = this.defaultArg(t, 0);
            }, i.extend(i.Multiply, i.Signal), i.Multiply.prototype.dispose = function() {
                return i.prototype.dispose.call(this), this._mult.dispose(), this._mult = null, this._param = null, this;
            }, i.Multiply;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(6),
            __webpack_require__(9),
            __webpack_require__(18),
            __webpack_require__(10)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(n) {
            "use strict";
            return n.Signal = function() {
                var t = this.optionsObject(arguments, [
                    "value",
                    "units"
                ], n.Signal.defaults);
                this.output = this._gain = this.context.createGain(), t.param = this._gain.gain, n.Param.call(this, t), this.input = this._param = this._gain.gain, this.context.getConstant(1).chain(this._gain);
            }, n.extend(n.Signal, n.Param), n.Signal.defaults = {
                value: 0,
                units: n.Type.Default,
                convert: !0
            }, n.Signal.prototype.connect = n.SignalBase.prototype.connect, n.Signal.prototype.dispose = function() {
                return n.Param.prototype.dispose.call(this), this._param = null, this._gain.disconnect(), this._gain = null, this;
            }, n.Signal;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        (function(global) {
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return getAudioContext;
            });
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return userStartAudio;
            });
            var startaudiocontext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22);
            var startaudiocontext__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(startaudiocontext__WEBPACK_IMPORTED_MODULE_0__);
            var Tone_core_Tone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
            var Tone_core_Tone__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(Tone_core_Tone__WEBPACK_IMPORTED_MODULE_1__);
            var Tone_core_Context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12);
            var Tone_core_Context__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(Tone_core_Context__WEBPACK_IMPORTED_MODULE_2__);
            global.TONE_SILENCE_VERSION_LOGGING = true;
            var audiocontext = new window.AudioContext();
            Tone_core_Tone__WEBPACK_IMPORTED_MODULE_1___default.a.setContext(audiocontext);
            /**
 * <p>Returns the Audio Context for this sketch. Useful for users
 * who would like to dig deeper into the <a target='_blank' href=
 * 'http://webaudio.github.io/web-audio-api/'>Web Audio API
 * </a>.</p>
 *
 * <p>Some browsers require users to startAudioContext
 * with a user gesture, such as touchStarted in the example below.</p>
 *
 * @for p5
 * @method getAudioContext
 * @return {Object}    AudioContext for this sketch
 * @example
 * <div><code>
 *  function draw() {
 *    background(255);
 *    textAlign(CENTER);
 *
 *    if (getAudioContext().state !== 'running') {
 *      text('click to start audio', width/2, height/2);
 *    } else {
 *      text('audio is enabled', width/2, height/2);
 *    }
 *  }
 *
 *  function touchStarted() {
 *    if (getAudioContext().state !== 'running') {
 *      getAudioContext().resume();
 *    }
 *    var synth = new p5.MonoSynth();
 *    synth.play('A4', 0.5, 0, 0.2);
 *  }
 *
 * </div></code>
 */ function getAudioContext() {
                return audiocontext;
            }
            /**
 *  <p>It is not only a good practice to give users control over starting
 *  audio. This policy is enforced by many web browsers, including iOS and
 *  <a href="https://goo.gl/7K7WLu" title="Google Chrome's autoplay
 *  policy">Google Chrome</a>, which create the Web Audio API's
 *  <a href="https://developer.mozilla.org/en-US/docs/Web/API/AudioContext"
 *  title="Audio Context @ MDN">Audio Context</a>
 *  in a suspended state.</p>
 *
 *  <p>In these browser-specific policies, sound will not play until a user
 *  interaction event (i.e. <code>mousePressed()</code>) explicitly resumes
 *  the AudioContext, or starts an audio node. This can be accomplished by
 *  calling <code>start()</code> on a <code>p5.Oscillator</code>,
 *  <code> play()</code> on a <code>p5.SoundFile</code>, or simply
 *  <code>userStartAudio()</code>.</p>
 *
 *  <p><code>userStartAudio()</code> starts the AudioContext on a user
 *  gesture. The default behavior will enable audio on any
 *  mouseUp or touchEnd event. It can also be placed in a specific
 *  interaction function, such as <code>mousePressed()</code> as in the
 *  example below. This method utilizes
 *  <a href="https://github.com/tambien/StartAudioContext">StartAudioContext
 *  </a>, a library by Yotam Mann (MIT Licence, 2016).</p>
 *  @param  {Element|Array}   [elements] This argument can be an Element,
 *                                Selector String, NodeList, p5.Element,
 *                                jQuery Element, or an Array of any of those.
 *  @param  {Function} [callback] Callback to invoke when the AudioContext
 *                                has started
 *  @return {Promise}            Returns a Promise that resolves when
 *                                       the AudioContext state is 'running'
 *  @method userStartAudio
 *  @for p5
 *  @example
 *  <div><code>
 *  function setup() {
 *    // mimics the autoplay policy
 *    getAudioContext().suspend();
 *
 *    let mySynth = new p5.MonoSynth();
 *
 *    // This won't play until the context has resumed
 *    mySynth.play('A6');
 *  }
 *  function draw() {
 *    background(220);
 *    textAlign(CENTER, CENTER);
 *    text(getAudioContext().state, width/2, height/2);
 *  }
 *  function mousePressed() {
 *    userStartAudio();
 *  }
 *  </code></div>
 */ function userStartAudio(elements, callback) {
                var elt = elements;
                if (elements instanceof (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Element) elt = elements.elt;
                else if (elements instanceof Array && elements[0] instanceof (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Element) elt = elements.map(function(e) {
                    return e.elt;
                });
                return startaudiocontext__WEBPACK_IMPORTED_MODULE_0___default()(audiocontext, elt, callback);
            }
            __webpack_exports__["a"] = audiocontext;
        }).call(this, __webpack_require__(26));
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(2),
            __webpack_require__(10)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(i) {
            "use strict";
            return i.Add = function(t) {
                this.createInsOuts(2, 0), this._sum = this.input[0] = this.input[1] = this.output = new i.Gain, this._param = this.input[1] = new i.Signal(t), this._param.connect(this._sum);
            }, i.extend(i.Add, i.Signal), i.Add.prototype.dispose = function() {
                return i.prototype.dispose.call(this), this._sum.dispose(), this._sum = null, this._param.dispose(), this._param = null, this;
            }, i.Add;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports) {
        module.exports = {
            recorderProcessor: "recorder-processor",
            soundFileProcessor: "sound-file-processor",
            amplitudeProcessor: "amplitude-processor"
        };
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(15)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(e) {
            "use strict";
            return e.WaveShaper = function(e, t) {
                this._shaper = this.input = this.output = this.context.createWaveShaper(), this._curve = null, Array.isArray(e) ? this.curve = e : isFinite(e) || this.isUndef(e) ? this._curve = new Float32Array(this.defaultArg(e, 1024)) : this.isFunction(e) && (this._curve = new Float32Array(this.defaultArg(t, 1024)), this.setMap(e));
            }, e.extend(e.WaveShaper, e.SignalBase), e.WaveShaper.prototype.setMap = function(e) {
                for(var t = 0, r = this._curve.length; t < r; t++){
                    var s = t / (r - 1) * 2 - 1;
                    this._curve[t] = e(s, t);
                }
                return this._shaper.curve = this._curve, this;
            }, Object.defineProperty(e.WaveShaper.prototype, "curve", {
                get: function() {
                    return this._shaper.curve;
                },
                set: function(e) {
                    this._curve = new Float32Array(e), this._shaper.curve = this._curve;
                }
            }), Object.defineProperty(e.WaveShaper.prototype, "oversample", {
                get: function() {
                    return this._shaper.oversample;
                },
                set: function(e) {
                    if (-1 === [
                        "none",
                        "2x",
                        "4x"
                    ].indexOf(e)) throw new RangeError("Tone.WaveShaper: oversampling must be either 'none', '2x', or '4x'");
                    this._shaper.oversample = e;
                }
            }), e.WaveShaper.prototype.dispose = function() {
                return e.prototype.dispose.call(this), this._shaper.disconnect(), this._shaper = null, this._curve = null, this;
            }, e.WaveShaper;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(2),
            __webpack_require__(19)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(o) {
            "use strict";
            return o.TimelineSignal = function() {
                var e = this.optionsObject(arguments, [
                    "value",
                    "units"
                ], o.Signal.defaults);
                this._events = new o.Timeline(10), o.Signal.apply(this, e), e.param = this._param, o.Param.call(this, e), this._initial = this._fromUnits(this._param.value);
            }, o.extend(o.TimelineSignal, o.Param), o.TimelineSignal.Type = {
                Linear: "linear",
                Exponential: "exponential",
                Target: "target",
                Curve: "curve",
                Set: "set"
            }, Object.defineProperty(o.TimelineSignal.prototype, "value", {
                get: function() {
                    var e = this.now(), t = this.getValueAtTime(e);
                    return this._toUnits(t);
                },
                set: function(e) {
                    var t = this._fromUnits(e);
                    this._initial = t, this.cancelScheduledValues(), this._param.value = t;
                }
            }), o.TimelineSignal.prototype.setValueAtTime = function(e, t) {
                return e = this._fromUnits(e), t = this.toSeconds(t), this._events.add({
                    type: o.TimelineSignal.Type.Set,
                    value: e,
                    time: t
                }), this._param.setValueAtTime(e, t), this;
            }, o.TimelineSignal.prototype.linearRampToValueAtTime = function(e, t) {
                return e = this._fromUnits(e), t = this.toSeconds(t), this._events.add({
                    type: o.TimelineSignal.Type.Linear,
                    value: e,
                    time: t
                }), this._param.linearRampToValueAtTime(e, t), this;
            }, o.TimelineSignal.prototype.exponentialRampToValueAtTime = function(e, t) {
                t = this.toSeconds(t);
                var i = this._searchBefore(t);
                i && 0 === i.value && this.setValueAtTime(this._minOutput, i.time), e = this._fromUnits(e);
                var n = Math.max(e, this._minOutput);
                return this._events.add({
                    type: o.TimelineSignal.Type.Exponential,
                    value: n,
                    time: t
                }), e < this._minOutput ? (this._param.exponentialRampToValueAtTime(this._minOutput, t - this.sampleTime), this.setValueAtTime(0, t)) : this._param.exponentialRampToValueAtTime(e, t), this;
            }, o.TimelineSignal.prototype.setTargetAtTime = function(e, t, i) {
                return e = this._fromUnits(e), e = Math.max(this._minOutput, e), i = Math.max(this._minOutput, i), t = this.toSeconds(t), this._events.add({
                    type: o.TimelineSignal.Type.Target,
                    value: e,
                    time: t,
                    constant: i
                }), this._param.setTargetAtTime(e, t, i), this;
            }, o.TimelineSignal.prototype.setValueCurveAtTime = function(e, t, i, n) {
                n = this.defaultArg(n, 1);
                for(var a = new Array(e.length), l = 0; l < a.length; l++)a[l] = this._fromUnits(e[l]) * n;
                t = this.toSeconds(t), i = this.toSeconds(i), this._events.add({
                    type: o.TimelineSignal.Type.Curve,
                    value: a,
                    time: t,
                    duration: i
                }), this._param.setValueAtTime(a[0], t);
                for(var s = 1; s < a.length; s++){
                    var r = t + s / (a.length - 1) * i;
                    this._param.linearRampToValueAtTime(a[s], r);
                }
                return this;
            }, o.TimelineSignal.prototype.cancelScheduledValues = function(e) {
                return e = this.toSeconds(e), this._events.cancel(e), this._param.cancelScheduledValues(e), this;
            }, o.TimelineSignal.prototype.setRampPoint = function(e) {
                e = this.toSeconds(e);
                var t = this._toUnits(this.getValueAtTime(e)), i = this._searchBefore(e);
                if (i && i.time === e) this.cancelScheduledValues(e + this.sampleTime);
                else if (i && i.type === o.TimelineSignal.Type.Curve && i.time + i.duration > e) this.cancelScheduledValues(e), this.linearRampToValueAtTime(t, e);
                else {
                    var n = this._searchAfter(e);
                    n && (this.cancelScheduledValues(e), n.type === o.TimelineSignal.Type.Linear ? this.linearRampToValueAtTime(t, e) : n.type === o.TimelineSignal.Type.Exponential && this.exponentialRampToValueAtTime(t, e)), this.setValueAtTime(t, e);
                }
                return this;
            }, o.TimelineSignal.prototype.linearRampToValueBetween = function(e, t, i) {
                return this.setRampPoint(t), this.linearRampToValueAtTime(e, i), this;
            }, o.TimelineSignal.prototype.exponentialRampToValueBetween = function(e, t, i) {
                return this.setRampPoint(t), this.exponentialRampToValueAtTime(e, i), this;
            }, o.TimelineSignal.prototype._searchBefore = function(e) {
                return this._events.get(e);
            }, o.TimelineSignal.prototype._searchAfter = function(e) {
                return this._events.getAfter(e);
            }, o.TimelineSignal.prototype.getValueAtTime = function(e) {
                e = this.toSeconds(e);
                var t = this._searchAfter(e), i = this._searchBefore(e), n = this._initial;
                if (null === i) n = this._initial;
                else if (i.type === o.TimelineSignal.Type.Target) {
                    var a, l = this._events.getBefore(i.time);
                    a = null === l ? this._initial : l.value, n = this._exponentialApproach(i.time, a, i.value, i.constant, e);
                } else n = i.type === o.TimelineSignal.Type.Curve ? this._curveInterpolate(i.time, i.value, i.duration, e) : null === t ? i.value : t.type === o.TimelineSignal.Type.Linear ? this._linearInterpolate(i.time, i.value, t.time, t.value, e) : t.type === o.TimelineSignal.Type.Exponential ? this._exponentialInterpolate(i.time, i.value, t.time, t.value, e) : i.value;
                return n;
            }, o.TimelineSignal.prototype.connect = o.SignalBase.prototype.connect, o.TimelineSignal.prototype._exponentialApproach = function(e, t, i, n, a) {
                return i + (t - i) * Math.exp(-(a - e) / n);
            }, o.TimelineSignal.prototype._linearInterpolate = function(e, t, i, n, a) {
                return t + (a - e) / (i - e) * (n - t);
            }, o.TimelineSignal.prototype._exponentialInterpolate = function(e, t, i, n, a) {
                return (t = Math.max(this._minOutput, t)) * Math.pow(n / t, (a - e) / (i - e));
            }, o.TimelineSignal.prototype._curveInterpolate = function(e, t, i, n) {
                var a = t.length;
                if (e + i <= n) return t[a - 1];
                if (n <= e) return t[0];
                var l = (n - e) / i, s = Math.floor((a - 1) * l), r = Math.ceil((a - 1) * l), o = t[s], p = t[r];
                return r === s ? o : this._linearInterpolate(s, o, r, p, l * (a - 1));
            }, o.TimelineSignal.prototype.dispose = function() {
                o.Signal.prototype.dispose.call(this), o.Param.prototype.dispose.call(this), this._events.dispose(), this._events = null;
            }, o.TimelineSignal;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(4),
            __webpack_require__(1),
            __webpack_require__(2)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(i) {
            "use strict";
            return i.Scale = function(t, e) {
                this._outputMin = this.defaultArg(t, 0), this._outputMax = this.defaultArg(e, 1), this._scale = this.input = new i.Multiply(1), this._add = this.output = new i.Add(0), this._scale.connect(this._add), this._setRange();
            }, i.extend(i.Scale, i.SignalBase), Object.defineProperty(i.Scale.prototype, "min", {
                get: function() {
                    return this._outputMin;
                },
                set: function(t) {
                    this._outputMin = t, this._setRange();
                }
            }), Object.defineProperty(i.Scale.prototype, "max", {
                get: function() {
                    return this._outputMax;
                },
                set: function(t) {
                    this._outputMax = t, this._setRange();
                }
            }), i.Scale.prototype._setRange = function() {
                this._add.value = this._outputMin, this._scale.value = this._outputMax - this._outputMin;
            }, i.Scale.prototype.dispose = function() {
                return i.prototype.dispose.call(this), this._add.dispose(), this._add = null, this._scale.dispose(), this._scale = null, this;
            }, i.Scale;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(16),
            __webpack_require__(30),
            __webpack_require__(31),
            __webpack_require__(12)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(t) {
            return t.Type = {
                Default: "number",
                Time: "time",
                Frequency: "frequency",
                TransportTime: "transportTime",
                Ticks: "ticks",
                NormalRange: "normalRange",
                AudioRange: "audioRange",
                Decibels: "db",
                Interval: "interval",
                BPM: "bpm",
                Positive: "positive",
                Cents: "cents",
                Degrees: "degrees",
                MIDI: "midi",
                BarsBeatsSixteenths: "barsBeatsSixteenths",
                Samples: "samples",
                Hertz: "hertz",
                Note: "note",
                Milliseconds: "milliseconds",
                Seconds: "seconds",
                Notation: "notation"
            }, t.prototype.toSeconds = function(e) {
                return this.isNumber(e) ? e : this.isUndef(e) ? this.now() : this.isString(e) ? new t.Time(e).toSeconds() : e instanceof t.TimeBase ? e.toSeconds() : void 0;
            }, t.prototype.toFrequency = function(e) {
                return this.isNumber(e) ? e : this.isString(e) || this.isUndef(e) ? new t.Frequency(e).valueOf() : e instanceof t.TimeBase ? e.toFrequency() : void 0;
            }, t.prototype.toTicks = function(e) {
                return this.isNumber(e) || this.isString(e) ? new t.TransportTime(e).toTicks() : this.isUndef(e) ? t.Transport.ticks : e instanceof t.TimeBase ? e.toTicks() : void 0;
            }, t;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(18),
            __webpack_require__(9)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(i) {
            "use strict";
            return window.GainNode && !AudioContext.prototype.createGain && (AudioContext.prototype.createGain = AudioContext.prototype.createGainNode), i.Gain = function() {
                var t = this.optionsObject(arguments, [
                    "gain",
                    "units"
                ], i.Gain.defaults);
                this.input = this.output = this._gainNode = this.context.createGain(), this.gain = new i.Param({
                    param: this._gainNode.gain,
                    units: t.units,
                    value: t.gain,
                    convert: t.convert
                }), this._readOnly("gain");
            }, i.extend(i.Gain), i.Gain.defaults = {
                gain: 1,
                convert: !0
            }, i.Gain.prototype.dispose = function() {
                i.Param.prototype.dispose.call(this), this._gainNode.disconnect(), this._gainNode = null, this._writable("gain"), this.gain.dispose(), this.gain = null;
            }, i.prototype.createInsOuts = function(t, n) {
                1 === t ? this.input = new i.Gain : 1 < t && (this.input = new Array(t)), 1 === n ? this.output = new i.Gain : 1 < n && (this.output = new Array(t));
            }, i.Gain;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(7),
            __webpack_require__(39),
            __webpack_require__(14),
            __webpack_require__(12)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(o) {
            "use strict";
            return o.Clock = function() {
                o.Emitter.call(this);
                var t = this.optionsObject(arguments, [
                    "callback",
                    "frequency"
                ], o.Clock.defaults);
                this.callback = t.callback, this._nextTick = 0, this._lastState = o.State.Stopped, this.frequency = new o.TimelineSignal(t.frequency, o.Type.Frequency), this._readOnly("frequency"), this.ticks = 0, this._state = new o.TimelineState(o.State.Stopped), this._boundLoop = this._loop.bind(this), this.context.on("tick", this._boundLoop);
            }, o.extend(o.Clock, o.Emitter), o.Clock.defaults = {
                callback: o.noOp,
                frequency: 1,
                lookAhead: "auto"
            }, Object.defineProperty(o.Clock.prototype, "state", {
                get: function() {
                    return this._state.getValueAtTime(this.now());
                }
            }), o.Clock.prototype.start = function(t, e) {
                return t = this.toSeconds(t), this._state.getValueAtTime(t) !== o.State.Started && this._state.add({
                    state: o.State.Started,
                    time: t,
                    offset: e
                }), this;
            }, o.Clock.prototype.stop = function(t) {
                return t = this.toSeconds(t), this._state.cancel(t), this._state.setStateAtTime(o.State.Stopped, t), this;
            }, o.Clock.prototype.pause = function(t) {
                return t = this.toSeconds(t), this._state.getValueAtTime(t) === o.State.Started && this._state.setStateAtTime(o.State.Paused, t), this;
            }, o.Clock.prototype._loop = function() {
                for(var t = this.now() + this.context.lookAhead + this.context.updateInterval + 2 * this.context.lag; t > this._nextTick && this._state;){
                    var e = this._state.getValueAtTime(this._nextTick);
                    if (e !== this._lastState) {
                        this._lastState = e;
                        var i = this._state.get(this._nextTick);
                        e === o.State.Started ? (this._nextTick = i.time, this.isUndef(i.offset) || (this.ticks = i.offset), this.emit("start", i.time, this.ticks)) : e === o.State.Stopped ? (this.ticks = 0, this.emit("stop", i.time)) : e === o.State.Paused && this.emit("pause", i.time);
                    }
                    var s = this._nextTick;
                    this.frequency && (this._nextTick += 1 / this.frequency.getValueAtTime(this._nextTick), e === o.State.Started && (this.callback(s), this.ticks++));
                }
            }, o.Clock.prototype.getStateAtTime = function(t) {
                return t = this.toSeconds(t), this._state.getValueAtTime(t);
            }, o.Clock.prototype.dispose = function() {
                o.Emitter.prototype.dispose.call(this), this.context.off("tick", this._boundLoop), this._writable("frequency"), this.frequency.dispose(), this.frequency = null, this._boundLoop = null, this._nextTick = 1 / 0, this.callback = null, this._state.dispose(), this._state = null;
            }, o.Clock;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(14)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(o) {
            function t(e, t, n) {
                if (e.input) Array.isArray(e.input) ? (o.prototype.isUndef(n) && (n = 0), this.connect(e.input[n])) : this.connect(e.input, t, n);
                else try {
                    e instanceof AudioNode ? i.call(this, e, t, n) : i.call(this, e, t);
                } catch (t) {
                    throw new Error("error connecting to node: " + e + "\n" + t);
                }
            }
            var i, r;
            return !window.hasOwnProperty("AudioContext") && window.hasOwnProperty("webkitAudioContext") && (window.AudioContext = window.webkitAudioContext), o.Context = function(t) {
                for(var e in o.Emitter.call(this), t = t || new window.AudioContext, this._context = t, this._context)this._defineProperty(this._context, e);
                this._latencyHint = "interactive", this._lookAhead = .1, this._updateInterval = this._lookAhead / 3, this._computedUpdateInterval = 0, this._worker = this._createWorker(), this._constants = {};
            }, o.extend(o.Context, o.Emitter), o.Emitter.mixin(o.Context), o.Context.prototype._defineProperty = function(e, n) {
                this.isUndef(this[n]) && Object.defineProperty(this, n, {
                    get: function() {
                        return "function" == typeof e[n] ? e[n].bind(e) : e[n];
                    },
                    set: function(t) {
                        e[n] = t;
                    }
                });
            }, o.Context.prototype.now = function() {
                return this._context.currentTime;
            }, o.Context.prototype._createWorker = function() {
                window.URL = window.URL || window.webkitURL;
                var t = new Blob([
                    "var timeoutTime = " + (1e3 * this._updateInterval).toFixed(1) + ";self.onmessage = function(msg){	timeoutTime = parseInt(msg.data);};function tick(){	setTimeout(tick, timeoutTime);	self.postMessage('tick');}tick();"
                ]), e = URL.createObjectURL(t), n = new Worker(e);
                return n.addEventListener("message", (function() {
                    this.emit("tick");
                }).bind(this)), n.addEventListener("message", (function() {
                    var t = this.now();
                    if (this.isNumber(this._lastUpdate)) {
                        var e = t - this._lastUpdate;
                        this._computedUpdateInterval = Math.max(e, .97 * this._computedUpdateInterval);
                    }
                    this._lastUpdate = t;
                }).bind(this)), n;
            }, o.Context.prototype.getConstant = function(t) {
                if (this._constants[t]) return this._constants[t];
                for(var e = this._context.createBuffer(1, 128, this._context.sampleRate), n = e.getChannelData(0), o = 0; o < n.length; o++)n[o] = t;
                var i = this._context.createBufferSource();
                return i.channelCount = 1, i.channelCountMode = "explicit", i.buffer = e, i.loop = !0, i.start(0), this._constants[t] = i;
            }, Object.defineProperty(o.Context.prototype, "lag", {
                get: function() {
                    var t = this._computedUpdateInterval - this._updateInterval;
                    return t = Math.max(t, 0);
                }
            }), Object.defineProperty(o.Context.prototype, "lookAhead", {
                get: function() {
                    return this._lookAhead;
                },
                set: function(t) {
                    this._lookAhead = t;
                }
            }), Object.defineProperty(o.Context.prototype, "updateInterval", {
                get: function() {
                    return this._updateInterval;
                },
                set: function(t) {
                    this._updateInterval = Math.max(t, o.prototype.blockTime), this._worker.postMessage(Math.max(1e3 * t, 1));
                }
            }), Object.defineProperty(o.Context.prototype, "latencyHint", {
                get: function() {
                    return this._latencyHint;
                },
                set: function(t) {
                    var e = t;
                    if (this._latencyHint = t, this.isString(t)) switch(t){
                        case "interactive":
                            e = .1, this._context.latencyHint = t;
                            break;
                        case "playback":
                            e = .8, this._context.latencyHint = t;
                            break;
                        case "balanced":
                            e = .25, this._context.latencyHint = t;
                            break;
                        case "fastest":
                            e = .01;
                    }
                    this.lookAhead = e, this.updateInterval = e / 3;
                }
            }), o.supported ? (i = AudioNode.prototype.connect, r = AudioNode.prototype.disconnect, AudioNode.prototype.connect !== t && (AudioNode.prototype.connect = t, AudioNode.prototype.disconnect = function(e, t, n) {
                if (e && e.input && Array.isArray(e.input)) o.prototype.isUndef(n) && (n = 0), this.disconnect(e.input[n], t, n);
                else if (e && e.input) this.disconnect(e.input, t, n);
                else try {
                    r.apply(this, arguments);
                } catch (t) {
                    throw new Error("error disconnecting node: " + e + "\n" + t);
                }
            }), o.context = new o.Context) : console.warn("This browser does not support Tone.js"), o.Context;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(4),
            __webpack_require__(20),
            __webpack_require__(2),
            __webpack_require__(10)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(n) {
            "use strict";
            return n.Subtract = function(t) {
                this.createInsOuts(2, 0), this._sum = this.input[0] = this.output = new n.Gain, this._neg = new n.Negate, this._param = this.input[1] = new n.Signal(t), this._param.chain(this._neg, this._sum);
            }, n.extend(n.Subtract, n.Signal), n.Subtract.prototype.dispose = function() {
                return n.prototype.dispose.call(this), this._neg.dispose(), this._neg = null, this._sum.disconnect(), this._sum = null, this._param.dispose(), this._param = null, this;
            }, n.Subtract;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(o) {
            "use strict";
            return o.Emitter = function() {
                this._events = {};
            }, o.extend(o.Emitter), o.Emitter.prototype.on = function(t, e) {
                for(var i = t.split(/\W+/), r = 0; r < i.length; r++){
                    var n = i[r];
                    this._events.hasOwnProperty(n) || (this._events[n] = []), this._events[n].push(e);
                }
                return this;
            }, o.Emitter.prototype.off = function(t, e) {
                for(var i = t.split(/\W+/), r = 0; r < i.length; r++)if (t = i[r], this._events.hasOwnProperty(t)) {
                    if (o.prototype.isUndef(e)) this._events[t] = [];
                    else for(var n = this._events[t], s = 0; s < n.length; s++)n[s] === e && n.splice(s, 1);
                }
                return this;
            }, o.Emitter.prototype.emit = function(t) {
                if (this._events) {
                    var e = Array.apply(null, arguments).slice(1);
                    if (this._events.hasOwnProperty(t)) for(var i = this._events[t], r = 0, n = i.length; r < n; r++)i[r].apply(this, e);
                }
                return this;
            }, o.Emitter.mixin = function(t) {
                var e = [
                    "on",
                    "off",
                    "emit"
                ];
                t._events = {};
                for(var i = 0; i < e.length; i++){
                    var r = e[i], n = o.Emitter.prototype[r];
                    t[r] = n;
                }
            }, o.Emitter.prototype.dispose = function() {
                return o.prototype.dispose.call(this), this._events = null, this;
            }, o.Emitter;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(c) {
            "use strict";
            return c.SignalBase = function() {}, c.extend(c.SignalBase), c.SignalBase.prototype.connect = function(e, n, a) {
                return c.Signal && c.Signal === e.constructor || c.Param && c.Param === e.constructor || c.TimelineSignal && c.TimelineSignal === e.constructor ? (e._param.cancelScheduledValues(0), e._param.value = 0, e.overridden = !0) : e instanceof AudioParam && (e.cancelScheduledValues(0), e.value = 0), c.prototype.connect.call(this, e, n, a), this;
            }, c.SignalBase;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(17)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(o) {
            return o.Time = function(t, e) {
                if (!(this instanceof o.Time)) return new o.Time(t, e);
                this._plusNow = !1, o.TimeBase.call(this, t, e);
            }, o.extend(o.Time, o.TimeBase), o.Time.prototype._unaryExpressions = Object.create(o.TimeBase.prototype._unaryExpressions), o.Time.prototype._unaryExpressions.quantize = {
                regexp: /^@/,
                method: function(t) {
                    return o.Transport.nextSubdivision(t());
                }
            }, o.Time.prototype._unaryExpressions.now = {
                regexp: /^\+/,
                method: function(t) {
                    return this._plusNow = !0, t();
                }
            }, o.Time.prototype.quantize = function(t, e) {
                return e = this.defaultArg(e, 1), this._expr = (function(t, e, o) {
                    return t = t(), e = e.toSeconds(), t + (Math.round(t / e) * e - t) * o;
                }).bind(this, this._expr, new this.constructor(t), e), this;
            }, o.Time.prototype.addNow = function() {
                return this._plusNow = !0, this;
            }, o.Time.prototype._defaultExpr = function() {
                return this._plusNow = !0, this._noOp;
            }, o.Time.prototype.copy = function(t) {
                return o.TimeBase.prototype.copy.call(this, t), this._plusNow = t._plusNow, this;
            }, o.Time.prototype.toNotation = function() {
                var t = this.toSeconds(), e = this._toNotationHelper(t, [
                    "1m",
                    "2n",
                    "4n",
                    "8n",
                    "16n",
                    "32n",
                    "64n",
                    "128n"
                ]), o = this._toNotationHelper(t, [
                    "1m",
                    "2n",
                    "2t",
                    "4n",
                    "4t",
                    "8n",
                    "8t",
                    "16n",
                    "16t",
                    "32n",
                    "32t",
                    "64n",
                    "64t",
                    "128n"
                ]);
                return o.split("+").length < e.split("+").length ? o : e;
            }, o.Time.prototype._toNotationHelper = function(t, e) {
                for(var o = this._notationToUnits(e[e.length - 1]), n = "", i = 0; i < e.length; i++){
                    var r = this._notationToUnits(e[i]), s = t / r;
                    if (1 - s % 1 < 1e-6 && (s += 1e-6), 0 < (s = Math.floor(s))) {
                        if (n += 1 === s ? e[i] : s.toString() + "*" + e[i], (t -= s * r) < o) break;
                        n += " + ";
                    }
                }
                return "" === n && (n = "0"), n;
            }, o.Time.prototype._notationToUnits = function(t) {
                for(var e = this._primaryExpressions, o = [
                    e.n,
                    e.t,
                    e.m
                ], n = 0; n < o.length; n++){
                    var i = o[n], r = t.match(i.regexp);
                    if (r) return i.method.call(this, r[1]);
                }
            }, o.Time.prototype.toBarsBeatsSixteenths = function() {
                var t = this._beatsToUnits(1), e = this.toSeconds() / t, o = Math.floor(e / this._timeSignature()), n = e % 1 * 4;
                return e = Math.floor(e) % this._timeSignature(), 3 < (n = n.toString()).length && (n = parseFloat(n).toFixed(3)), [
                    o,
                    e,
                    n
                ].join(":");
            }, o.Time.prototype.toTicks = function() {
                var t = this._beatsToUnits(1), e = this.valueOf() / t;
                return Math.floor(e * o.Transport.PPQ);
            }, o.Time.prototype.toSamples = function() {
                return this.toSeconds() * this.context.sampleRate;
            }, o.Time.prototype.toFrequency = function() {
                return 1 / this.toSeconds();
            }, o.Time.prototype.toSeconds = function() {
                return this.valueOf();
            }, o.Time.prototype.toMilliseconds = function() {
                return 1e3 * this.toSeconds();
            }, o.Time.prototype.valueOf = function() {
                return this._expr() + (this._plusNow ? this.now() : 0);
            }, o.Time;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(n) {
            return n.TimeBase = function(e, t) {
                if (!(this instanceof n.TimeBase)) return new n.TimeBase(e, t);
                if (this._expr = this._noOp, e instanceof n.TimeBase) this.copy(e);
                else if (!this.isUndef(t) || this.isNumber(e)) {
                    t = this.defaultArg(t, this._defaultUnits);
                    var r = this._primaryExpressions[t].method;
                    this._expr = r.bind(this, e);
                } else this.isString(e) ? this.set(e) : this.isUndef(e) && (this._expr = this._defaultExpr());
            }, n.extend(n.TimeBase), n.TimeBase.prototype.set = function(e) {
                return this._expr = this._parseExprString(e), this;
            }, n.TimeBase.prototype.clone = function() {
                var e = new this.constructor;
                return e.copy(this), e;
            }, n.TimeBase.prototype.copy = function(e) {
                var t = e._expr();
                return this.set(t);
            }, n.TimeBase.prototype._primaryExpressions = {
                n: {
                    regexp: /^(\d+)n/i,
                    method: function(e) {
                        return 1 === (e = parseInt(e)) ? this._beatsToUnits(this._timeSignature()) : this._beatsToUnits(4 / e);
                    }
                },
                t: {
                    regexp: /^(\d+)t/i,
                    method: function(e) {
                        return e = parseInt(e), this._beatsToUnits(8 / (3 * parseInt(e)));
                    }
                },
                m: {
                    regexp: /^(\d+)m/i,
                    method: function(e) {
                        return this._beatsToUnits(parseInt(e) * this._timeSignature());
                    }
                },
                i: {
                    regexp: /^(\d+)i/i,
                    method: function(e) {
                        return this._ticksToUnits(parseInt(e));
                    }
                },
                hz: {
                    regexp: /^(\d+(?:\.\d+)?)hz/i,
                    method: function(e) {
                        return this._frequencyToUnits(parseFloat(e));
                    }
                },
                tr: {
                    regexp: /^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?):?(\d+(?:\.\d+)?)?/,
                    method: function(e, t, r) {
                        var n = 0;
                        return e && "0" !== e && (n += this._beatsToUnits(this._timeSignature() * parseFloat(e))), t && "0" !== t && (n += this._beatsToUnits(parseFloat(t))), r && "0" !== r && (n += this._beatsToUnits(parseFloat(r) / 4)), n;
                    }
                },
                s: {
                    regexp: /^(\d+(?:\.\d+)?s)/,
                    method: function(e) {
                        return this._secondsToUnits(parseFloat(e));
                    }
                },
                samples: {
                    regexp: /^(\d+)samples/,
                    method: function(e) {
                        return parseInt(e) / this.context.sampleRate;
                    }
                },
                default: {
                    regexp: /^(\d+(?:\.\d+)?)/,
                    method: function(e) {
                        return this._primaryExpressions[this._defaultUnits].method.call(this, e);
                    }
                }
            }, n.TimeBase.prototype._binaryExpressions = {
                "+": {
                    regexp: /^\+/,
                    precedence: 2,
                    method: function(e, t) {
                        return e() + t();
                    }
                },
                "-": {
                    regexp: /^\-/,
                    precedence: 2,
                    method: function(e, t) {
                        return e() - t();
                    }
                },
                "*": {
                    regexp: /^\*/,
                    precedence: 1,
                    method: function(e, t) {
                        return e() * t();
                    }
                },
                "/": {
                    regexp: /^\//,
                    precedence: 1,
                    method: function(e, t) {
                        return e() / t();
                    }
                }
            }, n.TimeBase.prototype._unaryExpressions = {
                neg: {
                    regexp: /^\-/,
                    method: function(e) {
                        return -e();
                    }
                }
            }, n.TimeBase.prototype._syntaxGlue = {
                "(": {
                    regexp: /^\(/
                },
                ")": {
                    regexp: /^\)/
                }
            }, n.TimeBase.prototype._tokenize = function(e) {
                for(var t = -1, r = []; 0 < e.length;){
                    var n = i(e = e.trim(), this);
                    r.push(n), e = e.substr(n.value.length);
                }
                function i(e, t) {
                    for(var r = [
                        "_binaryExpressions",
                        "_unaryExpressions",
                        "_primaryExpressions",
                        "_syntaxGlue"
                    ], n = 0; n < r.length; n++){
                        var i = t[r[n]];
                        for(var s in i){
                            var o = i[s], p = o.regexp, a = e.match(p);
                            if (null !== a) return {
                                method: o.method,
                                precedence: o.precedence,
                                regexp: o.regexp,
                                value: a[0]
                            };
                        }
                    }
                    throw new SyntaxError("Tone.TimeBase: Unexpected token " + e);
                }
                return {
                    next: function() {
                        return r[++t];
                    },
                    peek: function() {
                        return r[t + 1];
                    }
                };
            }, n.TimeBase.prototype._matchGroup = function(e, t, r) {
                if (!this.isUndef(e)) for(var n in t){
                    var i = t[n];
                    if (i.regexp.test(e.value)) {
                        if (this.isUndef(r)) return i;
                        if (i.precedence === r) return i;
                    }
                }
                return !1;
            }, n.TimeBase.prototype._parseBinary = function(e, t) {
                var r;
                this.isUndef(t) && (t = 2), r = t < 0 ? this._parseUnary(e) : this._parseBinary(e, t - 1);
                for(var n = e.peek(); n && this._matchGroup(n, this._binaryExpressions, t);)r = (n = e.next()).method.bind(this, r, this._parseBinary(e, t - 1)), n = e.peek();
                return r;
            }, n.TimeBase.prototype._parseUnary = function(e) {
                var t, r;
                t = e.peek();
                var n = this._matchGroup(t, this._unaryExpressions);
                return n ? (t = e.next(), r = this._parseUnary(e), n.method.bind(this, r)) : this._parsePrimary(e);
            }, n.TimeBase.prototype._parsePrimary = function(e) {
                var t, r;
                if (t = e.peek(), this.isUndef(t)) throw new SyntaxError("Tone.TimeBase: Unexpected end of expression");
                if (this._matchGroup(t, this._primaryExpressions)) {
                    var n = (t = e.next()).value.match(t.regexp);
                    return t.method.bind(this, n[1], n[2], n[3]);
                }
                if (t && "(" === t.value) {
                    if (e.next(), r = this._parseBinary(e), !(t = e.next()) || ")" !== t.value) throw new SyntaxError("Expected )");
                    return r;
                }
                throw new SyntaxError("Tone.TimeBase: Cannot process token " + t.value);
            }, n.TimeBase.prototype._parseExprString = function(e) {
                this.isString(e) || (e = e.toString());
                var t = this._tokenize(e);
                return this._parseBinary(t);
            }, n.TimeBase.prototype._noOp = function() {
                return 0;
            }, n.TimeBase.prototype._defaultExpr = function() {
                return this._noOp;
            }, n.TimeBase.prototype._defaultUnits = "s", n.TimeBase.prototype._frequencyToUnits = function(e) {
                return 1 / e;
            }, n.TimeBase.prototype._beatsToUnits = function(e) {
                return 60 / n.Transport.bpm.value * e;
            }, n.TimeBase.prototype._secondsToUnits = function(e) {
                return e;
            }, n.TimeBase.prototype._ticksToUnits = function(e) {
                return e * (this._beatsToUnits(1) / n.Transport.PPQ);
            }, n.TimeBase.prototype._timeSignature = function() {
                return n.Transport.timeSignature;
            }, n.TimeBase.prototype._pushExpr = function(e, t, r) {
                return e instanceof n.TimeBase || (e = new this.constructor(e, r)), this._expr = this._binaryExpressions[t].method.bind(this, this._expr, e._expr), this;
            }, n.TimeBase.prototype.add = function(e, t) {
                return this._pushExpr(e, "+", t);
            }, n.TimeBase.prototype.sub = function(e, t) {
                return this._pushExpr(e, "-", t);
            }, n.TimeBase.prototype.mult = function(e, t) {
                return this._pushExpr(e, "*", t);
            }, n.TimeBase.prototype.div = function(e, t) {
                return this._pushExpr(e, "/", t);
            }, n.TimeBase.prototype.valueOf = function() {
                return this._expr();
            }, n.TimeBase.prototype.dispose = function() {
                this._expr = null;
            }, n.TimeBase;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(9)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(a) {
            "use strict";
            return a.Param = function() {
                var t = this.optionsObject(arguments, [
                    "param",
                    "units",
                    "convert"
                ], a.Param.defaults);
                this._param = this.input = t.param, this.units = t.units, this.convert = t.convert, this.overridden = !1, this._lfo = null, this.isObject(t.lfo) ? this.value = t.lfo : this.isUndef(t.value) || (this.value = t.value);
            }, a.extend(a.Param), a.Param.defaults = {
                units: a.Type.Default,
                convert: !0,
                param: void 0
            }, Object.defineProperty(a.Param.prototype, "value", {
                get: function() {
                    return this._toUnits(this._param.value);
                },
                set: function(t) {
                    if (this.isObject(t)) {
                        if (this.isUndef(a.LFO)) throw new Error("Include 'Tone.LFO' to use an LFO as a Param value.");
                        this._lfo && this._lfo.dispose(), this._lfo = new a.LFO(t).start(), this._lfo.connect(this.input);
                    } else {
                        var e = this._fromUnits(t);
                        this._param.cancelScheduledValues(0), this._param.value = e;
                    }
                }
            }), a.Param.prototype._fromUnits = function(t) {
                if (!this.convert && !this.isUndef(this.convert)) return t;
                switch(this.units){
                    case a.Type.Time:
                        return this.toSeconds(t);
                    case a.Type.Frequency:
                        return this.toFrequency(t);
                    case a.Type.Decibels:
                        return this.dbToGain(t);
                    case a.Type.NormalRange:
                        return Math.min(Math.max(t, 0), 1);
                    case a.Type.AudioRange:
                        return Math.min(Math.max(t, -1), 1);
                    case a.Type.Positive:
                        return Math.max(t, 0);
                    default:
                        return t;
                }
            }, a.Param.prototype._toUnits = function(t) {
                if (!this.convert && !this.isUndef(this.convert)) return t;
                switch(this.units){
                    case a.Type.Decibels:
                        return this.gainToDb(t);
                    default:
                        return t;
                }
            }, a.Param.prototype._minOutput = 1e-5, a.Param.prototype.setValueAtTime = function(t, e) {
                return t = this._fromUnits(t), (e = this.toSeconds(e)) <= this.now() + this.blockTime ? this._param.value = t : this._param.setValueAtTime(t, e), this;
            }, a.Param.prototype.setRampPoint = function(t) {
                t = this.defaultArg(t, this.now());
                var e = this._param.value;
                return 0 === e && (e = this._minOutput), this._param.setValueAtTime(e, t), this;
            }, a.Param.prototype.linearRampToValueAtTime = function(t, e) {
                return t = this._fromUnits(t), this._param.linearRampToValueAtTime(t, this.toSeconds(e)), this;
            }, a.Param.prototype.exponentialRampToValueAtTime = function(t, e) {
                return t = this._fromUnits(t), t = Math.max(this._minOutput, t), this._param.exponentialRampToValueAtTime(t, this.toSeconds(e)), this;
            }, a.Param.prototype.exponentialRampToValue = function(t, e, i) {
                return i = this.toSeconds(i), this.setRampPoint(i), this.exponentialRampToValueAtTime(t, i + this.toSeconds(e)), this;
            }, a.Param.prototype.linearRampToValue = function(t, e, i) {
                return i = this.toSeconds(i), this.setRampPoint(i), this.linearRampToValueAtTime(t, i + this.toSeconds(e)), this;
            }, a.Param.prototype.setTargetAtTime = function(t, e, i) {
                return t = this._fromUnits(t), t = Math.max(this._minOutput, t), i = Math.max(this._minOutput, i), this._param.setTargetAtTime(t, this.toSeconds(e), i), this;
            }, a.Param.prototype.setValueCurveAtTime = function(t, e, i) {
                for(var a = 0; a < t.length; a++)t[a] = this._fromUnits(t[a]);
                return this._param.setValueCurveAtTime(t, this.toSeconds(e), this.toSeconds(i)), this;
            }, a.Param.prototype.cancelScheduledValues = function(t) {
                return this._param.cancelScheduledValues(this.toSeconds(t)), this;
            }, a.Param.prototype.rampTo = function(t, e, i) {
                return e = this.defaultArg(e, 0), this.units === a.Type.Frequency || this.units === a.Type.BPM || this.units === a.Type.Decibels ? this.exponentialRampToValue(t, e, i) : this.linearRampToValue(t, e, i), this;
            }, Object.defineProperty(a.Param.prototype, "lfo", {
                get: function() {
                    return this._lfo;
                }
            }), a.Param.prototype.dispose = function() {
                return a.prototype.dispose.call(this), this._param = null, this._lfo && (this._lfo.dispose(), this._lfo = null), this;
            }, a.Param;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(9)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(i) {
            "use strict";
            return i.Timeline = function() {
                var e = this.optionsObject(arguments, [
                    "memory"
                ], i.Timeline.defaults);
                this._timeline = [], this._toRemove = [], this._iterating = !1, this.memory = e.memory;
            }, i.extend(i.Timeline), i.Timeline.defaults = {
                memory: 1 / 0
            }, Object.defineProperty(i.Timeline.prototype, "length", {
                get: function() {
                    return this._timeline.length;
                }
            }), i.Timeline.prototype.add = function(e) {
                if (this.isUndef(e.time)) throw new Error("Tone.Timeline: events must have a time attribute");
                if (this._timeline.length) {
                    var i = this._search(e.time);
                    this._timeline.splice(i + 1, 0, e);
                } else this._timeline.push(e);
                if (this.length > this.memory) {
                    var t = this.length - this.memory;
                    this._timeline.splice(0, t);
                }
                return this;
            }, i.Timeline.prototype.remove = function(e) {
                if (this._iterating) this._toRemove.push(e);
                else {
                    var i = this._timeline.indexOf(e);
                    -1 !== i && this._timeline.splice(i, 1);
                }
                return this;
            }, i.Timeline.prototype.get = function(e) {
                var i = this._search(e);
                return -1 !== i ? this._timeline[i] : null;
            }, i.Timeline.prototype.peek = function() {
                return this._timeline[0];
            }, i.Timeline.prototype.shift = function() {
                return this._timeline.shift();
            }, i.Timeline.prototype.getAfter = function(e) {
                var i = this._search(e);
                return i + 1 < this._timeline.length ? this._timeline[i + 1] : null;
            }, i.Timeline.prototype.getBefore = function(e) {
                var i = this._timeline.length;
                if (0 < i && this._timeline[i - 1].time < e) return this._timeline[i - 1];
                var t = this._search(e);
                return 0 <= t - 1 ? this._timeline[t - 1] : null;
            }, i.Timeline.prototype.cancel = function(e) {
                if (1 < this._timeline.length) {
                    var i = this._search(e);
                    if (0 <= i) {
                        if (this._timeline[i].time === e) {
                            for(var t = i; 0 <= t && this._timeline[t].time === e; t--)i = t;
                            this._timeline = this._timeline.slice(0, i);
                        } else this._timeline = this._timeline.slice(0, i + 1);
                    } else this._timeline = [];
                } else 1 === this._timeline.length && this._timeline[0].time >= e && (this._timeline = []);
                return this;
            }, i.Timeline.prototype.cancelBefore = function(e) {
                if (this._timeline.length) {
                    var i = this._search(e);
                    0 <= i && (this._timeline = this._timeline.slice(i + 1));
                }
                return this;
            }, i.Timeline.prototype._search = function(e) {
                var i = 0, t = this._timeline.length, n = t;
                if (0 < t && this._timeline[t - 1].time <= e) return t - 1;
                for(; i < n;){
                    var r = Math.floor(i + (n - i) / 2), s = this._timeline[r], h = this._timeline[r + 1];
                    if (s.time === e) {
                        for(var l = r; l < this._timeline.length; l++)this._timeline[l].time === e && (r = l);
                        return r;
                    }
                    if (s.time < e && h.time > e) return r;
                    s.time > e ? n = r : s.time < e && (i = r + 1);
                }
                return -1;
            }, i.Timeline.prototype._iterate = function(e, i, t) {
                this._iterating = !0, i = this.defaultArg(i, 0), t = this.defaultArg(t, this._timeline.length - 1);
                for(var n = i; n <= t; n++)e(this._timeline[n]);
                if (this._iterating = !1, 0 < this._toRemove.length) {
                    for(var r = 0; r < this._toRemove.length; r++){
                        var s = this._timeline.indexOf(this._toRemove[r]);
                        -1 !== s && this._timeline.splice(s, 1);
                    }
                    this._toRemove = [];
                }
            }, i.Timeline.prototype.forEach = function(e) {
                return this._iterate(e), this;
            }, i.Timeline.prototype.forEachBefore = function(e, i) {
                var t = this._search(e);
                return -1 !== t && this._iterate(i, 0, t), this;
            }, i.Timeline.prototype.forEachAfter = function(e, i) {
                var t = this._search(e);
                return this._iterate(i, t + 1), this;
            }, i.Timeline.prototype.forEachFrom = function(e, i) {
                for(var t = this._search(e); 0 <= t && this._timeline[t].time >= e;)t--;
                return this._iterate(i, t + 1), this;
            }, i.Timeline.prototype.forEachAtTime = function(i, t) {
                var e = this._search(i);
                return -1 !== e && this._iterate(function(e) {
                    e.time === i && t(e);
                }, 0, e), this;
            }, i.Timeline.prototype.dispose = function() {
                i.prototype.dispose.call(this), this._timeline = null, this._toRemove = null;
            }, i.Timeline;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(1),
            __webpack_require__(2)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(t) {
            "use strict";
            return t.Negate = function() {
                this._multiply = this.input = this.output = new t.Multiply(-1);
            }, t.extend(t.Negate, t.SignalBase), t.Negate.prototype.dispose = function() {
                return t.prototype.dispose.call(this), this._multiply.dispose(), this._multiply = null, this;
            }, t.Negate;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(2),
            __webpack_require__(1),
            __webpack_require__(6)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(e) {
            "use strict";
            return e.GreaterThanZero = function() {
                this._thresh = this.output = new e.WaveShaper(function(e) {
                    return e <= 0 ? 0 : 1;
                }, 127), this._scale = this.input = new e.Multiply(1e4), this._scale.connect(this._thresh);
            }, e.extend(e.GreaterThanZero, e.SignalBase), e.GreaterThanZero.prototype.dispose = function() {
                return e.prototype.dispose.call(this), this._scale.dispose(), this._scale = null, this._thresh.dispose(), this._thresh = null, this;
            }, e.GreaterThanZero;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        !function(e, t) {
            __WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = t, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function" ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
        }(this, function() {
            var r = function(e, t) {
                this._dragged = !1, this._element = e, this._bindedMove = this._moved.bind(this), this._bindedEnd = this._ended.bind(this, t), e.addEventListener("touchstart", this._bindedEnd), e.addEventListener("touchmove", this._bindedMove), e.addEventListener("touchend", this._bindedEnd), e.addEventListener("mouseup", this._bindedEnd);
            };
            function o(e) {
                return "running" === e.state;
            }
            return r.prototype._moved = function(e) {
                this._dragged = !0;
            }, r.prototype._ended = function(e) {
                this._dragged || function(e) {
                    var t = e.createBuffer(1, 1, e.sampleRate), n = e.createBufferSource();
                    n.buffer = t, n.connect(e.destination), n.start(0), e.resume && e.resume();
                }(e), this._dragged = !1;
            }, r.prototype.dispose = function() {
                this._element.removeEventListener("touchstart", this._bindedEnd), this._element.removeEventListener("touchmove", this._bindedMove), this._element.removeEventListener("touchend", this._bindedEnd), this._element.removeEventListener("mouseup", this._bindedEnd), this._bindedMove = null, this._bindedEnd = null, this._element = null;
            }, function(t, e, n) {
                var i = new Promise(function(e) {
                    !function(t, n) {
                        o(t) ? n() : function e() {
                            o(t) ? n() : (requestAnimationFrame(e), t.resume && t.resume());
                        }();
                    }(t, e);
                }), d = [];
                return function e(t, n, i) {
                    if (Array.isArray(t) || NodeList && t instanceof NodeList) for(var d = 0; d < t.length; d++)e(t[d], n, i);
                    else if ("string" == typeof t) e(document.querySelectorAll(t), n, i);
                    else if (t.jquery && "function" == typeof t.toArray) e(t.toArray(), n, i);
                    else if (Element && t instanceof Element) {
                        var o = new r(t, i);
                        n.push(o);
                    }
                }(e = e || document.body, d, t), i.then(function() {
                    for(var e = 0; e < d.length; e++)d[e].dispose();
                    d = null, n && n();
                }), i;
            };
        });
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(2),
            __webpack_require__(32),
            __webpack_require__(38),
            __webpack_require__(10)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(i) {
            "use strict";
            return i.CrossFade = function(e) {
                this.createInsOuts(2, 1), this.a = this.input[0] = new i.Gain, this.b = this.input[1] = new i.Gain, this.fade = new i.Signal(this.defaultArg(e, .5), i.Type.NormalRange), this._equalPowerA = new i.EqualPowerGain, this._equalPowerB = new i.EqualPowerGain, this._invert = new i.Expr("1 - $0"), this.a.connect(this.output), this.b.connect(this.output), this.fade.chain(this._equalPowerB, this.b.gain), this.fade.chain(this._invert, this._equalPowerA, this.a.gain), this._readOnly("fade");
            }, i.extend(i.CrossFade), i.CrossFade.prototype.dispose = function() {
                return i.prototype.dispose.call(this), this._writable("fade"), this._equalPowerA.dispose(), this._equalPowerA = null, this._equalPowerB.dispose(), this._equalPowerB = null, this.fade.dispose(), this.fade = null, this._invert.dispose(), this._invert = null, this.a.dispose(), this.a = null, this.b.dispose(), this.b = null, this;
            }, i.CrossFade;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports) {
        !function() {
            var l, s = [];
            function p(e) {
                var o = this, n = {}, i = -1;
                this.parameters.forEach(function(e, t) {
                    var r = s[++i] || (s[i] = new Float32Array(o.bufferSize));
                    r.fill(e.value), n[t] = r;
                }), this.processor.realm.exec("self.sampleRate=sampleRate=" + this.context.sampleRate + ";self.currentTime=currentTime=" + this.context.currentTime);
                var t = a(e.inputBuffer), r = a(e.outputBuffer);
                this.instance.process([
                    t
                ], [
                    r
                ], n);
            }
            function a(e) {
                for(var t = [], r = 0; r < e.numberOfChannels; r++)t[r] = e.getChannelData(r);
                return t;
            }
            function f(e) {
                return e.$$processors || (e.$$processors = {});
            }
            function e(e) {
                this.$$context = e;
            }
            "function" != typeof AudioWorkletNode && (self.AudioWorkletNode = function(e, t, r) {
                var o = f(e)[t], n = e.createScriptProcessor(void 0, 2, r && r.outputChannelCount ? r.outputChannelCount[0] : 2);
                if (n.parameters = new Map, o.properties) for(var i = 0; i < o.properties.length; i++){
                    var s = o.properties[i], a = e.createGain().gain;
                    a.value = s.defaultValue, n.parameters.set(s.name, a);
                }
                var u = new MessageChannel;
                l = u.port2;
                var c = new o.Processor(r || {});
                return l = null, n.port = u.port1, n.processor = o, n.instance = c, n.onaudioprocess = p, n;
            }, Object.defineProperty((self.AudioContext || self.webkitAudioContext).prototype, "audioWorklet", {
                get: function() {
                    return this.$$audioWorklet || (this.$$audioWorklet = new self.AudioWorklet(this));
                }
            }), self.AudioWorklet = (e.prototype.addModule = function(e, t) {
                var n = this;
                return fetch(e).then(function(e) {
                    if (!e.ok) throw Error(e.status);
                    return e.text();
                }).then(function(e) {
                    var r = {
                        sampleRate: 0,
                        currentTime: 0,
                        AudioWorkletProcessor: function() {
                            this.port = l;
                        },
                        registerProcessor: function(e, t) {
                            f(n.$$context)[e] = {
                                realm: o,
                                context: r,
                                Processor: t,
                                properties: t.parameterDescriptors || []
                            };
                        }
                    }, o = new function(e, t) {
                        var r = document.createElement("iframe");
                        r.style.cssText = "position:absolute;left:0;top:-999px;width:1px;height:1px;", t.appendChild(r);
                        var o = r.contentWindow, n = o.document, i = "var window,$hook";
                        for(var s in o)s in e || "eval" === s || (i += ",", i += s);
                        for(var a in e)i += ",", i += a, i += "=self.", i += a;
                        var u = n.createElement("script");
                        u.appendChild(n.createTextNode('function $hook(self,console) {"use strict";\n        ' + i + ";return function() {return eval(arguments[0])}}")), n.body.appendChild(u), this.exec = o.$hook(e, console);
                    }(r.self = r, document.documentElement);
                    return o.exec((t && t.transpile || String)(e)), null;
                });
            }, e));
        }();
    },
    function(module, exports) {
        /**
 * This module has shims
 */ (function() {
            function fixSetTarget(param) {
                if (!param) return;
                if (!param.setTargetAtTime) param.setTargetAtTime = param.setTargetValueAtTime;
            }
            if (window.hasOwnProperty("webkitAudioContext") && !window.hasOwnProperty("AudioContext")) {
                window.AudioContext = window.webkitAudioContext;
                if (typeof AudioContext.prototype.createGain !== "function") AudioContext.prototype.createGain = AudioContext.prototype.createGainNode;
                if (typeof AudioContext.prototype.createDelay !== "function") AudioContext.prototype.createDelay = AudioContext.prototype.createDelayNode;
                if (typeof AudioContext.prototype.createScriptProcessor !== "function") AudioContext.prototype.createScriptProcessor = AudioContext.prototype.createJavaScriptNode;
                if (typeof AudioContext.prototype.createPeriodicWave !== "function") AudioContext.prototype.createPeriodicWave = AudioContext.prototype.createWaveTable;
                AudioContext.prototype.internal_createGain = AudioContext.prototype.createGain;
                AudioContext.prototype.createGain = function() {
                    var node = this.internal_createGain();
                    fixSetTarget(node.gain);
                    return node;
                };
                AudioContext.prototype.internal_createDelay = AudioContext.prototype.createDelay;
                AudioContext.prototype.createDelay = function(maxDelayTime) {
                    var node = maxDelayTime ? this.internal_createDelay(maxDelayTime) : this.internal_createDelay();
                    fixSetTarget(node.delayTime);
                    return node;
                };
                AudioContext.prototype.internal_createBufferSource = AudioContext.prototype.createBufferSource;
                AudioContext.prototype.createBufferSource = function() {
                    var node = this.internal_createBufferSource();
                    if (!node.start) node.start = function(when, offset, duration) {
                        if (offset || duration) this.noteGrainOn(when || 0, offset, duration);
                        else this.noteOn(when || 0);
                    };
                    else {
                        node.internal_start = node.start;
                        node.start = function(when, offset, duration) {
                            if (typeof duration !== "undefined") node.internal_start(when || 0, offset, duration);
                            else node.internal_start(when || 0, offset || 0);
                        };
                    }
                    if (!node.stop) node.stop = function(when) {
                        this.noteOff(when || 0);
                    };
                    else {
                        node.internal_stop = node.stop;
                        node.stop = function(when) {
                            node.internal_stop(when || 0);
                        };
                    }
                    fixSetTarget(node.playbackRate);
                    return node;
                };
                AudioContext.prototype.internal_createDynamicsCompressor = AudioContext.prototype.createDynamicsCompressor;
                AudioContext.prototype.createDynamicsCompressor = function() {
                    var node = this.internal_createDynamicsCompressor();
                    fixSetTarget(node.threshold);
                    fixSetTarget(node.knee);
                    fixSetTarget(node.ratio);
                    fixSetTarget(node.reduction);
                    fixSetTarget(node.attack);
                    fixSetTarget(node.release);
                    return node;
                };
                AudioContext.prototype.internal_createBiquadFilter = AudioContext.prototype.createBiquadFilter;
                AudioContext.prototype.createBiquadFilter = function() {
                    var node = this.internal_createBiquadFilter();
                    fixSetTarget(node.frequency);
                    fixSetTarget(node.detune);
                    fixSetTarget(node.Q);
                    fixSetTarget(node.gain);
                    return node;
                };
                if (typeof AudioContext.prototype.createOscillator !== "function") {
                    AudioContext.prototype.internal_createOscillator = AudioContext.prototype.createOscillator;
                    AudioContext.prototype.createOscillator = function() {
                        var node = this.internal_createOscillator();
                        if (!node.start) node.start = function(when) {
                            this.noteOn(when || 0);
                        };
                        else {
                            node.internal_start = node.start;
                            node.start = function(when) {
                                node.internal_start(when || 0);
                            };
                        }
                        if (!node.stop) node.stop = function(when) {
                            this.noteOff(when || 0);
                        };
                        else {
                            node.internal_stop = node.stop;
                            node.stop = function(when) {
                                node.internal_stop(when || 0);
                            };
                        }
                        if (!node.setPeriodicWave) node.setPeriodicWave = node.setWaveTable;
                        fixSetTarget(node.frequency);
                        fixSetTarget(node.detune);
                        return node;
                    };
                }
            }
            if (window.hasOwnProperty("webkitOfflineAudioContext") && !window.hasOwnProperty("OfflineAudioContext")) window.OfflineAudioContext = window.webkitOfflineAudioContext;
        })(window);
        navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
        /**
 * Determine which filetypes are supported (inspired by buzz.js)
 * The audio element (el) will only be used to test browser support for various audio formats
 */ var el = document.createElement("audio");
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.isSupported = function() {
            return !!el.canPlayType;
        };
        var isOGGSupported = function isOGGSupported() {
            return !!el.canPlayType && el.canPlayType('audio/ogg; codecs="vorbis"');
        };
        var isMP3Supported = function isMP3Supported() {
            return !!el.canPlayType && el.canPlayType("audio/mpeg;");
        };
        var isWAVSupported = function isWAVSupported() {
            return !!el.canPlayType && el.canPlayType('audio/wav; codecs="1"');
        };
        var isAACSupported = function isAACSupported() {
            return !!el.canPlayType && (el.canPlayType("audio/x-m4a;") || el.canPlayType("audio/aac;"));
        };
        var isAIFSupported = function isAIFSupported() {
            return !!el.canPlayType && el.canPlayType("audio/x-aiff;");
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.isFileSupported = function(extension) {
            switch(extension.toLowerCase()){
                case "mp3":
                    return isMP3Supported();
                case "wav":
                    return isWAVSupported();
                case "ogg":
                    return isOGGSupported();
                case "aac":
                case "m4a":
                case "mp4":
                    return isAACSupported();
                case "aif":
                case "aiff":
                    return isAIFSupported();
                default:
                    return false;
            }
        };
    },
    function(module, exports) {
        var g;
        g = function() {
            return this;
        }();
        try {
            g = g || new Function("return this")();
        } catch (t) {
            "object" == typeof window && (g = window);
        }
        module.exports = g;
    },
    function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        __webpack_exports__["default"] = 'function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }\n\nfunction _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }\n\nfunction _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called"); } return self; }\n\nfunction _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }\n\nfunction _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }\n\nfunction isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }\n\nfunction _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }\n\nfunction _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }\n\nfunction _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }\n\nfunction _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\n// import dependencies via preval.require so that they\'re available as values at compile time\nvar processorNames = {\n  "recorderProcessor": "recorder-processor",\n  "soundFileProcessor": "sound-file-processor",\n  "amplitudeProcessor": "amplitude-processor"\n};\nvar RingBuffer = {\n  "default":\n  /*#__PURE__*/\n  function () {\n    /**\n     * @constructor\n     * @param  {number} length Buffer length in frames.\n     * @param  {number} channelCount Buffer channel count.\n     */\n    function RingBuffer(length, channelCount) {\n      _classCallCheck(this, RingBuffer);\n\n      this._readIndex = 0;\n      this._writeIndex = 0;\n      this._framesAvailable = 0;\n      this._channelCount = channelCount;\n      this._length = length;\n      this._channelData = [];\n\n      for (var i = 0; i < this._channelCount; ++i) {\n        this._channelData[i] = new Float32Array(length);\n      }\n    }\n    /**\n     * Getter for Available frames in buffer.\n     *\n     * @return {number} Available frames in buffer.\n     */\n\n\n    _createClass(RingBuffer, [{\n      key: "push",\n\n      /**\n       * Push a sequence of Float32Arrays to buffer.\n       *\n       * @param  {array} arraySequence A sequence of Float32Arrays.\n       */\n      value: function push(arraySequence) {\n        // The channel count of arraySequence and the length of each channel must\n        // match with this buffer obejct.\n        // Transfer data from the |arraySequence| storage to the internal buffer.\n        var sourceLength = arraySequence[0] ? arraySequence[0].length : 0;\n\n        for (var i = 0; i < sourceLength; ++i) {\n          var writeIndex = (this._writeIndex + i) % this._length;\n\n          for (var channel = 0; channel < this._channelCount; ++channel) {\n            this._channelData[channel][writeIndex] = arraySequence[channel][i];\n          }\n        }\n\n        this._writeIndex += sourceLength;\n\n        if (this._writeIndex >= this._length) {\n          this._writeIndex = 0;\n        } // For excessive frames, the buffer will be overwritten.\n\n\n        this._framesAvailable += sourceLength;\n\n        if (this._framesAvailable > this._length) {\n          this._framesAvailable = this._length;\n        }\n      }\n      /**\n       * Pull data out of buffer and fill a given sequence of Float32Arrays.\n       *\n       * @param  {array} arraySequence An array of Float32Arrays.\n       */\n\n    }, {\n      key: "pull",\n      value: function pull(arraySequence) {\n        // The channel count of arraySequence and the length of each channel must\n        // match with this buffer obejct.\n        // If the FIFO is completely empty, do nothing.\n        if (this._framesAvailable === 0) {\n          return;\n        }\n\n        var destinationLength = arraySequence[0].length; // Transfer data from the internal buffer to the |arraySequence| storage.\n\n        for (var i = 0; i < destinationLength; ++i) {\n          var readIndex = (this._readIndex + i) % this._length;\n\n          for (var channel = 0; channel < this._channelCount; ++channel) {\n            arraySequence[channel][i] = this._channelData[channel][readIndex];\n          }\n        }\n\n        this._readIndex += destinationLength;\n\n        if (this._readIndex >= this._length) {\n          this._readIndex = 0;\n        }\n\n        this._framesAvailable -= destinationLength;\n\n        if (this._framesAvailable < 0) {\n          this._framesAvailable = 0;\n        }\n      }\n    }, {\n      key: "framesAvailable",\n      get: function get() {\n        return this._framesAvailable;\n      }\n    }]);\n\n    return RingBuffer;\n  }()\n}["default"];\n\nvar RecorderProcessor =\n/*#__PURE__*/\nfunction (_AudioWorkletProcesso) {\n  _inherits(RecorderProcessor, _AudioWorkletProcesso);\n\n  function RecorderProcessor(options) {\n    var _this;\n\n    _classCallCheck(this, RecorderProcessor);\n\n    _this = _possibleConstructorReturn(this, _getPrototypeOf(RecorderProcessor).call(this));\n    var processorOptions = options.processorOptions || {};\n    _this.numOutputChannels = options.outputChannelCount || 2;\n    _this.numInputChannels = processorOptions.numInputChannels || 2;\n    _this.bufferSize = processorOptions.bufferSize || 1024;\n    _this.recording = false;\n\n    _this.clear();\n\n    _this.port.onmessage = function (event) {\n      var data = event.data;\n\n      if (data.name === \'start\') {\n        _this.record(data.duration);\n      } else if (data.name === \'stop\') {\n        _this.stop();\n      }\n    };\n\n    return _this;\n  }\n\n  _createClass(RecorderProcessor, [{\n    key: "process",\n    value: function process(inputs) {\n      if (!this.recording) {\n        return true;\n      } else if (this.sampleLimit && this.recordedSamples >= this.sampleLimit) {\n        this.stop();\n        return true;\n      }\n\n      var input = inputs[0];\n      this.inputRingBuffer.push(input);\n\n      if (this.inputRingBuffer.framesAvailable >= this.bufferSize) {\n        this.inputRingBuffer.pull(this.inputRingBufferArraySequence);\n\n        for (var channel = 0; channel < this.numOutputChannels; ++channel) {\n          var inputChannelCopy = this.inputRingBufferArraySequence[channel].slice();\n\n          if (channel === 0) {\n            this.leftBuffers.push(inputChannelCopy);\n\n            if (this.numInputChannels === 1) {\n              this.rightBuffers.push(inputChannelCopy);\n            }\n          } else if (channel === 1 && this.numInputChannels > 1) {\n            this.rightBuffers.push(inputChannelCopy);\n          }\n        }\n\n        this.recordedSamples += this.bufferSize;\n      }\n\n      return true;\n    }\n  }, {\n    key: "record",\n    value: function record(duration) {\n      if (duration) {\n        this.sampleLimit = Math.round(duration * sampleRate);\n      }\n\n      this.recording = true;\n    }\n  }, {\n    key: "stop",\n    value: function stop() {\n      this.recording = false;\n      var buffers = this.getBuffers();\n      var leftBuffer = buffers[0].buffer;\n      var rightBuffer = buffers[1].buffer;\n      this.port.postMessage({\n        name: \'buffers\',\n        leftBuffer: leftBuffer,\n        rightBuffer: rightBuffer\n      }, [leftBuffer, rightBuffer]);\n      this.clear();\n    }\n  }, {\n    key: "getBuffers",\n    value: function getBuffers() {\n      var buffers = [];\n      buffers.push(this.mergeBuffers(this.leftBuffers));\n      buffers.push(this.mergeBuffers(this.rightBuffers));\n      return buffers;\n    }\n  }, {\n    key: "mergeBuffers",\n    value: function mergeBuffers(channelBuffer) {\n      var result = new Float32Array(this.recordedSamples);\n      var offset = 0;\n      var lng = channelBuffer.length;\n\n      for (var i = 0; i < lng; i++) {\n        var buffer = channelBuffer[i];\n        result.set(buffer, offset);\n        offset += buffer.length;\n      }\n\n      return result;\n    }\n  }, {\n    key: "clear",\n    value: function clear() {\n      var _this2 = this;\n\n      this.leftBuffers = [];\n      this.rightBuffers = [];\n      this.inputRingBuffer = new RingBuffer(this.bufferSize, this.numInputChannels);\n      this.inputRingBufferArraySequence = new Array(this.numInputChannels).fill(null).map(function () {\n        return new Float32Array(_this2.bufferSize);\n      });\n      this.recordedSamples = 0;\n      this.sampleLimit = null;\n    }\n  }]);\n\n  return RecorderProcessor;\n}(_wrapNativeSuper(AudioWorkletProcessor));\n\nregisterProcessor(processorNames.recorderProcessor, RecorderProcessor);';
    },
    function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        __webpack_exports__["default"] = 'function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }\n\nfunction _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }\n\nfunction _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called"); } return self; }\n\nfunction _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }\n\nfunction _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }\n\nfunction isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }\n\nfunction _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }\n\nfunction _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }\n\nfunction _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }\n\nfunction _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\n// import dependencies via preval.require so that they\'re available as values at compile time\nvar processorNames = {\n  "recorderProcessor": "recorder-processor",\n  "soundFileProcessor": "sound-file-processor",\n  "amplitudeProcessor": "amplitude-processor"\n};\nvar RingBuffer = {\n  "default":\n  /*#__PURE__*/\n  function () {\n    /**\n     * @constructor\n     * @param  {number} length Buffer length in frames.\n     * @param  {number} channelCount Buffer channel count.\n     */\n    function RingBuffer(length, channelCount) {\n      _classCallCheck(this, RingBuffer);\n\n      this._readIndex = 0;\n      this._writeIndex = 0;\n      this._framesAvailable = 0;\n      this._channelCount = channelCount;\n      this._length = length;\n      this._channelData = [];\n\n      for (var i = 0; i < this._channelCount; ++i) {\n        this._channelData[i] = new Float32Array(length);\n      }\n    }\n    /**\n     * Getter for Available frames in buffer.\n     *\n     * @return {number} Available frames in buffer.\n     */\n\n\n    _createClass(RingBuffer, [{\n      key: "push",\n\n      /**\n       * Push a sequence of Float32Arrays to buffer.\n       *\n       * @param  {array} arraySequence A sequence of Float32Arrays.\n       */\n      value: function push(arraySequence) {\n        // The channel count of arraySequence and the length of each channel must\n        // match with this buffer obejct.\n        // Transfer data from the |arraySequence| storage to the internal buffer.\n        var sourceLength = arraySequence[0] ? arraySequence[0].length : 0;\n\n        for (var i = 0; i < sourceLength; ++i) {\n          var writeIndex = (this._writeIndex + i) % this._length;\n\n          for (var channel = 0; channel < this._channelCount; ++channel) {\n            this._channelData[channel][writeIndex] = arraySequence[channel][i];\n          }\n        }\n\n        this._writeIndex += sourceLength;\n\n        if (this._writeIndex >= this._length) {\n          this._writeIndex = 0;\n        } // For excessive frames, the buffer will be overwritten.\n\n\n        this._framesAvailable += sourceLength;\n\n        if (this._framesAvailable > this._length) {\n          this._framesAvailable = this._length;\n        }\n      }\n      /**\n       * Pull data out of buffer and fill a given sequence of Float32Arrays.\n       *\n       * @param  {array} arraySequence An array of Float32Arrays.\n       */\n\n    }, {\n      key: "pull",\n      value: function pull(arraySequence) {\n        // The channel count of arraySequence and the length of each channel must\n        // match with this buffer obejct.\n        // If the FIFO is completely empty, do nothing.\n        if (this._framesAvailable === 0) {\n          return;\n        }\n\n        var destinationLength = arraySequence[0].length; // Transfer data from the internal buffer to the |arraySequence| storage.\n\n        for (var i = 0; i < destinationLength; ++i) {\n          var readIndex = (this._readIndex + i) % this._length;\n\n          for (var channel = 0; channel < this._channelCount; ++channel) {\n            arraySequence[channel][i] = this._channelData[channel][readIndex];\n          }\n        }\n\n        this._readIndex += destinationLength;\n\n        if (this._readIndex >= this._length) {\n          this._readIndex = 0;\n        }\n\n        this._framesAvailable -= destinationLength;\n\n        if (this._framesAvailable < 0) {\n          this._framesAvailable = 0;\n        }\n      }\n    }, {\n      key: "framesAvailable",\n      get: function get() {\n        return this._framesAvailable;\n      }\n    }]);\n\n    return RingBuffer;\n  }()\n}["default"];\n\nvar SoundFileProcessor =\n/*#__PURE__*/\nfunction (_AudioWorkletProcesso) {\n  _inherits(SoundFileProcessor, _AudioWorkletProcesso);\n\n  function SoundFileProcessor(options) {\n    var _this;\n\n    _classCallCheck(this, SoundFileProcessor);\n\n    _this = _possibleConstructorReturn(this, _getPrototypeOf(SoundFileProcessor).call(this));\n    var processorOptions = options.processorOptions || {};\n    _this.bufferSize = processorOptions.bufferSize || 256;\n    _this.inputRingBuffer = new RingBuffer(_this.bufferSize, 1);\n    _this.inputRingBufferArraySequence = [new Float32Array(_this.bufferSize)];\n    return _this;\n  }\n\n  _createClass(SoundFileProcessor, [{\n    key: "process",\n    value: function process(inputs) {\n      var input = inputs[0]; // we only care about the first input channel, because that contains the position data\n\n      this.inputRingBuffer.push([input[0]]);\n\n      if (this.inputRingBuffer.framesAvailable >= this.bufferSize) {\n        this.inputRingBuffer.pull(this.inputRingBufferArraySequence);\n        var inputChannel = this.inputRingBufferArraySequence[0];\n        var position = inputChannel[inputChannel.length - 1] || 0;\n        this.port.postMessage({\n          name: \'position\',\n          position: position\n        });\n      }\n\n      return true;\n    }\n  }]);\n\n  return SoundFileProcessor;\n}(_wrapNativeSuper(AudioWorkletProcessor));\n\nregisterProcessor(processorNames.soundFileProcessor, SoundFileProcessor);';
    },
    function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        __webpack_exports__["default"] = 'function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }\n\nfunction _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }\n\nfunction _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called"); } return self; }\n\nfunction _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }\n\nfunction _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }\n\nfunction isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }\n\nfunction _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }\n\nfunction _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }\n\nfunction _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }\n\nfunction _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\n// import dependencies via preval.require so that they\'re available as values at compile time\nvar processorNames = {\n  "recorderProcessor": "recorder-processor",\n  "soundFileProcessor": "sound-file-processor",\n  "amplitudeProcessor": "amplitude-processor"\n};\nvar RingBuffer = {\n  "default":\n  /*#__PURE__*/\n  function () {\n    /**\n     * @constructor\n     * @param  {number} length Buffer length in frames.\n     * @param  {number} channelCount Buffer channel count.\n     */\n    function RingBuffer(length, channelCount) {\n      _classCallCheck(this, RingBuffer);\n\n      this._readIndex = 0;\n      this._writeIndex = 0;\n      this._framesAvailable = 0;\n      this._channelCount = channelCount;\n      this._length = length;\n      this._channelData = [];\n\n      for (var i = 0; i < this._channelCount; ++i) {\n        this._channelData[i] = new Float32Array(length);\n      }\n    }\n    /**\n     * Getter for Available frames in buffer.\n     *\n     * @return {number} Available frames in buffer.\n     */\n\n\n    _createClass(RingBuffer, [{\n      key: "push",\n\n      /**\n       * Push a sequence of Float32Arrays to buffer.\n       *\n       * @param  {array} arraySequence A sequence of Float32Arrays.\n       */\n      value: function push(arraySequence) {\n        // The channel count of arraySequence and the length of each channel must\n        // match with this buffer obejct.\n        // Transfer data from the |arraySequence| storage to the internal buffer.\n        var sourceLength = arraySequence[0] ? arraySequence[0].length : 0;\n\n        for (var i = 0; i < sourceLength; ++i) {\n          var writeIndex = (this._writeIndex + i) % this._length;\n\n          for (var channel = 0; channel < this._channelCount; ++channel) {\n            this._channelData[channel][writeIndex] = arraySequence[channel][i];\n          }\n        }\n\n        this._writeIndex += sourceLength;\n\n        if (this._writeIndex >= this._length) {\n          this._writeIndex = 0;\n        } // For excessive frames, the buffer will be overwritten.\n\n\n        this._framesAvailable += sourceLength;\n\n        if (this._framesAvailable > this._length) {\n          this._framesAvailable = this._length;\n        }\n      }\n      /**\n       * Pull data out of buffer and fill a given sequence of Float32Arrays.\n       *\n       * @param  {array} arraySequence An array of Float32Arrays.\n       */\n\n    }, {\n      key: "pull",\n      value: function pull(arraySequence) {\n        // The channel count of arraySequence and the length of each channel must\n        // match with this buffer obejct.\n        // If the FIFO is completely empty, do nothing.\n        if (this._framesAvailable === 0) {\n          return;\n        }\n\n        var destinationLength = arraySequence[0].length; // Transfer data from the internal buffer to the |arraySequence| storage.\n\n        for (var i = 0; i < destinationLength; ++i) {\n          var readIndex = (this._readIndex + i) % this._length;\n\n          for (var channel = 0; channel < this._channelCount; ++channel) {\n            arraySequence[channel][i] = this._channelData[channel][readIndex];\n          }\n        }\n\n        this._readIndex += destinationLength;\n\n        if (this._readIndex >= this._length) {\n          this._readIndex = 0;\n        }\n\n        this._framesAvailable -= destinationLength;\n\n        if (this._framesAvailable < 0) {\n          this._framesAvailable = 0;\n        }\n      }\n    }, {\n      key: "framesAvailable",\n      get: function get() {\n        return this._framesAvailable;\n      }\n    }]);\n\n    return RingBuffer;\n  }()\n}["default"];\n\nvar AmplitudeProcessor =\n/*#__PURE__*/\nfunction (_AudioWorkletProcesso) {\n  _inherits(AmplitudeProcessor, _AudioWorkletProcesso);\n\n  function AmplitudeProcessor(options) {\n    var _this;\n\n    _classCallCheck(this, AmplitudeProcessor);\n\n    _this = _possibleConstructorReturn(this, _getPrototypeOf(AmplitudeProcessor).call(this));\n    var processorOptions = options.processorOptions || {};\n    _this.numOutputChannels = options.outputChannelCount || 1;\n    _this.numInputChannels = processorOptions.numInputChannels || 2;\n    _this.normalize = processorOptions.normalize || false;\n    _this.smoothing = processorOptions.smoothing || 0;\n    _this.bufferSize = processorOptions.bufferSize || 2048;\n    _this.inputRingBuffer = new RingBuffer(_this.bufferSize, _this.numInputChannels);\n    _this.outputRingBuffer = new RingBuffer(_this.bufferSize, _this.numOutputChannels);\n    _this.inputRingBufferArraySequence = new Array(_this.numInputChannels).fill(null).map(function () {\n      return new Float32Array(_this.bufferSize);\n    });\n    _this.stereoVol = [0, 0];\n    _this.stereoVolNorm = [0, 0];\n    _this.volMax = 0.001;\n\n    _this.port.onmessage = function (event) {\n      var data = event.data;\n\n      if (data.name === \'toggleNormalize\') {\n        _this.normalize = data.normalize;\n      } else if (data.name === \'smoothing\') {\n        _this.smoothing = Math.max(0, Math.min(1, data.smoothing));\n      }\n    };\n\n    return _this;\n  } // TO DO make this stereo / dependent on # of audio channels\n\n\n  _createClass(AmplitudeProcessor, [{\n    key: "process",\n    value: function process(inputs, outputs) {\n      var input = inputs[0];\n      var output = outputs[0];\n      var smoothing = this.smoothing;\n      this.inputRingBuffer.push(input);\n\n      if (this.inputRingBuffer.framesAvailable >= this.bufferSize) {\n        this.inputRingBuffer.pull(this.inputRingBufferArraySequence);\n\n        for (var channel = 0; channel < this.numInputChannels; ++channel) {\n          var inputBuffer = this.inputRingBufferArraySequence[channel];\n          var bufLength = inputBuffer.length;\n          var sum = 0;\n\n          for (var i = 0; i < bufLength; i++) {\n            var x = inputBuffer[i];\n\n            if (this.normalize) {\n              sum += Math.max(Math.min(x / this.volMax, 1), -1) * Math.max(Math.min(x / this.volMax, 1), -1);\n            } else {\n              sum += x * x;\n            }\n          } // ... then take the square root of the sum.\n\n\n          var rms = Math.sqrt(sum / bufLength);\n          this.stereoVol[channel] = Math.max(rms, this.stereoVol[channel] * smoothing);\n          this.volMax = Math.max(this.stereoVol[channel], this.volMax);\n        } // calculate stero normalized volume and add volume from all channels together\n\n\n        var volSum = 0;\n\n        for (var index = 0; index < this.stereoVol.length; index++) {\n          this.stereoVolNorm[index] = Math.max(Math.min(this.stereoVol[index] / this.volMax, 1), 0);\n          volSum += this.stereoVol[index];\n        } // volume is average of channels\n\n\n        var volume = volSum / this.stereoVol.length; // normalized value\n\n        var volNorm = Math.max(Math.min(volume / this.volMax, 1), 0);\n        this.port.postMessage({\n          name: \'amplitude\',\n          volume: volume,\n          volNorm: volNorm,\n          stereoVol: this.stereoVol,\n          stereoVolNorm: this.stereoVolNorm\n        }); // pass input through to output\n\n        this.outputRingBuffer.push(this.inputRingBufferArraySequence);\n      } // pull 128 frames out of the ring buffer\n      // if the ring buffer does not have enough frames, the output will be silent\n\n\n      this.outputRingBuffer.pull(output);\n      return true;\n    }\n  }]);\n\n  return AmplitudeProcessor;\n}(_wrapNativeSuper(AudioWorkletProcessor));\n\nregisterProcessor(processorNames.amplitudeProcessor, AmplitudeProcessor);';
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(17)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(o) {
            o.Frequency = function(e, t) {
                if (!(this instanceof o.Frequency)) return new o.Frequency(e, t);
                o.TimeBase.call(this, e, t);
            }, o.extend(o.Frequency, o.TimeBase), o.Frequency.prototype._primaryExpressions = Object.create(o.TimeBase.prototype._primaryExpressions), o.Frequency.prototype._primaryExpressions.midi = {
                regexp: /^(\d+(?:\.\d+)?midi)/,
                method: function(e) {
                    return this.midiToFrequency(e);
                }
            }, o.Frequency.prototype._primaryExpressions.note = {
                regexp: /^([a-g]{1}(?:b|#|x|bb)?)(-?[0-9]+)/i,
                method: function(e, t) {
                    var r = n[e.toLowerCase()] + 12 * (parseInt(t) + 1);
                    return this.midiToFrequency(r);
                }
            }, o.Frequency.prototype._primaryExpressions.tr = {
                regexp: /^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?):?(\d+(?:\.\d+)?)?/,
                method: function(e, t, r) {
                    var n = 1;
                    return e && "0" !== e && (n *= this._beatsToUnits(this._timeSignature() * parseFloat(e))), t && "0" !== t && (n *= this._beatsToUnits(parseFloat(t))), r && "0" !== r && (n *= this._beatsToUnits(parseFloat(r) / 4)), n;
                }
            }, o.Frequency.prototype.transpose = function(e) {
                return this._expr = (function(e, t) {
                    return e() * this.intervalToFrequencyRatio(t);
                }).bind(this, this._expr, e), this;
            }, o.Frequency.prototype.harmonize = function(e) {
                return this._expr = (function(e, t) {
                    for(var r = e(), n = [], o = 0; o < t.length; o++)n[o] = r * this.intervalToFrequencyRatio(t[o]);
                    return n;
                }).bind(this, this._expr, e), this;
            }, o.Frequency.prototype.toMidi = function() {
                return this.frequencyToMidi(this.valueOf());
            }, o.Frequency.prototype.toNote = function() {
                var e = this.valueOf(), t = Math.log(e / o.Frequency.A4) / Math.LN2, r = Math.round(12 * t) + 57, n = Math.floor(r / 12);
                return n < 0 && (r += -12 * n), i[r % 12] + n.toString();
            }, o.Frequency.prototype.toSeconds = function() {
                return 1 / this.valueOf();
            }, o.Frequency.prototype.toFrequency = function() {
                return this.valueOf();
            }, o.Frequency.prototype.toTicks = function() {
                var e = this._beatsToUnits(1), t = this.valueOf() / e;
                return Math.floor(t * o.Transport.PPQ);
            }, o.Frequency.prototype._frequencyToUnits = function(e) {
                return e;
            }, o.Frequency.prototype._ticksToUnits = function(e) {
                return 1 / (60 * e / (o.Transport.bpm.value * o.Transport.PPQ));
            }, o.Frequency.prototype._beatsToUnits = function(e) {
                return 1 / o.TimeBase.prototype._beatsToUnits.call(this, e);
            }, o.Frequency.prototype._secondsToUnits = function(e) {
                return 1 / e;
            }, o.Frequency.prototype._defaultUnits = "hz";
            var n = {
                cbb: -2,
                cb: -1,
                c: 0,
                "c#": 1,
                cx: 2,
                dbb: 0,
                db: 1,
                d: 2,
                "d#": 3,
                dx: 4,
                ebb: 2,
                eb: 3,
                e: 4,
                "e#": 5,
                ex: 6,
                fbb: 3,
                fb: 4,
                f: 5,
                "f#": 6,
                fx: 7,
                gbb: 5,
                gb: 6,
                g: 7,
                "g#": 8,
                gx: 9,
                abb: 7,
                ab: 8,
                a: 9,
                "a#": 10,
                ax: 11,
                bbb: 9,
                bb: 10,
                b: 11,
                "b#": 12,
                bx: 13
            }, i = [
                "C",
                "C#",
                "D",
                "D#",
                "E",
                "F",
                "F#",
                "G",
                "G#",
                "A",
                "A#",
                "B"
            ];
            return o.Frequency.A4 = 440, o.Frequency.prototype.midiToFrequency = function(e) {
                return o.Frequency.A4 * Math.pow(2, (e - 69) / 12);
            }, o.Frequency.prototype.frequencyToMidi = function(e) {
                return 69 + 12 * Math.log(e / o.Frequency.A4) / Math.LN2;
            }, o.Frequency;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(16)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(o) {
            return o.TransportTime = function(t, r) {
                if (!(this instanceof o.TransportTime)) return new o.TransportTime(t, r);
                o.Time.call(this, t, r);
            }, o.extend(o.TransportTime, o.Time), o.TransportTime.prototype._unaryExpressions = Object.create(o.Time.prototype._unaryExpressions), o.TransportTime.prototype._unaryExpressions.quantize = {
                regexp: /^@/,
                method: function(t) {
                    var r = this._secondsToTicks(t()), e = Math.ceil(o.Transport.ticks / r);
                    return this._ticksToUnits(e * r);
                }
            }, o.TransportTime.prototype._secondsToTicks = function(t) {
                var r = t / this._beatsToUnits(1);
                return Math.round(r * o.Transport.PPQ);
            }, o.TransportTime.prototype.valueOf = function() {
                return this._secondsToTicks(this._expr()) + (this._plusNow ? o.Transport.ticks : 0);
            }, o.TransportTime.prototype.toTicks = function() {
                return this.valueOf();
            }, o.TransportTime.prototype.toSeconds = function() {
                return this._expr() + (this._plusNow ? o.Transport.seconds : 0);
            }, o.TransportTime.prototype.toFrequency = function() {
                return 1 / this.toSeconds();
            }, o.TransportTime;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(4),
            __webpack_require__(13),
            __webpack_require__(1),
            __webpack_require__(33),
            __webpack_require__(21),
            __webpack_require__(34),
            __webpack_require__(20),
            __webpack_require__(35),
            __webpack_require__(36),
            __webpack_require__(37)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(p) {
            "use strict";
            function r(e, n, r) {
                var t = new e;
                return r._eval(n[0]).connect(t, 0, 0), r._eval(n[1]).connect(t, 0, 1), t;
            }
            function t(e, n, r) {
                var t = new e;
                return r._eval(n[0]).connect(t, 0, 0), t;
            }
            function o(e) {
                return e ? parseFloat(e) : void 0;
            }
            function i(e) {
                return e && e.args ? parseFloat(e.args) : void 0;
            }
            return p.Expr = function() {
                var n = this._replacements(Array.prototype.slice.call(arguments)), e = this._parseInputs(n);
                this._nodes = [], this.input = new Array(e);
                for(var r = 0; r < e; r++)this.input[r] = this.context.createGain();
                var t, o = this._parseTree(n);
                try {
                    t = this._eval(o);
                } catch (e) {
                    throw this._disposeNodes(), new Error("Tone.Expr: Could evaluate expression: " + n);
                }
                this.output = t;
            }, p.extend(p.Expr, p.SignalBase), p.Expr._Expressions = {
                value: {
                    signal: {
                        regexp: /^\d+\.\d+|^\d+/,
                        method: function(e) {
                            return new p.Signal(o(e));
                        }
                    },
                    input: {
                        regexp: /^\$\d/,
                        method: function(e, n) {
                            return n.input[o(e.substr(1))];
                        }
                    }
                },
                glue: {
                    "(": {
                        regexp: /^\(/
                    },
                    ")": {
                        regexp: /^\)/
                    },
                    ",": {
                        regexp: /^,/
                    }
                },
                func: {
                    abs: {
                        regexp: /^abs/,
                        method: t.bind(this, p.Abs)
                    },
                    mod: {
                        regexp: /^mod/,
                        method: function(e, n) {
                            var r = i(e[1]), t = new p.Modulo(r);
                            return n._eval(e[0]).connect(t), t;
                        }
                    },
                    pow: {
                        regexp: /^pow/,
                        method: function(e, n) {
                            var r = i(e[1]), t = new p.Pow(r);
                            return n._eval(e[0]).connect(t), t;
                        }
                    },
                    a2g: {
                        regexp: /^a2g/,
                        method: function(e, n) {
                            var r = new p.AudioToGain;
                            return n._eval(e[0]).connect(r), r;
                        }
                    }
                },
                binary: {
                    "+": {
                        regexp: /^\+/,
                        precedence: 1,
                        method: r.bind(this, p.Add)
                    },
                    "-": {
                        regexp: /^\-/,
                        precedence: 1,
                        method: function(e, n) {
                            return 1 === e.length ? t(p.Negate, e, n) : r(p.Subtract, e, n);
                        }
                    },
                    "*": {
                        regexp: /^\*/,
                        precedence: 0,
                        method: r.bind(this, p.Multiply)
                    }
                },
                unary: {
                    "-": {
                        regexp: /^\-/,
                        method: t.bind(this, p.Negate)
                    },
                    "!": {
                        regexp: /^\!/,
                        method: t.bind(this, p.NOT)
                    }
                }
            }, p.Expr.prototype._parseInputs = function(e) {
                var n = e.match(/\$\d/g), r = 0;
                if (null !== n) for(var t = 0; t < n.length; t++){
                    var o = parseInt(n[t].substr(1)) + 1;
                    r = Math.max(r, o);
                }
                return r;
            }, p.Expr.prototype._replacements = function(e) {
                for(var n = e.shift(), r = 0; r < e.length; r++)n = n.replace(/\%/i, e[r]);
                return n;
            }, p.Expr.prototype._tokenize = function(e) {
                for(var n = -1, r = []; 0 < e.length;){
                    var t = o(e = e.trim());
                    r.push(t), e = e.substr(t.value.length);
                }
                function o(e) {
                    for(var n in p.Expr._Expressions){
                        var r = p.Expr._Expressions[n];
                        for(var t in r){
                            var o = r[t], i = o.regexp, a = e.match(i);
                            if (null !== a) return {
                                type: n,
                                value: a[0],
                                method: o.method
                            };
                        }
                    }
                    throw new SyntaxError("Tone.Expr: Unexpected token " + e);
                }
                return {
                    next: function() {
                        return r[++n];
                    },
                    peek: function() {
                        return r[n + 1];
                    }
                };
            }, p.Expr.prototype._parseTree = function(e) {
                var t = this._tokenize(e), a = this.isUndef.bind(this);
                function r(e, n) {
                    return !a(e) && "glue" === e.type && e.value === n;
                }
                function o(e, n, r) {
                    var t = p.Expr._Expressions[n];
                    if (!a(e)) for(var o in t){
                        var i = t[o];
                        if (i.regexp.test(e.value)) {
                            if (a(r)) return !0;
                            if (i.precedence === r) return !0;
                        }
                    }
                    return !1;
                }
                function i(e) {
                    var n;
                    a(e) && (e = 5), n = e < 0 ? function e() {
                        var n, r;
                        n = t.peek();
                        if (o(n, "unary")) return n = t.next(), r = e(), {
                            operator: n.value,
                            method: n.method,
                            args: [
                                r
                            ]
                        };
                        return s();
                    }() : i(e - 1);
                    for(var r = t.peek(); o(r, "binary", e);)n = {
                        operator: (r = t.next()).value,
                        method: r.method,
                        args: [
                            n,
                            i(e - 1)
                        ]
                    }, r = t.peek();
                    return n;
                }
                function s() {
                    var e, n;
                    if (e = t.peek(), a(e)) throw new SyntaxError("Tone.Expr: Unexpected termination of expression");
                    if ("func" === e.type) return function(e) {
                        var n = [];
                        if (!r(t.next(), "(")) throw new SyntaxError('Tone.Expr: Expected ( in a function call "' + e.value + '"');
                        r(t.peek(), ")") || (n = function() {
                            var e, n = [];
                            for(; e = i(), !a(e) && (n.push(e), r(t.peek(), ","));)t.next();
                            return n;
                        }());
                        if (r(t.next(), ")")) return {
                            method: e.method,
                            args: n,
                            name: name
                        };
                        throw new SyntaxError('Tone.Expr: Expected ) in a function call "' + e.value + '"');
                    }(e = t.next());
                    if ("value" === e.type) return {
                        method: (e = t.next()).method,
                        args: e.value
                    };
                    if (r(e, "(")) {
                        if (t.next(), n = i(), !r(e = t.next(), ")")) throw new SyntaxError("Expected )");
                        return n;
                    }
                    throw new SyntaxError("Tone.Expr: Parse error, cannot process token " + e.value);
                }
                return i();
            }, p.Expr.prototype._eval = function(e) {
                if (!this.isUndef(e)) {
                    var n = e.method(e.args, this);
                    return this._nodes.push(n), n;
                }
            }, p.Expr.prototype._disposeNodes = function() {
                for(var e = 0; e < this._nodes.length; e++){
                    var n = this._nodes[e];
                    this.isFunction(n.dispose) ? n.dispose() : this.isFunction(n.disconnect) && n.disconnect(), n = null, this._nodes[e] = null;
                }
                this._nodes = null;
            }, p.Expr.prototype.dispose = function() {
                p.prototype.dispose.call(this), this._disposeNodes();
            }, p.Expr;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(21),
            __webpack_require__(13),
            __webpack_require__(2)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(e) {
            "use strict";
            return e.GreaterThan = function(t) {
                this.createInsOuts(2, 0), this._param = this.input[0] = new e.Subtract(t), this.input[1] = this._param.input[1], this._gtz = this.output = new e.GreaterThanZero, this._param.connect(this._gtz);
            }, e.extend(e.GreaterThan, e.Signal), e.GreaterThan.prototype.dispose = function() {
                return e.prototype.dispose.call(this), this._param.dispose(), this._param = null, this._gtz.dispose(), this._gtz = null, this;
            }, e.GreaterThan;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(6),
            __webpack_require__(15)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(s) {
            "use strict";
            return s.Abs = function() {
                this._abs = this.input = this.output = new s.WaveShaper(function(s) {
                    return 0 === s ? 0 : Math.abs(s);
                }, 127);
            }, s.extend(s.Abs, s.SignalBase), s.Abs.prototype.dispose = function() {
                return s.prototype.dispose.call(this), this._abs.dispose(), this._abs = null, this;
            }, s.Abs;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(6),
            __webpack_require__(1),
            __webpack_require__(13)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(i) {
            "use strict";
            return i.Modulo = function(t) {
                this.createInsOuts(1, 0), this._shaper = new i.WaveShaper(Math.pow(2, 16)), this._multiply = new i.Multiply, this._subtract = this.output = new i.Subtract, this._modSignal = new i.Signal(t), this.input.fan(this._shaper, this._subtract), this._modSignal.connect(this._multiply, 0, 0), this._shaper.connect(this._multiply, 0, 1), this._multiply.connect(this._subtract, 0, 1), this._setWaveShaper(t);
            }, i.extend(i.Modulo, i.SignalBase), i.Modulo.prototype._setWaveShaper = function(i) {
                this._shaper.setMap(function(t) {
                    return Math.floor((t + 1e-4) / i);
                });
            }, Object.defineProperty(i.Modulo.prototype, "value", {
                get: function() {
                    return this._modSignal.value;
                },
                set: function(t) {
                    this._modSignal.value = t, this._setWaveShaper(t);
                }
            }), i.Modulo.prototype.dispose = function() {
                return i.prototype.dispose.call(this), this._shaper.dispose(), this._shaper = null, this._multiply.dispose(), this._multiply = null, this._subtract.dispose(), this._subtract = null, this._modSignal.dispose(), this._modSignal = null, this;
            }, i.Modulo;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(6)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(t) {
            "use strict";
            return t.Pow = function(e) {
                this._exp = this.defaultArg(e, 1), this._expScaler = this.input = this.output = new t.WaveShaper(this._expFunc(this._exp), 8192);
            }, t.extend(t.Pow, t.SignalBase), Object.defineProperty(t.Pow.prototype, "value", {
                get: function() {
                    return this._exp;
                },
                set: function(e) {
                    this._exp = e, this._expScaler.setMap(this._expFunc(this._exp));
                }
            }), t.Pow.prototype._expFunc = function(t) {
                return function(e) {
                    return Math.pow(Math.abs(e), t);
                };
            }, t.Pow.prototype.dispose = function() {
                return t.prototype.dispose.call(this), this._expScaler.dispose(), this._expScaler = null, this;
            }, t.Pow;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(6),
            __webpack_require__(2)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(n) {
            "use strict";
            return n.AudioToGain = function() {
                this._norm = this.input = this.output = new n.WaveShaper(function(n) {
                    return (n + 1) / 2;
                });
            }, n.extend(n.AudioToGain, n.SignalBase), n.AudioToGain.prototype.dispose = function() {
                return n.prototype.dispose.call(this), this._norm.dispose(), this._norm = null, this;
            }, n.AudioToGain;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(6)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(e) {
            "use strict";
            return e.EqualPowerGain = function() {
                this._eqPower = this.input = this.output = new e.WaveShaper((function(e) {
                    return Math.abs(e) < .001 ? 0 : this.equalPowerScale(e);
                }).bind(this), 4096);
            }, e.extend(e.EqualPowerGain, e.SignalBase), e.EqualPowerGain.prototype.dispose = function() {
                return e.prototype.dispose.call(this), this._eqPower.dispose(), this._eqPower = null, this;
            }, e.EqualPowerGain;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        __WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(0),
            __webpack_require__(19),
            __webpack_require__(9)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(t) {
            "use strict";
            return t.TimelineState = function(e) {
                t.Timeline.call(this), this._initial = e;
            }, t.extend(t.TimelineState, t.Timeline), t.TimelineState.prototype.getValueAtTime = function(e) {
                var t = this.get(e);
                return null !== t ? t.state : this._initial;
            }, t.TimelineState.prototype.setStateAtTime = function(e, t) {
                this.add({
                    state: e,
                    time: t
                });
            }, t.TimelineState;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
    },
    function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        var audioworklet_polyfill = __webpack_require__(24);
        var shims = __webpack_require__(25);
        var audiocontext = __webpack_require__(3);
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        var main_Main = function Main() {
            _classCallCheck(this, Main);
            this.input = audiocontext["a"].createGain();
            this.output = audiocontext["a"].createGain();
            this.limiter = audiocontext["a"].createDynamicsCompressor();
            this.limiter.threshold.value = -3;
            this.limiter.ratio.value = 20;
            this.limiter.knee.value = 1;
            this.audiocontext = audiocontext["a"];
            this.output.disconnect();
            this.input.connect(this.limiter);
            this.limiter.connect(this.output);
            this.meter = audiocontext["a"].createGain();
            this.fftMeter = audiocontext["a"].createGain();
            this.output.connect(this.meter);
            this.output.connect(this.fftMeter);
            this.output.connect(this.audiocontext.destination);
            this.soundArray = [];
            this.parts = [];
            this.extensions = [];
        };
        var p5sound = new main_Main();
        /**
 * Returns a number representing the output volume for sound
 * in this sketch.
 *
 * @method getOutputVolume
 * @return {Number} Output volume for sound in this sketch.
 *                  Should be between 0.0 (silence) and 1.0.
 */ (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.getOutputVolume = function() {
            return p5sound.output.gain.value;
        };
        /**
 *  <p>Scale the output of all sound in this sketch</p>
 *  Scaled between 0.0 (silence) and 1.0 (full volume).
 *  1.0 is the maximum amplitude of a digital sound, so multiplying
 *  by greater than 1.0 may cause digital distortion. To
 *  fade, provide a <code>rampTime</code> parameter. For more
 *  complex fades, see the Envelope class.
 *
 *  Alternately, you can pass in a signal source such as an
 *  oscillator to modulate the amplitude with an audio signal.
 *
 *  <p><b>How This Works</b>: When you load the p5.sound module, it
 *  creates a single instance of p5sound. All sound objects in this
 *  module output to p5sound before reaching your computer's output.
 *  So if you change the amplitude of p5sound, it impacts all of the
 *  sound in this module.</p>
 *
 *  <p>If no value is provided, returns a Web Audio API Gain Node</p>
 *
 *  @method  outputVolume
 *  @param {Number|Object} volume  Volume (amplitude) between 0.0
 *                                     and 1.0 or modulating signal/oscillator
 *  @param {Number} [rampTime]  Fade for t seconds
 *  @param {Number} [timeFromNow]  Schedule this event to happen at
 *                                 t seconds in the future
 */ (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.outputVolume = function(vol) {
            var rampTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var tFromNow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            if (typeof vol === "number") {
                var now = p5sound.audiocontext.currentTime;
                var currentVol = p5sound.output.gain.value;
                p5sound.output.gain.cancelScheduledValues(now + tFromNow);
                p5sound.output.gain.linearRampToValueAtTime(currentVol, now + tFromNow);
                p5sound.output.gain.linearRampToValueAtTime(vol, now + tFromNow + rampTime);
            } else if (vol) vol.connect(p5sound.output.gain);
            else return p5sound.output.gain;
        };
        /**
 *  `p5.soundOut` is the p5.sound final output bus. It sends output to
 *  the destination of this window's web audio context. It contains
 *  Web Audio API nodes including a dyanmicsCompressor (<code>.limiter</code>),
 *  and Gain Nodes for <code>.input</code> and <code>.output</code>.
 *
 *  @property {Object} soundOut
 */ (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.soundOut = (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).soundOut = p5sound;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).soundOut._silentNode = p5sound.audiocontext.createGain();
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).soundOut._silentNode.gain.value = 0;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).soundOut._silentNode.connect(p5sound.audiocontext.destination);
        var main = p5sound;
        var processorNames = __webpack_require__(5);
        var processorNames_default = __webpack_require__.n(processorNames);
        function _typeof(obj) {
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                return typeof obj;
            };
            else _typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            return _typeof(obj);
        }
        /**
 * @for p5
 */ /**
 * Returns a number representing the sample rate, in samples per second,
 * of all sound objects in this audio context. It is determined by the
 * sampling rate of your operating system's sound card, and it is not
 * currently possile to change.
 * It is often 44100, or twice the range of human hearing.
 *
 * @method sampleRate
 * @return {Number} samplerate samples per second
 */ function sampleRate() {
            return main.audiocontext.sampleRate;
        }
        /**
 *  Returns the closest MIDI note value for
 *  a given frequency.
 *
 *  @method freqToMidi
 *  @param  {Number} frequency A freqeuncy, for example, the "A"
 *                             above Middle C is 440Hz
 *  @return {Number}   MIDI note value
 */ function freqToMidi(f) {
            var mathlog2 = Math.log(f / 440) / Math.log(2);
            var m = Math.round(12 * mathlog2) + 69;
            return m;
        }
        /**
 *  Returns the frequency value of a MIDI note value.
 *  General MIDI treats notes as integers where middle C
 *  is 60, C# is 61, D is 62 etc. Useful for generating
 *  musical frequencies with oscillators.
 *
 *  @method  midiToFreq
 *  @param  {Number} midiNote The number of a MIDI note
 *  @return {Number} Frequency value of the given MIDI note
 *  @example
 *  <div><code>
 *  let midiNotes = [60, 64, 67, 72];
 *  let noteIndex = 0;
 *  let midiVal, freq;
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(startSound);
 *    osc = new p5.TriOsc();
 *    env = new p5.Envelope();
 *  }
 *
 *  function draw() {
 *    background(220);
 *    text('tap to play', 10, 20);
 *    if (midiVal) {
 *      text('MIDI: ' + midiVal, 10, 40);
 *      text('Freq: ' + freq, 10, 60);
 *    }
 *  }
 *
 *  function startSound() {
 *    // see also: userStartAudio();
 *    osc.start();
 *
 *    midiVal = midiNotes[noteIndex % midiNotes.length];
 *    freq = midiToFreq(midiVal);
 *    osc.freq(freq);
 *    env.ramp(osc, 0, 1.0, 0);
 *
 *    noteIndex++;
 *  }
 *  </code></div>
 */ function midiToFreq(m) {
            return 440 * Math.pow(2, (m - 69) / 12.0);
        }
        function noteToFreq(note) {
            if (typeof note !== "string") return note;
            var wholeNotes = {
                A: 21,
                B: 23,
                C: 24,
                D: 26,
                E: 28,
                F: 29,
                G: 31
            };
            var value = wholeNotes[note[0].toUpperCase()];
            var octave = ~~note.slice(-1);
            value += 12 * (octave - 1);
            switch(note[1]){
                case "#":
                    value += 1;
                    break;
                case "b":
                    value -= 1;
                    break;
                default:
                    break;
            }
            return midiToFreq(value);
        }
        /**
 *  List the SoundFile formats that you will include. LoadSound
 *  will search your directory for these extensions, and will pick
 *  a format that is compatable with the client's web browser.
 *  <a href="http://media.io/">Here</a> is a free online file
 *  converter.
 *
 *  @method soundFormats
 *  @param {String} [...formats] i.e. 'mp3', 'wav', 'ogg'
 *  @example
 *  <div><code>
 *  function preload() {
 *    // set the global sound formats
 *    soundFormats('mp3', 'ogg');
 *
 *    // load either beatbox.mp3, or .ogg, depending on browser
 *    mySound = loadSound('assets/beatbox.mp3');
 *  }
 *
 *  function setup() {
 *       let cnv = createCanvas(100, 100);
 *       background(220);
 *       text('sound loaded! tap to play', 10, 20, width - 20);
 *       cnv.mousePressed(function() {
 *         mySound.play();
 *       });
 *     }
 *  </code></div>
 */ function soundFormats() {
            main.extensions = [];
            for(var i = 0; i < arguments.length; i++){
                arguments[i] = arguments[i].toLowerCase();
                if ([
                    "mp3",
                    "wav",
                    "ogg",
                    "m4a",
                    "aac"
                ].indexOf(arguments[i]) > -1) main.extensions.push(arguments[i]);
                else throw arguments[i] + " is not a valid sound format!";
            }
        }
        function disposeSound() {
            for(var i = 0; i < main.soundArray.length; i++)main.soundArray[i].dispose();
        }
        function _checkFileFormats(paths) {
            var path;
            if (typeof paths === "string") {
                path = paths;
                var extTest = path.split(".").pop();
                if ([
                    "mp3",
                    "wav",
                    "ogg",
                    "m4a",
                    "aac"
                ].indexOf(extTest) > -1) {
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.isFileSupported(extTest)) {
                        var pathSplit = path.split(".");
                        var pathCore = pathSplit[pathSplit.length - 1];
                        for(var _i = 0; _i < main.extensions.length; _i++){
                            var _extension = main.extensions[_i];
                            var _supported = (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.isFileSupported(_extension);
                            if (_supported) {
                                pathCore = "";
                                if (pathSplit.length === 2) pathCore += pathSplit[0];
                                for(var _i2 = 1; _i2 <= pathSplit.length - 2; _i2++){
                                    var p = pathSplit[_i2];
                                    pathCore += "." + p;
                                }
                                path = pathCore += ".";
                                path = path += _extension;
                                break;
                            }
                        }
                    }
                } else for(var _i3 = 0; _i3 < main.extensions.length; _i3++){
                    var _extension2 = main.extensions[_i3];
                    var _supported2 = (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.isFileSupported(_extension2);
                    if (_supported2) {
                        path = path + "." + _extension2;
                        break;
                    }
                }
            } else if (_typeof(paths) === "object") for(var i = 0; i < paths.length; i++){
                var extension = paths[i].split(".").pop();
                var supported = (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.isFileSupported(extension);
                if (supported) {
                    path = paths[i];
                    break;
                }
            }
            return path;
        }
        /**
 *  Used by Osc and Envelope to chain signal math
 */ function _mathChain(o, math, thisChain, nextChain, type) {
            for(var i in o.mathOps)if (o.mathOps[i] instanceof type) {
                o.mathOps[i].dispose();
                thisChain = i;
                if (thisChain < o.mathOps.length - 1) nextChain = o.mathOps[i + 1];
            }
            o.mathOps[thisChain - 1].disconnect();
            o.mathOps[thisChain - 1].connect(math);
            math.connect(nextChain);
            o.mathOps[thisChain] = math;
            return o;
        }
        function convertToWav(audioBuffer) {
            var leftChannel, rightChannel;
            leftChannel = audioBuffer.getChannelData(0);
            if (audioBuffer.numberOfChannels > 1) rightChannel = audioBuffer.getChannelData(1);
            else rightChannel = leftChannel;
            var interleaved = interleave(leftChannel, rightChannel);
            var buffer = new window.ArrayBuffer(44 + interleaved.length * 2);
            var view = new window.DataView(buffer);
            writeUTFBytes(view, 0, "RIFF");
            view.setUint32(4, 36 + interleaved.length * 2, true);
            writeUTFBytes(view, 8, "WAVE");
            writeUTFBytes(view, 12, "fmt ");
            view.setUint32(16, 16, true);
            view.setUint16(20, 1, true);
            view.setUint16(22, 2, true);
            view.setUint32(24, main.audiocontext.sampleRate, true);
            view.setUint32(28, main.audiocontext.sampleRate * 4, true);
            view.setUint16(32, 4, true);
            view.setUint16(34, 16, true);
            writeUTFBytes(view, 36, "data");
            view.setUint32(40, interleaved.length * 2, true);
            var lng = interleaved.length;
            var index = 44;
            var volume = 1;
            for(var i = 0; i < lng; i++){
                view.setInt16(index, interleaved[i] * (0x7fff * volume), true);
                index += 2;
            }
            return view;
        }
        function interleave(leftChannel, rightChannel) {
            var length = leftChannel.length + rightChannel.length;
            var result = new Float32Array(length);
            var inputIndex = 0;
            for(var index = 0; index < length;){
                result[index++] = leftChannel[inputIndex];
                result[index++] = rightChannel[inputIndex];
                inputIndex++;
            }
            return result;
        }
        function writeUTFBytes(view, offset, string) {
            var lng = string.length;
            for(var i = 0; i < lng; i++)view.setUint8(offset + i, string.charCodeAt(i));
        }
        function safeBufferSize(idealBufferSize) {
            var bufferSize = idealBufferSize;
            var tempAudioWorkletNode = new AudioWorkletNode(main.audiocontext, processorNames_default.a.soundFileProcessor);
            if (tempAudioWorkletNode instanceof ScriptProcessorNode) bufferSize = tempAudioWorkletNode.bufferSize;
            tempAudioWorkletNode.disconnect();
            tempAudioWorkletNode = null;
            return bufferSize;
        }
        /**
 * Save a p5.SoundFile as a .wav file. The browser will prompt the user
 * to download the file to their device.
 * For uploading audio to a server, use
 * <a href="/docs/reference/#/p5.SoundFile/saveBlob">`p5.SoundFile.saveBlob`</a>.
 *
 *  @for p5
 *  @method saveSound
 *  @param  {p5.SoundFile} soundFile p5.SoundFile that you wish to save
 *  @param  {String} fileName      name of the resulting .wav file.
 */ function saveSound(soundFile, fileName) {
            var dataView = convertToWav(soundFile.buffer);
            (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.writeFile([
                dataView
            ], fileName, "wav");
        }
        var CustomError = function CustomError(name1, errorTrace, failedPath) {
            var err = new Error();
            var tempStack, splitStack;
            err.name = name1;
            err.originalStack = err.stack + errorTrace;
            tempStack = err.stack + errorTrace;
            err.failedPath = failedPath;
            splitStack = tempStack.split("\n").filter(function(ln) {
                return !ln.match(/(p5.|native code|globalInit)/g);
            });
            err.stack = splitStack.join("\n");
            return err;
        };
        var errorHandler = CustomError;
        var moduleSources = [
            __webpack_require__(27)["default"],
            __webpack_require__(28)["default"],
            __webpack_require__(29)["default"]
        ];
        var audioWorklet_ac = main.audiocontext;
        var initializedAudioWorklets = false;
        function loadAudioWorkletModules() {
            return Promise.all(moduleSources.map(function(moduleSrc) {
                var blob = new Blob([
                    moduleSrc
                ], {
                    type: "application/javascript"
                });
                var objectURL = URL.createObjectURL(blob);
                return audioWorklet_ac.audioWorklet.addModule(objectURL);
            }));
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.registerMethod("init", function() {
            if (initializedAudioWorklets) return;
            if (!this.preload && !window.preload) this.preload = function() {};
            this._incrementPreload();
            var onWorkletModulesLoad = (function() {
                initializedAudioWorklets = true;
                this._decrementPreload();
            }).bind(this);
            loadAudioWorkletModules().then(onWorkletModulesLoad);
        });
        function panner_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function _defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            return Constructor;
        }
        var panner_ac = main.audiocontext;
        var panner;
        if (typeof panner_ac.createStereoPanner !== "undefined") {
            var Panner = function() {
                function Panner(input, output) {
                    panner_classCallCheck(this, Panner);
                    this.stereoPanner = this.input = panner_ac.createStereoPanner();
                    input.connect(this.stereoPanner);
                    this.stereoPanner.connect(output);
                }
                _createClass(Panner, [
                    {
                        key: "pan",
                        value: function pan(val, tFromNow) {
                            var time = tFromNow || 0;
                            var t = panner_ac.currentTime + time;
                            this.stereoPanner.pan.linearRampToValueAtTime(val, t);
                        }
                    },
                    {
                        key: "inputChannels",
                        value: function inputChannels() {}
                    },
                    {
                        key: "connect",
                        value: function connect(obj) {
                            this.stereoPanner.connect(obj);
                        }
                    },
                    {
                        key: "disconnect",
                        value: function disconnect() {
                            if (this.stereoPanner) this.stereoPanner.disconnect();
                        }
                    }
                ]);
                return Panner;
            }();
            panner = Panner;
        } else {
            var _Panner = function() {
                function _Panner(input, output, numInputChannels) {
                    panner_classCallCheck(this, _Panner);
                    this.input = panner_ac.createGain();
                    input.connect(this.input);
                    this.left = panner_ac.createGain();
                    this.right = panner_ac.createGain();
                    this.left.channelInterpretation = "discrete";
                    this.right.channelInterpretation = "discrete";
                    if (numInputChannels > 1) {
                        this.splitter = panner_ac.createChannelSplitter(2);
                        this.input.connect(this.splitter);
                        this.splitter.connect(this.left, 1);
                        this.splitter.connect(this.right, 0);
                    } else {
                        this.input.connect(this.left);
                        this.input.connect(this.right);
                    }
                    this.output = panner_ac.createChannelMerger(2);
                    this.left.connect(this.output, 0, 1);
                    this.right.connect(this.output, 0, 0);
                    this.output.connect(output);
                }
                _createClass(_Panner, [
                    {
                        key: "pan",
                        value: function pan(val, tFromNow) {
                            var time = tFromNow || 0;
                            var t = panner_ac.currentTime + time;
                            var v = (val + 1) / 2;
                            var rightVal = Math.cos(v * Math.PI / 2);
                            var leftVal = Math.sin(v * Math.PI / 2);
                            this.left.gain.linearRampToValueAtTime(leftVal, t);
                            this.right.gain.linearRampToValueAtTime(rightVal, t);
                        }
                    },
                    {
                        key: "inputChannels",
                        value: function inputChannels(numChannels) {
                            if (numChannels === 1) {
                                this.input.disconnect();
                                this.input.connect(this.left);
                                this.input.connect(this.right);
                            } else if (numChannels === 2) {
                                if (typeof this.splitter === "undefined") this.splitter = panner_ac.createChannelSplitter(2);
                                this.input.disconnect();
                                this.input.connect(this.splitter);
                                this.splitter.connect(this.left, 1);
                                this.splitter.connect(this.right, 0);
                            }
                        }
                    },
                    {
                        key: "connect",
                        value: function connect(obj) {
                            this.output.connect(obj);
                        }
                    },
                    {
                        key: "disconnect",
                        value: function disconnect() {
                            if (this.output) this.output.disconnect();
                        }
                    }
                ]);
                return _Panner;
            }();
            panner = _Panner;
        }
        var panner_0 = panner;
        function soundfile_typeof(obj) {
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") soundfile_typeof = function _typeof(obj) {
                return typeof obj;
            };
            else soundfile_typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            return soundfile_typeof(obj);
        }
        function soundfile_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function soundfile_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) soundfile_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) soundfile_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        function soundfile_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        var soundfile_ac = main.audiocontext;
        var _createCounterBuffer = function _createCounterBuffer(buffer) {
            var len = buffer.length;
            var audioBuf = soundfile_ac.createBuffer(1, buffer.length, soundfile_ac.sampleRate);
            var arrayBuffer = audioBuf.getChannelData(0);
            for(var index = 0; index < len; index++)arrayBuffer[index] = index;
            return audioBuf;
        };
        var Cue = function Cue(callback, time, id, val) {
            soundfile_classCallCheck(this, Cue);
            this.callback = callback;
            this.time = time;
            this.id = id;
            this.val = val;
        };
        function _clearOnEnd(e) {
            var thisBufferSourceNode = e.target;
            var soundFile = this;
            thisBufferSourceNode._playing = false;
            thisBufferSourceNode.removeEventListener("ended", soundFile._clearOnEnd);
            soundFile._onended(soundFile);
            soundFile.bufferSourceNodes.map(function(_, i) {
                return i;
            }).reverse().forEach(function(i) {
                var n = soundFile.bufferSourceNodes[i];
                if (n._playing === false) soundFile.bufferSourceNodes.splice(i, 1);
            });
            if (soundFile.bufferSourceNodes.length === 0) soundFile._playing = false;
        }
        /**
 *  <p>SoundFile object with a path to a file.</p>
 *
 *  <p>The p5.SoundFile may not be available immediately because
 *  it loads the file information asynchronously.</p>
 *
 *  <p>To do something with the sound as soon as it loads
 *  pass the name of a function as the second parameter.</p>
 *
 *  <p>Only one file path is required. However, audio file formats
 *  (i.e. mp3, ogg, wav and m4a/aac) are not supported by all
 *  web browsers. If you want to ensure compatability, instead of a single
 *  file path, you may include an Array of filepaths, and the browser will
 *  choose a format that works.</p>
 *
 *  @class p5.SoundFile
 *  @constructor
 *  @param {String|Array} path   path to a sound file (String). Optionally,
 *                               you may include multiple file formats in
 *                               an array. Alternately, accepts an object
 *                               from the HTML5 File API, or a p5.File.
 *  @param {Function} [successCallback]   Name of a function to call once file loads
 *  @param {Function} [errorCallback]   Name of a function to call if file fails to
 *                                      load. This function will receive an error or
 *                                     XMLHttpRequest object with information
 *                                     about what went wrong.
 *  @param {Function} [whileLoadingCallback]   Name of a function to call while file
 *                                             is loading. That function will
 *                                             receive progress of the request to
 *                                             load the sound file
 *                                             (between 0 and 1) as its first
 *                                             parameter. This progress
 *                                             does not account for the additional
 *                                             time needed to decode the audio data.
 *
 *  @example
 *  <div><code>
 *  let mySound;
 *  function preload() {
 *    soundFormats('mp3', 'ogg');
 *    mySound = loadSound('assets/doorbell');
 *  }
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(canvasPressed);
 *    background(220);
 *    text('tap here to play', 10, 20);
 *  }
 *
 *  function canvasPressed() {
 *    // playing a sound file on a user gesture
 *    // is equivalent to `userStartAudio()`
 *    mySound.play();
 *  }
 * </code></div>
 */ var soundfile_SoundFile = function() {
            function SoundFile(paths, onload, onerror1, whileLoading) {
                soundfile_classCallCheck(this, SoundFile);
                if (typeof paths !== "undefined") {
                    if (typeof paths === "string" || typeof paths[0] === "string") {
                        var path = (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype._checkFileFormats(paths);
                        this.url = path;
                    } else if (soundfile_typeof(paths) === "object") {
                        if (!(window.File && window.FileReader && window.FileList && window.Blob)) throw "Unable to load file because the File API is not supported";
                    }
                    if (paths.file) paths = paths.file;
                    this.file = paths;
                }
                this._onended = function() {};
                this._looping = false;
                this._playing = false;
                this._paused = false;
                this._pauseTime = 0;
                this._cues = [];
                this._cueIDCounter = 0;
                this._lastPos = 0;
                this._counterNode = null;
                this._workletNode = null;
                this.bufferSourceNodes = [];
                this.bufferSourceNode = null;
                this.buffer = null;
                this.playbackRate = 1;
                this.input = main.audiocontext.createGain();
                this.output = main.audiocontext.createGain();
                this.reversed = false;
                this.startTime = 0;
                this.endTime = null;
                this.pauseTime = 0;
                this.mode = "sustain";
                this.startMillis = null;
                this.panPosition = 0.0;
                this.panner = new panner_0(this.output, main.input, 2);
                if (this.url || this.file) this.load(onload, onerror1);
                main.soundArray.push(this);
                if (typeof whileLoading === "function") this._whileLoading = whileLoading;
                else this._whileLoading = function() {};
                this._clearOnEnd = _clearOnEnd.bind(this);
                this.amp = this.setVolume;
                this.fade = this.setVolume;
            }
            /**
   * This is a helper function that the p5.SoundFile calls to load
   * itself. Accepts a callback (the name of another function)
   * as an optional parameter.
   *
   * @private
   * @for p5.SoundFile
   * @param {Function} [successCallback]   Name of a function to call once file loads
   * @param {Function} [errorCallback]   Name of a function to call if there is an error
   */ soundfile_createClass(SoundFile, [
                {
                    key: "load",
                    value: function load(callback, errorCallback) {
                        var self1 = this;
                        var errorTrace = new Error().stack;
                        if (this.url !== undefined && this.url !== "") {
                            var request = new XMLHttpRequest();
                            request.addEventListener("progress", function(evt) {
                                self1._updateProgress(evt);
                            }, false);
                            request.open("GET", this.url, true);
                            request.responseType = "arraybuffer";
                            request.onload = function() {
                                if (request.status === 200) {
                                    if (!self1.panner) return;
                                    soundfile_ac.decodeAudioData(request.response, function(buff) {
                                        if (!self1.panner) return;
                                        self1.buffer = buff;
                                        self1.panner.inputChannels(buff.numberOfChannels);
                                        if (callback) callback(self1);
                                    }, function() {
                                        if (!self1.panner) return;
                                        var err = new errorHandler("decodeAudioData", errorTrace, self1.url);
                                        var msg = "AudioContext error at decodeAudioData for " + self1.url;
                                        if (errorCallback) {
                                            err.msg = msg;
                                            errorCallback(err);
                                        } else console.error(msg + "\n The error stack trace includes: \n" + err.stack);
                                    });
                                } else {
                                    if (!self1.panner) return;
                                    var err = new errorHandler("loadSound", errorTrace, self1.url);
                                    var msg = "Unable to load " + self1.url + ". The request status was: " + request.status + " (" + request.statusText + ")";
                                    if (errorCallback) {
                                        err.message = msg;
                                        errorCallback(err);
                                    } else console.error(msg + "\n The error stack trace includes: \n" + err.stack);
                                }
                            };
                            request.onerror = function() {
                                var err = new errorHandler("loadSound", errorTrace, self1.url);
                                var msg = "There was no response from the server at " + self1.url + ". Check the url and internet connectivity.";
                                if (errorCallback) {
                                    err.message = msg;
                                    errorCallback(err);
                                } else console.error(msg + "\n The error stack trace includes: \n" + err.stack);
                            };
                            request.send();
                        } else if (this.file !== undefined) {
                            var reader = new FileReader();
                            reader.onload = function() {
                                if (!self1.panner) return;
                                soundfile_ac.decodeAudioData(reader.result, function(buff) {
                                    if (!self1.panner) return;
                                    self1.buffer = buff;
                                    self1.panner.inputChannels(buff.numberOfChannels);
                                    if (callback) callback(self1);
                                });
                            };
                            reader.onerror = function(e) {
                                if (!self1.panner) return;
                                if (onerror) onerror(e);
                            };
                            reader.readAsArrayBuffer(this.file);
                        }
                    }
                },
                {
                    key: "_updateProgress",
                    value: function _updateProgress(evt) {
                        if (evt.lengthComputable) {
                            var percentComplete = evt.loaded / evt.total * 0.99;
                            this._whileLoading(percentComplete, evt);
                        } else this._whileLoading("size unknown");
                    }
                },
                {
                    key: "isLoaded",
                    value: function isLoaded() {
                        if (this.buffer) return true;
                        else return false;
                    }
                },
                {
                    key: "play",
                    value: function play(startTime, rate, amp, _cueStart, duration) {
                        if (!this.output) {
                            console.warn("SoundFile.play() called after dispose");
                            return;
                        }
                        var now = main.audiocontext.currentTime;
                        var cueStart, cueEnd;
                        var time = startTime || 0;
                        if (time < 0) time = 0;
                        time = time + now;
                        if (typeof rate !== "undefined") this.rate(rate);
                        if (typeof amp !== "undefined") this.setVolume(amp);
                        if (this.buffer) {
                            this._pauseTime = 0;
                            if (this.mode === "restart" && this.buffer && this.bufferSourceNode) {
                                this.bufferSourceNode.stop(time);
                                this._counterNode.stop(time);
                            }
                            if (this.mode === "untildone" && this.isPlaying()) return;
                            this.bufferSourceNode = this._initSourceNode();
                            delete this._counterNode;
                            this._counterNode = this._initCounterNode();
                            if (_cueStart) {
                                if (_cueStart >= 0 && _cueStart < this.buffer.duration) cueStart = _cueStart;
                                else throw "start time out of range";
                            } else cueStart = 0;
                            if (duration) duration = duration <= this.buffer.duration - cueStart ? duration : this.buffer.duration;
                            if (this._paused) {
                                this.bufferSourceNode.start(time, this.pauseTime, duration);
                                this._counterNode.start(time, this.pauseTime, duration);
                            } else {
                                this.bufferSourceNode.start(time, cueStart, duration);
                                this._counterNode.start(time, cueStart, duration);
                            }
                            this._playing = true;
                            this._paused = false;
                            this.bufferSourceNodes.push(this.bufferSourceNode);
                            this.bufferSourceNode._arrayIndex = this.bufferSourceNodes.length - 1;
                            this.bufferSourceNode.addEventListener("ended", this._clearOnEnd);
                        } else throw "not ready to play file, buffer has yet to load. Try preload()";
                        this.bufferSourceNode.loop = this._looping;
                        this._counterNode.loop = this._looping;
                        if (this._looping === true) {
                            cueEnd = duration ? duration : cueStart - 0.000000000000001;
                            this.bufferSourceNode.loopStart = cueStart;
                            this.bufferSourceNode.loopEnd = cueEnd;
                            this._counterNode.loopStart = cueStart;
                            this._counterNode.loopEnd = cueEnd;
                        }
                    }
                },
                {
                    key: "playMode",
                    value: function playMode(str) {
                        var s = str.toLowerCase();
                        if (s === "restart" && this.buffer && this.bufferSourceNode) for(var i = 0; i < this.bufferSourceNodes.length - 1; i++){
                            var now = main.audiocontext.currentTime;
                            this.bufferSourceNodes[i].stop(now);
                        }
                        if (s === "restart" || s === "sustain" || s === "untildone") this.mode = s;
                        else throw 'Invalid play mode. Must be either "restart" or "sustain"';
                    }
                },
                {
                    key: "pause",
                    value: function pause(startTime) {
                        var now = main.audiocontext.currentTime;
                        var time = startTime || 0;
                        var pTime = time + now;
                        if (this.isPlaying() && this.buffer && this.bufferSourceNode) {
                            this._paused = true;
                            this._playing = false;
                            this.pauseTime = this.currentTime();
                            this.bufferSourceNode.stop(pTime);
                            this._counterNode.stop(pTime);
                            this._pauseTime = this.currentTime();
                        } else this._pauseTime = 0;
                    }
                },
                {
                    key: "loop",
                    value: function loop(startTime, rate, amp, loopStart, duration) {
                        this._looping = true;
                        this.play(startTime, rate, amp, loopStart, duration);
                    }
                },
                {
                    key: "setLoop",
                    value: function setLoop(bool) {
                        if (bool === true) this._looping = true;
                        else if (bool === false) this._looping = false;
                        else throw "Error: setLoop accepts either true or false";
                        if (this.bufferSourceNode) {
                            this.bufferSourceNode.loop = this._looping;
                            this._counterNode.loop = this._looping;
                        }
                    }
                },
                {
                    key: "isLooping",
                    value: function isLooping() {
                        if (!this.bufferSourceNode) return false;
                        if (this._looping === true && this.isPlaying() === true) return true;
                        return false;
                    }
                },
                {
                    key: "isPlaying",
                    value: function isPlaying() {
                        return this._playing;
                    }
                },
                {
                    key: "isPaused",
                    value: function isPaused() {
                        return this._paused;
                    }
                },
                {
                    key: "stop",
                    value: function stop(timeFromNow) {
                        var time = timeFromNow || 0;
                        if (this.mode === "sustain" || this.mode === "untildone") {
                            this.stopAll(time);
                            this._playing = false;
                            this.pauseTime = 0;
                            this._paused = false;
                        } else if (this.buffer && this.bufferSourceNode) {
                            var now = main.audiocontext.currentTime;
                            var t = time || 0;
                            this.pauseTime = 0;
                            this.bufferSourceNode.stop(now + t);
                            this._counterNode.stop(now + t);
                            this._playing = false;
                            this._paused = false;
                        }
                    }
                },
                {
                    key: "stopAll",
                    value: function stopAll(_time) {
                        var now = main.audiocontext.currentTime;
                        var time = _time || 0;
                        if (this.buffer && this.bufferSourceNode) {
                            for(var i in this.bufferSourceNodes){
                                var bufferSourceNode = this.bufferSourceNodes[i];
                                if (bufferSourceNode) try {
                                    bufferSourceNode.stop(now + time);
                                } catch (e) {}
                            }
                            this._counterNode.stop(now + time);
                        }
                    }
                },
                {
                    key: "getVolume",
                    value: function getVolume() {
                        return this.output.gain.value;
                    }
                },
                {
                    key: "pan",
                    value: function pan(pval, tFromNow) {
                        this.panPosition = pval;
                        this.panner.pan(pval, tFromNow);
                    }
                },
                {
                    key: "getPan",
                    value: function getPan() {
                        return this.panPosition;
                    }
                },
                {
                    key: "rate",
                    value: function rate(playbackRate) {
                        var reverse = false;
                        if (typeof playbackRate === "undefined") return this.playbackRate;
                        this.playbackRate = playbackRate;
                        if (playbackRate === 0) playbackRate = 0.0000000000001;
                        else if (playbackRate < 0 && !this.reversed) {
                            playbackRate = Math.abs(playbackRate);
                            reverse = true;
                        } else if (playbackRate > 0 && this.reversed) reverse = true;
                        if (this.bufferSourceNode) {
                            var now = main.audiocontext.currentTime;
                            this.bufferSourceNode.playbackRate.cancelScheduledValues(now);
                            this.bufferSourceNode.playbackRate.linearRampToValueAtTime(Math.abs(playbackRate), now);
                            this._counterNode.playbackRate.cancelScheduledValues(now);
                            this._counterNode.playbackRate.linearRampToValueAtTime(Math.abs(playbackRate), now);
                        }
                        if (reverse) this.reverseBuffer();
                        return this.playbackRate;
                    }
                },
                {
                    key: "setPitch",
                    value: function setPitch(num) {
                        var newPlaybackRate = midiToFreq(num) / midiToFreq(60);
                        this.rate(newPlaybackRate);
                    }
                },
                {
                    key: "getPlaybackRate",
                    value: function getPlaybackRate() {
                        return this.playbackRate;
                    }
                },
                {
                    key: "setVolume",
                    value: function setVolume(vol, _rampTime, _tFromNow) {
                        if (typeof vol === "number") {
                            var rampTime = _rampTime || 0;
                            var tFromNow = _tFromNow || 0;
                            var now = main.audiocontext.currentTime;
                            var currentVol = this.output.gain.value;
                            this.output.gain.cancelScheduledValues(now + tFromNow);
                            this.output.gain.linearRampToValueAtTime(currentVol, now + tFromNow);
                            this.output.gain.linearRampToValueAtTime(vol, now + tFromNow + rampTime);
                        } else if (vol) vol.connect(this.output.gain);
                        else return this.output.gain;
                    }
                },
                {
                    key: "duration",
                    value: function duration() {
                        if (this.buffer) return this.buffer.duration;
                        else return 0;
                    }
                },
                {
                    key: "currentTime",
                    value: function currentTime() {
                        return this.reversed ? Math.abs(this._lastPos - this.buffer.length) / soundfile_ac.sampleRate : this._lastPos / soundfile_ac.sampleRate;
                    }
                },
                {
                    key: "jump",
                    value: function jump(cueTime, duration) {
                        if (cueTime < 0 || cueTime > this.buffer.duration) throw "jump time out of range";
                        if (duration > this.buffer.duration - cueTime) throw "end time out of range";
                        var cTime = cueTime || 0;
                        var dur = duration || undefined;
                        if (this.isPlaying()) {
                            this.stop(0);
                            this.play(0, this.playbackRate, this.output.gain.value, cTime, dur);
                        }
                    }
                },
                {
                    key: "channels",
                    value: function channels() {
                        return this.buffer.numberOfChannels;
                    }
                },
                {
                    key: "sampleRate",
                    value: function sampleRate() {
                        return this.buffer.sampleRate;
                    }
                },
                {
                    key: "frames",
                    value: function frames() {
                        return this.buffer.length;
                    }
                },
                {
                    key: "getPeaks",
                    value: function getPeaks(length) {
                        if (this.buffer) {
                            if (!length) length = window.width * 5;
                            if (this.buffer) {
                                var buffer = this.buffer;
                                var sampleSize = buffer.length / length;
                                var sampleStep = ~~(sampleSize / 10) || 1;
                                var channels = buffer.numberOfChannels;
                                var peaks = new Float32Array(Math.round(length));
                                for(var c = 0; c < channels; c++){
                                    var chan = buffer.getChannelData(c);
                                    for(var i = 0; i < length; i++){
                                        var start = ~~(i * sampleSize);
                                        var end = ~~(start + sampleSize);
                                        var max = 0;
                                        for(var j = start; j < end; j += sampleStep){
                                            var value = chan[j];
                                            if (value > max) max = value;
                                            else if (-value > max) max = value;
                                        }
                                        if (c === 0 || Math.abs(max) > peaks[i]) peaks[i] = max;
                                    }
                                }
                                return peaks;
                            }
                        } else throw "Cannot load peaks yet, buffer is not loaded";
                    }
                },
                {
                    key: "reverseBuffer",
                    value: function reverseBuffer() {
                        if (this.buffer) {
                            var currentPos = this._lastPos / soundfile_ac.sampleRate;
                            var curVol = this.getVolume();
                            this.setVolume(0, 0.001);
                            var numChannels = this.buffer.numberOfChannels;
                            for(var i = 0; i < numChannels; i++)this.buffer.getChannelData(i).reverse();
                            this.reversed = !this.reversed;
                            if (this.isPlaying() && currentPos) this.jump(this.duration() - currentPos);
                            this.setVolume(curVol, 0.001);
                        } else throw "SoundFile is not done loading";
                    }
                },
                {
                    key: "onended",
                    value: function onended(callback) {
                        this._onended = callback;
                        return this;
                    }
                },
                {
                    key: "add",
                    value: function add() {}
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        var now = main.audiocontext.currentTime;
                        var index = main.soundArray.indexOf(this);
                        main.soundArray.splice(index, 1);
                        this.stop(now);
                        if (this.buffer && this.bufferSourceNode) {
                            for(var i = 0; i < this.bufferSourceNodes.length - 1; i++)if (this.bufferSourceNodes[i] !== null) {
                                this.bufferSourceNodes[i].disconnect();
                                try {
                                    this.bufferSourceNodes[i].stop(now);
                                } catch (e) {
                                    console.warn("no buffer source node to dispose");
                                }
                                this.bufferSourceNodes[i] = null;
                            }
                            if (this.isPlaying()) {
                                try {
                                    this._counterNode.stop(now);
                                } catch (e) {
                                    console.log(e);
                                }
                                this._counterNode = null;
                            }
                        }
                        if (this.output) {
                            this.output.disconnect();
                            this.output = null;
                        }
                        if (this.panner) {
                            this.panner.disconnect();
                            this.panner = null;
                        }
                    }
                },
                {
                    key: "connect",
                    value: function connect(unit) {
                        if (!unit) this.panner.connect(main.input);
                        else if (unit.hasOwnProperty("input")) this.panner.connect(unit.input);
                        else this.panner.connect(unit);
                    }
                },
                {
                    key: "disconnect",
                    value: function disconnect() {
                        if (this.panner) this.panner.disconnect();
                    }
                },
                {
                    key: "getLevel",
                    value: function getLevel() {
                        console.warn("p5.SoundFile.getLevel has been removed from the library. Use p5.Amplitude instead");
                    }
                },
                {
                    key: "setPath",
                    value: function setPath(p, callback) {
                        var path = (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype._checkFileFormats(p);
                        this.url = path;
                        this.load(callback);
                    }
                },
                {
                    key: "setBuffer",
                    value: function setBuffer(buf) {
                        var numChannels = buf.length;
                        var size = buf[0].length;
                        var newBuffer = soundfile_ac.createBuffer(numChannels, size, soundfile_ac.sampleRate);
                        if (!(buf[0] instanceof Float32Array)) buf[0] = new Float32Array(buf[0]);
                        for(var channelNum = 0; channelNum < numChannels; channelNum++){
                            var channel = newBuffer.getChannelData(channelNum);
                            channel.set(buf[channelNum]);
                        }
                        this.buffer = newBuffer;
                        this.panner.inputChannels(numChannels);
                    }
                },
                {
                    key: "_initCounterNode",
                    value: function _initCounterNode() {
                        var _this = this;
                        var self1 = this;
                        var now = soundfile_ac.currentTime;
                        var cNode = soundfile_ac.createBufferSource();
                        var workletBufferSize = safeBufferSize(256);
                        if (self1._workletNode) {
                            self1._workletNode.disconnect();
                            delete self1._workletNode;
                        }
                        self1._workletNode = new AudioWorkletNode(soundfile_ac, processorNames_default.a.soundFileProcessor, {
                            processorOptions: {
                                bufferSize: workletBufferSize
                            }
                        });
                        self1._workletNode.port.onmessage = function(event) {
                            if (event.data.name === "position") {
                                if (event.data.position === 0) return;
                                _this._lastPos = event.data.position;
                                _this._onTimeUpdate(self1._lastPos);
                            }
                        };
                        cNode.buffer = _createCounterBuffer(self1.buffer);
                        cNode.playbackRate.setValueAtTime(self1.playbackRate, now);
                        cNode.connect(self1._workletNode);
                        self1._workletNode.connect((0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).soundOut._silentNode);
                        return cNode;
                    }
                },
                {
                    key: "_initSourceNode",
                    value: function _initSourceNode() {
                        var bufferSourceNode = soundfile_ac.createBufferSource();
                        bufferSourceNode.buffer = this.buffer;
                        bufferSourceNode.playbackRate.value = this.playbackRate;
                        bufferSourceNode.connect(this.output);
                        return bufferSourceNode;
                    }
                },
                {
                    key: "processPeaks",
                    value: function processPeaks(callback, _initThreshold, _minThreshold, _minPeaks) {
                        console.warn("processPeaks is deprecated");
                    }
                },
                {
                    key: "addCue",
                    value: function addCue(time, callback, val) {
                        var id = this._cueIDCounter++;
                        var cue = new Cue(callback, time, id, val);
                        this._cues.push(cue);
                        return id;
                    }
                },
                {
                    key: "removeCue",
                    value: function removeCue(id) {
                        var cueLength = this._cues.length;
                        for(var i = 0; i < cueLength; i++){
                            var cue = this._cues[i];
                            if (cue.id === id) {
                                this._cues.splice(i, 1);
                                break;
                            }
                        }
                        this._cues.length;
                    }
                },
                {
                    key: "clearCues",
                    value: function clearCues() {
                        this._cues = [];
                    }
                },
                {
                    key: "_onTimeUpdate",
                    value: function _onTimeUpdate(position) {
                        var playbackTime = position / this.buffer.sampleRate;
                        var cueLength = this._cues.length;
                        for(var i = 0; i < cueLength; i++){
                            var cue = this._cues[i];
                            var callbackTime = cue.time;
                            var val = cue.val;
                            var leftLimit = this._prevUpdateTime || 0;
                            var rightLimit = playbackTime;
                            if (leftLimit <= callbackTime && callbackTime <= rightLimit) cue.callback(val);
                        }
                        this._prevUpdateTime = playbackTime;
                    }
                },
                {
                    key: "save",
                    value: function save(fileName) {
                        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.saveSound(this, fileName, "wav");
                    }
                },
                {
                    key: "getBlob",
                    value: function getBlob() {
                        var dataView = convertToWav(this.buffer);
                        return new Blob([
                            dataView
                        ], {
                            type: "audio/wav"
                        });
                    }
                }
            ]);
            return SoundFile;
        }();
        /**
 *  loadSound() returns a new p5.SoundFile from a specified
 *  path. If called during preload(), the p5.SoundFile will be ready
 *  to play in time for setup() and draw(). If called outside of
 *  preload, the p5.SoundFile will not be ready immediately, so
 *  loadSound accepts a callback as the second parameter. Using a
 *  <a href="https://github.com/processing/p5.js/wiki/Local-server">
 *  local server</a> is recommended when loading external files.
 *
 *  @method loadSound
 *  @for p5
 *  @param  {String|Array}   path     Path to the sound file, or an array with
 *                                    paths to soundfiles in multiple formats
 *                                    i.e. ['sound.ogg', 'sound.mp3'].
 *                                    Alternately, accepts an object: either
 *                                    from the HTML5 File API, or a p5.File.
 *  @param {Function} [successCallback]   Name of a function to call once file loads
 *  @param {Function} [errorCallback]   Name of a function to call if there is
 *                                      an error loading the file.
 *  @param {Function} [whileLoading] Name of a function to call while file is loading.
 *                                 This function will receive the percentage loaded
 *                                 so far, from 0.0 to 1.0.
 *  @return {SoundFile}            Returns a p5.SoundFile
 *  @example
 *  <div><code>
 *  let mySound;
 *  function preload() {
 *    soundFormats('mp3', 'ogg');
 *    mySound = loadSound('assets/doorbell');
 *  }
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(canvasPressed);
 *    background(220);
 *    text('tap here to play', 10, 20);
 *  }
 *
 *  function canvasPressed() {
 *    // playing a sound file on a user gesture
 *    // is equivalent to `userStartAudio()`
 *    mySound.play();
 *  }
 *  </code></div>
 */ function loadSound(path, callback, onerror1, whileLoading) {
            if (window.location.origin.indexOf("file://") > -1 && window.cordova === "undefined") window.alert("This sketch may require a server to load external files. Please see http://bit.ly/1qcInwS");
            var self1 = this;
            var s = new soundfile_SoundFile(path, function() {
                if (typeof callback === "function") callback.apply(self1, arguments);
                if (typeof self1._decrementPreload === "function") self1._decrementPreload();
            }, onerror1, whileLoading);
            return s;
        }
        var soundfile = soundfile_SoundFile;
        function amplitude_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function amplitude_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function amplitude_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) amplitude_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) amplitude_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        /**
 *  Amplitude measures volume between 0.0 and 1.0.
 *  Listens to all p5sound by default, or use setInput()
 *  to listen to a specific sound source. Accepts an optional
 *  smoothing value, which defaults to 0.
 *
 *  @class p5.Amplitude
 *  @constructor
 *  @param {Number} [smoothing] between 0.0 and .999 to smooth
 *                             amplitude readings (defaults to 0)
 *  @example
 *  <div><code>
 *  let sound, amplitude;
 *
 *  function preload(){
 *    sound = loadSound('assets/beat.mp3');
 *  }
 *  function setup() {
 *    let cnv = createCanvas(100,100);
 *    cnv.mouseClicked(togglePlay);
 *    amplitude = new p5.Amplitude();
 *  }
 *
 *  function draw() {
 *    background(220);
 *    text('tap to play', 20, 20);
 *
 *    let level = amplitude.getLevel();
 *    let size = map(level, 0, 1, 0, 200);
 *    ellipse(width/2, height/2, size, size);
 *  }
 *
 *  function togglePlay() {
 *    if (sound.isPlaying() ){
 *      sound.pause();
 *    } else {
 *      sound.loop();
 *		amplitude = new p5.Amplitude();
 *		amplitude.setInput(sound);
 *    }
 *  }
 *
 *  </code></div>
 */ var amplitude_Amplitude = function() {
            function Amplitude(smoothing) {
                amplitude_classCallCheck(this, Amplitude);
                this.bufferSize = safeBufferSize(2048);
                this.audiocontext = main.audiocontext;
                this._workletNode = new AudioWorkletNode(this.audiocontext, processorNames_default.a.amplitudeProcessor, {
                    outputChannelCount: [
                        1
                    ],
                    parameterData: {
                        smoothing: smoothing || 0
                    },
                    processorOptions: {
                        normalize: false,
                        smoothing: smoothing || 0,
                        numInputChannels: 2,
                        bufferSize: this.bufferSize
                    }
                });
                this._workletNode.port.onmessage = (function(event) {
                    if (event.data.name === "amplitude") {
                        this.volume = event.data.volume;
                        this.volNorm = event.data.volNorm;
                        this.stereoVol = event.data.stereoVol;
                        this.stereoVolNorm = event.data.stereoVolNorm;
                    }
                }).bind(this);
                this.input = this._workletNode;
                this.output = this.audiocontext.createGain();
                this.volume = 0;
                this.volNorm = 0;
                this.stereoVol = [
                    0,
                    0
                ];
                this.stereoVolNorm = [
                    0,
                    0
                ];
                this.normalize = false;
                this._workletNode.connect(this.output);
                this.output.gain.value = 0;
                this.output.connect(this.audiocontext.destination);
                main.meter.connect(this._workletNode);
                main.soundArray.push(this);
            }
            /**
   *  Connects to the p5sound instance (main output) by default.
   *  Optionally, you can pass in a specific source (i.e. a soundfile).
   *
   *  @method setInput
   *  @for p5.Amplitude
   *  @param {soundObject|undefined} [snd] set the sound source
   *                                       (optional, defaults to
   *                                       main output)
   *  @param {Number|undefined} [smoothing] a range between 0.0 and 1.0
   *                                        to smooth amplitude readings
   *  @example
   *  <div><code>
   *  function preload(){
   *    sound1 = loadSound('assets/beat.mp3');
   *    sound2 = loadSound('assets/drum.mp3');
   *  }
   *  function setup(){
   *    cnv = createCanvas(100, 100);
   *    cnv.mouseClicked(toggleSound);
   *
   *    amplitude = new p5.Amplitude();
   *    amplitude.setInput(sound2);
   *  }
   *
   *  function draw() {
   *    background(220);
   *    text('tap to play', 20, 20);
   *
   *    let level = amplitude.getLevel();
   *    let size = map(level, 0, 1, 0, 200);
   *    ellipse(width/2, height/2, size, size);
   *  }
   *
   *  function toggleSound(){
   *    if (sound1.isPlaying() && sound2.isPlaying()) {
   *      sound1.stop();
   *      sound2.stop();
   *    } else {
   *      sound1.play();
   *      sound2.play();
   *    }
   *  }
   *  </code></div>
   */ amplitude_createClass(Amplitude, [
                {
                    key: "setInput",
                    value: function setInput(source, smoothing) {
                        main.meter.disconnect();
                        if (smoothing) this._workletNode.parameters.get("smoothing").value = smoothing;
                        if (source == null) {
                            console.log("Amplitude input source is not ready! Connecting to main output instead");
                            main.meter.connect(this._workletNode);
                        } else if (source) {
                            source.connect(this._workletNode);
                            this._workletNode.disconnect();
                            this._workletNode.connect(this.output);
                        } else main.meter.connect(this._workletNode);
                    }
                },
                {
                    key: "connect",
                    value: function connect(unit) {
                        if (unit) {
                            if (unit.hasOwnProperty("input")) this.output.connect(unit.input);
                            else this.output.connect(unit);
                        } else this.output.connect(this.panner.connect(main.input));
                    }
                },
                {
                    key: "disconnect",
                    value: function disconnect() {
                        if (this.output) this.output.disconnect();
                    }
                },
                {
                    key: "getLevel",
                    value: function getLevel(channel) {
                        if (typeof channel !== "undefined") {
                            if (this.normalize) return this.stereoVolNorm[channel];
                            else return this.stereoVol[channel];
                        } else if (this.normalize) return this.volNorm;
                        else return this.volume;
                    }
                },
                {
                    key: "toggleNormalize",
                    value: function toggleNormalize(bool) {
                        if (typeof bool === "boolean") this.normalize = bool;
                        else this.normalize = !this.normalize;
                        this._workletNode.port.postMessage({
                            name: "toggleNormalize",
                            normalize: this.normalize
                        });
                    }
                },
                {
                    key: "smooth",
                    value: function smooth(s) {
                        if (s >= 0 && s < 1) this._workletNode.port.postMessage({
                            name: "smoothing",
                            smoothing: s
                        });
                        else console.log("Error: smoothing must be between 0 and 1");
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        var index = main.soundArray.indexOf(this);
                        main.soundArray.splice(index, 1);
                        if (this.input) {
                            this.input.disconnect();
                            delete this.input;
                        }
                        if (this.output) {
                            this.output.disconnect();
                            delete this.output;
                        }
                        this._workletNode.disconnect();
                        delete this._workletNode;
                    }
                }
            ]);
            return Amplitude;
        }();
        var amplitude = amplitude_Amplitude;
        function fft_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function fft_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function fft_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) fft_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) fft_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        /**
 *  <p>FFT (Fast Fourier Transform) is an analysis algorithm that
 *  isolates individual
 *  <a href="https://en.wikipedia.org/wiki/Audio_frequency">
 *  audio frequencies</a> within a waveform.</p>
 *
 *  <p>Once instantiated, a p5.FFT object can return an array based on
 *  two types of analyses: <br> • <code>FFT.waveform()</code> computes
 *  amplitude values along the time domain. The array indices correspond
 *  to samples across a brief moment in time. Each value represents
 *  amplitude of the waveform at that sample of time.<br>
 *  • <code>FFT.analyze() </code> computes amplitude values along the
 *  frequency domain. The array indices correspond to frequencies (i.e.
 *  pitches), from the lowest to the highest that humans can hear. Each
 *  value represents amplitude at that slice of the frequency spectrum.
 *  Use with <code>getEnergy()</code> to measure amplitude at specific
 *  frequencies, or within a range of frequencies. </p>
 *
 *  <p>FFT analyzes a very short snapshot of sound called a sample
 *  buffer. It returns an array of amplitude measurements, referred
 *  to as <code>bins</code>. The array is 1024 bins long by default.
 *  You can change the bin array length, but it must be a power of 2
 *  between 16 and 1024 in order for the FFT algorithm to function
 *  correctly. The actual size of the FFT buffer is twice the
 *  number of bins, so given a standard sample rate, the buffer is
 *  2048/44100 seconds long.</p>
 *
 *
 *  @class p5.FFT
 *  @constructor
 *  @param {Number} [smoothing]   Smooth results of Freq Spectrum.
 *                                0.0 < smoothing < 1.0.
 *                                Defaults to 0.8.
 *  @param {Number} [bins]    Length of resulting array.
 *                            Must be a power of two between
 *                            16 and 1024. Defaults to 1024.
 *  @example
 *  <div><code>
 *  function preload(){
 *    sound = loadSound('assets/Damscray_DancingTiger.mp3');
 *  }
 *
 *  function setup(){
 *    let cnv = createCanvas(100,100);
 *    cnv.mouseClicked(togglePlay);
 *    fft = new p5.FFT();
 *    sound.amp(0.2);
 *  }
 *
 *  function draw(){
 *    background(220);
 *
 *    let spectrum = fft.analyze();
 *    noStroke();
 *    fill(255, 0, 255);
 *    for (let i = 0; i< spectrum.length; i++){
 *      let x = map(i, 0, spectrum.length, 0, width);
 *      let h = -height + map(spectrum[i], 0, 255, height, 0);
 *      rect(x, height, width / spectrum.length, h )
 *    }
 *
 *    let waveform = fft.waveform();
 *    noFill();
 *    beginShape();
 *    stroke(20);
 *    for (let i = 0; i < waveform.length; i++){
 *      let x = map(i, 0, waveform.length, 0, width);
 *      let y = map( waveform[i], -1, 1, 0, height);
 *      vertex(x,y);
 *    }
 *    endShape();
 *
 *    text('tap to play', 20, 20);
 *  }
 *
 *  function togglePlay() {
 *    if (sound.isPlaying()) {
 *      sound.pause();
 *    } else {
 *      sound.loop();
 *    }
 *  }
 *  </code></div>
 */ var fft_FFT = function() {
            function FFT(smoothing, bins) {
                fft_classCallCheck(this, FFT);
                this.input = this.analyser = main.audiocontext.createAnalyser();
                Object.defineProperties(this, {
                    bins: {
                        get: function get() {
                            return this.analyser.fftSize / 2;
                        },
                        set: function set(b) {
                            this.analyser.fftSize = b * 2;
                        },
                        configurable: true,
                        enumerable: true
                    },
                    smoothing: {
                        get: function get() {
                            return this.analyser.smoothingTimeConstant;
                        },
                        set: function set(s) {
                            this.analyser.smoothingTimeConstant = s;
                        },
                        configurable: true,
                        enumerable: true
                    }
                });
                this.smooth(smoothing);
                this.bins = bins || 1024;
                main.fftMeter.connect(this.analyser);
                this.freqDomain = new Uint8Array(this.analyser.frequencyBinCount);
                this.timeDomain = new Uint8Array(this.analyser.frequencyBinCount);
                this.bass = [
                    20,
                    140
                ];
                this.lowMid = [
                    140,
                    400
                ];
                this.mid = [
                    400,
                    2600
                ];
                this.highMid = [
                    2600,
                    5200
                ];
                this.treble = [
                    5200,
                    14000
                ];
                main.soundArray.push(this);
            }
            /**
   *  Set the input source for the FFT analysis. If no source is
   *  provided, FFT will analyze all sound in the sketch.
   *
   *  @method  setInput
   *  @for p5.FFT
   *  @param {Object} [source] p5.sound object (or web audio API source node)
   */ fft_createClass(FFT, [
                {
                    key: "setInput",
                    value: function setInput(source) {
                        if (!source) main.fftMeter.connect(this.analyser);
                        else {
                            if (source.output) source.output.connect(this.analyser);
                            else if (source.connect) source.connect(this.analyser);
                            main.fftMeter.disconnect();
                        }
                    }
                },
                {
                    key: "waveform",
                    value: function waveform() {
                        var bins, mode;
                        var normalArray = new Array();
                        for(var i = 0; i < arguments.length; i++){
                            if (typeof arguments[i] === "number") {
                                bins = arguments[i];
                                this.analyser.fftSize = bins * 2;
                            }
                            if (typeof arguments[i] === "string") mode = arguments[i];
                        }
                        if (mode && !(0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype._isSafari()) {
                            timeToFloat(this, this.timeDomain);
                            this.analyser.getFloatTimeDomainData(this.timeDomain);
                            return this.timeDomain;
                        } else {
                            timeToInt(this, this.timeDomain);
                            this.analyser.getByteTimeDomainData(this.timeDomain);
                            for(var j = 0; j < this.timeDomain.length; j++){
                                var scaled = (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.map(this.timeDomain[j], 0, 255, -1, 1);
                                normalArray.push(scaled);
                            }
                            return normalArray;
                        }
                    }
                },
                {
                    key: "analyze",
                    value: function analyze() {
                        var mode;
                        for(var i = 0; i < arguments.length; i++){
                            if (typeof arguments[i] === "number") {
                                this.bins = arguments[i];
                                this.analyser.fftSize = this.bins * 2;
                            }
                            if (typeof arguments[i] === "string") mode = arguments[i];
                        }
                        if (mode && mode.toLowerCase() === "db") {
                            freqToFloat(this);
                            this.analyser.getFloatFrequencyData(this.freqDomain);
                            return this.freqDomain;
                        } else {
                            freqToInt(this, this.freqDomain);
                            this.analyser.getByteFrequencyData(this.freqDomain);
                            var normalArray = Array.apply([], this.freqDomain);
                            return normalArray;
                        }
                    }
                },
                {
                    key: "getEnergy",
                    value: function getEnergy(frequency1, frequency2) {
                        var nyquist = main.audiocontext.sampleRate / 2;
                        if (frequency1 === "bass") {
                            frequency1 = this.bass[0];
                            frequency2 = this.bass[1];
                        } else if (frequency1 === "lowMid") {
                            frequency1 = this.lowMid[0];
                            frequency2 = this.lowMid[1];
                        } else if (frequency1 === "mid") {
                            frequency1 = this.mid[0];
                            frequency2 = this.mid[1];
                        } else if (frequency1 === "highMid") {
                            frequency1 = this.highMid[0];
                            frequency2 = this.highMid[1];
                        } else if (frequency1 === "treble") {
                            frequency1 = this.treble[0];
                            frequency2 = this.treble[1];
                        }
                        if (typeof frequency1 !== "number") throw "invalid input for getEnergy()";
                        else if (!frequency2) {
                            var index = Math.round(frequency1 / nyquist * this.freqDomain.length);
                            return this.freqDomain[index];
                        } else if (frequency1 && frequency2) {
                            if (frequency1 > frequency2) {
                                var swap = frequency2;
                                frequency2 = frequency1;
                                frequency1 = swap;
                            }
                            var lowIndex = Math.round(frequency1 / nyquist * this.freqDomain.length);
                            var highIndex = Math.round(frequency2 / nyquist * this.freqDomain.length);
                            var total = 0;
                            var numFrequencies = 0;
                            for(var i = lowIndex; i <= highIndex; i++){
                                total += this.freqDomain[i];
                                numFrequencies += 1;
                            }
                            var toReturn = total / numFrequencies;
                            return toReturn;
                        } else throw "invalid input for getEnergy()";
                    }
                },
                {
                    key: "getFreq",
                    value: function getFreq(freq1, freq2) {
                        console.log("getFreq() is deprecated. Please use getEnergy() instead.");
                        var x = this.getEnergy(freq1, freq2);
                        return x;
                    }
                },
                {
                    key: "getCentroid",
                    value: function getCentroid() {
                        var nyquist = main.audiocontext.sampleRate / 2;
                        var cumulative_sum = 0;
                        var centroid_normalization = 0;
                        for(var i = 0; i < this.freqDomain.length; i++){
                            cumulative_sum += i * this.freqDomain[i];
                            centroid_normalization += this.freqDomain[i];
                        }
                        var mean_freq_index = 0;
                        if (centroid_normalization !== 0) mean_freq_index = cumulative_sum / centroid_normalization;
                        var spec_centroid_freq = mean_freq_index * (nyquist / this.freqDomain.length);
                        return spec_centroid_freq;
                    }
                },
                {
                    key: "smooth",
                    value: function smooth(s) {
                        if (typeof s !== "undefined") this.smoothing = s;
                        return this.smoothing;
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        var index = main.soundArray.indexOf(this);
                        main.soundArray.splice(index, 1);
                        if (this.analyser) {
                            this.analyser.disconnect();
                            delete this.analyser;
                        }
                    }
                },
                {
                    key: "linAverages",
                    value: function linAverages(_N) {
                        var N = _N || 16;
                        var spectrum = this.freqDomain;
                        var spectrumLength = spectrum.length;
                        var spectrumStep = Math.floor(spectrumLength / N);
                        var linearAverages = new Array(N);
                        var groupIndex = 0;
                        for(var specIndex = 0; specIndex < spectrumLength; specIndex++){
                            linearAverages[groupIndex] = linearAverages[groupIndex] !== undefined ? (linearAverages[groupIndex] + spectrum[specIndex]) / 2 : spectrum[specIndex];
                            if (specIndex % spectrumStep === spectrumStep - 1) groupIndex++;
                        }
                        return linearAverages;
                    }
                },
                {
                    key: "logAverages",
                    value: function logAverages(octaveBands) {
                        var nyquist = main.audiocontext.sampleRate / 2;
                        var spectrum = this.freqDomain;
                        var spectrumLength = spectrum.length;
                        var logAverages = new Array(octaveBands.length);
                        var octaveIndex = 0;
                        for(var specIndex = 0; specIndex < spectrumLength; specIndex++){
                            var specIndexFrequency = Math.round(specIndex * nyquist / this.freqDomain.length);
                            if (specIndexFrequency > octaveBands[octaveIndex].hi) octaveIndex++;
                            logAverages[octaveIndex] = logAverages[octaveIndex] !== undefined ? (logAverages[octaveIndex] + spectrum[specIndex]) / 2 : spectrum[specIndex];
                        }
                        return logAverages;
                    }
                },
                {
                    key: "getOctaveBands",
                    value: function getOctaveBands(_N, _fCtr0) {
                        var N = _N || 3;
                        var fCtr0 = _fCtr0 || 15.625;
                        var octaveBands = [];
                        var lastFrequencyBand = {
                            lo: fCtr0 / Math.pow(2, 1 / (2 * N)),
                            ctr: fCtr0,
                            hi: fCtr0 * Math.pow(2, 1 / (2 * N))
                        };
                        octaveBands.push(lastFrequencyBand);
                        var nyquist = main.audiocontext.sampleRate / 2;
                        while(lastFrequencyBand.hi < nyquist){
                            var newFrequencyBand = {};
                            newFrequencyBand.lo = lastFrequencyBand.hi;
                            newFrequencyBand.ctr = lastFrequencyBand.ctr * Math.pow(2, 1 / N);
                            newFrequencyBand.hi = newFrequencyBand.ctr * Math.pow(2, 1 / (2 * N));
                            octaveBands.push(newFrequencyBand);
                            lastFrequencyBand = newFrequencyBand;
                        }
                        return octaveBands;
                    }
                }
            ]);
            return FFT;
        }();
        function freqToFloat(fft) {
            if (fft.freqDomain instanceof Float32Array === false) fft.freqDomain = new Float32Array(fft.analyser.frequencyBinCount);
        }
        function freqToInt(fft) {
            if (fft.freqDomain instanceof Uint8Array === false) fft.freqDomain = new Uint8Array(fft.analyser.frequencyBinCount);
        }
        function timeToFloat(fft) {
            if (fft.timeDomain instanceof Float32Array === false) fft.timeDomain = new Float32Array(fft.analyser.frequencyBinCount);
        }
        function timeToInt(fft) {
            if (fft.timeDomain instanceof Uint8Array === false) fft.timeDomain = new Uint8Array(fft.analyser.frequencyBinCount);
        }
        var fft = fft_FFT;
        var Add = __webpack_require__(4);
        var Add_default = __webpack_require__.n(Add);
        var Multiply = __webpack_require__(1);
        var Multiply_default = __webpack_require__.n(Multiply);
        var Scale = __webpack_require__(8);
        var Scale_default = __webpack_require__.n(Scale);
        function oscillator_typeof(obj) {
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") oscillator_typeof = function _typeof(obj) {
                return typeof obj;
            };
            else oscillator_typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            return oscillator_typeof(obj);
        }
        function _possibleConstructorReturn(self1, call) {
            if (call && (oscillator_typeof(call) === "object" || typeof call === "function")) return call;
            return _assertThisInitialized(self1);
        }
        function _assertThisInitialized(self1) {
            if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return self1;
        }
        function _getPrototypeOf(o) {
            _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
            };
            return _getPrototypeOf(o);
        }
        function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    writable: true,
                    configurable: true
                }
            });
            if (superClass) _setPrototypeOf(subClass, superClass);
        }
        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };
            return _setPrototypeOf(o, p);
        }
        function oscillator_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function oscillator_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function oscillator_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) oscillator_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) oscillator_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        function sigChain(o, mathObj, thisChain, nextChain, type) {
            var chainSource = o.oscillator;
            for(var i in o.mathOps)if (o.mathOps[i] instanceof type) {
                chainSource.disconnect();
                o.mathOps[i].dispose();
                thisChain = i;
                if (thisChain < o.mathOps.length - 2) nextChain = o.mathOps[i + 1];
            }
            if (thisChain === o.mathOps.length - 1) o.mathOps.push(nextChain);
            if (i > 0) chainSource = o.mathOps[i - 1];
            chainSource.disconnect();
            chainSource.connect(mathObj);
            mathObj.connect(nextChain);
            o.mathOps[thisChain] = mathObj;
            return o;
        }
        /**
 *  <p>Creates a signal that oscillates between -1.0 and 1.0.
 *  By default, the oscillation takes the form of a sinusoidal
 *  shape ('sine'). Additional types include 'triangle',
 *  'sawtooth' and 'square'. The frequency defaults to
 *  440 oscillations per second (440Hz, equal to the pitch of an
 *  'A' note).</p>
 *
 *  <p>Set the type of oscillation with setType(), or by instantiating a
 *  specific oscillator: <a href="/reference/#/p5.SinOsc">p5.SinOsc</a>, <a
 *  href="/reference/#/p5.TriOsc">p5.TriOsc</a>, <a
 *  href="/reference/#/p5.SqrOsc">p5.SqrOsc</a>, or <a
 *  href="/reference/#/p5.SawOsc">p5.SawOsc</a>.
 *  </p>
 *
 *  @class p5.Oscillator
 *  @constructor
 *  @param {Number} [freq] frequency defaults to 440Hz
 *  @param {String} [type] type of oscillator. Options:
 *                         'sine' (default), 'triangle',
 *                         'sawtooth', 'square'
 *  @example
 *  <div><code>
 *  let osc, playing, freq, amp;
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(playOscillator);
 *    osc = new p5.Oscillator('sine');
 *  }
 *
 *  function draw() {
 *    background(220)
 *    freq = constrain(map(mouseX, 0, width, 100, 500), 100, 500);
 *    amp = constrain(map(mouseY, height, 0, 0, 1), 0, 1);
 *
 *    text('tap to play', 20, 20);
 *    text('freq: ' + freq, 20, 40);
 *    text('amp: ' + amp, 20, 60);
 *
 *    if (playing) {
 *      // smooth the transitions by 0.1 seconds
 *      osc.freq(freq, 0.1);
 *      osc.amp(amp, 0.1);
 *    }
 *  }
 *
 *  function playOscillator() {
 *    // starting an oscillator on a user gesture will enable audio
 *    // in browsers that have a strict autoplay policy.
 *    // See also: userStartAudio();
 *    osc.start();
 *    playing = true;
 *  }
 *
 *  function mouseReleased() {
 *    // ramp amplitude to 0 over 0.5 seconds
 *    osc.amp(0, 0.5);
 *    playing = false;
 *  }
 *  </code> </div>
 */ var oscillator_Oscillator = function() {
            function Oscillator(freq, type) {
                oscillator_classCallCheck(this, Oscillator);
                if (typeof freq === "string") {
                    var f = type;
                    type = freq;
                    freq = f;
                }
                if (typeof type === "number") {
                    var _f = type;
                    type = freq;
                    freq = _f;
                }
                this.started = false;
                this.phaseAmount = undefined;
                this.oscillator = main.audiocontext.createOscillator();
                this.f = freq || 440.0;
                this.oscillator.type = type || "sine";
                this.oscillator.frequency.setValueAtTime(this.f, main.audiocontext.currentTime);
                this.output = main.audiocontext.createGain();
                this._freqMods = [];
                this.output.gain.value = 0.5;
                this.output.gain.setValueAtTime(0.5, main.audiocontext.currentTime);
                this.oscillator.connect(this.output);
                this.panPosition = 0.0;
                this.connection = main.input;
                this.panner = new panner_0(this.output, this.connection, 1);
                this.mathOps = [
                    this.output
                ];
                main.soundArray.push(this);
                this.fade = this.amp;
            }
            /**
   *  Start an oscillator.
   *
   *  Starting an oscillator on a user gesture will enable audio in browsers
   *  that have a strict autoplay policy, including Chrome and most mobile
   *  devices. See also: `userStartAudio()`.
   *
   *  @method  start
   *  @for p5.Oscillator
   *  @param  {Number} [time] startTime in seconds from now.
   *  @param  {Number} [frequency] frequency in Hz.
   */ oscillator_createClass(Oscillator, [
                {
                    key: "start",
                    value: function start(time, f) {
                        if (this.started) {
                            var now = main.audiocontext.currentTime;
                            this.stop(now);
                        }
                        if (!this.started) {
                            var freq = f || this.f;
                            var type = this.oscillator.type;
                            if (this.oscillator) {
                                this.oscillator.disconnect();
                                delete this.oscillator;
                            }
                            this.oscillator = main.audiocontext.createOscillator();
                            this.oscillator.frequency.value = Math.abs(freq);
                            this.oscillator.type = type;
                            this.oscillator.connect(this.output);
                            time = time || 0;
                            this.oscillator.start(time + main.audiocontext.currentTime);
                            this.freqNode = this.oscillator.frequency;
                            for(var i in this._freqMods)if (typeof this._freqMods[i].connect !== "undefined") this._freqMods[i].connect(this.oscillator.frequency);
                            this.started = true;
                        }
                    }
                },
                {
                    key: "stop",
                    value: function stop(time) {
                        if (this.started) {
                            var t = time || 0;
                            var now = main.audiocontext.currentTime;
                            this.oscillator.stop(t + now);
                            this.started = false;
                        }
                    }
                },
                {
                    key: "amp",
                    value: function amp(vol) {
                        var rampTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                        var tFromNow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                        if (typeof vol === "number") {
                            var now = main.audiocontext.currentTime;
                            this.output.gain.linearRampToValueAtTime(vol, now + tFromNow + rampTime);
                        } else if (vol) vol.connect(this.output.gain);
                        else return this.output.gain;
                    }
                },
                {
                    key: "getAmp",
                    value: function getAmp() {
                        return this.output.gain.value;
                    }
                },
                {
                    key: "freq",
                    value: function freq(val) {
                        var rampTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                        var tFromNow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                        if (typeof val === "number" && !isNaN(val)) {
                            this.f = val;
                            var now = main.audiocontext.currentTime;
                            if (rampTime === 0) this.oscillator.frequency.setValueAtTime(val, tFromNow + now);
                            else if (val > 0) this.oscillator.frequency.exponentialRampToValueAtTime(val, tFromNow + rampTime + now);
                            else this.oscillator.frequency.linearRampToValueAtTime(val, tFromNow + rampTime + now);
                            if (this.phaseAmount) this.phase(this.phaseAmount);
                        } else if (val) {
                            if (val.output) val = val.output;
                            val.connect(this.oscillator.frequency);
                            this._freqMods.push(val);
                        } else return this.oscillator.frequency;
                    }
                },
                {
                    key: "getFreq",
                    value: function getFreq() {
                        return this.oscillator.frequency.value;
                    }
                },
                {
                    key: "setType",
                    value: function setType(type) {
                        this.oscillator.type = type;
                    }
                },
                {
                    key: "getType",
                    value: function getType() {
                        return this.oscillator.type;
                    }
                },
                {
                    key: "connect",
                    value: function connect(unit) {
                        if (!unit) this.panner.connect(main.input);
                        else if (unit.hasOwnProperty("input")) {
                            this.panner.connect(unit.input);
                            this.connection = unit.input;
                        } else {
                            this.panner.connect(unit);
                            this.connection = unit;
                        }
                    }
                },
                {
                    key: "disconnect",
                    value: function disconnect() {
                        if (this.output) this.output.disconnect();
                        if (this.panner) {
                            this.panner.disconnect();
                            if (this.output) this.output.connect(this.panner);
                        }
                        this.oscMods = [];
                    }
                },
                {
                    key: "pan",
                    value: function pan(pval, tFromNow) {
                        this.panPosition = pval;
                        this.panner.pan(pval, tFromNow);
                    }
                },
                {
                    key: "getPan",
                    value: function getPan() {
                        return this.panPosition;
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        var index = main.soundArray.indexOf(this);
                        main.soundArray.splice(index, 1);
                        if (this.oscillator) {
                            var now = main.audiocontext.currentTime;
                            this.stop(now);
                            this.disconnect();
                            this.panner = null;
                            this.oscillator = null;
                        }
                        if (this.osc2) this.osc2.dispose();
                    }
                },
                {
                    key: "phase",
                    value: function phase(p) {
                        var delayAmt = (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.map(p, 0, 1.0, 0, 1 / this.f);
                        var now = main.audiocontext.currentTime;
                        this.phaseAmount = p;
                        if (!this.dNode) {
                            this.dNode = main.audiocontext.createDelay();
                            this.oscillator.disconnect();
                            this.oscillator.connect(this.dNode);
                            this.dNode.connect(this.output);
                        }
                        this.dNode.delayTime.setValueAtTime(delayAmt, now);
                    }
                },
                {
                    key: "add",
                    value: function add(num) {
                        var add = new Add_default.a(num);
                        var thisChain = this.mathOps.length - 1;
                        var nextChain = this.output;
                        return sigChain(this, add, thisChain, nextChain, Add_default.a);
                    }
                },
                {
                    key: "mult",
                    value: function mult(num) {
                        var mult = new Multiply_default.a(num);
                        var thisChain = this.mathOps.length - 1;
                        var nextChain = this.output;
                        return sigChain(this, mult, thisChain, nextChain, Multiply_default.a);
                    }
                },
                {
                    key: "scale",
                    value: function scale(inMin, inMax, outMin, outMax) {
                        var mapOutMin, mapOutMax;
                        if (arguments.length === 4) {
                            mapOutMin = (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.map(outMin, inMin, inMax, 0, 1) - 0.5;
                            mapOutMax = (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.map(outMax, inMin, inMax, 0, 1) - 0.5;
                        } else {
                            mapOutMin = arguments[0];
                            mapOutMax = arguments[1];
                        }
                        var scale = new Scale_default.a(mapOutMin, mapOutMax);
                        var thisChain = this.mathOps.length - 1;
                        var nextChain = this.output;
                        return sigChain(this, scale, thisChain, nextChain, Scale_default.a);
                    }
                }
            ]);
            return Oscillator;
        }();
        /**
 *  Constructor: <code>new p5.SinOsc()</code>.
 *  This creates a Sine Wave Oscillator and is
 *  equivalent to <code> new p5.Oscillator('sine')
 *  </code> or creating a p5.Oscillator and then calling
 *  its method <code>setType('sine')</code>.
 *  See p5.Oscillator for methods.
 *
 *  @class  p5.SinOsc
 *  @constructor
 *  @extends p5.Oscillator
 *  @param {Number} [freq] Set the frequency
 */ var SinOsc = function(_Oscillator) {
            _inherits(SinOsc, _Oscillator);
            function SinOsc(freq) {
                oscillator_classCallCheck(this, SinOsc);
                return _possibleConstructorReturn(this, _getPrototypeOf(SinOsc).call(this, freq, "sine"));
            }
            return SinOsc;
        }(oscillator_Oscillator);
        /**
 *  Constructor: <code>new p5.TriOsc()</code>.
 *  This creates a Triangle Wave Oscillator and is
 *  equivalent to <code>new p5.Oscillator('triangle')
 *  </code> or creating a p5.Oscillator and then calling
 *  its method <code>setType('triangle')</code>.
 *  See p5.Oscillator for methods.
 *
 *  @class  p5.TriOsc
 *  @constructor
 *  @extends p5.Oscillator
 *  @param {Number} [freq] Set the frequency
 */ var TriOsc = function(_Oscillator2) {
            _inherits(TriOsc, _Oscillator2);
            function TriOsc(freq) {
                oscillator_classCallCheck(this, TriOsc);
                return _possibleConstructorReturn(this, _getPrototypeOf(TriOsc).call(this, freq, "triangle"));
            }
            return TriOsc;
        }(oscillator_Oscillator);
        /**
 *  Constructor: <code>new p5.SawOsc()</code>.
 *  This creates a SawTooth Wave Oscillator and is
 *  equivalent to <code> new p5.Oscillator('sawtooth')
 *  </code> or creating a p5.Oscillator and then calling
 *  its method <code>setType('sawtooth')</code>.
 *  See p5.Oscillator for methods.
 *
 *  @class  p5.SawOsc
 *  @constructor
 *  @extends p5.Oscillator
 *  @param {Number} [freq] Set the frequency
 */ var SawOsc = function(_Oscillator3) {
            _inherits(SawOsc, _Oscillator3);
            function SawOsc(freq) {
                oscillator_classCallCheck(this, SawOsc);
                return _possibleConstructorReturn(this, _getPrototypeOf(SawOsc).call(this, freq, "sawtooth"));
            }
            return SawOsc;
        }(oscillator_Oscillator);
        /**
 *  Constructor: <code>new p5.SqrOsc()</code>.
 *  This creates a Square Wave Oscillator and is
 *  equivalent to <code> new p5.Oscillator('square')
 *  </code> or creating a p5.Oscillator and then calling
 *  its method <code>setType('square')</code>.
 *  See p5.Oscillator for methods.
 *
 *  @class  p5.SqrOsc
 *  @constructor
 *  @extends p5.Oscillator
 *  @param {Number} [freq] Set the frequency
 */ var SqrOsc = function(_Oscillator4) {
            _inherits(SqrOsc, _Oscillator4);
            function SqrOsc(freq) {
                oscillator_classCallCheck(this, SqrOsc);
                return _possibleConstructorReturn(this, _getPrototypeOf(SqrOsc).call(this, freq, "square"));
            }
            return SqrOsc;
        }(oscillator_Oscillator);
        var oscillator = oscillator_Oscillator;
        var TimelineSignal = __webpack_require__(7);
        var TimelineSignal_default = __webpack_require__.n(TimelineSignal);
        /**
 *  <p>Envelopes are pre-defined amplitude distribution over time.
 *  Typically, envelopes are used to control the output volume
 *  of an object, a series of fades referred to as Attack, Decay,
 *  Sustain and Release (
 *  <a href="https://upload.wikimedia.org/wikipedia/commons/e/ea/ADSR_parameter.svg">ADSR</a>
 *  ). Envelopes can also control other Web Audio Parameters—for example, a p5.Envelope can
 *  control an Oscillator's frequency like this: <code>osc.freq(env)</code>.</p>
 *  <p>Use <code><a href="#/p5.Envelope/setRange">setRange</a></code> to change the attack/release level.
 *  Use <code><a href="#/p5.Envelope/setADSR">setADSR</a></code> to change attackTime, decayTime, sustainPercent and releaseTime.</p>
 *  <p>Use the <code><a href="#/p5.Envelope/play">play</a></code> method to play the entire envelope,
 *  the <code><a href="#/p5.Envelope/ramp">ramp</a></code> method for a pingable trigger,
 *  or <code><a href="#/p5.Envelope/triggerAttack">triggerAttack</a></code>/
 *  <code><a href="#/p5.Envelope/triggerRelease">triggerRelease</a></code> to trigger noteOn/noteOff.</p>
 *
 *  @class p5.Envelope
 *  @constructor
 *  @example
 *  <div><code>
 *  let t1 = 0.1; // attack time in seconds
 *  let l1 = 0.7; // attack level 0.0 to 1.0
 *  let t2 = 0.3; // decay time in seconds
 *  let l2 = 0.1; // decay level  0.0 to 1.0
 *
 *  let env;
 *  let triOsc;
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    background(220);
 *    text('tap to play', 20, 20);
 *    cnv.mousePressed(playSound);
 *
 *    env = new p5.Envelope(t1, l1, t2, l2);
 *    triOsc = new p5.Oscillator('triangle');
 *  }
 *
 *  function playSound() {
 *    // starting the oscillator ensures that audio is enabled.
 *    triOsc.start();
 *    env.play(triOsc);
 *  }
 *  </code></div>
 */ (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope = function(t1, l1, t2, l2, t3, l3) {
            /**
   * Time until envelope reaches attackLevel
   * @property attackTime
   */ this.aTime = t1 || 0.1;
            /**
   * Level once attack is complete.
   * @property attackLevel
   */ this.aLevel = l1 || 1;
            /**
   * Time until envelope reaches decayLevel.
   * @property decayTime
   */ this.dTime = t2 || 0.5;
            /**
   * Level after decay. The envelope will sustain here until it is released.
   * @property decayLevel
   */ this.dLevel = l2 || 0;
            /**
   * Duration of the release portion of the envelope.
   * @property releaseTime
   */ this.rTime = t3 || 0;
            /**
   * Level at the end of the release.
   * @property releaseLevel
   */ this.rLevel = l3 || 0;
            this._rampHighPercentage = 0.98;
            this._rampLowPercentage = 0.02;
            this.output = main.audiocontext.createGain();
            this.control = new TimelineSignal_default.a();
            this._init();
            this.control.connect(this.output);
            this.connection = null;
            this.mathOps = [
                this.control
            ];
            this.isExponential = false;
            this.sourceToClear = null;
            this.wasTriggered = false;
            main.soundArray.push(this);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype._init = function() {
            var now = main.audiocontext.currentTime;
            var t = now;
            this.control.setTargetAtTime(0.00001, t, 0.001);
            this._setRampAD(this.aTime, this.dTime);
        };
        /**
 *  Reset the envelope with a series of time/value pairs.
 *
 *  @method  set
 *  @for p5.Envelope
 *  @param {Number} attackTime     Time (in seconds) before level
 *                                 reaches attackLevel
 *  @param {Number} attackLevel    Typically an amplitude between
 *                                 0.0 and 1.0
 *  @param {Number} decayTime      Time
 *  @param {Number} decayLevel   Amplitude (In a standard ADSR envelope,
 *                                 decayLevel = sustainLevel)
 *  @param {Number} releaseTime   Release Time (in seconds)
 *  @param {Number} releaseLevel  Amplitude
 *  @example
 *  <div><code>
 *  let attackTime;
 *  let l1 = 0.7; // attack level 0.0 to 1.0
 *  let t2 = 0.3; // decay time in seconds
 *  let l2 = 0.1; // decay level  0.0 to 1.0
 *  let l3 = 0.2; // release time in seconds
 *
 *  let env, triOsc;
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(playSound);
 *
 *    env = new p5.Envelope();
 *    triOsc = new p5.Oscillator('triangle');
 *  }
 *
 *  function draw() {
 *    background(220);
 *    text('tap here to play', 5, 20);
 *
 *    attackTime = map(mouseX, 0, width, 0.0, 1.0);
 *    text('attack time: ' + attackTime, 5, height - 20);
 *  }
 *
 *  // mouseClick triggers envelope if over canvas
 *  function playSound() {
 *    env.set(attackTime, l1, t2, l2, l3);
 *
 *    triOsc.start();
 *    env.play(triOsc);
 *  }
 *  </code></div>
 *
 */ (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype.set = function(t1, l1, t2, l2, t3, l3) {
            this.aTime = t1;
            this.aLevel = l1;
            this.dTime = t2 || 0;
            this.dLevel = l2 || 0;
            this.rTime = t3 || 0;
            this.rLevel = l3 || 0;
            this._setRampAD(t1, t2);
        };
        /**
 *  Set values like a traditional
 *  <a href="https://en.wikipedia.org/wiki/Synthesizer#/media/File:ADSR_parameter.svg">
 *  ADSR envelope
 *  </a>.
 *
 *  @method  setADSR
 *  @for p5.Envelope
 *  @param {Number} attackTime    Time (in seconds before envelope
 *                                reaches Attack Level
 *  @param {Number} [decayTime]    Time (in seconds) before envelope
 *                                reaches Decay/Sustain Level
 *  @param {Number} [susRatio]    Ratio between attackLevel and releaseLevel, on a scale from 0 to 1,
 *                                where 1.0 = attackLevel, 0.0 = releaseLevel.
 *                                The susRatio determines the decayLevel and the level at which the
 *                                sustain portion of the envelope will sustain.
 *                                For example, if attackLevel is 0.4, releaseLevel is 0,
 *                                and susAmt is 0.5, the decayLevel would be 0.2. If attackLevel is
 *                                increased to 1.0 (using <code>setRange</code>),
 *                                then decayLevel would increase proportionally, to become 0.5.
 *  @param {Number} [releaseTime]   Time in seconds from now (defaults to 0)
 *  @example
 *  <div><code>
 *  let attackLevel = 1.0;
 *  let releaseLevel = 0;
 *
 *  let attackTime = 0.001;
 *  let decayTime = 0.2;
 *  let susPercent = 0.2;
 *  let releaseTime = 0.5;
 *
 *  let env, triOsc;
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(playEnv);
 *
 *    env = new p5.Envelope();
 *    triOsc = new p5.Oscillator('triangle');
 *    triOsc.amp(env);
 *    triOsc.freq(220);
 *  }
 *
 *  function draw() {
 *    background(220);
 *    text('tap here to play', 5, 20);
 *    attackTime = map(mouseX, 0, width, 0, 1.0);
 *    text('attack time: ' + attackTime, 5, height - 40);
 *  }
 *
 *  function playEnv() {
 *    triOsc.start();
 *    env.setADSR(attackTime, decayTime, susPercent, releaseTime);
 *    env.play();
 *  }
 *  </code></div>
 */ (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype.setADSR = function(aTime, dTime, sPercent, rTime) {
            this.aTime = aTime;
            this.dTime = dTime || 0;
            this.sPercent = sPercent || 0;
            this.dLevel = typeof sPercent !== "undefined" ? sPercent * (this.aLevel - this.rLevel) + this.rLevel : 0;
            this.rTime = rTime || 0;
            this._setRampAD(aTime, dTime);
        };
        /**
 *  Set max (attackLevel) and min (releaseLevel) of envelope.
 *
 *  @method  setRange
 *  @for p5.Envelope
 *  @param {Number} aLevel attack level (defaults to 1)
 *  @param {Number} rLevel release level (defaults to 0)
 *  @example
 *  <div><code>
 *  let attackLevel = 1.0;
 *  let releaseLevel = 0;
 *
 *  let attackTime = 0.001;
 *  let decayTime = 0.2;
 *  let susPercent = 0.2;
 *  let releaseTime = 0.5;
 *
 *  let env, triOsc;
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(playEnv);
 *
 *    env = new p5.Envelope();
 *    triOsc = new p5.Oscillator('triangle');
 *    triOsc.amp(env);
 *    triOsc.freq(220);
 *  }
 *
 *  function draw() {
 *    background(220);
 *    text('tap here to play', 5, 20);
 *    attackLevel = map(mouseY, height, 0, 0, 1.0);
 *    text('attack level: ' + attackLevel, 5, height - 20);
 *  }
 *
 *  function playEnv() {
 *    triOsc.start();
 *    env.setRange(attackLevel, releaseLevel);
 *    env.play();
 *  }
 *  </code></div>
 */ (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype.setRange = function(aLevel, rLevel) {
            this.aLevel = aLevel || 1;
            this.rLevel = rLevel || 0;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype._setRampAD = function(t1, t2) {
            this._rampAttackTime = this.checkExpInput(t1);
            this._rampDecayTime = this.checkExpInput(t2);
            var TCDenominator = 1.0;
            TCDenominator = Math.log(1.0 / this.checkExpInput(1.0 - this._rampHighPercentage));
            this._rampAttackTC = t1 / this.checkExpInput(TCDenominator);
            TCDenominator = Math.log(1.0 / this._rampLowPercentage);
            this._rampDecayTC = t2 / this.checkExpInput(TCDenominator);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype.setRampPercentages = function(p1, p2) {
            this._rampHighPercentage = this.checkExpInput(p1);
            this._rampLowPercentage = this.checkExpInput(p2);
            var TCDenominator = 1.0;
            TCDenominator = Math.log(1.0 / this.checkExpInput(1.0 - this._rampHighPercentage));
            this._rampAttackTC = this._rampAttackTime / this.checkExpInput(TCDenominator);
            TCDenominator = Math.log(1.0 / this._rampLowPercentage);
            this._rampDecayTC = this._rampDecayTime / this.checkExpInput(TCDenominator);
        };
        /**
 *  Assign a parameter to be controlled by this envelope.
 *  If a p5.Sound object is given, then the p5.Envelope will control its
 *  output gain. If multiple inputs are provided, the env will
 *  control all of them.
 *
 *  @method  setInput
 *  @for p5.Envelope
 *  @param  {Object} [...inputs]         A p5.sound object or
 *                                Web Audio Param.
 */ (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype.setInput = function() {
            for(var i = 0; i < arguments.length; i++)this.connect(arguments[i]);
        };
        /**
 *  Set whether the envelope ramp is linear (default) or exponential.
 *  Exponential ramps can be useful because we perceive amplitude
 *  and frequency logarithmically.
 *
 *  @method  setExp
 *  @for p5.Envelope
 *  @param {Boolean} isExp true is exponential, false is linear
 */ (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype.setExp = function(isExp) {
            this.isExponential = isExp;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype.checkExpInput = function(value) {
            if (value <= 0) value = 0.00000001;
            return value;
        };
        /**
 *  <p>Play tells the envelope to start acting on a given input.
 *  If the input is a p5.sound object (i.e. AudioIn, Oscillator,
 *  SoundFile), then Envelope will control its output volume.
 *  Envelopes can also be used to control any <a href="
 *  http://docs.webplatform.org/wiki/apis/webaudio/AudioParam">
 *  Web Audio Audio Param.</a></p>
 *
 *  @method  play
 *  @for p5.Envelope
 *  @param  {Object} unit         A p5.sound object or
 *                                Web Audio Param.
 *  @param  {Number} [startTime]  time from now (in seconds) at which to play
 *  @param  {Number} [sustainTime] time to sustain before releasing the envelope
 *  @example
 *  <div><code>
 *  let attackLevel = 1.0;
 *  let releaseLevel = 0;
 *
 *  let attackTime = 0.001;
 *  let decayTime = 0.2;
 *  let susPercent = 0.2;
 *  let releaseTime = 0.5;
 *
 *  let env, triOsc;
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(playEnv);
 *
 *    env = new p5.Envelope();
 *    triOsc = new p5.Oscillator('triangle');
 *    triOsc.amp(env);
 *    triOsc.freq(220);
 *    triOsc.start();
 *  }
 *
 *  function draw() {
 *    background(220);
 *    text('tap here to play', 5, 20);
 *    attackTime = map(mouseX, 0, width, 0, 1.0);
 *    attackLevel = map(mouseY, height, 0, 0, 1.0);
 *    text('attack time: ' + attackTime, 5, height - 40);
 *    text('attack level: ' + attackLevel, 5, height - 20);
 *  }
 *
 *  function playEnv() {
 *    // ensure that audio is enabled
 *    userStartAudio();
 *
 *    env.setADSR(attackTime, decayTime, susPercent, releaseTime);
 *    env.setRange(attackLevel, releaseLevel);
 *    env.play();
 *  }
 *  </code></div>
 */ (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype.play = function(unit, secondsFromNow, susTime) {
            var tFromNow = secondsFromNow || 0;
            if (unit) {
                if (this.connection !== unit) this.connect(unit);
            }
            this.triggerAttack(unit, tFromNow);
            this.triggerRelease(unit, tFromNow + this.aTime + this.dTime + ~~susTime);
        };
        /**
 *  Trigger the Attack, and Decay portion of the Envelope.
 *  Similar to holding down a key on a piano, but it will
 *  hold the sustain level until you let go. Input can be
 *  any p5.sound object, or a <a href="
 *  http://docs.webplatform.org/wiki/apis/webaudio/AudioParam">
 *  Web Audio Param</a>.
 *
 *  @method  triggerAttack
 *  @for p5.Envelope
 *  @param  {Object} unit p5.sound Object or Web Audio Param
 *  @param  {Number} secondsFromNow time from now (in seconds)
 *  @example
 *  <div><code>
 *  let attackTime = 0.001;
 *  let decayTime = 0.2;
 *  let susPercent = 0.3;
 *  let releaseTime = 0.4;
 *  let env, triOsc;
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    background(220);
 *    textAlign(CENTER);
 *    textSize(10);
 *    text('tap to triggerAttack', width/2, height/2);
 *
 *    env = new p5.Envelope();
 *    env.setADSR(attackTime, decayTime, susPercent, releaseTime);
 *    env.setRange(1.0, 0.0);
 *    triOsc = new p5.Oscillator('triangle');
 *    triOsc.freq(220);
 *
 *    cnv.mousePressed(envAttack);
 *  }
 *
 *  function envAttack()  {
 *    background(0, 255, 255);
 *    text('release to release', width/2, height/2);
 *
 *    // ensures audio is enabled. See also: `userStartAudio`
 *    triOsc.start();
 *
 *    env.triggerAttack(triOsc);
 *  }
 *
 *  function mouseReleased() {
 *    background(220);
 *    text('tap to triggerAttack', width/2, height/2);
 *
 *    env.triggerRelease(triOsc);
 *  }
 *  </code></div>
 */ (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype.triggerAttack = function(unit, secondsFromNow) {
            var now = main.audiocontext.currentTime;
            var tFromNow = secondsFromNow || 0;
            var t = now + tFromNow;
            this.lastAttack = t;
            this.wasTriggered = true;
            if (unit) {
                if (this.connection !== unit) this.connect(unit);
            }
            var valToSet = this.control.getValueAtTime(t);
            if (this.isExponential === true) this.control.exponentialRampToValueAtTime(this.checkExpInput(valToSet), t);
            else this.control.linearRampToValueAtTime(valToSet, t);
            t += this.aTime;
            if (this.isExponential === true) {
                this.control.exponentialRampToValueAtTime(this.checkExpInput(this.aLevel), t);
                valToSet = this.checkExpInput(this.control.getValueAtTime(t));
                this.control.cancelScheduledValues(t);
                this.control.exponentialRampToValueAtTime(valToSet, t);
            } else {
                this.control.linearRampToValueAtTime(this.aLevel, t);
                valToSet = this.control.getValueAtTime(t);
                this.control.cancelScheduledValues(t);
                this.control.linearRampToValueAtTime(valToSet, t);
            }
            t += this.dTime;
            if (this.isExponential === true) {
                this.control.exponentialRampToValueAtTime(this.checkExpInput(this.dLevel), t);
                valToSet = this.checkExpInput(this.control.getValueAtTime(t));
                this.control.cancelScheduledValues(t);
                this.control.exponentialRampToValueAtTime(valToSet, t);
            } else {
                this.control.linearRampToValueAtTime(this.dLevel, t);
                valToSet = this.control.getValueAtTime(t);
                this.control.cancelScheduledValues(t);
                this.control.linearRampToValueAtTime(valToSet, t);
            }
        };
        /**
 *  Trigger the Release of the Envelope. This is similar to releasing
 *  the key on a piano and letting the sound fade according to the
 *  release level and release time.
 *
 *  @method  triggerRelease
 *  @for p5.Envelope
 *  @param  {Object} unit p5.sound Object or Web Audio Param
 *  @param  {Number} secondsFromNow time to trigger the release
 *  @example
 *  <div><code>
 *  let attackTime = 0.001;
 *  let decayTime = 0.2;
 *  let susPercent = 0.3;
 *  let releaseTime = 0.4;
 *  let env, triOsc;
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    background(220);
 *    textAlign(CENTER);
 *    textSize(10);
 *    text('tap to triggerAttack', width/2, height/2);
 *
 *    env = new p5.Envelope();
 *    env.setADSR(attackTime, decayTime, susPercent, releaseTime);
 *    env.setRange(1.0, 0.0);
 *    triOsc = new p5.Oscillator('triangle');
 *    triOsc.freq(220);
 *
 *    cnv.mousePressed(envAttack);
 *  }
 *
 *  function envAttack()  {
 *    background(0, 255, 255);
 *    text('release to release', width/2, height/2);
 *
 *    // ensures audio is enabled. See also: `userStartAudio`
 *    triOsc.start();
 *
 *    env.triggerAttack(triOsc);
 *  }
 *
 *  function mouseReleased() {
 *    background(220);
 *    text('tap to triggerAttack', width/2, height/2);
 *
 *    env.triggerRelease(triOsc);
 *  }
 *  </code></div>
 */ (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype.triggerRelease = function(unit, secondsFromNow) {
            if (!this.wasTriggered) return;
            var now = main.audiocontext.currentTime;
            var tFromNow = secondsFromNow || 0;
            var t = now + tFromNow;
            if (unit) {
                if (this.connection !== unit) this.connect(unit);
            }
            var valToSet = this.control.getValueAtTime(t);
            if (this.isExponential === true) this.control.exponentialRampToValueAtTime(this.checkExpInput(valToSet), t);
            else this.control.linearRampToValueAtTime(valToSet, t);
            t += this.rTime;
            if (this.isExponential === true) {
                this.control.exponentialRampToValueAtTime(this.checkExpInput(this.rLevel), t);
                valToSet = this.checkExpInput(this.control.getValueAtTime(t));
                this.control.cancelScheduledValues(t);
                this.control.exponentialRampToValueAtTime(valToSet, t);
            } else {
                this.control.linearRampToValueAtTime(this.rLevel, t);
                valToSet = this.control.getValueAtTime(t);
                this.control.cancelScheduledValues(t);
                this.control.linearRampToValueAtTime(valToSet, t);
            }
            this.wasTriggered = false;
        };
        /**
 *  Exponentially ramp to a value using the first two
 *  values from <code><a href="#/p5.Envelope/setADSR">setADSR(attackTime, decayTime)</a></code>
 *  as <a href="https://en.wikipedia.org/wiki/RC_time_constant">
 *  time constants</a> for simple exponential ramps.
 *  If the value is higher than current value, it uses attackTime,
 *  while a decrease uses decayTime.
 *
 *  @method  ramp
 *  @for p5.Envelope
 *  @param  {Object} unit           p5.sound Object or Web Audio Param
 *  @param  {Number} secondsFromNow When to trigger the ramp
 *  @param  {Number} v              Target value
 *  @param  {Number} [v2]           Second target value
 *  @example
 *  <div><code>
 *  let env, osc, amp;
 *
 *  let attackTime = 0.001;
 *  let decayTime = 0.2;
 *  let attackLevel = 1;
 *  let decayLevel = 0;
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    fill(0,255,0);
 *    noStroke();
 *
 *    env = new p5.Envelope();
 *    env.setADSR(attackTime, decayTime);
 *    osc = new p5.Oscillator();
 *    osc.amp(env);
 *    amp = new p5.Amplitude();
 *
 *    cnv.mousePressed(triggerRamp);
 *  }
 *
 *  function triggerRamp() {
 *    // ensures audio is enabled. See also: `userStartAudio`
 *    osc.start();
 *
 *    env.ramp(osc, 0, attackLevel, decayLevel);
 *  }
 *
 *  function draw() {
 *    background(20);
 *    text('tap to play', 10, 20);
 *    let h = map(amp.getLevel(), 0, 0.4, 0, height);;
 *    rect(0, height, width, -h);
 *  }
 *  </code></div>
 */ (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype.ramp = function(unit, secondsFromNow, v1, v2) {
            var now = main.audiocontext.currentTime;
            var tFromNow = secondsFromNow || 0;
            var t = now + tFromNow;
            var destination1 = this.checkExpInput(v1);
            var destination2 = typeof v2 !== "undefined" ? this.checkExpInput(v2) : undefined;
            if (unit) {
                if (this.connection !== unit) this.connect(unit);
            }
            var currentVal = this.checkExpInput(this.control.getValueAtTime(t));
            if (destination1 > currentVal) {
                this.control.setTargetAtTime(destination1, t, this._rampAttackTC);
                t += this._rampAttackTime;
            } else if (destination1 < currentVal) {
                this.control.setTargetAtTime(destination1, t, this._rampDecayTC);
                t += this._rampDecayTime;
            }
            if (destination2 === undefined) return;
            if (destination2 > destination1) this.control.setTargetAtTime(destination2, t, this._rampAttackTC);
            else if (destination2 < destination1) this.control.setTargetAtTime(destination2, t, this._rampDecayTC);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype.connect = function(unit) {
            this.connection = unit;
            if (unit instanceof (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Oscillator || unit instanceof (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).SoundFile || unit instanceof (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).AudioIn || unit instanceof (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Reverb || unit instanceof (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Noise || unit instanceof (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Filter || unit instanceof (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Delay) unit = unit.output.gain;
            if (unit instanceof AudioParam) unit.setValueAtTime(0, main.audiocontext.currentTime);
            this.output.connect(unit);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype.disconnect = function() {
            if (this.output) this.output.disconnect();
        };
        /**
 *  Add a value to the p5.Oscillator's output amplitude,
 *  and return the oscillator. Calling this method
 *  again will override the initial add() with new values.
 *
 *  @method  add
 *  @for p5.Envelope
 *  @param {Number} number Constant number to add
 *  @return {p5.Envelope} Envelope Returns this envelope
 *                                     with scaled output
 */ (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype.add = function(num) {
            var add = new Add_default.a(num);
            var thisChain = this.mathOps.length;
            var nextChain = this.output;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype._mathChain(this, add, thisChain, nextChain, Add_default.a);
        };
        /**
 *  Multiply the p5.Envelope's output amplitude
 *  by a fixed value. Calling this method
 *  again will override the initial mult() with new values.
 *
 *  @method  mult
 *  @for p5.Envelope
 *  @param {Number} number Constant number to multiply
 *  @return {p5.Envelope} Envelope Returns this envelope
 *                                     with scaled output
 */ (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype.mult = function(num) {
            var mult = new Multiply_default.a(num);
            var thisChain = this.mathOps.length;
            var nextChain = this.output;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype._mathChain(this, mult, thisChain, nextChain, Multiply_default.a);
        };
        /**
 *  Scale this envelope's amplitude values to a given
 *  range, and return the envelope. Calling this method
 *  again will override the initial scale() with new values.
 *
 *  @method  scale
 *  @for p5.Envelope
 *  @param  {Number} inMin  input range minumum
 *  @param  {Number} inMax  input range maximum
 *  @param  {Number} outMin input range minumum
 *  @param  {Number} outMax input range maximum
 *  @return {p5.Envelope} Envelope Returns this envelope
 *                                     with scaled output
 */ (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype.scale = function(inMin, inMax, outMin, outMax) {
            var scale = new Scale_default.a(inMin, inMax, outMin, outMax);
            var thisChain = this.mathOps.length;
            var nextChain = this.output;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype._mathChain(this, scale, thisChain, nextChain, Scale_default.a);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype.dispose = function() {
            var index = main.soundArray.indexOf(this);
            main.soundArray.splice(index, 1);
            this.disconnect();
            if (this.control) {
                this.control.dispose();
                this.control = null;
            }
            for(var i = 1; i < this.mathOps.length; i++)this.mathOps[i].dispose();
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Env = function(t1, l1, t2, l2, t3, l3) {
            console.warn("WARNING: p5.Env is now deprecated and may be removed in future versions. Please use the new p5.Envelope instead.");
            (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.call(this, t1, l1, t2, l2, t3, l3);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Env.prototype = Object.create((0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope.prototype);
        var Envelope = (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Envelope;
        var envelope = Envelope;
        function noise_typeof(obj) {
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") noise_typeof = function _typeof(obj) {
                return typeof obj;
            };
            else noise_typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            return noise_typeof(obj);
        }
        function noise_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function noise_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function noise_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) noise_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) noise_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        function noise_possibleConstructorReturn(self1, call) {
            if (call && (noise_typeof(call) === "object" || typeof call === "function")) return call;
            return noise_assertThisInitialized(self1);
        }
        function noise_assertThisInitialized(self1) {
            if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return self1;
        }
        function noise_getPrototypeOf(o) {
            noise_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
            };
            return noise_getPrototypeOf(o);
        }
        function noise_inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    writable: true,
                    configurable: true
                }
            });
            if (superClass) noise_setPrototypeOf(subClass, superClass);
        }
        function noise_setPrototypeOf(o, p) {
            noise_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };
            return noise_setPrototypeOf(o, p);
        }
        var _whiteNoiseBuffer = function() {
            var bufferSize = 2 * main.audiocontext.sampleRate;
            var whiteBuffer = main.audiocontext.createBuffer(1, bufferSize, main.audiocontext.sampleRate);
            var noiseData = whiteBuffer.getChannelData(0);
            for(var i = 0; i < bufferSize; i++)noiseData[i] = Math.random() * 2 - 1;
            whiteBuffer.type = "white";
            return whiteBuffer;
        }();
        var _pinkNoiseBuffer = function() {
            var bufferSize = 2 * main.audiocontext.sampleRate;
            var pinkBuffer = main.audiocontext.createBuffer(1, bufferSize, main.audiocontext.sampleRate);
            var noiseData = pinkBuffer.getChannelData(0);
            var b0, b1, b2, b3, b4, b5, b6;
            b0 = b1 = b2 = b3 = b4 = b5 = b6 = 0.0;
            for(var i = 0; i < bufferSize; i++){
                var white = Math.random() * 2 - 1;
                b0 = 0.99886 * b0 + white * 0.0555179;
                b1 = 0.99332 * b1 + white * 0.0750759;
                b2 = 0.969 * b2 + white * 0.153852;
                b3 = 0.8665 * b3 + white * 0.3104856;
                b4 = 0.55 * b4 + white * 0.5329522;
                b5 = -0.7616 * b5 - white * 0.016898;
                noiseData[i] = b0 + b1 + b2 + b3 + b4 + b5 + b6 + white * 0.5362;
                noiseData[i] *= 0.11;
                b6 = white * 0.115926;
            }
            pinkBuffer.type = "pink";
            return pinkBuffer;
        }();
        var _brownNoiseBuffer = function() {
            var bufferSize = 2 * main.audiocontext.sampleRate;
            var brownBuffer = main.audiocontext.createBuffer(1, bufferSize, main.audiocontext.sampleRate);
            var noiseData = brownBuffer.getChannelData(0);
            var lastOut = 0.0;
            for(var i = 0; i < bufferSize; i++){
                var white = Math.random() * 2 - 1;
                noiseData[i] = (lastOut + 0.02 * white) / 1.02;
                lastOut = noiseData[i];
                noiseData[i] *= 3.5;
            }
            brownBuffer.type = "brown";
            return brownBuffer;
        }();
        /**
 *  Noise is a type of oscillator that generates a buffer with random values.
 *
 *  @class p5.Noise
 *  @extends p5.Oscillator
 *  @constructor
 *  @param {String} type Type of noise can be 'white' (default),
 *                       'brown' or 'pink'.
 */ var noise_Noise = function(_Oscillator) {
            noise_inherits(Noise, _Oscillator);
            function Noise(type) {
                var _this;
                noise_classCallCheck(this, Noise);
                _this = noise_possibleConstructorReturn(this, noise_getPrototypeOf(Noise).call(this));
                var assignType;
                delete _this.f;
                delete _this.freq;
                delete _this.oscillator;
                if (type === "brown") assignType = _brownNoiseBuffer;
                else if (type === "pink") assignType = _pinkNoiseBuffer;
                else assignType = _whiteNoiseBuffer;
                _this.buffer = assignType;
                return _this;
            }
            /**
   *  Set type of noise to 'white', 'pink' or 'brown'.
   *  White is the default.
   *
   *  @method setType
   *  @param {String} [type] 'white', 'pink' or 'brown'
   */ noise_createClass(Noise, [
                {
                    key: "setType",
                    value: function setType(type) {
                        switch(type){
                            case "white":
                                this.buffer = _whiteNoiseBuffer;
                                break;
                            case "pink":
                                this.buffer = _pinkNoiseBuffer;
                                break;
                            case "brown":
                                this.buffer = _brownNoiseBuffer;
                                break;
                            default:
                                this.buffer = _whiteNoiseBuffer;
                        }
                        if (this.started) {
                            var now = main.audiocontext.currentTime;
                            this.stop(now);
                            this.start(now + 0.01);
                        }
                    }
                },
                {
                    key: "getType",
                    value: function getType() {
                        return this.buffer.type;
                    }
                },
                {
                    key: "start",
                    value: function start() {
                        if (this.started) this.stop();
                        this.noise = main.audiocontext.createBufferSource();
                        this.noise.buffer = this.buffer;
                        this.noise.loop = true;
                        this.noise.connect(this.output);
                        var now = main.audiocontext.currentTime;
                        this.noise.start(now);
                        this.started = true;
                    }
                },
                {
                    key: "stop",
                    value: function stop() {
                        var now = main.audiocontext.currentTime;
                        if (this.noise) {
                            this.noise.stop(now);
                            this.started = false;
                        }
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        var now = main.audiocontext.currentTime;
                        var index = main.soundArray.indexOf(this);
                        main.soundArray.splice(index, 1);
                        if (this.noise) {
                            this.noise.disconnect();
                            this.stop(now);
                        }
                        if (this.output) this.output.disconnect();
                        if (this.panner) this.panner.disconnect();
                        this.output = null;
                        this.panner = null;
                        this.buffer = null;
                        this.noise = null;
                    }
                }
            ]);
            return Noise;
        }(oscillator);
        var noise = noise_Noise;
        var Signal = __webpack_require__(2);
        var Signal_default = __webpack_require__.n(Signal);
        function pulse_typeof(obj) {
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") pulse_typeof = function _typeof(obj) {
                return typeof obj;
            };
            else pulse_typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            return pulse_typeof(obj);
        }
        function pulse_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function pulse_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function pulse_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) pulse_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) pulse_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        function pulse_possibleConstructorReturn(self1, call) {
            if (call && (pulse_typeof(call) === "object" || typeof call === "function")) return call;
            return pulse_assertThisInitialized(self1);
        }
        function pulse_assertThisInitialized(self1) {
            if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return self1;
        }
        function pulse_getPrototypeOf(o) {
            pulse_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
            };
            return pulse_getPrototypeOf(o);
        }
        function pulse_inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    writable: true,
                    configurable: true
                }
            });
            if (superClass) pulse_setPrototypeOf(subClass, superClass);
        }
        function pulse_setPrototypeOf(o, p) {
            pulse_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };
            return pulse_setPrototypeOf(o, p);
        }
        /**
 *  Creates a Pulse object, an oscillator that implements
 *  Pulse Width Modulation.
 *  The pulse is created with two oscillators.
 *  Accepts a parameter for frequency, and to set the
 *  width between the pulses. See <a href="
 *  http://p5js.org/reference/#/p5.Oscillator">
 *  <code>p5.Oscillator</code> for a full list of methods.
 *
 *  @class p5.Pulse
 *  @extends p5.Oscillator
 *  @constructor
 *  @param {Number} [freq] Frequency in oscillations per second (Hz)
 *  @param {Number} [w]    Width between the pulses (0 to 1.0,
 *                         defaults to 0)
 *  @example
 *  <div><code>
 *  let pulse;
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(startPulse);
 *    background(220);
 *
 *    pulse = new p5.Pulse();
 *    pulse.amp(0.5);
 *    pulse.freq(220);
 *  }
 *  function startPulse() {
 *    pulse.start();
 *    pulse.amp(0.5, 0.02);
 *  }
 *  function mouseReleased() {
 *    pulse.amp(0, 0.2);
 *  }
 *  function draw() {
 *    background(220);
 *    text('tap to play', 5, 20, width - 20);
 *    let w = map(mouseX, 0, width, 0, 1);
 *    w = constrain(w, 0, 1);
 *    pulse.width(w);
 *    text('pulse width: ' + w, 5, height - 20);
 *  }
 *  </code></div>
 */ var pulse_Pulse = function(_Oscillator) {
            pulse_inherits(Pulse, _Oscillator);
            function Pulse(freq, w) {
                var _this;
                pulse_classCallCheck(this, Pulse);
                _this = pulse_possibleConstructorReturn(this, pulse_getPrototypeOf(Pulse).call(this, freq, "sawtooth"));
                _this.w = w || 0;
                _this.osc2 = new SawOsc(freq);
                _this.dNode = main.audiocontext.createDelay();
                _this.dcOffset = createDCOffset();
                _this.dcGain = main.audiocontext.createGain();
                _this.dcOffset.connect(_this.dcGain);
                _this.dcGain.connect(_this.output);
                _this.f = freq || 440;
                var mW = _this.w / _this.oscillator.frequency.value;
                _this.dNode.delayTime.value = mW;
                _this.dcGain.gain.value = 1.7 * (0.5 - _this.w);
                _this.osc2.disconnect();
                _this.osc2.panner.disconnect();
                _this.osc2.amp(-1);
                _this.osc2.output.connect(_this.dNode);
                _this.dNode.connect(_this.output);
                _this.output.gain.value = 1;
                _this.output.connect(_this.panner);
                return _this;
            }
            /**
   *  Set the width of a Pulse object (an oscillator that implements
   *  Pulse Width Modulation).
   *
   *  @method  width
   *  @param {Number} [width]    Width between the pulses (0 to 1.0,
   *                         defaults to 0)
   */ pulse_createClass(Pulse, [
                {
                    key: "width",
                    value: function width(w) {
                        if (typeof w === "number") {
                            if (w <= 1.0 && w >= 0.0) {
                                this.w = w;
                                var mW = this.w / this.oscillator.frequency.value;
                                this.dNode.delayTime.value = mW;
                            }
                            this.dcGain.gain.value = 1.7 * (0.5 - this.w);
                        } else {
                            w.connect(this.dNode.delayTime);
                            var sig = new Signal_default.a(-0.5);
                            w.connect(sig);
                            var mult1 = new Multiply_default.a(-1);
                            var mult2 = new Multiply_default.a(1.7);
                            sig = sig.connect(mult1).connect(mult2);
                            sig.connect(this.dcGain.gain);
                        }
                    }
                },
                {
                    key: "start",
                    value: function start(f, time) {
                        var now = main.audiocontext.currentTime;
                        var t = time || 0;
                        if (!this.started) {
                            var freq = f || this.f;
                            var type = this.oscillator.type;
                            this.oscillator = main.audiocontext.createOscillator();
                            this.oscillator.frequency.setValueAtTime(freq, now);
                            this.oscillator.type = type;
                            this.oscillator.connect(this.output);
                            this.oscillator.start(t + now);
                            this.osc2.oscillator = main.audiocontext.createOscillator();
                            this.osc2.oscillator.frequency.setValueAtTime(freq, t + now);
                            this.osc2.oscillator.type = type;
                            this.osc2.oscillator.connect(this.osc2.output);
                            this.osc2.start(t + now);
                            this.freqNode = [
                                this.oscillator.frequency,
                                this.osc2.oscillator.frequency
                            ];
                            this.dcOffset = createDCOffset();
                            this.dcOffset.connect(this.dcGain);
                            this.dcOffset.start(t + now);
                            if (this.mods !== undefined && this.mods.frequency !== undefined) {
                                this.mods.frequency.connect(this.freqNode[0]);
                                this.mods.frequency.connect(this.freqNode[1]);
                            }
                            this.started = true;
                            this.osc2.started = true;
                        }
                    }
                },
                {
                    key: "stop",
                    value: function stop(time) {
                        if (this.started) {
                            var t = time || 0;
                            var now = main.audiocontext.currentTime;
                            this.oscillator.stop(t + now);
                            if (this.osc2.oscillator) this.osc2.oscillator.stop(t + now);
                            this.dcOffset.stop(t + now);
                            this.started = false;
                            this.osc2.started = false;
                        }
                    }
                },
                {
                    key: "freq",
                    value: function freq(val) {
                        var rampTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                        var tFromNow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                        if (typeof val === "number") {
                            this.f = val;
                            var now = main.audiocontext.currentTime;
                            var currentFreq = this.oscillator.frequency.value;
                            this.oscillator.frequency.cancelScheduledValues(now);
                            this.oscillator.frequency.setValueAtTime(currentFreq, now + tFromNow);
                            this.oscillator.frequency.exponentialRampToValueAtTime(val, tFromNow + rampTime + now);
                            this.osc2.oscillator.frequency.cancelScheduledValues(now);
                            this.osc2.oscillator.frequency.setValueAtTime(currentFreq, now + tFromNow);
                            this.osc2.oscillator.frequency.exponentialRampToValueAtTime(val, tFromNow + rampTime + now);
                            if (this.freqMod) {
                                this.freqMod.output.disconnect();
                                this.freqMod = null;
                            }
                        } else if (val.output) {
                            val.output.disconnect();
                            val.output.connect(this.oscillator.frequency);
                            val.output.connect(this.osc2.oscillator.frequency);
                            this.freqMod = val;
                        }
                    }
                }
            ]);
            return Pulse;
        }(oscillator);
        function createDCOffset() {
            var ac = main.audiocontext;
            var buffer = ac.createBuffer(1, 2048, ac.sampleRate);
            var data = buffer.getChannelData(0);
            for(var i = 0; i < 2048; i++)data[i] = 1.0;
            var bufferSource = ac.createBufferSource();
            bufferSource.buffer = buffer;
            bufferSource.loop = true;
            return bufferSource;
        }
        var pulse = pulse_Pulse;
        function audioin_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function audioin_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function audioin_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) audioin_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) audioin_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        main.inputSources = [];
        /**
 *  <p>Get audio from an input, i.e. your computer's microphone.</p>
 *
 *  <p>Turn the mic on/off with the start() and stop() methods. When the mic
 *  is on, its volume can be measured with getLevel or by connecting an
 *  FFT object.</p>
 *
 *  <p>If you want to hear the AudioIn, use the .connect() method.
 *  AudioIn does not connect to p5.sound output by default to prevent
 *  feedback.</p>
 *
 *  <p><em>Note: This uses the <a href="http://caniuse.com/stream">getUserMedia/
 *  Stream</a> API, which is not supported by certain browsers. Access in Chrome browser
 *  is limited to localhost and https, but access over http may be limited.</em></p>
 *
 *  @class p5.AudioIn
 *  @constructor
 *  @param {Function} [errorCallback] A function to call if there is an error
 *                                    accessing the AudioIn. For example,
 *                                    Safari and iOS devices do not
 *                                    currently allow microphone access.
 *  @example
 *  <div><code>
 *  let mic;
 *
 *   function setup(){
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(userStartAudio);
 *    textAlign(CENTER);
 *    mic = new p5.AudioIn();
 *    mic.start();
 *  }
 *
 *  function draw(){
 *    background(0);
 *    fill(255);
 *    text('tap to start', width/2, 20);
 *
 *    micLevel = mic.getLevel();
 *    let y = height - micLevel * height;
 *    ellipse(width/2, y, 10, 10);
 *  }
 *  </code></div>
 */ var audioin_AudioIn = function() {
            function AudioIn(errorCallback) {
                audioin_classCallCheck(this, AudioIn);
                /**
     * @property {GainNode} input
     */ this.input = main.audiocontext.createGain();
                /**
     * @property {GainNode} output
     */ this.output = main.audiocontext.createGain();
                /**
     * @property {MediaStream|null} stream
     */ this.stream = null;
                /**
     * @property {MediaStreamAudioSourceNode|null} mediaStream
     */ this.mediaStream = null;
                /**
     * @property {Number|null} currentSource
     */ this.currentSource = null;
                /**
     *  Client must allow browser to access their microphone / audioin source.
     *  Default: false. Will become true when the client enables access.
     *
     *  @property {Boolean} enabled
     */ this.enabled = false;
                /**
     * Input amplitude, connect to it by default but not to master out
     *
     *  @property {p5.Amplitude} amplitude
     */ this.amplitude = new amplitude();
                this.output.connect(this.amplitude.input);
                if (!window.MediaStreamTrack || !window.navigator.mediaDevices || !window.navigator.mediaDevices.getUserMedia) errorCallback ? errorCallback() : window.alert("This browser does not support MediaStreamTrack and mediaDevices");
                main.soundArray.push(this);
            }
            /**
   *  Start processing audio input. This enables the use of other
   *  AudioIn methods like getLevel(). Note that by default, AudioIn
   *  is not connected to p5.sound's output. So you won't hear
   *  anything unless you use the connect() method.<br/>
   *
   *  Certain browsers limit access to the user's microphone. For example,
   *  Chrome only allows access from localhost and over https. For this reason,
   *  you may want to include an errorCallback—a function that is called in case
   *  the browser won't provide mic access.
   *
   *  @method start
   *  @for p5.AudioIn
   *  @param {Function} [successCallback] Name of a function to call on
   *                                    success.
   *  @param {Function} [errorCallback] Name of a function to call if
   *                                    there was an error. For example,
   *                                    some browsers do not support
   *                                    getUserMedia.
   */ audioin_createClass(AudioIn, [
                {
                    key: "start",
                    value: function start(successCallback, errorCallback) {
                        var self1 = this;
                        if (this.stream) this.stop();
                        var audioSource = main.inputSources[self1.currentSource];
                        var constraints = {
                            audio: {
                                sampleRate: main.audiocontext.sampleRate,
                                echoCancellation: false
                            }
                        };
                        if (main.inputSources[this.currentSource]) constraints.audio.deviceId = audioSource.deviceId;
                        window.navigator.mediaDevices.getUserMedia(constraints).then(function(stream) {
                            self1.stream = stream;
                            self1.enabled = true;
                            self1.mediaStream = main.audiocontext.createMediaStreamSource(stream);
                            self1.mediaStream.connect(self1.output);
                            self1.amplitude.setInput(self1.output);
                            if (successCallback) successCallback();
                        })["catch"](function(err) {
                            if (errorCallback) errorCallback(err);
                            else console.error(err);
                        });
                    }
                },
                {
                    key: "stop",
                    value: function stop() {
                        if (this.stream) {
                            this.stream.getTracks().forEach(function(track) {
                                track.stop();
                            });
                            this.mediaStream.disconnect();
                            delete this.mediaStream;
                            delete this.stream;
                        }
                    }
                },
                {
                    key: "connect",
                    value: function connect(unit) {
                        if (unit) {
                            if (unit.hasOwnProperty("input")) this.output.connect(unit.input);
                            else if (unit.hasOwnProperty("analyser")) this.output.connect(unit.analyser);
                            else this.output.connect(unit);
                        } else this.output.connect(main.input);
                    }
                },
                {
                    key: "disconnect",
                    value: function disconnect() {
                        if (this.output) {
                            this.output.disconnect();
                            this.output.connect(this.amplitude.input);
                        }
                    }
                },
                {
                    key: "getLevel",
                    value: function getLevel(smoothing) {
                        if (smoothing) this.amplitude.smoothing = smoothing;
                        return this.amplitude.getLevel();
                    }
                },
                {
                    key: "amp",
                    value: function amp(vol, t) {
                        if (t) {
                            var rampTime = t || 0;
                            var currentVol = this.output.gain.value;
                            this.output.gain.cancelScheduledValues(main.audiocontext.currentTime);
                            this.output.gain.setValueAtTime(currentVol, main.audiocontext.currentTime);
                            this.output.gain.linearRampToValueAtTime(vol, rampTime + main.audiocontext.currentTime);
                        } else {
                            this.output.gain.cancelScheduledValues(main.audiocontext.currentTime);
                            this.output.gain.setValueAtTime(vol, main.audiocontext.currentTime);
                        }
                    }
                },
                {
                    key: "getSources",
                    value: function getSources(onSuccess, onError) {
                        return new Promise(function(resolve, reject) {
                            window.navigator.mediaDevices.enumerateDevices().then(function(devices) {
                                main.inputSources = devices.filter(function(device) {
                                    return device.kind === "audioinput";
                                });
                                resolve(main.inputSources);
                                if (onSuccess) onSuccess(main.inputSources);
                            })["catch"](function(error) {
                                reject(error);
                                if (onError) onError(error);
                                else console.error("This browser does not support MediaStreamTrack.getSources()");
                            });
                        });
                    }
                },
                {
                    key: "setSource",
                    value: function setSource(num) {
                        if (main.inputSources.length > 0 && num < main.inputSources.length) {
                            this.currentSource = num;
                            console.log("set source to ", main.inputSources[this.currentSource]);
                        } else console.log("unable to set input source");
                        if (this.stream && this.stream.active) this.start();
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        var index = main.soundArray.indexOf(this);
                        main.soundArray.splice(index, 1);
                        this.stop();
                        if (this.output) this.output.disconnect();
                        if (this.amplitude) this.amplitude.disconnect();
                        delete this.amplitude;
                        delete this.output;
                    }
                }
            ]);
            return AudioIn;
        }();
        var audioin = audioin_AudioIn;
        var CrossFade = __webpack_require__(23);
        var CrossFade_default = __webpack_require__.n(CrossFade);
        function effect_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function effect_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function effect_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) effect_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) effect_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        /**
 * Effect is a base class for audio effects in p5. <br>
 * This module handles the nodes and methods that are
 * common and useful for current and future effects.
 *
 *
 * This class is extended by <a href="/reference/#/p5.Distortion">p5.Distortion</a>,
 * <a href="/reference/#/p5.Compressor">p5.Compressor</a>,
 * <a href="/reference/#/p5.Delay">p5.Delay</a>,
 * <a href="/reference/#/p5.Filter">p5.Filter</a>,
 * <a href="/reference/#/p5.Reverb">p5.Reverb</a>.
 *
 * @class  p5.Effect
 * @constructor
 *
 * @param {Object} [ac]   Reference to the audio context of the p5 object
 * @param {AudioNode} [input]  Gain Node effect wrapper
 * @param {AudioNode} [output] Gain Node effect wrapper
 * @param {Object} [_drywet]   Tone.JS CrossFade node (defaults to value: 1)
 * @param {AudioNode} [wet]  Effects that extend this class should connect
 *                              to the wet signal to this gain node, so that dry and wet
 *                              signals are mixed properly.
 */ var effect_Effect = function() {
            function Effect() {
                effect_classCallCheck(this, Effect);
                this.ac = main.audiocontext;
                this.input = this.ac.createGain();
                this.output = this.ac.createGain();
                /**
     *	The p5.Effect class is built
     * 	using Tone.js CrossFade
     * 	@private
     */ this._drywet = new CrossFade_default.a(1);
                /**
     *	In classes that extend
     *	p5.Effect, connect effect nodes
     *	to the wet parameter
     */ this.wet = this.ac.createGain();
                this.input.connect(this._drywet.a);
                this.wet.connect(this._drywet.b);
                this._drywet.connect(this.output);
                this.connect();
                main.soundArray.push(this);
            }
            /**
   *  Set the output volume of the filter.
   *
   *  @method  amp
   *  @for p5.Effect
   *  @param {Number} [vol] amplitude between 0 and 1.0
   *  @param {Number} [rampTime] create a fade that lasts until rampTime
   *  @param {Number} [tFromNow] schedule this event to happen in tFromNow seconds
   */ effect_createClass(Effect, [
                {
                    key: "amp",
                    value: function amp(vol) {
                        var rampTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                        var tFromNow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                        var now = main.audiocontext.currentTime;
                        var startTime = now + tFromNow;
                        var endTime = startTime + rampTime + 0.001;
                        var currentVol = this.output.gain.value;
                        this.output.gain.cancelScheduledValues(now);
                        this.output.gain.linearRampToValueAtTime(currentVol, startTime + 0.001);
                        this.output.gain.linearRampToValueAtTime(vol, endTime);
                    }
                },
                {
                    key: "chain",
                    value: function chain() {
                        if (arguments.length > 0) {
                            this.connect(arguments[0]);
                            for(var i = 1; i < arguments.length; i += 1)arguments[i - 1].connect(arguments[i]);
                        }
                        return this;
                    }
                },
                {
                    key: "drywet",
                    value: function drywet(fade) {
                        if (typeof fade !== "undefined") this._drywet.fade.value = fade;
                        return this._drywet.fade.value;
                    }
                },
                {
                    key: "connect",
                    value: function connect(unit) {
                        var u = unit || (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).soundOut.input;
                        this.output.connect(u.input ? u.input : u);
                    }
                },
                {
                    key: "disconnect",
                    value: function disconnect() {
                        if (this.output) this.output.disconnect();
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        var index = main.soundArray.indexOf(this);
                        main.soundArray.splice(index, 1);
                        if (this.input) {
                            this.input.disconnect();
                            delete this.input;
                        }
                        if (this.output) {
                            this.output.disconnect();
                            delete this.output;
                        }
                        if (this._drywet) {
                            this._drywet.disconnect();
                            delete this._drywet;
                        }
                        if (this.wet) {
                            this.wet.disconnect();
                            delete this.wet;
                        }
                        this.ac = undefined;
                    }
                }
            ]);
            return Effect;
        }();
        var effect = effect_Effect;
        function filter_typeof(obj) {
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") filter_typeof = function _typeof(obj) {
                return typeof obj;
            };
            else filter_typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            return filter_typeof(obj);
        }
        function filter_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function filter_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function filter_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) filter_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) filter_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        function filter_possibleConstructorReturn(self1, call) {
            if (call && (filter_typeof(call) === "object" || typeof call === "function")) return call;
            return filter_assertThisInitialized(self1);
        }
        function filter_assertThisInitialized(self1) {
            if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return self1;
        }
        function _get(target, property, receiver) {
            if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get;
            else _get = function _get(target, property, receiver) {
                var base = _superPropBase(target, property);
                if (!base) return;
                var desc = Object.getOwnPropertyDescriptor(base, property);
                if (desc.get) return desc.get.call(receiver);
                return desc.value;
            };
            return _get(target, property, receiver || target);
        }
        function _superPropBase(object, property) {
            while(!Object.prototype.hasOwnProperty.call(object, property)){
                object = filter_getPrototypeOf(object);
                if (object === null) break;
            }
            return object;
        }
        function filter_getPrototypeOf(o) {
            filter_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
            };
            return filter_getPrototypeOf(o);
        }
        function filter_inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    writable: true,
                    configurable: true
                }
            });
            if (superClass) filter_setPrototypeOf(subClass, superClass);
        }
        function filter_setPrototypeOf(o, p) {
            filter_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };
            return filter_setPrototypeOf(o, p);
        }
        /**
 *  <p>A p5.Filter uses a Web Audio Biquad Filter to filter
 *  the frequency response of an input source. Subclasses
 *  include:</p>
 *  <a href="/reference/#/p5.LowPass"><code>p5.LowPass</code></a>:
 *  Allows frequencies below the cutoff frequency to pass through,
 *  and attenuates frequencies above the cutoff.<br/>
 *  <a href="/reference/#/p5.HighPass"><code>p5.HighPass</code></a>:
 *  The opposite of a lowpass filter. <br/>
 *  <a href="/reference/#/p5.BandPass"><code>p5.BandPass</code></a>:
 *  Allows a range of frequencies to pass through and attenuates
 *  the frequencies below and above this frequency range.<br/>
 *
 *  The <code>.res()</code> method controls either width of the
 *  bandpass, or resonance of the low/highpass cutoff frequency.
 *
 *  This class extends <a href = "/reference/#/p5.Effect">p5.Effect</a>.
 *  Methods <a href = "/reference/#/p5.Effect/amp">amp()</a>, <a href = "/reference/#/p5.Effect/chain">chain()</a>,
 *  <a href = "/reference/#/p5.Effect/drywet">drywet()</a>, <a href = "/reference/#/p5.Effect/connect">connect()</a>, and
 *  <a href = "/reference/#/p5.Effect/disconnect">disconnect()</a> are available.
 *
 *  @class p5.Filter
 *  @extends p5.Effect
 *  @constructor
 *  @param {String} [type] 'lowpass' (default), 'highpass', 'bandpass'
 *  @example
 *  <div><code>
 *  let fft, noise, filter;
 *
 *  function setup() {
 *    let cnv = createCanvas(100,100);
 *    cnv.mousePressed(makeNoise);
 *    fill(255, 0, 255);
 *
 *    filter = new p5.BandPass();
 *    noise = new p5.Noise();
 *    noise.disconnect();
 *    noise.connect(filter);
 *
 *    fft = new p5.FFT();
 *  }
 *
 *  function draw() {
 *    background(220);
 *
 *    // set the BandPass frequency based on mouseX
 *    let freq = map(mouseX, 0, width, 20, 10000);
 *    freq = constrain(freq, 0, 22050);
 *    filter.freq(freq);
 *    // give the filter a narrow band (lower res = wider bandpass)
 *    filter.res(50);
 *
 *    // draw filtered spectrum
 *    let spectrum = fft.analyze();
 *    noStroke();
 *    for (let i = 0; i < spectrum.length; i++) {
 *      let x = map(i, 0, spectrum.length, 0, width);
 *      let h = -height + map(spectrum[i], 0, 255, height, 0);
 *      rect(x, height, width/spectrum.length, h);
 *    }
 *    if (!noise.started) {
 *      text('tap here and drag to change frequency', 10, 20, width - 20);
 *    } else {
 *      text('Frequency: ' + round(freq)+'Hz', 20, 20, width - 20);
 *    }
 *  }
 *
 *  function makeNoise() {
 *    // see also: `userStartAudio()`
 *    noise.start();
 *    noise.amp(0.5, 0.2);
 *  }
 *
 *  function mouseReleased() {
 *    noise.amp(0, 0.2);
 *  }
 *
 *  </code></div>
 */ var Filter = function(_Effect) {
            filter_inherits(Filter, _Effect);
            function Filter(type) {
                var _this;
                filter_classCallCheck(this, Filter);
                _this = filter_possibleConstructorReturn(this, filter_getPrototypeOf(Filter).call(this));
                /**
     *  The p5.Filter is built with a
     *  <a href="http://www.w3.org/TR/webaudio/#BiquadFilterNode">
     *  Web Audio BiquadFilter Node</a>.
     *
     *  @property {DelayNode} biquadFilter
     */ _this.biquad = _this.ac.createBiquadFilter();
                _this.input.connect(_this.biquad);
                _this.biquad.connect(_this.wet);
                if (type) _this.setType(type);
                _this._on = true;
                _this._untoggledType = _this.biquad.type;
                return _this;
            }
            /**
   *  Filter an audio signal according to a set
   *  of filter parameters.
   *
   *  @method  process
   *  @param  {Object} Signal  An object that outputs audio
   *  @param {Number} [freq] Frequency in Hz, from 10 to 22050
   *  @param {Number} [res] Resonance/Width of the filter frequency
   *                        from 0.001 to 1000
   */ filter_createClass(Filter, [
                {
                    key: "process",
                    value: function process(src, freq, res, time) {
                        src.connect(this.input);
                        this.set(freq, res, time);
                    }
                },
                {
                    key: "set",
                    value: function set(freq, res, time) {
                        if (freq) this.freq(freq, time);
                        if (res) this.res(res, time);
                    }
                },
                {
                    key: "freq",
                    value: function freq(_freq, time) {
                        var t = time || 0;
                        if (_freq <= 0) _freq = 1;
                        if (typeof _freq === "number") {
                            this.biquad.frequency.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.biquad.frequency.exponentialRampToValueAtTime(_freq, this.ac.currentTime + 0.02 + t);
                        } else if (_freq) _freq.connect(this.biquad.frequency);
                        return this.biquad.frequency.value;
                    }
                },
                {
                    key: "res",
                    value: function res(_res, time) {
                        var t = time || 0;
                        if (typeof _res === "number") {
                            this.biquad.Q.value = _res;
                            this.biquad.Q.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.biquad.Q.linearRampToValueAtTime(_res, this.ac.currentTime + 0.02 + t);
                        } else if (_res) _res.connect(this.biquad.Q);
                        return this.biquad.Q.value;
                    }
                },
                {
                    key: "gain",
                    value: function gain(_gain, time) {
                        var t = time || 0;
                        if (typeof _gain === "number") {
                            this.biquad.gain.value = _gain;
                            this.biquad.gain.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.biquad.gain.linearRampToValueAtTime(_gain, this.ac.currentTime + 0.02 + t);
                        } else if (_gain) _gain.connect(this.biquad.gain);
                        return this.biquad.gain.value;
                    }
                },
                {
                    key: "toggle",
                    value: function toggle() {
                        this._on = !this._on;
                        if (this._on === true) this.biquad.type = this._untoggledType;
                        else if (this._on === false) this.biquad.type = "allpass";
                        return this._on;
                    }
                },
                {
                    key: "setType",
                    value: function setType(t) {
                        this.biquad.type = t;
                        this._untoggledType = this.biquad.type;
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        _get(filter_getPrototypeOf(Filter.prototype), "dispose", this).call(this);
                        if (this.biquad) {
                            this.biquad.disconnect();
                            delete this.biquad;
                        }
                    }
                }
            ]);
            return Filter;
        }(effect);
        /**
 *  Constructor: <code>new p5.LowPass()</code> Filter.
 *  This is the same as creating a p5.Filter and then calling
 *  its method <code>setType('lowpass')</code>.
 *  See p5.Filter for methods.
 *
 *  @class p5.LowPass
 *  @constructor
 *  @extends p5.Filter
 */ var LowPass = function(_Filter) {
            filter_inherits(LowPass, _Filter);
            function LowPass() {
                filter_classCallCheck(this, LowPass);
                return filter_possibleConstructorReturn(this, filter_getPrototypeOf(LowPass).call(this, "lowpass"));
            }
            return LowPass;
        }(Filter);
        /**
 *  Constructor: <code>new p5.HighPass()</code> Filter.
 *  This is the same as creating a p5.Filter and then calling
 *  its method <code>setType('highpass')</code>.
 *  See p5.Filter for methods.
 *
 *  @class p5.HighPass
 *  @constructor
 *  @extends p5.Filter
 */ var HighPass = function(_Filter2) {
            filter_inherits(HighPass, _Filter2);
            function HighPass() {
                filter_classCallCheck(this, HighPass);
                return filter_possibleConstructorReturn(this, filter_getPrototypeOf(HighPass).call(this, "highpass"));
            }
            return HighPass;
        }(Filter);
        /**
 *  Constructor: <code>new p5.BandPass()</code> Filter.
 *  This is the same as creating a p5.Filter and then calling
 *  its method <code>setType('bandpass')</code>.
 *  See p5.Filter for methods.
 *
 *  @class p5.BandPass
 *  @constructor
 *  @extends p5.Filter
 */ var BandPass = function(_Filter3) {
            filter_inherits(BandPass, _Filter3);
            function BandPass() {
                filter_classCallCheck(this, BandPass);
                return filter_possibleConstructorReturn(this, filter_getPrototypeOf(BandPass).call(this, "bandpass"));
            }
            return BandPass;
        }(Filter);
        var filter = Filter;
        function eqFilter_typeof(obj) {
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") eqFilter_typeof = function _typeof(obj) {
                return typeof obj;
            };
            else eqFilter_typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            return eqFilter_typeof(obj);
        }
        function eqFilter_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function eqFilter_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function eqFilter_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) eqFilter_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) eqFilter_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        function eqFilter_possibleConstructorReturn(self1, call) {
            if (call && (eqFilter_typeof(call) === "object" || typeof call === "function")) return call;
            return eqFilter_assertThisInitialized(self1);
        }
        function eqFilter_assertThisInitialized(self1) {
            if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return self1;
        }
        function eqFilter_getPrototypeOf(o) {
            eqFilter_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
            };
            return eqFilter_getPrototypeOf(o);
        }
        function eqFilter_inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    writable: true,
                    configurable: true
                }
            });
            if (superClass) eqFilter_setPrototypeOf(subClass, superClass);
        }
        function eqFilter_setPrototypeOf(o, p) {
            eqFilter_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };
            return eqFilter_setPrototypeOf(o, p);
        }
        /**
 *  EQFilter extends p5.Filter with constraints
 *  necessary for the p5.EQ
 *
 *  @private
 */ var eqFilter_EQFilter = function(_Filter) {
            eqFilter_inherits(EQFilter, _Filter);
            function EQFilter(freq, res) {
                var _this;
                eqFilter_classCallCheck(this, EQFilter);
                _this = eqFilter_possibleConstructorReturn(this, eqFilter_getPrototypeOf(EQFilter).call(this, "peaking"));
                _this.disconnect();
                _this.set(freq, res);
                _this.biquad.gain.value = 0;
                delete _this.input;
                delete _this.output;
                delete _this._drywet;
                delete _this.wet;
                return _this;
            }
            eqFilter_createClass(EQFilter, [
                {
                    key: "amp",
                    value: function amp() {
                        console.warn("`amp()` is not available for p5.EQ bands. Use `.gain()`");
                    }
                },
                {
                    key: "drywet",
                    value: function drywet() {
                        console.warn("`drywet()` is not available for p5.EQ bands.");
                    }
                },
                {
                    key: "connect",
                    value: function connect(unit) {
                        var u = unit || (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).soundOut.input;
                        if (this.biquad) this.biquad.connect(u.input ? u.input : u);
                        else this.output.connect(u.input ? u.input : u);
                    }
                },
                {
                    key: "disconnect",
                    value: function disconnect() {
                        if (this.biquad) this.biquad.disconnect();
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        var index = main.soundArray.indexOf(this);
                        main.soundArray.splice(index, 1);
                        this.disconnect();
                        delete this.biquad;
                    }
                }
            ]);
            return EQFilter;
        }(filter);
        var eqFilter = eqFilter_EQFilter;
        function eq_typeof(obj) {
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") eq_typeof = function _typeof(obj) {
                return typeof obj;
            };
            else eq_typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            return eq_typeof(obj);
        }
        function eq_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function eq_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function eq_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) eq_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) eq_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        function eq_possibleConstructorReturn(self1, call) {
            if (call && (eq_typeof(call) === "object" || typeof call === "function")) return call;
            return eq_assertThisInitialized(self1);
        }
        function eq_assertThisInitialized(self1) {
            if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return self1;
        }
        function eq_get(target, property, receiver) {
            if (typeof Reflect !== "undefined" && Reflect.get) eq_get = Reflect.get;
            else eq_get = function _get(target, property, receiver) {
                var base = eq_superPropBase(target, property);
                if (!base) return;
                var desc = Object.getOwnPropertyDescriptor(base, property);
                if (desc.get) return desc.get.call(receiver);
                return desc.value;
            };
            return eq_get(target, property, receiver || target);
        }
        function eq_superPropBase(object, property) {
            while(!Object.prototype.hasOwnProperty.call(object, property)){
                object = eq_getPrototypeOf(object);
                if (object === null) break;
            }
            return object;
        }
        function eq_getPrototypeOf(o) {
            eq_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
            };
            return eq_getPrototypeOf(o);
        }
        function eq_inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    writable: true,
                    configurable: true
                }
            });
            if (superClass) eq_setPrototypeOf(subClass, superClass);
        }
        function eq_setPrototypeOf(o, p) {
            eq_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };
            return eq_setPrototypeOf(o, p);
        }
        /**
 * p5.EQ is an audio effect that performs the function of a multiband
 * audio equalizer. Equalization is used to adjust the balance of
 * frequency compoenents of an audio signal. This process is commonly used
 * in sound production and recording to change the waveform before it reaches
 * a sound output device. EQ can also be used as an audio effect to create
 * interesting distortions by filtering out parts of the spectrum. p5.EQ is
 * built using a chain of Web Audio Biquad Filter Nodes and can be
 * instantiated with 3 or 8 bands. Bands can be added or removed from
 * the EQ by directly modifying p5.EQ.bands (the array that stores filters).
 *
 * This class extends <a href = "/reference/#/p5.Effect">p5.Effect</a>.
 * Methods <a href = "/reference/#/p5.Effect/amp">amp()</a>, <a href = "/reference/#/p5.Effect/chain">chain()</a>,
 * <a href = "/reference/#/p5.Effect/drywet">drywet()</a>, <a href = "/reference/#/p5.Effect/connect">connect()</a>, and
 * <a href = "/reference/#/p5.Effect/disconnect">disconnect()</a> are available.
 *
 * @class p5.EQ
 * @constructor
 * @extends p5.Effect
 * @param {Number} [_eqsize] Constructor will accept 3 or 8, defaults to 3
 * @return {Object} p5.EQ object
 *
 * @example
 * <div><code>
 * let eq, soundFile
 * let eqBandIndex = 0;
 * let eqBandNames = ['lows', 'mids', 'highs'];
 *
 * function preload() {
 *   soundFormats('mp3', 'ogg');
 *   soundFile = loadSound('assets/beat');
 * }
 *
 * function setup() {
 *   let cnv = createCanvas(100, 100);
 *   cnv.mousePressed(toggleSound);
 *
 *   eq = new p5.EQ(eqBandNames.length);
 *   soundFile.disconnect();
 *   eq.process(soundFile);
 * }
 *
 * function draw() {
 *   background(30);
 *   noStroke();
 *   fill(255);
 *   textAlign(CENTER);
 *   text('filtering ', 50, 25);
 *
 *   fill(255, 40, 255);
 *   textSize(26);
 *   text(eqBandNames[eqBandIndex], 50, 55);
 *
 *   fill(255);
 *   textSize(9);
 *
 *   if (!soundFile.isPlaying()) {
 *     text('tap to play', 50, 80);
 *   } else {
 *     text('tap to filter next band', 50, 80)
 *   }
 * }
 *
 * function toggleSound() {
 *   if (!soundFile.isPlaying()) {
 *     soundFile.play();
 *   } else {
 *     eqBandIndex = (eqBandIndex + 1) % eq.bands.length;
 *   }
 *
 *   for (let i = 0; i < eq.bands.length; i++) {
 *     eq.bands[i].gain(0);
 *   }
 *   // filter the band we want to filter
 *   eq.bands[eqBandIndex].gain(-40);
 * }
 * </code></div>
 */ var eq_EQ = function(_Effect) {
            eq_inherits(EQ, _Effect);
            function EQ(_eqsize) {
                var _this;
                eq_classCallCheck(this, EQ);
                _this = eq_possibleConstructorReturn(this, eq_getPrototypeOf(EQ).call(this));
                _eqsize = _eqsize === 3 || _eqsize === 8 ? _eqsize : 3;
                var factor;
                _eqsize === 3 ? factor = Math.pow(2, 3) : factor = 2;
                /**
     *  The p5.EQ is built with abstracted p5.Filter objects.
     *  To modify any bands, use methods of the <a
     *  href="/reference/#/p5.Filter" title="p5.Filter reference">
     *  p5.Filter</a> API, especially `gain` and `freq`.
     *  Bands are stored in an array, with indices 0 - 3, or 0 - 7
     *  @property {Array}  bands
     *
     */ _this.bands = [];
                var freq, res;
                for(var i = 0; i < _eqsize; i++){
                    if (i === _eqsize - 1) {
                        freq = 21000;
                        res = 0.01;
                    } else if (i === 0) {
                        freq = 100;
                        res = 0.1;
                    } else if (i === 1) {
                        freq = _eqsize === 3 ? 360 * factor : 360;
                        res = 1;
                    } else {
                        freq = _this.bands[i - 1].freq() * factor;
                        res = 1;
                    }
                    _this.bands[i] = _this._newBand(freq, res);
                    if (i > 0) _this.bands[i - 1].connect(_this.bands[i].biquad);
                    else _this.input.connect(_this.bands[i].biquad);
                }
                _this.bands[_eqsize - 1].connect(_this.output);
                return _this;
            }
            /**
   * Process an input by connecting it to the EQ
   * @method  process
   * @param  {Object} src Audio source
   */ eq_createClass(EQ, [
                {
                    key: "process",
                    value: function process(src) {
                        src.connect(this.input);
                    }
                },
                {
                    key: "set",
                    value: function set() {
                        if (arguments.length === this.bands.length * 2) for(var i = 0; i < arguments.length; i += 2){
                            this.bands[i / 2].freq(arguments[i]);
                            this.bands[i / 2].gain(arguments[i + 1]);
                        }
                        else console.error("Argument mismatch. .set() should be called with " + this.bands.length * 2 + " arguments. (one frequency and gain value pair for each band of the eq)");
                    }
                },
                {
                    key: "_newBand",
                    value: function _newBand(freq, res) {
                        return new eqFilter(freq, res);
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        eq_get(eq_getPrototypeOf(EQ.prototype), "dispose", this).call(this);
                        if (this.bands) {
                            while(this.bands.length > 0)delete this.bands.pop().dispose();
                            delete this.bands;
                        }
                    }
                }
            ]);
            return EQ;
        }(effect);
        var eq = eq_EQ;
        function listener3d_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function listener3d_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function listener3d_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) listener3d_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) listener3d_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        //   * listener is a class that can construct both a Spatial Panner
        //   * and a Spatial Listener. The panner is based on the
        //   * Web Audio Spatial Panner Node
        //   * https://www.w3.org/TR/webaudio/#the-listenernode-interface
        //   * This panner is a spatial processing node that allows audio to be positioned
        //   * and oriented in 3D space.
        //   *
        //   * The Listener modifies the properties of the Audio Context Listener.
        //   * Both objects types use the same methods. The default is a spatial panner.
        //   *
        //   * <code>p5.Panner3D</code> - Constructs a Spatial Panner<br/>
        //   * <code>p5.Listener3D</code> - Constructs a Spatial Listener<br/>
        //   *
        //   * @class listener
        //   * @constructor
        //   * @return {Object} p5.Listener3D Object
        //   *
        //   * @param {Web Audio Node} listener Web Audio Spatial Panning Node
        //   * @param {AudioParam} listener.panningModel "equal power" or "HRTF"
        //   * @param {AudioParam} listener.distanceModel "linear", "inverse", or "exponential"
        //   * @param {String} [type] [Specify construction of a spatial panner or listener]
        //   */
        var listener3d_Listener3D = function() {
            function Listener3D(type) {
                listener3d_classCallCheck(this, Listener3D);
                this.ac = main.audiocontext;
                this.listener = this.ac.listener;
            }
            //   * Connect an audio sorce
            //   * @param  {Object} src Input source
            //   */
            listener3d_createClass(Listener3D, [
                {
                    key: "process",
                    value: function process(src) {
                        src.connect(this.input);
                    }
                },
                {
                    key: "position",
                    value: function position(xVal, yVal, zVal, time) {
                        this.positionX(xVal, time);
                        this.positionY(yVal, time);
                        this.positionZ(zVal, time);
                        return [
                            this.listener.positionX.value,
                            this.listener.positionY.value,
                            this.listener.positionZ.value
                        ];
                    }
                },
                {
                    key: "positionX",
                    value: function positionX(xVal, time) {
                        var t = time || 0;
                        if (typeof xVal === "number") {
                            this.listener.positionX.value = xVal;
                            this.listener.positionX.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.listener.positionX.linearRampToValueAtTime(xVal, this.ac.currentTime + 0.02 + t);
                        } else if (xVal) xVal.connect(this.listener.positionX);
                        return this.listener.positionX.value;
                    }
                },
                {
                    key: "positionY",
                    value: function positionY(yVal, time) {
                        var t = time || 0;
                        if (typeof yVal === "number") {
                            this.listener.positionY.value = yVal;
                            this.listener.positionY.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.listener.positionY.linearRampToValueAtTime(yVal, this.ac.currentTime + 0.02 + t);
                        } else if (yVal) yVal.connect(this.listener.positionY);
                        return this.listener.positionY.value;
                    }
                },
                {
                    key: "positionZ",
                    value: function positionZ(zVal, time) {
                        var t = time || 0;
                        if (typeof zVal === "number") {
                            this.listener.positionZ.value = zVal;
                            this.listener.positionZ.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.listener.positionZ.linearRampToValueAtTime(zVal, this.ac.currentTime + 0.02 + t);
                        } else if (zVal) zVal.connect(this.listener.positionZ);
                        return this.listener.positionZ.value;
                    }
                },
                {
                    key: "orient",
                    value: function orient(xValF, yValF, zValF, xValU, yValU, zValU, time) {
                        if (arguments.length === 3 || arguments.length === 4) {
                            time = arguments[3];
                            this.orientForward(xValF, yValF, zValF, time);
                        } else if (arguments.length === 6 || arguments === 7) {
                            this.orientForward(xValF, yValF, zValF);
                            this.orientUp(xValU, yValU, zValU, time);
                        }
                        return [
                            this.listener.forwardX.value,
                            this.listener.forwardY.value,
                            this.listener.forwardZ.value,
                            this.listener.upX.value,
                            this.listener.upY.value,
                            this.listener.upZ.value
                        ];
                    }
                },
                {
                    key: "orientForward",
                    value: function orientForward(xValF, yValF, zValF, time) {
                        this.forwardX(xValF, time);
                        this.forwardY(yValF, time);
                        this.forwardZ(zValF, time);
                        return [
                            this.listener.forwardX,
                            this.listener.forwardY,
                            this.listener.forwardZ
                        ];
                    }
                },
                {
                    key: "orientUp",
                    value: function orientUp(xValU, yValU, zValU, time) {
                        this.upX(xValU, time);
                        this.upY(yValU, time);
                        this.upZ(zValU, time);
                        return [
                            this.listener.upX,
                            this.listener.upY,
                            this.listener.upZ
                        ];
                    }
                },
                {
                    key: "forwardX",
                    value: function forwardX(xVal, time) {
                        var t = time || 0;
                        if (typeof xVal === "number") {
                            this.listener.forwardX.value = xVal;
                            this.listener.forwardX.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.listener.forwardX.linearRampToValueAtTime(xVal, this.ac.currentTime + 0.02 + t);
                        } else if (xVal) xVal.connect(this.listener.forwardX);
                        return this.listener.forwardX.value;
                    }
                },
                {
                    key: "forwardY",
                    value: function forwardY(yVal, time) {
                        var t = time || 0;
                        if (typeof yVal === "number") {
                            this.listener.forwardY.value = yVal;
                            this.listener.forwardY.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.listener.forwardY.linearRampToValueAtTime(yVal, this.ac.currentTime + 0.02 + t);
                        } else if (yVal) yVal.connect(this.listener.forwardY);
                        return this.listener.forwardY.value;
                    }
                },
                {
                    key: "forwardZ",
                    value: function forwardZ(zVal, time) {
                        var t = time || 0;
                        if (typeof zVal === "number") {
                            this.listener.forwardZ.value = zVal;
                            this.listener.forwardZ.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.listener.forwardZ.linearRampToValueAtTime(zVal, this.ac.currentTime + 0.02 + t);
                        } else if (zVal) zVal.connect(this.listener.forwardZ);
                        return this.listener.forwardZ.value;
                    }
                },
                {
                    key: "upX",
                    value: function upX(xVal, time) {
                        var t = time || 0;
                        if (typeof xVal === "number") {
                            this.listener.upX.value = xVal;
                            this.listener.upX.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.listener.upX.linearRampToValueAtTime(xVal, this.ac.currentTime + 0.02 + t);
                        } else if (xVal) xVal.connect(this.listener.upX);
                        return this.listener.upX.value;
                    }
                },
                {
                    key: "upY",
                    value: function upY(yVal, time) {
                        var t = time || 0;
                        if (typeof yVal === "number") {
                            this.listener.upY.value = yVal;
                            this.listener.upY.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.listener.upY.linearRampToValueAtTime(yVal, this.ac.currentTime + 0.02 + t);
                        } else if (yVal) yVal.connect(this.listener.upY);
                        return this.listener.upY.value;
                    }
                },
                {
                    key: "upZ",
                    value: function upZ(zVal, time) {
                        var t = time || 0;
                        if (typeof zVal === "number") {
                            this.listener.upZ.value = zVal;
                            this.listener.upZ.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.listener.upZ.linearRampToValueAtTime(zVal, this.ac.currentTime + 0.02 + t);
                        } else if (zVal) zVal.connect(this.listener.upZ);
                        return this.listener.upZ.value;
                    }
                }
            ]);
            return Listener3D;
        }();
        var listener3d = listener3d_Listener3D;
        function panner3d_typeof(obj) {
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") panner3d_typeof = function _typeof(obj) {
                return typeof obj;
            };
            else panner3d_typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            return panner3d_typeof(obj);
        }
        function panner3d_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function panner3d_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function panner3d_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) panner3d_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) panner3d_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        function panner3d_possibleConstructorReturn(self1, call) {
            if (call && (panner3d_typeof(call) === "object" || typeof call === "function")) return call;
            return panner3d_assertThisInitialized(self1);
        }
        function panner3d_assertThisInitialized(self1) {
            if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return self1;
        }
        function panner3d_get(target, property, receiver) {
            if (typeof Reflect !== "undefined" && Reflect.get) panner3d_get = Reflect.get;
            else panner3d_get = function _get(target, property, receiver) {
                var base = panner3d_superPropBase(target, property);
                if (!base) return;
                var desc = Object.getOwnPropertyDescriptor(base, property);
                if (desc.get) return desc.get.call(receiver);
                return desc.value;
            };
            return panner3d_get(target, property, receiver || target);
        }
        function panner3d_superPropBase(object, property) {
            while(!Object.prototype.hasOwnProperty.call(object, property)){
                object = panner3d_getPrototypeOf(object);
                if (object === null) break;
            }
            return object;
        }
        function panner3d_getPrototypeOf(o) {
            panner3d_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
            };
            return panner3d_getPrototypeOf(o);
        }
        function panner3d_inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    writable: true,
                    configurable: true
                }
            });
            if (superClass) panner3d_setPrototypeOf(subClass, superClass);
        }
        function panner3d_setPrototypeOf(o, p) {
            panner3d_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };
            return panner3d_setPrototypeOf(o, p);
        }
        /**
 * Panner3D is based on the <a title="Web Audio Panner docs"  href=
 * "https://developer.mozilla.org/en-US/docs/Web/API/PannerNode">
 * Web Audio Spatial Panner Node</a>.
 * This panner is a spatial processing node that allows audio to be positioned
 * and oriented in 3D space.
 *
 * The position is relative to an <a title="Web Audio Listener docs" href=
 * "https://developer.mozilla.org/en-US/docs/Web/API/AudioListener">
 * Audio Context Listener</a>, which can be accessed
 * by <code>p5.soundOut.audiocontext.listener</code>
 *
 *
 * @class p5.Panner3D
 * @constructor
 */ var Panner3D = function(_Effect) {
            panner3d_inherits(Panner3D, _Effect);
            function Panner3D() {
                var _this;
                panner3d_classCallCheck(this, Panner3D);
                _this = panner3d_possibleConstructorReturn(this, panner3d_getPrototypeOf(Panner3D).call(this));
                /**
     *  <a title="Web Audio Panner docs"  href=
     *  "https://developer.mozilla.org/en-US/docs/Web/API/PannerNode">
     *  Web Audio Spatial Panner Node</a>
     *
     *  Properties include<br>
     * [Panning Model](https://www.w3.org/TR/webaudio/#idl-def-PanningModelType)
     * : "equal power" or "HRTF"<br>
     * [DistanceModel](https://www.w3.org/TR/webaudio/#idl-def-DistanceModelType)
     *  : "linear", "inverse", or "exponential"
     *
     *  @property {AudioNode} panner
     *
     */ _this.panner = _this.ac.createPanner();
                _this.panner.panningModel = "HRTF";
                _this.panner.distanceModel = "linear";
                _this.panner.connect(_this.output);
                _this.input.connect(_this.panner);
                return _this;
            }
            /**
   * Connect an audio sorce
   *
   * @method  process
   * @for p5.Panner3D
   * @param  {Object} src Input source
   */ panner3d_createClass(Panner3D, [
                {
                    key: "process",
                    value: function process(src) {
                        src.connect(this.input);
                    }
                },
                {
                    key: "set",
                    value: function set(xVal, yVal, zVal, time) {
                        this.positionX(xVal, time);
                        this.positionY(yVal, time);
                        this.positionZ(zVal, time);
                        return [
                            this.panner.positionX.value,
                            this.panner.positionY.value,
                            this.panner.positionZ.value
                        ];
                    }
                },
                {
                    key: "positionX",
                    value: function positionX(xVal, time) {
                        var t = time || 0;
                        if (typeof xVal === "number") {
                            this.panner.positionX.value = xVal;
                            this.panner.positionX.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.panner.positionX.linearRampToValueAtTime(xVal, this.ac.currentTime + 0.02 + t);
                        } else if (xVal) xVal.connect(this.panner.positionX);
                        return this.panner.positionX.value;
                    }
                },
                {
                    key: "positionY",
                    value: function positionY(yVal, time) {
                        var t = time || 0;
                        if (typeof yVal === "number") {
                            this.panner.positionY.value = yVal;
                            this.panner.positionY.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.panner.positionY.linearRampToValueAtTime(yVal, this.ac.currentTime + 0.02 + t);
                        } else if (yVal) yVal.connect(this.panner.positionY);
                        return this.panner.positionY.value;
                    }
                },
                {
                    key: "positionZ",
                    value: function positionZ(zVal, time) {
                        var t = time || 0;
                        if (typeof zVal === "number") {
                            this.panner.positionZ.value = zVal;
                            this.panner.positionZ.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.panner.positionZ.linearRampToValueAtTime(zVal, this.ac.currentTime + 0.02 + t);
                        } else if (zVal) zVal.connect(this.panner.positionZ);
                        return this.panner.positionZ.value;
                    }
                },
                {
                    key: "orient",
                    value: function orient(xVal, yVal, zVal, time) {
                        this.orientX(xVal, time);
                        this.orientY(yVal, time);
                        this.orientZ(zVal, time);
                        return [
                            this.panner.orientationX.value,
                            this.panner.orientationY.value,
                            this.panner.orientationZ.value
                        ];
                    }
                },
                {
                    key: "orientX",
                    value: function orientX(xVal, time) {
                        var t = time || 0;
                        if (typeof xVal === "number") {
                            this.panner.orientationX.value = xVal;
                            this.panner.orientationX.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.panner.orientationX.linearRampToValueAtTime(xVal, this.ac.currentTime + 0.02 + t);
                        } else if (xVal) xVal.connect(this.panner.orientationX);
                        return this.panner.orientationX.value;
                    }
                },
                {
                    key: "orientY",
                    value: function orientY(yVal, time) {
                        var t = time || 0;
                        if (typeof yVal === "number") {
                            this.panner.orientationY.value = yVal;
                            this.panner.orientationY.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.panner.orientationY.linearRampToValueAtTime(yVal, this.ac.currentTime + 0.02 + t);
                        } else if (yVal) yVal.connect(this.panner.orientationY);
                        return this.panner.orientationY.value;
                    }
                },
                {
                    key: "orientZ",
                    value: function orientZ(zVal, time) {
                        var t = time || 0;
                        if (typeof zVal === "number") {
                            this.panner.orientationZ.value = zVal;
                            this.panner.orientationZ.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.panner.orientationZ.linearRampToValueAtTime(zVal, this.ac.currentTime + 0.02 + t);
                        } else if (zVal) zVal.connect(this.panner.orientationZ);
                        return this.panner.orientationZ.value;
                    }
                },
                {
                    key: "setFalloff",
                    value: function setFalloff(maxDistance, rolloffFactor) {
                        this.maxDist(maxDistance);
                        this.rolloff(rolloffFactor);
                    }
                },
                {
                    key: "maxDist",
                    value: function maxDist(maxDistance) {
                        if (typeof maxDistance === "number") this.panner.maxDistance = maxDistance;
                        return this.panner.maxDistance;
                    }
                },
                {
                    key: "rolloff",
                    value: function rolloff(rolloffFactor) {
                        if (typeof rolloffFactor === "number") this.panner.rolloffFactor = rolloffFactor;
                        return this.panner.rolloffFactor;
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        panner3d_get(panner3d_getPrototypeOf(Panner3D.prototype), "dispose", this).call(this);
                        if (this.panner) {
                            this.panner.disconnect();
                            delete this.panner;
                        }
                    }
                }
            ]);
            return Panner3D;
        }(effect);
        var panner3d = Panner3D;
        function delay_typeof(obj) {
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") delay_typeof = function _typeof(obj) {
                return typeof obj;
            };
            else delay_typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            return delay_typeof(obj);
        }
        function delay_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function delay_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function delay_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) delay_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) delay_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        function delay_possibleConstructorReturn(self1, call) {
            if (call && (delay_typeof(call) === "object" || typeof call === "function")) return call;
            return delay_assertThisInitialized(self1);
        }
        function delay_assertThisInitialized(self1) {
            if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return self1;
        }
        function delay_get(target, property, receiver) {
            if (typeof Reflect !== "undefined" && Reflect.get) delay_get = Reflect.get;
            else delay_get = function _get(target, property, receiver) {
                var base = delay_superPropBase(target, property);
                if (!base) return;
                var desc = Object.getOwnPropertyDescriptor(base, property);
                if (desc.get) return desc.get.call(receiver);
                return desc.value;
            };
            return delay_get(target, property, receiver || target);
        }
        function delay_superPropBase(object, property) {
            while(!Object.prototype.hasOwnProperty.call(object, property)){
                object = delay_getPrototypeOf(object);
                if (object === null) break;
            }
            return object;
        }
        function delay_getPrototypeOf(o) {
            delay_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
            };
            return delay_getPrototypeOf(o);
        }
        function delay_inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    writable: true,
                    configurable: true
                }
            });
            if (superClass) delay_setPrototypeOf(subClass, superClass);
        }
        function delay_setPrototypeOf(o, p) {
            delay_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };
            return delay_setPrototypeOf(o, p);
        }
        /**
 *  Delay is an echo effect. It processes an existing sound source,
 *  and outputs a delayed version of that sound. The p5.Delay can
 *  produce different effects depending on the delayTime, feedback,
 *  filter, and type. In the example below, a feedback of 0.5 (the
 *  default value) will produce a looping delay that decreases in
 *  volume by 50% each repeat. A filter will cut out the high
 *  frequencies so that the delay does not sound as piercing as the
 *  original source.
 *
 *
 *  This class extends <a href = "/reference/#/p5.Effect">p5.Effect</a>.
 *  Methods <a href = "/reference/#/p5.Effect/amp">amp()</a>, <a href = "/reference/#/p5.Effect/chain">chain()</a>,
 *  <a href = "/reference/#/p5.Effect/drywet">drywet()</a>, <a href = "/reference/#/p5.Effect/connect">connect()</a>, and
 *  <a href = "/reference/#/p5.Effect/disconnect">disconnect()</a> are available.
 *  @class p5.Delay
 *  @extends p5.Effect
 *  @constructor
 *  @example
 *  <div><code>
 *  let osc;
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    background(220);
 *    textAlign(CENTER);
 *    text('tap to play', width/2, height/2);
 *
 *    osc = new p5.Oscillator('square');
 *    osc.amp(0.5);
 *    delay = new p5.Delay();
 *
 *    // delay.process() accepts 4 parameters:
 *    // source, delayTime (in seconds), feedback, filter frequency
 *    delay.process(osc, 0.12, .7, 2300);
 *
 *    cnv.mousePressed(oscStart);
 *  }
 *
 *  function oscStart() {
 *    osc.start();
 *  }
 *
 *  function mouseReleased() {
 *    osc.stop();
 *  }
 *  </code></div>
 */ var delay_Delay = function(_Effect) {
            delay_inherits(Delay, _Effect);
            function Delay() {
                var _this;
                delay_classCallCheck(this, Delay);
                _this = delay_possibleConstructorReturn(this, delay_getPrototypeOf(Delay).call(this));
                _this._split = _this.ac.createChannelSplitter(2);
                _this._merge = _this.ac.createChannelMerger(2);
                _this._leftGain = _this.ac.createGain();
                _this._rightGain = _this.ac.createGain();
                /**
     *  The p5.Delay is built with two
     *  <a href="http://www.w3.org/TR/webaudio/#DelayNode">
     *  Web Audio Delay Nodes</a>, one for each stereo channel.
     *
     *  @for p5.Delay
     *  @property {DelayNode} leftDelay
     */ _this.leftDelay = _this.ac.createDelay();
                /**
     *  The p5.Delay is built with two
     *  <a href="http://www.w3.org/TR/webaudio/#DelayNode">
     *  Web Audio Delay Nodes</a>, one for each stereo channel.
     *  @for p5.Delay
     *  @property {DelayNode} rightDelay
     */ _this.rightDelay = _this.ac.createDelay();
                _this._leftFilter = new filter();
                _this._rightFilter = new filter();
                _this._leftFilter.disconnect();
                _this._rightFilter.disconnect();
                _this._leftFilter.biquad.frequency.setValueAtTime(1200, _this.ac.currentTime);
                _this._rightFilter.biquad.frequency.setValueAtTime(1200, _this.ac.currentTime);
                _this._leftFilter.biquad.Q.setValueAtTime(0.3, _this.ac.currentTime);
                _this._rightFilter.biquad.Q.setValueAtTime(0.3, _this.ac.currentTime);
                _this.input.connect(_this._split);
                _this.leftDelay.connect(_this._leftGain);
                _this.rightDelay.connect(_this._rightGain);
                _this._leftGain.connect(_this._leftFilter.input);
                _this._rightGain.connect(_this._rightFilter.input);
                _this._merge.connect(_this.wet);
                _this._leftFilter.biquad.gain.setValueAtTime(1, _this.ac.currentTime);
                _this._rightFilter.biquad.gain.setValueAtTime(1, _this.ac.currentTime);
                _this.setType(0);
                _this._maxDelay = _this.leftDelay.delayTime.maxValue;
                _this.feedback(0.5);
                return _this;
            }
            /**
   *  Add delay to an audio signal according to a set
   *  of delay parameters.
   *
   *  @method  process
   *  @for p5.Delay
   *  @param  {Object} Signal  An object that outputs audio
   *  @param  {Number} [delayTime] Time (in seconds) of the delay/echo.
   *                               Some browsers limit delayTime to
   *                               1 second.
   *  @param  {Number} [feedback]  sends the delay back through itself
   *                               in a loop that decreases in volume
   *                               each time.
   *  @param  {Number} [lowPass]   Cutoff frequency. Only frequencies
   *                               below the lowPass will be part of the
   *                               delay.
   */ delay_createClass(Delay, [
                {
                    key: "process",
                    value: function process(src, _delayTime, _feedback, _filter) {
                        var feedback = _feedback || 0;
                        var delayTime = _delayTime || 0;
                        if (feedback >= 1.0) throw new Error("Feedback value will force a positive feedback loop.");
                        if (delayTime >= this._maxDelay) throw new Error("Delay Time exceeds maximum delay time of " + this._maxDelay + " second.");
                        src.connect(this.input);
                        this.leftDelay.delayTime.setValueAtTime(delayTime, this.ac.currentTime);
                        this.rightDelay.delayTime.setValueAtTime(delayTime, this.ac.currentTime);
                        this._leftGain.gain.value = feedback;
                        this._rightGain.gain.value = feedback;
                        if (_filter) {
                            this._leftFilter.freq(_filter);
                            this._rightFilter.freq(_filter);
                        }
                    }
                },
                {
                    key: "delayTime",
                    value: function delayTime(t) {
                        if (typeof t !== "number") {
                            t.connect(this.leftDelay.delayTime);
                            t.connect(this.rightDelay.delayTime);
                        } else {
                            this.leftDelay.delayTime.cancelScheduledValues(this.ac.currentTime);
                            this.rightDelay.delayTime.cancelScheduledValues(this.ac.currentTime);
                            this.leftDelay.delayTime.linearRampToValueAtTime(t, this.ac.currentTime);
                            this.rightDelay.delayTime.linearRampToValueAtTime(t, this.ac.currentTime);
                        }
                    }
                },
                {
                    key: "feedback",
                    value: function feedback(f) {
                        if (f && typeof f !== "number") {
                            f.connect(this._leftGain.gain);
                            f.connect(this._rightGain.gain);
                        } else if (f >= 1.0) throw new Error("Feedback value will force a positive feedback loop.");
                        else if (typeof f === "number") {
                            this._leftGain.gain.value = f;
                            this._rightGain.gain.value = f;
                        }
                        return this._leftGain.gain.value;
                    }
                },
                {
                    key: "filter",
                    value: function filter(freq, q) {
                        this._leftFilter.set(freq, q);
                        this._rightFilter.set(freq, q);
                    }
                },
                {
                    key: "setType",
                    value: function setType(t) {
                        if (t === 1) t = "pingPong";
                        this._split.disconnect();
                        this._leftFilter.disconnect();
                        this._rightFilter.disconnect();
                        this._split.connect(this.leftDelay, 0);
                        this._split.connect(this.rightDelay, 1);
                        switch(t){
                            case "pingPong":
                                this._rightFilter.setType(this._leftFilter.biquad.type);
                                this._leftFilter.output.connect(this._merge, 0, 0);
                                this._rightFilter.output.connect(this._merge, 0, 1);
                                this._leftFilter.output.connect(this.rightDelay);
                                this._rightFilter.output.connect(this.leftDelay);
                                break;
                            default:
                                this._leftFilter.output.connect(this._merge, 0, 0);
                                this._rightFilter.output.connect(this._merge, 0, 1);
                                this._leftFilter.output.connect(this.leftDelay);
                                this._rightFilter.output.connect(this.rightDelay);
                        }
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        delay_get(delay_getPrototypeOf(Delay.prototype), "dispose", this).call(this);
                        this._split.disconnect();
                        this._leftFilter.dispose();
                        this._rightFilter.dispose();
                        this._merge.disconnect();
                        this._leftGain.disconnect();
                        this._rightGain.disconnect();
                        this.leftDelay.disconnect();
                        this.rightDelay.disconnect();
                        this._split = undefined;
                        this._leftFilter = undefined;
                        this._rightFilter = undefined;
                        this._merge = undefined;
                        this._leftGain = undefined;
                        this._rightGain = undefined;
                        this.leftDelay = undefined;
                        this.rightDelay = undefined;
                    }
                }
            ]);
            return Delay;
        }(effect);
        var delay = delay_Delay;
        function reverb_typeof(obj) {
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") reverb_typeof = function _typeof(obj) {
                return typeof obj;
            };
            else reverb_typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            return reverb_typeof(obj);
        }
        function reverb_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function reverb_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function reverb_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) reverb_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) reverb_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        function reverb_possibleConstructorReturn(self1, call) {
            if (call && (reverb_typeof(call) === "object" || typeof call === "function")) return call;
            return reverb_assertThisInitialized(self1);
        }
        function reverb_assertThisInitialized(self1) {
            if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return self1;
        }
        function reverb_get(target, property, receiver) {
            if (typeof Reflect !== "undefined" && Reflect.get) reverb_get = Reflect.get;
            else reverb_get = function _get(target, property, receiver) {
                var base = reverb_superPropBase(target, property);
                if (!base) return;
                var desc = Object.getOwnPropertyDescriptor(base, property);
                if (desc.get) return desc.get.call(receiver);
                return desc.value;
            };
            return reverb_get(target, property, receiver || target);
        }
        function reverb_superPropBase(object, property) {
            while(!Object.prototype.hasOwnProperty.call(object, property)){
                object = reverb_getPrototypeOf(object);
                if (object === null) break;
            }
            return object;
        }
        function reverb_getPrototypeOf(o) {
            reverb_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
            };
            return reverb_getPrototypeOf(o);
        }
        function reverb_inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    writable: true,
                    configurable: true
                }
            });
            if (superClass) reverb_setPrototypeOf(subClass, superClass);
        }
        function reverb_setPrototypeOf(o, p) {
            reverb_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };
            return reverb_setPrototypeOf(o, p);
        }
        /**
 *  Reverb adds depth to a sound through a large number of decaying
 *  echoes. It creates the perception that sound is occurring in a
 *  physical space. The p5.Reverb has paramters for Time (how long does the
 *  reverb last) and decayRate (how much the sound decays with each echo)
 *  that can be set with the .set() or .process() methods. The p5.Convolver
 *  extends p5.Reverb allowing you to recreate the sound of actual physical
 *  spaces through convolution.
 *
 *  This class extends <a href = "/reference/#/p5.Effect">p5.Effect</a>.
 *  Methods <a href = "/reference/#/p5.Effect/amp">amp()</a>, <a href = "/reference/#/p5.Effect/chain">chain()</a>,
 *  <a href = "/reference/#/p5.Effect/drywet">drywet()</a>, <a href = "/reference/#/p5.Effect/connect">connect()</a>, and
 *  <a href = "/reference/#/p5.Effect/disconnect">disconnect()</a> are available.
 *
 *  @class p5.Reverb
 *  @extends p5.Effect
 *  @constructor
 *  @example
 *  <div><code>
 *  let soundFile, reverb;
 *  function preload() {
 *    soundFile = loadSound('assets/Damscray_DancingTiger.mp3');
 *  }
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(playSound);
 *
 *    reverb = new p5.Reverb();
 *    soundFile.disconnect(); // so we'll only hear reverb...
 *
 *    // connect soundFile to reverb, process w/
 *    // 3 second reverbTime, decayRate of 2%
 *    reverb.process(soundFile, 3, 2);
 *  }
 *
 *  function draw() {
 *    let dryWet = constrain(map(mouseX, 0, width, 0, 1), 0, 1);
 *    // 1 = all reverb, 0 = no reverb
 *    reverb.drywet(dryWet);
 *
 *    background(220);
 *    text('tap to play', 10, 20);
 *    text('dry/wet: ' + round(dryWet * 100) + '%', 10, height - 20);
 *  }
 *
 *  function playSound() {
 *    soundFile.play();
 *  }
 *  </code></div>
 */ var Reverb = function(_Effect) {
            reverb_inherits(Reverb, _Effect);
            function Reverb() {
                var _this;
                reverb_classCallCheck(this, Reverb);
                _this = reverb_possibleConstructorReturn(this, reverb_getPrototypeOf(Reverb).call(this));
                _this._initConvolverNode();
                _this.input.gain.value = 0.5;
                _this._seconds = 3;
                _this._decay = 2;
                _this._reverse = false;
                _this._buildImpulse();
                return _this;
            }
            reverb_createClass(Reverb, [
                {
                    key: "_initConvolverNode",
                    value: function _initConvolverNode() {
                        this.convolverNode = this.ac.createConvolver();
                        this.input.connect(this.convolverNode);
                        this.convolverNode.connect(this.wet);
                    }
                },
                {
                    key: "_teardownConvolverNode",
                    value: function _teardownConvolverNode() {
                        if (this.convolverNode) {
                            this.convolverNode.disconnect();
                            delete this.convolverNode;
                        }
                    }
                },
                {
                    key: "_setBuffer",
                    value: function _setBuffer(audioBuffer) {
                        this._teardownConvolverNode();
                        this._initConvolverNode();
                        this.convolverNode.buffer = audioBuffer;
                    }
                },
                {
                    key: "process",
                    value: function process(src, seconds, decayRate, reverse) {
                        src.connect(this.input);
                        var rebuild = false;
                        if (seconds) {
                            this._seconds = seconds;
                            rebuild = true;
                        }
                        if (decayRate) this._decay = decayRate;
                        if (reverse) this._reverse = reverse;
                        if (rebuild) this._buildImpulse();
                    }
                },
                {
                    key: "set",
                    value: function set(seconds, decayRate, reverse) {
                        var rebuild = false;
                        if (seconds) {
                            this._seconds = seconds;
                            rebuild = true;
                        }
                        if (decayRate) this._decay = decayRate;
                        if (reverse) this._reverse = reverse;
                        if (rebuild) this._buildImpulse();
                    }
                },
                {
                    key: "_buildImpulse",
                    value: function _buildImpulse() {
                        var rate = this.ac.sampleRate;
                        var length = rate * this._seconds;
                        var decay = this._decay;
                        var impulse = this.ac.createBuffer(2, length, rate);
                        var impulseL = impulse.getChannelData(0);
                        var impulseR = impulse.getChannelData(1);
                        var n, i;
                        for(i = 0; i < length; i++){
                            n = this._reverse ? length - i : i;
                            impulseL[i] = (Math.random() * 2 - 1) * Math.pow(1 - n / length, decay);
                            impulseR[i] = (Math.random() * 2 - 1) * Math.pow(1 - n / length, decay);
                        }
                        this._setBuffer(impulse);
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        reverb_get(reverb_getPrototypeOf(Reverb.prototype), "dispose", this).call(this);
                        this._teardownConvolverNode();
                    }
                }
            ]);
            return Reverb;
        }(effect);
        /**
 *  <p>p5.Convolver extends p5.Reverb. It can emulate the sound of real
 *  physical spaces through a process called <a href="
 *  https://en.wikipedia.org/wiki/Convolution_reverb#Real_space_simulation">
 *  convolution</a>.</p>
 *
 *  <p>Convolution multiplies any audio input by an "impulse response"
 *  to simulate the dispersion of sound over time. The impulse response is
 *  generated from an audio file that you provide. One way to
 *  generate an impulse response is to pop a balloon in a reverberant space
 *  and record the echo. Convolution can also be used to experiment with
 *  sound.</p>
 *
 *  <p>Use the method <code>createConvolution(path)</code> to instantiate a
 *  p5.Convolver with a path to your impulse response audio file.</p>
 *
 *  @class p5.Convolver
 *  @extends p5.Effect
 *  @constructor
 *  @param  {String}   path     path to a sound file
 *  @param  {Function} [callback] function to call when loading succeeds
 *  @param  {Function} [errorCallback] function to call if loading fails.
 *                                     This function will receive an error or
 *                                     XMLHttpRequest object with information
 *                                     about what went wrong.
 *  @example
 *  <div><code>
 *  let cVerb, sound;
 *  function preload() {
 *    // We have both MP3 and OGG versions of all sound assets
 *    soundFormats('ogg', 'mp3');
 *
 *    // Try replacing 'bx-spring' with other soundfiles like
 *    // 'concrete-tunnel' 'small-plate' 'drum' 'beatbox'
 *    cVerb = createConvolver('assets/bx-spring.mp3');
 *
 *    // Try replacing 'Damscray_DancingTiger' with
 *    // 'beat', 'doorbell', lucky_dragons_-_power_melody'
 *    sound = loadSound('assets/Damscray_DancingTiger.mp3');
 *  }
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(playSound);
 *    background(220);
 *    text('tap to play', 20, 20);
 *
 *    // disconnect from main output...
 *    sound.disconnect();
 *
 *    // ...and process with cVerb
 *    // so that we only hear the convolution
 *    cVerb.process(sound);
 *  }
 *
 *  function playSound() {
 *    sound.play();
 *  }
 *  </code></div>
 */ var reverb_Convolver = function(_Reverb) {
            reverb_inherits(Convolver, _Reverb);
            function Convolver(path, callback, errorCallback) {
                var _this2;
                reverb_classCallCheck(this, Convolver);
                _this2 = reverb_possibleConstructorReturn(this, reverb_getPrototypeOf(Convolver).call(this));
                /**
     *  Internally, the p5.Convolver uses the a
     *  <a href="http://www.w3.org/TR/webaudio/#ConvolverNode">
     *  Web Audio Convolver Node</a>.
     *
     *  @property {ConvolverNode} convolverNode
     */ _this2._initConvolverNode();
                _this2.input.gain.value = 0.5;
                if (path) {
                    _this2.impulses = [];
                    _this2._loadBuffer(path, callback, errorCallback);
                } else {
                    _this2._seconds = 3;
                    _this2._decay = 2;
                    _this2._reverse = false;
                    _this2._buildImpulse();
                }
                /**
     *  If you load multiple impulse files using the .addImpulse method,
     *  they will be stored as Objects in this Array. Toggle between them
     *  with the <code>toggleImpulse(id)</code> method.
     *
     *  @property {Array} impulses
     *  @for p5.Convolver
     */ _this2.impulses = [];
                _this2.set = null;
                return _this2;
            }
            /**
   *  Private method to load a buffer as an Impulse Response,
   *  assign it to the convolverNode, and add to the Array of .impulses.
   *
   *  @param   {String}   path
   *  @param   {Function} callback
   *  @param   {Function} errorCallback
   *  @private
   */ reverb_createClass(Convolver, [
                {
                    key: "_loadBuffer",
                    value: function _loadBuffer(_path, callback, errorCallback) {
                        var path = (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype._checkFileFormats(_path);
                        var self1 = this;
                        var errorTrace = new Error().stack;
                        var ac = Object(audiocontext["b"])();
                        var request = new XMLHttpRequest();
                        request.open("GET", path, true);
                        request.responseType = "arraybuffer";
                        request.onload = function() {
                            if (request.status === 200) ac.decodeAudioData(request.response, function(buff) {
                                var buffer = {};
                                var chunks = path.split("/");
                                buffer.name = chunks[chunks.length - 1];
                                buffer.audioBuffer = buff;
                                self1.impulses.push(buffer);
                                self1._setBuffer(buffer.audioBuffer);
                                if (callback) callback(buffer);
                            }, function() {
                                var err = new errorHandler("decodeAudioData", errorTrace, self1.url);
                                var msg = "AudioContext error at decodeAudioData for " + self1.url;
                                if (errorCallback) {
                                    err.msg = msg;
                                    errorCallback(err);
                                } else console.error(msg + "\n The error stack trace includes: \n" + err.stack);
                            });
                            else {
                                var err = new errorHandler("loadConvolver", errorTrace, self1.url);
                                var msg = "Unable to load " + self1.url + ". The request status was: " + request.status + " (" + request.statusText + ")";
                                if (errorCallback) {
                                    err.message = msg;
                                    errorCallback(err);
                                } else console.error(msg + "\n The error stack trace includes: \n" + err.stack);
                            }
                        };
                        request.onerror = function() {
                            var err = new errorHandler("loadConvolver", errorTrace, self1.url);
                            var msg = "There was no response from the server at " + self1.url + ". Check the url and internet connectivity.";
                            if (errorCallback) {
                                err.message = msg;
                                errorCallback(err);
                            } else console.error(msg + "\n The error stack trace includes: \n" + err.stack);
                        };
                        request.send();
                    }
                },
                {
                    key: "process",
                    value: function process(src) {
                        src.connect(this.input);
                    }
                },
                {
                    key: "addImpulse",
                    value: function addImpulse(path, callback, errorCallback) {
                        if (window.location.origin.indexOf("file://") > -1 && window.cordova === "undefined") alert("This sketch may require a server to load external files. Please see http://bit.ly/1qcInwS");
                        this._loadBuffer(path, callback, errorCallback);
                    }
                },
                {
                    key: "resetImpulse",
                    value: function resetImpulse(path, callback, errorCallback) {
                        if (window.location.origin.indexOf("file://") > -1 && window.cordova === "undefined") alert("This sketch may require a server to load external files. Please see http://bit.ly/1qcInwS");
                        this.impulses = [];
                        this._loadBuffer(path, callback, errorCallback);
                    }
                },
                {
                    key: "toggleImpulse",
                    value: function toggleImpulse(id) {
                        if (typeof id === "number" && id < this.impulses.length) this._setBuffer(this.impulses[id].audioBuffer);
                        if (typeof id === "string") {
                            for(var i = 0; i < this.impulses.length; i++)if (this.impulses[i].name === id) {
                                this._setBuffer(this.impulses[i].audioBuffer);
                                break;
                            }
                        }
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        reverb_get(reverb_getPrototypeOf(Convolver.prototype), "dispose", this).call(this);
                        for(var i in this.impulses)if (this.impulses[i]) this.impulses[i] = null;
                    }
                }
            ]);
            return Convolver;
        }(Reverb);
        /**
 *  Create a p5.Convolver. Accepts a path to a soundfile
 *  that will be used to generate an impulse response.
 *
 *  @method  createConvolver
 *  @for p5
 *  @param  {String}   path     path to a sound file
 *  @param  {Function} [callback] function to call if loading is successful.
 *                                The object will be passed in as the argument
 *                                to the callback function.
 *  @param  {Function} [errorCallback] function to call if loading is not successful.
 *                                A custom error will be passed in as the argument
 *                                to the callback function.
 *  @return {p5.Convolver}
 *  @example
 *  <div><code>
 *  let cVerb, sound;
 *  function preload() {
 *    // We have both MP3 and OGG versions of all sound assets
 *    soundFormats('ogg', 'mp3');
 *
 *    // Try replacing 'bx-spring' with other soundfiles like
 *    // 'concrete-tunnel' 'small-plate' 'drum' 'beatbox'
 *    cVerb = createConvolver('assets/bx-spring.mp3');
 *
 *    // Try replacing 'Damscray_DancingTiger' with
 *    // 'beat', 'doorbell', lucky_dragons_-_power_melody'
 *    sound = loadSound('assets/Damscray_DancingTiger.mp3');
 *  }
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(playSound);
 *    background(220);
 *    text('tap to play', 20, 20);
 *
 *    // disconnect from main output...
 *    sound.disconnect();
 *
 *    // ...and process with cVerb
 *    // so that we only hear the convolution
 *    cVerb.process(sound);
 *  }
 *
 *  function playSound() {
 *    sound.play();
 *  }
 *  </code></div>
 */ function createConvolver(path, callback, errorCallback) {
            if (window.location.origin.indexOf("file://") > -1 && window.cordova === "undefined") alert("This sketch may require a server to load external files. Please see http://bit.ly/1qcInwS");
            var self1 = this;
            var cReverb = new reverb_Convolver(path, function(buffer) {
                if (typeof callback === "function") callback(buffer);
                if (typeof self1._decrementPreload === "function") self1._decrementPreload();
            }, errorCallback);
            cReverb.impulses = [];
            return cReverb;
        }
        var Clock = __webpack_require__(11);
        var Clock_default = __webpack_require__.n(Clock);
        function metro_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function metro_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function metro_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) metro_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) metro_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        var metro_Metro = function() {
            function Metro() {
                metro_classCallCheck(this, Metro);
                this.clock = new Clock_default.a({
                    callback: this.ontick.bind(this)
                });
                this.syncedParts = [];
                this.bpm = 120;
                this._init();
                this.prevTick = 0;
                this.tatumTime = 0;
                this.tickCallback = function() {};
            }
            metro_createClass(Metro, [
                {
                    key: "ontick",
                    value: function ontick(tickTime) {
                        var elapsedTime = tickTime - this.prevTick;
                        var secondsFromNow = tickTime - main.audiocontext.currentTime;
                        if (elapsedTime - this.tatumTime <= -0.02) return;
                        else {
                            this.prevTick = tickTime;
                            var self1 = this;
                            this.syncedParts.forEach(function(thisPart) {
                                if (!thisPart.isPlaying) return;
                                thisPart.incrementStep(secondsFromNow);
                                thisPart.phrases.forEach(function(thisPhrase) {
                                    var phraseArray = thisPhrase.sequence;
                                    var bNum = self1.metroTicks % phraseArray.length;
                                    if (phraseArray[bNum] !== 0 && (self1.metroTicks < phraseArray.length || !thisPhrase.looping)) thisPhrase.callback(secondsFromNow, phraseArray[bNum]);
                                });
                            });
                            this.metroTicks += 1;
                            this.tickCallback(secondsFromNow);
                        }
                    }
                },
                {
                    key: "setBPM",
                    value: function setBPM(bpm) {
                        var rampTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                        var beatTime = 60 / (bpm * this.tatums);
                        var now = main.audiocontext.currentTime;
                        this.tatumTime = beatTime;
                        this.clock.frequency.setValueAtTime(this.clock.frequency.value, now);
                        this.clock.frequency.linearRampToValueAtTime(bpm, now + rampTime);
                        this.bpm = bpm;
                    }
                },
                {
                    key: "getBPM",
                    value: function getBPM() {
                        return this.clock.getRate() / this.tatums * 60;
                    }
                },
                {
                    key: "_init",
                    value: function _init() {
                        this.metroTicks = 0;
                    }
                },
                {
                    key: "resetSync",
                    value: function resetSync(part) {
                        this.syncedParts = [
                            part
                        ];
                    }
                },
                {
                    key: "pushSync",
                    value: function pushSync(part) {
                        this.syncedParts.push(part);
                    }
                },
                {
                    key: "start",
                    value: function start(timeFromNow) {
                        var t = timeFromNow || 0;
                        var now = main.audiocontext.currentTime;
                        this.clock.start(now + t);
                        this.setBPM(this.bpm);
                    }
                },
                {
                    key: "stop",
                    value: function stop(timeFromNow) {
                        var t = timeFromNow || 0;
                        var now = main.audiocontext.currentTime;
                        this.clock.stop(now + t);
                    }
                },
                {
                    key: "beatLength",
                    value: function beatLength(tatums) {
                        this.tatums = 1 / tatums / 4;
                    }
                }
            ]);
            return Metro;
        }();
        var metro = metro_Metro;
        function looper_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function looper_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) looper_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) looper_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        function looper_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        var BPM = 120;
        /**
 *  Set the global tempo, in beats per minute, for all
 *  p5.Parts. This method will impact all active p5.Parts.
 *
 *  @method setBPM
 *  @for p5
 *  @param {Number} BPM      Beats Per Minute
 *  @param {Number} rampTime Seconds from now
 */ (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.setBPM = function(bpm, rampTime) {
            BPM = bpm;
            for(var i in main.parts)if (main.parts[i]) main.parts[i].setBPM(bpm, rampTime);
        };
        /**
 *  <p>A phrase is a pattern of musical events over time, i.e.
 *  a series of notes and rests.</p>
 *
 *  <p>Phrases must be added to a p5.Part for playback, and
 *  each part can play multiple phrases at the same time.
 *  For example, one Phrase might be a kick drum, another
 *  could be a snare, and another could be the bassline.</p>
 *
 *  <p>The first parameter is a name so that the phrase can be
 *  modified or deleted later. The callback is a a function that
 *  this phrase will call at every step—for example it might be
 *  called <code>playNote(value){}</code>. The array determines
 *  which value is passed into the callback at each step of the
 *  phrase. It can be numbers, an object with multiple numbers,
 *  or a zero (0) indicates a rest so the callback won't be called).</p>
 *
 *  @class p5.Phrase
 *  @constructor
 *  @param {String}   name     Name so that you can access the Phrase.
 *  @param {Function} callback The name of a function that this phrase
 *                             will call. Typically it will play a sound,
 *                             and accept two parameters: a time at which
 *                             to play the sound (in seconds from now),
 *                             and a value from the sequence array. The
 *                             time should be passed into the play() or
 *                             start() method to ensure precision.
 *  @param {Array}   sequence    Array of values to pass into the callback
 *                            at each step of the phrase.
 *  @example
 *  <div><code>
 *  let mySound, myPhrase, myPart;
 *  let pattern = [1,0,0,2,0,2,0,0];
 *
 *  function preload() {
 *    mySound = loadSound('assets/beatbox.mp3');
 *  }
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(playMyPart);
 *    background(220);
 *    text('tap to play', width/2, height/2);
 *    textAlign(CENTER, CENTER);
 *
 *    myPhrase = new p5.Phrase('bbox', onEachStep, pattern);
 *    myPart = new p5.Part();
 *    myPart.addPhrase(myPhrase);
 *    myPart.setBPM(60);
 *  }
 *
 *  function onEachStep(time, playbackRate) {
 *    mySound.rate(playbackRate);
 *    mySound.play(time);
 *  }
 *
 *  function playMyPart() {
 *    userStartAudio();
 *    myPart.start();
 *  }
 *  </code></div>
 */ var Phrase = function Phrase(name1, callback, sequence) {
            looper_classCallCheck(this, Phrase);
            this.phraseStep = 0;
            this.name = name1;
            this.callback = callback;
            /**
   * Array of values to pass into the callback
   * at each step of the phrase. Depending on the callback
   * function's requirements, these values may be numbers,
   * strings, or an object with multiple parameters.
   * Zero (0) indicates a rest.
   *
   * @property {Array} sequence
   */ this.sequence = sequence;
        };
        /**
 *  <p>A p5.Part plays back one or more p5.Phrases. Instantiate a part
 *  with steps and tatums. By default, each step represents a 1/16th note.</p>
 *
 *  <p>See p5.Phrase for more about musical timing.</p>
 *
 *  @class p5.Part
 *  @constructor
 *  @param {Number} [steps]   Steps in the part
 *  @param {Number} [tatums] Divisions of a beat, e.g. use 1/4, or 0.25 for a quater note (default is 1/16, a sixteenth note)
 *  @example
 *  <div><code>
 *  let box, drum, myPart;
 *  let boxPat = [1,0,0,2,0,2,0,0];
 *  let drumPat = [0,1,1,0,2,0,1,0];
 *
 *  function preload() {
 *    box = loadSound('assets/beatbox.mp3');
 *    drum = loadSound('assets/drum.mp3');
 *  }
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(playMyPart);
 *    background(220);
 *    textAlign(CENTER, CENTER);
 *    text('tap to play', width/2, height/2);
 *
 *    let boxPhrase = new p5.Phrase('box', playBox, boxPat);
 *    let drumPhrase = new p5.Phrase('drum', playDrum, drumPat);
 *    myPart = new p5.Part();
 *    myPart.addPhrase(boxPhrase);
 *    myPart.addPhrase(drumPhrase);
 *    myPart.setBPM(60);
 *  }
 *
 *  function playBox(time, playbackRate) {
 *    box.rate(playbackRate);
 *    box.play(time);
 *  }
 *
 *  function playDrum(time, playbackRate) {
 *    drum.rate(playbackRate);
 *    drum.play(time);
 *  }
 *
 *  function playMyPart() {
 *    userStartAudio();
 *
 *    myPart.start();
 *  }
 *  </code></div>
 */ var looper_Part = function() {
            function Part(steps, bLength) {
                looper_classCallCheck(this, Part);
                this.length = steps || 0;
                this.partStep = 0;
                this.phrases = [];
                this.isPlaying = false;
                this.noLoop();
                this.tatums = bLength || 0.0625;
                this.metro = new metro();
                this.metro._init();
                this.metro.beatLength(this.tatums);
                this.metro.setBPM(BPM);
                main.parts.push(this);
                this.callback = function() {};
            }
            /**
   *  Set the tempo of this part, in Beats Per Minute.
   *
   *  @method  setBPM
   *  @for p5.Part
   *  @param {Number} BPM      Beats Per Minute
   *  @param {Number} [rampTime] Seconds from now
   */ looper_createClass(Part, [
                {
                    key: "setBPM",
                    value: function setBPM(tempo, rampTime) {
                        this.metro.setBPM(tempo, rampTime);
                    }
                },
                {
                    key: "getBPM",
                    value: function getBPM() {
                        return this.metro.getBPM();
                    }
                },
                {
                    key: "start",
                    value: function start(time) {
                        if (!this.isPlaying) {
                            this.isPlaying = true;
                            this.metro.resetSync(this);
                            var t = time || 0;
                            this.metro.start(t);
                        }
                    }
                },
                {
                    key: "loop",
                    value: function loop(time) {
                        this.looping = true;
                        this.onended = function() {
                            this.partStep = 0;
                        };
                        var t = time || 0;
                        this.start(t);
                    }
                },
                {
                    key: "noLoop",
                    value: function noLoop() {
                        this.looping = false;
                        this.onended = function() {
                            this.stop();
                        };
                    }
                },
                {
                    key: "stop",
                    value: function stop(time) {
                        this.partStep = 0;
                        this.pause(time);
                    }
                },
                {
                    key: "pause",
                    value: function pause(time) {
                        this.isPlaying = false;
                        var t = time || 0;
                        this.metro.stop(t);
                    }
                },
                {
                    key: "addPhrase",
                    value: function addPhrase(name1, callback, array) {
                        var p;
                        if (arguments.length === 3) p = new Phrase(name1, callback, array);
                        else if (arguments[0] instanceof Phrase) p = arguments[0];
                        else throw "invalid input. addPhrase accepts name, callback, array or a p5.Phrase";
                        this.phrases.push(p);
                        if (p.sequence.length > this.length) this.length = p.sequence.length;
                    }
                },
                {
                    key: "removePhrase",
                    value: function removePhrase(name1) {
                        for(var i in this.phrases)if (this.phrases[i].name === name1) this.phrases.splice(i, 1);
                    }
                },
                {
                    key: "getPhrase",
                    value: function getPhrase(name1) {
                        for(var i in this.phrases){
                            if (this.phrases[i].name === name1) return this.phrases[i];
                        }
                    }
                },
                {
                    key: "replaceSequence",
                    value: function replaceSequence(name1, array) {
                        for(var i in this.phrases)if (this.phrases[i].name === name1) this.phrases[i].sequence = array;
                    }
                },
                {
                    key: "incrementStep",
                    value: function incrementStep(time) {
                        if (this.partStep < this.length - 1) {
                            this.callback(time);
                            this.partStep += 1;
                        } else if (!this.looping && this.partStep === this.length - 1) this.onended();
                    }
                },
                {
                    key: "onStep",
                    value: function onStep(callback) {
                        this.callback = callback;
                    }
                }
            ]);
            return Part;
        }();
        /**
 *  A Score consists of a series of Parts. The parts will
 *  be played back in order. For example, you could have an
 *  A part, a B part, and a C part, and play them back in this order
 *  <code>new p5.Score(a, a, b, a, c)</code>
 *
 *  @class p5.Score
 *  @constructor
 *  @param {p5.Part} [...parts] One or multiple parts, to be played in sequence.
 */ var Score = function() {
            function Score() {
                looper_classCallCheck(this, Score);
                this.parts = [];
                this.currentPart = new Array(arguments.length);
                var thisScore = this;
                for(var i in arguments){
                    this.parts[i] = arguments[i];
                    this.parts[i].nextPart = this.parts[i + 1];
                    this.parts[i].onended = function() {
                        thisScore.resetPart(i);
                        playNextPart(thisScore);
                    };
                }
                this.looping = false;
            }
            looper_createClass(Score, [
                {
                    key: "onended",
                    value: function onended() {
                        if (this.looping) this.parts[0].start();
                        else this.parts[this.parts.length - 1].onended = function() {
                            this.stop();
                            this.resetParts();
                        };
                        this.currentPart = 0;
                    }
                },
                {
                    key: "start",
                    value: function start() {
                        this.parts[this.currentPart].start();
                        this.scoreStep = 0;
                    }
                },
                {
                    key: "stop",
                    value: function stop() {
                        this.parts[this.currentPart].stop();
                        this.currentPart = 0;
                        this.scoreStep = 0;
                    }
                },
                {
                    key: "pause",
                    value: function pause() {
                        this.parts[this.currentPart].stop();
                    }
                },
                {
                    key: "loop",
                    value: function loop() {
                        this.looping = true;
                        this.start();
                    }
                },
                {
                    key: "noLoop",
                    value: function noLoop() {
                        this.looping = false;
                    }
                },
                {
                    key: "resetParts",
                    value: function resetParts() {
                        var self1 = this;
                        this.parts.forEach(function(part) {
                            self1.resetParts[part];
                        });
                    }
                },
                {
                    key: "resetPart",
                    value: function resetPart(i) {
                        this.parts[i].stop();
                        this.parts[i].partStep = 0;
                        for(var p in this.parts[i].phrases)if (this.parts[i]) this.parts[i].phrases[p].phraseStep = 0;
                    }
                },
                {
                    key: "setBPM",
                    value: function setBPM(bpm, rampTime) {
                        for(var i in this.parts)if (this.parts[i]) this.parts[i].setBPM(bpm, rampTime);
                    }
                }
            ]);
            return Score;
        }();
        function playNextPart(aScore) {
            aScore.currentPart++;
            if (aScore.currentPart >= aScore.parts.length) {
                aScore.scoreStep = 0;
                aScore.onended();
            } else {
                aScore.scoreStep = 0;
                aScore.parts[aScore.currentPart - 1].stop();
                aScore.parts[aScore.currentPart].start();
            }
        }
        function soundLoop_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function soundLoop_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function soundLoop_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) soundLoop_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) soundLoop_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        /**
 * SoundLoop
 *
 * @class p5.SoundLoop
 * @constructor
 *
 * @param {Function} callback this function will be called on each iteration of theloop
 * @param {Number|String} [interval] amount of time (if a number) or beats (if a string, following <a href = "https://github.com/Tonejs/Tone.js/wiki/Time">Tone.Time</a> convention) for each iteration of the loop. Defaults to 1 second.
 *
 * @example
 * <div><code>
 *  let synth, soundLoop;
 *  let notePattern = [60, 62, 64, 67, 69, 72];
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(canvasPressed);
 *    colorMode(HSB);
 *    background(0, 0, 86);
 *    text('tap to start/stop', 10, 20);
 *
 *    //the looper's callback is passed the timeFromNow
 *    //this value should be used as a reference point from
 *    //which to schedule sounds
 *    let intervalInSeconds = 0.2;
 *    soundLoop = new p5.SoundLoop(onSoundLoop, intervalInSeconds);
 *
 *    synth = new p5.MonoSynth();
 * }
 *
 * function canvasPressed() {
 *   // ensure audio is enabled
 *   userStartAudio();
 *
 *   if (soundLoop.isPlaying) {
 *     soundLoop.stop();
 *   } else {
 *     // start the loop
 *     soundLoop.start();
 *   }
 * }
 *
 * function onSoundLoop(timeFromNow) {
 *   let noteIndex = (soundLoop.iterations - 1) % notePattern.length;
 *   let note = midiToFreq(notePattern[noteIndex]);
 *   synth.play(note, 0.5, timeFromNow);
 *   background(noteIndex * 360 / notePattern.length, 50, 100);
 * }
 * </code></div>
 */ var soundLoop_SoundLoop = function() {
            function SoundLoop(callback, interval) {
                soundLoop_classCallCheck(this, SoundLoop);
                /**
     * Getters and Setters, setting any paramter will result in a change in the clock's
     * frequency, that will be reflected after the next callback
     * beats per minute (defaults to 60)
     * @property {Number} bpm
     * @for p5.SoundLoop
     */ Object.defineProperty(this, "bpm", {
                    get: function get() {
                        return this._bpm;
                    },
                    set: function set(bpm) {
                        if (!this.musicalTimeMode) console.warn('Changing the BPM in "seconds" mode has no effect. BPM is only relevant in musicalTimeMode when the interval is specified as a string ("2n", "4n", "1m"...etc)');
                        this._bpm = bpm;
                        this._update();
                    }
                });
                /**
     * number of quarter notes in a measure (defaults to 4)
     * @property {Number} timeSignature
     * @for p5.SoundLoop
     */ Object.defineProperty(this, "timeSignature", {
                    get: function get() {
                        return this._timeSignature;
                    },
                    set: function set(timeSig) {
                        if (!this.musicalTimeMode) console.warn('Changing the timeSignature in "seconds" mode has no effect. BPM is only relevant in musicalTimeMode when the interval is specified as a string ("2n", "4n", "1m"...etc)');
                        this._timeSignature = timeSig;
                        this._update();
                    }
                });
                /**
     * length of the loops interval
     * @property {Number|String} interval
     * @for p5.SoundLoop
     */ Object.defineProperty(this, "interval", {
                    get: function get() {
                        return this._interval;
                    },
                    set: function set(interval) {
                        this.musicalTimeMode = typeof interval === "number" ? false : true;
                        this._interval = interval;
                        this._update();
                    }
                });
                /**
     * how many times the callback has been called so far
     * @property {Number} iterations
     * @for p5.SoundLoop
     * @readonly
     */ Object.defineProperty(this, "iterations", {
                    get: function get() {
                        return this.clock.ticks;
                    }
                });
                this.callback = callback;
                /**
     * musicalTimeMode uses <a href = "https://github.com/Tonejs/Tone.js/wiki/Time">Tone.Time</a> convention
     * true if string, false if number
     * @property {Boolean} musicalTimeMode
     */ this.musicalTimeMode = typeof this._interval === "number" ? false : true;
                this._interval = interval || 1;
                /**
     * musicalTimeMode variables
     * modify these only when the interval is specified in musicalTime format as a string
     */ this._timeSignature = 4;
                this._bpm = 60;
                this.isPlaying = false;
                /**
     * Set a limit to the number of loops to play. defaults to Infinity
     * @property {Number} maxIterations
     */ this.maxIterations = Infinity;
                var self1 = this;
                this.clock = new Clock_default.a({
                    callback: function callback(time) {
                        var timeFromNow = time - main.audiocontext.currentTime;
                        /**
         * Do not initiate the callback if timeFromNow is < 0
         * This ususually occurs for a few milliseconds when the page
         * is not fully loaded
         *
         * The callback should only be called until maxIterations is reached
         */ if (timeFromNow > 0 && self1.iterations <= self1.maxIterations) self1.callback(timeFromNow);
                    },
                    frequency: this._calcFreq()
                });
            }
            /**
   * Start the loop
   * @method  start
   * @for p5.SoundLoop
   * @param  {Number} [timeFromNow] schedule a starting time
   */ soundLoop_createClass(SoundLoop, [
                {
                    key: "start",
                    value: function start(timeFromNow) {
                        var t = timeFromNow || 0;
                        var now = main.audiocontext.currentTime;
                        if (!this.isPlaying) {
                            this.clock.start(now + t);
                            this.isPlaying = true;
                        }
                    }
                },
                {
                    key: "stop",
                    value: function stop(timeFromNow) {
                        var t = timeFromNow || 0;
                        var now = main.audiocontext.currentTime;
                        if (this.isPlaying) {
                            this.clock.stop(now + t);
                            this.isPlaying = false;
                        }
                    }
                },
                {
                    key: "pause",
                    value: function pause(timeFromNow) {
                        var t = timeFromNow || 0;
                        var now = main.audiocontext.currentTime;
                        if (this.isPlaying) {
                            this.clock.pause(now + t);
                            this.isPlaying = false;
                        }
                    }
                },
                {
                    key: "syncedStart",
                    value: function syncedStart(otherLoop, timeFromNow) {
                        var t = timeFromNow || 0;
                        var now = main.audiocontext.currentTime;
                        if (!otherLoop.isPlaying) {
                            otherLoop.clock.start(now + t);
                            otherLoop.isPlaying = true;
                            this.clock.start(now + t);
                            this.isPlaying = true;
                        } else if (otherLoop.isPlaying) {
                            var time = otherLoop.clock._nextTick - main.audiocontext.currentTime;
                            this.clock.start(now + time);
                            this.isPlaying = true;
                        }
                    }
                },
                {
                    key: "_update",
                    value: function _update() {
                        this.clock.frequency.value = this._calcFreq();
                    }
                },
                {
                    key: "_calcFreq",
                    value: function _calcFreq() {
                        if (typeof this._interval === "number") {
                            this.musicalTimeMode = false;
                            return 1 / this._interval;
                        } else if (typeof this._interval === "string") {
                            this.musicalTimeMode = true;
                            return this._bpm / 60 / this._convertNotation(this._interval) * (this._timeSignature / 4);
                        }
                    }
                },
                {
                    key: "_convertNotation",
                    value: function _convertNotation(value) {
                        var type = value.slice(-1);
                        value = Number(value.slice(0, -1));
                        switch(type){
                            case "m":
                                return this._measure(value);
                            case "n":
                                return this._note(value);
                            default:
                                console.warn("Specified interval is not formatted correctly. See Tone.js timing reference for more info: https://github.com/Tonejs/Tone.js/wiki/Time");
                        }
                    }
                },
                {
                    key: "_measure",
                    value: function _measure(value) {
                        return value * this._timeSignature;
                    }
                },
                {
                    key: "_note",
                    value: function _note(value) {
                        return this._timeSignature / value;
                    }
                }
            ]);
            return SoundLoop;
        }();
        var soundLoop = soundLoop_SoundLoop;
        function compressor_typeof(obj) {
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") compressor_typeof = function _typeof(obj) {
                return typeof obj;
            };
            else compressor_typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            return compressor_typeof(obj);
        }
        function compressor_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function compressor_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function compressor_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) compressor_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) compressor_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        function compressor_possibleConstructorReturn(self1, call) {
            if (call && (compressor_typeof(call) === "object" || typeof call === "function")) return call;
            return compressor_assertThisInitialized(self1);
        }
        function compressor_assertThisInitialized(self1) {
            if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return self1;
        }
        function compressor_get(target, property, receiver) {
            if (typeof Reflect !== "undefined" && Reflect.get) compressor_get = Reflect.get;
            else compressor_get = function _get(target, property, receiver) {
                var base = compressor_superPropBase(target, property);
                if (!base) return;
                var desc = Object.getOwnPropertyDescriptor(base, property);
                if (desc.get) return desc.get.call(receiver);
                return desc.value;
            };
            return compressor_get(target, property, receiver || target);
        }
        function compressor_superPropBase(object, property) {
            while(!Object.prototype.hasOwnProperty.call(object, property)){
                object = compressor_getPrototypeOf(object);
                if (object === null) break;
            }
            return object;
        }
        function compressor_getPrototypeOf(o) {
            compressor_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
            };
            return compressor_getPrototypeOf(o);
        }
        function compressor_inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    writable: true,
                    configurable: true
                }
            });
            if (superClass) compressor_setPrototypeOf(subClass, superClass);
        }
        function compressor_setPrototypeOf(o, p) {
            compressor_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };
            return compressor_setPrototypeOf(o, p);
        }
        /**
 * Compressor is an audio effect class that performs dynamics compression
 * on an audio input source. This is a very commonly used technique in music
 * and sound production. Compression creates an overall louder, richer,
 * and fuller sound by lowering the volume of louds and raising that of softs.
 * Compression can be used to avoid clipping (sound distortion due to
 * peaks in volume) and is especially useful when many sounds are played
 * at once. Compression can be used on indivudal sound sources in addition
 * to the main output.
 *
 * This class extends <a href = "/reference/#/p5.Effect">p5.Effect</a>.
 * Methods <a href = "/reference/#/p5.Effect/amp">amp()</a>, <a href = "/reference/#/p5.Effect/chain">chain()</a>,
 * <a href = "/reference/#/p5.Effect/drywet">drywet()</a>, <a href = "/reference/#/p5.Effect/connect">connect()</a>, and
 * <a href = "/reference/#/p5.Effect/disconnect">disconnect()</a> are available.
 *
 * @class p5.Compressor
 * @constructor
 * @extends p5.Effect
 *
 *
 */ var Compressor = function(_Effect) {
            compressor_inherits(Compressor, _Effect);
            function Compressor() {
                var _this;
                compressor_classCallCheck(this, Compressor);
                _this = compressor_possibleConstructorReturn(this, compressor_getPrototypeOf(Compressor).call(this));
                /**
     *
     * The p5.Compressor is built with a <a href="https://www.w3.org/TR/webaudio/#the-dynamicscompressornode-interface"
     *   target="_blank" title="W3 spec for Dynamics Compressor Node">Web Audio Dynamics Compressor Node
     *   </a>
     * @property {AudioNode} compressor
     */ _this.compressor = _this.ac.createDynamicsCompressor();
                _this.input.connect(_this.compressor);
                _this.compressor.connect(_this.wet);
                return _this;
            }
            /**
   * Performs the same function as .connect, but also accepts
   * optional parameters to set compressor's audioParams
   * @method process
   * @for p5.Compressor
   *
   * @param {Object} src         Sound source to be connected
   *
   * @param {Number} [attack]     The amount of time (in seconds) to reduce the gain by 10dB,
   *                            default = .003, range 0 - 1
   * @param {Number} [knee]       A decibel value representing the range above the
   *                            threshold where the curve smoothly transitions to the "ratio" portion.
   *                            default = 30, range 0 - 40
   * @param {Number} [ratio]      The amount of dB change in input for a 1 dB change in output
   *                            default = 12, range 1 - 20
   * @param {Number} [threshold]  The decibel value above which the compression will start taking effect
   *                            default = -24, range -100 - 0
   * @param {Number} [release]    The amount of time (in seconds) to increase the gain by 10dB
   *                            default = .25, range 0 - 1
   */ compressor_createClass(Compressor, [
                {
                    key: "process",
                    value: function process(src, attack, knee, ratio, threshold, release) {
                        src.connect(this.input);
                        this.set(attack, knee, ratio, threshold, release);
                    }
                },
                {
                    key: "set",
                    value: function set(attack, knee, ratio, threshold, release) {
                        if (typeof attack !== "undefined") this.attack(attack);
                        if (typeof knee !== "undefined") this.knee(knee);
                        if (typeof ratio !== "undefined") this.ratio(ratio);
                        if (typeof threshold !== "undefined") this.threshold(threshold);
                        if (typeof release !== "undefined") this.release(release);
                    }
                },
                {
                    key: "attack",
                    value: function attack(_attack, time) {
                        var t = time || 0;
                        if (typeof _attack === "number") {
                            this.compressor.attack.value = _attack;
                            this.compressor.attack.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.compressor.attack.linearRampToValueAtTime(_attack, this.ac.currentTime + 0.02 + t);
                        } else if (typeof _attack !== "undefined") _attack.connect(this.compressor.attack);
                        return this.compressor.attack.value;
                    }
                },
                {
                    key: "knee",
                    value: function knee(_knee, time) {
                        var t = time || 0;
                        if (typeof _knee === "number") {
                            this.compressor.knee.value = _knee;
                            this.compressor.knee.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.compressor.knee.linearRampToValueAtTime(_knee, this.ac.currentTime + 0.02 + t);
                        } else if (typeof _knee !== "undefined") _knee.connect(this.compressor.knee);
                        return this.compressor.knee.value;
                    }
                },
                {
                    key: "ratio",
                    value: function ratio(_ratio, time) {
                        var t = time || 0;
                        if (typeof _ratio === "number") {
                            this.compressor.ratio.value = _ratio;
                            this.compressor.ratio.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.compressor.ratio.linearRampToValueAtTime(_ratio, this.ac.currentTime + 0.02 + t);
                        } else if (typeof _ratio !== "undefined") _ratio.connect(this.compressor.ratio);
                        return this.compressor.ratio.value;
                    }
                },
                {
                    key: "threshold",
                    value: function threshold(_threshold, time) {
                        var t = time || 0;
                        if (typeof _threshold === "number") {
                            this.compressor.threshold.value = _threshold;
                            this.compressor.threshold.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.compressor.threshold.linearRampToValueAtTime(_threshold, this.ac.currentTime + 0.02 + t);
                        } else if (typeof _threshold !== "undefined") _threshold.connect(this.compressor.threshold);
                        return this.compressor.threshold.value;
                    }
                },
                {
                    key: "release",
                    value: function release(_release, time) {
                        var t = time || 0;
                        if (typeof _release === "number") {
                            this.compressor.release.value = _release;
                            this.compressor.release.cancelScheduledValues(this.ac.currentTime + 0.01 + t);
                            this.compressor.release.linearRampToValueAtTime(_release, this.ac.currentTime + 0.02 + t);
                        } else if (typeof number !== "undefined") _release.connect(this.compressor.release);
                        return this.compressor.release.value;
                    }
                },
                {
                    key: "reduction",
                    value: function reduction() {
                        return this.compressor.reduction.value;
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        compressor_get(compressor_getPrototypeOf(Compressor.prototype), "dispose", this).call(this);
                        if (this.compressor) {
                            this.compressor.disconnect();
                            delete this.compressor;
                        }
                    }
                }
            ]);
            return Compressor;
        }(effect);
        var compressor = Compressor;
        function peakDetect_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function peakDetect_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function peakDetect_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) peakDetect_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) peakDetect_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        /**
 *  <p>PeakDetect works in conjunction with p5.FFT to
 *  look for onsets in some or all of the frequency spectrum.
 *  </p>
 *  <p>
 *  To use p5.PeakDetect, call <code>update</code> in the draw loop
 *  and pass in a p5.FFT object.
 *  </p>
 *  <p>
 *  You can listen for a specific part of the frequency spectrum by
 *  setting the range between <code>freq1</code> and <code>freq2</code>.
 *  </p>
 *
 *  <p><code>threshold</code> is the threshold for detecting a peak,
 *  scaled between 0 and 1. It is logarithmic, so 0.1 is half as loud
 *  as 1.0.</p>
 *
 *  <p>
 *  The update method is meant to be run in the draw loop, and
 *  <b>frames</b> determines how many loops must pass before
 *  another peak can be detected.
 *  For example, if the frameRate() = 60, you could detect the beat of a
 *  120 beat-per-minute song with this equation:
 *  <code> framesPerPeak = 60 / (estimatedBPM / 60 );</code>
 *  </p>
 *
 *  <p>
 *  Based on example contribtued by @b2renger, and a simple beat detection
 *  explanation by <a
 *  href="http://www.airtightinteractive.com/2013/10/making-audio-reactive-visuals/"
 *  target="_blank">Felix Turner</a>.
 *  </p>
 *
 *  @class  p5.PeakDetect
 *  @constructor
 *  @param {Number} [freq1]     lowFrequency - defaults to 20Hz
 *  @param {Number} [freq2]     highFrequency - defaults to 20000 Hz
 *  @param {Number} [threshold] Threshold for detecting a beat between 0 and 1
 *                            scaled logarithmically where 0.1 is 1/2 the loudness
 *                            of 1.0. Defaults to 0.35.
 *  @param {Number} [framesPerPeak]     Defaults to 20.
 *  @example
 *  <div><code>
 *
 *  var cnv, soundFile, fft, peakDetect;
 *  var ellipseWidth = 10;
 *
 *  function preload() {
 *    soundFile = loadSound('assets/beat.mp3');
 *  }
 *
 *  function setup() {
 *    background(0);
 *    noStroke();
 *    fill(255);
 *    textAlign(CENTER);
 *
 *    // p5.PeakDetect requires a p5.FFT
 *    fft = new p5.FFT();
 *    peakDetect = new p5.PeakDetect();
 *  }
 *
 *  function draw() {
 *    background(0);
 *    text('click to play/pause', width/2, height/2);
 *
 *    // peakDetect accepts an fft post-analysis
 *    fft.analyze();
 *    peakDetect.update(fft);
 *
 *    if ( peakDetect.isDetected ) {
 *      ellipseWidth = 50;
 *    } else {
 *      ellipseWidth *= 0.95;
 *    }
 *
 *    ellipse(width/2, height/2, ellipseWidth, ellipseWidth);
 *  }
 *
 *  // toggle play/stop when canvas is clicked
 *  function mouseClicked() {
 *    if (mouseX > 0 && mouseX < width && mouseY > 0 && mouseY < height) {
 *      if (soundFile.isPlaying() ) {
 *        soundFile.stop();
 *      } else {
 *        soundFile.play();
 *      }
 *    }
 *  }
 *  </code></div>
 */ var PeakDetect = function() {
            function PeakDetect(freq1, freq2, threshold, _framesPerPeak) {
                peakDetect_classCallCheck(this, PeakDetect);
                this.framesPerPeak = _framesPerPeak || 20;
                this.framesSinceLastPeak = 0;
                this.decayRate = 0.95;
                this.threshold = threshold || 0.35;
                this.cutoff = 0;
                this.cutoffMult = 1.5;
                this.energy = 0;
                this.penergy = 0;
                this.currentValue = 0;
                /**
     *  isDetected is set to true when a peak is detected.
     *
     *  @attribute isDetected {Boolean}
     *  @default  false
     */ this.isDetected = false;
                this.f1 = freq1 || 40;
                this.f2 = freq2 || 20000;
                this._onPeak = function() {};
            }
            /**
   *  The update method is run in the draw loop.
   *
   *  Accepts an FFT object. You must call .analyze()
   *  on the FFT object prior to updating the peakDetect
   *  because it relies on a completed FFT analysis.
   *
   *  @method  update
   *  @param  {p5.FFT} fftObject A p5.FFT object
   */ peakDetect_createClass(PeakDetect, [
                {
                    key: "update",
                    value: function update(fftObject) {
                        var nrg = this.energy = fftObject.getEnergy(this.f1, this.f2) / 255;
                        if (nrg > this.cutoff && nrg > this.threshold && nrg - this.penergy > 0) {
                            this._onPeak();
                            this.isDetected = true;
                            this.cutoff = nrg * this.cutoffMult;
                            this.framesSinceLastPeak = 0;
                        } else {
                            this.isDetected = false;
                            if (this.framesSinceLastPeak <= this.framesPerPeak) this.framesSinceLastPeak++;
                            else {
                                this.cutoff *= this.decayRate;
                                this.cutoff = Math.max(this.cutoff, this.threshold);
                            }
                        }
                        this.currentValue = nrg;
                        this.penergy = nrg;
                    }
                },
                {
                    key: "onPeak",
                    value: function onPeak(callback, val) {
                        var self1 = this;
                        self1._onPeak = function() {
                            callback(self1.energy, val);
                        };
                    }
                }
            ]);
            return PeakDetect;
        }();
        var peakDetect = PeakDetect;
        function soundRecorder_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function soundRecorder_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function soundRecorder_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) soundRecorder_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) soundRecorder_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        var soundRecorder_ac = main.audiocontext;
        /**
 *  <p>Record sounds for playback and/or to save as a .wav file.
 *  The p5.SoundRecorder records all sound output from your sketch,
 *  or can be assigned a specific source with setInput().</p>
 *  <p>The record() method accepts a p5.SoundFile as a parameter.
 *  When playback is stopped (either after the given amount of time,
 *  or with the stop() method), the p5.SoundRecorder will send its
 *  recording to that p5.SoundFile for playback.</p>
 *
 *  @class p5.SoundRecorder
 *  @constructor
 *  @example
 *  <div><code>
 *  let mic, recorder, soundFile;
 *  let state = 0;
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(canvasPressed);
 *    background(220);
 *    textAlign(CENTER, CENTER);
 *
 *    // create an audio in
 *    mic = new p5.AudioIn();
 *
 *    // prompts user to enable their browser mic
 *    mic.start();
 *
 *    // create a sound recorder
 *    recorder = new p5.SoundRecorder();
 *
 *    // connect the mic to the recorder
 *    recorder.setInput(mic);
 *
 *    // this sound file will be used to
 *    // playback & save the recording
 *    soundFile = new p5.SoundFile();
 *
 *    text('tap to record', width/2, height/2);
 *  }
 *
 *  function canvasPressed() {
 *    // ensure audio is enabled
 *    userStartAudio();
 *
 *    // make sure user enabled the mic
 *    if (state === 0 && mic.enabled) {
 *
 *      // record to our p5.SoundFile
 *      recorder.record(soundFile);
 *
 *      background(255,0,0);
 *      text('Recording!', width/2, height/2);
 *      state++;
 *    }
 *    else if (state === 1) {
 *      background(0,255,0);
 *
 *      // stop recorder and
 *      // send result to soundFile
 *      recorder.stop();
 *
 *      text('Done! Tap to play and download', width/2, height/2, width - 20);
 *      state++;
 *    }
 *
 *    else if (state === 2) {
 *      soundFile.play(); // play the result!
 *      save(soundFile, 'mySound.wav');
 *      state++;
 *    }
 *  }
 *  </div></code>
 */ var soundRecorder_SoundRecorder = function() {
            function SoundRecorder() {
                soundRecorder_classCallCheck(this, SoundRecorder);
                this.input = soundRecorder_ac.createGain();
                this.output = soundRecorder_ac.createGain();
                this._inputChannels = 2;
                this._outputChannels = 2;
                var workletBufferSize = safeBufferSize(1024);
                this._workletNode = new AudioWorkletNode(soundRecorder_ac, processorNames_default.a.recorderProcessor, {
                    outputChannelCount: [
                        this._outputChannels
                    ],
                    processorOptions: {
                        numInputChannels: this._inputChannels,
                        bufferSize: workletBufferSize
                    }
                });
                this._workletNode.port.onmessage = (function(event) {
                    if (event.data.name === "buffers") {
                        var buffers = [
                            new Float32Array(event.data.leftBuffer),
                            new Float32Array(event.data.rightBuffer)
                        ];
                        this._callback(buffers);
                    }
                }).bind(this);
                /**
     *  callback invoked when the recording is over
     *  @private
     *  @type Function(Float32Array)
     */ this._callback = function() {};
                this._workletNode.connect((0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).soundOut._silentNode);
                this.setInput();
                main.soundArray.push(this);
            }
            /**
   *  Connect a specific device to the p5.SoundRecorder.
   *  If no parameter is given, p5.SoundRecorer will record
   *  all audible p5.sound from your sketch.
   *
   *  @method  setInput
   *  @for p5.SoundRecorder
   *  @param {Object} [unit] p5.sound object or a web audio unit
   *                         that outputs sound
   */ soundRecorder_createClass(SoundRecorder, [
                {
                    key: "setInput",
                    value: function setInput(unit) {
                        this.input.disconnect();
                        this.input = null;
                        this.input = soundRecorder_ac.createGain();
                        this.input.connect(this._workletNode);
                        this.input.connect(this.output);
                        if (unit) unit.connect(this.input);
                        else (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).soundOut.output.connect(this.input);
                    }
                },
                {
                    key: "record",
                    value: function record(sFile, duration, callback) {
                        this._workletNode.port.postMessage({
                            name: "start",
                            duration: duration
                        });
                        if (sFile && callback) this._callback = function(buffer) {
                            sFile.setBuffer(buffer);
                            callback();
                        };
                        else if (sFile) this._callback = function(buffer) {
                            sFile.setBuffer(buffer);
                        };
                    }
                },
                {
                    key: "stop",
                    value: function stop() {
                        this._workletNode.port.postMessage({
                            name: "stop"
                        });
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        var index = main.soundArray.indexOf(this);
                        main.soundArray.splice(index, 1);
                        this._callback = function() {};
                        if (this.input) this.input.disconnect();
                        this.input = null;
                        this._workletNode = null;
                    }
                }
            ]);
            return SoundRecorder;
        }();
        var soundRecorder = soundRecorder_SoundRecorder;
        function distortion_typeof(obj) {
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") distortion_typeof = function _typeof(obj) {
                return typeof obj;
            };
            else distortion_typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            return distortion_typeof(obj);
        }
        function distortion_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function distortion_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function distortion_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) distortion_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) distortion_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        function distortion_possibleConstructorReturn(self1, call) {
            if (call && (distortion_typeof(call) === "object" || typeof call === "function")) return call;
            return distortion_assertThisInitialized(self1);
        }
        function distortion_assertThisInitialized(self1) {
            if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return self1;
        }
        function distortion_get(target, property, receiver) {
            if (typeof Reflect !== "undefined" && Reflect.get) distortion_get = Reflect.get;
            else distortion_get = function _get(target, property, receiver) {
                var base = distortion_superPropBase(target, property);
                if (!base) return;
                var desc = Object.getOwnPropertyDescriptor(base, property);
                if (desc.get) return desc.get.call(receiver);
                return desc.value;
            };
            return distortion_get(target, property, receiver || target);
        }
        function distortion_superPropBase(object, property) {
            while(!Object.prototype.hasOwnProperty.call(object, property)){
                object = distortion_getPrototypeOf(object);
                if (object === null) break;
            }
            return object;
        }
        function distortion_getPrototypeOf(o) {
            distortion_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
            };
            return distortion_getPrototypeOf(o);
        }
        function distortion_inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    writable: true,
                    configurable: true
                }
            });
            if (superClass) distortion_setPrototypeOf(subClass, superClass);
        }
        function distortion_setPrototypeOf(o, p) {
            distortion_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };
            return distortion_setPrototypeOf(o, p);
        }
        function makeDistortionCurve(amount) {
            var k = typeof amount === "number" ? amount : 50;
            var numSamples = 44100;
            var curve = new Float32Array(numSamples);
            var deg = Math.PI / 180;
            var i = 0;
            var x;
            for(; i < numSamples; ++i){
                x = i * 2 / numSamples - 1;
                curve[i] = (3 + k) * x * 20 * deg / (Math.PI + k * Math.abs(x));
            }
            return curve;
        }
        /**
 * A Distortion effect created with a Waveshaper Node,
 * with an approach adapted from
 * [Kevin Ennis](http://stackoverflow.com/questions/22312841/waveshaper-node-in-webaudio-how-to-emulate-distortion)
 *
 * This class extends <a href = "/reference/#/p5.Effect">p5.Effect</a>.
 * Methods <a href = "/reference/#/p5.Effect/amp">amp()</a>, <a href = "/reference/#/p5.Effect/chain">chain()</a>,
 * <a href = "/reference/#/p5.Effect/drywet">drywet()</a>, <a href = "/reference/#/p5.Effect/connect">connect()</a>, and
 * <a href = "/reference/#/p5.Effect/disconnect">disconnect()</a> are available.
 *
 * @class p5.Distortion
 * @extends p5.Effect
 * @constructor
 * @param {Number} [amount=0.25] Unbounded distortion amount.
 *                                Normal values range from 0-1.
 * @param {String} [oversample='none'] 'none', '2x', or '4x'.
 *
 */ var Distortion = function(_Effect) {
            distortion_inherits(Distortion, _Effect);
            function Distortion(amount, oversample) {
                var _this;
                distortion_classCallCheck(this, Distortion);
                _this = distortion_possibleConstructorReturn(this, distortion_getPrototypeOf(Distortion).call(this));
                if (typeof amount === "undefined") amount = 0.25;
                if (typeof amount !== "number") throw new Error("amount must be a number");
                if (typeof oversample === "undefined") oversample = "2x";
                if (typeof oversample !== "string") throw new Error("oversample must be a String");
                var curveAmount = (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.map(amount, 0.0, 1.0, 0, 2000);
                /**
     *  The p5.Distortion is built with a
     *  <a href="http://www.w3.org/TR/webaudio/#WaveShaperNode">
     *  Web Audio WaveShaper Node</a>.
     *
     *  @property {AudioNode} WaveShaperNode
     */ _this.waveShaperNode = _this.ac.createWaveShaper();
                _this.amount = curveAmount;
                _this.waveShaperNode.curve = makeDistortionCurve(curveAmount);
                _this.waveShaperNode.oversample = oversample;
                _this.input.connect(_this.waveShaperNode);
                _this.waveShaperNode.connect(_this.wet);
                return _this;
            }
            /**
   * Process a sound source, optionally specify amount and oversample values.
   *
   * @method process
   * @for p5.Distortion
   * @param {Number} [amount=0.25] Unbounded distortion amount.
   *                                Normal values range from 0-1.
   * @param {String} [oversample='none'] 'none', '2x', or '4x'.
   */ distortion_createClass(Distortion, [
                {
                    key: "process",
                    value: function process(src, amount, oversample) {
                        src.connect(this.input);
                        this.set(amount, oversample);
                    }
                },
                {
                    key: "set",
                    value: function set(amount, oversample) {
                        if (amount) {
                            var curveAmount = (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.map(amount, 0.0, 1.0, 0, 2000);
                            this.amount = curveAmount;
                            this.waveShaperNode.curve = makeDistortionCurve(curveAmount);
                        }
                        if (oversample) this.waveShaperNode.oversample = oversample;
                    }
                },
                {
                    key: "getAmount",
                    value: function getAmount() {
                        return this.amount;
                    }
                },
                {
                    key: "getOversample",
                    value: function getOversample() {
                        return this.waveShaperNode.oversample;
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        distortion_get(distortion_getPrototypeOf(Distortion.prototype), "dispose", this).call(this);
                        if (this.waveShaperNode) {
                            this.waveShaperNode.disconnect();
                            this.waveShaperNode = null;
                        }
                    }
                }
            ]);
            return Distortion;
        }(effect);
        var distortion = Distortion;
        function gain_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function gain_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function gain_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) gain_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) gain_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        /**
 *  A gain node is usefull to set the relative volume of sound.
 *  It's typically used to build mixers.
 *
 *  @class p5.Gain
 *  @constructor
 *  @example
 *  <div><code>
 *
 *  // load two soundfile and crossfade beetween them
 *  let sound1,sound2;
 *  let sound1Gain, sound2Gain, mixGain;
 *  function preload(){
 *    soundFormats('ogg', 'mp3');
 *    sound1 = loadSound('assets/Damscray_-_Dancing_Tiger_01');
 *    sound2 = loadSound('assets/beat');
 *  }
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(startSound);
 *    // create a 'mix' gain bus to which we will connect both soundfiles
 *    mixGain = new p5.Gain();
 *    mixGain.connect();
 *    sound1.disconnect(); // diconnect from p5 output
 *    sound1Gain = new p5.Gain(); // setup a gain node
 *    sound1Gain.setInput(sound1); // connect the first sound to its input
 *    sound1Gain.connect(mixGain); // connect its output to the final mix bus
 *    sound2.disconnect();
 *    sound2Gain = new p5.Gain();
 *    sound2Gain.setInput(sound2);
 *    sound2Gain.connect(mixGain);
 *  }
 *  function startSound() {
 *    sound1.loop();
 *    sound2.loop();
 *    loop();
 *  }
 *  function mouseReleased() {
 *    sound1.stop();
 *    sound2.stop();
 *  }
 *  function draw(){
 *    background(220);
 *    textAlign(CENTER);
 *    textSize(11);
 *    fill(0);
 *    if (!sound1.isPlaying()) {
 *      text('tap and drag to play', width/2, height/2);
 *      return;
 *    }
 *    // map the horizontal position of the mouse to values useable for volume    *  control of sound1
 *    var sound1Volume = constrain(map(mouseX,width,0,0,1), 0, 1);
 *    var sound2Volume = 1-sound1Volume;
 *    sound1Gain.amp(sound1Volume);
 *    sound2Gain.amp(sound2Volume);
 *    // map the vertical position of the mouse to values useable for 'output    *  volume control'
 *    var outputVolume = constrain(map(mouseY,height,0,0,1), 0, 1);
 *    mixGain.amp(outputVolume);
 *    text('output', width/2, height - outputVolume * height * 0.9)
 *    fill(255, 0, 255);
 *    textAlign(LEFT);
 *    text('sound1', 5, height - sound1Volume * height * 0.9);
 *    textAlign(RIGHT);
 *    text('sound2', width - 5, height - sound2Volume * height * 0.9);
 *  }
 *</code></div>
 */ var gain_Gain = function() {
            function Gain() {
                gain_classCallCheck(this, Gain);
                this.ac = main.audiocontext;
                this.input = this.ac.createGain();
                this.output = this.ac.createGain();
                this.input.gain.value = 0.5;
                this.input.connect(this.output);
                main.soundArray.push(this);
            }
            /**
   *  Connect a source to the gain node.
   *
   *  @method  setInput
   *  @for p5.Gain
   *  @param  {Object} src     p5.sound / Web Audio object with a sound
   *                           output.
   */ gain_createClass(Gain, [
                {
                    key: "setInput",
                    value: function setInput(src) {
                        src.connect(this.input);
                    }
                },
                {
                    key: "connect",
                    value: function connect(unit) {
                        var u = unit || (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).soundOut.input;
                        this.output.connect(u.input ? u.input : u);
                    }
                },
                {
                    key: "disconnect",
                    value: function disconnect() {
                        if (this.output) this.output.disconnect();
                    }
                },
                {
                    key: "amp",
                    value: function amp(vol) {
                        var rampTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                        var tFromNow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                        var now = main.audiocontext.currentTime;
                        var currentVol = this.output.gain.value;
                        this.output.gain.cancelScheduledValues(now);
                        this.output.gain.linearRampToValueAtTime(currentVol, now + tFromNow);
                        this.output.gain.linearRampToValueAtTime(vol, now + tFromNow + rampTime);
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        var index = main.soundArray.indexOf(this);
                        main.soundArray.splice(index, 1);
                        if (this.output) {
                            this.output.disconnect();
                            delete this.output;
                        }
                        if (this.input) {
                            this.input.disconnect();
                            delete this.input;
                        }
                    }
                }
            ]);
            return Gain;
        }();
        var gain = gain_Gain;
        function audioVoice_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function audioVoice_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function audioVoice_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) audioVoice_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) audioVoice_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        /**
 * Base class for monophonic synthesizers. Any extensions of this class
 * should follow the API and implement the methods below in order to
 * remain compatible with p5.PolySynth();
 *
 * @class p5.AudioVoice
 * @constructor
 */ var audioVoice_AudioVoice = function() {
            function AudioVoice() {
                audioVoice_classCallCheck(this, AudioVoice);
                this.ac = main.audiocontext;
                this.output = this.ac.createGain();
                this.connect();
                main.soundArray.push(this);
            }
            audioVoice_createClass(AudioVoice, [
                {
                    key: "play",
                    value: function play(note, velocity, secondsFromNow, sustime) {}
                },
                {
                    key: "triggerAttack",
                    value: function triggerAttack(note, velocity, secondsFromNow) {}
                },
                {
                    key: "triggerRelease",
                    value: function triggerRelease(secondsFromNow) {}
                },
                {
                    key: "amp",
                    value: function amp(vol, rampTime) {}
                },
                {
                    key: "connect",
                    value: function connect(unit) {
                        var u = unit || main.input;
                        this.output.connect(u.input ? u.input : u);
                    }
                },
                {
                    key: "disconnect",
                    value: function disconnect() {
                        this.output.disconnect();
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        if (this.output) {
                            this.output.disconnect();
                            delete this.output;
                        }
                    }
                }
            ]);
            return AudioVoice;
        }();
        var audioVoice_0 = audioVoice_AudioVoice;
        function monosynth_typeof(obj) {
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") monosynth_typeof = function _typeof(obj) {
                return typeof obj;
            };
            else monosynth_typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            return monosynth_typeof(obj);
        }
        function monosynth_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function monosynth_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function monosynth_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) monosynth_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) monosynth_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        function monosynth_possibleConstructorReturn(self1, call) {
            if (call && (monosynth_typeof(call) === "object" || typeof call === "function")) return call;
            return monosynth_assertThisInitialized(self1);
        }
        function monosynth_assertThisInitialized(self1) {
            if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return self1;
        }
        function monosynth_get(target, property, receiver) {
            if (typeof Reflect !== "undefined" && Reflect.get) monosynth_get = Reflect.get;
            else monosynth_get = function _get(target, property, receiver) {
                var base = monosynth_superPropBase(target, property);
                if (!base) return;
                var desc = Object.getOwnPropertyDescriptor(base, property);
                if (desc.get) return desc.get.call(receiver);
                return desc.value;
            };
            return monosynth_get(target, property, receiver || target);
        }
        function monosynth_superPropBase(object, property) {
            while(!Object.prototype.hasOwnProperty.call(object, property)){
                object = monosynth_getPrototypeOf(object);
                if (object === null) break;
            }
            return object;
        }
        function monosynth_getPrototypeOf(o) {
            monosynth_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
            };
            return monosynth_getPrototypeOf(o);
        }
        function monosynth_inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    writable: true,
                    configurable: true
                }
            });
            if (superClass) monosynth_setPrototypeOf(subClass, superClass);
        }
        function monosynth_setPrototypeOf(o, p) {
            monosynth_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };
            return monosynth_setPrototypeOf(o, p);
        }
        var DEFAULT_SUSTAIN = 0.15;
        /**
 *  A MonoSynth is used as a single voice for sound synthesis.
 *  This is a class to be used in conjunction with the PolySynth
 *  class. Custom synthetisers should be built inheriting from
 *  this class.
 *
 *  @class p5.MonoSynth
 *  @constructor
 *  @example
 *  <div><code>
 *  let monoSynth;
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(playSynth);
 *    background(220);
 *    textAlign(CENTER);
 *    text('tap to play', width/2, height/2);
 *
 *    monoSynth = new p5.MonoSynth();
 *  }
 *
 *  function playSynth() {
 *    userStartAudio();
 *
 *    let note = random(['Fb4', 'G4']);
 *    // note velocity (volume, from 0 to 1)
 *    let velocity = random();
 *    // time from now (in seconds)
 *    let time = 0;
 *    // note duration (in seconds)
 *    let dur = 1/6;
 *
 *    monoSynth.play(note, velocity, time, dur);
 *  }
 *  </code></div>
 **/ var monosynth_MonoSynth = function(_AudioVoice) {
            monosynth_inherits(MonoSynth, _AudioVoice);
            function MonoSynth() {
                var _this;
                monosynth_classCallCheck(this, MonoSynth);
                _this = monosynth_possibleConstructorReturn(this, monosynth_getPrototypeOf(MonoSynth).call(this));
                _this.oscillator = new oscillator();
                _this.env = new envelope();
                _this.env.setRange(1, 0);
                _this.env.setExp(true);
                _this.setADSR(0.02, 0.25, 0.05, 0.35);
                _this.oscillator.disconnect();
                _this.oscillator.connect(_this.output);
                _this.env.disconnect();
                _this.env.setInput(_this.output.gain);
                _this.oscillator.output.gain.value = 1.0;
                _this.oscillator.start();
                _this.connect();
                main.soundArray.push(monosynth_assertThisInitialized(_this));
                /**
     * Getters and Setters
     * @property {Number} attack
     * @for p5.MonoSynth
     */ /**
     * @property {Number} decay
     * @for p5.MonoSynth
     */ /**
     * @property {Number} sustain
     * @for p5.MonoSynth
     */ /**
     * @property {Number} release
     * @for p5.MonoSynth
     */ Object.defineProperties(monosynth_assertThisInitialized(_this), {
                    attack: {
                        get: function get() {
                            return this.env.aTime;
                        },
                        set: function set(attack) {
                            this.env.setADSR(attack, this.env.dTime, this.env.sPercent, this.env.rTime);
                        }
                    },
                    decay: {
                        get: function get() {
                            return this.env.dTime;
                        },
                        set: function set(decay) {
                            this.env.setADSR(this.env.aTime, decay, this.env.sPercent, this.env.rTime);
                        }
                    },
                    sustain: {
                        get: function get() {
                            return this.env.sPercent;
                        },
                        set: function set(sustain) {
                            this.env.setADSR(this.env.aTime, this.env.dTime, sustain, this.env.rTime);
                        }
                    },
                    release: {
                        get: function get() {
                            return this.env.rTime;
                        },
                        set: function set(release) {
                            this.env.setADSR(this.env.aTime, this.env.dTime, this.env.sPercent, release);
                        }
                    }
                });
                return _this;
            }
            /**
   *  Play tells the MonoSynth to start playing a note. This method schedules
   *  the calling of .triggerAttack and .triggerRelease.
   *
   *  @method play
   *  @for p5.MonoSynth
   *  @param {String | Number} note the note you want to play, specified as a
   *                                 frequency in Hertz (Number) or as a midi
   *                                 value in Note/Octave format ("C4", "Eb3"...etc")
   *                                 See <a href = "https://github.com/Tonejs/Tone.js/wiki/Instruments">
   *                                 Tone</a>. Defaults to 440 hz.
   *  @param  {Number} [velocity] velocity of the note to play (ranging from 0 to 1)
   *  @param  {Number} [secondsFromNow]  time from now (in seconds) at which to play
   *  @param  {Number} [sustainTime] time to sustain before releasing the envelope. Defaults to 0.15 seconds.
   *  @example
   *  <div><code>
   *  let monoSynth;
   *
   *  function setup() {
   *    let cnv = createCanvas(100, 100);
   *    cnv.mousePressed(playSynth);
   *    background(220);
   *    textAlign(CENTER);
   *    text('tap to play', width/2, height/2);
   *
   *    monoSynth = new p5.MonoSynth();
   *  }
   *
   *  function playSynth() {
   *    userStartAudio();
   *
   *    let note = random(['Fb4', 'G4']);
   *    // note velocity (volume, from 0 to 1)
   *    let velocity = random();
   *    // time from now (in seconds)
   *    let time = 0;
   *    // note duration (in seconds)
   *    let dur = 1/6;
   *
   *    monoSynth.play(note, velocity, time, dur);
   *  }
   *  </code></div>
   *
   */ monosynth_createClass(MonoSynth, [
                {
                    key: "play",
                    value: function play(note, velocity, secondsFromNow, susTime) {
                        this.triggerAttack(note, velocity, ~~secondsFromNow);
                        this.triggerRelease(~~secondsFromNow + (susTime || DEFAULT_SUSTAIN));
                    }
                },
                {
                    key: "triggerAttack",
                    value: function triggerAttack(note, velocity) {
                        var secondsFromNow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                        var freq = noteToFreq(note);
                        var vel = velocity || 0.1;
                        this.oscillator.freq(freq, 0, secondsFromNow);
                        this.env.ramp(this.output.gain, secondsFromNow, vel);
                    }
                },
                {
                    key: "triggerRelease",
                    value: function triggerRelease() {
                        var secondsFromNow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                        this.env.ramp(this.output.gain, secondsFromNow, 0);
                    }
                },
                {
                    key: "setADSR",
                    value: function setADSR(attack, decay, sustain, release) {
                        this.env.setADSR(attack, decay, sustain, release);
                    }
                },
                {
                    key: "amp",
                    value: function amp(vol, rampTime) {
                        var t = rampTime || 0;
                        if (typeof vol !== "undefined") this.oscillator.amp(vol, t);
                        return this.oscillator.amp().value;
                    }
                },
                {
                    key: "connect",
                    value: function connect(unit) {
                        var u = unit || main.input;
                        this.output.connect(u.input ? u.input : u);
                    }
                },
                {
                    key: "disconnect",
                    value: function disconnect() {
                        if (this.output) this.output.disconnect();
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        monosynth_get(monosynth_getPrototypeOf(MonoSynth.prototype), "dispose", this).call(this);
                        if (this.env) this.env.dispose();
                        if (this.oscillator) this.oscillator.dispose();
                    }
                }
            ]);
            return MonoSynth;
        }(audioVoice_0);
        var monosynth = monosynth_MonoSynth;
        function onsetDetect_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function onsetDetect_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function onsetDetect_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) onsetDetect_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) onsetDetect_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        /**
 *  Listen for onsets (a sharp increase in volume) within a given
 *  frequency range.
 *
 *  @class p5.OnsetDetect
 *  @constructor
 *  @param {Number} freqLow     Low frequency
 *  @param {Number} freqHigh     High frequency
 *  @param {Number} threshold   Amplitude threshold between 0 (no energy) and 1 (maximum)
 *  @param {Function} callback  Function to call when an onset is detected
 */ var OnsetDetect = function() {
            function OnsetDetect(freqLow, freqHigh, threshold, callback) {
                onsetDetect_classCallCheck(this, OnsetDetect);
                this.isDetected = false;
                this.freqLow = freqLow;
                this.freqHigh = freqHigh;
                this.treshold = threshold;
                this.energy = 0;
                this.penergy = 0;
                this.sensitivity = 500;
                this.callback = callback;
            }
            onsetDetect_createClass(OnsetDetect, [
                {
                    key: "update",
                    value: function update(fftObject, callback) {
                        this.energy = fftObject.getEnergy(this.freqLow, this.freqHigh) / 255;
                        if (this.isDetected === false) {
                            if (this.energy - this.penergy > this.treshold) {
                                this.isDetected = true;
                                if (this.callback) this.callback(this.energy);
                                else if (callback) callback(this.energy);
                                var self1 = this;
                                setTimeout(function() {
                                    self1.isDetected = false;
                                }, this.sensitivity);
                            }
                        }
                        this.penergy = this.energy;
                    }
                }
            ]);
            return OnsetDetect;
        }();
        var onsetDetect = OnsetDetect;
        function polysynth_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function polysynth_defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function polysynth_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) polysynth_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) polysynth_defineProperties(Constructor, staticProps);
            return Constructor;
        }
        /**
 *  An AudioVoice is used as a single voice for sound synthesis.
 *  The PolySynth class holds an array of AudioVoice, and deals
 *  with voices allocations, with setting notes to be played, and
 *  parameters to be set.
 *
 *  @class p5.PolySynth
 *  @constructor
 *
 *  @param {Number} [synthVoice]   A monophonic synth voice inheriting
 *                                 the AudioVoice class. Defaults to p5.MonoSynth
 *  @param {Number} [maxVoices] Number of voices, defaults to 8;
 *  @example
 *  <div><code>
 *  let polySynth;
 *
 *  function setup() {
 *    let cnv = createCanvas(100, 100);
 *    cnv.mousePressed(playSynth);
 *    background(220);
 *    text('click to play', 20, 20);
 *
 *    polySynth = new p5.PolySynth();
 *  }
 *
 *  function playSynth() {
 *    userStartAudio();
 *
 *    // note duration (in seconds)
 *    let dur = 1.5;
 *
 *    // time from now (in seconds)
 *    let time = 0;
 *
 *    // velocity (volume, from 0 to 1)
 *    let vel = 0.1;
 *
 *    // notes can overlap with each other
 *    polySynth.play('G2', vel, 0, dur);
 *    polySynth.play('C3', vel, time += 1/3, dur);
 *    polySynth.play('G3', vel, time += 1/3, dur);
 *  }
 *  </code></div>
 **/ var polysynth_PolySynth = function() {
            function PolySynth(audioVoice, maxVoices) {
                polysynth_classCallCheck(this, PolySynth);
                this.audiovoices = [];
                /**
     * An object that holds information about which notes have been played and
     * which notes are currently being played. New notes are added as keys
     * on the fly. While a note has been attacked, but not released, the value of the
     * key is the audiovoice which is generating that note. When notes are released,
     * the value of the key becomes undefined.
     * @property notes
     */ this.notes = {};
                this._newest = 0;
                this._oldest = 0;
                /**
     * A PolySynth must have at least 1 voice, defaults to 8
     * @property polyvalue
     */ this.maxVoices = maxVoices || 8;
                /**
     * Monosynth that generates the sound for each note that is triggered. The
     * p5.PolySynth defaults to using the p5.MonoSynth as its voice.
     * @property AudioVoice
     */ this.AudioVoice = audioVoice === undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).MonoSynth : audioVoice;
                /**
     * This value must only change as a note is attacked or released. Due to delay
     * and sustain times, Tone.TimelineSignal is required to schedule the change in value.
     * @private
     * @property {Tone.TimelineSignal} _voicesInUse
     */ this._voicesInUse = new TimelineSignal_default.a(0);
                this.output = main.audiocontext.createGain();
                this.connect();
                this._allocateVoices();
                main.soundArray.push(this);
            }
            /**
   * Construct the appropriate number of audiovoices
   * @private
   * @for p5.PolySynth
   * @method  _allocateVoices
   */ polysynth_createClass(PolySynth, [
                {
                    key: "_allocateVoices",
                    value: function _allocateVoices() {
                        for(var i = 0; i < this.maxVoices; i++){
                            this.audiovoices.push(new this.AudioVoice());
                            this.audiovoices[i].disconnect();
                            this.audiovoices[i].connect(this.output);
                        }
                    }
                },
                {
                    key: "play",
                    value: function play(note, velocity, secondsFromNow) {
                        var susTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
                        this.noteAttack(note, velocity, secondsFromNow);
                        this.noteRelease(note, secondsFromNow + susTime);
                    }
                },
                {
                    key: "noteADSR",
                    value: function noteADSR(note, a, d, s, r) {
                        var timeFromNow = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
                        var now = main.audiocontext.currentTime;
                        var t = now + timeFromNow;
                        this.audiovoices[this.notes[note].getValueAtTime(t)].setADSR(a, d, s, r);
                    }
                },
                {
                    key: "setADSR",
                    value: function setADSR(a, d, s, r) {
                        this.audiovoices.forEach(function(voice) {
                            voice.setADSR(a, d, s, r);
                        });
                    }
                },
                {
                    key: "noteAttack",
                    value: function noteAttack(_note, _velocity) {
                        var secondsFromNow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                        var acTime = main.audiocontext.currentTime + secondsFromNow;
                        var note = noteToFreq(_note);
                        var velocity = _velocity || 0.1;
                        var currentVoice;
                        if (this.notes[note] && this.notes[note].getValueAtTime(acTime) !== null) this.noteRelease(note, 0);
                        if (this._voicesInUse.getValueAtTime(acTime) < this.maxVoices) currentVoice = Math.max(~~this._voicesInUse.getValueAtTime(acTime), 0);
                        else {
                            currentVoice = this._oldest;
                            oldestNote = freqToMidi(this.audiovoices[this._oldest].oscillator.freq().value);
                            this.noteRelease(oldestNote);
                            this._oldest = (this._oldest + 1) % (this.maxVoices - 1);
                        }
                        this.notes[note] = new TimelineSignal_default.a();
                        this.notes[note].setValueAtTime(currentVoice, acTime);
                        var previousVal = this._voicesInUse._searchBefore(acTime) === null ? 0 : this._voicesInUse._searchBefore(acTime).value;
                        this._voicesInUse.setValueAtTime(previousVal + 1, acTime);
                        this._updateAfter(acTime, 1);
                        this._newest = currentVoice;
                        if (typeof velocity === "number") {
                            var maxRange = 1 / this._voicesInUse.getValueAtTime(acTime) * 2;
                            velocity = velocity > maxRange ? maxRange : velocity;
                        }
                        this.audiovoices[currentVoice].triggerAttack(note, velocity, secondsFromNow);
                    }
                },
                {
                    key: "_updateAfter",
                    value: function _updateAfter(time, value) {
                        if (this._voicesInUse._searchAfter(time) === null) return;
                        else {
                            this._voicesInUse._searchAfter(time).value += value;
                            var nextTime = this._voicesInUse._searchAfter(time).time;
                            this._updateAfter(nextTime, value);
                        }
                    }
                },
                {
                    key: "noteRelease",
                    value: function noteRelease(_note, secondsFromNow) {
                        var now = main.audiocontext.currentTime;
                        var tFromNow = secondsFromNow || 0;
                        var t = now + tFromNow;
                        if (!_note) {
                            this.audiovoices.forEach(function(voice) {
                                voice.triggerRelease(tFromNow);
                            });
                            this._voicesInUse.setValueAtTime(0, t);
                            for(var n in this.notes){
                                this.notes[n].dispose();
                                delete this.notes[n];
                            }
                            return;
                        }
                        var note = noteToFreq(_note);
                        if (!this.notes[note] || this.notes[note].getValueAtTime(t) === null) console.warn("Cannot release a note that is not already playing");
                        else {
                            var previousVal = Math.max(~~this._voicesInUse.getValueAtTime(t).value, 1);
                            this._voicesInUse.setValueAtTime(previousVal - 1, t);
                            if (previousVal > 0) this._updateAfter(t, -1);
                            this.audiovoices[this.notes[note].getValueAtTime(t)].triggerRelease(tFromNow);
                            this.notes[note].dispose();
                            delete this.notes[note];
                            this._newest = this._newest === 0 ? 0 : (this._newest - 1) % (this.maxVoices - 1);
                        }
                    }
                },
                {
                    key: "connect",
                    value: function connect(unit) {
                        var u = unit || main.input;
                        this.output.connect(u.input ? u.input : u);
                    }
                },
                {
                    key: "disconnect",
                    value: function disconnect() {
                        if (this.output) this.output.disconnect();
                    }
                },
                {
                    key: "dispose",
                    value: function dispose() {
                        this.audiovoices.forEach(function(voice) {
                            voice.dispose();
                        });
                        if (this.output) {
                            this.output.disconnect();
                            delete this.output;
                        }
                    }
                }
            ]);
            return PolySynth;
        }();
        var polysynth = polysynth_PolySynth;
        function Signal_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        var Signal_Signal = function Signal() {
            Signal_classCallCheck(this, Signal);
            console.warn("p5.Signal is deprecated , Use Tone.js Signal instead ");
        };
        var deprecations_Signal = Signal_Signal;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.getAudioContext = audiocontext["b"];
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.userStartAudio = audiocontext["c"];
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.sampleRate = sampleRate;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.freqToMidi = freqToMidi;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.midiToFreq = midiToFreq;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.noteToFreq = noteToFreq;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.soundFormats = soundFormats;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.disposeSound = disposeSound;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype._checkFileFormats = _checkFileFormats;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype._mathChain = _mathChain;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.convertToWav = convertToWav;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.interleave = interleave;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.writeUTFBytes = writeUTFBytes;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.safeBufferSize = safeBufferSize;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.saveSound = saveSound;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.registerMethod("remove", (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.disposeSound);
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Panner = panner_0;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).SoundFile = soundfile;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.loadSound = loadSound;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.registerPreloadMethod("loadSound", (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype);
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Amplitude = amplitude;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).FFT = fft;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Oscillator = oscillator;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).SinOsc = SinOsc;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).TriOsc = TriOsc;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).SawOsc = SawOsc;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).SqrOsc = SqrOsc;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Noise = noise;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Pulse = pulse;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).AudioIn = audioin;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Effect = effect;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Filter = filter;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).LowPass = LowPass;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).HighPass = HighPass;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).BandPass = BandPass;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).EQ = eq;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).listener3D = listener3d;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Panner3D = panner3d;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Delay = delay;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Reverb = Reverb;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Convolver = reverb_Convolver;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.createConvolver = createConvolver;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype.registerPreloadMethod("createConvolver", (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).prototype);
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Metro = metro;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Phrase = Phrase;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Part = looper_Part;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Score = Score;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).SoundLoop = soundLoop;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Compressor = compressor;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).peakDetect = peakDetect;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).SoundRecorder = soundRecorder;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Distortion = distortion;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Gain = gain;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).AudioVoice = audioVoice_0;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).MonoSynth = monosynth;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).OnsetDetect = onsetDetect;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).PolySynth = polysynth;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).PeakDetect = peakDetect;
        (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Signal = deprecations_Signal;
    }
]);


"use strict";



































var $7c0747b58b41b25c$export$2e2bcd8739ae039 = {
    logo: (parcelRequire("gzEFX")),
    arrowDownCircle: (parcelRequire("aSkX0")),
    arrowDownLeft: (parcelRequire("aDAK4")),
    arrowDownRight: (parcelRequire("1meM0")),
    arrowDown: (parcelRequire("cTP1h")),
    arrowLeftCircle: (parcelRequire("at0JQ")),
    arrowLeft: (parcelRequire("k9pG5")),
    arrowRight: (parcelRequire("gvg6J")),
    arrowRightCircle: (parcelRequire("6bhVB")),
    arrowUpCircle: (parcelRequire("5Ys9c")),
    arrowUpLeft: (parcelRequire("fkduY")),
    arrowUpRight: (parcelRequire("5MMfA")),
    arrowUp: (parcelRequire("egVAF")),
    checkCircle: (parcelRequire("5bEOF")),
    check: (parcelRequire("8uQrw")),
    chevronDown: (parcelRequire("3i4HJ")),
    chevronLeft: (parcelRequire("aI8cw")),
    chevronRight: (parcelRequire("e0I9T")),
    chevronUp: (parcelRequire("27kk0")),
    copy: (parcelRequire("4fLzU")),
    eyeOff: (parcelRequire("3mjvv")),
    eye: (parcelRequire("iybUV")),
    info: (parcelRequire("fPARS")),
    minus: (parcelRequire("6F1KK")),
    sun: (parcelRequire("cqUTC")),
    moon: (parcelRequire("3iyV5")),
    moreHorizontal: (parcelRequire("g4mKI")),
    moreVertical: (parcelRequire("iq8O1")),
    send: (parcelRequire("hXJX4")),
    smile: (parcelRequire("48dpK")),
    search: (parcelRequire("dnzu1")),
    upload: (parcelRequire("cA0OS")),
    video: (parcelRequire("5gLkM")),
    x: (parcelRequire("7Gv20")),
    plus: (parcelRequire("li2ow"))
};


"use strict";
const $68c1235a721b25ba$export$9b982809044276a6 = {
    transparent: "rgba(0, 0, 0, 0)",
    black: "black",
    gray: "#4e4e50",
    blue: "#0e80fd",
    indigo: "#50E1FF",
    green: "#59AC56",
    red: "#FE5B47",
    yellow: "#EDCB38",
    orange: "#E2862F",
    brown: "#7D6755",
    pink: "#FD8ABF",
    purple: "#7345AF",
    white: "white",
    green2: "#04F214",
    blue2: "#0474F2",
    gray2: "#A3A3A8",
    gray3: "#1C1C1F",
    gray4: "#BDBDC1",
    title: [
        "--black 1",
        "--white 1"
    ],
    caption: [
        "--gray 1 +16",
        "--gray4 1"
    ],
    paragraph: [
        "--gray 1",
        "--gray 1 +65"
    ]
};
const $68c1235a721b25ba$export$3d856cf049c09ba8 = {
    "gradient-blue-light": `linear-gradient(to right,
    rgba(4, 116, 242, 1),
    rgba(0, 48, 103, 1)
  )`,
    "gradient-blue-dark": `linear-gradient(to right,
    #0474F2,
    #003067
  )`,
    "gradient-dark": `linear-gradient(0deg,
    rgba(0,0,0,0.06) 0%,
    rgba(0,0,0,0.07) 100%
  )`,
    "gradient-dark-active": `linear-gradient(0deg,
    rgba(0,0,0,0.09) 0%,
    rgba(0,0,0,0.1) 100%
  )`,
    "gradient-light": `linear-gradient(
    0deg,
    rgba(255,255,255,0.05) 0%,
    rgba(255,255,255,0.06) 100%
  )`,
    "gradient-light-active": `linear-gradient(
    0deg,
    rgba(255,255,255,0.09) 0%,
    rgba(255,255,255,0.10) 100%
  )`,
    "gradient-colorful": `linear-gradient(60deg,
    #00A2E7 0%,
    #185DF3 31%,
    #1E54F0 36%,
    #8B4CCA 69%,
    #C66894 100%
  )`
};


"use strict";
const $ff633047a5e6ba5f$var$PRIORITIES = {
    primary: {
        "@dark": {
            color: "white",
            background: "blue",
            ".color-only": {
                color: "blue"
            },
            ".inactive": {
                background: "gray 1 +16"
            },
            ".gradient": {
                color: "white",
                background: "gradient-blue"
            }
        },
        "@light": {
            color: "white",
            background: "gradient-blue",
            ".color-only": {
                color: "blue"
            },
            ".gradient": {
                color: "white",
                background: "gradient-colorful"
            }
        }
    },
    secondary: {
        "@dark": {
            color: "white",
            background: "green",
            ".color-only": {
                color: "green"
            }
        },
        "@light": {
            color: "white",
            background: "green",
            ".color-only": {
                color: "green"
            }
        },
        ".child": "--primary"
    },
    tertiary: {
        "@dark": {
            color: "white",
            background: "gray .92 +8"
        },
        "@light": {
            background: "gray .1"
        }
    },
    quaternary: {
        "@light": {
            color: "white",
            background: "gradient-light"
        },
        "@dark": {
            color: "white",
            background: "gradient-dark-active"
        }
    },
    quinary: {
        "@dark": {
            color: "gray 1 90",
            background: "gradient-light",
            ":hover": {
                color: "gray 1 95",
                background: "gradient-light-active"
            },
            ":focus": {
                color: "gray 1 120",
                background: "gradient-light-active"
            },
            ":active": {
                color: "gray 1 120",
                background: "gradient-light-active"
            },
            ".active": {
                color: "gray 1 120",
                background: "gradient-light-active"
            }
        },
        "@light": {
            color: "gray3",
            background: "gradient-dark",
            ":hover": {
                color: "gray1",
                background: "gradient-dark-active"
            },
            ":active": {
                color: "gray1",
                background: "gradient-dark-active"
            },
            ".active": {
                color: "gray1",
                background: "gradient-dark-active"
            }
        }
    }
};
const $ff633047a5e6ba5f$var$STATES = {
    alert: {
        "@dark": {
            color: "white",
            background: "red"
        }
    },
    warning: {
        "@dark": {
            color: "black",
            background: "yellow"
        }
    },
    success: {
        "@dark": {
            color: "black",
            background: "green"
        }
    }
};
const $ff633047a5e6ba5f$var$UI = {
    field: {
        "@light": {
            color: "black",
            background: "gray .975 +144",
            borderColor: "gray .975 +144",
            "::placeholder": {
                color: "gray 1 -68"
            }
        },
        "@dark": {
            color: "white",
            background: "gray .975 -52",
            borderColor: "gray .975 -52",
            "::placeholder": {
                color: "gray 1 +68"
            }
        }
    },
    label: {
        "@dark": {
            color: "white",
            background: "gray .92 +8"
        },
        "@light": {
            background: "gray .1"
        },
        ".light": {
            color: "white",
            background: "gray3"
        },
        ".dark": {
            color: "white",
            background: "black .35"
        }
    },
    card: {
        "@light": {
            background: "gray .975 +150"
        },
        "@dark": {
            color: "white",
            background: "gray .975 -56"
        },
        ".child": {
            color: "white",
            background: "gray3"
        },
        ".secondary": {
            color: "white",
            background: "gradient-blue-dark",
            ".child": {
                color: "white",
                background: "black .35"
            }
        }
    },
    dialog: {
        "@dark": {
            color: "white",
            background: "gray .92",
            ".helper": {
                color: "white",
                background: "black"
            }
        },
        "@light": {
            color: "currentColor",
            background: "gray .1"
        }
    }
};
const $ff633047a5e6ba5f$export$5714e40777c1bcc2 = {
    document: {
        "@light": {
            color: "black",
            background: "white"
        },
        "@dark": {
            color: "white",
            background: "black"
        }
    },
    ...$ff633047a5e6ba5f$var$PRIORITIES,
    ...$ff633047a5e6ba5f$var$STATES,
    ...$ff633047a5e6ba5f$var$UI,
    none: {
        color: "none",
        background: "none"
    },
    transparent: {
        color: "currentColor",
        background: "transparent"
    }
};


"use strict";
const $5f8d538af304c7c6$export$d36796ab73e728d9 = {
    base: 16,
    ratio: 1.25,
    subSequence: true,
    templates: {}
};


"use strict";
const $79ffe4ae2b30fe08$export$82ea42e772d49e5b = {
    ratio: 1.618,
    subSequence: true
};


"use strict";
const $dbb948e0eaf3d49a$export$75d3998385cc196f = {
    SourceSans: [
        {
            url: ""
        }
    ]
};
const $dbb948e0eaf3d49a$export$530097e879f93363 = {
    system: {
        value: [
            '"Helvetica Neue"',
            "Helvetica",
            "Arial"
        ],
        type: "sans-serif"
    }
};


"use strict";
const $99bfc4205b1fbca6$export$500415a86c544f73 = {
    tv: "(min-width: 2780px)",
    screenL: "(max-width: 1920px)",
    "screenL<": "(min-width: 1920px)",
    screenM: "(max-width: 1680px)",
    "screenM<": "(min-width: 1680px)",
    screenS: "(max-width: 1440px)",
    "screenS<": "(min-width: 1440px)",
    tabletL: "(max-width: 1366px)",
    "tabletL<": "(min-width: 1366px)",
    tabletM: "(max-width: 1280px)",
    "tabletM<": "(min-width: 1280px)",
    tabletS: "(max-width: 1024px)",
    "tabletS<": "(min-width: 1024px)",
    mobileL: "(max-width: 768px)",
    "mobileL<": "(min-width: 768px)",
    mobileM: "(max-width: 560px)",
    "mobileM<": "(min-width: 560px)",
    mobileS: "(max-width: 480px)",
    "mobileS<": "(min-width: 480px)",
    mobileXS: "(max-width: 375px)",
    "mobileXS<": "(min-width: 375px)",
    light: "(prefers-color-scheme: light)",
    dark: "(prefers-color-scheme: dark)",
    print: "print"
};


"use strict";
const $ab3d361449dd62cb$export$3c9e9dc0cdfaa753 = {
    base: 150,
    ratio: 1.333,
    unit: "ms",
    subSequence: true
};


"use strict";
const $812d27f1e77a76ab$export$c2f8e0cc249a8d8f = {
    version: "0.0.1",
    COLOR: $68c1235a721b25ba$export$9b982809044276a6,
    GRADIENT: $68c1235a721b25ba$export$3d856cf049c09ba8,
    THEME: $ff633047a5e6ba5f$export$5714e40777c1bcc2,
    TYPOGRAPHY: $5f8d538af304c7c6$export$d36796ab73e728d9,
    SPACING: $79ffe4ae2b30fe08$export$82ea42e772d49e5b,
    FONT: $dbb948e0eaf3d49a$export$75d3998385cc196f,
    FONT_FAMILY: $dbb948e0eaf3d49a$export$530097e879f93363,
    TIMING: $ab3d361449dd62cb$export$3c9e9dc0cdfaa753,
    ICONS: $7c0747b58b41b25c$export$2e2bcd8739ae039,
    MEDIA: $99bfc4205b1fbca6$export$500415a86c544f73,
    DEVICES: {},
    CASES: {},
    SVG: {} // TODO: Check with @nikoloza on this
};
var $812d27f1e77a76ab$export$2e2bcd8739ae039 = $812d27f1e77a76ab$export$c2f8e0cc249a8d8f;


var $75f36cb383311abc$exports = {};
var $18dbdacc7a38df0d$exports = {};

$parcel$export($18dbdacc7a38df0d$exports, "isScalingUnit", () => $18dbdacc7a38df0d$export$6a836bb704f10b75);
"use strict";
const $18dbdacc7a38df0d$export$6a836bb704f10b75 = (unit)=>{
    return unit === "em" || unit === "rem" || unit === "vw" || unit === "vh" || unit === "vmax" || unit === "vmin";
};


var $1ef99b0b26632769$exports = {};

$parcel$export($1ef99b0b26632769$exports, "colorStringToRgbaArray", () => $1ef99b0b26632769$export$fa32e9c99a43479e);
$parcel$export($1ef99b0b26632769$exports, "mixTwoColors", () => $1ef99b0b26632769$export$fc81362b978df912);
$parcel$export($1ef99b0b26632769$exports, "mixTwoRgba", () => $1ef99b0b26632769$export$7aaa71d8fa03e6fa);
$parcel$export($1ef99b0b26632769$exports, "hexToRgb", () => $1ef99b0b26632769$export$5a544e13ad4e1fa5);
$parcel$export($1ef99b0b26632769$exports, "hexToRgbArray", () => $1ef99b0b26632769$export$fc66327a54d8eee6);
$parcel$export($1ef99b0b26632769$exports, "rgbToHex", () => $1ef99b0b26632769$export$34d09c4a771c46ef);
$parcel$export($1ef99b0b26632769$exports, "rgbArrayToHex", () => $1ef99b0b26632769$export$becee3e8de1b8d23);
$parcel$export($1ef99b0b26632769$exports, "hexToRgba", () => $1ef99b0b26632769$export$9665a07d9187b414);
$parcel$export($1ef99b0b26632769$exports, "mixTwoRgb", () => $1ef99b0b26632769$export$7d1bd62512294b2f);
$parcel$export($1ef99b0b26632769$exports, "changeLightness", () => $1ef99b0b26632769$export$784aaa753604ca97);
$parcel$export($1ef99b0b26632769$exports, "rgbToHSL", () => $1ef99b0b26632769$export$ac60e367bcb68b);
$parcel$export($1ef99b0b26632769$exports, "hslToRgb", () => $1ef99b0b26632769$export$29fb7152bd3f781a);
$parcel$export($1ef99b0b26632769$exports, "getColorShade", () => $1ef99b0b26632769$export$e1d0a0f5f1f4ce36);
$parcel$export($1ef99b0b26632769$exports, "opacify", () => $1ef99b0b26632769$export$f4f50e3877dd0530);
$parcel$export($1ef99b0b26632769$exports, "getRgbTone", () => $1ef99b0b26632769$export$2d78fefdcfb7f222);

var $aOJ2H = parcelRequire("aOJ2H");
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $1ef99b0b26632769$var$ENV = "production";
const $1ef99b0b26632769$export$fa32e9c99a43479e = (color)=>{
    if (color === "") return;
    if (color.toLowerCase() === "transparent") return [
        0,
        0,
        0,
        0
    ];
    // convert #RGB and #RGBA to #RRGGBB and #RRGGBBAA
    if (color[0] === "#") {
        if (color.length < 7) color = "#" + color[1] + color[1] + color[2] + color[2] + color[3] + color[3] + (color.length > 4 ? color[4] + color[4] : "");
        return [
            parseInt(color.substr(1, 2), 16),
            parseInt(color.substr(3, 2), 16),
            parseInt(color.substr(5, 2), 16),
            color.length > 7 ? parseInt(color.substr(7, 2), 16) / 255 : 1
        ];
    }
    // convert named colors
    if (color.indexOf("rgb") === -1) {
        if ((0, $aOJ2H.document) && (0, $aOJ2H.window)) {
            // intentionally use unknown tag to lower chances of css rule override with !important
            const elem = (0, $aOJ2H.document).body.appendChild((0, $aOJ2H.document).createElement("fictum"));
            // this flag tested on chrome 59, ff 53, ie9, ie10, ie11, edge 14
            const flag = "rgb(1, 2, 3)";
            elem.style.color = flag;
            // color set failed - some monstrous css rule is probably taking over the color of our object
            if (elem.style.color !== flag) return;
            elem.style.color = color;
            if (elem.style.color === flag || elem.style.color === "") return; // color parse failed
            color = (0, $aOJ2H.window).getComputedStyle(elem).color;
            (0, $aOJ2H.document).body.removeChild(elem);
        }
    }
    // convert 'rgb(R,G,B)' to 'rgb(R,G,B,A)' which looks awful but will pass the regxep below
    if (color.indexOf("rgb") === 0) {
        if (color.indexOf("rgba") === -1) color = `${color}, 1`;
        return color.match(/[\.\d]+/g).map((a)=>+a) // eslint-disable-line
        ;
    }
    // TODO: fix this
    return [];
};
const $1ef99b0b26632769$export$fc81362b978df912 = (colorA, colorB, range = 0.5)=>{
    colorA = $1ef99b0b26632769$export$fa32e9c99a43479e(colorA);
    colorB = $1ef99b0b26632769$export$fa32e9c99a43479e(colorB);
    return $1ef99b0b26632769$export$7aaa71d8fa03e6fa(colorA, colorB, range);
};
const $1ef99b0b26632769$export$5a544e13ad4e1fa5 = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return `rgb(${r},${g},${b})`;
};
const $1ef99b0b26632769$export$fc66327a54d8eee6 = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return [
        r,
        g,
        b
    ];
};
const $1ef99b0b26632769$export$34d09c4a771c46ef = (r, g, b)=>{
    return "#" + (16777216 | r << 16 | g << 8 | b).toString(16).slice(1);
};
const $1ef99b0b26632769$export$becee3e8de1b8d23 = ([r, g, b])=>{
    return (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
};
const $1ef99b0b26632769$export$9665a07d9187b414 = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
};
const $1ef99b0b26632769$export$7d1bd62512294b2f = (colorA, colorB, range = 0.5)=>{
    const arr = [];
    for(let i = 0; i < 3; i++)arr[i] = ~~(colorA[i] + (colorB[i] - colorA[i]) * range);
    return `rgb(${arr})`;
};
const $1ef99b0b26632769$export$784aaa753604ca97 = (delta, hsl)=>{
    const [hue, saturation, lightness] = hsl;
    const newLightness = Math.max(0, Math.min(100, lightness + parseFloat(delta)));
    return [
        hue,
        saturation,
        newLightness
    ];
};
const $1ef99b0b26632769$export$ac60e367bcb68b = (r, g, b)=>{
    const a = Math.max(r, g, b);
    const n = a - Math.min(r, g, b);
    const f = 1 - Math.abs(a + a - n - 1);
    const h = n && (a == r ? (g - b) / n : a == g ? 2 + (b - r) / n : 4 + (r - g) / n //eslint-disable-line
    );
    return [
        60 * (h < 0 ? h + 6 : h),
        f ? n / f : 0,
        (a + a - n) / 2
    ];
};
const $1ef99b0b26632769$export$29fb7152bd3f781a = (h, s, l, a = s * Math.min(l, 1 - l), f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1))=>[
        f(0),
        f(8),
        f(4)
    ];
const $1ef99b0b26632769$export$e1d0a0f5f1f4ce36 = (col, amt)=>{
    const num = parseInt(col, 16);
    let r = (num >> 16) + amt;
    if (r > 255) r = 255;
    else if (r < 0) r = 0;
    let b = (num >> 8 & 0x00FF) + amt;
    if (b > 255) b = 255;
    else if (b < 0) b = 0;
    let g = (num & 0x0000FF) + amt;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    return ((g | b << 8 | r << 16) + 0x1000000).toString(16).slice(1);
};
const $1ef99b0b26632769$export$7aaa71d8fa03e6fa = (colorA, colorB, range = 0.5)=>{
    const arr = [];
    for(let i = 0; i < 4; i++){
        const round = i === 3 ? (x)=>x : Math.round;
        arr[i] = round(colorA[i] + (colorB[i] - colorA[i]) * range);
    }
    return `rgba(${arr})`;
};
const $1ef99b0b26632769$export$f4f50e3877dd0530 = (color, opacity)=>{
    const arr = $1ef99b0b26632769$export$fa32e9c99a43479e(color);
    if (!arr) {
        if ($1ef99b0b26632769$var$ENV === "test" || $1ef99b0b26632769$var$ENV === "development") console.warn(color + " color is not rgba");
        return;
    }
    arr[3] = opacity;
    return `rgba(${arr})`;
};
const $1ef99b0b26632769$export$2d78fefdcfb7f222 = (rgb, tone)=>{
    if ((0, $EqHTq.isString)(rgb) && rgb.includes("rgb")) rgb = $1ef99b0b26632769$export$fa32e9c99a43479e(rgb).join(", ");
    if ((0, $EqHTq.isString)(rgb)) rgb = rgb.split(",").map((v)=>parseFloat(v.trim()));
    if ((0, $EqHTq.isNumber)(tone)) tone += "";
    const toHex = $1ef99b0b26632769$export$becee3e8de1b8d23(rgb);
    const abs = tone.slice(0, 1);
    if (abs === "-" || abs === "+") {
        const colorShade = $1ef99b0b26632769$export$e1d0a0f5f1f4ce36(toHex, parseFloat(tone));
        return $1ef99b0b26632769$export$fc66327a54d8eee6(colorShade).join(", ");
    } else {
        const [r, g, b] = rgb;
        const hsl = $1ef99b0b26632769$export$ac60e367bcb68b(r, g, b);
        const [h, s, l] = hsl // eslint-disable-line
        ;
        const newRgb = $1ef99b0b26632769$export$29fb7152bd3f781a(h, s, parseFloat(tone) / 100 * 255);
        return newRgb;
    }
};


var $08f037a4512e32ac$exports = {};

$parcel$export($08f037a4512e32ac$exports, "returnSubThemeOrDefault", () => $08f037a4512e32ac$export$b653d4648867fe18);
"use strict";
const $08f037a4512e32ac$export$b653d4648867fe18 = (orig, theme)=>{
    if (!orig) return;
    if (orig.themes && orig.themes[theme]) return orig.themes[theme];
    if (orig[theme]) return [
        orig,
        orig[theme]
    ];
    return orig;
};


var $acb660e77bec9cb5$exports = {};

$parcel$export($acb660e77bec9cb5$exports, "getDefaultOrFirstKey", () => $acb660e77bec9cb5$export$73aa7d12a2d2fb83);
$parcel$export($acb660e77bec9cb5$exports, "getFontFormat", () => $acb660e77bec9cb5$export$6c7bbed5530e9474);
$parcel$export($acb660e77bec9cb5$exports, "setInCustomFontMedia", () => $acb660e77bec9cb5$export$e84fe2812840a337);
$parcel$export($acb660e77bec9cb5$exports, "setCustomFont", () => $acb660e77bec9cb5$export$27bb82ae7d3ac02b);
$parcel$export($acb660e77bec9cb5$exports, "setCustomFontMedia", () => $acb660e77bec9cb5$export$2593ac3417be5ed7);
$parcel$export($acb660e77bec9cb5$exports, "getFontFaceEach", () => $acb660e77bec9cb5$export$198e04e3616f042a);
$parcel$export($acb660e77bec9cb5$exports, "getFontFace", () => $acb660e77bec9cb5$export$e9d70cd3a9044b8e);
$parcel$export($acb660e77bec9cb5$exports, "getFontFaceEachString", () => $acb660e77bec9cb5$export$c26ef91aac8931ec);
$parcel$export($acb660e77bec9cb5$exports, "getFontFaceString", () => $acb660e77bec9cb5$export$8b73d71a1d936bc);
"use strict";
const $acb660e77bec9cb5$export$73aa7d12a2d2fb83 = (LIBRARY, key)=>{
    if (LIBRARY[key]) return LIBRARY[key].value;
    if (LIBRARY.default) return LIBRARY[LIBRARY.default].value;
    const hasValue = Object.keys(LIBRARY)[0];
    return hasValue && LIBRARY[hasValue] && LIBRARY[hasValue].value;
};
const $acb660e77bec9cb5$export$6c7bbed5530e9474 = (url)=>url.split(/[#?]/)[0].split(".").pop().trim();
const $acb660e77bec9cb5$export$e84fe2812840a337 = (str)=>`@font-face { ${str} }`;
const $acb660e77bec9cb5$export$27bb82ae7d3ac02b = (name, url, weight)=>`
  font-family: '${name}';
  font-style: normal;
  ${weight && `font-weight: ${weight};`}
  src: url('${url}') format('${$acb660e77bec9cb5$export$6c7bbed5530e9474(url)}');`;
const $acb660e77bec9cb5$export$2593ac3417be5ed7 = (name, url, weight)=>`@font-face {
  ${$acb660e77bec9cb5$export$27bb82ae7d3ac02b(name, url, weight)}
}`;
const $acb660e77bec9cb5$export$198e04e3616f042a = (name, weights)=>{
    const keys = Object.keys(weights);
    return keys.map((key)=>{
        const { url: url, fontWeight: fontWeight } = weights[key];
        return $acb660e77bec9cb5$export$27bb82ae7d3ac02b(name, url, fontWeight);
    });
};
const $acb660e77bec9cb5$export$e9d70cd3a9044b8e = (LIBRARY)=>{
    const keys = Object.keys(LIBRARY);
    return keys.map((key)=>$acb660e77bec9cb5$export$198e04e3616f042a(key, LIBRARY[key].value));
};
const $acb660e77bec9cb5$export$c26ef91aac8931ec = (name, weights)=>{
    const isArr = weights[0];
    if (isArr) return $acb660e77bec9cb5$export$198e04e3616f042a(name, weights).map($acb660e77bec9cb5$export$e84fe2812840a337);
    return $acb660e77bec9cb5$export$2593ac3417be5ed7(name, weights.url);
};
const $acb660e77bec9cb5$export$8b73d71a1d936bc = (LIBRARY)=>{
    const keys = Object.keys(LIBRARY);
    return keys.map((key)=>$acb660e77bec9cb5$export$c26ef91aac8931ec(key, LIBRARY[key].value));
};


var $366218d35fdab076$exports = {};

$parcel$export($366218d35fdab076$exports, "numToLetterMap", () => $366218d35fdab076$export$81ab9dc24d52c4ba);
$parcel$export($366218d35fdab076$exports, "setScalingVar", () => $366218d35fdab076$export$68dfa61d698afbde);
$parcel$export($366218d35fdab076$exports, "setSubScalingVar", () => $366218d35fdab076$export$c9d5ef57eeb83fa);
$parcel$export($366218d35fdab076$exports, "getSubratioDifference", () => $366218d35fdab076$export$12adf55fdaa50348);
$parcel$export($366218d35fdab076$exports, "getSubratio", () => $366218d35fdab076$export$50db87b17b1557b4);
$parcel$export($366218d35fdab076$exports, "generateSubSequence", () => $366218d35fdab076$export$622ae6209895c34e);
$parcel$export($366218d35fdab076$exports, "generateSequence", () => $366218d35fdab076$export$29708af739d9b0fc);
$parcel$export($366218d35fdab076$exports, "getSequenceValue", () => $366218d35fdab076$export$efde09b5692f9bd0);
$parcel$export($366218d35fdab076$exports, "getSequenceValuePropertyPair", () => $366218d35fdab076$export$86c0052f25dacc45);
$parcel$export($366218d35fdab076$exports, "findHeadingLetter", () => $366218d35fdab076$export$14c834a042d41297);
$parcel$export($366218d35fdab076$exports, "findHeadings", () => $366218d35fdab076$export$8dc77c00fe04c40a);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $8319f99b46b296c9$exports = {};

$parcel$export($8319f99b46b296c9$exports, "copyStringToClipboard", () => $8319f99b46b296c9$export$4cdfed7d7fed21b8);
$parcel$export($8319f99b46b296c9$exports, "toCamelCase", () => $8319f99b46b296c9$export$86f54f62aa7a7514);
$parcel$export($8319f99b46b296c9$exports, "toTitleCase", () => $8319f99b46b296c9$export$f06f8b3003f18927);
$parcel$export($8319f99b46b296c9$exports, "toDashCase", () => $8319f99b46b296c9$export$6401d9e8afa09755);
$parcel$export($8319f99b46b296c9$exports, "toDescriptionCase", () => $8319f99b46b296c9$export$c82070d8669cc24e);
$parcel$export($8319f99b46b296c9$exports, "arrayzeValue", () => $8319f99b46b296c9$export$d1ef4b1a340dec10);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $6d2b41257afed6ac$exports = {};

$parcel$export($6d2b41257afed6ac$exports, "findClosestNumber", () => $6d2b41257afed6ac$export$97a41db892f2d4c);
$parcel$export($6d2b41257afed6ac$exports, "findClosestNumberInFactory", () => $6d2b41257afed6ac$export$63c606e1170dd201);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $6d2b41257afed6ac$export$97a41db892f2d4c = (number, arr)=>{
    return ((0, $EqHTq.isArray)(arr) ? arr : Object.values(arr)).reduce((prev, curr)=>{
        return Math.abs(curr - number) < Math.abs(prev - number) ? curr : prev;
    });
};
const $6d2b41257afed6ac$export$63c606e1170dd201 = (val, factory)=>{
    val = parseFloat(val);
    if ((0, $EqHTq.isObject)(factory)) factory = Object.values(factory);
    return $6d2b41257afed6ac$export$97a41db892f2d4c(val, factory);
};


var $6990ad4ace0aad0d$exports = {};

$parcel$export($6990ad4ace0aad0d$exports, "formatDate", () => $6990ad4ace0aad0d$export$3ae94a2503e890a1);
"use strict";
const $6990ad4ace0aad0d$export$3ae94a2503e890a1 = (timestamp)=>{
    if (!timestamp) return "";
    const d = new Date(timestamp);
    const ye = new Intl.DateTimeFormat("en", {
        year: "numeric"
    }).format(d);
    const mo = new Intl.DateTimeFormat("en", {
        month: "short"
    }).format(d);
    const da = new Intl.DateTimeFormat("en", {
        day: "2-digit"
    }).format(d);
    return `${da} ${mo}, ${ye}`;
};


"use strict";
const $8319f99b46b296c9$export$4cdfed7d7fed21b8 = (str)=>{
    const el = document.createElement("textarea");
    el.value = str;
    el.setAttribute("readonly", "");
    el.style = {
        position: "absolute",
        left: "-9999px"
    };
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
};
const $8319f99b46b296c9$export$86f54f62aa7a7514 = (str)=>{
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replaceAll(/\s+/g, "");
};
const $8319f99b46b296c9$export$f06f8b3003f18927 = (str)=>str && str.replace(/\w\S*/g, (txt)=>{
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
const $8319f99b46b296c9$export$6401d9e8afa09755 = (val)=>val.replace(/[^a-zA-Z0-9]/g, " ") // Replace non-alphanumeric characters with spaces
    .trim() // Remove leading and trailing spaces
    .toLowerCase() // Convert to lowercase
    .replace(/\s+/g, "-") // Replace spaces with dashes
    .replace(/-+/g, "-") // Replace consecutive dashes with a single dash
    .replace(/^-|-$/g, "") // Remove leading and trailing dashes
;
const $8319f99b46b296c9$export$c82070d8669cc24e = (str)=>{
    const result = str.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
};
const $8319f99b46b296c9$export$d1ef4b1a340dec10 = (val)=>{
    if ((0, $EqHTq.isArray)(val)) return val;
    if ((0, $EqHTq.isString)(val)) return val.split(" ");
    if ((0, $EqHTq.isObject)(val)) return Object.values(val);
    if ((0, $EqHTq.isNumber)(val)) return [
        val
    ];
};
$parcel$exportWildcard($8319f99b46b296c9$exports, $6d2b41257afed6ac$exports);
$parcel$exportWildcard($8319f99b46b296c9$exports, $6990ad4ace0aad0d$exports);


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $9da0db98e0c07b6d$exports = {};

$parcel$export($9da0db98e0c07b6d$exports, "RESET", () => $9da0db98e0c07b6d$export$4a991c87e640ef77);
var $d2de3d327c0c6201$exports = {};

$parcel$export($d2de3d327c0c6201$exports, "SEQUENCE", () => $d2de3d327c0c6201$export$34694f8d8b23ee2a);
"use strict";
const $d2de3d327c0c6201$export$34694f8d8b23ee2a = {
    "minor-second": 1.067,
    "major-second": 1.125,
    "minor-third": 1.2,
    "major-third": 1.25,
    "perfect-fourth": 1.333,
    "augmented-fourth": 1.414,
    "perfect-fifth": 1.5,
    "minor-sixth": 1.6,
    phi: 1.618,
    "major-sixth": 1.667,
    "square-root-3": 1.732,
    "minor-seventh": 1.778,
    "major-seventh": 1.875,
    octave: 2,
    "square-root-5": 2.23,
    "major-tenth": 2.5,
    "major-eleventh": 2.667,
    "major-twelfth": 3,
    pi: 3.14,
    "double-octave": 4
};


var $9ac3be22fd3c73fc$exports = {};

$parcel$export($9ac3be22fd3c73fc$exports, "UNIT", () => $9ac3be22fd3c73fc$export$97361b7a0c542045);
"use strict";
const $9ac3be22fd3c73fc$export$97361b7a0c542045 = {
    default: "em"
};


var $cc16a6638a049274$exports = {};

$parcel$export($cc16a6638a049274$exports, "TYPOGRAPHY", () => $cc16a6638a049274$export$d36796ab73e728d9);

"use strict";
const $cc16a6638a049274$var$defaultProps = {
    browserDefault: 16,
    base: 16,
    type: "font-size",
    ratio: (0, $d2de3d327c0c6201$export$34694f8d8b23ee2a)["minor-third"],
    range: [
        -3,
        12
    ],
    h1Matches: 6,
    lineHeight: 1.5,
    subSequence: true,
    mediaRegenerate: false,
    unit: "em",
    templates: {},
    sequence: {},
    scales: {},
    vars: {}
};
const $cc16a6638a049274$export$d36796ab73e728d9 = $cc16a6638a049274$var$defaultProps;


var $2015873c4c2cfb72$exports = {};

$parcel$export($2015873c4c2cfb72$exports, "FONT", () => $2015873c4c2cfb72$export$75d3998385cc196f);
"use strict";
var $2015873c4c2cfb72$var$defFont = {
    name: "",
    url: "",
    fontStyle: "",
    fontWeight: 500,
    fontStretch: "normal",
    fontOpticalSizing: "auto"
};
const $2015873c4c2cfb72$export$75d3998385cc196f = {};


var $814e605b31851b50$exports = {};

$parcel$export($814e605b31851b50$exports, "FONT_FAMILY", () => $814e605b31851b50$export$530097e879f93363);
$parcel$export($814e605b31851b50$exports, "FONT_FAMILY_TYPES", () => $814e605b31851b50$export$756e583a6734f96e);
$parcel$export($814e605b31851b50$exports, "FONT_FACE", () => $814e605b31851b50$export$2c16de31893252e6);
"use strict";
var $814e605b31851b50$var$defaultFont = {
    name: "",
    family: "",
    type: ""
};
const $814e605b31851b50$export$530097e879f93363 = {};
const $814e605b31851b50$export$756e583a6734f96e = {
    "sans-serif": "Helvetica, Arial, sans-serif, --system-default",
    serif: "Times New Roman, Georgia, serif, --system-default",
    monospace: "Courier New, monospace, --system-default"
};
const $814e605b31851b50$export$2c16de31893252e6 = {};


var $1dbcec70a81fc9be$exports = {};

$parcel$export($1dbcec70a81fc9be$exports, "MEDIA", () => $1dbcec70a81fc9be$export$500415a86c544f73);
"use strict";
const $1dbcec70a81fc9be$export$500415a86c544f73 = {
    tv: "(min-width: 2780px)",
    light: "(prefers-color-scheme: light)",
    dark: "(prefers-color-scheme: dark)",
    print: "print"
};


var $950c64c959f06041$exports = {};

$parcel$export($950c64c959f06041$exports, "SPACING", () => $950c64c959f06041$export$82ea42e772d49e5b);


"use strict";
const $950c64c959f06041$var$defaultProps = {
    base: (0, $cc16a6638a049274$export$d36796ab73e728d9).base,
    type: "spacing",
    ratio: (0, $d2de3d327c0c6201$export$34694f8d8b23ee2a).phi,
    range: [
        -5,
        15
    ],
    subSequence: true,
    mediaRegenerate: false,
    unit: "em",
    sequence: {},
    scales: {},
    vars: {}
};
const $950c64c959f06041$export$82ea42e772d49e5b = $950c64c959f06041$var$defaultProps;


var $891220fdda3d21a2$exports = {};

$parcel$export($891220fdda3d21a2$exports, "COLOR", () => $891220fdda3d21a2$export$9b982809044276a6);
$parcel$export($891220fdda3d21a2$exports, "GRADIENT", () => $891220fdda3d21a2$export$3d856cf049c09ba8);
"use strict";
var $891220fdda3d21a2$var$proto = {
    name: "",
    value: ""
};
const $891220fdda3d21a2$export$9b982809044276a6 = {};
const $891220fdda3d21a2$export$3d856cf049c09ba8 = {};


var $d3a916a1fb7d8435$exports = {};

$parcel$export($d3a916a1fb7d8435$exports, "THEME", () => $d3a916a1fb7d8435$export$5714e40777c1bcc2);
"use strict";
const $d3a916a1fb7d8435$var$themeA = {
    text: "blue",
    background: "white",
    border: "black",
    active: {},
    helpers: [],
    themes: {},
    inverse: {} // schemeAInverse
};
const $d3a916a1fb7d8435$export$5714e40777c1bcc2 = {};


var $8bcf1bed1aa8dad9$exports = {};

$parcel$export($8bcf1bed1aa8dad9$exports, "SHADOW", () => $8bcf1bed1aa8dad9$export$98b6069deb71e13e);
"use strict";
const $8bcf1bed1aa8dad9$var$shadow = {
    name: "primaryShadow",
    boxShadow: "gray12, 0 0px 50px 50px"
};
const $8bcf1bed1aa8dad9$export$98b6069deb71e13e = {};


var $60fc9d3d8a249143$exports = {};

$parcel$export($60fc9d3d8a249143$exports, "ICONS", () => $60fc9d3d8a249143$export$fde44257752a9f60);
"use strict";
const $60fc9d3d8a249143$export$fde44257752a9f60 = {};


var $0cc3469566cd77c9$exports = {};

$parcel$export($0cc3469566cd77c9$exports, "TIMING", () => $0cc3469566cd77c9$export$3c9e9dc0cdfaa753);

"use strict";
const $0cc3469566cd77c9$var$defaultProps = {
    default: 150,
    base: 150,
    type: "timing",
    ratio: (0, $d2de3d327c0c6201$export$34694f8d8b23ee2a)["perfect-fourth"],
    range: [
        -3,
        12
    ],
    mediaRegenerate: false,
    unit: "ms",
    sequence: {},
    scales: {},
    vars: {}
};
const $0cc3469566cd77c9$export$3c9e9dc0cdfaa753 = $0cc3469566cd77c9$var$defaultProps;


var $438de410da63932f$exports = {};

$parcel$export($438de410da63932f$exports, "DOCUMENT", () => $438de410da63932f$export$ef011b4e114b1fba);
"use strict";
const $438de410da63932f$export$ef011b4e114b1fba = {};


var $567db250b885dfb6$exports = {};

$parcel$export($567db250b885dfb6$exports, "BREAKPOINTS", () => $567db250b885dfb6$export$426e07cd0772984d);
$parcel$export($567db250b885dfb6$exports, "DEVICES", () => $567db250b885dfb6$export$7e1b78538df536d8);
"use strict";
const $567db250b885dfb6$export$426e07cd0772984d = {
    screenL: 1920,
    screenM: 1680,
    screenS: 1440,
    tabletL: 1366,
    tabletM: 1280,
    tabletS: 1024,
    mobileL: 768,
    mobileM: 560,
    mobileS: 480,
    mobileXS: 375
};
const $567db250b885dfb6$export$7e1b78538df536d8 = {
    screenL: [
        1920,
        1024
    ],
    screenM: [
        1680,
        1024
    ],
    screenS: [
        1440,
        978
    ],
    tabletL: [
        1366,
        926
    ],
    tabletM: [
        1280,
        768
    ],
    tabletS: [
        1024,
        768
    ],
    mobileL: [
        768,
        375
    ],
    mobileM: [
        560,
        768
    ],
    mobileS: [
        480,
        768
    ],
    mobileXS: [
        375,
        768
    ]
};


var $49f0f03e163f2585$exports = {};

$parcel$export($49f0f03e163f2585$exports, "CASES", () => $49f0f03e163f2585$export$ddbef7dfaa374d2d);
"use strict";
const $49f0f03e163f2585$export$ddbef7dfaa374d2d = {};


var $fc04128916812e44$exports = {};

$parcel$export($fc04128916812e44$exports, "ANIMATION", () => $fc04128916812e44$export$a8fef325e42f6db3);
"use strict";
const $fc04128916812e44$export$a8fef325e42f6db3 = {};


var $f4fd3215e1191093$exports = {};

$parcel$export($f4fd3215e1191093$exports, "SVG", () => $f4fd3215e1191093$export$13f4b12aafeba5d6);
$parcel$export($f4fd3215e1191093$exports, "SVG_DATA", () => $f4fd3215e1191093$export$9738e40199601663);
"use strict";
const $f4fd3215e1191093$export$13f4b12aafeba5d6 = {};
const $f4fd3215e1191093$export$9738e40199601663 = {};


var $a13c32e8633d5002$exports = {};

$parcel$export($a13c32e8633d5002$exports, "TEMPLATES", () => $a13c32e8633d5002$export$b8020e85ad90bfe5);
"use strict";
const $a13c32e8633d5002$export$b8020e85ad90bfe5 = {};


"use strict";
const $9da0db98e0c07b6d$export$4a991c87e640ef77 = {};
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $d2de3d327c0c6201$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $9ac3be22fd3c73fc$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $cc16a6638a049274$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $2015873c4c2cfb72$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $814e605b31851b50$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $1dbcec70a81fc9be$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $950c64c959f06041$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $891220fdda3d21a2$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $d3a916a1fb7d8435$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $8bcf1bed1aa8dad9$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $60fc9d3d8a249143$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $0cc3469566cd77c9$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $438de410da63932f$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $567db250b885dfb6$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $49f0f03e163f2585$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $fc04128916812e44$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $f4fd3215e1191093$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $a13c32e8633d5002$exports);


"use strict";
const $5a3b725cdb25b0eb$export$220f2e5d84ced4cb = {};
const $5a3b725cdb25b0eb$export$1630b5343357e8b5 = {
    verbose: false,
    useVariable: true,
    useReset: true,
    CSS_VARS: $5a3b725cdb25b0eb$export$220f2e5d84ced4cb,
    ...$9da0db98e0c07b6d$exports
};
const $5a3b725cdb25b0eb$var$cachedConfig = (0, $8wu6n.deepClone)($5a3b725cdb25b0eb$export$1630b5343357e8b5);
const $5a3b725cdb25b0eb$export$ee513c29aad6cc62 = {
    active: "0",
    0: $5a3b725cdb25b0eb$export$1630b5343357e8b5
};
const $5a3b725cdb25b0eb$export$8a278b801d0668ff = (def)=>{
    if ((0, $EqHTq.isDefined)(def)) $5a3b725cdb25b0eb$export$ee513c29aad6cc62.active = def;
    return $5a3b725cdb25b0eb$export$ee513c29aad6cc62[def || $5a3b725cdb25b0eb$export$ee513c29aad6cc62.active];
};
const $5a3b725cdb25b0eb$export$e23c3d522afb24cd = (def)=>{
    return $5a3b725cdb25b0eb$export$ee513c29aad6cc62[def || $5a3b725cdb25b0eb$export$ee513c29aad6cc62.active];
};
const $5a3b725cdb25b0eb$export$5e61d1b6fff0c794 = (newConfig)=>{
    if (!(0, $EqHTq.isObject)(newConfig)) return;
    $5a3b725cdb25b0eb$export$ee513c29aad6cc62.active = "1";
    $5a3b725cdb25b0eb$export$ee513c29aad6cc62["1"] = (0, $8wu6n.deepMerge)(newConfig, (0, $8wu6n.deepClone)($5a3b725cdb25b0eb$var$cachedConfig));
    return newConfig;
};



"use strict";
const $366218d35fdab076$export$81ab9dc24d52c4ba = {
    "-6": "U",
    "-5": "V",
    "-4": "W",
    "-3": "X",
    "-2": "Y",
    "-1": "Z",
    0: "A",
    1: "B",
    2: "C",
    3: "D",
    4: "E",
    5: "F",
    6: "G",
    7: "H",
    8: "I",
    9: "J",
    10: "K",
    11: "L",
    12: "M",
    13: "N",
    14: "O",
    15: "P",
    16: "Q",
    17: "R",
    18: "S",
    19: "T"
};
const $366218d35fdab076$var$setSequenceValue = (props, sequenceProps)=>{
    const { key: key, variable: variable, value: value, scaling: scaling, index: index, scalingVariable: scalingVariable } = props;
    sequenceProps.sequence[key] = {
        key: key,
        decimal: ~~(value * 100) / 100,
        val: ~~value,
        scaling: scaling,
        index: index,
        scalingVariable: scalingVariable,
        variable: variable
    };
    sequenceProps.scales[key] = scaling;
    sequenceProps.vars[variable] = scaling + sequenceProps.unit;
};
const $366218d35fdab076$export$68dfa61d698afbde = (key, sequenceProps)=>{
    const { base: base, type: type, unit: unit } = sequenceProps;
    const defaultVal = ((0, $18dbdacc7a38df0d$export$6a836bb704f10b75)(unit) ? 1 : base) + unit;
    if (key === 0) return defaultVal;
    const prefix = "--" + (type && type.replace(".", "-"));
    const ratioVar = `${prefix}-ratio`;
    if (key > 0) {
        const prevLetterKey = $366218d35fdab076$export$81ab9dc24d52c4ba[key - 1];
        return `calc(var(${prefix}-${prevLetterKey}) * var(${ratioVar}))`;
    }
    if (key < 0) {
        const nextLetterKey = $366218d35fdab076$export$81ab9dc24d52c4ba[key + 1];
        return `calc(var(${prefix}-${nextLetterKey}) / var(${ratioVar}))`;
    }
};
const $366218d35fdab076$export$c9d5ef57eeb83fa = (index, arr, variable, sequenceProps)=>{
    const { type: type } = sequenceProps;
    const skipMiddle = index === 2 && arr.length === 2;
    const indexMapWithLength = skipMiddle ? index + 1 : index;
    const prefix = "--" + (type && type.replace(".", "-"));
    const subRatioVarPrefix = `${prefix}-sub-ratio-`;
    return `calc(var(${variable}) * var(${subRatioVarPrefix + indexMapWithLength}))`;
};
const $366218d35fdab076$export$12adf55fdaa50348 = (base, ratio)=>{
    const diff = base * ratio - base;
    const subRatio = diff / 1.618;
    const first = base * ratio - subRatio;
    const second = base + subRatio;
    const middle = (first + second) / 2;
    return [
        first,
        middle,
        second
    ];
};
const $366218d35fdab076$export$50db87b17b1557b4 = (base, ratio)=>{
    return $366218d35fdab076$export$12adf55fdaa50348(base, ratio).map((v)=>v / base);
};
const $366218d35fdab076$export$622ae6209895c34e = (props, sequenceProps)=>{
    const { key: key, base: base, value: value, ratio: ratio, variable: variable, index: index } = props;
    const next = value * ratio;
    const diffRounded = ~~next - ~~value;
    let arr;
    const [first, middle, second] = $366218d35fdab076$export$12adf55fdaa50348(value, ratio);
    if (diffRounded > 16) arr = [
        first,
        middle,
        second
    ];
    else arr = [
        first,
        second
    ];
    arr.forEach((v, k)=>{
        const scaling = ~~(v / base * 1000) / 1000;
        const newVar = variable + (k + 1);
        const newIndex = index + (k + 1) / 10;
        const scalingVariable = $366218d35fdab076$export$c9d5ef57eeb83fa(k + 1, arr, variable, sequenceProps);
        const props = {
            key: key + (k + 1),
            variable: newVar,
            value: v,
            scaling: scaling,
            scalingVariable: scalingVariable,
            index: newIndex
        };
        $366218d35fdab076$var$setSequenceValue(props, sequenceProps);
    });
};
const $366218d35fdab076$var$switchSequenceOnNegative = (key, base, ratio)=>{
    // const values = Object.values(SEQUENCE)
    // const index = values.indexOf(ratio)
    // const diffRatio = ratio / SPACING.ratio
    // const total = values[values.length - 1] - values[0]
    // const avg = total / 2
    // const diff = avg - ratio
    // const scale = total / ratio
    // const finalDiff = avg + avg / diffRatio
    // if (key < 0) return base * Math.pow(avg, key)
    return base * Math.pow(ratio, key);
};
const $366218d35fdab076$export$29708af739d9b0fc = (sequenceProps)=>{
    const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence } = sequenceProps;
    const n = Math.abs(range[0]) + Math.abs(range[1]);
    const prefix = "--" + (type && type.replace(".", "-")) + "-";
    for(let i = 0; i <= n; i++){
        const key = range[1] - i;
        const letterKey = $366218d35fdab076$export$81ab9dc24d52c4ba[key];
        const value = $366218d35fdab076$var$switchSequenceOnNegative(key, base, ratio);
        const scaling = ~~(value / base * 100) / 100;
        const variable = prefix + letterKey;
        const scalingVariable = $366218d35fdab076$export$68dfa61d698afbde(key, sequenceProps);
        const props = {
            key: letterKey,
            variable: variable,
            value: value,
            base: base,
            scaling: scaling,
            scalingVariable: scalingVariable,
            ratio: ratio,
            index: key
        };
        $366218d35fdab076$var$setSequenceValue(props, sequenceProps);
        if (subSequence) $366218d35fdab076$export$622ae6209895c34e(props, sequenceProps);
    }
    return sequenceProps;
};
const $366218d35fdab076$export$efde09b5692f9bd0 = (value = "A", sequenceProps)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { UNIT: UNIT } = CONFIG;
    const { sequence: sequence, unit: unit = UNIT.default, useVariable: useVariable } = sequenceProps;
    if ((0, $EqHTq.isString)(value) && value.slice(0, 2) === "--") return `var(${value})`;
    const prefix = `--${(0, $8319f99b46b296c9$export$6401d9e8afa09755)(sequenceProps.type.replace(".", "-"))}-`;
    const startsWithDashOrLetterRegex = /^-?[a-zA-Z]/i;
    const startsWithDashOrLetter = startsWithDashOrLetterRegex.test(value);
    if (value === "none" || value === "auto" || value === "unset" || value === "inherit" || value === "fit-content" || value === "min-content" || value === "max-content" || value.includes("calc") || value.includes("var") || !startsWithDashOrLetter) return value;
    const letterVal = value.toUpperCase();
    const isNegative = letterVal.slice(0, 1) === "-" ? "-" : "";
    let absValue = isNegative ? letterVal.slice(1) : letterVal;
    let mediaName = "";
    if (absValue.includes("_")) {
        mediaName = "_" + absValue.split("_")[1].toLowerCase();
        absValue = absValue.split("_")[0];
    }
    const varValue = (v)=>startsWithDashOrLetterRegex.test(v) ? `var(${prefix}${v}${mediaName})` : v;
    if (absValue.includes("+")) {
        const [first, second] = absValue.split("+");
        const joint = `${varValue(first)} + ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    } else if (absValue.includes("*")) {
        const [first, second] = absValue.split("*");
        const joint = `${varValue(first)} * ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    } else if (absValue.includes("-")) {
        // TODO: check this
        // check for the first char
        const [first, second] = absValue.split("-");
        const joint = `${varValue(first)} - ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    }
    // if subsequence is not set but value is applied
    if (!sequence[absValue] && absValue.length === 2) {
        if (CONFIG.verbose) console.warn(absValue, "- value is not found because `subSequence` is set to false");
        absValue = absValue.slice(0, 1);
    }
    if (useVariable || CONFIG.useVariable) {
        const varValue = `var(${prefix}${absValue}${mediaName})`;
        return isNegative ? `calc(${varValue} * -1)` : varValue;
    }
    const sequenceItem = sequence ? sequence[absValue] : null;
    if (!sequenceItem) return console.warn("can't find", sequence, absValue);
    if (unit === "ms" || unit === "s") return isNegative + sequenceItem.val + unit;
    return isNegative + sequenceItem.scaling + unit;
};
const $366218d35fdab076$export$86c0052f25dacc45 = (value, propertyName, sequenceProps)=>{
    if (typeof value !== "string") {
        console.warn(propertyName, value, "is not a string");
        return {
            [propertyName]: value
        };
    }
    if (value === "-" || value === "") return {};
    return {
        [propertyName]: $366218d35fdab076$export$efde09b5692f9bd0(value, sequenceProps)
    };
};
const $366218d35fdab076$export$14c834a042d41297 = (h1Matches, index)=>$366218d35fdab076$export$81ab9dc24d52c4ba[h1Matches - index];
const $366218d35fdab076$export$8dc77c00fe04c40a = (propertyNames)=>{
    const { h1Matches: h1Matches, sequence: sequence } = propertyNames;
    return new Array(6).fill(null).map((_, i)=>{
        const findLetter = $366218d35fdab076$export$14c834a042d41297(h1Matches, i);
        return sequence[findLetter];
    });
};


var $313f46bb97bb8cbe$exports = {};

$parcel$export($313f46bb97bb8cbe$exports, "setVariables", () => $313f46bb97bb8cbe$export$7c38483ff47439d8);
$parcel$export($313f46bb97bb8cbe$exports, "applySequenceGlobalVars", () => $313f46bb97bb8cbe$export$eba6b21fdce78bcd);
$parcel$export($313f46bb97bb8cbe$exports, "applySequenceVars", () => $313f46bb97bb8cbe$export$97ab4e7d8ade5018);
$parcel$export($313f46bb97bb8cbe$exports, "applyMediaSequenceVars", () => $313f46bb97bb8cbe$export$768e417cbfe71417);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");



"use strict";
const $313f46bb97bb8cbe$export$7c38483ff47439d8 = (result, key)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { CSS_VARS: CSS_VARS } = CONFIG;
    if ((0, $EqHTq.isObjectLike)(result.value)) ;
    else CSS_VARS[result.var] = result.value;
};
const $313f46bb97bb8cbe$export$eba6b21fdce78bcd = (vars, obj, options)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { UNIT: UNIT } = CONFIG;
    const unit = obj.unit || UNIT.default;
    const { base: base, ratio: ratio, type: type } = obj;
    const prefix = "--" + (type && type.replace(".", "-"));
    vars[`${prefix}-base`] = base;
    vars[`${prefix}-unit`] = unit;
    const ratioVar = `${prefix}-ratio`;
    vars[ratioVar] = ratio;
    const [first, middle, second] = (0, $366218d35fdab076$export$50db87b17b1557b4)(base, ratio);
    vars[`${prefix}-sub-ratio-1`] = `calc(var(${prefix}-ratio) * ${first / ratio})`;
    vars[`${prefix}-sub-ratio-2`] = `calc(var(${prefix}-ratio) * ${middle / ratio})`;
    vars[`${prefix}-sub-ratio-3`] = `calc(var(${prefix}-ratio) * ${second / ratio})`;
// vars[`${prefix}-sub-ratio-1`] = first
// vars[`${prefix}-sub-ratio-2`] = middle
// vars[`${prefix}-sub-ratio-3`] = second
};
const $313f46bb97bb8cbe$export$97ab4e7d8ade5018 = (FACTORY, options = {})=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { UNIT: UNIT, TIMING: TIMING, CSS_VARS: CSS_VARS } = CONFIG;
    const unit = FACTORY.unit || UNIT.default;
    const { mediaRegenerate: mediaRegenerate, sequence: sequence, scales: scales } = FACTORY;
    if (!mediaRegenerate) $313f46bb97bb8cbe$export$eba6b21fdce78bcd(CSS_VARS, FACTORY, options);
    for(const key in sequence){
        const item = sequence[key];
        const value = (FACTORY.type === TIMING.type ? sequence[key].val : scales[key]) + unit;
        if (!mediaRegenerate) {
            CSS_VARS[item.variable + "_default"] = value;
            CSS_VARS[item.variable] = item.scalingVariable;
            continue;
        }
        if (options.useDefault === false) CSS_VARS[item.variable] = value;
        else {
            CSS_VARS[item.variable + "_default"] = value;
            CSS_VARS[item.variable] = `var(${item.variable + "_default"})`;
        }
    }
};
const $313f46bb97bb8cbe$export$768e417cbfe71417 = (FACTORY, media, options = {})=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { UNIT: UNIT, MEDIA: MEDIA, CSS_VARS: CSS_VARS } = CONFIG;
    const mediaName = media.slice(1);
    const unit = FACTORY.unit || UNIT.default;
    const { mediaRegenerate: mediaRegenerate } = FACTORY;
    const { sequence: sequence, scales: scales } = FACTORY[media];
    const query = MEDIA[mediaName];
    if (!query && CONFIG.verbose) console.warn("Can't find media query ", query);
    // if mediaRegenerate is not applied ratio and and sequence sizes
    // will be applied using CSS vars
    if (!mediaRegenerate) {
        let underMediaQuery = CSS_VARS[`@media ${query}`];
        if (!underMediaQuery) underMediaQuery = CSS_VARS[`@media ${query}`] = {};
        $313f46bb97bb8cbe$export$eba6b21fdce78bcd(underMediaQuery, FACTORY[media], options);
        return;
    }
    for(const key in sequence){
        const item = sequence[key];
        const value = ((0, $18dbdacc7a38df0d$export$6a836bb704f10b75)(unit) ? scales[key] : sequence[key].val) + unit;
        if (!query && CONFIG.verbose) console.warn("Can't find query ", query);
        let underMediaQuery = CSS_VARS[`@media ${query}`];
        if (!underMediaQuery) underMediaQuery = CSS_VARS[`@media ${query}`] = {};
        underMediaQuery[item.variable] = `var(${item.variable + "_" + mediaName})`;
        CSS_VARS[item.variable + "_" + mediaName] = value;
    }
};


var $da07070d258f49a5$exports = {};

$parcel$export($da07070d258f49a5$exports, "generateSprite", () => $da07070d258f49a5$export$121b8d85aca89bf6);
$parcel$export($da07070d258f49a5$exports, "convertSvgToSymbol", () => $da07070d258f49a5$export$510fb280711ea968);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $da07070d258f49a5$export$121b8d85aca89bf6 = (icons)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    let sprite = "";
    for(const key in icons){
        if (CONFIG.__svg_cache[key]) continue;
        else CONFIG.__svg_cache[key] = true;
        sprite += icons[key];
    }
    return sprite;
};
const $da07070d258f49a5$var$parseRootAttributes = (htmlString)=>{
    if (!(0, $EqHTq.isString)(htmlString)) return console.warn(`parseRootAttributes: ${htmlString} is not a string`);
    const match = htmlString.match(/<svg\s+(.*?)>/);
    if (!match || !match[1]) return {};
    const attrString = match[1];
    const attrs = attrString.match(/(\S+)=["']?((?:.(?!["']?\s+(?:\S+)=|\s*\/?[>"']))+.)["']?/gm);
    return attrs.reduce((acc, attr)=>{
        const [key, value] = attr.split("=");
        acc[key] = value.replace(/['"]/g, "");
        return acc;
    }, {});
};
const $da07070d258f49a5$var$replaceIdsAndUrls = (code, key)=>{
    const idRegex = /id="([^"]*)"/;
    const urlRegex = /url\(#([^)]*)\)/g;
    const matches = code.match(/id="([^"]*)"/g);
    let replacedCode = code;
    if ((0, $EqHTq.isArray)(matches)) matches.forEach(()=>{
        const randomKey = Math.floor(Math.random() * 100000);
        replacedCode = code.replace(idRegex, `id="${key}-${randomKey}"`).replace(urlRegex, `url(#${key}-${randomKey})`);
    });
    return replacedCode;
};
const $da07070d258f49a5$export$510fb280711ea968 = (key, code)=>{
    const extractAttrs = $da07070d258f49a5$var$parseRootAttributes(code);
    const { width: width, height: height } = extractAttrs;
    const viewBox = extractAttrs.viewBox || `0 0 ${width || 24} ${height || 24}`;
    const xmlns = "http://www.w3.org/2000/svg";
    const replacedCode = $da07070d258f49a5$var$replaceIdsAndUrls(code, key);
    let symbol = replacedCode.replace("<svg", `<symbol id="${key}" xmlns="${xmlns}" viewBox="${viewBox}"`);
    symbol = symbol.replace(/width="[^"]*"/, "");
    symbol = symbol.replace(/height="[^"]*"/, "");
    symbol = symbol.replace("</svg", "</symbol");
    return symbol;
};


"use strict";
$parcel$exportWildcard($75f36cb383311abc$exports, $18dbdacc7a38df0d$exports);
$parcel$exportWildcard($75f36cb383311abc$exports, $1ef99b0b26632769$exports);
$parcel$exportWildcard($75f36cb383311abc$exports, $08f037a4512e32ac$exports);
$parcel$exportWildcard($75f36cb383311abc$exports, $acb660e77bec9cb5$exports);
$parcel$exportWildcard($75f36cb383311abc$exports, $366218d35fdab076$exports);
$parcel$exportWildcard($75f36cb383311abc$exports, $313f46bb97bb8cbe$exports);
$parcel$exportWildcard($75f36cb383311abc$exports, $da07070d258f49a5$exports);


var $30c1eb8bbbe7b5d7$exports = {};
var $c6753c52b98cd54e$exports = {};

$parcel$export($c6753c52b98cd54e$exports, "getColor", () => $c6753c52b98cd54e$export$5551a2d24ff40153);
$parcel$export($c6753c52b98cd54e$exports, "getMediaColor", () => $c6753c52b98cd54e$export$dd72f6d9deea7207);
$parcel$export($c6753c52b98cd54e$exports, "setColor", () => $c6753c52b98cd54e$export$130a5dc1bc9cd8e1);
$parcel$export($c6753c52b98cd54e$exports, "setGradient", () => $c6753c52b98cd54e$export$afaa8352c6a43a44);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");


"use strict";
const $c6753c52b98cd54e$export$5551a2d24ff40153 = (value, key, config)=>{
    const CONFIG = config || (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if (!(0, $EqHTq.isString)(value)) {
        if (CONFIG.verbose) console.warn(value, "- type for color is not valid");
        return;
    }
    if (value.slice(0, 2) === "--") return `var(${value})`;
    if (key && value[key]) value = value[key];
    const [name, alpha, tone] = (0, $EqHTq.isArray)(value) ? value : value.split(" ");
    const { COLOR: COLOR, GRADIENT: GRADIENT } = CONFIG;
    let val = COLOR[name] || GRADIENT[name];
    if (!val) {
        if (CONFIG.verbose) console.warn("Can't find color ", name);
        return value;
    }
    if (key) {
        if (val[key]) val = val[key];
        else if (CONFIG.verbose) console.warn(value, " - does not have ", key);
    }
    // TODO: support variables
    // if (alpha) return `rgba(var(${val[shade || ''].var}), ${modifier})`
    let rgb = val.rgb;
    if (!rgb) return CONFIG.useVariable ? `var(${val.var})` : val.value;
    if (tone && !val[tone]) {
        rgb = (0, $1ef99b0b26632769$export$2d78fefdcfb7f222)(rgb, tone);
        val[tone] = {
            rgb: rgb,
            var: `${val.var}-${tone}`
        };
    }
    if (val[tone]) rgb = val[tone].rgb;
    if (alpha) return `rgba(${rgb}, ${alpha})`;
    return CONFIG.useVariable ? `var(${val.var})` : `rgb(${rgb})`;
};
const $c6753c52b98cd54e$export$dd72f6d9deea7207 = (value, globalTheme, config)=>{
    const CONFIG = config || (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if (!globalTheme) globalTheme = CONFIG.globalTheme;
    if (!(0, $EqHTq.isString)(value)) {
        if (CONFIG.verbose) console.warn(value, "- type for color is not valid");
        return;
    }
    if (value.slice(0, 2) === "--") return `var(${value})`;
    const [name] = (0, $EqHTq.isArray)(value) ? value : value.split(" ");
    const { COLOR: COLOR, GRADIENT: GRADIENT } = CONFIG;
    const val = COLOR[name] || GRADIENT[name];
    const isObj = (0, $EqHTq.isObject)(val);
    if (isObj && val.value) return $c6753c52b98cd54e$export$5551a2d24ff40153(value, `@${globalTheme}`, config);
    else if (isObj) {
        if (globalTheme) return $c6753c52b98cd54e$export$5551a2d24ff40153(value, `@${globalTheme}`, config);
        else {
            const obj = {};
            for(const mediaName in val){
                const query = CONFIG.MEDIA[mediaName.slice(1)];
                const media = `@media screen and ${query}`;
                obj[media] = $c6753c52b98cd54e$export$5551a2d24ff40153(value, mediaName, config);
            }
            return obj;
        }
    } else {
        if (CONFIG.verbose) console.warn("Can't find color", value);
        return value;
    }
};
const $c6753c52b98cd54e$export$130a5dc1bc9cd8e1 = (val, key, suffix)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if ((0, $EqHTq.isString)(val) && val.slice(0, 2) === "--") val = $c6753c52b98cd54e$export$5551a2d24ff40153(val.slice(2));
    if ((0, $EqHTq.isArray)(val)) return {
        "@light": $c6753c52b98cd54e$export$130a5dc1bc9cd8e1(val[0], key, "light"),
        "@dark": $c6753c52b98cd54e$export$130a5dc1bc9cd8e1(val[1], key, "dark")
    };
    if ((0, $EqHTq.isObject)(val)) {
        const obj = {};
        for(const variant in val)obj[variant] = $c6753c52b98cd54e$export$130a5dc1bc9cd8e1(val[variant], key, variant.slice(0, 1) === "@" ? variant.slice(1) : variant);
        return obj;
    }
    const CSSVar = `--color-${key}` + (suffix ? `-${suffix}` : "");
    const [r, g, b, a = 1] = (0, $1ef99b0b26632769$export$fa32e9c99a43479e)(val.value || val);
    const alpha = parseFloat(a.toFixed(2));
    const rgb = `${r}, ${g}, ${b}`;
    const value = `rgba(${rgb}, ${alpha})`;
    if (CONFIG.useVariable) CONFIG.CSS_VARS[CSSVar] = value;
    return {
        var: CSSVar,
        rgb: rgb,
        alpha: alpha,
        value: value
    };
};
const $c6753c52b98cd54e$export$afaa8352c6a43a44 = (val, key, suffix)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if ((0, $EqHTq.isString)(val) && val.slice(0, 2) === "--") val = $c6753c52b98cd54e$export$5551a2d24ff40153(val.slice(2));
    if ((0, $EqHTq.isArray)(val)) return {
        "@light": $c6753c52b98cd54e$export$afaa8352c6a43a44(val[0], key, "light"),
        "@dark": $c6753c52b98cd54e$export$afaa8352c6a43a44(val[0], key, "dark")
    };
    if ((0, $EqHTq.isObject)(val)) {
        const obj = {};
        for(const variant in val)obj[variant] = $c6753c52b98cd54e$export$afaa8352c6a43a44(val[variant], key, variant.slice(0, 1) === "@" ? variant.slice(1) : variant);
        return obj;
    }
    const CSSVar = `--gradient-${key}` + (suffix ? `-${suffix}` : "");
    if (CONFIG.useVariable) CONFIG.CSS_VARS[CSSVar] = val.value || val;
    return {
        var: CSSVar,
        value: val.value || val
    };
};


var $50bcf74814855f89$exports = {};

$parcel$export($50bcf74814855f89$exports, "getTheme", () => $50bcf74814855f89$export$89cbf1a0881c8b9c);
$parcel$export($50bcf74814855f89$exports, "getMediaTheme", () => $50bcf74814855f89$export$b3cf7317de2f2233);
$parcel$export($50bcf74814855f89$exports, "setTheme", () => $50bcf74814855f89$export$2e49b867b7a0847c);
$parcel$export($50bcf74814855f89$exports, "setMediaTheme", () => $50bcf74814855f89$export$c57b11cd015ce162);


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $50bcf74814855f89$var$setThemeValue = (theme)=>{
    const value = {};
    const { state: state, media: media, helpers: helpers, ...rest } = theme;
    const keys = Object.keys(rest);
    keys.map((key)=>{
        const conditions = [
            "color",
            "Color",
            "background",
            "border"
        ];
        const isColor = conditions.some((k)=>key.includes(k));
        return value[key] = isColor ? (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(theme[key]) : theme[key];
    });
    return value;
};
const $50bcf74814855f89$var$getThemeValue = (theme)=>{
    if (theme.value) return theme.value;
    theme.value = $50bcf74814855f89$var$setThemeValue(theme);
    return theme.value;
};
const $50bcf74814855f89$export$89cbf1a0881c8b9c = (value, modifier)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if (CONFIG.useVariable) return $50bcf74814855f89$export$b3cf7317de2f2233(value, modifier);
    const { THEME: THEME } = CONFIG;
    if ((0, $EqHTq.isString)(value)) {
        const [theme, subtheme] = value.split(" ");
        const isOurTheme = THEME[theme];
        if (isOurTheme) {
            if (!subtheme && !modifier) return $50bcf74814855f89$var$getThemeValue(isOurTheme);
            value = [
                theme,
                subtheme || modifier
            ];
        }
    }
    if ((0, $EqHTq.isObjectLike)(value) && value[1]) {
        const themeName = value[0];
        const subThemeName = value[1];
        const { helpers: helpers, media: media, state: state } = THEME[themeName];
        if (media && media[subThemeName]) return $50bcf74814855f89$var$getThemeValue(media[subThemeName]);
        if (helpers && helpers[subThemeName]) return $50bcf74814855f89$var$getThemeValue(helpers[subThemeName]);
        if (state && state[subThemeName]) return $50bcf74814855f89$var$getThemeValue(state[subThemeName]);
    } else if ((0, $EqHTq.isObject)(value)) return $50bcf74814855f89$var$setThemeValue(value);
};
const $50bcf74814855f89$var$setInverseTheme = (theme, variant, value)=>{
    if ((0, $EqHTq.isObject)(variant)) theme.variants.inverse.value = $50bcf74814855f89$var$setThemeValue(variant);
    else if (variant === true) {
        const { color: color, background: background } = value;
        theme.variants.inverse = {
            value: {
                color: background,
                background: color
            }
        };
    }
};
const $50bcf74814855f89$var$setPseudo = (theme, key, variant, themeValue)=>{
    const result = $50bcf74814855f89$export$89cbf1a0881c8b9c(variant);
    themeValue[`&:${key}`] = result;
    if ((0, $EqHTq.isObject)(variant) && !variant.value) variant.value = result;
};
const $50bcf74814855f89$var$setSelectors = (theme, value)=>{
    const { state: state } = theme;
    if (!state) return;
    const keys = Object.keys(state);
    keys.map((key)=>{
        const variant = state[key];
        $50bcf74814855f89$var$setPseudo(theme, key, variant, value);
        return theme;
    });
    return theme;
};
const $50bcf74814855f89$var$setPrefersScheme = (theme, key, variant, themeValue)=>{
    const result = $50bcf74814855f89$export$89cbf1a0881c8b9c(variant);
    themeValue[`@media (prefers-color-scheme: ${key})`] = result;
    if ((0, $EqHTq.isObject)(variant) && !variant.value) variant.value = result;
};
const $50bcf74814855f89$var$setMedia = (theme, value)=>{
    const { media: media } = theme;
    if (!media) return;
    const keys = Object.keys(media);
    keys.map((key)=>{
        const variant = media[key];
        if (key === "dark" || key === "light") $50bcf74814855f89$var$setPrefersScheme(theme, key, variant, value);
        if (key === "inverse") $50bcf74814855f89$var$setInverseTheme(theme, variant, value);
        return theme;
    });
    return theme;
};
const $50bcf74814855f89$var$setHelpers = (theme, value)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { helpers: helpers } = theme;
    if (!helpers) return;
    const keys = Object.keys(helpers);
    keys.map((key)=>{
        const helper = helpers[key];
        if ((0, $EqHTq.isString)(helper)) helpers[key] = CONFIG.THEME[helper];
        else $50bcf74814855f89$var$getThemeValue(helpers[key]);
        return theme;
    });
    return theme;
};
const $50bcf74814855f89$export$2e49b867b7a0847c = (val, key)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if (CONFIG.useVariable) return $50bcf74814855f89$export$c57b11cd015ce162(val, key);
    const { state: state, media: media, helpers: helpers } = val;
    const value = $50bcf74814855f89$var$setThemeValue(val, key);
    const CSSvar = `--theme-${key}`;
    $50bcf74814855f89$var$setSelectors(val, value);
    $50bcf74814855f89$var$setMedia(val, value);
    $50bcf74814855f89$var$setHelpers(val, value);
    return {
        var: CSSvar,
        value: value,
        state: state,
        media: media,
        helpers: helpers
    };
};
const $50bcf74814855f89$var$keySetters = {
    "@": (theme, value)=>$50bcf74814855f89$var$setMedia(theme, value),
    ":": (theme, value)=>$50bcf74814855f89$var$setSelectors(theme, value),
    ".": (theme, value)=>$50bcf74814855f89$var$setHelpers(theme, value)
};
const $50bcf74814855f89$export$c57b11cd015ce162 = (val, key, suffix, prefers)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { CSS_VARS: CSS_VARS } = CONFIG;
    const theme = {
        value: val
    };
    if ((0, $EqHTq.isObjectLike)(val)) {
        for(const param in val){
            const symb = param.slice(0, 1);
            const value = val[param];
            if (symb === "@" || symb === ":" || symb === ".") {
                const hasPrefers = symb === "@" && param;
                theme[param] = $50bcf74814855f89$export$c57b11cd015ce162(value, key, param, prefers || hasPrefers);
            } else {
                const color = (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(value, prefers);
                const metaSuffixes = [
                    ...new Set([
                        prefers,
                        suffix
                    ].filter((v)=>v).map((v)=>v.slice(1)))
                ];
                const varmetaSuffixName = metaSuffixes.length ? "-" + metaSuffixes.join("-") : "";
                const CSSVar = `--theme-${key}${varmetaSuffixName}-${param}`;
                if (CONFIG.useVariable) {
                    CSS_VARS[CSSVar] = color;
                    theme[param] = `var(${CSSVar})`;
                } else theme[param] = color;
                theme[`.${param}`] = {
                    [param]: theme[param]
                };
            }
        }
        if (theme.background || theme.color || theme.backgroundColor) theme[".inversed"] = {
            color: theme.background || theme.backgroundColor,
            background: theme.color
        };
    }
    if ((0, $EqHTq.isString)(val) && val.slice(0, 2) === "--") {
        const { THEME: THEME } = CONFIG;
        const value = THEME[val.slice(2)];
        const getReferenced = $50bcf74814855f89$export$b3cf7317de2f2233(value, prefers);
        return getReferenced;
    }
    return theme;
};
const $50bcf74814855f89$var$recursiveTheme = (val)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const obj = {};
    for(const param in val){
        const symb = param.slice(0, 1);
        if ((0, $EqHTq.isObjectLike)(val[param])) {
            if (symb === "@") {
                const query = CONFIG.MEDIA[param.slice(1)];
                const media = `@media screen and ${query}`;
                obj[media] = $50bcf74814855f89$var$recursiveTheme(val[param]);
            } else if (symb === ":") obj[`&${param}`] = $50bcf74814855f89$var$recursiveTheme(val[param]);
        } else obj[param] = val[param];
    }
    return obj;
};
const $50bcf74814855f89$var$findModifierFromArray = (val, modifierArray)=>{
    const currentMod = modifierArray.shift();
    if (val[currentMod]) return $50bcf74814855f89$var$findModifierFromArray(val[currentMod], modifierArray);
    return val;
};
const $50bcf74814855f89$var$findModifier = (val, modifier)=>{
    if ((0, $EqHTq.isArray)(modifier)) return $50bcf74814855f89$var$findModifierFromArray(val, modifier);
    else if ((0, $EqHTq.isString)(modifier) && val[modifier]) return val[modifier];
    else return val;
};
const $50bcf74814855f89$var$checkForReference = (val, callback)=>{
    if ((0, $EqHTq.isString)(val) && val.slice(0, 2) === "--") return $50bcf74814855f89$export$b3cf7317de2f2233(val.slice(2));
    return val;
};
const $50bcf74814855f89$var$checkThemeReference = (val)=>$50bcf74814855f89$var$checkForReference(val, $50bcf74814855f89$var$checkThemeReference) // eslint-disable-line
;
const $50bcf74814855f89$export$b3cf7317de2f2233 = (value, modifier)=>{
    const activeConfig = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if ((0, $EqHTq.isString)(value) && value.slice(0, 2) === "--") value = $50bcf74814855f89$export$b3cf7317de2f2233(value.slice(2));
    if (!value || !(0, $EqHTq.isString)(value)) {
        if (activeConfig.verbose) console.warn(`${value} - Theme is not a string`);
        return;
    }
    const [themeName, ...themeModifiers] = (0, $EqHTq.isArray)(value) ? value : value.split(" ");
    let themeValue = activeConfig.THEME[themeName];
    if (themeValue && (themeModifiers || modifier)) themeValue = $50bcf74814855f89$var$findModifier(themeValue, themeModifiers.length ? themeModifiers : modifier);
    const resolvedTheme = $50bcf74814855f89$var$recursiveTheme(themeValue);
    return resolvedTheme;
};


var $ed362cf167c3740b$exports = {};

$parcel$export($ed362cf167c3740b$exports, "setFont", () => $ed362cf167c3740b$export$69e9bdef456a9c46);
$parcel$export($ed362cf167c3740b$exports, "getFontFamily", () => $ed362cf167c3740b$export$c4930fc256cef44f);
$parcel$export($ed362cf167c3740b$exports, "setFontFamily", () => $ed362cf167c3740b$export$5fae120d779aafec);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");



"use strict";
const $ed362cf167c3740b$export$69e9bdef456a9c46 = (val, key)=>{
    const CSSvar = `--font-${key}`;
    if (!val || (0, $EqHTq.isArray)(val) && !val[0]) return;
    const fontFace = val[0] ? (0, $acb660e77bec9cb5$export$198e04e3616f042a)(key, val) : (0, $acb660e77bec9cb5$export$2593ac3417be5ed7)(key, val.url);
    return {
        var: CSSvar,
        value: val,
        fontFace: fontFace
    };
};
const $ed362cf167c3740b$export$c4930fc256cef44f = (key, factory)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { FONT_FAMILY: FONT_FAMILY } = CONFIG;
    return (0, $acb660e77bec9cb5$export$73aa7d12a2d2fb83)(factory || FONT_FAMILY, key);
};
const $ed362cf167c3740b$export$5fae120d779aafec = (val, key)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { FONT_FAMILY: FONT_FAMILY, FONT_FAMILY_TYPES: FONT_FAMILY_TYPES } = CONFIG;
    let { value: value, type: type } = val;
    if (val.isDefault) FONT_FAMILY.default = key;
    if ((0, $EqHTq.isObject)(value)) value = (0, $8319f99b46b296c9$export$d1ef4b1a340dec10)(value);
    const CSSvar = `--font-family-${key}`;
    const str = `${value.join(", ")}, ${FONT_FAMILY_TYPES[type]}`;
    return {
        var: CSSvar,
        value: str,
        arr: value,
        type: type
    };
};


var $277afaefb2791215$exports = {};

$parcel$export($277afaefb2791215$exports, "runThroughMedia", () => $277afaefb2791215$export$ee622839cb6e2b5d);
$parcel$export($277afaefb2791215$exports, "applyHeadings", () => $277afaefb2791215$export$7fc39a69c6299a60);
$parcel$export($277afaefb2791215$exports, "applyTypographySequence", () => $277afaefb2791215$export$7c7d7b0d076fe8b5);
$parcel$export($277afaefb2791215$exports, "getFontSizeByKey", () => $277afaefb2791215$export$ea9b2cd64205746b);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");


"use strict";
const $277afaefb2791215$export$ee622839cb6e2b5d = (FACTORY)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { TYPOGRAPHY: TYPOGRAPHY, MEDIA: MEDIA } = CONFIG;
    for(const prop in FACTORY){
        const isPropMedia = prop.slice(0, 1) === "@";
        const mediaValue = FACTORY[prop];
        if (!isPropMedia) continue;
        const { mediaRegenerate: mediaRegenerate } = FACTORY;
        const mediaName = prop.slice(1);
        const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence, h1Matches: h1Matches, unit: unit } = FACTORY;
        (0, $8wu6n.merge)(mediaValue, {
            type: type,
            base: base,
            ratio: ratio,
            range: range,
            subSequence: subSequence,
            h1Matches: h1Matches,
            unit: unit
        });
        const query = MEDIA[mediaName];
        TYPOGRAPHY.templates[`@media screen and ${query}`] = {
            fontSize: mediaValue.base / TYPOGRAPHY.browserDefault + unit
        };
        if (!mediaRegenerate) {
            (0, $313f46bb97bb8cbe$export$768e417cbfe71417)(FACTORY, prop);
            continue;
        }
        (0, $8wu6n.merge)(mediaValue, {
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        });
        (0, $366218d35fdab076$export$29708af739d9b0fc)(mediaValue);
        (0, $313f46bb97bb8cbe$export$768e417cbfe71417)(FACTORY, prop);
    }
};
const $277afaefb2791215$export$7fc39a69c6299a60 = (props)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if (props.h1Matches) {
        const unit = props.unit;
        const HEADINGS = (0, $366218d35fdab076$export$8dc77c00fe04c40a)(props);
        const { templates: templates } = props;
        for(const k in HEADINGS){
            const headerName = `h${parseInt(k) + 1}`;
            const headerStyle = templates[headerName];
            templates[headerName] = {
                fontSize: CONFIG.useVariable ? `var(${HEADINGS[k].variable})` : `${HEADINGS[k].scaling}${unit}`,
                margin: headerStyle ? headerStyle.margin : 0,
                lineHeight: headerStyle ? headerStyle.lineHeight : props.lineHeight,
                letterSpacing: headerStyle ? headerStyle.letterSpacing : props.letterSpacing,
                fontWeight: headerStyle ? headerStyle.fontWeight : 900 - k * 100
            };
        }
    }
};
const $277afaefb2791215$export$7c7d7b0d076fe8b5 = ()=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { TYPOGRAPHY: TYPOGRAPHY } = CONFIG;
    (0, $366218d35fdab076$export$29708af739d9b0fc)(TYPOGRAPHY);
    $277afaefb2791215$export$7fc39a69c6299a60(TYPOGRAPHY);
    (0, $313f46bb97bb8cbe$export$97ab4e7d8ade5018)(TYPOGRAPHY);
    $277afaefb2791215$export$ee622839cb6e2b5d(TYPOGRAPHY);
};
const $277afaefb2791215$export$ea9b2cd64205746b = (value)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { TYPOGRAPHY: TYPOGRAPHY } = CONFIG;
    return (0, $366218d35fdab076$export$86c0052f25dacc45)(value, "fontSize", TYPOGRAPHY);
};


var $7a9f91e2b97567cc$exports = {};

$parcel$export($7a9f91e2b97567cc$exports, "applySpacingSequence", () => $7a9f91e2b97567cc$export$9bfe8384addafa7c);
$parcel$export($7a9f91e2b97567cc$exports, "getSpacingByKey", () => $7a9f91e2b97567cc$export$4f949d23b5dbefe6);
$parcel$export($7a9f91e2b97567cc$exports, "getSpacingBasedOnRatio", () => $7a9f91e2b97567cc$export$94679ba49f16fc2e);

parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $8wu6n = parcelRequire("8wu6n");


"use strict";
const $7a9f91e2b97567cc$var$runThroughMedia = (FACTORY)=>{
    for(const prop in FACTORY){
        const mediaProps = FACTORY[prop];
        const isMediaName = prop.slice(0, 1) === "@";
        if (!isMediaName) continue;
        const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence, h1Matches: h1Matches, unit: unit } = FACTORY;
        (0, $8wu6n.merge)(mediaProps, {
            type: type,
            base: base,
            ratio: ratio,
            range: range,
            subSequence: subSequence,
            h1Matches: h1Matches,
            unit: unit,
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        });
        (0, $366218d35fdab076$export$29708af739d9b0fc)(mediaProps);
        (0, $313f46bb97bb8cbe$export$768e417cbfe71417)(FACTORY, prop);
    }
};
const $7a9f91e2b97567cc$export$9bfe8384addafa7c = ()=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { SPACING: SPACING } = CONFIG;
    (0, $366218d35fdab076$export$29708af739d9b0fc)(SPACING);
    (0, $313f46bb97bb8cbe$export$97ab4e7d8ade5018)(SPACING);
    $7a9f91e2b97567cc$var$runThroughMedia(SPACING);
};
const $7a9f91e2b97567cc$var$getSequence = (sequenceProps)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { SPACING: SPACING } = CONFIG;
    if (!sequenceProps) return SPACING;
    const hasGenerated = Object.keys(sequenceProps.sequence).length > 0;
    return hasGenerated ? sequenceProps : (0, $366218d35fdab076$export$29708af739d9b0fc)(sequenceProps);
};
const $7a9f91e2b97567cc$export$4f949d23b5dbefe6 = (value, propertyName = "padding", sequenceProps)=>{
    const sequence = $7a9f91e2b97567cc$var$getSequence(sequenceProps);
    if ((0, $EqHTq.isString)(value) && (value.includes("calc") || value.includes("var"))) return {
        [propertyName]: value
    };
    const stack = (0, $8319f99b46b296c9$export$d1ef4b1a340dec10)(value);
    if (!(0, $EqHTq.isArray)(stack)) return;
    if (stack.length > 1) {
        let suffix = "";
        if (propertyName === "borderWidth") {
            propertyName = "border";
            suffix = "Width";
        }
        const directions = {
            2: [
                "Block",
                "Inline"
            ],
            3: [
                "BlockStart",
                "Inline",
                "BlockEnd"
            ],
            4: [
                "BlockStart",
                "InlineEnd",
                "BlockEnd",
                "InlineStart"
            ]
        };
        const wrapSequenceValueByDirection = (direction, i)=>(0, $366218d35fdab076$export$86c0052f25dacc45)(stack[i], propertyName + direction + suffix, sequence);
        return directions[stack.length].map((dir, key)=>wrapSequenceValueByDirection(dir, key));
    }
    return (0, $366218d35fdab076$export$86c0052f25dacc45)(value, propertyName, sequence);
};
const $7a9f91e2b97567cc$export$94679ba49f16fc2e = (props, propertyName, val)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { SPACING: SPACING } = CONFIG;
    const { spacingRatio: spacingRatio, unit: unit } = props;
    const value = val || props[propertyName];
    if (spacingRatio) {
        let sequenceProps = SPACING[spacingRatio];
        if (!sequenceProps) {
            const { type: type, base: base, range: range, subSequence: subSequence } = SPACING;
            sequenceProps = SPACING[spacingRatio] = (0, $8wu6n.merge)({
                ratio: spacingRatio,
                type: type + "-" + spacingRatio,
                unit: unit,
                sequence: {},
                scales: {},
                templates: {},
                vars: {}
            }, {
                base: base,
                range: range,
                subSequence: subSequence,
                ratio: SPACING.ratio,
                unit: SPACING.unit
            });
        }
        (0, $313f46bb97bb8cbe$export$97ab4e7d8ade5018)(sequenceProps, {
            useDefault: false
        });
        return $7a9f91e2b97567cc$export$4f949d23b5dbefe6(value, propertyName, sequenceProps);
    }
    return $7a9f91e2b97567cc$export$4f949d23b5dbefe6(value, propertyName);
};


var $4a7f8e4f20ce09e5$exports = {};

$parcel$export($4a7f8e4f20ce09e5$exports, "setShadow", () => $4a7f8e4f20ce09e5$export$9cd3672191b5a46f);
$parcel$export($4a7f8e4f20ce09e5$exports, "getShadow", () => $4a7f8e4f20ce09e5$export$db93b77dbb14f011);



parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $4a7f8e4f20ce09e5$export$9cd3672191b5a46f = (value, key, suffix, prefers)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    // const { CSS_VARS } = CONFIG
    // const theme = { valueue: value }
    if ((0, $EqHTq.isArray)(value)) return {
        "@light": $4a7f8e4f20ce09e5$export$9cd3672191b5a46f(value[0], key, "light"),
        "@dark": $4a7f8e4f20ce09e5$export$9cd3672191b5a46f(value[1], key, "dark")
    };
    if ((0, $EqHTq.isObject)(value)) {
        const obj = {};
        for(const variant in value)obj[variant] = $4a7f8e4f20ce09e5$export$9cd3672191b5a46f(value[variant], key, variant.startsWith("@") ? variant.slice(1) : variant);
        return obj;
    }
    if ((0, $EqHTq.isString)(value) && value.includes(",")) value = value.split(",").map((v)=>{
        v = v.trim();
        if (v.startsWith("--")) return `var(${v})`;
        if ((0, $c6753c52b98cd54e$export$5551a2d24ff40153)(v).length > 2) return (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(v);
        if (v.includes("px") || v.slice(-2) === "em") return v;
        const arr = v.split(" ");
        if (!arr.length) return v;
        return arr.map((v)=>(0, $7a9f91e2b97567cc$export$4f949d23b5dbefe6)(v, "shadow").shadow).join(" ");
    }).join(" ");
    const CSSVar = `--shadow-${key}` + (suffix ? `-${suffix}` : "");
    if (CONFIG.useVariable) CONFIG.CSS_VARS[CSSVar] = value;
    return {
        var: CSSVar,
        value: value
    };
};
const $4a7f8e4f20ce09e5$export$db93b77dbb14f011 = (value, globalTheme)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if (!globalTheme) globalTheme = CONFIG.globalTheme;
    if (!(0, $EqHTq.isString)(value)) {
        if (CONFIG.verbose) console.warn(value, "- type for color is not valid");
        return;
    }
    if (value.slice(0, 2) === "--") return `var(${value})`;
    const [name] = (0, $EqHTq.isArray)(value) ? value : value.split(" ");
    const { SHADOW: SHADOW } = CONFIG;
    const val = SHADOW[name];
    const isObj = (0, $EqHTq.isObject)(val);
    if (!val) {
        if (CONFIG.verbose) console.warn("Can't find color ", name);
        return value;
    }
    if (globalTheme) {
        if (val[globalTheme]) return val[globalTheme].value;
        else if (CONFIG.verbose) console.warn(value, " - does not have ", globalTheme);
    }
    if (isObj && val.value) return val.value;
    if (isObj) {
        const obj = {};
        for(const mediaName in val){
            const query = CONFIG.MEDIA[mediaName.slice(1)];
            const media = `@media screen and ${query}`;
            obj[media] = val.value;
        }
        return obj;
    }
    if (CONFIG.verbose) console.warn("Can't find color", value);
    return value;
};


var $200bfc3872a6d81d$exports = {};

$parcel$export($200bfc3872a6d81d$exports, "applyTimingSequence", () => $200bfc3872a6d81d$export$a5be618f63a441ac);
$parcel$export($200bfc3872a6d81d$exports, "getTimingFunction", () => $200bfc3872a6d81d$export$23ba66c7c3e2e613);
$parcel$export($200bfc3872a6d81d$exports, "getTimingByKey", () => $200bfc3872a6d81d$export$3fa311edc5edd22f);



"use strict";
const $200bfc3872a6d81d$export$a5be618f63a441ac = ()=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { TIMING: TIMING } = CONFIG;
    (0, $366218d35fdab076$export$29708af739d9b0fc)(TIMING);
    (0, $313f46bb97bb8cbe$export$97ab4e7d8ade5018)(TIMING);
};
const $200bfc3872a6d81d$export$23ba66c7c3e2e613 = (value)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { TIMING: TIMING } = CONFIG;
    return TIMING[value] || TIMING[(0, $8319f99b46b296c9$export$86f54f62aa7a7514)(value)] || value;
};
const $200bfc3872a6d81d$export$3fa311edc5edd22f = (value, property = "timing")=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { TIMING: TIMING } = CONFIG;
    return (0, $366218d35fdab076$export$86c0052f25dacc45)(value, property, TIMING);
};


var $ffaa6eb4db8ddc52$exports = {};

$parcel$export($ffaa6eb4db8ddc52$exports, "applyDocument", () => $ffaa6eb4db8ddc52$export$25b333cdc54cc186);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");


"use strict";
const $ffaa6eb4db8ddc52$export$25b333cdc54cc186 = ()=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { DOCUMENT: DOCUMENT, FONT_FAMILY: FONT_FAMILY, THEME: THEME, TYPOGRAPHY: TYPOGRAPHY } = CONFIG;
    return (0, $8wu6n.merge)(DOCUMENT, {
        theme: THEME.document,
        fontFamily: (0, $acb660e77bec9cb5$export$73aa7d12a2d2fb83)(FONT_FAMILY),
        fontSize: TYPOGRAPHY.base,
        lineHeight: TYPOGRAPHY.lineHeight
    });
};


var $0475f9d7e694cab2$exports = {};

$parcel$export($0475f9d7e694cab2$exports, "setSVG", () => $0475f9d7e694cab2$export$694c6c574069ebf2);
$parcel$export($0475f9d7e694cab2$exports, "appendSVGSprite", () => $0475f9d7e694cab2$export$2c4662f4a995c568);
$parcel$export($0475f9d7e694cab2$exports, "setIcon", () => $0475f9d7e694cab2$export$33914de34c28be6c);
$parcel$export($0475f9d7e694cab2$exports, "appendIconsSprite", () => $0475f9d7e694cab2$export$6831f47ca12f6d69);

var $aOJ2H = parcelRequire("aOJ2H");


"use strict";
const $0475f9d7e694cab2$var$DEF_OPTIONS = {
    document: $aOJ2H.document
};
const $0475f9d7e694cab2$export$694c6c574069ebf2 = (val, key)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if (!val) {
        if (CONFIG.verbose) console.warn("setSVG: val is not defined", key);
        return;
    }
    if (CONFIG.useSvgSprite) return (0, $da07070d258f49a5$export$510fb280711ea968)(key, val);
    return val;
};
const $0475f9d7e694cab2$export$2c4662f4a995c568 = (LIBRARY, options = $0475f9d7e694cab2$var$DEF_OPTIONS)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const lib = Object.keys(LIBRARY).length ? {} : CONFIG.SVG;
    for(const key in LIBRARY)lib[key] = CONFIG.SVG[key];
    $0475f9d7e694cab2$var$appendSVG(lib, options);
};
const $0475f9d7e694cab2$export$33914de34c28be6c = (val, key)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if (CONFIG.useIconSprite) return $0475f9d7e694cab2$export$694c6c574069ebf2(val, key);
    return val;
};
const $0475f9d7e694cab2$export$6831f47ca12f6d69 = (LIBRARY, options = $0475f9d7e694cab2$var$DEF_OPTIONS)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const lib = Object.keys(LIBRARY).length ? {} : CONFIG.ICONS;
    for(const key in LIBRARY)lib[key] = CONFIG.ICONS[key];
    $0475f9d7e694cab2$var$appendSVG(lib, options);
};
const $0475f9d7e694cab2$var$createSVGSpriteElement = (options = {
    isRoot: true
})=>{
    if (!(0, $aOJ2H.document) || !(0, $aOJ2H.document).createElementNS) return;
    const svgElem = (0, $aOJ2H.document).createElementNS("http://www.w3.org/2000/svg", "svg");
    if (options.isRoot) {
        svgElem.setAttribute("aria-hidden", "true");
        svgElem.setAttribute("width", "0");
        svgElem.setAttribute("height", "0");
        svgElem.setAttribute("style", "position:absolute");
        svgElem.setAttribute("id", "svgSprite");
    }
    return svgElem;
};
const $0475f9d7e694cab2$var$appendSVG = (lib, options = $0475f9d7e694cab2$var$DEF_OPTIONS)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const doc = options.document || (0, $aOJ2H.document);
    if (!doc || !doc.documentElement) {
        if (CONFIG.verbose) console.warn("To append SVG sprites it should be run in browser environment");
        return (0, $da07070d258f49a5$export$121b8d85aca89bf6)(lib);
    }
    const exists = doc.querySelector("#svgSprite");
    const SVGsprite = (0, $da07070d258f49a5$export$121b8d85aca89bf6)(lib);
    if (exists) {
        const tempSVG = $0475f9d7e694cab2$var$createSVGSpriteElement({
            isRoot: false
        });
        // const svgSpriteWithoutRoot = doc.createElement('template')
        tempSVG.innerHTML = SVGsprite;
        exists.append(...tempSVG.children);
    } else {
        const svgSpriteDOM = $0475f9d7e694cab2$var$createSVGSpriteElement();
        if (svgSpriteDOM && svgSpriteDOM.nodeType) {
            svgSpriteDOM.innerHTML = SVGsprite;
            doc.body.prepend(svgSpriteDOM);
        }
    }
};


var $da693abe5a891559$exports = {};

$parcel$export($da693abe5a891559$exports, "applyReset", () => $da693abe5a891559$export$984fb5f73961424e);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");


"use strict";
const $da693abe5a891559$export$984fb5f73961424e = (reset = {})=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { RESET: RESET, TYPOGRAPHY: TYPOGRAPHY, DOCUMENT: DOCUMENT } = CONFIG;
    if (RESET) {
        if (RESET[":root"]) {
            const configReset = RESET;
            const configTemplates = TYPOGRAPHY.templates;
            configReset.body = {
                ...CONFIG.useDocumentTheme ? (0, $50bcf74814855f89$export$b3cf7317de2f2233)("document", `@${CONFIG.globalTheme}`) : {},
                ...configTemplates.body
            };
            configReset.h1 = configTemplates.h1;
            configReset.h2 = configTemplates.h2;
            configReset.h3 = configTemplates.h3;
            configReset.h4 = configTemplates.h4;
            configReset.h5 = configTemplates.h5;
            configReset.h6 = configTemplates.h6;
        }
        const { body: body, ...templates } = TYPOGRAPHY.templates;
        const globalTheme = CONFIG.useDocumentTheme ? (0, $50bcf74814855f89$export$b3cf7317de2f2233)("document", `@${CONFIG.globalTheme}`) : {};
        if (RESET.html) (0, $8wu6n.overwriteDeep)(RESET.html, globalTheme);
        return (0, $8wu6n.deepMerge)((0, $8wu6n.merge)(RESET, reset), {
            html: {
                position: "absolute",
                // overflow: 'hidden',
                width: "100%",
                height: "100%",
                top: "0",
                left: "0",
                margin: "0",
                WebkitFontSmoothing: "subpixel-antialiased",
                scrollBehavior: "smooth",
                ...globalTheme,
                fontSize: TYPOGRAPHY.browserDefault + "px",
                fontFamily: DOCUMENT.fontFamily,
                lineHeight: DOCUMENT.lineHeight
            },
            body: {
                boxSizing: "border-box",
                height: "100%",
                margin: 0,
                fontFamily: DOCUMENT.fontFamily,
                fontSize: TYPOGRAPHY.base / TYPOGRAPHY.browserDefault + CONFIG.UNIT.default,
                ...templates,
                ...body
            },
            // form elements
            fieldset: {
                border: 0,
                padding: 0,
                margin: 0
            },
            "select, input": {
                fontFamily: DOCUMENT.fontFamily
            }
        });
    }
};


"use strict";
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $c6753c52b98cd54e$exports);
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $50bcf74814855f89$exports);
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $ed362cf167c3740b$exports);
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $277afaefb2791215$exports);
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $7a9f91e2b97567cc$exports);
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $4a7f8e4f20ce09e5$exports);
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $200bfc3872a6d81d$exports);
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $ffaa6eb4db8ddc52$exports);
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $0475f9d7e694cab2$exports);
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $da693abe5a891559$exports);






parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");


"use strict";
const $33055954907944f0$var$isBorderStyle = (str)=>[
        "none",
        "hidden",
        "dotted",
        "dashed",
        "solid",
        "double",
        "groove",
        "ridge",
        "inset",
        "outset",
        "initial"
    ].some((v)=>str.includes(v));
const $33055954907944f0$export$ca4ef6ca6dc743f2 = (border)=>{
    const arr = border.split(", ");
    return arr.map((v)=>{
        v = v.trim();
        if (v.slice(0, 2) === "--") return `var(${v})`;
        else if ($33055954907944f0$var$isBorderStyle(v)) return v || "solid";
        else if (v.slice(-2) === "px" || v.slice(-2) === "em") return v // TODO: add map spacing
        ;
        else if ((0, $c6753c52b98cd54e$export$5551a2d24ff40153)(v).length > 2) return (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(v);
        return (0, $7a9f91e2b97567cc$export$4f949d23b5dbefe6)(v, "border").border;
    }).join(" ");
};
const $33055954907944f0$export$8bcd50b221b13db = (stroke)=>{
    return stroke.split(", ").map((v)=>{
        if (v.slice(0, 2) === "--") return `var(${v})`;
        if (v.includes("px")) return v;
        else if ((0, $c6753c52b98cd54e$export$5551a2d24ff40153)(v)) return (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(v);
        return v;
    }).join(" ");
};
const $33055954907944f0$export$837e4beeff9ff924 = (sh, globalTheme)=>(0, $4a7f8e4f20ce09e5$export$db93b77dbb14f011)(sh, globalTheme);
const $33055954907944f0$export$9c296746f296a70 = (shadows)=>shadows.split("|").map((shadow)=>{
        return shadow.split(", ").map((v)=>{
            v = v.trim();
            if (v.slice(0, 2) === "--") return `var(${v})`;
            if ((0, $c6753c52b98cd54e$export$5551a2d24ff40153)(v).length > 2) return (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(v);
            if (v.includes("px") || v.slice(-2) === "em") return v;
            const arr = v.split(" ");
            if (!arr.length) return v;
            return arr.map((v)=>(0, $7a9f91e2b97567cc$export$4f949d23b5dbefe6)(v, "shadow").shadow).join(" ");
        }).join(" ");
    }).join(",");
const $33055954907944f0$export$15f2b9b64835b137 = (backgroundImage, globalTheme)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    return backgroundImage.split(", ").map((v)=>{
        if (v.slice(0, 2) === "--") return `var(${v})`;
        if (v.includes("url") || v.includes("gradient")) return v;
        else if (CONFIG.GRADIENT[backgroundImage]) return {
            backgroundImage: (0, $c6753c52b98cd54e$export$dd72f6d9deea7207)(backgroundImage, globalTheme || CONFIG.globalTheme)
        };
        else if (v.includes("/") || v.includes("http")) return `url(${v})`;
        return v;
    }).join(" ");
};
const $33055954907944f0$export$1e420ad2d0d06436 = (gap)=>(0, $EqHTq.isString)(gap) && gap.split(" ").map((v)=>(0, $7a9f91e2b97567cc$export$4f949d23b5dbefe6)(v, "gap").gap).join(" ");
const $33055954907944f0$export$df2b736a06860be7 = (transition)=>{
    const arr = transition.split(" ");
    if (!arr.length) return transition;
    return arr.map((v)=>{
        if (v.slice(0, 2) === "--") return `var(${v})`;
        if (v.length < 3 || v.includes("ms")) {
            const mapWithSequence = (0, $200bfc3872a6d81d$export$3fa311edc5edd22f)(v);
            return mapWithSequence.timing || v;
        }
        if ((0, $200bfc3872a6d81d$export$23ba66c7c3e2e613)(v)) return (0, $200bfc3872a6d81d$export$23ba66c7c3e2e613)(v);
        return v;
    }).join(" ");
};
const $33055954907944f0$export$d87c1c5f4a8ec3d9 = (duration, props, propertyName)=>{
    if (!(0, $EqHTq.isString)(duration)) return;
    return duration.split(",").map((v)=>(0, $200bfc3872a6d81d$export$3fa311edc5edd22f)(v).timing || v).join(",");
};
const $33055954907944f0$export$d9f7ff0c2b32d4b5 = (transition)=>{
    const arr = transition.split(",");
    if (!arr.length) return;
    return arr.map($33055954907944f0$export$df2b736a06860be7).join(",");
};
const $33055954907944f0$export$80eafc63c0bb6c49 = (propertyName)=>{
    const prop = propertyName.toLowerCase();
    return (prop.includes("width") || prop.includes("height")) && !prop.includes("border");
};
const $33055954907944f0$export$f09d9444954afeda = (propertyName, val, props = {}, opts = {})=>{
    let value = val || props[propertyName];
    if ((0, $EqHTq.isUndefined)(value) && (0, $EqHTq.isNull)(value)) return;
    const shouldScaleBoxSize = props.scaleBoxSize;
    const isBoxSize = $33055954907944f0$export$80eafc63c0bb6c49(propertyName);
    if (!shouldScaleBoxSize && isBoxSize && (0, $EqHTq.isString)(value)) value = value.split(" ").map((v)=>{
        const isSingleLetter = v.length < 3 && /[A-Z]/.test(v);
        const hasUnits = [
            "%",
            "vw",
            "vh",
            "ch"
        ].some((unit)=>value.includes(unit));
        if (isSingleLetter && !hasUnits) return v + "_default";
        return v;
    }).join(" ");
    if (opts.ratio) return (0, $7a9f91e2b97567cc$export$94679ba49f16fc2e)(props, propertyName, value);
    else return (0, $7a9f91e2b97567cc$export$4f949d23b5dbefe6)(value, propertyName);
};
const $33055954907944f0$export$b6e34d20a288a08c = (propertyName, props)=>{
    return $33055954907944f0$export$f09d9444954afeda(propertyName, null, props, {
        ratio: true
    });
};




parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $baa590feaf6cb6da$var$setCases = (val, key)=>{
    if ((0, $EqHTq.isFunction)(val)) return val();
    return val;
};
const $baa590feaf6cb6da$var$setSameValue = (val, key)=>val;
const $baa590feaf6cb6da$export$9ae1d0dd64d4a382 = {
    color: (0, $c6753c52b98cd54e$export$130a5dc1bc9cd8e1),
    gradient: (0, $c6753c52b98cd54e$export$afaa8352c6a43a44),
    font: (0, $ed362cf167c3740b$export$69e9bdef456a9c46),
    font_family: (0, $ed362cf167c3740b$export$5fae120d779aafec),
    theme: (0, $50bcf74814855f89$export$2e49b867b7a0847c),
    icons: (0, $0475f9d7e694cab2$export$33914de34c28be6c),
    svg: (0, $0475f9d7e694cab2$export$694c6c574069ebf2),
    svg_data: $baa590feaf6cb6da$var$setSameValue,
    typography: $baa590feaf6cb6da$var$setSameValue,
    cases: $baa590feaf6cb6da$var$setCases,
    shadow: (0, $4a7f8e4f20ce09e5$export$9cd3672191b5a46f),
    spacing: $baa590feaf6cb6da$var$setSameValue,
    media: $baa590feaf6cb6da$var$setSameValue,
    timing: $baa590feaf6cb6da$var$setSameValue,
    reset: $baa590feaf6cb6da$var$setSameValue,
    unit: $baa590feaf6cb6da$var$setSameValue,
    animation: $baa590feaf6cb6da$var$setSameValue
};
const $baa590feaf6cb6da$export$80746c6bc6142fc8 = (FACTORY_NAME, value, key)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const factoryName = FACTORY_NAME.toLowerCase();
    const FACTORY = CONFIG[FACTORY_NAME];
    if ($baa590feaf6cb6da$export$9ae1d0dd64d4a382[factoryName]) {
        const result = $baa590feaf6cb6da$export$9ae1d0dd64d4a382[factoryName](value, key);
        FACTORY[key] = result;
        return FACTORY;
    }
    if (CONFIG.verbose) console.warn("Can not find", factoryName, "method in scratch");
};
const $baa590feaf6cb6da$export$943920cf7e6d5f23 = (factoryName, props)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const FACTORY_NAME = factoryName.toUpperCase();
    const keys = Object.keys(props);
    keys.map((key)=>$baa590feaf6cb6da$export$80746c6bc6142fc8(FACTORY_NAME, props[key], key));
    return CONFIG[FACTORY_NAME];
};
const $baa590feaf6cb6da$var$SET_OPTIONS = {};
const $baa590feaf6cb6da$export$adaa4cf7ef1b65be = (recivedConfig, options = $baa590feaf6cb6da$var$SET_OPTIONS)=>{
    let CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { version: version, verbose: verbose, useVariable: useVariable, useReset: useReset, useSvgSprite: useSvgSprite, useFontImport: useFontImport, useIconSprite: useIconSprite, globalTheme: globalTheme, useDocumentTheme: useDocumentTheme, useDefaultConfig: useDefaultConfig, ...config } = recivedConfig;
    if (options.newConfig) CONFIG = (0, $5a3b725cdb25b0eb$export$5e61d1b6fff0c794)(options.newConfig);
    if (verbose !== undefined) CONFIG.verbose = verbose;
    if (useVariable !== undefined) CONFIG.useVariable = useVariable;
    if (useReset !== undefined) CONFIG.useReset = useReset;
    if (useFontImport !== undefined) CONFIG.useFontImport = useFontImport;
    if (useSvgSprite !== undefined) CONFIG.useSvgSprite = useSvgSprite;
    if (useIconSprite !== undefined) CONFIG.useIconSprite = useIconSprite;
    if (useDocumentTheme !== undefined) CONFIG.useDocumentTheme = useDocumentTheme;
    if (globalTheme !== undefined) CONFIG.globalTheme = globalTheme;
    if (useDefaultConfig !== undefined) CONFIG.useDefaultConfig = useDefaultConfig;
    if (CONFIG.verbose) console.log(CONFIG);
    if (!CONFIG.__svg_cache) CONFIG.__svg_cache = {};
    const keys = Object.keys(config);
    keys.map((key)=>$baa590feaf6cb6da$export$943920cf7e6d5f23(key, config[key]));
    // apply generic configs
    (0, $277afaefb2791215$export$7c7d7b0d076fe8b5)();
    (0, $7a9f91e2b97567cc$export$9bfe8384addafa7c)();
    (0, $200bfc3872a6d81d$export$a5be618f63a441ac)();
    (0, $ffaa6eb4db8ddc52$export$25b333cdc54cc186)();
    (0, $da693abe5a891559$export$984fb5f73961424e)();
    return CONFIG;
};


"use strict";


/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $e18645ac1956fbe6$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $e18645ac1956fbe6$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e18645ac1956fbe6$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e18645ac1956fbe6$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $e18645ac1956fbe6$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)) break;
        (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)();
    }
    return (0, $298fb931ed4fbf8b$export$58adb3bec8346d0f)(begin, (0, $298fb931ed4fbf8b$export$5880b8b5730aff45));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $298fb931ed4fbf8b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $298fb931ed4fbf8b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $298fb931ed4fbf8b$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $298fb931ed4fbf8b$export$45918ac1574455b1)($fc182b1f84212d3f$var$toRules((0, $298fb931ed4fbf8b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $fc182b1f84212d3f$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $fc182b1f84212d3f$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($fc182b1f84212d3f$var$ignoreFlag) > -1;
};
var $fc182b1f84212d3f$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($fc182b1f84212d3f$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $fc182b1f84212d3f$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $fc182b1f84212d3f$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$fc182b1f84212d3f$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $fc182b1f84212d3f$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $fc182b1f84212d3f$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$fc182b1f84212d3f$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    } else if ($fc182b1f84212d3f$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $298fb931ed4fbf8b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-item-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "stretch") ? $fc182b1f84212d3f$var$prefix((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, (0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 3 - (~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $298fb931ed4fbf8b$export$527d108ccf083c2b:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                    (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                        value: (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $298fb931ed4fbf8b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $298fb931ed4fbf8b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $298fb931ed4fbf8b$export$fac44ee5b035f737),
        (0, $298fb931ed4fbf8b$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $e18645ac1956fbe6$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $90ba2da1f62e5f1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $90ba2da1f62e5f1b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $90ba2da1f62e5f1b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $90ba2da1f62e5f1b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $90ba2da1f62e5f1b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $90ba2da1f62e5f1b$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $90ba2da1f62e5f1b$var$isCustomProperty(styleName) ? styleName : styleName.replace($90ba2da1f62e5f1b$var$hyphenateRegex, "-$&").toLowerCase();
});
var $90ba2da1f62e5f1b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($90ba2da1f62e5f1b$var$animationRegex, function(match, p1, p2) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $936be3b045ab836e$export$2e2bcd8739ae039)[key] !== 1 && !$90ba2da1f62e5f1b$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $90ba2da1f62e5f1b$var$contentValuePattern, $90ba2da1f62e5f1b$var$contentValues, $90ba2da1f62e5f1b$var$oldProcessStyleValue, $90ba2da1f62e5f1b$var$msPattern, $90ba2da1f62e5f1b$var$hyphenPattern, $90ba2da1f62e5f1b$var$hyphenatedCache;
var $90ba2da1f62e5f1b$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $90ba2da1f62e5f1b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $90ba2da1f62e5f1b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $90ba2da1f62e5f1b$var$cursor;
                var result = interpolation(mergedProps);
                $90ba2da1f62e5f1b$var$cursor = previousCursor;
                return $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($90ba2da1f62e5f1b$var$isProcessableValue(value)) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($90ba2da1f62e5f1b$var$isProcessableValue(value[_i])) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $90ba2da1f62e5f1b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $90ba2da1f62e5f1b$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $90ba2da1f62e5f1b$var$cursor;
var $90ba2da1f62e5f1b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $90ba2da1f62e5f1b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $90ba2da1f62e5f1b$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $90ba2da1f62e5f1b$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $90ba2da1f62e5f1b$var$cursor
    };
};


var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


function $f80ae5e019588f18$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert("", serialized, cache.sheet, true);
}
function $f80ae5e019588f18$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $1f6791d0a193b918$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $f80ae5e019588f18$export$2e2bcd8739ae039 = function createEmotion(options) {
    var cache = (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args, cache.registered, undefined);
        (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $f80ae5e019588f18$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args, cache.registered);
        $f80ae5e019588f18$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $f80ae5e019588f18$var$merge(cache.registered, css, $f80ae5e019588f18$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $1f6791d0a193b918$export$95d99596f328fd52).bind(null, cache.registered),
        merge: $f80ae5e019588f18$var$merge.bind(null, cache.registered, css)
    };
};
var $f80ae5e019588f18$var$classnames = function classnames(args) {
    var cls = "";
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};


"use strict";
const $b3468425a35a59c8$export$100c3af055d141e0 = (key = "smbls", container)=>{
    const cleanKey = key.replaceAll(/\./g, "-");
    return (0, $f80ae5e019588f18$export$2e2bcd8739ae039)({
        key: cleanKey,
        container: container
    });
};
const $b3468425a35a59c8$export$51d693b3d243fd90 = $b3468425a35a59c8$export$100c3af055d141e0();



parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

var $0e6c01aab9a4ae9b$exports = {};
$0e6c01aab9a4ae9b$exports = JSON.parse("{}");


"use strict";
const $31242768b5023c84$var$CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
const $31242768b5023c84$var$mergeWithLocalFile = (config = $31242768b5023c84$var$CONFIG, RC_FILE)=>{
    const rcfile = (0, $EqHTq.isObject)(RC_FILE) ? RC_FILE : (0, (/*@__PURE__*/$parcel$interopDefault($0e6c01aab9a4ae9b$exports))) || {};
    const clonedFile = (0, $8wu6n.deepClone)(rcfile.designSystem || {});
    return (0, $8wu6n.deepMerge)(config, clonedFile);
};
const $31242768b5023c84$var$SET_OPTIONS = {
    emotion: (0, $b3468425a35a59c8$export$51d693b3d243fd90),
    useVariable: true,
    useReset: true,
    useFontImport: true,
    useIconSprite: true,
    useDocumentTheme: true,
    useSvgSprite: true
};
const $31242768b5023c84$export$2cd8252107eb640b = (config, options = $31242768b5023c84$var$SET_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    const resultConfig = $31242768b5023c84$var$mergeWithLocalFile(config || {});
    const conf = (0, $baa590feaf6cb6da$export$adaa4cf7ef1b65be)({
        verbose: options.verbose,
        useReset: options.useReset,
        useFontImport: options.useFontImport,
        useVariable: options.useVariable,
        useSvgSprite: options.useSvgSprite,
        useDocumentTheme: options.useDocumentTheme,
        useIconSprite: options.useIconSprite,
        useDefaultConfig: options.useDefaultConfig,
        ...resultConfig
    }, {
        newConfig: options.newConfig
    });
    const FontFace = (0, $acb660e77bec9cb5$export$8b73d71a1d936bc)(conf.FONT);
    const useReset = conf.useReset;
    const useVariable = conf.useVariable;
    const useFontImport = conf.useFontImport;
    const useSvgSprite = conf.useSvgSprite;
    const hasSvgs = config.svg || config.SVG;
    const useIconSprite = conf.useIconSprite;
    const hasIcons = config.icons || config.ICONS;
    if (useFontImport) emotion.injectGlobal(FontFace);
    if (useVariable) emotion.injectGlobal({
        ":root": conf.CSS_VARS
    });
    if (useReset) emotion.injectGlobal(conf.RESET);
    if (hasSvgs) (0, $0475f9d7e694cab2$export$2c4662f4a995c568)(hasSvgs, {
        document: options.document
    });
    else if (useSvgSprite) (0, $0475f9d7e694cab2$export$2c4662f4a995c568)(conf.SVG, {
        document: options.document
    });
    if (hasIcons) (0, $0475f9d7e694cab2$export$6831f47ca12f6d69)(hasIcons, {
        document: options.document
    });
    else if (useIconSprite) (0, $0475f9d7e694cab2$export$6831f47ca12f6d69)(conf.ICONS, {
        document: options.document
    });
    return conf;
};
const $31242768b5023c84$var$UPDATE_OPTIONS = {
    emotion: (0, $b3468425a35a59c8$export$51d693b3d243fd90)
};
const $31242768b5023c84$export$4f395a2c8fcf6959 = (config, RC_FILE, options = $31242768b5023c84$var$UPDATE_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    const resultConfig = $31242768b5023c84$var$mergeWithLocalFile(config || {}, RC_FILE);
    const conf = (0, $baa590feaf6cb6da$export$adaa4cf7ef1b65be)({
        verbose: false,
        ...resultConfig
    });
    emotion.injectGlobal({
        ":root": conf.CSS_VARS
    });
    emotion.injectGlobal(conf.RESET);
};
const $31242768b5023c84$export$3a26aa64e59aeaff = (styles, options = $31242768b5023c84$var$UPDATE_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    emotion.injectGlobal(styles);
};
const $31242768b5023c84$export$ed2c61d2d8a098be = (config, options = $31242768b5023c84$var$UPDATE_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    emotion.injectGlobal({
        ":root": config.CSS_VARS
    });
};
const $31242768b5023c84$export$2796c4ce44e61efa = (props, options = $31242768b5023c84$var$UPDATE_OPTIONS)=>{} // setClassname(props, options.emotion.css)
;


var $be006f1a0fabd945$exports = {};
var $73d59c6c3fce378b$exports = {};
var $40d382f435ee1fdb$exports = {};

$parcel$export($40d382f435ee1fdb$exports, "Block", () => $40d382f435ee1fdb$export$d96a8827a60d6b69);
$parcel$export($40d382f435ee1fdb$exports, "Hr", () => $40d382f435ee1fdb$export$c65504044f62f430);
$parcel$export($40d382f435ee1fdb$exports, "Br", () => $40d382f435ee1fdb$export$9130f216d904f5ea);
$parcel$export($40d382f435ee1fdb$exports, "Div", () => $40d382f435ee1fdb$export$5bfb0bc6cd684584);
$parcel$export($40d382f435ee1fdb$exports, "Span", () => $40d382f435ee1fdb$export$5f1714a13ed34c01);
$parcel$export($40d382f435ee1fdb$exports, "Ul", () => $40d382f435ee1fdb$export$d4f99c77eeffeaea);
$parcel$export($40d382f435ee1fdb$exports, "Gutter", () => $40d382f435ee1fdb$export$b710539649c46ff);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $40d382f435ee1fdb$export$d96a8827a60d6b69 = {
    deps: {
        getSpacingBasedOnRatio: $7a9f91e2b97567cc$export$94679ba49f16fc2e,
        getSpacingByKey: $7a9f91e2b97567cc$export$4f949d23b5dbefe6,
        transfromGap: $33055954907944f0$export$1e420ad2d0d06436,
        transformSizeRatio: $33055954907944f0$export$b6e34d20a288a08c,
        transformSize: $33055954907944f0$export$f09d9444954afeda
    },
    class: {
        boxSizing: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.boxSizing) ? {
                boxSizing: props.boxSizing
            } : {
                boxSizing: "border-box"
            },
        display: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.display) && {
                display: props.display
            },
        hide: ({ props: props })=>props.hide && {
                display: "none !important"
            },
        width: ({ props: props, deps: deps })=>deps.transformSizeRatio("width", props),
        height: ({ props: props, deps: deps })=>deps.transformSizeRatio("height", props),
        boxSize: ({ props: props, deps: deps })=>{
            if (typeof props.boxSize !== "string") return;
            const [height, width] = props.boxSize.split(" ");
            return {
                ...deps.transformSize("height", height),
                ...deps.transformSize("width", width || height)
            };
        },
        minWidth: ({ props: props, deps: deps })=>deps.transformSizeRatio("minWidth", props),
        maxWidth: ({ props: props, deps: deps })=>deps.transformSizeRatio("maxWidth", props),
        widthRange: ({ props: props, deps: deps })=>{
            if (typeof props.widthRange !== "string") return;
            const [minWidth, maxWidth] = props.widthRange.split(" ");
            return {
                ...deps.transformSize("minWidth", minWidth),
                ...deps.transformSize("maxWidth", maxWidth || minWidth)
            };
        },
        minHeight: ({ props: props, deps: deps })=>deps.transformSizeRatio("minHeight", props),
        maxHeight: ({ props: props, deps: deps })=>deps.transformSizeRatio("maxHeight", props),
        heightRange: ({ props: props, deps: deps })=>{
            if (typeof props.heightRange !== "string") return;
            const [minHeight, maxHeight] = props.heightRange.split(" ");
            return {
                ...deps.transformSize("minHeight", minHeight),
                ...deps.transformSize("maxHeight", maxHeight || minHeight)
            };
        },
        direction: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.direction) && {
                direction: props.direction
            },
        aspectRatio: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.aspectRatio) && {
                aspectRatio: props.aspectRatio
            },
        borderWidth: ({ props: props, deps: deps })=>deps.transformSizeRatio("borderWidth", props),
        padding: ({ props: props, deps: deps })=>deps.transformSizeRatio("padding", props),
        paddingInline: ({ props: props, deps: deps })=>{
            if (typeof props.paddingInline !== "string") return;
            const [paddingInlineStart, paddingInlineEnd] = props.paddingInline.split(" ");
            return {
                ...deps.transformSize("paddingInlineStart", paddingInlineStart),
                ...deps.transformSize("paddingInlineEnd", paddingInlineEnd || paddingInlineStart)
            };
        },
        paddingBlock: ({ props: props, deps: deps })=>{
            if (typeof props.paddingBlock !== "string") return;
            const [paddingBlockStart, paddingBlockEnd] = props.paddingBlock.split(" ");
            return {
                ...deps.transformSize("paddingBlockStart", paddingBlockStart),
                ...deps.transformSize("paddingBlockEnd", paddingBlockEnd || paddingBlockStart)
            };
        },
        paddingInlineStart: ({ props: props, deps: deps })=>deps.transformSizeRatio("paddingInlineStart", props),
        paddingInlineEnd: ({ props: props, deps: deps })=>deps.transformSizeRatio("paddingInlineEnd", props),
        paddingBlockStart: ({ props: props, deps: deps })=>deps.transformSizeRatio("paddingBlockStart", props),
        paddingBlockEnd: ({ props: props, deps: deps })=>deps.transformSizeRatio("paddingBlockEnd", props),
        margin: ({ props: props, deps: deps })=>deps.transformSizeRatio("margin", props),
        marginInline: ({ props: props, deps: deps })=>{
            if (typeof props.marginInline !== "string") return;
            const [marginInlineStart, marginInlineEnd] = props.marginInline.split(" ");
            return {
                ...deps.transformSize("marginInlineStart", marginInlineStart),
                ...deps.transformSize("marginInlineEnd", marginInlineEnd || marginInlineStart)
            };
        },
        marginBlock: ({ props: props, deps: deps })=>{
            if (typeof props.marginBlock !== "string") return;
            const [marginBlockStart, marginBlockEnd] = props.marginBlock.split(" ");
            return {
                ...deps.transformSize("marginBlockStart", marginBlockStart),
                ...deps.transformSize("marginBlockEnd", marginBlockEnd || marginBlockStart)
            };
        },
        marginInlineStart: ({ props: props, deps: deps })=>deps.transformSizeRatio("marginInlineStart", props),
        marginInlineEnd: ({ props: props, deps: deps })=>deps.transformSizeRatio("marginInlineEnd", props),
        marginBlockStart: ({ props: props, deps: deps })=>deps.transformSizeRatio("marginBlockStart", props),
        marginBlockEnd: ({ props: props, deps: deps })=>deps.transformSizeRatio("marginBlockEnd", props),
        gap: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.gap) && {
                gap: (0, $33055954907944f0$export$1e420ad2d0d06436)(props.gap)
            },
        gridArea: ({ props: props, deps: deps })=>props.gridArea && {
                gridArea: props.gridArea
            },
        flex: ({ props: props })=>props.flex && {
                flex: props.flex
            },
        flexDirection: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.flexDirection) && {
                flexDirection: props.flexDirection
            },
        alignItems: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.alignItems) && {
                alignItems: props.alignItems
            },
        alignContent: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.alignContent) && {
                alignContent: props.alignContent
            },
        justifyContent: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.justifyContent) && {
                justifyContent: props.justifyContent
            },
        justifyItems: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.justifyItems) && {
                justifyItems: props.justifyItems
            },
        alignSelf: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.alignSelf) && {
                alignSelf: props.alignSelf
            },
        order: ({ props: props })=>props.order && {
                order: props.order
            },
        flexWrap: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.flexWrap) && {
                display: "flex",
                flexFlow: props.flexWrap
            },
        flexFlow: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.flexFlow) && {
                display: "flex",
                flexFlow: props.flexFlow + (props.reverse ? "-reverse" : "")
            },
        flexAlign: ({ props: props })=>{
            if (typeof props.flexAlign !== "string") return;
            const [alignItems, justifyContent] = props.flexAlign.split(" ");
            return {
                display: "flex",
                alignItems: alignItems,
                justifyContent: justifyContent
            };
        },
        gridColumn: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.gridColumn) && {
                gridColumn: props.gridColumn
            },
        gridColumnStart: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.gridColumnStart) && {
                gridColumnStart: props.gridColumnStart
            },
        gridRow: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.gridRow) && {
                gridRow: props.gridRow
            },
        gridRowStart: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.gridRowStart) && {
                gridRowStart: props.gridRowStart
            },
        size: ({ props: props, deps: deps })=>{
            if (typeof props.heightRange !== "string") return;
            const [minHeight, maxHeight] = props.heightRange.split(" ");
            return {
                ...deps.transformSizeRatio("minHeight", minHeight),
                ...deps.transformSizeRatio("maxHeight", maxHeight || minHeight)
            };
        },
        columns: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.columns) && {
                columns: props.columns
            },
        columnRule: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.columnRule) && {
                columnRule: props.columnRule
            },
        columnWidth: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.columnWidth) && {
                columnWidth: props.columnWidth
            },
        columnGap: ({ props: props, deps: deps })=>deps.transformSizeRatio("columnGap", props),
        columnSpan: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.columnSpan) && {
                columnSpan: props.columnSpan
            },
        columnFill: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.columnFill) && {
                columnFill: props.columnFill
            },
        columnCount: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.columnCount) && {
                columnCount: props.columnCount
            }
    }
};
const $40d382f435ee1fdb$export$c65504044f62f430 = {
    tag: "hr",
    props: {
        margin: "C1 0"
    }
};
const $40d382f435ee1fdb$export$9130f216d904f5ea = {
    tag: "br"
};
const $40d382f435ee1fdb$export$5bfb0bc6cd684584 = {
    tag: "div"
};
const $40d382f435ee1fdb$export$5f1714a13ed34c01 = {
    tag: "span"
};
const $40d382f435ee1fdb$export$d4f99c77eeffeaea = {
    tag: "ul",
    childExtend: {
        tag: "li"
    }
};
const $40d382f435ee1fdb$export$b710539649c46ff = {
    deps: {
        getSpacingByKey: $7a9f91e2b97567cc$export$4f949d23b5dbefe6
    },
    props: {
        size: "C1"
    },
    class: {
        size: ({ props: props, deps: deps })=>{
            if (typeof props.size !== "string") return;
            const [height, width] = props.size.split(" ");
            return {
                ...deps.getSpacingByKey("height", height),
                ...deps.getSpacingByKey("width", width || height)
            };
        }
    }
};


var $b908145e0b91dcdb$exports = {};

$parcel$export($b908145e0b91dcdb$exports, "Direction", () => $b908145e0b91dcdb$export$cacd6541cfeeb6c1);
"use strict";
const $b908145e0b91dcdb$export$cacd6541cfeeb6c1 = {
    props: {
        direction: "ltr"
    },
    class: {
        direction: ({ props: props })=>({
                direction: props.direction
            })
    }
};


var $8184389c03ed1792$exports = {};

$parcel$export($8184389c03ed1792$exports, "Flex", () => $8184389c03ed1792$export$f51f4c4ede09e011);
"use strict";
const $8184389c03ed1792$export$f51f4c4ede09e011 = {
    props: {
        display: "flex"
    },
    class: {
        flow: ({ props: props })=>props.flow && {
                flexFlow: props.flow + (props.reverse ? "-reverse" : "")
            },
        wrap: ({ props: props })=>props.wrap && {
                flexWrap: props.wrap
            },
        align: ({ props: props })=>{
            if (typeof props.align !== "string") return;
            const [alignItems, justifyContent] = props.align.split(" ");
            return {
                alignItems: alignItems,
                justifyContent: justifyContent
            };
        }
    }
};


var $afd03220988cb716$exports = {};

$parcel$export($afd03220988cb716$exports, "Grid", () => $afd03220988cb716$export$ef2184bd89960b14);

"use strict";
const $afd03220988cb716$export$ef2184bd89960b14 = {
    deps: {
        getSpacingBasedOnRatio: $7a9f91e2b97567cc$export$94679ba49f16fc2e
    },
    props: {
        display: "grid"
    },
    class: {
        area: ({ props: props })=>props.area ? {
                gridArea: props.area
            } : null,
        template: ({ props: props })=>props.template ? {
                gridTemplate: props.template
            } : null,
        templateAreas: ({ props: props })=>props.templateAreas ? {
                gridTemplateAreas: props.templateAreas
            } : null,
        column: ({ props: props })=>props.column ? {
                gridColumn: props.column
            } : null,
        columns: ({ props: props })=>props.columns ? {
                gridTemplateColumns: props.columns
            } : null,
        templateColumns: ({ props: props })=>props.templateColumns ? {
                gridTemplateColumns: props.templateColumns
            } : null,
        autoColumns: ({ props: props })=>props.autoColumns ? {
                gridAutoColumns: props.autoColumns
            } : null,
        columnStart: ({ props: props })=>props.columnStart ? {
                gridColumnStart: props.columnStart
            } : null,
        row: ({ props: props })=>props.row ? {
                gridRow: props.row
            } : null,
        rows: ({ props: props })=>props.rows ? {
                gridTemplateRows: props.rows
            } : null,
        templateRows: ({ props: props })=>props.templateRows ? {
                gridTemplateRows: props.templateRows
            } : null,
        autoRows: ({ props: props })=>props.autoRows ? {
                gridAutoRows: props.autoRows
            } : null,
        rowStart: ({ props: props })=>props.rowStart ? {
                gridRowStart: props.rowStart
            } : null,
        autoFlow: ({ props: props })=>props.autoFlow ? {
                gridAutoFlow: props.autoFlow
            } : null,
        columnGap: ({ props: props, deps: deps })=>props.columnGap ? deps.getSpacingBasedOnRatio(props, "columnGap") : null,
        rowGap: ({ props: props, deps: deps })=>props.rowGap ? deps.getSpacingBasedOnRatio(props, "rowGap") : null
    }
};


var $c95002999fe11fd8$exports = {};

$parcel$export($c95002999fe11fd8$exports, "Img", () => $c95002999fe11fd8$export$cc7b5f925acc71d3);
"use strict";
const $c95002999fe11fd8$export$cc7b5f925acc71d3 = {
    tag: "img",
    attr: {
        src: ({ props: props })=>props.src,
        alt: ({ props: props })=>props.alt,
        title: ({ props: props })=>props.title || props.alt
    }
};


var $f085155ee8a416c4$exports = {};

$parcel$export($f085155ee8a416c4$exports, "Form", () => $f085155ee8a416c4$export$a7fed597f4b8afd8);
"use strict";
const $f085155ee8a416c4$export$a7fed597f4b8afd8 = {
    tag: "form",
    attr: {
        action: ({ props: props })=>props.action,
        method: ({ props: props })=>props.method,
        enctype: ({ props: props })=>props.enctype
    }
};


var $bc85e892389de1ab$exports = {};

$parcel$export($bc85e892389de1ab$exports, "keySetters", () => $bc85e892389de1ab$export$5c168558fab3755c);
$parcel$export($bc85e892389de1ab$exports, "Media", () => $bc85e892389de1ab$export$7fc53215244aec38);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $8wu6n = parcelRequire("8wu6n");
var $2ae1edf582b77174$exports = {};

$parcel$export($2ae1edf582b77174$exports, "getSystemTheme", () => $2ae1edf582b77174$export$fe979c3403443f94);
$parcel$export($2ae1edf582b77174$exports, "Theme", () => $2ae1edf582b77174$export$14faa19a0f3bbeb2);


var $3e7681929891ee4e$exports = {};

$parcel$export($3e7681929891ee4e$exports, "Timing", () => $3e7681929891ee4e$export$ef1e5872612852d1);

"use strict";
const $3e7681929891ee4e$export$ef1e5872612852d1 = {
    deps: {
        getTimingFunction: $200bfc3872a6d81d$export$23ba66c7c3e2e613,
        splitTransition: $33055954907944f0$export$d9f7ff0c2b32d4b5,
        transformDuration: $33055954907944f0$export$d87c1c5f4a8ec3d9
    },
    class: {
        transition: ({ props: props, deps: deps })=>props.transition && {
                transition: deps.splitTransition(props.transition)
            },
        willChange: ({ props: props })=>props.willChange && {
                willChange: props.willChange
            },
        transitionDuration: ({ props: props, deps: deps })=>props.transitionDuration && {
                transitionDuration: deps.transformDuration(props.transitionDuration)
            },
        transitionDelay: ({ props: props, deps: deps })=>props.transitionDelay && {
                transitionDelay: deps.transformDuration(props.transitionDelay)
            },
        transitionTimingFunction: ({ props: props, deps: deps })=>props.transitionTimingFunction && {
                transitionTimingFunction: deps.getTimingFunction(props.transitionTimingFunction)
            },
        transitionProperty: ({ props: props })=>props.transitionProperty && {
                transitionProperty: props.transitionProperty,
                willChange: props.transitionProperty
            }
    }
};


"use strict";
const $1364b7b7ead3f203$var$CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
const $1364b7b7ead3f203$export$b202ba015b5882cd = {
    4: {
        boxShadow: `rgba(0,0,0,.10) 0 2${$1364b7b7ead3f203$var$CONFIG.UNIT.default} 4${$1364b7b7ead3f203$var$CONFIG.UNIT.default}`
    },
    6: {
        boxShadow: `rgba(0,0,0,.10) 0 3${$1364b7b7ead3f203$var$CONFIG.UNIT.default} 6${$1364b7b7ead3f203$var$CONFIG.UNIT.default}`
    },
    10: {
        boxShadow: `rgba(0,0,0,.10) 0 4${$1364b7b7ead3f203$var$CONFIG.UNIT.default} 10${$1364b7b7ead3f203$var$CONFIG.UNIT.default}`
    },
    16: {
        boxShadow: `rgba(0,0,0,.10) 0 8${$1364b7b7ead3f203$var$CONFIG.UNIT.default} 16${$1364b7b7ead3f203$var$CONFIG.UNIT.default}`
    },
    26: {
        boxShadow: `rgba(0,0,0,.10) 0 14${$1364b7b7ead3f203$var$CONFIG.UNIT.default} 26${$1364b7b7ead3f203$var$CONFIG.UNIT.default}`
    },
    42: {
        boxShadow: `rgba(0,0,0,.10) 0 20${$1364b7b7ead3f203$var$CONFIG.UNIT.default} 42${$1364b7b7ead3f203$var$CONFIG.UNIT.default}`
    }
};
const $1364b7b7ead3f203$var$getComputedBackgroundColor = ({ props: props })=>{
    return (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(props.shapeDirectionColor) || (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(props.borderColor) || (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(props.backgroundColor) || (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(props.background);
};
const $1364b7b7ead3f203$var$inheritTransition = ({ props: props, deps: deps })=>{
    const exec = (0, $3e7681929891ee4e$export$ef1e5872612852d1).class.transition({
        props: props,
        deps: deps
    });
    return exec && exec.transition;
};
const $1364b7b7ead3f203$export$511e1d54a4a8684e = {
    rectangle: {},
    circle: {
        borderRadius: "100%"
    },
    bubble: {},
    tv: {
        borderRadius: "1.15em/2.5em"
    },
    tooltip: ({ props: props, deps: deps })=>({
            position: props.position || "relative",
            "&:before": {
                content: '""',
                display: "block",
                width: "0px",
                height: "0px",
                border: ".35em solid",
                borderColor: $1364b7b7ead3f203$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                transition: $1364b7b7ead3f203$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: "border-color",
                position: "absolute",
                borderRadius: ".15em"
            }
        }),
    tooltipDirection: {
        top: {
            "&:before": {
                top: "0",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        },
        right: {
            "&:before": {
                top: "50%",
                right: "0",
                transform: "translate(50%, -50%) rotate(45deg)"
            }
        },
        bottom: {
            "&:before": {
                bottom: "0",
                left: "50%",
                transform: "translate(-50%, 50%) rotate(45deg)"
            }
        },
        left: {
            "&:before": {
                top: "50%",
                left: "0",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        }
    },
    tag: ({ props: props, deps: deps })=>({
            position: "relative",
            "&:before": {
                content: '""',
                display: "block",
                background: $1364b7b7ead3f203$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                transition: $1364b7b7ead3f203$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: "background",
                borderRadius: ".25em",
                position: "absolute",
                zIndex: "-1",
                aspectRatio: "1/1",
                top: "50%",
                transformOrigin: "50% 50%",
                height: "73%"
            }
        }),
    tagDirection: {
        top: {
            "&:before": {
                bottom: "100%",
                left: "50%",
                transform: "translate(-50%, 50%) rotate(45deg)"
            }
        },
        right: {
            "&:before": {
                top: "50%",
                left: "100%",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        },
        bottom: {
            "&:before": {
                top: "100%",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        },
        left: {
            "&:before": {
                top: "50%",
                right: "100%",
                transform: "translate(50%, -50%) rotate(45deg)"
            }
        }
    },
    hexagon: ({ props: props, deps: deps })=>({
            position: "relative",
            "&:before, &:after": {
                content: '""',
                display: "block",
                position: "absolute",
                zIndex: "-1",
                borderRadius: ".25em",
                aspectRatio: "1/1",
                top: "50%",
                transformOrigin: "50% 50%",
                height: "73%",
                background: $1364b7b7ead3f203$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                transition: $1364b7b7ead3f203$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: "background"
            },
            "&:before": {
                left: "0",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            },
            "&:after": {
                left: "100%",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            }
        }),
    chevron: ({ props: props, deps: deps })=>({
            position: "relative",
            "&:before, &:after": {
                content: '""',
                display: "block",
                position: "absolute",
                zIndex: "-1",
                aspectRatio: "1/1",
                top: "50%",
                transformOrigin: "50% 50%",
                transition: $1364b7b7ead3f203$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: "background"
            },
            "&:before": {
                background: `linear-gradient(225deg, ${$1364b7b7ead3f203$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                })} 25%, transparent 25%), linear-gradient(315deg, ${$1364b7b7ead3f203$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                })} 25%, transparent 25%)`
            },
            "&:after": {
                background: $1364b7b7ead3f203$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                borderRadius: ".25em"
            }
        }),
    chevronDirection: {
        left: {
            "&:before": {
                height: "100%",
                left: "100%",
                transform: "translate3d(-1%, -50%, 1px) scale(-1, 1)"
            },
            "&:after": {
                height: "73%",
                left: "0",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            }
        },
        right: {
            "&:before": {
                height: "100%",
                left: "0",
                transform: "translate3d(-99%, -50%, 1px)"
            },
            "&:after": {
                height: "73%",
                left: "100%",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            }
        }
    }
};


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $2ae1edf582b77174$export$fe979c3403443f94 = ({ context: context, state: state })=>{
    const rootState = state && state.__root;
    return rootState && rootState.globalTheme ? rootState.globalTheme : context.designSystem && context.designSystem.globalTheme;
};
const $2ae1edf582b77174$export$14faa19a0f3bbeb2 = {
    deps: {
        depth: $1364b7b7ead3f203$export$b202ba015b5882cd,
        getSystemTheme: $2ae1edf582b77174$export$fe979c3403443f94,
        getMediaTheme: $50bcf74814855f89$export$b3cf7317de2f2233,
        getMediaColor: $c6753c52b98cd54e$export$dd72f6d9deea7207,
        transformTextStroke: $33055954907944f0$export$8bcd50b221b13db,
        transformShadow: $33055954907944f0$export$837e4beeff9ff924,
        transformBoxShadow: $33055954907944f0$export$9c296746f296a70,
        transformBorder: $33055954907944f0$export$ca4ef6ca6dc743f2,
        transformBackgroundImage: $33055954907944f0$export$15f2b9b64835b137
    },
    class: {
        depth: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.depth) && deps.depth[props.depth],
        theme: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemTheme(element);
            if (!props.theme) return;
            const hasSubtheme = props.theme.includes(" ") && !props.theme.includes("@");
            const globalThemeForced = `@${props.themeModifier || globalTheme}`;
            if (hasSubtheme) {
                const themeAppliedInVal = props.theme.split(" ");
                themeAppliedInVal.splice(1, 0, globalThemeForced);
                return deps.getMediaTheme(themeAppliedInVal);
            } else if (props.theme.includes("@{globalTheme}")) props.theme.replace("@{globalTheme}", globalThemeForced);
            return deps.getMediaTheme(props.theme, `@${props.themeModifier || globalTheme}`);
        },
        color: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemTheme(element);
            if (!props.color) return;
            return {
                color: deps.getMediaColor(props.color, globalTheme)
            };
        },
        background: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemTheme(element);
            if (!props.background) return;
            return {
                background: deps.getMediaColor(props.background, globalTheme)
            };
        },
        backgroundColor: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemTheme(element);
            if (!props.backgroundColor) return;
            return {
                backgroundColor: deps.getMediaColor(props.backgroundColor, globalTheme)
            };
        },
        backgroundImage: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemTheme(element);
            if (!props.backgroundImage) return;
            return {
                backgroundImage: deps.transformBackgroundImage(props.backgroundImage, globalTheme)
            };
        },
        backgroundSize: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.backgroundSize) ? {
                backgroundSize: props.backgroundSize
            } : null,
        backgroundPosition: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.backgroundPosition) ? {
                backgroundPosition: props.backgroundPosition
            } : null,
        textStroke: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.textStroke) ? {
                WebkitTextStroke: deps.transformTextStroke(props.textStroke)
            } : null,
        outline: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.outline) && {
                outline: deps.transformBorder(props.outline)
            },
        border: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.border) && {
                border: deps.transformBorder(props.border)
            },
        borderColor: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemTheme(element);
            if (!props.borderColor) return;
            return {
                borderColor: deps.getMediaColor(props.borderColor, globalTheme)
            };
        },
        borderStyle: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.borderStyle) && {
                borderStyle: props.borderStyle
            },
        borderLeft: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.borderLeft) && {
                borderLeft: deps.transformBorder(props.borderLeft)
            },
        borderTop: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.borderTop) && {
                borderTop: deps.transformBorder(props.borderTop)
            },
        borderRight: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.borderRight) && {
                borderRight: deps.transformBorder(props.borderRight)
            },
        borderBottom: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.borderBottom) && {
                borderBottom: deps.transformBorder(props.borderBottom)
            },
        shadow: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemTheme(element);
            if (!props.backgroundImage) return;
            return {
                boxShadow: deps.transformShadow(props.backgroundImage, globalTheme)
            };
        },
        boxShadow: ({ props: props, deps: deps })=>(0, $EqHTq.isString)(props.boxShadow) && {
                boxShadow: deps.transformBoxShadow(props.boxShadow)
            },
        textShadow: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.textShadow) && {
                textShadow: deps.transformBoxShadow(props.textShadow)
            },
        backdropFilter: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.backdropFilter) && {
                backdropFilter: props.backdropFilter
            },
        opacity: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.opacity) && {
                opacity: props.opacity
            },
        visibility: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.visibility) && {
                visibility: props.visibility
            },
        columnRule: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.columnRule) && {
                columnRule: deps.transformBorder(props.columnRule)
            },
        filter: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.filter) && {
                filter: props.filter
            },
        mixBlendMode: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.mixBlendMode) && {
                mixBlendMode: props.mixBlendMode
            },
        appearance: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.appearance) && {
                appearance: props.appearance
            }
    }
};


"use strict";
const $bc85e892389de1ab$export$5c168558fab3755c = {
    "@": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyMediaProps(key, props, isSubtree ? result : result && result.media, element),
    ":": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    "[": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    "*": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    "+": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    "~": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    "&": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyAndProps(key, props, isSubtree ? result : result && result.selector, element),
    ">": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyAndProps(key, props, isSubtree ? result : result && result.selector, element),
    $: (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyCaseProps(key, props, isSubtree ? result : result && result.case, element),
    "-": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyVariableProps(key, props, isSubtree ? result : result && result.variable, element),
    ".": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyConditionalCaseProps(key, props, isSubtree ? result : result && result.case, element),
    "!": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyConditionalFalsyProps(key, props, isSubtree ? result : result && result.case, element)
};
const $bc85e892389de1ab$var$execClass = (key, props, result, element)=>{
    const { class: className } = element;
    const classnameExec = className[key];
    if (typeof classnameExec !== "function") return;
    let classExec = classnameExec({
        props: props,
        context: element.context,
        state: element.state,
        deps: element.deps
    });
    if ((0, $EqHTq.isArray)(classExec)) classExec = classExec.reduce((a, c)=>(0, $8wu6n.merge)(a, c), {});
    for(const finalProp in classExec)result[finalProp] = classExec[finalProp];
    return classExec;
};
const $bc85e892389de1ab$var$convertPropsToClass = (props, result, element)=>{
    const propsClassObj = {};
    for(const key in props){
        const setter = $bc85e892389de1ab$export$5c168558fab3755c[key.slice(0, 1)];
        if (setter) {
            setter(key, props[key], propsClassObj, element, true);
            continue;
        } else $bc85e892389de1ab$var$execClass(key, props, propsClassObj, element);
    }
    return propsClassObj;
};
const $bc85e892389de1ab$var$applyMediaProps = (key, props, result, element)=>{
    const { context: context } = element;
    if (!context.designSystem || !context.designSystem.MEDIA) return;
    const globalTheme = (0, $2ae1edf582b77174$export$fe979c3403443f94)(element);
    const { MEDIA: MEDIA } = context.designSystem;
    const mediaName = MEDIA[key.slice(1)];
    const generatedClass = $bc85e892389de1ab$var$convertPropsToClass(props, result, element);
    const name = key.slice(1);
    const isTheme = [
        "dark",
        "light"
    ].includes(name);
    const matchesGlobal = name === globalTheme;
    if (globalTheme && isTheme) {
        if (matchesGlobal) return (0, $8wu6n.merge)(result, generatedClass);
        return;
    }
    const mediaKey = mediaName ? `@media screen and ${mediaName}` : key;
    result[mediaKey] = generatedClass;
    return result[mediaKey];
};
const $bc85e892389de1ab$var$applyAndProps = (key, props, result, element)=>{
    result[key] = $bc85e892389de1ab$var$convertPropsToClass(props, result, element);
    return result[key];
};
const $bc85e892389de1ab$var$applySelectorProps = (key, props, result, element)=>{
    const selectorKey = `&${key}`;
    result[selectorKey] = $bc85e892389de1ab$var$convertPropsToClass(props, result, element);
    return result[selectorKey];
};
const $bc85e892389de1ab$var$applyCaseProps = (key, props, result, element)=>{
    const { CASES: CASES } = element.context && element.context.designSystem;
    const caseKey = key.slice(1);
    const isPropTrue = element.props[caseKey];
    if (!CASES[caseKey] && !isPropTrue) return;
    return (0, $8wu6n.merge)(result, $bc85e892389de1ab$var$convertPropsToClass(props, result, element));
};
const $bc85e892389de1ab$var$applyVariableProps = (key, props, result, element)=>{
    result[key] = props;
    return result;
};
const $bc85e892389de1ab$var$applyConditionalCaseProps = (key, props, result, element)=>{
    const caseKey = key.slice(1);
    const isPropTrue = element.props[caseKey] || element.state[caseKey];
    if (!isPropTrue) return; // remove classname if not here
    return (0, $8wu6n.merge)(result, $bc85e892389de1ab$var$convertPropsToClass(props, result, element));
};
const $bc85e892389de1ab$var$applyConditionalFalsyProps = (key, props, result, element)=>{
    const caseKey = key.slice(1);
    const isPropTrue = element.props[caseKey] || element.state[caseKey] === true;
    if (!isPropTrue) return (0, $8wu6n.merge)(result, $bc85e892389de1ab$var$convertPropsToClass(props, result, element));
};
const $bc85e892389de1ab$var$applyTrueProps = (props, result, element)=>(0, $8wu6n.merge)(result, $bc85e892389de1ab$var$convertPropsToClass(props, result, element));
const $bc85e892389de1ab$var$beforeClassAssign = (element, s)=>{
    const { props: props, class: className, context: context } = element;
    const CLASS_NAMES = {
        media: {},
        selector: {},
        case: {},
        variable: {}
    };
    if (!context) return;
    const globalTheme = context.designSystem.globalTheme;
    for(const key in props){
        const setter = $bc85e892389de1ab$export$5c168558fab3755c[key.slice(0, 1)];
        if (globalTheme) {
            if (key === "theme") props.update({
                themeModifier: globalTheme
            }, {
                preventRecursive: true,
                isForced: true,
                preventDefineUpdate: true
            });
            else if (key === "true") $bc85e892389de1ab$var$applyTrueProps(props[key], CLASS_NAMES, element);
        }
        if (setter) setter(key, props[key], CLASS_NAMES, element);
    }
    // override props
    if (props["^"]) {
        for(const key in props["^"])$bc85e892389de1ab$var$execClass(key, props, CLASS_NAMES, element);
        console.log(CLASS_NAMES);
    }
    const parentProps = element.parent && element.parent.props;
    if (parentProps && parentProps.spacingRatio && parentProps.inheritSpacingRatio) element.setProps({
        spacingRatio: parentProps.spacingRatio,
        inheritSpacingRatio: true
    }, {
        preventRecursive: true,
        isForced: true,
        preventDefineUpdate: true
    });
    (0, $8wu6n.overwriteShallow)(className, CLASS_NAMES);
};
const $bc85e892389de1ab$export$7fc53215244aec38 = {
    class: {
        case: (el, s)=>{
            return {
            };
        }
    },
    on: {
        beforeClassAssign: $bc85e892389de1ab$var$beforeClassAssign
    }
};


var $0b0e26e2a21aab54$exports = {};

$parcel$export($0b0e26e2a21aab54$exports, "Iframe", () => $0b0e26e2a21aab54$export$5137ec99f248330b);
"use strict";
const $0b0e26e2a21aab54$export$5137ec99f248330b = {
    tag: "iframe",
    props: {
        position: "relative",
        minWidth: "H",
        minHeight: "H"
    },
    attr: {
        src: ({ props: props })=>props.src,
        loading: ({ props: props })=>props.loading,
        allowfullscreen: ({ props: props })=>props.allowfullscreen,
        frameborder: ({ props: props })=>props.frameborder,
        allow: ({ props: props })=>props.allow,
        referrerpolicy: ({ props: props })=>props.referrerpolicy
    }
};


var $2d62e11bc2f194bd$exports = {};

$parcel$export($2d62e11bc2f194bd$exports, "Interaction", () => $2d62e11bc2f194bd$export$a13296960cae0384);
"use strict";
const $2d62e11bc2f194bd$export$a13296960cae0384 = {
    class: {
        userSelect: ({ props: props })=>props.userSelect && {
                userSelect: props.userSelect
            },
        pointerEvents: ({ props: props })=>props.pointerEvents && {
                pointerEvents: props.pointerEvents
            },
        cursor: ({ props: props })=>props.cursor && {
                cursor: props.cursor
            }
    }
};


var $c3656ade3a6fd1e0$exports = {};

$parcel$export($c3656ade3a6fd1e0$exports, "Hoverable", () => $c3656ade3a6fd1e0$export$8cf654b375a16d2d);
$parcel$export($c3656ade3a6fd1e0$exports, "Clickable", () => $c3656ade3a6fd1e0$export$2f51d37476d4c437);
$parcel$export($c3656ade3a6fd1e0$exports, "Focusable", () => $c3656ade3a6fd1e0$export$35a3bebf7ef2d934);
$parcel$export($c3656ade3a6fd1e0$exports, "FocusableComponent", () => $c3656ade3a6fd1e0$export$b177f82f5511f000);
"use strict";
const $c3656ade3a6fd1e0$var$style = {
    appearance: "none",
    border: "none",
    cursor: "pointer",
    fontFamily: "inherit"
};
const $c3656ade3a6fd1e0$export$8cf654b375a16d2d = {
    props: {
        transition: "C defaultBezier",
        transitionProperty: "opacity, transform",
        opacity: 0.85,
        ":hover": {
            opacity: 0.9,
            transform: "scale(1.015)"
        },
        ":active": {
            opacity: 1,
            transform: "scale(1.015)"
        },
        ".active": {
            opacity: 1,
            transform: "scale(1.015)",
            ":hover": {
                opacity: 1
            }
        }
    }
};
const $c3656ade3a6fd1e0$export$2f51d37476d4c437 = {
    extend: $c3656ade3a6fd1e0$export$8cf654b375a16d2d,
    props: {
        ":active": {
            opacity: 1,
            transform: "scale(1.015)"
        },
        ".active": {
            opacity: 1
        }
    }
};
const $c3656ade3a6fd1e0$export$35a3bebf7ef2d934 = {
    props: {
        border: "none",
        outline: "solid, 0, blue .3",
        ":focus-visible": {
            opacity: 1,
            outline: "solid, X, blue .3"
        }
    },
    attr: {
        placeholder: ({ props: props })=>props.placeholder,
        tabIndex: ({ props: props })=>props.tabIndex
    }
};
const $c3656ade3a6fd1e0$export$b177f82f5511f000 = {
    extend: $c3656ade3a6fd1e0$export$35a3bebf7ef2d934,
    tag: "button",
    props: {
        fontSize: "A",
        type: "button",
        border: "none",
        textDecoration: "none",
        lineHeight: "1",
        whiteSpace: "nowrap",
        fontFamily: "inherit",
        style: $c3656ade3a6fd1e0$var$style
    },
    attr: {
        type: ({ props: props })=>props.type
    }
};


var $1cd063474a590068$exports = {};

$parcel$export($1cd063474a590068$exports, "Overflow", () => $1cd063474a590068$export$25d20c189d4a23b8);
"use strict";
const $1cd063474a590068$export$25d20c189d4a23b8 = {
    class: {
        overflow: ({ props: props })=>props.overflow && {
                overflow: props.overflow
            },
        overflowX: ({ props: props })=>props.overflowX && {
                overflowX: props.overflowX
            },
        overflowY: ({ props: props })=>props.overflowY && {
                overflowY: props.overflowY
            }
    }
};


var $c17872c3358c86eb$exports = {};

$parcel$export($c17872c3358c86eb$exports, "Collection", () => $c17872c3358c86eb$export$fb8073518f34e6ec);
"use strict";
const $bfb47641e396194b$export$5100524046ce8de6 = [
    "update",
    "parse",
    "clean",
    "create",
    "destroy",
    "add",
    "toggle",
    "remove",
    "apply",
    "set",
    "reset",
    "rootUpdate",
    "parentUpdate",
    "parent",
    "__element",
    "__depends",
    "__ref",
    "__children",
    "__root"
];


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $33936e69aa63c9cd$export$27ca81ea148fa005 = (param, element, state, context, options)=>{
    return param(element, state || element.state, context || element.context, options);
};
const $33936e69aa63c9cd$export$1bc010482b845252 = (param, element, options)=>{
    if (element.on && (0, $EqHTq.isFunction)(element.on[param])) {
        const { state: state, context: context } = element;
        return $33936e69aa63c9cd$export$27ca81ea148fa005(element.on[param], element, state, context, options);
    }
};
const $33936e69aa63c9cd$export$906113ec468a9c43 = (param, updatedObj, element, state, context, options)=>{
    return param(updatedObj, element, state || element.state, context || element.context, options);
};
const $33936e69aa63c9cd$export$8fe90418b8a0fc1e = (param, updatedObj, element, options)=>{
    if (element.on && (0, $EqHTq.isFunction)(element.on[param])) {
        const { state: state, context: context } = element;
        return $33936e69aa63c9cd$export$906113ec468a9c43(element.on[param], updatedObj, element, state, context, options);
    }
};
const $33936e69aa63c9cd$export$1f7cb486ba1f8a10 = (element, options)=>{
    const { node: node, on: on } = element;
    for(const param in on){
        if (param === "init" || param === "beforeClassAssign" || param === "render" || param === "renderRouter" || param === "attachNode" || param === "stateInit" || param === "stateCreated" || param === "initStateUpdate" || param === "stateUpdate" || param === "initUpdate" || param === "update") continue;
        const appliedFunction = element.on[param];
        if ((0, $EqHTq.isFunction)(appliedFunction)) node.addEventListener(param, (event)=>{
            const { state: state, context: context } = element;
            appliedFunction(event, element, state, context, options);
        });
    }
};


var $06908963bda72849$exports = {};

$parcel$export($06908963bda72849$exports, "ERRORS_REGISTRY", () => $06908963bda72849$export$fc4da02de2c0bd43);
$parcel$export($06908963bda72849$exports, "report", () => $06908963bda72849$export$f18d5b0af29128b7);
"use strict";
const $06908963bda72849$export$fc4da02de2c0bd43 = {
    en: {
        DocumentNotDefined: {
            title: "Document is undefined",
            description: "To tweak with DOM, you should use browser."
        },
        OverwriteToBuiltin: {
            title: "Overwriting to builtin method",
            description: "Overwriting a builtin method in the window define is not possible, please choose different name"
        },
        BrowserNotDefined: {
            title: "Can't recognize environment",
            description: "Environment should be browser application, that can run Javascript"
        },
        SetQuickPreferancesIsNotObject: {
            title: "Quick preferances object is required",
            description: 'Please pass a plain object with "lang", "culture" and "area" properties'
        },
        InvalidParams: {
            title: "Params are invalid",
            description: 'Please pass a plain object with "lang", "culture" and "area" properties'
        },
        CantCreateWithoutNode: {
            title: "You must provide node",
            description: "Can't create DOM element without setting node or text"
        },
        HTMLInvalidTag: {
            title: "Element tag name (or DOM nodeName) is invalid",
            description: "To create element, you must provide valid DOM node. See full list of them at here: http://www.w3schools.com/tags/"
        },
        HTMLInvalidAttr: {
            title: "Attibutes object is invalid",
            description: "Please pass a valid plain object to apply as an attributes for a DOM node"
        },
        HTMLInvalidData: {
            title: "Data object is invalid",
            description: "Please pass a valid plain object to apply as an dataset for a DOM node"
        },
        HTMLInvalidStyles: {
            title: "Styles object is invalid",
            description: "Please pass a valid plain object to apply as an style for a DOM node"
        },
        HTMLInvalidText: {
            title: "Text string is invalid",
            description: "Please pass a valid string to apply text to DOM node"
        },
        ElementOnStateIsNotDefined: {
            title: "Element on state is not defined",
            description: "Please check the element object"
        }
    }
};
const $06908963bda72849$export$f18d5b0af29128b7 = (err, arg, element)=>{
    const currentLang = "en";
    let errObj;
    if (err && typeof err === "string") errObj = $06908963bda72849$export$fc4da02de2c0bd43[currentLang][err];
    return new Error(`"${err}", "${arg}"\n\n`, `${errObj.description}`, element ? `\n\n${element}` : "");
};


parcelRequire("cBUNY");
var $glQML = parcelRequire("glQML");
"use strict";
const $a7c2803c7e7b293f$export$5d42fc0d80b5349f = (element)=>{
    const tag = element.tag || "div";
    return (0, $glQML.isValidHtmlTag)(tag) || (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidTag");
};


"use strict";


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $hSU9O = parcelRequire("hSU9O");

"use strict";
const $7c314a91da5c12c3$export$98e6a39c04603d36 = function() {
    const state = this;
    if ((0, $EqHTq.isObject)(state)) {
        const obj = {};
        for(const param in state)if (!(0, $bfb47641e396194b$export$5100524046ce8de6).includes(param)) obj[param] = state[param];
        return obj;
    } else if ((0, $EqHTq.isArray)(state)) return state.filter((item)=>!(0, $bfb47641e396194b$export$5100524046ce8de6).includes(item));
};
const $7c314a91da5c12c3$export$cf0b2a6c63f9e656 = function(options = {}) {
    const state = this;
    for(const param in state)if (!(0, $bfb47641e396194b$export$5100524046ce8de6).includes(param)) delete state[param];
    if (!options.preventStateUpdate) state.update(state, {
        replace: true,
        ...options
    });
    return state;
};
const $7c314a91da5c12c3$export$b1fb4cac938035f7 = function(options = {}) {
    const state = this;
    const element = state.__element;
    const stateKey = element.__ref.__state;
    if ((0, $EqHTq.isString)(stateKey)) {
        element.parent.state.remove(stateKey, {
            isHoisted: true,
            ...options
        });
        return element.state;
    }
    delete element.state;
    element.state = state.parent;
    if (state.parent) delete state.parent.__children[element.key];
    if (state.__children) for(const key in state.__children){
        const child = state.__children[key];
        if (child.state) {
            if ((0, $EqHTq.isArray)(child.state)) Object.defineProperty(child.state, "parent", {
                value: state.parent,
                enumerable: false,
                configurable: true,
                writable: true // Set this to true if you want to allow changing the function later
            });
            else Object.setPrototypeOf(child, {
                parent: state.parent
            });
        }
    }
    element.state.update({}, {
        isHoisted: true,
        ...options
    });
    return element.state;
};
const $7c314a91da5c12c3$export$e45af8832c6abf26 = function(obj, options = {}) {
    const state = this;
    if (!state || !state.parent) return;
    return state.parent.update(obj, {
        isHoisted: true,
        ...options
    });
};
const $7c314a91da5c12c3$export$c2f300c8c094e900 = function(obj, options = {}) {
    const state = this;
    if (!state) return;
    const rootState = state.__element.__ref.__root.state;
    return rootState.update(obj, {
        isHoisted: false,
        ...options
    });
};
const $7c314a91da5c12c3$export$e16d8520af44a096 = function(value, options = {}) {
    const state = this;
    if ((0, $EqHTq.isArray)(state)) {
        state.push(value);
        state.update(state.parse(), {
            overwrite: "replace",
            ...options
        });
    } else if ((0, $EqHTq.isObject)(state)) {
        const key = Object.keys(state).length;
        state.update({
            [key]: value
        }, options);
    }
};
const $7c314a91da5c12c3$export$e03c1c3201ee8bb7 = function(key, options = {}) {
    const state = this;
    state.update({
        [key]: !state[key]
    }, options);
};
const $7c314a91da5c12c3$export$cd7f480d6b8286c3 = function(key, options = {}) {
    const state = this;
    if ((0, $EqHTq.isArray)(state)) (0, $hSU9O.removeFromArray)(state, key);
    if ((0, $EqHTq.isObject)(state)) (0, $8wu6n.removeFromObject)(state, key);
    return state.set(state.parse(), {
        replace: true,
        ...options
    });
};
const $7c314a91da5c12c3$export$adaa4cf7ef1b65be = function(val, options = {}) {
    const state = this;
    const value = (0, $8wu6n.deepCloneWithExtnd)(val);
    return state.clean({
        preventStateUpdate: true,
        ...options
    }).update(value, {
        replace: true,
        ...options
    });
};
const $7c314a91da5c12c3$export$aad8462122ac592b = function(options = {}) {
    const state = this;
    const value = (0, $8wu6n.deepCloneWithExtnd)(state.parse());
    return state.set(value, {
        replace: true,
        ...options
    });
};
const $7c314a91da5c12c3$export$5635d7ef4b8fee1c = function(func, options = {}) {
    const state = this;
    if ((0, $EqHTq.isFunction)(func)) {
        func(state);
        return state.update(state.parse(), {
            replace: true,
            ...options
        });
    }
};





parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $5fcb062e9eb35754$export$f7dd4f6f6830b29d = (stateKey, parentState)=>{
    if (!stateKey.includes("../")) return;
    const arr = stateKey.split("../");
    const arrLength = arr.length - 1;
    for(let i = 0; i < arrLength; i++){
        if (!parentState.parent) return null;
        parentState = parentState.parent;
    }
    return parentState;
};
const $5fcb062e9eb35754$export$e6d108f71cc7e736 = (stateKey, parentState, options = {})=>{
    const arr = stateKey.split("/");
    const arrLength = arr.length - 1;
    for(let i = 0; i < arrLength; i++){
        const childKey = arr[i];
        const grandChildKey = arr[i + 1];
        if (childKey === "__proto__" || grandChildKey === "__proto__") return;
        let childInParent = parentState[childKey];
        if (!childInParent) childInParent = parentState[childKey] = {} // check for array
        ;
        if (!childInParent[grandChildKey]) childInParent[grandChildKey] = {} // check for array
        ;
        stateKey = grandChildKey;
        parentState = childInParent;
    }
    if (options.returnParent) return parentState;
    return parentState[stateKey];
};
const $5fcb062e9eb35754$export$487549069bb5d2a9 = (element, parent, options = {})=>{
    const ref = element.__ref;
    let stateKey = ref.__state;
    if (!$5fcb062e9eb35754$export$e187d7e20e9fd8fa(element)) return;
    let parentState = parent.state;
    const findGrandParentState = $5fcb062e9eb35754$export$f7dd4f6f6830b29d(stateKey, parent.state);
    if (findGrandParentState) {
        parentState = findGrandParentState;
        stateKey = stateKey.replaceAll("../", "");
    }
    if (!parentState) return;
    return $5fcb062e9eb35754$export$e6d108f71cc7e736(stateKey, parentState, options);
};
const $5fcb062e9eb35754$export$c546cc738d4564ba = (element, parent)=>{
    const ref = element.__ref;
    const inheritedState = $5fcb062e9eb35754$export$487549069bb5d2a9(element, parent);
    if ((0, $EqHTq.isUndefined)(inheritedState)) return element.state;
    if ((0, $EqHTq.is)(inheritedState)("object", "array")) return (0, $8wu6n.deepCloneWithExtnd)(inheritedState, (0, $bfb47641e396194b$export$5100524046ce8de6));
    else if ((0, $EqHTq.is)(inheritedState)("string", "number", "boolean")) {
        ref.__stateType = typeof inheritedState;
        return {
            value: inheritedState
        };
    }
    console.warn(ref.__state, "is not present. Replacing with", {});
};
const $5fcb062e9eb35754$export$e187d7e20e9fd8fa = (element)=>{
    const ref = element.__ref;
    const stateKey = ref.__state;
    if (stateKey && (0, $EqHTq.is)(stateKey)("number", "string", "boolean")) return true;
    return false;
};
const $5fcb062e9eb35754$export$e5d60a6bbabd36f = function(state) {
    if (!(0, $EqHTq.isObjectLike)(state)) return false;
    return state.update && state.parse && state.clean && state.create && state.parent && state.destroy && state.rootUpdate && state.parentUpdate && state.toggle && state.add && state.apply && state.__element && state.__children;
// return arrayContainsOtherArray(keys, ['update', 'parse', 'clean', 'create', 'parent', 'rootUpdate'])
};
const $5fcb062e9eb35754$export$2318606fe59d6594 = (path, value)=>{
    if (!path) return value || {};
    const keys = path.split("/");
    const obj = {};
    let ref = obj;
    keys.forEach((key, index)=>{
        ref[key] = index === keys.length - 1 ? value || {} : {};
        ref = ref[key];
    });
    return obj;
};


"use strict";
const $8b576c5d9c1d0c84$var$STATE_UPDATE_OPTIONS = {
    overwrite: true,
    preventHoistElementUpdate: false,
    updateByState: true,
    isHoisted: true,
    execStateFunction: true
};
const $8b576c5d9c1d0c84$export$4971331372cec95a = function(obj, options = $8b576c5d9c1d0c84$var$STATE_UPDATE_OPTIONS) {
    const state = this;
    const element = state.__element;
    if (!options.updateByState) (0, $8wu6n.merge)(options, $8b576c5d9c1d0c84$var$STATE_UPDATE_OPTIONS);
    if (!state.__element) (0, $06908963bda72849$export$f18d5b0af29128b7)("ElementOnStateIsNotDefined");
    if (options.preventInheritAtCurrentState === true) options.preventInheritAtCurrentState = state;
    else if (options.preventInheritAtCurrentState) return;
    if (!options.preventInitStateUpdateListener) {
        const initStateUpdateReturns = (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("initStateUpdate", obj, element, options);
        if (initStateUpdateReturns === false) return element;
    }
    $8b576c5d9c1d0c84$var$applyOverwrite(state, obj, options);
    const updateIsHoisted = $8b576c5d9c1d0c84$var$hoistStateUpdate(state, obj, options);
    if (updateIsHoisted) return state;
    $8b576c5d9c1d0c84$var$updateDependentState(state, obj, options);
    $8b576c5d9c1d0c84$var$applyElementUpdate(state, obj, options);
    if (!options.preventStateUpdateListener) (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("stateUpdate", obj, element, options);
    return state;
};
const $8b576c5d9c1d0c84$var$applyOverwrite = (state, obj, options)=>{
    const { overwrite: overwrite } = options;
    if (!overwrite) return;
    const shallow = overwrite === "shallow" || overwrite === "shallow-once";
    const merge = overwrite === "merge";
    if (merge) {
        (0, $8wu6n.deepMerge)(state, obj, (0, $bfb47641e396194b$export$5100524046ce8de6));
        return;
    }
    const overwriteFunc = shallow ? (0, $8wu6n.overwriteShallow) : (0, $8wu6n.overwriteDeep);
    if (options.overwrite === "shallow-once") options.overwrite = true;
    overwriteFunc(state, obj, (0, $bfb47641e396194b$export$5100524046ce8de6));
};
const $8b576c5d9c1d0c84$var$hoistStateUpdate = (state, obj, options)=>{
    const element = state.__element;
    const { parent: parent, __ref: ref } = element;
    const stateKey = ref.__state;
    const stateType = ref.__stateType;
    if (!stateKey) return;
    const asksForInherit = (0, $5fcb062e9eb35754$export$e187d7e20e9fd8fa)(element);
    const inheritedState = (0, $5fcb062e9eb35754$export$487549069bb5d2a9)(element, parent, {
        returnParent: true
    });
    const shouldPropagateState = asksForInherit && inheritedState && !options.stopStatePropagation;
    if (!shouldPropagateState) return;
    const isStringState = stateType === "string" || stateType === "number" || stateType === "boolean";
    const value = isStringState ? state.value : state.parse();
    const passedValue = isStringState ? state.value : obj;
    const findGrandParentState = (0, $5fcb062e9eb35754$export$f7dd4f6f6830b29d)(stateKey, parent.state);
    const changesValue = (0, $5fcb062e9eb35754$export$2318606fe59d6594)(stateKey, passedValue);
    const targetParent = findGrandParentState || parent.state;
    if (options.replace) (0, $8wu6n.overwriteDeep)(targetParent, changesValue || value) // check with createChangesByKey
    ;
    targetParent.update(changesValue, {
        execStateFunction: false,
        isHoisted: true,
        preventUpdate: options.preventHoistElementUpdate,
        overwrite: !options.replace,
        ...options
    });
    const hasNotUpdated = options.preventUpdate !== true || !options.preventHoistElementUpdate;
    if (!options.preventStateUpdateListener && hasNotUpdated) (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("stateUpdate", obj, element, options);
    return true;
};
const $8b576c5d9c1d0c84$var$updateDependentState = (state, obj, options)=>{
    if (!state.__depends) return;
    for(const el in state.__depends){
        const dependentState = state.__depends[el];
        dependentState.clean().update(state.parse(), options);
    }
};
const $8b576c5d9c1d0c84$var$applyElementUpdate = (state, obj, options)=>{
    const element = state.__element;
    if (options.preventUpdate !== true) element.update({}, {
        ...options,
        updateByState: true
    });
    else if (options.preventUpdate === "recursive") element.update({}, {
        ...options,
        isHoisted: false,
        updateByState: true,
        preventUpdate: true
    });
};



"use strict";
const $774f1a3b2fe82710$export$e6a0daad8304de = function(element, parent, options) {
    element.state = $774f1a3b2fe82710$export$6e8a0938c76079c7(element, parent, options);
    return element.state;
};
const $774f1a3b2fe82710$export$6e8a0938c76079c7 = function(element, parent, options) {
    const objectizeState = $774f1a3b2fe82710$var$checkForTypes(element);
    if (objectizeState === false) return parent.state || {};
    else element.state = (0, $8wu6n.deepCloneWithExtnd)(objectizeState, (0, $bfb47641e396194b$export$5100524046ce8de6));
    const whatInitReturns = (0, $33936e69aa63c9cd$export$1bc010482b845252)("stateInit", element, options);
    if (whatInitReturns === false) return element.state;
    if ((0, $5fcb062e9eb35754$export$e187d7e20e9fd8fa)(element)) {
        const inheritedState = (0, $5fcb062e9eb35754$export$c546cc738d4564ba)(element, parent);
        element.state = (0, $EqHTq.isUndefined)(inheritedState) ? {} : inheritedState;
    }
    const dependentState = $774f1a3b2fe82710$var$applyDependentState(element, element.state);
    if (dependentState) element.state = dependentState;
    $774f1a3b2fe82710$var$applyMethods(element);
    // trigger `on.stateCreated`
    (0, $33936e69aa63c9cd$export$1bc010482b845252)("stateCreated", element);
    return element.state;
};
const $774f1a3b2fe82710$var$applyDependentState = (element, state)=>{
    const { __ref: ref } = state;
    if (!ref) return;
    const dependentState = (0, $8wu6n.deepCloneWithExtnd)(ref, (0, $bfb47641e396194b$export$5100524046ce8de6));
    const newDepends = {
        [element.key]: dependentState
    };
    ref.__depends = (0, $EqHTq.isObject)(ref.__depends) ? {
        ...ref.__depends,
        ...newDepends
    } : newDepends;
    return dependentState;
};
const $774f1a3b2fe82710$var$checkForTypes = (element)=>{
    const { state: state, __ref: ref } = element;
    if ((0, $EqHTq.isFunction)(state)) {
        ref.__state = state;
        return (0, $8wu6n.exec)(state, element);
    } else if ((0, $EqHTq.is)(state)("string", "number")) {
        ref.__state = state;
        return {};
    } else if (state === true) {
        ref.__state = element.key;
        return {};
    } else if (state) {
        ref.__hasRootState = true;
        return state;
    } else return false;
};
const $774f1a3b2fe82710$var$addProtoToArray = (state, proto)=>{
    for(const key in proto)Object.defineProperty(state, key, {
        value: proto[key],
        enumerable: false,
        configurable: true,
        writable: true // Set this to true if you want to allow changing the function later
    });
};
const $774f1a3b2fe82710$var$applyMethods = (element)=>{
    const state = element.state;
    const ref = element.__ref;
    const proto = {
        clean: (0, $7c314a91da5c12c3$export$cf0b2a6c63f9e656).bind(state),
        parse: (0, $7c314a91da5c12c3$export$98e6a39c04603d36).bind(state),
        destroy: (0, $7c314a91da5c12c3$export$b1fb4cac938035f7).bind(state),
        update: (0, $8b576c5d9c1d0c84$export$4971331372cec95a).bind(state),
        rootUpdate: (0, $7c314a91da5c12c3$export$c2f300c8c094e900).bind(state),
        parentUpdate: (0, $7c314a91da5c12c3$export$e45af8832c6abf26).bind(state),
        create: $774f1a3b2fe82710$export$e6a0daad8304de.bind(state),
        add: (0, $7c314a91da5c12c3$export$e16d8520af44a096).bind(state),
        toggle: (0, $7c314a91da5c12c3$export$e03c1c3201ee8bb7).bind(state),
        remove: (0, $7c314a91da5c12c3$export$cd7f480d6b8286c3).bind(state),
        apply: (0, $7c314a91da5c12c3$export$5635d7ef4b8fee1c).bind(state),
        set: (0, $7c314a91da5c12c3$export$adaa4cf7ef1b65be).bind(state),
        reset: (0, $7c314a91da5c12c3$export$aad8462122ac592b).bind(state),
        parent: element.parent.state,
        __element: element,
        __children: {},
        __root: ref.__root ? ref.__root.state : state
    };
    if ((0, $EqHTq.isArray)(state)) $774f1a3b2fe82710$var$addProtoToArray(state, proto);
    else Object.setPrototypeOf(state, proto);
    if (state.parent && state.parent.__children) state.parent.__children[element.key] = state;
};





"use strict";


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $c17872c3358c86eb$export$fb8073518f34e6ec = {
    define: {
        $collection: (param, el, state)=>{
            if (!param) return;
            if ((0, $EqHTq.isString)(param)) {
                if (param === "state") param = state.parse();
                else param = (0, $5fcb062e9eb35754$export$e6d108f71cc7e736)(param, state);
            }
            if ((0, $5fcb062e9eb35754$export$e5d60a6bbabd36f)(param)) param = param.parse();
            if ((0, $EqHTq.isNot)(param)("array", "object")) return;
            const { __ref: ref } = el;
            if (ref.__stateCollectionCache) {
                const d = (0, $8wu6n.deepDiff)(param, ref.__stateCollectionCache) // eslint-disable-line
                ;
                if (Object.keys(d).length) {
                    ref.__stateCollectionCache = (0, $8wu6n.deepClone)(param);
                    delete ref.__noCollectionDifference;
                } else {
                    ref.__noCollectionDifference = true;
                    return;
                }
            } else ref.__stateCollectionCache = (0, $8wu6n.deepClone)(param);
            const obj = {
                tag: "fragment",
                props: {
                    childProps: el.props && el.props.childProps
                }
            };
            for(const key in param){
                const value = param[key];
                obj[key] = (0, $EqHTq.isObjectLike)(value) ? value : {
                    value: value
                };
            }
            el.removeContent();
            el.content = obj;
            return obj;
        },
        $setCollection: (param, el, state)=>{
            if (!param) return;
            if ((0, $EqHTq.isString)(param)) {
                if (param === "state") param = state.parse();
                else param = (0, $5fcb062e9eb35754$export$e6d108f71cc7e736)(param, state);
            }
            const data = ((0, $EqHTq.isArray)(param) ? param : (0, $EqHTq.isObject)(param) ? Object.values(param) : []).map((item)=>!(0, $EqHTq.isObjectLike)(item) ? {
                    props: {
                        value: item
                    }
                } : item);
            if (data.length) {
                const t = setTimeout(()=>{
                    el.set({
                        tag: "fragment",
                        ...data
                    }, {
                        preventDefineUpdate: "$setCollection"
                    });
                    clearTimeout(t);
                });
            }
            return data;
        },
        $stateCollection: (param, el, state)=>{
            if (!param) return;
            if ((0, $EqHTq.isString)(param)) {
                if (param === "state") param = state.parse();
                else param = (0, $5fcb062e9eb35754$export$e6d108f71cc7e736)(param, state);
            }
            if ((0, $5fcb062e9eb35754$export$e5d60a6bbabd36f)(param)) param = param.parse();
            if ((0, $EqHTq.isNot)(param)("array", "object")) return;
            const { __ref: ref } = el;
            if (ref.__stateCollectionCache) {
                const d = (0, $8wu6n.deepDiff)(param, ref.__stateCollectionCache) // eslint-disable-line
                ;
                if (Object.keys(d).length) {
                    ref.__stateCollectionCache = (0, $8wu6n.deepClone)(param);
                    delete ref.__noCollectionDifference;
                } else {
                    ref.__noCollectionDifference = true;
                    return;
                }
            } else ref.__stateCollectionCache = (0, $8wu6n.deepClone)(param);
            const obj = {
                tag: "fragment",
                props: {
                    childProps: el.props && el.props.childProps
                }
            };
            for(const key in param){
                const value = param[key];
                obj[key] = {
                    state: (0, $EqHTq.isObjectLike)(value) ? value : {
                        value: value
                    }
                };
            }
            el.removeContent();
            el.content = obj;
            return obj;
        },
        $propsCollection: (param, el, state)=>{
            if (!param) return;
            if ((0, $EqHTq.isString)(param)) {
                if (param === "state") param = state.parse();
                else param = (0, $5fcb062e9eb35754$export$e6d108f71cc7e736)(param, state);
            }
            if ((0, $5fcb062e9eb35754$export$e5d60a6bbabd36f)(param)) param = param.parse();
            if ((0, $EqHTq.isNot)(param)("array", "object")) return;
            const { __ref: ref } = el;
            if (ref.__propsCollectionCache) {
                const d = (0, $8wu6n.deepDiff)(param, ref.__propsCollectionCache) // eslint-disable-line
                ;
                if (Object.keys(d).length) {
                    ref.__propsCollectionCache = (0, $8wu6n.deepClone)(param);
                    delete ref.__noCollectionDifference;
                } else {
                    ref.__noCollectionDifference = true;
                    return;
                }
            } else ref.__propsCollectionCache = (0, $8wu6n.deepClone)(param);
            const obj = {
                tag: "fragment",
                props: {
                    childProps: el.props && el.props.childProps
                }
            };
            for(const key in param){
                const value = param[key];
                obj[key] = {
                    props: (0, $EqHTq.isObjectLike)(value) ? value : {
                        value: value
                    }
                };
            }
            el.removeContent();
            el.content = obj;
            // const set = () => {
            //   el.set(obj, { preventDefineUpdate: '$propsCollection' })
            // }
            // if (el.props && el.props.lazyLoad) {
            //   window.requestAnimationFrame(set)
            // } else set()
            return obj;
        }
    }
};


var $b974d8cead94d416$exports = {};

$parcel$export($b974d8cead94d416$exports, "Position", () => $b974d8cead94d416$export$13807d9ee5a34a42);

"use strict";
const $b974d8cead94d416$export$13807d9ee5a34a42 = {
    deps: {
        getSpacingByKey: $7a9f91e2b97567cc$export$4f949d23b5dbefe6
    },
    class: {
        position: ({ props: props })=>props.position && {
                position: props.position
            },
        inset: ({ props: props, deps: deps })=>{
            const { inset: inset } = props;
            if (typeof inset !== "string") return;
            return {
                inset: inset.split(" ").map((v)=>deps.getSpacingByKey(v, "k").k).join(" ")
            };
        },
        left: ({ props: props, deps: deps })=>deps.getSpacingByKey(props.left, "left"),
        top: ({ props: props, deps: deps })=>deps.getSpacingByKey(props.top, "top"),
        right: ({ props: props, deps: deps })=>deps.getSpacingByKey(props.right, "right"),
        bottom: ({ props: props, deps: deps })=>deps.getSpacingByKey(props.bottom, "bottom")
    }
};


var $80736e04e60e3fa1$exports = {};

$parcel$export($80736e04e60e3fa1$exports, "Picture", () => $80736e04e60e3fa1$export$f0d5dc2ce3e4cb5f);

"use strict";
const $80736e04e60e3fa1$export$f0d5dc2ce3e4cb5f = {
    deps: {
        getSystemTheme: $2ae1edf582b77174$export$fe979c3403443f94
    },
    tag: "picture",
    childExtend: {
        tag: "source",
        attr: {
            media: (element)=>{
                const { props: props, key: key, context: context, deps: deps } = element;
                const { MEDIA: MEDIA } = context.designSystem;
                const globalTheme = deps.getSystemTheme(element);
                const mediaName = (props.media || key).slice(1);
                if (mediaName === globalTheme) return "(min-width: 0px)";
                else if (mediaName === "dark" || mediaName === "light") return "(max-width: 0px)";
                return MEDIA[mediaName];
            },
            srcset: ({ props: props })=>props.srcset
        }
    },
    Img: ({ props: props })=>({
            width: "inherit",
            height: "inherit",
            src: props.src
        })
};


var $2fb1843bd4d59ef3$exports = {};

$parcel$export($2fb1843bd4d59ef3$exports, "Pseudo", () => $2fb1843bd4d59ef3$export$36c664c5efe2f59c);
"use strict";
const $2fb1843bd4d59ef3$export$36c664c5efe2f59c = {
    class: {
        content: ({ props: props })=>props.content && {
                content: props.content
            }
    }
};


var $7d36ad90912ad279$exports = {};

$parcel$export($7d36ad90912ad279$exports, "Svg", () => $7d36ad90912ad279$export$e17b9c1182212c96);

"use strict";
const $7d36ad90912ad279$export$e17b9c1182212c96 = {
    tag: "svg",
    deps: {
        init: $31242768b5023c84$export$2cd8252107eb640b
    },
    props: {
        style: {
            "*": {
                fill: "currentColor"
            }
        }
    },
    attr: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
    },
    html: ({ key: key, props: props, context: context, deps: deps, ...el })=>{
        const { designSystem: designSystem } = context;
        const SVG = designSystem && designSystem.SVG;
        const useSvgSprite = props.spriteId || context.designSystem && context.designSystem.useSvgSprite;
        if (!useSvgSprite && props.src) return props.src;
        const useSVGSymbol = (icon)=>`<use xlink:href="#${icon}" />`;
        const spriteId = props.spriteId;
        if (spriteId) return useSVGSymbol(spriteId);
        const symbolId = Symbol.for(props.src);
        let SVGKey = SVG[symbolId];
        if (SVGKey && SVG[SVGKey]) return useSVGSymbol(SVGKey);
        SVGKey = SVG[symbolId] = Math.random();
        if (props.src) deps.init({
            svg: {
                [SVGKey]: props.src
            }
        }, {
            document: context.document,
            emotion: context.emotion
        });
        return useSVGSymbol(SVGKey);
    }
};


var $f93c5e7c35cc4205$exports = {};

$parcel$defineInteropFlag($f93c5e7c35cc4205$exports);

$parcel$export($f93c5e7c35cc4205$exports, "Shape", () => $f93c5e7c35cc4205$export$6428a7f2611ef1fa);
$parcel$export($f93c5e7c35cc4205$exports, "default", () => $f93c5e7c35cc4205$export$2e2bcd8739ae039);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");



"use strict";
const $f93c5e7c35cc4205$var$transformBorderRadius = (radius, props, propertyName)=>{
    if (!(0, $EqHTq.isString)(radius)) return;
    return {
        borderRadius: radius.split(" ").map((v, k)=>(0, $7a9f91e2b97567cc$export$94679ba49f16fc2e)(props, propertyName, v)[propertyName]).join(" ")
    };
};
const $f93c5e7c35cc4205$export$6428a7f2611ef1fa = {
    extend: (0, $2fb1843bd4d59ef3$export$36c664c5efe2f59c),
    deps: {
        exec: $8wu6n.exec,
        getSpacingBasedOnRatio: $7a9f91e2b97567cc$export$94679ba49f16fc2e,
        getMediaColor: $c6753c52b98cd54e$export$dd72f6d9deea7207,
        transformBorderRadius: $f93c5e7c35cc4205$var$transformBorderRadius
    },
    class: {
        shape: ({ props: props, deps: deps })=>{
            const { shape: shape } = props;
            return deps.exec((0, $1364b7b7ead3f203$export$511e1d54a4a8684e)[shape], {
                props: props,
                deps: deps
            });
        },
        shapeDirection: ({ props: props })=>{
            const { shape: shape, shapeDirection: shapeDirection } = props;
            if (!shape || !shapeDirection) return;
            const shapeDir = (0, $1364b7b7ead3f203$export$511e1d54a4a8684e)[shape + "Direction"];
            return shape && shapeDir ? shapeDir[shapeDirection || "left"] : null;
        },
        shapeDirectionColor: ({ props: props, deps: deps })=>{
            const { background: background, backgroundColor: backgroundColor } = props;
            const borderColor = {
                borderColor: deps.getMediaColor(background || backgroundColor)
            };
            return props.shapeDirection ? borderColor : null;
        },
        round: ({ props: props, key: key, deps: deps, ...el })=>deps.transformBorderRadius(props.round || props.borderRadius, props, "round"),
        borderRadius: ({ props: props, key: key, deps: deps, ...el })=>deps.transformBorderRadius(props.borderRadius || props.round, props, "borderRadius")
    }
};
var $f93c5e7c35cc4205$export$2e2bcd8739ae039 = $f93c5e7c35cc4205$export$6428a7f2611ef1fa;



var $b448a4a1f1311a88$exports = {};

$parcel$export($b448a4a1f1311a88$exports, "Text", () => $b448a4a1f1311a88$export$5f1af8db9871e1d6);
$parcel$export($b448a4a1f1311a88$exports, "H1", () => $b448a4a1f1311a88$export$5523b16adee8048);
$parcel$export($b448a4a1f1311a88$exports, "H2", () => $b448a4a1f1311a88$export$cb94397127ac9363);
$parcel$export($b448a4a1f1311a88$exports, "H3", () => $b448a4a1f1311a88$export$746be9e3a3dfff1f);
$parcel$export($b448a4a1f1311a88$exports, "H4", () => $b448a4a1f1311a88$export$cc5e069d64fda823);
$parcel$export($b448a4a1f1311a88$exports, "H5", () => $b448a4a1f1311a88$export$88ef9fdaf11f7a1f);
$parcel$export($b448a4a1f1311a88$exports, "H6", () => $b448a4a1f1311a88$export$a559fb8039b06400);
$parcel$export($b448a4a1f1311a88$exports, "P", () => $b448a4a1f1311a88$export$56c0d5a1e737357d);
$parcel$export($b448a4a1f1311a88$exports, "Caption", () => $b448a4a1f1311a88$export$32fbfacc5d962e0c);
$parcel$export($b448a4a1f1311a88$exports, "Strong", () => $b448a4a1f1311a88$export$f301627d437cff88);
$parcel$export($b448a4a1f1311a88$exports, "Underline", () => $b448a4a1f1311a88$export$741ee5bff4f2bc22);
$parcel$export($b448a4a1f1311a88$exports, "Italic", () => $b448a4a1f1311a88$export$1cfcf4275506b1c6);
$parcel$export($b448a4a1f1311a88$exports, "Title", () => $b448a4a1f1311a88$export$f99233281efd08a0);
$parcel$export($b448a4a1f1311a88$exports, "Headline", () => $b448a4a1f1311a88$export$e1faab0803786bcf);
$parcel$export($b448a4a1f1311a88$exports, "Subhead", () => $b448a4a1f1311a88$export$17e07beff4cf82a6);
$parcel$export($b448a4a1f1311a88$exports, "Footnote", () => $b448a4a1f1311a88$export$54539b446c9863da);
$parcel$export($b448a4a1f1311a88$exports, "B", () => $b448a4a1f1311a88$export$ef35774e6d314e91);
$parcel$export($b448a4a1f1311a88$exports, "I", () => $b448a4a1f1311a88$export$9bb611d729802a56);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $b448a4a1f1311a88$export$5f1af8db9871e1d6 = {
    deps: {
        getFontSizeByKey: $277afaefb2791215$export$ea9b2cd64205746b,
        getFontFamily: $ed362cf167c3740b$export$c4930fc256cef44f
    },
    text: ({ key: key, props: props, state: state, deps: deps })=>{
        if (props.text === true) return state && state[key] || props && props[key];
        return props.text;
    },
    class: {
        fontSize: (el)=>{
            const { props: props, deps: deps } = el;
            return props.fontSize ? deps.getFontSizeByKey(props.fontSize) : null;
        },
        font: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.font) && {
                font: props.font
            },
        fontFamily: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.fontFamily) && {
                fontFamily: deps.getFontFamily(props.fontFamily) || props.fontFamily
            },
        lineHeight: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.lineHeight) && {
                lineHeight: props.lineHeight
            },
        // lineHeight: ({ props }) => !isUndefined(props.lineHeight) && getSpacingBasedOnRatio(props, 'lineHeight', null, ''),
        textDecoration: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.textDecoration) && {
                textDecoration: props.textDecoration
            },
        textTransform: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.textTransform) && {
                textTransform: props.textTransform
            },
        wordBreak: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.wordBreak) && {
                wordBreak: props.wordBreak
            },
        whiteSpace: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.whiteSpace) && {
                whiteSpace: props.whiteSpace
            },
        wordWrap: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.wordWrap) && {
                wordWrap: props.wordWrap
            },
        letterSpacing: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.letterSpacing) && {
                letterSpacing: props.letterSpacing
            },
        textOverflow: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.textOverflow) && {
                textOverflow: props.textOverflow
            },
        textAlign: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.textAlign) && {
                textAlign: props.textAlign
            },
        fontWeight: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.fontWeight) && {
                fontWeight: props.fontWeight,
                fontVariationSettings: '"wght" ' + props.fontWeight
            }
    }
};
const $b448a4a1f1311a88$export$5523b16adee8048 = {
    tag: "h1"
};
const $b448a4a1f1311a88$export$cb94397127ac9363 = {
    tag: "h2"
};
const $b448a4a1f1311a88$export$746be9e3a3dfff1f = {
    tag: "h3"
};
const $b448a4a1f1311a88$export$cc5e069d64fda823 = {
    tag: "h4"
};
const $b448a4a1f1311a88$export$88ef9fdaf11f7a1f = {
    tag: "h5"
};
const $b448a4a1f1311a88$export$a559fb8039b06400 = {
    tag: "h6"
};
const $b448a4a1f1311a88$export$56c0d5a1e737357d = {
    tag: "p"
};
const $b448a4a1f1311a88$export$32fbfacc5d962e0c = {
    tag: "caption"
};
const $b448a4a1f1311a88$export$f301627d437cff88 = {
    tag: "strong",
    props: {
        fontWeight: "700"
    }
};
const $b448a4a1f1311a88$export$741ee5bff4f2bc22 = {
    tag: "u"
};
const $b448a4a1f1311a88$export$1cfcf4275506b1c6 = {
    tag: "i"
};
const $b448a4a1f1311a88$export$f99233281efd08a0 = {};
const $b448a4a1f1311a88$export$e1faab0803786bcf = {
    tag: "h6",
    props: {
        fontSize: "B",
        fontWeight: 500
    }
};
const $b448a4a1f1311a88$export$17e07beff4cf82a6 = {
    tag: "span",
    props: {
        fontSize: "Z1"
    }
};
const $b448a4a1f1311a88$export$54539b446c9863da = {
    tag: "span",
    props: {
        fontSize: "Z"
    }
};
const $b448a4a1f1311a88$export$ef35774e6d314e91 = {
    tag: "b"
};
const $b448a4a1f1311a88$export$9bb611d729802a56 = {
    tag: "i"
};



var $d40f17327c4275d4$exports = {};

$parcel$export($d40f17327c4275d4$exports, "Transform", () => $d40f17327c4275d4$export$563a914cafbdc389);
"use strict";
const $d40f17327c4275d4$export$563a914cafbdc389 = {
    class: {
        zoom: ({ props: props })=>props.zoom && {
                zoom: props.zoom
            },
        transform: ({ props: props })=>props.transform && {
                transform: props.transform
            },
        transformOrigin: ({ props: props })=>props.transformOrigin && {
                transformOrigin: props.transformOrigin
            }
    }
};


var $6a19813fd6d21e30$exports = {};

$parcel$export($6a19813fd6d21e30$exports, "XYZ", () => $6a19813fd6d21e30$export$36b810b8b2e73231);
"use strict";
const $6a19813fd6d21e30$export$36b810b8b2e73231 = {
    class: {
        zIndex: ({ props: props })=>props.zIndex && {
                zIndex: props.zIndex
            }
    }
};


var $d23f9a85003e63d3$exports = {};

$parcel$export($d23f9a85003e63d3$exports, "Animation", () => $d23f9a85003e63d3$export$c35d437ae5945fcd);

parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $d23f9a85003e63d3$var$applyAnimationProps = (animation, element)=>{
    const { emotion: ctxEmotion } = element.context;
    const { keyframes: keyframes } = ctxEmotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    if ((0, $EqHTq.isObject)(animation)) return {
        animationName: keyframes(animation)
    };
    const { ANIMATION: ANIMATION } = element.context && element.context.designSystem;
    const record = ANIMATION[animation];
    return keyframes(record);
};
const $d23f9a85003e63d3$export$c35d437ae5945fcd = {
    deps: {
        isObject: $EqHTq.isObject,
        getTimingByKey: $200bfc3872a6d81d$export$3fa311edc5edd22f,
        getTimingFunction: $200bfc3872a6d81d$export$23ba66c7c3e2e613,
        applyAnimationProps: $d23f9a85003e63d3$var$applyAnimationProps
    },
    class: {
        animation: (el)=>el.props.animation && {
                animationName: el.deps.applyAnimationProps(el.props.animation, el),
                animationDuration: el.deps.getTimingByKey(el.props.animationDuration || "A").timing,
                animationDelay: el.deps.getTimingByKey(el.props.animationDelay || "0s").timing,
                animationTimingFunction: el.deps.getTimingFunction(el.props.animationTimingFunction || "ease"),
                animationFillMode: el.props.animationFillMode || "both",
                animationPlayState: el.props.animationPlayState,
                animationDirection: el.props.animationDirection
            },
        animationName: (el)=>el.props.animationName && {
                animationName: el.deps.applyAnimationProps(el.props.animationName, el)
            },
        animationDuration: ({ props: props, deps: deps })=>props.animationDuration && {
                animationDuration: deps.getTimingByKey(props.animationDuration).timing
            },
        animationDelay: ({ props: props, deps: deps })=>props.animationDelay && {
                animationDelay: deps.getTimingByKey(props.animationDelay).timing
            },
        animationTimingFunction: ({ props: props, deps: deps })=>props.animationTimingFunction && {
                animationTimingFunction: deps.getTimingFunction(props.animationTimingFunction)
            },
        animationFillMode: ({ props: props })=>props.animationFillMode && {
                animationFillMode: props.animationFillMode
            },
        animationPlayState: ({ props: props })=>props.animationPlayState && {
                animationPlayState: props.animationPlayState
            },
        animationIterationCount: ({ props: props })=>props.animationIterationCount && {
                animationIterationCount: props.animationIterationCount || 1
            },
        animationDirection: ({ props: props })=>props.animationDirection && {
                animationDirection: props.animationDirection
            }
    }
};


"use strict";
$parcel$exportWildcard($73d59c6c3fce378b$exports, $40d382f435ee1fdb$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $b908145e0b91dcdb$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $8184389c03ed1792$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $afd03220988cb716$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $c95002999fe11fd8$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $f085155ee8a416c4$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $bc85e892389de1ab$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $0b0e26e2a21aab54$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $2d62e11bc2f194bd$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $c3656ade3a6fd1e0$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $1cd063474a590068$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $c17872c3358c86eb$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $b974d8cead94d416$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $80736e04e60e3fa1$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $2fb1843bd4d59ef3$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $7d36ad90912ad279$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $f93c5e7c35cc4205$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $2ae1edf582b77174$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $b448a4a1f1311a88$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $3e7681929891ee4e$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $d40f17327c4275d4$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $6a19813fd6d21e30$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $d23f9a85003e63d3$exports);


var $c95c6861d219ec8a$exports = {};

$parcel$export($c95c6861d219ec8a$exports, "Box", () => $c95c6861d219ec8a$export$e71c4d32a2263218);
$parcel$export($c95c6861d219ec8a$exports, "Circle", () => $c95c6861d219ec8a$export$c89a927ffc67e6fa);

parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $c95c6861d219ec8a$var$PropsCSS = {
    class: {
        style: ({ props: props })=>props && props.style
    }
};
const $c95c6861d219ec8a$export$e71c4d32a2263218 = {
    extend: [
        $c95c6861d219ec8a$var$PropsCSS,
        (0, $f93c5e7c35cc4205$export$6428a7f2611ef1fa),
        (0, $b974d8cead94d416$export$13807d9ee5a34a42),
        (0, $2ae1edf582b77174$export$14faa19a0f3bbeb2),
        (0, $40d382f435ee1fdb$export$d96a8827a60d6b69),
        (0, $b448a4a1f1311a88$export$5f1af8db9871e1d6),
        (0, $1cd063474a590068$export$25d20c189d4a23b8),
        (0, $3e7681929891ee4e$export$ef1e5872612852d1),
        (0, $d40f17327c4275d4$export$563a914cafbdc389),
        (0, $bc85e892389de1ab$export$7fc53215244aec38),
        (0, $2d62e11bc2f194bd$export$a13296960cae0384),
        (0, $6a19813fd6d21e30$export$36b810b8b2e73231),
        (0, $d23f9a85003e63d3$export$c35d437ae5945fcd)
    ],
    deps: {
        isString: $EqHTq.isString
    },
    attr: {
        id: ({ props: props, deps: deps })=>deps.isString(props.id) && props.id,
        title: ({ props: props, deps: deps })=>deps.isString(props.title) && props.title,
        contentEditable: ({ props: props })=>props.contentEditable || props.contenteditable,
        dir: ({ props: props })=>props.dir,
        draggable: ({ props: props })=>props.draggable,
        hidden: ({ props: props })=>props.hidden,
        lang: ({ props: props })=>props.lang,
        spellcheck: ({ props: props })=>props.spellcheck,
        tabindex: ({ props: props })=>props.tabindex,
        translate: ({ props: props })=>props.translate
    }
};
const $c95c6861d219ec8a$export$c89a927ffc67e6fa = {
    props: {
        round: "100%"
    }
};


var $f8a17223267b0208$exports = {};

$parcel$export($f8a17223267b0208$exports, "Icon", () => $f8a17223267b0208$export$f04a61298a47a40f);
$parcel$export($f8a17223267b0208$exports, "IconText", () => $f8a17223267b0208$export$fe7c634bfc18e397);
$parcel$export($f8a17223267b0208$exports, "FileIcon", () => $f8a17223267b0208$export$8c1a3d13e85d78b7);

parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $f8a17223267b0208$export$f04a61298a47a40f = {
    extend: (0, $7d36ad90912ad279$export$e17b9c1182212c96),
    deps: {
        isString: $EqHTq.isString
    },
    props: ({ key: key, props: props, parent: parent, context: context, deps: deps })=>{
        const { ICONS: ICONS, useIconSprite: useIconSprite, verbose: verbose } = context && context.designSystem;
        const { toCamelCase: toCamelCase } = context && context.utils;
        const iconName = props.name || props.icon || key;
        const camelCase = toCamelCase(deps.isString(iconName) ? iconName : key);
        const isArray = camelCase.split(/([a-z])([A-Z])/g);
        let activeIconName;
        if (props.active) activeIconName = props[".active"].name || props[".active"].icon;
        if (parent && parent.props && parent.props.active && parent.props[".active"] && parent.props[".active"].icon) activeIconName = parent.props[".active"].icon.name || parent.props[".active"].icon.icon || parent.props[".active"].icon;
        let validIconName;
        if (ICONS[activeIconName]) validIconName = activeIconName;
        if (ICONS[camelCase]) validIconName = camelCase;
        else if (ICONS[isArray[0] + isArray[1]]) validIconName = isArray[0] + isArray[1];
        else if (ICONS[isArray[0]]) validIconName = isArray[0];
        else if (verbose) console.warn("Can't find icon:", iconName, validIconName);
        const iconFromLibrary = ICONS[validIconName];
        const directSrc = parent && parent.props && parent.props.src || props.src;
        return {
            width: "A",
            height: "A",
            display: "inline-block",
            spriteId: useIconSprite && validIconName,
            src: iconFromLibrary || directSrc || ICONS.noIcon,
            style: {
                fill: "currentColor"
            }
        };
    },
    attr: {
        viewBox: "0 0 24 24"
    }
};
const $f8a17223267b0208$export$fe7c634bfc18e397 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        align: "center center",
        lineHeight: 1
    },
    Icon: {
        props: ({ parent: parent, props: props })=>({
                icon: parent.props.icon
            }),
        if: ({ parent: parent, props: props })=>{
            const doesExist = parent.props.icon || parent.props.Icon || props.name || props.icon;
            return doesExist;
        }
    },
    text: ({ props: props })=>props.text,
    ".reversed": {
        props: {
            flow: "row-reverse"
        }
    },
    ".vertical": {
        props: {
            flow: "column"
        }
    }
};
const $f8a17223267b0208$export$8c1a3d13e85d78b7 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        theme: "tertiary",
        boxSize: "C1",
        align: "center center",
        round: "Z"
    },
    Icon: {
        fontSize: "B",
        margin: "auto",
        icon: "file"
    }
};


var $5d0d06667ca93e89$exports = {};
var $c740580a6e69a0e6$exports = {};

$parcel$export($c740580a6e69a0e6$exports, "StatusIndicator", () => $c740580a6e69a0e6$export$b4f88f0ca5784eef);
"use strict";
const $c740580a6e69a0e6$export$b4f88f0ca5784eef = {
    props: {
        widthRange: "Z+V",
        theme: "primary",
        round: "100%",
        aspectRatio: "1/1",
        border: "solid, gray",
        borderWidth: "2px"
    }
};


var $0c6dd160b1fcaf0f$exports = {};

$parcel$export($0c6dd160b1fcaf0f$exports, "CheckIndicator", () => $0c6dd160b1fcaf0f$export$1b5af9b9e924baca);
$parcel$export($0c6dd160b1fcaf0f$exports, "CheckIndicatorWithLabel", () => $0c6dd160b1fcaf0f$export$1c148d89e9c73bd2);

"use strict";
const $0c6dd160b1fcaf0f$export$1b5af9b9e924baca = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        padding: "Y1",
        round: "100%",
        theme: "success"
    },
    Icon: {
        name: "check",
        fontSize: "A"
    }
};
const $0c6dd160b1fcaf0f$export$1c148d89e9c73bd2 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        align: "center flex-start",
        gap: "Z"
    },
    CheckIndicator: {},
    Caption: {
        text: "Step",
        fontWeight: "400"
    }
};


var $ec3d83c516121c79$exports = {};

$parcel$export($ec3d83c516121c79$exports, "CountIndicator", () => $ec3d83c516121c79$export$484b8642c0073407);

"use strict";
const $ec3d83c516121c79$export$484b8642c0073407 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        text: "2",
        theme: "primary",
        widthRange: "A1",
        boxSizing: "content-box",
        lineHeight: "1em",
        padding: "X",
        round: "100%",
        align: "center center",
        aspectRatio: "1 / 1"
    }
};


var $0734a9a0d8a64818$exports = {};

$parcel$export($0734a9a0d8a64818$exports, "RadioIndicator", () => $0734a9a0d8a64818$export$d35a9ffa9a04f9e7);
$parcel$export($0734a9a0d8a64818$exports, "RadioIndicatorWithLabel", () => $0734a9a0d8a64818$export$d488d51e59555914);

"use strict";
const $0734a9a0d8a64818$export$d35a9ffa9a04f9e7 = {
    props: {
        padding: "Z+V",
        theme: "tertiary",
        boxSize: "fit-content",
        round: "100%",
        ":after": {
            content: '""',
            boxSize: "Z",
            background: "white",
            display: "block",
            round: "100%"
        }
    }
};
const $0734a9a0d8a64818$export$d488d51e59555914 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        align: "center flex-start",
        gap: "Z"
    },
    RadioIndicator: {},
    Caption: {
        text: "Step",
        fontWeight: "500",
        fontSize: "Z2"
    }
};


var $96edeac257cf83d5$exports = {};

$parcel$export($96edeac257cf83d5$exports, "SuccessIndicator", () => $96edeac257cf83d5$export$93b3b8f45e6ad816);

"use strict";
const $96edeac257cf83d5$export$93b3b8f45e6ad816 = {
    extend: (0, $0c6dd160b1fcaf0f$export$1b5af9b9e924baca),
    props: {
        theme: "success",
        padding: "X+V2",
        fontSize: "F"
    }
};


"use strict";
$parcel$exportWildcard($5d0d06667ca93e89$exports, $c740580a6e69a0e6$exports);
$parcel$exportWildcard($5d0d06667ca93e89$exports, $0c6dd160b1fcaf0f$exports);
$parcel$exportWildcard($5d0d06667ca93e89$exports, $ec3d83c516121c79$exports);
$parcel$exportWildcard($5d0d06667ca93e89$exports, $0734a9a0d8a64818$exports);
$parcel$exportWildcard($5d0d06667ca93e89$exports, $96edeac257cf83d5$exports);


var $32625a13d757d0d6$exports = {};

$parcel$export($32625a13d757d0d6$exports, "Hgroup", () => $32625a13d757d0d6$export$bd5b3f7ef3b94a4a);
$parcel$export($32625a13d757d0d6$exports, "HgroupRows", () => $32625a13d757d0d6$export$4c6ac4526c395f50);
$parcel$export($32625a13d757d0d6$exports, "HgroupButton", () => $32625a13d757d0d6$export$7fa5389f12735f1f);

"use strict";
const $32625a13d757d0d6$export$bd5b3f7ef3b94a4a = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    tag: "hgroup",
    props: {
        flow: "column",
        gap: "Y",
        Title: {
            fontWeight: "700",
            alignItems: "center"
        },
        Paragraph: {
            margin: "0",
            color: "caption",
            "> p": {
                margin: "0"
            }
        }
    },
    Title: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        if: ({ parent: parent })=>parent.props.title,
        props: ({ scope: scope, parent: parent })=>({
                text: parent.props.title,
                lineHeight: "1em"
            })
    },
    Paragraph: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        if: ({ parent: parent })=>parent.props.paragraph,
        props: ({ scope: scope, parent: parent })=>({
                text: parent.props.paragraph,
                margin: "0"
            })
    }
};
const $32625a13d757d0d6$export$4c6ac4526c395f50 = {
    extend: $32625a13d757d0d6$export$bd5b3f7ef3b94a4a,
    Title: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            color: "title",
            align: "center space-between"
        }
    },
    Paragraph: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            color: "paragraph",
            align: "center space-between"
        }
    }
};
const $32625a13d757d0d6$export$7fa5389f12735f1f = {
    extend: $32625a13d757d0d6$export$4c6ac4526c395f50,
    Title: {
        props: {
            justifyContent: "space-between"
        },
        Span: {},
        Button: {
            props: {
                background: "transparent",
                color: "currentColor",
                padding: "0",
                Icon: {
                    name: "x",
                    fontSize: "C"
                }
            }
        }
    },
    Paragraph: {}
};


var $f70d2005bd02a5dc$exports = {};

$parcel$export($f70d2005bd02a5dc$exports, "Banner", () => $f70d2005bd02a5dc$export$3b4e64e77073e307);

var $bfe4bf8a850bff5d$exports = {};
var $6129fe7cbc1a3e27$exports = {};

$parcel$export($6129fe7cbc1a3e27$exports, "List", () => $6129fe7cbc1a3e27$export$54c2e3dc7acea9f5);
$parcel$export($6129fe7cbc1a3e27$exports, "ListTemplate", () => $6129fe7cbc1a3e27$export$92d9ebaedf6ba994);
$parcel$export($6129fe7cbc1a3e27$exports, "DotList", () => $6129fe7cbc1a3e27$export$4f8543c05544ab60);

"use strict";
const $6129fe7cbc1a3e27$export$54c2e3dc7acea9f5 = {
    props: {
        position: "relative",
        overflow: "hidden",
        round: "A",
        minWidth: "F1",
        theme: "dialog",
        ":before, &:after": {
            content: '""',
            position: "absolute",
            boxSize: "A2 100%",
            zIndex: "2",
            left: "0",
            pointerEvents: "none"
        },
        ":before": {
            top: "0",
            background: "linear-gradient(to bottom, var(--theme-dialog-dark-background) 0%, transparent 100%)"
        },
        ":after": {
            bottom: "0",
            background: "linear-gradient(to top, var(--theme-dialog-dark-background) 0%, transparent 100%)"
        }
    },
    Flex: {
        props: {
            flow: "column",
            maxHeight: "F+C",
            overflow: "auto",
            "::-webkit-scrollbar": {
                display: "none"
            }
        },
        childExtend: {
            props: {
                padding: "Z1 A1",
                position: "relative",
                cursor: "pointer",
                color: "caption",
                ":hover": {
                    background: "gray .92 +4"
                },
                childProps: {
                    position: "relative"
                }
            }
        }
    }
};
const $6129fe7cbc1a3e27$export$92d9ebaedf6ba994 = {
    extend: $6129fe7cbc1a3e27$export$54c2e3dc7acea9f5,
    props: {
        maxWidth: "F"
    },
    Flex: {
        ...[
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            }
        ]
    }
};
const $6129fe7cbc1a3e27$export$4f8543c05544ab60 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        flow: "column",
        gap: "Z2"
    },
    childExtend: {
        tag: "caption",
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            align: "center flex-start",
            lineHeight: "1em",
            fontWeight: "700",
            fontSize: "B",
            gap: "Z",
            ":before": {
                content: '""',
                boxSize: "W_default",
                background: "currentColor",
                zIndex: "20"
            }
        }
    },
    ...[
        {
            props: {
                text: "brand font"
            }
        }
    ]
};


var $c7bf60df080a0235$exports = {};

$parcel$export($c7bf60df080a0235$exports, "ListWithTitle", () => $c7bf60df080a0235$export$4ff37d595c9ddd65);
$parcel$export($c7bf60df080a0235$exports, "ListWithTitleTemplate", () => $c7bf60df080a0235$export$40693a637a08ac1c);


"use strict";
const $c7bf60df080a0235$export$4ff37d595c9ddd65 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        flow: "column",
        overflow: "hidden",
        round: "A",
        maxWidth: "F1"
    },
    Title: {
        tag: "h5",
        props: {
            position: "sticky",
            top: "0",
            zIndex: "3",
            text: "Group name",
            color: "gray .92 +68",
            fontWeight: "400",
            theme: "dialog",
            padding: "A"
        }
    },
    List: {
        extend: (0, $6129fe7cbc1a3e27$export$54c2e3dc7acea9f5),
        props: {
            round: "0",
            minWidth: "100%"
        }
    }
};
const $c7bf60df080a0235$export$40693a637a08ac1c = {
    extend: $c7bf60df080a0235$export$4ff37d595c9ddd65,
    Title: {},
    List: {
        Flex: {
            ...[
                {
                    span: {
                        text: "Item"
                    }
                },
                {
                    span: {
                        text: "Item"
                    }
                },
                {
                    span: {
                        text: "Item"
                    }
                },
                {
                    span: {
                        text: "Item"
                    }
                },
                {
                    span: {
                        text: "Item"
                    }
                }
            ]
        }
    }
};


var $4579617f0fa8bf9e$exports = {};

$parcel$export($4579617f0fa8bf9e$exports, "GroupList", () => $4579617f0fa8bf9e$export$fbb84e1f3ad193aa);
$parcel$export($4579617f0fa8bf9e$exports, "GroupListTemplate", () => $4579617f0fa8bf9e$export$68db3b1dce1e4bec);


"use strict";
const $4579617f0fa8bf9e$export$fbb84e1f3ad193aa = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        flow: "column",
        overflow: "hidden",
        theme: "dialog",
        maxHeight: "H",
        round: "A",
        maxWidth: "G"
    },
    Header: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            text: "Header",
            padding: "Z2 A",
            fontSize: "A2",
            fontWeight: "500"
        }
    },
    Groups: {
        props: {
            position: "relative",
            ":before, &:after": {
                content: '""',
                position: "absolute",
                boxSize: "A2 100%",
                zIndex: "2",
                left: "0",
                pointerEvents: "none"
            },
            ":before": {
                top: "0",
                background: "linear-gradient(to bottom, var(--theme-dialog-dark-background) 0%, transparent 100%)"
            },
            ":after": {
                bottom: "0",
                background: "linear-gradient(to top, var(--theme-dialog-dark-background) 0%, transparent 100%)"
            }
        },
        Flex: {
            extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
            props: {
                flow: "column",
                maxHeight: "G2",
                overflow: "auto",
                "::-webkit-scrollbar": {
                    display: "none"
                }
            },
            childExtend: {
                extend: (0, $c7bf60df080a0235$export$4ff37d595c9ddd65),
                props: {
                    round: "0",
                    minWidth: "100%",
                    overflow: "visible",
                    background: "transparent"
                },
                Title: {
                    props: {
                        theme: "transparent"
                    }
                },
                List: {
                    props: {
                        overflow: "visible",
                        theme: "transparent",
                        ":before": {
                            display: "none"
                        },
                        ":after": {
                            display: "none"
                        }
                    },
                    Flex: {
                        props: {
                            style: {
                                overflowY: "visible"
                            },
                            minHeight: "fit-content",
                            maxHeight: "fit-content",
                            childProps: {
                                ":after": {
                                    background: "gray"
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
const $4579617f0fa8bf9e$export$68db3b1dce1e4bec = {
    extend: $4579617f0fa8bf9e$export$fbb84e1f3ad193aa,
    Header: {},
    Groups: {
        props: {},
        Flex: {
            props: {},
            ...[
                {
                    Title: null,
                    List: {
                        props: {},
                        Flex: {
                            props: {},
                            ...[
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                }
                            ]
                        }
                    }
                },
                {
                    Title: {},
                    List: {
                        props: {},
                        Flex: {
                            props: {},
                            ...[
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                }
                            ]
                        }
                    }
                },
                {
                    Title: {},
                    List: {
                        props: {},
                        Flex: {
                            props: {},
                            ...[
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                }
                            ]
                        }
                    }
                }
            ]
        }
    }
};


var $1c06718eab5142ba$exports = {};

$parcel$export($1c06718eab5142ba$exports, "GroupListWithSearch", () => $1c06718eab5142ba$export$8fd62ef8d907c0bc);
$parcel$export($1c06718eab5142ba$exports, "GroupListWithSearchTemplate", () => $1c06718eab5142ba$export$acc754292a9a26ee);

var $408dff139db483ea$exports = {};
var $846f9615e5dff418$exports = {};

$parcel$export($846f9615e5dff418$exports, "CommonField", () => $846f9615e5dff418$export$5fe3d428dda5a48e);
$parcel$export($846f9615e5dff418$exports, "CommonFieldTemplate", () => $846f9615e5dff418$export$baa29b825dfa9c0a);


"use strict";
const $846f9615e5dff418$export$5fe3d428dda5a48e = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    tag: "label",
    props: {
        flow: "column",
        boxSize: "fit-content fit-content",
        gap: "Z"
    },
    Title: {
        props: {
            text: "Label",
            lineHeight: "1em",
            padding: "- - - V2",
            color: "caption"
        }
    },
    Field: {
        tag: "div"
    },
    Hint: {
        extend: (0, $f8a17223267b0208$export$fe7c634bfc18e397),
        props: {
            color: "caption",
            align: "center flex-start",
            text: "",
            fontSize: "Z1",
            gap: "Y",
            padding: "W - - W"
        }
    }
};
const $846f9615e5dff418$export$baa29b825dfa9c0a = {
    extend: $846f9615e5dff418$export$5fe3d428dda5a48e,
    Title: {},
    Field: {
        Icon: {
            props: {
                name: "info"
            }
        },
        Input: {},
        Button: {
            icon: "eye"
        }
    },
    Hint: {
        Icon: {
            props: {
                name: "info"
            }
        },
        text: "Description"
    }
};


var $86fa541a35e509bb$exports = {};

$parcel$export($86fa541a35e509bb$exports, "Field", () => $86fa541a35e509bb$export$a455218a85c89869);
$parcel$export($86fa541a35e509bb$exports, "FieldTemplate", () => $86fa541a35e509bb$export$5eb2102ba34ef9b2);
$parcel$export($86fa541a35e509bb$exports, "FieldWithTitle", () => $86fa541a35e509bb$export$257a13be48b6f047);
$parcel$export($86fa541a35e509bb$exports, "FieldWithTitleTemplate", () => $86fa541a35e509bb$export$a9dd5a869d4dc0cb);


"use strict";
const $86fa541a35e509bb$export$a455218a85c89869 = {
    extend: "Flex",
    tag: "label",
    props: {
        minWidth: "F2+Z2",
        maxWidth: "F2+Z2",
        minHeight: "C+V",
        align: "center flex-start",
        gap: "Y",
        boxSizing: "border-box",
        position: "relative",
        Input: {
            padding: "Z2 B2 Z2 B",
            flex: "1"
        },
        Button: {
            padding: "0",
            background: "transparent",
            margin: "- - - auto",
            fontSize: "Z2"
        }
    },
    Input: {
        placeholder: "Placeholder"
    },
    Icon: {
        props: ({ parent: parent })=>({
                name: parent.props.icon,
                minWidth: "A",
                margin: "- Z1 - -C",
                position: "relative"
            })
    }
};
const $86fa541a35e509bb$export$5eb2102ba34ef9b2 = {
    extend: $86fa541a35e509bb$export$a455218a85c89869,
    Icon: {
        props: {
            name: "info"
        }
    },
    Input: {},
    Button: {
        Icon: {
            name: "eye"
        }
    }
};
const $86fa541a35e509bb$export$257a13be48b6f047 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        flow: "column",
        boxSize: "fit-content fit-content",
        gap: "Y1",
        // border: '.05px solid red',
        Hint: {
            color: "gray 1 +64",
            align: "center flex-start",
            fontSize: "Z2",
            gap: "Y",
            padding: "W Y2 - Y2"
        }
    },
    Title: {
        props: {
            text: "Label",
            lineHeight: "1em",
            color: "title",
            fontWeight: "400",
            padding: "- Y1"
        }
    },
    Field: {
        extend: $86fa541a35e509bb$export$a455218a85c89869
    }
};
const $86fa541a35e509bb$export$a9dd5a869d4dc0cb = {
    extend: $86fa541a35e509bb$export$257a13be48b6f047,
    Title: {},
    Field: {
        Icon: {
            props: {
                name: "info"
            }
        },
        Input: {},
        Button: {
            icon: "eye"
        }
    },
    Hint: {
        extend: (0, $f8a17223267b0208$export$fe7c634bfc18e397),
        props: {
            icon: "info",
            text: "Description"
        }
    }
};


var $d5f256e68f92ff3f$exports = {};

$parcel$export($d5f256e68f92ff3f$exports, "Search", () => $d5f256e68f92ff3f$export$4b85d3515bd863a5);
$parcel$export($d5f256e68f92ff3f$exports, "SearchWithButton", () => $d5f256e68f92ff3f$export$19f2462a4dbfed8);
$parcel$export($d5f256e68f92ff3f$exports, "SearchWithDropDownButton", () => $d5f256e68f92ff3f$export$b28ff139ed930e2d);
"use strict";
const $d5f256e68f92ff3f$export$4b85d3515bd863a5 = {
    tag: "search",
    props: {
        maxWidth: "G3",
        gap: "Z",
        onSubmit: (ev, el, s)=>{}
    },
    Form: {
        extend: "Field",
        props: {
            flow: "row-reverse",
            Input: {
                padding: "Z2 B Z2 C"
            },
            Icon: {
                margin: "- -C - Z1",
                name: "search"
            }
        },
        Input: {
            props: {
                type: "search",
                placeholder: "Search",
                "::placeholder": {
                    color: "paragraph"
                }
            }
        },
        Icon: {},
        on: {
            submit: (ev, el, s)=>el.parent.props.onSubmit(ev, el, s)
        }
    }
};
const $d5f256e68f92ff3f$export$19f2462a4dbfed8 = {
    extend: $d5f256e68f92ff3f$export$4b85d3515bd863a5,
    props: {
        Button: {
            fontSize: "B"
        }
    },
    Form: {
        Icon: {},
        Input: {
            props: {
                ":focus ~ button": {
                    opacity: "1"
                }
            }
        },
        Button: {
            props: {
                opacity: "0",
                icon: "x"
            },
            Icon: {
                on: {
                    click: (e, el)=>{
                        el.parent.parent.Input.node.value = "";
                    }
                }
            }
        }
    }
};
const $d5f256e68f92ff3f$export$b28ff139ed930e2d = {
    extend: $d5f256e68f92ff3f$export$19f2462a4dbfed8,
    props: {
        theme: "tertiary",
        maxWidth: "G3+C",
        padding: "0 A 0 0",
        gap: "Z"
    },
    DropDownButton: {},
    Input: {
        props: {
            padding: "- - - X"
        }
    },
    Button: {},
    Icon: {}
};


var $dd0910b23638afad$exports = {};

$parcel$export($dd0910b23638afad$exports, "TextAreaField", () => $dd0910b23638afad$export$301bf6213f61d17f);

"use strict";
const $dd0910b23638afad$export$301bf6213f61d17f = {
    tag: "label",
    extend: (0, $c3656ade3a6fd1e0$export$35a3bebf7ef2d934),
    props: {
        boxSize: "fit-content",
        border: "solid, gray .45 +80",
        borderWidth: ".8px",
        overflow: "hidden",
        round: "Z1",
        ":focus-within": {
            outline: "1px solid #0474F2"
        }
    },
    TextArea: {
        tag: "textarea",
        attr: {
            placeholder: "Leave us a message..."
        },
        props: {
            minWidth: "H",
            minHeight: "D2+Y1",
            padding: "A",
            fontFamily: "avenir",
            theme: "transparent",
            border: "none",
            outline: "none",
            style: {
                resize: "none"
            },
            "::placeholder": {
                color: "gray 1 +64"
            }
        }
    }
};


"use strict";
$parcel$exportWildcard($408dff139db483ea$exports, $846f9615e5dff418$exports);
$parcel$exportWildcard($408dff139db483ea$exports, $86fa541a35e509bb$exports);
$parcel$exportWildcard($408dff139db483ea$exports, $d5f256e68f92ff3f$exports);
$parcel$exportWildcard($408dff139db483ea$exports, $dd0910b23638afad$exports);



"use strict";
const $1c06718eab5142ba$export$8fd62ef8d907c0bc = {
    extend: (0, $4579617f0fa8bf9e$export$fbb84e1f3ad193aa),
    props: {
        maxWidth: "G1_default"
    },
    Header: {},
    SearchContainer: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            padding: "0 Z1 Y2 Z1",
            background: "transparent"
        },
        Search: {
            extend: (0, $d5f256e68f92ff3f$export$4b85d3515bd863a5),
            props: {
                maxWidth: "100%",
                minWidth: "100%",
                minHeight: "C",
                theme: "transparent",
                round: "Z1"
            },
            Icon: {
                props: {
                    fontSize: "C",
                    color: "title"
                }
            },
            Input: {
                fontSize: "Z"
            }
        }
    },
    Groups: {
        Flex: {
            childExtend: {
                Title: {},
                List: {
                    Flex: {
                        childExtend: {
                            props: {}
                        }
                    }
                }
            }
        }
    }
};
const $1c06718eab5142ba$export$acc754292a9a26ee = {
    extend: $1c06718eab5142ba$export$8fd62ef8d907c0bc,
    Header: {},
    SearchContainer: {},
    Groups: {
        Flex: {
            ...[
                {
                    Title: null,
                    List: {
                        Flex: {
                            ...[
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                }
                            ]
                        }
                    }
                },
                {
                    Title: {},
                    List: {
                        Flex: {
                            ...[
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                }
                            ]
                        }
                    }
                },
                {
                    Title: {},
                    List: {
                        Flex: {
                            ...[
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                }
                            ]
                        }
                    }
                }
            ]
        }
    }
};


"use strict";
$parcel$exportWildcard($bfe4bf8a850bff5d$exports, $6129fe7cbc1a3e27$exports);
$parcel$exportWildcard($bfe4bf8a850bff5d$exports, $c7bf60df080a0235$exports);
$parcel$exportWildcard($bfe4bf8a850bff5d$exports, $4579617f0fa8bf9e$exports);
$parcel$exportWildcard($bfe4bf8a850bff5d$exports, $1c06718eab5142ba$exports);


"use strict";
const $f70d2005bd02a5dc$export$3b4e64e77073e307 = {
    extend: (0, $32625a13d757d0d6$export$bd5b3f7ef3b94a4a),
    props: {
        height: "fit-content",
        padding: "D2+Z D+Y2 D D",
        width: "100%",
        theme: "dialog",
        align: "flex-start",
        gap: "B",
        "@mobileL": {
            padding: "C1 C"
        },
        "@mobileS": {
            padding: "C1 B"
        }
    },
    Title: {
        tag: "h1",
        props: {
            textTransform: "capitalize",
            fontSize: "L",
            fontWeight: "900",
            letterSpacing: "-0.035em",
            lineHeight: ".8em",
            gap: "0",
            "@mobileL": {
                fontSize: "J2"
            },
            "@mobileM": {
                fontSize: "J"
            },
            "@mobileS": {
                fontSize: "I"
            },
            maxWidth: "fit-content"
        }
    },
    Paragraph: {
        props: {
            flow: "column",
            justifyContent: "space-between",
            flex: "1",
            minWidth: "100%",
            position: "relative",
            gap: "A",
            "@mobileL": {
                display: "none"
            },
            // '@tabletS': { display: 'none' },
            ":before": {
                content: '""',
                position: "absolute",
                boxSize: "0.3px 100%",
                theme: "dialog",
                top: "0",
                round: "C",
                background: "white 0"
            }
        },
        P: {
            props: {
                text: "Our typography system ranges from impactful brand type used in marketing applications to functional type used in product.",
                // maxWidth: 'G2_default',
                maxWidth: "G1_default",
                lineHeight: "1.6em",
                color: "grey",
                padding: "- Z",
                "@mobileL": {
                    display: "none"
                }
            }
        },
        Flex: {
            extend: (0, $32625a13d757d0d6$export$bd5b3f7ef3b94a4a),
            props: {
                gap: "A2",
                alignSelf: "flex-end",
                "@mobileL": {
                    alignSelf: "flex-start",
                    padding: "- A2"
                }
            },
            Title: {
                tag: "h6",
                props: {
                    text: "What you\u2019ll find",
                    fontWeight: "400",
                    color: "grey",
                    fontSize: "Z2"
                }
            },
            Paragraph: {
                ...(0, $6129fe7cbc1a3e27$export$4f8543c05544ab60),
                ...[
                    {}
                ]
            }
        }
    }
};


var $f887848157c82147$exports = {};

$parcel$export($f887848157c82147$exports, "UnitValue", () => $f887848157c82147$export$d703b7d35511419c);
$parcel$export($f887848157c82147$exports, "DoubleUnitValue", () => $f887848157c82147$export$19636468023d76f);
$parcel$export($f887848157c82147$exports, "UnitValueWithLabel", () => $f887848157c82147$export$2315678a8bc727a7);
$parcel$export($f887848157c82147$exports, "UnitValueWithTitle", () => $f887848157c82147$export$8efdae2c595fd1);

"use strict";
const $f887848157c82147$export$d703b7d35511419c = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        color: "title",
        align: "center flex-start",
        gap: "V",
        fontWeight: "400",
        "> *": {
            lineHeight: "1em"
        }
    },
    Value: {
        props: {
            text: "72"
        }
    },
    Unit: {
        props: {
            text: "%"
        }
    }
};
const $f887848157c82147$export$19636468023d76f = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        align: "center flex-start",
        color: "caption",
        gap: "Y"
    },
    UnitValue: {
        Value: {
            text: "72"
        },
        Unit: {
            text: "%"
        }
    },
    dot: {
        props: {
            boxSize: "W W",
            round: "100%",
            background: "currentColor"
        }
    },
    UnitValue_2: {
        props: {
            gap: "X+W"
        },
        Value: {
            text: "2"
        },
        Unit: {
            text: "Second left"
        }
    }
};
const $f887848157c82147$export$2315678a8bc727a7 = {
    extend: $f887848157c82147$export$19636468023d76f,
    props: {
        gap: "Y2"
    },
    UnitValue: {
        flow: "row-reverse",
        fontWeight: "700",
        Value: {
            text: "12,759"
        },
        Unit: {
            text: "$"
        }
    },
    dot: null,
    UnitValue_2: {
        props: {
            theme: "field",
            padding: "Z",
            round: "Y1",
            gap: "0"
        },
        Value: {
            text: "+8.8"
        },
        Unit: {
            text: "%"
        }
    }
};
const $f887848157c82147$export$8efdae2c595fd1 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        align: "center flex-start",
        gap: "Y",
        fontSize: "Z1"
    },
    Title: {
        tag: "caption",
        props: {
            text: "balance :",
            textTransform: "capitalize"
        }
    },
    UnitValue: {
        textTransform: "uppercase",
        gap: "Y",
        color: "currentColor",
        Value: {
            text: "0"
        },
        Unit: {
            text: "bnb"
        }
    }
};


var $59e9b7f5a8955db9$exports = {};

$parcel$export($59e9b7f5a8955db9$exports, "Link", () => $59e9b7f5a8955db9$export$a6c7ac8248d6e38a);
$parcel$export($59e9b7f5a8955db9$exports, "RouterLink", () => $59e9b7f5a8955db9$export$fce709ebdac448ed);
$parcel$export($59e9b7f5a8955db9$exports, "RouteLink", () => $59e9b7f5a8955db9$export$9a6dc2d0fce7da79);
var $90351548418b68d1$exports = {};

$parcel$defineInteropFlag($90351548418b68d1$exports);

$parcel$export($90351548418b68d1$exports, "getActiveRoute", () => $90351548418b68d1$export$e7a685f330e7752);
$parcel$export($90351548418b68d1$exports, "lastPathname", () => $90351548418b68d1$export$7a9e7a91cdf4fce1);
$parcel$export($90351548418b68d1$exports, "lastLevel", () => $90351548418b68d1$export$ed098f724085d263);
$parcel$export($90351548418b68d1$exports, "router", () => $90351548418b68d1$export$5375cda95f0b0eb4);
$parcel$export($90351548418b68d1$exports, "default", () => $90351548418b68d1$export$2e2bcd8739ae039);
parcelRequire("cBUNY");
var $jvD5p = parcelRequire("jvD5p");
"use strict";
const $90351548418b68d1$export$e7a685f330e7752 = (level = 0, route = (0, $jvD5p.window).location.pathname)=>{
    const routeArray = route.split("/");
    const activeRoute = routeArray[level + 1];
    if (activeRoute) return `/${activeRoute}`;
};
let $90351548418b68d1$export$7a9e7a91cdf4fce1;
let $90351548418b68d1$export$ed098f724085d263 = 0;
const $90351548418b68d1$var$defaultOptions = {
    level: $90351548418b68d1$export$ed098f724085d263,
    pushState: true,
    initialRender: false,
    scrollToTop: true,
    scrollToNode: false,
    scrollNode: (0, $jvD5p.document) && (0, $jvD5p.document).documentElement,
    scrollBody: false,
    useFragment: false,
    updateState: true,
    scrollToOffset: 0,
    scrollToOptions: {
        behavior: "smooth"
    }
};
const $90351548418b68d1$export$5375cda95f0b0eb4 = (path, element, state = {}, passedOptions = {})=>{
    const options = {
        ...$90351548418b68d1$var$defaultOptions,
        ...element.context.routerOptions,
        ...passedOptions
    };
    $90351548418b68d1$export$ed098f724085d263 = options.lastLevel;
    const newElementKey = options.newElementKey;
    const [pathname, hash] = path.split("#");
    const rootNode = element.node;
    const route = $90351548418b68d1$export$e7a685f330e7752(options.level, pathname);
    const content = element.routes[route || "/"] || element.routes["/*"];
    const scrollNode = options.scrollToNode ? rootNode : options.scrollNode;
    const hashChanged = hash && hash !== (0, $jvD5p.window).location.hash.slice(1);
    const pathChanged = pathname !== $90351548418b68d1$export$7a9e7a91cdf4fce1;
    $90351548418b68d1$export$7a9e7a91cdf4fce1 = pathname;
    if (!content) return;
    if (options.pushState) (0, $jvD5p.window).history.pushState(state, null, pathname + (hash ? `#${hash}` : ""));
    if (pathChanged || !hashChanged) {
        if (options.updateState) element.state.update({
            route: route,
            hash: hash
        }, {
            preventContentUpdate: true
        });
        if (newElementKey && options.removeOldElement) element[newElementKey].remove();
        element.set({
            tag: options.useFragment && "fragment",
            extend: content
        }, {
            newElementKey: newElementKey
        });
    }
    if (options.scrollToTop) scrollNode.scrollTo({
        ...options.scrollToOptions || {},
        top: 0,
        left: 0
    });
    if (options.scrollToNode) content.content.node.scrollTo({
        ...options.scrollToOptions || {},
        top: 0,
        left: 0
    });
    if (hash) {
        const activeNode = (0, $jvD5p.document).getElementById(hash);
        if (activeNode) {
            const top = activeNode.getBoundingClientRect().top + rootNode.scrollTop - options.scrollToOffset || 0;
            scrollNode.scrollTo({
                ...options.scrollToOptions || {},
                top: top,
                left: 0
            });
        }
    }
};
var $90351548418b68d1$export$2e2bcd8739ae039 = $90351548418b68d1$export$5375cda95f0b0eb4;


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $59e9b7f5a8955db9$export$a6c7ac8248d6e38a = {
    extend: (0, $c3656ade3a6fd1e0$export$35a3bebf7ef2d934),
    tag: "a",
    props: {
        aria: {},
        fontWeight: "bold",
        textDecoration: "none",
        color: "currentColor",
        draggable: false
    },
    attr: {
        href: (el)=>{
            const { context: ctx } = el;
            const { exec: exec } = ctx.utils;
            return exec(el.props.href, el) || exec(el.props, el).href;
        },
        target: ({ props: props })=>props.target,
        "aria-label": ({ props: props })=>props.aria ? props.aria.label : props.text,
        draggable: ({ props: props })=>props.draggable
    }
};
const $59e9b7f5a8955db9$export$fce709ebdac448ed = {
    on: {
        click: (event, el)=>{
            const { props: props, context: ctx } = el;
            const { href: href, scrollToTop: scrollToTop } = props;
            if (!href) return;
            const { utils: utils, snippets: snippets, routerOptions: routerOptions } = ctx;
            const root = el.__ref.__root;
            const linkIsExternal = href.includes("http://") || href.includes("https://") || href.includes("mailto:") || href.includes("tel:");
            if (href && !linkIsExternal) {
                (snippets.router || utils.router || (0, $90351548418b68d1$export$5375cda95f0b0eb4))(href, root, {}, {
                    scrollToOptions: {
                        behaviour: "instant"
                    },
                    scrollToTop: (0, $EqHTq.isDefined)(scrollToTop) ? scrollToTop : true,
                    ...routerOptions,
                    ...props.routerOptions
                });
                event.preventDefault();
            }
        }
    }
};
const $59e9b7f5a8955db9$export$9a6dc2d0fce7da79 = {
    extend: [
        $59e9b7f5a8955db9$export$a6c7ac8248d6e38a,
        $59e9b7f5a8955db9$export$fce709ebdac448ed
    ]
};


var $eb21f9c2ced2890e$exports = {};

$parcel$export($eb21f9c2ced2890e$exports, "Video", () => $eb21f9c2ced2890e$export$ae01dedf5c052bb);
"use strict";
const $eb21f9c2ced2890e$export$ae01dedf5c052bb = {
    tag: "video",
    childExtend: {
        tag: "source",
        attr: {
            src: ({ props: props })=>props.src,
            controls: ({ props: props })=>props.controls
        }
    },
    props: {
        controls: true
    },
    attr: {
        src: ({ props: props })=>props.src,
        autoplay: ({ props: props })=>props.autoplay,
        loop: ({ props: props })=>props.loop,
        poster: ({ props: props })=>props.poster,
        muted: ({ props: props })=>props.muted,
        preload: ({ props: props })=>props.preload,
        controls: ({ props: props })=>props.controls
    }
};


var $8a688fbb24f94be4$exports = {};

$parcel$export($8a688fbb24f94be4$exports, "DoubleHr", () => $8a688fbb24f94be4$export$c4a0252366c774e);

"use strict";
const $8a688fbb24f94be4$export$c4a0252366c774e = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        gap: "B",
        fontSize: "Z1",
        fontWeight: "500",
        alignItems: "center",
        ":before": {
            content: '""',
            height: "V",
            flex: "1",
            background: "gray3"
        },
        text: "Or",
        ":after": {
            content: '""',
            height: "V",
            flex: "1",
            background: "gray3"
        }
    }
};


var $7f02b9e3018c9249$exports = {};
var $d4fa7f19f335d32f$exports = {};

$parcel$export($d4fa7f19f335d32f$exports, "Input", () => $d4fa7f19f335d32f$export$f5b8910cec6cf069);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $5WrxC = parcelRequire("5WrxC");
"use strict";
const $d4fa7f19f335d32f$export$f5b8910cec6cf069 = {
    extend: [
        "Focusable"
    ],
    tag: "input",
    deps: {
        isString: $EqHTq.isString,
        replaceLiteralsWithObjectFields: $5WrxC.replaceLiteralsWithObjectFields
    },
    props: {
        border: "none",
        type: "input",
        theme: "field",
        fontSize: "A",
        round: "C",
        lineHeight: "1",
        padding: "Z2 B"
    },
    attr: {
        pattern: ({ props: props })=>props.pattern,
        minLength: ({ props: props })=>props.minlength,
        maxLength: ({ props: props })=>props.maxlength,
        name: ({ props: props })=>props.name,
        autocomplete: ({ props: props })=>props.autocomplete,
        placeholder: ({ props: props })=>props.placeholder,
        value: ({ props: props, state: state, deps: deps })=>{
            const { isString: isString, replaceLiteralsWithObjectFields: replaceLiteralsWithObjectFields } = deps;
            if (isString(props.value) && props.value.includes("{{")) return replaceLiteralsWithObjectFields(props.value, state);
            return props.value;
        },
        disabled: ({ props: props })=>props.disabled || null,
        readonly: ({ props: props })=>props.readonly,
        required: ({ props: props })=>props.required,
        type: ({ props: props })=>props.type
    }
};


var $213c0d90580abffb$exports = {};

$parcel$export($213c0d90580abffb$exports, "NumberInput", () => $213c0d90580abffb$export$6bf0cd3a219bbade);

"use strict";
const $213c0d90580abffb$export$6bf0cd3a219bbade = {
    extend: [
        "Flex",
        (0, $d4fa7f19f335d32f$export$f5b8910cec6cf069)
    ],
    props: {
        type: "number",
        boxSize: "C+X",
        align: "center center",
        textAlign: "center",
        round: "Y1",
        theme: "transparent",
        border: "solid, gray3",
        borderWidth: "1px",
        placeholder: "0",
        fontWeight: "400",
        "::-webkit-inner-spin-button": {
            appearance: "none"
        }
    },
    attr: {
        step: ({ props: props })=>props.step,
        min: ({ props: props })=>props.min,
        max: ({ props: props })=>props.max
    }
};


var $59b438ee4e9b846d$exports = {};

$parcel$export($59b438ee4e9b846d$exports, "Checkbox", () => $59b438ee4e9b846d$export$48513f6b9f8ce62d);
$parcel$export($59b438ee4e9b846d$exports, "CheckboxHgroup", () => $59b438ee4e9b846d$export$8d7a3c6c6de62e1f);
"use strict";
const $59b438ee4e9b846d$export$48513f6b9f8ce62d = {
    extend: "Focusable",
    tag: "label",
    props: {
        boxSize: "fit-content fit-content",
        cursor: "pointer",
        round: "Y"
    },
    Input: {
        props: {
            type: "checkbox",
            display: "none",
            ":checked + div": {
                theme: "primary"
            },
            ":checked + div > svg": {
                transform: "none",
                opacity: "1"
            }
        },
        attr: {
            checked: ({ parent: parent })=>parent.props.checked
        }
    },
    Flex: {
        props: {
            align: "center center",
            fontSize: "B1",
            padding: "V",
            theme: "field",
            round: "X2",
            transition: "background A defaultBezier"
        },
        Icon: {
            props: {
                icon: "check",
                opacity: "0",
                transform: "scale(0.9) rotate(-15deg)",
                transition: "opacity B defaultBezier"
            }
        }
    }
};
const $59b438ee4e9b846d$export$8d7a3c6c6de62e1f = {
    extend: "Flex",
    tag: "label",
    props: {
        boxSize: "fit-content",
        align: "flex-start flex-start",
        gap: "A"
    },
    Checkbox: {
        tag: "div"
    },
    HgroupRows: {
        gap: "Z1",
        margin: "Y - - -"
    }
};


var $36ec4dd7c97e9ba6$exports = {};

$parcel$export($36ec4dd7c97e9ba6$exports, "Radio", () => $36ec4dd7c97e9ba6$export$d7b12c4107be0d61);
$parcel$export($36ec4dd7c97e9ba6$exports, "RadioHgroup", () => $36ec4dd7c97e9ba6$export$4a51391209c6c8b9);

"use strict";
const $36ec4dd7c97e9ba6$export$d7b12c4107be0d61 = {
    extend: (0, $59b438ee4e9b846d$export$48513f6b9f8ce62d),
    Input: {
        type: "radio",
        ":checked + div:after": {
            opacity: "1"
        }
    },
    Flex: {
        extend: "Pseudo",
        props: {
            round: "100%",
            padding: "Y",
            ":after": {
                content: '""',
                display: "block",
                boxSize: "X+W1",
                round: "100%",
                background: "white",
                opacity: "0",
                transition: "opacity .15s ease-in-out"
            }
        },
        Icon: null
    }
};
const $36ec4dd7c97e9ba6$export$4a51391209c6c8b9 = {
    extend: (0, $59b438ee4e9b846d$export$8d7a3c6c6de62e1f),
    Checkbox: null,
    Radio: {}
};


var $d0c993a5e2b7f197$exports = {};

$parcel$export($d0c993a5e2b7f197$exports, "Toggle", () => $d0c993a5e2b7f197$export$bea8ebba691c5813);
$parcel$export($d0c993a5e2b7f197$exports, "ToggleHgroup", () => $d0c993a5e2b7f197$export$9c397544fb27ca65);

"use strict";
const $d0c993a5e2b7f197$export$bea8ebba691c5813 = {
    extend: (0, $59b438ee4e9b846d$export$48513f6b9f8ce62d),
    Input: {
        props: {
            ":checked + div": {
                background: "green2 +8",
                justifyContent: "flex-end"
            }
        }
    },
    Flex: {
        props: {
            boxSize: "A1 B1",
            padding: "- W_default",
            round: "D",
            align: "center flex-start",
            theme: "field",
            border: "none",
            transition: "opacity .15s ease",
            ":after": {
                content: '""',
                boxSize: "A A",
                round: "100%",
                background: "white",
                boxShadow: "1px, 1px, Z, gray .2"
            }
        },
        Icon: null
    }
};
const $d0c993a5e2b7f197$export$9c397544fb27ca65 = {
    extend: (0, $59b438ee4e9b846d$export$8d7a3c6c6de62e1f),
    Checkbox: null,
    Toggle: {}
};


var $20f1327918487e94$exports = {};

$parcel$export($20f1327918487e94$exports, "Textarea", () => $20f1327918487e94$export$379139ebc1c2b235);
$parcel$export($20f1327918487e94$exports, "TextareaWithButton", () => $20f1327918487e94$export$b70f05b5c6092f02);


"use strict";
const $20f1327918487e94$export$379139ebc1c2b235 = {
    tag: "textarea",
    extend: [
        (0, $d4fa7f19f335d32f$export$f5b8910cec6cf069),
        (0, $8184389c03ed1792$export$f51f4c4ede09e011)
    ],
    props: {
        variant: "outlined",
        fontfamily: "Avenir",
        round: "Z1",
        placeholder: "Leave us a message...",
        padding: "A",
        theme: "field",
        border: "none",
        maxWidth: "G1_default",
        minHeight: "E_default",
        width: "100%",
        height: "E1_default",
        fontFamily: "inherit",
        style: {
            resize: "none"
        }
    },
    ".simple": {
        props: {
            theme: "field",
            round: "Z2",
            lineHeight: 1.4
        }
    },
    ".outlined": {
        props: {
            theme: "field",
            borderWidth: "1px",
            borderStyle: "solid",
            lineHeight: 1.4,
            placeholder: "Leave us a message...",
            resize: "none"
        }
    }
};
const $20f1327918487e94$export$b70f05b5c6092f02 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        gap: "Y2"
    },
    Textarea: {
        height: "C2+W",
        minWidth: "H",
        padding: "A",
        fontSize: "Z1",
        round: "Z2",
        minHeight: "fit-content"
    },
    SquareButton: {
        props: {
            background: "blue",
            Icon: {
                name: "send"
            }
        }
    }
};


"use strict";
$parcel$exportWildcard($7f02b9e3018c9249$exports, $d4fa7f19f335d32f$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $213c0d90580abffb$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $59b438ee4e9b846d$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $36ec4dd7c97e9ba6$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $d0c993a5e2b7f197$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $20f1327918487e94$exports);


var $c038997f2687863c$exports = {};

$parcel$export($c038997f2687863c$exports, "Select", () => $c038997f2687863c$export$ef9b1a59e592288f);

"use strict";
const $c038997f2687863c$export$ef9b1a59e592288f = {
    extend: (0, $c3656ade3a6fd1e0$export$35a3bebf7ef2d934),
    tag: "select",
    props: {
        fontSize: "A",
        border: "none",
        boxSizing: "border-box",
        theme: "field",
        cursor: "pointer"
    },
    childExtend: {
        tag: "option",
        props: {
            value: "",
            selected: "",
            disabled: ""
        },
        attr: {
            value: ({ props: props })=>props.value,
            selected: ({ props: props })=>props.selected,
            disabled: ({ props: props })=>props.disabled
        }
    },
    attr: {
        name: ({ props: props })=>props.name,
        disabled: ({ props: props })=>props.disabled
    }
};



var $ca26469f43255c37$exports = {};

$parcel$export($ca26469f43255c37$exports, "Button", () => $ca26469f43255c37$export$353f5b6fc5456de1);
$parcel$export($ca26469f43255c37$exports, "SquareButton", () => $ca26469f43255c37$export$51cd5c72b5e560c6);
$parcel$export($ca26469f43255c37$exports, "CircleButton", () => $ca26469f43255c37$export$235c11ae4b685dbd);
$parcel$export($ca26469f43255c37$exports, "KangorooButton", () => $ca26469f43255c37$export$6fbe98cd572b6a70);
$parcel$export($ca26469f43255c37$exports, "FlexButton", () => $ca26469f43255c37$export$c48f2f65343acffb);
$parcel$export($ca26469f43255c37$exports, "ButtonSet", () => $ca26469f43255c37$export$87e672a75327e04b);
$parcel$export($ca26469f43255c37$exports, "CancelConfirmButtons", () => $ca26469f43255c37$export$68fd62726e540676);
$parcel$export($ca26469f43255c37$exports, "IcontextButton", () => $ca26469f43255c37$export$61af5426caa380d5);
$parcel$export($ca26469f43255c37$exports, "DropDownButton", () => $ca26469f43255c37$export$e200d4ca2624495d);
$parcel$export($ca26469f43255c37$exports, "DropDownButtonWithAvatar", () => $ca26469f43255c37$export$4ded3f507897701b);
$parcel$export($ca26469f43255c37$exports, "PlusMinusButtons", () => $ca26469f43255c37$export$f3d9ff5714153fda);


"use strict";
const $ca26469f43255c37$export$353f5b6fc5456de1 = {
    extend: [
        (0, $f8a17223267b0208$export$fe7c634bfc18e397),
        (0, $c3656ade3a6fd1e0$export$b177f82f5511f000)
    ],
    tag: "button",
    props: {
        fontSize: "A",
        type: "button",
        border: "none",
        display: "inline-flex",
        align: "center center",
        textDecoration: "none",
        lineHeight: "1",
        whiteSpace: "nowrap",
        padding: "Z B2",
        fontWeight: "500",
        fontFamily: "inherit",
        round: "C2"
    },
    attr: {
        type: ({ props: props })=>props.type
    }
};
const $ca26469f43255c37$export$51cd5c72b5e560c6 = {
    extend: $ca26469f43255c37$export$353f5b6fc5456de1,
    props: {
        fontSize: "A",
        width: "A",
        padding: "Z",
        aspectRatio: "1 / 1",
        icon: "smile",
        boxSize: "fit-content fit-content",
        justifyContent: "center",
        round: "Z",
        boxSizing: "content-box"
    }
};
const $ca26469f43255c37$export$235c11ae4b685dbd = {
    extend: $ca26469f43255c37$export$51cd5c72b5e560c6,
    props: {
        round: "C"
    }
};
const $ca26469f43255c37$export$6fbe98cd572b6a70 = {
    extend: $ca26469f43255c37$export$353f5b6fc5456de1,
    childExtend: (0, $f8a17223267b0208$export$fe7c634bfc18e397)
};
const $ca26469f43255c37$export$c48f2f65343acffb = {
    extend: $ca26469f43255c37$export$353f5b6fc5456de1,
    props: {
        boxSize: "fit-content",
        padding: "Z2 A2",
        round: "Z1",
        gap: "Z",
        position: "relative",
        Icon: {
            fontSize: "B1"
        }
    },
    Icon: {},
    Text: {
        text: "Button"
    }
};
const $ca26469f43255c37$export$87e672a75327e04b = {
    tag: "nav",
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    childExtend: $ca26469f43255c37$export$51cd5c72b5e560c6
};
const $ca26469f43255c37$export$68fd62726e540676 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        gap: "Z2",
        maxWidth: "fit-content"
    },
    childExtend: {
        extend: $ca26469f43255c37$export$c48f2f65343acffb,
        props: {
            ":first-child": {
                theme: "transparent",
                padding: "- Y1"
            }
        }
    },
    ...[
        {
            Text: "No"
        },
        {
            Text: "Yes"
        }
    ]
};
const $ca26469f43255c37$export$61af5426caa380d5 = {
    extend: $ca26469f43255c37$export$c48f2f65343acffb,
    props: {
        position: "relative",
        theme: "tertiary",
        padding: "Z2 A",
        icon: "smile"
    }
};
const $ca26469f43255c37$export$e200d4ca2624495d = {
    extend: $ca26469f43255c37$export$c48f2f65343acffb,
    props: {
        gap: "X2",
        boxSize: "fit-content fit-content",
        padding: "Z1 A1 Z Z1",
        theme: "dialog",
        icon: "chevronDown",
        Icon: {
            fontSize: "D"
        },
        Text: {
            text: "All"
        }
    }
};
const $ca26469f43255c37$export$4ded3f507897701b = {
    extend: $ca26469f43255c37$export$e200d4ca2624495d,
    props: {
        gap: "Y",
        padding: "Y",
        round: "Z1",
        theme: "dialog",
        Icon: {
            fontSize: "B1"
        }
    },
    Avatar: {
        boxSize: "A2+V1"
    },
    caption: {
        text: "ETH",
        props: {
            fontSize: "Y1",
            fontWeight: "400"
        }
    }
};
const $ca26469f43255c37$export$f3d9ff5714153fda = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        alignItems: "center",
        gap: "A"
    },
    Minus: {
        extend: $ca26469f43255c37$export$51cd5c72b5e560c6,
        props: {
            icon: "minus"
        }
    },
    Value: {
        props: {
            text: "1"
        }
    },
    Plus: {
        extend: $ca26469f43255c37$export$51cd5c72b5e560c6,
        props: {
            icon: "plus"
        }
    }
};


var $aad64e0c8b152d2b$exports = {};
var $dffb8c7028cd6201$exports = {};

$parcel$export($dffb8c7028cd6201$exports, "ProgressLine", () => $dffb8c7028cd6201$export$e5c0f55a2ee94410);
$parcel$export($dffb8c7028cd6201$exports, "ProgressLineWithUnitValue", () => $dffb8c7028cd6201$export$4ae3d31aafc39023);

"use strict";
const $dffb8c7028cd6201$export$e5c0f55a2ee94410 = {
    tag: "progress",
    props: {
        value: 0.7,
        height: "X1",
        minWidth: "F2+B1",
        round: "2px",
        overflow: "hidden",
        theme: "primary @dark .inactive",
        "::-webkit-progress-bar": {
            theme: "primary @dark .inactive"
        },
        "::-webkit-progress-value": {
            theme: "primary",
            borderRadius: "2px"
        }
    },
    attr: {
        max: ({ props: props })=>props.max,
        progress: ({ props: props })=>props.progress,
        value: ({ props: props })=>props.value
    }
};
const $dffb8c7028cd6201$export$4ae3d31aafc39023 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        align: "center flex-start",
        gap: "Z1"
    },
    ProgressLine: {
        minWidth: "F2+B1"
    },
    UnitValue: {}
};


var $48668b60617de765$exports = {};

$parcel$export($48668b60617de765$exports, "ProgressCircle", () => $48668b60617de765$export$c79b9d6b4cc92af7);
$parcel$export($48668b60617de765$exports, "ProgressCircleWithIcon", () => $48668b60617de765$export$f3fa27e27f68075d);
$parcel$export($48668b60617de765$exports, "ProgressCircleWithUnitValue", () => $48668b60617de765$export$cf4b72ceff71fe7f);
$parcel$export($48668b60617de765$exports, "ProgressCircleWithSideUnitValue", () => $48668b60617de765$export$ee33a859843d9344);

"use strict";
const $48668b60617de765$export$c79b9d6b4cc92af7 = {
    props: {
        widthRange: "D",
        aspectRatio: "1 / 1",
        position: "relative",
        ":after": {
            content: '""',
            position: "absolute",
            width: "calc(100% - 5px)",
            height: "calc(100% - 5px)",
            background: "black",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            round: "100%"
        }
    },
    Progress: {
        tag: "progress",
        props: {
            boxSize: "100% 100%",
            value: 0.7,
            round: "100%",
            overflow: "hidden",
            style: {
                "&::-webkit-progress-bar": {
                    background: "#0474F2"
                },
                "&::-webkit-progress-value": {
                    background: "#252527"
                }
            }
        },
        attr: {
            max: ({ props: props })=>props.max,
            progress: ({ props: props })=>props.progress,
            value: ({ props: props })=>props.value
        }
    }
};
const $48668b60617de765$export$f3fa27e27f68075d = {
    extend: $48668b60617de765$export$c79b9d6b4cc92af7,
    Icon: {
        name: "arrowUp",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: "3",
        fontSize: "E"
    }
};
const $48668b60617de765$export$cf4b72ceff71fe7f = {
    extend: $48668b60617de765$export$c79b9d6b4cc92af7,
    Progress: {},
    UnitValue: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: "3",
        fontSize: "Z"
    }
};
const $48668b60617de765$export$ee33a859843d9344 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        align: "center flex-start",
        boxSize: "fit-content",
        gap: "Y"
    },
    ProgressCircle: {
        boxSize: "A",
        ":after": {
            width: "calc(100% - 5px)",
            height: "calc(100% - 5px)"
        }
    },
    UnitValue: {}
};


"use strict";
$parcel$exportWildcard($aad64e0c8b152d2b$exports, $dffb8c7028cd6201$exports);
$parcel$exportWildcard($aad64e0c8b152d2b$exports, $48668b60617de765$exports);


var $781e0e9576e3e707$exports = {};

$parcel$export($781e0e9576e3e707$exports, "Range", () => $781e0e9576e3e707$export$9a58ef0d7ad3278c);
$parcel$export($781e0e9576e3e707$exports, "RangeWithButtons", () => $781e0e9576e3e707$export$94c40b3709c521a9);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");


"use strict";
const $781e0e9576e3e707$var$props = {
    appearance: "none",
    width: "100%",
    height: "2px",
    outline: "none",
    flex: 1,
    onInput: (ev, el, s)=>s.update({
            value: el.node.value
        }),
    onChange: (ev, el, s)=>s.update({
            value: el.node.value
        }),
    style: {
        appearance: "none"
    },
    "::-webkit-slider-thumb": {
        boxSizing: "content-box",
        width: "8px",
        height: "8px",
        borderWidth: "2px",
        borderStyle: "solid",
        borderRadius: "100%",
        opacity: ".8",
        style: {
            appearance: "none"
        }
    },
    "::-webkit-slider-runnable-track": {},
    "@dark": {
        background: "white 0.2",
        "::-webkit-slider-thumb": {
            background: "#232526",
            borderColor: (0, $1ef99b0b26632769$export$f4f50e3877dd0530)("#454646", 0.75)
        },
        ":hover": {
            "::-webkit-slider-thumb": {
                borderColor: (0, $1ef99b0b26632769$export$f4f50e3877dd0530)("#fff", 0.35)
            }
        },
        ":focus": {
            "::-webkit-slider-thumb": {
                borderColor: "#3C6AC0"
            }
        }
    },
    "@light": {
        background: "gray9",
        "::-webkit-slider-thumb": {
            background: "white",
            borderColor: "gray9"
        },
        ":hover": {
            "::-webkit-slider-thumb": {
                borderColor: "gray7"
            }
        },
        ":focus": {
            "::-webkit-slider-thumb": {
                borderColor: "blue"
            }
        }
    }
};
const $781e0e9576e3e707$var$returnPropertyValue = (el, property, def)=>{
    const val = el.props && el.props[property];
    const r = (0, $EqHTq.isFunction)(val) ? val(el, el.state) : val !== undefined ? val : def !== undefined ? def : 0;
    return r + "";
};
const $781e0e9576e3e707$export$9a58ef0d7ad3278c = {
    props: $781e0e9576e3e707$var$props,
    tag: "input",
    attr: {
        type: "range",
        value: (el, s)=>parseFloat(el.state.value || el.props.value || el.props.defaultValue),
        min: (el, s)=>$781e0e9576e3e707$var$returnPropertyValue(el, "min", 0),
        max: (el, s)=>$781e0e9576e3e707$var$returnPropertyValue(el, "max", 100),
        step: (el, s)=>$781e0e9576e3e707$var$returnPropertyValue(el, "step", 1)
    },
    on: {
        input: (ev, el, s)=>{
            const props = el.props;
            if ((0, $EqHTq.isFunction)(props.onInput)) props.onInput(ev, el, s);
            else s.update({
                value: parseFloat(el.node.value)
            });
        },
        change: (ev, el, s)=>{
            const props = el.props;
            if ((0, $EqHTq.isFunction)(props.onChange)) props.onChange(ev, el, s);
            else s.update({
                value: parseFloat(el.node.value)
            });
        }
    }
};
const $781e0e9576e3e707$export$94c40b3709c521a9 = {
    minus: {
        extend: (0, $ca26469f43255c37$export$51cd5c72b5e560c6),
        props: {
            theme: "field",
            icon: "minus"
        },
        on: {
            click: (ev, el, s)=>{
                const parentProps = el.parent.props;
                if ((0, $EqHTq.isFunction)(parentProps.onDecrease)) parentProps.onDecrease(ev, el.parent, s);
                else {
                    const value = parseFloat(s.value);
                    const min = $781e0e9576e3e707$var$returnPropertyValue(el.parent, "min", 1);
                    const step = $781e0e9576e3e707$var$returnPropertyValue(el.parent, "step", 1);
                    if (value > min) s.update({
                        value: value - step
                    });
                }
            }
        }
    },
    value: {
        props: {
            width: "4ch"
        },
        tag: "span",
        text: ({ state: state, parent: parent })=>{
            const unit = $781e0e9576e3e707$var$returnPropertyValue(parent, "unit", "");
            return "" + (state.value || state.defaultValue || 0) + unit;
        }
    },
    input: {
        extend: $781e0e9576e3e707$export$9a58ef0d7ad3278c,
        attr: {
            value: (el, s)=>parseFloat(s.value || s.defaultValue),
            min: (el, s)=>$781e0e9576e3e707$var$returnPropertyValue(el.parent, "min", 0),
            max: (el, s)=>$781e0e9576e3e707$var$returnPropertyValue(el.parent, "max", 100),
            step: (el, s)=>$781e0e9576e3e707$var$returnPropertyValue(el.parent, "step", 1)
        },
        on: {
            input: (ev, el, s)=>{
                const parentProps = el.parent.props;
                if ((0, $EqHTq.isFunction)(parentProps.onInput)) parentProps.onInput(ev, el, s);
                else s.update({
                    value: parseFloat(el.node.value)
                });
            },
            change: (ev, el, s)=>{
                const parentProps = el.parent.props;
                if ((0, $EqHTq.isFunction)(parentProps.onChange)) parentProps.onChange(ev, el, s);
                else s.update({
                    value: parseFloat(el.node.value)
                });
            }
        }
    },
    plus: {
        extend: (0, $ca26469f43255c37$export$51cd5c72b5e560c6),
        props: {
            theme: "field",
            icon: "plus"
        },
        on: {
            click: (ev, el, s)=>{
                const parentProps = el.parent.props;
                if ((0, $EqHTq.isFunction)(parentProps.onIncrease)) parentProps.onIncrease(ev, el.parent, s);
                else {
                    const value = parseFloat(s.value);
                    const max = $781e0e9576e3e707$var$returnPropertyValue(el.parent, "max", 1);
                    const step = $781e0e9576e3e707$var$returnPropertyValue(el.parent, "step", 1);
                    if (value < max) s.update({
                        value: value + step
                    });
                }
            }
        }
    }
};


var $c658bc99cb4f11e8$exports = {};

$parcel$export($c658bc99cb4f11e8$exports, "RangeSlider", () => $c658bc99cb4f11e8$export$826424dabc3dd705);
$parcel$export($c658bc99cb4f11e8$exports, "Slider", () => $c658bc99cb4f11e8$export$472062a354075cee);
"use strict";
var $a2410c4a861c3532$export$2e2bcd8739ae039 = {
    appearance: "none",
    width: "100%",
    height: "2px",
    outline: "none",
    flex: 1,
    "&::-webkit-slider-thumb": {
        boxSizing: "content-box",
        appearance: "none",
        width: "8px",
        height: "8px",
        borderWidth: "2px",
        borderStyle: "solid",
        borderRadius: "100%",
        opacity: ".8"
    }
};



parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $c658bc99cb4f11e8$export$826424dabc3dd705 = {
    style: $a2410c4a861c3532$export$2e2bcd8739ae039,
    props: {
        theme: "sliderThumb"
    },
    tag: "input",
    attr: {
        type: "range"
    }
};
const $c658bc99cb4f11e8$var$listenProp = (el, prop, def)=>{
    const val = el && el.props && el.props[prop];
    const r = ((0, $EqHTq.isFunction)(val) ? val() : val) || (def !== undefined ? def : 50);
    return r;
};
const $c658bc99cb4f11e8$export$472062a354075cee = {
    button0: {
        extend: [
            (0, $ca26469f43255c37$export$51cd5c72b5e560c6)
        ],
        props: {
            icon: "minus"
        },
        on: {
            click: (ev, el, s)=>{
                el.props && (0, $EqHTq.isFunction)(el.props.click) && el.props.click(ev, el, s);
                const input = el.parent.input;
                const props = input.props;
                const value = (0, $EqHTq.isFunction)(props.value) ? props.value() : props.value;
                input.node.value = value;
            }
        }
    },
    value: {
        style: {
            width: "4ch"
        },
        tag: "span",
        text: (el, s)=>{
            const value = $c658bc99cb4f11e8$var$listenProp(el.parent.input, "value");
            const unit = $c658bc99cb4f11e8$var$listenProp(el.parent.input, "unit", "");
            return "" + value + unit;
        }
    },
    range: {
        extend: $c658bc99cb4f11e8$export$826424dabc3dd705,
        attr: {
            value: (el, s)=>$c658bc99cb4f11e8$var$listenProp(el, "value", 50),
            min: (el, s)=>$c658bc99cb4f11e8$var$listenProp(el, "min", 0),
            max: (el, s)=>$c658bc99cb4f11e8$var$listenProp(el, "max", 100),
            step: (el, s)=>$c658bc99cb4f11e8$var$listenProp(el, "step", 1)
        },
        on: {
            input: (ev, el, s)=>el.props && (0, $EqHTq.isFunction)(el.props.input) && el.props.input(ev, el, s),
            change: (ev, el, s)=>el.props && (0, $EqHTq.isFunction)(el.props.change) && el.props.change(ev, el, s)
        }
    },
    button1: {
        extend: [
            (0, $ca26469f43255c37$export$51cd5c72b5e560c6)
        ],
        props: {
            icon: "plus"
        },
        on: {
            click: (ev, el, s)=>{
                el.props && (0, $EqHTq.isFunction)(el.props.click) && el.props.click(ev, el, s);
                const input = el.parent.input;
                const props = input.props;
                const value = (0, $EqHTq.isFunction)(props.value) ? props.value() : props.value;
                input.node.value = value;
            }
        }
    }
};


var $7bd759d9ddd96987$exports = {};

$parcel$export($7bd759d9ddd96987$exports, "Label", () => $7bd759d9ddd96987$export$b04be29aa201d4f5);
$parcel$export($7bd759d9ddd96987$exports, "LabelButton", () => $7bd759d9ddd96987$export$239fbcd864262455);
$parcel$export($7bd759d9ddd96987$exports, "CardLabel", () => $7bd759d9ddd96987$export$e13aaac4037b0914);


"use strict";
const $7bd759d9ddd96987$export$b04be29aa201d4f5 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        text: "-2.902x",
        fontSize: "Z",
        theme: "tertiary",
        boxSize: "fit-content fit-content",
        padding: "W2 Y2",
        round: "Y1",
        fontWeight: "400"
    }
};
const $7bd759d9ddd96987$export$239fbcd864262455 = {
    extend: (0, $ca26469f43255c37$export$353f5b6fc5456de1),
    props: {
        theme: "tertiary",
        fontSize: "Z2",
        emoji: "\uD83D\uDC4D",
        text: "3",
        padding: "X2 Z",
        round: "C",
        lineHeight: 1,
        gap: "X2",
        fontWeight: "500"
    },
    emoji: {
        props: ({ parent: parent })=>({
                text: parent.props.emoji
            })
    }
};
const $7bd759d9ddd96987$export$e13aaac4037b0914 = {
    props: {
        text: "-2.902x",
        fontSize: "Z",
        background: "#F4454E",
        boxSize: "fit-content fit-content",
        padding: "W Y",
        round: "Y"
    }
};


var $d0fd1386e51a3c49$exports = {};
var $de415e64d965a551$exports = {};

$parcel$export($de415e64d965a551$exports, "Avatar", () => $de415e64d965a551$export$e2255cf6045e8d47);

"use strict";
const $de415e64d965a551$export$e2255cf6045e8d47 = {
    extend: (0, $c95002999fe11fd8$export$cc7b5f925acc71d3),
    props: ({ key: key, props: props })=>({
            display: "block",
            avatarType: "adventurer-neutral",
            borderRadius: "100%",
            boxSize: "C+X C+X",
            src: `https://api.dicebear.com/7.x/${props.avatarType || "initials"}/svg?seed=${props.key || key || "no-avatar"}`
        })
};


var $6ee5e234b1e3ae1a$exports = {};

$parcel$export($6ee5e234b1e3ae1a$exports, "AvatarIndicator", () => $6ee5e234b1e3ae1a$export$2fb355f3907c18fc);
"use strict";
const $6ee5e234b1e3ae1a$export$2fb355f3907c18fc = {
    props: {
        boxSize: "fit-content",
        position: "relative",
        round: "100%"
    },
    Avatar: {},
    StatusIndicator: {
        theme: "success",
        position: "absolute",
        bottom: "0",
        right: "0"
    }
};


var $8f77a64ae10a2cb0$exports = {};

$parcel$export($8f77a64ae10a2cb0$exports, "AvatarBundle", () => $8f77a64ae10a2cb0$export$5822eaed382932db);


"use strict";
const $8f77a64ae10a2cb0$export$5822eaed382932db = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        childProps: {
            "@light": {
                border: "2px, var(--theme-document-light-background), solid"
            },
            "@dark": {
                border: "2px, var(--theme-document-dark-background), solid"
            },
            ":not(:last-child)": {
                margin: "0 -Y2 0 0"
            }
        }
    },
    childExtend: (0, $de415e64d965a551$export$e2255cf6045e8d47),
    $propsCollection: ({ props: props })=>props.options
};


var $715033dbecabb105$exports = {};

$parcel$export($715033dbecabb105$exports, "AvatarChooser", () => $715033dbecabb105$export$666bea062326062a);

"use strict";
const $715033dbecabb105$export$666bea062326062a = {
    extend: (0, $ca26469f43255c37$export$353f5b6fc5456de1),
    tag: "label",
    state: {
        key: "am"
    },
    props: {
        round: "A2",
        width: "fit-content",
        padding: "X2 Y2+V X2 X2",
        theme: "tertiary",
        position: "relative",
        cursor: "pointer"
    },
    Avatar: {
        props: ({ state: state })=>({
                key: state.key,
                boxSize: "B1",
                pointerEvents: "none"
            })
    },
    Select: {
        props: {
            outline: "none",
            pointerEvents: "All",
            appearance: "none",
            height: "100%",
            background: "none",
            color: "currentColor",
            lineHeight: 1,
            padding: "- B - Y1",
            zIndex: "2",
            flex: "1",
            fontWeight: "500",
            ":focus-visible": {
                outline: "none"
            }
        },
        childExtend: {
            tag: "option"
        },
        $propsCollection: ({ parent: parent, state: state })=>{
            if (!parent.props.options) return [];
            return parent.props.options.map((v)=>{
                if (v.text === state.key) return {
                    ...v,
                    selected: true
                };
                return v;
            });
        },
        on: {
            change: (ev, { state: state })=>{
                console.log(state.key);
                state.update({
                    key: ev.target.value
                });
            }
        }
    },
    Icon: {
        props: {
            icon: "chevronDown",
            fontSize: "C",
            margin: "V - - -",
            position: "absolute",
            right: "Y1",
            pointerEvents: "none"
        }
    }
};


"use strict";
$parcel$exportWildcard($d0fd1386e51a3c49$exports, $de415e64d965a551$exports);
$parcel$exportWildcard($d0fd1386e51a3c49$exports, $6ee5e234b1e3ae1a$exports);
$parcel$exportWildcard($d0fd1386e51a3c49$exports, $8f77a64ae10a2cb0$exports);
$parcel$exportWildcard($d0fd1386e51a3c49$exports, $715033dbecabb105$exports);


var $e39e4f558cd2a095$exports = {};

$parcel$export($e39e4f558cd2a095$exports, "Notification", () => $e39e4f558cd2a095$export$14834abbfce3b8cd);
$parcel$export($e39e4f558cd2a095$exports, "NotificationIndicator", () => $e39e4f558cd2a095$export$208fd20af21dc523);

"use strict";
const $e39e4f558cd2a095$export$14834abbfce3b8cd = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        theme: "alert",
        padding: "Z1 B Z A",
        round: "A A A Y2",
        gap: "X2",
        cursor: "pointer",
        align: "flex-start center"
    },
    IconText: {
        props: {
            icon: "info outline"
        }
    },
    Flex: {
        props: {
            flow: "column",
            align: "flex-start",
            gap: "X2"
        },
        Title: {
            tag: "h6",
            props: {
                margin: "0",
                fontWeight: "600",
                lineHeight: "1em",
                text: "Notification"
            }
        },
        P: {
            props: {
                fontSize: "Z",
                margin: "0",
                text: "is not always a distraction"
            }
        }
    }
};
const $e39e4f558cd2a095$export$208fd20af21dc523 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        text: "2",
        fontSize: "Z",
        lineHeight: "1em",
        background: "#0474F2",
        boxSize: "fit-content fit-content",
        padding: "X+W",
        round: "Y+X"
    }
};


var $5789735af6bd85de$exports = {};

$parcel$export($5789735af6bd85de$exports, "Tooltip", () => $5789735af6bd85de$export$28c660c63b792dea);
$parcel$export($5789735af6bd85de$exports, "TooltipHidden", () => $5789735af6bd85de$export$92ba62bde414cbb2);
$parcel$export($5789735af6bd85de$exports, "TooltipParent", () => $5789735af6bd85de$export$1d54d90a050b9c15);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $5789735af6bd85de$export$28c660c63b792dea = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        theme: "dialog",
        background: "black",
        flow: "column",
        shape: "tooltip",
        shapeDirection: "left",
        padding: "Z1 A",
        round: "Y2",
        width: "fit-content",
        minWidth: "D2",
        maxWidth: "F2",
        gap: "X",
        textAlign: "center"
    },
    attr: {
        tooltip: true
    },
    Title: {
        if: ({ parent: parent, props: props })=>(0, $EqHTq.isDefined)(parent.props.title) || props.text,
        props: ({ parent: parent })=>({
                width: "fit-content",
                fontWeight: 500,
                color: "gray12",
                text: parent.props.title
            })
    },
    P: {
        if: ({ parent: parent, props: props })=>(0, $EqHTq.isDefined)(parent.props.description) || props.text,
        props: ({ parent: parent })=>({
                width: "fit-content",
                fontSize: "Z2",
                margin: "0",
                color: "gray6",
                fontWeight: "400",
                text: parent.props.description
            })
    }
};
const $5789735af6bd85de$export$92ba62bde414cbb2 = {
    extend: $5789735af6bd85de$export$28c660c63b792dea,
    props: ({ props: props })=>({
            position: "absolute",
            pointerEvents: "none",
            opacity: "0",
            visibility: "hidden",
            transition: "C defaultBezier opacity, C defaultBezier visibility, B defaultBezier transform",
            ...props.shapeDirection === "top" ? {
                top: "112%",
                left: "50%",
                transform: "translate3d(-50%,10%,0)",
                ".active": {
                    transform: "translate3d(-50%,0,0)",
                    opacity: 1,
                    visibility: "visible"
                }
            } : props.shapeDirection === "right" ? {
                transform: "translate3d(10%,-50%,0)",
                right: "112%",
                top: "50%",
                ".active": {
                    transform: "translate3d(0%,-50%,0)",
                    opacity: 1,
                    visibility: "visible"
                }
            } : props.shapeDirection === "bottom" ? {
                transform: "translate3d(-50%,-10%,0)",
                bottom: "112%",
                left: "50%",
                ".active": {
                    transform: "translate3d(-50%,0,0)",
                    opacity: 1,
                    visibility: "visible"
                }
            } : {
                transform: "translate3d(10%,-50%,0)",
                left: "112%",
                top: "50%",
                ".active": {
                    transform: "translate3d(0%,-50%,0)",
                    opacity: 1,
                    visibility: "visible"
                }
            }
        })
};
const $5789735af6bd85de$export$1d54d90a050b9c15 = {
    props: ({ Tooltip: Tooltip, TooltipHidden: TooltipHidden })=>{
        const TooltipElem = Tooltip || TooltipHidden;
        const TooltipActive = TooltipElem && TooltipElem.props[".active"];
        return {
            position: "relative",
            zIndex: 999,
            style: {
                "&:hover, &:focus-visible": {
                    zIndex: 1000,
                    "& [tooltip]": TooltipActive || {
                        transform: "translate3d(-50%,0,0)",
                        opacity: 1,
                        visibility: "visible"
                    }
                }
            }
        };
    }
};


var $f935884925ad4fcf$exports = {};

$parcel$export($f935884925ad4fcf$exports, "Pills", () => $f935884925ad4fcf$export$93f0733b9cd7cb26);

"use strict";
const $f935884925ad4fcf$export$93f0733b9cd7cb26 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        gap: "Y2"
    },
    childExtend: {
        extend: {
            props: ({ key: key, state: state, parent: parent })=>({
                    boxSize: "Y2",
                    round: "A",
                    background: "currentColor",
                    active: parseInt(key) === parseInt(state.active || parent.props.active),
                    "!active": {
                        opacity: 0.35
                    }
                })
        },
        on: {
            click: (e, el)=>{
                el.state.update({
                    active: parseInt(el.key)
                });
            }
        }
    },
    $propsCollection: ({ props: props, state: state })=>new Array(props.qty).fill({})
};


var $d6afc2003bbecb7e$exports = {};

$parcel$export($d6afc2003bbecb7e$exports, "Tab", () => $d6afc2003bbecb7e$export$3e41faf802a29e71);
$parcel$export($d6afc2003bbecb7e$exports, "IconTab", () => $d6afc2003bbecb7e$export$5fd6e91639893354);

"use strict";
const $d6afc2003bbecb7e$export$3e41faf802a29e71 = {
    extend: (0, $ca26469f43255c37$export$c48f2f65343acffb),
    props: {
        boxSize: "fit-content fit-content",
        align: "center flex-start",
        position: "relative",
        padding: "Z Z1",
        theme: "field",
        borderRadius: "A A X2 X2",
        icon: "smile"
    },
    Icon: {},
    Text: {
        text: "Caption"
    },
    CountIndicator: {
        fontSize: "Z1",
        text: "19",
        margin: "- - - X1"
    }
};
const $d6afc2003bbecb7e$export$5fd6e91639893354 = {
    extend: (0, $ca26469f43255c37$export$51cd5c72b5e560c6),
    Span: null,
    CountIndicator: {
        fontSize: "Z",
        position: "absolute",
        top: "-Y2",
        right: "-Y2",
        text: "19"
    }
};


var $0845c3d41e8b035e$exports = {};
var $e82f0792b13ea87f$exports = {};

$parcel$export($e82f0792b13ea87f$exports, "CheckStep", () => $e82f0792b13ea87f$export$63e9616f085c25f5);
$parcel$export($e82f0792b13ea87f$exports, "CheckSteps", () => $e82f0792b13ea87f$export$f6472a2e5cf4be95);

"use strict";
const $e82f0792b13ea87f$export$63e9616f085c25f5 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        boxSize: "fit-content",
        align: "center flex-start",
        gap: "Z1"
    },
    CheckIndicatorWithLabel: {
        CheckIndicator: {
            theme: "transparent",
            border: "1.5px solid #1C1C1F",
            ".isActive": {
                theme: "primary",
                border: "none"
            }
        }
    },
    ProgressLine: {
        value: 0,
        height: "V2",
        minWidth: "E",
        maxWidth: "E",
        round: "D",
        ".isActive": {
            value: 1
        }
    }
};
const $e82f0792b13ea87f$export$f6472a2e5cf4be95 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        boxSize: "fit-content fit-content",
        align: "center flex-start",
        gap: "Z1",
        childProps: {
            ":last-child > progress": {
                display: "none"
            }
        }
    },
    childExtend: $e82f0792b13ea87f$export$63e9616f085c25f5,
    ...[
        {
            CheckIndicatorWithLabel: {
                CheckIndicator: {
                    isActive: true
                }
            },
            ProgressLine: {
                value: 1
            }
        },
        {
            CheckIndicatorWithLabel: {
                CheckIndicator: {
                    isActive: true
                }
            },
            ProgressLine: {
                value: 1
            }
        },
        {
            CheckIndicatorWithLabel: {
                CheckIndicator: {
                    isActive: true
                }
            },
            ProgressLine: {
                value: 1
            }
        },
        {},
        {}
    ]
};


var $35d1430a0e07c2dc$exports = {};

$parcel$export($35d1430a0e07c2dc$exports, "RadioStep", () => $35d1430a0e07c2dc$export$ed72fcde61061f29);
$parcel$export($35d1430a0e07c2dc$exports, "RadioSteps", () => $35d1430a0e07c2dc$export$c1b1d6357b678bd5);


"use strict";
const $35d1430a0e07c2dc$export$ed72fcde61061f29 = {
    extend: (0, $e82f0792b13ea87f$export$63e9616f085c25f5),
    CheckIndicatorWithLabel: null,
    RadioIndicatorWithLabel: {
        RadioIndicator: {
            theme: "dialog",
            ":after": {},
            ".isActive": {
                theme: "dialog",
                border: "none",
                ":after": {
                    theme: "primary"
                }
            }
        }
    },
    ProgressLine: {}
};
const $35d1430a0e07c2dc$export$c1b1d6357b678bd5 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        boxSize: "fit-content fit-content",
        align: "center flex-start",
        gap: "Z",
        childProps: {
            ":last-child > progress": {
                display: "none"
            }
        }
    },
    childExtend: $35d1430a0e07c2dc$export$ed72fcde61061f29,
    ...[
        {
            RadioIndicatorWithLabel: {
                RadioIndicator: {
                    isActive: true
                }
            },
            ProgressLine: {
                value: 1
            }
        },
        {
            RadioIndicatorWithLabel: {
                RadioIndicator: {
                    isActive: true
                }
            },
            ProgressLine: {
                value: 1
            }
        },
        {
            RadioIndicatorWithLabel: {
                RadioIndicator: {
                    isActive: true
                }
            },
            ProgressLine: {
                value: 1
            }
        },
        {},
        {}
    ]
};


var $55a7a8d2fb1cfa5b$exports = {};

$parcel$export($55a7a8d2fb1cfa5b$exports, "LineSteps", () => $55a7a8d2fb1cfa5b$export$ca8e53c01c00bf00);
$parcel$export($55a7a8d2fb1cfa5b$exports, "LineStepsWithHgroup", () => $55a7a8d2fb1cfa5b$export$4ae04c55091daa94);


"use strict";
const $55a7a8d2fb1cfa5b$export$ca8e53c01c00bf00 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        boxSize: "fit-content",
        gap: "Y1"
    },
    childExtend: {
        extend: (0, $dffb8c7028cd6201$export$e5c0f55a2ee94410),
        props: {
            value: 1,
            height: "X2",
            minWidth: "F",
            round: "X"
        }
    },
    ...[
        {},
        {},
        {
            props: {
                value: 0
            }
        }
    ]
};
const $55a7a8d2fb1cfa5b$export$4ae04c55091daa94 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        flow: "column",
        padding: "A A1",
        theme: "dialog",
        round: "A1",
        boxSize: "fit-content",
        gap: "A1"
    },
    Hgroup: {
        gap: "Y1",
        Title: {
            text: "Symbols",
            fontSize: "D1"
        },
        Paragraph: {
            text: "The easiest way to build your own website.",
            fontSize: "Z1",
            color: "caption"
        }
    },
    LineSteps: {
        childProps: {
            minWidth: "E+A",
            maxWidth: "E+A"
        }
    }
};


"use strict";
$parcel$exportWildcard($0845c3d41e8b035e$exports, $e82f0792b13ea87f$exports);
$parcel$exportWildcard($0845c3d41e8b035e$exports, $35d1430a0e07c2dc$exports);
$parcel$exportWildcard($0845c3d41e8b035e$exports, $55a7a8d2fb1cfa5b$exports);


var $ffecead860a69fb6$exports = {};

$parcel$export($ffecead860a69fb6$exports, "ParagraphButton", () => $ffecead860a69fb6$export$67f2745a7819a23e);
$parcel$export($ffecead860a69fb6$exports, "ParagraphButtonWithCheckbox", () => $ffecead860a69fb6$export$e49a0306ba5b7ef2);

"use strict";
const $ffecead860a69fb6$export$67f2745a7819a23e = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        alignItems: "center",
        gap: "Y2"
    },
    P: {
        props: {
            text: "Didn't get the code?",
            color: "caption",
            margin: "0"
        }
    },
    Button: {
        text: "Click to resend",
        padding: "0",
        background: "transparent",
        textDecoration: "underline",
        fontWeight: "500",
        Icon: {
            display: "none"
        }
    }
};
const $ffecead860a69fb6$export$e49a0306ba5b7ef2 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    tag: "label",
    props: {
        gap: "1ch",
        alignItems: "center"
    },
    Checkbox: {
        tag: "div",
        props: {
            Input: {},
            Flex: {
                fontSize: "A"
            }
        }
    },
    ParagraphButton: {
        P: {
            text: "You agree to"
        },
        Button: {
            text: "privacy policy"
        }
    }
};


var $b0b428f1a022b7ac$exports = {};

$parcel$export($b0b428f1a022b7ac$exports, "SocialLink", () => $b0b428f1a022b7ac$export$cc8afd413c65875b);


"use strict";
const $b0b428f1a022b7ac$export$cc8afd413c65875b = {
    extend: [
        (0, $59e9b7f5a8955db9$export$a6c7ac8248d6e38a),
        (0, $f8a17223267b0208$export$fe7c634bfc18e397)
    ],
    props: {
        fontWeight: "500",
        text: "Continue with Twitch",
        fontSize: "Z1",
        gap: "Z",
        boxSize: "fit-content",
        padding: "A A2",
        background: "gray3",
        round: "Z1",
        maxHeight: `${3}em`,
        cursor: "pointer",
        Icon: {
            name: "twitch",
            boxSize: "A2"
        }
    }
};


var $14b0ee601310f298$exports = {};

$parcel$export($14b0ee601310f298$exports, "Dialog", () => $14b0ee601310f298$export$3ddf2d174ce01153);
$parcel$export($14b0ee601310f298$exports, "DialogHeader", () => $14b0ee601310f298$export$742513523b177e3b);
$parcel$export($14b0ee601310f298$exports, "DialogFooter", () => $14b0ee601310f298$export$7bbfb2d443473050);
"use strict";
const $14b0ee601310f298$export$3ddf2d174ce01153 = {
    extend: "Flex",
    tag: "dialog",
    props: {
        flow: "column",
        border: "0",
        theme: "dialog",
        round: "Z2"
    }
};
const $14b0ee601310f298$export$742513523b177e3b = {
    extend: "Hgroup",
    props: {
        minWidth: "100%",
        gap: "A"
    },
    Title: {
        props: {
            align: "center space-between"
        },
        Text: {
            text: "Title"
        },
        SquareButton: {
            icon: "x",
            theme: "transparent"
        }
    },
    Paragraph: {
        props: {
            color: "caption"
        }
    }
};
const $14b0ee601310f298$export$7bbfb2d443473050 = {
    extend: "Flex",
    props: {
        align: "center flex-end",
        gap: "X2",
        margin: "auto - -",
        padding: "Y2 X2"
    },
    childExtend: {
        extend: "Button",
        props: {
            textTransform: "uppercase",
            background: "transparent",
            "@dark": {
                theme: "primary @dark .color-only"
            },
            "@light": {
                theme: "primary @light .color-only"
            },
            "&": {
                padding: "Z A"
            },
            ":hover": {
                theme: "tertiary"
            },
            ":active": {
                background: "white .1"
            }
        }
    },
    cancel: {
        text: "cancel"
    },
    ok: {
        text: "ok"
    }
};


var $423902791a5aa103$exports = {};
var $1c7c00bc6cd309dd$exports = {};

$parcel$export($1c7c00bc6cd309dd$exports, "Modal", () => $1c7c00bc6cd309dd$export$2b77a92f1a5ad772);

"use strict";
const $1c7c00bc6cd309dd$export$2b77a92f1a5ad772 = {
    extend: (0, $14b0ee601310f298$export$3ddf2d174ce01153),
    props: {
        boxSize: "fit-content",
        align: "stretch flex-start",
        minWidth: "G3",
        position: "relative",
        padding: "Z2 A2",
        round: "A1"
    },
    ModalHeader: {
        extend: "DialogHeader"
    }
};


var $b1364ff4d85ad896$exports = {};

$parcel$export($b1364ff4d85ad896$exports, "CompleteProcess", () => $b1364ff4d85ad896$export$8bf7a5ad1edc323e);

"use strict";
const $b1364ff4d85ad896$export$8bf7a5ad1edc323e = {
    extend: (0, $1c7c00bc6cd309dd$export$2b77a92f1a5ad772),
    props: {
        align: "center",
        gap: "B"
    },
    ModalHeader: {
        Title: {
            Text: null,
            SquareButton_x: {
                margin: "- - - auto"
            }
        },
        Paragraph: null
    },
    SuccessIndicator: {
        fontSize: "D"
    },
    Hgroup: {
        alignItems: "center",
        gap: "Y",
        Title: {
            text: "Reset complete!"
        },
        Paragraph: {
            text: "Your request has been approved!"
        }
    },
    FlexButton: {
        minWidth: "100%",
        margin: "Y - - -",
        fontWeight: "500",
        Text: {
            text: "Done"
        }
    }
};


var $6376e85cc840acfd$exports = {};

$parcel$export($6376e85cc840acfd$exports, "Message", () => $6376e85cc840acfd$export$f69c19e57285b83a);

"use strict";
const $6376e85cc840acfd$export$f69c19e57285b83a = {
    extend: (0, $1c7c00bc6cd309dd$export$2b77a92f1a5ad772),
    props: {
        maxWidth: "G3"
    },
    ModalHeader: {
        Title: {
            Text: {
                text: "Message"
            },
            SquareButton: {
                padding: "V2"
            }
        },
        Paragraph: {
            props: {
                text: "Yes. If you change your mind and no longer wish to keep your iPhone, you have the option to return it to us. The returned iPhone must be in good condition and in the original packaging, which contains all accessories, manuals and instructions. Returns are subject to Apple\u2019s Sales and Refunds Policy."
            }
        }
    }
};


var $3345613b86ec130c$exports = {};

$parcel$export($3345613b86ec130c$exports, "Pricing", () => $3345613b86ec130c$export$bc75f5ddb26aac73);


"use strict";
const $3345613b86ec130c$export$bc75f5ddb26aac73 = {
    extend: (0, $1c7c00bc6cd309dd$export$2b77a92f1a5ad772),
    props: {
        background: "gray3",
        gap: "B",
        minWidth: "G+B",
        maxWidth: "G+B",
        padding: "A1"
    },
    ModalHeader: null,
    Content: {
        props: {
            flow: "column",
            gap: "A1"
        },
        childExtend: {
            extend: (0, $f887848157c82147$export$d703b7d35511419c),
            props: {
                justifyContent: "space-between",
                textTransform: "capitalize"
            }
        },
        ...[
            {
                Unit: {
                    props: {
                        text: "subtotal"
                    }
                },
                Value: {
                    props: {
                        text: "$5,499.00"
                    }
                }
            },
            {
                Unit: {
                    props: {
                        text: "Shipping"
                    }
                },
                Value: {
                    props: {
                        text: "Free"
                    }
                }
            },
            {
                Unit: {
                    props: {
                        text: "Savings"
                    }
                },
                Value: {
                    props: {
                        text: "$1,600.00"
                    }
                }
            }
        ]
    },
    ModalFooter: {
        props: {
            margin: "- -X -X"
        },
        FlexButton: {
            flex: "1",
            padding: "Z2 -",
            round: "Y2",
            theme: "field",
            margin: "- -X -X",
            text: "Add promo code",
            fontWeight: "500"
        }
    }
};


"use strict";
$parcel$exportWildcard($423902791a5aa103$exports, $1c7c00bc6cd309dd$exports);
$parcel$exportWildcard($423902791a5aa103$exports, $b1364ff4d85ad896$exports);
$parcel$exportWildcard($423902791a5aa103$exports, $6376e85cc840acfd$exports);
$parcel$exportWildcard($423902791a5aa103$exports, $3345613b86ec130c$exports);



var $d93ddbd64d83a6b9$exports = {};

$parcel$export($d93ddbd64d83a6b9$exports, "TimePicker", () => $d93ddbd64d83a6b9$export$5f876910ea565cd3);


var $dcb83043ba4dd622$exports = {};

$parcel$export($dcb83043ba4dd622$exports, "TimePickerItem", () => $dcb83043ba4dd622$export$c15bac1813c10cfa);

"use strict";
const $dcb83043ba4dd622$var$props = {
    align: "center center",
    flow: "column",
    gap: "X",
    "> button": {
        padding: "0",
        background: "transparent",
        fontSize: "Z",
        display: "none"
    }
};
const $dcb83043ba4dd622$export$c15bac1813c10cfa = {
    tag: "label",
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: $dcb83043ba4dd622$var$props,
    Button_plus: {
        icon: "plus"
    },
    NumberInput: {
        boxSize: "C C",
        round: "Z",
        padding: "0",
        align: "center center",
        textAlign: "center",
        min: 0,
        max: 24,
        placeholder: "00",
        appearance: "textfield",
        theme: "field",
        "::-webkit-inner-spin-button": {
            style: {
                appearance: "none"
            },
            margin: 0
        },
        "::-webkit-outer-spin-button": {
            style: {
                appearance: "none"
            },
            margin: 0
        }
    },
    Button_minus: {
        icon: "minus"
    }
};


var $c217819d479da9d8$exports = {};

$parcel$export($c217819d479da9d8$exports, "TimeSwitcher", () => $c217819d479da9d8$export$d4eea2dc8b6aadbd);


"use strict";
const $c217819d479da9d8$var$props = {
    boxSize: "C B2",
    flow: "column",
    overflow: "hidden",
    round: "Z",
    theme: "field"
};
const $c217819d479da9d8$export$d4eea2dc8b6aadbd = {
    props: $c217819d479da9d8$var$props,
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    childExtend: {
        extend: (0, $ca26469f43255c37$export$353f5b6fc5456de1),
        props: ({ state: state, key: key })=>({
                active: state.activeShift === key,
                padding: "0",
                flex: "1",
                width: "100%",
                fontSize: "Y",
                textTransform: "uppercase",
                round: "0",
                background: "transparent",
                color: "currentColor",
                lineHeight: "1",
                ".active": {
                    theme: "primary"
                }
            }),
        on: {
            click: (ev, { key: key, state: state })=>{
                console.log(ev, key, state);
                state.update({
                    activeShift: key
                });
            }
        }
    },
    am: {
        text: "am"
    },
    pm: {
        text: "pm"
    }
};


"use strict";
const $d93ddbd64d83a6b9$export$5f876910ea565cd3 = {
    extend: [
        (0, $14b0ee601310f298$export$3ddf2d174ce01153),
        (0, $8184389c03ed1792$export$f51f4c4ede09e011)
    ],
    state: {
        activeShift: "am"
    },
    props: {
        flow: "column",
        width: "fit-content",
        padding: "Z2 A"
    },
    Title: {
        fontSize: "Z1",
        textTransform: "capitalize",
        padding: "- - A -",
        text: "enter time"
    },
    Flex: {
        props: {
            align: "center center",
            gap: "A"
        },
        Flex: {
            tag: "label",
            props: {
                align: "center center",
                gap: "Y2"
            },
            TimePickerItem_hh: {
                NumberInput: {
                    placeholder: "HH",
                    min: "0",
                    max: "11"
                }
            },
            Span: {
                text: ":"
            },
            TimePickerItem_mm: {
                NumberInput: {
                    placeholder: "MM",
                    min: "0",
                    max: "59"
                }
            },
            Span_2: {
                text: ":"
            },
            TimePickerItem_ss: {
                NumberInput: {
                    placeholder: "SS",
                    min: "0",
                    max: "59"
                }
            }
        },
        TimeSwitcher: {}
    },
    DialogFooter: {
        align: "center flex-end",
        gap: "X",
        margin: "Z2 -Z2 -Z",
        childProps: {
            background: "transparent",
            padding: "0",
            color: "#0079FD"
        }
    }
};
$parcel$exportWildcard($d93ddbd64d83a6b9$exports, $dcb83043ba4dd622$exports);
$parcel$exportWildcard($d93ddbd64d83a6b9$exports, $c217819d479da9d8$exports);


var $954e4cb4adbc0299$exports = {};

$parcel$export($954e4cb4adbc0299$exports, "DropdownList", () => $954e4cb4adbc0299$export$e40cc1c58d22b809);
$parcel$export($954e4cb4adbc0299$exports, "DropdownParent", () => $954e4cb4adbc0299$export$b162207c9836937);


"use strict";
const $954e4cb4adbc0299$export$e40cc1c58d22b809 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        padding: "0 Y",
        maxHeight: "G",
        flow: "column",
        theme: "quaternary",
        overflow: "hidden auto",
        style: {
            listStyleType: "none"
        }
    },
    childExtend: {
        extend: (0, $ca26469f43255c37$export$353f5b6fc5456de1),
        state: {},
        props: ({ key: key, state: state })=>({
                active: state.active === key,
                position: "relative",
                round: "0",
                align: "center flex-end",
                flow: "row-reverse",
                padding: "Z2 C Z2 Y2",
                margin: "0",
                gap: "Y2",
                theme: "quaternary .child",
                ":hover": {
                    style: {
                        svg: {
                            opacity: "0.5"
                        }
                    }
                },
                Icon: {
                    active: state.active === key,
                    name: "checkmark",
                    opacity: "0.1",
                    ".active": {
                        opacity: "1"
                    }
                },
                ":not(:first-child)": {
                    "@dark": {
                        border: "gray4 .65, solid"
                    },
                    "@light": {
                        border: "gray11, solid"
                    },
                    borderWidth: "1px 0 0"
                }
            })
    },
    $propsCollection: ({ props: props })=>props.options
};
const $954e4cb4adbc0299$export$b162207c9836937 = {
    props: {
        position: "relative",
        zIndex: 999,
        style: {
            "&:hover": {
                zIndex: 1000,
                "& [dropdown]": {
                    transform: "translate3d(0,0,0)",
                    opacity: 1,
                    visibility: "visible"
                }
            }
        }
    }
};


var $9f1f1f2471e307cd$exports = {};
var $372c98013349edc9$exports = {};

$parcel$export($372c98013349edc9$exports, "CommonForm", () => $372c98013349edc9$export$4452190d80a7d3c4);



"use strict";
const $372c98013349edc9$export$4452190d80a7d3c4 = {
    extend: (0, $1c7c00bc6cd309dd$export$2b77a92f1a5ad772),
    props: {
        gap: "B",
        boxSizing: "border-box",
        padding: "A+V A"
    },
    ModalHeader: {
        props: {
            gap: "Z"
        },
        Title: {
            Text: {},
            SquareButton_x: {
                margin: "-Y+V - - -",
                fontSize: "C"
            }
        }
    },
    Form: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            flow: "column",
            "> div ~ button": {
                padding: "Z2+V1 -"
            },
            "> div ~ div:last-child > button": {
                padding: "Z2+V1 B"
            },
            "> div ~ div:last-child > button:first-child": {
                padding: "Z2+V Z"
            }
        },
        Fields: {
            extend: (0, $afd03220988cb716$export$ef2184bd89960b14),
            props: {
                columnGap: "A",
                rowGap: "A1"
            },
            childExtend: {
                extend: (0, $86fa541a35e509bb$export$257a13be48b6f047),
                props: {
                    width: "100%",
                    Field: {
                        minWidth: "100%"
                    }
                }
            }
        },
        Submit: {
            props: {
                minWidth: "100%",
                margin: "C - - -"
            }
        }
    }
};


var $1d4fe7f0128f8c5f$exports = {};

$parcel$export($1d4fe7f0128f8c5f$exports, "VerificationCode", () => $1d4fe7f0128f8c5f$export$2927e323c8fd0351);



"use strict";
const $1d4fe7f0128f8c5f$export$2927e323c8fd0351 = {
    extend: (0, $372c98013349edc9$export$4452190d80a7d3c4),
    // state: { value: NUMBERS },
    Header: {
        props: {
            gap: "A"
        },
        Title: {
            caption: {
                props: {
                    text: "Verify your email"
                }
            }
        },
        Paragraph: {
            props: {
                text: "Verification code has been sent to you. Enter the code below.",
                maxWidth: "G1_default"
            }
        }
    },
    Form: {
        props: {
            "> div ~ div:last-child > button": {
                padding: "Z1+V1 B+V"
            },
            "> div ~ div:last-child > button:first-child": {
                padding: "Z1+V1 Y1"
            }
        },
        Fields: {
            props: {
                display: "flex",
                columnGap: "A",
                childProps: {
                    flex: "1",
                    fontSize: "E"
                }
            },
            childExtend: (0, $213c0d90580abffb$export$6bf0cd3a219bbade),
            ...[
                {},
                {},
                {},
                {}
            ]
        },
        ParagraphButton: {
            padding: "Z1 Z2 - Z2"
        },
        Submit: {
            extend: (0, $ca26469f43255c37$export$68fd62726e540676),
            props: {
                justifyContent: "flex-end"
            },
            ...[
                {
                    caption: {
                        props: {
                            text: "Cancel"
                        }
                    }
                },
                {
                    caption: {
                        props: {
                            text: "Verify"
                        }
                    }
                }
            ]
        }
    }
};


var $19adbe66832a7db4$exports = {};

$parcel$export($19adbe66832a7db4$exports, "ResetPassword", () => $19adbe66832a7db4$export$a4c3d56613a57187);



"use strict";
const $19adbe66832a7db4$export$a4c3d56613a57187 = {
    extend: (0, $372c98013349edc9$export$4452190d80a7d3c4),
    props: {
        minWidth: "G3+D"
    },
    ModalHeader: {
        Title: {
            caption: {
                props: {
                    text: "Choose new password"
                }
            }
        },
        Paragraph: {
            props: {
                text: "Almost done. Enter your new password and you\u2019re all set"
            }
        }
    },
    Form: {
        Fields: {
            ...[
                {
                    Title: {
                        props: {
                            text: "Old password"
                        }
                    },
                    Field: {}
                },
                {
                    Title: {
                        props: {
                            text: "New password"
                        }
                    },
                    Field: {},
                    Hint: {
                        extend: (0, $f8a17223267b0208$export$fe7c634bfc18e397),
                        props: {
                            icon: "info",
                            text: "8 character minimum"
                        }
                    }
                },
                {
                    Title: {
                        props: {
                            text: "Confirm new password"
                        }
                    },
                    Field: {},
                    Hint: {
                        extend: (0, $f8a17223267b0208$export$fe7c634bfc18e397),
                        props: {
                            icon: "info",
                            text: "8 character minimum"
                        }
                    }
                }
            ]
        },
        Submit: {
            extend: (0, $ca26469f43255c37$export$68fd62726e540676),
            props: {
                justifyContent: "flex-end"
            },
            ...[
                {
                    Text: "Cancel"
                },
                {
                    Text: "Reset password"
                }
            ]
        }
    }
};


var $98f1138c763dad2c$exports = {};

$parcel$export($98f1138c763dad2c$exports, "ContactForm", () => $98f1138c763dad2c$export$d5d8fc50aded1148);



"use strict";
const $98f1138c763dad2c$export$d5d8fc50aded1148 = {
    extend: (0, $372c98013349edc9$export$4452190d80a7d3c4),
    ModalHeader: {
        Title: {
            Text: {
                text: "We\u2019d love to help"
            }
        },
        Paragraph: {
            props: {
                text: "Reach out and we\u2019ll get in touch within 24 hours."
            }
        }
    },
    Form: {
        Fields: {
            props: {
                columns: "repeat(2, 1fr)"
            },
            ...[
                {
                    props: {
                        gridColumn: "1"
                    },
                    Title: {
                        props: {
                            text: "First name"
                        }
                    },
                    Field: {
                        Input: {
                            props: {
                                placeholder: "First name"
                            }
                        }
                    }
                },
                {
                    props: {
                        gridColumn: "2"
                    },
                    Title: {
                        props: {
                            text: "Last name"
                        }
                    },
                    Field: {
                        Input: {
                            props: {
                                placeholder: "Last name"
                            }
                        }
                    }
                },
                {
                    props: {
                        gridColumn: "1 / span 2"
                    },
                    Title: {
                        props: {
                            text: "Email"
                        }
                    },
                    Field: {
                        Input: {
                            props: {
                                placeholder: "example@email.com"
                            }
                        }
                    }
                },
                {
                    props: {
                        gridColumn: "1 / span 2"
                    },
                    Title: {
                        props: {
                            text: "Message"
                        }
                    },
                    Field: {
                        extend: (0, $dd0910b23638afad$export$301bf6213f61d17f)
                    }
                }
            ]
        },
        ParagraphButtonWithCheckbox: {
            padding: "Z1 Z - Z"
        },
        Submit: {
            extend: (0, $ca26469f43255c37$export$c48f2f65343acffb),
            text: "Send message"
        }
    }
};


var $1ba06bf2d1a50fb3$exports = {};

$parcel$export($1ba06bf2d1a50fb3$exports, "SignUp", () => $1ba06bf2d1a50fb3$export$4ee457d816cea81a);



"use strict";
const $1ba06bf2d1a50fb3$export$4ee457d816cea81a = {
    extend: (0, $372c98013349edc9$export$4452190d80a7d3c4),
    props: {
        minWidth: "H"
    },
    ModalHeader: {
        Title: {
            caption: {
                props: {
                    text: "Create your account"
                }
            }
        },
        Paragraph: {
            props: {
                text: "Let\u2019s get started with your 30 days free trial"
            }
        }
    },
    Form: {
        Fields: {
            ...[
                {
                    Title: {
                        props: {
                            text: "Full name"
                        }
                    },
                    Field: {
                        Input: {
                            props: {
                                placeholder: "Enter your full name"
                            }
                        }
                    }
                },
                {
                    Title: {
                        props: {
                            text: "Email"
                        }
                    },
                    Field: {
                        Input: {
                            props: {
                                placeholder: "Email address"
                            }
                        }
                    }
                },
                {
                    Title: {
                        props: {
                            text: "Password"
                        }
                    },
                    Field: {
                        Input: {
                            props: {
                                placeholder: "Create a password"
                            }
                        }
                    },
                    Hint: {
                        extend: (0, $f8a17223267b0208$export$fe7c634bfc18e397),
                        props: {
                            icon: "info",
                            text: "8 character minimum"
                        }
                    }
                },
                {
                    Title: {
                        props: {
                            text: "Confirm password"
                        }
                    },
                    Field: {
                        Input: {
                            props: {
                                placeholder: "Repeat password"
                            }
                        }
                    },
                    Hint: {
                        extend: (0, $f8a17223267b0208$export$fe7c634bfc18e397),
                        props: {
                            icon: "info",
                            text: "8 character minimum"
                        }
                    }
                }
            ]
        },
        ParagraphButtonWithCheckbox: {
            padding: "Z2 Z1 - Z1",
            justifyContent: "flex-end"
        },
        Submit: {
            extend: (0, $ca26469f43255c37$export$c48f2f65343acffb),
            text: "Create an account"
        }
    }
};


var $1470454842f104bb$exports = {};

$parcel$export($1470454842f104bb$exports, "LogIn", () => $1470454842f104bb$export$88195aaac9f90319);




"use strict";
const $1470454842f104bb$export$88195aaac9f90319 = {
    extend: (0, $372c98013349edc9$export$4452190d80a7d3c4),
    props: {
        minWidth: "G3+C1"
    },
    ModalHeader: {
        Title: {
            caption: {
                props: {
                    text: "Log in to your account"
                }
            }
        },
        Paragraph: {
            props: {
                text: "Enter your email address and password to log in."
            }
        }
    },
    Form: {
        props: {
            ParagraphButtonWithCheckbox: {
                margin: "A -"
            }
        },
        Fields: {
            ...[
                {
                    Title: {
                        props: {
                            text: "Email"
                        }
                    },
                    Field: {
                        Input: {
                            props: {
                                placeholder: "Enter your email"
                            }
                        }
                    }
                },
                {
                    Title: {
                        props: {
                            text: "Password"
                        }
                    },
                    Field: {
                        Icon: null,
                        Input: {
                            props: {
                                placeholder: "Enter your password"
                            }
                        },
                        Button: {
                            props: {
                                icon: "eye"
                            }
                        }
                    }
                }
            ]
        },
        ParagraphButtonWithCheckbox: {
            padding: "- Y1",
            Checkbox: {},
            ParagraphButton: {
                flex: "1",
                justifyContent: "space-between",
                P: {
                    text: "Keep me logged in"
                },
                Button: {
                    text: "Forgot your password?",
                    fontWeight: "400",
                    textDecoration: "none"
                }
            }
        },
        Submit: {
            extend: (0, $ca26469f43255c37$export$c48f2f65343acffb),
            props: {
                margin: "A - - -"
            },
            text: "Sign in"
        }
    },
    DoubleHr: {},
    ModalFooter: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            flow: "column",
            gap: "Z2"
        },
        childExtend: {
            extend: (0, $b0b428f1a022b7ac$export$cc8afd413c65875b),
            props: {
                minWidth: "100%",
                color: "caption"
            }
        },
        ...[
            {},
            {}
        ]
    }
};


"use strict";
$parcel$exportWildcard($9f1f1f2471e307cd$exports, $372c98013349edc9$exports);
$parcel$exportWildcard($9f1f1f2471e307cd$exports, $1d4fe7f0128f8c5f$exports);
$parcel$exportWildcard($9f1f1f2471e307cd$exports, $19adbe66832a7db4$exports);
$parcel$exportWildcard($9f1f1f2471e307cd$exports, $98f1138c763dad2c$exports);
$parcel$exportWildcard($9f1f1f2471e307cd$exports, $1ba06bf2d1a50fb3$exports);
$parcel$exportWildcard($9f1f1f2471e307cd$exports, $1470454842f104bb$exports);


var $6e069cc18a82edfb$exports = {};
var $061ed3737020da80$exports = {};

$parcel$export($061ed3737020da80$exports, "UploadImage", () => $061ed3737020da80$export$eaa555e7f7268368);
$parcel$export($061ed3737020da80$exports, "UploadIcon", () => $061ed3737020da80$export$8df90684a752ef81);

"use strict";
const $061ed3737020da80$export$eaa555e7f7268368 = {
    props: {
        padding: "A+V",
        theme: "tertiary",
        boxSize: "fit-content",
        round: "Z2"
    },
    Icon: {
        name: "upload"
    }
};
const $061ed3737020da80$export$8df90684a752ef81 = {
    extend: [
        (0, $c3656ade3a6fd1e0$export$35a3bebf7ef2d934),
        (0, $8184389c03ed1792$export$f51f4c4ede09e011)
    ],
    tag: "label",
    props: {
        position: "relative",
        theme: "tertiary",
        flow: "column",
        align: "center center",
        round: "A",
        cursor: "pointer",
        border: "1.6px, dashed, white 0.1",
        padding: "B B2"
    },
    Input: {
        props: {
            type: "file",
            position: "absolute",
            inset: "0 0 0 0",
            opacity: "0",
            visibility: "hidden"
        }
    },
    Icon: {
        props: {
            name: "upload",
            fontSize: "B",
            opacity: ".2"
        }
    },
    P: {
        props: {
            text: " or click and upload from your computer",
            flexFlow: "column",
            flexAlign: "center center",
            opacity: ".22",
            margin: "0"
        },
        Span: {
            text: "Drag and drop your font file",
            display: "block"
        }
    }
};


var $37c84bf058717c9e$exports = {};

$parcel$export($37c84bf058717c9e$exports, "UploadButton", () => $37c84bf058717c9e$export$b3fd96a52c80b3af);
$parcel$export($37c84bf058717c9e$exports, "UploadButtonWithBackground", () => $37c84bf058717c9e$export$d93e13215bb24752);

"use strict";
const $37c84bf058717c9e$export$b3fd96a52c80b3af = {
    extend: (0, $ca26469f43255c37$export$c48f2f65343acffb),
    props: {
        position: "relative",
        padding: "0",
        theme: "field @{globalTheme} .color-only",
        boxSize: "fit-content fit-content",
        cursor: "pointer"
    },
    Input: {
        type: "file",
        inset: "0 0 0 0",
        position: "absolute",
        boxSize: "100% 100%",
        top: "0",
        left: "0",
        opacity: "0",
        cursor: "pointer"
    },
    Text: "Browse files"
};
const $37c84bf058717c9e$export$d93e13215bb24752 = {
    extend: $37c84bf058717c9e$export$b3fd96a52c80b3af,
    props: {
        theme: "field",
        padding: "Z2 A1"
    },
    Text: "Browse files"
};


var $b73fb42cd78333e5$exports = {};

$parcel$export($b73fb42cd78333e5$exports, "UploadLabel", () => $b73fb42cd78333e5$export$505072ee04aa5991);
$parcel$export($b73fb42cd78333e5$exports, "UploadLabel2", () => $b73fb42cd78333e5$export$a0e211032c21de58);

"use strict";
const $b73fb42cd78333e5$export$505072ee04aa5991 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        flow: "column",
        align: "center flex-start",
        boxSize: "fit-content fit-content",
        gap: "B2",
        padding: "C D1",
        round: "A",
        border: "solid, gray2 .05",
        borderWidth: "1px",
        theme: "dialog"
    },
    Icon: {
        name: "file",
        fontSize: "D",
        theme: "field .color-only"
    },
    Hgroup: {
        props: {
            align: "center flex-start",
            gap: "Z",
            fontWeight: "400"
        },
        Title: {
            props: {
                text: "Drag & drop your files here or",
                flow: "row-reverse",
                fontWeight: "400",
                gap: "Y2",
                align: "center flex-start",
                color: "title"
            },
            UploadButton: {
                caption: {
                    fontWeight: "500"
                }
            }
        },
        Paragraph: {
            props: {
                text: "50 MB max file size",
                fontSize: "Z"
            }
        }
    }
};
const $b73fb42cd78333e5$export$a0e211032c21de58 = {
    extend: $b73fb42cd78333e5$export$505072ee04aa5991,
    props: {
        padding: "B2 E1",
        gap: "B"
    },
    Icon: {},
    Hgroup: {
        Title: {
            UploadButton: null
        }
    },
    UploadButtonWithBackground: {
        padding: "A C",
        margin: "Z - - -",
        caption: {
            fontWeight: "500"
        }
    }
};


var $ecaa8d2defd13b14$exports = {};

$parcel$export($ecaa8d2defd13b14$exports, "UploadFooter", () => $ecaa8d2defd13b14$export$f7dfe53dbb716bc9);
$parcel$export($ecaa8d2defd13b14$exports, "UploadModal", () => $ecaa8d2defd13b14$export$46267e49b219a0a9);
$parcel$export($ecaa8d2defd13b14$exports, "UploadModal2", () => $ecaa8d2defd13b14$export$b65842c4956b58f0);
$parcel$export($ecaa8d2defd13b14$exports, "UploadModal3", () => $ecaa8d2defd13b14$export$c900fbf3ee85d573);
$parcel$export($ecaa8d2defd13b14$exports, "UploadModal4", () => $ecaa8d2defd13b14$export$3a5e73785f9123f5);





"use strict";
const $ecaa8d2defd13b14$export$f7dfe53dbb716bc9 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        gap: "E",
        align: "center space-between",
        boxSize: "fit-content"
    },
    IconText: {
        extend: (0, $f8a17223267b0208$export$fe7c634bfc18e397),
        props: {
            icon: "info",
            text: "Support",
            gap: "Y",
            fontWeight: "400"
        }
    },
    Buttons: {
        extend: (0, $ca26469f43255c37$export$68fd62726e540676),
        props: {
            childProps: {
                padding: "Z2 A1",
                ":first-child": {
                    theme: "tertiary",
                    padding: "- A1"
                }
            }
        },
        ...[
            {
                Text: "Cancel"
            },
            {
                extend: (0, $37c84bf058717c9e$export$d93e13215bb24752),
                Text: "Attach file"
            }
        ]
    }
};
const $ecaa8d2defd13b14$export$46267e49b219a0a9 = {
    extend: (0, $1c7c00bc6cd309dd$export$2b77a92f1a5ad772),
    props: {
        gap: "A",
        round: "A1",
        padding: "A"
    },
    ModalHeader: {
        Title: {
            Text: {
                text: "File Upload"
            },
            SquareButton_x: {
                margin: "-V2 - - -"
            }
        },
        Paragraph: null
    },
    UploadLabel: {},
    UploadFooter: {
        props: {
            minWidth: "100%",
            margin: "-W - - -"
        },
        IconText: {
            props: {
                padding: "- Z"
            }
        },
        Buttons: {
            props: {
                gap: "Z2"
            }
        }
    }
};
const $ecaa8d2defd13b14$export$b65842c4956b58f0 = {
    extend: $ecaa8d2defd13b14$export$46267e49b219a0a9,
    ModalHeader: {},
    UploadLabel: null,
    UploadLabel2: {
        width: "100%",
        Icon: {},
        Hgroup: {},
        UploadButtonWithBackground: {
            theme: "tertiary"
        }
    }
};
const $ecaa8d2defd13b14$export$c900fbf3ee85d573 = {
    extend: $ecaa8d2defd13b14$export$b65842c4956b58f0,
    ModalHeader: {},
    UploadLabel2: {},
    UploadFooter: {
        props: {
            padding: "0"
        },
        IconText: null,
        Buttons: {
            props: {
                minWidth: "100%",
                childProps: {
                    flex: "1"
                }
            }
        }
    }
};
const $ecaa8d2defd13b14$export$3a5e73785f9123f5 = {
    extend: $ecaa8d2defd13b14$export$c900fbf3ee85d573,
    ModalHeader: {},
    UploadLabel2: {},
    UploadingProcess4: {
        minWidth: "100%"
    },
    UploadFooter: {}
};


var $436e06560fe36808$exports = {};

$parcel$export($436e06560fe36808$exports, "UploadingProcess", () => $436e06560fe36808$export$d3bde94e2efb9035);
$parcel$export($436e06560fe36808$exports, "UploadedProcess", () => $436e06560fe36808$export$d49bf085c21e643f);
$parcel$export($436e06560fe36808$exports, "UploadingProcess2", () => $436e06560fe36808$export$cec7e46fa1c18b50);
$parcel$export($436e06560fe36808$exports, "UploadedProcess2", () => $436e06560fe36808$export$e5b51bef77ac41e4);
$parcel$export($436e06560fe36808$exports, "UploadingProcess3", () => $436e06560fe36808$export$cb8aa0cad0ef2fbe);
$parcel$export($436e06560fe36808$exports, "UploadedProcess3", () => $436e06560fe36808$export$a68cdcc6f5f09a7);
$parcel$export($436e06560fe36808$exports, "UploadingProcess4", () => $436e06560fe36808$export$ee74b8d4b46a24c5);
$parcel$export($436e06560fe36808$exports, "UploadedProcess4", () => $436e06560fe36808$export$822735be3c4db181);



"use strict";
const $436e06560fe36808$export$d3bde94e2efb9035 = {
    extend: (0, $14b0ee601310f298$export$3ddf2d174ce01153),
    props: {
        boxSize: "fit-content",
        padding: "Y2 Z2 Y2 Y2",
        round: "A",
        gap: "Y2",
        position: "relative"
    },
    Image: {
        extend: (0, $061ed3737020da80$export$eaa555e7f7268368)
    },
    Flex: {
        extend: (0, $32625a13d757d0d6$export$bd5b3f7ef3b94a4a),
        props: {
            justifyContent: "space-between",
            padding: "W2 -"
        },
        Title: {
            props: {
                justifyContent: "space-between"
            },
            Text: {
                text: "Image.jpg",
                fontSize: "Z2"
            },
            SquareButton_x: {
                icon: "x",
                fontSize: "B",
                boxSize: "fit-content",
                padding: "0",
                theme: "transparent",
                margin: "- -V1 - -"
            }
        },
        Paragraph: {
            props: {
                flow: "column",
                gap: "Y2"
            },
            DoubleUnitValue: {
                fontSize: "Z2"
            },
            ProgressLine: {}
        }
    }
};
const $436e06560fe36808$export$d49bf085c21e643f = {
    extend: $436e06560fe36808$export$d3bde94e2efb9035,
    Image: {},
    Flex: {
        Title: {},
        Paragraph: {
            DoubleUnitValue: null,
            span: {
                props: {
                    text: "Done",
                    lineHeight: "1em",
                    color: "title",
                    display: "block"
                }
            },
            ProgressLine: {
                value: "1",
                style: {
                    "&::-webkit-progress-value": {
                        background: "#04F214"
                    }
                }
            }
        }
    }
};
const $436e06560fe36808$export$cec7e46fa1c18b50 = {
    extend: $436e06560fe36808$export$d3bde94e2efb9035,
    props: {
        border: "solid, gray3",
        borderWidth: "1px"
    },
    Image: {
        props: {
            padding: "Z2"
        },
        Icon: {
            fontSize: "D"
        }
    },
    Flex: {
        Title: {
            caption: {
                props: {
                    fontSize: "A1"
                }
            }
        },
        Paragraph: {
            ProgressLineWithUnitValue: {
                ProgressLine: {},
                UnitValue: {
                    fontSize: "Z1"
                }
            },
            DoubleUnitValue: null,
            ProgressLine: null
        }
    }
};
const $436e06560fe36808$export$e5b51bef77ac41e4 = {
    extend: $436e06560fe36808$export$cec7e46fa1c18b50,
    Image: {},
    Flex: {
        props: {
            margin: "- - -V2 -"
        },
        Title: {},
        Paragraph: {
            ProgressLineWithUnitValue: {
                ProgressLine: {
                    value: 1,
                    style: {
                        "&::-webkit-progress-value": {
                            background: "#04F214"
                        }
                    }
                },
                UnitValue: {
                    Value: {
                        text: "100"
                    }
                }
            }
        }
    }
};
const $436e06560fe36808$export$cb8aa0cad0ef2fbe = {
    extend: $436e06560fe36808$export$cec7e46fa1c18b50,
    props: {
        minWidth: "G+C2",
        gap: "Z"
    },
    Image: {},
    Flex: {
        props: {
            padding: "0",
            justifyContent: "center",
            gap: "Z"
        },
        Title: {
            Text: {
                fontSize: "Z2"
            },
            SquareButton_x: {
                position: "absolute",
                top: "50%",
                right: "B+W1",
                transform: "translate(50%, -50%)",
                padding: "Y",
                fontSize: "A1",
                theme: "tertiary"
            }
        },
        Paragraph: {
            ProgressLineWithUnitValue: null,
            ProgressCircleWithSideUnitValue: {}
        }
    }
};
const $436e06560fe36808$export$a68cdcc6f5f09a7 = {
    extend: $436e06560fe36808$export$cb8aa0cad0ef2fbe,
    Image: {},
    Flex: {
        Title: {},
        Paragraph: {
            ProgressCircleWithSideUnitValue: {
                ProgressCircle: {
                    Progress: {
                        value: 1,
                        style: {
                            "&::-webkit-progress-value": {
                                background: "#04F214"
                            }
                        }
                    }
                },
                UnitValue: {
                    Value: {
                        text: "Done"
                    },
                    Unit: {
                        display: "none"
                    }
                }
            }
        }
    }
};
const $436e06560fe36808$export$ee74b8d4b46a24c5 = {
    extend: $436e06560fe36808$export$cb8aa0cad0ef2fbe,
    props: {
        alignItems: "center",
        padding: "Y2 Y2 Y2 Z",
        gap: "Z1"
    },
    Image: null,
    ProgressCircleWithIcon: {
        boxSize: "C+X1",
        Icon: {
            fontSize: "C"
        }
    },
    Flex: {
        props: {
            gap: "Y1",
            padding: "W2 - - -"
        },
        Title: {},
        Paragraph: {
            tag: "p",
            props: {
                text: "Uploading . . .",
                margin: "0",
                padding: "0",
                color: "title"
            },
            ProgressCircleWithSideUnitValue: null
        }
    }
};
const $436e06560fe36808$export$822735be3c4db181 = {
    extend: $436e06560fe36808$export$ee74b8d4b46a24c5,
    ProgressCircleWithIcon: {
        ":after": {
            width: "calc(100% - 3px)",
            height: "calc(100% - 3px)"
        },
        Icon: {
            name: "check",
            color: "#04F214",
            fontSize: "E1"
        },
        Progress: {
            value: 1,
            style: {
                "&::-webkit-progress-value": {
                    background: "#04F214"
                }
            }
        }
    },
    Flex: {
        Title: {},
        Paragraph: {
            text: "Uploaded"
        }
    }
};


"use strict";
$parcel$exportWildcard($6e069cc18a82edfb$exports, $061ed3737020da80$exports);
$parcel$exportWildcard($6e069cc18a82edfb$exports, $37c84bf058717c9e$exports);
$parcel$exportWildcard($6e069cc18a82edfb$exports, $b73fb42cd78333e5$exports);
$parcel$exportWildcard($6e069cc18a82edfb$exports, $ecaa8d2defd13b14$exports);
$parcel$exportWildcard($6e069cc18a82edfb$exports, $436e06560fe36808$exports);


var $bdfe1d5bd3b47067$exports = {};
var $7c01b64d6fe504fd$exports = {};

$parcel$export($7c01b64d6fe504fd$exports, "User", () => $7c01b64d6fe504fd$export$1f44aaf2ec115b54);

"use strict";
const $7c01b64d6fe504fd$export$1f44aaf2ec115b54 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        boxSize: "fit-content",
        theme: "dialog",
        padding: "Z A Z Z",
        round: "A",
        gap: "Y1",
        align: "center flex-start"
    },
    AvatarIndicator: {
        Avatar: {
            boxSize: "C+V"
        }
    },
    Hgroup: {
        props: {
            justifyContent: "center",
            gap: "W2",
            margin: "X2 - - -"
        },
        Title: {
            props: {
                fontWeight: "500"
            }
        },
        Paragraph: {
            props: {
                fontSize: "Z1",
                alignItems: "center"
            }
        }
    }
};


var $f1342b36a388e88f$exports = {};

$parcel$export($f1342b36a388e88f$exports, "ChatUser", () => $f1342b36a388e88f$export$742dee7e484b86e3);



"use strict";
const $f1342b36a388e88f$export$742dee7e484b86e3 = {
    extend: (0, $7c01b64d6fe504fd$export$1f44aaf2ec115b54),
    props: {
        gap: "Y2"
    },
    Avatar: {},
    Notes: {
        props: {
            gap: "X1"
        },
        Title: {
            props: {
                align: "center space-between"
            },
            caption: {
                props: {
                    text: "Maria Kenter"
                }
            },
            time: {
                extend: (0, $f887848157c82147$export$d703b7d35511419c),
                props: {
                    fontSize: "Z1",
                    color: "paragraph",
                    gap: "X2"
                },
                Unit: {
                    props: {
                        text: "2:22"
                    }
                },
                Value: {
                    props: {
                        text: "AM"
                    }
                }
            }
        },
        Paragraph: {
            props: {
                gap: "C1"
            },
            p: {
                extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
                props: {
                    text: "Hey team, I\u2019ve finished the requirements document",
                    maxWidth: "F1",
                    overflow: "hidden",
                    whiteSpace: "nowrap"
                }
            },
            CountIndicator: {}
        }
    }
};


var $b9343a89d12ca1bd$exports = {};

$parcel$export($b9343a89d12ca1bd$exports, "UserButtonSet", () => $b9343a89d12ca1bd$export$2f974c3ae0bad759);
$parcel$export($b9343a89d12ca1bd$exports, "UserButtonSetCircle", () => $b9343a89d12ca1bd$export$c41b1e39f58ef596);

"use strict";
const $b9343a89d12ca1bd$export$2f974c3ae0bad759 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        boxSize: "fit-content",
        theme: "dialog",
        padding: "Z1 Z1 Z Z",
        round: "A",
        alignItems: "center",
        gap: "E"
    },
    User: {
        padding: "0",
        gap: "Y2",
        Avatar: {
            fontSize: "A"
        },
        Notes: {
            margin: "W - - -",
            gap: "X2",
            Title: {
                text: "Group"
            },
            Paragraph: {
                text: "Active now"
            }
        }
    },
    ButtonSet: {
        props: {
            gap: "Y2"
        },
        ...[
            {
                props: {
                    icon: "phone"
                }
            },
            {
                props: {
                    icon: "video"
                }
            },
            {
                props: {
                    icon: "moreHorizontal"
                }
            }
        ]
    }
};
const $b9343a89d12ca1bd$export$c41b1e39f58ef596 = {
    extend: $b9343a89d12ca1bd$export$2f974c3ae0bad759,
    User: {},
    ButtonSet: {
        childExtend: {
            props: {
                round: "100%"
            }
        }
    }
};


var $1ee0560b3704dbc9$exports = {};

$parcel$export($1ee0560b3704dbc9$exports, "UserMessage", () => $1ee0560b3704dbc9$export$46bbf1c329ce020);

"use strict";
const $1ee0560b3704dbc9$export$46bbf1c329ce020 = {
    extend: (0, $7c01b64d6fe504fd$export$1f44aaf2ec115b54),
    props: {
        gap: "Z",
        theme: "transparent"
    },
    AvatarIndicator: {},
    Hgroup: {
        props: {
            margin: "0"
        },
        Title: null,
        Paragraph: {
            props: {
                text: "Can you please review the latest design?",
                padding: "Z1 Z2",
                round: "Z2",
                theme: "dialog"
            }
        }
    }
};


var $a3d32edcf109e612$exports = {};

$parcel$export($a3d32edcf109e612$exports, "UserWithLabel", () => $a3d32edcf109e612$export$4817664f18cc7faa);


"use strict";
const $a3d32edcf109e612$export$4817664f18cc7faa = {
    extend: (0, $7c01b64d6fe504fd$export$1f44aaf2ec115b54),
    props: {
        gap: "Y2"
    },
    Avatar: {
        StatusIndicator: null,
        Avatar: {
            props: {
                boxSize: "B2+W"
            }
        }
    },
    Notes: {
        props: {
            margin: "V2 - - -"
        },
        Title: {
            props: {
                gap: "Y1",
                fontSize: "Z2"
            },
            caption: {
                props: {
                    text: "ETHDOWN"
                }
            },
            label: {
                extend: (0, $7bd759d9ddd96987$export$b04be29aa201d4f5)
            }
        },
        Paragraph: {
            tag: "p",
            props: {
                text: "Short ETH with up to 4x Leverage",
                fontSize: "Z1"
            }
        }
    }
};


var $f6d27188afd1d14c$exports = {};

$parcel$export($f6d27188afd1d14c$exports, "UserWithButton", () => $f6d27188afd1d14c$export$d467f8a0cb59b203);


"use strict";
const $f6d27188afd1d14c$export$d467f8a0cb59b203 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        boxSize: "fit-content",
        theme: "dialog",
        border: "1px, solid, gray3",
        padding: "Y Z2 Y Y",
        alignItems: "center",
        gap: "B",
        round: "A"
    },
    User: {
        extend: (0, $7c01b64d6fe504fd$export$1f44aaf2ec115b54),
        props: {
            padding: "0"
        },
        Avatar: {
            Avatar: {
                props: {
                    fontSize: "Z2",
                    round: "Z1"
                }
            },
            StatusIndicator: null
        },
        Notes: {
            props: {
                gap: "X"
            },
            Title: {
                props: {
                    text: "Wallet ID"
                }
            },
            Paragraph: {
                props: {
                    text: "0xfb59...d862"
                }
            }
        }
    },
    SquareButton: {
        background: "transparent",
        theme: null,
        color: "currentColor",
        opacity: "0.5",
        transition: "A defaultBezier",
        transitionProperty: "opacity, background",
        padding: "0",
        Icon: {
            name: "copy",
            fontSize: "C"
        }
    }
};


"use strict";
$parcel$exportWildcard($bdfe1d5bd3b47067$exports, $7c01b64d6fe504fd$exports);
$parcel$exportWildcard($bdfe1d5bd3b47067$exports, $f1342b36a388e88f$exports);
$parcel$exportWildcard($bdfe1d5bd3b47067$exports, $b9343a89d12ca1bd$exports);
$parcel$exportWildcard($bdfe1d5bd3b47067$exports, $1ee0560b3704dbc9$exports);
$parcel$exportWildcard($bdfe1d5bd3b47067$exports, $a3d32edcf109e612$exports);
$parcel$exportWildcard($bdfe1d5bd3b47067$exports, $f6d27188afd1d14c$exports);


var $87ee317037997b79$exports = {};

$parcel$export($87ee317037997b79$exports, "Table", () => $87ee317037997b79$export$54ec01a60f47d33d);
"use strict";
const $87ee317037997b79$export$54ec01a60f47d33d = {};


var $98c6b405bb42d461$exports = {};
var $98eb44ecb3737867$exports = {};

$parcel$export($98eb44ecb3737867$exports, "Card", () => $98eb44ecb3737867$export$60332b2344f7fe41);

"use strict";
const $98eb44ecb3737867$export$60332b2344f7fe41 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        boxSize: "fit-content",
        padding: "Z2 A",
        gap: "Z1",
        round: "Z2",
        theme: "card"
    }
};


var $33039b825a2544f7$exports = {};

$parcel$export($33039b825a2544f7$exports, "BalanceCard", () => $33039b825a2544f7$export$d2076e5299ace0ec);



"use strict";
const $33039b825a2544f7$export$d2076e5299ace0ec = {
    extend: [
        (0, $98eb44ecb3737867$export$60332b2344f7fe41),
        (0, $32625a13d757d0d6$export$bd5b3f7ef3b94a4a)
    ],
    props: {
        theme: "card .secondary",
        gap: "Z2",
        padding: "A A"
    },
    Title: {
        props: {
            justifyContent: "space-between",
            gap: "E"
        },
        caption: {
            props: {
                text: "Total crypto assets",
                fontSize: "Z2",
                fontWeight: "500"
            }
        },
        arrowBtn: {
            extend: (0, $ca26469f43255c37$export$353f5b6fc5456de1),
            props: {
                padding: "0",
                theme: "transparent",
                fontSize: "D",
                color: "caption",
                margin: "-X -W2 - -",
                Icon: {
                    name: "arrowUpRight"
                }
            }
        }
    },
    Paragraph: {
        props: {
            flow: "column",
            align: "flex-start flex-start",
            gap: "A"
        },
        UnitValueWithLabel: {
            UnitValue: {},
            UnitValue2: {
                theme: "card .secondary .child"
            }
        },
        UnitValue: {
            flow: "row-reverse",
            color: "paragraph",
            fontWeight: "400",
            fontSize: "Z",
            gap: "Y",
            Value: {
                text: "an hour ago"
            },
            Unit: {
                text: "Last update:"
            }
        }
    }
};


var $74fcd0d805acd80b$exports = {};

$parcel$export($74fcd0d805acd80b$exports, "StepCard", () => $74fcd0d805acd80b$export$25f0557f767cf1c9);

"use strict";
const $74fcd0d805acd80b$export$25f0557f767cf1c9 = {
    props: {
        boxSize: "fit-content",
        padding: "F E2+A2 G E2+A2",
        position: "relative",
        overflow: "hidden",
        round: "A2",
        backgroundColor: "#FF3CAC",
        background: "linear-gradient(225deg, #FF3CAC 0%, #784BA0 50%, #2B86C5 100%)"
    },
    Icon: {
        extend: (0, $f8a17223267b0208$export$f04a61298a47a40f),
        props: {
            icon: "dribbble",
            boxSize: "E"
        }
    },
    LineStepsWithHgroup: {
        position: "absolute",
        left: "0",
        bottom: "0",
        width: "100%",
        round: "0",
        background: "black .2"
    }
};


var $3bbc74ee3952d628$exports = {};

$parcel$export($3bbc74ee3952d628$exports, "ConvertCard", () => $3bbc74ee3952d628$export$de7984f25c7cb2b1);


"use strict";
const $3bbc74ee3952d628$export$de7984f25c7cb2b1 = {
    extend: [
        (0, $98eb44ecb3737867$export$60332b2344f7fe41),
        (0, $32625a13d757d0d6$export$bd5b3f7ef3b94a4a)
    ],
    props: {
        minWidth: "G1_default",
        theme: "dialog",
        round: "Z2",
        padding: "A Z2+V Y1 Z2+V",
        gap: "A1"
    },
    Title: {
        props: {
            justifyContent: "space-between",
            fontWeight: "400",
            color: "caption"
        },
        caption: {
            props: {
                text: "From"
            }
        },
        UnitValueWithTitle: {}
    },
    Paragraph: {
        props: {
            align: "center space-between",
            margin: "0",
            padding: "0"
        },
        value: {
            props: {
                text: "0.00",
                fontSize: "C1"
            }
        },
        DropDownButtonWithAvatar: {
            theme: "tertiary",
            margin: "- -V"
        }
    }
};


var $386272c7763df5dc$exports = {};

$parcel$export($386272c7763df5dc$exports, "CurrencyConvert", () => $386272c7763df5dc$export$ad6bf4752205be04);


"use strict";
const $386272c7763df5dc$export$ad6bf4752205be04 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        boxSize: "fit-content",
        gap: "Z",
        padding: "Z A A A",
        flow: "column",
        theme: "dialog",
        round: "A1"
    },
    Title: {
        props: {
            text: "convert",
            textTransform: "capitalize",
            fontSize: "A2",
            padding: "- W",
            fontWeight: "500"
        }
    },
    Cards: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            flow: "column",
            gap: "A"
        },
        childExtend: {
            extend: (0, $3bbc74ee3952d628$export$de7984f25c7cb2b1),
            props: {
                theme: "tertiary",
                Paragraph: {
                    dropDownButton: {
                        theme: "field"
                    }
                }
            }
        },
        ...[
            {},
            {}
        ]
    },
    FlexButton: {
        minWidth: "100%",
        margin: "Z - - -",
        text: "convert",
        textTransform: "capitalize"
    }
};


"use strict";
$parcel$exportWildcard($98c6b405bb42d461$exports, $98eb44ecb3737867$exports);
$parcel$exportWildcard($98c6b405bb42d461$exports, $33039b825a2544f7$exports);
$parcel$exportWildcard($98c6b405bb42d461$exports, $74fcd0d805acd80b$exports);
$parcel$exportWildcard($98c6b405bb42d461$exports, $3bbc74ee3952d628$exports);
$parcel$exportWildcard($98c6b405bb42d461$exports, $386272c7763df5dc$exports);


"use strict";
$parcel$exportWildcard($be006f1a0fabd945$exports, $73d59c6c3fce378b$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $c95c6861d219ec8a$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $f8a17223267b0208$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $5d0d06667ca93e89$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $32625a13d757d0d6$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $f70d2005bd02a5dc$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $f887848157c82147$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $59e9b7f5a8955db9$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $eb21f9c2ced2890e$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $8a688fbb24f94be4$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $7f02b9e3018c9249$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $c038997f2687863c$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $408dff139db483ea$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $ca26469f43255c37$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $aad64e0c8b152d2b$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $781e0e9576e3e707$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $c658bc99cb4f11e8$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $7bd759d9ddd96987$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $d0fd1386e51a3c49$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $e39e4f558cd2a095$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $5789735af6bd85de$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $f935884925ad4fcf$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $d6afc2003bbecb7e$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $0845c3d41e8b035e$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $ffecead860a69fb6$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $b0b428f1a022b7ac$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $14b0ee601310f298$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $423902791a5aa103$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $bfe4bf8a850bff5d$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $d93ddbd64d83a6b9$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $954e4cb4adbc0299$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $9f1f1f2471e307cd$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $6e069cc18a82edfb$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $bdfe1d5bd3b47067$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $87ee317037997b79$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $98c6b405bb42d461$exports);


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $2a60ce89a661a6b2$exports = {};

$parcel$export($2a60ce89a661a6b2$exports, "scratchUtils", () => $75f36cb383311abc$exports);
$parcel$export($2a60ce89a661a6b2$exports, "scratchSystem", () => $30c1eb8bbbe7b5d7$exports);
$parcel$export($2a60ce89a661a6b2$exports, "set", () => $baa590feaf6cb6da$export$adaa4cf7ef1b65be);
$parcel$export($2a60ce89a661a6b2$exports, "init", () => $31242768b5023c84$export$2cd8252107eb640b);
$parcel$export($2a60ce89a661a6b2$exports, "reInit", () => $31242768b5023c84$export$4f395a2c8fcf6959);
$parcel$export($2a60ce89a661a6b2$exports, "applyCSS", () => $31242768b5023c84$export$3a26aa64e59aeaff);


var $cBUNY = parcelRequire("cBUNY");




"use strict";
$parcel$exportWildcard($2a60ce89a661a6b2$exports, $cBUNY);
$parcel$exportWildcard($2a60ce89a661a6b2$exports, $8319f99b46b296c9$exports);
$parcel$exportWildcard($2a60ce89a661a6b2$exports, $06908963bda72849$exports);
$parcel$exportWildcard($2a60ce89a661a6b2$exports, $90351548418b68d1$exports);



parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $jvD5p = parcelRequire("jvD5p");

"use strict";
const $4747ce2ab72764ea$var$DEFAULT_ROUTING_OPTIONS = {
    initRouter: true,
    injectRouterInLinkComponent: true,
    popState: true
};
const $4747ce2ab72764ea$export$cf7ee87ede64229c = (element, options)=>{
    if (options.router === false) return;
    else if (options.router === true) options.router = $4747ce2ab72764ea$var$DEFAULT_ROUTING_OPTIONS;
    else (0, $8wu6n.merge)(options.router || {}, $4747ce2ab72764ea$var$DEFAULT_ROUTING_OPTIONS);
    const routerOptions = options.router;
    const router = options.snippets && options.snippets.router ? options.snippets.router : (0, $90351548418b68d1$export$5375cda95f0b0eb4);
    const onRouterRenderDefault = (el, s)=>{
        const { pathname: pathname, hash: hash } = (0, $jvD5p.window).location;
        const url = pathname + hash;
        if (el.routes) router(url, el, {}, {
            initialRender: true
        });
    };
    const hasRenderRouter = element.on && !(0, $EqHTq.isUndefined)(element.on.renderRouter);
    if (routerOptions && routerOptions.initRouter && !hasRenderRouter) {
        if (element.on) element.on.renderRouter = onRouterRenderDefault;
        else element.on = {
            renderRouter: onRouterRenderDefault
        };
    }
    $4747ce2ab72764ea$export$54b760094ac80b64(routerOptions);
    return routerOptions;
};
let $4747ce2ab72764ea$var$popStateFired;
const $4747ce2ab72764ea$export$423945072aa2156 = (element, options)=>{
    if ($4747ce2ab72764ea$var$popStateFired) return;
    $4747ce2ab72764ea$var$popStateFired = true;
    const routerOptions = options.router || $4747ce2ab72764ea$var$DEFAULT_ROUTING_OPTIONS;
    if (!routerOptions.popState) return;
    const router = options.snippets && options.snippets.router ? options.snippets.router : (0, $90351548418b68d1$export$5375cda95f0b0eb4);
    (0, $jvD5p.window).onpopstate = (e)=>{
        const { pathname: pathname, hash: hash } = (0, $jvD5p.window).location;
        const url = pathname + hash;
        router(url, element, {}, {
            pushState: false,
            scrollToTop: false,
            level: 0
        });
    };
};
const $4747ce2ab72764ea$export$54b760094ac80b64 = (routerOptions)=>{
    if (routerOptions && routerOptions.injectRouterInLinkComponent) return (0, $8wu6n.deepMerge)((0, $59e9b7f5a8955db9$export$a6c7ac8248d6e38a), (0, $59e9b7f5a8955db9$export$fce709ebdac448ed));
};


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

var $cBUNY = parcelRequire("cBUNY");

var $aOJ2H = parcelRequire("aOJ2H");
"use strict";
const { overwriteDeep: $b7a07a87e1dff17d$var$overwriteDeep, deepDestringify: $b7a07a87e1dff17d$var$deepDestringify } = $cBUNY;
const { window: $b7a07a87e1dff17d$var$window } = $aOJ2H;
const $b7a07a87e1dff17d$var$IS_DEVELOPMENT = $b7a07a87e1dff17d$var$window && $b7a07a87e1dff17d$var$window.location ? $b7a07a87e1dff17d$var$window.location.host.includes("dev.") || $b7a07a87e1dff17d$var$window.location.host.includes("symbo.ls") : false;
const $b7a07a87e1dff17d$var$SERVER_URL = $b7a07a87e1dff17d$var$IS_DEVELOPMENT ? "http://localhost:13335/" : "https://api.symbols.app/";
const $b7a07a87e1dff17d$var$defaultOptions = {
    endpoint: $b7a07a87e1dff17d$var$SERVER_URL
};
const $b7a07a87e1dff17d$export$e7aa7bc5c1b3cfb3 = globalThis.fetch;
const $b7a07a87e1dff17d$export$db36d2f1649120da = async (key, options = $b7a07a87e1dff17d$var$defaultOptions)=>{
    const baseUrl = options.endpoint || $b7a07a87e1dff17d$var$SERVER_URL;
    const route = options.serviceRoute ? $cBUNY.isArray(options.serviceRoute) ? options.serviceRoute.map((v)=>v.toLowerCase()).join(",") : options.serviceRoute : "";
    let response;
    try {
        response = await $b7a07a87e1dff17d$export$e7aa7bc5c1b3cfb3(baseUrl + route, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-AppKey": key
            }
        });
        return await response.json();
    } catch (e) {
        if ($cBUNY.isFunction(options.onError)) return options.onError(e);
        else console.error(e);
    }
};
const $b7a07a87e1dff17d$export$525bc467aeb111d5 = async (key, options)=>{
    const { editor: editor } = options;
    if (editor && editor.remote) {
        const data = await $b7a07a87e1dff17d$export$db36d2f1649120da(key, editor);
        const evalData = $b7a07a87e1dff17d$var$IS_DEVELOPMENT ? $b7a07a87e1dff17d$var$deepDestringify(data) : $b7a07a87e1dff17d$var$deepDestringify(data.releases[0]);
        if (editor.serviceRoute) {
            console.log(editor.serviceRoute);
            console.log(evalData);
            console.log(options);
            if ($cBUNY.isArray(editor.serviceRoute)) editor.serviceRoute.forEach((route)=>{
                $b7a07a87e1dff17d$var$overwriteDeep(options[route], evalData[route.toLowerCase()]);
            });
            else $b7a07a87e1dff17d$var$overwriteDeep(options[editor.serviceRoute], evalData);
        } else [
            "state",
            "designSystem",
            "components",
            "snippets",
            "pages"
        ].forEach((key)=>{
            $b7a07a87e1dff17d$var$overwriteDeep(options[key], evalData[key.toLowerCase()]);
        });
    }
    return options;
};
const $b7a07a87e1dff17d$export$571411efd7718583 = async (key, options, callback)=>{
    const { editor: editor } = options;
    if (editor && editor.remote) {
        const data = await $b7a07a87e1dff17d$export$db36d2f1649120da(key, editor);
        const evalData = $b7a07a87e1dff17d$var$IS_DEVELOPMENT ? $b7a07a87e1dff17d$var$deepDestringify(data) : $b7a07a87e1dff17d$var$deepDestringify(data.releases[0]);
        callback(evalData);
    }
};


"use strict";
const $5e586daec44b56de$export$8946d631417d8ced = async (key, options)=>{
    if (key && options.editor) try {
        if (!options.editor.async) await (0, $b7a07a87e1dff17d$export$525bc467aeb111d5)(key, options);
    } catch (e) {
        console.error(e);
    }
};
const $5e586daec44b56de$export$beca342e15b450be = (app, key, options, callback)=>{
    if (key && options.editor) try {
        const defaultCallback = (data)=>{
            if ((0, $EqHTq.isObject)(data.designsystem)) options.utils.init(data.designsystem);
            if ((0, $EqHTq.isObject)(data.state)) app.state.set(data.state);
        };
        if (options.editor.async) (0, $b7a07a87e1dff17d$export$571411efd7718583)(key, options, callback || defaultCallback);
    } catch (e) {
        console.error(e);
    }
};






var $cVSYW = parcelRequire("cVSYW");


var $aOJ2H = parcelRequire("aOJ2H");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");

parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

var $cVSYW = parcelRequire("cVSYW");
"use strict";
const $7b205a167d538434$export$bf8485336ba6654d = {
    props: {
        ".preventSelect": {
            userSelect: "none"
        }
    },
    focus: {
        state: {},
        props: (el, s)=>({
                position: "fixed",
                hide: !s.area || !s.parent.debugging
            }),
        class: {
            inset: (el, state)=>{
                const { area: area } = state;
                if (!area) return;
                const { x: x, y: y, width: width, height: height } = area;
                return {
                    top: y - 6 + "px",
                    left: x - 6 + "px",
                    width: width + 12 + "px",
                    height: height + 12 + "px"
                };
            }
        },
        style: {
            boxShadow: "0 0 10px #3686F733, 0 0 0 3px #3686F766, 0 0 100vmax 100vmax #000A",
            zIndex: "9999999",
            borderRadius: "10px",
            pointerEvents: "none"
        },
        span: {
            props: {
                position: "absolute",
                margin: "A2 0",
                fontSize: "Z",
                color: "text",
                // color: 'blue',
                zIndex: "99999999",
                textDecoration: "underline",
                fontWeight: "500",
                top: "100%"
            },
            style: {
                boxShadow: "0 25px 10px 35px black",
                textShadow: "0 0 10px black"
            },
            text: (el, s)=>s.focusKey
        },
        on: {
            init: ({ context: context })=>{
                const { components: components } = context;
                if ((0, $EqHTq.isObject)(components)) {
                    const { Content: Content, ...rest } = components;
                    for(const key in rest){
                        if ($be006f1a0fabd945$exports[key]) continue;
                        if (!rest[key].__ref) rest[key].__ref = {};
                        if (!rest[key].__ref.__componentKey) rest[key].__ref.__componentKey = key;
                    }
                }
            }
        }
    },
    on: {
        mousemove: (ev, e, state)=>{
            const el = ev.target.ref;
            const component = $7b205a167d538434$var$findComponent(el);
            if (!component || !state.debugging || !component.__ref) return;
            const focusState = e.focus.state;
            const updateValue = (area)=>{
                focusState.update({
                    area: area,
                    focusKey: component.__ref.__componentKey
                });
            };
            const update = ()=>{
                if (ev.altKey && ev.shiftKey) {
                    const { x: x, y: y, width: width, height: height } = component.node.getBoundingClientRect();
                    const area = {
                        x: x,
                        y: y,
                        width: width,
                        height: height
                    };
                    if (!focusState.area) return updateValue(area);
                    if (focusState.area.x !== area.x) updateValue(area);
                } else if (focusState.area) focusState.update({
                    area: false
                });
            };
            window.requestAnimationFrame(()=>{
                update();
                window.requestAnimationFrame(update);
            });
        },
        click: (ev, elem, state)=>{
            const el = ev.target.ref;
            const component = $7b205a167d538434$var$findComponent(el);
            if (!component || !component.__ref.__componentKey || !state.debugging) return;
            (0, $cVSYW.send)("route", `/export/${component.__ref.__componentKey}`);
            return false;
        }
    }
};
function $7b205a167d538434$var$findComponent(el) {
    if (!el || !el.__ref) return;
    if (el.__ref.__componentKey) return el;
    return $7b205a167d538434$var$findComponent(el.parent);
}
const $7b205a167d538434$export$db4eced57a06882d = (app)=>{
    window.onkeydown = (ev)=>{
        if (ev.altKey && ev.shiftKey) app.state.update({
            debugging: true,
            preventSelect: true
        }, {
            preventContentUpdate: true,
            preventRecursive: true
        });
    };
    window.onkeyup = (ev)=>{
        if ((!ev.altKey || !ev.shiftKey) && app.state.debugging) {
            app.focus.state.update({
                area: false
            });
            app.state.update({
                debugging: false,
                preventSelect: false
            }, {
                preventContentUpdate: true,
                preventRecursive: true,
                preventPropsUpdate: true
            });
        }
    };
};


"use strict";
const $18c650c6b9aa2424$var$isLocalhost = (0, $aOJ2H.window) && (0, $aOJ2H.window).location && (0, $aOJ2H.window).location.host.includes("local");
const $18c650c6b9aa2424$var$ANIMATION = {
    fadeInUp: {
        from: {
            transform: "translate3d(0, 12.5%, 1px)",
            opacity: 0
        },
        to: {
            transform: "translate3d(0, 0, 1px)",
            opacity: 1
        }
    },
    fadeOutDown: {
        from: {
            transform: "translate3d(0, 0, 1px)",
            opacity: 1
        },
        to: {
            transform: "translate3d(0, 12.5%, 1px)",
            opacity: 0
        }
    }
};
const $18c650c6b9aa2424$var$COLOR = {
    black: "#000000",
    blue: "#3686F7"
};
// set({
//   COLOR,
//   ANIMATION
// })
const $18c650c6b9aa2424$var$connectedToSymbols = (clients, element, state)=>{
    if (clients.symbols) {
        if (!state.connected) {
            state.notifications.connected = {
                title: "Connected",
                message: "to the Symbols live server"
            };
            state.update({
                connected: true
            });
            const t = setTimeout(()=>{
                delete state.notifications.connected;
                element.notifications.content.connected.setProps({
                    animation: "fadeOutDown"
                });
                state.update({
                    connected: true
                });
                clearTimeout(t);
            }, 3000);
        }
    } else if (state.connected) {
        state.notifications.connected = {
            title: "Disconnected",
            message: "from the Symbols live server",
            type: "error"
        };
        state.update({
            connected: false
        });
        const t = setTimeout(()=>{
            delete state.notifications.connected;
            element.notifications.content.connected.setProps({
                animation: "fadeOutDown"
            });
            state.update({
                connected: true
            });
            clearTimeout(t);
        }, 3000);
    }
};
const $18c650c6b9aa2424$var$onConnect = (element, state)=>{
    return (socketId, socket)=>{
    // send('components', { COMPONENTS: a(COMPONENTS) })
    };
};
const $18c650c6b9aa2424$var$onDisconnect = (element, state)=>{
    return ()=>{};
};
const $18c650c6b9aa2424$var$onChange = (el, s, ctx)=>{
    return (event, data)=>{
        if (event === "change") {
            const obj = JSON.parse(data);
            const { state: state, designSystem: designSystem, pages: pages, components: components, snippets: snippets } = obj.DATA;
            const { utils: utils } = ctx;
            if (pages) // overwriteShallow(ctx.pages, pages)
            (0, $8wu6n.overwriteDeep)(ctx.pages, pages);
            if (components) (0, $8wu6n.overwriteDeep)(ctx.components, components);
            if (snippets) (0, $8wu6n.overwriteDeep)(ctx.snippets, snippets);
            if (state) {
                const route = state.route;
                if (route) (utils.router || (0, $90351548418b68d1$export$5375cda95f0b0eb4))(route.replace("/state", "") || "/", el, {});
                else if (!(snippets && components && pages)) s.update(state);
            }
            if (snippets || components || pages) {
                console.log(pages);
                console.log((0, $aOJ2H.window).location.pathname);
                (utils.router || (0, $90351548418b68d1$export$5375cda95f0b0eb4))((0, $aOJ2H.window).location.pathname, el, {});
            }
            if (designSystem) (0, $31242768b5023c84$export$2cd8252107eb640b)(designSystem);
        }
        if (event === "clients") $18c650c6b9aa2424$var$connectedToSymbols(data, el, s);
    };
};
const $18c650c6b9aa2424$var$NOTIF_COLORS = {
    success: "green",
    error: "red",
    warning: "yellow"
};
const $18c650c6b9aa2424$var$Notifications = {
    props: {
        position: "fixed",
        left: "A2",
        bottom: "Z2",
        zIndex: "999"
    },
    childExtend: {
        extend: [
            (0, $e39e4f558cd2a095$export$14834abbfce3b8cd)
        ],
        props: ({ state: state })=>({
                animation: "fadeInUp",
                animationDuration: "C",
                background: $18c650c6b9aa2424$var$NOTIF_COLORS[state.type || "success"],
                icon: null,
                article: {
                    Flex: {
                        Title: {
                            text: state.title
                        },
                        P: {
                            text: state.message
                        }
                    }
                }
            }),
        on: {
            click: (e, el)=>el.setProps({
                    animation: "fadeOutDown"
                })
        }
    },
    $stateCollection: ({ state: state })=>state.notifications
};
const $18c650c6b9aa2424$export$2ae15352e0a80063 = {
    notifications: $18c650c6b9aa2424$var$Notifications,
    state: {
        notifications: {}
    },
    on: {
        render: (el, s, ctx)=>{
            (0, $cVSYW.connect)(ctx.key, {
                source: $18c650c6b9aa2424$var$isLocalhost ? "localhost" : "client",
                socketUrl: $18c650c6b9aa2424$var$isLocalhost ? "localhost:13336" : "socket.symbols.app",
                location: (0, $aOJ2H.window).location.host,
                onConnect: $18c650c6b9aa2424$var$onConnect(el, s, ctx),
                onDisconnect: $18c650c6b9aa2424$var$onDisconnect(el, s, ctx),
                onChange: $18c650c6b9aa2424$var$onChange(el, s, ctx)
            });
        }
    }
};


parcelRequire("cBUNY");
var $jOLBF = parcelRequire("jOLBF");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $5b6a3972014f3e94$export$ca717cfcb724fd64 = (extend, options)=>{
    const { editor: editor } = options;
    if (!editor) return extend;
    const inspect = (0, $EqHTq.isUndefined)(editor.inspect) ? (0, $jOLBF.isDevelopment)() : editor.inspect;
    if (inspect) extend.push((0, $7b205a167d538434$export$bf8485336ba6654d));
    const liveSync = (0, $EqHTq.isUndefined)(editor.liveSync) ? (0, $jOLBF.isDevelopment)() : editor.liveSync;
    if (liveSync) extend.push((0, $18c650c6b9aa2424$export$2ae15352e0a80063));
    return extend;
};
const $5b6a3972014f3e94$export$a0eecf521ca4df6c = (root, options)=>{
    const { editor: editor } = options;
    if (!editor) return;
    const inspect = (0, $EqHTq.isUndefined)(editor.inspect) ? (0, $jOLBF.isDevelopment)() : editor.inspect;
    if (inspect) (0, $7b205a167d538434$export$db4eced57a06882d)(root);
};



"use strict";
const $596256ead72518a6$export$6588fc50c67b09a2 = {
    routes: (param)=>param,
    // deps: (param, el) => param || el.parent.deps,
    $router: (param, el)=>{
        if (!param) return;
        const obj = {
            tag: "fragment",
            ...param
        };
        const set = ()=>{
            el.set(obj, {
                preventDefineUpdate: "$router"
            });
        };
        if (el.props && el.props.lazyLoad) window.requestAnimationFrame(set);
        else set();
        return obj;
    },
    $collection: (0, $c17872c3358c86eb$export$fb8073518f34e6ec).define.$collection,
    $setCollection: (0, $c17872c3358c86eb$export$fb8073518f34e6ec).define.$setCollection,
    $stateCollection: (0, $c17872c3358c86eb$export$fb8073518f34e6ec).define.$stateCollection,
    $propsCollection: (0, $c17872c3358c86eb$export$fb8073518f34e6ec).define.$propsCollection
};


"use strict";
const $d5fc17b4ecb94b3e$export$882cd4124a942c79 = {
    useReset: true,
    useVariable: true,
    useIconSprite: true,
    useSvgSprite: true,
    useDocumentTheme: true,
    useFontImport: true,
    useDefaultConfig: true
};
const $d5fc17b4ecb94b3e$export$7f202753e6a32b2b = {
    defaultConfig: true,
    state: {},
    pages: {},
    components: {},
    router: {
        initRouter: true,
        popState: true,
        injectRouterInLinkComponent: true
    },
    define: (0, $596256ead72518a6$export$6588fc50c67b09a2)
};
var $d5fc17b4ecb94b3e$export$2e2bcd8739ae039 = $d5fc17b4ecb94b3e$export$7f202753e6a32b2b;



parcelRequire("cBUNY");
var $jvD5p = parcelRequire("jvD5p");

"use strict";
const $80563b8eaf6ba844$export$fbea82a1c0574ef4 = {
    key: ":root",
    node: (0, $jvD5p.document) ? (0, $jvD5p.document).body : (0, $06908963bda72849$export$f18d5b0af29128b7)("DocumentNotDefined", (0, $jvD5p.document))
};
const $80563b8eaf6ba844$export$33ecaa422889cd80 = $80563b8eaf6ba844$export$fbea82a1c0574ef4;


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $8af08dc9e7559b54$export$270e7ba5936d3c48 = (element)=>{};




parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $glQML = parcelRequire("glQML");
"use strict";
const $01ef634a92434650$var$cache = {};
const $01ef634a92434650$export$39fdcd81e0c5d80b = (element)=>{
    const { tag: tag } = element;
    if (tag) {
        if (tag === "string") return document.createTextNode(element.text);
        else if (tag === "fragment") return document.createDocumentFragment();
        else if (tag === "svg" || tag === "path") return document.createElementNS("http://www.w3.org/2000/svg", tag);
        else return document.createElement(tag) // TODO: allow strict mode to check validity
        ;
    } else return document.createElement("div");
};
const $01ef634a92434650$export$5075bd4eae016d2c = (element)=>{
    let { tag: tag, key: key, props: props } = element;
    tag = (0, $8wu6n.exec)(tag, element);
    if (tag === true) tag = key;
    if ((0, $EqHTq.isObject)(props) && (0, $EqHTq.isString)(props.tag)) {
        const tagExists = (0, $glQML.isValidHtmlTag)(props.tag);
        if (tagExists) return props.tag;
    }
    if ((0, $EqHTq.isString)(tag)) {
        const tagExists = (0, $glQML.isValidHtmlTag)(tag);
        if (tagExists) return tag;
    } else {
        const isKeyATag = (0, $glQML.isValidHtmlTag)(key);
        if (isKeyATag) return key;
    }
    return "div";
};
const $01ef634a92434650$export$257247f9c0329159 = (element)=>{
    const tag = element.tag = $01ef634a92434650$export$5075bd4eae016d2c(element);
    if (!(0, $a7c2803c7e7b293f$export$5d42fc0d80b5349f)(element)) return (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidTag", element.tag, element);
    let cachedTag = $01ef634a92434650$var$cache[tag];
    if (!cachedTag) cachedTag = $01ef634a92434650$var$cache[tag] = $01ef634a92434650$export$39fdcd81e0c5d80b(element);
    const clonedNode = cachedTag.cloneNode(true);
    if (tag === "string") clonedNode.nodeValue = element.text;
    return clonedNode;
};


"use strict";
const $98807bf18bc93fb3$export$13970129ca912f06 = (node, parentNode)=>{
    parentNode.appendChild(node);
    return node;
};
const $98807bf18bc93fb3$export$9c63b8d16fa708c5 = (node, siblingNode, parentNode)=>{
    const parent = parentNode || siblingNode.parentNode;
    if (siblingNode.nextSibling) parent && parent.insertBefore(node, siblingNode.nextSibling);
    else siblingNode && siblingNode.insertAdjacentElement("afterend", node);
};
const $98807bf18bc93fb3$export$3a727f1d0007fe49 = (node, siblingNode, parentNode)=>{
    const parent = parentNode || siblingNode.parentNode;
    parent && parent.insertBefore(node, siblingNode);
};
const $98807bf18bc93fb3$export$4f2a718cb234b42f = (element, parent, key, attachOptions)=>{
    parent[key || element.key] = element;
    if (element.tag !== "shadow") {
        if (attachOptions && attachOptions.position) (attachOptions.position === "before" ? $98807bf18bc93fb3$export$3a727f1d0007fe49 : $98807bf18bc93fb3$export$9c63b8d16fa708c5)(element.node, attachOptions.node || parent.node);
        else $98807bf18bc93fb3$export$13970129ca912f06(element.node, parent.node);
    }
    return element;
};


"use strict";


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $jOLBF = parcelRequire("jOLBF");

parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
var /**
 * Recursively add attributes to a DOM node
 */ $781ba30c522cf3e7$export$2e2bcd8739ae039 = (params, element, node)=>{
    const { __ref: __ref } = element;
    const { __attr: __attr } = __ref;
    if ((0, $EqHTq.isNot)("object")) (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidAttr", params);
    if (params) for(const attr in params){
        const val = (0, $8wu6n.exec)(params[attr], element);
        // if (__attr[attr] === val) return
        if (val && node.setAttribute) node.setAttribute(attr, val);
        else if (node.removeAttribute) node.removeAttribute(attr);
        __attr[attr] = val;
    }
    console.groupEnd(params, __attr);
};


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $6a43953e96d89b45$export$d559e9a3b71405f6 = (element)=>{
    const { key: key } = element;
    if (element.class === true) element.class = key;
    else if (!element.class && typeof key === "string" && key.charAt(0) === "_" && key.charAt(1) !== "_") element.class = key.slice(1);
};
const $6a43953e96d89b45$export$b04d9b8d414ba5e8 = (obj, element)=>{
    let className = "";
    for(const item in obj){
        const param = obj[item];
        if (typeof param === "boolean" && param) className += ` ${item}`;
        else if (typeof param === "string") className += ` ${param}`;
        else if (typeof param === "function") className += ` ${(0, $8wu6n.exec)(param, element)}`;
    }
    return className;
};
const $6a43953e96d89b45$export$11c615ce16f87241 = (params, element)=>{
    if (!params) return;
    const { key: key } = element;
    if (params === true) params = element.class = {
        key: key
    };
    if ((0, $EqHTq.isString)(params)) params = element.class = {
        default: params
    };
    if ((0, $EqHTq.isObject)(params)) params = $6a43953e96d89b45$export$b04d9b8d414ba5e8(params, element);
    // TODO: fails on string
    const className = params.replace(/\s+/g, " ").trim();
    if (element.ref) element.ref.class = className // TODO: this check is NOT needed in new DOMQL
    ;
    return className;
};
const $6a43953e96d89b45$export$e8f750c9f10c0a7b = (params, element, node)=>{
    const className = $6a43953e96d89b45$export$11c615ce16f87241(params, element);
    node.classList = className;
    return className;
};
var $6a43953e96d89b45$export$2e2bcd8739ae039 = (params, element, node)=>{
    $6a43953e96d89b45$export$e8f750c9f10c0a7b(params, element, node);
};


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");

"use strict";
var $ad3d3b247d47f3a2$export$2e2bcd8739ae039 = {};




"use strict";
const $bf937aebc888d68f$var$set = function(params, options = {}, el) {
    const element = el || this;
    const { __ref: ref, content: content } = element;
    const __contentRef = content && content.__ref;
    const lazyLoad = element.props && element.props.lazyLoad;
    if (options.preventContentUpdate === true) return;
    if (ref.__noCollectionDifference || __contentRef && __contentRef.__cached && (0, $8wu6n.deepContains)(params, content)) return content.update();
    const setAsync = ()=>{
        (0, $0a7669919424e35c$export$6e1d9b0d0e1e1def)(element);
        (0, $947d5c063e68e91c$export$2e2bcd8739ae039)(params, element, options.newElementKey || "content", {
            ignoreChildExtend: true,
            ...(0, $782cf63e523d0885$export$2e2bcd8739ae039).defaultOptions,
            ...(0, $ad3d3b247d47f3a2$export$2e2bcd8739ae039).create,
            ...options
        });
    };
    if (params) {
        const { childExtend: childExtend } = params;
        if (!childExtend && element.childExtend) params.childExtend = element.childExtend;
        if (lazyLoad) window.requestAnimationFrame(setAsync);
        else setAsync();
    }
    return element;
};
var $bf937aebc888d68f$export$2e2bcd8739ae039 = $bf937aebc888d68f$var$set;


"use strict";
const $0a7669919424e35c$export$5143cc956eb9d8f6 = function(params, options) {
    const element = this;
    if (!element.content) return;
    if (element.content.update) element.content.update(params, options);
};
const $0a7669919424e35c$export$6e1d9b0d0e1e1def = function(el) {
    const element = el || this;
    const { __ref: __ref } = element;
    if (element.content) {
        if (element.content.node) {
            if (element.content.tag === "fragment") element.node.innerHTML = "";
            else element.node.removeChild(element.content.node);
        }
        const { __cached: __cached } = __ref;
        if (__cached && __cached.content) {
            if (__cached.content.tag === "fragment") __cached.content.parent.node.innerHTML = "";
            else if (__cached.content && (0, $EqHTq.isFunction)(__cached.content.remove)) __cached.content.remove();
        }
        delete element.content;
    }
};
const $0a7669919424e35c$export$431313f2afd011e2 = (param, element, node, options)=>{
    if (param && element) {
        if (element.content.update) element.content.update({}, options);
        else (0, $bf937aebc888d68f$export$2e2bcd8739ae039).call(element, param, options);
    }
};
var $0a7669919424e35c$export$2e2bcd8739ae039 = $0a7669919424e35c$export$431313f2afd011e2;


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
var /**
 * Apply data parameters on the DOM nodes
 * this should only work if `showOnNode: true` is passed
 */ $e4aeb17327021212$export$2e2bcd8739ae039 = (params, element, node)=>{
    if (params && params.showOnNode) {
        if (!(0, $EqHTq.isObject)(params)) (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidData", params);
        // Apply data params on node
        for(const dataset in params)if (dataset !== "showOnNode") node.dataset[dataset] = (0, $8wu6n.exec)(params[dataset], element);
    }
};


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
"use strict";
var /**
 * Appends raw HTML as content
 * an original one as a child
 */ $1591488d379f80a7$export$2e2bcd8739ae039 = (param, element, node)=>{
    const prop = (0, $8wu6n.exec)(param, element);
    const { __ref: __ref } = element;
    if (prop !== __ref.__html) {
        // const parser = new window.DOMParser()
        // param = parser.parseFromString(param, 'text/html')
        if (node.nodeName === "SVG") node.textContent = prop;
        else node.innerHTML = prop;
        __ref.__html = prop;
    }
};


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $8wu6n = parcelRequire("8wu6n");

"use strict";
var /**
 * Recursively add styles to a DOM node
 */ $479abf9e8c0e6739$export$2e2bcd8739ae039 = (params, element, node)=>{
    if (params) {
        if ((0, $EqHTq.isObject)(params)) (0, $8wu6n.map)(node.style, params, element);
        else (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidStyles", params);
    }
};



parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $5WrxC = parcelRequire("5WrxC");
"use strict";
var /**
 * Creates a text node and appends into
 * an original one as a child
 */ $19f4b3c5f241581d$export$2e2bcd8739ae039 = (param, element, node)=>{
    let prop = (0, $8wu6n.exec)(param, element);
    if ((0, $EqHTq.isString)(prop) && prop.includes("{{")) prop = (0, $5WrxC.replaceLiteralsWithObjectFields)(prop, element.state);
    if (element.tag === "string") node.nodeValue = prop;
    else if (param !== undefined || param !== null) {
        if (element.__text) {
            if (element.__text.text === prop) return;
            element.__text.text = prop;
            if (element.__text.node) element.__text.node.nodeValue = prop;
        } else (0, $947d5c063e68e91c$export$2e2bcd8739ae039)({
            tag: "string",
            text: prop
        }, element, "__text");
    }
};



parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $4a610b4ab9f6f506$export$ca000e230c0caa3e = (params, element, node)=>{
    const state = (0, $8wu6n.exec)(params, element);
    if ((0, $EqHTq.isObject)(state)) for(const param in state){
        if ((0, $bfb47641e396194b$export$5100524046ce8de6).includes(param)) continue;
        if (!Object.hasOwnProperty.call(state, param)) continue;
    // element.state[param] = exec(state[param], element)
    }
    return element;
};
var $4a610b4ab9f6f506$export$2e2bcd8739ae039 = $4a610b4ab9f6f506$export$ca000e230c0caa3e;


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
var /**
 * Apply data parameters on the DOM nodes
 * this should only work if `showOnNode: true` is passed
 */ $d1bc0a58271a837c$export$2e2bcd8739ae039 = (params, element, node)=>{
    if (!(0, $EqHTq.isObject)(params)) return;
    // Apply data params on node
    for(const scopeItem in params){
        const value = params[scopeItem];
        if ((0, $EqHTq.isFunction)(value)) element.scope[scopeItem] = value.bind(element);
        else element.scope[scopeItem] = value;
    }
};



"use strict";
var $782cf63e523d0885$export$2e2bcd8739ae039 = {
    attr: $781ba30c522cf3e7$export$2e2bcd8739ae039,
    style: $479abf9e8c0e6739$export$2e2bcd8739ae039,
    text: $19f4b3c5f241581d$export$2e2bcd8739ae039,
    html: $1591488d379f80a7$export$2e2bcd8739ae039,
    content: $0a7669919424e35c$export$2e2bcd8739ae039,
    data: $e4aeb17327021212$export$2e2bcd8739ae039,
    class: (0, $6a43953e96d89b45$export$2e2bcd8739ae039),
    state: $4a610b4ab9f6f506$export$2e2bcd8739ae039,
    scope: $d1bc0a58271a837c$export$2e2bcd8739ae039,
    deps: (param, el)=>param || el.parent.deps,
    extend: {},
    childExtend: {},
    childExtendRecursive: {},
    props: {},
    path: {},
    if: {},
    define: {},
    transform: {},
    __name: {},
    __ref: {},
    __hash: {},
    __text: {},
    nextElement: {},
    previousElement: {},
    key: {},
    tag: {},
    query: {},
    parent: {},
    node: {},
    set: {},
    update: {},
    setProps: {},
    remove: {},
    updateContent: {},
    removeContent: {},
    lookup: {},
    spotByPath: {},
    keys: {},
    log: {},
    parse: {},
    parseDeep: {},
    on: {},
    component: {},
    context: {},
    $setStateCollection: {},
    $setCollection: {},
    $setPropsCollection: {}
};
const $782cf63e523d0885$export$2f387f690230eab4 = {
    elementKeys: [
        "tag",
        "text",
        "style",
        "attr",
        "class",
        "state",
        "props",
        "data",
        "content",
        "html",
        "on",
        "key"
    ],
    propsKeys: [
        "__element",
        "update"
    ],
    stateKeys: []
};


"use strict";


"use strict";
const $d61abc47c39ce5ac$export$cec27f102c074405 = function(path) {
    const element = this;
    const arr = [].concat(path);
    let active = (0, $80563b8eaf6ba844$export$33ecaa422889cd80)[arr[0]];
    if (!arr || !arr.length) return console.log(arr, "on", element.key, "is undefined");
    while(active.key === arr[0]){
        arr.shift();
        if (!arr.length) break;
        active = active[arr[0]];
        if (!active) return;
    }
    return active;
};
const $d61abc47c39ce5ac$export$dfc7155ac0343b8 = function(key) {
    const element = this;
    let { parent: parent } = element;
    while(parent.key !== key){
        if (parent[key]) return parent[key];
        parent = parent.parent;
        if (!parent) return;
    }
    return parent;
};
const $d61abc47c39ce5ac$export$cd7f480d6b8286c3 = function(params) {
    const element = this;
    if ((0, $EqHTq.isFunction)(element.node.remove)) element.node.remove();
    else if (!(0, $jOLBF.isProduction)()) {
        console.warn("This item cant be removed");
        element.log();
    }
    delete element.parent[element.key];
};
const $d61abc47c39ce5ac$export$3988ae62b71be9a3 = function(param) {
    const element = this;
    return element[param];
};
const $d61abc47c39ce5ac$export$938ca3893886de06 = function(param, options) {
    const element = this;
    if (!param || !element.props) return;
    element.update({
        props: param
    }, options);
    return element;
};
const $d61abc47c39ce5ac$export$a98d858bb785d7b9 = (element, key, get, set)=>Object.defineProperty(element, key, {
        get: get,
        set: set
    });
const $d61abc47c39ce5ac$export$ed97f33186d4b816 = function() {
    const element = this;
    const keys = [];
    for(const param in element){
        if ((0, $782cf63e523d0885$export$2e2bcd8739ae039)[param] && !(0, $782cf63e523d0885$export$2f387f690230eab4).elementKeys.includes(param)) continue;
        keys.push(param);
    }
    return keys;
};
const $d61abc47c39ce5ac$export$98e6a39c04603d36 = function(excl = []) {
    const element = this;
    const obj = {};
    const keyList = $d61abc47c39ce5ac$export$ed97f33186d4b816.call(element);
    keyList.forEach((v)=>{
        if (excl.includes(v)) return;
        let val = element[v];
        if (v === "state") {
            if (element.__ref && element.__ref.__hasRootState) return;
            if ((0, $EqHTq.isFunction)(val && val.parse)) val = val.parse();
        } else if (v === "props") {
            const { __element: __element, update: update, ...props } = element[v];
            obj[v] = props;
        } else if ((0, $EqHTq.isDefined)(val)) obj[v] = val;
    });
    return obj;
};
const $d61abc47c39ce5ac$export$3ed0fe0c6a5387e2 = function(excl = []) {
    const element = this;
    const obj = $d61abc47c39ce5ac$export$98e6a39c04603d36.call(element, excl);
    for(const v in obj){
        if (excl.includes(v)) return;
        if ((0, $EqHTq.isObjectLike)(obj[v])) obj[v] = $d61abc47c39ce5ac$export$3ed0fe0c6a5387e2.call(obj[v], excl);
    }
    return obj;
};
const $d61abc47c39ce5ac$export$bef1f36f5486a6a3 = function(...args) {
    const element = this;
    const { __ref: __ref } = element;
    console.group(element.key);
    if (args.length) args.forEach((v)=>console.log(`%c${v}:\n`, "font-weight: bold", element[v]));
    else {
        console.log(__ref.path);
        const keys = element.keys();
        keys.forEach((v)=>console.log(`%c${v}:\n`, "font-weight: bold", element[v]));
    }
    console.groupEnd(element.key);
    return element;
};
const $d61abc47c39ce5ac$export$e87a5caa96444a37 = function() {
    const element = this;
    const { key: key, parent: parent } = element;
    const { __children: __children } = parent.__ref;
    const currentIndex = __children.indexOf(key);
    const nextChild = __children[currentIndex + 1];
    return parent[nextChild];
};
const $d61abc47c39ce5ac$export$1facc1d780a4d839 = function(el) {
    const element = el || this;
    const { key: key, parent: parent } = element;
    const { __children: __children } = parent.__ref;
    if (!__children) return;
    const currentIndex = __children.indexOf(key);
    return parent[__children[currentIndex - 1]];
};
const $d61abc47c39ce5ac$export$f0748ddc99f937c7 = [
    "set",
    "update",
    "remove",
    "updateContent",
    "removeContent",
    "lookup",
    "spotByPath",
    "keys",
    "parse",
    "setProps",
    "parseDeep",
    "if",
    "log",
    "nextElement",
    "previousElement"
];
const $d61abc47c39ce5ac$export$ed2133acb96eb5aa = function(param) {
    return $d61abc47c39ce5ac$export$f0748ddc99f937c7.includes(param);
};



parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $hSU9O = parcelRequire("hSU9O");

"use strict";
const $c6321d44fd66ade0$export$431871e52735632b = [
    "update",
    "__element"
];


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $045c563bb4b0b2eb$var$objectizeStringProperty = (propValue)=>{
    if ((0, $EqHTq.is)(propValue)("string", "number")) return {
        inheritedString: propValue
    };
    return propValue;
};
const $045c563bb4b0b2eb$export$d25057a75c14aff7 = (element, parent)=>{
    let propsStack = [];
    const parentProps = (0, $8wu6n.exec)(parent, parent.state).props;
    const matchParent = parent.props && parentProps[element.key];
    const matchParentIsString = (0, $EqHTq.isString)(matchParent);
    const matchParentChildProps = parentProps && parentProps.childProps;
    if (matchParent) {
        if (matchParentIsString) {
            const inheritedStringExists = propsStack.filter((v)=>v.inheritedString)[0];
            if (inheritedStringExists) inheritedStringExists.inheritedString = matchParent;
            else propsStack = [].concat($045c563bb4b0b2eb$var$objectizeStringProperty(matchParent), propsStack);
        } else propsStack.push($045c563bb4b0b2eb$var$objectizeStringProperty(matchParent));
    }
    if (matchParentChildProps) propsStack.push(matchParentChildProps);
    return propsStack;
};


"use strict";
const $e818f1ed291a38e8$var$createPropsStack = (element, parent)=>{
    const { props: props, __ref: __ref } = element;
    const propsStack = __ref.__props = (0, $045c563bb4b0b2eb$export$d25057a75c14aff7)(element, parent);
    if ((0, $EqHTq.isObject)(props)) propsStack.push(props);
    else if (props === "inherit" && parent.props) propsStack.push(parent.props);
    else if (props) propsStack.push(props);
    if ((0, $EqHTq.isArray)(__ref.__extend)) __ref.__extend.forEach((extend)=>{
        if (extend.props && extend.props !== props) propsStack.push(extend.props);
    });
    __ref.__props = propsStack;
    return propsStack;
};
const $e818f1ed291a38e8$export$b23ca50362483f82 = (props, element)=>{
    element.props = {};
    const mergedProps = {};
    props.forEach((v)=>{
        if ((0, $c6321d44fd66ade0$export$431871e52735632b).includes(v)) return;
        const execProps = (0, $8wu6n.exec)(v, element);
        // TODO: check if this failing the function props merge
        // if (isObject(execProps) && execProps.__element) return
        // it was causing infinite loop at early days
        element.props = (0, $8wu6n.deepMerge)(mergedProps, (0, $8wu6n.deepClone)(execProps, (0, $c6321d44fd66ade0$export$431871e52735632b)), (0, $c6321d44fd66ade0$export$431871e52735632b));
    });
    element.props = mergedProps;
    const methods = {
        update: $e818f1ed291a38e8$var$update.bind(element.props),
        __element: element
    };
    Object.setPrototypeOf(element.props, methods);
    return element.props;
};
const $e818f1ed291a38e8$export$c94ea207b45fef3a = function(element, parent, cached) {
    const { __ref: ref } = element;
    // if (element.parent.key === '0' && element.key === 'editor') {
    //   debugger
    // }
    const applyProps = ()=>{
        const propsStack = cached || $e818f1ed291a38e8$var$createPropsStack(element, parent);
        if (propsStack.length) {
            ref.__props = propsStack;
            $e818f1ed291a38e8$export$b23ca50362483f82(propsStack, element);
        } else {
            ref.__props = cached || [];
            element.props = {};
        }
    };
    if (ref.__if) applyProps();
    else try {
        applyProps();
    } catch  {
        element.props = {};
        ref.__props = cached || [];
    }
    const methods = {
        update: $e818f1ed291a38e8$var$update.bind(element.props),
        __element: element
    };
    Object.setPrototypeOf(element.props, methods);
    return element;
};
function $e818f1ed291a38e8$var$update(props, options) {
    const element = this.__element;
    element.update({
        props: props
    }, options);
}





"use strict";
const $902e7fcbfa0a2596$export$c8dce3c08436e91e = (newProps, element, parent)=>{
    const { __ref: __ref } = element;
    let propsStack = __ref.__props;
    const parentProps = (0, $045c563bb4b0b2eb$export$d25057a75c14aff7)(element, parent);
    if (parentProps.length) propsStack = __ref.__props = [].concat(parentProps, propsStack);
    if (newProps) propsStack = __ref.__props = [].concat(newProps, propsStack);
    if (propsStack) (0, $e818f1ed291a38e8$export$b23ca50362483f82)(propsStack, element);
    return element;
};


"use strict";



"use strict";
const $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d = (0, $hSU9O.joinArrays)([
    "node",
    "state",
    "context",
    "extend"
], (0, $d61abc47c39ce5ac$export$f0748ddc99f937c7), (0, $bfb47641e396194b$export$5100524046ce8de6), (0, $c6321d44fd66ade0$export$431871e52735632b));
const $9dbe2fe74e93fc61$export$6969335ea1e4e77c = (element, extend, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    for(const e in extend){
        if (exclude.includes(e)) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if (elementProp === undefined) element[e] = extendProp;
        else if ((0, $EqHTq.isObjectLike)(elementProp) && (0, $EqHTq.isObject)(extendProp)) $9dbe2fe74e93fc61$export$6969335ea1e4e77c(elementProp, extendProp);
    }
    return element;
};
const $9dbe2fe74e93fc61$export$9cd59f9826255e47 = (obj, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    const o = {};
    for(const e in obj){
        if (exclude.includes(e)) continue;
        o[e] = obj[e];
    }
    return o;
};
const $9dbe2fe74e93fc61$export$b7d58db314e0ac27 = (obj, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    const o = (0, $EqHTq.isArray)(obj) ? [] : {};
    for(const e in obj){
        if (exclude.includes(e)) continue;
        let objProp = obj[e];
        if (e === "extend" && (0, $EqHTq.isArray)(objProp)) objProp = $9dbe2fe74e93fc61$export$fd2fbaf2367ef824(objProp, exclude);
        if ((0, $EqHTq.isObjectLike)(objProp)) o[e] = $9dbe2fe74e93fc61$export$b7d58db314e0ac27(objProp, exclude);
        else o[e] = objProp;
    }
    return o;
};
const $9dbe2fe74e93fc61$export$d3305692eb3e9a81 = (element, params, options)=>{
    const changes = {};
    const { __ref: __ref } = element;
    const { __exec: __exec, __cached: __cached } = __ref;
    for(const e in params){
        if (e === "props" || e === "state" || e === "__ref") continue;
        const elementProp = element[e];
        const paramsProp = params[e];
        if (paramsProp !== undefined) {
            __cached[e] = changes[e] = elementProp;
            element[e] = paramsProp;
        }
        if (options.cleanExec) delete __exec[e];
    }
    return changes;
};
const $9dbe2fe74e93fc61$export$1c07155dfdd98f41 = (obj, params, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    for(const e in params){
        if (exclude.includes(e)) continue;
        obj[e] = params[e];
    }
    return obj;
};
const $9dbe2fe74e93fc61$export$f0b277b530b4fffd = (obj, params, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    for(const e in params){
        if (exclude.includes(e)) continue;
        const objProp = obj[e];
        const paramsProp = params[e];
        if ((0, $EqHTq.isObjectLike)(objProp) && (0, $EqHTq.isObjectLike)(paramsProp)) $9dbe2fe74e93fc61$export$f0b277b530b4fffd(objProp, paramsProp);
        else if (paramsProp !== undefined) obj[e] = paramsProp;
    }
    return obj;
};
const $9dbe2fe74e93fc61$export$7bde6dffa6d2dd59 = (a, b)=>{
    if ((0, $EqHTq.isObjectLike)(a) && (0, $EqHTq.isObjectLike)(b)) return $9dbe2fe74e93fc61$export$6969335ea1e4e77c(a, b);
    return a || b;
};
const $9dbe2fe74e93fc61$export$fd2fbaf2367ef824 = (arr, exclude = [
    "parent",
    "node",
    "__element",
    "state",
    "context",
    "__ref"
])=>{
    return arr.reduce((a, c)=>$9dbe2fe74e93fc61$export$6969335ea1e4e77c(a, $9dbe2fe74e93fc61$export$b7d58db314e0ac27(c, exclude)), {});
};
const $9dbe2fe74e93fc61$export$803a4c6bdde5cd1d = (obj)=>{
    return (0, $EqHTq.isArray)(obj) ? $9dbe2fe74e93fc61$export$fd2fbaf2367ef824(obj) : $9dbe2fe74e93fc61$export$b7d58db314e0ac27(obj);
};
const $9dbe2fe74e93fc61$export$d53c2c5b09d0676f = (param, prop, stack = [])=>{
    const objectized = $9dbe2fe74e93fc61$export$803a4c6bdde5cd1d(param);
    stack.push(objectized);
    const extendOfExtend = objectized[prop];
    if (extendOfExtend) $9dbe2fe74e93fc61$export$d53c2c5b09d0676f(extendOfExtend, prop, stack);
    delete objectized[prop];
    return stack;
};


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $ce326eb5cdcc3ce9$var$ENV = "production";
const $ce326eb5cdcc3ce9$export$daf4c137c5f56404 = ()=>Math.random().toString(36).substring(2);
const $ce326eb5cdcc3ce9$export$476cb8ab9adcdb0d = {};
const $ce326eb5cdcc3ce9$export$bc442b6cc8c83971 = {};
const $ce326eb5cdcc3ce9$export$46ce3405574370c6 = (extend)=>{
    return $ce326eb5cdcc3ce9$export$476cb8ab9adcdb0d[extend.__hash];
};
const $ce326eb5cdcc3ce9$export$8c8f2806a2edf07f = (extend, stack)=>{
    const hash = $ce326eb5cdcc3ce9$export$daf4c137c5f56404();
    if (!(0, $EqHTq.isString)(extend)) extend.__hash = hash;
    $ce326eb5cdcc3ce9$export$476cb8ab9adcdb0d[hash] = stack;
    return stack;
};
const $ce326eb5cdcc3ce9$export$6ef9dd655b57622a = (extend, stack)=>{
    if (extend.__hash) return stack.concat($ce326eb5cdcc3ce9$export$46ce3405574370c6(extend));
    return $ce326eb5cdcc3ce9$export$8c8f2806a2edf07f(extend, stack) // stack .concat(hashedExtend)
    ;
};
const $ce326eb5cdcc3ce9$export$2c118161a655606a = (extend, stack, context)=>{
    extend.forEach((each)=>$ce326eb5cdcc3ce9$export$802e3e1ed5ecb3f2(each, stack, context));
    return stack;
};
const $ce326eb5cdcc3ce9$export$54e9fb29908872fa = (extend, stack, context)=>{
    const extendOflattenExtend = extend.extend;
    if (extendOflattenExtend) $ce326eb5cdcc3ce9$export$802e3e1ed5ecb3f2(extendOflattenExtend, stack, context);
    return stack;
};
const $ce326eb5cdcc3ce9$export$802e3e1ed5ecb3f2 = (extend, stack, context)=>{
    if (!extend) return stack;
    if ((0, $EqHTq.isArray)(extend)) return $ce326eb5cdcc3ce9$export$2c118161a655606a(extend, stack, context);
    if ((0, $EqHTq.isString)(extend)) extend = $ce326eb5cdcc3ce9$export$ade1aefc7d5ec315(extend, context);
    stack.push(extend);
    if (extend.extend) $ce326eb5cdcc3ce9$export$54e9fb29908872fa(extend, stack, context);
    return stack;
};
const $ce326eb5cdcc3ce9$export$16fb354ab895483c = (obj)=>{
    const o = {};
    for(const prop in obj){
        if ([
            "parent",
            "node",
            "__element"
        ].indexOf(prop) > -1) continue;
        const objProp = obj[prop];
        if ((0, $EqHTq.isObject)(objProp)) o[prop] = $ce326eb5cdcc3ce9$export$16fb354ab895483c(objProp);
        else if ((0, $EqHTq.isArray)(objProp)) o[prop] = objProp.map((x)=>x);
        else o[prop] = objProp;
    }
    return o;
};
const $ce326eb5cdcc3ce9$export$d20ceec222df68ed = (element, extend)=>{
    for(const e in extend){
        if ([
            "parent",
            "node",
            "__element"
        ].indexOf(e) > -1) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if (elementProp === undefined) element[e] = extendProp;
        else if ((0, $EqHTq.isObject)(elementProp) && (0, $EqHTq.isObject)(extendProp)) $ce326eb5cdcc3ce9$export$d20ceec222df68ed(elementProp, extendProp);
        else if ((0, $EqHTq.isArray)(elementProp) && (0, $EqHTq.isArray)(extendProp)) element[e] = elementProp.concat(extendProp);
        else if ((0, $EqHTq.isArray)(elementProp) && (0, $EqHTq.isObject)(extendProp)) {
            const obj = $ce326eb5cdcc3ce9$export$d20ceec222df68ed({}, elementProp);
            element[e] = $ce326eb5cdcc3ce9$export$d20ceec222df68ed(obj, extendProp);
        } else if (elementProp === undefined && (0, $EqHTq.isFunction)(extendProp)) element[e] = extendProp;
    }
    return element;
};
const $ce326eb5cdcc3ce9$export$e2e460d82983fb19 = (stack)=>{
    return stack.reduce((a, c)=>{
        return $ce326eb5cdcc3ce9$export$d20ceec222df68ed(a, $ce326eb5cdcc3ce9$export$16fb354ab895483c(c));
    }, {});
};
const $ce326eb5cdcc3ce9$export$ade1aefc7d5ec315 = (extend, context, options = {})=>{
    const COMPONENTS = context && context.components || options.components;
    if ((0, $EqHTq.isString)(extend)) {
        const componentExists = COMPONENTS[extend] || COMPONENTS["smbls." + extend];
        if (COMPONENTS && componentExists) return componentExists;
        else {
            if (options.verbose && ($ce326eb5cdcc3ce9$var$ENV === "test" || $ce326eb5cdcc3ce9$var$ENV === "development")) console.warn("Extend is string but component was not found:", extend);
            return {};
        }
    }
    return extend;
};
const $ce326eb5cdcc3ce9$export$f9f936cf352c3af2 = (extendStack, childExtendStack)=>{
    return [].concat(extendStack.slice(0, 1)).concat(childExtendStack.slice(0, 1)).concat(extendStack.slice(1)).concat(childExtendStack.slice(1));
};
const $ce326eb5cdcc3ce9$export$a0203ee23029af7e = (extend, context)=>{
    if (!extend) return [];
    if (extend.__hash) return $ce326eb5cdcc3ce9$export$46ce3405574370c6(extend) || [];
    const stack = $ce326eb5cdcc3ce9$export$802e3e1ed5ecb3f2(extend, [], context);
    return $ce326eb5cdcc3ce9$export$6ef9dd655b57622a(extend, stack);
};
const $ce326eb5cdcc3ce9$export$52f1fe7126b651a = (extend)=>{
    const stack = $ce326eb5cdcc3ce9$export$a0203ee23029af7e(extend);
    return $ce326eb5cdcc3ce9$export$e2e460d82983fb19(stack);
} // export const replaceStringsWithComponents = (stack, context, options) => {
 //   const COMPONENTS = (context && context.components) || options.components
 //   return stack.map(v => {
 //     if (isString(v)) {
 //       const component = COMPONENTS[v]
 //       return component
 //     }
 //     if (isString(v.extend)) {
 //       v.extend = getExtendMerged(COMPONENTS[v.extend])
 //     }
 //     return v
 //   })
 // }
;


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $hSU9O = parcelRequire("hSU9O");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $3bff1c984b824aeb$var$ENV = "production";
let $3bff1c984b824aeb$var$mainExtend;
const $3bff1c984b824aeb$export$f20941eae6723bcc = (element, parent, options = {})=>{
    if ((0, $EqHTq.isFunction)(element)) element = (0, $8wu6n.exec)(element, parent);
    let { extend: extend, props: props, context: context, __ref: __ref } = element;
    extend = (0, $ce326eb5cdcc3ce9$export$ade1aefc7d5ec315)(extend, context, options);
    const extendStack = (0, $ce326eb5cdcc3ce9$export$a0203ee23029af7e)(extend, context);
    if ($3bff1c984b824aeb$var$ENV !== "test" || $3bff1c984b824aeb$var$ENV !== "development") delete element.extend;
    let childExtendStack = [];
    if (parent) {
        element.parent = parent;
        // Assign parent attr to the element
        if (!options.ignoreChildExtend && !(props && props.ignoreChildExtend)) {
            childExtendStack = (0, $ce326eb5cdcc3ce9$export$a0203ee23029af7e)(parent.childExtend, context);
            const ignoreChildExtendRecursive = props && props.ignoreChildExtendRecursive;
            if (parent.childExtendRecursive && !ignoreChildExtendRecursive) {
                const canExtendRecursive = element.key !== "__text";
                if (canExtendRecursive) {
                    const childExtendRecursiveStack = (0, $ce326eb5cdcc3ce9$export$a0203ee23029af7e)(parent.childExtendRecursive, context);
                    // add error if childExtendRecursive contains element which goes to infinite loop
                    childExtendStack = childExtendStack.concat(childExtendRecursiveStack);
                    element.childExtendRecursive = parent.childExtendRecursive;
                }
            }
        }
    }
    const extendLength = extendStack.length;
    const childExtendLength = childExtendStack.length;
    let stack = [];
    if (extendLength && childExtendLength) stack = (0, $ce326eb5cdcc3ce9$export$f9f936cf352c3af2)(extendStack, childExtendStack);
    else if (extendLength) stack = extendStack;
    else if (childExtendLength) stack = childExtendStack;
    else if (!options.extend) return element;
    if (options.extend) {
        if (!$3bff1c984b824aeb$var$mainExtend) {
            const defaultOptionsExtend = (0, $ce326eb5cdcc3ce9$export$a0203ee23029af7e)(options.extend, context);
            $3bff1c984b824aeb$var$mainExtend = (0, $ce326eb5cdcc3ce9$export$e2e460d82983fb19)(defaultOptionsExtend);
            delete $3bff1c984b824aeb$var$mainExtend.extend;
        }
        stack = [].concat(stack, $3bff1c984b824aeb$var$mainExtend);
    }
    // check if array contains string extends
    if (__ref) __ref.__extend = stack;
    let mergedExtend = (0, $ce326eb5cdcc3ce9$export$e2e460d82983fb19)(stack);
    // apply `component:` property
    const COMPONENTS = context && context.components || options.components;
    const component = (0, $8wu6n.exec)(element.component || mergedExtend.component, element);
    if (component && COMPONENTS && COMPONENTS[component]) {
        const componentExtend = (0, $ce326eb5cdcc3ce9$export$e2e460d82983fb19)((0, $ce326eb5cdcc3ce9$export$a0203ee23029af7e)(COMPONENTS[component]));
        mergedExtend = (0, $ce326eb5cdcc3ce9$export$d20ceec222df68ed)(componentExtend, mergedExtend);
    }
    const merged = (0, $ce326eb5cdcc3ce9$export$d20ceec222df68ed)(element, mergedExtend);
    return merged;
};


"use strict";
const $a6bfc6202982ac85$var$ENV = "production";
const $a6bfc6202982ac85$var$DOMQL_BUILTINS = [
    "extend",
    "childExtend",
    "childExtendRecursive",
    "define",
    "props",
    "state",
    "on",
    "if",
    "attr",
    "key",
    "tag"
];
const $a6bfc6202982ac85$export$b791484194c5fc38 = (key)=>{
    const isFirstKeyString = (0, $EqHTq.isString)(key);
    if (!isFirstKeyString) return;
    const firstCharKey = key.slice(0, 1);
    return /^[A-Z]*$/.test(firstCharKey);
};
const $a6bfc6202982ac85$export$69dfe88127d1d0de = (key)=>{
    const isFirstKeyString = (0, $EqHTq.isString)(key);
    if (!isFirstKeyString) return;
    const firstCharKey = key.slice(0, 1);
    return /^[a-z]*$/.test(firstCharKey);
};
const $a6bfc6202982ac85$export$356ecc5e07374be5 = (newExtend, element)=>{
    const { extend: elementExtend } = element;
    const originalArray = (0, $EqHTq.isArray)(elementExtend) ? elementExtend : [
        elementExtend
    ];
    const receivedArray = (0, $EqHTq.isArray)(newExtend) ? newExtend : [
        newExtend
    ];
    const extend = (0, $hSU9O.joinArrays)(receivedArray, originalArray);
    return {
        ...element,
        extend: extend
    };
};
const $a6bfc6202982ac85$var$replaceOnKeys = (key)=>key.replace(/on\w+/g, (match)=>match.substring(2));
const $a6bfc6202982ac85$export$2cbc234431a4ef8 = (el, parent, key, options)=>{
    const newElem = {
        props: {},
        on: {}
    };
    for(const k in el){
        const prop = el[k];
        const isEvent = prop.startsWith("on");
        const isMethod = prop.startsWith("$");
        if (isEvent) {
            const onKey = $a6bfc6202982ac85$var$replaceOnKeys(prop);
            newElem.on[onKey] = prop;
        } else if (!isMethod && $a6bfc6202982ac85$export$69dfe88127d1d0de(k)) {
            if (!$a6bfc6202982ac85$var$DOMQL_BUILTINS.includes(k)) newElem.props[k] = prop;
        } else if ($a6bfc6202982ac85$export$b791484194c5fc38(k)) newElem[k] = prop;
        else newElem[k] = prop;
    }
    return newElem;
};
const $a6bfc6202982ac85$export$c786485ace8eb69b = (element, parent, key)=>{
    const { context: context, tag: tag, extend: extend, props: props, attr: attr, state: state, childExtend: childExtend, childProps: childProps, on: on, if: condition } = element;
    const hasComponentAttrs = extend || childExtend || props || state || on || condition || attr;
    const extendFromKey = key.includes("+") ? key.split("+") // get array of componentKeys
     : key.includes("_") ? key.split("_")[0] // get component key split _
     : key.includes(".") ? key.split(".")[0] // get component key split .
     : [
        key
    ];
    const isExtendKeyComponent = context && context.components[extendFromKey];
    if (element === isExtendKeyComponent) return element;
    else if (!hasComponentAttrs || childProps) return {
        extend: extendFromKey,
        tag: tag,
        props: {
            ...element
        }
    };
    else if (!extend || extend === true) return {
        ...element,
        tag: tag,
        extend: extendFromKey
    };
    else if (extend) return $a6bfc6202982ac85$export$356ecc5e07374be5(extendFromKey, element);
    else if ((0, $EqHTq.isFunction)(element)) return {
        extend: extendFromKey,
        tag: tag,
        props: {
            ...(0, $8wu6n.exec)(element, parent)
        }
    };
};
const $a6bfc6202982ac85$export$2279e5e6b0817ddc = (element, parent, key)=>{
    return $a6bfc6202982ac85$export$c786485ace8eb69b(element, parent, key) || element;
};
const $a6bfc6202982ac85$export$fd6b2f481ffc7974 = (element, parent, options)=>{
    const { context: context } = element;
    if (!context || !context.components) return;
    const { components: components } = context;
    const { extend: extend } = element;
    const execExtend = (0, $8wu6n.exec)(extend, element);
    if ((0, $EqHTq.isString)(execExtend)) {
        const componentExists = components[execExtend] || components["smbls." + execExtend];
        if (componentExists) element.extend = componentExists;
        else {
            if (($a6bfc6202982ac85$var$ENV === "test" || $a6bfc6202982ac85$var$ENV === "development") && options.verbose) {
                console.warn(execExtend, "is not in library", components, element);
                console.warn("replacing with ", {});
            }
            element.extend = {};
        }
    }
};
const $a6bfc6202982ac85$export$53cd1a145c393044 = (param)=>{
    if (!(0, $EqHTq.isString)(param)) return;
    const firstCharKey = param.slice(0, 1);
    // return (firstCharKey === '.' || firstCharKey === '$')
    return firstCharKey === ".";
};
const $a6bfc6202982ac85$export$c66af1c05bf7bb06 = (element)=>{
    const { props: props } = element;
    if ((0, $EqHTq.isObject)(props) && (0, $EqHTq.isString)(props.variant)) return true;
};
const $a6bfc6202982ac85$export$a9aa73f3ae416cbd = (element, variant, variantProps)=>{
    let variantElement = element[variant];
    if (!variantElement) return;
    const props = (0, $EqHTq.isObject)(variantProps) ? variantProps : {};
    if ((0, $EqHTq.isString)(variantElement)) variantElement = {
        extend: [
            {
                props: props
            },
            variantElement
        ]
    };
    else if (variantElement.extend) variantElement = $a6bfc6202982ac85$export$356ecc5e07374be5({
        props: props
    }, variantElement);
    return (0, $8wu6n.overwriteDeep)(element, (0, $3bff1c984b824aeb$export$f20941eae6723bcc)(variantElement)) // TODO: check why string is not working
    ;
};
const $a6bfc6202982ac85$export$f1439fc936ef702f = (element)=>{
    const { props: props } = element;
    if (!$a6bfc6202982ac85$export$c66af1c05bf7bb06(element)) return element;
    const { variant: variant } = props;
    $a6bfc6202982ac85$export$a9aa73f3ae416cbd(element, `.${variant}`);
    const elKeys = Object.keys(element).filter((key)=>$a6bfc6202982ac85$export$53cd1a145c393044(key));
    elKeys.forEach((variant)=>{
        const slicedVariantElementKey = variant.slice(1);
        const variantElementProps = props[slicedVariantElementKey];
        if (variantElementProps) $a6bfc6202982ac85$export$a9aa73f3ae416cbd(element, variant, variantElementProps);
    });
    return element;
};


"use strict";



"use strict";
const $0513b3ed7d5404ec$export$3223a9877c540db8 = (element, exclude = {})=>{
    const { __ref: ref } = element;
    for(const param in element){
        if (exclude[param]) continue;
        const prop = element[param];
        if ((0, $EqHTq.isFunction)(prop) && !(0, $d61abc47c39ce5ac$export$ed2133acb96eb5aa)(param) && !(0, $a6bfc6202982ac85$export$53cd1a145c393044)(param)) {
            ref.__exec[param] = prop;
            element[param] = prop(element, element.state);
        // if (isComponent)
        }
    }
};
const $0513b3ed7d5404ec$export$2ad800d85590910f = (element, options = {
    excludes: (0, $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)
})=>{
    const { __ref: ref } = element;
    const changes = {};
    for(const param in ref.__exec){
        const prop = element[param];
        const isDefinedParam = ref.__defineCache[param];
        if (isDefinedParam) continue;
        const newExec = ref.__exec[param](element, element.state, element.context);
        const execReturnsString = (0, $EqHTq.isString)(newExec) || (0, $EqHTq.isNumber)(newExec);
        // if (prop && prop.node && execReturnsString) {
        if (prop && prop.node && execReturnsString) (0, $9dbe2fe74e93fc61$export$d3305692eb3e9a81)(prop, {
            text: newExec
        }, options);
        else if (newExec !== prop) {
            if ((0, $a6bfc6202982ac85$export$b791484194c5fc38)(param)) {
                const { extend: extend, ...newElem } = (0, $a6bfc6202982ac85$export$c786485ace8eb69b)(newExec, element, param);
                (0, $9dbe2fe74e93fc61$export$d3305692eb3e9a81)(prop, newElem, options);
            // } else {
            //   overwrite(prop, newExec, options)
            } else {
                ref.__cached[param] = changes[param] = prop;
                element[param] = newExec;
            }
        }
    }
    return changes;
};
const $0513b3ed7d5404ec$export$b4c781127351659b = (element)=>{
    const { define: define, context: context, __ref: ref } = element;
    let defineObj = {};
    const hasGlobalDefine = context && (0, $EqHTq.isObject)(context.define);
    if ((0, $EqHTq.isObject)(define)) defineObj = {
        ...define
    };
    if (hasGlobalDefine) defineObj = {
        ...defineObj,
        ...context.define
    };
    for(const param in defineObj){
        let elementProp = element[param];
        if ((0, $EqHTq.isFunction)(elementProp) && !(0, $d61abc47c39ce5ac$export$ed2133acb96eb5aa)(param) && !(0, $a6bfc6202982ac85$export$53cd1a145c393044)(param)) {
            ref.__exec[param] = elementProp;
            const execParam = elementProp = (0, $8wu6n.exec)(elementProp, element);
            if (execParam) {
                elementProp = element[param] = execParam.parse ? execParam.parse() : execParam;
                ref.__defineCache[param] = elementProp;
            }
        }
        const execParam = defineObj[param](elementProp, element, element.state, element.context);
        if (execParam) element[param] = execParam;
    }
    return element;
};
const $0513b3ed7d5404ec$export$88eda8a7eb5c5eff = (element)=>{
    const { context: context, define: define, __ref: ref } = element;
    const changes = {};
    let obj = {};
    if ((0, $EqHTq.isObject)(define)) obj = {
        ...define
    };
    if ((0, $EqHTq.isObject)(context && context.define)) obj = {
        ...obj,
        ...context.define
    };
    for(const param in obj){
        const execParam = ref.__exec[param];
        if (execParam) ref.__defineCache[param] = execParam(element, element.state, element.context);
        const cached = (0, $8wu6n.exec)(ref.__defineCache[param], element);
        const newExecParam = obj[param](cached, element, element.state, element.context);
        if (newExecParam) element[param] = newExecParam;
    }
    return changes;
};



parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $88e1be01eff6bc07$export$535107f3c159da5d = (param, element, options)=>{
    const { node: node, context: context, __ref: ref } = element;
    const prop = element[param];
    const DOMQLProperty = (0, $782cf63e523d0885$export$2e2bcd8739ae039)[param];
    const DOMQLPropertyFromContext = context && context.registry && context.registry[param];
    const isGlobalTransformer = DOMQLPropertyFromContext || DOMQLProperty;
    const hasDefine = element.define && element.define[param];
    const hasContextDefine = context && context.define && context.define[param];
    if (!ref.__if) return;
    if (isGlobalTransformer && !hasContextDefine) {
        if ((0, $EqHTq.isFunction)(isGlobalTransformer)) {
            isGlobalTransformer(prop, element, node, options);
            return;
        }
    }
    return {
        hasDefine: hasDefine,
        hasContextDefine: hasContextDefine
    };
};



parcelRequire("cBUNY");
var $5WrxC = parcelRequire("5WrxC");
"use strict";
const $11a8b378b730acc1$export$e43138af17da316d = (element)=>{
    const { props: props, on: on } = element;
    const eventKeysFromProps = Object.keys(props).filter((key)=>key.startsWith("on"));
    eventKeysFromProps.forEach((v)=>{
        const eventName = (0, $5WrxC.lowercaseFirstLetter)(v.split("on")[1]);
        if (on[eventName]) on[eventName] = (...args)=>{
            on[eventName](...args);
            props[v](...args);
        };
        else on[eventName] = props[v];
    });
};


"use strict";
// import { defineSetter } from './methods'
const $4e214d02be0ddce7$var$ENV = "production";
const $4e214d02be0ddce7$export$270e7ba5936d3c48 = (element, options)=>{
    // create and assign a node
    let { node: node, tag: tag, __ref: ref } = element;
    let isNewNode;
    if (!node) {
        isNewNode = true;
        if (!ref.__if) return element;
        if (tag === "shadow") node = element.node = element.parent.node.attachShadow({
            mode: "open"
        });
        else node = element.node = (0, $01ef634a92434650$export$257247f9c0329159)(element);
        // trigger `on.attachNode`
        (0, $33936e69aa63c9cd$export$1bc010482b845252)("attachNode", element, options);
    }
    // node.dataset // .key = element.key
    if ($4e214d02be0ddce7$var$ENV === "test" || $4e214d02be0ddce7$var$ENV === "development" || options.alowRefReference) {
        node.ref = element;
        if ((0, $EqHTq.isFunction)(node.setAttribute)) node.setAttribute("key", element.key);
    }
    // iterate through define
    (0, $0513b3ed7d5404ec$export$b4c781127351659b)(element);
    // iterate through exec
    (0, $0513b3ed7d5404ec$export$3223a9877c540db8)(element);
    if (element.tag !== "string" && element.tag !== "fragment") {
        (0, $11a8b378b730acc1$export$e43138af17da316d)(element);
        // apply events
        if (isNewNode && (0, $EqHTq.isObject)(element.on)) (0, $33936e69aa63c9cd$export$1f7cb486ba1f8a10)(element, options);
    }
    for(const param in element){
        const value = element[param];
        if ((0, $EqHTq.isUndefined)(value) || (0, $d61abc47c39ce5ac$export$ed2133acb96eb5aa)(param) || (0, $a6bfc6202982ac85$export$53cd1a145c393044)(param) || (0, $EqHTq.isObject)((0, $782cf63e523d0885$export$2e2bcd8739ae039)[param])) continue;
        const isElement = (0, $88e1be01eff6bc07$export$535107f3c159da5d)(param, element, options);
        if (isElement) {
            const { hasDefine: hasDefine, hasContextDefine: hasContextDefine } = isElement;
            if (element[param] && !hasDefine && !hasContextDefine) {
                const createAsync = ()=>(0, $947d5c063e68e91c$export$2e2bcd8739ae039)((0, $8wu6n.exec)(value, element), element, param, options);
                if (element.props && element.props.lazyLoad || options.lazyLoad) window.requestAnimationFrame(()=>createAsync());
                else createAsync();
            }
        }
    }
    // node.dataset.key = key
    return element;
};
var $4e214d02be0ddce7$export$2e2bcd8739ae039 = $4e214d02be0ddce7$export$270e7ba5936d3c48;



parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
"use strict";
const $5fc178d8c3a9e6de$export$5c3eb765ea0f1dc2 = {
    key: {},
    tag: {},
    if: {},
    define: {},
    attr: {},
    style: {},
    content: {},
    class: {},
    props: {},
    state: {},
    method: {},
    transform: {},
    on: {},
    ref: {},
    extend: {},
    childExtend: {},
    text: (element, state)=>{
        element.ref.text = {
            tag: "text",
            text: (0, $8wu6n.exec)(element.text, element, state)
        };
    },
    innerHTML: {},
    set: {},
    update: {},
    remove: {}
} // log: {}
 // value: {},
 // text: {},
 // html: {},
 // path: {},
 // data: {},
 // if: {},
 // __hash: {},
 // __cache: {},
 // __defined: {},
 // __exec: {},
 // __changes: {},
 // __trash: {},
 // __root: {},
 // __props: {},
 // __extend: {},
 // __ifFragment: {},
 // __ifFalsy: {},
 // parent: {},
 // node: {},
 // lookup: {},
 // keys: {},
 // parse: {},
 // parseDeep: {},
;


"use strict";
const $89442055fcdd5e8d$export$de435b1ae0c975f3 = {
    root: [
        "body",
        "html"
    ],
    head: [
        "title",
        "base",
        "meta",
        "style"
    ],
    body: [
        "html",
        "body",
        "string",
        "fragment",
        "a",
        "abbr",
        "acronym",
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "basefont",
        "bdi",
        "bdo",
        "big",
        "blockquote",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "data",
        "datalist",
        "dd",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "em",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hr",
        "i",
        "iframe",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "link",
        "main",
        "map",
        "mark",
        "meter",
        "nav",
        "noframes",
        "noscript",
        "object",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "param",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "script",
        "section",
        "select",
        "small",
        "source",
        "span",
        "strike",
        "strong",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr",
        // SVG
        "svg",
        "path"
    ]
};


"use strict";









parcelRequire("cBUNY");
var $jOLBF = parcelRequire("jOLBF");

parcelRequire("cBUNY");
var $NWrSd = parcelRequire("NWrSd");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $jvD5p = parcelRequire("jvD5p");










"use strict";
const $196ad7400dcaf39e$var$snapshot = {
    snapshotId: (0, $NWrSd.createSnapshotId)
};
const $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS = {
    stackChanges: false,
    cleanExec: true,
    preventRecursive: false,
    currentSnapshot: false,
    calleeElement: false,
    excludes: (0, $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)
};
const $196ad7400dcaf39e$var$update = function(params = {}, options = $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS) {
    const element = this;
    const { parent: parent, node: node, key: key } = element;
    const { excludes: excludes, preventInheritAtCurrentState: preventInheritAtCurrentState } = options;
    (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("startUpdate", params, element, options);
    if (preventInheritAtCurrentState && preventInheritAtCurrentState.__element === element) return;
    if (!excludes) (0, $8wu6n.merge)(options, $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS);
    let ref = element.__ref;
    if (!ref) ref = element.__ref = {};
    const [snapshotOnCallee, calleeElement, snapshotHasUpdated] = $196ad7400dcaf39e$var$captureSnapshot(element, options);
    if (snapshotHasUpdated) return;
    if ((0, $EqHTq.isString)(params) || (0, $EqHTq.isNumber)(params)) params = {
        text: params
    };
    const inheritState = $196ad7400dcaf39e$var$inheritStateUpdates(element, options);
    if (inheritState === false) return;
    const ifFails = $196ad7400dcaf39e$var$checkIfOnUpdate(element, parent, options);
    if (ifFails) return;
    if (ref.__if && !options.preventPropsUpdate) {
        const hasParentProps = parent.props && (parent.props[key] || parent.props.childProps);
        const hasFunctionInProps = ref.__props.filter((v)=>(0, $EqHTq.isFunction)(v));
        const props = params.props || hasParentProps || hasFunctionInProps.length;
        if (props) (0, $902e7fcbfa0a2596$export$c8dce3c08436e91e)(props, element, parent);
    }
    if (!options.preventInitUpdateListener) {
        const initUpdateReturns = (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("initUpdate", params, element, options);
        if (initUpdateReturns === false) return element;
    }
    const overwriteChanges = (0, $8wu6n.overwriteDeep)(element, params, (0, $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d));
    const execChanges = (0, $0513b3ed7d5404ec$export$2ad800d85590910f)(element, {
        ignore: $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS
    });
    const definedChanges = (0, $0513b3ed7d5404ec$export$88eda8a7eb5c5eff)(element);
    if (!options.isForced) (0, $33936e69aa63c9cd$export$1bc010482b845252)("beforeClassAssign", element, options);
    if (options.stackChanges && element.__stackChanges) {
        const stackChanges = (0, $8wu6n.merge)(definedChanges, (0, $8wu6n.merge)(execChanges, overwriteChanges));
        element.__stackChanges.push(stackChanges);
    }
    if (!ref.__if) return false;
    if (!node) // return createNode(element, options)
    return;
    for(const param in element){
        const prop = element[param];
        const hasOnlyUpdateFalsy = options.onlyUpdate && (options.onlyUpdate !== param || !element.lookup(options.onlyUpdate));
        const isInPreventUpdate = (0, $EqHTq.isArray)(options.preventUpdate) && options.preventUpdate.includes(param);
        const isInPreventDefineUpdate = (0, $EqHTq.isArray)(options.preventDefineUpdate) && options.preventDefineUpdate.includes(param);
        if ((0, $EqHTq.isUndefined)(prop) || hasOnlyUpdateFalsy || isInPreventUpdate || isInPreventDefineUpdate || options.preventDefineUpdate === true || options.preventDefineUpdate === param || options.preventContentUpdate && param === "content" || (options.preventStateUpdate && param) === "state" || (0, $d61abc47c39ce5ac$export$ed2133acb96eb5aa)(param) || (0, $EqHTq.isObject)((0, $782cf63e523d0885$export$2e2bcd8739ae039)[param]) || (0, $a6bfc6202982ac85$export$53cd1a145c393044)(param)) continue;
        if (options.preventStateUpdate === "once") options.preventStateUpdate = false;
        const isElement = (0, $88e1be01eff6bc07$export$535107f3c159da5d)(param, element, options);
        if (isElement) {
            const { hasDefine: hasDefine, hasContextDefine: hasContextDefine } = isElement;
            const canUpdate = (0, $EqHTq.isObject)(prop) && !hasDefine && !hasContextDefine && !options.preventRecursive;
            if (!canUpdate) continue;
            const lazyLoad = element.props.lazyLoad || options.lazyLoad;
            const childUpdateCall = ()=>$196ad7400dcaf39e$var$update.call(prop, params[prop], {
                    ...options,
                    currentSnapshot: snapshotOnCallee,
                    calleeElement: calleeElement
                });
            lazyLoad ? (0, $jvD5p.window).requestAnimationFrame(()=>childUpdateCall()) : childUpdateCall();
        }
    }
    if (!options.preventUpdateListener) (0, $33936e69aa63c9cd$export$1bc010482b845252)("update", element, options);
};
const $196ad7400dcaf39e$var$captureSnapshot = (element, options)=>{
    const ref = element.__ref;
    const { currentSnapshot: currentSnapshot, calleeElement: calleeElement } = options;
    const isCallee = calleeElement === element;
    if (!calleeElement || isCallee) {
        const createdStanpshot = $196ad7400dcaf39e$var$snapshot.snapshotId();
        ref.__currentSnapshot = createdStanpshot;
        return [
            createdStanpshot,
            element
        ];
    }
    const snapshotOnCallee = ref.__currentSnapshot;
    if (currentSnapshot < snapshotOnCallee) return [
        snapshotOnCallee,
        calleeElement,
        true
    ];
    return [
        snapshotOnCallee,
        calleeElement
    ];
};
const $196ad7400dcaf39e$var$checkIfOnUpdate = (element, parent, options)=>{
    if (!(0, $EqHTq.isFunction)(element.if) || !parent) return;
    const ref = element.__ref;
    const ifPassed = element.if(element, element.state, element.context, options);
    const itWasFalse = ref.__if !== true;
    if (ifPassed) {
        ref.__if = true;
        if (itWasFalse) {
            delete element.__hash;
            delete element.extend;
            if (!ref.__hasRootState) delete element.state;
            if (ref.__state) element.state = ref.__state;
            else if (!ref.__hasRootState) delete element.state;
            element.node && element.node.remove();
            const previousElement = element.previousElement();
            const nextElement = element.nextElement();
            const hasPrevious = previousElement && previousElement.node;
            const hasNext = nextElement && nextElement.node;
            const attachOptions = (hasPrevious && hasPrevious.parentNode || hasNext && hasNext.parentNode) && {
                position: hasPrevious ? "after" : hasNext ? "before" : null,
                node: hasPrevious || hasNext
            };
            const created = (0, $947d5c063e68e91c$export$2e2bcd8739ae039)(element, parent, element.key, (0, $ad3d3b247d47f3a2$export$2e2bcd8739ae039).create, attachOptions);
            // check preventUpdate for an array (Line: 87)
            if (options.preventUpdate !== true && element.on && (0, $EqHTq.isFunction)(element.on.update)) (0, $33936e69aa63c9cd$export$27ca81ea148fa005)(element.on.update, created, created.state);
            return created;
        }
    } else if (element.node && !ifPassed) {
        element.node.remove();
        delete ref.__if;
    }
};
/**
 * Inherit state updates for a given element based on the specified options.
 *
 * @param {Object} element - The element to inherit state updates for.
 * @param {Object} options - Configuration options for state update inheritance.
 * @param {boolean} [options.preventUpdateTriggerStateUpdate] - If true, prevent triggering state updates.
 * @param {boolean} [options.isHoisted] - Whether the state is hoisted.
 * @param {boolean} [options.execStateFunction] - Execute the state functions.
 * @param {boolean} [options.stateFunctionOverwrite] - If true, overwrite (not merge) current state with what function returns.
 * @param {boolean} [options.preventInheritedStateUpdate] - If true, prevent inheriting state updates.
 * @param {boolean} [options.preventInitStateUpdateListener] - If true, prevent the 'initStateUpdate' event listener.
 * @param {boolean} [options.preventStateUpdateListener] - If true, prevent the 'stateUpdate' event listener.
 * @returns {boolean} - If returns false, it breaks the update function
 */ const $196ad7400dcaf39e$var$inheritStateUpdates = (element, options)=>{
    const { __ref: ref } = element;
    const stateKey = ref.__state;
    const { parent: parent, state: state } = element;
    const { preventUpdateTriggerStateUpdate: preventUpdateTriggerStateUpdate, isHoisted: isHoisted, execStateFunction: execStateFunction } = options;
    if (preventUpdateTriggerStateUpdate) return;
    // If does not have own state inherit from parent
    if (!stateKey && !ref.__hasRootState) {
        element.state = parent && parent.state || {};
        return;
    }
    // If state is function, decide execution and apply setting a current state
    const shouldForceFunctionState = (0, $EqHTq.isFunction)(stateKey) && !isHoisted && execStateFunction;
    if (shouldForceFunctionState) {
        const execState = (0, $8wu6n.exec)(stateKey, element);
        state.set(execState, {
            ...options,
            preventUpdate: true,
            preventStateUpdateListener: false,
            updatedByStateFunction: true
        });
        return;
    }
    // If state is string, find its value in the state tree
    const keyInParentState = (0, $5fcb062e9eb35754$export$487549069bb5d2a9)(element, element.parent);
    if (!keyInParentState || options.preventInheritedStateUpdate) return;
    // Trigger on.initStateUpdate event
    if (!options.preventInitStateUpdateListener) {
        const initStateReturns = (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("initStateUpdate", keyInParentState, element, options);
        if (initStateReturns === false) return element;
    }
    // Recreate the state again
    const newState = $196ad7400dcaf39e$var$createStateUpdate(element, parent, options);
    // Trigger on.stateUpdate event
    if (!options.preventStateUpdateListener) (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("stateUpdate", newState.parse(), element, options);
};
const $196ad7400dcaf39e$var$createStateUpdate = (element, parent, options)=>{
    const __stateChildren = element.state.__children;
    const newState = (0, $774f1a3b2fe82710$export$e6a0daad8304de)(element, parent);
    element.state = newState;
    for(const child in __stateChildren){
        // check this for inherited states
        if (newState[child]) newState.__children[child] = __stateChildren[child];
        __stateChildren[child].parent = newState;
    }
    return newState;
};
var $196ad7400dcaf39e$export$2e2bcd8739ae039 = $196ad7400dcaf39e$var$update;




"use strict";
const $6587d89a5cc3b917$export$626ce79af72fc3d3 = (element, parent)=>{
    const proto = {
        set: (0, $bf937aebc888d68f$export$2e2bcd8739ae039).bind(element),
        update: (0, $196ad7400dcaf39e$export$2e2bcd8739ae039).bind(element),
        remove: (0, $d61abc47c39ce5ac$export$cd7f480d6b8286c3).bind(element),
        updateContent: (0, $0a7669919424e35c$export$5143cc956eb9d8f6).bind(element),
        removeContent: (0, $0a7669919424e35c$export$6e1d9b0d0e1e1def).bind(element),
        setProps: (0, $d61abc47c39ce5ac$export$938ca3893886de06).bind(element),
        lookup: (0, $d61abc47c39ce5ac$export$dfc7155ac0343b8).bind(element),
        spotByPath: (0, $d61abc47c39ce5ac$export$cec27f102c074405).bind(element),
        parse: (0, $d61abc47c39ce5ac$export$98e6a39c04603d36).bind(element),
        parseDeep: (0, $d61abc47c39ce5ac$export$3ed0fe0c6a5387e2).bind(element),
        keys: (0, $d61abc47c39ce5ac$export$ed97f33186d4b816).bind(element),
        nextElement: (0, $d61abc47c39ce5ac$export$e87a5caa96444a37).bind(element),
        previousElement: (0, $d61abc47c39ce5ac$export$1facc1d780a4d839).bind(element)
    };
    if ((0, $jOLBF.isDevelopment)()) proto.log = (0, $d61abc47c39ce5ac$export$bef1f36f5486a6a3).bind(element);
    Object.setPrototypeOf(element, proto);
};




parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $NWrSd = parcelRequire("NWrSd");
var $EqHTq = parcelRequire("EqHTq");
var $cPMIO = parcelRequire("cPMIO");


"use strict";
const $947d5c063e68e91c$var$ENV = "production";
/**
 * Creating a domQL element using passed parameters
 */ const $947d5c063e68e91c$var$create = (element, parent, key, options = (0, $ad3d3b247d47f3a2$export$2e2bcd8739ae039).create || {}, attachOptions)=>{
    $947d5c063e68e91c$var$cacheOptions(element, options);
    // if (key === 'Title') debugger
    // if element is STRING
    if ($947d5c063e68e91c$var$checkIfPrimitive(element)) element = $947d5c063e68e91c$var$applyValueAsText(element, parent, key);
    element = $947d5c063e68e91c$var$redefineElement(element, parent, key, options);
    parent = $947d5c063e68e91c$var$redefineParent(element, parent, key);
    key = $947d5c063e68e91c$var$createKey(element, parent, key);
    const ref = $947d5c063e68e91c$var$addRef(element, parent, key);
    // assign initial props
    ref.__initialProps = (0, $8wu6n.deepClone)(element.props, []);
    // assign context
    $947d5c063e68e91c$var$applyContext(element, parent, options);
    (0, $a6bfc6202982ac85$export$fd6b2f481ffc7974)(element, parent, options);
    if (!ref.__skipCreate) // create EXTEND inheritance
    (0, $3bff1c984b824aeb$export$f20941eae6723bcc)(element, parent, options);
    // create and assign a KEY
    element.key = key;
    // Only resolve extends, skip everything else
    if (options.onlyResolveExtends) return $947d5c063e68e91c$var$onlyResolveExtends(element, parent, key, options);
    $947d5c063e68e91c$var$switchDefaultOptions(element, parent, options);
    $947d5c063e68e91c$var$addCaching(element, parent);
    (0, $6587d89a5cc3b917$export$626ce79af72fc3d3)(element, parent);
    $947d5c063e68e91c$var$createScope(element, parent);
    (0, $774f1a3b2fe82710$export$e6a0daad8304de)(element, parent);
    if (element.scope === "state") element.scope = element.state;
    $947d5c063e68e91c$var$createIfConditionFlag(element, parent);
    // apply props settings
    (0, $e818f1ed291a38e8$export$c94ea207b45fef3a)(element, parent);
    if (element.scope === "props" || element.scope === true) element.scope = element.props;
    // recatch if it passess props again
    $947d5c063e68e91c$var$createIfConditionFlag(element, parent);
    // if it already HAS a NODE
    if (element.node && ref.__if) return (0, $98807bf18bc93fb3$export$4f2a718cb234b42f)(element, parent, key, attachOptions);
    // apply variants
    (0, $a6bfc6202982ac85$export$f1439fc936ef702f)(element, parent);
    const onInit = (0, $33936e69aa63c9cd$export$1bc010482b845252)("init", element, options);
    if (onInit === false) return element;
    (0, $33936e69aa63c9cd$export$1bc010482b845252)("beforeClassAssign", element, options);
    // generate a CLASS name
    (0, $6a43953e96d89b45$export$d559e9a3b71405f6)(element);
    $947d5c063e68e91c$var$renderElement(element, parent, options, attachOptions);
    $947d5c063e68e91c$var$addElementIntoParentChildren(element, parent);
    (0, $33936e69aa63c9cd$export$1bc010482b845252)("complete", element, options);
    return element;
};
const $947d5c063e68e91c$var$createBasedOnType = (element, parent, key, options)=>{
    // if ELEMENT is not given
    if (element === undefined) {
        if ($947d5c063e68e91c$var$ENV === "test" || $947d5c063e68e91c$var$ENV === "development") console.warn(key, "element is undefined in", parent && parent.__ref && parent.__ref.path);
        return {};
    }
    if ((0, $EqHTq.isString)(key) && key.slice(0, false)) {
        if ($947d5c063e68e91c$var$ENV === "test" || $947d5c063e68e91c$var$ENV === "development") console.warn(key, "seems like to be in __ref");
    }
    if (element === null) return;
    if (element === true) return {
        text: true
    };
    // if element is extend
    if (element.__hash) return {
        extend: element
    };
    return element;
};
const $947d5c063e68e91c$var$redefineElement = (element, parent, key, options)=>{
    const elementWrapper = $947d5c063e68e91c$var$createBasedOnType(element, parent, key, options);
    if (options.syntaxv3 || element.props?.syntaxv3) return (0, $a6bfc6202982ac85$export$2cbc234431a4ef8)(element, parent, key, options);
    else if ((0, $a6bfc6202982ac85$export$b791484194c5fc38)(key)) return (0, $a6bfc6202982ac85$export$2279e5e6b0817ddc)(elementWrapper, parent, key);
    // TODO: move as define plugins
    // Responsive rendering
    if ($947d5c063e68e91c$var$checkIfMedia(key)) return $947d5c063e68e91c$var$applyMediaProps(elementWrapper, parent, key);
    return elementWrapper;
};
const $947d5c063e68e91c$var$redefineParent = (element, parent, key, options)=>{
    if (!parent) return 0, $80563b8eaf6ba844$export$fbea82a1c0574ef4;
    if ((0, $cPMIO.isNode)(parent)) {
        const parentNodeWrapper = {
            key: ":root",
            node: parent
        };
        (0, $80563b8eaf6ba844$export$fbea82a1c0574ef4)[`${key}_parent`] = parentNodeWrapper;
        return parentNodeWrapper;
    }
    return parent;
};
const $947d5c063e68e91c$var$cacheOptions = (element, options)=>{
    if (options && !(0, $ad3d3b247d47f3a2$export$2e2bcd8739ae039).create) {
        (0, $ad3d3b247d47f3a2$export$2e2bcd8739ae039).create = options;
        (0, $ad3d3b247d47f3a2$export$2e2bcd8739ae039).create.context = element.context || options.context;
    }
};
const $947d5c063e68e91c$var$createKey = (element, parent, key)=>{
    return ((0, $8wu6n.exec)(key, element) || key || element.key || (0, $NWrSd.generateKey)()).toString();
};
const $947d5c063e68e91c$var$addRef = (element, parent)=>{
    if (element.__ref) element.__ref.origin = element;
    else element.__ref = {
        origin: element
    };
    return element.__ref;
};
const $947d5c063e68e91c$var$switchDefaultOptions = (element, parent, options)=>{
    if (Object.keys(options).length) {
        (0, $782cf63e523d0885$export$2e2bcd8739ae039).defaultOptions = options;
        if (options.ignoreChildExtend) delete options.ignoreChildExtend;
    }
};
const $947d5c063e68e91c$var$addElementIntoParentChildren = (element, parent)=>{
    if (parent.__ref && parent.__ref.__children) parent.__ref.__children.push(element.key);
};
const $947d5c063e68e91c$var$renderElement = (element, parent, options, attachOptions)=>{
    const { __ref: ref, key: key } = element;
    // CREATE a real NODE
    (0, $4e214d02be0ddce7$export$2e2bcd8739ae039)(element, options);
    if (!ref.__if) {
        parent[key || element.key] = element;
        return element;
    }
    // assign NODE
    (0, $98807bf18bc93fb3$export$4f2a718cb234b42f)(element, parent, key, attachOptions);
    // run `on.renderRouter`
    (0, $33936e69aa63c9cd$export$1bc010482b845252)("renderRouter", element, options);
    // run `on.render`
    (0, $33936e69aa63c9cd$export$1bc010482b845252)("render", element, options);
};
const $947d5c063e68e91c$var$checkIfPrimitive = (element)=>(0, $EqHTq.is)(element)("string", "number");
const $947d5c063e68e91c$var$applyValueAsText = (element, parent, key)=>{
    const extendTag = element.extend && element.extend.tag;
    const childExtendTag = parent.childExtend && parent.childExtend.tag;
    const isKeyValidHTMLTag = (0, $89442055fcdd5e8d$export$de435b1ae0c975f3).body.indexOf(key) > -1 && key;
    return {
        text: element,
        tag: extendTag || childExtendTag || isKeyValidHTMLTag || "string"
    };
};
const $947d5c063e68e91c$var$applyContext = (element, parent, options)=>{
    const forcedOptionsContext = options.context && !(0, $80563b8eaf6ba844$export$fbea82a1c0574ef4).context && !element.context;
    if (forcedOptionsContext) (0, $80563b8eaf6ba844$export$fbea82a1c0574ef4).context = options.context;
    // inherit from parent or root
    if (!element.context) element.context = parent.context || options.context || (0, $80563b8eaf6ba844$export$fbea82a1c0574ef4).context;
};
// Create scope - shared object across the elements to the own or the nearest parent
const $947d5c063e68e91c$var$createScope = (element, parent)=>{
    const { __ref: ref } = element;
    // If the element doesn't have a scope, initialize it using the parent's scope or the root's scope.
    if (!element.scope) element.scope = parent.scope || ref.__root.scope || {};
};
const $947d5c063e68e91c$var$createIfConditionFlag = (element, parent)=>{
    const { __ref: ref } = element;
    if ((0, $EqHTq.isFunction)(element.if) && !element.if(element, element.state)) delete ref.__if;
    else ref.__if = true;
};
const $947d5c063e68e91c$var$addCaching = (element, parent)=>{
    const { __ref: ref } = element;
    let { __ref: parentRef } = parent;
    // enable TRANSFORM in data
    if (!element.transform) element.transform = {};
    // enable CACHING
    if (!ref.__cached) ref.__cached = {};
    if (!ref.__defineCache) ref.__defineCache = {};
    // enable EXEC
    if (!ref.__exec) ref.__exec = {};
    // enable CLASS CACHING
    if (!ref.__class) ref.__class = {};
    if (!ref.__classNames) ref.__classNames = {};
    // enable CLASS CACHING
    if (!ref.__attr) ref.__attr = {};
    // enable CHANGES storing
    if (!ref.__changes) ref.__changes = [];
    // enable CHANGES storing
    if (!ref.__children) ref.__children = [];
    // Add _root element property
    const hasRoot = parent && parent.key === ":root";
    if (!ref.__root) ref.__root = hasRoot ? element : parentRef.__root;
    // set the PATH array
    if ($947d5c063e68e91c$var$ENV === "test" || $947d5c063e68e91c$var$ENV === "development") {
        if (!parentRef) parentRef = parent.ref = {};
        if (!parentRef.__path) parentRef.__path = [];
        ref.__path = parentRef.__path.concat(element.key);
    }
};
const $947d5c063e68e91c$var$onlyResolveExtends = (element, parent, key, options)=>{
    const { __ref: ref } = element;
    if (!ref.__skipCreate) {
        element.tag = (0, $01ef634a92434650$export$5075bd4eae016d2c)(element);
        // if (!element.props) element.props = {}
        // Copy-paste of addCaching()
        // enable CACHING
        if (!ref.__cached) ref.__cached = {};
        if (!ref.__defineCache) ref.__defineCache = {};
        // enable EXEC
        if (!ref.__exec) ref.__exec = {};
        // enable CLASS CACHING
        if (!ref.__class) ref.__class = {};
        if (!ref.__classNames) ref.__classNames = {};
        // enable CLASS CACHING
        if (!ref.__attr) ref.__attr = {};
        // enable CHANGES storing
        if (!ref.__changes) ref.__changes = [];
        // enable CHANGES storing
        if (!ref.__children) ref.__children = [];
        // Add __root element property
        // const hasRoot = parent && parent.key === ':root'
        // if (!ref.__root) ref.__root = hasRoot ? element : parentRef.__root
        (0, $6587d89a5cc3b917$export$626ce79af72fc3d3)(element, parent);
        (0, $774f1a3b2fe82710$export$e6a0daad8304de)(element, parent);
        // Borrowed from createIfConditionFlag()
        if ((0, $EqHTq.isFunction)(element.if)) {
            const ifPassed = element.if(element, element.state);
            if (!ifPassed) // const ifFragment = cacheNode({ tag: 'fragment' })
            // ref.__ifFragment = appendNode(ifFragment, parent.node)
            delete ref.__if;
            else ref.__if = true;
        } else ref.__if = true;
        /// ///
        if (element.node && ref.__if) parent[key || element.key] = element;
         // Borrowed from assignNode()
        (0, $e818f1ed291a38e8$export$c94ea207b45fef3a)(element, parent);
        if (!element.props) element.props = {};
        (0, $a6bfc6202982ac85$export$f1439fc936ef702f)(element, parent);
    }
    if (element.tag !== "string" && element.tag !== "fragment") {
        (0, $0513b3ed7d5404ec$export$b4c781127351659b)(element);
        (0, $0513b3ed7d5404ec$export$3223a9877c540db8)(element);
        for(const k in element){
            if ((0, $EqHTq.isUndefined)(element[k]) || (0, $d61abc47c39ce5ac$export$ed2133acb96eb5aa)(k) || (0, $EqHTq.isObject)((0, $782cf63e523d0885$export$2e2bcd8739ae039)[k]) || (0, $a6bfc6202982ac85$export$53cd1a145c393044)(k)) continue;
            const hasDefine = element.define && element.define[k];
            const contextHasDefine = element.context && element.context.define && element.context.define[k];
            const optionsHasDefine = options.define && options.define[k];
            if (!ref.__skipCreate && (0, $782cf63e523d0885$export$2e2bcd8739ae039)[k] && !optionsHasDefine) continue;
            else if (element[k] && !hasDefine && !optionsHasDefine && !contextHasDefine) $947d5c063e68e91c$var$create((0, $8wu6n.exec)(element[k], element), element, k, options);
        }
    }
    parent[key || element.key] = element // Borrowed from assignNode()
    ;
    delete element.update;
    delete element.__element;
    // added by createProps
    if (element.props) {
        delete element.props.update;
        delete element.props.__element;
    }
    return element;
};
const $947d5c063e68e91c$var$checkIfMedia = (key)=>key.slice(0, 1) === "@";
const $947d5c063e68e91c$var$applyMediaProps = (element, parent, key)=>{
    const { props: props } = element;
    if (props) {
        props.display = "none";
        if (props[key]) props[key].display = props.display;
        else props[key] = {
            display: props.display || "block"
        };
        return element;
    } else return {
        ...element,
        props: {
            display: "none",
            [key]: {
                display: "block"
            }
        }
    };
};
var $947d5c063e68e91c$export$2e2bcd8739ae039 = $947d5c063e68e91c$var$create;





"use strict";
var $dd5b413a87318846$export$2e2bcd8739ae039 = (params, options = {})=>{
    const { overwrite: overwrite } = options;
    for(const param in params)if ((0, $782cf63e523d0885$export$2e2bcd8739ae039)[param] && !overwrite) (0, $06908963bda72849$export$f18d5b0af29128b7)("OverwriteToBuiltin", param);
    else (0, $782cf63e523d0885$export$2e2bcd8739ae039)[param] = params[param];
};




"use strict";


"use strict";
const $07fce7224ceb45c2$var$create = (element, parent, key, options)=>{
    // createState
    // createNode
    return (0, $947d5c063e68e91c$export$2e2bcd8739ae039)(element, parent, key, options);
};
var $07fce7224ceb45c2$export$2e2bcd8739ae039 = {
    TREE: $80563b8eaf6ba844$export$33ecaa422889cd80,
    create: $07fce7224ceb45c2$var$create
};


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");




parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $jOLBF = parcelRequire("jOLBF");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $ef00d6a2421ef52f$export$990fa93f2c5a3271 = (element)=>{
    const { key: key } = element;
    if (element.class === true) element.class = key;
    else if (!element.class && typeof key === "string" && key.charAt(0) === "_" && key.charAt(1) !== "_") element.class = key.slice(1);
};
const $ef00d6a2421ef52f$export$b04d9b8d414ba5e8 = (obj, element)=>{
    let className = "";
    for(const item in obj){
        const param = obj[item];
        if (typeof param === "boolean" && param) className += ` ${item}`;
        else if (typeof param === "string") className += ` ${param}`;
        else if (typeof param === "function") className += ` ${(0, $8wu6n.exec)(param, element)}`;
    }
    return className;
};
const $ef00d6a2421ef52f$export$11c615ce16f87241 = (params, element)=>{
    if (!params) return;
    const { key: key } = element;
    if (params === true) params = element.class = {
        key: key
    };
    if ((0, $EqHTq.isString)(params)) params = element.class = {
        default: params
    };
    if ((0, $EqHTq.isObject)(params)) params = $ef00d6a2421ef52f$export$b04d9b8d414ba5e8(params, element);
    // TODO: fails on string
    const className = params.replace(/\s+/g, " ").trim();
    if (element.ref) element.ref.class = className // TODO: this check is NOT needed in new DOMQL
    ;
    return className;
};
const $ef00d6a2421ef52f$export$e8f750c9f10c0a7b = (params, element, node)=>{
    const className = $ef00d6a2421ef52f$export$11c615ce16f87241(params, element);
    node.classList = className;
    return className;
};



"use strict";
const $a03ad4de26254f62$export$c79b0dc85ccca679 = (emotion)=>{
    return (params, element, state)=>{
        const execParams = (0, $8wu6n.exec)(params, element);
        if (params) {
            if ((0, $EqHTq.isObjectLike)(element.class)) element.class.elementStyle = execParams;
            else element.class = {
                elementStyle: execParams
            };
        }
        $a03ad4de26254f62$export$62b33bcc98e42249(emotion)(element.class, element, element.state, true);
    };
};
const $a03ad4de26254f62$export$62b33bcc98e42249 = (emotion)=>{
    return (params, element, state, flag)=>{
        if (element.style && !flag) return;
        const { __ref: __ref } = element;
        const { __class: __class, __classNames: __classNames } = __ref;
        if (!(0, $EqHTq.isObjectLike)(params)) return;
        if (element.props.class) __classNames.classProps = element.props.class;
        if (element.attr.class) __classNames.class = element.attr.class;
        for(const key in params){
            const prop = (0, $8wu6n.exec)(params[key], element);
            if (!prop) {
                delete __class[key];
                delete __classNames[key];
                continue;
            }
            const isEqual = (0, $8wu6n.isEqualDeep)(__class[key], prop);
            if (!isEqual) {
                if (!(0, $jOLBF.isProduction)() && (0, $EqHTq.isObject)(prop)) prop.label = key || element.key;
                const CSSed = emotion.css(prop);
                __class[key] = prop;
                __classNames[key] = CSSed;
            }
        }
        (0, $ef00d6a2421ef52f$export$e8f750c9f10c0a7b)(__classNames, element, element.node);
    // return element.class
    };
};
const $a03ad4de26254f62$export$23627aa597d6e60c = (emotion, options)=>{
    if (!emotion) emotion = (0, $f80ae5e019588f18$export$2e2bcd8739ae039)(options || {
        key: "smbls"
    });
    return {
        style: $a03ad4de26254f62$export$c79b0dc85ccca679(emotion),
        class: $a03ad4de26254f62$export$62b33bcc98e42249(emotion)
    };
};




parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");


"use strict";
const $0cb0e0c91cc6836f$export$e567b959eb9cc2cc = (key, options = {})=>{
    const doc = options.parent || options.document || document;
    const initOptions = options.initOptions || {};
    const emotion = initOptions.emotion;
    if (!initOptions.emotion) initOptions.emotion = (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    const registry = options.registry || (0, $a03ad4de26254f62$export$23627aa597d6e60c)(initOptions.emotion, options);
    const defaultDesignSystem = (0, $8wu6n.deepClone)((0, $812d27f1e77a76ab$export$2e2bcd8739ae039));
    const designSystem = initOptions.useDefaultConfig ? (0, $8wu6n.deepMerge)(options.designSystem, defaultDesignSystem) : options.designSystem || defaultDesignSystem;
    const scratchSystem = (0, $31242768b5023c84$export$2cd8252107eb640b)(designSystem, {
        key: key,
        emotion: emotion,
        verbose: options.verbose,
        document: doc,
        ...(0, $d5fc17b4ecb94b3e$export$882cd4124a942c79),
        ...initOptions
    });
    return [
        scratchSystem,
        emotion,
        registry
    ];
};




"use strict";
const $f46ec85bc7cd1647$var$checkIfKeyIsComponent = (key)=>{
    const isFirstKeyString = (0, $EqHTq.isString)(key);
    if (!isFirstKeyString) return;
    const firstCharKey = key.slice(0, 1);
    return /^[A-Z]*$/.test(firstCharKey);
};
const $f46ec85bc7cd1647$export$17aa062053a6ac51 = ()=>{
    const newObj = {};
    for(const key in $be006f1a0fabd945$exports)if (Object.prototype.hasOwnProperty.call($be006f1a0fabd945$exports, key)) {
        if ($f46ec85bc7cd1647$var$checkIfKeyIsComponent(key)) newObj[`smbls.${key}`] = $be006f1a0fabd945$exports[key];
        else newObj[key] = $be006f1a0fabd945$exports[key];
    }
    return newObj;
};
const $f46ec85bc7cd1647$export$4f2633f1ff10978c = (options)=>{
    return options.components ? {
        ...$f46ec85bc7cd1647$export$17aa062053a6ac51(),
        ...options.components
    } : $f46ec85bc7cd1647$export$17aa062053a6ac51();
};
const $f46ec85bc7cd1647$export$348dc3ccba7d17b1 = (options)=>{
    return {
        ...$2a60ce89a661a6b2$exports,
        ...$2a60ce89a661a6b2$exports.scratchUtils,
        ...options.snippets || options.utils || {}
    };
};
const $f46ec85bc7cd1647$export$d54de307475be07a = (options, key)=>{
    const [scratcDesignhSystem, emotion, registry] = (0, $0cb0e0c91cc6836f$export$e567b959eb9cc2cc)(key, options);
    return [
        scratcDesignhSystem,
        emotion,
        registry
    ];
};
const $f46ec85bc7cd1647$export$beb986ec1c64324 = (options, App)=>{
    const state = {};
    if (options.state) $2a60ce89a661a6b2$exports.deepMerge(state, options.state);
    if (App && App.state) (0, $8wu6n.deepMerge)(state, App.state);
    return (0, $8wu6n.deepCloneWithExtnd)(state);
};
const $f46ec85bc7cd1647$export$b2f7e94520d001d1 = (options)=>{
    return options.pages || {};
};
const $f46ec85bc7cd1647$export$b2b7a41b0a3bae42 = (options)=>{
    if (typeof document === "undefined") {
        if (typeof window === "undefined") window = {} // eslint-disable-line
        ;
        if (!window.document) window.document = {
            body: {}
        };
        document = window.document // eslint-disable-line
        ;
    }
    return options.parent || options.document || document;
};


"use strict";
const $a04f9f910a252074$var$SYMBOLS_KEY = undefined;
const $a04f9f910a252074$export$b5b313bfdabf2fb4 = (App, options)=>{
    const key = options.key || $a04f9f910a252074$var$SYMBOLS_KEY || ((0, $EqHTq.isString)(App) ? App : "");
    const [scratcDesignSystem, emotion, registry] = (0, $f46ec85bc7cd1647$export$d54de307475be07a)(options, key);
    if ((0, $EqHTq.isString)(App)) App = {};
    const doc = (0, $f46ec85bc7cd1647$export$b2b7a41b0a3bae42)(options);
    const state = (0, $f46ec85bc7cd1647$export$beb986ec1c64324)(options, App);
    const pages = (0, $f46ec85bc7cd1647$export$b2f7e94520d001d1)(options);
    const components = (0, $f46ec85bc7cd1647$export$4f2633f1ff10978c)(options);
    const designSystem = scratcDesignSystem;
    const snippets = (0, $f46ec85bc7cd1647$export$348dc3ccba7d17b1)(options);
    const define = options.define || (0, $596256ead72518a6$export$6588fc50c67b09a2);
    const routerOptions = (0, $4747ce2ab72764ea$export$cf7ee87ede64229c)(App, options) // eslint-disable-line
    ;
    const extend = (0, $5b6a3972014f3e94$export$ca717cfcb724fd64)([
        App
    ], options);
    return ((0, $07fce7224ceb45c2$export$2e2bcd8739ae039).default && (0, $07fce7224ceb45c2$export$2e2bcd8739ae039).default.create || (0, $07fce7224ceb45c2$export$2e2bcd8739ae039).create)({
        extend: extend,
        routes: options.pages,
        state: state,
        context: {
            key: key,
            components: components,
            state: state,
            pages: pages,
            designSystem: designSystem,
            snippets: snippets,
            functions: options.functions,
            files: options.files,
            utils: snippets,
            define: define,
            registry: registry,
            emotion: emotion,
            routerOptions: routerOptions,
            document: doc
        }
    }, doc.body, key, {
        extend: [
            $c95c6861d219ec8a$export$e71c4d32a2263218
        ],
        verbose: options.verbose,
        ...options.domqlOptions
    });
};


"use strict";
const $22cae8e82746fd5e$var$SYMBOLS_KEY = undefined;
const $22cae8e82746fd5e$var$mergeWithLocalFile = (options, optionsExternalFile)=>{
    const rcfile = (0, $EqHTq.isObject)(optionsExternalFile) ? optionsExternalFile : (0, (/*@__PURE__*/$parcel$interopDefault($0e6c01aab9a4ae9b$exports))) || {};
    return (0, $8wu6n.deepMerge)(options, rcfile);
};
const $22cae8e82746fd5e$export$185802fd694ee1f5 = (App, options = (0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039), optionsExternalFile)=>{
    const redefinedOptions = {
        ...(0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039),
        ...$22cae8e82746fd5e$var$mergeWithLocalFile(options, optionsExternalFile)
    };
    const domqlApp = (0, $a04f9f910a252074$export$b5b313bfdabf2fb4)(App, redefinedOptions);
    (0, $5b6a3972014f3e94$export$a0eecf521ca4df6c)(domqlApp, redefinedOptions);
    (0, $4747ce2ab72764ea$export$423945072aa2156)(domqlApp, redefinedOptions);
    if (redefinedOptions.on && redefinedOptions.on.create) redefinedOptions.on.create(domqlApp, redefinedOptions);
    return domqlApp;
};
const $22cae8e82746fd5e$export$fa0abf86dcc47d66 = (App, options = (0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039), optionsExternalFile)=>{
    const redefinedOptions = {
        ...(0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039),
        ...$22cae8e82746fd5e$var$mergeWithLocalFile(options, optionsExternalFile)
    };
    const domqlApp = (0, $a04f9f910a252074$export$b5b313bfdabf2fb4)(App, redefinedOptions);
    (0, $5b6a3972014f3e94$export$a0eecf521ca4df6c)(domqlApp, redefinedOptions);
    (0, $4747ce2ab72764ea$export$423945072aa2156)(domqlApp, redefinedOptions);
    if (redefinedOptions.on && redefinedOptions.on.create) redefinedOptions.on.create(domqlApp, redefinedOptions);
    const key = options.key || $22cae8e82746fd5e$var$SYMBOLS_KEY;
    (0, $5e586daec44b56de$export$beca342e15b450be)(domqlApp, key, {
        utils: $2a60ce89a661a6b2$exports,
        ...redefinedOptions
    });
    return domqlApp;
};
const $22cae8e82746fd5e$export$df2a74307fafca3b = async (App, options = (0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039), optionsExternalFile)=>{
    const redefinedOptions = {
        ...(0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039),
        ...$22cae8e82746fd5e$var$mergeWithLocalFile(options, optionsExternalFile)
    };
    const key = options.key || $22cae8e82746fd5e$var$SYMBOLS_KEY;
    await (0, $5e586daec44b56de$export$8946d631417d8ced)(key, redefinedOptions);
    const domqlApp = (0, $a04f9f910a252074$export$b5b313bfdabf2fb4)(App, redefinedOptions);
    if (redefinedOptions.on && redefinedOptions.on.create) redefinedOptions.on.create(domqlApp, redefinedOptions);
    return domqlApp;
};
var $22cae8e82746fd5e$export$2e2bcd8739ae039 = $22cae8e82746fd5e$export$185802fd694ee1f5;



"use strict";
 // export * from '@symbo.ls/socket/client' // TODO: Check with @nikoloza
 // export * from '@symbo.ls/socket-ui' // TODO: add it soon


"use strict";
var $5cd95e4506904c32$export$2e2bcd8739ae039 = {
    COLOR: {
        trendyPink: "#81548c",
        espresso: "#5b251d",
        grayChateau: "#a3a8ab",
        charm: "#ff79a5",
        azure: "#2b63a9",
        black: "#000",
        white: "#fff",
        light: "#BDBDC1",
        gray: "#6e6e72",
        dark: "#000",
        primary: [
            "--espresso",
            "--charm"
        ]
    },
    GRADIENT: {},
    THEME: {
        document: {
            "@light": {
                color: "dark",
                background: "espresso"
            },
            "@dark": {
                color: "white",
                background: "dark"
            }
        },
        primary: {}
    },
    FONT: {
        Avenir: [
            {
                url: "https://based-files-production.based.dev/enD5U3P7x0/fifc633c27/c36ede7c-ed5f-4b99-9656-45690e2b6904-4eb228d0-4cd5-46ee-9f3b-e28e6a950cf5-3066dc0e-9e3d-4d50-80b8-4593025ba75b.woff",
                fontWeight: "300"
            },
            {
                url: "https://based-files-production.based.dev/enD5U3P7x0/fi1e7dbb26/33b58b34-f081-4085-9913-cfb690a181f6-b775a155-bfe9-4962-9e53-0907a5e1ea3a-7aad4efa-fa6e-4f5f-88ad-9512c582423f.woff",
                fontWeight: "500"
            },
            {
                url: "https://based-files-production.based.dev/enD5U3P7x0/fif85e0382/4efd15a3-196e-49f5-9b62-8199bfd524bc-7925aba8-c377-4883-8f68-597bb6fdf5a5-42b78bf8-38d3-4aa5-bd07-febb7ce311ee.woff",
                fontWeight: "700"
            }
        ],
        Press: [
            {
                url: "https://fonts.gstatic.com/s/pressstart2p/v15/e3t4euO8T-267oIAQAu6jDQyK3nVivNm4I81.woff2",
                fontWeight: "400"
            }
        ]
    },
    FONT_FAMILY: {
        def: {
            type: "serif",
            value: [
                "Press",
                "Avenir"
            ]
        },
        game: {
            type: "serif",
            value: [
                "Press"
            ]
        },
        ui: {
            type: "serif",
            value: [
                "Avenir"
            ]
        }
    },
    TYPOGRAPHY: {
        base: 16,
        ratio: 1.25,
        subSequence: true,
        templates: {
            h1: {},
            h2: {},
            h3: {},
            h4: {},
            h5: {},
            h6: {},
            body: {}
        },
        "@screenL<": {
            base: 17
        },
        "@screenL": {
            base: 16
        },
        "@tabletS": {
            base: 15,
            ratio: 1.2
        },
        "@mobileM": {
            base: 14,
            ratio: 1.15
        },
        "@mobileS": {
            base: 13,
            ratio: 1.1
        }
    },
    SPACING: {
        base: 16,
        ratio: 1.618,
        subSequence: true,
        "@screenL<": {
            ratio: 1.717
        },
        "@mobileS": {
            ratio: 1.5
        },
        "@mobileXS": {
            ratio: 1.414
        }
    },
    TIMING: {
        base: 150,
        ratio: 1.333,
        subSequence: true
    },
    ANIMATION: {
        pacman: {
            "0%": {
                backgroundPosition: "80px 0"
            },
            "24.9%": {
                backgroundPosition: "80px 0"
            },
            "25%": {
                backgroundPosition: "40px 0"
            },
            "49.9%": {
                backgroundPosition: "40px 0"
            },
            "50%": {
                backgroundPosition: "0px 0"
            },
            "74.9%": {
                backgroundPosition: "0px 0"
            },
            "75%": {
                backgroundPosition: "120px 0"
            },
            "100%": {
                backgroundPosition: "120px 0"
            }
        },
        pinky: {
            "0%": {
                backgroundPosition: "38px 0"
            },
            "49.9%": {
                backgroundPosition: "38px 0"
            },
            "50%": {
                backgroundPosition: "0px 0"
            },
            "100%": {
                backgroundPosition: "0 0"
            }
        },
        cherry: {
            "0%": {
                opacity: 1
            },
            "49.9%": {
                opacity: 1
            },
            "50%": {
                opacity: 0.65
            },
            "100%": {
                opacity: 0.65
            }
        }
    },
    RESET: {},
    ICONS: {
        play: '<svg xmlns="http://www.w3.org/2000/svg" id="mdi-play" viewBox="0 0 24 24"><path d="M8,5.14V19.14L19,12.14L8,5.14Z" /></svg>',
        pause: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M4.75 3A1.75 1.75 0 0 0 3 4.75v14.5c0 .966.784 1.75 1.75 1.75h14.5A1.75 1.75 0 0 0 21 19.25V4.75A1.75 1.75 0 0 0 19.25 3H4.75Z"/></svg>',
        stop: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5.746 3a1.75 1.75 0 0 0-1.75 1.75v14.5c0 .966.784 1.75 1.75 1.75h3.5a1.75 1.75 0 0 0 1.75-1.75V4.75A1.75 1.75 0 0 0 9.246 3h-3.5ZM14.746 3a1.75 1.75 0 0 0-1.75 1.75v14.5c0 .966.784 1.75 1.75 1.75h3.5a1.75 1.75 0 0 0 1.75-1.75V4.75A1.75 1.75 0 0 0 18.246 3h-3.5Z"/></svg>',
        clear: '<svg xmlns="http://www.w3.org/2000/svg" id="mdi-close" viewBox="0 0 24 24"><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" /></svg>',
        staub: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M2.28588419,8.75037458 L2.37465854,8.83846341 L2.36161561,8.82589308 L2.36161561,8.8403321 L2.36200585,8.8883321 L2.36473756,9.07877112 L2.36551805,9.12638088 L2.36590829,9.15018576 L2.36590829,9.16345405 L2.29971317,9.22925893 L2.27665854,9.25046341 L2.26756683,9.25086868 L2.17195707,9.25242966 L1.98190829,9.25555161 L1.60298146,9.26140527 L1.56265854,9.26146341 L1.56278634,9.21106381 L1.5623961,9.16423454 L1.46465854,9.25946341 L1.46561561,9.23330771 C1.41956683,9.22511259 1.49449366,9.12872234 1.47693268,9.14042966 C1.54054244,9.14316137 1.64122537,9.15018576 1.68376195,9.14394186 C1.65527415,9.150576 1.71459122,9.16579551 1.66190829,9.16696625 L1.70210341,9.17789308 C1.69624976,9.18530771 1.6611278,9.17555161 1.67361561,9.18452722 C1.7001522,9.18374673 1.77742049,9.17672234 1.80122537,9.17984429 C1.8503961,9.16891747 1.89566439,9.14862478 1.9748839,9.14628332 C1.93742049,9.15330771 1.99634732,9.16579551 1.97098146,9.16891747 L2.08181073,9.13496625 C2.10834732,9.13418576 2.08766439,9.14901503 2.12590829,9.1443321 C2.12395707,9.13964917 2.14073756,9.13652722 2.15205463,9.13262478 L2.21220098,9.13340527 C2.22607902,9.13384429 2.24001805,9.13477112 2.25121927,9.13668576 L2.26765854,9.14346341 C2.26571317,9.12335649 2.26151805,9.10355161 2.26366439,9.08579551 C2.26834732,9.05301503 2.25859122,8.99096625 2.24844488,9.02569795 L2.25390829,9.05028332 C2.24337171,9.02803942 2.24064,8.97184429 2.24064,8.92306381 C2.24337171,8.93945405 2.24805463,8.93789308 2.2531278,8.94413698 L2.24265854,8.87446341 L2.22391733,8.87442785 L2.20065854,8.87346341 L2.2115596,8.8692246 L2.21765854,8.86646341 L2.13151624,8.86490301 C2.0681522,8.86851638 2.0062335,8.87727519 1.95420098,8.8660882 C1.96707902,8.86452722 1.96083512,8.87779551 1.96005463,8.87545405 C1.91478634,8.87428332 1.91673756,8.86218576 1.88746927,8.86686868 C1.88434732,8.85984429 1.8503961,8.86921015 1.81995707,8.87116137 L1.799296,8.87078049 C1.73113756,8.87625015 1.6068839,8.8816199 1.52883512,8.87350283 C1.53078634,8.87818576 1.46873756,8.89067356 1.44649366,8.89028332 L1.45507902,8.87935649 L1.42865854,8.87546341 L1.44610341,8.87350283 L1.46865854,8.86946341 L1.44224976,8.87174673 L1.41965854,8.87346341 L1.39362284,8.87580093 L1.37478995,8.87545405 C1.34524705,8.87848928 1.31628228,8.88169795 1.28766439,8.87467356 C1.3001522,8.87662478 1.32434732,8.85945405 1.28805463,8.86023454 C1.22366439,8.86218576 1.26971317,8.86530771 1.21742049,8.86921015 L1.19765854,8.87146341 C1.19218878,8.900076 1.18527415,8.91701503 1.18659122,8.90355161 L1.17254244,8.894576 C1.17332293,8.92189308 1.18737171,8.93945405 1.19361561,8.96130771 C1.19244488,8.9648199 1.18932293,8.97223454 1.18737171,8.97067356 L1.1963839,8.98324064 L1.19582293,9.04042356 C1.19632293,9.05084429 1.19800585,9.0608199 1.20220098,9.06901503 C1.19478634,9.12677112 1.20181073,9.21535649 1.1881522,9.24267356 L1.19693268,9.30784429 L1.19665854,9.37646341 L1.1948839,9.36164917 C1.19390829,9.35662478 1.19264,9.35252722 1.19049366,9.35116137 C1.18385951,9.38277112 1.18971317,9.390576 1.19322537,9.41984429 C1.19010341,9.41321015 1.18034732,9.48306381 1.17293268,9.518576 C1.17956683,9.56267356 1.1908839,9.54745405 1.19790829,9.55174673 C1.17644488,9.59194186 1.21156683,9.67623454 1.19244488,9.72618576 C1.18971317,9.71096625 1.18190829,9.66179551 1.17683512,9.69886868 C1.15537171,9.73906381 1.19244488,9.78003942 1.18229854,9.8448199 L1.19985951,9.8288199 C1.18893268,9.85769795 1.2103961,9.92442966 1.19205463,9.91779551 C1.19868878,9.93964917 1.18620098,9.99428332 1.20337171,9.98725893 C1.18854244,10.0937955 1.21234732,10.2463809 1.1811278,10.3115516 C1.18385951,10.3267711 1.1811278,10.365015 1.18971317,10.3572101 C1.19946927,10.3318443 1.18307902,10.321698 1.18932293,10.3123321 C1.18971317,10.3259906 1.1943961,10.3291126 1.19673756,10.3302833 C1.19283512,10.3634541 1.19166439,10.3896004 1.17722537,10.3583809 C1.16668878,10.432137 1.20649366,10.4344784 1.19985951,10.528137 C1.19283512,10.5238443 1.19010341,10.5308687 1.19127415,10.558576 L1.20337171,10.6104784 C1.20064,10.6709662 1.18698146,10.6448199 1.1748839,10.6463809 C1.17683512,10.6787711 1.17644488,10.7181858 1.18542049,10.733015 L1.17020098,10.7724297 C1.1811278,10.7435516 1.17761561,10.7989662 1.18073756,10.8141858 L1.17761561,10.7989662 C1.17254244,10.8048199 1.17566439,10.8422833 1.17722537,10.8614053 C1.18216846,10.8582833 1.18520369,10.8402454 1.18737171,10.8224387 L1.18965854,10.7984634 L1.19507902,10.8277955 C1.19624976,10.8390638 1.19751805,10.8510638 1.20064,10.8621858 C1.18893268,10.8551614 1.19205463,10.9152589 1.19127415,10.9406248 C1.18854244,10.9702833 1.20181073,10.9737955 1.20142049,10.9823809 C1.19517659,10.9831614 1.20024976,11.0307711 1.19205463,11.0077467 C1.19010341,10.9976004 1.19790829,10.9847223 1.19244488,10.9679419 C1.18776195,10.9874541 1.17722537,10.9851126 1.18503024,11.025698 C1.1908839,11.056137 1.20844488,11.0178931 1.20103024,11.0756492 C1.19829854,11.0604297 1.19322537,11.057698 1.18893268,11.0459906 L1.18268878,11.1002345 L1.19361561,11.102576 C1.19985951,11.1240394 1.19205463,11.1907711 1.20493268,11.2028687 L1.20151805,11.2452101 L1.19565854,11.2834634 C1.18932293,11.3133077 1.19322537,11.3554541 1.20064,11.3819906 C1.19751805,11.3979906 1.19907902,11.4389662 1.20571317,11.4608199 C1.19751805,11.5049175 1.1651278,11.4756492 1.1783961,11.5240394 C1.17878634,11.5685272 1.19829854,11.5938931 1.20493268,11.5759419 C1.19751805,11.6559419 1.21546927,11.7472589 1.19829854,11.8214053 C1.20259122,11.8327223 1.20532293,11.825698 1.20805463,11.8495028 C1.20519285,11.9278118 1.21187035,12.0120177 1.2103961,12.0872047 L1.19965854,12.1894634 L1.19607902,12.1766797 C1.19205463,12.1712833 1.18737171,12.1892101 1.18268878,12.1897955 C1.19244488,12.2178931 1.17254244,12.2237467 1.18932293,12.2338931 C1.19907902,12.2311614 1.20376195,12.2338931 1.20766439,12.2007223 C1.2131278,12.2709662 1.2131278,12.3775028 1.20376195,12.4165272 C1.20805463,12.397015 1.21117659,12.4122345 1.21429854,12.4274541 C1.19868878,12.4223809 1.19634732,12.4742833 1.20181073,12.5133077 L1.21117659,12.5187711 L1.20142049,12.544137 C1.2041522,12.5593565 1.22132293,12.5605272 1.21195707,12.5995516 C1.20844488,12.6015028 1.20454244,12.6038443 1.20181073,12.6108687 C1.20961561,12.6514541 1.22249366,12.7084297 1.21468878,12.7525272 L1.20103024,12.7884297 C1.20259122,12.8071614 1.21078634,12.8387711 1.21468878,12.8056004 C1.20649366,12.8809175 1.20532293,12.9289175 1.19322537,12.9527223 C1.22249366,13.0818931 1.22366439,13.2696004 1.22132293,13.4198443 C1.20766439,13.4557467 1.22678634,13.4362345 1.22171317,13.4643321 C1.21507902,13.4514541 1.2068839,13.4951614 1.19868878,13.4635516 C1.19127415,13.5213077 1.21117659,13.5380882 1.21429854,13.5755516 C1.22366439,13.5814053 1.20844488,13.5451126 1.2201522,13.5525272 C1.22327415,13.5587711 1.21273756,13.6325272 1.22717659,13.6415028 C1.22132293,13.6559419 1.21117659,13.6446248 1.20532293,13.6368199 L1.21234732,13.6719419 C1.19595707,13.7148687 1.18307902,13.5736004 1.1623961,13.6188687 L1.16473756,13.6516492 C1.14990829,13.6828687 1.14795707,13.5654053 1.1428839,13.6473565 C1.14990829,13.6828687 1.17020098,13.7129175 1.17644488,13.6813077 C1.18034732,13.7550638 1.21000585,13.7152589 1.20883512,13.7948687 C1.20064,13.8163321 1.2068839,13.7312589 1.19517659,13.7464784 C1.18763187,13.7714541 1.19292184,13.7964297 1.19613051,13.8201334 L1.19665854,13.8534634 L1.20291439,13.8383992 C1.20929854,13.8326736 1.21771317,13.8547711 1.21976195,13.8729175 C1.2131278,13.9131126 1.20649366,13.8467711 1.20493268,13.9037467 C1.2131278,13.9131126 1.21898146,13.9657955 1.22483512,13.920137 C1.24317659,13.9408199 1.21976195,13.9794541 1.23420098,14.0106736 C1.22132293,14.0294053 1.2041522,13.952137 1.19751805,14.014576 C1.21000585,14.0048199 1.21468878,14.0918443 1.23303024,14.0586736 C1.2291278,14.0832589 1.21976195,14.0859906 1.21195707,14.0680394 C1.2041522,14.1031614 1.23459122,14.1531126 1.21000585,14.1648199 L1.2228839,14.1769175 C1.21859122,14.1878443 1.21546927,14.2038443 1.20883512,14.2217955 C1.20844488,14.2526248 1.22600585,14.321698 1.2068839,14.318576 C1.20883512,14.3283321 1.20805463,14.3989662 1.22132293,14.3720394 C1.22951805,14.3279419 1.21156683,14.3213077 1.22951805,14.2971126 C1.21468878,14.3283321 1.23146927,14.3603321 1.2361522,14.385698 C1.23146927,14.4052101 1.22990829,14.4399419 1.23810341,14.4493077 C1.23381073,14.4376004 1.22873756,14.4438443 1.22678634,14.4559419 L1.23810341,14.4719419 C1.24395707,14.5336004 1.21820098,14.4863809 1.22132293,14.5460882 L1.21273756,14.5008199 C1.21468878,14.510576 1.2041522,14.5312589 1.20766439,14.5597467 C1.21820098,14.5706736 1.23029854,14.5917467 1.23849366,14.6011126 C1.24161561,14.6234866 1.23537171,14.6227928 1.23398417,14.6296727 L1.23665854,14.6484634 L1.22483512,14.6061858 C1.22132293,14.5995516 1.20766439,14.6354541 1.20805463,14.6803321 C1.21156683,14.7092101 1.2263961,14.753698 1.23224976,14.7084297 C1.23264,14.7310638 1.22600585,14.7626736 1.21859122,14.7447223 C1.22210341,14.7958443 1.22951805,14.7380882 1.2361522,14.7821858 C1.23146927,14.7941532 1.22557225,14.8232914 1.21915491,14.8514468 L1.20865854,14.8894634 L1.19165854,14.8454634 L1.19205463,14.8750638 C1.17800585,14.8352589 1.1811278,14.8953565 1.16668878,14.8727223 C1.16434732,14.8934053 1.16942049,14.9191614 1.17332293,14.9390638 C1.19673756,14.8777955 1.20532293,15.0077467 1.22678634,14.9897955 C1.23146927,15.0569175 1.19544195,15.0503614 1.19802693,15.0898103 L1.20100585,15.102387 C1.2708839,15.0928199 1.28181073,15.1111614 1.3091278,15.089698 C1.26776195,15.0916492 1.25722537,15.0787711 1.25800585,15.070576 L1.30600585,15.0655028 L1.29664,15.073698 C1.37390829,15.0795516 1.31927415,15.0588687 1.39420098,15.0612101 L1.42932293,15.0772101 C1.41137171,15.0908687 1.32044488,15.0709662 1.33371317,15.0932101 C1.38249366,15.0939906 1.39849366,15.0826736 1.44454244,15.0885272 L1.41020098,15.0928199 C1.42776195,15.0936004 1.44493268,15.1232589 1.5143961,15.1060882 C1.55029854,15.0994541 1.52376195,15.0978931 1.52454244,15.089698 C1.60259122,15.0869662 1.6263961,15.0787711 1.67634732,15.0772101 C1.66620098,15.0932101 1.76532293,15.0787711 1.70990829,15.0951614 C1.68454244,15.0857955 1.57137171,15.086576 1.54366439,15.1021858 C1.5721522,15.121698 1.4823961,15.0994541 1.46561561,15.1189662 C1.52805463,15.1193565 1.52532293,15.1384784 1.53507902,15.1509662 C1.55264,15.1517467 1.56942049,15.1466736 1.57956683,15.1447223 C1.58698146,15.133015 1.56434732,15.1334053 1.56278634,15.1209175 C1.63264,15.1240394 1.69976195,15.1177955 1.73878634,15.1060882 C1.76220098,15.1119419 1.75478634,15.1236492 1.72707902,15.1248199 L1.84728076,15.1227721 C1.86588793,15.1180775 1.88645818,15.1149762 1.90229854,15.1141126 L1.87363789,15.1232061 C1.90943646,15.1237566 1.94463056,15.1248939 1.97800585,15.1263809 C1.9268839,15.1072589 2.06620098,15.1220882 2.03107902,15.1060882 C1.98893268,15.1017955 1.95264,15.088137 1.97566439,15.0795516 C2.00220098,15.0807223 1.9748839,15.088137 1.98581073,15.0920394 L2.01551263,15.0910999 L2.04065854,15.0964634 C2.01667122,15.1053233 2.05363512,15.118498 2.0423961,15.1306736 C2.08366439,15.1242345 2.06171317,15.1333809 2.07104244,15.1383565 C2.10554244,15.1357659 2.13854244,15.1197659 2.16754244,15.1297659 C2.15072426,15.1297659 2.14279037,15.131832 2.13763635,15.1349312 L2.09429854,15.1412101 C2.14893268,15.133015 2.21605463,15.1263809 2.27654244,15.1232589 C2.2121522,15.1298931 2.25468878,14.9550638 2.23673756,14.9058931 C2.24454244,14.8707711 2.26171317,14.894576 2.26483512,14.8563321 L2.27537171,14.8493077 L2.25703024,14.8278443 C2.27693268,14.8024784 2.30854244,14.8485272 2.30659122,14.8910638 C2.30190829,14.9414053 2.31634732,14.9414053 2.31361561,15.0018931 L2.30932293,15.1560394 C2.20942049,15.2309662 2.19810341,15.1759419 2.14698146,15.1923321 C2.09976195,15.2032589 1.99556683,15.1903809 1.93546927,15.1993565 C1.83322537,15.1899906 1.71381073,15.2087223 1.66151805,15.1919419 C1.49729041,15.1818606 1.39864542,15.2289608 1.21833828,15.1925471 L1.12565854,15.1674634 L1.12008741,15.1537292 C1.11818927,15.1472043 1.1177522,15.1411321 1.11946927,15.1365272 C1.1081522,15.1739906 1.10464,15.0916492 1.09566439,15.0686248 C1.10659122,14.9862833 1.0948839,14.8809175 1.08473756,14.8079419 C1.0761522,14.7314541 1.0921522,14.6436492 1.09527415,14.5519419 C1.09956683,14.5414053 1.10854244,14.5246248 1.10737171,14.4973077 C1.09137171,14.4477467 1.09254244,14.4216004 1.08278634,14.3486248 C1.08278634,14.2951614 1.08668878,14.2085272 1.09293268,14.1542833 C1.07068878,13.953698 1.08473756,13.7488199 1.07146927,13.5404297 L1.08317659,13.5252101 C1.05859122,13.3230638 1.08083512,13.0744784 1.06795707,12.9016004 L1.08785951,12.9183809 C1.09410341,12.864137 1.08278634,12.7950638 1.06873756,12.8087223 C1.07498146,12.7544784 1.05937171,12.6733077 1.07537171,12.6389662 C1.07927415,12.5835516 1.0663961,12.5710638 1.06366439,12.525015 C1.06860748,12.4508687 1.06956141,12.4079419 1.06849185,12.3565742 L1.06565854,12.2964634 C1.07363729,12.3034432 1.07771317,12.2981532 1.07849366,12.2807223 C1.07303024,12.241698 1.08395707,12.1371126 1.0601522,12.1757467 C1.07381073,12.064137 1.04922537,11.9150638 1.06756683,11.806576 C1.06093268,11.8155516 1.05976195,11.7882345 1.05546927,11.7769175 C1.05507902,11.6789662 1.06834732,11.5759419 1.05742049,11.4975028 C1.06054244,11.4818931 1.06834732,11.5220882 1.0691278,11.4822833 C1.06678634,11.4584784 1.06054244,11.4818931 1.05703024,11.4526248 C1.04493268,11.2937955 1.06951805,11.1310638 1.0663961,10.9866736 C1.05390829,10.7298931 1.0601522,10.4621858 1.05820098,10.2163321 C1.04493268,10.1367223 1.08161561,10.0258931 1.05429854,9.95994186 C1.05859122,9.94042966 1.05624976,9.88579551 1.06561561,9.89984429 C1.05273756,9.83428332 1.07771317,9.71642966 1.06132293,9.62121015 L1.06405463,9.64501503 C1.07459122,9.54901503 1.0601522,9.46472234 1.06990829,9.36364917 C1.07185951,9.37379551 1.07342049,9.39252722 1.07810341,9.39564917 C1.08707902,9.35662478 1.05820098,9.30277112 1.08083512,9.28169795 C1.08083512,9.25945405 1.06951805,9.26569795 1.06990829,9.27935649 C1.07420098,9.16852722 1.07303024,9.05418576 1.06990829,8.93867356 L1.06717659,8.85203942 L1.0663961,8.83018576 C1.21117659,8.67330771 1.11907902,8.7860882 1.15732293,8.75096625 L1.20142049,8.74940527 L1.37703024,8.7443321 C1.54366439,8.75760039 1.38717659,8.78218576 1.51868878,8.76540527 C1.57917659,8.75525893 1.60766439,8.78686868 1.64278634,8.77477112 C1.62834732,8.76111259 1.66620098,8.76696625 1.66737171,8.75877112 C1.76922537,8.76774673 1.78990829,8.78023454 1.87029854,8.76969795 C1.95849366,8.75603942 2.06776195,8.76735649 2.14737171,8.74355161 L2.24493268,8.74277112 L2.27810341,8.74277112 C2.27468413,8.73935184 2.27830163,8.74289855 2.28588419,8.75037458 Z M1.56265854,9.26146341 L1.56434732,9.39877112 C1.55966439,9.89516137 1.57059122,10.381015 1.55771317,10.8848199 C1.53820098,11.0030638 1.53898146,11.0116492 1.54678634,11.1416004 C1.55576195,11.1431614 1.54171317,11.2282345 1.55654244,11.2403321 L1.55629854,11.513015 L1.55765854,11.7884634 L1.55498146,11.770387 C1.55059122,11.7549662 1.54356683,11.7532101 1.54444488,11.7804297 L1.55459122,11.8178931 C1.55224976,11.8487223 1.56044488,11.8756492 1.56551805,11.8502833 C1.57917659,12.3318443 1.54717659,12.8056004 1.55107902,13.2774053 C1.54444488,13.3894053 1.55068878,13.5486248 1.55381073,13.6703809 C1.53234732,14.0309662 1.51556683,14.3560394 1.5303961,14.7224784 C1.53156683,14.7252101 1.49059122,14.6772101 1.48083512,14.5257955 C1.44376195,14.3326248 1.48122537,14.078576 1.45781073,13.8670638 C1.45624976,13.8420882 1.47810341,13.8733077 1.47303024,13.8175028 C1.44454244,13.6126248 1.46132293,13.2895028 1.48356683,13.0397467 L1.48942049,13.0549662 C1.49371317,13.0073565 1.47459122,12.9496004 1.47732293,12.8988687 C1.48122537,12.8984784 1.48278634,12.9148687 1.48785951,12.9035516 C1.47654244,12.8906736 1.4823961,12.8122345 1.47420098,12.7911614 C1.47849366,12.7712589 1.48785951,12.7732101 1.49254244,12.7474541 L1.47966439,12.718576 C1.44844488,12.638576 1.48161561,12.5238443 1.46600585,12.414576 C1.46873756,12.4200394 1.47146927,12.430576 1.47420098,12.4219906 L1.46166981,12.2341821 L1.45195707,11.8303809 C1.45664,11.8381858 1.46483512,11.8456004 1.47029854,11.8338931 C1.45664,11.824137 1.4531278,11.7636492 1.4503961,11.7109662 C1.46444488,11.6871614 1.43751805,11.6208199 1.44532293,11.5591614 C1.43361561,11.518576 1.45703024,11.4967223 1.43946927,11.4596492 L1.4503961,11.4303809 C1.43049366,11.4104784 1.46054244,11.3644297 1.4503961,11.3269662 C1.44181073,11.2926248 1.45156683,11.2742833 1.44844488,11.2411126 C1.44824976,11.1993565 1.44971317,11.1688199 1.44985951,11.1481858 L1.44765854,11.1244634 C1.45214439,11.1490462 1.45406439,11.1755516 1.46483512,11.1497955 C1.44883512,10.8957467 1.45195707,10.6338931 1.45156683,10.3782833 C1.45781073,10.3494053 1.45976195,10.3310638 1.46561561,10.3244297 C1.46249366,10.2990638 1.4628839,10.2284297 1.45507902,10.205015 C1.45546927,10.2136004 1.4628839,10.1886248 1.46366439,10.1749662 C1.46756683,10.1440069 1.45863458,10.1317793 1.45432744,10.1119202 L1.45265854,10.0734634 L1.45796972,10.0889536 C1.46106276,10.0965272 1.46444488,10.0980882 1.46834732,10.0934053 C1.45624976,10.049698 1.45820098,9.99155161 1.45429854,9.94003942 C1.45703024,9.94823454 1.45859122,9.9603321 1.46327415,9.95838088 C1.44961561,9.90218576 1.46600585,9.85574673 1.45742049,9.80618576 L1.4663961,9.82452722 C1.47732293,9.74491747 1.44766439,9.80111259 1.45390829,9.73242966 C1.45664,9.7488199 1.46054244,9.74296625 1.46405463,9.7460882 C1.44766439,9.6820882 1.4531278,9.57828332 1.44766439,9.51428332 C1.44922537,9.44755161 1.45429854,9.374576 1.44727415,9.2980882 C1.45020098,9.27701503 1.46103024,9.29260039 1.46478024,9.27059429 L1.5081522,9.262576 L1.56265854,9.26146341 Z M4.85917659,10.0208199 C5.10971317,10.077015 5.33059122,10.1886248 5.5171278,10.3392589 C5.6103961,10.4157467 5.69273756,10.5031614 5.76961561,10.5979906 L5.87264,10.7517467 C5.80824976,10.9527223 5.77585951,10.8742833 5.72590829,10.9503809 C5.72590829,10.9503809 5.73176195,10.9324297 5.75634732,10.897698 C5.75907902,10.8902833 5.89293268,10.7814053 5.7863961,10.704137 C5.62171317,10.5082345 5.37546927,10.2553565 5.09254244,10.1847223 C5.06054244,10.1753565 5.10776195,10.1687223 5.03478634,10.1492101 C4.76864,10.0781858 4.32844488,10.061015 4.00766439,10.1866736 L4.02366439,10.1722345 C3.96356683,10.1976004 3.90190829,10.2498931 3.84024976,10.2783809 C3.83790829,10.2756492 3.85703024,10.2639419 3.83985951,10.2666736 C3.8308839,10.2846248 3.74542049,10.3470638 3.72785951,10.3712589 C3.70405463,10.3845272 3.7001522,10.3763321 3.66932293,10.3942833 L3.64785951,10.4282345 C3.60181073,10.5308687 3.47146927,10.6237467 3.42698146,10.7685272 C3.42737171,10.7611126 3.43205463,10.7470638 3.42424976,10.7560394 C3.33917659,10.9710638 3.26893268,11.265698 3.32903024,11.520137 C3.32317659,11.5107711 3.31381073,11.5021858 3.31068878,11.5181858 C3.33176195,11.5275516 3.32590829,11.6110638 3.36298146,11.6715516 C3.36220098,11.7051126 3.42073756,11.7757467 3.44454244,11.8522345 L3.47125247,11.8873854 C3.48816304,11.9118118 3.49969691,11.9323646 3.52805463,11.9513565 L3.54327415,11.9876492 C3.57722537,11.9919419 3.58346927,12.0684297 3.63459122,12.0879419 C3.67634732,12.1086248 3.68922537,12.1308687 3.72590829,12.1550638 C3.7607961,12.1835516 3.78761366,12.2043126 3.80836215,12.2194416 L3.83465854,12.2374634 L3.81988215,12.2310459 C3.80572098,12.2249019 3.79716683,12.2235906 3.8121522,12.241698 C4.1188839,12.3872589 4.42795707,12.5507711 4.7303961,12.7092101 C4.76161561,12.7314541 4.78385951,12.7439419 4.78854244,12.7529175 C4.82054244,12.765015 4.90561561,12.8059906 4.93683512,12.813015 C4.92629854,12.8083321 4.95283512,12.8301858 4.96883512,12.8387711 C5.02151805,12.8719419 5.03790829,12.8532101 5.09449366,12.8918443 C5.0691278,12.881698 5.05820098,12.8824784 5.06366439,12.8918443 C5.11985951,12.9094053 5.18698146,12.9496004 5.24864,12.9808199 C5.23810341,12.9773077 5.2228839,12.9706736 5.22249366,12.976137 C5.29390829,13.0042345 5.33410341,13.0557467 5.39381073,13.0854053 L5.36844488,13.0783809 C5.44571317,13.1501858 5.40473756,13.0826736 5.47029854,13.1478443 C5.45195707,13.1349662 5.45546927,13.1427711 5.45000585,13.1427711 C5.5303961,13.182576 5.61234732,13.2980882 5.66424976,13.3671614 C5.69742049,13.4518443 5.74073756,13.5404297 5.75010341,13.6446248 C5.7508839,13.6824784 5.72707902,13.6352589 5.74307902,13.7312589 C5.76298146,13.7273565 5.73293268,13.8971126 5.75985951,13.8413077 C5.75634732,13.9279419 5.7161522,14.0551614 5.69742049,14.1094053 C5.70327415,14.0711614 5.66385951,14.141015 5.68454244,14.0742833 L5.65761561,14.1203321 C5.65293268,14.110576 5.6771278,14.0707711 5.66268878,14.0832589 C5.65293268,14.1156492 5.62951805,14.2143809 5.60493268,14.237015 C5.57878634,14.2943809 5.57761561,14.3646248 5.50971317,14.446576 C5.53703024,14.4052101 5.47537171,14.4555516 5.49527415,14.4286248 L5.42307902,14.5613077 C5.3988839,14.5878443 5.40981073,14.5589662 5.37546927,14.5968199 C5.38054244,14.5987711 5.36493268,14.6147711 5.35517659,14.6272589 C5.34307902,14.6338931 5.23927415,14.721698 5.21703024,14.7166248 C5.20064,14.7205272 5.26073756,14.6787711 5.22600585,14.6971126 C5.17605463,14.7384784 5.17176195,14.737698 5.11517659,14.769698 C5.08130341,14.7818736 5.02979122,14.8148414 5.03402459,14.8210853 L5.04865854,14.8194634 L5.04040874,14.8273384 C5.00916033,14.8475733 4.96519285,14.8696004 4.92122537,14.8789662 C4.94190829,14.8699906 4.93761561,14.8660882 4.94464,14.8590638 C4.89026602,14.8811776 4.83329041,14.9098822 4.77140061,14.9287585 L4.68665854,14.9444634 L4.70503024,14.9366067 C4.7125316,14.9333402 4.71985951,14.9309988 4.72493268,14.9320394 C4.59693268,14.9359419 4.46073756,14.9753565 4.35498146,14.9417955 C4.37254244,14.9417955 4.36317659,14.9542833 4.36200585,14.9519419 C4.30034732,14.9453077 4.30464,14.9363321 4.26444488,14.9336004 C4.26171317,14.9257955 4.2148839,14.9238443 4.17351805,14.9156492 L4.1571007,14.9118877 C4.06796791,14.8943809 3.89306276,14.8381207 3.80785951,14.7607223 C3.80785951,14.7661858 3.72864,14.7291126 3.70327415,14.7107711 L3.72005463,14.7092101 L3.70010951,14.6892711 L3.68469541,14.6771165 L3.67464,14.6656004 L3.66265854,14.6534634 L3.67665854,14.6634634 L3.65465854,14.6454634 L3.63968803,14.6348791 L3.63565854,14.6284634 L3.59361561,14.5946374 C3.57895978,14.5811234 3.56564813,14.566511 3.55498146,14.5496004 C3.56395707,14.5644297 3.59907902,14.576137 3.56590829,14.5402345 C3.51010341,14.4742833 3.5463961,14.5246248 3.49917659,14.4719419 L3.46795707,14.4403321 C3.45664,14.445015 3.42151805,14.3775028 3.43049366,14.4110638 C3.43205463,14.397015 3.35946927,14.305698 3.37937171,14.304137 L3.39771317,14.3072589 C3.37742049,14.2764297 3.35322537,14.2627711 3.33254244,14.2405272 C3.33098146,14.2358443 3.32824976,14.2260882 3.33137171,14.2264784 C3.30951805,14.2307711 3.29546927,14.1453077 3.26151805,14.1117467 L3.25065854,14.0874634 L3.22194443,14.1002996 C3.19786493,14.1097522 3.17748553,14.1164297 3.16473756,14.1172101 C3.15068878,14.1194401 3.10147026,14.1574769 3.07227592,14.1721947 L3.07184325,14.1832029 C3.07441778,14.1879202 3.07745301,14.1912264 3.08122537,14.1917467 C3.07498146,14.1851126 3.10307902,14.2713565 3.11478634,14.317015 C3.14366439,14.366576 3.14600585,14.3431614 3.15459122,14.3451126 C3.16395707,14.3993565 3.25098146,14.4731126 3.26893268,14.5386736 C3.25605463,14.5234541 3.21624976,14.4738931 3.23693268,14.5172101 C3.24434732,14.5765272 3.31381073,14.5913565 3.35868878,14.6623809 L3.35868878,14.6354541 C3.37468878,14.6709662 3.44493268,14.7220882 3.42698146,14.7275516 C3.45273756,14.7412101 3.49761561,14.7962345 3.50229854,14.7775028 C3.59127415,14.8852101 3.7731278,14.9663809 3.83595707,15.0268687 C3.85546927,15.0319419 3.89995707,15.0537955 3.89410341,15.041698 C3.86756683,15.0202345 3.84883512,15.0299906 3.84024976,15.0194541 C3.85664,15.025698 3.86210341,15.0229662 3.86483512,15.0214053 C3.90229854,15.0413077 3.93351805,15.0557467 3.89020098,15.053015 C3.97566439,15.0986736 3.98932293,15.0701858 4.10522537,15.1017955 C4.09820098,15.1072589 4.1063961,15.1123321 4.1411278,15.1193565 L4.20864,15.1232589 C4.28395707,15.1427711 4.25000585,15.1455028 4.24961561,15.1595516 C4.2921522,15.1607223 4.34405463,15.1654053 4.36395707,15.1579906 L4.41429854,15.1767223 C4.37722537,15.1630638 4.44942049,15.1724297 4.46932293,15.1708687 L4.44942049,15.1724297 C4.45722537,15.1798443 4.50600585,15.1782833 4.53098146,15.1716492 C4.52473756,15.1654053 4.47517659,15.1673565 4.44824976,15.1599419 C4.46971317,15.1579906 4.50327415,15.1595516 4.53098146,15.1486248 C4.52200585,15.1615028 4.59927415,15.150576 4.63283512,15.1486248 C4.67107902,15.1474541 4.67459122,15.1341858 4.68551805,15.1334053 C4.68746927,15.1396492 4.74756683,15.1287223 4.71946927,15.1400394 C4.70659122,15.1431614 4.68903024,15.1369175 4.66795707,15.1443321 C4.69371317,15.1466736 4.6921522,15.1572101 4.74366439,15.1447223 C4.78151805,15.1334053 4.7303961,15.1275516 4.8041522,15.118576 C4.78581073,15.1263809 4.78385951,15.1337955 4.76903024,15.1384784 C4.79283512,15.1384784 4.81507902,15.1310638 4.83849366,15.1275516 L4.8388839,15.1162345 C4.86464,15.102576 4.94932293,15.086576 4.96064,15.0701858 C4.99381073,15.0588687 5.03478634,15.0584784 5.06678634,15.0475516 C5.10073756,15.0389662 5.14834732,15.0112589 5.17644488,14.9894053 C5.19634732,14.9831614 5.24356683,14.9581858 5.26581073,14.9406248 C5.31927415,14.9211126 5.3063961,14.9714541 5.3508839,14.9234541 C5.39771317,14.8883321 5.41293268,14.8536004 5.39029854,14.8617955 C5.47966439,14.8079419 5.56161561,14.7263809 5.63264,14.6627711 C5.63927415,14.6491126 5.63107902,14.6537955 5.64981073,14.6299906 C5.76571317,14.5300882 5.82190829,14.368137 5.89644488,14.2752589 C5.88629854,14.3177955 5.90542049,14.2822833 5.91127415,14.2838443 C5.9143961,14.2459906 5.93507902,14.2463809 5.9241522,14.2280394 C5.91400585,14.2280394 5.91049366,14.2229662 5.89332293,14.2608199 C5.90795707,14.1958443 5.94542049,14.1108931 5.9653778,14.0515699 L5.97665854,14.0044634 C5.97046114,14.0130584 5.96994081,13.9998768 5.96942049,13.9868687 C5.98424976,13.9962345 5.99361561,13.9310638 5.99400585,13.8811126 L5.98542049,13.8733077 L5.99868878,13.8420882 C5.99790829,13.8229662 5.9811278,13.8202345 5.99595707,13.7722345 C5.99985951,13.7695028 6.00493268,13.7667711 6.0068839,13.7577955 C5.99283512,13.7066736 5.97137171,13.6376004 5.97332293,13.5821858 L5.98190829,13.5349662 C5.97761561,13.5115516 5.96551805,13.4740882 5.96590829,13.5158443 C5.9651278,13.4202345 5.92376195,13.3702833 5.92961561,13.3367223 C5.8601522,13.1896004 5.69820098,13.0182833 5.54444488,12.9078443 C5.51673756,12.8692101 5.52493268,12.8996492 5.49956683,12.8738931 C5.51673756,12.878576 5.47693268,12.8379906 5.51361561,12.8559419 C5.45976195,12.801698 5.43556683,12.8173077 5.3863961,12.7946736 C5.37546927,12.7993565 5.42503024,12.8079419 5.41098146,12.8137955 C5.40161561,12.813015 5.31927415,12.7583809 5.30210341,12.7654053 C5.28727415,12.7517467 5.30561561,12.7494053 5.31771317,12.7494053 L5.27283512,12.7337955 C5.2291278,12.6928199 5.40317659,12.768137 5.35868878,12.7224784 L5.3188839,12.7045272 C5.28883512,12.6725272 5.42854244,12.7423809 5.33410341,12.688137 C5.28883512,12.6725272 5.24356683,12.672137 5.27829854,12.6967223 C5.18893268,12.6549662 5.22210341,12.7053077 5.12844488,12.6557467 C5.10659122,12.6354541 5.20454244,12.6928199 5.19205463,12.6733077 C5.15303024,12.6405272 5.10034732,12.6331126 5.06249366,12.6093077 C5.10385951,12.6366248 5.0601522,12.6299906 5.0308839,12.6175028 C4.98600585,12.5870638 5.06834732,12.6217955 5.00083512,12.5855028 C4.98600585,12.5870638 4.92083512,12.560137 4.97195707,12.5929175 C4.93878634,12.5964297 4.90366439,12.5519419 4.86034732,12.545698 L4.89459824,12.5359762 C4.90241561,12.5343965 4.90116683,12.5289955 4.87244488,12.5113565 C4.87868878,12.5285272 4.77293268,12.4789662 4.80337171,12.5156492 C4.77605463,12.4973077 4.77722537,12.4871614 4.80220098,12.4914541 C4.76434732,12.4629662 4.69059122,12.4594541 4.68824976,12.430576 L4.66795707,12.4344784 C4.65664,12.4239419 4.63946927,12.4118443 4.62151805,12.3946736 C4.58483512,12.3755516 4.49507902,12.3486248 4.50756683,12.3337955 C4.49937171,12.3314541 4.41078634,12.2893077 4.4388839,12.317015 C4.49117659,12.350576 4.50132293,12.3357467 4.52278634,12.3669662 C4.49234732,12.3341858 4.45098146,12.3337955 4.41585951,12.3224784 C4.3943961,12.3072589 4.35303024,12.2861858 4.33781073,12.2877467 C4.35381073,12.2904784 4.34873756,12.2826736 4.33507902,12.2740882 L4.31049366,12.2744784 C4.23283512,12.241698 4.30190829,12.2479419 4.22776195,12.2139906 L4.28707902,12.2338931 C4.27420098,12.2296004 4.25429854,12.2077467 4.21800585,12.1933077 C4.19966439,12.1956492 4.16844488,12.1940882 4.15322537,12.193698 C4.13951528,12.1972072 4.10831528,12.1852072 4.08251528,12.1714072 L4.06951528,12.1384072 C4.08598194,12.1491738 4.09562972,12.1563305 4.10912817,12.1636877 L4.15361561,12.1788687 C4.16298146,12.1804297 4.12707902,12.1437467 4.07322537,12.1133077 C4.04419122,12.1008199 3.9996722,12.0845858 4.00900059,12.0979727 L4.02465854,12.1114634 L4.00676805,12.1001919 C3.9873961,12.0847711 3.97400585,12.0676492 3.99244488,12.0746736 C3.93195707,12.0360394 3.99400585,12.0895028 3.93937171,12.0582833 C3.92298146,12.0372101 3.86210341,11.9860882 3.83634732,11.9423809 L3.89527415,11.9732101 L3.86366439,11.9447223 C3.91244488,11.9720394 3.8503961,11.9174053 3.8823961,11.9279419 C3.86327415,11.9064784 3.83478634,11.8861858 3.81176195,11.8697955 C3.85703024,11.9451126 3.71849366,11.8260882 3.72278634,11.8534053 C3.64864,11.7527223 3.71420098,11.7675516 3.62873756,11.6719419 C3.63092293,11.6894248 3.60713366,11.6614521 3.61571278,11.6853288 L3.6111461,11.6763382 C3.59495707,11.6506736 3.5828839,11.6518443 3.56356683,11.5845272 C3.59634732,11.6446248 3.55810341,11.5111614 3.60532293,11.597015 C3.59634732,11.5935028 3.6201522,11.6485272 3.62717659,11.6614053 C3.62327415,11.6294053 3.64903024,11.6582833 3.62132293,11.5884297 C3.59751805,11.5474541 3.58932293,11.4854053 3.58073756,11.4963321 C3.56629854,11.501015 3.59517659,11.5654053 3.57566439,11.5396492 C3.55810341,11.4475516 3.57605463,11.4299906 3.5491278,11.3933077 C3.55810341,11.4522345 3.54756683,11.469015 3.53898146,11.4694053 L3.52532293,11.3995516 L3.53507902,11.4124297 C3.53000585,11.2996492 3.51010341,11.3788687 3.52024976,11.2707711 L3.54093268,11.2219906 C3.55146927,11.248137 3.52064,11.376137 3.54834732,11.3574053 C3.54808715,11.3118768 3.54626602,11.2864676 3.54820278,11.2556239 L3.55365854,11.2064634 L3.55459122,11.2504784 C3.55868878,11.2320394 3.57332293,11.2157955 3.58170098,11.1681614 L3.58325698,11.1520433 C3.58261073,11.1625955 3.58401561,11.1715711 3.58893268,11.1771126 C3.59946927,11.0920394 3.62717659,11.102576 3.64044488,11.0920394 C3.64785951,11.0701858 3.64942049,11.0471614 3.65137171,11.0335028 C3.64278634,11.0202345 3.63420098,11.0498931 3.62210341,11.0483321 C3.64590829,10.9550638 3.68961561,10.8742833 3.70405463,10.8208199 C3.72434732,10.7950638 3.72942049,10.8102833 3.71303024,10.8442345 C3.76454244,10.7443321 3.84337171,10.6456004 3.93195707,10.5831614 C3.86522537,10.6139906 4.02249366,10.5016004 3.97566439,10.5199419 C3.92805463,10.5542833 3.8788839,10.5773077 3.89878634,10.5496004 C3.92883512,10.5261858 3.90346927,10.5566248 3.91829854,10.5496004 C3.93963187,10.5248849 3.9609652,10.5161261 3.98241416,10.5027422 L4.01468878,10.4766248 C3.92922537,10.5414053 4.0103961,10.5062833 4.00259122,10.529698 C4.05617471,10.4868312 4.01394817,10.5302915 4.05550824,10.5101158 C4.07781912,10.4906403 4.09616586,10.4751842 4.11664,10.4692467 L4.10465854,10.4774634 L4.13437803,10.457604 C4.18158309,10.4286681 4.23543675,10.4032589 4.28981073,10.3884297 C4.3908839,10.366576 4.55244488,10.3416004 4.64454244,10.3494053 C4.69254244,10.3599419 4.65859122,10.3747711 4.71010341,10.381015 C4.77059122,10.3853077 4.66717659,10.3583809 4.7561522,10.3747711 L4.74600585,10.3759419 C4.77371317,10.3794541 4.90678634,10.414576 4.93761561,10.4056004 L4.90600585,10.4137955 C4.92122537,10.4208199 4.93722537,10.4219906 4.9508839,10.4247223 C4.94971317,10.430576 4.96649366,10.4422833 4.93956683,10.4372101 C4.98717659,10.4672589 5.05000585,10.4707711 5.10229854,10.5012101 L5.07303024,10.4735028 C5.17137171,10.5101858 5.2228839,10.5589662 5.30522537,10.6151614 L5.29585951,10.6217955 L5.34385951,10.6565272 C5.33068878,10.6550638 5.3471522,10.6777467 5.36839,10.6954358 L5.32537171,10.668137 C5.30405463,10.6541858 5.28259122,10.6409175 5.25956683,10.6299906 C5.2291278,10.6011126 5.30483512,10.6463809 5.29000585,10.6229662 C5.27751805,10.6026736 5.20024976,10.5515516 5.18268878,10.5519419 C5.2103961,10.573015 5.2131278,10.5718443 5.23771317,10.5847223 C5.23810341,10.6034541 5.19556683,10.5722345 5.16942049,10.5659906 L5.1848279,10.5776401 L5.19565854,10.5864634 L5.17617026,10.5758045 C5.15385409,10.5640394 5.12870504,10.5507711 5.09332293,10.5343809 C5.13117659,10.5472589 5.07849366,10.5164297 5.09371317,10.5195516 C5.08278634,10.529698 5.0343961,10.5031614 4.96610341,10.4793565 C4.92317659,10.4438443 4.83381073,10.449698 4.75342049,10.4313565 C4.78854244,10.4251126 4.83381073,10.4231614 4.88610341,10.4282345 C4.83498146,10.4114541 4.82756683,10.4169175 4.77566439,10.3997467 C4.74834732,10.4032589 4.72844488,10.416137 4.65898146,10.4184784 L4.65585951,10.4087223 C4.59303024,10.4118443 4.59264,10.4180882 4.51498146,10.4251126 C4.38073756,10.4266736 4.24454244,10.4664784 4.1543961,10.5133077 L4.14659122,10.5066736 C4.10210341,10.5460882 3.98776195,10.6108687 3.93859122,10.672137 C3.83517659,10.7552589 3.77390829,10.8957467 3.73332293,10.9496004 C3.6521522,11.1618931 3.63576195,11.3749662 3.71185951,11.5892101 L3.68376195,11.5576004 C3.70067252,11.5812752 3.69607631,11.5860448 3.69633648,11.59781 L3.70365854,11.6224634 L3.70490068,11.6101834 C3.71209366,11.610658 3.73956683,11.6764687 3.76454244,11.6883321 C3.80942049,11.7827711 3.91634732,11.8717467 3.99829854,11.917015 L3.99556683,11.9267711 C4.08142049,11.969698 4.1703961,12.0407223 4.27693268,12.0996492 C4.28746927,12.1094053 4.30268878,12.1273565 4.33546927,12.142576 C4.40103024,12.158576 4.43264,12.1734053 4.52473756,12.206576 C4.59264,12.2393565 4.69020098,12.2955516 4.75264,12.3341858 C5.00122537,12.4372101 5.23771317,12.5753565 5.49137171,12.6908687 L5.50385951,12.7099906 C5.75634732,12.8461858 6.00376195,13.1119419 6.07010341,13.3558443 L6.0423961,13.3402345 C6.07283512,13.4100882 6.09781073,13.5014053 6.10561561,13.4807223 C6.10873756,13.5564297 6.13722537,13.6680394 6.12629854,13.7168199 C6.13371317,13.7933077 6.13059122,13.8104784 6.13020098,13.8748687 C6.11293268,13.9904784 6.10751805,14.0514297 6.08382902,14.1327955 L6.06565854,14.1864634 C6.06177821,14.1749662 6.05553431,14.1806898 6.04668878,14.2030638 L6.03708264,14.2350331 L6.01093268,14.3105272 C5.99956683,14.3451126 5.99478634,14.3679419 6.01468878,14.3474541 C5.93117659,14.478576 5.84064,14.6713565 5.71303024,14.7626736 C5.72629854,14.7576004 5.70132293,14.7864784 5.6931278,14.8013077 C5.60064,14.9043321 5.46405463,14.9648199 5.38522537,15.041698 C5.3641522,15.0487223 5.41059122,15.0171126 5.36024976,15.0413077 C5.33176195,15.057698 5.3641522,15.0487223 5.32903024,15.0697955 C5.13781073,15.1872589 4.90873756,15.2376004 4.7108839,15.2633565 C4.3561522,15.3316492 3.9651278,15.2473565 3.66698146,15.0729175 C3.55927415,15.0303809 3.4601522,14.9058931 3.37585951,14.8617955 C3.35673756,14.8422833 3.30093268,14.7896004 3.32278634,14.7966248 C3.27068878,14.7503809 3.20651805,14.6617711 3.14574976,14.5750821 L3.10620098,14.5176004 L3.04322717,14.4053836 L2.98771136,14.291866 L2.93865854,14.1724634 L2.95049366,14.1912589 C2.95517659,14.1987711 2.95966439,14.205015 2.96259122,14.2061858 L2.94620098,14.1663809 C3.0023961,13.9989662 2.98366439,14.1070638 3.00551805,14.064137 C3.02971317,14.049698 3.05195707,14.0379906 3.06951805,14.0422833 L3.08489655,14.0321659 L3.10070402,14.0264906 C3.16462171,14.0046797 3.15459122,13.9207223 3.35400585,14.0067711 C3.38678634,14.0715516 3.41332293,14.1414053 3.45351805,14.2030638 C3.53117659,14.3275516 3.61937171,14.4485272 3.73059122,14.5394541 C3.87654244,14.6857955 3.71224976,14.5819906 3.85546927,14.6639419 C3.86444488,14.6748687 3.86873756,14.6619906 3.86795707,14.6670638 C3.92259122,14.6986736 3.93859122,14.7431614 3.98620098,14.749015 C3.97566439,14.7291126 4.01664,14.753698 4.02132293,14.7466736 C4.13176195,14.8110638 4.16024976,14.8149662 4.25976195,14.8333077 L4.25078634,14.8387711 C4.37098146,14.8383809 4.51029854,14.861015 4.60668878,14.8208199 C5.25371317,14.7759419 5.77507902,14.1230638 5.61078634,13.5427711 C5.48467252,13.2238443 5.16747198,13.0402318 4.81774863,12.8711711 L4.51371927,12.7270089 C4.36142049,12.6538931 4.21146927,12.5771126 4.07634732,12.4871614 C3.94561561,12.397015 3.93507902,12.3919419 3.77820098,12.318576 C3.76103024,12.3205272 3.68024976,12.2377955 3.6548839,12.2381858 C3.47277008,12.1126573 3.34079176,11.9315733 3.26617568,11.7200015 L3.23904312,11.6264644 C3.2443161,11.6361487 3.24801561,11.630576 3.24356683,11.600137 L3.22678634,11.5486248 L3.22990829,11.5392589 C3.22327415,11.5049175 3.21078634,11.4670638 3.21000585,11.504137 C3.08317659,10.8102833 3.6228839,10.110576 4.30346927,10.0212101 C4.46151805,10.0083321 4.68707902,9.98335649 4.85917659,10.0208199 Z M11.0562498,9.95799064 L11.07264,9.99506381 L11.0968351,10.0653077 C11.1124449,10.112137 11.1280546,10.1566248 11.1538107,10.1839419 C11.1573229,10.2046248 11.1819083,10.2580882 11.1674693,10.2471614 C11.2057132,10.3072589 11.2302985,10.4325272 11.2833717,10.5203321 L11.2726585,10.5004634 L11.3054133,10.5909662 C11.3303311,10.6508904 11.3584286,10.7085597 11.379762,10.7775028 C11.3739083,10.768137 11.3649327,10.7501858 11.3594693,10.749015 C11.3668839,10.7911614 11.4152741,10.8329175 11.4027863,10.862576 C11.4121522,10.8844297 11.4199571,10.8738931 11.4137132,10.8606248 C11.4944937,11.0822833 11.6033717,11.3097955 11.7013229,11.5349662 C11.7551766,11.7027711 11.6697132,11.5591614 11.7380059,11.6813077 C11.7380059,11.6934053 11.7493229,11.6856004 11.7454205,11.6891126 C11.7715668,11.7363321 11.7536156,11.7757467 11.7785912,11.8057955 C11.7856156,11.7862833 11.7953717,11.825698 11.8035668,11.8237467 C11.8355668,11.9267711 11.8324449,11.9513565 11.874201,12.0258931 C11.9218107,12.1070638 11.9553717,12.2182833 12.0092254,12.2869662 C12.2207376,12.7931126 12.4322498,13.2750638 12.6371278,13.7691126 L12.9352741,14.4992589 L13.0843473,14.8653077 L13.1577132,15.0502833 L13.1760546,15.0967223 L13.1806585,15.1064634 L13.1650654,15.1317319 C13.1497522,15.1541662 13.1257132,15.1893662 13.0890302,15.2430638 L13.0515668,15.2426736 L12.9501034,15.2403321 C12.8868839,15.2309662 12.8525424,15.2262833 12.81664,15.2247223 C12.7662985,15.2009175 12.8537132,15.2766248 12.6851278,15.1728199 C12.675762,15.1525272 12.6644449,15.1287223 12.6492254,15.0975028 C12.6398595,15.0990638 12.6187863,15.0100882 12.5996644,15.0034541 C12.527079,14.8188687 12.4533229,14.6514541 12.3752741,14.4621858 C12.3889327,14.4914541 12.4072741,14.5016004 12.3916644,14.4664784 L12.367079,14.4333077 C12.3565424,14.4020882 12.338201,14.3786736 12.3440546,14.4056004 C12.2398595,14.1710638 12.1473717,13.9337955 12.0564449,13.697698 C12.0621034,13.6854053 12.0315668,13.6367223 12.0159571,13.6029662 L11.874201,13.5938931 L11.4933229,13.5915516 C11.3731278,13.5849175 11.2014205,13.5911614 11.0706888,13.5942833 C10.6827863,13.5732101 10.3331278,13.5564297 9.93898146,13.5712589 C9.94054244,13.5712589 9.99205463,13.5302833 10.1547863,13.5209175 C10.3623961,13.4842345 10.6355668,13.5213077 10.863079,13.4978931 C10.8896156,13.4963321 10.8560546,13.5177955 10.9161522,13.5131126 C11.13664,13.4846248 11.4839571,13.5017955 11.7524449,13.5236492 L11.7360546,13.5291126 C11.7871766,13.5334053 11.8496156,13.5146736 11.9038595,13.517015 C11.9042498,13.5209175 11.8862985,13.5224784 11.8987863,13.5275516 C11.9124449,13.5162345 11.9967376,13.5224784 12.019762,13.5138931 C12.0412254,13.5181858 12.0392741,13.5275516 12.0665912,13.5322345 L12.0782985,13.5312162 L12.1136278,13.5799419 C12.1467376,13.6484297 12.1667863,13.7379906 12.2109815,13.8143809 C12.2062985,13.8104784 12.1996644,13.8003321 12.2000546,13.8100882 C12.28864,13.9759419 12.3748839,14.1940882 12.4607376,14.3849175 C12.4533229,14.3790638 12.4427863,14.3751614 12.4423961,14.3880394 C12.4591766,14.3923321 12.4868839,14.4508687 12.5106888,14.5019906 C12.5075668,14.5304784 12.5594693,14.5858931 12.5770302,14.6498931 C12.6039571,14.6854053 12.5914693,14.7158443 12.6226888,14.7455028 L12.6242498,14.7782833 C12.6507863,14.7907711 12.6414205,14.8473565 12.6660059,14.8805272 C12.6878595,14.9109662 12.6862985,14.9328199 12.7026888,14.9640394 C12.7198595,15.005015 12.7308839,15.0356492 12.7391278,15.0560394 L12.7446585,15.0684634 L12.7319627,15.0492258 C12.7275044,15.0442072 12.7244254,15.0451321 12.7245424,15.0596492 C12.7475668,15.2247223 12.9684449,15.0967223 13.0820059,15.1337955 C13.0285424,15.0498931 12.9770302,14.8910638 12.925518,14.7743809 C12.9196644,14.7435516 12.9138107,14.7244297 12.9165424,14.7158443 C12.9036644,14.6916492 12.8751766,14.6217955 12.8583961,14.6018931 C12.8622985,14.6100882 12.8591766,14.5827711 12.8544937,14.5691126 C12.8412254,14.5211126 12.818201,14.5254053 12.8041522,14.4723321 C12.8162498,14.4906736 12.8236644,14.4957467 12.8263961,14.4867711 L12.7995993,14.4429482 L12.7514693,14.3408199 C12.7573229,14.3478443 12.7635668,14.3591614 12.767079,14.3556492 C12.7315668,14.3053077 12.7284449,14.2534053 12.7003473,14.2077467 L12.7159571,14.222576 C12.6941034,14.1402345 12.6890302,14.206576 12.6675668,14.1363321 C12.6769327,14.1515516 12.6777132,14.1445272 12.6823961,14.1460882 C12.6414205,14.0887223 12.6047376,13.9845272 12.573518,13.9236492 C12.5485424,13.8573077 12.5235668,13.7835516 12.4861034,13.710576 C12.4837307,13.701335 12.4853541,13.6980882 12.4875722,13.6956054 L12.47964,13.6779541 L12.4915529,13.677352 C12.4897768,13.6696386 12.4855311,13.6580336 12.4771278,13.6399419 C12.461518,13.6493077 12.419762,13.5193565 12.4185912,13.569698 C12.3959571,13.5064784 12.3620059,13.4054053 12.3393717,13.3663809 C12.3573229,13.3917467 12.3475668,13.328137 12.370201,13.3792589 L12.3643473,13.3363321 C12.3737132,13.3394541 12.3783961,13.3773077 12.3819083,13.361698 C12.3705912,13.3359419 12.3331278,13.2633565 12.3264937,13.2391614 C12.2968351,13.1950638 12.259762,13.1587711 12.2258107,13.0822833 C12.2419083,13.1077467 12.2393473,13.0792101 12.2424937,13.0732284 L12.1723473,12.9819906 C12.1610302,12.9566248 12.1832741,12.9710638 12.163762,12.9355516 C12.1598595,12.9390638 12.1504937,12.9238443 12.1422985,12.9140882 C12.1403473,12.9035516 12.0942985,12.8083321 12.1060059,12.7903809 C12.1079571,12.7763321 12.1266888,12.8309662 12.1208351,12.800137 C12.1013229,12.7525272 12.0946888,12.7529175 12.0747863,12.7049175 C12.066201,12.670576 12.0318595,12.6128199 12.0365424,12.6506736 L12.0513717,12.6729175 C12.0385202,12.660066 12.0220285,12.6293965 12.006595,12.5958101 C12.0044447,12.6040455 11.9961947,12.6042955 11.9976947,12.6107955 C11.9783614,12.5674622 11.9981391,12.5894622 12.0022132,12.5831659 C11.9957036,12.5713903 11.9916113,12.5617245 11.987762,12.5523321 L11.99864,12.5642833 L11.9896947,12.5407955 L12.0021717,12.5656874 L11.9534693,12.4749175 L11.9066585,12.3814634 L11.9193681,12.3932282 L11.8912272,12.3134884 C11.8625804,12.253015 11.8297132,12.1957793 11.8195668,12.1406248 C11.826201,12.1527223 11.8109815,12.1519419 11.8129327,12.1499906 C11.795762,12.1055028 11.8078595,12.1027711 11.7922498,12.0758443 C11.7977132,12.0703809 11.775079,12.0403321 11.7610302,12.0114541 L11.7529912,11.9912425 C11.7205854,11.926818 11.666201,11.8077467 11.6427863,11.728137 C11.6392741,11.7320394 11.6025912,11.6762345 11.5940059,11.6539906 L11.6076644,11.6582833 L11.6006585,11.6324634 L11.6094693,11.6471614 L11.6206585,11.6664634 L11.5986585,11.6214634 L11.5864756,11.5970006 L11.5787863,11.5782689 C11.5642172,11.550576 11.5496481,11.5235191 11.5444449,11.4928199 C11.5475668,11.505698 11.5733229,11.5228687 11.5581034,11.4877467 C11.5307863,11.425698 11.5460059,11.4717467 11.5218107,11.4221858 L11.50464,11.392137 C11.4937132,11.3940882 11.4831766,11.3355516 11.4812254,11.3632589 C11.4862985,11.3523321 11.439079,11.2742833 11.458201,11.2738931 L11.4749815,11.2774053 C11.4628839,11.2508687 11.4429815,11.2383809 11.4285424,11.2196492 C11.4281522,11.2157467 11.427762,11.2075516 11.4304937,11.2079419 C11.40864,11.2118443 11.4059083,11.1427711 11.3770302,11.1166248 C11.36064,11.0569175 11.3188839,10.9718443 11.3204449,10.9402345 C11.2962498,10.8988687 11.2728351,10.8621858 11.2568351,10.8106736 C11.2626888,10.8196492 11.2689327,10.8333077 11.2743961,10.8344784 C11.2673717,10.8009175 11.2591766,10.7950638 11.2439571,10.7677467 C11.2498107,10.7728199 11.2302985,10.7006248 11.2228839,10.6627711 C11.199079,10.6217955 11.1943961,10.6409175 11.186201,10.6393565 C11.1885424,10.6076167 11.1598378,10.5659906 11.1397475,10.5248849 L11.1216585,10.4664634 L11.1302132,10.479576 C11.1410059,10.4965516 11.1541034,10.5150638 11.1467863,10.4863809 C11.1478627,10.4717908 11.1438448,10.4591797 11.137271,10.4467508 L11.1415546,10.4656248 L11.1025546,10.3956248 C11.0963888,10.3823267 11.0879686,10.365302 11.0827863,10.3443321 L11.0730302,10.366576 C11.0714693,10.3341858 11.0250302,10.2760394 11.0445424,10.2760394 C11.0297132,10.2569175 11.0191766,10.1983809 11.0059083,10.2120394 L10.9766585,10.1284634 C10.97664,10.1392589 10.9778107,10.141015 10.9785912,10.1421858 C10.9660059,10.1656004 10.9562741,10.1855028 10.9518656,10.1788443 L10.9486585,10.1634634 L10.9312924,10.2062711 C10.92264,10.2442833 10.9347863,10.2707711 10.9017132,10.3380882 C10.8970302,10.3314541 10.8915668,10.3373077 10.8814205,10.3646248 L10.8716644,10.4204297 C10.8447376,10.4793565 10.8427863,10.4485272 10.831079,10.4454053 C10.819762,10.4781858 10.8033717,10.5168199 10.8057132,10.5347711 L10.7756644,10.5679419 C10.797518,10.5437467 10.7713717,10.5968199 10.7682498,10.6132101 L10.7713717,10.5972101 L10.7630465,10.6105941 L10.7456156,10.6588687 C10.7545912,10.6569175 10.7725424,10.6206248 10.783079,10.6007223 C10.781518,10.6190638 10.7698107,10.6436492 10.7666888,10.6678443 C10.7584937,10.656137 10.7374205,10.717015 10.7261034,10.7416004 C10.7116644,10.7700882 10.722201,10.7786736 10.7186888,10.7868687 C10.7128351,10.7853077 10.6983961,10.8340882 10.6995668,10.8083321 C10.7019083,10.7977955 10.7143961,10.7880394 10.7159571,10.7693077 C10.7038595,10.7868687 10.6948839,10.7806248 10.685518,10.8235516 C10.6784937,10.8555516 10.7104937,10.8243321 10.6800546,10.878576 C10.6831766,10.862576 10.6800546,10.8578931 10.6808351,10.845015 L10.6531278,10.896137 L10.6621034,10.9023809 C10.6589815,10.9261858 10.6250302,10.9886248 10.6320546,11.0054053 C10.6222985,11.0327223 10.6016156,11.0592589 10.5902985,11.0842345 C10.5727376,11.1080394 10.5594693,11.1513565 10.5555668,11.1806248 C10.546201,11.1950638 10.5309815,11.2360394 10.5282498,11.2602345 C10.5028839,11.3004297 10.4845424,11.2594541 10.477518,11.3125272 C10.4599571,11.3566248 10.467762,11.3886248 10.4814205,11.3737955 C10.4420059,11.4498931 10.4217132,11.5462833 10.3760546,11.6134053 C10.3756644,11.6262833 10.3811278,11.6200394 10.3737132,11.6446248 C10.322201,11.7589662 10.2851278,11.8943809 10.227762,11.9786736 C10.2371278,11.9435516 10.2187863,11.9724297 10.2125424,11.9708687 C10.210201,12.0020882 10.189518,12.0005272 10.2008351,12.0165272 C10.2075993,12.0170475 10.2112416,12.0193023 10.2180059,12.0114974 L10.2296585,11.9924634 L10.2105912,12.0488443 C10.1873961,12.1100882 10.1584937,12.1759419 10.1403473,12.2022833 C10.1524449,12.1847223 10.1489327,12.2007223 10.1454205,12.2171126 C10.1329327,12.2061858 10.1099083,12.2565272 10.0993717,12.2971126 L10.1060059,12.3060882 L10.0864937,12.3275516 C10.0833717,12.3435516 10.098201,12.3513565 10.0740059,12.3860882 C10.0697132,12.3864784 10.0654205,12.3876492 10.0599571,12.3935028 C10.0509815,12.4364297 10.0400546,12.497698 10.0146888,12.5378931 L9.98737171,12.5683321 C9.98268878,12.5826736 9.97866439,12.605576 9.98418878,12.6029601 L9.99065854,12.5934634 L9.96045933,12.653492 C9.94158309,12.6899148 9.92779447,12.7150638 9.91400585,12.7275516 C9.88864,12.865698 9.81371317,13.0510638 9.75127415,13.198576 C9.72395707,13.229015 9.74932293,13.2169175 9.73371317,13.2426736 C9.73254244,13.2274541 9.70756683,13.2676492 9.71264,13.2333077 C9.68220098,13.2875516 9.69390829,13.3113565 9.68181073,13.3496004 C9.68805463,13.358576 9.68844488,13.3176004 9.69664,13.3293077 C9.69703024,13.3367223 9.65761561,13.4054053 9.66698146,13.4194541 C9.65605463,13.4315516 9.65098146,13.4167223 9.64864,13.4069662 L9.64083512,13.4444297 C9.60805463,13.4807223 9.65332293,13.3367223 9.61624976,13.3737955 L9.60532293,13.406576 C9.57917659,13.4315516 9.62483512,13.3156492 9.58698146,13.3940882 C9.57917659,13.4315516 9.58581073,13.469015 9.60454244,13.440137 L9.59573756,13.4798321 L9.60168878,13.5223443 C9.60071317,13.5318443 9.59722537,13.5447223 9.58893268,13.5642345 C9.57254244,13.582576 9.61273756,13.501015 9.59556683,13.5115516 C9.57020098,13.5443321 9.57137171,13.5876492 9.55381073,13.6188687 C9.57371317,13.5845272 9.57449366,13.6204297 9.56707902,13.645015 C9.54483512,13.6824784 9.5651278,13.6141858 9.54093268,13.6699906 C9.54483512,13.6824784 9.52922537,13.7363321 9.55264,13.6937955 C9.56122537,13.7211126 9.52376195,13.7503809 9.52454244,13.7866736 C9.50503024,13.8003321 9.52024976,13.7176004 9.48903024,13.7769175 C9.50464,13.7718443 9.47342049,13.8596492 9.50424976,13.8338931 C9.49098146,13.8565272 9.48083512,13.8557467 9.48122537,13.8350638 C9.45976195,13.8666736 9.46795707,13.9275516 9.44024976,13.9295028 L9.44727415,13.9462833 C9.43907902,13.9556492 9.42971317,13.9700882 9.41605463,13.9849175 C9.40317659,14.0153565 9.39185951,14.0895028 9.37507902,14.0797467 C9.3731278,14.0902833 9.34346927,14.1597467 9.3668839,14.1378931 C9.39224976,14.097698 9.37820098,14.0844297 9.4051278,14.0668687 C9.37898146,14.0918443 9.38132293,14.1300882 9.37546927,14.1566248 C9.36376195,14.1741858 9.3481522,14.2077467 9.35166439,14.2202345 C9.35244488,14.2073565 9.34542049,14.2112589 9.33878634,14.222576 L9.34268878,14.2424784 L9.33034732,14.2710211 L9.31064,14.2825943 L9.29765854,14.3064634 L9.30565854,14.2644634 L9.30096159,14.2742616 C9.2943419,14.2843213 9.28454244,14.2980232 9.27907902,14.3177955 C9.2841522,14.3326248 9.28727415,14.3579906 9.29078634,14.3704784 C9.28454244,14.3938931 9.27916575,14.3907711 9.2752344,14.3969572 L9.27165854,14.4064634 L9.27634732,14.3700882 C9.27595707,14.3622833 9.24864,14.3927223 9.23068878,14.4368199 C9.22249366,14.4664784 9.21820098,14.5164297 9.24200585,14.4735028 C9.23527415,14.4901858 9.22305463,14.5106004 9.21753024,14.5112041 L9.20933512,14.526576 C9.21010341,14.5353565 9.22503024,14.5134053 9.21624976,14.5476492 C9.20259122,14.5628687 9.17059122,14.6147711 9.14756683,14.6444297 L9.14990829,14.5925272 L9.13742049,14.622576 C9.14054244,14.5784784 9.11946927,14.638576 9.11478634,14.6108687 C9.10424976,14.6307711 9.09878634,14.657698 9.09371317,14.6787711 C9.14054244,14.6272589 9.09605463,14.7583809 9.12298146,14.7486248 C9.09449366,14.833698 9.05351805,14.781015 9.04922537,14.8797467 C9.05742049,14.8706736 9.05859122,14.8947467 9.06524976,14.8843016 L9.06665854,14.8794634 C9.06173756,14.9107467 9.07176195,14.9171126 9.0468839,14.960137 C9.05742049,14.9117467 9.00707902,15.0003321 9.02190829,14.9308687 C9.02659122,14.9378931 9.04181073,14.8965272 9.0441522,14.8859906 C9.02776195,14.9039419 9.02581073,14.8735028 9.00434732,14.9261858 C8.99303024,14.9589662 8.97546927,15.0030638 8.98834732,15.0011126 C9.00005463,15.0042345 9.00707902,14.9515516 9.01020098,14.9769175 C8.98795707,15.0424784 8.96610341,15.0463809 8.97585951,15.0807223 C8.99068878,15.0397467 9.00668878,15.0342833 9.01410341,15.0381858 L9.00265854,15.0714634 L9.0622335,15.0684224 C9.09813593,15.0650692 9.12103024,15.0610801 9.15693268,15.0600394 C9.15329041,15.0655028 9.16248282,15.0674974 9.17433467,15.0683357 L9.18365854,15.0684634 L9.20965854,15.0024634 L9.18367015,15.0405272 C9.17539742,15.0356846 9.19659106,15.0045055 9.22202248,14.9738406 C9.23751299,14.9389137 9.25261458,14.9053126 9.26737171,14.8735028 C9.2291278,14.9160394 9.29859122,14.7860882 9.26971317,14.8137955 C9.24864,14.8536004 9.22132293,14.8836492 9.2228839,14.8578931 C9.23459122,14.8325272 9.23029854,14.8617955 9.23849366,14.8528199 L9.24965174,14.8232914 L9.27283512,14.769698 C9.24824976,14.8461858 9.28883512,14.7927223 9.29703024,14.8122345 C9.30790132,14.7684482 9.30732254,14.7961652 9.31663025,14.7865338 C9.31970424,14.7688419 9.32404034,14.7541257 9.33344982,14.7424966 L9.33165854,14.7484634 L9.35317659,14.6751126 C9.36278634,14.6435516 9.37332293,14.6114541 9.38405463,14.5812101 C9.42776195,14.512137 9.46171317,14.3931126 9.48864,14.3267711 C9.51010341,14.2947711 9.51634732,14.3248199 9.53468878,14.288137 C9.55264,14.2436492 9.50385951,14.3138931 9.53820098,14.2514541 L9.56854244,14.1893077 C9.5811278,14.1594541 9.59127415,14.1287223 9.58385951,14.1144784 L9.59265854,14.1394634 L9.59932293,14.1235516 C9.60064,14.1175028 9.60142049,14.1115516 9.60259122,14.1062833 C9.60844488,14.1078443 9.61937171,14.0957467 9.61468878,14.1172101 C9.64317659,14.081698 9.64785951,14.0317467 9.66542049,13.9876492 L9.64356683,14.0118443 C9.66659122,13.9334053 9.69742049,13.8873565 9.72356683,13.8132101 L9.73254244,13.8194541 L9.74424976,13.7737955 C9.74698146,13.781015 9.75400585,13.7753565 9.76049366,13.7646248 L9.76865854,13.7454634 L9.75166439,13.8471614 C9.73293268,13.8760394 9.75361561,13.808137 9.73566439,13.8237467 C9.72005463,13.837015 9.69546927,13.9053077 9.7001522,13.920137 C9.71185951,13.8947711 9.71029854,13.8928199 9.71498146,13.8713565 C9.7321522,13.8686248 9.71576195,13.9072589 9.71693268,13.9302833 L9.72703024,13.9089662 L9.72965854,13.8994634 L9.72476647,13.9236058 C9.71927415,13.9435516 9.71094894,13.9654053 9.69898146,13.9950638 C9.70561561,13.9630638 9.68376195,14.0079419 9.6841522,13.9950638 C9.69507902,14.0036492 9.68142049,14.0473565 9.65527415,14.1004297 C9.62522537,14.1336004 9.62210341,14.206576 9.59244488,14.2682345 C9.59049366,14.2374053 9.5943961,14.2007223 9.60532293,14.1605272 C9.58268878,14.1976004 9.58737171,14.2046248 9.56473756,14.2420882 C9.56590829,14.2651126 9.57449366,14.2842345 9.55849366,14.3384784 L9.54834732,14.337698 C9.53351805,14.3864784 9.54717659,14.3919419 9.51985951,14.4508687 C9.47342049,14.5515516 9.43010341,14.6565272 9.39654244,14.734576 L9.38600585,14.7337955 C9.38756683,14.7853077 9.33371317,14.881698 9.31810341,14.9433565 C9.2931278,14.9913565 9.27322537,15.0463809 9.2548839,15.0947711 C9.23029854,15.1287223 9.2708839,15.1197467 9.19361561,15.1829662 C9.1721522,15.1821858 9.15381073,15.1802345 9.13976195,15.1759419 C9.06587577,15.1616329 9.02251534,15.194847 8.9554512,15.1857413 L8.89986132,15.1695733 C8.87928499,15.1606031 8.85637984,15.1475841 8.83029854,15.1291126 L8.86365854,15.0424634 L8.87995707,15.0022345 C8.89722537,14.9593565 8.91537171,14.9156492 8.9348839,14.8703809 L8.93566439,14.9062833 C8.93917659,14.8696004 8.95205463,14.8879419 8.96298146,14.8551614 C8.93761561,14.8879419 8.96727415,14.8056004 8.96883512,14.7794541 C9.01254244,14.702576 9.04376195,14.593698 9.06405463,14.5183809 L9.07420098,14.5191614 C9.08707902,14.4395516 9.13742049,14.3587711 9.17722537,14.2694053 C9.18542049,14.2608199 9.20064,14.2475516 9.2103961,14.2202345 C9.21585951,14.1652101 9.22756683,14.1398443 9.24785951,14.064137 C9.26932293,14.0114541 9.30795707,13.9275516 9.33566439,13.8764297 C9.3961522,13.6703809 9.4921522,13.473698 9.56395707,13.2629662 L9.58073756,13.2524297 C9.63966439,13.0436492 9.76103024,12.8071614 9.81878634,12.6323321 L9.83010341,12.656137 C9.85781073,12.605015 9.87537171,12.5328199 9.85664,12.541015 C9.88395707,12.4895028 9.90229854,12.4040394 9.93156683,12.3759419 C9.95732293,12.3224784 9.95029854,12.305698 9.96668878,12.2592589 C10.0012904,12.1882345 10.0194151,12.1461749 10.0392163,12.0950385 L10.0616585,12.0344634 C10.0655506,12.0441912 10.0712741,12.0404622 10.079079,12.0235516 C10.0900059,11.9829662 10.1419083,11.8838443 10.1044449,11.9135028 C10.162201,11.8085272 10.1996644,11.6524297 10.2605424,11.552137 C10.2507863,11.5587711 10.2605424,11.5314541 10.2613229,11.518576 C10.3007376,11.4217955 10.3545912,11.325015 10.3760546,11.2438443 C10.3854205,11.2297955 10.3760546,11.2723321 10.3928351,11.2333077 C10.4002498,11.2091126 10.3854205,11.2297955 10.3936156,11.1997467 C10.4466888,11.038576 10.5352741,10.8871614 10.5906888,10.7439419 C10.6827863,10.4863809 10.7971278,10.2245272 10.8946888,9.98140527 L10.9017132,9.96930771 L10.9044449,9.95916137 L11.0562498,9.95799064 Z M9.32665854,10.0664634 L9.39128154,10.1304887 C9.39964619,10.1387543 9.40659207,10.1456229 9.41077781,10.1497699 L9.41410341,10.1808199 L9.41722537,10.3615028 L9.41800585,10.4063809 L9.4183961,10.4516492 L9.36849894,10.5009023 L9.33374315,10.5351667 L9.32565854,10.5414634 L9.2361522,10.5437467 L8.51264,10.5531126 L8.15517659,10.5519419 L8.12265854,10.5514634 L8.12265854,10.4534634 L8.14167659,10.4554419 C8.16190829,10.4521126 8.14405463,10.4368199 8.19381073,10.4415028 C8.17781073,10.4442345 8.18327415,10.4477467 8.18054244,10.4512589 C8.24220098,10.4352589 8.34249366,10.4403321 8.40376195,10.4348687 C8.4681522,10.4368199 8.5383961,10.4418931 8.61254244,10.4348687 C8.63946927,10.4387711 8.60356683,10.4563321 8.67498146,10.4532101 C8.67224976,10.4352589 8.79556683,10.4457955 8.75381073,10.4258931 C8.81468878,10.4286248 8.91068878,10.4352589 8.9508839,10.4294053 C8.92356683,10.4360394 8.98054244,10.4512589 8.93020098,10.4524297 L8.96844488,10.4633565 C8.96259122,10.4707711 8.92903024,10.461015 8.94151805,10.4699906 C8.9668839,10.4692101 9.04064,10.4621858 9.0628839,10.4649175 C9.10971317,10.4539906 9.15264,10.433698 9.22873756,10.4313565 C9.19322537,10.4383809 9.24903024,10.4512589 9.22483512,10.4539906 C9.23701073,10.4544589 9.27194537,10.4362423 9.29120156,10.4311192 L9.30165854,10.4314634 C9.30774027,10.4239852 9.30834732,10.4180882 9.30678634,10.4059906 C9.30210341,10.4079419 9.29898146,10.3919419 9.29507902,10.381015 C9.29742049,10.3716492 9.29078634,10.2772101 9.30834732,10.2662833 C9.31185951,10.2606248 9.31283512,10.2707711 9.31371317,10.2788687 C9.31810341,10.2331126 9.31224976,10.2307711 9.31185951,10.1847223 L9.2956138,10.1847802 C9.26971317,10.1886248 9.23537171,10.1899256 9.2041522,10.1901858 C9.2201522,10.1874541 9.21820098,10.1827711 9.22444488,10.177698 L9.12785951,10.1926736 L9.03265854,10.2004634 L9.04753431,10.1934089 C9.05304108,10.1908362 9.05833106,10.1891451 9.06171317,10.190576 C8.97195707,10.1788687 8.87634732,10.2069662 8.80181073,10.1901858 C8.81429854,10.1886248 8.80844488,10.2018931 8.80766439,10.1995516 C8.76434732,10.1987711 8.76668878,10.1862833 8.73820098,10.1909662 C8.73546927,10.1839419 8.70268878,10.1933077 8.67381073,10.1952589 C8.65898146,10.2003321 8.6663961,10.1917467 8.69137171,10.1909662 C8.65117659,10.1972101 8.48922537,10.2077467 8.39634732,10.1976004 C8.39829854,10.2022833 8.33898146,10.2147711 8.31751805,10.2143809 L8.32571317,10.2034541 L8.29965854,10.1994634 L8.26714768,10.1997829 L8.20723801,10.2029337 C8.19333377,10.2032372 8.17950179,10.2022833 8.16571317,10.1987711 C8.17742049,10.2007223 8.20083512,10.1835516 8.16571317,10.1843321 C8.10444488,10.1862833 8.1481522,10.1894053 8.09859122,10.1933077 L8.06737171,10.1976004 C8.06542049,10.2085272 8.01273756,10.1960394 8.03537171,10.208137 C8.02795707,10.1991614 7.9463961,10.2136004 7.95264,10.1960394 L7.96122537,10.1819906 C7.93468878,10.1831614 7.91790829,10.1968199 7.89683512,10.2026736 C7.89332293,10.2015028 7.88629854,10.1987711 7.88785951,10.1964297 C7.88356683,10.2178931 7.82464,10.1944784 7.79342049,10.2112589 C7.73800585,10.2038443 7.6521522,10.2104784 7.62600585,10.1972101 C7.58346927,10.2038443 7.54405463,10.2112589 7.49566439,10.206576 C7.50542049,10.2046248 7.51868878,10.2038443 7.52142049,10.1995516 C7.49098146,10.1933077 7.48317659,10.1987711 7.45546927,10.2022833 C7.46171317,10.1991614 7.39420098,10.1897955 7.36024976,10.1823809 C7.33917659,10.1855028 7.33224976,10.1899906 7.33005463,10.194576 L7.32824976,10.2073565 C7.28961561,10.1862833 7.20844488,10.221015 7.15966439,10.2018931 C7.17449366,10.1991614 7.22171317,10.1913565 7.18620098,10.1862833 C7.14756683,10.1652101 7.1081522,10.2018931 7.04571317,10.1917467 L7.06093268,10.2093077 C7.03322537,10.1983809 6.96883512,10.2194541 6.97546927,10.2018931 C6.9543961,10.208137 6.90171317,10.1960394 6.90873756,10.2132101 C6.80610341,10.1987711 6.65898146,10.2217955 6.59576195,10.1913565 L6.55650631,10.1945073 C6.57624976,10.209698 6.58561561,10.1933077 6.59498146,10.1995516 C6.58171317,10.1999419 6.57898146,10.2046248 6.57742049,10.2069662 C6.54542049,10.2030638 6.52044488,10.2018931 6.55049366,10.1874541 C6.52730202,10.1687223 6.48461412,10.197011 6.46065792,10.2049661 L6.44965854,10.2054634 L6.4583961,10.238576 C6.45703024,10.2674541 6.45293268,10.2756492 6.44766439,10.2768199 L6.42990829,10.2729175 C6.43185951,10.3037467 6.43146927,10.3416004 6.44044488,10.3556492 L6.42565854,10.3904634 C6.4358177,10.4087781 6.39086001,10.3777975 6.40199277,10.3954267 L6.41065854,10.4064634 L6.42444488,10.413015 L6.42965854,10.4254634 L6.43265854,10.3964634 L6.45107902,10.3992101 C6.46776195,10.4000394 6.48844488,10.3995516 6.50093268,10.400137 C6.52942049,10.4024784 6.53293268,10.3896004 6.54151805,10.3899906 C6.54229854,10.3962345 6.58795707,10.3911614 6.56571317,10.3993565 C6.55595707,10.4013077 6.54346927,10.3935028 6.52746927,10.3989662 C6.54620098,10.4036492 6.54385951,10.4141858 6.58327415,10.4063809 C6.61254244,10.4005272 6.57585951,10.3833565 6.63127415,10.3907711 C6.61683512,10.3935028 6.61410341,10.3981858 6.6023961,10.4024784 L6.65468878,10.4087223 L6.65703024,10.3977955 C6.67810341,10.3915516 6.74210341,10.3993565 6.75381073,10.3868687 C6.77995707,10.385698 6.80922537,10.3942833 6.83420098,10.3954541 C6.86034732,10.4024784 6.90093268,10.398576 6.92668878,10.3911614 C6.94229854,10.3942833 6.98171317,10.3927223 7.00317659,10.3864784 C7.04532293,10.3946736 7.01722537,10.4266736 7.06405463,10.4134053 C7.10698146,10.413015 7.13117659,10.3938931 7.11400585,10.3868687 C7.19127415,10.3938931 7.27907902,10.3767223 7.35049366,10.3931126 C7.36142049,10.3888199 7.3543961,10.3860882 7.37742049,10.3837467 C7.49415916,10.4118443 7.54925523,10.3355795 7.68376992,10.4066016 L7.73965854,10.4434634 L7.71173124,10.4154017 C7.70379808,10.4075769 7.69905373,10.4029843 7.69639429,10.4004983 C7.68653917,10.3864216 7.68855979,10.3846364 7.71838102,10.4143485 L7.75829854,10.4555516 L7.74065854,10.4444634 C7.7508839,10.4813077 7.73137171,10.4867711 7.7481522,10.4965272 C7.75465626,10.4947061 7.75890558,10.4953131 7.76217207,10.4865543 L7.76565854,10.4694634 L7.76928634,10.5202162 C7.77100585,10.5789175 7.76932293,10.6431614 7.76259122,10.6709662 C7.76727415,10.6522345 7.77000585,10.6666736 7.7731278,10.6815028 C7.75751805,10.6768199 7.75517659,10.7259906 7.76064,10.7634541 L7.77000585,10.7685272 L7.76024976,10.7927223 L7.77302663,10.8187675 C7.77429854,10.8250259 7.77416846,10.8334378 7.77117659,10.8457955 C7.76766439,10.8477467 7.76376195,10.8500882 7.76103024,10.8567223 C7.76883512,10.8953565 7.78171317,10.9499906 7.77390829,10.9917467 L7.76024976,11.0260882 C7.76181073,11.0440394 7.77000585,11.0740882 7.77390829,11.0424784 C7.76571317,11.1138931 7.76454244,11.1603321 7.75244488,11.1829662 C7.78132293,11.3062833 7.7828839,11.4854053 7.78054244,11.6286248 C7.7668839,11.6629662 7.78600585,11.6442345 7.78093268,11.6711614 C7.77429854,11.6586736 7.76610341,11.7004297 7.75790829,11.6703809 C7.75049366,11.7254053 7.7703961,11.7414053 7.77351805,11.7773077 C7.7828839,11.7827711 7.76727415,11.7484297 7.77937171,11.7554541 L7.77885138,11.815754 C7.77954515,11.8276058 7.78158309,11.8372752 7.7863961,11.840137 C7.78054244,11.8537955 7.7703961,11.8432589 7.76454244,11.8358443 L7.77117659,11.8694053 C7.75478634,11.9103809 7.74190829,11.7757467 7.72161561,11.8186736 L7.72395707,11.8495028 C7.7091278,11.8791614 7.70756683,11.7675516 7.70210341,11.8452101 C7.7091278,11.8791614 7.72942049,11.9080394 7.73566439,11.8779906 C7.73859122,11.9306736 7.75600585,11.9225516 7.76403634,11.947137 L7.76665854,11.9764634 L7.76031683,11.9440516 C7.74307902,11.9755516 7.76064,12.0114541 7.75673756,12.0430638 C7.76220098,12.0079419 7.77624976,12.0376004 7.77898146,12.0602345 C7.77234732,12.0984784 7.76571317,12.0352589 7.7641522,12.0898931 C7.77234732,12.0988687 7.77859122,12.1492101 7.78405463,12.1055028 C7.8023961,12.1254053 7.77898146,12.1620882 7.79303024,12.1917467 C7.7801522,12.2093077 7.76298146,12.1355516 7.75673756,12.1956492 C7.76922537,12.1862833 7.77390829,12.2694053 7.79224976,12.2377955 C7.78873756,12.2612101 7.77898146,12.2639419 7.77117659,12.2467711 C7.76337171,12.2803321 7.79420098,12.3279419 7.76922537,12.3388687 L7.78210341,12.3501858 C7.77781073,12.3607223 7.77507902,12.3755516 7.76805463,12.3927223 C7.76766439,12.4223809 7.78522537,12.4879419 7.76610341,12.4852101 C7.76805463,12.494576 7.76727415,12.5620882 7.78054244,12.5363321 C7.78873756,12.4941858 7.77078634,12.4879419 7.78873756,12.4645272 C7.77390829,12.4941858 7.79068878,12.525015 7.79576195,12.5492101 C7.79107902,12.5675516 7.78951805,12.6007223 7.79771317,12.609698 C7.79342049,12.5987711 7.78834732,12.6046248 7.7863961,12.6159419 L7.79771317,12.6311614 L7.79712171,12.6588809 L7.78306073,12.6749541 L7.78099747,12.6848031 L7.78065854,12.6994634 L7.77165854,12.6594634 L7.76907902,12.6798443 C7.76707902,12.6893077 7.76532293,12.701015 7.76727415,12.7146736 C7.77781073,12.7252101 7.78990829,12.7451126 7.79810341,12.7540882 C7.80278634,12.7860882 7.7863961,12.7685272 7.79732293,12.800137 L7.78483512,12.7587711 C7.78171317,12.7525272 7.76766439,12.7868687 7.76805463,12.8297955 C7.77195707,12.8571126 7.7863961,12.8996492 7.79224976,12.8563321 C7.79224976,12.8777955 7.78600585,12.9082345 7.77859122,12.8910638 C7.78210341,12.9398443 7.78990829,12.8844297 7.7961522,12.926576 C7.7891278,12.9437467 7.77937171,12.9976004 7.76922537,13.0296004 L7.75166439,12.9855028 L7.75166439,13.0147711 C7.73800585,12.9769175 7.7411278,13.0338931 7.72629854,13.0128199 C7.72395707,13.0327223 7.72903024,13.0569175 7.73293268,13.0760394 C7.75634732,13.0175028 7.76493268,13.1412101 7.7863961,13.1244297 C7.79224976,13.2044297 7.73449366,13.1743809 7.76805463,13.2578931 C7.7721522,13.2476492 7.7823961,13.2670394 7.7846278,13.256137 L7.78365854,13.2444634 L7.78533457,13.257832 C7.78817388,13.2700436 7.79360838,13.2754974 7.79649908,13.2864242 L7.79565854,13.3234634 L7.79072312,13.3131017 C7.78243122,13.3119028 7.77219122,13.3593565 7.76220098,13.3094053 C7.76922537,13.313698 7.76766439,13.2742833 7.76532293,13.2649175 C7.7571278,13.2852101 7.74385951,13.2606248 7.74385951,13.3117467 C7.74581073,13.3429662 7.74620098,13.3855028 7.75751805,13.3792589 C7.77000585,13.3780882 7.75595707,13.3320394 7.76844488,13.3519419 C7.77273756,13.4139906 7.75400585,13.424137 7.77585951,13.4498931 C7.77390829,13.4108687 7.78678634,13.4011126 7.79498146,13.4018931 L7.80005463,13.4471614 L7.79185951,13.438576 C7.78600585,13.5115516 7.80668878,13.4600394 7.80473756,13.5306736 L7.78873756,13.5638443 C7.77507902,13.5470638 7.79498146,13.4612101 7.77234732,13.473698 C7.77182699,13.5043971 7.77668336,13.5213944 7.77824434,13.5421496 L7.77665854,13.5744634 L7.77265854,13.5464634 L7.76786561,13.5589541 C7.75990829,13.5735516 7.74629854,13.5950638 7.75946927,13.6442345 C7.76610341,13.6781858 7.76766439,13.6532101 7.77585951,13.6539906 C7.77820098,13.7277467 7.78717659,13.7496004 7.78834732,13.7972101 C7.77195707,13.7874541 7.78678634,13.8811126 7.77000585,13.8284297 C7.77937171,13.8042345 7.77859122,13.697698 7.76298146,13.6715516 C7.74346927,13.6984784 7.76571317,13.6137955 7.74581073,13.5977955 C7.74542049,13.6571126 7.72590829,13.6539906 7.71342049,13.6633565 C7.71264,13.6797467 7.71771317,13.6953565 7.71966439,13.7055028 C7.73137171,13.7125272 7.73137171,13.6910638 7.74346927,13.6898931 C7.74034732,13.7558443 7.74698146,13.8194541 7.75829854,13.8557467 C7.7543961,13.870576 7.74789203,13.8723971 7.74364271,13.8642165 L7.73865854,13.8484634 L7.74142049,13.9647223 C7.74103024,14.0048199 7.73976195,14.0444297 7.73800585,14.081698 C7.75751805,14.0333077 7.74268878,14.1648199 7.75868878,14.1316492 C7.76298146,14.0918443 7.77664,14.0575028 7.78561561,14.0793565 C7.78444488,14.1043321 7.77703024,14.078576 7.7731278,14.0891126 L7.77398056,14.1170801 L7.77265854,14.1674634 L7.76774556,14.1407559 C7.75957854,14.1183653 7.74596683,14.1532687 7.73410341,14.1429662 C7.74268878,14.1944784 7.72317659,14.1406248 7.72317659,14.1917467 C7.73176195,14.2432589 7.7383961,14.3064784 7.74151805,14.3638443 C7.72707902,14.4356492 7.7411278,14.5460882 7.74190829,14.6100882 C7.73410341,14.6436492 7.71693268,14.621015 7.71381073,14.6573077 C7.71420098,14.7002345 7.7321522,14.625698 7.72473756,14.6889175 C7.7251278,14.7021858 7.70951805,14.7989662 7.73410341,14.817698 L7.71576195,14.7981858 C7.71381073,14.8098931 7.71810341,14.8208199 7.72005463,14.8309662 C7.71589203,14.8312264 7.71224976,14.8373836 7.70901218,14.8357937 L7.70365854,14.8264634 L7.69924163,14.8660593 L7.70665854,14.9484634 L7.71771317,14.9230638 C7.72629854,14.9956492 7.71537171,15.0444297 7.71927415,15.1150638 L7.70834732,15.1127223 C7.72551805,15.133015 7.68844488,15.1369175 7.71107902,15.1295028 C7.70054244,15.1400394 7.73956683,15.1466736 7.76181073,15.137698 C7.72824976,15.1618931 7.67634732,15.1474541 7.67985951,15.0959419 C7.68610341,15.0655028 7.69273756,15.1291126 7.70366439,15.1099906 C7.70990829,15.099324 7.71060206,15.0668036 7.70736448,15.0431867 L7.69965854,15.0184634 L7.7003961,15.0431126 C7.70132293,15.0489175 7.7028839,15.0539906 7.70483512,15.0635516 C7.69468878,15.069015 7.69165355,15.0540123 7.68775111,15.0378533 L7.67965854,15.0154634 L7.67903024,15.0362833 L7.67865854,15.0364634 L7.67549456,15.0231108 C7.67292184,15.0046681 7.6723148,14.9836817 7.67205463,14.9550638 C7.67790829,14.9839419 7.68142049,14.9394541 7.68571317,14.9503809 C7.67244488,14.9472589 7.66854244,14.9062833 7.67205463,14.8532101 C7.68220098,14.8282345 7.67448282,14.7925055 7.66948192,14.7533077 L7.66565854,14.6934634 L7.68429854,14.7351126 L7.69565854,14.7844634 L7.69896701,14.7570223 C7.69937171,14.741557 7.69781073,14.7310638 7.70249366,14.7053077 C7.69273756,14.686576 7.67751805,14.6733077 7.67127415,14.6233565 L7.68103024,14.6206248 C7.67595707,14.5753565 7.66151805,14.5753565 7.66424976,14.5176004 C7.66893268,14.4184784 7.66893268,14.3166248 7.67049366,14.2409175 L7.68024976,14.2381858 C7.65956683,14.1960394 7.67244488,14.0980882 7.66307902,14.0415028 C7.67244488,13.9451126 7.65371317,13.8323321 7.67049366,13.7827711 C7.66307902,13.6126248 7.65527415,13.4639419 7.65917659,13.2879419 L7.67322537,13.3176004 C7.66268878,13.2859906 7.68142049,13.2973077 7.67946927,13.2660882 C7.6681522,13.3016004 7.66464,13.2231614 7.65605463,13.2013077 C7.66698146,13.1228687 7.6548839,13.0221858 7.6451278,12.9527223 L7.6548839,12.9499906 C7.63654244,12.8797467 7.65254244,12.7958443 7.65566439,12.7084297 C7.65995707,12.6982833 7.66893268,12.6826736 7.6681522,12.6565272 C7.6521522,12.6089175 7.65332293,12.5843321 7.64356683,12.5144784 C7.64356683,12.4637467 7.64746927,12.381015 7.65371317,12.3295028 C7.63146927,12.1378931 7.64551805,11.9427711 7.63224976,11.7437467 L7.64356683,11.7293077 C7.61898146,11.5365272 7.64122537,11.2992589 7.62873756,11.134576 L7.64864,11.150576 C7.6548839,11.0990638 7.64356683,11.0331126 7.62951805,11.0459906 C7.63576195,10.9940882 7.6201522,10.9168199 7.6361522,10.8840394 C7.64005463,10.8309662 7.62717659,10.8192589 7.62444488,10.7751614 C7.62938797,10.7046573 7.6303419,10.6636383 7.62927234,10.6145254 L7.62665854,10.5574634 C7.63424434,10.5633023 7.6382335,10.5581858 7.63927415,10.5417955 L7.63765854,10.5244634 L7.57738435,10.5234541 C7.49514407,10.5253619 7.40798959,10.5322996 7.33800585,10.5203321 C7.34698146,10.526576 7.32044488,10.5277467 7.3091278,10.5320394 C7.21468878,10.5324297 7.11517659,10.5191614 7.03985951,10.5300882 C7.02464,10.5269662 7.06405463,10.5191614 7.02542049,10.5187711 C7.00278634,10.5211126 7.02503024,10.5269662 6.99693268,10.5304784 C6.84356683,10.5421858 6.68668878,10.5179906 6.54776195,10.5215028 L6.45449366,10.5254053 L6.40766439,10.5269662 L6.39595707,10.5273565 C6.40331596,10.5347154 6.37677141,10.5084575 6.34962272,10.4815751 L6.30438628,10.4367528 L6.31673756,10.4489175 L6.31673756,10.4387711 L6.31634732,10.4157467 L6.3143961,10.2296004 L6.3143961,10.1523321 L6.3217429,10.1451789 L6.39634732,10.0711614 L6.41195707,10.0711614 L6.50483512,10.0715516 L6.68590829,10.0711614 C6.76278634,10.0578931 6.86971317,10.0941858 6.93293268,10.0672589 C6.95166439,10.0719419 7.00473756,10.0692101 6.99068878,10.078576 C7.05390829,10.065698 7.16746927,10.0902833 7.25917659,10.0742833 L7.2361522,10.0766248 C7.32824976,10.0871614 7.40981073,10.0727223 7.50737171,10.0820882 C7.49761561,10.0840394 7.47927415,10.0856004 7.47654244,10.0902833 C7.5143961,10.0992589 7.56590829,10.0703809 7.58620098,10.093015 C7.60766439,10.0926248 7.60181073,10.081698 7.58854244,10.0820882 C7.80200585,10.0910638 8.02951805,10.0766248 8.25156683,10.0711614 C8.41078634,10.0848199 8.26132293,10.1094053 8.38698146,10.0926248 C8.44473756,10.0824784 8.47166439,10.1140882 8.50522537,10.1019906 C8.49156683,10.0883321 8.52785951,10.0941858 8.52864,10.0859906 C8.62581073,10.0949662 8.64532293,10.1074541 8.72220098,10.0969175 C8.80610341,10.0836492 8.91068878,10.0949662 8.9863961,10.0711614 L9.17176195,10.0692101 L9.26385951,10.0680394 L9.30990829,10.0672589 L9.32665854,10.0664634 Z M8.12278634,10.445015 L8.10483512,10.4536004 L8.11965854,10.4534634 L8.04096927,10.5328138 C8.03318268,10.5405242 8.02697841,10.546672 8.02341591,10.5502094 L8.12265854,10.5514634 L8.12293268,11.0257955 C8.12210341,11.1442345 8.12044488,11.2633565 8.11732293,11.3835516 C8.09781073,11.4959419 8.09859122,11.5045272 8.1063961,11.6282345 L8.10962171,11.6419419 L8.1096339,11.7028687 C8.11054244,11.7121126 8.11244488,11.7193565 8.1161522,11.7222833 C8.11342049,11.8998443 8.11771317,12.0637467 8.11771317,12.2463809 C8.11576195,12.2175028 8.1028839,12.2026736 8.10405463,12.2374053 L8.11420098,12.2733077 C8.11185951,12.302576 8.12005463,12.3283321 8.1251278,12.304137 C8.13878634,12.7634541 8.10678634,13.2149662 8.11068878,13.6649175 C8.10405463,13.7718443 8.11029854,13.9236492 8.11342049,14.0399419 C8.09195707,14.3837467 8.07517659,14.6939906 8.09000585,15.0436492 C8.09117659,15.0428687 8.04981073,14.9972101 8.04044488,14.8528199 C8.00337171,14.6686248 8.04083512,14.4262833 8.01742049,14.2245272 C8.01585951,14.2007223 8.03771317,14.2307711 8.03264,14.1773077 C8.0041522,13.9817955 8.02093268,13.6735028 8.04317659,13.4354541 L8.04903024,13.4498931 C8.05332293,13.4046248 8.03420098,13.3492101 8.03693268,13.3012101 L8.04335003,13.309333 C8.0361522,13.2934053 8.04200585,13.2184784 8.03381073,13.1981858 C8.03810341,13.1790638 8.04746927,13.181015 8.0521522,13.1564297 L8.03927415,13.1291126 C8.00805463,13.0526248 8.04122537,12.9433565 8.02561561,12.8391614 C8.02834732,12.8442345 8.03107902,12.8543809 8.03381073,12.8461858 C8.01507902,12.6787711 8.01859122,12.4692101 8.01156683,12.2818931 C8.01624976,12.2893077 8.02444488,12.2963321 8.02990829,12.2854053 C8.01624976,12.2760394 8.01273756,12.2182833 8.01000585,12.1679419 C8.02405463,12.1453077 7.9971278,12.081698 8.00493268,12.0227711 C7.99322537,11.984137 8.01664,11.9634541 7.99907902,11.9279419 L8.01000585,11.9002345 C7.99010341,11.8811126 8.0201522,11.8374053 8.01000585,11.8015028 C8.00142049,11.7687223 8.01117659,11.7511614 8.00805463,11.7195516 C8.00785951,11.6799419 8.00932293,11.6507711 8.00946927,11.6310638 L8.00765854,11.6084634 L8.01049366,11.6230638 C8.01264,11.6390638 8.01546927,11.6532101 8.02444488,11.6329175 C8.00844488,11.390576 8.01156683,11.1408199 8.01117659,10.8969175 C8.01742049,10.8692101 8.01937171,10.8516492 8.02522537,10.8454053 C8.02210341,10.8208199 8.02249366,10.753698 8.01468878,10.7314541 C8.01507902,10.7396492 8.02249366,10.7158443 8.02327415,10.7029662 C8.0291278,10.6584784 8.00610341,10.654576 8.0131278,10.6057955 C8.01742049,10.6253077 8.02210341,10.6319419 8.02795707,10.6253077 L8.01785951,10.5550638 L8.01365854,10.4794634 L8.01665854,10.4864634 L8.01460449,10.4599255 C8.02750439,10.4322775 8.09937171,10.4543809 8.12278634,10.445015 Z M10.8541034,11.0889175 L10.8607376,11.1419906 C10.8498107,11.1513565 10.8541034,11.1240394 10.8412254,11.1275516 C10.8299083,11.1302833 10.8221034,11.1572101 10.8299083,11.1654053 C10.8349815,11.1560394 10.8330302,11.1544784 10.83264,11.1455028 C10.8478595,11.1478443 10.8412254,11.1626736 10.8474693,11.1739906 L10.8521522,11.1599419 C10.8544937,11.1728199 10.8513717,11.1833565 10.8451278,11.2005272 C10.8443473,11.1868687 10.8338107,11.2032589 10.8318595,11.1974053 C10.8435668,11.2036492 10.8408351,11.2212101 10.8287376,11.2407223 C10.8084449,11.2500882 10.8217132,11.2836492 10.8076644,11.3062833 C10.7994693,11.2914541 10.7947863,11.2750638 10.7959571,11.2582833 C10.7834693,11.2711614 10.7893229,11.2754541 10.7768351,11.2879419 C10.783079,11.2988687 10.7951766,11.3097955 10.7924449,11.3320394 C10.7803473,11.3492101 10.7940059,11.3546736 10.7819083,11.376137 C10.7612254,11.4136004 10.7448351,11.4537955 10.7311766,11.4834541 C10.7342985,11.505698 10.706201,11.5392589 10.7058107,11.5654053 C10.6812254,11.5997467 10.6804449,11.6516492 10.65664,11.6649175 C10.6359571,11.7347711 10.6187863,11.7964297 10.5867863,11.8647223 L10.578201,11.8475516 C10.5828839,11.8639419 10.5672741,11.8526248 10.5641522,11.8655028 L10.5754693,11.8998443 C10.5524449,11.9267711 10.5469815,11.9708687 10.5450302,12.0020882 C10.541518,12.0340882 10.51264,12.0614053 10.4958595,12.094576 C10.4903961,12.0969175 10.4794693,12.0996492 10.4759571,12.110576 C10.4829815,12.1351614 10.4779083,12.1445272 10.4759571,12.1757467 C10.467762,12.1956492 10.4505912,12.2268687 10.4365424,12.2452101 C10.4260059,12.3291126 10.3811278,12.4013077 10.3612254,12.4848199 L10.3483473,12.4863809 C10.339762,12.5718443 10.2804449,12.6573077 10.2656156,12.7271614 L10.2500059,12.7135028 C10.2359571,12.7314541 10.2355668,12.7618931 10.2507863,12.7618931 C10.2367376,12.7802345 10.2386888,12.8165272 10.2183961,12.8235516 C10.2062985,12.8430638 10.2164449,12.8524297 10.211762,12.8707711 C10.1956319,12.8967874 10.1881739,12.912744 10.1811784,12.9325164 L10.1736585,12.9554634 C10.1658107,12.9512589 10.1625912,12.9527223 10.1598595,12.9574053 C10.159079,12.9741858 10.1329327,13.009698 10.16064,13.0038443 C10.1406075,13.0285597 10.13393,13.065763 10.1216445,13.0979942 L10.1056585,13.1224634 L10.1654241,13.129763 C10.1865695,13.1324513 10.2072091,13.1344459 10.2269815,13.1334053 C10.3327376,13.1209175 10.4427863,13.1271614 10.5438595,13.1252101 C10.57664,13.1119419 10.6222985,13.1482345 10.6492254,13.1213077 C10.6574205,13.1259906 10.6796644,13.1232589 10.6738107,13.1326248 C10.7007376,13.1197467 10.749518,13.1443321 10.7881522,13.1283321 L10.7783961,13.1306736 C10.8178107,13.1412101 10.8525424,13.1267711 10.8942985,13.1365272 C10.8900059,13.1384784 10.882201,13.1400394 10.8810302,13.1447223 C10.8970302,13.153698 10.9192741,13.1248199 10.9278595,13.1474541 C10.9372254,13.1474541 10.9344937,13.136137 10.92864,13.1369175 C11.0195668,13.1455028 11.1167376,13.1310638 11.2115668,13.1259906 C11.2794693,13.1392589 11.2158595,13.1638443 11.2693229,13.1470638 C11.2939083,13.1369175 11.3056156,13.1685272 11.3200546,13.1564297 C11.314201,13.1427711 11.3294205,13.1486248 11.3298107,13.1404297 C11.3715668,13.1494053 11.379762,13.1618931 11.4125424,13.1513565 C11.4484449,13.1380882 11.4929327,13.1494053 11.5253229,13.1256004 L11.8186585,13.1154634 L11.8640546,13.2180882 L11.8414205,13.2247223 C11.85664,13.217698 11.8328351,13.2052101 11.8433717,13.2020882 L11.7981034,13.2360394 C11.7875668,13.2368199 11.795762,13.2219906 11.7801522,13.2266736 C11.7809327,13.2313565 11.7739083,13.2344784 11.7696156,13.2383809 C11.7653229,13.2364297 11.7247376,13.2426736 11.7200546,13.2251126 C11.7153717,13.2180882 11.7376156,13.2212101 11.725518,13.2153565 C11.7056156,13.2153565 11.7048351,13.2216004 11.6849327,13.2216004 C11.6759571,13.217698 11.6616481,13.2215137 11.6572254,13.2271216 L11.6480546,13.2412589 C11.6385912,13.2432589 11.627762,13.2440394 11.6178107,13.2442345 C11.6244449,13.2415028 11.6236644,13.2368199 11.6263961,13.2317467 C11.5994693,13.2454053 11.5713717,13.249698 11.5413229,13.2555516 C11.5409327,13.2637467 11.55264,13.2403321 11.5569327,13.2446248 C11.5186888,13.2329175 11.4781034,13.261015 11.4461034,13.2442345 C11.4511766,13.2426736 11.4488351,13.2559419 11.4484449,13.2536004 C11.4301034,13.2524297 11.4308839,13.2403321 11.4187863,13.245015 C11.4176156,13.2379906 11.4035668,13.2473565 11.3914693,13.2493077 C11.3817132,13.2508687 11.31264,13.2617955 11.2728351,13.2516492 C11.2736156,13.2563321 11.2482498,13.2688199 11.2392741,13.2684386 L11.2427863,13.2575028 L11.2326585,13.2544634 L11.2456585,13.2484634 L11.2276585,13.2504634 C11.2263238,13.2541785 11.2214819,13.2543664 11.2176951,13.2538316 L11.1921847,13.2569825 C11.1862443,13.257286 11.1803473,13.2563321 11.1744937,13.2528199 C11.1795668,13.2547711 11.1893229,13.2376004 11.1744937,13.2383809 C11.1483473,13.2403321 11.167079,13.2434541 11.1460059,13.2473565 L11.1327376,13.2516492 C11.1319571,13.262576 11.1093229,13.2500882 11.119079,13.2621858 C11.1159571,13.2536004 11.0812254,13.2676492 11.0839571,13.2500882 L11.0874693,13.2360394 C11.0761522,13.2368199 11.0691278,13.2508687 11.0601522,13.2567223 C11.0542985,13.2719419 11.0293229,13.2485272 11.0160546,13.2653077 C10.9922498,13.2578931 10.9559571,13.2645272 10.94464,13.2512589 C10.9262985,13.2578931 10.9099083,13.2653077 10.8892254,13.2606248 L10.9001522,13.2536004 C10.8868839,13.2473565 10.883762,13.2528199 10.8720546,13.2563321 C10.8747863,13.2532101 10.8459083,13.2438443 10.8314693,13.2364297 C10.813518,13.2426736 10.819762,13.2543809 10.8178107,13.2614053 C10.8014205,13.2403321 10.7666888,13.2750638 10.7460059,13.2559419 C10.7522498,13.2532101 10.7725424,13.2454053 10.7573229,13.2403321 C10.7409327,13.2192589 10.7241522,13.2559419 10.6972254,13.2457955 L10.7038595,13.2633565 C10.6921522,13.2524297 10.6644449,13.2735028 10.6671766,13.2559419 C10.658201,13.2621858 10.6355668,13.2500882 10.6386888,13.2672589 C10.5949815,13.2528199 10.5321522,13.2758443 10.5052254,13.2454053 C10.4989815,13.248137 10.4833717,13.2454053 10.4864937,13.2539906 C10.4970302,13.2633565 10.5013229,13.2473565 10.5048351,13.2536004 C10.4989815,13.2539906 10.498201,13.2586736 10.4974205,13.261015 C10.483762,13.2571126 10.4732254,13.2559419 10.4861034,13.2418931 C10.4556644,13.2313565 10.4548839,13.2707711 10.4162498,13.264137 C10.418201,13.2571126 10.415079,13.2543809 10.403762,13.2555516 L10.3822985,13.2676492 C10.3573229,13.2649175 10.3682498,13.2516492 10.3674693,13.2395516 C10.354201,13.2415028 10.3378107,13.2411126 10.3319571,13.2500882 L10.3159571,13.2348687 C10.3276644,13.2457955 10.3050302,13.2418931 10.2987863,13.245015 C10.3026888,13.2368199 10.287079,13.2399419 10.2792741,13.2415028 C10.2812254,13.2489175 10.2968351,13.2520394 10.3054205,13.2539906 L10.2788839,13.264137 C10.2820059,13.2524297 10.2570302,13.2555516 10.2468839,13.2547711 C10.2347863,13.2520394 10.2332254,13.2653077 10.2297132,13.2649175 C10.2293229,13.2586736 10.2098107,13.2637467 10.2191766,13.2555516 C10.223079,13.2536004 10.2285424,13.2614053 10.2355668,13.2559419 C10.2273717,13.2512589 10.2285424,13.2407223 10.211762,13.2485272 C10.1992741,13.2543809 10.2148839,13.2715516 10.1914693,13.264137 L10.2035668,13.2524297 L10.1813229,13.2461858 L10.1796585,13.2554634 C10.1715668,13.2629662 10.1442498,13.2551614 10.1391766,13.2676492 C10.1278595,13.2688199 10.1153717,13.2602345 10.1048351,13.2590638 C10.093518,13.2520394 10.0763473,13.2559419 10.0654205,13.2633565 C10.0587863,13.2602345 10.0416156,13.2617955 10.03264,13.2680394 C10.0146888,13.2598443 10.0267863,13.2278443 10.0064937,13.2411126 L9.9943961,13.2446248 L9.97835286,13.2274279 C9.97210441,13.2182475 9.96373408,13.2059349 9.95264,13.1896004 C9.94561561,13.1771126 9.9401522,13.1739906 9.93546927,13.1763321 C9.95459122,13.149015 9.95264,13.1080394 9.97956683,13.0861858 C9.97722537,13.0799419 9.97371317,13.0818931 9.9748839,13.072137 C9.9971278,13.0292101 10.0014205,12.9737955 10.035762,12.9464784 L10.0513717,12.9535028 C10.0466888,12.9394541 10.0658107,12.9445272 10.0521522,12.9343809 C10.0427863,12.9320394 10.0388839,12.9289175 10.0299083,12.9402345 C10.0361522,12.9117467 10.0525424,12.8715516 10.0669815,12.8602345 C10.0599571,12.8660882 10.0595668,12.8590638 10.0591766,12.8520394 C10.0728351,12.8598443 10.0829815,12.8411126 10.083762,12.8243321 L10.0888351,12.8126248 C10.0884449,12.8056004 10.0728351,12.7989662 10.0872741,12.7876492 L10.098201,12.7872589 C10.0974205,12.7693077 10.0939083,12.7427711 10.1083473,12.7291126 L10.1266888,12.7205272 C10.1282498,12.7131126 10.125518,12.6978931 10.1165424,12.7088199 C10.1360546,12.6834541 10.14464,12.6658931 10.159079,12.6612101 C10.1520546,12.6015028 10.1801522,12.5304784 10.205518,12.4746736 C10.2238595,12.4660882 10.2031766,12.4664784 10.2121522,12.4575028 C10.2164449,12.4649175 10.2304937,12.4512589 10.2332254,12.4664784 L10.2404521,12.4490909 L10.2363473,12.4184784 C10.2285424,12.4126248 10.2371278,12.432137 10.2273717,12.4251126 C10.2254205,12.4212101 10.2464937,12.3977955 10.2347863,12.3892101 C10.242201,12.385698 10.2500059,12.3938931 10.2542985,12.3989662 L10.253518,12.3829662 C10.2753717,12.3728199 10.2656156,12.4309662 10.2913717,12.4216004 L10.2941034,12.4083321 C10.3124449,12.4020882 10.2960546,12.4469662 10.3136156,12.4180882 C10.3128351,12.4020882 10.2983961,12.3833565 10.2878595,12.3927223 C10.2956644,12.3634541 10.2621034,12.3673565 10.2753717,12.337698 C10.2862985,12.3326248 10.2675668,12.3622833 10.2804449,12.3611126 C10.2968351,12.3513565 10.2862985,12.3302833 10.2952741,12.3193565 C10.2843473,12.3314541 10.2761522,12.3142833 10.2773229,12.304137 C10.2898107,12.2912589 10.2859083,12.3189662 10.2956644,12.2978931 C10.2894205,12.2912589 10.2921522,12.2694053 10.2796644,12.2842345 C10.2656156,12.2694053 10.2937132,12.2635516 10.2851278,12.2467711 C10.2999571,12.2444297 10.3038595,12.2799419 10.3194693,12.2588687 C10.3065912,12.2580882 10.3159571,12.2233565 10.2933229,12.2292101 C10.3003473,12.221015 10.3101034,12.224137 10.3143961,12.2335028 C10.3272741,12.2233565 10.3065912,12.1929175 10.3315668,12.1979906 L10.3214205,12.1886248 L10.3417132,12.1773077 C10.3467863,12.1656004 10.3413229,12.1332101 10.3584937,12.1414053 C10.3581034,12.1371126 10.3698107,12.110576 10.3534205,12.1160394 C10.3389815,12.129698 10.3545912,12.1386736 10.3342985,12.141015 C10.35264,12.1347711 10.3424937,12.1164297 10.3417132,12.1051126 C10.3487376,12.0996492 10.355762,12.0871614 10.349518,12.0805272 C10.3518595,12.0863809 10.3573229,12.0859906 10.3608351,12.0820882 L10.35264,12.0719419 C10.3569327,12.046576 10.3733229,12.0738931 10.3795668,12.0500882 L10.3807376,12.0703809 C10.3803473,12.0660882 10.3936156,12.0621858 10.3947863,12.0500882 L10.3725424,12.0231614 C10.3733229,12.0087223 10.3858107,12.0216004 10.3807376,12.0052101 L10.3858107,12.0262833 C10.387762,12.0301858 10.4061034,12.0216004 10.4127376,12.0044297 C10.4139083,11.9923321 10.4068839,11.9700882 10.3947863,11.9849175 C10.3979083,11.9763321 10.4088351,11.9669662 10.4131278,11.9763321 C10.4178107,11.9556492 10.4018107,11.9747711 10.4025912,11.9556492 C10.4115668,11.9513565 10.429518,11.9337955 10.4439571,11.9248199 L10.4524149,11.9463778 C10.4554619,11.9323828 10.4551634,11.913816 10.459103,11.9071278 C10.457518,11.8950638 10.4548839,11.881698 10.4435668,11.8811126 C10.4509815,11.8471614 10.499762,11.8807223 10.4825912,11.8350638 C10.4751766,11.838576 10.466201,11.8167223 10.4638595,11.8389662 C10.4740059,11.8202345 10.4494205,11.8175028 10.4669815,11.7979906 C10.4681522,11.8182833 10.4946888,11.7874541 10.4962498,11.8171126 C10.4903961,11.8128199 10.4857132,11.8288199 10.4857132,11.8335028 C10.49664,11.8284297 10.5052254,11.8432589 10.5130302,11.8229662 C10.5161522,11.8100882 10.5227863,11.7929175 10.5114693,11.7913565 C10.499762,11.7870638 10.5048351,11.8104784 10.49664,11.7979906 C10.5028839,11.7718443 10.5216156,11.7749662 10.5056156,11.7566248 C10.5009327,11.7726248 10.4876644,11.7718443 10.4798595,11.7683321 L10.4825912,11.7484297 C10.5060059,11.7285272 10.4786888,11.741015 10.4919571,11.7140882 L10.5122498,11.7070638 C10.5223961,11.7187711 10.4900059,11.7453077 10.51264,11.7488199 L10.5174205,11.7261858 L10.5246585,11.7084634 L10.5239571,11.7203321 C10.5274693,11.7140882 10.5579083,11.7187711 10.5520546,11.6863809 C10.5512741,11.6703809 10.546201,11.6797467 10.5383961,11.6762345 C10.547762,11.6461858 10.5434693,11.6340882 10.5501034,11.6149662 C10.563762,11.6247223 10.5653229,11.5821858 10.5723473,11.6091126 C10.5594693,11.6149662 10.543079,11.6575028 10.5532254,11.6738931 C10.5758595,11.6707711 10.541518,11.6957467 10.5571278,11.7094053 C10.5668839,11.6863809 10.5844449,11.694576 10.5977132,11.6953565 C10.6012254,11.6891126 10.5988839,11.6809175 10.5984937,11.6762345 C10.5887376,11.6692101 10.5852254,11.6777955 10.5739083,11.6735028 C10.5875668,11.6485272 10.5918595,11.6208199 10.5867863,11.6024784 C10.595762,11.5958443 10.605518,11.6028687 10.6023961,11.6137955 C10.610201,11.5878833 10.6212527,11.5619711 10.6333534,11.5382568 C10.636722,11.5316853 10.6396427,11.5262248 10.6425912,11.5209175 C10.6168351,11.5326248 10.6519571,11.486576 10.6316644,11.4936004 C10.6211278,11.5076492 10.6027863,11.5162345 10.5984937,11.504137 C10.6035668,11.4947711 10.6062985,11.5076492 10.611762,11.5049175 C10.607079,11.4885272 10.6355668,11.4916492 10.6250302,11.4733077 C10.6191766,11.504137 10.6445424,11.4877467 10.65664,11.4982833 C10.656863,11.4846805 10.6598894,11.4882803 10.6640444,11.490078 C10.6717186,11.4884622 10.6731603,11.4864459 10.6745912,11.4830638 C10.6753717,11.4596492 10.6792741,11.4319419 10.685518,11.408137 C10.7104937,11.3851126 10.7151766,11.3363321 10.7253229,11.310576 C10.7378107,11.3000394 10.7499083,11.3156492 10.7588839,11.3023809 C10.765518,11.2852101 10.73664,11.3078443 10.754201,11.2859906 C10.7561522,11.2809175 10.786201,11.248137 10.7662985,11.2317467 L10.7803473,11.246576 C10.7838595,11.2422833 10.7819083,11.2368199 10.781518,11.2317467 C10.7869815,11.233698 10.7943961,11.230576 10.7947863,11.2395516 C10.8131278,11.229015 10.8064937,11.2063809 10.8127376,11.1896004 L10.7979083,11.1962345 C10.8018107,11.1642345 10.819762,11.149015 10.8275668,11.1197467 L10.8373229,11.1248199 L10.8381034,11.105698 C10.8462985,11.1138931 10.8583961,11.101015 10.8541034,11.0889175 Z M11.0137132,11.0557467 C11.0141034,11.0549662 11.059762,11.057698 11.091762,11.1115516 C11.155762,11.1708687 11.1604449,11.2805272 11.2146888,11.3515516 C11.219762,11.3605272 11.1947863,11.3566248 11.2080546,11.376137 C11.266201,11.4428687 11.3001522,11.5708687 11.3181034,11.6735028 C11.3138107,11.6895028 11.3407376,11.7043321 11.3458107,11.7242345 C11.3422985,11.7257955 11.3383961,11.7199419 11.3352741,11.726576 C11.347762,11.7269662 11.3540059,11.7589662 11.3653229,11.7640394 C11.3641522,11.773015 11.3555668,11.7757467 11.3547863,11.7874541 L11.3711766,11.793698 C11.4121522,11.8124297 11.3992741,11.8678443 11.4308839,11.9033565 C11.4663961,11.9630638 11.4972254,12.0473565 11.533518,12.1187711 C11.5280546,12.1176004 11.5194693,12.1179906 11.5159571,12.1242345 C11.5300059,12.1226736 11.5424937,12.1445272 11.5534205,12.1632589 C11.5440546,12.1773077 11.5791766,12.1925272 11.581518,12.2186736 C11.5986888,12.2296004 11.5803473,12.2467711 11.6025912,12.2537955 L11.5967376,12.269015 C11.618201,12.269015 11.597518,12.2978931 11.6123473,12.3084297 C11.6260059,12.3181858 11.6193717,12.3287223 11.6275668,12.3400394 C11.6427863,12.3693077 11.6392741,12.3903809 11.6533229,12.3837467 C11.6459083,12.398576 11.6365424,12.3576004 11.6263961,12.3806248 C11.6802498,12.4703809 11.7177132,12.5706736 11.757518,12.6670638 C11.7559571,12.6803321 11.7571278,12.6877467 11.7528351,12.6924297 C11.7594693,12.701015 11.7703961,12.7275516 11.7813229,12.7334053 C11.779762,12.7302833 11.7762498,12.7423809 11.7778107,12.7478443 C11.7793717,12.7677467 11.8012254,12.7607223 11.8027863,12.782576 C11.795762,12.7763321 11.7899083,12.7755516 11.7856156,12.7802345 C11.8035668,12.7919419 11.8105912,12.8149662 11.8222985,12.8329175 C11.8183961,12.8309662 11.8152741,12.8266736 11.8109815,12.8294053 C11.8324449,12.8454053 11.8242498,12.8692101 11.8398595,12.8848199 L11.8289327,12.8813077 C11.8312741,12.9152589 11.8500059,12.8832589 11.8542985,12.9113565 C11.8492254,12.9062833 11.8468839,12.9097955 11.8429815,12.9097955 C11.8679571,12.9277467 11.8788839,12.9691126 11.8941034,12.9909662 C11.9026888,13.0167223 11.9093229,13.0463809 11.9276644,13.0725272 C11.9280546,13.0846248 11.9058107,13.0772101 11.9202498,13.1037467 L11.934761,13.1111036 L11.9151766,13.1115516 L11.8379083,13.1146736 L11.8186585,13.1154634 L11.8027863,13.0776004 C11.7305912,12.8887223 11.6459083,12.7092101 11.5799571,12.5144784 C11.5795668,12.462576 11.5780059,12.4594541 11.5506888,12.4134053 C11.5421034,12.416137 11.5421034,12.3786736 11.5264937,12.3798443 C11.5003473,12.3084297 11.4699083,12.2452101 11.4402498,12.173015 C11.4464937,12.1839419 11.4609327,12.1847223 11.4542985,12.1714541 L11.439079,12.1609175 C11.4359571,12.1484297 11.42464,12.1414053 11.4238595,12.1527223 C11.3368351,11.9759419 11.293518,11.7855028 11.2170302,11.6091126 C11.2057132,11.5642345 11.1760546,11.5064784 11.154201,11.4616004 C11.1182985,11.3176004 11.0839571,11.1888199 11.0137132,11.0557467 Z M13.938201,10.0731126 L14.0195607,10.1481248 L14.0244449,10.1632589 L14.0248351,10.1788687 C14.0111766,10.4188687 13.9865912,10.193698 14.0033717,10.382576 C13.999079,10.3981858 14.0119571,10.3938931 14.0072741,10.3962345 C14.013518,10.4696004 13.9819083,10.5101858 13.9936156,10.5609175 C14.0076644,10.5402345 14.0014205,10.5948687 14.0100059,10.5964297 C14.0010302,10.7431614 13.9881522,10.7724297 13.9986888,10.8883321 L13.9912741,10.8797467 C14.0119571,11.0155516 14.0010302,11.1728199 14.0248351,11.2871614 C14.0306888,12.0340882 14.0388839,12.7556492 14.04864,13.4791614 C14.0576156,13.8280394 14.1052254,14.1847223 14.3319571,14.4192589 C14.5532254,14.6541858 14.9028839,14.7817955 15.2447376,14.8141858 C15.4059083,14.8403321 15.4211278,14.8376004 15.5986888,14.8044297 C15.5920546,14.8087223 15.5807376,14.8110638 15.5936156,14.8118443 C15.6002498,14.798576 15.7181034,14.782576 15.7309815,14.7646248 C15.9811278,14.702576 16.2008351,14.5827711 16.3674693,14.3966248 C16.3417132,14.4266736 16.3374205,14.4504784 16.3694205,14.414576 L16.3955668,14.3708687 C16.4193717,14.337698 16.4322498,14.304137 16.4096156,14.3291126 C16.7296156,13.7819906 16.6020059,13.024137 16.6382985,12.3560394 C16.6449327,12.1933077 16.6386888,11.9615028 16.6355668,11.7847223 C16.6570302,11.2606248 16.6738107,10.7880394 16.6589815,10.2553565 C16.6562498,10.2553565 16.6976156,10.3248199 16.7069815,10.5445272 C16.7440546,10.8251126 16.7065912,11.1942833 16.7300059,11.5017955 C16.7315668,11.537698 16.7097132,11.4924297 16.7147863,11.5736004 C16.7375766,11.8118053 16.7313951,12.1599028 16.716622,12.4754322 L16.7036585,12.7024634 L16.6983961,12.6818931 C16.6941034,12.7509662 16.7132254,12.8352589 16.7104937,12.9086248 C16.7065912,12.909015 16.7050302,12.8852101 16.6999571,12.9019906 C16.7112741,12.9203321 16.7054205,13.0342833 16.7136156,13.0655028 C16.7093229,13.0943809 16.6999571,13.0916492 16.6952741,13.1291126 L16.7081522,13.1708687 C16.7306888,13.2583809 16.7189815,13.3737711 16.7136949,13.4930028 L16.7116585,13.6094634 L16.7088731,13.6003975 C16.7116644,13.854576 16.655079,14.1835516 16.4825912,14.4216004 C16.4853229,14.4091126 16.4841522,14.3954541 16.4708839,14.4063809 C16.4782985,14.429015 16.41664,14.4941858 16.3659083,14.5535028 C16.3272741,14.5613077 16.274201,14.6537955 16.1875668,14.6900882 C16.1419083,14.7306736 16.1036644,14.7295028 16.0611278,14.7661858 L16.0174205,14.7739906 C15.999079,14.8059906 15.9245424,14.8048199 15.8749815,14.8301858 C15.8297132,14.8547711 15.8012254,14.8559419 15.7543961,14.8692101 C15.6619083,14.8958248 15.600718,14.8986345 15.582336,14.9064394 L15.5929257,14.9027586 C15.6209951,14.8960901 15.6594888,14.8884101 15.6201522,14.8832589 C15.2548839,14.9734053 14.84864,14.8898931 14.5204449,14.7084297 C14.4868839,14.6811126 14.46464,14.6655028 14.4595668,14.6557467 C14.4232741,14.6424784 14.3463961,14.5726248 14.3132254,14.5589662 C14.3229815,14.5663809 14.2987863,14.5386736 14.2874693,14.5222833 C14.2606725,14.4861207 14.2401197,14.4799635 14.2174855,14.4607982 L14.1836585,14.4194634 L14.197453,14.4333511 C14.2067321,14.4401153 14.2120221,14.4389012 14.210201,14.432137 C14.1672741,14.3864784 14.1118595,14.3181858 14.082201,14.2487223 C14.0892254,14.2580882 14.098201,14.2740882 14.1013229,14.2694053 C14.0529327,14.2007223 14.0420059,14.1320394 14.0162498,14.0649175 L14.03264,14.0879419 C14.0157815,13.9970931 14.0049171,14.0346189 13.9942525,14.0021132 L13.9856585,13.9624634 L13.9920835,13.9755083 C13.9627863,13.8912589 13.9475668,13.7394541 13.93664,13.6469662 C13.9315668,13.5497955 13.9331278,13.4432589 13.9249327,13.3320394 C13.9281211,13.2988803 13.9406873,13.3287615 13.9432638,13.2822782 L13.9421888,13.2638809 C13.9437886,13.2597645 13.9436627,13.249864 13.9432741,13.2379906 C13.9253229,13.2418931 13.9358595,13.056137 13.9151766,13.1193565 C13.9179083,13.0276492 13.9249327,12.8828687 13.9186888,12.8219906 C13.9239961,12.8547711 13.934798,12.8066306 13.9397058,12.8250252 L13.9416585,12.8514634 L13.9526585,12.7984634 L13.9558839,12.8393626 C13.9588839,12.798576 13.9518595,12.6877467 13.9549815,12.6534053 C13.9440546,12.5827711 13.9233717,12.5179906 13.9210302,12.4036492 C13.9280546,12.4575028 13.9409327,12.3732101 13.9440546,12.4095028 L13.9097132,12.2498931 C13.9089327,12.2120394 13.923762,12.241698 13.919079,12.1866736 C13.9143961,12.1894053 13.9112741,12.1656004 13.9073717,12.1488199 C13.9097132,12.1343809 13.903079,11.9903809 13.92064,11.9739906 C13.9276644,11.9572101 13.9245424,12.0360394 13.9307863,11.9938931 C13.9307863,11.9236492 13.9245424,11.9205272 13.9241522,11.8502833 C13.9292254,11.8022833 13.919079,11.712137 13.9089327,11.7624784 L13.9064467,11.7511758 C13.9025153,11.7120936 13.9011278,11.6602345 13.9011278,11.6134053 L13.9045533,11.6299834 L13.8988351,11.4982833 L13.8906585,11.3554634 L13.8979047,11.3776112 L13.9006585,11.3954634 L13.902313,11.2623737 C13.9005063,11.2168163 13.8974133,11.1717937 13.8961703,11.1287946 L13.9006585,11.0084634 C13.8953609,11.0207982 13.8898107,11.0167223 13.8913717,11.0159419 C13.8925424,10.9507711 13.90464,10.9538931 13.9003473,10.9113565 C13.9073717,10.9070638 13.8980059,10.8578931 13.8956644,10.8141858 L13.8956585,10.8114634 L13.895858,10.7845241 C13.890201,10.6864199 13.8848937,10.5078443 13.8933229,10.3954541 C13.88864,10.3981858 13.875762,10.3092101 13.8765424,10.2768199 L13.8874693,10.2893077 L13.8902924,10.259765 L13.8896585,10.2544634 C13.8926299,10.2708507 13.8942501,10.2820554 13.8956738,10.2933132 L13.8952741,10.2710638 L13.8936585,10.2374634 L13.8907376,10.2233077 L13.8916585,10.2034634 L13.8824449,10.2035516 C13.8666888,10.2032589 13.8509815,10.2020882 13.8351766,10.1995516 C13.8531278,10.2015028 13.8882498,10.1843321 13.8355668,10.1851126 C13.7419083,10.1870638 13.8090302,10.1901858 13.7333229,10.1940882 L13.6857132,10.1983809 L13.6739296,10.2255028 C13.670079,10.2525394 13.6640059,10.2749662 13.6638595,10.2588687 L13.6498107,10.2459906 C13.6505912,10.2857955 13.66464,10.3111614 13.6704937,10.3427711 C13.6693229,10.3478443 13.6665912,10.3583809 13.6642498,10.3564297 L13.673262,10.3748504 L13.672701,10.4577894 C13.673201,10.4728931 13.6748839,10.4873565 13.679079,10.4992589 C13.6716644,10.5831614 13.6786888,10.7119419 13.6650302,10.7513565 C13.669453,10.7942833 13.6743961,10.8346085 13.6758125,10.8784604 L13.6746585,10.9424634 L13.6721522,10.9242345 C13.6711766,10.9169175 13.6699083,10.9109662 13.667762,10.909015 C13.6611278,10.9550638 13.6669815,10.9663809 13.6704937,11.0085272 C13.6673717,10.9991614 13.6576156,11.1006248 13.650201,11.1517467 C13.6568351,11.2157467 13.6681522,11.1935028 13.6751766,11.200137 C13.6537132,11.2586736 13.6888351,11.3808199 13.6697132,11.4541858 C13.6669815,11.4319419 13.6591766,11.3609175 13.6541034,11.4139906 C13.63264,11.4725272 13.6697132,11.5318443 13.6595668,11.6262833 L13.6771278,11.6032589 C13.666201,11.6454053 13.6872741,11.7421858 13.6693229,11.7324297 C13.6755668,11.7640394 13.6634693,11.8436492 13.68064,11.8331126 C13.666201,11.9880394 13.6896156,12.209698 13.6587863,12.3045272 C13.661518,12.3267711 13.6587863,12.3821858 13.6673717,12.3708687 C13.6771278,12.3337955 13.6607376,12.3193565 13.6669815,12.305698 C13.6673717,12.3256004 13.6720546,12.3298931 13.6743961,12.3322345 C13.6704937,12.3802345 13.6693229,12.4180882 13.6548839,12.3728199 C13.6443473,12.4797467 13.6841522,12.4832589 13.677518,12.6198443 C13.6704937,12.6136004 13.667762,12.624137 13.6689327,12.6639419 L13.6814205,12.7396492 C13.6786888,12.8278443 13.6650302,12.7896004 13.6529327,12.7919419 C13.6548839,12.8391614 13.6544937,12.8965272 13.6634693,12.9179906 L13.6486585,12.9714634 C13.6556394,12.9634743 13.6564012,12.9772047 13.6568757,12.9931703 L13.6566585,13.0204634 L13.6529616,13.035613 L13.6535542,13.0713276 L13.6546585,13.1034634 L13.661388,13.0850584 C13.6630357,13.0746952 13.6643365,13.0616438 13.6654205,13.048679 L13.6676585,13.0204634 L13.6729815,13.0566736 C13.6741034,13.073015 13.6753717,13.0902833 13.6786888,13.1060882 C13.6669815,13.0955516 13.6701034,13.1829662 13.6689327,13.2200394 C13.6665912,13.2629662 13.6794693,13.2684297 13.6794693,13.2809175 C13.6732254,13.2820882 13.6786888,13.3507711 13.6701034,13.3176004 C13.6681522,13.3027711 13.6759571,13.2840394 13.6704937,13.2598443 C13.666201,13.2879419 13.6552741,13.2848199 13.6634693,13.3433565 C13.6693229,13.3874541 13.6868839,13.3320394 13.6794693,13.4155516 C13.6763473,13.393698 13.6716644,13.3897955 13.6673717,13.3726248 L13.661518,13.4510638 L13.6724449,13.4541858 C13.6794693,13.4854053 13.6740059,13.5814053 13.6872741,13.598576 L13.6857132,13.7183809 C13.6810302,13.7574053 13.6888351,13.8178931 13.7028839,13.8537955 C13.7028839,13.8768199 13.7130302,13.9341858 13.7235668,13.9634541 C13.72864,14.0251126 13.6880546,13.9915516 13.7173229,14.0559419 C13.7290302,14.1021858 13.7468839,14.1299906 13.7554083,14.1299723 L13.7596585,14.1204634 L13.7972073,14.2291957 C13.827762,14.3007982 13.8665262,14.3700882 13.891762,14.4348687 C13.903079,14.4469662 13.9007376,14.4364297 13.9218107,14.4621858 C14.0061034,14.6057955 14.1508839,14.7127223 14.2457132,14.8083321 C14.2051278,14.7821858 14.2367376,14.8149662 14.2340059,14.8204297 C14.271079,14.8376004 14.2660059,14.8586736 14.2882498,14.8524297 C14.2909815,14.8415028 14.2948839,14.8426736 14.2609327,14.8102833 C14.3440546,14.8637467 14.4732254,14.9390638 14.5212254,14.9671614 C14.4985912,14.9515516 14.5188839,14.9577955 14.5395668,14.9644297 C14.527079,14.9734053 14.5902985,15.0128199 14.6461034,15.0237467 L14.6570302,15.0175028 L14.6878595,15.038576 C14.7093229,15.0428687 14.7167376,15.0276492 14.765518,15.054576 C14.767079,15.0588687 14.7690302,15.0635516 14.7780059,15.0697955 C14.8361522,15.0768199 14.9173229,15.0838443 14.9758595,15.1053077 L15.0238595,15.1259906 C15.045401,15.1278638 15.078681,15.1272394 15.0677541,15.1213202 L15.0536585,15.1164634 L15.1214998,15.131576 C15.1861278,15.1435028 15.2312741,15.1459906 15.2564449,15.1568199 C15.4418107,15.1384784 15.7040546,15.1072589 15.906201,15.0428687 C15.9581034,15.0389662 15.9264937,15.0303809 15.9651278,15.0214053 C15.9499083,15.0338931 16.0111766,15.0206248 15.971762,15.0432589 C16.0525424,15.0237467 16.0669815,14.9964297 16.11264,14.9698931 C16.115762,14.9581858 16.0767376,14.993698 16.0810302,14.9784784 C16.0876644,14.9714541 16.1856156,14.9367223 16.1902985,14.9191614 C16.2109815,14.9152589 16.2016156,14.9308687 16.1945912,14.941015 L16.2355668,14.912137 C16.2987863,14.8984784 16.1251278,15.0015028 16.1914693,14.9897955 L16.2328351,14.9675516 C16.2812254,14.9609175 16.1274693,15.0358443 16.237518,14.9894053 C16.2804449,14.9597467 16.3058107,14.9172101 16.2644449,14.9359419 C16.3522498,14.877015 16.2890302,14.8824784 16.3842498,14.8243321 C16.415079,14.8149662 16.3097132,14.8735028 16.3339083,14.8715516 C16.3869815,14.8551614 16.418201,14.8071614 16.4572254,14.7814053 C16.4131278,14.8095028 16.4388839,14.7708687 16.4634693,14.7486248 C16.5122498,14.7189662 16.4427863,14.7814053 16.5071766,14.7334053 C16.514201,14.7209175 16.56064,14.6643321 16.5122498,14.7045272 C16.5204449,14.6713565 16.5739083,14.6502833 16.5945912,14.6100882 C16.6226888,14.6007223 16.5579083,14.6885272 16.6250302,14.6311614 C16.610201,14.6319419 16.6831766,14.5433565 16.6386888,14.5659906 C16.6609327,14.541015 16.671079,14.5437467 16.6624937,14.5687223 C16.6972254,14.5332101 16.7124449,14.4598443 16.7424937,14.4602345 L16.7417132,14.4399419 C16.7553717,14.430576 16.7659083,14.4118443 16.7842498,14.3935028 C16.803762,14.3548687 16.8345912,14.2655028 16.8474693,14.2748687 C16.850201,14.2612101 16.8853229,14.1698931 16.8595668,14.2007223 C16.8299083,14.2537955 16.8466888,14.270576 16.8139083,14.2928199 C16.8466888,14.2608199 16.8435668,14.2112589 16.851762,14.1780882 C16.8654205,14.1550638 16.8833717,14.1109662 16.8771278,14.0957467 C16.877518,14.1125272 16.8841522,14.1058931 16.8900059,14.0902833 L16.8841522,14.0660882 C16.8985912,13.9833565 16.9083473,14.0512589 16.9247376,13.9704784 L16.9184937,14.0333077 C16.9192741,14.0192589 16.9387863,13.9946736 16.941518,13.9540882 C16.9337132,13.9365272 16.925518,13.905698 16.9192741,13.8916492 C16.9208351,13.8604297 16.9267321,13.8623375 16.9293338,13.8532029 L16.9296585,13.8294634 L16.9337132,13.8869662 C16.9352741,13.8963321 16.9579083,13.8491126 16.9641522,13.7855028 C16.9633717,13.744137 16.9528351,13.6805272 16.9426888,13.7437467 C16.94464,13.712137 16.9543961,13.6676492 16.9602498,13.6937955 C16.9618107,13.6212101 16.9485424,13.7023809 16.9465912,13.6403321 C16.9520546,13.6234215 16.9589056,13.5822291 16.9663347,13.542193 L16.9776585,13.4874634 L16.9796585,13.4944634 L16.9839158,13.4759866 C16.9837558,13.4404899 16.9637558,13.3847432 16.9853558,13.3999604 C16.9863328,13.4230772 17.0006735,13.4736509 16.980815,13.4958667 L16.9934205,13.5529175 L16.9945912,13.5088199 C17.007079,13.5661858 17.0059083,13.4799419 17.0199571,13.5127223 C17.023079,13.4822833 17.0191766,13.4456004 17.0148839,13.4163321 C16.991079,13.5049175 16.9832741,13.3168199 16.9618107,13.342576 C16.9563473,13.2212101 17.0141034,13.2664784 16.9805424,13.1396492 C16.9772644,13.1520589 16.9700527,13.1355282 16.9661565,13.1369237 L16.9626585,13.1434634 L16.9579062,13.1211478 C16.9527193,13.10123 16.9473961,13.0868931 16.9524449,13.0366248 C16.9610302,13.102576 16.9739083,12.9656004 16.9867863,13.0612101 C16.979762,13.0549662 16.9813229,13.1146736 16.9832741,13.1291126 C16.9914693,13.0978931 17.0047376,13.1357467 17.0047376,13.0580882 C17.0027863,13.0108687 17.0023961,12.9460882 16.991079,12.9554541 C16.9789815,12.9574053 16.99264,13.0276492 16.9801522,12.9972101 C16.9758595,12.9031614 16.9945912,12.8871614 16.9727376,12.848137 C16.9746888,12.9078443 16.9618107,12.9226736 16.9532254,12.9215028 L16.9481522,12.8524297 L16.9563473,12.865698 C16.962201,12.7544784 16.941518,12.8329175 16.9438595,12.7252101 L16.9598595,12.6748687 L16.964786,12.7007309 L16.9647485,12.7794478 C16.9650107,12.8034931 16.9671961,12.8198833 16.9762498,12.8122345 C16.9770302,12.7423809 16.9657132,12.7189662 16.9715668,12.6534053 L16.9756585,12.7004634 L16.9795778,12.6869912 C16.9870205,12.6646131 17.0032546,12.6326443 16.989518,12.5527223 C16.9824937,12.5012101 16.9813229,12.5390638 16.9731278,12.5378931 C16.9703961,12.4255028 16.9618107,12.3919419 16.96064,12.3197467 C16.9770302,12.334576 16.962201,12.1917467 16.9789815,12.2717467 C16.9692254,12.3084297 16.9703961,12.4707711 16.9860059,12.510576 C17.005518,12.4696004 16.9832741,12.5987711 17.0031766,12.622576 C17.0035668,12.5328199 17.023079,12.5371126 17.0351766,12.5226736 C17.0359571,12.497698 17.0308839,12.4735028 17.0289327,12.4582833 C17.0172254,12.4477467 17.0172254,12.4805272 17.0051278,12.4824784 C17.0082498,12.3821858 17.0020059,12.2854053 16.9902985,12.2296004 C16.9961522,12.1960394 17.0078595,12.206576 17.0090302,12.2463809 L17.0072102,12.0953411 C16.9998813,12.0641799 16.9948279,12.024107 16.9937254,11.9950638 L17.0073356,12.0502586 C17.0078659,11.9937394 17.009172,11.938062 17.0109815,11.8854053 C16.9914693,11.9587711 17.0062985,11.758576 16.9902985,11.8089175 C16.9860059,11.8697955 16.9723473,11.9220882 16.9633717,11.8885272 C16.9645424,11.8506736 16.9719571,11.8900882 16.9758595,11.873698 L16.9750068,11.8309012 L16.9806585,11.7924634 L16.9857457,11.8056365 L17.0073067,11.7897503 C17.0069706,11.7642695 17.0089146,11.7564313 17.011656,11.7544145 C17.006843,11.7359229 17.0038374,11.7172693 17.0102002,11.7000394 C17.0110183,11.7307938 17.0178613,11.7325873 17.0247043,11.7411571 L17.0258107,11.7176004 C17.0172254,11.6391614 17.0105912,11.5427711 17.0074693,11.4557467 C17.021518,11.3460882 17.0074693,11.1782833 17.007079,11.0803321 C17.0144937,11.0292101 17.0320546,11.0639419 17.0347863,11.008137 C17.0343961,10.9429662 17.0164449,11.0565272 17.0242498,10.9597467 C17.0238595,10.9398443 17.0394693,10.7919419 17.0148839,10.7634541 L17.0332254,10.7931126 C17.0347863,10.7751614 17.0308839,10.7583809 17.0285424,10.7435516 C17.0347863,10.7427711 17.0402498,10.721698 17.0441522,10.7509662 C17.0570302,10.6912589 17.042201,10.625698 17.0414205,10.5609175 L17.0304937,10.6026736 C17.0219083,10.4918443 17.0328351,10.417698 17.0289327,10.3103809 L17.0398595,10.3135028 L17.0336156,10.2495028 C17.0388839,10.2573077 17.0431766,10.246576 17.045079,10.229698 L17.0456585,10.2034634 L17.0687376,10.3388687 C17.0621034,10.3849175 17.0554693,10.2885272 17.0449327,10.3174053 C17.0355668,10.3419906 17.0386888,10.4415028 17.0488351,10.4575028 C17.0500059,10.4196492 17.0476644,10.417698 17.043762,10.3880394 C17.0548839,10.3786736 17.0574449,10.4088199 17.0623107,10.4364967 L17.0676585,10.4584634 L17.0688387,10.4402454 L17.0696585,10.4314634 L17.0729146,10.4492065 C17.0754584,10.4772752 17.0761522,10.5092752 17.0761522,10.5527223 C17.0702985,10.5086248 17.0667863,10.5765272 17.0624937,10.560137 C17.075762,10.5652101 17.0796644,10.6276492 17.0761522,10.7080394 C17.0609327,10.7654053 17.0859083,10.8590638 17.0816156,10.9523321 L17.0640546,10.8879419 L17.0516585,10.8144634 L17.0492543,10.8545977 L17.0488025,10.9009195 C17.0483774,10.909993 17.0475777,10.9205055 17.0461034,10.9336004 C17.0558595,10.9620882 17.071079,10.9823809 17.0773229,11.0584784 L17.0675668,11.0627711 C17.07264,11.1318443 17.087079,11.1318443 17.0843473,11.2200394 C17.0792741,11.3710638 17.0792741,11.5263809 17.0781034,11.6418931 L17.0683473,11.6461858 C17.0894205,11.7101858 17.0761522,11.8596492 17.085518,11.9458931 C17.0761522,12.0926248 17.0948839,12.2647223 17.0781034,12.3400394 C17.085518,12.5991614 17.0933229,12.8258931 17.0894205,13.0939906 L17.0749815,13.0487223 C17.085518,13.0967223 17.0667863,13.0799419 17.0687376,13.1271614 L17.0746585,13.1134634 L17.0794209,13.1289284 C17.0837385,13.1548999 17.0871571,13.2059906 17.0925424,13.2258931 C17.0816156,13.345698 17.0929327,13.4994541 17.0987863,13.6067711 L17.0890302,13.6106736 C17.103079,13.7199419 17.0761522,13.8491126 17.0507863,13.9829662 L17.0304937,14.0252282 C17.0266779,14.034912 17.023079,14.0461858 17.0203473,14.0594541 C17.0195668,14.1355516 17.0090302,14.173015 16.9778107,14.2791614 C16.9516644,14.3552589 16.8841522,14.4703809 16.8334205,14.5336004 C16.6796644,14.8032589 16.4088351,14.9816004 16.1266888,15.1197467 L16.1013229,15.118576 C15.8254205,15.261015 15.437518,15.2895028 15.1772254,15.2758443 L15.203762,15.2575028 C15.1225912,15.2516492 15.0187863,15.2395516 15.0367376,15.2586736 C14.9555668,15.2454053 14.8322498,15.2274541 14.7858107,15.1997467 C14.7054205,15.1751614 14.685518,15.1759419 14.6176156,15.1564297 C14.5020059,15.1040394 14.4403961,15.0773321 14.3590302,15.0326797 L14.3076585,15.0024634 C14.3190302,15.0036492 14.3159571,14.9960394 14.2913717,14.9796492 C14.2347863,14.9577955 14.1165424,14.849698 14.1493229,14.9043321 C14.0170302,14.8020882 13.8433717,14.6362345 13.7742985,14.4824784 C13.7754693,14.4980882 13.7543961,14.4617955 13.7422985,14.448137 C13.6634693,14.317015 13.63264,14.158576 13.5951766,14.0461858 C13.5928351,14.0223809 13.615079,14.0805272 13.6010302,14.0216004 C13.5908839,13.9872589 13.5912741,14.0227711 13.5803473,13.9798443 C13.5257132,13.742576 13.5514693,13.4990638 13.5483473,13.2902833 C13.5358595,12.9168199 13.5421034,12.5277467 13.5401522,12.1702833 C13.5268839,12.0543809 13.5635668,11.8932101 13.5362498,11.7976004 C13.5409327,11.7691126 13.538201,11.6895028 13.5475668,11.710576 C13.5379083,11.6391614 13.5495424,11.5247223 13.5490485,11.4138504 L13.5436585,11.3304634 C13.5530302,11.2473565 13.5489544,11.1619364 13.5483473,11.0717178 L13.5516585,10.9334634 L13.5562823,10.9670457 C13.5572796,10.9722779 13.5584937,10.9762671 13.5600546,10.977698 C13.5690302,10.9211126 13.5401522,10.8430638 13.5627863,10.8122345 C13.5627863,10.7876492 13.5564205,10.7869906 13.5534022,10.7965943 L13.5516585,10.8024634 L13.55464,10.5643321 C13.5544937,10.481698 13.5534205,10.3981858 13.5518595,10.3142833 L13.5491278,10.1882345 L13.5483473,10.1566248 C13.7001522,10.0032589 13.6088351,10.113698 13.6509815,10.0789662 L13.7149815,10.0774053 L13.8425912,10.0746736 L13.9065912,10.0735028 L13.938201,10.0731126 Z M20.1962895,12.4575458 L20.2258107,12.4660882 C20.33664,12.5156492 20.4533229,12.5577955 20.5504937,12.6354541 C20.9540059,12.9082345 21.1756644,13.4147711 21.1058107,13.8928199 C21.0691278,14.0024784 21.08864,14.0126248 21.0562498,14.1328199 C21.0648351,14.1367223 21.026201,14.2108687 21.0371278,14.2264784 C20.989518,14.3989662 20.8958595,14.545698 20.781518,14.6885272 C20.80064,14.6658931 20.8002498,14.6475516 20.7772254,14.6733077 L20.7600546,14.7060882 C20.738201,14.7263809 20.7257132,14.750576 20.7467863,14.736137 C20.4474693,15.1138931 19.9385912,15.2282345 19.5085424,15.2317467 C19.4031766,15.2282345 19.2583961,15.233698 19.1475668,15.2368199 C18.8189815,15.2157467 18.5223961,15.1989662 18.1883473,15.2137955 C18.1875668,15.2134053 18.2312741,15.1728199 18.3690302,15.1634541 C18.5450302,15.1267711 18.7768351,15.1638443 18.9692254,15.1404297 C18.9918595,15.1388687 18.9633717,15.1603321 19.0141034,15.1556492 C19.2014205,15.1240394 19.4941034,15.1540882 19.7247376,15.1486248 L19.7114693,15.1560394 C19.7555668,15.1540882 19.8059083,15.1283321 19.8519571,15.1248199 C19.8449327,15.1331885 19.8458433,15.1344459 19.8496156,15.1357467 C19.8593717,15.1228687 19.9307863,15.1127223 19.9479571,15.1006248 C19.9666888,15.101015 19.9674693,15.1099906 19.9920546,15.1096004 L20.0142985,15.0904784 C20.0759571,15.0409175 20.1852254,15.0374053 20.2691278,14.9780882 C20.2660059,14.9827711 20.258201,14.989015 20.2667863,14.9882345 C20.402201,14.9004297 20.5657132,14.785698 20.6745912,14.6440394 C20.6730302,14.6522345 20.6749815,14.6623809 20.6859083,14.6580882 C20.6820059,14.6424784 20.7167376,14.6007223 20.7471766,14.5652101 C20.7705912,14.5554541 20.7780059,14.4883321 20.8123473,14.4457955 C20.8205424,14.4091126 20.8509815,14.4032589 20.8521522,14.366576 L20.8751766,14.349015 C20.8685424,14.3267711 20.9118595,14.301015 20.911079,14.2639419 C20.9122498,14.2319419 20.9266888,14.2194541 20.9321522,14.1901858 C20.9432741,14.1546736 20.9529327,14.129015 20.95864,14.1115028 L20.9632895,14.0905458 L20.9618595,14.1046248 C20.9593717,14.1194541 20.9581034,14.1328199 20.9727376,14.1168199 C21.0125424,13.8924297 21.0269815,13.6536004 20.9668839,13.4319419 C20.9664937,13.4054053 20.9641522,13.3886248 20.9680546,13.3812101 C20.9586888,13.3597467 20.9454205,13.2973077 20.9259083,13.2824784 C20.9294205,13.2895028 20.927079,13.2664784 20.9227863,13.2547711 C20.9102985,13.2141858 20.8880546,13.2196492 20.8751766,13.1755516 C20.8864937,13.1903809 20.893518,13.1938931 20.8962498,13.1860882 L20.8594205,13.1302345 L20.8182895,13.0725458 L20.8280059,13.0794541 L20.75264,12.9714541 L20.7690302,12.9796492 C20.735079,12.9148687 20.7456156,12.9706736 20.7085424,12.9218931 C20.7214205,12.9304784 20.7202498,12.9246248 20.7249327,12.9242345 C20.671079,12.8941858 20.6109815,12.8231614 20.5649327,12.7888199 C20.5169327,12.7529175 20.4658107,12.7107711 20.4061034,12.6772101 L20.4026585,12.6704634 L20.3977132,12.6986858 L20.3797132,12.6906858 L20.4061034,12.6772101 C20.3873717,12.6600394 20.4256156,12.6608199 20.3635668,12.6342833 C20.3569327,12.6510638 20.2578107,12.592137 20.2843473,12.6272589 C20.2367376,12.5968199 20.1551766,12.558576 20.1153717,12.5577955 C20.1419083,12.5581858 20.0954693,12.5293077 20.141518,12.541015 L20.1102895,12.5215458 C20.1318053,12.5241045 20.1422985,12.5295679 20.1368351,12.5215028 L20.1172895,12.5165458 L20.131762,12.5082345 L20.1962895,12.4575458 Z M19.5736585,12.6824634 L19.5661829,12.6898714 C19.602201,12.7076492 19.6525424,12.6791614 19.6876644,12.704137 C19.6814205,12.7045272 19.6861034,12.6916492 19.6861034,12.6943809 C19.7075668,12.6990638 19.7048351,12.7107711 19.7192741,12.7088199 C19.7196644,12.7162345 19.7368351,12.7096004 19.7516644,12.7099906 C19.7598595,12.7060882 19.7547863,12.7138931 19.7422985,12.7127223 C19.7629815,12.7099906 19.8453229,12.7135028 19.8894205,12.7314541 C19.8894205,12.7267711 19.9218107,12.7197467 19.9323473,12.7220882 L19.9253229,12.7318443 C19.9310465,12.7362671 19.9449218,12.7384351 19.9533049,12.7422797 L19.9536585,12.7434634 L19.9546585,12.7434634 L19.9576585,12.7434634 L19.97264,12.7469662 C19.9832741,12.7488199 19.9934205,12.7519419 20.0018107,12.7603321 C19.9967376,12.7564297 19.9807376,12.7689175 19.997518,12.7739906 C20.0271766,12.782576 20.0072741,12.7720394 20.0322498,12.7767223 L20.04864,12.7778931 C20.0533229,12.768137 20.0747863,12.7888199 20.067762,12.7736004 C20.0681522,12.7829662 20.11264,12.784137 20.1032741,12.7993565 L20.0939083,12.8110638 C20.1067863,12.814576 20.1200546,12.8048199 20.1325424,12.8028687 C20.1450302,12.7915516 20.163762,12.8227711 20.1860059,12.8134053 C20.2098107,12.8270638 20.2503961,12.8493077 20.2554693,12.8660882 C20.2777132,12.8715516 20.2995668,12.8754541 20.3186888,12.8926248 C20.3132254,12.8918443 20.3069815,12.8887223 20.303079,12.8918443 C20.3128351,12.9055028 20.3202498,12.9016004 20.333518,12.9078443 C20.3292254,12.9082345 20.3506888,12.9378931 20.3588839,12.9546736 C20.3795668,12.9632589 20.381518,12.9499906 20.387762,12.9460882 C20.3885424,12.9753565 20.4462985,12.974576 20.4494205,13.0077467 C20.4431766,13.0034541 20.4193717,12.9929175 20.4291278,13.0085272 C20.4267863,13.0377955 20.4669815,13.0272589 20.48064,13.0584784 L20.4888351,13.0409175 L20.4946585,13.0504634 L20.5217498,13.0697345 C20.5161956,13.0761045 20.5149815,13.0776654 20.5122498,13.0791614 C20.5243473,13.0834541 20.5329327,13.1111614 20.5438595,13.0982833 C20.5598595,13.1509662 20.6250302,13.2013077 20.6105912,13.2454053 C20.6164449,13.2508687 20.6219083,13.2692101 20.6281522,13.2617955 C20.6312741,13.2461858 20.6144937,13.2489175 20.6183961,13.2418931 C20.6219083,13.2477467 20.6265912,13.2469662 20.6293229,13.246576 C20.6328351,13.2629662 20.6371278,13.2750638 20.6176156,13.2676492 C20.6234693,13.3043321 20.6601522,13.2887223 20.6738107,13.3339906 C20.6663961,13.3347711 20.6652254,13.3390638 20.6718595,13.3507711 L20.6913717,13.3706736 C20.6980059,13.4003321 20.6812254,13.392137 20.6699083,13.3968199 C20.6765424,13.4108687 20.6820059,13.4296004 20.6929327,13.4338931 L20.6843473,13.4565272 C20.6905912,13.440137 20.6952741,13.4670638 20.7003473,13.4729175 C20.6909815,13.470576 20.7007376,13.4869662 20.7034693,13.4959419 C20.7108839,13.4916492 20.7081522,13.4733077 20.7069815,13.4627711 L20.7257132,13.4908687 C20.7136156,13.4900882 20.7225912,13.5181858 20.7233717,13.5306736 C20.7233717,13.5455028 20.73664,13.5447223 20.7370302,13.549015 C20.7311766,13.550576 20.7401522,13.5728199 20.7300059,13.5630638 C20.7272741,13.5583809 20.7339083,13.5509662 20.7268839,13.5439419 C20.7241522,13.5540882 20.7132254,13.5548687 20.7245424,13.5728199 C20.7331278,13.5864784 20.7467863,13.5654053 20.7448351,13.5942833 L20.7303961,13.5817955 L20.7292254,13.6087223 L20.7401522,13.6083321 C20.749518,13.617698 20.7436644,13.6512589 20.7565424,13.6559419 C20.7584937,13.6692101 20.7506888,13.6852101 20.7502985,13.697698 C20.7440546,13.7113565 20.7491278,13.7316492 20.7573229,13.7445272 C20.7545912,13.7527223 20.7577132,13.7726248 20.7616156,13.7835516 C20.7506888,13.805015 20.7198595,13.7897955 20.7303961,13.8136004 C20.7280546,13.8350638 20.7460059,13.8487223 20.7538107,13.8405272 C20.7417132,13.8791614 20.7534205,13.9263809 20.7319571,13.9603321 C20.7354693,13.9669662 20.7385912,13.9634541 20.739762,13.9759419 C20.7339083,14.0340882 20.7261034,14.1000394 20.6862985,14.1363321 C20.6882498,14.1191614 20.6765424,14.1316492 20.6706888,14.129698 C20.6745912,14.145698 20.655079,14.1414053 20.6687376,14.1519419 C20.6784937,14.1538931 20.6823961,14.157015 20.6921522,14.1429662 C20.6839571,14.1773077 20.6632741,14.2272589 20.6476644,14.2413077 C20.6554693,14.2342833 20.655079,14.2424784 20.655079,14.2506736 C20.6418107,14.241698 20.6301034,14.2643321 20.627762,14.2846248 L20.621518,14.2986736 C20.621518,14.3068687 20.6343961,14.3150638 20.6152741,14.3267711 L20.6031766,14.3263809 C20.5981034,14.3462833 20.5918595,14.3767223 20.5719571,14.3899906 L20.5497132,14.3966248 C20.5454205,14.4048199 20.5426888,14.4223809 20.5559571,14.4114541 C20.5266888,14.4368199 20.5114693,14.4551614 20.495079,14.4571126 C20.4849327,14.5324297 20.4080546,14.5909662 20.3491278,14.6381858 C20.3264937,14.6389662 20.3460059,14.6475516 20.3323473,14.6526248 C20.3331278,14.6432589 20.3112741,14.6510638 20.3182985,14.6346736 C20.291762,14.6471614 20.2976156,14.6678443 20.2847376,14.6822833 C20.2878595,14.6916492 20.2929327,14.6678443 20.2972254,14.6795516 C20.2968351,14.6842345 20.2621034,14.6990638 20.2667863,14.7135028 C20.2578107,14.7135028 20.2562498,14.7014053 20.2562498,14.6943809 L20.2464937,14.7111614 C20.2211278,14.7111614 20.2671766,14.656137 20.2382985,14.6541858 L20.2273717,14.6658931 C20.2078595,14.6631614 20.2492254,14.6260882 20.2164449,14.6467711 C20.2082498,14.6639419 20.205518,14.686576 20.2226888,14.6846248 C20.1934205,14.705698 20.226201,14.7209175 20.191079,14.7396492 C20.1774205,14.7380882 20.2180059,14.7220882 20.2047376,14.7162345 C20.1828839,14.7158443 20.1754693,14.7400394 20.159079,14.7451126 C20.1778107,14.7408199 20.1711766,14.7607223 20.1618107,14.7689175 C20.1407376,14.7732101 20.1668839,14.750576 20.1411278,14.7638443 C20.1411278,14.7732101 20.1200546,14.7919419 20.143079,14.785698 C20.1422985,14.8075516 20.114201,14.7958443 20.1052254,14.8141858 C20.0911766,14.8059906 20.1200546,14.7759419 20.0880546,14.7821858 C20.0978107,14.7915516 20.0587863,14.8122345 20.0818107,14.8227711 C20.0685424,14.8243321 20.0638595,14.8157467 20.0689327,14.8052101 C20.0498107,14.8048199 20.0373229,14.8422833 20.0228839,14.8216004 L20.0217132,14.8356492 L19.9959571,14.8309662 C19.9819083,14.8372101 19.9530302,14.8614053 19.9491278,14.8430638 C19.9448351,14.8461858 19.9104937,14.8547711 19.9272741,14.8637467 C19.951079,14.865698 19.9491278,14.8477467 19.9662985,14.8614053 C19.9467863,14.8516492 19.9358595,14.8719419 19.9245424,14.8797467 C19.9140059,14.8777955 19.8964449,14.8809175 19.8937132,14.8898931 C19.8983961,14.8840394 19.8941034,14.880137 19.8878595,14.880137 L19.8827863,14.8934053 C19.853518,14.9066736 19.871079,14.877015 19.8425912,14.8859906 L19.8628839,14.8727223 C19.8585912,14.8762345 19.8464937,14.8680394 19.8332254,14.8735028 L19.8187863,14.9070638 C19.8027863,14.9144784 19.8090302,14.8969175 19.7945912,14.9101858 L19.8137132,14.894576 C19.8164449,14.8906736 19.7961522,14.8805272 19.7742985,14.8844297 C19.7610302,14.8902833 19.7411278,14.9086248 19.7645424,14.910576 C19.7532254,14.9125272 19.7368351,14.909015 19.74464,14.9000394 C19.7200546,14.9078443 19.7497132,14.910576 19.72864,14.9203321 C19.7188839,14.9156492 19.6900059,14.9078443 19.6724449,14.8996492 L19.6927376,14.8805272 L19.6779083,14.881698 C19.6954693,14.8660882 19.6669815,14.8723321 19.6759571,14.8567223 C19.6658107,14.8555516 19.6541034,14.8614053 19.6447376,14.8660882 C19.6767376,14.8863809 19.6146888,14.9008199 19.6252254,14.9211126 C19.5842498,14.9300882 19.5959571,14.8731126 19.555762,14.9078443 C19.5631766,14.9129175 19.5440546,14.9300882 19.5694205,14.9226736 C19.5440546,14.9215028 19.5534205,14.9449175 19.5229815,14.9371126 C19.5448351,14.9277467 19.4983961,14.9168199 19.5296156,14.9027711 C19.5280546,14.9097955 19.5475668,14.9074541 19.55264,14.9051126 C19.5417132,14.8973077 19.5534205,14.8836492 19.5280546,14.8848199 C19.5124449,14.8875516 19.4909815,14.8887223 19.4944937,14.8996492 C19.4956644,14.9117467 19.5182985,14.8973077 19.5089327,14.9101858 C19.4777132,14.9156492 19.4718595,14.8973077 19.4593717,14.9195516 C19.4792741,14.9168199 19.4847376,14.9293077 19.4843473,14.9375028 L19.4613229,14.9437467 C19.4281522,14.9312589 19.455079,14.9507711 19.4191766,14.9492101 L19.4020059,14.9336004 C19.410201,14.9199419 19.4539083,14.9394541 19.4472741,14.9168199 C19.4242498,14.9164297 19.4164449,14.9277467 19.3945912,14.9218931 L19.4105912,14.9172101 C19.4023961,14.9164297 19.3938107,14.8867711 19.3610302,14.9047223 C19.3442498,14.9117467 19.3567376,14.9129175 19.3563473,14.9211126 C19.3192741,14.9238443 19.3079571,14.9328199 19.2845424,14.9339906 C19.2759248,14.9436248 19.2154409,14.9576248 19.1799571,14.9596248 L19.2786677,14.9260182 C19.2683141,14.9236038 19.2505114,14.9274718 19.2689327,14.9156492 C19.28064,14.9254053 19.3341034,14.9242345 19.3473717,14.9082345 C19.3337132,14.8887223 19.3762498,14.910576 19.3840546,14.8910638 C19.3543961,14.8910638 19.3555668,14.8719419 19.3508839,14.8594541 L19.330201,14.8660882 C19.3266888,14.8777955 19.3372254,14.8777955 19.3380059,14.8898931 C19.3048351,14.8871614 19.2736156,14.8934053 19.2552741,14.9051126 C19.2443473,14.8992589 19.2478595,14.8875516 19.2607376,14.8863809 C19.2217132,14.8898931 19.1799571,14.8883321 19.1428839,14.8844297 C19.167079,14.9035516 19.1019083,14.8891126 19.1179083,14.9047223 C19.1378107,14.909015 19.1549815,14.9226736 19.1440546,14.9312589 C19.1315668,14.9300882 19.1444449,14.9226736 19.1393717,14.9187711 C19.123762,14.9293077 19.1147863,14.9019906 19.0991766,14.9183809 C19.1346888,14.912137 19.106201,14.8949662 19.1128351,14.880137 C19.087079,14.8887223 19.1140059,14.8696004 19.08864,14.8696004 L19.0031766,14.8875516 C18.9672741,14.8735028 18.91264,14.8871614 18.88064,14.8879419 C18.8638595,14.8805272 18.8751766,14.8633565 18.8572254,14.8602345 C18.835762,14.8606248 18.8728351,14.878576 18.8416156,14.8707711 L18.7970989,14.866912 C18.7881956,14.8683863 18.7807376,14.8720719 18.7776156,14.880137 L18.7873717,14.8617955 C18.781518,14.8602345 18.7760546,14.8645272 18.7713717,14.8664784 C18.7709815,14.8606248 18.7643473,14.8551614 18.7737132,14.8512589 L18.753724,14.8460557 L18.7116644,14.8536004 L18.7253229,14.8645272 C18.6890302,14.8731126 18.6648351,14.8621858 18.6301034,14.8660882 L18.6312741,14.8555516 L18.6162039,14.861082 C18.6241211,14.8692218 18.624917,14.8783086 18.6058813,14.8908443 C18.6008813,14.8718443 18.5738813,14.8508443 18.5798813,14.8328443 C18.5841035,14.8381221 18.590763,14.8427731 18.597526,14.8472568 L18.6394693,14.8274541 C18.6546888,14.833698 18.623079,14.8403321 18.6324449,14.8508687 C18.64064,14.8598443 18.67264,14.8571126 18.6781034,14.8469662 C18.6656156,14.8457955 18.6652254,14.848137 18.6554693,14.8520394 C18.6515668,14.8372101 18.6702985,14.8376004 18.6796644,14.8278443 C18.6730302,14.8286248 18.6640546,14.8239419 18.6624937,14.8286248 C18.6753717,14.8212101 18.6882498,14.8200394 18.7093229,14.8200394 C18.6948839,14.8258931 18.7171278,14.829015 18.7116644,14.8333077 C18.7132254,14.8200394 18.733518,14.816137 18.7600546,14.8200394 C18.7787863,14.8352589 18.8092254,14.8102833 18.8396644,14.8141858 C18.8271766,14.8274541 18.8115668,14.8379906 18.7932254,14.8434541 C18.8123473,14.8500882 18.8142985,14.8430638 18.8334205,14.849698 C18.8427863,14.8399419 18.8490302,14.8247223 18.8740059,14.8188687 L18.8755668,14.8286248 C18.898201,14.8235516 18.898201,14.8091126 18.9266888,14.8118443 C18.9758595,14.8165272 19.0265912,14.8165272 19.0640546,14.817698 C19.0862985,14.8067711 19.135079,14.8196492 19.1635668,14.8102833 C19.2115668,14.8196492 19.267762,14.8013077 19.2919571,14.817698 C19.3762498,14.8098931 19.4496156,14.8020882 19.5358595,14.8013077 L19.5218107,14.816137 C19.5370302,14.8052101 19.5323473,14.8239419 19.5475668,14.8212101 C19.5292254,14.8106736 19.5678595,14.8059906 19.5780059,14.7966248 C19.61664,14.8040394 19.6650302,14.7872589 19.6970302,14.7743809 L19.6993717,14.7837467 C19.730201,14.7603321 19.7719571,14.7693077 19.8144937,14.7654053 C19.8199571,14.7685272 19.8297132,14.7767223 19.8414205,14.7720394 C19.859762,14.750576 19.8714693,14.7486248 19.9007376,14.7306736 C19.9245424,14.7252101 19.9627863,14.7174053 19.9869815,14.7127223 C20.0619083,14.6592589 20.1512741,14.6338931 20.2137132,14.560137 L20.2258107,14.5648199 C20.2784937,14.4871614 20.3850302,14.4383809 20.413518,14.3618931 L20.4244449,14.3798443 C20.4439571,14.3642345 20.4533229,14.3326248 20.4381034,14.3295028 C20.4576156,14.3138931 20.4654205,14.2768199 20.4888351,14.2733077 C20.5056156,14.2549662 20.5017132,14.2459906 20.5063961,14.2260882 C20.5227863,14.198511 20.5305045,14.1813402 20.5379914,14.1601225 L20.5456585,14.1354634 C20.5538107,14.1399419 20.5571278,14.1382833 20.5598595,14.1332101 C20.5614205,14.1152589 20.5891278,14.0766248 20.5602498,14.0844297 C20.5977132,14.045015 20.5875668,13.9763321 20.6066888,13.9322345 C20.6000546,13.9349662 20.6000546,13.9232589 20.5965424,13.9174053 C20.6016156,13.8756492 20.6203473,13.8323321 20.6141034,13.7979906 C20.6183961,13.7913565 20.6234693,13.8093077 20.6265912,13.7917467 C20.6258107,13.7812101 20.6183961,13.7913565 20.6164449,13.7788687 C20.6031766,13.7109662 20.6250302,13.6383809 20.607079,13.5763321 C20.5774205,13.4678443 20.5380059,13.3581858 20.483762,13.2668687 C20.4533229,13.2457955 20.4591766,13.1837467 20.4193717,13.1775028 C20.4174205,13.1685272 20.3998595,13.1525272 20.4107863,13.1513565 C20.3811278,13.1404297 20.3705912,13.0795516 20.3249327,13.0678443 L20.3342985,13.0725272 C20.3085424,13.0393565 20.274201,13.0233565 20.2425912,12.9929175 C20.2476644,12.9933077 20.2554693,12.9964297 20.2593717,12.9933077 C20.2496156,12.9773077 20.2137132,12.9894053 20.2176156,12.9656004 C20.2090302,12.9609175 20.205518,12.9718443 20.2109815,12.9741858 C20.1380059,12.909015 20.0189815,12.9039419 19.9264937,12.8692101 C19.858201,12.8372101 19.9319571,12.8297955 19.8699083,12.8348687 C19.84064,12.8403321 19.8343961,12.8071614 19.8160546,12.8157467 C19.8199571,12.830576 19.8039571,12.8216004 19.8020059,12.8297955 C19.7582985,12.813015 19.7508839,12.7989662 19.7130302,12.8032589 C19.6720546,12.8079419 19.6236644,12.7915516 19.58464,12.8141858 C19.347762,12.7966248 19.1155668,12.8157467 18.8771278,12.8169175 L18.5046585,12.8164634 L18.5013229,12.9460882 C18.4818107,13.0015028 18.4825912,13.0057955 18.4903961,13.0662833 C18.4993717,13.0670638 18.4853229,13.1072589 18.5001522,13.1127223 C18.4974205,13.200137 18.5017132,13.2805272 18.5017132,13.3706736 C18.499762,13.3566248 18.4868839,13.3492101 18.4880546,13.3663809 L18.498201,13.3839419 C18.4958595,13.3983809 18.5040546,13.4108687 18.5091278,13.3991614 C18.5227863,13.6247223 18.4907863,13.8471614 18.4946888,14.0680394 C18.4880546,14.1207223 18.4942985,14.1952589 18.4974205,14.2522345 C18.4759571,14.4212101 18.4591766,14.5737955 18.4740059,14.7455028 C18.4740059,14.7447223 18.4330302,14.7224784 18.4232741,14.6514541 C18.386201,14.5609175 18.4236644,14.4418931 18.4002498,14.3427711 C18.3986888,14.3310638 18.4205424,14.3455028 18.4154693,14.3197467 C18.3869815,14.2237467 18.403762,14.0723321 18.4260059,13.9552589 C18.4361522,13.9400394 18.4170302,13.9127223 18.419762,13.8889175 C18.4236644,13.8889175 18.4252254,13.8963321 18.4302985,13.8912589 C18.4189815,13.8854053 18.4248351,13.8483321 18.41664,13.838576 C18.4209327,13.8292101 18.4302985,13.8299906 18.4349815,13.8182833 L18.4221034,13.8046248 C18.3908839,13.7671614 18.4240546,13.7133077 18.4084449,13.6621858 L18.4041088,13.5776329 L18.3943961,13.3882345 C18.399079,13.392137 18.4072741,13.3952589 18.4127376,13.3901858 C18.399079,13.3855028 18.3955668,13.357015 18.3928351,13.3324297 C18.4068839,13.3211126 18.3799571,13.2902833 18.387762,13.261015 C18.3760546,13.2418931 18.3994693,13.2317467 18.3819083,13.2141858 L18.3928351,13.2005272 C18.3729327,13.1911614 18.4029815,13.169698 18.3928351,13.152137 C18.3842498,13.136137 18.3940059,13.1271614 18.3908839,13.1119419 L18.3919101,13.079595 L18.3916585,13.0594634 L18.3958993,13.0715299 C18.3980384,13.0751722 18.4012904,13.0760394 18.4072741,13.0694053 L18.393079,12.889015 C18.3906888,12.8286248 18.394201,12.7675516 18.4142985,12.7045272 C18.4279571,12.7107711 18.4369327,12.7127223 18.4400546,12.7181858 C18.4521522,12.7150638 18.4857132,12.7154541 18.49664,12.7076492 C18.4927376,12.7080394 18.5044449,12.7154541 18.511079,12.7162345 C18.5329327,12.7220882 18.5352741,12.6994541 18.5594693,12.7064784 C18.5501034,12.7107711 18.5465912,12.7154541 18.5497132,12.7213077 C18.5703961,12.7092101 18.5981034,12.7111614 18.6222985,12.7072589 C18.6183961,12.7096004 18.6125424,12.7115516 18.6137132,12.7162345 C18.6402498,12.702576 18.6624937,12.7189662 18.685518,12.7107711 L18.6769327,12.7193565 C18.7143961,12.7302833 18.6878595,12.701015 18.7202498,12.7072589 C18.7124449,12.7099906 18.7151766,12.7135028 18.7140059,12.717015 C18.7444449,12.701015 18.7936156,12.7060882 18.8236644,12.7006248 C18.8552741,12.7021858 18.8896156,12.7072589 18.9259083,12.7002345 C18.9391766,12.704137 18.9216156,12.7220882 18.9567376,12.718576 C18.9555668,12.701015 19.0160546,12.7111614 18.9953717,12.6912589 C19.0250302,12.6939906 19.07264,12.701015 19.0921522,12.6947711 C19.0788839,12.7014053 19.1065912,12.7166248 19.0816156,12.7177955 L19.1003473,12.7287223 C19.0976156,12.736137 19.0808351,12.7263809 19.087079,12.7353565 C19.0995668,12.734576 19.1358595,12.7279419 19.1467863,12.7310638 C19.1698107,12.7205272 19.1912741,12.7002345 19.2287376,12.6986736 C19.2111766,12.7053077 19.2384937,12.718576 19.2263961,12.7213077 L19.279079,12.6877467 C19.2915668,12.6869662 19.2814205,12.7017955 19.2993717,12.6975028 C19.2985912,12.6928199 19.3063961,12.6900882 19.3122498,12.6861858 C19.3169327,12.688137 19.3641522,12.6822833 19.3688351,12.6998443 C19.3739083,12.7068687 19.3485424,12.7033565 19.362201,12.7096004 C19.3852254,12.7096004 19.3863961,12.7045272 19.4094205,12.7053077 C19.42464,12.7115516 19.4546888,12.7033565 19.4386888,12.6924297 C19.4281522,12.6912589 19.442201,12.7033565 19.4265912,12.6971126 C19.4379083,12.6877467 19.4648351,12.686576 19.4882498,12.688137 C19.4800546,12.6904784 19.4808351,12.6951614 19.4773229,12.6998443 L19.5134204,12.6902063 L19.5156585,12.6894634 L19.5263473,12.6881858 L19.5736585,12.6824634 Z M18.9243473,10.0797467 C19.1561522,10.0672589 19.40864,10.0696004 19.6412254,10.1156492 C19.7200546,10.1191614 19.8121522,10.1831614 19.8800546,10.1855028 C19.8960546,10.1968199 19.9463961,10.2151614 19.9296156,10.2178931 C19.9932254,10.2362345 20.0802498,10.3135028 20.1598595,10.3607223 L20.1387863,10.3482345 C20.20864,10.4075516 20.2632741,10.4696004 20.3245424,10.5449175 C20.3163473,10.5386736 20.303079,10.526576 20.2976156,10.5273565 C20.3151766,10.5605272 20.3725424,10.5812101 20.3678595,10.6100882 C20.3774855,10.6204947 20.3829489,10.6191072 20.3828622,10.6142508 L20.4587437,10.7451675 C20.5344937,10.8892589 20.5944937,11.045698 20.6211278,11.2087223 C20.6199571,11.3648199 20.5836644,11.2223809 20.610201,11.3417955 C20.62464,11.3972101 20.5949815,11.424137 20.6094205,11.456137 C20.6222985,11.4424784 20.6191766,11.4776004 20.6273717,11.4787711 C20.6125424,11.5736004 20.6020059,11.5907711 20.6047376,11.6660882 C20.6066888,11.7492101 20.5762498,11.8471614 20.5723473,11.9263809 C20.5115343,12.1267061 20.3851386,12.302099 20.2288423,12.4342671 L20.1962895,12.4575458 L20.0812895,12.4265458 L20.1030302,12.3998443 C20.1131278,12.3858931 20.1225912,12.3714541 20.1309815,12.3560394 C20.1481522,12.3404297 20.1438595,12.3638443 20.1664937,12.3384784 C20.162201,12.336137 20.1715668,12.3244297 20.17664,12.3150638 C20.1871766,12.3131126 20.2441522,12.2479419 20.2621034,12.2506736 C20.274201,12.2475516 20.239079,12.2815028 20.2613229,12.2662833 C20.290201,12.2338931 20.2866888,12.2284297 20.3155668,12.1964297 C20.3393717,12.1773077 20.3588839,12.1238443 20.3346888,12.144137 L20.3306585,12.1534634 L20.3364377,12.1370548 C20.346266,12.1152589 20.3623961,12.0887223 20.3780059,12.0653077 C20.3725424,12.078576 20.3776156,12.0797467 20.3787863,12.0871614 L20.4365424,11.9162345 C20.4299083,11.9127223 20.4420059,11.9431614 20.4338107,11.9501858 C20.4603473,11.9020557 20.4691928,11.8461207 20.4794259,11.7954468 L20.4962895,11.7275458 C20.4954693,11.6898931 20.5071766,11.6934053 20.5071766,11.6676492 C20.5145912,11.665698 20.5114693,11.6356492 20.5091278,11.6091126 L20.5106585,11.6074634 L20.5104266,11.5795455 C20.5083229,11.5186492 20.5064937,11.4208199 20.5044449,11.357015 C20.499762,11.3589662 20.4829815,11.3066736 20.482201,11.2871614 L20.4939083,11.2937955 L20.4942895,11.2685458 L20.4933591,11.2401731 L20.4970302,11.2243321 L20.4885912,11.2051126 C20.4844449,11.186576 20.4804449,11.1683321 20.4794693,11.1497955 C20.4802498,11.1603321 20.5028839,11.1778931 20.4939083,11.1470638 C20.477518,11.0932101 20.4845424,11.1326248 20.4693229,11.089698 L20.4576156,11.0635516 C20.4466888,11.0643321 20.4462985,11.0151614 20.4400546,11.038576 C20.4466888,11.0296004 20.4146888,10.9628687 20.4330302,10.9624784 L20.4482498,10.9656004 C20.4400546,10.9429662 20.4267863,10.9312589 20.4111766,10.9172101 C20.3912741,10.9125272 20.3881522,10.8567223 20.3600546,10.8387711 C20.3436644,10.7915516 20.3026888,10.7271614 20.303079,10.6986736 C20.2777132,10.6694053 20.243762,10.6518443 20.2195668,10.6155516 C20.2269815,10.6206248 20.2355668,10.6292101 20.24064,10.6280394 C20.2269815,10.6038443 20.2180059,10.6018931 20.1988839,10.5858931 C20.2051278,10.5882345 20.1715668,10.5367223 20.1559571,10.5078443 C20.125518,10.4836492 20.1266888,10.5019906 20.1196644,10.5043321 C20.1114693,10.4594541 20.0275668,10.448137 20.0064937,10.4044297 C20.0185912,10.4102833 20.0572254,10.4301858 20.0345912,10.4063809 C20.019762,10.3654053 19.9666888,10.3802345 19.9233717,10.3435516 L19.9268839,10.3657955 C19.9108839,10.3427711 19.8507863,10.3353565 19.8624937,10.3232589 C19.8425912,10.3220882 19.8031766,10.2928199 19.8023961,10.3111614 C19.7227863,10.2600394 19.5858107,10.2565272 19.5342985,10.2178931 C19.52064,10.2175028 19.4874693,10.2104784 19.4929327,10.2202345 C19.5143961,10.2315516 19.5249327,10.2182833 19.5323473,10.2260882 C19.5202498,10.2245272 19.5171278,10.2284297 19.5151766,10.2307711 C19.487079,10.222576 19.4636644,10.2198443 19.4933229,10.2085272 C19.4285424,10.192137 19.423079,10.2284297 19.3403473,10.2171126 C19.34464,10.2100882 19.3383961,10.2073565 19.3138107,10.2073565 L19.2669815,10.2171126 C19.2131278,10.2116492 19.2365424,10.1999419 19.235762,10.1878443 C19.2064937,10.1894053 19.1705912,10.1886248 19.1569327,10.1972101 L19.1214205,10.1819906 C19.1475668,10.1929175 19.0972254,10.1886248 19.0835668,10.1917467 L19.0972254,10.189015 C19.091762,10.1839419 19.0578107,10.1870638 19.0402498,10.1886248 C19.0445424,10.1960394 19.0792741,10.1991614 19.0983961,10.2011126 C19.0831766,10.2061858 19.059762,10.205015 19.0398595,10.2112589 C19.0431766,10.2054053 19.0311766,10.2032589 19.0154205,10.2024784 L18.9684449,10.2018931 C18.941518,10.1991614 18.9380059,10.2124297 18.930201,10.2120394 C18.9294205,10.2057955 18.8861034,10.2108687 18.9071766,10.2026736 C18.9165424,10.2007223 18.9282498,10.2085272 18.9434693,10.2030638 C18.925518,10.1983809 18.9278595,10.1878443 18.8907863,10.1956492 C18.863079,10.2015028 18.8978107,10.2186736 18.845518,10.2112589 C18.8591766,10.2085272 18.861518,10.2038443 18.8724449,10.1995516 L18.8232741,10.1933077 L18.8209327,10.2038443 C18.8010302,10.2100882 18.7405424,10.2022833 18.7296156,10.2147711 C18.70464,10.2159419 18.6769327,10.2073565 18.653518,10.2061858 C18.6293229,10.1991614 18.5906888,10.2030638 18.5661034,10.2104784 C18.5516644,10.2073565 18.5138107,10.2089175 18.4939083,10.2151614 C18.4541034,10.2069662 18.48064,10.1749662 18.4361522,10.1882345 C18.3955668,10.1886248 18.3725424,10.2077467 18.3889327,10.2147711 C18.3159571,10.2077467 18.2328351,10.2249175 18.1653229,10.2085272 C18.1582985,10.211389 18.1589056,10.213557 18.1537312,10.2154938 L18.1532254,10.2600394 L18.1523473,10.3373077 L18.1422895,10.4035458 L18.1375433,10.3921876 C18.1338433,10.3916383 18.1296807,10.4045597 18.125518,10.4048199 C18.1352741,10.4301858 18.115762,10.4352589 18.1321522,10.4446248 C18.1386563,10.4428036 18.1429056,10.4434107 18.1461721,10.43523 L18.1502895,10.4165458 L18.1539914,10.4857449 C18.1549164,10.5356383 18.1528351,10.5862833 18.1465912,10.609698 C18.1508839,10.592137 18.1540059,10.6057955 18.1571278,10.6194541 C18.141518,10.6147711 18.1391766,10.6616004 18.14464,10.6971126 L18.1540059,10.7021858 L18.1442498,10.7252101 C18.1473717,10.7388687 18.1641522,10.7404297 18.1551766,10.7751614 L18.1450302,10.785698 C18.1528351,10.8219906 18.1657132,10.8735028 18.1579083,10.9133077 L18.1442498,10.945698 C18.1454205,10.958576 18.1503229,10.9776004 18.1543473,10.9737955 L18.1513898,11.0209428 C18.1477186,11.0554866 18.1445099,11.0796817 18.1364449,11.0939906 C18.1657132,11.2106736 18.1668839,11.3796492 18.1649327,11.5150638 C18.1512741,11.5474541 18.1703961,11.5298931 18.1653229,11.5556492 C18.1586888,11.5439419 18.1504937,11.5833565 18.1422985,11.5548687 C18.1348839,11.6067711 18.1547863,11.6219906 18.1579083,11.6559419 C18.1672741,11.661015 18.1520546,11.6286248 18.163762,11.6352589 C18.1668839,11.6411126 18.1563473,11.7074541 18.1703961,11.7152589 C18.1649327,11.7285272 18.1543961,11.7179906 18.1485424,11.7109662 L18.1555668,11.742576 C18.1391766,11.7816004 18.1262985,11.6539906 18.1060059,11.6949662 L18.1083473,11.7242345 C18.093518,11.7523321 18.0919571,11.646576 18.0864937,11.7203321 C18.093518,11.7523321 18.1138107,11.7796492 18.1200546,11.7511614 C18.1239571,11.8175028 18.1536156,11.7819906 18.1524449,11.8534053 C18.1442498,11.8729175 18.1504937,11.7960394 18.1387863,11.8100882 C18.1274693,11.8436492 18.1450302,11.8776004 18.1411278,11.9076492 C18.146201,11.8744784 18.16064,11.902576 18.1633717,11.9240394 C18.1567376,11.9603321 18.1501034,11.9002345 18.1485424,11.952137 C18.1567376,11.9607223 18.1629815,12.0079419 18.1684449,11.9669662 C18.1867863,11.985698 18.1633717,12.0204297 18.1774205,12.0485272 C18.1645424,12.0653077 18.1473717,11.9954541 18.1411278,12.0520394 C18.1536156,12.0430638 18.1579083,12.1218931 18.17664,12.0918443 C18.1731278,12.1140882 18.1633717,12.1164297 18.1555668,12.1004297 C18.147762,12.1320394 18.1785912,12.1773077 18.1536156,12.1878443 L18.1664937,12.1987711 C18.162201,12.2089175 18.1594693,12.2229662 18.1524449,12.2389662 C18.1524449,12.2670638 18.1700059,12.3287223 18.1504937,12.3263809 C18.1524449,12.3353565 18.1516644,12.3989662 18.1649327,12.3743809 C18.1731278,12.3349662 18.1551766,12.3287223 18.1731278,12.3068687 C18.1582985,12.3349662 18.175079,12.3642345 18.179762,12.3868687 C18.175079,12.4044297 18.173518,12.4356492 18.1817132,12.4442345 C18.1774205,12.433698 18.1723473,12.4391614 18.1703961,12.4500882 L18.1817132,12.4645272 C18.1875668,12.5199419 18.1618107,12.4774053 18.1649327,12.5316492 L18.1559571,12.4906736 C18.1579083,12.4996492 18.1473717,12.5179906 18.1508839,12.5437467 C18.1610302,12.5538931 18.173518,12.5726248 18.1817132,12.5812101 C18.1848351,12.6015028 18.1785912,12.6008091 18.1773193,12.6069952 L18.1792895,12.6205458 L18.1684449,12.5858931 C18.1653229,12.5800394 18.1512741,12.6124297 18.1516644,12.653015 C18.1551766,12.6787711 18.1700059,12.7193565 18.1758595,12.6783809 C18.1762498,12.6986736 18.1696156,12.7271614 18.162201,12.7111614 C18.1657132,12.7572101 18.173518,12.7049175 18.179762,12.7447223 C18.1731278,12.7611126 18.1629815,12.8118443 18.1532254,12.8422833 L18.1356644,12.8009175 L18.1356644,12.8282345 C18.1216156,12.7927223 18.1251278,12.846576 18.1102985,12.8262833 C18.1079571,12.845015 18.1130302,12.8680394 18.1169327,12.8863809 C18.1403473,12.8309662 18.1489327,12.9480394 18.1703961,12.9320394 C18.1762498,13.0077467 18.1184937,12.9792589 18.1520546,13.0584784 C18.157518,13.0456004 18.1739083,13.0826736 18.1676644,13.0350638 C18.1653229,13.0818931 18.1891278,13.0670638 18.1805424,13.1224784 C18.1715668,13.0815028 18.1586888,13.166576 18.146201,13.1072589 C18.1532254,13.1111614 18.1516644,13.0740882 18.1493229,13.0651126 C18.1411278,13.0846248 18.1278595,13.0612101 18.1278595,13.1092101 C18.1298107,13.1384784 18.130201,13.1790638 18.141518,13.1732101 C18.1540059,13.1720394 18.1399571,13.1283321 18.1524449,13.1470638 C18.1567376,13.2056004 18.1380059,13.2153565 18.1598595,13.2395516 C18.1579083,13.2024784 18.1707863,13.1935028 18.1789815,13.1942833 L18.1840546,13.2372101 L18.1758595,13.229015 C18.1700059,13.2980882 18.1906888,13.2493077 18.1887376,13.3160394 L18.1727376,13.3472589 C18.159079,13.3312589 18.1789815,13.2500882 18.1563473,13.2621858 C18.155827,13.2910638 18.1606834,13.3071072 18.1622443,13.326735 L18.1602895,13.3595458 L18.1563473,13.3304784 C18.1555668,13.3460882 18.1259083,13.361698 18.1434693,13.4233565 C18.1501034,13.4553565 18.1516644,13.4319419 18.1598595,13.4327223 C18.1625912,13.5021858 18.1711766,13.5232589 18.1723473,13.568137 C18.1559571,13.5587711 18.1707863,13.6473565 18.1540059,13.5977955 C18.1633717,13.5747711 18.1625912,13.4740882 18.1469815,13.4495028 C18.1323473,13.4685272 18.141201,13.4282833 18.1381461,13.4007162 L18.1292895,13.3805458 L18.1264022,13.412015 C18.1202741,13.4352101 18.1071766,13.4353565 18.0978107,13.4420882 C18.0970302,13.457698 18.1021034,13.4725272 18.1040546,13.4818931 C18.115762,13.4885272 18.115762,13.4682345 18.1278595,13.4670638 C18.1247376,13.5295028 18.1313717,13.5896004 18.1426888,13.6239419 C18.1368351,13.6446248 18.1251278,13.6383809 18.1239571,13.6134053 C18.1274693,13.6875516 18.1259083,13.7667711 18.1223961,13.8374053 C18.1419083,13.7917467 18.127079,13.9158443 18.143079,13.885015 C18.1473717,13.8471614 18.1610302,13.8147711 18.1700059,13.8354541 C18.1688351,13.8592589 18.1614205,13.8346736 18.157518,13.8444297 L18.1583708,13.8710096 L18.1566585,13.9194634 L18.1521358,13.8929729 C18.1439688,13.8717936 18.1303571,13.9047614 18.1184937,13.8947711 L18.1204083,13.9158016 L18.1104815,13.9203992 C18.1087863,13.9232101 18.1075668,13.9291126 18.1075668,13.9412101 C18.1161522,13.9899906 18.1227863,14.049698 18.1259083,14.1039419 C18.1114693,14.1718443 18.125518,14.2760394 18.1262985,14.3369175 C18.1188839,14.3685272 18.1017132,14.3470638 18.0985912,14.3817955 C18.0989815,14.4223809 18.1169327,14.3517467 18.1091278,14.4114541 C18.109518,14.4235516 18.0939083,14.5152589 18.1188839,14.5332101 L18.1001522,14.5148687 C18.0985912,14.5261858 18.1028839,14.5363321 18.1048351,14.545698 C18.0985912,14.5460882 18.093518,14.5593565 18.0892254,14.541015 L18.0840366,14.5791144 L18.0912895,14.6575458 L18.1028839,14.6331126 C18.1114693,14.7017955 18.1005424,14.7478443 18.1044449,14.814576 L18.093518,14.8126248 L18.1001522,14.8524297 C18.0896156,14.8426736 18.0829815,14.8789662 18.0915668,14.9000394 L18.0650302,14.797015 L18.0813839,14.8117772 C18.098201,14.7950638 18.095079,14.7334053 18.0849327,14.7236492 C18.083762,14.7470638 18.0861034,14.7482345 18.0900059,14.766576 C18.0798595,14.7717793 18.0768243,14.757557 18.0729218,14.7422942 L18.0652895,14.7215458 L18.0643473,14.7408199 L18.0606653,14.7287946 C18.0580926,14.7113348 18.0574855,14.691389 18.0572254,14.6643321 C18.063079,14.6916492 18.0665912,14.6495028 18.0708839,14.6596492 C18.0576156,14.6565272 18.0537132,14.6178931 18.0572254,14.5679419 C18.0673717,14.5442671 18.0596536,14.5105326 18.0546526,14.473445 L18.0512895,14.4165458 L18.0693229,14.4560394 C18.0742985,14.4708687 18.0782985,14.4871614 18.0810302,14.5047223 C18.0876644,14.4684297 18.08064,14.464137 18.0876644,14.4278443 C18.0779083,14.4102833 18.0622985,14.3974053 18.0564449,14.3501858 C18.0611278,14.3049175 18.0466888,14.3049175 18.0494205,14.2502833 C18.0541034,14.1566248 18.0541034,14.0602345 18.0552741,13.9888199 L18.0650302,13.9860882 C18.0439571,13.9462833 18.0572254,13.8534053 18.0478595,13.7999419 C18.0572254,13.7086248 18.0384937,13.6020882 18.0552741,13.5552589 C18.0478595,13.3944784 18.0400546,13.2539906 18.0439571,13.0873565 L18.0580059,13.1154541 C18.0474693,13.0857955 18.066201,13.0959419 18.0642498,13.0666736 C18.0529327,13.1002345 18.0494205,13.0260882 18.0408351,13.0054053 C18.051762,12.9312589 18.0396644,12.8360394 18.0299083,12.7704784 L18.0396644,12.7677467 C18.0213229,12.7014053 18.0373229,12.6221858 18.0404449,12.5394541 C18.0447376,12.5300882 18.0537132,12.5148687 18.0529327,12.4902833 C18.0369327,12.4454053 18.0381034,12.4219906 18.0283473,12.3560394 C18.0283473,12.3080394 18.0322498,12.2299906 18.0384937,12.1812101 C18.0162498,12.000137 18.0302985,11.8155516 18.0170302,11.6274541 L18.0283473,11.6137955 C18.003762,11.4315516 18.0260059,11.2071614 18.013518,11.0514541 L18.0330302,11.0666736 C18.0392741,11.0178931 18.0279571,10.9554541 18.0139083,10.9679419 C18.0201522,10.9187711 18.0045424,10.8457955 18.0205424,10.814576 C18.0244449,10.7646248 18.0115668,10.7533077 18.0088351,10.7119419 C18.0137782,10.6450801 18.0147321,10.6063158 18.0136626,10.5599202 L18.0112895,10.5065458 C18.018808,10.5119202 18.0228839,10.5070638 18.0236644,10.4914541 C18.018201,10.4563321 18.0291278,10.3618931 18.0057132,10.397015 C18.0123473,10.3466736 18.0096156,10.2877467 18.0076644,10.2296004 L18.0061034,10.1858931 L18.0057132,10.1527223 L18.0376453,10.1209929 L18.0857132,10.0738931 L18.0978107,10.0738931 L18.1778107,10.0809175 C18.1692254,10.0742833 18.194201,10.0731126 18.2047376,10.0692101 C18.2941034,10.0688199 18.3881522,10.0820882 18.4591766,10.0711614 C18.4732254,10.0742833 18.4365424,10.0820882 18.4728351,10.0824784 C18.4942985,10.080137 18.4732254,10.0742833 18.499762,10.0707711 C18.6445424,10.0590638 18.7928351,10.0832589 18.9243473,10.0797467 Z M19.2756585,10.4104634 C19.2671115,10.4189988 19.2647701,10.4204297 19.2634693,10.4188687 C19.3005424,10.4333077 19.3442498,10.4087223 19.3742985,10.4278443 C19.3688351,10.429015 19.3727376,10.4157467 19.3731278,10.4180882 C19.3914693,10.4208199 19.3891278,10.4325272 19.4016156,10.429015 C19.4020059,10.4360394 19.4172254,10.4274541 19.4297132,10.429015 C19.439079,10.429015 19.5108839,10.4333077 19.5483473,10.4524297 C19.5487376,10.4477467 19.5772254,10.4411126 19.586201,10.4434541 L19.5795668,10.4532101 L19.5876585,10.4574634 L19.5727159,10.4613475 L19.5604449,10.4586736 C19.5458107,10.4606248 19.563762,10.4609175 19.5824937,10.4617955 L19.5920546,10.4629662 L19.5795668,10.4532101 C19.5839896,10.4586736 19.5963907,10.4594541 19.6037041,10.4621424 L19.6046585,10.4634634 L19.6056585,10.4634634 L19.6298649,10.4645561 C19.6358487,10.465698 19.6413554,10.4682996 19.6459083,10.4738931 C19.6416156,10.4699906 19.6271766,10.4820882 19.6412254,10.4875516 C19.666201,10.4965272 19.6498107,10.4856004 19.6708839,10.4914541 L19.6849327,10.493015 C19.6896156,10.4832589 19.7063961,10.5043321 19.7017132,10.4891126 C19.7013229,10.4984784 19.7399571,10.5008199 19.730201,10.5156492 L19.7212254,10.5269662 C19.7321522,10.5308687 19.74464,10.5215028 19.7555668,10.5199419 C19.7676644,10.509015 19.7809327,10.5406248 19.8012254,10.5320394 C19.8195668,10.5499906 19.859762,10.5566248 19.8593717,10.5784784 C19.8773229,10.5851126 19.8952741,10.5901858 19.9093229,10.6077467 C19.90464,10.606576 19.8999571,10.6030638 19.8964449,10.6061858 C19.903079,10.6198443 19.9089327,10.6175028 19.92064,10.6229662 C19.9167376,10.6237467 19.933518,10.6502833 19.939762,10.6655028 C19.9581034,10.6725272 19.9612254,10.6600394 19.967079,10.656137 C19.9659083,10.6826736 20.0174205,10.6811126 20.0205424,10.7088199 C20.013518,10.7064784 19.9920546,10.6982833 20.0002498,10.7119419 C19.9963473,10.7380882 20.0404449,10.7213077 20.04864,10.750576 L20.0583961,10.7334053 L20.0636585,10.7474634 L20.091701,10.7624297 L20.074701,10.7704297 C20.0833717,10.7736004 20.0864937,10.8005272 20.0985912,10.7876492 C20.1114693,10.833698 20.1672741,10.877015 20.1551766,10.9148687 C20.1614205,10.9191614 20.1672741,10.9336004 20.173518,10.9273565 C20.1762498,10.9140882 20.1594693,10.9176004 20.1629815,10.9113565 C20.1664937,10.9160394 20.1715668,10.9148687 20.1739083,10.9144784 C20.178201,10.928137 20.1828839,10.9378931 20.1629815,10.9328199 C20.1715668,10.9624784 20.2020059,10.9496004 20.2105912,10.9894053 C20.2035668,10.990576 20.2020059,10.9944784 20.2066888,11.005015 L20.2250302,11.0214053 C20.2308839,11.0467711 20.2144937,11.0405272 20.2031766,11.0452101 C20.2094205,11.0573077 20.2141034,11.0733077 20.22464,11.0760394 L20.2152741,11.0959419 C20.2219083,11.0815028 20.2258107,11.1045272 20.2304937,11.1096004 C20.221518,11.1084297 20.2297132,11.1220882 20.2336156,11.1295028 C20.2402498,11.1256004 20.2382985,11.1096004 20.237518,11.1006248 L20.2558595,11.1236492 C20.2433717,11.1236492 20.2546888,11.1470638 20.2570302,11.1576004 C20.2585912,11.1700882 20.2718595,11.1689175 20.27264,11.1724297 C20.2679571,11.1739906 20.2745912,11.1927223 20.2652254,11.1849175 C20.2632741,11.181015 20.269518,11.1743809 20.2621034,11.1689175 C20.259762,11.1778931 20.2503961,11.1786736 20.2593717,11.1938931 C20.2663961,11.2052101 20.2820059,11.1864784 20.2773229,11.2118443 L20.2644449,11.201698 L20.2605424,11.2251126 L20.2714693,11.2243321 C20.2784937,11.232137 20.2738107,11.261015 20.287079,11.2645272 C20.2894205,11.2758443 20.2820059,11.2895028 20.2820059,11.3004297 C20.275762,11.3125272 20.2816156,11.329698 20.290201,11.3402345 C20.2878595,11.3472589 20.2909815,11.3640394 20.2983961,11.373015 C20.2921522,11.3917467 20.258201,11.3804297 20.2738107,11.4003321 C20.2761522,11.4186736 20.2964449,11.4292101 20.3026888,11.4217955 C20.2964449,11.4549662 20.3112741,11.4932101 20.2937132,11.5236492 C20.2980059,11.5287223 20.3007376,11.5256004 20.303079,11.5357467 C20.2968351,11.584137 20.30464,11.6418931 20.2796644,11.6774053 L20.2632741,11.6742833 C20.271079,11.6875516 20.2503961,11.6863809 20.2660059,11.6934053 C20.275762,11.6937955 20.2800546,11.696137 20.287079,11.6828687 C20.2859083,11.7129175 20.275762,11.7581858 20.2632741,11.7718443 C20.269518,11.7648199 20.2706888,11.7718443 20.2722498,11.7788687 C20.2570302,11.7726248 20.2519571,11.793698 20.2503961,11.8108687 L20.2453229,11.8229662 C20.2461034,11.8299906 20.2617132,11.8358443 20.2476644,11.8491126 L20.2363473,11.8506736 C20.237518,11.8694053 20.2414205,11.8982833 20.2269815,11.9131126 L20.207079,11.9213077 C20.2047376,11.9291126 20.205518,11.9451126 20.2160546,11.9337955 C20.1934205,11.9595516 20.1824937,11.9775028 20.1672741,11.9806248 C20.1645424,12.0422833 20.1169327,12.1152589 20.0673717,12.1589662 C20.0462985,12.1609175 20.066201,12.1679419 20.0541034,12.1734053 C20.0533229,12.1644297 20.034201,12.1726248 20.0381034,12.157015 C20.0158595,12.1695028 20.0244449,12.1886248 20.015079,12.2030638 C20.019762,12.2116492 20.0201522,12.1894053 20.0260059,12.1999419 C20.0267863,12.2054053 19.9951766,12.2178931 20.0014205,12.2303809 C19.9928351,12.2303809 19.9901034,12.2194541 19.9885424,12.2132101 L19.9811278,12.2276492 C19.9561522,12.2268687 19.9943961,12.1796492 19.9659083,12.1765272 L19.9569327,12.1866736 C19.9374205,12.1835516 19.9733229,12.1523321 19.9440546,12.1691126 C19.9374205,12.1831614 19.9409327,12.206576 19.9549815,12.2030638 C19.933518,12.2253077 19.965518,12.2377955 19.938201,12.2580882 C19.9257132,12.2573077 19.9581034,12.2397467 19.9456156,12.2346736 C19.9261034,12.2354541 19.9249327,12.2592589 19.9112741,12.2651126 C19.9268839,12.2596492 19.9249327,12.2791614 19.9182985,12.2877467 C19.9007376,12.2928199 19.9194693,12.2701858 19.8987863,12.2838443 C19.9003473,12.2924297 19.8839571,12.3096004 19.9042498,12.3037467 C19.9069815,12.3236492 19.8792741,12.3135028 19.875762,12.3326248 C19.8621034,12.3259906 19.8808351,12.2943809 19.8542985,12.3033565 C19.8648351,12.3115516 19.8347863,12.3353565 19.8570302,12.3431614 C19.8457132,12.3458931 19.8398595,12.3380882 19.842201,12.3275516 C19.8254205,12.3291126 19.8222985,12.366576 19.805518,12.3478443 L19.8074693,12.3615028 L19.7836644,12.3587711 C19.7715668,12.3642345 19.7516644,12.3923321 19.7442498,12.3747711 C19.741518,12.3782833 19.7130302,12.3903809 19.7290302,12.3974053 C19.7501034,12.3966248 19.7450302,12.3794541 19.7625912,12.3911614 C19.7438595,12.3837467 19.7380059,12.4044297 19.7294205,12.4137955 C19.7196644,12.413015 19.7048351,12.4180882 19.7040546,12.4270638 C19.7071766,12.4208199 19.7028839,12.417698 19.6974205,12.4180882 L19.695079,12.4313565 C19.6720546,12.4473565 19.6818107,12.4157467 19.6580059,12.4270638 L19.6740059,12.413015 C19.6704937,12.416137 19.6583961,12.4087223 19.6478595,12.4157467 L19.6404449,12.4500882 C19.6315993,12.4560719 19.6300384,12.4500882 19.626743,12.4497124 L19.6196585,12.4544634 L19.634201,12.4379906 C19.635762,12.433698 19.61664,12.4255028 19.5979083,12.4317467 C19.5869815,12.4387711 19.5721522,12.4590638 19.5928351,12.4582833 C19.5834693,12.4614053 19.5682498,12.4594541 19.5741034,12.449698 C19.5534205,12.4594541 19.5799571,12.4598443 19.5627863,12.4711614 C19.5534205,12.4660882 19.5268839,12.4614053 19.5108839,12.4543809 L19.5264937,12.4340882 L19.5136156,12.4364297 C19.5268839,12.4200394 19.503079,12.4278443 19.5093229,12.4118443 C19.5003473,12.4114541 19.4909815,12.4180882 19.4831766,12.4231614 C19.5128351,12.4411126 19.4605424,12.4598443 19.471079,12.4793565 C19.4355668,12.4918443 19.4414205,12.4329175 19.4090302,12.4696004 C19.4156644,12.4742833 19.4000546,12.4922345 19.4219083,12.4836492 C19.3996644,12.4836492 19.4094205,12.5062833 19.3817132,12.5000394 C19.4000546,12.4895028 19.359079,12.4809175 19.3852254,12.465698 C19.3840546,12.4727223 19.4012254,12.4696004 19.405518,12.4672589 C19.395762,12.4598443 19.4047376,12.4457955 19.3824937,12.448137 C19.3692254,12.4512589 19.3508839,12.4536004 19.3543961,12.4645272 C19.3559571,12.4766248 19.375079,12.4614053 19.3676644,12.4742833 C19.3407376,12.4813077 19.3348839,12.4633565 19.3251278,12.4856004 C19.3422985,12.4820882 19.347762,12.4941858 19.347762,12.5027711 L19.3278595,12.5097955 C19.2985912,12.4973077 19.3227863,12.5164297 19.2911766,12.5156492 L19.2755668,12.5004297 C19.282201,12.4863809 19.3212254,12.5047223 19.314201,12.4824784 C19.2942985,12.4824784 19.2880546,12.4937955 19.2689327,12.4891126 L19.2829815,12.4840394 C19.2755668,12.4836492 19.2673717,12.4543809 19.2396644,12.4727223 C19.2252254,12.480137 19.2361522,12.4809175 19.235762,12.4891126 C19.2033717,12.493015 19.1940059,12.5012101 19.1737132,12.5027711 L19.1726585,12.5014634 L19.1622853,12.5119008 C19.1405477,12.5218267 19.1060721,12.5289378 19.0823961,12.5302711 L19.1706585,12.4984634 C19.1577999,12.4927982 19.1449652,12.4957467 19.1600546,12.4848199 C19.1705912,12.4941858 19.21664,12.4934053 19.2275668,12.4766248 C19.215079,12.4578931 19.2529327,12.478576 19.2587863,12.4586736 C19.2334205,12.4590638 19.2338107,12.4403321 19.229518,12.4278443 L19.2115668,12.4348687 C19.2088351,12.446576 19.2178107,12.4461858 19.2189815,12.4582833 C19.1904937,12.4559419 19.1635668,12.4621858 19.1479571,12.4738931 C19.1385912,12.4680394 19.1413229,12.4563321 19.15264,12.4551614 C19.119079,12.4586736 19.0831766,12.4575028 19.0515668,12.4536004 C19.0718595,12.4727223 19.0160546,12.4578931 19.0301034,12.4738931 C19.0472741,12.4781858 19.0617132,12.4918443 19.0523473,12.5004297 C19.0418107,12.4992589 19.0527376,12.4918443 19.0484449,12.4879419 C19.0393392,12.4949662 19.0330086,12.4851668 19.0258685,12.4827097 L19.0156585,12.4864634 L19.0293663,12.4782436 C19.0315343,12.4702942 19.0219083,12.4594541 19.0258107,12.4493077 C19.0039571,12.4578931 19.0265912,12.4387711 19.0051278,12.4383809 L18.9321522,12.4563321 C18.9017132,12.4422833 18.8548839,12.4559419 18.8275668,12.4567223 C18.813518,12.4493077 18.8228839,12.432137 18.8076644,12.429015 C18.7893229,12.4294053 18.8213229,12.4473565 18.7940059,12.4395516 L18.755892,12.4359093 C18.748304,12.4373836 18.7419733,12.4411126 18.7393717,12.4493077 L18.7475668,12.4309662 C18.7424937,12.429015 18.7378107,12.4333077 18.7339083,12.4352589 C18.7339083,12.4294053 18.7276644,12.4239419 18.7358595,12.4200394 C18.7194693,12.4071614 18.7011278,12.4219906 18.6827863,12.4223809 L18.6944937,12.4333077 C18.6636644,12.4418931 18.6429815,12.4309662 18.6129327,12.4348687 L18.6137132,12.4243321 L18.602121,12.4283108 C18.6110436,12.4371666 18.6140489,12.4468455 18.5959655,12.4607955 C18.5919655,12.4407955 18.5689655,12.4207955 18.5739655,12.4027955 L18.5866585,12.4154634 L18.6211278,12.3962345 C18.6340059,12.4024784 18.607079,12.4091126 18.6148839,12.4196492 C18.6219083,12.429015 18.6492254,12.4258931 18.6539083,12.4157467 C18.6433717,12.414576 18.6425912,12.4169175 18.6343961,12.4208199 C18.6308839,12.4059906 18.6468839,12.4067711 18.6546888,12.3966248 L18.6426585,12.3954634 L18.6575668,12.3904784 C18.6639571,12.3892101 18.6712741,12.3888199 18.6804449,12.3888199 C18.6679571,12.3946736 18.687079,12.3977955 18.6823961,12.4020882 C18.6839571,12.3888199 18.7011278,12.3849175 18.723762,12.3888199 C18.739762,12.4040394 18.7659083,12.3790638 18.7920546,12.3833565 C18.781518,12.3966248 18.7682498,12.4071614 18.7522498,12.4122345 C18.76864,12.4188687 18.7705912,12.4118443 18.7865912,12.4184784 C18.7943961,12.4087223 18.8002498,12.3935028 18.8217132,12.3876492 C18.8423961,12.3923321 18.8423961,12.3778931 18.8669815,12.3806248 C18.9091278,12.3853077 18.9524449,12.3853077 18.9844449,12.3868687 L18.9856156,12.3966248 C19.0035668,12.3759419 19.0453229,12.3892101 19.069518,12.3802345 C19.1104937,12.3896004 19.1581034,12.3708687 19.1787863,12.3872589 C19.2505912,12.3778931 19.3122498,12.3700882 19.3844449,12.365015 L19.373518,12.3802345 C19.3856156,12.3685272 19.3828839,12.3876492 19.395762,12.384137 C19.379762,12.3743809 19.411762,12.3677467 19.4195668,12.3583809 C19.4531278,12.3642345 19.491762,12.3439419 19.5167376,12.3295028 C19.5432741,12.3150638 19.5783961,12.3189662 19.6139083,12.3119419 C19.6189815,12.3146736 19.6287376,12.3213077 19.6384937,12.317015 C19.650201,12.2943809 19.6599571,12.2912589 19.6810302,12.270576 C19.6989815,12.2616004 19.731762,12.2537955 19.7516644,12.2463809 C19.8066888,12.1894053 19.8777132,12.1546736 19.9272741,12.0910638 L19.9389815,12.0953565 C19.9752741,12.0258931 20.0505912,11.9685272 20.0673717,11.904137 L20.0818107,11.9189662 C20.09664,11.9037467 20.0989815,11.8756492 20.083762,11.8744784 C20.1001522,11.8600394 20.0942985,11.825698 20.114201,11.8194541 C20.1247376,11.8011126 20.114201,11.7929175 20.1173229,11.776137 C20.1308514,11.7519419 20.1348405,11.7362454 20.1377312,11.7171379 L20.1406585,11.6944634 C20.1489327,11.6979906 20.1518595,11.696137 20.1536156,11.6914541 C20.1528351,11.6762345 20.1696156,11.6391614 20.1434693,11.649698 C20.1610302,11.6091126 20.146201,11.552137 20.1641522,11.5111614 C20.157518,11.5142833 20.1567376,11.5037467 20.1524449,11.4990638 L20.1601919,11.4252643 C20.160163,11.4137738 20.1582985,11.4030638 20.1528351,11.393698 C20.1555668,11.3878443 20.1649327,11.4026736 20.163762,11.3878443 C20.16064,11.3788687 20.1551766,11.3878443 20.1504937,11.3773077 C20.1321522,11.3195516 20.1508839,11.2563321 20.1419083,11.2024784 C20.0911766,11.1189662 20.0903961,11.0112589 20.0279571,10.9429662 C20.0010302,10.9261858 20.0088351,10.8719419 19.9737132,10.8672589 C19.9733229,10.8586736 19.9608351,10.8430638 19.9709815,10.8418931 C19.9522498,10.8266736 19.935079,10.784137 19.8968351,10.7728199 C19.885518,10.7462833 19.8523473,10.7369175 19.8301034,10.705698 C19.8340059,10.7064784 19.8402498,10.7099906 19.8441522,10.7068687 C19.8382985,10.6900882 19.8062985,10.7006248 19.8133229,10.6768199 C19.8066888,10.6717467 19.8023961,10.6826736 19.8066888,10.6854053 C19.743079,10.6335028 19.6529327,10.6112589 19.5721522,10.5878443 C19.5143961,10.561698 19.5787863,10.5503809 19.5253229,10.5562345 C19.5007376,10.5613077 19.4968351,10.528137 19.4812254,10.5371126 C19.4839571,10.5519419 19.4706888,10.5429662 19.4687376,10.5507711 C19.4328351,10.5339906 19.4269815,10.5187711 19.3949815,10.5238443 C19.3586888,10.5343809 19.3173229,10.5199419 19.2845424,10.5414053 C19.0847376,10.5289175 18.8825912,10.5507711 18.6792741,10.5511614 L18.5290302,10.5499906 L18.5066585,10.5494634 L18.5069327,10.6242345 C18.5061034,10.6740882 18.5044449,10.7242345 18.5013229,10.7747711 C18.4818107,10.8219906 18.4825912,10.8255028 18.4903961,10.8777955 C18.4993717,10.878576 18.4853229,10.9125272 18.5001522,10.9176004 C18.4974205,10.9925272 18.5017132,11.0612101 18.5017132,11.1380882 C18.499762,11.1259906 18.4868839,11.1197467 18.4880546,11.1341858 L18.498201,11.1494053 C18.4958595,11.1615028 18.5040546,11.1724297 18.5091278,11.1622833 C18.5227863,11.3554541 18.4907863,11.5455028 18.4946888,11.7347711 C18.4880546,11.7796492 18.4942985,11.8436492 18.4974205,11.8924297 C18.4759571,12.0372101 18.4591766,12.1675516 18.4740059,12.3142833 C18.4740059,12.3146736 18.4330302,12.2955516 18.4232741,12.2346736 C18.386201,12.1574053 18.4236644,12.0551614 18.4002498,11.9704784 C18.3986888,11.9607223 18.4205424,11.9728199 18.4154693,11.950576 C18.3869815,11.8682345 18.403762,11.7386736 18.4260059,11.6387711 L18.419762,11.582576 C18.4236644,11.5821858 18.4252254,11.5888199 18.4302985,11.5845272 C18.4189815,11.5794541 18.4248351,11.5478443 18.41664,11.5392589 C18.4209327,11.5310638 18.4302985,11.5322345 18.4349815,11.521698 L18.4221034,11.5099906 C18.3908839,11.4779906 18.4240546,11.4319419 18.4084449,11.3878443 L18.4041088,11.3155769 L18.3943961,11.153698 C18.399079,11.1568199 18.4072741,11.1595516 18.4127376,11.1552589 C18.399079,11.1513565 18.3955668,11.1271614 18.3928351,11.1060882 C18.4068839,11.0967223 18.3799571,11.0697955 18.387762,11.0452101 C18.3760546,11.0288199 18.3994693,11.0202345 18.3819083,11.005015 L18.3928351,10.9933077 C18.3729327,10.9851126 18.4029815,10.9667711 18.3928351,10.9515516 C18.3842498,10.9378931 18.3940059,10.9300882 18.3908839,10.9172101 L18.3919101,10.8896185 L18.3916585,10.8724634 C18.3980384,10.8855137 18.4012904,10.8862508 18.4072741,10.8805272 C18.3912741,10.7786736 18.3943961,10.673698 18.3940059,10.5710638 L18.4011766,10.5567711 L18.4056585,10.5504634 L18.41664,10.5507711 L18.4541034,10.5503809 L18.5066585,10.5494634 L18.5075668,10.4500882 L18.4610802,10.4955551 L18.4076585,10.5474634 L18.4045424,10.5249175 C18.4032741,10.5153565 18.4014205,10.5058931 18.397518,10.5012101 C18.3979083,10.5047223 18.4053229,10.494576 18.4061034,10.4891126 C18.4142985,10.4724297 18.3941766,10.4737467 18.3962802,10.460137 L18.4036585,10.4464634 C18.4009002,10.4598443 18.4105262,10.456202 18.4107863,10.4567223 C18.4053229,10.4418931 18.4459083,10.4457955 18.461518,10.4411126 C18.4583961,10.4438443 18.4533229,10.4454053 18.4541034,10.4500882 C18.4767376,10.4364297 18.4958595,10.4528199 18.515762,10.4442345 L18.5083473,10.4528199 C18.5407376,10.4637467 18.5177132,10.4344784 18.5458107,10.4407223 C18.5391766,10.4434541 18.541518,10.4469662 18.5403473,10.4504784 C18.5664937,10.4344784 18.6082498,10.4395516 18.6340059,10.4340882 C18.6613229,10.4360394 18.6905912,10.4407223 18.7218107,10.433698 C18.7331278,10.4376004 18.7179083,10.4555516 18.7479571,10.4520394 C18.7467863,10.4344784 18.7986888,10.4446248 18.7811278,10.4247223 C18.8064937,10.4274541 18.847079,10.4340882 18.8642498,10.4282345 C18.8529327,10.4348687 18.8767376,10.4500882 18.8552741,10.4512589 L18.8712741,10.4621858 C18.8689327,10.4696004 18.8548839,10.4598443 18.8599571,10.4688199 C18.8704937,10.4680394 18.9017132,10.461015 18.911079,10.464137 C18.9309815,10.4532101 18.9489327,10.4325272 18.9809327,10.4309662 C18.9657132,10.4376004 18.989518,10.4508687 18.9789815,10.4536004 L19.0238595,10.4200394 C19.0343961,10.4192589 19.0258107,10.4340882 19.0414205,10.4294053 C19.04064,10.4247223 19.0476644,10.4219906 19.0523473,10.4180882 C19.0562498,10.4200394 19.0968351,10.4141858 19.1011278,10.4317467 C19.1058107,10.4387711 19.0835668,10.4352589 19.0952741,10.4415028 L19.1354693,10.4356492 C19.1444449,10.4398118 19.1585804,10.4360828 19.1630031,10.4305037 L19.1596585,10.4204634 L19.1724937,10.4160882 C19.1819083,10.4141858 19.19264,10.4137955 19.2025912,10.4149662 C19.1955668,10.4173077 19.1963473,10.4219906 19.1936156,10.4266736 L19.2354205,10.4148687 L19.2756585,10.4104634 Z M22.8183166,8.80083978 L22.9106585,8.82646341 L22.9166642,8.8392082 C22.9185873,8.84568625 22.91904,8.85172722 22.9173229,8.8563321 C22.92864,8.81886868 22.9321522,8.90121015 22.9407376,8.92423454 C22.9298107,9.006576 22.9419083,9.11194186 22.9516644,9.18491747 L22.9419083,9.18764917 C22.9602498,9.26140527 22.9442498,9.34921015 22.9411278,9.44130771 C22.9368351,9.45184429 22.9278595,9.46823454 22.92864,9.49555161 C22.94464,9.54511259 22.9434693,9.57125893 22.9532254,9.64462478 C22.9532254,9.6980882 22.9493229,9.78472234 22.943079,9.838576 C22.9653229,10.0391614 22.9512741,10.2440394 22.9645424,10.4528199 L22.9536156,10.4653077 C22.978201,10.6674541 22.9559571,10.9160394 22.9684449,11.0889175 L22.9485424,11.072137 C22.9422985,11.1263809 22.9536156,11.1954541 22.9676644,11.1817955 C22.9614205,11.2360394 22.9770302,11.3172101 22.9610302,11.3515516 C22.9571278,11.4069662 22.9700059,11.4194541 22.9727376,11.4655028 C22.9677945,11.5396492 22.9668405,11.582576 22.9679101,11.6339437 L22.9696585,11.6924634 C22.9629381,11.6870746 22.9589489,11.6923646 22.9579083,11.7097955 C22.9633717,11.7488199 22.9528351,11.8534053 22.9762498,11.8143809 C22.9625912,11.9259906 22.9875668,12.0750638 22.9692254,12.1839419 C22.9754693,12.174576 22.9770302,12.2022833 22.9813229,12.2136004 C22.9817132,12.3115516 22.9684449,12.414576 22.9793717,12.493015 C22.9762498,12.5086248 22.9684449,12.4680394 22.9676644,12.5082345 C22.9700059,12.5320394 22.9758595,12.5086248 22.979762,12.5378931 C22.9918595,12.6967223 22.9672741,12.8594541 22.9703961,13.0038443 C22.9828839,13.2606248 22.97664,13.5283321 22.9785912,13.774576 C22.9918595,13.8541858 22.9555668,13.965015 22.9824937,14.0309662 C22.9778107,14.0504784 22.9805424,14.1051126 22.9711766,14.0910638 C22.9840546,14.1566248 22.959079,14.2744784 22.9754693,14.369698 L22.9731278,14.3458931 C22.9625912,14.4418931 22.9770302,14.5261858 22.9672741,14.6272589 C22.9653229,14.6171126 22.963762,14.5983809 22.959079,14.5952589 C22.9501034,14.6342833 22.9789815,14.6877467 22.9563473,14.7092101 C22.9563473,14.7314541 22.9676644,14.7252101 22.9668839,14.7115516 C22.9625912,14.8223809 22.9641522,14.9367223 22.9668839,15.0522345 L22.9696156,15.1388687 L22.9703961,15.1607223 C22.8260059,15.3179906 22.9177132,15.2048199 22.8798595,15.2399419 L22.835762,15.2415028 L22.6601522,15.246576 C22.4931278,15.2333077 22.6500059,15.2087223 22.5181034,15.2255028 C22.4580059,15.2356492 22.429518,15.2040394 22.3940059,15.2157467 C22.4084449,15.2297955 22.3705912,15.2235516 22.3694205,15.232137 C22.2675668,15.2231614 22.2468839,15.2106736 22.1664937,15.2212101 C22.0779083,15.2344784 21.96864,15.2235516 21.8890302,15.2473565 L21.7914693,15.248137 L21.7582985,15.248137 L21.7243069,15.2151111 C21.7115729,15.2025333 21.6952254,15.1863809 21.6743961,15.1657955 L21.6740059,15.1033565 L21.6712741,14.9129175 L21.6704937,14.865698 L21.6701034,14.8286248 C21.6653229,14.8333077 21.6733473,14.8253321 21.6868473,14.8119541 L21.7364449,14.7628687 L21.7582985,14.7416004 L21.7684449,14.7416004 L21.8640546,14.7400394 L22.0544937,14.7369175 L22.4334205,14.7310638 L22.4726585,14.7304634 L22.4740059,14.7814053 L22.4743961,14.8286248 L22.4992254,14.8043809 L22.5141424,14.7896451 L22.5726585,14.7304634 L22.5723473,14.7603321 C22.6183961,14.7685272 22.5434693,14.8645272 22.56064,14.8532101 C22.4970302,14.8504784 22.3963473,14.8434541 22.3538107,14.849698 C22.3826888,14.8430638 22.3229815,14.8278443 22.3760546,14.8266736 L22.3358595,14.8157467 C22.3417132,14.8083321 22.3768351,14.8180882 22.3643473,14.8091126 C22.3378107,14.8098931 22.2605424,14.8169175 22.2367376,14.8137955 C22.1875668,14.8247223 22.1422985,14.845015 22.0626888,14.8473565 C22.1001522,14.8403321 22.0416156,14.8278443 22.0669815,14.8247223 L21.9561522,14.8586736 C21.9296156,14.8594541 21.9502985,14.8446248 21.9120546,14.8493077 C21.9140059,14.8539906 21.8972254,14.8571126 21.8859083,14.861015 C21.8785912,14.8595516 21.8203473,14.862698 21.7867437,14.8569541 L21.7696585,14.8494634 C21.7721522,14.8702833 21.7762498,14.8900882 21.7739083,14.9078443 C21.7688351,14.9406248 21.7789815,15.0026736 21.7891278,14.9679419 C21.789518,14.945698 21.778201,14.9765272 21.7836644,14.9433565 C21.794201,14.9659906 21.7969327,15.0221858 21.7969327,15.070576 C21.794201,15.0541858 21.789518,15.056137 21.7844449,15.0495028 L21.7946585,15.1174634 L21.8336585,15.1194634 C21.8202172,15.1265543 21.8146237,15.128202 21.8109815,15.1267711 C21.9050302,15.1384784 22.0053229,15.1103809 22.0833717,15.1271614 C22.0704937,15.1287223 22.0763473,15.1154541 22.0771278,15.1177955 C22.1223961,15.1189662 22.1204449,15.1310638 22.1501034,15.1263809 C22.1528351,15.1334053 22.1871766,15.1240394 22.2176156,15.1220882 C22.2332254,15.117015 22.2254205,15.1256004 22.1992741,15.1263809 C22.2418107,15.1205272 22.4111766,15.1096004 22.5087376,15.1197467 C22.5067863,15.1150638 22.5688351,15.102576 22.5914693,15.1029662 L22.5824937,15.1138931 L22.6086585,15.1164634 L22.5913229,15.1197467 L22.5676585,15.1234634 L22.5953229,15.1215028 L22.6176585,15.1194634 L22.6440366,15.1174486 L22.6496585,15.1184634 L22.6626093,15.1177955 C22.6921522,15.1147603 22.7212904,15.1115516 22.7499083,15.118576 C22.7374205,15.1166248 22.7132254,15.1337955 22.7499083,15.133015 C22.8142985,15.1310638 22.7682498,15.1279419 22.8201522,15.1240394 L22.8386585,15.1214634 C22.8453839,15.0931187 22.8522985,15.0762345 22.8509815,15.089698 L22.8650302,15.0986736 C22.8638595,15.0713565 22.850201,15.0537955 22.8439571,15.0319419 C22.8451278,15.0284297 22.8478595,15.021015 22.850201,15.022576 C22.8283473,15.0182833 22.8521522,14.957015 22.8353717,14.9242345 C22.8427863,14.8664784 22.8361522,14.7778931 22.8494205,14.750576 L22.8402985,14.6852589 L22.8396585,14.6164634 L22.8423473,14.6316004 C22.8433717,14.6366248 22.8447376,14.6407223 22.847079,14.6420882 C22.8533229,14.6104784 22.8478595,14.6026736 22.8443473,14.5734053 C22.8474693,14.5800394 22.8568351,14.5101858 22.86464,14.4746736 C22.8583961,14.430576 22.8466888,14.4457955 22.8396644,14.4415028 C22.8611278,14.4013077 22.8260059,14.317015 22.8451278,14.2666736 C22.8478595,14.2818931 22.8556644,14.3310638 22.8611278,14.2943809 C22.8825912,14.2541858 22.845518,14.2132101 22.8556644,14.1484297 L22.8381034,14.1644297 C22.8490302,14.1355516 22.8279571,14.0688199 22.8459083,14.0754541 C22.8396644,14.0536004 22.851762,13.9989662 22.8345912,14.0059906 C22.8490302,13.8994541 22.8256156,13.7468687 22.8568351,13.681698 C22.8541034,13.6664784 22.8568351,13.6282345 22.8478595,13.6360394 C22.8381034,13.6614053 22.8548839,13.6715516 22.8482498,13.6809175 C22.8478595,13.6672589 22.8431766,13.664137 22.8408351,13.662576 C22.8447376,13.6294053 22.8459083,13.6032589 22.8603473,13.6344784 C22.8708839,13.5607223 22.831079,13.5583809 22.8377132,13.4647223 C22.8447376,13.469015 22.8474693,13.4619906 22.8462985,13.4342833 L22.8338107,13.3823809 C22.8365424,13.3218931 22.850201,13.3480394 22.8622985,13.3464784 C22.8603473,13.3140882 22.8607376,13.2742833 22.851762,13.2594541 L22.8669815,13.2200394 C22.8587863,13.241698 22.8589327,13.2159419 22.858201,13.1952894 L22.8566585,13.1784634 L22.8599571,13.1935028 C22.8650302,13.1876492 22.8619083,13.1497955 22.8603473,13.1310638 C22.8554042,13.1341858 22.852369,13.1520503 22.850201,13.1698569 L22.8466585,13.1934634 L22.8427863,13.1646736 C22.8416156,13.1534053 22.8402498,13.1414053 22.8369327,13.1302833 C22.84864,13.137698 22.845518,13.0776004 22.8466888,13.0518443 C22.8494205,13.0221858 22.8361522,13.0182833 22.8365424,13.009698 C22.8427863,13.0089175 22.8377132,12.9613077 22.8462985,12.9847223 C22.8482498,12.9944784 22.8404449,13.0077467 22.8459083,13.0245272 L22.8559101,12.9954468 C22.8564882,12.9890584 22.8559246,12.9802996 22.8533229,12.9667711 C22.8474693,12.9363321 22.8299083,12.974576 22.8373229,12.9168199 C22.8400546,12.9320394 22.8451278,12.9347711 22.8490302,12.9464784 L22.8552741,12.8926248 L22.8443473,12.8902833 C22.8381034,12.8684297 22.8459083,12.8020882 22.8330302,12.7896004 C22.8318595,12.7622833 22.8404449,12.7322345 22.8416156,12.7060882 L22.8451278,12.6589175 C22.8439571,12.641015 22.8410302,12.6237467 22.8373229,12.6104784 C22.8404449,12.5944784 22.8388839,12.5535028 22.8322498,12.5316492 C22.8404449,12.4879419 22.8732254,12.5168199 22.8595668,12.4684297 C22.8591766,12.4239419 22.8396644,12.398576 22.83264,12.4165272 C22.8400546,12.3365272 22.8224937,12.2452101 22.8392741,12.1710638 C22.8349815,12.1593565 22.8322498,12.1667711 22.829518,12.1429662 C22.8323798,12.0643971 22.8257023,11.9801045 22.8272922,11.9048886 L22.8376585,11.8014634 L22.8418778,11.8153992 C22.8458839,11.8207955 22.8504937,11.8028687 22.8548839,11.8022833 C22.845518,11.7741858 22.8650302,11.7683321 22.8482498,11.7581858 C22.8384937,11.7609175 22.8338107,11.7581858 22.8299083,11.7913565 C22.8248351,11.7211126 22.8248351,11.614576 22.8338107,11.5755516 C22.8291278,11.5950638 22.8263961,11.5798443 22.8232741,11.5646248 C22.8388839,11.569698 22.8412254,11.5177955 22.835762,11.4787711 L22.8263961,11.4733077 L22.8361522,11.4479419 C22.8330302,11.4327223 22.8162498,11.4315516 22.8252254,11.3925272 C22.8287376,11.390576 22.83264,11.3882345 22.8353717,11.3812101 C22.8275668,11.3406248 22.8146888,11.2836492 22.8224937,11.2395516 L22.8361522,11.2036492 C22.8349815,11.1896004 22.830079,11.1683077 22.8260546,11.1725333 L22.8290122,11.1201514 C22.8326834,11.0818497 22.835892,11.0552264 22.8439571,11.0393565 C22.815079,10.9101858 22.813518,10.7224784 22.8158595,10.5722345 C22.829518,10.5363321 22.8103961,10.5558443 22.8154693,10.5277467 C22.8221034,10.5406248 22.8302985,10.4969175 22.8384937,10.5285272 C22.8459083,10.4707711 22.8260059,10.4539906 22.8228839,10.4165272 C22.813518,10.4106736 22.8291278,10.4469662 22.8170302,10.4395516 L22.8175506,10.3762454 C22.8168568,10.3637576 22.8148189,10.3535679 22.8100059,10.350576 C22.8158595,10.336137 22.8260059,10.3474541 22.8318595,10.3552589 L22.8252254,10.320137 C22.8416156,10.2768199 22.8544937,10.4184784 22.8747863,10.3732101 L22.8724449,10.3408199 C22.8872741,10.3096004 22.8888351,10.4270638 22.8942985,10.3451126 C22.8872741,10.3096004 22.8669815,10.2795516 22.8607376,10.3111614 C22.8568351,10.2374053 22.8271766,10.2772101 22.8283473,10.1976004 C22.8365424,10.176137 22.8302985,10.2612101 22.8420059,10.2459906 C22.8495506,10.221015 22.8442606,10.1960394 22.8410519,10.1723357 L22.8396585,10.1384634 L22.834268,10.154076 C22.8278839,10.1598199 22.8194693,10.1377955 22.8174205,10.1199419 C22.8240546,10.0797467 22.8306888,10.1460882 22.8322498,10.0891126 C22.8240546,10.0797467 22.8178107,10.0270638 22.8123473,10.0727223 C22.7940059,10.0520394 22.8174205,10.0134053 22.8033717,9.98218576 C22.8162498,9.96345405 22.8334205,10.0407223 22.8396644,9.97828332 C22.8271766,9.98803942 22.8224937,9.90062478 22.8041522,9.93418576 C22.8076644,9.90960039 22.8174205,9.90686868 22.8252254,9.9248199 C22.8330302,9.88969795 22.802201,9.83974673 22.8271766,9.82803942 L22.8142985,9.81594186 C22.8185912,9.80501503 22.8213229,9.78940527 22.8283473,9.77145405 C22.8287376,9.74062478 22.8111766,9.67155161 22.8302985,9.67467356 C22.8283473,9.66491747 22.8291278,9.59428332 22.8158595,9.62121015 C22.8076644,9.66530771 22.8256156,9.67194186 22.8076644,9.69613698 C22.8224937,9.66491747 22.8057132,9.63291747 22.80064,9.60755161 C22.8053229,9.58803942 22.8068839,9.55330771 22.7986888,9.54394186 C22.8029815,9.55564917 22.8080546,9.54940527 22.8100059,9.53769795 L22.7986888,9.52169795 C22.7928351,9.46003942 22.8185912,9.50725893 22.8154693,9.44755161 L22.8240546,9.4928199 C22.8221034,9.48267356 22.8330302,9.46238088 22.8291278,9.43389308 C22.8185912,9.422576 22.8064937,9.40189308 22.7982985,9.39213698 C22.7936156,9.358576 22.8100059,9.37691747 22.799079,9.34374673 L22.8115668,9.38706381 C22.8146888,9.39369795 22.8287376,9.35779551 22.8283473,9.31291747 C22.8244449,9.28403942 22.8100059,9.23955161 22.8041522,9.2848199 C22.8041522,9.26218576 22.8103961,9.230576 22.8178107,9.24852722 C22.8142985,9.19740527 22.8064937,9.25516137 22.8002498,9.21106381 C22.8072741,9.19311259 22.8170302,9.13691747 22.8271766,9.10296625 L22.8336585,9.12146341 C22.8341199,9.08355597 22.8145999,9.02823239 22.8353999,9.04267859 C22.8370781,9.06288112 22.847909,9.10238958 22.8389454,9.12762021 L22.8446585,9.14746341 L22.8447376,9.118576 C22.8583961,9.15799064 22.8552741,9.09828332 22.8701034,9.12091747 C22.8724449,9.09984429 22.8673717,9.07447844 22.8634693,9.05418576 C22.8400546,9.11545405 22.8314693,8.98550283 22.8100059,9.00345405 C22.8053229,8.9363321 22.8413502,8.9428882 22.8387653,8.90343922 L22.8306585,8.87446341 L22.8126585,8.87746341 C22.8027647,8.87966001 22.7992091,8.88221828 22.8014205,8.88599064 C22.8025912,8.8980882 22.851762,8.88442966 22.8302985,8.89691747 C22.7647376,8.90121015 22.7538107,8.88286868 22.7268839,8.9043321 C22.7682498,8.90238088 22.7787863,8.91525893 22.7780059,8.92345405 L22.7300059,8.92852722 L22.7393717,8.9203321 C22.6621034,8.91447844 22.7167376,8.93516137 22.6418107,8.9328199 L22.6066888,8.9168199 C22.62464,8.90316137 22.7155668,8.92306381 22.7022985,8.9008199 C22.653518,8.90003942 22.637518,8.91135649 22.5914693,8.90550283 L22.6258107,8.9008199 C22.6082498,8.90003942 22.591079,8.87038088 22.5216156,8.88794186 C22.4857132,8.894576 22.5122498,8.89613698 22.511079,8.9043321 C22.4330302,8.90706381 22.4096156,8.91525893 22.3592741,8.9168199 C22.3698107,8.9008199 22.2702985,8.91525893 22.3261034,8.89886868 C22.3514693,8.90823454 22.46464,8.90745405 22.4923473,8.89184429 C22.4638595,8.8723321 22.5536156,8.894576 22.5703961,8.87506381 C22.5079571,8.87467356 22.5106888,8.85555161 22.5009327,8.84306381 C22.4833717,8.84228332 22.4665912,8.84735649 22.4564449,8.84930771 C22.4490302,8.86101503 22.4716644,8.86062478 22.4732254,8.87311259 C22.4033717,8.86999064 22.3358595,8.87623454 22.2972254,8.88794186 C22.2738107,8.8820882 22.2812254,8.87038088 22.3089327,8.86921015 C22.2258107,8.87272234 22.1368351,8.87116137 22.0580059,8.86764917 C22.1091278,8.88677112 21.9698107,8.87194186 22.0049327,8.88794186 C22.047079,8.89223454 22.0833717,8.90589308 22.0603473,8.91447844 C22.0338107,8.91330771 22.0611278,8.90589308 22.050201,8.90199064 L22.0202389,8.90293011 L21.9936585,8.89646341 C22.0193405,8.88858186 21.9823766,8.8752199 21.9936156,8.86335649 C21.9385912,8.87194186 21.9959571,8.8528199 21.9417132,8.8528199 C21.887079,8.86101503 21.8199571,8.86764917 21.7594693,8.87077112 C21.82464,8.86452722 21.7813229,9.03896625 21.7996644,9.08852722 C21.7922498,9.12364917 21.7746888,9.09984429 21.7719571,9.1380882 L21.7618107,9.14511259 C21.7581034,9.14394186 21.7676644,9.15438088 21.7755668,9.1623321 L21.7636766,9.172826 C21.7463717,9.16852722 21.7287376,9.13486868 21.730201,9.10296625 L21.7399571,9.10023454 C21.7348839,9.05262478 21.7204449,9.05262478 21.7227863,8.99174673 L21.727079,8.83760039 C21.8265912,8.76228332 21.8382985,8.81769795 21.8890302,8.80130771 L21.8921522,8.81106381 C21.93664,8.79038088 22.0408351,8.80325893 22.1009327,8.79428332 C22.2031766,8.80364917 22.3225912,8.78491747 22.3748839,8.80169795 C22.5394367,8.81145405 22.6378649,8.76457058 22.8183166,8.80083978 Z M22.5063961,9.26999064 C22.5063961,9.26842966 22.547762,9.31642966 22.5571278,9.46745405 C22.594201,9.66062478 22.5567376,9.91467356 22.5801522,10.1261858 C22.5817132,10.1511614 22.5598595,10.1199419 22.5649327,10.1757467 C22.5934205,10.3806248 22.57664,10.7037467 22.5543961,10.9531126 L22.5485424,10.9378931 C22.5442498,10.9855028 22.5633717,11.0436492 22.56064,11.0939906 L22.5542227,11.0856943 C22.5614205,11.102576 22.5555668,11.1806248 22.563762,11.2020882 C22.5594693,11.2219906 22.5501034,11.2200394 22.5454205,11.2457955 L22.5582985,11.2746736 C22.589518,11.3546736 22.5563473,11.4694053 22.5719571,11.5786736 C22.5692254,11.5736004 22.5664937,11.5626736 22.563762,11.5712589 L22.5762931,11.7590674 L22.5860059,12.1628687 C22.5813229,12.1550638 22.5731278,12.1476492 22.5676644,12.1593565 C22.5813229,12.1691126 22.5848351,12.2299906 22.5875668,12.2822833 C22.573518,12.3060882 22.6004449,12.3728199 22.59264,12.4344784 C22.6043473,12.4750638 22.5809327,12.4969175 22.5984937,12.5339906 L22.5875668,12.5628687 C22.6074693,12.5827711 22.5774205,12.6288199 22.5875668,12.6666736 C22.5961522,12.701015 22.5863961,12.7193565 22.589518,12.7525272 C22.5904937,12.7932427 22.5885099,12.824473 22.5881901,12.8453384 L22.5876585,12.8564634 C22.5843054,12.8344101 22.5812059,12.8243126 22.5731278,12.8434541 C22.5891278,13.0975028 22.5860059,13.3593565 22.5863961,13.6153565 C22.5801522,13.6442345 22.578201,13.662576 22.5723473,13.6692101 C22.5754693,13.694576 22.575079,13.7652101 22.5828839,13.7886248 C22.5824937,13.7800394 22.575079,13.805015 22.5742985,13.8186736 C22.5703961,13.8496329 22.5793283,13.8618606 22.5836355,13.8817196 L22.5836585,13.9194634 L22.5799932,13.9046862 C22.5769002,13.8971126 22.573518,13.8955516 22.5696156,13.9002345 C22.5817132,13.9439419 22.579762,14.0020882 22.5836644,14.0536004 C22.5809327,14.0457955 22.5793717,14.0333077 22.5746888,14.0352589 C22.5883473,14.0918443 22.5719571,14.1378931 22.5805424,14.1874541 L22.5715668,14.1691126 C22.56064,14.2487223 22.5902985,14.1925272 22.5840546,14.2612101 C22.5813229,14.2448199 22.5774205,14.2506736 22.5739083,14.2475516 C22.5902985,14.3115516 22.5848351,14.4153565 22.5902985,14.4793565 C22.5887376,14.5460882 22.5836644,14.6190638 22.5906888,14.6955516 C22.587762,14.7166248 22.5769327,14.7010394 22.5731827,14.7230455 L22.5282498,14.7298931 L22.4726585,14.7304634 L22.4724449,14.593698 C22.4771278,14.097698 22.466201,13.6114541 22.479079,13.1076492 C22.4985912,12.9894053 22.4978107,12.9808199 22.4900059,12.8508687 L22.4867802,12.8364845 L22.486768,12.772448 C22.4858595,12.7627467 22.4839571,12.7551614 22.4802498,12.752137 L22.4804937,12.4793077 L22.4786585,12.2044634 L22.4818107,12.2220821 C22.486201,12.2375028 22.4932254,12.2392589 22.4923473,12.2120394 L22.482201,12.174576 C22.4845424,12.1437467 22.4763473,12.1168199 22.4712741,12.1421858 C22.4576156,11.6606248 22.4896156,11.1868687 22.4857132,10.7150638 C22.4923473,10.6030638 22.4861034,10.4438443 22.4829815,10.3220882 C22.5044449,9.96150283 22.5212254,9.63642966 22.5063961,9.26999064 Z"/></svg>'
    },
    MEDIA: {
        tv: "(min-width: 2780px)",
        screenL: "(max-width: 1920px)",
        "screenL<": "(min-width: 1920px)",
        screenM: "(max-width: 1680px)",
        "screenM<": "(min-width: 1680px)",
        screenS: "(max-width: 1440px)",
        "screenS<": "(min-width: 1440px)",
        tabletL: "(max-width: 1366px)",
        "tabletL<": "(min-width: 1366px)",
        tabletM: "(max-width: 1280px)",
        "tabletM<": "(min-width: 1280px)",
        tabletS: "(max-width: 1024px)",
        "tabletS<": "(min-width: 1024px)",
        mobileL: "(max-width: 768px)",
        "mobileL<": "(min-width: 768px)",
        mobileM: "(max-width: 560px)",
        "mobileM<": "(min-width: 560px)",
        mobileS: "(max-width: 480px)",
        "mobileS<": "(min-width: 480px)",
        mobileXS: "(max-width: 375px)",
        "mobileXS<": "(min-width: 375px)",
        light: "(prefers-color-scheme: light)",
        dark: "(prefers-color-scheme: dark)",
        print: "print"
    },
    useReset: true,
    useVariable: true,
    useFontImport: true,
    useIconSprite: true,
    useSvgSprite: true,
    useDefaultConfig: true,
    useDocumentTheme: true,
    verbose: false
};


var $8b2868fa924aab9a$exports = {};
var $1d2e473525dfc7f2$exports = {};

$parcel$export($1d2e473525dfc7f2$exports, "Transition", () => $1d2e473525dfc7f2$export$be58926105124dd4);
$parcel$export($1d2e473525dfc7f2$exports, "TransitionTrigger", () => $1d2e473525dfc7f2$export$aeb57bebb92c49ec);


var $2Tywo = parcelRequire("2Tywo");
/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $2Tywo = parcelRequire("2Tywo");
var $0cdfc2eaac330c87$var$_win, $0cdfc2eaac330c87$var$_doc, $0cdfc2eaac330c87$var$_docElement, $0cdfc2eaac330c87$var$_pluginInitted, $0cdfc2eaac330c87$var$_tempDiv, $0cdfc2eaac330c87$var$_tempDivStyler, $0cdfc2eaac330c87$var$_recentSetterPlugin, $0cdfc2eaac330c87$var$_reverting, $0cdfc2eaac330c87$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $0cdfc2eaac330c87$var$_transformProps = {}, $0cdfc2eaac330c87$var$_RAD2DEG = 180 / Math.PI, $0cdfc2eaac330c87$var$_DEG2RAD = Math.PI / 180, $0cdfc2eaac330c87$var$_atan2 = Math.atan2, $0cdfc2eaac330c87$var$_bigNum = 1e8, $0cdfc2eaac330c87$var$_capsExp = /([A-Z])/g, $0cdfc2eaac330c87$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $0cdfc2eaac330c87$var$_complexExp = /[\s,\(]\S/, $0cdfc2eaac330c87$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $0cdfc2eaac330c87$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $0cdfc2eaac330c87$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $0cdfc2eaac330c87$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$0cdfc2eaac330c87$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $0cdfc2eaac330c87$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $0cdfc2eaac330c87$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $0cdfc2eaac330c87$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $0cdfc2eaac330c87$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $0cdfc2eaac330c87$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $0cdfc2eaac330c87$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $0cdfc2eaac330c87$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $0cdfc2eaac330c87$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $0cdfc2eaac330c87$var$_transformProp = "transform", $0cdfc2eaac330c87$var$_transformOriginProp = $0cdfc2eaac330c87$var$_transformProp + "Origin", $0cdfc2eaac330c87$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $0cdfc2eaac330c87$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $0cdfc2eaac330c87$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $0cdfc2eaac330c87$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $0cdfc2eaac330c87$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $0cdfc2eaac330c87$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $0cdfc2eaac330c87$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($0cdfc2eaac330c87$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($0cdfc2eaac330c87$var$_transformOriginProp, isNotCSS, "");
        }
        property = $0cdfc2eaac330c87$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $0cdfc2eaac330c87$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $0cdfc2eaac330c87$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3)// stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($0cdfc2eaac330c87$var$_capsExp, "-$1").toLowerCase());
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $0cdfc2eaac330c87$var$_reverting();
        if ((!i || !i.isStart) && !style[$0cdfc2eaac330c87$var$_transformProp]) {
            $0cdfc2eaac330c87$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$0cdfc2eaac330c87$var$_transformOriginProp]) {
                style[$0cdfc2eaac330c87$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $0cdfc2eaac330c87$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $0cdfc2eaac330c87$var$_revertStyle,
        save: $0cdfc2eaac330c87$var$_saveStyle
    };
    target._gsap || (0, $2Tywo.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && properties.split(",").forEach(function(p) {
        return saver.save(p);
    });
    return saver;
}, $0cdfc2eaac330c87$var$_supports3D, $0cdfc2eaac330c87$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $0cdfc2eaac330c87$var$_doc.createElementNS ? $0cdfc2eaac330c87$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $0cdfc2eaac330c87$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $0cdfc2eaac330c87$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $0cdfc2eaac330c87$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($0cdfc2eaac330c87$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $0cdfc2eaac330c87$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $0cdfc2eaac330c87$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $0cdfc2eaac330c87$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $0cdfc2eaac330c87$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($0cdfc2eaac330c87$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $0cdfc2eaac330c87$var$_prefixes[i] : "") + property;
}, $0cdfc2eaac330c87$var$_initCore = function _initCore() {
    if ($0cdfc2eaac330c87$var$_windowExists() && window.document) {
        $0cdfc2eaac330c87$var$_win = window;
        $0cdfc2eaac330c87$var$_doc = $0cdfc2eaac330c87$var$_win.document;
        $0cdfc2eaac330c87$var$_docElement = $0cdfc2eaac330c87$var$_doc.documentElement;
        $0cdfc2eaac330c87$var$_tempDiv = $0cdfc2eaac330c87$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $0cdfc2eaac330c87$var$_tempDivStyler = $0cdfc2eaac330c87$export$a232bb0480ae674a("div");
        $0cdfc2eaac330c87$var$_transformProp = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b($0cdfc2eaac330c87$var$_transformProp);
        $0cdfc2eaac330c87$var$_transformOriginProp = $0cdfc2eaac330c87$var$_transformProp + "Origin";
        $0cdfc2eaac330c87$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $0cdfc2eaac330c87$var$_supports3D = !!$0cdfc2eaac330c87$export$8cbef5dd49a09c8b("perspective");
        $0cdfc2eaac330c87$var$_reverting = (0, $2Tywo.gsap).core.reverting;
        $0cdfc2eaac330c87$var$_pluginInitted = 1;
    }
}, $0cdfc2eaac330c87$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $0cdfc2eaac330c87$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $0cdfc2eaac330c87$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $0cdfc2eaac330c87$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $0cdfc2eaac330c87$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $0cdfc2eaac330c87$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $0cdfc2eaac330c87$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $0cdfc2eaac330c87$var$_getBBoxHack || (bounds = $0cdfc2eaac330c87$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$0cdfc2eaac330c87$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$0cdfc2eaac330c87$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $0cdfc2eaac330c87$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $0cdfc2eaac330c87$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$0cdfc2eaac330c87$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $0cdfc2eaac330c87$var$_transformProps && property !== $0cdfc2eaac330c87$var$_transformOriginProp) property = $0cdfc2eaac330c87$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($0cdfc2eaac330c87$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $0cdfc2eaac330c87$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $2Tywo.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $0cdfc2eaac330c87$var$_renderNonTweeningValueOnlyAtEnd : $0cdfc2eaac330c87$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $0cdfc2eaac330c87$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $0cdfc2eaac330c87$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$0cdfc2eaac330c87$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $0cdfc2eaac330c87$var$_tempDiv.style, horizontal = $0cdfc2eaac330c87$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $0cdfc2eaac330c87$var$_nonConvertibleUnits[unit] || $0cdfc2eaac330c87$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $0cdfc2eaac330c87$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($0cdfc2eaac330c87$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $2Tywo._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $0cdfc2eaac330c87$var$_doc || !parent.appendChild) parent = $0cdfc2eaac330c87$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $2Tywo._ticker).time && !cache.uncache) return (0, $2Tywo._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $0cdfc2eaac330c87$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$0cdfc2eaac330c87$var$_nonStandardLayouts[$0cdfc2eaac330c87$var$_getComputedProperty(parent, "display")] && (style.position = $0cdfc2eaac330c87$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($0cdfc2eaac330c87$var$_tempDiv);
            px = $0cdfc2eaac330c87$var$_tempDiv[measureProperty];
            parent.removeChild($0cdfc2eaac330c87$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $2Tywo._getCache)(parent);
            cache.time = (0, $2Tywo._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $2Tywo._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $0cdfc2eaac330c87$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $0cdfc2eaac330c87$var$_pluginInitted || $0cdfc2eaac330c87$var$_initCore();
    if (property in $0cdfc2eaac330c87$var$_propertyAliases && property !== "transform") {
        property = $0cdfc2eaac330c87$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($0cdfc2eaac330c87$var$_transformProps[property] && property !== "transform") {
        value = $0cdfc2eaac330c87$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $0cdfc2eaac330c87$var$_firstTwoOnly($0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $0cdfc2eaac330c87$var$_specialProps[property] && $0cdfc2eaac330c87$var$_specialProps[property](target, property, unit) || $0cdfc2eaac330c87$var$_getComputedProperty(target, property) || (0, $2Tywo._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $0cdfc2eaac330c87$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $0cdfc2eaac330c87$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $0cdfc2eaac330c87$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $0cdfc2eaac330c87$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $2Tywo.PropTween)(this._pt, target.style, prop, 0, 1, (0, $2Tywo._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $0cdfc2eaac330c87$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $0cdfc2eaac330c87$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $2Tywo._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $2Tywo._numWithUnitExp)) || [];
    endValues = end.match((0, $2Tywo._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $2Tywo._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $2Tywo._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $2Tywo._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $2Tywo._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $0cdfc2eaac330c87$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $0cdfc2eaac330c87$var$_renderNonTweeningValueOnlyAtEnd : $0cdfc2eaac330c87$var$_renderNonTweeningValue;
    (0, $2Tywo._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $0cdfc2eaac330c87$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $0cdfc2eaac330c87$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $0cdfc2eaac330c87$var$_keywordToPercent[x] || x;
    split[1] = $0cdfc2eaac330c87$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $0cdfc2eaac330c87$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($0cdfc2eaac330c87$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $0cdfc2eaac330c87$var$_transformOriginProp : $0cdfc2eaac330c87$var$_transformProp;
                }
                $0cdfc2eaac330c87$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $0cdfc2eaac330c87$var$_removeProperty(target, $0cdfc2eaac330c87$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $0cdfc2eaac330c87$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $0cdfc2eaac330c87$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$0cdfc2eaac330c87$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $2Tywo.PropTween)(plugin._pt, target, property, 0, 0, $0cdfc2eaac330c87$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $0cdfc2eaac330c87$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $0cdfc2eaac330c87$var$_rotationalProperties = {}, $0cdfc2eaac330c87$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $0cdfc2eaac330c87$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformProp);
    return $0cdfc2eaac330c87$var$_isNullTransform(matrixString) ? $0cdfc2eaac330c87$var$_identity2DMatrix : matrixString.substr(7).match((0, $2Tywo._numExp)).map((0, $2Tywo._round));
}, $0cdfc2eaac330c87$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $2Tywo._getCache)(target), style = target.style, matrix = $0cdfc2eaac330c87$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $0cdfc2eaac330c87$var$_identity2DMatrix : matrix;
    } else if (matrix === $0cdfc2eaac330c87$var$_identity2DMatrix && !target.offsetParent && target !== $0cdfc2eaac330c87$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $0cdfc2eaac330c87$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $0cdfc2eaac330c87$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $0cdfc2eaac330c87$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $0cdfc2eaac330c87$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $0cdfc2eaac330c87$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $0cdfc2eaac330c87$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $0cdfc2eaac330c87$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $0cdfc2eaac330c87$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$0cdfc2eaac330c87$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $0cdfc2eaac330c87$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $2Tywo.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $0cdfc2eaac330c87$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$0cdfc2eaac330c87$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$0cdfc2eaac330c87$var$_transformProp] !== "none" ? cs[$0cdfc2eaac330c87$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $0cdfc2eaac330c87$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $0cdfc2eaac330c87$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $0cdfc2eaac330c87$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $0cdfc2eaac330c87$var$_atan2(b, a) * $0cdfc2eaac330c87$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $0cdfc2eaac330c87$var$_atan2(c, d) * $0cdfc2eaac330c87$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $0cdfc2eaac330c87$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $0cdfc2eaac330c87$var$_atan2(a32, a33);
            rotationX = angle * $0cdfc2eaac330c87$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $0cdfc2eaac330c87$var$_atan2(-c, a33);
            rotationY = angle * $0cdfc2eaac330c87$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $0cdfc2eaac330c87$var$_atan2(b, a);
            rotation = angle * $0cdfc2eaac330c87$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $2Tywo._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $2Tywo._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $0cdfc2eaac330c87$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $0cdfc2eaac330c87$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$0cdfc2eaac330c87$var$_isNullTransform($0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $2Tywo._round)(scaleX);
    cache.scaleY = (0, $2Tywo._round)(scaleY);
    cache.rotation = (0, $2Tywo._round)(rotation) + deg;
    cache.rotationX = (0, $2Tywo._round)(rotationX) + deg;
    cache.rotationY = (0, $2Tywo._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$0cdfc2eaac330c87$var$_transformOriginProp] = $0cdfc2eaac330c87$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $2Tywo._config).force3D;
    cache.renderTransform = cache.svg ? $0cdfc2eaac330c87$var$_renderSVGTransforms : $0cdfc2eaac330c87$var$_supports3D ? $0cdfc2eaac330c87$var$_renderCSSTransforms : $0cdfc2eaac330c87$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $0cdfc2eaac330c87$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$0cdfc2eaac330c87$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $2Tywo.getUnit)(start);
    return (0, $2Tywo._round)(parseFloat(start) + parseFloat($0cdfc2eaac330c87$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $0cdfc2eaac330c87$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $0cdfc2eaac330c87$var$_renderCSSTransforms(ratio, cache);
}, $0cdfc2eaac330c87$var$_zeroDeg = "0deg", $0cdfc2eaac330c87$var$_zeroPx = "0px", $0cdfc2eaac330c87$var$_endParenthesis = ") ", $0cdfc2eaac330c87$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $0cdfc2eaac330c87$var$_zeroDeg || rotationY !== $0cdfc2eaac330c87$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $0cdfc2eaac330c87$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $0cdfc2eaac330c87$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $0cdfc2eaac330c87$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $0cdfc2eaac330c87$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $0cdfc2eaac330c87$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $0cdfc2eaac330c87$var$_zeroPx) transforms += "perspective(" + transformPerspective + $0cdfc2eaac330c87$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $0cdfc2eaac330c87$var$_zeroPx || y !== $0cdfc2eaac330c87$var$_zeroPx || z !== $0cdfc2eaac330c87$var$_zeroPx) transforms += z !== $0cdfc2eaac330c87$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $0cdfc2eaac330c87$var$_endParenthesis;
    if (rotation !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "rotate(" + rotation + $0cdfc2eaac330c87$var$_endParenthesis;
    if (rotationY !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "rotateY(" + rotationY + $0cdfc2eaac330c87$var$_endParenthesis;
    if (rotationX !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "rotateX(" + rotationX + $0cdfc2eaac330c87$var$_endParenthesis;
    if (skewX !== $0cdfc2eaac330c87$var$_zeroDeg || skewY !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $0cdfc2eaac330c87$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $0cdfc2eaac330c87$var$_endParenthesis;
    target.style[$0cdfc2eaac330c87$var$_transformProp] = transforms || "translate(0, 0)";
}, $0cdfc2eaac330c87$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $0cdfc2eaac330c87$var$_DEG2RAD;
        skewX *= $0cdfc2eaac330c87$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $0cdfc2eaac330c87$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $2Tywo._round)(a11);
        a21 = (0, $2Tywo._round)(a21);
        a12 = (0, $2Tywo._round)(a12);
        a22 = (0, $2Tywo._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $0cdfc2eaac330c87$var$_convertToUnit(target, "x", x, "px");
        ty = $0cdfc2eaac330c87$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $2Tywo._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $2Tywo._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $2Tywo._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $2Tywo._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$0cdfc2eaac330c87$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $0cdfc2eaac330c87$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $2Tywo._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $0cdfc2eaac330c87$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $0cdfc2eaac330c87$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $0cdfc2eaac330c87$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $2Tywo.PropTween)(plugin._pt, target, property, startNum, change, $0cdfc2eaac330c87$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $0cdfc2eaac330c87$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $0cdfc2eaac330c87$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $0cdfc2eaac330c87$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$0cdfc2eaac330c87$var$_transformProp] = transforms;
        endCache = $0cdfc2eaac330c87$var$_parseTransform(target, 1);
        $0cdfc2eaac330c87$var$_removeProperty(target, $0cdfc2eaac330c87$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$0cdfc2eaac330c87$var$_transformProp];
        style[$0cdfc2eaac330c87$var$_transformProp] = transforms;
        endCache = $0cdfc2eaac330c87$var$_parseTransform(target, 1);
        style[$0cdfc2eaac330c87$var$_transformProp] = startValue;
    }
    for(p in $0cdfc2eaac330c87$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $2Tywo.getUnit)(startValue);
            endUnit = (0, $2Tywo.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $0cdfc2eaac330c87$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $2Tywo.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $0cdfc2eaac330c87$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $0cdfc2eaac330c87$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $2Tywo._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $0cdfc2eaac330c87$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $0cdfc2eaac330c87$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $0cdfc2eaac330c87$export$855822f522f18eef = {
    name: "css",
    register: $0cdfc2eaac330c87$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $0cdfc2eaac330c87$var$_pluginInitted || $0cdfc2eaac330c87$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $0cdfc2eaac330c87$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $2Tywo._plugins)[p] && (0, $2Tywo._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $0cdfc2eaac330c87$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $2Tywo._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $2Tywo._colorExp).lastIndex = 0;
                if (!(0, $2Tywo._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $2Tywo.getUnit)(startValue);
                    endUnit = (0, $2Tywo.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $0cdfc2eaac330c87$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $2Tywo._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $2Tywo._replaceRandom)(startValue));
                    (0, $2Tywo.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $2Tywo._config).units[p] || (0, $2Tywo.getUnit)($0cdfc2eaac330c87$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $0cdfc2eaac330c87$var$_get(target, p)); // can't work with relative values
                } else startValue = $0cdfc2eaac330c87$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $0cdfc2eaac330c87$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $0cdfc2eaac330c87$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $0cdfc2eaac330c87$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $0cdfc2eaac330c87$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $0cdfc2eaac330c87$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $0cdfc2eaac330c87$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $2Tywo.PropTween)(this._pt, style, $0cdfc2eaac330c87$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $2Tywo.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $2Tywo._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $0cdfc2eaac330c87$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($0cdfc2eaac330c87$var$_transformOriginProp, 0, style[$0cdfc2eaac330c87$var$_transformOriginProp]);
                        endValue = $0cdfc2eaac330c87$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $0cdfc2eaac330c87$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $0cdfc2eaac330c87$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $0cdfc2eaac330c87$var$_addNonTweeningPT(this, style, p, $0cdfc2eaac330c87$var$_firstTwoOnly(startValue), $0cdfc2eaac330c87$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $0cdfc2eaac330c87$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $0cdfc2eaac330c87$var$_rotationalProperties) {
                        $0cdfc2eaac330c87$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $2Tywo._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $0cdfc2eaac330c87$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $0cdfc2eaac330c87$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$0cdfc2eaac330c87$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $2Tywo.getUnit)(endValue) || (p in (0, $2Tywo._config).units ? (0, $2Tywo._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $0cdfc2eaac330c87$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $2Tywo.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $2Tywo._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $0cdfc2eaac330c87$var$_renderRoundedCSSProp : $0cdfc2eaac330c87$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $0cdfc2eaac330c87$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $2Tywo._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $0cdfc2eaac330c87$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $2Tywo._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$0cdfc2eaac330c87$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $0cdfc2eaac330c87$var$_get,
    aliases: $0cdfc2eaac330c87$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $0cdfc2eaac330c87$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $0cdfc2eaac330c87$var$_transformProps && property !== $0cdfc2eaac330c87$var$_transformOriginProp && (target._gsap.x || $0cdfc2eaac330c87$var$_get(target, "x")) ? plugin && $0cdfc2eaac330c87$var$_recentSetterPlugin === plugin ? property === "scale" ? $0cdfc2eaac330c87$var$_setterScale : $0cdfc2eaac330c87$var$_setterTransform : ($0cdfc2eaac330c87$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $0cdfc2eaac330c87$var$_setterScaleWithRender : $0cdfc2eaac330c87$var$_setterTransformWithRender) : target.style && !(0, $2Tywo._isUndefined)(target.style[property]) ? $0cdfc2eaac330c87$var$_setterCSSStyle : ~property.indexOf("-") ? $0cdfc2eaac330c87$var$_setterCSSProp : (0, $2Tywo._getSetter)(target, property);
    },
    core: {
        _removeProperty: $0cdfc2eaac330c87$var$_removeProperty,
        _getMatrix: $0cdfc2eaac330c87$var$_getMatrix
    }
};
(0, $2Tywo.gsap).utils.checkPrefix = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b;
(0, $2Tywo.gsap).core.getStyleSaver = $0cdfc2eaac330c87$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $2Tywo._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $0cdfc2eaac330c87$var$_transformProps[name] = 1;
    });
    (0, $2Tywo._forEachName)(rotation, function(name) {
        (0, $2Tywo._config).units[name] = "deg";
        $0cdfc2eaac330c87$var$_rotationalProperties[name] = 1;
    });
    $0cdfc2eaac330c87$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $2Tywo._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $0cdfc2eaac330c87$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $2Tywo._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $2Tywo._config).units[name] = "px";
});
(0, $2Tywo.gsap).registerPlugin($0cdfc2eaac330c87$export$855822f522f18eef);


var $357b3f2d5f2ec9d5$export$99ee26438460406a = (0, $2Tywo.gsap).registerPlugin((0, $0cdfc2eaac330c87$export$855822f522f18eef)) || (0, $2Tywo.gsap), // to protect from tree shaking
$357b3f2d5f2ec9d5$export$7b23975ad686bf91 = $357b3f2d5f2ec9d5$export$99ee26438460406a.core.Tween;


"use strict";
class $bcb281589db0dd07$export$a61c93f32abb920f {
    // Object to hold references to DOM elements associated with the tooltip
    DOM = {
        // eslint-disable-line
        el: null,
        bg: null,
        cells: null // The individual cell elements that make up the background
    };
    element;
    Logo;
    rows;
    cols;
    isOpen = false // State flag indicating whether the tooltip is open
    ;
    tl;
    /**
   * Creates an instance of Tooltip.
   * @param {HTMLElement} DOM_el - The main DOM element for the tooltip.
   */ constructor(element){
        // Initialize DOM references
        this.element = element;
        this.Logo = element.Logo;
        this.Grid = element.Grid;
        // Read rows and columns from data attributes or default to 4
        const data = element.data;
        this.rows = data.rows || 4;
        this.cols = data.cols || 4;
        // Create the grid layout for the tooltip background
        this.#layout();
    }
    /**
   * Calculates the optimal tooltip position based on the event's coordinates.
   * @param {MouseEvent} event - The mouse event that triggers tooltip positioning.
   * @returns {Object} The calculated position for the tooltip.
   */ calculateTooltipPosition(event) {
        // Get the mouse position from the event
        const { clientX: clientX, clientY: clientY } = event;
        // Get the scroll position of the page
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        // Get the viewport dimensions
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        // Assuming the tooltip element is available in the scope, get its dimensions
        const tooltipWidth = this.element.node.offsetWidth;
        const tooltipHeight = this.element.node.offsetHeight;
        // Initialize the position object with the mouse coordinates plus the scroll offset
        let position = {
            left: 0,
            top: 0
        };
        // Adjust the left position if the tooltip goes beyond the right edge of the viewport
        if (clientX + tooltipWidth > viewportWidth) position.left = clientX - tooltipWidth + scrollLeft;
        // Adjust the top position if the tooltip goes beyond the bottom edge of the viewport
        if (clientY + tooltipHeight > viewportHeight) position.top = clientY - tooltipHeight + scrollTop;
        // Adjust the left position if the tooltip goes beyond the left edge of the viewport
        if (position.left < scrollLeft) position.left = scrollLeft;
        // Adjust the top position if the tooltip goes beyond the top edge of the viewport
        if (position.top < scrollTop) position.top = scrollTop;
        return position;
    }
    /**
   * Creates the grid layout for the tooltip's background.
   * @private
   */ #layout() {
        let strHTML = "";
        // Create the grid of cells as a string
        for(let row = 0; row < this.rows; row++)for(let col = 0; col < this.cols; col++)// Add a div for each cell to the string
        strHTML += "<div></div>";
        // Set the innerHTML of the background element in one operation
        this.Grid.node.innerHTML = strHTML;
        // Set the CSS variables on the tooltip element
        this.element.node.style.setProperty("--tt-columns", this.cols);
        this.element.node.style.setProperty("--tt-rows", this.rows);
        this.DOM.cells = [
            ...this.Grid.node.querySelectorAll("div")
        ];
    }
    /**
   * Toggles the tooltip's visibility and triggers the animation effect.
   * @param {string} effectType - The type of animation effect to apply.
   * @param {MouseEvent} event - The mouse event associated with the toggle action.
   */ toggle(effectType, event) {
        // Toggle the state
        this.isOpen = !this.isOpen;
        // Logic to close the tooltip
        // This would be the reverse of the open animation
        this.#animateCells(effectType, event);
    }
    /**
   * Animates the tooltip cells based on the specified effect type.
   * @private
   * @param {string} effectType - The type of animation effect to apply.
   * @param {MouseEvent} event - The mouse event associated with the animation.
   */ #animateCells(effectType, event) {
        // Determine the animation based on effectType
        // Construct the method name based on the effectType
        const methodName = `animate${effectType.charAt(0).toUpperCase() + effectType.slice(1)}`;
        // Check if the method exists
        if (typeof this[methodName] === "function") // Call the dynamically determined method
        this[methodName](event);
        else // Handle the case where the method does not exist
        console.warn(`Animation effect '${effectType}' is not defined.`);
    }
    /**
   * Creates a default GSAP timeline for animations, with optional parameters to override defaults.
   * @param {Object} [options={}] - Optional parameters to override default timeline settings.
   * @param {number} [options.duration=0.1] - Duration of the animation.
   * @param {string} [options.ease='expo'] - Easing function for the animation.
   * @returns {GSAPTimeline} The GSAP timeline object for animations.
   */ createDefaultTimeline({ duration: duration = 0.1, ease: ease = "expo" } = {}) {
        if (this.tl) this.tl.kill();
        return (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).timeline({
            defaults: {
                duration: duration,
                ease: ease // use the ease passed in, or default to 'expo'
            }
        });
    }
    /**
   * Specific animation effects applied to the tooltip cells and content
   */ animateEffect1(event) {
        // this.tl = this.createDefaultTimeline()
        this.tl = this.createDefaultTimeline({
            duration: 0.1,
            ease: "ease-out"
        });
        // Get the mouse position from the event
        const mousePosition = {
            x: event.clientX,
            y: event.clientY
        };
        // Calculate the maximum distance as the diagonal of the page
        const pageWidth = document.documentElement.scrollWidth;
        const pageHeight = document.documentElement.scrollHeight;
        const maximumDistance = Math.sqrt(pageWidth * pageWidth + pageHeight * pageHeight);
        // Define the maximum delay you want to apply to any cell
        const maximumDelay = 0.5;
        // Calculate the delay for each cell based on its distance from the mouse position
        // this.DOM.cells.forEach(cell => {
        for(let i = 0; i < this.rows * this.cols; i++){
            // Get the position of the cell
            const cell = this.DOM.cells[i];
            const cellRect = cell.getBoundingClientRect();
            const cellPosition = {
                x: cellRect.left,
                y: cellRect.top
            };
            // Calculate the distance from the cell to the mouse position
            const distance = Math.sqrt(Math.pow(cellPosition.x - mousePosition.x, 2) + Math.pow(cellPosition.y - mousePosition.y, 2));
            // Convert distance to a delay, for example by inverting and scaling the distance
            // This is where you can get creative with how the distance affects the delay
            const delay = distance / maximumDistance * maximumDelay;
            // Apply the animation with the calculated delay
            if (this.isOpen) this.tl.fromTo(cell, {
                opacity: 0
            }, {
                opacity: 1,
                delay: delay // Use the calculated delay here
            }, 0);
            else this.tl.to(cell, {
                opacity: 0,
                delay: delay // Use the calculated delay here
            }, 0);
        }
    // });
    }
    /**
   * Specific animation effects applied to the tooltip cells and content
   */ animateEffect2() {
        this.tl = this.createDefaultTimeline();
        if (this.isOpen) this.tl.fromTo(this.DOM.cells, {
            opacity: 0,
            scale: 0
        }, {
            opacity: 1,
            scale: 1,
            stagger: {
                each: 0.02,
                from: "start"
            }
        }, 0);
        else this.tl.to(this.DOM.cells, {
            opacity: 0,
            scale: 0,
            stagger: {
                each: 0.02,
                from: "end"
            }
        }, 0);
    }
    /**
   * Specific animation effects applied to the tooltip cells and content
   */ animateEffect3() {
        this.tl = this.createDefaultTimeline();
        if (this.isOpen) this.tl.fromTo(this.DOM.cells, {
            opacity: 0,
            scale: 0,
            yPercent: ()=>(0, $357b3f2d5f2ec9d5$export$99ee26438460406a).utils.random(-200, 200)
        }, {
            opacity: 1,
            scale: 1,
            yPercent: 0,
            stagger: {
                each: 0.03,
                from: "center",
                grid: "auto"
            }
        }, 0);
        else this.tl.to(this.DOM.cells, {
            opacity: 0,
            scale: 0,
            yPercent: ()=>(0, $357b3f2d5f2ec9d5$export$99ee26438460406a).utils.random(-200, 200),
            stagger: {
                each: 0.03,
                from: "center",
                grid: "auto"
            }
        }, 0);
    }
    /**
   * Specific animation effects applied to the tooltip cells and content
   */ animateEffect4() {
        this.tl = this.createDefaultTimeline();
        if (this.isOpen) this.tl.fromTo(this.DOM.cells, {
            opacity: 0,
            scaleX: 0.8,
            xPercent: ()=>(0, $357b3f2d5f2ec9d5$export$99ee26438460406a).utils.random(-200, 200)
        }, {
            opacity: 1,
            scaleX: 1,
            xPercent: 0,
            stagger: {
                each: 0.02,
                from: "random",
                grid: "auto"
            }
        }, 0);
        else this.tl.to(this.DOM.cells, {
            opacity: 0,
            scaleX: 0.8,
            xPercent: ()=>(0, $357b3f2d5f2ec9d5$export$99ee26438460406a).utils.random(-200, 200),
            stagger: {
                each: 0.02,
                from: "random",
                grid: "auto"
            }
        }, 0);
    }
    /**
   * Specific animation effects applied to the tooltip cells and content
   */ animateEffect5() {
        this.tl = this.createDefaultTimeline();
        if (this.isOpen) this.tl.fromTo(this.DOM.cells, {
            opacity: 0,
            scale: 0
        }, {
            opacity: 1,
            scale: 1,
            stagger: {
                each: 0.02,
                from: "center",
                grid: "auto"
            }
        }, 0);
        else this.tl.to(this.DOM.cells, {
            opacity: 0,
            scale: 0,
            stagger: {
                each: 0.02,
                from: "edges",
                grid: "auto"
            }
        }, 0);
    }
    /**
   * Applies a gooey animation effect to the tooltip cells and animates the content.
   * @param {MouseEvent} event - The mouse event associated with the animation.
   */ animateEffect6() {
        this.Grid.node.style.filter = "url(#gooey)";
        this.tl = this.createDefaultTimeline({
            duration: 0.15,
            ease: "expo"
        });
        if (this.isOpen) this.tl.fromTo(this.DOM.cells, {
            opacity: 0,
            scale: 0.3
        }, {
            opacity: 1,
            scale: 1,
            stagger: {
                each: 0.08,
                from: "random",
                grid: "auto"
            }
        }, 0);
        else this.tl.to(this.DOM.cells, {
            opacity: 0,
            scale: 0.3,
            stagger: {
                each: 0.04,
                from: "random",
                grid: "auto"
            }
        }, 0);
    }
}


"use strict";
const $1d2e473525dfc7f2$var$rows = 16;
const $1d2e473525dfc7f2$var$cols = 12;
const $1d2e473525dfc7f2$var$startColor = {
    r: 25,
    g: 25,
    b: 25
};
const $1d2e473525dfc7f2$var$endColor = {
    r: 255,
    g: 255,
    b: 255
};
const $1d2e473525dfc7f2$var$generateGradientMatrix = (rows, cols, startColor, endColor)=>{
    const matrix = [];
    for(let i = 0; i < rows; i++)for(let j = 0; j < cols; j++){
        const ratioStart = (i * cols + j) / (rows * cols);
        const ratioEnd = (i * cols + j + 1) / (rows * cols);
        const colorStart = $1d2e473525dfc7f2$var$interpolateColor(startColor, endColor, ratioStart);
        const colorEnd = $1d2e473525dfc7f2$var$interpolateColor(startColor, endColor, ratioEnd);
        matrix.push({
            start: colorStart,
            end: colorEnd
        });
    }
    return matrix;
};
const $1d2e473525dfc7f2$var$interpolateColor = (color1, color2, ratio)=>{
    const r = Math.round(color1.r + (color2.r - color1.r) * ratio);
    const g = Math.round(color1.g + (color2.g - color1.g) * ratio);
    const b = Math.round(color1.b + (color2.b - color1.b) * ratio);
    return {
        r: r,
        g: g,
        b: b
    };
};
const $1d2e473525dfc7f2$var$rgbToCss = ({ r: r, g: g, b: b })=>{
    return `rgb(${r}, ${g}, ${b})`;
};
const $1d2e473525dfc7f2$var$gradientMatrix = $1d2e473525dfc7f2$var$generateGradientMatrix($1d2e473525dfc7f2$var$rows, $1d2e473525dfc7f2$var$cols, $1d2e473525dfc7f2$var$startColor, $1d2e473525dfc7f2$var$endColor);
const $1d2e473525dfc7f2$var$GridMatrix = new Array($1d2e473525dfc7f2$var$cols * $1d2e473525dfc7f2$var$rows).fill(0).reduce((acc, _, i)=>{
    const color = $1d2e473525dfc7f2$var$gradientMatrix[i];
    acc[`:nth-child(${i + 1})`] = {
        background: `linear-gradient(to right, ${$1d2e473525dfc7f2$var$rgbToCss(color.start)} , ${$1d2e473525dfc7f2$var$rgbToCss(color.end)})`
    };
    return acc;
}, {});
const $1d2e473525dfc7f2$export$be58926105124dd4 = {
    props: {
        position: "fixed",
        top: "0",
        left: "0",
        boxSize: "100%",
        pointerEvents: "none",
        zIndex: 5,
        opacity: 1
    },
    data: {
        showOnNode: true,
        cols: $1d2e473525dfc7f2$var$cols,
        rows: $1d2e473525dfc7f2$var$rows
    },
    on: {
        render: (el, s)=>{
            s.transition = new (0, $bcb281589db0dd07$export$a61c93f32abb920f)(el);
        }
    },
    Logo: {
        position: "absolute",
        fontSize: "3.5vmin",
        top: "50%",
        left: "50%",
        transform: "translate3d(-50%, -50%, 1px)",
        filter: "shadow(0 0 0 10px var(--color-charm))",
        color: "transparent"
    },
    Grid: {
        boxSize: "100%",
        templateColumns: "repeat(var(--tt-columns), 1fr)",
        templateRows: "repeat(var(--tt-rows), 1fr)",
        opacity: 1,
        "& div": {
            opacity: "0",
            // color: 'charm',
            // backgroundColor: 'currentColor',
            // boxShadow: '0 0 0 2px currentColor',
            ...$1d2e473525dfc7f2$var$GridMatrix
        }
    }
};
const $1d2e473525dfc7f2$export$aeb57bebb92c49ec = {
    on: {
        click: (ev, el, s)=>{
            const transition = s.transition;
            const Logo = el.__ref.__root.Transition.Logo;
            transition.toggle("effect1", ev);
            setTimeout(()=>{
                transition.toggle("effect1", ev);
            }, 450);
            setTimeout(()=>{
                Logo.setProps({
                    color: "dark .85"
                });
            }, 100);
            setTimeout(()=>{
                Logo.setProps({
                    color: "transparent"
                });
            }, 650);
            setTimeout(()=>{
                (0, $59e9b7f5a8955db9$export$a6c7ac8248d6e38a).on.click(ev, el, s);
            }, 420);
        }
    }
};


var $ef0ca6b97a81452e$exports = {};

$parcel$export($ef0ca6b97a81452e$exports, "Page", () => $ef0ca6b97a81452e$export$6955bcca4cd3539f);
$parcel$export($ef0ca6b97a81452e$exports, "Divider", () => $ef0ca6b97a81452e$export$2e0a83ec2e27ecbb);
"use strict";
const $ef0ca6b97a81452e$export$6955bcca4cd3539f = {
    extend: "Flex",
    props: {
        flow: "column",
        boxSize: "100%",
        padding: "C1 C1 D1",
        align: "center space-between"
    }
};
const $ef0ca6b97a81452e$export$2e0a83ec2e27ecbb = {
    props: {
        ":before": {
            content: '"..."',
            display: "inline-block",
            margin: "B1",
            opacity: ".35",
            position: "relative"
        }
    }
};


var $664f79cf6a97be87$exports = {};

$parcel$export($664f79cf6a97be87$exports, "Logo", () => $664f79cf6a97be87$export$e6ff31bff12b7ff4);

"use strict";
const $664f79cf6a97be87$export$e6ff31bff12b7ff4 = {
    extend: [
        (0, $1d2e473525dfc7f2$export$aeb57bebb92c49ec)
    ],
    props: {
        href: "/",
        color: "charm",
        zIndex: "3"
    },
    Icon: {
        icon: "staub",
        fontSize: "I3"
    }
};


var $5437dddba42655e6$exports = {};

$parcel$export($5437dddba42655e6$exports, "Navigation", () => $5437dddba42655e6$export$b8a61e5c71402559);


"use strict";
const $5437dddba42655e6$export$b8a61e5c71402559 = {
    extend: [
        (0, $1d2e473525dfc7f2$export$aeb57bebb92c49ec),
        "Flex"
    ],
    props: ()=>{
        let location = window.location.pathname.split("/")[1];
        let fontFamily = "ui";
        if (location == "controller") {
            fontFamily = "game";
            console.log("controller");
        }
        return {
            gap: "D3",
            zIndex: 2,
            pointerEvents: "none",
            order: 3,
            padding: "C1",
            fontFamily: fontFamily
        };
    },
    childExtend: {
        props: {
            color: "charm",
            fontWeight: "300",
            letterSpacing: "3px",
            pointerEvents: "auto"
        },
        on: {
            click: (ev, el, s)=>{
                setTimeout(()=>{
                    (0, $59e9b7f5a8955db9$export$a6c7ac8248d6e38a).on.click(ev, el, s);
                }, 250);
            }
        }
    },
    $collection: [
        {
            props: {
                text: "Home",
                href: "/"
            }
        },
        // {
        //   props: {
        //     text: 'Controller',
        //     href: '/controller'
        //   }
        // },
        {
            props: {
                text: "Events",
                href: "/events"
            }
        },
        {
            props: {
                text: "About",
                href: "/about"
            }
        },
        {
            props: {
                text: "Contact",
                href: "/contact"
            }
        }
    ]
};


var $3df07944bfa6aab3$exports = {};

$parcel$export($3df07944bfa6aab3$exports, "Header", () => $3df07944bfa6aab3$export$8b251419efc915eb);
"use strict";
const $3df07944bfa6aab3$export$8b251419efc915eb = {
    extend: "Flex",
    props: {
        gap: "C1",
        padding: "B C1",
        width: "100%"
    }
};


var $3f1fb52ab2bebfc0$exports = {};

$parcel$export($3f1fb52ab2bebfc0$exports, "Loading", () => $3f1fb52ab2bebfc0$export$669f6ea7d267feaf);
"use strict";
const $3f1fb52ab2bebfc0$export$669f6ea7d267feaf = {
    extend: "Flex",
    props: {
        position: "absolute",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        top: "50%",
        left: "50%",
        transform: "translate3d(-50%, -50%, 1px)",
        fontSize: "A2",
        backgroundColor: "charm",
        opacity: 1,
        zIndex: 10
    },
    Loader: {
        text: "Loading..."
    }
};


var $12cecb1d1ea15958$exports = {};

$parcel$export($12cecb1d1ea15958$exports, "Pacman", () => $12cecb1d1ea15958$export$d9bf50261c442177);
$parcel$export($12cecb1d1ea15958$exports, "Pinky", () => $12cecb1d1ea15958$export$862b723e2adc9960);
$parcel$export($12cecb1d1ea15958$exports, "Clyde", () => $12cecb1d1ea15958$export$ae4a364a1512d773);
$parcel$export($12cecb1d1ea15958$exports, "Blinky", () => $12cecb1d1ea15958$export$870dde75fff1da8f);
$parcel$export($12cecb1d1ea15958$exports, "BlinkyAngry", () => $12cecb1d1ea15958$export$bc64783784265a85);
$parcel$export($12cecb1d1ea15958$exports, "BlinkyAnnoyed", () => $12cecb1d1ea15958$export$bcdd9a8d69f6647c);
$parcel$export($12cecb1d1ea15958$exports, "Inky", () => $12cecb1d1ea15958$export$fb185367fe67580b);
$parcel$export($12cecb1d1ea15958$exports, "Scared", () => $12cecb1d1ea15958$export$b3d2eb68ec29efae);
$parcel$export($12cecb1d1ea15958$exports, "Cherry", () => $12cecb1d1ea15958$export$e0c62b5cdc73b9f);
$parcel$export($12cecb1d1ea15958$exports, "Bell", () => $12cecb1d1ea15958$export$84dc348f90a995ec);
$parcel$export($12cecb1d1ea15958$exports, "Key", () => $12cecb1d1ea15958$export$cd0f44441c3b7719);
$parcel$export($12cecb1d1ea15958$exports, "Galaxian", () => $12cecb1d1ea15958$export$1d8f89b05d18ad33);
$parcel$export($12cecb1d1ea15958$exports, "Apple", () => $12cecb1d1ea15958$export$e3fccb5d29105673);
$parcel$export($12cecb1d1ea15958$exports, "Melon", () => $12cecb1d1ea15958$export$15db1777d3075b6b);
$parcel$export($12cecb1d1ea15958$exports, "Orange", () => $12cecb1d1ea15958$export$a8e2843f0fe527f4);
$parcel$export($12cecb1d1ea15958$exports, "Strawberry", () => $12cecb1d1ea15958$export$e253430465890a3);
"use strict";
var $a5cacf6f0471b791$exports = {};
$a5cacf6f0471b791$exports = new URL("pacman.092c98c2.svg", import.meta.url).toString();


const $12cecb1d1ea15958$var$pacmanSvg = new URL($a5cacf6f0471b791$exports);
const $12cecb1d1ea15958$export$d9bf50261c442177 = {
    props: {
        backgroundColor: "none",
        backgroundImage: $12cecb1d1ea15958$var$pacmanSvg.toString(),
        backgroundSize: "160px",
        backgroundPosition: "40px 0",
        width: "40px",
        height: "40px",
        borderRadius: "0",
        transform: "translateX(-20px)",
        ".playing": {
            animation: "pacman",
            animationDuration: "350ms",
            animationIterationCount: "infinite"
        }
    }
};
var $0f9cbd9032311c6b$exports = {};
$0f9cbd9032311c6b$exports = new URL("pinky_right.67d07641.svg", import.meta.url).toString();


const $12cecb1d1ea15958$var$pinkySvg = new URL($0f9cbd9032311c6b$exports);
const $12cecb1d1ea15958$export$862b723e2adc9960 = {
    props: ({ key: key })=>({
            backgroundColor: "none",
            backgroundImage: $12cecb1d1ea15958$var$pinkySvg.toString(),
            backgroundSize: "76px",
            backgroundPosition: "76px 0",
            width: "38px",
            height: "38px",
            borderRadius: "0",
            position: "relative",
            id: key.split(".")[1],
            cursor: "pointer",
            "&.active, &.recording": {
                animation: "pinky",
                animationDuration: "350ms",
                animationIterationCount: "infinite"
            }
        }),
    Text: ({ key: key })=>({
            position: "absolute",
            top: "110%",
            left: "50%",
            textAlign: "center",
            width: "200%",
            whiteSpace: "normal",
            transform: "translate3d(-50%, 0, 1px)",
            fontSize: "Y2",
            text: key.split(".")[1]
        })
};
var $e85d4e6439a47aa3$exports = {};
$e85d4e6439a47aa3$exports = new URL("clyde_up.51f3ac24.svg", import.meta.url).toString();


const $12cecb1d1ea15958$var$clydeSvg = new URL($e85d4e6439a47aa3$exports);
const $12cecb1d1ea15958$export$ae4a364a1512d773 = {
    extend: "Pinky",
    props: {
        backgroundImage: $12cecb1d1ea15958$var$clydeSvg.toString()
    }
};
var $f99c8eea3fa8247b$exports = {};
$f99c8eea3fa8247b$exports = new URL("blinky_right.a94dba6b.svg", import.meta.url).toString();


const $12cecb1d1ea15958$var$blinkySvg = new URL($f99c8eea3fa8247b$exports);
const $12cecb1d1ea15958$export$870dde75fff1da8f = {
    extend: "Pinky",
    props: {
        backgroundImage: $12cecb1d1ea15958$var$blinkySvg.toString()
    }
};
var $7a2cd24876582771$exports = {};
$7a2cd24876582771$exports = new URL("blinky_right_angry.96716aa1.svg", import.meta.url).toString();


const $12cecb1d1ea15958$var$blinkyAngry = new URL($7a2cd24876582771$exports);
const $12cecb1d1ea15958$export$bc64783784265a85 = {
    extend: "Pinky",
    props: {
        backgroundImage: $12cecb1d1ea15958$var$blinkyAngry.toString()
    }
};
var $54d8990f829f7c91$exports = {};
$54d8990f829f7c91$exports = new URL("blinky_up_annoyed.5c556501.svg", import.meta.url).toString();


const $12cecb1d1ea15958$var$blinkyAnnoyed = new URL($54d8990f829f7c91$exports);
const $12cecb1d1ea15958$export$bcdd9a8d69f6647c = {
    extend: "Pinky",
    props: {
        backgroundImage: $12cecb1d1ea15958$var$blinkyAnnoyed.toString()
    }
};
var $b415ad20e483881a$exports = {};
$b415ad20e483881a$exports = new URL("inky_down.3962f609.svg", import.meta.url).toString();


const $12cecb1d1ea15958$var$inkySvg = new URL($b415ad20e483881a$exports);
const $12cecb1d1ea15958$export$fb185367fe67580b = {
    extend: "Pinky",
    props: {
        backgroundImage: $12cecb1d1ea15958$var$inkySvg.toString()
    }
};
var $ebd25fc397625bda$exports = {};
$ebd25fc397625bda$exports = new URL("scared_blue.40ac03aa.svg", import.meta.url).toString();


const $12cecb1d1ea15958$var$scaredSvg = new URL($ebd25fc397625bda$exports);
const $12cecb1d1ea15958$export$b3d2eb68ec29efae = {
    extend: "Pinky",
    props: {
        backgroundImage: $12cecb1d1ea15958$var$scaredSvg.toString(),
        ".playing": {
            animation: "pinky",
            animationDuration: "350ms",
            animationIterationCount: "infinite"
        }
    }
};
var $3f64c57c2baa56ac$exports = {};
$3f64c57c2baa56ac$exports = new URL("cherry.afcba890.svg", import.meta.url).toString();


const $12cecb1d1ea15958$var$cherrySvg = new URL($3f64c57c2baa56ac$exports);
const $12cecb1d1ea15958$export$e0c62b5cdc73b9f = {
    extend: "Pinky",
    props: {
        backgroundColor: "none",
        backgroundSize: "38px",
        backgroundPosition: "0 0",
        backgroundImage: $12cecb1d1ea15958$var$cherrySvg.toString(),
        whiteSpace: "nowrap",
        "&.active, &.recording": {
            animation: "cherry",
            animationDuration: "350ms",
            animationIterationCount: "infinite"
        }
    }
};
var $7319b58e7b34e07e$exports = {};
$7319b58e7b34e07e$exports = new URL("bell.c0620b4e.svg", import.meta.url).toString();


const $12cecb1d1ea15958$var$bellSvg = new URL($7319b58e7b34e07e$exports);
const $12cecb1d1ea15958$export$84dc348f90a995ec = {
    extend: "Cherry",
    props: {
        backgroundImage: $12cecb1d1ea15958$var$bellSvg.toString()
    }
};
var $1bfc13210856dda2$exports = {};
$1bfc13210856dda2$exports = new URL("key.7d2f3fde.svg", import.meta.url).toString();


const $12cecb1d1ea15958$var$keySvg = new URL($1bfc13210856dda2$exports);
const $12cecb1d1ea15958$export$cd0f44441c3b7719 = {
    extend: "Cherry",
    props: {
        backgroundImage: $12cecb1d1ea15958$var$keySvg.toString()
    }
};
var $2491be06fb7013ce$exports = {};
$2491be06fb7013ce$exports = new URL("galaxian.6c8175db.svg", import.meta.url).toString();


const $12cecb1d1ea15958$var$galaxianSvg = new URL($2491be06fb7013ce$exports);
const $12cecb1d1ea15958$export$1d8f89b05d18ad33 = {
    extend: "Cherry",
    props: {
        backgroundImage: $12cecb1d1ea15958$var$galaxianSvg.toString()
    }
};
var $f085b7ff7bce90c2$exports = {};
$f085b7ff7bce90c2$exports = new URL("apple.f6c562b9.svg", import.meta.url).toString();


const $12cecb1d1ea15958$var$appleSvg = new URL($f085b7ff7bce90c2$exports);
const $12cecb1d1ea15958$export$e3fccb5d29105673 = {
    extend: "Cherry",
    props: {
        backgroundImage: $12cecb1d1ea15958$var$appleSvg.toString()
    }
};
var $96f4f4023c13c153$exports = {};
$96f4f4023c13c153$exports = new URL("melon.9ac31b74.svg", import.meta.url).toString();


const $12cecb1d1ea15958$var$melonSvg = new URL($96f4f4023c13c153$exports);
const $12cecb1d1ea15958$export$15db1777d3075b6b = {
    extend: "Cherry",
    props: {
        backgroundImage: $12cecb1d1ea15958$var$melonSvg.toString()
    }
};
var $8fb14c1d5790fefa$exports = {};
$8fb14c1d5790fefa$exports = new URL("orange.18984088.svg", import.meta.url).toString();


const $12cecb1d1ea15958$var$orangeSvg = new URL($8fb14c1d5790fefa$exports);
const $12cecb1d1ea15958$export$a8e2843f0fe527f4 = {
    extend: "Cherry",
    props: {
        backgroundImage: $12cecb1d1ea15958$var$orangeSvg.toString()
    }
};
var $db71e6f0776a605d$exports = {};
$db71e6f0776a605d$exports = new URL("strawberry.014f77aa.svg", import.meta.url).toString();


const $12cecb1d1ea15958$var$strawberrySvg = new URL($db71e6f0776a605d$exports);
const $12cecb1d1ea15958$export$e253430465890a3 = {
    extend: "Cherry",
    props: {
        backgroundImage: $12cecb1d1ea15958$var$strawberrySvg.toString()
    }
};


var $f43f2f1d01c97ca5$exports = {};

$parcel$export($f43f2f1d01c97ca5$exports, "Spinner", () => $f43f2f1d01c97ca5$export$7f7cbe89f1eacd2);
"use strict";
const $f43f2f1d01c97ca5$export$7f7cbe89f1eacd2 = {
    props: {
        position: "relative",
        boxSize: "B",
        Text: {
            position: "absolute",
            transform: "translate3d(-50%, 0, 1px)",
            top: "130%",
            textAlign: "center",
            left: "50%",
            fontSize: "Y"
        }
    },
    Tick: {
        position: "absolute",
        inset: "0 0 0 0",
        transform: "rotate(-135deg)",
        color: "#f1bcb2",
        ":after": {
            content: '""',
            position: "absolute",
            top: "0",
            left: "50%",
            width: "2px",
            color: "currentColor",
            background: "currentColor",
            margin: "- - - -1px",
            bottom: "50%"
        }
    },
    Box: {
        props: {},
        html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 43"><path fill="currentColor" fill-rule="evenodd" d="M1456,936 L1456,938 L1461,938 L1460.999,940 L1474.999,940 L1475,938 L1480,938 L1480,936 L1482,936 L1482,931 L1484.5,931 L1484.5,916 L1482,916 L1482,911 L1480,911 L1480,909 L1475,909 L1474.999,907 L1460.999,907 L1461,909 L1456,909 L1456,911 L1454,911 L1454,916 L1451.5,916 L1451.499,931 L1454,931 L1454,936 L1456,936 Z M1449,936 L1448.999,932.5 L1446.5,932.5 L1446.5,914.5 L1448.999,914.499 L1449,911 L1451,911 L1451,906 L1456,906 L1456,904 L1458.999,904 L1459,902 L1477,902 L1476.999,904 L1480,904 L1480,906 L1485,906 L1485,911 L1487,911 L1486.999,914.499 L1489.5,914.5 L1489.5,932.5 L1486.999,932.5 L1487,936 L1485,936 L1485,941 L1480,941 L1480,943 L1476.999,943 L1477,945 L1459,945 L1458.999,943 L1456,943 L1456,941 L1451,941 L1451,936 L1449,936 Z" transform="translate(-1446 -902)"/></svg>'
    }
};


var $370f806f0e15aac5$exports = {};

$parcel$export($370f806f0e15aac5$exports, "Controller", () => $370f806f0e15aac5$export$bd0bf19f25da8474);













const $712cfcee42657bad$export$67c81e1d21dd176c = (p)=>{
    p.soundFormats("mp3", "ogg", "wav");
    // ეს რო იყოს იდეაში ადგილი სადაც სრულად აღვწერთ character-ებს თავისი
    // ხმით, ბექგრაუნდით და ტექსტით.
    return {
        kick1: {
            sound: p.loadSound((parcelRequire("iJUCQ"))),
            effects: {},
            el: null,
            playing: false
        },
        kick2: {
            sound: p.loadSound((parcelRequire("lQ3FR"))),
            effects: {},
            el: null,
            playing: false
        },
        snare: {
            sound: p.loadSound((parcelRequire("bl0Lo"))),
            effects: {},
            el: null,
            playing: false
        },
        rim: {
            sound: p.loadSound((parcelRequire("ldgBe"))),
            effects: {},
            el: null,
            playing: false
        },
        "hat-closed": {
            sound: p.loadSound((parcelRequire("gUISN"))),
            effects: {},
            el: null,
            playing: false
        },
        "hat-open": {
            sound: p.loadSound((parcelRequire("ICc8l"))),
            effects: {},
            el: null,
            playing: false
        },
        "tom-high": {
            sound: p.loadSound((parcelRequire("724aH"))),
            effects: {},
            ref: null,
            playing: false
        },
        "tom-low": {
            sound: p.loadSound((parcelRequire("dihGQ"))),
            effects: {},
            el: null,
            playing: false
        },
        cymbal: {
            sound: p.loadSound((parcelRequire("i9qio"))),
            effects: {},
            el: null,
            playing: false
        },
        maracas: {
            sound: p.loadSound((parcelRequire("eyEFG"))),
            effects: {},
            el: null,
            playing: false
        },
        zap: {
            sound: p.loadSound((parcelRequire("5eTGP"))),
            effects: {},
            el: null,
            playing: false
        },
        sample: {
            sound: p.loadSound((parcelRequire("hhjNk"))),
            effects: {},
            el: null,
            playing: false
        }
    };
};


"use strict";
const $c57428761514d11f$var$makeSound = (soundObj)=>{
    return function(time, playbackRate) {
        soundObj.el.target.classList.add("active");
        setTimeout(()=>{
            soundObj.el.target.classList.remove("active");
        }, 350);
        soundObj.sound.rate(playbackRate);
        soundObj.sound.play(time);
    };
};
let $c57428761514d11f$var$looping = false;
let $c57428761514d11f$var$sequence;
let $c57428761514d11f$var$currentPart;
let $c57428761514d11f$var$activePhrase;
let $c57428761514d11f$var$phraseName;
let $c57428761514d11f$var$sounds;
let $c57428761514d11f$var$activePad = null;
const $c57428761514d11f$var$phrases = {};
const $c57428761514d11f$var$patterns = {};
const $c57428761514d11f$export$8ceded137695f5d5 = {
    preload: (p)=>{
        $c57428761514d11f$var$sounds = (0, $712cfcee42657bad$export$67c81e1d21dd176c)(p);
    },
    setup: (p)=>{
        const startButton = p.select(".play-button");
        const stopButton = p.select(".stop-button");
        const clearButton = p.select(".clear-button") // eslint-disable-line
        ;
        const sequencerSteps = p.selectAll(".sequencer-step");
        const pacman = p.select("#pacman");
        const pads = p.selectAll(".drum-pad");
        const instrumentParts = [
            "kick1",
            "kick2",
            "snare",
            "rim",
            "hat-closed",
            "hat-open",
            "tom-high",
            "tom-low",
            "cymbal",
            "maracas",
            "zap",
            "sample"
        ];
        instrumentParts.forEach((el)=>{
            $c57428761514d11f$var$patterns[el] = [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ];
            $c57428761514d11f$var$phrases[el] = new (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Phrase(el, $c57428761514d11f$var$makeSound($c57428761514d11f$var$sounds[el]), $c57428761514d11f$var$patterns[el]);
            $c57428761514d11f$var$sounds[el].effects.lowPassfilter = new (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).LowPass();
            $c57428761514d11f$var$sounds[el].effects.highPassfilter = new (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).HighPass();
            $c57428761514d11f$var$sounds[el].effects.delay = new (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Delay();
            $c57428761514d11f$var$sounds[el].effects.reverb = new (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Reverb();
            // sounds[el].sound.disconnect()
            // sounds[el].sound.connect(sounds[el].effects.env);
            $c57428761514d11f$var$sounds[el].effects.reverb.process($c57428761514d11f$var$sounds[el].sound, 0.1, 1, 0);
            $c57428761514d11f$var$sounds[el].effects.delay.process($c57428761514d11f$var$sounds[el].sound, 0, 0, 0);
            // sounds[el].sound.connect(sounds[el].effects.reverb);
            $c57428761514d11f$var$sounds[el].sound.connect($c57428761514d11f$var$sounds[el].effects.lowPassfilter);
            $c57428761514d11f$var$sounds[el].sound.connect($c57428761514d11f$var$sounds[el].effects.highPassfilter);
            $c57428761514d11f$var$sounds[el].sound.connect($c57428761514d11f$var$sounds[el].effects.delay);
        // sounds[el].effects.reverb.set(0, 0);
        // sounds[el].effects.delay.filter(0);
        // sounds[el].effects.delay.delayTime(0.1);
        // sounds[el].effects.delay.feedback(0.1);
        // sounds[el].effects.highPassfilter.amp(sounds[el].effects.env);
        // sounds[el].sound.amp(sounds[el].effects.env);
        });
        // Initialize a new p5.Part object
        $c57428761514d11f$var$currentPart = new (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Part(16);
        $c57428761514d11f$var$currentPart.setBPM(80);
        let stepCounter = 0;
        const pacmanPhrase = new (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).Phrase("pacman", ()=>{
            // move pacman to next step
            pacman.style("left", `${stepCounter * 42}px`);
            stepCounter++;
            if (stepCounter > 15) stepCounter = 0;
        }, [
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ]);
        // start stop button for the part
        startButton.mouseClicked(function() {
            $c57428761514d11f$var$currentPart.loop();
            $c57428761514d11f$var$currentPart.addPhrase(pacmanPhrase);
            if ($c57428761514d11f$var$currentPart != null) {
                $c57428761514d11f$var$currentPart.start();
                $c57428761514d11f$var$currentPart.loop();
                $c57428761514d11f$var$looping = true;
            // this.addClass('active')
            }
        });
        stopButton.mouseClicked(function() {
            if ($c57428761514d11f$var$currentPart != null) {
                $c57428761514d11f$var$currentPart.stop();
                $c57428761514d11f$var$looping = false;
                startButton.removeClass("active");
            }
        });
        // Handle sequencer steps
        sequencerSteps.forEach((el, i)=>el.mouseClicked(function() {
                $c57428761514d11f$var$sequence = $c57428761514d11f$var$activePhrase.sequence;
                if ($c57428761514d11f$var$activePhrase.sequence[i]) {
                    $c57428761514d11f$var$sequence[i] = 0;
                    $c57428761514d11f$var$currentPart.replaceSequence($c57428761514d11f$var$activePhrase.name, $c57428761514d11f$var$sequence);
                    el.removeClass("active");
                } else {
                    $c57428761514d11f$var$sequence[i] = 1;
                    $c57428761514d11f$var$currentPart.replaceSequence($c57428761514d11f$var$activePhrase.name, $c57428761514d11f$var$sequence);
                    el.addClass("active");
                }
            }));
        pads.forEach((pad)=>pad.mouseClicked(function(el) {
                $c57428761514d11f$var$phraseName = pad.attribute("id");
                // Add el to sound object
                if ($c57428761514d11f$var$sounds[$c57428761514d11f$var$phraseName].el == null) $c57428761514d11f$var$sounds[$c57428761514d11f$var$phraseName].el = el;
                $c57428761514d11f$var$sounds[$c57428761514d11f$var$phraseName].sound.play();
                pads.forEach((p)=>p.removeClass("recording"));
                pad.addClass("recording");
                if ($c57428761514d11f$var$currentPart.getPhrase($c57428761514d11f$var$phraseName) == null && $c57428761514d11f$var$phrases[$c57428761514d11f$var$phraseName] != null) {
                    $c57428761514d11f$var$currentPart.addPhrase($c57428761514d11f$var$phrases[$c57428761514d11f$var$phraseName]);
                    // if (looping) {
                    pad.addClass("playing");
                    // }
                    $c57428761514d11f$var$activePad = pad;
                } else if ($c57428761514d11f$var$activePad === pad) {
                    $c57428761514d11f$var$currentPart.removePhrase($c57428761514d11f$var$phraseName);
                    // if (looping) {
                    pad.removeClass("recording");
                    pad.removeClass("playing");
                    // }
                    $c57428761514d11f$var$activePad = null;
                } else $c57428761514d11f$var$activePad = pad;
                if ($c57428761514d11f$var$activePad != null) {
                    $c57428761514d11f$var$activePhrase = $c57428761514d11f$var$currentPart.getPhrase($c57428761514d11f$var$activePad.attribute("id"));
                    sequencerSteps.forEach((el, i)=>{
                        el.removeClass("active");
                        if ($c57428761514d11f$var$activePhrase.sequence[i]) el.addClass("active");
                    });
                } else sequencerSteps.forEach((el)=>el.removeClass("active"));
            }));
    }
};



"use strict";
const $370f806f0e15aac5$export$bd0bf19f25da8474 = {
    extend: (0, $afd03220988cb716$export$ef2184bd89960b14),
    props: {
        class: "test-class",
        borderRadius: "Z",
        gap: "Z",
        templateColumns: "1fr 1fr 1fr 1fr 1fr",
        position: "relative",
        margin: "auto",
        flexDirection: "column",
        background: "black 0.25",
        backdropFilter: "blur(3px)",
        zIndex: 2
    },
    childExtend: {
        props: {
            round: "Y",
            border: "3px, solid, white .05"
        }
    },
    DrumPads: {
        extend: (0, $afd03220988cb716$export$ef2184bd89960b14),
        props: {
            gridColumnStart: "span 3",
            padding: "C D D",
            gap: "D1",
            columns: "repeat(4, 1fr)",
            "@tabletS": {
                gridColumnStart: "span 5",
                columns: "repeat(3, 1fr)"
            }
        },
        childExtend: {
            props: {
                class: "drum-pad"
            }
        },
        "Pinky.cymbal": {},
        "Clyde.maracas": {},
        "Blinky.zap": {},
        "Inky.sample": {},
        "Cherry.hat-closed": {},
        "BlinkyAngry.hat-open": {},
        "Bell.tom-high": {},
        "Key.tom-low": {},
        "Galaxian.kick1": {},
        "Apple.kick2": {},
        "Melon.snare": {},
        "Orange.rim": {}
    },
    Effects: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            flex: 1,
            alignItems: "center",
            gridColumnStart: "span 2",
            flexDirection: "column",
            padding: "B C",
            "@tabletS": {
                gridColumnStart: "span 5",
                gridRowStart: "5",
                padding: "B B D"
            }
        },
        Text: {
            margin: "X -B B1",
            textAlign: "center",
            opacity: ".55",
            fontFamily: "game",
            padding: "Z2",
            width: "85%",
            background: "white 0.15",
            text: "0"
        },
        Grid: {
            props: {
                columns: "repeat(3, 1fr)",
                gap: "D+X",
                "@tabletS": {
                    gap: "D3"
                },
                "@mobileS": {
                    gap: "E1"
                }
            },
            childExtend: "Spinner",
            ...[
                {
                    Text: {
                        text: "Freq"
                    }
                },
                {
                    Text: {
                        text: "Res"
                    }
                },
                {
                    Text: {
                        text: "Amp"
                    }
                },
                {
                    Text: {
                        text: "Delay"
                    }
                },
                {
                    Text: {
                        text: "Feedback"
                    }
                },
                {
                    Text: {
                        text: "Filter"
                    }
                },
                {
                    Text: {
                        text: "Reverb"
                    }
                },
                {
                    Text: {
                        text: "Decay"
                    }
                },
                {
                    Text: {
                        text: "Pan"
                    }
                }
            ]
        }
    },
    StepSequencer: {
        extend: "Grid",
        props: {
            overflow: "hidden",
            round: "Y",
            gap: "B1+Z",
            align: "center",
            padding: "B B B D1",
            position: "relative",
            columns: "repeat(16, 1fr)",
            gridColumnStart: "span 5",
            "@tabletS": {
                padding: "B B2 B D1-C",
                columns: "repeat(8, 1fr)"
            }
        },
        childExtend: {
            props: {
                class: "sequencer-step",
                position: "relative",
                background: "#f1bcb2",
                boxSize: "Y",
                cursor: "pointer",
                round: "V",
                "&.active div": {
                    display: "block"
                },
                ":after": {
                    content: '""',
                    background: "white .05",
                    boxSize: "C",
                    position: "absolute",
                    top: "50%",
                    round: "C1",
                    opacity: 0,
                    transition: "opacity, defaultBezier, A",
                    left: "50%",
                    transform: "translate3d(-50%, -50%, 1px)"
                },
                ":hover": {
                    ":after": {
                        opacity: 1
                    }
                }
            }
        },
        Pacman: {
            ignoreChildExtend: true,
            position: "absolute",
            id: "pacman",
            top: "Z",
            left: "B2",
            borderRadius: "0",
            transform: "translateX(-20px)",
            zIndex: 2,
            transition: "A left linear",
            margin: "- C - -",
            "@tabletS": {
                left: 0
            },
            ":after": {
                content: '""',
                background: "black",
                top: "0",
                bottom: "0",
                position: "absolute",
                right: "100%",
                width: "100vw"
            }
        },
        step1: {},
        step2: {},
        step3: {},
        step4: {},
        step5: {},
        step6: {},
        step7: {},
        step8: {},
        step9: {},
        step10: {},
        step11: {},
        step12: {},
        step13: {},
        step14: {},
        step15: {},
        step16: {}
    },
    Footer: {
        extend: "Flex",
        props: {
            border: "",
            gridColumnStart: "span 5",
            color: "white",
            padding: "A 0",
            align: "center space-between"
        },
        MainControls: {
            extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
            props: {
                margin: "- - - -Z2"
            },
            childExtend: {
                extend: "SquareButton",
                props: {
                    fontSize: "C1",
                    padding: "Y",
                    color: "white",
                    background: "transparent",
                    cursor: "pointer"
                }
            },
            Play: {
                props: ({ state: state })=>({
                        class: "play-button",
                        icon: "play",
                        hide: state.playing,
                        onClick: (ev, el, s)=>{
                            s.update({
                                playing: true
                            });
                        }
                    })
            },
            Stop: {
                props: ({ state: state })=>({
                        class: "stop-button",
                        icon: "pause",
                        hide: !state.playing,
                        onClick: (ev, el, s)=>{
                            s.update({
                                playing: false
                            });
                        }
                    })
            },
            Clear: {
                class: "clear-button",
                boxSize: "B1",
                fontSize: "A1",
                icon: null,
                text: "X"
            }
        },
        Flex: {
            props: {
                gap: "B",
                align: "center"
            },
            Pass: {
                props: ({ state: state })=>({
                        cursor: "pointer",
                        text: (state.pass === "low" ? "L" : "H") + "-pass",
                        onClick: (ev, el, s)=>s.update({
                                pass: s.pass === "low" ? "high" : "low"
                            })
                    })
            },
            Sep: "|",
            Bpm: {
                extend: "Flex",
                props: {
                    gap: "A",
                    align: "center"
                },
                Spinner: {},
                Text: {
                    fontFamily: "game",
                    text: "0BPM"
                }
            }
        }
    },
    on: {
        init: (el, s)=>{
            el.__ref.__root.data.setup.push((0, $c57428761514d11f$export$8ceded137695f5d5).setup);
        }
    }
};


var $19c06d1ad5782596$exports = {};

$parcel$export($19c06d1ad5782596$exports, "SpaceParticles", () => $19c06d1ad5782596$export$791fc27fd81f9ae4);
class $a21513083de3e86c$var$Particle {
    constructor(p, x, y){
        // Position and velocity
        this.p = p;
        this.reset(this.p.random(this.p.windowWidth), this.p.random(this.p.windowHeight));
    }
    reset(x, y) {
        this.position = this.p.createVector(x, y);
        this.velocity = this.p.createVector(0, this.p.random(0.2, 0.2));
        this.size = this.p.random(2, 5);
        this.alpha = this.p.random(50, 150);
    }
    // Update particle's position
    update() {
        this.velocity.add(0, 0);
        this.position.add(this.velocity);
        // Optional: Add boundaries or reset logic
        // Check for boundary collision and set global flag if collision occurs
        if (this.position.x < 0 || this.position.x > this.p.width || this.position.y < 0 || this.position.y > this.p.height) this.reset(this.p.random(this.p.windowWidth), 0);
    }
    // Display the particle
    display() {
        this.p.noStroke();
        this.p.fill(255, this.alpha);
        this.p.ellipse(this.position.x, this.position.y, this.size);
    }
}
const $a21513083de3e86c$var$particles = [];
const $a21513083de3e86c$export$791fc27fd81f9ae4 = {
    setup: (p)=>{
        p.createCanvas(p.windowWidth, p.windowHeight);
        for(let i = 0; i < 50; i++)$a21513083de3e86c$var$particles.push(new $a21513083de3e86c$var$Particle(p, p.random(p.windowWidth), p.random(p.windowHeight)));
    },
    draw: (p)=>{
        p.background(0);
        // Update and display particles
        for (const particle of $a21513083de3e86c$var$particles){
            particle.update();
            particle.display();
        }
    }
};


"use strict";
const $19c06d1ad5782596$export$791fc27fd81f9ae4 = {
    props: {
        position: "absolute",
        width: "100%",
        height: "100%",
        top: "0",
        left: "0",
        zIndex: 1
    },
    on: {
        render: (el, s)=>{
            el.__ref.__root.data.setup.push((0, $a21513083de3e86c$export$791fc27fd81f9ae4).setup);
            el.__ref.__root.data.draw.push((0, $a21513083de3e86c$export$791fc27fd81f9ae4).draw);
        }
    }
};


"use strict";
$parcel$exportWildcard($8b2868fa924aab9a$exports, $1d2e473525dfc7f2$exports);
$parcel$exportWildcard($8b2868fa924aab9a$exports, $ef0ca6b97a81452e$exports);
$parcel$exportWildcard($8b2868fa924aab9a$exports, $664f79cf6a97be87$exports);
$parcel$exportWildcard($8b2868fa924aab9a$exports, $5437dddba42655e6$exports);
$parcel$exportWildcard($8b2868fa924aab9a$exports, $3df07944bfa6aab3$exports);
$parcel$exportWildcard($8b2868fa924aab9a$exports, $3f1fb52ab2bebfc0$exports);
$parcel$exportWildcard($8b2868fa924aab9a$exports, $12cecb1d1ea15958$exports);
$parcel$exportWildcard($8b2868fa924aab9a$exports, $f43f2f1d01c97ca5$exports);
$parcel$exportWildcard($8b2868fa924aab9a$exports, $370f806f0e15aac5$exports);
$parcel$exportWildcard($8b2868fa924aab9a$exports, $19c06d1ad5782596$exports);


"use strict";
var $bfc59006cf644cf7$export$2e2bcd8739ae039 = {
    main: {
        data: {
            looping: false,
            myPart: {},
            sounds: {},
            phrases: {},
            patterns: {}
        }
    }
};


"use strict";
const $10f10b065ec0b87e$export$c8424c4d8ba2150 = {
    props: {},
    Flex: {
        props: {
            flow: "column",
            position: "relative",
            zIndex: 1,
            width: "100%",
            maxWidth: "I3",
            margin: "auto",
            align: "center center",
            textAlign: "center"
        },
        H3: {
            text: "The monthly party at ://about blank is breaking with tradition by not announcing lineups."
        },
        P: {
            text: "How STAUB, A \u201CTechno Communist\u201D Day Party, Quietly Became One Of Berlin\u2019s Best Events"
        },
        Img: {
            margin: "C1",
            maxWidth: "100%",
            src: "https://res.cloudinary.com/electronic-beats/c_fit,q_auto,f_auto,w_3840/stage/uploads/2019/02/STAUB-lead-image-by-george-nebieridze.jpg"
        },
        Text: {
            margin: "A",
            fontFamily: "ui",
            text: "Published February 20, 2019. Words by Chlo\xe9 Lula, photos by George Nebieridze."
        },
        Flex: {
            props: {
                gap: "A1",
                childProps: {
                    flex: 1,
                    textAlign: "justify"
                }
            },
            Italic: {
                margin: "A",
                fontFamily: "ui",
                text: "STAUB, a monthly daytime event that takes place the last Saturday of every month at ://about blank, is one of Berlin\u2019s best parties. But it\u2019s historically operated behind a shroud of anonymity; the lineups are never announced, the STAUB Records artists are never revealed and the promoters skirt the sidelines of the dance floors, never putting themselves in the limelight."
            },
            Italic_2: {
                margin: "A",
                fontFamily: "ui",
                text: "In honor of the party\u2019s six-year anniversary this weekend, we decided to take a deeper look at its impact on the scene. TEB editor Chlo\xe9 Lula traveled to Detroit to see STAUB\u2019s United States debut and discussed the party\u2019s philosophy with its three organizers, Irakli, Ines and Jan (pictured above)."
            }
        },
        Divider: {},
        P_2: {
            fontFamily: "ui",
            text: "It\u2019s twilight on Monday, May 28 and the sun is setting over the Detroit skyline. A tired but exuberant crowd is dancing on the back patio of the downtown venue TV Lounge, an off-Movement Festival space that plays host to afterparties throughout the duration of the country\u2019s largest and oldest electronic music event. But on this final day of the Memorial Day weekend, the crowd isn\u2019t dancing to the more standard musical offerings of local talent or US-based techno artists; they\u2019re dancing to STAUB, a Berlin-based party that only recently touched down in Detroit."
        },
        P_3: {
            fontFamily: "ui",
            text: "STAUB\u2019s appearance in the Motor City was its first in the US, and its famously anonymous booking concept fell counter to the heavily promoted Movement festivities that were happening a few blocks away. That the undisclosed STAUB headliners included major acts that played at the much more heavily publicized\u2014and costly\u2014festival the weekend before was not received without a touch of irony from the guests who were able to identify them."
        },
        Flex_soundcloud: {
            props: {
                width: "100%",
                margin: "C",
                gap: "Z",
                flow: "column"
            },
            Iframe: {
                width: "100%",
                minHeight: "none",
                height: "166px",
                scrolling: "no",
                frameborder: "no",
                allow: "autoplay",
                src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/576853176&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
            },
            Italic: {
                fontSize: "Z1",
                fontFamily: "ui",
                text: "Lorem inpsum from the guests who were able to identify them."
            }
        }
    }
};
const $10f10b065ec0b87e$export$6f06e1a71cb9735e = {
    props: {
        ":before": {
            content: '""',
            opacity: ".35",
            position: "absolute",
            zIndex: 0,
            inset: "0 0 0 0",
            background: "url(https://res.cloudinary.com/electronic-beats/c_fit,q_auto,f_auto,w_3840/stage/uploads/2019/02/STAUB-lead-image-by-george-nebieridze.jpg) center center",
            backgroundSize: "cover"
        },
        ":after": {
            content: '""',
            opacity: ".35",
            position: "absolute",
            zIndex: 0,
            inset: "0 0 0 0",
            background: "dark 1 -250"
        }
    },
    Flex: {
        props: {
            flow: "column",
            position: "relative",
            zIndex: 1,
            width: "100%",
            maxWidth: "I3",
            margin: "auto",
            align: "center center",
            textAlign: "center"
        },
        H3: {
            text: "The monthly party at ://about blank is breaking with tradition by not announcing lineups."
        },
        P: {
            text: "How STAUB, A \u201CTechno Communist\u201D Day Party, Quietly Became One Of Berlin\u2019s Best Events"
        }
    }
};


"use strict";
const $c6a94bec3615bf9a$export$861edd1ccea2f746 = {
    extend: [
        "Page"
    ],
    Controller: {}
};


"use strict";
var // import { Controller } from './Controller'
$9315346aaf6c1014$export$2e2bcd8739ae039 = {
    "/": (0, $c6a94bec3615bf9a$export$861edd1ccea2f746),
    // '/controller': Controller,
    "/events": {
        text: "events"
    },
    "/about": (0, $10f10b065ec0b87e$export$c8424c4d8ba2150),
    "/contact": {
        text: "contact"
    }
};




"use strict";
(0, $22cae8e82746fd5e$export$185802fd694ee1f5)({
    extend: "Flex",
    data: {
        preload: [
            (0, $c57428761514d11f$export$8ceded137695f5d5).preload
        ],
        setup: [
            (0, $a21513083de3e86c$export$791fc27fd81f9ae4).setup,
            (0, $c57428761514d11f$export$8ceded137695f5d5).setup
        ],
        draw: [
            (0, $a21513083de3e86c$export$791fc27fd81f9ae4).draw
        ]
    },
    props: {
        theme: "document",
        flow: "column",
        height: "100vh",
        align: "center space-between",
        content: {
            flow: "column",
            flex: "1 1 auto",
            zIndex: 1,
            order: 2
        },
        "& .p5Canvas": {
            position: "fixed",
            inset: "0 0 0 0",
            zIndex: 0
        }
    },
    // Loading: {},
    Logo: {},
    Navigation: {},
    Transition: {},
    SpaceParticles: {
        hide: true
    },
    on: {
        render: (el, s)=>{
            return new (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports)))((p)=>{
                p.preload = ()=>el.data.preload.forEach((callback)=>callback(p));
                p.setup = ()=>el.data.setup.forEach((callback)=>callback(p));
                p.draw = ()=>el.data.draw.forEach((callback)=>callback(p));
            }, el.node);
        }
    }
}, {
    state: $bfc59006cf644cf7$export$2e2bcd8739ae039,
    designSystem: $5cd95e4506904c32$export$2e2bcd8739ae039,
    components: $8b2868fa924aab9a$exports,
    pages: $9315346aaf6c1014$export$2e2bcd8739ae039
});


//# sourceMappingURL=index.7c4ccbe0.js.map
